import gql from 'graphql-tag'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
export type Maybe<T> = T
export type InputMaybe<T> = T
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** An account number for a corepro account */
  AccountNumber: any
  Amount: any
  BankCardPin: any
  /** An arbitrary precision signed decimal */
  BigDecimal: any
  CardNumberMasked: any
  /** A ISO8601 format date string */
  Date: any
  /** A ISO8601 format date time string */
  DateTime: any
  /** A field representing a standard email address. https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address */
  Email: any
  /**  A field whose value conforms to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/.  */
  EmailAddress: any
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any
  /** Represents untyped JSON */
  JSON: any
  /** Standard format for monetary value - string representation of BigInt */
  Micros: any
  /** A field representing a e.164 phone number. https://en.wikipedia.org/wiki/E.164 */
  PhoneNumber: any
  PositiveFloat: any
  ReferralCode: any
  /** A routing number for a bank */
  RoutingNumber: any
  /** A key scalar which maps to a string in the Unified String Repo */
  StringKey: any
  /** A valid security symbol */
  TickerSymbol: any
  Time: any
  /** A legal URL */
  URL: any
  /** Formatted full-name of a US state. */
  USStateName: any
  /** A universally unique identifier compliant UUID Scalar */
  UUID: any
  /** The Upload scalar type represents a file upload. */
  Upload: any
  /**
   * Allows for a cleaner 'null' return type
   *             to support legacy GQL queries from the gateway
   */
  Void: any
}

/** Describes the employer switch based on the switch type. */
export type AbstractSwitch = AcornsPdfSwitch | OnlineSwitch | SubmittableSwitch

/** Bundle of acceptance date, signature, and document type */
export type AcceptDocumentInput = {
  /** The date the document was signed by the user */
  acceptedDate: Scalars['Date']
  /** Type of document the given signature is accepting */
  documentType: AcceptanceDocumentType
  /** The version of the document the user is accepting */
  documentVersion: Scalars['String']
  /** Name to apply to the accepted document */
  signature: Scalars['String']
}

/** What happens when a user accepts a document */
export type AcceptDocumentResponse =
  | AcceptedDocument
  | DocumentNotFound
  | UserNotFound

/** Acceptance documents */
export type AcceptanceDocument = {
  __typename?: 'AcceptanceDocument'
  id: Scalars['ID']
  /** Indicates whether the app should force the user to scroll to the bottom before accepting */
  mustScrollToBottom: Maybe<Scalars['Boolean']>
  /** The name of the document */
  name: Scalars['String']
  /** A string indicating a specific app feature that the acceptance of the document is required for using */
  requiredFor: Maybe<Scalars['String']>
  /** The name of the summary */
  summaryName: Maybe<Scalars['String']>
  /** The URL to the summary text */
  summaryUrl: Maybe<Scalars['URL']>
  /** The type of document (arbitrary right now) */
  type: Scalars['String']
  /** The URL to the document text */
  url: Scalars['URL']
  /** The version of the document */
  version: Scalars['String']
}

export enum AcceptanceDocumentType {
  /**
   * Required agreement when user is signed up through a referral program or code
   * @deprecated Referral disclosure is no longer required for referred users
   */
  ReferralDisclosure = 'referralDisclosure',
}

/** A document that a user has accepted */
export type AcceptedDocument = {
  __typename?: 'AcceptedDocument'
  acceptedDate: Scalars['Date']
  documentType: AcceptanceDocumentType
  documentUrl: Scalars['String']
  documentVersion: Scalars['String']
  signature: Scalars['String']
}

/** Individual accounts opened by a user at Acorns */
export type Account = TimestampsInterface & {
  __typename?: 'Account'
  /** Type of account */
  accountType: AccountType
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Internal ID for account creator */
  creatorId: Scalars['ID']
  /** Internal ID for account */
  id: Scalars['ID']
  /** Status of account */
  status: AccountStatus
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export type AccountAchievement = {
  __typename?: 'AccountAchievement'
  achievement: AchievementItem
  completed: Scalars['Boolean']
  dateCompleted: Scalars['DateTime']
}

/** The account provided is already closed */
export type AccountAlreadyClosedException = {
  __typename?: 'AccountAlreadyClosedException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Investment account is already closed */
export type AccountClosedException = {
  __typename?: 'AccountClosedException'
  /** message */
  errorMessage: Maybe<Scalars['String']>
}

export type AccountDesignations = {
  __typename?: 'AccountDesignations'
  accountId: Scalars['ID']
  accountType: DesignationAccountType
  designations: Array<Maybe<Designation>>
  userId: Scalars['ID']
}

/** The account has been frozen due to too many incorrect attempts */
export type AccountFrozen = {
  __typename?: 'AccountFrozen'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export type AccountMoneyAssignmentInput = {
  amount?: InputMaybe<Scalars['Int']>
  targetAccountId: Scalars['String']
}

/** When investment account id doesn't match with user */
export type AccountNotFoundException = {
  __typename?: 'AccountNotFoundException'
  /** message */
  errorMessage: Maybe<Scalars['String']>
}

export type AccountPoints = {
  __typename?: 'AccountPoints'
  /**
   * detailed explanation about how points are earned
   * @deprecated Use detailsKey field instead
   */
  details: Scalars['String']
  /** key that maps to a detailed explanation about how points are earned */
  detailsKey: Scalars['StringKey']
  earned: Scalars['Int']
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int']
  /**
   * summarized explanation about how points are earned
   * @deprecated Use summaryKey field instead
   */
  summary: Maybe<Scalars['String']>
  /** key that maps to a summarized explanation about how points are earned */
  summaryKey: Maybe<Scalars['StringKey']>
}

export type AccountPointsRule = {
  __typename?: 'AccountPointsRule'
  /**
   * detailed explanation about how points are earned
   * @deprecated Use detailsKey field instead
   */
  details: Scalars['String']
  /** key that maps to a detailed explanation about how points are earned */
  detailsKey: Scalars['StringKey']
  milestoneID: Scalars['ID']
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int']
  /**
   * summarized explanation about how points are earned
   * @deprecated Use summaryKey field instead
   */
  summary: Maybe<Scalars['String']>
  /** key that maps to a summarized explanation about how points are earned */
  summaryKey: Maybe<Scalars['StringKey']>
}

export type AccountRequirement = {
  __typename?: 'AccountRequirement'
  actionable: Scalars['Boolean']
  description: Maybe<Scalars['String']>
  status: AccountRequirementStatus
  type: AccountRequirementType
}

export enum AccountRequirementStatus {
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
}

export enum AccountRequirementType {
  FundingSource = 'FUNDING_SOURCE',
  Liquidated = 'LIQUIDATED',
  NoPendingInvestments = 'NO_PENDING_INVESTMENTS',
  NoTransferringDividends = 'NO_TRANSFERRING_DIVIDENDS',
  NoTransferringInvestments = 'NO_TRANSFERRING_INVESTMENTS',
  RecurringDepositsDisabled = 'RECURRING_DEPOSITS_DISABLED',
  SelfDirectedPortfolioClosed = 'SELF_DIRECTED_PORTFOLIO_CLOSED',
  VerifiedFundingSource = 'VERIFIED_FUNDING_SOURCE',
}

export type AccountRequirements = {
  __typename?: 'AccountRequirements'
  close: Array<AccountRequirement>
}

/** reflects the user's account setup progress */
export type AccountSetupMilestones = {
  __typename?: 'AccountSetupMilestones'
  /** optional copy to provide more info */
  descriptionKey: Maybe<Scalars['StringKey']>
  /** account setup completion progress */
  groupProgress: DiscreteMilestoneProgress
  /** list of milestones to show in account set up widget */
  milestones: Array<Milestone>
}

export enum AccountStatus {
  /** Account has been closed */
  Closed = 'closed',
  /** Account closure is in progress */
  Inactive = 'inactive',
  /** Open account ready for use */
  Open = 'open',
  /** Account is in process of being opened or verified */
  Pending = 'pending',
}

export type AccountStrengthResult = {
  __typename?: 'AccountStrengthResult'
  achievements: Maybe<Array<Maybe<AccountAchievement>>>
  percentage: Scalars['Float']
}

export enum AccountType {
  /** Core basic investment account */
  Basic = 'basic',
  /** Spend LSB checking account */
  Checking = 'checking',
  /** Later ROTH IRA account */
  RothIra = 'rothIra',
  /** Later SEP IRA account */
  SepIra = 'sepIra',
  /** Later traditional IRA account */
  TraditionalIra = 'traditionalIra',
  /** Uniform Gift to Minors Act */
  Ugma = 'ugma',
  /** Uniform Transfers to Minors Act */
  Utma = 'utma',
}

/** Account values over the reporting period */
export type AccountValue = {
  __typename?: 'AccountValue'
  /** The dollar amount of the account's balance */
  amount: Maybe<Scalars['Float']>
  /** The time of the associated account value */
  timestamp: Maybe<Scalars['DateTime']>
}

export enum AchievementItem {
  AccountValueGte10 = 'accountValueGte10',
  AccountValueGte100 = 'accountValueGte100',
  AutomaticInvestmentOn = 'automaticInvestmentOn',
  AutomaticRoundupsOn = 'automaticRoundupsOn',
  FundingSourceLinked = 'fundingSourceLinked',
  MultipleRoundupAccountsLinked = 'multipleRoundupAccountsLinked',
  RegistrationComplete = 'registrationComplete',
  RoundupAccountLinked = 'roundupAccountLinked',
}

export type AcornsEarlyUserDetails = {
  __typename?: 'AcornsEarlyUserDetails'
  address1: Maybe<Scalars['String']>
  address2: Maybe<Scalars['String']>
  city: Maybe<Scalars['String']>
  credentialsExist: Scalars['Boolean']
  dateOfBirth: Maybe<Scalars['DateTime']>
  email: Scalars['String']
  externalId: Scalars['String']
  firstName: Maybe<Scalars['String']>
  lastName: Maybe<Scalars['String']>
  phoneNumber: Maybe<Scalars['String']>
  state: Maybe<Scalars['String']>
  zipCode: Maybe<Scalars['String']>
}

export enum AcornsPartnerStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  ExpiringSoon = 'EXPIRING_SOON',
  Inactive = 'INACTIVE',
  InProgress = 'IN_PROGRESS',
}

/** Acorns PDF Switches are performed by emailing and printing a PDF. */
export type AcornsPdfSwitch = SwitchInterface & {
  __typename?: 'AcornsPdfSwitch'
  source: SwitchSource
  type: SwitchType
}

/** Returned when there is negative values in allocations. */
export type AcornsValidationError = {
  __typename?: 'AcornsValidationError'
  message: Scalars['String']
}

export type ActionCard = {
  __typename?: 'ActionCard'
  /** The body text for the card */
  body: Maybe<Scalars['String']>
  /** call-to-action */
  ctaDetails: Maybe<ActionCardButton>
  /** A smaller card title */
  eyebrow: Maybe<Scalars['String']>
  /** Headline for the card */
  headline: Maybe<Scalars['String']>
  /** An image used in the hero of a card */
  heroImageUrl: Maybe<Scalars['URL']>
  /** A type of icon to render on the card */
  icon: Maybe<Scalars['String']>
  /** An image to render on the card */
  image: Maybe<Scalars['JSON']>
  /** An image to render on the card */
  imageUrl: Maybe<Scalars['URL']>
  /** Owner name for found money offers */
  ownerName: Maybe<Scalars['String']>
  /** A specific card style */
  style: ActionCardStyle
  /** The title for the card */
  title: Maybe<Scalars['String']>
  /** A specific type of card */
  type: Scalars['String']
  /** Unique digest for the card */
  userCardDigest: Maybe<Scalars['ID']>
  /** A widget to be rendered with the card */
  widget: Maybe<Scalars['JSON']>
}

export type ActionCardButton = {
  __typename?: 'ActionCardButton'
  id: Maybe<Scalars['String']>
  image: Maybe<Scalars['URL']>
  title: Scalars['String']
  type: Scalars['String']
  video: Maybe<Scalars['URL']>
  videoUrl: Maybe<Scalars['URL']>
}

export enum ActionCardStyle {
  /** alert */
  Alert = 'alert',
  /** announcingLater */
  AnnouncingLater = 'announcingLater',
  /** basic */
  Basic = 'basic',
  /** basicVideo */
  BasicVideo = 'basicVideo',
  /** foundMoney */
  FoundMoney = 'foundMoney',
  /** grow */
  Grow = 'grow',
  /** snackable */
  Snackable = 'snackable',
  /** widget */
  Widget = 'widget',
}

export type ActionCardsInput = {
  feedContext?: InputMaybe<ActionFeedContext>
}

export enum ActionFeedContext {
  /** feed context */
  A3Core = 'a3Core',
  /** feed context */
  A3Later = 'a3Later',
  /** feed context */
  A3Present = 'a3Present',
  /** feed context */
  A3Spend = 'a3Spend',
  /** feed context */
  A4BankingHub = 'a4BankingHub',
  /** feed context */
  A4CheckingEngagementWizard = 'a4CheckingEngagementWizard',
  /** feed context */
  A4CheckingHub = 'a4CheckingHub',
  /** feed context */
  A4Early = 'a4Early',
  /** feed context */
  A4EarlyDetails = 'a4EarlyDetails',
  /** feed context */
  A4Home = 'a4Home',
  /** feed context */
  A4HomeBottomNav = 'a4HomeBottomNav',
  /** feed context */
  A4Invest = 'a4Invest',
  /** feed context */
  A4InvestHub = 'a4InvestHub',
  /** feed context */
  A4Kids = 'a4Kids',
  /** feed context */
  A4Later = 'a4Later',
  /** feed context */
  A4LearnHub = 'a4LearnHub',
  /** feed context */
  A4Savings = 'a4Savings',
  /** feed context */
  A4Spend = 'a4Spend',
  /** feed context */
  Later = 'later',
  /** feed context */
  Present = 'present',
}

export type ActionFeedCta = {
  __typename?: 'ActionFeedCta'
  hideCardIfUnknown: Maybe<Scalars['Boolean']>
  id: Maybe<Scalars['ID']>
  image: Maybe<Scalars['String']>
  title: Scalars['String']
  type: Maybe<ActionFeedCtaType>
  video: Maybe<Scalars['String']>
  videoUrl: Maybe<Scalars['String']>
}

export enum ActionFeedCtaType {
  /** triggers an email download */
  Email = 'email',
  /** grow article link */
  GrowArticle = 'grow_article',
  /** link */
  Link = 'link',
  /** insights sequence offer */
  Offer = 'offer',
  /** insights sequence spell */
  Spell = 'spell',
  /** customer feedback survey */
  Survey = 'survey',
  /** link to view a video */
  Video = 'video',
  /** insights sequence wizard */
  Wizard = 'wizard',
}

/** input for an action feed event */
export type ActionFeedEvent = {
  /** investment account id */
  accountId?: InputMaybe<Scalars['ID']>
  /** event action type */
  action: ActionFeedEventAction
  /** body of event */
  body?: InputMaybe<Scalars['String']>
  /** cta id */
  ctaId?: InputMaybe<Scalars['ID']>
  /** card, widget, or tip type */
  eventKey: Scalars['ID']
  /** CARD | TIP */
  eventType: ActionFeedEventType
  /** card digest id */
  userCardDigest?: InputMaybe<Scalars['String']>
}

export enum ActionFeedEventAction {
  /** Completed */
  Completed = 'completed',
  /** Dismissed */
  Dismissed = 'dismissed',
  /** Card Impression */
  Impression = 'impression',
  /** CTA Tapped */
  Tapped = 'tapped',
}

/** Response to recording a feed event */
export type ActionFeedEventResponse = {
  __typename?: 'ActionFeedEventResponse'
  success: Scalars['Boolean']
}

export enum ActionFeedEventType {
  /** Card Event - impression, tapped, dismissed */
  Card = 'CARD',
  /** Tip Event - completed, dismissed */
  Tip = 'TIP',
}

/** Extendable Frontend Component Type */
export type ActionScreenComponent = ActionWidget

/**
 * Screen context enum - where the action feed appears in the app
 * Note: Uses camelCase to match legacy schema for compatibility
 */
export enum ActionScreenContext {
  /** screen context */
  A4BankingHub = 'a4BankingHub',
  /** screen context */
  A4BenefitsHub = 'a4BenefitsHub',
  /** screen context */
  A4CheckingHub = 'a4CheckingHub',
  /** screen context */
  A4EarlyDetails = 'a4EarlyDetails',
  /** screen context */
  A4HomeBottomNav = 'a4HomeBottomNav',
  /** screen context */
  A4Invest = 'a4Invest',
  /** screen context */
  A4InvestHub = 'a4InvestHub',
  /** screen context */
  A4Kids = 'a4Kids',
  /** screen context */
  A4Later = 'a4Later',
  /** screen context */
  A4LearnHub = 'a4LearnHub',
  /** screen context */
  A4Savings = 'a4Savings',
  /** screen context */
  A4Spend = 'a4Spend',
}

export enum ActionType {
  Choose = 'CHOOSE',
  Continue = 'CONTINUE',
  Direct = 'DIRECT',
  Link = 'LINK',
  Manual = 'MANUAL',
  MoreInfo = 'MORE_INFO',
  Skip = 'SKIP',
  Switch = 'SWITCH',
  /** Represents when a user switches funnels mid-way through a funnel */
  Update = 'UPDATE',
}

/** Action Screen widget type */
export type ActionWidget = {
  __typename?: 'ActionWidget'
  /**
   * unique identifying hash of the card
   * @deprecated not in use by clients
   */
  digest: Maybe<Scalars['String']>
  /** The identifying string for the widget */
  identifier: Scalars['String']
  /** The unique name of the widget */
  type: Scalars['String']
}

export type ActivateAcornsCredentialsResult =
  | ActivateAcornsCredentialsSuccess
  | ActivateCredentialsAttemptsExceededException
  | OidcCredentialsAlreadyLinkedException
  | OidcCredentialsNotFoundException

export type ActivateAcornsCredentialsSuccess = {
  __typename?: 'ActivateAcornsCredentialsSuccess'
  cta: Maybe<Scalars['String']>
  email: Scalars['EmailAddress']
}

export type ActivateBankCardInput = {
  cardNumberMasked: Scalars['CardNumberMasked']
}

export type ActivateBankCardPayload = {
  __typename?: 'ActivateBankCardPayload'
  bankCard: Maybe<BankCard>
}

export type ActivateCredentialsAttemptsExceededException = {
  __typename?: 'ActivateCredentialsAttemptsExceededException'
  email: Scalars['String']
}

export type ActivateOauthAppClientResult =
  | OauthAppClient
  | OauthAppClientNotFoundException

export type ActivateOauthAppResult = OauthApp | OauthAppNotFoundException

export type ActivateSecuritiesFailed = {
  __typename?: 'ActivateSecuritiesFailed'
  description: Scalars['String']
}

export type ActivateSecuritiesInput = {
  active: Scalars['Boolean']
  searchable: Scalars['Boolean']
  symbols: Array<Scalars['TickerSymbol']>
}

export type ActivateSecuritiesResult =
  | ActivateSecuritiesFailed
  | ActivateSecuritiesSuccess

/** Securities whose flags were updated, plus any requested symbols that were not found */
export type ActivateSecuritiesSuccess = {
  __typename?: 'ActivateSecuritiesSuccess'
  notFoundSymbols: Array<Scalars['TickerSymbol']>
  securities: Array<Security>
}

export type ActiveReferralCampaignOutput = {
  __typename?: 'ActiveReferralCampaignOutput'
  campaigns: Array<Maybe<ReferralCampaignV2>>
}

export type Activity = {
  __typename?: 'Activity'
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  meta: Scalars['JSON']
  pending: Maybe<Scalars['Boolean']>
  type: ActivityType
}

export enum ActivitySummaryProduct {
  /** Early investment product */
  Early = 'EARLY',
  /** Core investment product */
  Invest = 'INVEST',
  /** Later investment product */
  Later = 'LATER',
}

export type ActivitySummaryResponse = {
  __typename?: 'ActivitySummaryResponse'
  activitySummaryItems: Maybe<Array<SummaryItem>>
  numberOfDays: Maybe<Scalars['Int']>
  /** @deprecated Use `totalV2` for standardized money format */
  total: Maybe<CurrencyAmount>
  totalV2: Maybe<MicrosMoney>
}

export enum ActivityType {
  AchFee = 'achFee',
  BonusRoundup = 'bonusRoundup',
  Credit = 'credit',
  DirectFee = 'directFee',
  Dividend = 'dividend',
  EmployeeContribution = 'employeeContribution',
  Fee = 'fee',
  FoundMoney = 'foundMoney',
  GiftCard = 'giftCard',
  OneTimeInvestment = 'oneTimeInvestment',
  PartnerReward = 'partnerReward',
  Rebalance = 'rebalance',
  RecurringInvestment = 'recurringInvestment',
  ReferralReward = 'referralReward',
  RoundUp = 'roundUp',
  Seeding = 'seeding',
  Withdrawal = 'withdrawal',
}

export type AddCaseFileError = {
  __typename?: 'AddCaseFileError'
  error: Maybe<Scalars['String']>
  message: Scalars['String']
}

export type AddCaseFileInput = {
  base64Data: Scalars['String']
  caseId: Scalars['ID']
  fileType: AttachmentDocType
  title: Scalars['String']
}

export type AddCaseFileResult = AddCaseFileError | CaseFile

export type AddCaseNoteInput = {
  caseID: Scalars['ID']
  isPublic?: InputMaybe<Scalars['Boolean']>
  noteBody: Scalars['String']
}

export type AddCaseNoteResult = {
  __typename?: 'AddCaseNoteResult'
  caseID: Scalars['ID']
  error: Maybe<Scalars['String']>
  noteId: Scalars['ID']
  success: Scalars['Boolean']
}

/** Input for adding cohorts */
export type AddCohortEligibilityInput = {
  /** List of cohort slugs to add */
  add: Array<Scalars['String']>
}

/** Added Cohorts Result */
export type AddCohortEligibilityResult = UserCohorts

export type AddPolicyInput = {
  name: Scalars['String']
}

export type AddPolicyResult =
  | AddPolicySuccess
  | PoliciesRecordDoesNotExistException
  | PolicyNotAddedException

export type AddPolicySuccess = {
  __typename?: 'AddPolicySuccess'
  policies: Maybe<Array<Maybe<Policy>>>
}

export type AddSearchTermToLearnSearchHistoryInput = {
  term: Scalars['String']
}

export type AddSearchTermToLearnSearchHistoryResult = LearnSearchTermSavedResult

/** Failure for all Securities */
export type AddSecuritiesFailed = {
  __typename?: 'AddSecuritiesFailed'
  description: Scalars['String']
}

export type AddSecuritiesInput = {
  active: Scalars['Boolean']
  searchable: Scalars['Boolean']
  securitiesToAdd: Array<Scalars['TickerSymbol']>
}

export type AddSecuritiesResult = AddSecuritiesFailed | AddSecurityResults

export type AddSecurityFailed = {
  __typename?: 'AddSecurityFailed'
  description: Scalars['String']
}

export type AddSecurityResult = AddSecurityFailed | Fund | Stock

export type AddSecurityResults = {
  __typename?: 'AddSecurityResults'
  results: Array<AddSecurityResult>
}

/** Input to add a security to a portfolio */
export type AddSecurityToPortfolioInput = {
  /** Investment account ID */
  investmentAccountId: Scalars['ID']
  /** The market exchange symbol of the ETF to add to the portfolio */
  symbol: Scalars['String']
}

/** Result from adding a security to a portfolio */
export type AddSecurityToPortfolioResult =
  | InvestmentAccountNotFoundException
  | InvestmentAccountNotSupportedException
  | Portfolio
  | PortfolioNotFoundException
  | PortfolioNotSupportedException
  | SecurityNotSupportedException

/** Input for creating a Self Directed Portfolio */
export type AddSelfDirectedPortfolioInput = {
  /** ID of the existing investment account for this portfolio to be associated with */
  investmentAccountId: Scalars['ID']
}

/** Result from opening a Self Directed Portfolio */
export type AddSelfDirectedPortfolioResult =
  | CustomerAgreementRequiredException
  | InvalidInvestmentAccountException
  | InvalidSubscriptionTierException
  | InvestmentAccount
  | PortfolioNotFoundException

/** Miscellaneous attributes and information about a user's address */
export type Address = TimestampsInterface & {
  __typename?: 'Address'
  /** Type of address */
  addressType: AddressType
  /** City */
  city: Scalars['String']
  /** Country */
  country: Scalars['String']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Internal ID for address */
  id: Scalars['ID']
  /** State */
  state: Scalars['String']
  /** First street address */
  street1: Scalars['String']
  /** Second street address */
  street2: Maybe<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Internal ID for user */
  userId: Scalars['ID']
  /** Address has been verified */
  verified: Scalars['Boolean']
  /** Zip code */
  zipCode: Scalars['String']
}

export type AddressDeliverabilityAdditionalInfo = {
  __typename?: 'AddressDeliverabilityAdditionalInfo'
  isBusiness: Maybe<Scalars['Boolean']>
  isPoBox: Maybe<Scalars['Boolean']>
  isPrivateMailbox: Maybe<Scalars['Boolean']>
  isVacant: Maybe<Scalars['Boolean']>
}

/**
 * The Address is verified as deliverable but requires corrections to one or more input fields.
 * Note: Clients can determine what fields are different by diffing their input with the corrected field.
 */
export type AddressDeliverabilityCorrectedAddress = {
  __typename?: 'AddressDeliverabilityCorrectedAddress'
  additionalInfo: Maybe<AddressDeliverabilityAdditionalInfo>
  city: Maybe<Scalars['String']>
  country: Maybe<Scalars['String']>
  state: Maybe<Scalars['String']>
  street1: Maybe<Scalars['String']>
  street2: Maybe<Scalars['String']>
  zipCode: Maybe<Scalars['String']>
}

/** Changeable attributes for addresses */
export type AddressDeliverabilityInput = {
  city?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  street1: Scalars['String']
  street2?: InputMaybe<Scalars['String']>
  /** 5 digit zip code */
  zipCode?: InputMaybe<Scalars['String']>
}

export type AddressDeliverabilityResult =
  | AddressDeliverabilityCorrectedAddress
  | AddressDeliverabilityUnavailableError
  | AddressDeliverabilityVerificationError
  | AddressDeliverabilityVerified

/** The Verification was unavailable. Clients should determine how to handle this case according to product requirements */
export type AddressDeliverabilityUnavailableError = {
  __typename?: 'AddressDeliverabilityUnavailableError'
  requestId: Maybe<Scalars['String']>
}

/** The Verification rejected the address as undeliverable. */
export type AddressDeliverabilityVerificationError = {
  __typename?: 'AddressDeliverabilityVerificationError'
  failureReason: Maybe<AddressDeliverabilityVerificationErrorFailureReason>
  requestId: Maybe<Scalars['String']>
}

export enum AddressDeliverabilityVerificationErrorFailureReason {
  /** The input address matched to a physical address that does not receive delivery from the USPS */
  AddressNotDeliverable = 'addressNotDeliverable',
  /** The input address is missing or was not found */
  AddressNotFound = 'addressNotFound',
  /** The input matched multiple addresses, needs more info */
  AmbiguousAddress = 'ambiguousAddress',
  /** The input address has an invalid house number */
  InvalidAddressPrimaryNumber = 'invalidAddressPrimaryNumber',
  /** The input address contains an invalid ste, apt, or box number */
  InvalidAddressSecondaryNumber = 'invalidAddressSecondaryNumber',
  /** The input city is missing or invalid */
  InvalidCity = 'invalidCity',
  /** The input address' PO, RR, or HC box number invalid */
  InvalidPoBoxNumber = 'invalidPoBoxNumber',
  /** The input state code is missing or invalid */
  InvalidState = 'invalidState',
  /** The input postal code is missing or invalid */
  InvalidZipCode = 'invalidZipCode',
  /** The input address is missing a house number */
  MissingAddressPrimaryNumber = 'missingAddressPrimaryNumber',
  /** The input address is missing ste, apt, or box number */
  MissingAddressSecondaryNumber = 'missingAddressSecondaryNumber',
  /** The input address matched to CMRA but PMB designator not present (PMB 123 or # 123) */
  MissingPmbNumber = 'missingPmbNumber',
  /** The input address is missing PO, RR, or HC box number */
  MissingPoBoxNumber = 'missingPoBoxNumber',
  /** An unknown or unmapped error occurred */
  Unknown = 'unknown',
}

/** The Address is verified as deliverable with no corrections issued on any input fields. */
export type AddressDeliverabilityVerified = {
  __typename?: 'AddressDeliverabilityVerified'
  additionalInfo: Maybe<AddressDeliverabilityAdditionalInfo>
  requestId: Maybe<Scalars['String']>
}

/** Address Document Requested Alert. */
export type AddressDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'AddressDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Changeable attributes for addresses */
export type AddressInput = {
  /** City */
  city?: InputMaybe<Scalars['String']>
  /** Country */
  country?: InputMaybe<Scalars['String']>
  /** State */
  state?: InputMaybe<Scalars['String']>
  /** Street 1 */
  street1?: InputMaybe<Scalars['String']>
  /** Street 2 */
  street2?: InputMaybe<Scalars['String']>
  /** Zip code */
  zipCode?: InputMaybe<Scalars['String']>
}

export enum AddressType {
  /** A billing address */
  Billing = 'billing',
  /** A mailing address */
  Mailing = 'mailing',
  /** A residential address */
  Residential = 'residential',
}

export type AddressVerification = {
  verificationStatus: VerificationStatus
}

export type AdultContextInput = {
  accountTenureDays?: InputMaybe<Scalars['Int']>
  activationDate?: InputMaybe<Scalars['String']>
  dateOfBirth?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  enabledFeatures?: InputMaybe<Array<Scalars['String']>>
  firstName?: InputMaybe<Scalars['String']>
  gender?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  numberOfChildren?: InputMaybe<Scalars['Int']>
  parentWalletBalance?: InputMaybe<Scalars['Float']>
  signupDate?: InputMaybe<Scalars['String']>
  subscriptionPlan?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
}

/** An existing Acorns user that has referred friends to Acorns */
export type Advocate = {
  __typename?: 'Advocate'
  /** User's current eligible campaign */
  campaign: Maybe<ReferralCampaignV2>
  /** The content that supports and drives the user experience */
  experienceContent: Maybe<ExperienceContent>
  /**
   * A list of people that have used the advocate's share link
   * @deprecated Field no longer supported
   */
  friends: Maybe<Array<Friend>>
  /** The referral code associated with the advocate */
  referralCodes: Maybe<Array<Scalars['String']>>
  /**
   * An object with referral metrics for the advocate
   * @deprecated Field no longer supported
   */
  referralHistory: Maybe<ReferralHistory>
  /** UUID of the existing Acorns user */
  userId: Maybe<Scalars['ID']>
}

/** List of referral codes and friends that were referred by an existing Acorns user */
export type AdvocateFriendsStatuses = {
  __typename?: 'AdvocateFriendsStatuses'
  /** A list of people that have used the advocate's share link */
  friends: Maybe<Array<Friend>>
  /** The referral codes associated with the advocate */
  referralCodes: Maybe<Array<Scalars['String']>>
  /** User ID of the advocate */
  userId: Scalars['ID']
}

export type AdvocateV2 = {
  __typename?: 'AdvocateV2'
  userId: Maybe<Scalars['ID']>
}

export type Alert = {
  /** @deprecated The type of the alert is defined by the gql type. */
  type: Scalars['String']
  userId: Scalars['ID']
}

/** Response from beneficiary alert hub alerts query */
export type AlertHubBeneficiaryAlert =
  | MissingSsnBeneficiaryAlertItem
  | UnverifiedBeneficiarySsnAlertItem

export type AlertMessage = Message & {
  __typename?: 'AlertMessage'
  actionCount: Scalars['Int']
  body: MessageTextAsset
  cardSubCategory: Maybe<CardSubCategory>
  createdAt: Scalars['DateTime']
  deepLink: Maybe<Scalars['URL']>
  delay: Maybe<Scalars['Int']>
  externalId: Scalars['ID']
  icon: Maybe<MessageVisualAsset>
  iconEnum: Maybe<IconType>
  iconURL: Maybe<Scalars['URL']>
  id: Scalars['ID']
  isDismissed: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isRead: Scalars['Boolean']
  lifetimeCap: Maybe<Scalars['Int']>
  messageCategory: MessageCategory
  messageType: MessageType
  platforms: Array<Platform>
  priority: Maybe<Scalars['Int']>
  readAt: Maybe<Scalars['DateTime']>
  title: MessageTextAsset
  trackingId: Maybe<Scalars['ID']>
  updatedAt: Scalars['DateTime']
}

export type AllAccountHistorySummary = PastSummary & {
  __typename?: 'AllAccountHistorySummary'
  dividends: CurrencyAmount
  earnRewards: CurrencyAmount
  moneyIn: CurrencyAmount
  moneyOut: CurrencyAmount
  referralRewards: CurrencyAmount
}

/** Optional filter to retrieve all accounts for a customer. */
export type AllAccountsFilterInput = {
  /** Retrieve accounts internal to Acorns. */
  internalType?: InputMaybe<Scalars['Boolean']>
}

export type AllBankAccountsInput = {
  /** Deprecated. Use types instead. types takes precedence over type if both are non-null */
  type?: InputMaybe<BankAccountType>
  types?: InputMaybe<Array<BankAccountType>>
}

export type AllBankCardsFilter = {
  showNonActive?: InputMaybe<Scalars['Boolean']>
}

export type AllBankDocumentsInput = {
  accountType?: InputMaybe<BankAccountType>
  isActive?: InputMaybe<Scalars['Boolean']>
}

export type AllChatHistoryMessages = {
  __typename?: 'AllChatHistoryMessages'
  edges: Array<ChatHistoryMessageEdge>
  pageInfo: PageInfo
}

export type AllChatSessions = {
  __typename?: 'AllChatSessions'
  edges: Array<ChatSessionEdge>
  pageInfo: PageInfo
}

/** The result of the allCheckPayments query */
export type AllCheckPaymentsResult = AuthorizationError | CheckPaymentConnection

export type AllPastCoreItemsSchemaFilter = {
  /** Only return pending items */
  pending?: InputMaybe<Scalars['Boolean']>
}

export type AllPastEarlyItemsSchemaFilter = {
  /** Only return pending items */
  pending?: InputMaybe<Scalars['Boolean']>
}

export type AllPastItemsFilter = {
  /** Only return items created on or before this date. yyyy-MM-dd */
  endDate?: InputMaybe<Scalars['Date']>
  /** Requested Account */
  pastItemsAccountFilter?: InputMaybe<PastItemsAccountFilter>
  /** Only return pending items */
  pending?: InputMaybe<Scalars['Boolean']>
  /** Only return items created on or after this date. yyyy-MM-dd */
  startDate?: InputMaybe<Scalars['Date']>
}

export type AllPastLaterItemsSchemaFilter = {
  /** Only return pending items */
  pending?: InputMaybe<Scalars['Boolean']>
}

export type AllPastSpendItemsSchemaFilter = {
  /** Only return pending items */
  pending?: InputMaybe<Scalars['Boolean']>
}

export type AllSupportArticlesFilterInput = {
  after?: InputMaybe<Scalars['String']>
  brand?: InputMaybe<ArticleBrand>
  first?: InputMaybe<Scalars['Int']>
  promoted?: InputMaybe<Scalars['Boolean']>
}

export type AllTransferableToInput = {
  /** ID of TransferableAccounts that money can be taken from */
  from: Scalars['ID']
}

export type AllocateFirmSharesFailed = {
  __typename?: 'AllocateFirmSharesFailed'
  description: Scalars['String']
  errorCode: Scalars['String']
}

export type AllocateFirmSharesSuccess = {
  __typename?: 'AllocateFirmSharesSuccess'
  allocationId: Scalars['String']
}

export type AllocateFirmSharesToSettlementInput = {
  /** Per-product share allocations */
  allocations: Array<FirmAllocationInput>
  /** Idempotency key passed through to DriveWealth */
  idempotencyKey: Scalars['String']
  /** The order ID (same as aggregate_order_fund.id in the backend) */
  orderId: Scalars['UUID']
}

export type AllocateFirmSharesToSettlementResult =
  | AllocateFirmSharesFailed
  | AllocateFirmSharesSuccess

/** Returned when the allocation amounts add up to over 100 */
export type AllocationAmountsSumExceedingMaxError = {
  __typename?: 'AllocationAmountsSumExceedingMaxError'
  message: Scalars['String']
}

/**
 * An operator-managed Amplitude feature flag. Creating or updating a flag
 * automatically syncs the corresponding amplitudeState.<flagKey> entry in
 * field_registry so it is immediately available for rule authoring.
 * flagKey is immutable after creation.
 */
export type AmplitudeFlag = {
  __typename?: 'AmplitudeFlag'
  /** Full Amplitude dashboard URL for deep linking (optional). */
  amplitudeUrl: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  createdBy: Maybe<Scalars['String']>
  description: Maybe<Scalars['String']>
  displayName: Scalars['String']
  /** Raw Amplitude flag key (no namespace prefix, e.g. enable_early_match_widget). */
  flagKey: Scalars['String']
  id: Scalars['ID']
  status: AmplitudeFlagStatus
  /** When true, evaluateV2() fires an Amplitude exposure event on each evaluation (24-hour dedup). Default false — enable only when starting an A/B experiment. */
  trackExposure: Scalars['Boolean']
  updatedAt: Scalars['DateTime']
  updatedBy: Maybe<Scalars['String']>
}

export type AmplitudeFlagConnection = {
  __typename?: 'AmplitudeFlagConnection'
  edges: Array<AmplitudeFlagEdge>
  pageInfo: PageInfo
}

export type AmplitudeFlagEdge = {
  __typename?: 'AmplitudeFlagEdge'
  node: AmplitudeFlag
}

export type AmplitudeFlagFilterInput = {
  flagKey?: InputMaybe<Scalars['String']>
  status?: InputMaybe<AmplitudeFlagStatus>
}

export enum AmplitudeFlagStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type AnswerChallengeResult =
  | AnswerChallengeSuccess
  | AuthChallengeAnswerAttemptsExhaustedException
  | AuthChallengeAnswerIncorrectException
  | AuthChallengeExpiredException

export type AnswerChallengeSuccess = {
  __typename?: 'AnswerChallengeSuccess'
  authenticatorId: Scalars['ID']
  deliveryType: ChallengeDeliveryType
  userId: Scalars['ID']
}

export type AnswerLearnQuizQuestionInput = {
  questionId: Scalars['ID']
  quizId: Scalars['ID']
  /** A list of one or more answers (if multiple choice question) */
  selectedAnswers: Array<LearnAnswerInput>
}

export type AnswerLearnQuizQuestionResult =
  | LearnQuizAnswerResult
  | RecordDoesNotExistError
  | UnauthorizedModifyLockedContentError

export type ApexAccountIdResult = {
  __typename?: 'ApexAccountIdResult'
  /** The Apex Silver account ID (null on error) */
  apexAccountId: Maybe<Scalars['String']>
  /** Error code for programmatic handling (ACCOUNT_NOT_FOUND, UNSUPPORTED_ACCOUNT_TYPE, USER_NOT_FOUND, MISSING_ACCOUNT_NUMBER, UNKNOWN_ERROR) */
  errorCode: Maybe<Scalars['String']>
  /** Human-readable error message (null on success) */
  message: Maybe<Scalars['String']>
  /** Indicates whether the operation succeeded */
  success: Scalars['Boolean']
}

export enum App {
  Acorns = 'ACORNS',
  AcornsEarly = 'ACORNS_EARLY',
}

export enum ApplicationType {
  AskAcorns = 'ASK_ACORNS',
  MoneyMentor = 'MONEY_MENTOR',
}

export type ApplyPromoCodeResult = InvalidPromoCodeError | PromoCodeCustomer

export type ApplyPromotionInput = {
  promotionId: Scalars['ID']
  subscriptionId: Scalars['ID']
}

export type ApplyPromotionResult =
  | PromotionConsumedError
  | PromotionExpiredError
  | PromotionNotFoundError
  | SubscriberIneligibleError
  | TierSubscription

export type ApplyPromotionalWaiverInput = {
  monthsToWaive: Scalars['Int']
  promotion: WaiverPromotion_V2
}

export type ApplyPromotionalWaiverResult =
  | InvalidDateException
  | InvalidUserIdException
  | PromotionalWaiver_V2
  | WaiverCreationException

export type ApplyProvisionalWaiverResult =
  | InvalidDateException
  | InvalidUserIdException
  | ProvisionalWaiver_V2
  | WaiverCreationException

export type ApplyWaiverCouponInput = {
  /** Number of months to waive the subscription fee */
  monthsToWaive: Scalars['Int']
  /** Optional reason for applying provisional waiver */
  waiverReason?: InputMaybe<Scalars['String']>
  /**
   * The type of waiver to apply (e.g., 'CRICKET', 'MIGHTY_OAK_CARD').
   * Note: New waiver types must be raised to the engineering team prior to being used in the mutation.
   */
  waiverType: Scalars['String']
}

export type ApplyWaiverCouponResult =
  | CouponNotFoundError
  | InvalidUserIdException
  | RedeemedWaiverCoupon
  | WaiverCreationException

export type ArchiveInvalidSmartDepositRecordsResult = {
  __typename?: 'ArchiveInvalidSmartDepositRecordsResult'
  userId: Scalars['String']
}

export enum ArticleBrand {
  Acorns = 'ACORNS',
  AcornsEarly = 'ACORNS_EARLY',
  All = 'ALL',
}

/** Options to assign a subaccount to a given role */
export type AssignLinkedSubaccountInput = {
  /** Role to give the linked subaccount */
  role: LinkedSubaccountRoleEnum
}

/** Response returned if the link session is asynchronous. */
export type AsyncLinkSessionResult = {
  __typename?: 'AsyncLinkSessionResult'
  /** The asynchronous process was kicked off successfully? */
  success: Scalars['Boolean']
}

export type AttachChatTranscriptInput = {
  messagingSessionId: Scalars['String']
}

export type AttachChatTranscriptResult = {
  __typename?: 'AttachChatTranscriptResult'
  contentDocumentId: Scalars['ID']
  contentVersionId: Scalars['ID']
  error: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export enum AttachmentDocType {
  Pdf = 'PDF',
}

export type AuthAlert = {
  type: Scalars['String']
  userId: Scalars['ID']
}

export type AuthChallenge = {
  alternateAuthenticators: Array<AuthenticatorInfo>
  challengeTrigger: ChallengeTriggers
  completedAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  sessionId: Maybe<Scalars['ID']>
  updatedAt: Scalars['DateTime']
}

export type AuthChallengeAnswerAttemptsExhaustedException = {
  __typename?: 'AuthChallengeAnswerAttemptsExhaustedException'
  message: Maybe<Scalars['String']>
}

export type AuthChallengeAnswerIncorrectException = {
  __typename?: 'AuthChallengeAnswerIncorrectException'
  message: Maybe<Scalars['String']>
}

export type AuthChallengeExpiredException = {
  __typename?: 'AuthChallengeExpiredException'
  message: Maybe<Scalars['String']>
}

export type AuthProfile = {
  __typename?: 'AuthProfile'
  /** the Authenticator that will be used for challenges by default. */
  defaultAuthenticator: Maybe<Authenticator>
  email: Maybe<Scalars['EmailAddress']>
  emailVerifiedAt: Maybe<Scalars['DateTime']>
  loginAccess: Maybe<LoginAccess>
  phoneNumber: Maybe<Scalars['String']>
  phoneNumberVerifiedAt: Maybe<Scalars['DateTime']>
  privateRelayUnverified: Maybe<Scalars['Boolean']>
  requireLoginChallenge: Maybe<Scalars['Boolean']>
  userId: Scalars['ID']
}

export type AuthProfileAlreadyExistsException = {
  __typename?: 'AuthProfileAlreadyExistsException'
  message: Maybe<Scalars['String']>
}

export type AuthProfileNotFoundException = {
  __typename?: 'AuthProfileNotFoundException'
  message: Maybe<Scalars['String']>
  userId: Maybe<Scalars['ID']>
}

export type AuthSession = {
  __typename?: 'AuthSession'
  id: Scalars['ID']
  identityId: Scalars['ID']
  identityToken: Maybe<Scalars['ID']>
  /** @deprecated No longer used */
  redirectUrl: Maybe<Scalars['URL']>
  refreshToken: Maybe<Scalars['ID']>
  token: Scalars['ID']
}

export type AuthTokenNotFoundException = {
  __typename?: 'AuthTokenNotFoundException'
  userId: Scalars['ID']
}

export enum AuthType {
  Email = 'EMAIL',
  Phone = 'PHONE',
  Push = 'PUSH',
}

export type AuthenticateForFeeNegotiationChallengeInput = {
  linkedAccountId: Scalars['ID']
  tfaInput: Scalars['String']
}

export type AuthenticateForFeeNegotiationChallengeMethodInput = {
  linkedAccountId: Scalars['ID']
  restart: Scalars['Boolean']
  tfaOption: Scalars['String']
  tfaType: TfaType
}

export type AuthenticateForFeeNegotiationInput = {
  bankName: BankName
  linkedAccountId: Scalars['ID']
  password: Scalars['String']
  reconnect: Scalars['Boolean']
  userName: Scalars['String']
}

export type AuthenticateForFeeNegotiationResult =
  | AuthenticateForFeeNegotiationStatus
  | LinkedAccountNotFound
  | NegotiationServiceConnectionFailure

export type AuthenticateForFeeNegotiationStatus = {
  __typename?: 'AuthenticateForFeeNegotiationStatus'
  credentialStatus: CredentialStatus
  operationError: Maybe<AutomationError>
  operationStage: OperationStage
  tfaMethod: Maybe<Scalars['String']>
  tfaOptions: Maybe<TfaOptions>
  tfaStatus: TfaStatus
  tfaType: TfaType
}

export type AuthenticateInput = {
  email: Scalars['EmailAddress']
  password: Scalars['String']
  rememberMe?: InputMaybe<Scalars['Boolean']>
  udid: Scalars['String']
}

export type AuthenticateNegotiationStatusResult =
  | AuthenticateForFeeNegotiationStatus
  | LinkedAccountNotFound

export type AuthenticateResult =
  | AuthChallengeAnswerAttemptsExhaustedException
  | AuthChallengeAnswerIncorrectException
  | AuthChallengeExpiredException
  | AuthSession
  | AuthenticatorTypeAlreadyRegisteredException
  | AuthenticatorUnavailableException
  | ChallengeRateExceededException
  | DeviceBlockedException
  | EmailAuthChallenge
  | InvalidCredentialsException
  | LoginRateLimitedException
  | PhoneNumberOptedOutException
  | SmsAuthChallenge
  | UserLockedException
  | UserSuspendedException

export type AuthenticationAlreadyUpgradedException = {
  __typename?: 'AuthenticationAlreadyUpgradedException'
  userId: Scalars['ID']
}

export type Authenticator = {
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  lastAuthenticatedAt: Maybe<Scalars['DateTime']>
  lastUsedAt: Maybe<Scalars['DateTime']>
  name: Scalars['String']
  type: AuthType
  updatedAt: Scalars['DateTime']
}

export type AuthenticatorAlreadyDefaultException = {
  __typename?: 'AuthenticatorAlreadyDefaultException'
  message: Maybe<Scalars['String']>
}

export type AuthenticatorInfo = {
  __typename?: 'AuthenticatorInfo'
  id: Scalars['ID']
  type: AuthType
}

export type AuthenticatorNotFoundException = {
  __typename?: 'AuthenticatorNotFoundException'
  message: Maybe<Scalars['String']>
}

export type AuthenticatorTypeAlreadyRegisteredException = {
  __typename?: 'AuthenticatorTypeAlreadyRegisteredException'
  message: Maybe<Scalars['String']>
}

export type AuthenticatorUnavailableException = {
  __typename?: 'AuthenticatorUnavailableException'
  message: Maybe<Scalars['String']>
}

export type AuthorizationError = {
  __typename?: 'AuthorizationError'
  requestId: Scalars['ID']
}

export type AutomationError = {
  __typename?: 'AutomationError'
  error: Maybe<Scalars['String']>
  errorCode: Maybe<AutomationErrorCode>
}

export enum AutomationErrorCode {
  CttEx = 'CTT_EX',
  LogBlk = 'LOG_BLK',
  LogEx = 'LOG_EX',
  LogInv = 'LOG_INV',
  SttEx = 'STT_EX',
  SttRes = 'STT_RES',
  TfaInv = 'TFA_INV',
  TfaSelInv = 'TFA_SEL_INV',
  WfTfa = 'WF_TFA',
}

export type BackendJobBatch = {
  __typename?: 'BackendJobBatch'
  createdAt: Scalars['DateTime']
  failedJobs: Maybe<Scalars['Int']>
  id: Scalars['ID']
  name: Scalars['String']
  pendingJobs: Maybe<Scalars['Int']>
  pendingPercentage: Maybe<Scalars['Float']>
  processedJobs: Maybe<Scalars['Int']>
  status: BackendJobBatchStatus
  successPercentage: Maybe<Scalars['Float']>
  totalJobs: Maybe<Scalars['Int']>
  type: BackendJobBatchType
}

export type BackendJobBatchAutomatedOrdersFilterInput = {
  jobBatchType?: InputMaybe<BackendJobBatchType>
  timeframe: BackendJobBatchTimeframe
}

export type BackendJobBatchMoneyMovementFilterInput = {
  jobBatchType?: InputMaybe<BackendJobBatchType>
  timeframe: BackendJobBatchTimeframe
}

export type BackendJobBatchOrdersFilterInput = {
  jobBatchType?: InputMaybe<BackendJobBatchType>
  timeframe: BackendJobBatchTimeframe
}

export type BackendJobBatchProfitStarsFilterInput = {
  timeframe: BackendJobBatchTimeframe
}

export enum BackendJobBatchStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Restarted = 'RESTARTED',
  Started = 'STARTED',
}

export type BackendJobBatchSummary = {
  __typename?: 'BackendJobBatchSummary'
  createdAt: Scalars['DateTime']
  customerCount: Maybe<Scalars['Int']>
  id: Scalars['ID']
  name: Scalars['String']
  totalHoldingsAmount: Maybe<Scalars['Float']>
  totalInvestmentAmount: Maybe<Scalars['Float']>
  totalInvestmentCount: Maybe<Scalars['Int']>
}

export type BackendJobBatchSummaryFilterInput = {
  jobBatchType: BackendJobBatchType
  timeframe: BackendJobBatchTimeframe
}

export enum BackendJobBatchTimeframe {
  LastSeven = 'LAST_SEVEN',
  LastThirty = 'LAST_THIRTY',
  Month = 'MONTH',
  Today = 'TODAY',
  Year = 'YEAR',
  Yesterday = 'YESTERDAY',
}

export enum BackendJobBatchType {
  AutomatedBuyOrderConfirm = 'AUTOMATED_BUY_ORDER_CONFIRM',
  AutomatedBuyOrderLock = 'AUTOMATED_BUY_ORDER_LOCK',
  AutomatedSellFeeOrderConfirm = 'AUTOMATED_SELL_FEE_ORDER_CONFIRM',
  AutomatedSellFeeOrderLock = 'AUTOMATED_SELL_FEE_ORDER_LOCK',
  BuyOrderConfirm = 'BUY_ORDER_CONFIRM',
  BuyOrderLock = 'BUY_ORDER_LOCK',
  ChargebackOrderLock = 'CHARGEBACK_ORDER_LOCK',
  ProfitStarsDeposits = 'PROFIT_STARS_DEPOSITS',
  RebalanceBuyOrderConfirm = 'REBALANCE_BUY_ORDER_CONFIRM',
  RebalanceBuyOrderLock = 'REBALANCE_BUY_ORDER_LOCK',
  RebalanceSellOrderConfirm = 'REBALANCE_SELL_ORDER_CONFIRM',
  RebalanceSellOrderLock = 'REBALANCE_SELL_ORDER_LOCK',
  SellFeeOrderConfirm = 'SELL_FEE_ORDER_CONFIRM',
  SellFeeOrderLock = 'SELL_FEE_ORDER_LOCK',
  TransferApproval = 'TRANSFER_APPROVAL',
}

/** Request either has missing or incorrect data */
export type BadRequestError = {
  __typename?: 'BadRequestError'
  message: Scalars['String']
}

export enum BadgeCategory {
  NewCustomer = 'NEW_CUSTOMER',
  Travel = 'TRAVEL',
}

export type BankAccount = {
  __typename?: 'BankAccount'
  accountHolderReferenceId: Scalars['ID']
  /** The name of the account */
  accountName: Scalars['String']
  /**
   * Balance available for immediate withdrawal.
   * Settling a transaction for a DDA account will typically credit the
   * availableBalance immediately. However, savings or FBO accounts may have
   * a "deposit hold time" or a "new customer hold time", meaning there could be
   * a length of time between when the transaction is settled and the corresponding
   * funds are made available for withdrawal.
   */
  availableBalance: CurrencyAmount
  availableBalanceAndIncomingBalance: CurrencyAmount
  balance: CurrencyAmount
  /** The bank that this account is associated with */
  bankType: BankType
  closedAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  /**
   * The interest rates that are currently being offered
   * @deprecated Use bankInterestRates Query to get apy
   */
  currentAPY: Maybe<Scalars['String']>
  /** @deprecated Use balance */
  currentBalance: CurrencyAmount
  /** Information related to the goals of the bank account */
  goals: BankAccountGoals
  id: Scalars['ID']
  /** The BankingProduct interest-rate bucket for this account, or null if non-interest-bearing. Used to look up the interest rate via bankInterestRates query. */
  interestRateProduct: Maybe<BankingProduct>
  isEligible: Scalars['Boolean']
  isLocked: Scalars['Boolean']
  /**
   * True if an account closure has been initiated but
   * was unsuccessful in automatically closing.
   */
  isPendingClosure: Maybe<Scalars['Boolean']>
  lockReason: Maybe<BankAccountLockReason>
  number: Scalars['String']
  /**
   * Balance of pending deposit transactions. When a pending deposit transaction
   * settles, it will debit this balance. Deposit transactions which settle
   * immediately will never affect this balance.
   */
  pendingBalance: CurrencyAmount
  referenceId: Scalars['ID']
  /**
   * The current status of the account and requirements
   * needed to be met to close the account
   */
  requirements: BankAccountRequirements
  routingNumber: Scalars['String']
  status: BankAccountStatus
  /**
   * Total balance of account, including funds that have holds placed on them. Represents all settled
   * transactions on the account to date. Balance of pending deposit transactions. When a pending deposit transaction settles, it will
   * debit this balance. Deposit transactions which settle immediately will never affect this
   * balance.
   */
  totalBalance: CurrencyAmount
  type: BankAccountType
  unavailableBalance: BankingCurrencyAmount
  updatedAt: Scalars['DateTime']
}

export enum BankAccountClosureReason {
  /** Going to a competitor */
  GoingToACompetitor = 'GOING_TO_A_COMPETITOR',
  /** Had a bad experience */
  HadABadExperience = 'HAD_A_BAD_EXPERIENCE',
  /** Missing features I expect with a checking account */
  MissingFeaturesExpectedWithCheckingAccount = 'MISSING_FEATURES_EXPECTED_WITH_CHECKING_ACCOUNT',
  /** Not seeing the value */
  NotSeeingTheValue = 'NOT_SEEING_THE_VALUE',
  /** No longer use */
  NoLongerUse = 'NO_LONGER_USE',
  /** Other */
  Other = 'OTHER',
}

export type BankAccountDisclosure = {
  __typename?: 'BankAccountDisclosure'
  id: Scalars['ID']
  mustScrollToBottom: Maybe<Scalars['Boolean']>
  name: Scalars['String']
  requiredFor: Maybe<Scalars['String']>
  summaryName: Maybe<Scalars['String']>
  summaryUrl: Maybe<Scalars['String']>
  type: Scalars['String']
  url: Scalars['String']
  version: Scalars['String']
}

export type BankAccountDisclosureFilter = {
  bankType: BankType
  paymentProcessor: BankCardPaymentProcessor
}

export type BankAccountGoal = {
  __typename?: 'BankAccountGoal'
  amount: CurrencyAmount
  name: Scalars['String']
  type: BankAccountGoalType
}

export type BankAccountGoalInput = {
  amount: PositiveCurrencyAmountInput
  type: BankAccountGoalType
}

export enum BankAccountGoalType {
  EmergencySavings = 'EMERGENCY_SAVINGS',
}

export type BankAccountGoals = {
  __typename?: 'BankAccountGoals'
  currentGoal: Maybe<BankAccountGoal>
}

export enum BankAccountLockReason {
  Administrative = 'Administrative',
  CreditsOnly = 'CreditsOnly',
  Fraud = 'Fraud',
  Frozen = 'Frozen',
  Temporary = 'Temporary',
  Unknown = 'Unknown',
}

export type BankAccountNotFoundError = {
  __typename?: 'BankAccountNotFoundError'
  message: Scalars['String']
}

/**
 * Defines a list of requirements that must be met before a bank account
 * can be closed
 */
export type BankAccountRequirement = {
  __typename?: 'BankAccountRequirement'
  actionable: Scalars['Boolean']
  description: Maybe<Scalars['String']>
  expectedCompletionDate: Maybe<Scalars['DateTime']>
  status: BankAccountRequirementStatus
  type: BankAccountRequirementType
}

export enum BankAccountRequirementStatus {
  ActionsRequired = 'ACTIONS_REQUIRED',
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
}

export enum BankAccountRequirementType {
  FundingSource = 'FUNDING_SOURCE',
  NoPendingTransfers = 'NO_PENDING_TRANSFERS',
  UnlockedCheckingAccount = 'UNLOCKED_CHECKING_ACCOUNT',
  VerifiedFundingSource = 'VERIFIED_FUNDING_SOURCE',
}

export type BankAccountRequirements = {
  __typename?: 'BankAccountRequirements'
  close: Array<BankAccountRequirement>
}

export type BankAccountState = {
  __typename?: 'BankAccountState'
  accountType: BankAccountType
  status: BankAccountStateStatus
}

export type BankAccountStateResult = {
  __typename?: 'BankAccountStateResult'
  accounts: Array<BankAccountState>
}

export enum BankAccountStateStatus {
  Closed = 'CLOSED',
  HardFailure = 'HARD_FAILURE',
  Locked = 'LOCKED',
  NotOpened = 'NOT_OPENED',
  Open = 'OPEN',
  Opening = 'OPENING',
  Reopening = 'REOPENING',
}

export enum BankAccountStatus {
  Closed = 'closed',
  Locked = 'locked',
  Open = 'open',
}

export enum BankAccountType {
  Save = 'save',
  Spend = 'spend',
}

export type BankAccountTypeConfig = {
  accountType: BankAccountType
  bankType?: InputMaybe<BankType>
}

export type BankCard = {
  __typename?: 'BankCard'
  activatedAt: Maybe<Scalars['DateTime']>
  bankType: BankType
  cardNumberMasked: Maybe<Scalars['CardNumberMasked']>
  createdAt: Scalars['DateTime']
  digitalWalletTokens: Array<DigitalWalletToken>
  expireMonth: Scalars['Int']
  expireYear: Scalars['Int']
  id: Scalars['ID']
  isDigitalOnly: Maybe<Scalars['Boolean']>
  isDigitallyProvisioned: Scalars['Boolean']
  lockReason: Maybe<BankCardLockReason>
  lockTypeCode: BankCardLockTypeCode
  paymentProcessor: BankCardPaymentProcessor
  referenceId: Scalars['ID']
  status: BankCardStatus
  tier: BankCardTier
  type: BankCardType
  userActivatedAt: Maybe<Scalars['DateTime']>
}

export enum BankCardLockReason {
  Admin = 'admin',
  Damage = 'damage',
  Fraud = 'fraud',
  Lost = 'lost',
  PinRetriesExceeded = 'pinRetriesExceeded',
  Stolen = 'stolen',
  Temporary = 'temporary',
  Unknown = 'unknown',
}

export enum BankCardLockTypeCode {
  Customer = 'customer',
  System = 'system',
  Unlocked = 'unlocked',
}

export type BankCardOrder = {
  __typename?: 'BankCardOrder'
  addressVerification: Maybe<BankCardOrderAddressVerification>
  bankCardTier: Maybe<BankCardTier>
  bankType: Maybe<BankType>
  cardOrderStatus: BankCardOrderStatus
  createdAt: Maybe<Scalars['String']>
  failureReason: Maybe<BankCardOrderFailureReason>
  /**
   * @deprecated - Only used for backward compatibility with pre-optional physical cards flows (SEPTEMBER_2022 and earlier).
   * Funding event requirements:
   * - OPC flow (OPTIONAL_PHYSICAL_CARD): NOT required for issuing physical/digital cards.
   * - Legacy flows (SEPTEMBER_2022 and earlier): REQUIRED for issuing physical/digital cards
   */
  fundingInitiated: Maybe<Scalars['Boolean']>
  fundingSourceVerification: Maybe<BankCardOrderFundingSourceVerification>
  identityVerification: Maybe<BankCardOrderIdentityVerification>
  /**
   * Verification results for this customer contained reasons that we consider high risk,
   * irrespective of the decision returned by our KYC vendor.
   * The purpose of this field is to surface that risk to related backend services.
   * Front end clients should confirm with banking team before using.
   */
  isKycHighRisk: Maybe<Scalars['Boolean']>
  kycStatus: Maybe<KycStatus>
  prefundVerification: Maybe<BankCardOrderPrefundVerification>
  requestVersion: Maybe<RequestVersions>
}

export type BankCardOrderAddressVerification = AddressVerification & {
  __typename?: 'BankCardOrderAddressVerification'
  actionRequired: Maybe<BankCardOrderAddressVerificationActions>
  status: BankCardOrderVerificationStatus
  verificationStatus: VerificationStatus
}

export enum BankCardOrderAddressVerificationActions {
  UploadDocuments = 'uploadDocuments',
}

export enum BankCardOrderFailureReason {
  AddressFailure = 'ADDRESS_FAILURE',
  Expired = 'EXPIRED',
  FundingSourceFailure = 'FUNDING_SOURCE_FAILURE',
  IdentityFailure = 'IDENTITY_FAILURE',
  PrefundFailure = 'PREFUND_FAILURE',
}

export type BankCardOrderFundingSourceVerification = {
  __typename?: 'BankCardOrderFundingSourceVerification'
  actionRequired: Maybe<BankCardOrderFundingSourceVerificationActions>
  pendingReason: Maybe<BankCardOrderFundingSourceVerificationPendingReason>
  status: BankCardOrderVerificationStatus
}

export enum BankCardOrderFundingSourceVerificationActions {
  HandleFrozenFundingSource = 'handleFrozenFundingSource',
  LinkFundingSource = 'linkFundingSource',
  SubmitRdVs = 'submitRDVs',
  UploadDocuments = 'uploadDocuments',
}

export enum BankCardOrderFundingSourceVerificationPendingReason {
  DocumentsUnderReview = 'documentsUnderReview',
  RdvsInitiated = 'rdvsInitiated',
  RdvsPending = 'rdvsPending',
}

export type BankCardOrderIdentityVerification = IdentityVerification & {
  __typename?: 'BankCardOrderIdentityVerification'
  actionRequired: Maybe<BankCardOrderIdentityVerificationActions>
  /**
   * If the user can re-attempt identity verification
   * They may have reached the max configured allowed attempts, or need manual approval due to suspected fraud or risk
   */
  canRetry: Maybe<Scalars['Boolean']>
  documentUploadUrl: Maybe<Scalars['String']>
  status: BankCardOrderVerificationStatus
  verificationStatus: VerificationStatus
}

export enum BankCardOrderIdentityVerificationActions {
  UploadDocuments = 'uploadDocuments',
}

export type BankCardOrderPrefundVerification = {
  __typename?: 'BankCardOrderPrefundVerification'
  actionRequired: Maybe<BankCardOrderPrefundVerificationActions>
  status: BankCardOrderVerificationStatus
}

export enum BankCardOrderPrefundVerificationActions {
  CreateBankTransfer = 'createBankTransfer',
}

export enum BankCardOrderStatus {
  Accepted = 'accepted',
  ActionRequired = 'actionRequired',
  Failure = 'failure',
  NotOrdered = 'notOrdered',
  Pending = 'pending',
  Success = 'success',
}

export enum BankCardOrderVerificationStatus {
  ActionRequired = 'actionRequired',
  ActionRequiredDueToFailure = 'actionRequiredDueToFailure',
  Failure = 'failure',
  Pending = 'pending',
  Success = 'success',
}

export type BankCardPanDisplayPayload = {
  __typename?: 'BankCardPanDisplayPayload'
  bankCard: BankCard
  token: Scalars['String']
}

export type BankCardPanDisplayResult = BankCardPanDisplayPayload

export enum BankCardPaymentProcessor {
  Dps = 'DPS',
  Shazam = 'SHAZAM',
}

export enum BankCardPermanentLockReason {
  Fraud = 'fraud',
  Lost = 'lost',
  Stolen = 'stolen',
}

export type BankCardPrefundTransfer = {
  /** Amount (either $0 or between $25, $500) to transfer after bank account is created. */
  amount: PositiveCurrencyAmountInput
}

export type BankCardProvisioningDetailsInput = {
  nonce: Scalars['String']
}

export type BankCardProvisioningDetailsPayload = {
  __typename?: 'BankCardProvisioningDetailsPayload'
  cardNumberMasked: Maybe<Scalars['CardNumberMasked']>
  token: Scalars['String']
}

export type BankCardProvisioningDetailsResult =
  BankCardProvisioningDetailsPayload

export type BankCardReissue = {
  __typename?: 'BankCardReissue'
  bankCardRequest: Maybe<BankCardRequest>
  bankType: BankType
  reissueBankCardEligibility: ReissueBankCardEligibility
}

export type BankCardRequest = {
  __typename?: 'BankCardRequest'
  /** tag for new bank card */
  id: Scalars['ID']
  /** True when new bank card has been activated */
  isActivated: Scalars['Boolean']
  /** Indicates whether this reissue request is for a digital-only card */
  isDigitalOnlyReissueRequest: Maybe<Scalars['Boolean']>
  isReissue: Scalars['Boolean']
  /** Issued date for new bank card */
  issuedDate: Maybe<Scalars['Date']>
  /** The mailing address used to ship the reissued card */
  mailingAddress: Maybe<BankCardRequestMailingAddress>
  previousBankCardId: Maybe<Scalars['ID']>
  /** The tier level of the card. */
  previousBankCardTier: Maybe<BankCardTier>
  /** Reason for requesting a new bank card */
  reason: BankCardRequestReason
  /** Additional information pertaining to the request */
  reasonComment: Maybe<Scalars['String']>
  /** Date associated with reason (Date lost, date stolen, etc) */
  reasonDate: Maybe<Scalars['Date']>
  requestedDate: Scalars['Date']
  status: BankCardRequestStatus
  userId: Scalars['ID']
}

export type BankCardRequestMailingAddress = {
  __typename?: 'BankCardRequestMailingAddress'
  city: Scalars['String']
  country: Scalars['String']
  state: Scalars['String']
  street1: Scalars['String']
  street2: Maybe<Scalars['String']>
  zipCode: Scalars['String']
}

export type BankCardRequestMailingAddressInput = {
  city: Scalars['String']
  country: Scalars['String']
  state: Scalars['String']
  street1: Scalars['String']
  street2?: InputMaybe<Scalars['String']>
  zipCode: Scalars['String']
}

export enum BankCardRequestReason {
  Damaged = 'DAMAGED',
  DeliveryIssue = 'DELIVERY_ISSUE',
  Lost = 'LOST',
  NewAccount = 'NEW_ACCOUNT',
  Other = 'OTHER',
  Stolen = 'STOLEN',
  Unauthorized = 'UNAUTHORIZED',
}

export enum BankCardRequestStatus {
  Approved = 'APPROVED',
  Issued = 'ISSUED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
}

export enum BankCardStatus {
  Archived = 'archived',
  Denied = 'denied',
  DigitalActivePhysicalInitiated = 'digitalActivePhysicalInitiated',
  DigitalActivePhysicalPending = 'digitalActivePhysicalPending',
  Expired = 'expired',
  Hotlisted = 'hotlisted',
  Initiated = 'initiated',
  Pending = 'pending',
  PendingVerification = 'pendingVerification',
  Reissued = 'reissued',
  Verified = 'verified',
}

export enum BankCardTemporaryLockReason {
  Damage = 'damage',
  Fraud = 'fraud',
  Temporary = 'temporary',
  Unknown = 'unknown',
}

export enum BankCardTier {
  MightyOak = 'mightyOak',
  Oak = 'oak',
  PremiumOak = 'premiumOak',
  VipReissue = 'vipReissue',
}

export enum BankCardType {
  Credit = 'credit',
  Debit = 'debit',
}

export type BankConnection = {
  __typename?: 'BankConnection'
  accountStatus: Maybe<BankConnectionStatus>
  bank: Scalars['String']
  eligible: Maybe<Scalars['Boolean']>
  lastSubmissionDate: Maybe<Scalars['DateTime']>
  linkedAccountId: Scalars['ID']
  logoUrl: Maybe<Scalars['URL']>
  negotiationType: Maybe<NegotiationType>
  nextSubmissionDate: Maybe<Scalars['DateTime']>
  totalNegotiableFees: Maybe<MonetaryAmount>
}

export enum BankConnectionStatus {
  Eligible = 'ELIGIBLE',
  IneligibleCooldown = 'INELIGIBLE_COOLDOWN',
  IneligibleNotsupported = 'INELIGIBLE_NOTSUPPORTED',
  IneligibleThreshold = 'INELIGIBLE_THRESHOLD',
  Lowertier = 'LOWERTIER',
  Pending = 'PENDING',
}

export type BankDocument = {
  __typename?: 'BankDocument'
  name: Scalars['String']
  type: Scalars['String']
  url: Scalars['String']
}

/** Bank Document Requested Alert. */
export type BankDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'BankDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type BankFee = {
  __typename?: 'BankFee'
  accountName: Maybe<Scalars['String']>
  amount: MonetaryAmount
  category: Maybe<TransactionCategory>
  /** @deprecated replaced by last4 */
  digit: Maybe<Scalars['String']>
  last4: Maybe<Scalars['String']>
  linkedAccountId: Maybe<Scalars['ID']>
  linkedSubAccountId: Maybe<Scalars['ID']>
  name: Maybe<Scalars['String']>
  status: Maybe<FeeStatus>
  submissionKey: Maybe<Scalars['String']>
  subtitle: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
  transactionDate: Maybe<Scalars['DateTime']>
  type: Maybe<BankFeeType>
}

export type BankFeeConnection = {
  __typename?: 'BankFeeConnection'
  bank: BankName
  eligible: Scalars['Boolean']
  feeSynopsis: Maybe<Scalars['String']>
  institutionName: Scalars['String']
  latestSubmission: Maybe<Submission>
  linkedAccountId: Scalars['ID']
  logoUrl: Scalars['URL']
  mailInEligibility: Scalars['Boolean']
  status: ConnectionStatus
  submissions: Maybe<Array<Submission>>
  totalNegotiableFees: MonetaryAmount
}

export type BankFeeFilter = {
  connectionStatus?: InputMaybe<Array<BankConnectionStatus>>
  status?: InputMaybe<Array<FeeStatus>>
  submissionKey?: InputMaybe<Scalars['String']>
}

export enum BankFeeNegotiationExternalStatus {
  ActionrequiredConnectionError = 'ACTIONREQUIRED_CONNECTION_ERROR',
  ActionrequiredReportRefund = 'ACTIONREQUIRED_REPORT_REFUND',
  ActionrequiredScheduleCall = 'ACTIONREQUIRED_SCHEDULE_CALL',
  CallScheduled = 'CALL_SCHEDULED',
  ResolvedNoRefund = 'RESOLVED_NO_REFUND',
  ResolvedRefund = 'RESOLVED_REFUND',
  Submitted = 'SUBMITTED',
  SubmittedSent = 'SUBMITTED_SENT',
}

export enum BankFeeNegotiationInternalStatus {
  AutofetchCompleted = 'AUTOFETCH_COMPLETED',
  AutoConnectionError = 'AUTO_CONNECTION_ERROR',
  AutoError = 'AUTO_ERROR',
  AutoInProgress = 'AUTO_IN_PROGRESS',
  CallScheduled = 'CALL_SCHEDULED',
  MailInError = 'MAIL_IN_ERROR',
  MailInEscalated = 'MAIL_IN_ESCALATED',
  MailInPending = 'MAIL_IN_PENDING',
  MailInScheduleCall = 'MAIL_IN_SCHEDULE_CALL',
  MailInSent = 'MAIL_IN_SENT',
  Pending = 'PENDING',
  ResolvedNoRefund = 'RESOLVED_NO_REFUND',
  ResolvedRefund = 'RESOLVED_REFUND',
}

export enum BankFeeNegotiationStatus {
  AutoConnectionError = 'AUTO_CONNECTION_ERROR',
  AutoError = 'AUTO_ERROR',
  AutoInProgress = 'AUTO_IN_PROGRESS',
  CallScheduled = 'CALL_SCHEDULED',
  MailInError = 'MAIL_IN_ERROR',
  MailInEscalated = 'MAIL_IN_ESCALATED',
  MailInPending = 'MAIL_IN_PENDING',
  MailInScheduleCall = 'MAIL_IN_SCHEDULE_CALL',
  MailInSent = 'MAIL_IN_SENT',
  ResolvedNoRefund = 'RESOLVED_NO_REFUND',
  ResolvedRefund = 'RESOLVED_REFUND',
  Submitted = 'SUBMITTED',
}

export type BankFeeSummary = {
  __typename?: 'BankFeeSummary'
  coffeeCount: Scalars['Int']
  eligible: Scalars['Boolean']
  feesFound: FeeStatusSummary
  linkedAccounts: Array<BankFeeConnection>
  totalNegotiableFees: MonetaryAmount
  totalNegotiatedFees: MonetaryAmount
  totalReimbursedFees: MonetaryAmount
}

export enum BankFeeType {
  AccountMaintenanceFee = 'ACCOUNT_MAINTENANCE_FEE',
  AtmFee = 'ATM_FEE',
  BalanceInquiryFee = 'BALANCE_INQUIRY_FEE',
  CardSetupFee = 'CARD_SETUP_FEE',
  CashAdvance = 'CASH_ADVANCE',
  CheckFee = 'CHECK_FEE',
  ClosedAccountProcessingFee = 'CLOSED_ACCOUNT_PROCESSING_FEE',
  CreditCardInterestCharge = 'CREDIT_CARD_INTEREST_CHARGE',
  DormantFee = 'DORMANT_FEE',
  EarlyClosureFee = 'EARLY_CLOSURE_FEE',
  ExcessFee = 'EXCESS_FEE',
  ExternalTransferFee = 'EXTERNAL_TRANSFER_FEE',
  ForeignTransactionFee = 'FOREIGN_TRANSACTION_FEE',
  LateFee = 'LATE_FEE',
  MinimumBalanceFee = 'MINIMUM_BALANCE_FEE',
  MonthlyServiceFee = 'MONTHLY_SERVICE_FEE',
  NsfFee = 'NSF_FEE',
  OverdraftFee = 'OVERDRAFT_FEE',
  PaperStatementFee = 'PAPER_STATEMENT_FEE',
  StopPaymentFee = 'STOP_PAYMENT_FEE',
  WireTransferFee = 'WIRE_TRANSFER_FEE',
}

export type BankInterestRate = {
  __typename?: 'BankInterestRate'
  /** Pre-formatted to two places (i.e. "5.00"). Not present if the product has no associated interest rate. */
  currentApy: Maybe<Scalars['String']>
  liveDate: Maybe<Scalars['String']>
  productName: BankingProduct
}

export type BankInterestRates = {
  __typename?: 'BankInterestRates'
  bankInterestRates: Maybe<Array<BankInterestRate>>
}

export type BankInterestRatesResult = BankInterestRates | BankServiceFailure

export type BankMetadata = {
  __typename?: 'BankMetadata'
  /** Deprecated */
  totals: Maybe<BankMetadataTotals>
}

export type BankMetadataTotals = {
  __typename?: 'BankMetadataTotals'
  oak: Scalars['Int']
  royalOak: Scalars['Int']
}

export enum BankName {
  Chase = 'CHASE',
  NotApplicable = 'NOT_APPLICABLE',
  TestBank = 'TEST_BANK',
  WellsFargo = 'WELLS_FARGO',
}

export type BankServiceFailure = {
  __typename?: 'BankServiceFailure'
  reason: Maybe<Scalars['String']>
  retryable: Maybe<Scalars['Boolean']>
}

export type BankStatement = {
  __typename?: 'BankStatement'
  createdAt: Scalars['DateTime']
  month: Scalars['String']
  type: BankStatementType
  url: Scalars['String']
  year: Scalars['String']
}

export enum BankStatementType {
  Monthly = 'monthly',
  Tax = 'tax',
}

export type BankTransaction = {
  __typename?: 'BankTransaction'
  /** The amount of funds the transaction represents. */
  amount: CurrencyAmount
  /** The exact date and time the funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>
  /**
   * The card that created the transaction. Will be null if this transaction is
   * not tied to a card
   */
  bankCard: Maybe<BankCard>
  /** The exact date and time the transaction was created */
  createdAt: Scalars['DateTime']
  /**
   * Represents a client-specified description of the transaction.
   * If transaction was received from a NACHA file (typeCode is UNKWTH, UNKDEP, UNKRSV),
   * this property contains the description verbatim from the NACHA file. By law, this
   * description must be displayed to the end user. If transaction was received
   * from an ISO-8583 interface (i.e. debit card transaction), this property contains
   * description verbatim from DataElement 43 (Card Acceptor Name/Location) of
   * ISO-8583 interface plus details of any fees or surchages that may have been
   * incurred. By law, this description must be displayed to the end user
   * Otherwise, the transaction was received from a call to CorePro API or it was
   * line item in the Bulk Transfer File. This property contains the description
   * verbatim passed by the client code
   */
  description: Scalars['String']
  id: Scalars['ID']
  nachaCode: Scalars['String']
  nachaInfo: Maybe<BankTransactionNachaInfo>
  /** The exact date and time the transaction was settled. */
  settledAt: Maybe<Scalars['DateTime']>
  /** The status of the transaction */
  status: BankTransactionStatus
  /**
   * Shorter version of description. Depending on type, may contain full description.
   * Ex. Purchase transactions contain merchant name without address.
   */
  summary: Scalars['String']
  /** The program-wide unique identifier generated for each transfer */
  tag: Maybe<Scalars['String']>
  type: BankTransactionType
  typeCode: Scalars['String']
  updatedAt: Scalars['DateTime']
  /** The exact date and time the transaction was voided. */
  voidedAt: Maybe<Scalars['DateTime']>
}

export type BankTransactionConnection = {
  __typename?: 'BankTransactionConnection'
  edges: Array<Maybe<BankTransactionEdge>>
  pageInfo: PageInfo
}

export type BankTransactionEdge = {
  __typename?: 'BankTransactionEdge'
  cursor: Scalars['ID']
  node: Maybe<BankTransaction>
}

export type BankTransactionNachaInfo = {
  __typename?: 'BankTransactionNachaInfo'
  companyDiscretionaryData: Maybe<Scalars['String']>
  companyEntryDescription: Maybe<Scalars['String']>
  companyIdentification: Maybe<Scalars['String']>
  companyName: Maybe<Scalars['String']>
  isEarlyDeposit: Maybe<Scalars['Boolean']>
  nachaSettledDate: Maybe<Scalars['DateTime']>
  standardEntryClassCode: Maybe<Scalars['String']>
}

export enum BankTransactionStatus {
  /** Transaction has been created but not yet put into a NACHA file */
  Initiated = 'initiated',
  /** Transaction has been created and put into a NACHA file */
  Pending = 'pending',
  /** Transaction has been posted to the account */
  Settled = 'settled',
  /** Transaction has been voided */
  Voided = 'voided',
}

export enum BankTransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
}

export enum BankType {
  Lsb = 'LSB',
  Nbkc = 'NBKC',
}

export type BankingCurrencyAmount = {
  __typename?: 'BankingCurrencyAmount'
  decimalAmount: Scalars['String']
  microsMoney: MicrosMoney
}

export enum BankingEligibilityFeature {
  ChangeBankingProductId = 'CHANGE_BANKING_PRODUCT_ID',
  DigitalCardRequest = 'DIGITAL_CARD_REQUEST',
  FirstPhysicalCardRequest = 'FIRST_PHYSICAL_CARD_REQUEST',
  PhysicalCardRequest = 'PHYSICAL_CARD_REQUEST',
  ViewPanDetails = 'VIEW_PAN_DETAILS',
}

/**
 * Contains all feature-specific eligibility reasons that can be returned.
 * Feature reason mapping:
 * - Base
 *   - UNAVAILABLE
 *   - AVAILABLE
 * - VIEW_PAN_DETAILS
 *   - MFA_SMS_SETUP_REQUIRED
 *   - MFA_SMS_CHALLENGE_REQUIRED
 * - FIRST_PHYSICAL_CARD_REQUEST
 *   - PHYSICAL_CARD_PENDING
 * - DIGITAL_CARD_REQUEST
 *   - DIGITAL_CARD_REQUEST_RECENTLY_OCCURRED
 *   - PHYSICAL_CARD_REQUEST_PENDING
 *   - DIGITAL_CARD_REQUEST_PENDING
 * - PHYSICAL_CARD_REQUEST
 *   - PHYSICAL_CARD_REQUEST_RECENTLY_OCCURRED
 * - CHANGE_BANKING_PRODUCT_ID
 *   - DEMOGRAPHIC_LOCK
 */
export enum BankingEligibilityReason {
  Available = 'AVAILABLE',
  DemographicLock = 'DEMOGRAPHIC_LOCK',
  DigitalCardRequestPending = 'DIGITAL_CARD_REQUEST_PENDING',
  DigitalCardRequestRecentlyOccurred = 'DIGITAL_CARD_REQUEST_RECENTLY_OCCURRED',
  MfaSmsChallengeRequired = 'MFA_SMS_CHALLENGE_REQUIRED',
  MfaSmsSetupRequired = 'MFA_SMS_SETUP_REQUIRED',
  PhysicalCardNotActivated = 'PHYSICAL_CARD_NOT_ACTIVATED',
  PhysicalCardPending = 'PHYSICAL_CARD_PENDING',
  PhysicalCardRequestPending = 'PHYSICAL_CARD_REQUEST_PENDING',
  PhysicalCardRequestRecentlyOccurred = 'PHYSICAL_CARD_REQUEST_RECENTLY_OCCURRED',
  Unavailable = 'UNAVAILABLE',
}

export type BankingFeatureEligibility = {
  __typename?: 'BankingFeatureEligibility'
  eligible: Scalars['Boolean']
  reason: Maybe<BankingEligibilityReason>
}

export type BankingKyc = {
  __typename?: 'BankingKyc'
  addressVerification: Maybe<AddressVerification>
  identityVerification: Maybe<IdentityVerification>
  kycStatus: Maybe<KycStatus>
  /**
   * Details of Banking KYC results surfaced for clients that have been cleared to reuse Banking KYC user info for specific scenarios, with specific criteria.
   * Usage of this field is only appliable for approved clients.
   * Please confirm with the banking team before using.
   */
  verificationDetails: Maybe<VerificationDetails>
}

export type BankingKycAddressVerification = AddressVerification & {
  __typename?: 'BankingKycAddressVerification'
  verificationStatus: VerificationStatus
}

export type BankingKycIdentityVerification = IdentityVerification & {
  __typename?: 'BankingKycIdentityVerification'
  /**
   * If the user can re-attempt identity verification
   * They may have reached the max configured allowed attempts, or need manual review due to suspected fraud or risk
   */
  canRetry: Maybe<Scalars['Boolean']>
  verificationStatus: VerificationStatus
}

export enum BankingProduct {
  /** Interest-bearing checking account product. Used to return APY rates for Silver/Gold tier customers with the CHECKING_APY entitlement. */
  Checking = 'checking',
  EmergencySavings = 'emergencySavings',
  MightyOakChecking = 'mightyOakChecking',
  MightyOakEmergencyFund = 'mightyOakEmergencyFund',
  OakChecking = 'oakChecking',
  OakEmergencyFund = 'oakEmergencyFund',
}

export type BannersErrors = {
  __typename?: 'BannersErrors'
  error: Maybe<Scalars['String']>
  message: Maybe<Scalars['String']>
}

export type BannersResponse =
  | BannersErrors
  | HelpcenterBannerContent
  | SiteWideBannerContent

/** Acorns base Portfolio interface */
export type BasePortfolio = {
  /** Indicates the portfolio's allocation percentage */
  accountAllocation: PortfolioAllocation
  cashOwed: MonetaryAmount
  currentAllocationPercentage: Scalars['Float']
  currentBalance: MonetaryAmount
  currentBalanceWithPending: MonetaryAmount
  /** Indicates the extent to which the Portfolio has been customized by an investor. */
  customizationLevel: Maybe<PortfolioCustomizationLevel>
  /** Description of the portfolio */
  description: Scalars['String']
  /** ID of the Portfolio */
  id: Scalars['ID']
  /** Indicates the Acorns-designated portfolio name */
  name: Scalars['String']
  pendingBalance: MonetaryAmount
  /**
   * Securities currently owned by the Portfolio's InvestmentAccount (will be null
   * if not selected in the context of an InvestmentAccount).
   */
  portfolioSecurities: Maybe<Array<PortfolioSecurity>>
  /** Security Allocations for the given portfolio */
  portfolioSecurityAllocations: Maybe<Array<PortfolioSecurityAllocation>>
  yearToDateReturn: Maybe<MarketReturn>
}

/** Returned result for a batchAddTierSubscriptions mutation */
export type BatchAddTierSubscriptions = {
  __typename?: 'BatchAddTierSubscriptions'
  addedIds: Array<Scalars['ID']>
  unaddedIds: Array<Scalars['ID']>
}

export type BatchAddTierSubscriptionsInput = {
  allowInactiveTier?: InputMaybe<Scalars['Boolean']>
  createdBy?: InputMaybe<TierSubscriptionCreatedBy>
  migrationId?: InputMaybe<Scalars['ID']>
  tierId: Scalars['ID']
  tierPriceId: Scalars['ID']
  transitionAction?: InputMaybe<TransitionAction>
  userIds: Array<Scalars['ID']>
}

export type BatchAddTierSubscriptionsResult =
  | BatchAddTierSubscriptions
  | InvalidTier
  | InvalidTierPrice

/** A person who doesn't have an Acorns account, but may someday inherit one or funds from one. */
export type Beneficiary = TimestampsInterface & {
  __typename?: 'Beneficiary'
  /** List of addresses associated with beneficiary */
  addresses: Maybe<Array<Maybe<Address>>>
  /** Age of beneficiary */
  age: Scalars['Int']
  /** URL for the Beneficiary's avatar image */
  avatarUrl: Maybe<Scalars['String']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Internal ID for user who this beneficiary belongs to */
  custodianId: Scalars['ID']
  /** Beneficiary's nickname for their custodian */
  custodianNickname: Maybe<Scalars['String']>
  /**
   * Beneficiary's date of birth:
   * @deprecated Use beneficiary.age or beneficiary.eligible for contribution tooltip instead
   */
  dateOfBirth: Scalars['String']
  /** Timestamp when the Beneficiary was deactivated */
  deactivatedAt: Maybe<Scalars['DateTime']>
  /** Beneficiary's birthday is within the next month */
  eligibleForContributionTooltip: Scalars['Boolean']
  /** Beneficiary's email ID */
  email: Maybe<Scalars['Email']>
  /** First name of beneficiary */
  firstName: Scalars['String']
  /** Internal ID for beneficiary */
  id: Scalars['ID']
  /** Beneficiary's investment account */
  investmentAccount: Maybe<InvestmentAccount>
  /** Last name of beneficiary */
  lastName: Scalars['String']
  /** List of phone numbers associated with the beneficiary */
  phoneNumbers: Maybe<Array<Maybe<Phone>>>
  /** True if the beneficiary has an ssn false if not */
  ssnPresent: Scalars['Boolean']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** Cannot open early account because the beneficiary account already exsists */
export type BeneficiaryAccountExistsException = {
  __typename?: 'BeneficiaryAccountExistsException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** A person with the supplied date of birth is too old to open a UTMA/UGMA account */
export type BeneficiaryExceedsAgeLimitException = {
  __typename?: 'BeneficiaryExceedsAgeLimitException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Changeable attributes for beneficiaries */
export type BeneficiaryInfoInput = {
  /** Beneficiaries nickname for their custodian. */
  custodianNickname?: InputMaybe<Scalars['String']>
  /** Beneficiary Email */
  email?: InputMaybe<Scalars['Email']>
  /** Mailing Address */
  mailingAddress?: InputMaybe<AddressInput>
  /** Beneficiary Phone number */
  phoneNumber?: InputMaybe<Scalars['String']>
}

/** Changeable attributes for beneficiaries */
export type BeneficiaryInput = {
  /** Date of Birth */
  dateOfBirth: Scalars['String']
  /** Beneficiary First Name */
  firstName: Scalars['String']
  /** Beneficiary Last Name */
  lastName: Scalars['String']
}

/** Beneficiary does not exist */
export type BeneficiaryNotFoundException = {
  __typename?: 'BeneficiaryNotFoundException'
  /** message */
  message: Maybe<Scalars['String']>
}

export enum BeneficiaryType {
  Entity = 'entity',
  Individual = 'individual',
}

export type BenefitPartnerInput = {
  product: BenefitsProduct
}

export type BenefitPartnerResponse =
  | ProductNotSupportedException
  | TaxFilingPartner

export enum BenefitProductStatus {
  ComingSoon = 'COMING_SOON',
  Disabled = 'DISABLED',
  DisablingSoon = 'DISABLING_SOON',
  Enabled = 'ENABLED',
  TemporarilyUnavailable = 'TEMPORARILY_UNAVAILABLE',
  UnderMaintenance = 'UNDER_MAINTENANCE',
}

export type BenefitProductTile = {
  __typename?: 'BenefitProductTile'
  product: BenefitsTrackerProducts
  status: BenefitProductStatus
}

export enum BenefitPromotedThrough {
  MainFeedCard = 'MAIN_FEED_CARD',
  TourTip = 'TOUR_TIP',
  Wtdn = 'WTDN',
}

export type BenefitStatus = {
  __typename?: 'BenefitStatus'
  benefitProductKey: Scalars['String']
  claimStatus: ClaimStatus
  claimedOn: Maybe<Scalars['String']>
  details: Maybe<Array<Maybe<ClaimStatusDetails>>>
  expiresOn: Maybe<Scalars['String']>
  /** @deprecated Use claim_status instead */
  status: Scalars['String']
  updatedBy: Maybe<Scalars['String']>
  updatedOn: Maybe<Scalars['String']>
}

export enum BenefitStatusDetail {
  IneligibleAcornsEarlyMatched = 'INELIGIBLE_ACORNS_EARLY_MATCHED',
  IneligibleAge = 'INELIGIBLE_AGE',
  IneligibleLocation = 'INELIGIBLE_LOCATION',
}

export type BenefitTileGroup = {
  __typename?: 'BenefitTileGroup'
  group: Scalars['String']
  groupName: Scalars['String']
  products: Maybe<Array<Maybe<BenefitProductTile>>>
}

export type BenefitsMessage = {
  __typename?: 'BenefitsMessage'
  message: Scalars['String']
}

export enum BenefitsPartner {
  April = 'APRIL',
  Avibra = 'AVIBRA',
  ColumnTax = 'COLUMN_TAX',
  GoHenry = 'GO_HENRY',
  TrustAndWill = 'TRUST_AND_WILL',
}

export enum BenefitsProduct {
  BenefitsGohenryStandard = 'BENEFITS_GOHENRY_STANDARD',
  BenefitsInsuranceBasic = 'BENEFITS_INSURANCE_BASIC',
  BenefitsInsuranceStandard = 'BENEFITS_INSURANCE_STANDARD',
  BenefitsTaxfilingStandard = 'BENEFITS_TAXFILING_STANDARD',
  BenefitsWillStandard = 'BENEFITS_WILL_STANDARD',
}

export type BenefitsStatusResponse = {
  __typename?: 'BenefitsStatusResponse'
  benefitsStatus: Array<BenefitStatus>
  userId: Scalars['String']
}

export enum BenefitsTrackerProducts {
  BenefitsFeeNegotiation = 'BENEFITS_FEE_NEGOTIATION',
  BenefitsGohenryStandard = 'BENEFITS_GOHENRY_STANDARD',
  BenefitsInsuranceStandard = 'BENEFITS_INSURANCE_STANDARD',
  BenefitsTaxfilingStandard = 'BENEFITS_TAXFILING_STANDARD',
  BenefitsWillStandard = 'BENEFITS_WILL_STANDARD',
}

export type BigCurrencyAmount = {
  __typename?: 'BigCurrencyAmount'
  currency: Currency
  value: Scalars['BigDecimal']
}

/** Attributes related to the billing cycle */
export type BillingCycle = TimestampsInterface & {
  __typename?: 'BillingCycle'
  active: Scalars['Boolean']
  adhoc: Scalars['Boolean']
  amount: Maybe<Scalars['Float']>
  amountCollected: Maybe<Scalars['Float']>
  amountOwed: Maybe<Scalars['Float']>
  callbackUrl: Maybe<Scalars['String']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  credits: Array<Maybe<Credit>>
  endDate: Scalars['String']
  executionAudits: Array<Maybe<ExecutionAudit>>
  extension: Scalars['String']
  fees: Array<Maybe<Fee>>
  id: Scalars['ID']
  invoiceDate: Scalars['String']
  liquidations: Array<Maybe<Liquidation>>
  nonce: Maybe<Scalars['String']>
  startDate: Scalars['String']
  state: BillingCycleState
  tierSubscription: Maybe<TierSubscription>
  tierSubscriptionId: Maybe<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId: Scalars['ID']
}

/** Attributes related to the billing cycle */
export type BillingCycleCreditsArgs = {
  discount_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
}

/** Attributes related to the billing cycle */
export type BillingCycleFeesArgs = {
  execution_methods?: InputMaybe<Array<InputMaybe<FeeExecutionMethod>>>
}

export enum BillingCycleState {
  /** Assessed billing cycle */
  Assessed = 'ASSESSED',
  /** Billing cycle execution started */
  Executed = 'EXECUTED',
  /** Billing cycle execution failed */
  ExecutionFailed = 'EXECUTION_FAILED',
  /** Failed billing cycle */
  Failed = 'FAILED',
  /** Paid billing cycle */
  Paid = 'PAID',
  /** Partially collected billing cycle */
  Partial = 'PARTIAL',
  /** Initiate refund billing cycle */
  PendingRefund = 'PENDING_REFUND',
  /** Refunded billing cycle */
  Refunded = 'REFUNDED',
  /** Refund failed billing cycle */
  RefundFailed = 'REFUND_FAILED',
  /** Billing cycle pending retry */
  RetryPending = 'RETRY_PENDING',
  /** Unpaid billing cycle */
  Unpaid = 'UNPAID',
}

export enum BillingFrequency {
  Monthly = 'MONTHLY',
  Never = 'NEVER',
  Yearly = 'YEARLY',
}

/** Internal representation of a billing cycle */
export type BillingInvoice = {
  __typename?: 'BillingInvoice'
  amount: Maybe<Scalars['Float']>
  amountCollected: Maybe<Scalars['Float']>
  amountOwed: Maybe<Scalars['Float']>
  createdAt: Scalars['DateTime']
  endDate: Scalars['DateTime']
  executionMethod: Maybe<Scalars['String']>
  failureReason: Maybe<Scalars['String']>
  fundingSource: Maybe<InvoiceFundingSource>
  id: Scalars['ID']
  invoiceDate: Scalars['DateTime']
  invoiceItems: Array<Maybe<InvoiceItem>>
  startDate: Scalars['DateTime']
  state: BillingCycleState
  updatedAt: Scalars['DateTime']
  userId: Scalars['ID']
  vendorIntegrated: Scalars['Boolean']
}

/** the billing profile for a user */
export type BillingProfile = {
  __typename?: 'BillingProfile'
  mightyOakCardWaiver: Maybe<MightyOakCardWaiver>
  provisionalWaiver: Maybe<ProvisionalWaiver>
  userId: Scalars['ID']
  userVerifiedAt: Maybe<Scalars['String']>
  waivers: Maybe<Array<Waiver>>
}

/** Billing Profile not found */
export type BillingProfileNotFoundException = {
  __typename?: 'BillingProfileNotFoundException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type BillingVendorError = {
  __typename?: 'BillingVendorError'
  message: Scalars['String']
}

export type BlockDeviceInput = {
  deviceId: Scalars['ID']
}

export type BlockDeviceResult = Device | DeviceNotFoundException

export type BlockedEmailDomainException = {
  __typename?: 'BlockedEmailDomainException'
  message: Maybe<Scalars['String']>
}

/**
 * Returned when an action cannot run: its id is unknown, its arguments are
 * invalid, or it failed unexpectedly. The specific cause is logged server-side;
 * clients should render their own error state.
 */
export type BlueprintActionException = {
  __typename?: 'BlueprintActionException'
  message: Maybe<Scalars['String']>
}

/** Result of performing a blueprint action. */
export type BlueprintActionResult =
  | BlueprintActionException
  | BlueprintActionSuccess

/**
 * Returned when an action succeeds, including an expected failure such as
 * insufficient funds, which the action reports in its results.
 */
export type BlueprintActionSuccess = {
  __typename?: 'BlueprintActionSuccess'
  /** The action's results, shaped by the action. */
  results: Scalars['JSON']
}

/**
 * Client-declared capabilities. Used by the server to compose a Blueprint
 * document appropriate for what the client can render.
 */
export type BlueprintCapabilities = {
  /**
   * Schema versions the client can render (e.g., ["v1", "v2"]).
   * The server resolves the highest version that both the client and server support.
   */
  schemaVersions: Array<Scalars['String']>
}

/** A rendered blueprint document containing the layout and content for a user. */
export type BlueprintDoc = {
  __typename?: 'BlueprintDoc'
  /**
   * The blueprint content as a JSON object.
   * This allows for flexible, evolving content without schema changes.
   */
  content: Scalars['JSON']
  /**
   * The schema version this document was composed against. Clients should decode
   * the content using the models generated from this version's JSON Schema.
   */
  schemaVersion: Scalars['String']
}

/**
 * Returned when a blueprint cannot be rendered (for example, a backing data
 * fetch failed). The specific cause is logged server-side; clients should render
 * their own error state.
 */
export type BlueprintException = {
  __typename?: 'BlueprintException'
  message: Maybe<Scalars['String']>
}

/**
 * Result of rendering a blueprint. Failure modes are returned as typed variants
 * so clients can distinguish a successful render from an error. Clients that
 * only select BlueprintDoc fields will see an empty selection on failure and
 * should render their own error state.
 */
export type BlueprintResult =
  | BlueprintDoc
  | BlueprintException
  | UnsupportedSchemaVersionException

/** A Blueprint DSL JSON Schema. */
export type BlueprintSchemaDoc = {
  __typename?: 'BlueprintSchemaDoc'
  /** The JSON Schema document. */
  content: Scalars['JSON']
}

/**
 * Result of asking for a Blueprint DSL JSON Schema by version. A rejected key and
 * an unknown version are typed variants, so a caller tells them apart without
 * matching on an error message.
 */
export type BlueprintSchemaResult =
  | BlueprintSchemaDoc
  | InvalidApiKeyException
  | UnsupportedSchemaVersionException

/**
 * Identifies a blueprint screen the client can request. Lets the schema advertise
 * which screens exist and gives clients type-level safety instead of a freeform
 * string id.
 */
export enum BlueprintScreen {
  /** Lets the user pick a subscription tier. */
  ChangePlan = 'CHANGE_PLAN',
}

export enum BrazeEvent {
  AdvocateReferralLinkClick = 'AdvocateReferralLinkClick',
  FriendInvestCore = 'FriendInvestCore',
  FriendRegistrationStart = 'FriendRegistrationStart',
  FriendUserVerified = 'FriendUserVerified',
}

/** Grouping of Products */
export type Bundle = {
  __typename?: 'Bundle'
  /** Image asset path in CDN */
  iconPath: Scalars['String']
  /** Name of bundle */
  name: Scalars['String']
  /** Associated products to display for grouping */
  products: Array<PresentableProduct>
}

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
}

export enum CampaignBackgroundType {
  SquirrelsWithAcorns = 'SQUIRRELS_WITH_ACORNS',
  SquirrelsWithAcornsCloud = 'SQUIRRELS_WITH_ACORNS_CLOUD',
  SquirrelsWithAcornsPotential = 'SQUIRRELS_WITH_ACORNS_POTENTIAL',
  SquirrelsWithAcornsTransparent = 'SQUIRRELS_WITH_ACORNS_TRANSPARENT',
  SquirrelsWithAcornsUber = 'SQUIRRELS_WITH_ACORNS_UBER',
}

export enum CampaignFilterType {
  Advertised = 'ADVERTISED',
  Participated = 'PARTICIPATED',
}

export type CampaignHistoryConnection = {
  __typename?: 'CampaignHistoryConnection'
  edges: Maybe<Array<CampaignHistoryEdge>>
  pageInfo: ReferralPaginatedInfo
}

export type CampaignHistoryEdge = {
  __typename?: 'CampaignHistoryEdge'
  cursor: Scalars['String']
  eligibilityMet: Maybe<Scalars['Boolean']>
  hurdleMet: Maybe<Scalars['Boolean']>
  node: ReferralCampaignV2
  /** Number of referrals that have completed all requirements and are eligible for rewards */
  numCompletedReferrals: Maybe<Scalars['Int']>
  /** Number of referrals that are currently ineligible for rewards */
  numIneligibleReferrals: Maybe<Scalars['Int']>
  /** Number of referrals that have started but haven't completed the qualifying action yet */
  numNonQualifiedReferrals: Maybe<Scalars['Int']>
  /** Total number of referrals that are still in progress (qualified + non-qualified) */
  numPendingReferrals: Maybe<Scalars['Int']>
  /** Number of referrals that have completed the qualifying action (e.g., investment, subscription, roundup) */
  numQualifiedReferrals: Maybe<Scalars['Int']>
  /**
   * Indicates if campaign is under review - true when user has met the invitation hurdle but not eligibility,
   * has ineligible friends who could potentially requalify, and campaign is in PAYOUT_BUFFER status
   */
  underReview: Maybe<Scalars['Boolean']>
}

export type CampaignHistoryFilter = {
  /** filters specific Campaign */
  campaignId?: InputMaybe<Scalars['ID']>
  /** Whether campaigns where created after the date. */
  createdAfter?: InputMaybe<Scalars['DateTime']>
  /** Whether or not hurdle has been met */
  hurdleMet?: InputMaybe<Scalars['Boolean']>
  /** Whether campaigns where published after the date. Defaults to 6 month back */
  publishedAfter?: InputMaybe<Scalars['DateTime']>
  /** Published Campaign status (eg. COMPLETE, LIVE, PENDING, SCHEDULED) */
  publishedStatus?: InputMaybe<PublishedCampaignStatus>
  /** Campaign reward filter type */
  rewardType?: InputMaybe<CampaignRewardFilterType>
  /** Campaign filter type */
  type: CampaignFilterType
}

export enum CampaignIconType {
  SquirrelAvatar_1 = 'SQUIRREL_AVATAR_1',
  SquirrelAvatar_2 = 'SQUIRREL_AVATAR_2',
  SquirrelAvatar_3 = 'SQUIRREL_AVATAR_3',
  SquirrelAvatarUber = 'SQUIRREL_AVATAR_UBER',
}

export enum CampaignQualificationActionType {
  InitialInvestment = 'INITIAL_INVESTMENT',
}

export enum CampaignRewardFilterType {
  Burst = 'BURST',
  Evergreen = 'EVERGREEN',
}

export enum CampaignStatus {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED',
}

export type CampaignV2 = {
  __typename?: 'CampaignV2'
  campaignId: Maybe<Scalars['ID']>
}

/** The result of the cancelCheckPayment mutation */
export type CancelCheckPaymentResult =
  | AuthorizationError
  | CheckPayment
  | ResourceNotFoundError
  | UnableToCancelCheckError

export type CancelIntentResult = Intent | ValidationError

/** Input to cancel existing account closure request */
export type CancelInvestmentAccountClosureRequestInput = {
  /** The ID of the investment account */
  investmentAccountId: Scalars['ID']
}

/** Cancel investment account request mutation response */
export type CancelInvestmentAccountClosureRequestResult =
  | AccountClosedException
  | AccountNotFoundException
  | ClosureRequestDoesNotExistException
  | InvestmentAccount

/** Input to cancel a pending investment */
export type CancelInvestmentInput = {
  /** DEPRECATED: The ID of the investment account */
  investmentAccountId?: InputMaybe<Scalars['ID']>
  /** The ID of the pending investment associated with the investment account id */
  investmentId: Scalars['ID']
}

/** ID of canceled investment */
export type CancelInvestmentPayload = {
  __typename?: 'CancelInvestmentPayload'
  id: Scalars['ID']
}

/** Cancel investment mutation response */
export type CancelInvestmentResult =
  | CancelInvestmentPayload
  | InvestmentNotFoundException
  | InvestmentUncancellableException

export type CancelMoneyAssignmentInput = {
  transactionId: Scalars['ID']
}

export type CancelMoneyAssignmentResult =
  | MoneyAssignmentAlreadyTransferredError
  | MoneyAssignmentNotFoundError
  | MoneyRulesCancelMoneyAssignmentSuccess

export type CancelRecurringTransferResult =
  | RecurringTransfer
  | VersionMismatchException

export type CancelTransferPayload = {
  __typename?: 'CancelTransferPayload'
  transactionId: Scalars['ID']
}

/** Card delivery status */
export type CardDeliveryStatus = {
  __typename?: 'CardDeliveryStatus'
  /** When the card tracking record was created */
  createdAt: Scalars['String']
  /** Current Tracking Status Description */
  description: Maybe<Scalars['String']>
  /** USPS Tracking Number */
  picNumber: Maybe<Scalars['String']>
  /** Reference ID */
  referenceId: Scalars['String']
  /** Status enum */
  status: PackageStatus
  /** When the card tracking record was updated */
  updatedAt: Scalars['String']
}

export enum CardSubCategory {
  Alert = 'ALERT',
  Announcement = 'ANNOUNCEMENT',
  Education = 'EDUCATION',
  Engagement = 'ENGAGEMENT',
  Funding = 'FUNDING',
  Legacy = 'LEGACY',
  ProductAdoption = 'PRODUCT_ADOPTION',
}

export enum CarouselType {
  Banner = 'BANNER',
  Standard = 'STANDARD',
}

export type CaseEmailAttachment = {
  __typename?: 'CaseEmailAttachment'
  base64Data: Scalars['String']
  emailSubject: Maybe<Scalars['String']>
  fromInboundEfaxQueue: Scalars['Boolean']
  title: Scalars['String']
}

export type CaseEmailAttachmentsErrors = {
  __typename?: 'CaseEmailAttachmentsErrors'
  error: Maybe<Scalars['String']>
  message: Scalars['String']
}

export type CaseEmailAttachmentsResponse =
  | CaseEmailAttachmentsErrors
  | CaseEmailAttachmentsResult

export type CaseEmailAttachmentsResult = {
  __typename?: 'CaseEmailAttachmentsResult'
  attachments: Array<CaseEmailAttachment>
}

export type CaseFile = {
  __typename?: 'CaseFile'
  contentDocumentId: Scalars['ID']
  contentVersionId: Scalars['ID']
}

export type ChallengeAnswerInput = {
  challengeAnswer: Scalars['String']
  challengeId: Scalars['ID']
}

export enum ChallengeDeliveryType {
  Email = 'EMAIL',
  Push = 'PUSH',
  Sms = 'SMS',
}

export type ChallengePointsEarned = {
  __typename?: 'ChallengePointsEarned'
  challengeID: Scalars['ID']
  /** legal copy about how points are earned */
  details: Scalars['String']
  /** how many points earned out of how many possible */
  earningProgress: DiscreteMilestoneProgress
  /** summarized information about how points are earned */
  summary: Maybe<Scalars['String']>
}

export enum ChallengePushState {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
}

export type ChallengeRateExceededException = {
  __typename?: 'ChallengeRateExceededException'
  errorCode: Scalars['String']
}

export enum ChallengeTriggers {
  Authenticate = 'AUTHENTICATE',
  InitEmail = 'INIT_EMAIL',
  InitEmailForAuthenticate = 'INIT_EMAIL_FOR_AUTHENTICATE',
  InitPushForVerification = 'INIT_PUSH_FOR_VERIFICATION',
  InitSms = 'INIT_SMS',
  LoginWithRiskDecision = 'LOGIN_WITH_RISK_DECISION',
  ReinitChallenge = 'REINIT_CHALLENGE',
  ReinitWithRiskDecision = 'REINIT_WITH_RISK_DECISION',
  StepUpAuthentication = 'STEP_UP_AUTHENTICATION',
  SuspendedChallenge = 'SUSPENDED_CHALLENGE',
  SuspendedInitEmailForAuthenticate = 'SUSPENDED_INIT_EMAIL_FOR_AUTHENTICATE',
}

/**
 * Action performed on a configuration entity. Recorded in change_log.
 * The old_value/new_value diff is the source of truth for exactly what changed —
 * action describes whether it was a new record or a change to an existing one.
 */
export enum ChangeLogAction {
  /** A new entity was created. */
  Created = 'CREATED',
  /** An existing entity was updated. Covers all changes: status, metadata, rule trees, deprecation, etc. */
  Updated = 'UPDATED',
}

/** Input to change the amount of an outside contribution */
export type ChangeOutsideContributionAmountInput = {
  /** investment amount for the outside contribution */
  investmentAmount: Scalars['String']
  /** Stripe payment intent id */
  paymentIntentId: Scalars['ID']
}

/** Change outside contribution amount response */
export type ChangeOutsideContributionAmountResult =
  | ContributionAmountAboveThresholdError
  | ContributionAmountBelowThresholdError
  | OutsideContributionCheckoutCart

export type ChangePasswordInput = {
  newPassword: Scalars['String']
  oldPassword: Scalars['String']
  securityAnswer?: InputMaybe<SecurityAnswer>
}

export type ChangePasswordResult =
  | ChangePasswordSuccess
  | IncorrectOldPasswordException
  | InvalidPasswordException
  | SamePasswordsException

export type ChangePasswordSuccess = {
  __typename?: 'ChangePasswordSuccess'
  userId: Scalars['ID']
}

export type ChangeSecuritySymbolInput = {
  newSymbol: Scalars['TickerSymbol']
  priorSymbol: Scalars['TickerSymbol']
}

export type ChangeSecuritySymbolResult =
  | Fund
  | InvalidSecurityForSymbolChangeError
  | InvalidSymbolForSymbolChangeError
  | Stock

export type ChatActionData = {
  __typename?: 'ChatActionData'
  /** Data that was passed back to api */
  apiScope: Maybe<Scalars['String']>
  /** Data that was passed back to models */
  modelScope: Maybe<Scalars['String']>
}

export type ChatActionDataInput = {
  /** Data passed to api */
  apiScope?: InputMaybe<Scalars['String']>
  /** Data passed to models */
  modelScope?: InputMaybe<Scalars['String']>
}

/** Specifies whether a message was written by a user or is bot generated */
export enum ChatAuthor {
  Bot = 'BOT',
  User = 'USER',
}

export type ChatChoice = {
  __typename?: 'ChatChoice'
  /** Description associated with choices */
  description: Maybe<Scalars['String']>
  /** ID generated for the choices */
  id: Scalars['ID']
  /** Metadata associated with choices, typically hidden from user */
  metadata: Maybe<ChatChoiceActionMetadata>
  /** Title to be displayed for the choices */
  title: Scalars['String']
}

export type ChatChoiceActionData = {
  __typename?: 'ChatChoiceActionData'
  /** Additional data to be passed back to subsequent api calls once a choice is selected. */
  apiScope: Maybe<Scalars['String']>
  /** Additional data to be passed back to subsequent model calls once a choice is selected. */
  modelScope: Maybe<Scalars['String']>
}

export type ChatChoiceActionMetadata = {
  __typename?: 'ChatChoiceActionMetadata'
  /** Data associated with the action, gets back to the models */
  actionData: Maybe<ChatChoiceActionData>
  /** Type of action performed by the choice */
  actionType: Scalars['String']
}

export type ChatChoiceWidget = {
  __typename?: 'ChatChoiceWidget'
  choices: Array<ChatChoice>
  title: Maybe<Scalars['String']>
}

export enum ChatContext {
  BenefitsHub = 'BENEFITS_HUB',
  Earn = 'EARN',
  Generic = 'GENERIC',
  Home = 'HOME',
  Invest = 'INVEST',
  LearnHub = 'LEARN_HUB',
  MoneyMentorHome = 'MONEY_MENTOR_HOME',
  ReferralsLander = 'REFERRALS_LANDER',
  Support = 'SUPPORT',
}

export type ChatDeeplink = {
  __typename?: 'ChatDeeplink'
  title: Scalars['String']
  url: Scalars['String']
}

export type ChatDocument = {
  link: Scalars['String']
  title: Scalars['String']
}

export enum ChatFeatures {
  Basic = 'BASIC',
  ChoiceSelection = 'CHOICE_SELECTION',
  MarkdownSupport = 'MARKDOWN_SUPPORT',
  PerformanceWidget = 'PERFORMANCE_WIDGET',
  Support = 'SUPPORT',
  SvgWidget = 'SVG_WIDGET',
  TaxDocs = 'TAX_DOCS',
  ToolProgress = 'TOOL_PROGRESS',
}

export type ChatHistoryCitation = {
  __typename?: 'ChatHistoryCitation'
  id: Scalars['ID']
  title: Maybe<Scalars['String']>
  type: CitationType
}

export type ChatHistoryCitationV2 =
  | LearnHubCitation
  | SupportCitation
  | WebCitation

export type ChatHistoryMessage = {
  __typename?: 'ChatHistoryMessage'
  /** Specifies whether a message was written by a user or is bot generated */
  author: ChatAuthor
  /** Contains the contents of the message */
  body: Scalars['String']
  canRate: Scalars['Boolean']
  /** Chat widget associated with a particular BOT response */
  chatWidgets: Array<ChatWidget>
  /**
   * The citations for a chat response. Only chats authored by a BOT will contain these
   * @deprecated Use CitationWidget in chatWidgets instead.
   */
  citations: Array<ChatHistoryCitation>
  createdAt: Scalars['DateTime']
  /** Custom feedback text provided by the user */
  customFeedback: Maybe<Scalars['String']>
  /**
   * Deeplinks associated with a particular BOT response
   * @deprecated Use DeeplinkWidget in chatWidgets instead
   */
  deeplinks: Array<ChatDeeplink>
  /** Reason for the feedback provided */
  feedbackReason: Maybe<MessageFeedbackReason>
  id: Scalars['ID']
  /** Metadata associated with the message */
  metadata: Maybe<ChatMessageMetadata>
  /** ID of the message that prompted the current message. Only present for 'BOT' authored messages */
  originatingMessageId: Maybe<Scalars['ID']>
  ragSessionId: Maybe<Scalars['ID']>
  rating: Maybe<Scalars['Int']>
  /** Specifies which session a message is from */
  sessionId: Scalars['ID']
  /** Suggested follow-up replies for the user */
  suggestedReplies: Array<Scalars['String']>
}

export type ChatHistoryMessageBody = {
  __typename?: 'ChatHistoryMessageBody'
  /** Id of the chat history message, subsequent body and reasoning messages, footer, and tool progress messages will have the same ID */
  id: Scalars['ID']
  /** When the partial message was sent */
  sentAt: Scalars['DateTime']
  /** Text chunk of the full message */
  text: Scalars['String']
}

export type ChatHistoryMessageCustomFeedbackOutOfBounds =
  ChatHistoryMessageError & {
    __typename?: 'ChatHistoryMessageCustomFeedbackOutOfBounds'
    id: Scalars['ID']
    message: Scalars['String']
  }

export type ChatHistoryMessageEdge = {
  __typename?: 'ChatHistoryMessageEdge'
  /** This value is passed back as the 'cursor' parameter to continue pagination. An empty string indicates there are no more pages to fetch. */
  cursor: Scalars['ID']
  /** The ChatSessionRecord in the edge */
  node: ChatHistoryMessage
}

export type ChatHistoryMessageError = {
  id: Scalars['ID']
  message: Scalars['String']
}

export type ChatHistoryMessageFooter = {
  __typename?: 'ChatHistoryMessageFooter'
  /** Used to display thumbs up/down */
  canRate: Scalars['Boolean']
  chatWidgets: Array<ChatWidget>
  /**
   * Citations for the chat history message
   * @deprecated Use CitationWidget in chatWidgets instead.
   */
  citations: Array<ChatHistoryCitation>
  /** @deprecated Use DeeplinkWidget in chatWidgets instead */
  deeplinks: Array<ChatDeeplink>
  /** Id of the chat history message, subsequent body and reasoning messages, footer, and tool progress messages will have the same ID */
  id: Scalars['ID']
  /** When the footer message was sent */
  sentAt: Scalars['DateTime']
  suggestedReplies: Array<Scalars['String']>
}

export type ChatHistoryMessageHeader = {
  __typename?: 'ChatHistoryMessageHeader'
  /** Specifies whether a message was written by a user or is bot generated */
  author: ChatAuthor
  createdAt: Scalars['DateTime']
  /** Id of the chat history message, subsequent body and reasoning messages, footer, and tool progress messages will have the same ID */
  id: Scalars['ID']
  /** ID of the message that prompted the current message. Only present for 'BOT' authored messages */
  originatingMessageId: Maybe<Scalars['ID']>
  /** Specifies which session a message is from */
  sessionId: Scalars['ID']
}

export type ChatHistoryMessageNotFound = ChatHistoryMessageError & {
  __typename?: 'ChatHistoryMessageNotFound'
  id: Scalars['ID']
  message: Scalars['String']
}

export type ChatHistoryMessageNotRatable = ChatHistoryMessageError & {
  __typename?: 'ChatHistoryMessageNotRatable'
  id: Scalars['ID']
  message: Scalars['String']
}

export type ChatHistoryMessageRatingFailed = ChatHistoryMessageError & {
  __typename?: 'ChatHistoryMessageRatingFailed'
  id: Scalars['ID']
  message: Scalars['String']
}

export type ChatHistoryMessageRatingOutOfBounds = ChatHistoryMessageError & {
  __typename?: 'ChatHistoryMessageRatingOutOfBounds'
  id: Scalars['ID']
  message: Scalars['String']
}

export type ChatInProgressException = {
  __typename?: 'ChatInProgressException'
  id: Scalars['ID']
  message: Scalars['String']
}

export type ChatMessageMetadata = {
  __typename?: 'ChatMessageMetadata'
  /** Data associated with the action */
  actionData: Maybe<ChatActionData>
  /** Type of action associated with the message */
  actionType: Scalars['String']
}

export type ChatMessageMetadataInput = {
  /** Data associated with the action */
  actionData?: InputMaybe<ChatActionDataInput>
  /** Type of action associated with the message */
  actionType: Scalars['String']
}

export type ChatMessageSizeOutOfBounds = ChatHistoryMessageError & {
  __typename?: 'ChatMessageSizeOutOfBounds'
  id: Scalars['ID']
  message: Scalars['String']
}

export type ChatMessageStreamResponse =
  | ChatHistoryMessage
  | ChatHistoryMessageBody
  | ChatHistoryMessageFooter
  | ChatHistoryMessageHeader
  | ChatStreamStatus
  | ChatToolProgress

export type ChatRedirect = {
  __typename?: 'ChatRedirect'
  conversationCategory: Scalars['String']
  conversationContext: Scalars['String']
  ctaExpiresAt: Scalars['DateTime']
  title: Scalars['String']
}

export type ChatSession = {
  __typename?: 'ChatSession'
  applicationType: ApplicationType
  /** When the session was blocked due to child session detection */
  blockedAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  endedAt: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  messageLastSentAt: Maybe<Scalars['DateTime']>
  originatingContext: Maybe<ChatContext>
  supportedChatFeatures: Array<ChatFeatures>
  title: Maybe<Scalars['String']>
  type: Maybe<SessionType>
  /** Specifies the id of the user who had the chat session */
  userId: Scalars['ID']
}

export type ChatSessionBlockedException = {
  __typename?: 'ChatSessionBlockedException'
  /** When the block expires and the user can chat again */
  blockedUntil: Scalars['DateTime']
  /** The session ID that triggered the block */
  id: Scalars['ID']
  message: Scalars['String']
}

export type ChatSessionEdge = {
  __typename?: 'ChatSessionEdge'
  /** This value is passed back as the 'cursor' parameter to continue pagination. An empty string indicates there are no more pages to fetch. */
  cursor: Scalars['ID']
  /** The ChatSessionRecord in the edge */
  node: ChatSession
}

/** Additional metadata to associate with a chat session at creation time. */
export type ChatSessionMetadata = {
  /** Identifier of the insight that originated this chat session. */
  insightId?: InputMaybe<Scalars['String']>
}

export type ChatSessionNotFound = {
  __typename?: 'ChatSessionNotFound'
  id: Scalars['ID']
  message: Scalars['String']
}

export type ChatStreamStatus = {
  __typename?: 'ChatStreamStatus'
  /** Whether the stream is currently in use by another connection */
  isStreaming: Scalars['Boolean']
  /** When the status event was sent */
  sentAt: Scalars['DateTime']
  /** When the session was blocked due to child session detection */
  sessionBlockedAt: Maybe<Scalars['DateTime']>
}

export type ChatToolProgress = {
  __typename?: 'ChatToolProgress'
  /** Id of the chat history message, subsequent body and reasoning messages, footer, and tool progress messages will have the same ID */
  id: Scalars['ID']
  /** Human-readable progress message describing what the tool is doing */
  progressMessage: Scalars['String']
  /** When the tool progress event was sent */
  sentAt: Scalars['DateTime']
  /** Identifier for the tool being used */
  toolId: Scalars['String']
}

export type ChatUnavailableError = {
  __typename?: 'ChatUnavailableError'
  message: Scalars['String']
}

export type ChatWidget =
  | ChatChoiceWidget
  | CitationWidget
  | CustomerSupportChatWidget
  | DeeplinkWidget
  | DocumentWidget
  | InvestmentPerformanceWidget
  | SvgWidget
  | SduiWidget
  | StockPerformanceWidget

/** Represents the check to be uploaded. */
export type CheckImage = {
  /** Image based-64 encoded. */
  image: Scalars['String']
  type: ImageType
}

export type CheckPayment = {
  __typename?: 'CheckPayment'
  amount: CurrencyAmount
  canceledAt: Maybe<Scalars['DateTime']>
  checkNumber: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  estimatedArrivalAt: Scalars['DateTime']
  failedAt: Maybe<Scalars['DateTime']>
  failureReason: Maybe<CheckPaymentFailureReason>
  fromAccountId: Scalars['String']
  id: Scalars['ID']
  memo: Maybe<Scalars['String']>
  recipientAddress: CheckPaymentAddress
  recipientName: Scalars['String']
  status: CheckPaymentStatus
  trackingNumber: Maybe<Scalars['String']>
}

export type CheckPaymentAddress = {
  __typename?: 'CheckPaymentAddress'
  city: Scalars['String']
  country: Scalars['String']
  state: Scalars['String']
  street1: Scalars['String']
  street2: Maybe<Scalars['String']>
  zipCode: Scalars['String']
}

export type CheckPaymentAddressInput = {
  city: Scalars['String']
  country: Scalars['String']
  state: Scalars['String']
  street1: Scalars['String']
  street2?: InputMaybe<Scalars['String']>
  zipCode: Scalars['String']
}

export type CheckPaymentConnection = {
  __typename?: 'CheckPaymentConnection'
  edges: Array<CheckPaymentEdge>
  pageInfo: PageInfo
}

export type CheckPaymentEdge = {
  __typename?: 'CheckPaymentEdge'
  cursor: Scalars['ID']
  node: CheckPayment
}

export enum CheckPaymentFailureReason {
  InsufficientFunds = 'insufficientFunds',
}

export type CheckPaymentRecipient = {
  __typename?: 'CheckPaymentRecipient'
  businessName: Maybe<Scalars['String']>
  firstName: Maybe<Scalars['String']>
  lastName: Maybe<Scalars['String']>
}

export type CheckPaymentRecipientAddressType = {
  __typename?: 'CheckPaymentRecipientAddressType'
  recipient: CheckPaymentRecipient
  recipientAddress: CheckPaymentAddress
}

export type CheckPaymentRecipientInput = {
  businessName?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
}

export enum CheckPaymentStatus {
  Canceled = 'canceled',
  Failed = 'failed',
  Pending = 'pending',
  Shipped = 'shipped',
}

export type CheckingHistorySummary = PastSummary & {
  __typename?: 'CheckingHistorySummary'
  interestEarned: Maybe<CurrencyAmount>
  moneyIn: CurrencyAmount
  moneyOut: CurrencyAmount
}

export enum CheckoutCartStatus {
  /** Terminal state, canceled payment intent */
  Canceled = 'CANCELED',
  /** State a payment intent is in after actions are handled */
  Processing = 'PROCESSING',
  /** Payment intent needs further action by frontend */
  RequiresAction = 'REQUIRES_ACTION',
  /** Payment intent needs capturing */
  RequiresCapture = 'REQUIRES_CAPTURE',
  /** Payment intent needs confirming */
  RequiresConfirmation = 'REQUIRES_CONFIRMATION',
  /** Initial state, before a payment method is attached */
  RequiresPaymentMethod = 'REQUIRES_PAYMENT_METHOD',
  /** Terminal state, succeeded payment intent */
  Succeeded = 'SUCCEEDED',
}

export type ChildContextInput = {
  accountTenureDays?: InputMaybe<Scalars['Int']>
  activationDate?: InputMaybe<Scalars['String']>
  age?: InputMaybe<Scalars['Int']>
  ageYears?: InputMaybe<Scalars['Int']>
  allowanceAmount?: InputMaybe<Scalars['Float']>
  availableBalance?: InputMaybe<Scalars['Float']>
  cardBalance?: InputMaybe<Scalars['Float']>
  cardStatusDescription?: InputMaybe<Scalars['String']>
  dateOfBirth?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  gender?: InputMaybe<Scalars['String']>
  investBalance?: InputMaybe<Scalars['Float']>
  lastName?: InputMaybe<Scalars['String']>
  signupDate?: InputMaybe<Scalars['String']>
  taskCount?: InputMaybe<Scalars['Int']>
  totalSavingsBalance?: InputMaybe<Scalars['Float']>
  userId?: InputMaybe<Scalars['String']>
}

export enum CitationType {
  LearnHubContent = 'LEARN_HUB_CONTENT',
  Other = 'OTHER',
  SupportFaq = 'SUPPORT_FAQ',
  Web = 'WEB',
}

export type CitationWidget = {
  __typename?: 'CitationWidget'
  citations: Array<ChatHistoryCitationV2>
}

export enum ClaimStatus {
  Claimed = 'CLAIMED',
  Expired = 'EXPIRED',
  ExpiringSoon = 'EXPIRING_SOON',
  Ineligible = 'INELIGIBLE',
  InProgress = 'IN_PROGRESS',
  Unclaimed = 'UNCLAIMED',
  UpgradeRequired = 'UPGRADE_REQUIRED',
}

export type ClaimStatusDetails = {
  __typename?: 'ClaimStatusDetails'
  message: Maybe<Scalars['String']>
  statusCode: Maybe<BenefitStatusDetail>
}

export type ClearSupportSiteCache = {
  __typename?: 'ClearSupportSiteCache'
  eventIds: Maybe<Array<Maybe<Scalars['String']>>>
  message: Maybe<Scalars['String']>
}

/** Represents the client info passed into startCheckDeposit */
export type ClientInfo = {
  /** App version */
  appVersion: Scalars['String']
  /** Make of the device, e.g. Samsung, Apple, LG, etc */
  manufacturer: Scalars['String']
  /** Device model, e.g. iPhone 7, AsusPad 2 etc. */
  model: Scalars['String']
  /** Operating System, e.g. iOS, Android, Windows, Mac OS */
  os: Scalars['String']
  /** Operating System version, e.g. 8.0.10211, KITKAT, LOLLIPOP etc. */
  osVersion: Scalars['String']
  /** iphone, android, or web */
  platform: Scalars['String']
}

export type CloseAccountReason = {
  __typename?: 'CloseAccountReason'
  key: Scalars['String']
  label: Scalars['String']
}

export type CloseBankAccountInput = {
  accountId: Scalars['ID']
  bankAccountClosureReason?: InputMaybe<BankAccountClosureReason>
  feedback?: InputMaybe<Scalars['String']>
}

export type CloseBankAccountResult = BankAccount | BankAccountNotFoundError

/** Investment account closure request */
export type CloseInvestmentAccountInput = {
  /** List of reasons for account closure */
  accountClosureReasons?: InputMaybe<Array<Scalars['String']>>
  /** Account closure reason comments */
  comments?: InputMaybe<Scalars['String']>
  /** The Money Transfer Account ID to be used to send liquidated funds to (only for Money Platform orchestrated liquidations) */
  destinationAccountId?: InputMaybe<Scalars['ID']>
  /** The ID of the investment account to be closed */
  investmentAccountId: Scalars['ID']
  /** Tax withholding information to be used during liquidation (required for Later closure) */
  taxWithholdings?: InputMaybe<TaxWithholdings>
  /** The reason for withdrawaling the funds (required for Later closure) */
  withdrawalReason?: InputMaybe<LaterWithdrawalReason>
}

/** Investment Account Closure Response */
export type CloseInvestmentAccountResult =
  | AccountNotFoundException
  | InvestmentAccount
  | InvestmentAccountAlreadyClosed
  | InvestmentAccountClosureInProgress
  | LaterAccountRequiresTaxWithholdings
  | LaterAccountRequiresWithdrawalReason
  | LaterAccountTaxWithholdingsPercentageExceeded
  | NonBasicAccountOpenException

/** Close User Account Response */
export type CloseUserAccountResult =
  | OpenAccountsException
  | UserNotFoundException
  | User_V2

/** No account closure request exists for the given investment account */
export type ClosureRequestDoesNotExistException = {
  __typename?: 'ClosureRequestDoesNotExistException'
  /** message */
  errorMessage: Maybe<Scalars['String']>
}

/** An account closure request already exists for this account */
export type ClosureRequestExistsException = {
  __typename?: 'ClosureRequestExistsException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type CohortEligibility = {
  __typename?: 'CohortEligibility'
  /** key referencing if the user is eligible or not */
  eligible: Scalars['Boolean']
  /** key referencing the cohort eligibility scope */
  type: CohortEligibilityScope
}

export enum CohortEligibilityScope {
  /** Earn Incentive New User Cohort */
  EarnIncentive = 'EARN_INCENTIVE',
  /** Mobile Remote Deposit Checks Feature Cohort */
  Mrdc = 'MRDC',
  /** Passions Cohort */
  PassionsExperience = 'PASSIONS_EXPERIENCE',
  /** Personalized Found Money on Present Cohort */
  PersonalizedFoundMoneyOnPresent = 'PERSONALIZED_FOUND_MONEY_ON_PRESENT',
  /** Send Check Cohort */
  SendCheck = 'SEND_CHECK',
}

export type CohortEligibility_V2 = {
  __typename?: 'CohortEligibility_v2'
  /** key referencing the cohort name */
  cohort: Scalars['String']
  /** key referencing if the user is eligible or not */
  eligible: Scalars['Boolean']
}

export type CohortEligibility_V2FilterInput = {
  /** key referencing the cohort name */
  cohorts?: InputMaybe<Array<Scalars['String']>>
}

export enum CollectionMethod {
  Automatic = 'automatic',
  Manual = 'manual',
}

/** Performance values aggregated across all investment accounts within a user's Acorns account */
export type CombinedPerformance = {
  __typename?: 'CombinedPerformance'
  /** Combined investment account values based on previous market day's closing prices */
  accountValues: Maybe<Array<Maybe<AccountValue>>>
  /** Value of bond holdings across all investment accounts */
  bondValue: Maybe<MonetaryAmount>
  /** Value of crypto holdings across all investment accounts */
  cryptoValue: Maybe<MonetaryAmount>
  /** Value of all investment accounts based on most current available prices */
  currentBalance: Maybe<MonetaryAmount>
  /** The dollar change in combined account value from market movement over the reporting period */
  marketChange: Maybe<MonetaryAmount>
  /** The percentage change in combined account value from market movement over the reporting period */
  marketChangePercent: Maybe<Scalars['Float']>
  /** The percentage change in combined account value from market movement over the reporting period (excluding fees) */
  marketChangePercentWithoutFees: Maybe<Scalars['Float']>
  /** The dollar change in combined account value from market movement over the reporting period (excluding fees) */
  marketChangeWithoutFees: Maybe<MonetaryAmount>
  /** The total dollar amount of contributions minus withdrawals */
  netInvestments: Maybe<MonetaryAmount>
  /** Value of stock holdings across all investment accounts */
  stockValue: Maybe<MonetaryAmount>
  /**
   * The total dollar amount invested over the reporting period
   * @deprecated Will not be supported in the future
   */
  totalInvested: Maybe<MonetaryAmount>
  /**
   * The total dollar amount invested over the reporting period (including pending investments)
   * @deprecated Will not be supported in the future
   */
  totalInvestedWithPending: Maybe<MonetaryAmount>
}

export type CommitmentReward = WeeklyRaffle

export type CompleteCheckDepositInput = {
  amount: CurrencyAmountInput
  /** The session to complete. */
  sessionToken: Scalars['String']
}

/** Response from completing a deposit. */
export type CompleteCheckDepositPayload = {
  __typename?: 'CompleteCheckDepositPayload'
  /** The session that was completed. */
  sessionToken: Scalars['String']
}

export type CompleteFunnelOnboardingResult =
  | RegistrationFunnel
  | UnmetRequirementsException

export type CompletedQuiz = {
  __typename?: 'CompletedQuiz'
  communityAvgPercents: Scalars['Int']
  correctQuestions: Scalars['Int']
  totalQuestions: Scalars['Int']
  userScorePercents: Scalars['Int']
}

export type ConfigureSettingsInput = {
  employerHidden?: InputMaybe<Scalars['Boolean']>
  employerName: Scalars['String']
  splitPercent: Scalars['String']
  splitType: DistributionType
}

export type ConfigureSplitDepositDirectDepositIntentPayload = {
  __typename?: 'ConfigureSplitDepositDirectDepositIntentPayload'
  intent: SplitDepositDirectDepositIntentSetting
}

export type ConfigureSplitDepositDirectDepositIntentSettingInput = {
  allocations: Array<SplitDepositAllocationInput>
  estimatedPaycheckAmount: CurrencyAmountInput
  id?: InputMaybe<Scalars['ID']>
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
}

export type ConfigureSplitDepositDirectDepositSettingInput = {
  allocations: Array<SplitDepositAllocationInput>
  directDepositIntentSettingId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
}

export type ConfigureSplitDepositDirectDepositSettingPayload = {
  __typename?: 'ConfigureSplitDepositDirectDepositSettingPayload'
  setting: SplitDepositDirectDepositSetting
}

export type ConnectAchAccountInput = {
  account: Scalars['AccountNumber']
  routing: Scalars['RoutingNumber']
}

export type ConnectAchAccountResult =
  | ConnectAchAccountSucceeded
  | InstitutionNotSupportedError

export type ConnectAchAccountSucceeded = {
  __typename?: 'ConnectACHAccountSucceeded'
  message: Scalars['String']
}

export enum ConnectionStatus {
  Authorized = 'AUTHORIZED',
  TfaRequired = 'TFA_REQUIRED',
  Unauthorized = 'UNAUTHORIZED',
}

export type ConnectionSummary = {
  __typename?: 'ConnectionSummary'
  connections: Maybe<Array<BankConnection>>
  totalEligibleFeeCount: Maybe<Scalars['Int']>
  totalEligibleFees: Maybe<MonetaryAmount>
  /** @deprecated replaced by totalEligibleFees */
  totalEligibleFeesForUser: Maybe<MonetaryAmount>
  userEligibility: Maybe<Scalars['Boolean']>
}

export type ConsumeUserTokenResult = InvalidUserTokenException | UserToken

export type ContactCategory = {
  __typename?: 'ContactCategory'
  id: Scalars['ID']
  label: Scalars['String']
  subcategories: Maybe<Array<ContactSubcategory>>
  value: Scalars['String']
}

export type ContactFaq = {
  __typename?: 'ContactFaq'
  answer: Scalars['String']
  href: Scalars['String']
  id: Scalars['ID']
  question: Scalars['String']
}

export type ContactFormAlert = {
  __typename?: 'ContactFormAlert'
  message: Maybe<Scalars['String']>
}

export type ContactInfoInput = {
  address1?: InputMaybe<Scalars['String']>
  address2?: InputMaybe<Scalars['String']>
  city?: InputMaybe<Scalars['String']>
  phoneNumber?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  zip?: InputMaybe<Scalars['String']>
}

export type ContactSubcategory = {
  __typename?: 'ContactSubcategory'
  chatEnabled: Scalars['Boolean']
  emailEnabled: Scalars['Boolean']
  faqs: Array<ContactFaq>
  id: Scalars['ID']
  label: Scalars['String']
  message: Maybe<SubcategoryMessage>
  phoneEnabled: Scalars['Boolean']
  value: Scalars['String']
}

export type ContentPreviewConnection = LearnConnection & {
  __typename?: 'ContentPreviewConnection'
  edges: Array<ContentPreviewEdge>
  pageInfo: LearnPageInfo
}

export type ContentPreviewEdge = LearnEdge & {
  __typename?: 'ContentPreviewEdge'
  cursor: Scalars['ID']
  node: LearnContentPreview
}

export type ContentRulesChangeLogConnection = {
  __typename?: 'ContentRulesChangeLogConnection'
  edges: Array<ContentRulesChangeLogEntryEdge>
  pageInfo: PageInfo
}

/** Audit log entry — immutable record of a configuration change. */
export type ContentRulesChangeLogEntry = {
  __typename?: 'ContentRulesChangeLogEntry'
  /** Action performed on the entity. */
  action: ChangeLogAction
  /** Email of the admin who made the change (from Okta). */
  changedBy: Scalars['String']
  /** ISO 8601 timestamp when the change was recorded. */
  createdAt: Scalars['DateTime']
  /** UUID of the changed entity. */
  entityId: Scalars['String']
  /** Type of entity that was changed (e.g. widget_registry, screens, widget_rulesets). */
  entityType: Scalars['String']
  /** UUID primary key. */
  id: Scalars['ID']
  /** State of the entity after the change. */
  newValue: Maybe<Scalars['JSON']>
  /** State of the entity before the change. */
  oldValue: Maybe<Scalars['JSON']>
  /** Optional reason for the change provided by the admin. */
  reason: Maybe<Scalars['String']>
}

export type ContentRulesChangeLogEntryEdge = {
  __typename?: 'ContentRulesChangeLogEntryEdge'
  node: ContentRulesChangeLogEntry
}

/** Filter for audit log queries. All fields are optional. */
export type ContentRulesChangeLogFilterInput = {
  /** Filter by action type. */
  action?: InputMaybe<ChangeLogAction>
  /** Filter by email of the admin who made the change. */
  changedBy?: InputMaybe<Scalars['String']>
  /** Filter by UUID of the changed entity. */
  entityId?: InputMaybe<Scalars['String']>
  /** Filter by entity type (e.g. widget_registry, screens, widget_rulesets, field_registry). */
  entityType?: InputMaybe<Scalars['String']>
  /** Return only entries created on or after this ISO 8601 datetime. */
  fromDate?: InputMaybe<Scalars['String']>
  /** Return only the entry with this UUID. */
  id?: InputMaybe<Scalars['ID']>
  /** Return only entries created on or before this ISO 8601 datetime. */
  toDate?: InputMaybe<Scalars['String']>
}

/**
 * Pagination input for admin queries. Uses limit/offset consistent with Acorns standard.
 * Results are ordered by created_at ASC, id ASC (deterministic stable ordering).
 * change_log queries are ordered created_at DESC, id DESC (most recent first).
 */
export type ContentRulesPaginationInput = {
  /** Number of items to return. Defaults to 50. */
  limit?: InputMaybe<Scalars['Int']>
  /** Number of items to skip. Defaults to 0. */
  offset?: InputMaybe<Scalars['Int']>
}

/** Lifecycle status for a widget ruleset. */
export enum ContentRulesRulesetStatus {
  /** Ruleset is active and evaluated for eligibility. */
  Active = 'ACTIVE',
  /** Ruleset is inactive and not evaluated. */
  Inactive = 'INACTIVE',
}

/** Screen configuration — widget priority ordering and selection rules. */
export type ContentRulesScreen = {
  __typename?: 'ContentRulesScreen'
  /** ISO 8601 timestamp when this row was created. */
  createdAt: Scalars['DateTime']
  /** ID of the actor who created this row. */
  createdBy: Maybe<Scalars['String']>
  /** Optional description of this screen configuration. */
  description: Maybe<Scalars['String']>
  /** Human-readable name for the admin UI. */
  displayName: Maybe<Scalars['String']>
  /** UUID primary key. */
  id: Scalars['ID']
  /** If true, this config is used when no selectionRules match. */
  isDefault: Scalars['Boolean']
  /** Internal screen identifier in snake_case (e.g. a4_home_bottom_nav). */
  screenContext: Scalars['String']
  /** Priority for selecting among multiple configs for the same screenContext. Higher = evaluated first. */
  selectionPriority: Scalars['Int']
  /** Optional JSON rule tree that determines when this screen config is selected. */
  selectionRules: Maybe<Scalars['JSON']>
  /** Lifecycle status. */
  status: ContentRulesScreenStatus
  /** ISO 8601 timestamp when this row was last updated. */
  updatedAt: Scalars['DateTime']
  /** ID of the actor who last updated this row. */
  updatedBy: Maybe<Scalars['String']>
  /** Ordered list of widget_type strings defining display priority. */
  widgetPriority: Array<Scalars['String']>
}

export type ContentRulesScreenConnection = {
  __typename?: 'ContentRulesScreenConnection'
  edges: Array<ContentRulesScreenEdge>
  pageInfo: PageInfo
}

export type ContentRulesScreenEdge = {
  __typename?: 'ContentRulesScreenEdge'
  node: ContentRulesScreen
}

/** Filter for screen configuration queries. All fields are optional. */
export type ContentRulesScreenFilterInput = {
  /** Return only the entry with this UUID. */
  id?: InputMaybe<Scalars['ID']>
  /** Filter by screen context identifier. */
  screenContext?: InputMaybe<Scalars['String']>
  /** Filter by lifecycle status. */
  status?: InputMaybe<ContentRulesScreenStatus>
}

/** Lifecycle status for a screen configuration. */
export enum ContentRulesScreenStatus {
  /** Screen config is active and used for widget priority selection. */
  Active = 'ACTIVE',
  /** Screen config is soft-deleted and no longer used. */
  Inactive = 'INACTIVE',
}

export type ContentRulesTestEvaluationResult = {
  __typename?: 'ContentRulesTestEvaluationResult'
  configError: Maybe<Scalars['String']>
  degradation: TestEvaluationDegradation
  evaluatedAt: Scalars['DateTime']
  legacyComparison: Maybe<LegacyComparisonResult>
  legacyComparisonError: Maybe<Scalars['String']>
  screenContext: Scalars['String']
  selectedScreenRow: Maybe<TestEvaluationScreenRow>
  userContext: Maybe<Scalars['JSON']>
  userContextError: Maybe<Scalars['String']>
  userId: Scalars['String']
  widgets: Array<WidgetEvaluationTrace>
}

/** Controls how the effective dismissal key is built at read time. */
export enum ContentRulesWidgetDismissalScope {
  /**
   * Use dismissal_key as-is — dismissal applies across all screens.
   * e.g. "early_match" stays "early_match"
   */
  All = 'ALL',
  /**
   * Prepend screen_context (snake_case) to dismissal_key.
   * e.g. "a4_home_bottom_nav" + "tracking_widget" → "a4_home_bottom_nav_tracking_widget"
   */
  Screen = 'SCREEN',
}

/** Routing status for a widget type in the registry. */
export enum ContentRulesWidgetStatus {
  /** Evaluated by the Content Rules Service (new path). */
  Active = 'ACTIVE',
  /** Excluded from all results regardless of screen. */
  Inactive = 'INACTIVE',
  /** Proxied to the legacy action_feed_service. */
  Legacy = 'LEGACY',
}

export type ContextEntryInput = {
  key: Scalars['String']
  value: Scalars['String']
}

/** Input for continuing investment account liquidation */
export type ContinueInvestmentAccountLiquidationInput = {
  /** The ID of the investment account */
  investmentAccountId: Scalars['ID']
}

/** Continue Investment Account Liquidation Response */
export type ContinueInvestmentAccountLiquidationResult =
  | AccountNotFoundException
  | ContinueInvestmentAccountLiquidationSuccess
  | WorkflowNotFoundException

/** Success response for continuing investment account liquidation */
export type ContinueInvestmentAccountLiquidationSuccess = {
  __typename?: 'ContinueInvestmentAccountLiquidationSuccess'
  /** The ID of the investment account */
  investmentAccountId: Scalars['ID']
}

/** Legacy per-tax-year contribution ability, kept shape-compatible with graphql_service. */
export type ContributionAbility = {
  __typename?: 'ContributionAbility'
  /** flag indicating if the user can contribute to this tax year */
  canContribute: Maybe<Scalars['Boolean']>
  /** maximum legally allowed amount for contributions */
  planLimit: Maybe<Scalars['Int']>
  /** available contribution amount */
  remaining: Maybe<Scalars['Float']>
  /** tax year of aggregated contributions */
  taxYear: Scalars['Int']
  /** total current contributions in tax year */
  yearToDate: Maybe<Scalars['Float']>
}

export type ContributionAbilityByYear = {
  __typename?: 'ContributionAbilityByYear'
  contributionAbilities: Maybe<Array<ContributionAbility>>
}

/** A set of investment accounts that share a contribution limit, along with the contribution ability for each eligible tax year. */
export type ContributionAbilityGroup = {
  __typename?: 'ContributionAbilityGroup'
  /** Contribution ability for each eligible tax year within this limit group. */
  abilities: Array<TaxYearContributionAbility>
  /** The investment account IDs that share this limit group. */
  investmentAccountIds: Array<Scalars['ID']>
  /** The contribution limit group these accounts fall under (e.g. ANNUAL_IRA, SEP). */
  limitGroup: LimitGroup
}

/** Contribution cannot be created because an additional action needs to be taken first */
export type ContributionActionRequiredError = {
  __typename?: 'ContributionActionRequiredError'
  /** The payment_intent_id that the contribution was attempted to be made for */
  paymentIntentId: Scalars['ID']
  /** The url that the frontend needs to redirect the user to for 3DS. Only available for REDIRECT_TO_URL action */
  redirectUrl: Maybe<Scalars['String']>
  /** The action that needs to be taken in order to create transaction */
  requiredAction: ContributionRequiredAction
}

/** Contribution amount must be below the maximum threshold */
export type ContributionAmountAboveThresholdError = {
  __typename?: 'ContributionAmountAboveThresholdError'
  maximumThresholdAmount: Scalars['String']
}

/** Contribution amount must be above the minimum threshold */
export type ContributionAmountBelowThresholdError = {
  __typename?: 'ContributionAmountBelowThresholdError'
  minimumThresholdAmount: Scalars['String']
}

/** Contribution cannot be created because the card was declined */
export type ContributionCardDeclinedError = {
  __typename?: 'ContributionCardDeclinedError'
  /** The payment_intent_id that the contribution was attempted to be made for */
  paymentIntentId: Scalars['ID']
}

/** A tax year in which a contribution was made to a Later account */
export type ContributionHistoryItem = {
  __typename?: 'ContributionHistoryItem'
  /** Tax year a settled contribution was made */
  year: Scalars['Int']
}

/** The reason a user cannot make contributions for a given tax year. */
export enum ContributionIneligibleReason {
  /** The user has already reached the plan limit for this tax year. */
  LimitReached = 'LIMIT_REACHED',
  /** The contribution window for this tax year has closed. */
  TaxYearClosed = 'TAX_YEAR_CLOSED',
}

/** Invalid owner email. */
export type ContributionInvalidOwnerEmailError = {
  __typename?: 'ContributionInvalidOwnerEmailError'
  /** The invalid email provided. */
  providedEmail: Scalars['String']
}

export type ContributionLink = {
  __typename?: 'ContributionLink'
  code: Scalars['ID']
  contributionType: ContributionType
  id: Scalars['ID']
  linkUrl: Scalars['String']
}

export type ContributionPage = {
  __typename?: 'ContributionPage'
  code: Scalars['ID']
  contributionType: ContributionType
  details: ContributionPageDetails
  limits: ExternalContributionLimits
}

export type ContributionPageDetails = TipContributionPageDetails

export type ContributionPageResult =
  | ContributionPage
  | ContributionPageUnavailable

export type ContributionPageUnavailable = {
  __typename?: 'ContributionPageUnavailable'
  reason: ContributionPageUnavailableReason
  targetDisplayName: Maybe<Scalars['String']>
}

export enum ContributionPageUnavailableReason {
  ContributionTargetAtCap = 'CONTRIBUTION_TARGET_AT_CAP',
  ContributionTargetUnavailable = 'CONTRIBUTION_TARGET_UNAVAILABLE',
}

/** The breakdown of contributions made toward a tax year's limit. */
export type ContributionProgress = {
  __typename?: 'ContributionProgress'
  /** Contributions that have been fully processed and settled. */
  applied: Money
  /** Contributions that have been initiated but not yet settled. */
  pending: Money
  /** Sum of applied and pending contributions — the total that counts against the plan limit. */
  total: Money
}

export enum ContributionRequiredAction {
  /** Stripe is expecting the app to redirect the user (not part of our flow and should not happen) */
  RedirectToUrl = 'REDIRECT_TO_URL',
  /** The frontend is responsible for sending this payment intent to Stripe for 3DS verification */
  UseStripeSdk = 'USE_STRIPE_SDK',
}

export enum ContributionState {
  /** Terminal state, failed contribution */
  Failed = 'FAILED',
  /** Initial state, pending contribution */
  Pending = 'PENDING',
  /** Terminal state, successful contribution */
  Success = 'SUCCESS',
}

export type ContributionStickerRequest = {
  __typename?: 'ContributionStickerRequest'
  contributionLink: ContributionLink
  id: Scalars['ID']
  quantity: Scalars['Int']
  requestedAt: Scalars['ISO8601DateTime']
  shippingAddress: ContributionStickerShippingAddress
}

export type ContributionStickerRequestInputViolation = {
  __typename?: 'ContributionStickerRequestInputViolation'
  path: Array<Scalars['String']>
  reason: ContributionStickerRequestInvalidInputReason
}

export type ContributionStickerRequestInvalidInputError = {
  __typename?: 'ContributionStickerRequestInvalidInputError'
  violations: Array<ContributionStickerRequestInputViolation>
}

export enum ContributionStickerRequestInvalidInputReason {
  /** Field value is not valid */
  Invalid = 'INVALID',
  /** Field value exceeds maximum length */
  TooLong = 'TOO_LONG',
  /** Country is not supported for sticker delivery */
  UnsupportedCountry = 'UNSUPPORTED_COUNTRY',
}

export type ContributionStickerRequestsInput = {
  code: Scalars['ID']
}

export type ContributionStickerShippingAddress = {
  __typename?: 'ContributionStickerShippingAddress'
  city: Scalars['String']
  country: Scalars['String']
  line1: Scalars['String']
  line2: Maybe<Scalars['String']>
  name: Scalars['String']
  postalCode: Scalars['String']
  state: Scalars['String']
}

export type ContributionStickerShippingAddressInput = {
  city: Scalars['String']
  country: Scalars['String']
  line1: Scalars['String']
  line2?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  postalCode: Scalars['String']
  state: Scalars['String']
}

export enum ContributionType {
  Tip = 'TIP',
}

/** Pulls from funding source */
export type CoreAchSubscriptionFeeItem = PastItem & {
  __typename?: 'CoreACHSubscriptionFeeItem'
  /** The amount paid for the subscription. Note that this is intentionally positive because it does not represent removing balance from the account. */
  amount: CurrencyAmount
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean']
  /** Past Item ID */
  id: Scalars['ID']
  /** The corresponding product of the item */
  productType: ProductType
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
  /** The current state of the item */
  status: PastItemStatus
  /** The title of the item */
  title: Scalars['String']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
}

/** A Core account already exists for this user */
export type CoreAccountAlreadyExistsException = {
  __typename?: 'CoreAccountAlreadyExistsException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Deprecated - This exception is no longer returned */
export type CoreAccountClosedException = {
  __typename?: 'CoreAccountClosedException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Legacy type we need to account for Credit (Found Money Credits + Employee Contribution) */
export type CoreAdjustmentItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreAdjustmentItem'
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CoreCashForwardItem = PastItem & {
  __typename?: 'CoreCashForwardItem'
  amount: CurrencyAmount
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean']
  /** Past Item ID */
  id: Scalars['ID']
  /** The corresponding product of the item */
  productType: ProductType
  /** Format: 2017-02 */
  relatedMonth: Scalars['String']
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
  /** The current state of the item */
  status: PastItemStatus
  /** The title of the item */
  title: Scalars['String']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
}

/** You owe us money */
export type CoreCollectionItem = PastItem & {
  __typename?: 'CoreCollectionItem'
  /** The amount owed. */
  amount: CurrencyAmount
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean']
  /** Past Item ID */
  id: Scalars['ID']
  /** The corresponding product of the item */
  productType: ProductType
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
  /** The current state of the item */
  status: PastItemStatus
  /** The title of the item */
  title: Scalars['String']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
}

/** Sell shares to pay down cash owed by the customer. */
export type CoreDebtCollectionItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreDebtCollectionItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CoreDividendsItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreDividendsItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    etfCategory: Scalars['String']
    etfTicker: Scalars['String']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CoreEmployeeCreditItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreEmployeeCreditItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    employerName: Scalars['String']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Sell shares for the fee. This happens for Paypal users or if users never accepted the new EFT */
export type CoreFeeInvestmentItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreFeeInvestmentItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CoreFoundMoneyRewardItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreFoundMoneyRewardItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    merchantName: Maybe<Scalars['String']>
    partnerLogoUrl: Maybe<Scalars['URL']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CoreGiftCardCreditRedemptionItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreGiftCardCreditRedemptionItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Holding transfer transfered in from Age of Transfer beneficiary investment account */
export type CoreHoldingsTransferInItem = PastItem & {
  __typename?: 'CoreHoldingsTransferInItem'
  amount: CurrencyAmount
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean']
  /** Past Item ID */
  id: Scalars['ID']
  /** The corresponding product of the item */
  productType: ProductType
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
  /** The current state of the item */
  status: PastItemStatus
  /** The title of the item */
  title: Scalars['String']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
}

/** An investment in to the Core account */
export type CoreInvestmentItem = PastCoreCombinedItem &
  PastCoreTradedItem &
  PastItem &
  PastUserTransferItem & {
    __typename?: 'CoreInvestmentItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    isCombinedInvestment: Scalars['Boolean']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CoreLocalFoundMoneyItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreLocalFoundMoneyItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    merchantName: Maybe<Scalars['String']>
    partnerLogoUrl: Maybe<Scalars['URL']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CorePartnerRewardItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CorePartnerRewardItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    merchantName: Maybe<Scalars['String']>
    partnerLogoUrl: Maybe<Scalars['URL']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CoreRebalanceItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreRebalanceItem'
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CoreReferralRewardItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreReferralRewardItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Cash refunded to the customer */
export type CoreRefundedItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreRefundedItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Cash that is reinvested into the investment account */
export type CoreReinvestmentItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreReinvestmentItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Instant and regular round ups */
export type CoreRoundUpsItem = PastCoreCombinedItem &
  PastCoreTradedItem &
  PastItem &
  PastUserTransferItem & {
    __typename?: 'CoreRoundUpsItem'
    /** The investment amount after being multiplied. */
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    /** The investment amount prior to being multiplied */
    initialAmount: CurrencyAmount
    isCombinedInvestment: Scalars['Boolean']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    merchantName: Maybe<Scalars['String']>
    multiplier: Scalars['Int']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** The amount of the transaction that caused this round up. TransactionAmount will be null if this is a combined round up investment. */
    transactionAmount: Maybe<CurrencyAmount>
    type: RoundUpType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CoreWithdrawalItem = PastCoreTradedItem &
  PastItem &
  PastUserTransferItem & {
    __typename?: 'CoreWithdrawalItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CouponNotFoundError = {
  __typename?: 'CouponNotFoundError'
  message: Scalars['String']
}

export type Course = {
  __typename?: 'Course'
  authors: Array<LearnAuthor>
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  id: Scalars['ID']
  learnProductKey: Maybe<LearnProductKey>
  lessons: Array<Lesson>
  metadata: LearnMetadata
  summary: Maybe<Scalars['String']>
  tags: Array<LearnTag>
  theme: CourseTheme
  /** @deprecated Tier will be removed */
  tier: LearnTier
  title: Scalars['String']
  topics: Array<LearnTopic>
}

export type CourseLocked = {
  __typename?: 'CourseLocked'
  authors: Array<LearnAuthor>
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  id: Scalars['ID']
  lessons: Array<Lesson>
  numLessons: Scalars['Int']
  primaryTopicName: Scalars['String']
  productRequired: Scalars['String']
  summary: Maybe<Scalars['String']>
  theme: CourseTheme
  title: Scalars['String']
  topics: Array<LearnTopic>
}

export type CoursePreview = {
  __typename?: 'CoursePreview'
  contentId: Scalars['ID']
  contentType: LearnContentType
  courseTheme: CourseTheme
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  isCompleted: Scalars['Boolean']
  numberOfLessons: Scalars['Int']
  primaryTopicName: Scalars['String']
  productRequired: Maybe<Scalars['String']>
  progress: Maybe<LearnProgress>
  relatedQuizProgress: Maybe<LearnProgress>
  /** @deprecated tierName is being replaced by productRequired */
  tierName: Scalars['String']
  title: Scalars['String']
}

export type CoursePreviewLocked = {
  __typename?: 'CoursePreviewLocked'
  contentId: Scalars['ID']
  contentType: LearnContentType
  courseTheme: CourseTheme
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  lockedReason: Maybe<Scalars['String']>
  numberOfLessons: Scalars['Int']
  primaryTopicName: Scalars['String']
  productRequired: Scalars['String']
  title: Scalars['String']
}

export type CourseTheme = LearnThemeLiteral

export type CreateAmplitudeFlagInput = {
  amplitudeUrl?: InputMaybe<Scalars['String']>
  changedBy: Scalars['String']
  description?: InputMaybe<Scalars['String']>
  displayName: Scalars['String']
  flagKey: Scalars['String']
  reason?: InputMaybe<Scalars['String']>
  status?: InputMaybe<AmplitudeFlagStatus>
  trackExposure?: InputMaybe<Scalars['Boolean']>
}

export type CreateAnonymousSupportTicketInput = {
  category?: InputMaybe<Scalars['String']>
  contactReason?: InputMaybe<Scalars['String']>
  message: Scalars['String']
  origin?: InputMaybe<SupportTicketOriginEnum>
  ownerId?: InputMaybe<Scalars['ID']>
  productTag?: InputMaybe<ProductTagEnum>
  skipFtTriage?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<SupportTicketStatusEnum>
  subcategory?: InputMaybe<Scalars['String']>
  subject?: InputMaybe<Scalars['String']>
  tags?: InputMaybe<Array<Scalars['String']>>
}

export type CreateAuthProfileInput = {
  email?: InputMaybe<Scalars['EmailAddress']>
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>
}

export type CreateAuthProfileResult =
  | AuthProfile
  | AuthProfileAlreadyExistsException

export type CreateBankAccountInput = {
  accountName?: InputMaybe<Scalars['String']>
  isDocumentsAccepted: Scalars['Boolean']
  tag?: InputMaybe<Scalars['String']>
  type: BankAccountType
}

export type CreateBankAccountPayload = {
  __typename?: 'CreateBankAccountPayload'
  bankAccount: Maybe<BankAccount>
}

/** Response to a beneficiary creation attempt */
export type CreateBeneficiaryResult =
  | Beneficiary
  | BeneficiaryExceedsAgeLimitException
  | InternalErrorException
  | InvalidDateOfBirthException
  | InvalidFirstNameException
  | InvalidLastNameException

export type CreateCustomSupportTicketInput = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  category?: InputMaybe<Scalars['String']>
  customFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  dateOfBirth?: InputMaybe<Scalars['String']>
  description: Scalars['String']
  email: Scalars['String']
  phoneNumber: Scalars['String']
  subject: Scalars['String']
  ticketFormId?: InputMaybe<Scalars['String']>
  uuid?: InputMaybe<Scalars['ID']>
}

export type CreateDelegateResult = DelegateDefinition

export type CreateDesignatedBeneficiaryAddressInput = {
  city: Scalars['String']
  state: Scalars['String']
  street1: Scalars['String']
  street2?: InputMaybe<Scalars['String']>
  zipCode: Scalars['String']
}

export type CreateDesignatedBeneficiaryInput = {
  address: CreateDesignatedBeneficiaryAddressInput
  dateOfBirth: Scalars['String']
  email: Scalars['EmailAddress']
  firstName: Scalars['String']
  lastName: Scalars['String']
  phoneNumber: Scalars['PhoneNumber']
  relationship: DesignatedBeneficiaryRelationship
  ssn: Scalars['String']
}

export type CreateDesignatedBeneficiaryResult =
  | DesignatedBeneficiary
  | DesignatedBeneficiaryExistsException
  | DesignatedBeneficiaryValidationException

export type CreateDesignationInput = {
  accountId: Scalars['ID']
  accountType: DesignationAccountType
  beneficiaryId: Scalars['ID']
}

export type CreateDesignationResult =
  | DesignatedBeneficiaryNotFoundException
  | Designation
  | DesignationExistsException
  | DesignationLimitReachedException
  | DesignationValidationException

/** Pinwheel Token Return Results */
export type CreateDirectDepositLinkInfoFailure = {
  __typename?: 'CreateDirectDepositLinkInfoFailure'
  failureMessage: Scalars['String']
}

/** Mutation attributes for retrieving a Pinwheel link token */
export type CreateDirectDepositLinkInfoInput = {
  /** Account ID */
  accountId: Scalars['ID']
  /** Required Job */
  requiredJobs: Array<PinwheelLinkTokenRequiredJobs>
  /** User ID */
  userId?: InputMaybe<Scalars['ID']>
  /** Vendor */
  vendor?: InputMaybe<DirectDepositVendor>
}

/** Pinwheel Token Return Results */
export type CreateDirectDepositLinkInfoPayload = {
  __typename?: 'CreateDirectDepositLinkInfoPayload'
  results: CreatePinwheelLinkToken
  vendor: Scalars['String']
}

/** Describes the create direct deposit info return type. */
export type CreateDirectDepositLinkInfoSwitch =
  | CreateDirectDepositLinkInfoFailure
  | CreateDirectDepositLinkInfoPayload

export type CreateDocumentUpload = {
  __typename?: 'CreateDocumentUpload'
  createdAt: Scalars['DateTime']
  expiresAt: Scalars['DateTime']
  requestedDocumentId: Scalars['ID']
  uploadUrl: Scalars['URL']
}

export type CreateDocumentUploadInput = {
  contentType: Scalars['String']
  documentRequestId?: InputMaybe<Scalars['ID']>
  documentType: DocumentType
  namespace?: InputMaybe<Scalars['String']>
  postUploadProcessing?: InputMaybe<PostUploadProcessingInput>
  sourceOperationId?: InputMaybe<Scalars['String']>
}

/**
 * Create a new field registry entry.
 *
 * Intended for operator-managed fields only: amplitudeState.* (FEATURE_FLAGS category).
 * New Amplitude flags can be registered here without a code deploy.
 *
 * For customerState.* and clientContext.* fields, an engineer must first add the
 * datasource mapping (customerStateFieldMap.ts or header extraction) and deploy
 * before the field will resolve correctly at runtime.
 */
export type CreateFieldRegistryEntryInput = {
  /** Grouping category for the field picker. */
  category: FieldCategory
  /** Email of the admin making the change (from Okta). Written to change_log.changed_by. */
  changedBy: Scalars['String']
  /**
   * Backend datasource that provides this field (e.g. legacyUser, investmentAccounts, amplitude).
   * NULL for client-derived fields.
   */
  datasource?: InputMaybe<Scalars['String']>
  /** Help text for rule authors shown in the admin UI. */
  description?: InputMaybe<Scalars['String']>
  /** Human-readable name shown in the admin field picker. */
  displayName: Scalars['String']
  /** Dot-notation path matching how the field is referenced in rule trees. */
  fieldPath: Scalars['String']
  /** Valid comparison operators for this field (e.g. equals, greater_than). */
  operators: Array<Scalars['String']>
  /** Optional reason for the change. Written to change_log.reason. */
  reason?: InputMaybe<Scalars['String']>
  /** Data type determining valid operators and UI rendering. */
  valueType: FieldValueType
}

export type CreateFieldRegistryEntryResult = FieldRegistryEntry

export type CreateImplicitTokenForUserInput = {
  oauthAppClientId?: InputMaybe<Scalars['String']>
  oauthAppId: Scalars['String']
}

export type CreateImplicitTokenForUserResult =
  | ImplicitToken
  | InvalidOauthAppClientIdException
  | OauthAppNotFoundException

/** Input of CreateIntent. */
export type CreateIntentInput = {
  /**
   * The amount to transfer.
   * @deprecated Use `amountMicros` instead.
   */
  amount?: InputMaybe<CurrencyAmountInput>
  /** The amount to transfer. */
  amountMicros?: InputMaybe<MicrosMoneyInput>
  /** Optional client ID for route selection. If not provided, defaults to GATEWAY_ACCESS_CLIENT_ID. */
  clientID?: InputMaybe<Scalars['UUID']>
  /** The ID of the `CustomerAccount` to transfer money from. */
  fromId: Scalars['ID']
  /** Idempotent identifier for this transaction intent, provided by caller. */
  nonce: Scalars['UUID']
  /** The ID of the `CustomerAccount` to transfer money to. */
  toId: Scalars['ID']
  /** Additional input to be passed for this transfer. */
  transferContext?: InputMaybe<Array<ContextEntryInput>>
}

export type CreateIntentResult = Intent | ValidationError

/** Input for creating investing strategy recommendations */
export type CreateInvestingStrategyRecommendationInput = {
  /** Type of account to get recommendation for */
  accountType: SuitabilityAccountType
  /** Factors affecting outcome of recommendation */
  factors: Array<InvestingStrategyFactors>
}

export type CreateInvestingStrategyRecommendationResult =
  | BadRequestError
  | RecommendedInvestingStrategy

export type CreateInvestmentAccountResponse = {
  __typename?: 'CreateInvestmentAccountResponse'
  id: Scalars['ID']
  iraType: InvestmentAccountTypes
  userUuid: Scalars['ID']
}

export type CreateJobAlertResult = JobAlert

export type CreateOauthAppInput = {
  accessTokenAudience: Array<InputMaybe<Scalars['String']>>
  accessTokenExpiry?: InputMaybe<Scalars['Int']>
  active: Scalars['Boolean']
  contactEmail?: InputMaybe<Scalars['String']>
  contactName?: InputMaybe<Scalars['String']>
  contract?: InputMaybe<Scalars['String']>
  externalApp: Scalars['Boolean']
  imageUri?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  pageType: Scalars['String']
  redirectUri?: InputMaybe<Scalars['String']>
  refreshTokenExpiry?: InputMaybe<Scalars['Int']>
  scopeIdentifiers: Array<Scalars['String']>
  type: OauthAppType
}

export type CreateOauthAppResult = OauthApp

export type CreateOfferInput = {
  availableTo: OfferAvailability
  expiresAt?: InputMaybe<Scalars['DateTime']>
  offerType: OfferType
  price: OfferPriceInput
}

export type CreateOfferResult = Offer

/** Input to create a new outside contribution checkout cart */
export type CreateOutsideContributionCheckoutCartInput = {
  /** Outside contribution code */
  code: Scalars['String']
  /** investment amount for the outside contribution */
  investmentAmount: Scalars['String']
}

/** Create Outside Contribution checkout cart response */
export type CreateOutsideContributionCheckoutCartResult =
  | ContributionAmountAboveThresholdError
  | ContributionAmountBelowThresholdError
  | OutsideContributionCheckoutCart

/** Input to create a new outside contribution */
export type CreateOutsideContributionInput = {
  /** The last 4 digits of the debit card number */
  cardNumberLast4: Scalars['String']
  /** The provider of the debit card ie visa, mastercard etc */
  cardProvider: Scalars['String']
  /** The outside contributor email address */
  contributorEmail: Scalars['String']
  /** The first name of the outside contributor */
  contributorFirstName: Scalars['String']
  /** The last name of the outside contributor */
  contributorLastName: Scalars['String']
  /** The note from the outside contributor */
  note?: InputMaybe<Scalars['String']>
  /** The name from the note of the contributor */
  noteAuthor?: InputMaybe<Scalars['String']>
  /** Stripe payment_intent_id */
  paymentIntentId: Scalars['ID']
  /** Stripe payment_method_id */
  paymentMethodId: Scalars['ID']
}

/** Create Outside Contribution mutation response */
export type CreateOutsideContributionResult =
  | ContributionActionRequiredError
  | ContributionCardDeclinedError
  | ContributionInvalidOwnerEmailError
  | OutsideContribution

export type CreatePinwheelLinkToken = {
  __typename?: 'CreatePinwheelLinkToken'
  /** Pinwheel Token expiration date/time */
  expires: Scalars['DateTime']
  /** UUID of the link token */
  id: Scalars['String']
  /** Pinwheel token Environment */
  mode: Scalars['String']
  /** Short lived token that is used to initialize Pinwheel Link */
  token: Scalars['String']
}

/** Attributes for a linked account created through Plaid Link */
export type CreatePlaidLinkedAccountInput = {
  /** Should the related round up account be disabled */
  disableRoundUps?: InputMaybe<Scalars['Boolean']>
  /** Plaid's Financial Institution ID */
  externalInstitutionId?: InputMaybe<Scalars['String']>
  /** Plaid link session id */
  linkSessionId: Scalars['String']
}

export type CreatePromoCodeInput = {
  businessLine: PromoCodeBusinessLine
  channel: Scalars['String']
  condensedTitle: Scalars['String']
  description: Scalars['String']
  internalMemo?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  publishEnd?: InputMaybe<Scalars['DateTime']>
  publishStart: Scalars['DateTime']
  qualificationAction: PromoCodeQualificationAction
  qualificationAmount: Scalars['Int']
  rewards: Array<Scalars['ID']>
  status: PromoCodeStatus
  termsUrl?: InputMaybe<Scalars['URL']>
  title: Scalars['String']
}

export type CreatePromoCodeResult =
  | DuplicatePromoCodeError
  | PromoCode
  | PromoCodeFieldLengthError

export type CreatePromoCodeRewardInput = {
  amount: Scalars['Float']
  type: PromoCodeRewardType
}

export type CreatePromoCodeRewardResult =
  | DuplicatePromoCodeRewardError
  | PromoCodeReward

/** Input for creating a prospect user */
export type CreateProspectUserInput = {
  /** Email address of the prospect user */
  email: Scalars['String']
  /** Prospect Type */
  type: ProspectType
}

/** Create Prospect User Response */
export type CreateProspectUserResult =
  | GrowProspect
  | InternalErrorException
  | LaterWaitlistProspect
  | OutsideContributionProspect
  | User_V2

export type CreateReferralCampaignInput = {
  actionFeedDesc?: InputMaybe<Scalars['String']>
  background?: InputMaybe<CampaignBackgroundType>
  condensedTitle?: InputMaybe<Scalars['String']>
  description: Scalars['String']
  eligibilityEnd?: InputMaybe<Scalars['DateTime']>
  hidden: Scalars['Boolean']
  icon?: InputMaybe<CampaignIconType>
  internalMemo?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  payoutExpiryBufferDays?: InputMaybe<Scalars['Int']>
  publishEnd?: InputMaybe<Scalars['DateTime']>
  publishStart: Scalars['DateTime']
  qualificationAction: CampaignQualificationActionType
  qualificationAmount: Scalars['Int']
  rewards: Array<Scalars['ID']>
  status: CampaignStatus
  title: Scalars['String']
}

export type CreateReferralCampaignResult = ReferralCampaignV2

export type CreateReferralCampaignRewardInput = {
  amount: Scalars['Float']
  hurdle: Scalars['Int']
  repeated: Scalars['Boolean']
  targets: Array<ReferralCampaignRewardTarget>
  type: ReferralCampaignRewardType
}

export type CreateReferralCampaignRewardResult = ReferralCampaignReward

export type CreateReferralPayoutInput = {
  advocateId: Scalars['ID']
  campaignId: Scalars['ID']
  friendId?: InputMaybe<Scalars['ID']>
  rewardId: Scalars['ID']
}

export type CreateReferralPayoutResult =
  | ReferralPayout
  | ReferralPayoutExistsError

export type CreateReferralRelationshipResult =
  | InvalidReferralRelationship
  | ReferralRelationship

export type CreateRefundError = {
  __typename?: 'CreateRefundError'
  message: Scalars['String']
}

export type CreateRefundResult =
  | BillingInvoice
  | CreateRefundError
  | VendorIntegrationError
  | VendorRefundInvoiceError

export type CreateSavingsAccountInput = {
  bankType?: InputMaybe<BankType>
  currentGoal?: InputMaybe<BankAccountGoalInput>
  isReopen?: InputMaybe<Scalars['Boolean']>
  type: SavingsAccountType
}

export type CreateSavingsAccountPayload = {
  __typename?: 'CreateSavingsAccountPayload'
  bankAccountId: Scalars['ID']
}

export type CreateSavingsAccountResult =
  | CreateSavingsAccountPayload
  | CreateSavingsAccountVerificationError

export type CreateSavingsAccountVerificationError = {
  __typename?: 'CreateSavingsAccountVerificationError'
  notEligibleReasons: Array<SavingsAccountEligibilityRequirement>
}

export type CreateScopeException = {
  __typename?: 'CreateScopeException'
  message: Scalars['String']
}

export type CreateScopeInput = {
  description?: InputMaybe<Scalars['String']>
  identifier: Scalars['String']
  required?: InputMaybe<Scalars['Boolean']>
  title: Scalars['String']
}

export type CreateScopeResult = CreateScopeException | Scope

export type CreateScreenInput = {
  /** Email of the admin making the change. Written to change_log.changed_by. */
  changedBy: Scalars['String']
  /** Optional description of this screen configuration. */
  description?: InputMaybe<Scalars['String']>
  /** Human-readable name for the admin UI. */
  displayName?: InputMaybe<Scalars['String']>
  /** If true, this config is used when no selectionRules match. */
  isDefault?: InputMaybe<Scalars['Boolean']>
  /** Optional reason for the change. Written to change_log.reason. */
  reason?: InputMaybe<Scalars['String']>
  /** Internal screen identifier in snake_case (e.g. a4_home_bottom_nav). */
  screenContext: Scalars['String']
  /** Priority for selecting among multiple configs for the same screenContext. Higher = evaluated first. */
  selectionPriority?: InputMaybe<Scalars['Int']>
  /** Optional JSON rule tree that determines when this screen config is selected. */
  selectionRules?: InputMaybe<Scalars['JSON']>
  /** Initial lifecycle status. Defaults to ACTIVE. */
  status?: InputMaybe<ContentRulesScreenStatus>
  /** Ordered list of widget_type strings defining display priority. */
  widgetPriority: Array<Scalars['String']>
}

export type CreateScreenResult = ContentRulesScreen | RuleTreeValidationError

export type CreateSubscriptionMigrationInput = {
  description: Scalars['String']
  effectiveAt: Scalars['DateTime']
  fromTierId: Scalars['ID']
  toTierId: Scalars['ID']
}

export type CreateSubscriptionMigrationResult = SubscriptionMigration

export type CreateSupportTicketInput = {
  category?: InputMaybe<Scalars['String']>
  contactReason?: InputMaybe<Scalars['String']>
  dob?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  message: Scalars['String']
  origin?: InputMaybe<SupportTicketOriginEnum>
  ownerId?: InputMaybe<Scalars['ID']>
  phone: Scalars['String']
  productTag?: InputMaybe<ProductTagEnum>
  recaptchaToken?: InputMaybe<Scalars['String']>
  skipFtTriage?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<SupportTicketStatusEnum>
  subcategory?: InputMaybe<Scalars['String']>
  subject?: InputMaybe<Scalars['String']>
  tags?: InputMaybe<Array<Scalars['String']>>
  uuid?: InputMaybe<Scalars['ID']>
}

export type CreateSuspendedUserSupportTicketInput = {
  dob?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  message: Array<Scalars['String']>
  phone?: InputMaybe<Scalars['String']>
  subject: Scalars['String']
  tags?: InputMaybe<Array<Scalars['String']>>
  uuid?: InputMaybe<Scalars['ID']>
}

/** Input for creating an upload url for direct to s3 upload */
export type CreateUploadUrlInput = {
  /** the document type of the upload document */
  documentType: DocumentType
  /** the file_name upload document */
  fileName: Scalars['String']
  /** the user_id of the user uploading a document */
  userId: Scalars['String']
}

/** CreateUploadUrlResult */
export type CreateUploadUrlResult = UploadUrl

export type CreateUserInput = {
  acceptanceDocumentVersionUuids: Array<InputMaybe<Scalars['String']>>
  authorizationAccessToken?: InputMaybe<Scalars['String']>
  authorizationExpiresAt?: InputMaybe<Scalars['DateTime']>
  authorizationProvider?: InputMaybe<Scalars['String']>
  authorizationRefreshToken?: InputMaybe<Scalars['String']>
  authorizationUid?: InputMaybe<Scalars['String']>
  captchaToken?: InputMaybe<Scalars['String']>
  clientCredentialsToken?: InputMaybe<Scalars['String']>
  codeGroup?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  firstName?: InputMaybe<Scalars['String']>
  invitationCode?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  password: Scalars['String']
  sourceAttributes?: InputMaybe<Scalars['JSON']>
  sourceId?: InputMaybe<Scalars['String']>
  udid: Scalars['String']
  usResident?: InputMaybe<Scalars['Boolean']>
  /** @deprecated withBasicAccount input is deprecated in favor of OpenCoreInvestmentAccount */
  withBasicAccount?: InputMaybe<Scalars['Boolean']>
}

/** Input for creating a new user and user profile */
export type CreateUserProfileInput = {
  /** required acceptance document version UUIDs for login */
  acceptanceDocumentVersionUuids: Array<InputMaybe<Scalars['String']>>
  dateOfBirth?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  usResident: Scalars['Boolean']
}

/** CreateUserProfileResult */
export type CreateUserProfileResult =
  | MissingAgreementsException
  | User
  | UserExistsException
  | UserNotUsResidentException

export type CreateVendorInvoiceInput = {
  chargeCustomerNotes?: InputMaybe<Scalars['String']>
  collectionMethod?: InputMaybe<CollectionMethod>
  creditCustomerNotes?: InputMaybe<Scalars['String']>
  currency: Currency
  netTerms?: InputMaybe<Scalars['Int']>
  netTermsType?: InputMaybe<NetTermsType>
  poNumber?: InputMaybe<Scalars['String']>
  termsAndConditions?: InputMaybe<Scalars['String']>
  vatReverseChargeNotes?: InputMaybe<Scalars['String']>
}

export type CreateVendorInvoiceResult = BillingVendorError | InvoiceCollection

export type CreateVendorLineItemInput = {
  accountingCode?: InputMaybe<Scalars['String']>
  avalaraServiceType?: InputMaybe<Scalars['Int']>
  avalaraTransactionType?: InputMaybe<Scalars['Int']>
  creditReasonCode?: InputMaybe<CreditReasonCode>
  currency: Currency
  customFields?: InputMaybe<Array<CustomFieldInput>>
  description?: InputMaybe<Scalars['String']>
  endDate?: InputMaybe<Scalars['DateTime']>
  itemCode?: InputMaybe<Scalars['String']>
  itemId?: InputMaybe<Scalars['String']>
  origin?: InputMaybe<Origin>
  productCode?: InputMaybe<Scalars['String']>
  quantity?: InputMaybe<Scalars['Int']>
  revenueScheduleType?: InputMaybe<RevenueScheduleType>
  startDate?: InputMaybe<Scalars['DateTime']>
  taxCode?: InputMaybe<Scalars['String']>
  taxExempt?: InputMaybe<Scalars['Boolean']>
  taxInclusive?: InputMaybe<Scalars['Boolean']>
  type: Type
  unitAmount: Scalars['Float']
}

export type CreateVendorLineItemResult = BillingVendorError | InvoiceLineItem

export type CreateWidgetRegistryEntryInput = {
  /** Widget category for grouping in the admin UI (e.g. onboarding, engagement). */
  category?: InputMaybe<Scalars['String']>
  /** Email of the admin making the change. Written to change_log.changed_by. */
  changedBy: Scalars['String']
  /** When true, show widget when required data is unavailable for rule evaluation. Default false (conservative). */
  degradeToVisible?: InputMaybe<Scalars['Boolean']>
  /** Optional description of the widget's purpose. */
  description?: InputMaybe<Scalars['String']>
  /** Base dismissal key. SCREEN scope prepends screen_context; ALL uses as-is. Null = proxy to legacy. */
  dismissalKey?: InputMaybe<Scalars['String']>
  /** Controls how the effective dismissal key is built at read time. Default SCREEN. */
  dismissalScope?: InputMaybe<ContentRulesWidgetDismissalScope>
  /** Human-readable name for the admin UI. */
  displayName: Scalars['String']
  /** Optional reason for the change. Written to change_log.reason. */
  reason?: InputMaybe<Scalars['String']>
  /** Owning team (e.g. enrichment, growth, engagement). */
  serviceTeam?: InputMaybe<Scalars['String']>
  /** Initial routing status. Defaults to LEGACY (safe — proxies to legacy service). */
  status?: InputMaybe<ContentRulesWidgetStatus>
  /** Unique widget type identifier (e.g. referral, earn, roundup_widget). */
  widgetType: Scalars['String']
}

export type CreateWidgetRegistryEntryResult = WidgetRegistryEntry

export type CreateWidgetRulesetInput = {
  /** Email of the admin making the change (from Okta). Written to change_log.changed_by. */
  changedBy: Scalars['String']
  /** Optional description of this ruleset's purpose. */
  description?: InputMaybe<Scalars['String']>
  /** Human-readable name for the admin UI. */
  displayName?: InputMaybe<Scalars['String']>
  /** Optional reason for the change. Written to change_log.reason. */
  reason?: InputMaybe<Scalars['String']>
  /** JSON rule tree for eligibility evaluation. Null means always eligible. */
  ruleTree?: InputMaybe<Scalars['JSON']>
  /**
   * Screen context this ruleset applies to. Use "ALL" to apply the rule tree across
   * every screen context this widget appears in (no screen-specific override needed).
   * A specific screen_context match takes priority over "ALL" at evaluation time.
   */
  screenContext: Scalars['String']
  /** Initial lifecycle status. Defaults to ACTIVE. */
  status?: InputMaybe<ContentRulesRulesetStatus>
  /** Widget type this ruleset applies to. */
  widgetType: Scalars['String']
}

export type CreateWidgetRulesetResult = RuleTreeValidationError | WidgetRuleset

export type CredentialExists = {
  __typename?: 'CredentialExists'
  /** Apps where credentials exist for this email */
  apps: Array<App>
}

export enum CredentialStatus {
  Invalid = 'INVALID',
  Pending = 'PENDING',
  Valid = 'VALID',
}

export type Credentials = {
  __typename?: 'Credentials'
  email: Scalars['EmailAddress']
  userId: Scalars['ID']
}

export type CredentialsDoNotExist = {
  __typename?: 'CredentialsDoNotExist'
  /** Whether the email domain has valid MX records */
  deliverable: Scalars['Boolean']
  /** Suggestion for corrected address if a typo was detected */
  suggestion: Maybe<Scalars['EmailAddress']>
}

/** Possible credentials types */
export enum CredentialsType {
  /** Acorns Early OIDC credentials */
  AcornsEarly = 'ACORNS_EARLY',
  /** Apple OIDC credentials */
  Apple = 'APPLE',
  /** Google OIDC credentials */
  Google = 'GOOGLE',
  /** Native email and password credentials */
  User = 'USER',
}

/** Credit information */
export type Credit = TimestampsInterface & {
  __typename?: 'Credit'
  amount: Scalars['Float']
  assessedAt: Maybe<Scalars['String']>
  billingCycle: BillingCycle
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  discountId: Scalars['ID']
  id: Scalars['ID']
  state: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export enum CreditReasonCode {
  General = 'general',
  Promotional = 'promotional',
  Service = 'service',
}

export type Cta = {
  __typename?: 'Cta'
  id: Scalars['ID']
  image: Maybe<Image>
  title: Maybe<Scalars['String']>
  type: CtaType
}

export enum CtaType {
  Action = 'action',
  Disclaimer = 'disclaimer',
  GrowArticle = 'grow_article',
  Link = 'link',
  ProtectLink = 'protect_link',
  Video = 'video',
}

/** System of money that is used in a particular country */
export enum Currency {
  /** United States Dollar */
  Usd = 'USD',
}

/** Standard format for all currency amounts */
export type CurrencyAmount = {
  __typename?: 'CurrencyAmount'
  /** Currency code of owning country. */
  currency: Currency
  /** Quantity of currency */
  value: Scalars['Float']
}

/** Input the amount to be transferred. */
export type CurrencyAmountInput = {
  /** Currency code of the country. */
  currency: Currency
  /** Quantity of currency */
  value: Scalars['Float']
}

export type CurrencyMilestoneProgress = {
  __typename?: 'CurrencyMilestoneProgress'
  /** the type of currency */
  currency: Currency
  /** the current value */
  currentAmount: Scalars['Float']
  /** the value needed for completion */
  targetAmount: Scalars['Float']
}

/** A bank statement showing ownership of the current funding source has not been provided */
export type CurrentBankStatementNotProvided = {
  __typename?: 'CurrentBankStatementNotProvided'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export type CustodianAccountNotFoundError = {
  __typename?: 'CustodianAccountNotFoundError'
  message: Scalars['String']
}

export type CustodianAccountSyncDetails = {
  __typename?: 'CustodianAccountSyncDetails'
  custodianName: Scalars['String']
  investmentAccountId: Scalars['ID']
  syncStatus: Scalars['String']
}

export type CustomFieldInput = {
  name?: InputMaybe<Scalars['String']>
  value?: InputMaybe<Scalars['String']>
}

export type CustomFieldOption = {
  __typename?: 'CustomFieldOption'
  default: Maybe<Scalars['Boolean']>
  id: Maybe<Scalars['ID']>
  label: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
  raw_name: Maybe<Scalars['String']>
  value: Maybe<Scalars['String']>
}

/** Account details of a customer account. This owns the customerAccount type and can be defined by id. */
export type CustomerAccount = {
  __typename?: 'CustomerAccount'
  /** The available balance of the account (current balance minus pending withdrawals). */
  availableBalance: Maybe<MicrosMoney>
  /**
   * The current balance of the account.
   * @deprecated Use `balanceMicros` instead.
   */
  balance: Maybe<CurrencyAmount>
  /** The current balance of the account. */
  balanceMicros: Maybe<MicrosMoney>
  /** Beneficiary as populated by user service. */
  beneficiary: Maybe<Beneficiary>
  /** Datetime the account was created. */
  createdAt: Scalars['DateTime']
  /** Get customer accounts by transfer action. */
  customerAccountsByTransferAction: Array<Maybe<CustomerAccount>>
  /** Account has either a customer action required or will have customer communication to show. */
  customerNotice: Scalars['Boolean']
  /** ID. */
  id: Scalars['ID']
  /** The FinancialInstitution associated with this account. Populated if the account was connected through Plaid or DBI, null for all other accounts. */
  institution: Maybe<FinancialInstitution>
  /**
   * Indicator if the account has deposit capability at this time.
   * @deprecated Deprecated
   */
  isDepositAllowed: Scalars['Boolean']
  /**
   * Indicator if the account has withdrawal capability at this time.
   * @deprecated Deprecated
   */
  isWithdrawalAllowed: Scalars['Boolean']
  /** The last 2-4 alphanumeric characters of an account's official account number. */
  mask: Maybe<Scalars['String']>
  /** Account name. */
  name: Scalars['String']
  /** User ID. */
  ownerId: Scalars['ID']
  /** ID used to reference the account in the owning domain. */
  referenceId: Scalars['ID']
  /** Account status. */
  status: CustomerAccountStatus
  /** Type of the account. */
  type: Scalars['String']
  /** Datetime the account was last updated. */
  updatedAt: Scalars['DateTime']
}

/** Account details of a customer account. This owns the customerAccount type and can be defined by id. */
export type CustomerAccountCustomerAccountsByTransferActionArgs = {
  transferAction: TransferAction
}

/** Customer Account Closure Record */
export type CustomerAccountClosure = {
  __typename?: 'CustomerAccountClosure'
  closedAt: Maybe<Scalars['DateTime']>
  closureState: CustomerAccountClosureState
  requestedAt: Scalars['DateTime']
  requestedBy: Scalars['String']
  /** User UUID */
  userId: Scalars['ID']
  workflowId: Scalars['String']
}

export enum CustomerAccountClosureState {
  Fulfilled = 'FULFILLED',
  Initiated = 'INITIATED',
}

export enum CustomerAccountStatus {
  /** Account is closed. */
  Closed = 'CLOSED',
  /** Account is open but locked for transfer. */
  Locked = 'LOCKED',
  /** Account is open. */
  Open = 'OPEN',
  /** Account has started the closure process. */
  PendingClosure = 'PENDING_CLOSURE',
  /** Account has started the opening process. */
  PendingOpen = 'PENDING_OPEN',
  /** Account has started the re-opening process. */
  PendingReopen = 'PENDING_REOPEN',
  /** Account is read-only. */
  ReadOnly = 'READ_ONLY',
}

/** Required acceptance documents for portfolio missing */
export type CustomerAgreementRequiredException = {
  __typename?: 'CustomerAgreementRequiredException'
  /** message */
  message: Maybe<Scalars['String']>
  /** message */
  requiredAcceptanceDocumentTypes: Array<Scalars['String']>
}

export type CustomerLifecyclePrediction = {
  __typename?: 'CustomerLifecyclePrediction'
  firstBillingDecile: Maybe<Scalars['Float']>
  hardChurnDecile: Maybe<Scalars['Float']>
  ltvDecile: Maybe<Scalars['Float']>
  softChurnDecile: Maybe<Scalars['Float']>
  upgradeDecile: Maybe<Scalars['Float']>
  userId: Maybe<Scalars['ID']>
}

export type CustomerLifecyclePredictionErrors = {
  __typename?: 'CustomerLifecyclePredictionErrors'
  error: Maybe<Scalars['String']>
  message: Maybe<Scalars['String']>
}

export type CustomerLifecyclePredictionResponse =
  | CustomerLifecyclePrediction
  | CustomerLifecyclePredictionErrors

/** A customer's match eligibility status for a specific investment account. */
export type CustomerMatchEligibility = {
  __typename?: 'CustomerMatchEligibility'
  /** When the eligibility expires. Null for perpetual eligibility. */
  eligibilityExpiresAt: Maybe<Scalars['Date']>
  /** When the customer's match eligibility began. */
  eligibilityStartDate: Scalars['Date']
  /** Whether this is a perpetual or temporary eligibility. */
  eligibilityType: MatchEligibilityType
  /** The percentage of eligible contributions that will be matched. */
  matchPercentage: Scalars['Float']
  /** Number of days until matched contributions vest. */
  vestingDays: Scalars['Int']
}

export type CustomerMoneyRulesResult =
  | CustomerMoneyRulesResultSuccess
  | MoneyRulesRulesetNotFoundException

export type CustomerMoneyRulesResultSuccess = {
  __typename?: 'CustomerMoneyRulesResultSuccess'
  resultingRuleset: MoneyRulesRuleset
}

export type CustomerSupportChatWidget = {
  __typename?: 'CustomerSupportChatWidget'
  chatRedirect: Maybe<ChatRedirect>
  emailRedirect: Maybe<EmailRedirect>
  phoneRedirect: Maybe<PhoneRedirect>
  sessionId: Scalars['ID']
}

export enum DayOfWeek {
  Fri = 'FRI',
  Mon = 'MON',
  Sat = 'SAT',
  Sun = 'SUN',
  Thu = 'THU',
  Tue = 'TUE',
  Wed = 'WED',
}

/** Response to a beneficiary ssn update */
export type DeactivateBeneficiaryResult =
  | Beneficiary
  | BeneficiaryNotFoundException
  | InternalErrorException

export type DeactivateOauthAppClientResult =
  | OauthAppClient
  | OauthAppClientNotFoundException

export type DeactivateOauthAppResult = OauthApp | OauthAppNotFoundException

export type DeactivateSecurityFailed = {
  __typename?: 'DeactivateSecurityFailed'
  description: Scalars['String']
}

export type DeactivateSecurityInput = {
  symbol: Scalars['TickerSymbol']
}

export type DeactivateSecurityResult = DeactivateSecurityFailed | Fund | Stock

export type DeactivateTierSubscriptionInput = {
  feedback?: InputMaybe<Scalars['String']>
  subscriptionDeactivationReason?: InputMaybe<TierSubscriptionDeactivationReason>
  userId?: InputMaybe<Scalars['ID']>
}

export type DeactivateTierSubscriptionResult =
  | TierSubscription
  | TierSubscriptionAlreadyDeactivated

export enum DealType {
  PartnerLink = 'PARTNER_LINK',
  SimplySpend = 'SIMPLY_SPEND',
  TapAndGet = 'TAP_AND_GET',
  UniquePricePoint = 'UNIQUE_PRICE_POINT',
  VerifiedReferral = 'VERIFIED_REFERRAL',
}

export type DeeplinkWidget = {
  __typename?: 'DeeplinkWidget'
  deeplinks: Array<ChatDeeplink>
}

export type DelegateDefinition = {
  __typename?: 'DelegateDefinition'
  departmentId: Scalars['ID']
  id: Scalars['ID']
  name: Scalars['String']
  ownerId: Scalars['ID']
  qualifiedHostName: Scalars['String']
}

export type DelegateDefinitionInput = {
  departmentId?: InputMaybe<Scalars['ID']>
  id?: InputMaybe<Scalars['ID']>
  name?: InputMaybe<Scalars['String']>
  ownerId?: InputMaybe<Scalars['ID']>
  qualifiedHostName?: InputMaybe<Scalars['String']>
}

export type DelegateFilterInput = {
  departmentId?: InputMaybe<Scalars['ID']>
  ownerId?: InputMaybe<Scalars['ID']>
}

export type DeleteChatSessionError = {
  __typename?: 'DeleteChatSessionError'
  id: Scalars['ID']
  message: Scalars['String']
}

export type DeleteDelegateResult = DeleteDelegateResultTemporaryImpl

export type DeleteDelegateResultTemporaryImpl = {
  __typename?: 'DeleteDelegateResultTemporaryImpl'
  someField: Scalars['String']
}

export type DeleteExpiredBankCardOrderCardTierNotFoundError = {
  __typename?: 'DeleteExpiredBankCardOrderCardTierNotFoundError'
  failureMessage: Scalars['String']
}

export type DeleteExpiredBankCardOrderNotExpiredError = {
  __typename?: 'DeleteExpiredBankCardOrderNotExpiredError'
  expiresAt: Scalars['DateTime']
}

export type DeleteExpiredBankCardOrderNotFoundError = {
  __typename?: 'DeleteExpiredBankCardOrderNotFoundError'
  userId: Scalars['ID']
}

export type DeleteExpiredBankCardOrderResult =
  | BankCardOrder
  | DeleteExpiredBankCardOrderCardTierNotFoundError
  | DeleteExpiredBankCardOrderNotExpiredError
  | DeleteExpiredBankCardOrderNotFoundError

export type DeleteOauthAppResult =
  | DeleteOauthAppSuccess
  | OauthAppNotFoundException

export type DeleteOauthAppSuccess = {
  __typename?: 'DeleteOauthAppSuccess'
  oauthAppId: Scalars['ID']
}

export type DeleteScopeSuccess = {
  __typename?: 'DeleteScopeSuccess'
  message: Scalars['String']
}

/** Response for deleting a trusted contact for a user */
export type DeleteTrustedContactResult =
  | InternalErrorException
  | TrustedContact
  | TrustedContactNotFoundException

export type DeleteWaiverCouponInput = {
  waiverType: Scalars['String']
}

export type DeleteWaiverCouponResult =
  | CouponNotFoundError
  | InvalidUserIdException
  | RedeemedWaiverCoupon
  | WaiverDeletionException

export type DepositAccountMismatchError = {
  __typename?: 'DepositAccountMismatchError'
  investmentAccountId: Scalars['ID']
  investmentUuid: Scalars['ID']
  message: Scalars['String']
}

export enum DepositField {
  AccountHolderName = 'accountHolderName',
  AccountNumber = 'accountNumber',
  AuxOnUs = 'auxOnUs',
  BackEndorsement = 'backEndorsement',
  BackImage = 'backImage',
  CheckDate = 'checkDate',
  CheckNumber = 'checkNumber',
  Codeline = 'codeline',
  CourtesyAmount = 'courtesyAmount',
  CustomerSuppliedAmount = 'customerSuppliedAmount',
  EncodedAmount = 'encodedAmount',
  Epc = 'epc',
  FractionCode = 'fractionCode',
  FrontImage = 'frontImage',
  FrontSignature = 'frontSignature',
  InstitutionName = 'institutionName',
  InstrumentType = 'instrumentType',
  LegalAmount = 'legalAmount',
  OnUs = 'onUs',
  PayeeName = 'payeeName',
  Routing = 'routing',
}

export type DepositNotSyncedError = {
  __typename?: 'DepositNotSyncedError'
  investmentUuid: Scalars['ID']
  message: Scalars['String']
}

/** Represents a risk that could prevent the deposit from completing */
export type DepositRiskFactor = {
  __typename?: 'DepositRiskFactor'
  /** Description of risk */
  description: Scalars['String']
  fields: Array<DepositField>
  /**
   * Risk Statuses:
   *     fixable: fixable = true
   *     confirmable: confirmable = true
   *     hard_reject: fixable = false, confirmable = false, severity level reject
   */
  status: RiskStatus
}

export type DeregisterAuthenticatorInput = {
  id: Scalars['ID']
}

export type DeregisterAuthenticatorResult =
  | AuthenticatorNotFoundException
  | EmailAuthenticator
  | PhoneAuthenticator

export type DesignLibraryIcon = {
  __typename?: 'DesignLibraryIcon'
  /** icon type corresponding to a Design Library icon */
  icon: IconType
}

export type DesignatedBeneficiary = {
  __typename?: 'DesignatedBeneficiary'
  address: DesignatedBeneficiaryAddress
  dateOfBirth: Scalars['String']
  designations: Array<Designation>
  email: Maybe<Scalars['EmailAddress']>
  firstName: Scalars['String']
  id: Scalars['ID']
  lastName: Scalars['String']
  maskedSsn: Scalars['String']
  phoneNumber: Scalars['PhoneNumber']
  relationship: DesignatedBeneficiaryRelationship
  userId: Scalars['ID']
}

export type DesignatedBeneficiaryAddress = {
  __typename?: 'DesignatedBeneficiaryAddress'
  city: Scalars['String']
  state: Scalars['String']
  street1: Scalars['String']
  street2: Maybe<Scalars['String']>
  zipCode: Scalars['String']
}

export type DesignatedBeneficiaryExistsException = {
  __typename?: 'DesignatedBeneficiaryExistsException'
  beneficiaryId: Scalars['ID']
  userId: Scalars['ID']
}

export type DesignatedBeneficiaryNotFoundException = {
  __typename?: 'DesignatedBeneficiaryNotFoundException'
  beneficiaryId: Scalars['ID']
  userId: Scalars['ID']
}

export enum DesignatedBeneficiaryRelationship {
  NonSpouse = 'NON_SPOUSE',
  Spouse = 'SPOUSE',
}

export type DesignatedBeneficiaryValidationException = {
  __typename?: 'DesignatedBeneficiaryValidationException'
  errors: Array<Scalars['String']>
  userId: Scalars['ID']
}

export type Designation = {
  __typename?: 'Designation'
  accountId: Scalars['ID']
  accountType: DesignationAccountType
  beneficiary: DesignatedBeneficiary
  designationType: DesignationType
  id: Scalars['ID']
  pctShare: Scalars['Int']
}

export enum DesignationAccountType {
  Checking = 'CHECKING',
  Emergency = 'EMERGENCY',
  Invest = 'INVEST',
  Later = 'LATER',
}

export type DesignationExistsException = {
  __typename?: 'DesignationExistsException'
  accountId: Scalars['ID']
  beneficiaryId: Scalars['ID']
  existingDesignationId: Scalars['ID']
  userId: Scalars['ID']
}

export type DesignationLimitReachedException = {
  __typename?: 'DesignationLimitReachedException'
  accountId: Scalars['ID']
  userId: Scalars['ID']
}

export type DesignationNotFoundException = {
  __typename?: 'DesignationNotFoundException'
  designationId: Scalars['ID']
  userId: Scalars['ID']
}

export enum DesignationType {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
}

export type DesignationValidationException = {
  __typename?: 'DesignationValidationException'
  accountId: Scalars['ID']
  errors: Array<Scalars['String']>
  userId: Scalars['ID']
}

export type Destination = {
  __typename?: 'Destination'
  /** deep link to milestone action destination */
  deepLink: Scalars['URL']
  /** key that maps to client-defined destination label */
  labelKey: Scalars['StringKey']
}

export type Device = {
  __typename?: 'Device'
  appVersion: Maybe<Scalars['String']>
  blockTrigger: Maybe<Scalars['String']>
  city: Maybe<Scalars['String']>
  country: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  deviceAdid: Maybe<Scalars['String']>
  firstLoginAt: Maybe<Scalars['DateTime']>
  hasActiveSession: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  isBlocked: Scalars['Boolean']
  lastAuthnIp: Maybe<Scalars['String']>
  lastChallengeType: Maybe<Scalars['String']>
  lastLoginAt: Maybe<Scalars['DateTime']>
  platform: Maybe<Scalars['String']>
  state: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  userAgent: Maybe<Scalars['String']>
  userId: Scalars['ID']
}

export type DeviceBlockedException = {
  __typename?: 'DeviceBlockedException'
  message: Maybe<Scalars['String']>
}

export type DeviceNotFoundException = {
  __typename?: 'DeviceNotFoundException'
  message: Maybe<Scalars['String']>
}

export enum DeviceType {
  Android = 'ANDROID',
  Ios = 'IOS',
}

export type DigitalWalletDevice = {
  __typename?: 'DigitalWalletDevice'
  deviceId: Scalars['String']
  deviceName: Scalars['String']
  deviceNumber: Scalars['String']
  deviceType: DigitalWalletDeviceType
}

export enum DigitalWalletDeviceType {
  Card = 'Card',
  FashionAccessory = 'FashionAccessory',
  HomeAppliance = 'HomeAppliance',
  KeyFob = 'KeyFob',
  MediaOrGamingDevice = 'MediaOrGamingDevice',
  MobileDevice = 'MobileDevice',
  MobileDeviceAccessory = 'MobileDeviceAccessory',
  MobilePhone = 'MobilePhone',
  PcOrLaptop = 'PCOrLaptop',
  Tablet = 'Tablet',
  UnknownOther = 'UnknownOther',
  Vehicle = 'Vehicle',
  Watch = 'Watch',
}

export type DigitalWalletToken = {
  __typename?: 'DigitalWalletToken'
  device: DigitalWalletDevice
  isDeviceProvisioned: Scalars['Boolean']
  tokenStatus: Scalars['String']
}

export enum DirectDepositDistribution {
  /** Amount of Paycheck */
  FixedAmount = 'FIXED_AMOUNT',
  /** Entire Paycheck */
  FullAmount = 'FULL_AMOUNT',
  /** Percentage of Paycheck */
  PercentageAmount = 'PERCENTAGE_AMOUNT',
}

/** Describes a user direct deposit info */
export type DirectDepositInfo = {
  __typename?: 'DirectDepositInfo'
  /** Direct Deposit Status */
  status: DirectDepositStatus
}

/** Direct Deposit Info */
export type DirectDepositInfoPayload = {
  __typename?: 'DirectDepositInfoPayload'
  /** Direct Deposit Info */
  info: Maybe<DirectDepositInfo>
}

/** Describes a user state for all its direct deposit switches. */
export type DirectDepositState = {
  __typename?: 'DirectDepositState'
  /** Creation Date */
  createdAt: Maybe<Scalars['DateTime']>
  /** Switch Method */
  switchMethod: SwitchMethod
  /** Switch State */
  switchState: SwitchState
  /** Last Updated Date */
  updatedAt: Maybe<Scalars['DateTime']>
}

/** Direct Deposit User State */
export type DirectDepositStatePayload = {
  __typename?: 'DirectDepositStatePayload'
  /** Direct Deposit State */
  state: Maybe<DirectDepositState>
}

export enum DirectDepositStatus {
  /** Downloaded pdf to personal device or got a success status back from Pinwheel */
  Attempted = 'Attempted',
  /** SplitDepositSettings Query returns a paycheck has landed */
  Completed = 'Completed',
  /** Has not set up DD */
  NoInteraction = 'NoInteraction',
  /** Has viewed the pdf or entered the pinwheel flow */
  Viewed = 'Viewed',
}

export enum DirectDepositVendor {
  Pinwheel = 'Pinwheel',
}

export type DisableMoneyManagerFailure = {
  __typename?: 'DisableMoneyManagerFailure'
  reason: Scalars['String']
}

export type DisableMoneyManagerRecurringFailure = {
  __typename?: 'DisableMoneyManagerRecurringFailure'
  reason: Scalars['String']
}

export type DisableMoneyManagerRecurringResult =
  | DisableMoneyManagerRecurringFailure
  | DisableMoneyManagerRecurringSuccess

export type DisableMoneyManagerRecurringSuccess = {
  __typename?: 'DisableMoneyManagerRecurringSuccess'
  settings: Maybe<MoneyManagerSettings>
}

export type DisableMoneyManagerResult =
  | DisableMoneyManagerFailure
  | DisableMoneyManagerSuccess

export type DisableMoneyManagerSuccess = {
  __typename?: 'DisableMoneyManagerSuccess'
  settings: Maybe<MoneyManagerSettings>
}

export type DiscreteMilestoneProgress = {
  __typename?: 'DiscreteMilestoneProgress'
  /** the current value */
  currentInt: Scalars['Int']
  /** the value needed for completion */
  targetInt: Scalars['Int']
}

export type DismissMessageInput = {
  messageId: Scalars['ID']
}

export type DismissMessagesInput = {
  messageIds: Array<Scalars['ID']>
}

export type DismissMessagesResult =
  | DismissMessagesSuccess
  | UpdateMessagesFailure

export type DismissMessagesSuccess = {
  __typename?: 'DismissMessagesSuccess'
  dismissedCount: Scalars['Int']
}

export type DisplayRule = {
  __typename?: 'DisplayRule'
  /** Inclusive upper bound of the client version range this rule applies to. Null means unbounded above. */
  maxVersion: Maybe<Scalars['String']>
  /** Inclusive lower bound of the client version range this rule applies to. Null means unbounded below. */
  minVersion: Maybe<Scalars['String']>
  /** Platform this rule applies to. */
  platform: Platform
}

export type DisplayRuleInput = {
  /** Inclusive upper bound of the client version range this rule applies to. Omit for unbounded above. */
  maxVersion?: InputMaybe<Scalars['String']>
  /** Inclusive lower bound of the client version range this rule applies to. Omit for unbounded below. */
  minVersion?: InputMaybe<Scalars['String']>
  /** Platform this rule applies to. */
  platform: Platform
}

export type DistributionAmounts = {
  __typename?: 'DistributionAmounts'
  investment: Scalars['String']
  retirement: Scalars['String']
  savings: Scalars['String']
}

export enum DistributionType {
  Balanced = 'BALANCED',
  LongTerm = 'LONG_TERM',
  LongWeighted = 'LONG_WEIGHTED',
  MediumTerm = 'MEDIUM_TERM',
  MediumWeighted = 'MEDIUM_WEIGHTED',
}

/** Discrete categorization information for diversification scores */
export type DiversificationBucket = {
  __typename?: 'DiversificationBucket'
  bucketName: DiversificationBucketType
  minDiversificationScoreThreshold: Scalars['Float']
}

export enum DiversificationBucketType {
  /** Excellent Diversification Bucket */
  Excellent = 'EXCELLENT',
  /** Fair Diversification Bucket */
  Fair = 'FAIR',
  /** Poor Diversification Bucket */
  Poor = 'POOR',
}

/** Diversification information for a given portfolio */
export type DiversificationInfo = {
  __typename?: 'DiversificationInfo'
  diversificationBuckets: Array<DiversificationBucket>
  securityDiversificationInfo: Array<SecurityDiversificationInfo>
}

/** Input to fetch portfolio diversification information for a provided customer's account */
export type DiversificationInfoByInvestmentAccountIdInput = {
  /** Investment account id of the desired customer's investment account, currently limited to managed account id */
  investmentAccountId: Scalars['ID']
  /** List of ticker symbols the caller wishes to know the diversification factors for */
  symbols: Array<Scalars['TickerSymbol']>
}

export type Dividend = {
  __typename?: 'Dividend'
  /** Dividend amount per share */
  amountPerShare: Maybe<Scalars['BigDecimal']>
  /** The Dividend Execution Date (Ex Date) */
  executionDate: Maybe<Scalars['Date']>
  /** Dividend payout frequency */
  frequency: DividendFrequency
  /** Dividend Payment Date */
  payableDate: Maybe<Scalars['Date']>
  /** Dividend Record Date */
  recordDate: Maybe<Scalars['Date']>
  symbol: Scalars['TickerSymbol']
}

export enum DividendFrequency {
  Annually = 'ANNUALLY',
  Irregularly = 'IRREGULARLY',
  Monthly = 'MONTHLY',
  OtherRegular = 'OTHER_REGULAR',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY',
  Unspecified = 'UNSPECIFIED',
}

export type DividendsBySymbolInput = {
  /** Filter to select dividends with executionDate before or on the executionEndDate */
  executionEndDate?: InputMaybe<Scalars['Date']>
  /** Filter to select dividends with executionDate on or after the executionStartDate */
  executionStartDate?: InputMaybe<Scalars['Date']>
  symbol: Scalars['TickerSymbol']
}

export type Document = {
  __typename?: 'Document'
  uploadedAt: Scalars['DateTime']
  url: Scalars['URL']
}

export type DocumentInput = {
  uploadedAt: Scalars['DateTime']
  url: Scalars['URL']
}

/** No document for the given document_type and version */
export type DocumentNotFound = {
  __typename?: 'DocumentNotFound'
  /** The type of document to sign */
  documentType: AcceptanceDocumentType
  /** The version of the document to sign */
  documentVersion: Scalars['String']
}

export enum DocumentQueryType {
  Address = 'address',
  All = 'all',
  BeneficiarySsn = 'beneficiarySsn',
  BulkSuspendCsv = 'bulkSuspendCsv',
  CurrentBankStatement = 'currentBankStatement',
  EarlyQuarantinePromotion = 'earlyQuarantinePromotion',
  FutureBankStatement = 'futureBankStatement',
  Id = 'id',
  MilitaryId = 'militaryId',
  Miscellaneous = 'miscellaneous',
  PaypalFundingSource = 'paypalFundingSource',
  SpendAddress = 'spendAddress',
  SpendFundingSource = 'spendFundingSource',
  SpendId = 'spendId',
  Ssn = 'ssn',
  TraditionalFundingSource = 'traditionalFundingSource',
  W9 = 'w9',
}

export type DocumentRequest = {
  __typename?: 'DocumentRequest'
  acceptedAt: Maybe<Scalars['DateTime']>
  canceledAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  documentType: DocumentType
  documents: Maybe<Array<Document>>
  externalId: Maybe<Scalars['ID']>
  id: Scalars['ID']
  namespace: Maybe<Scalars['String']>
  parentRequest: Maybe<DocumentRequest>
  parentRequestId: Maybe<Scalars['ID']>
  postUploadProcessing: Maybe<PostUploadProcessing>
  rejectedAt: Maybe<Scalars['DateTime']>
  rejectedNote: Maybe<Scalars['String']>
  rejectedReason: Maybe<RejectedReason>
  requestKey: Maybe<Scalars['String']>
  requestedFileCount: Maybe<Scalars['Int']>
  requesterId: Maybe<Scalars['ID']>
  reviewerId: Maybe<Scalars['String']>
  sourceOperationId: Maybe<Scalars['String']>
  status: DocumentStatus
  userId: Scalars['ID']
}

export type DocumentRequestEdge = {
  __typename?: 'DocumentRequestEdge'
  node: Maybe<DocumentRequest>
}

export type DocumentRequestInput = {
  documentRequestId: Scalars['ID']
}

export type DocumentRequestsConnection = {
  __typename?: 'DocumentRequestsConnection'
  edges: Maybe<Array<DocumentRequestEdge>>
  pageInfo: DocumentRequestsPageInfo
}

export type DocumentRequestsInput = {
  namespace?: InputMaybe<Scalars['String']>
  pageInput?: InputMaybe<DocumentRequestsPageInput>
  sourceOperationId?: InputMaybe<Scalars['String']>
  status?: InputMaybe<DocumentStatus>
  type: DocumentQueryType
  /** Deprecated: use `status` field */
  uploaded?: InputMaybe<Scalars['Boolean']>
}

export type DocumentRequestsPageInfo = {
  __typename?: 'DocumentRequestsPageInfo'
  cursor: Maybe<Scalars['String']>
  hasNext: Scalars['Boolean']
}

export type DocumentRequestsPageInput = {
  ascending?: InputMaybe<Scalars['Boolean']>
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
}

export enum DocumentStatus {
  Accepted = 'accepted',
  AwaitingPostUploadProcessing = 'awaitingPostUploadProcessing',
  Canceled = 'canceled',
  Rejected = 'rejected',
  Requested = 'requested',
  Uploaded = 'uploaded',
}

export enum DocumentType {
  Address = 'address',
  BeneficiarySsn = 'beneficiarySsn',
  BulkSuspendCsv = 'bulkSuspendCsv',
  CurrentBankStatement = 'currentBankStatement',
  EarlyQuarantinePromotion = 'earlyQuarantinePromotion',
  FutureBankStatement = 'futureBankStatement',
  Id = 'id',
  MilitaryId = 'militaryId',
  Miscellaneous = 'miscellaneous',
  PaypalFundingSource = 'paypalFundingSource',
  SpendAddress = 'spendAddress',
  SpendFundingSource = 'spendFundingSource',
  SpendId = 'spendId',
  Ssn = 'ssn',
  TraditionalFundingSource = 'traditionalFundingSource',
  W9 = 'w9',
}

export type DocumentUploadSession = {
  __typename?: 'DocumentUploadSession'
  /** Token used as identifier for document upload session */
  token: Scalars['String']
}

/** Uploads from backend */
export type DocumentUploads = {
  __typename?: 'DocumentUploads'
  uploadDocuments: Array<LegacyUploadDocument>
}

export type DocumentVerification = {
  __typename?: 'DocumentVerification'
  /** Result of verifying uploaded documents */
  decision: DocumentVerificationDecision
  /** Error descriptors based on reason codes triggered */
  outstandingIssues: Maybe<Array<Scalars['String']>>
  /** Flag indicating if the customer’s identity was marked as verified during document review */
  verificationCriteriaMet: Scalars['Boolean']
}

export enum DocumentVerificationDecision {
  /** Documents were verified and accepted */
  Accepted = 'ACCEPTED',
  /** Documents were declined due to various reason codes */
  Rejected = 'REJECTED',
  /** The information submitted was incomplete or missing */
  ResubmissionRequired = 'RESUBMISSION_REQUIRED',
  /** Manual review is necessary */
  ReviewRequired = 'REVIEW_REQUIRED',
}

export type DocumentWidget = {
  __typename?: 'DocumentWidget'
  documents: Array<ChatDocument>
}

export type DuplicateActionError = {
  __typename?: 'DuplicateActionError'
  requestId: Scalars['ID']
}

export type DuplicateBillingInfoError = {
  __typename?: 'DuplicateBillingInfoError'
  message: Scalars['String']
}

export type DuplicatePromoCodeError = {
  __typename?: 'DuplicatePromoCodeError'
  name: Scalars['String']
}

export type DuplicatePromoCodeRewardError = {
  __typename?: 'DuplicatePromoCodeRewardError'
  /** @deprecated Use amountMicros. */
  amount: Scalars['Float']
  amountMicros: MicrosMoney
  type: PromoCodeRewardType
}

/** DEPRECATED - Use Security type instead */
export type Etf = {
  __typename?: 'ETF'
  /** Indicates the amount of every dollar that will go towards buying a share of the ETF */
  amount: Maybe<Scalars['Int']>
  /** ETF high price over trailing 12 month period */
  annualHigh: Maybe<Scalars['Float']>
  /** ETF low price over trailing 12 month period */
  annualLow: Maybe<Scalars['Float']>
  /** Indicates the current per/share price */
  currentPrice: Maybe<Scalars['Float']>
  /** The Acorns-designated display name of the ETF */
  displayName: Scalars['String']
  /** Indicates the individual stocks that make up the ETF */
  holdings: Maybe<Array<Holding>>
  /** Indicates the investment category for the ETF */
  investmentCategories: InvestmentCategory
  /** Indicates the last market day's close per/share price */
  lastClosePrice: Maybe<Scalars['Float']>
  /** The Acorns-designated name of the ETF */
  name: Scalars['String']
  /** Indicates the total worth of the ETF as a whole */
  netAssets: Maybe<Scalars['String']>
  /** Indicates the day's open per/share price */
  openPrice: Maybe<Scalars['Float']>
  /**
   * Indicates the number of shares the user owns
   * @deprecated Use Portfolio.portfolioSecurities instead.
   */
  ownedShares: Maybe<Scalars['Float']>
  /** Indicates the percent of every dollar that will go towards buying a share of the ETF */
  percent: Maybe<Scalars['Float']>
  /** Get price values of the ETF over a time range */
  performance: EtfPerformance
  /** Indicates the position of the ETF */
  position: Maybe<Scalars['Int']>
  /** Indicates the per/share price range over the current week */
  priceRangeOverWeek: Maybe<Scalars['String']>
  /** Indicates whether or not the ETF can be removed from a managed Portfolio by direction of an account holder. */
  removable: Maybe<Scalars['Boolean']>
  /** The market exchange symbol of the ETF */
  symbol: Scalars['String']
  /** Indicates the total number of shares in the market */
  volume: Maybe<Scalars['Int']>
  /** Indicates the year-to-date return of the ETF */
  ytdReturn: Maybe<Scalars['Float']>
  /** Indicates the year-to-date return percentage of the ETF */
  ytdReturnPercentage: Maybe<Scalars['Float']>
}

/** DEPRECATED - Use Security type instead */
export type EtfPerformanceArgs = {
  points?: InputMaybe<Scalars['Int']>
  timescale: EtfTimescale
  timespan: Scalars['Int']
}

/** Amount and Percentage of ETF Gain */
export type EtfGain = {
  __typename?: 'ETFGain'
  amount: Scalars['Float']
  percentage: Scalars['Float']
}

/** Gain and Prices of ETF */
export type EtfPerformance = {
  __typename?: 'ETFPerformance'
  gain: Maybe<EtfGain>
  prices: Maybe<Array<EtfPrice>>
}

/** Price of ETF */
export type EtfPrice = {
  __typename?: 'ETFPrice'
  amount: Scalars['Float']
  timestamp: Scalars['DateTime']
}

export enum EtfTimescale {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year',
}

/** State Laws Regarding UGMA/UTMA account types and termination ages */
export type EarlyAccountStateRegulation = {
  __typename?: 'EarlyAccountStateRegulation'
  /** Whether UGMA/UTMA account is offered in the given state */
  accountType: EarlyInvestmentAccountType
  /**
   * When present, the custodian must choose one of these exact termination ages (not a range).
   * Prefer this over minAge/maxAge for display and validation when non-null.
   */
  ages: Maybe<Array<Scalars['Int']>>
  /** Default age of termination for the given state */
  defaultAge: Scalars['Int']
  /** Maximum age of termination for the given state */
  maxAge: Maybe<Scalars['Int']>
  /** Minimum age of termination for the given state */
  minAge: Maybe<Scalars['Int']>
  /** Full State/Territory name */
  state: Scalars['String']
  /** State/Territory abbreviation */
  stateCode: Scalars['String']
}

/** Result for Early Account state regulations */
export type EarlyAccountStateRegulationResult =
  | EarlyAccountStateRegulation
  | InternalErrorException
  | InvalidStateException
  | UserNotFoundException

/** DEPRECATED - Use InvestmentAccountTransferability instead */
export type EarlyAccountTransferInfo = {
  __typename?: 'EarlyAccountTransferInfo'
  /** The beneficiary investment account's state of residence */
  stateCode: Scalars['String']
  /** The beneficiary investment account's age of transfer */
  terminationAge: Scalars['Int']
  /** The beneficiary investment account's date of transfer */
  terminationDate: Scalars['Date']
}

/** Sell shares to pay down cash owed by the customer. */
export type EarlyDebtCollectionItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'EarlyDebtCollectionItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type EarlyDividendsItem = PastCoreTradedItem &
  PastEarlyItem &
  PastItem & {
    __typename?: 'EarlyDividendsItem'
    amount: CurrencyAmount
    beneficiaryAccountId: Scalars['String']
    beneficiaryId: Scalars['String']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    etfCategory: Scalars['String']
    etfTicker: Scalars['String']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Sell shares for the fee. */
export type EarlyFeeInvestmentItem = PastCoreTradedItem &
  PastEarlyItem &
  PastItem & {
    __typename?: 'EarlyFeeInvestmentItem'
    amount: CurrencyAmount
    beneficiaryAccountId: Scalars['String']
    beneficiaryId: Scalars['String']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A gift investment line item for the Early account */
export type EarlyGiftItem = PastAnnotatedItem &
  PastCoreTradedItem &
  PastEarlyItem &
  PastItem & {
    __typename?: 'EarlyGiftItem'
    amount: CurrencyAmount
    beneficiaryAccountId: Scalars['String']
    beneficiaryId: Scalars['String']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** Annotation on the item */
    note: Maybe<Scalars['String']>
    /** Author of the note */
    noteAuthor: Maybe<Scalars['String']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type EarlyHistorySummary = PastSummary & {
  __typename?: 'EarlyHistorySummary'
  dividends: CurrencyAmount
  earlyInvestMatches: CurrencyAmount
  giftsReceived: CurrencyAmount
  moneyIn: CurrencyAmount
  moneyOut: CurrencyAmount
}

export enum EarlyInvestmentAccountType {
  /** Uniform Gift to Minors Act Custodial Investment Account */
  Ugma = 'UGMA',
  /** Uniform Transfer to Minors Act Custodial Investment Account */
  Utma = 'UTMA',
}

/** A generic money movement line item for the Early account */
export type EarlyInvestmentItem = PastCoreTradedItem &
  PastEarlyItem &
  PastItem &
  PastUserTransferItem & {
    __typename?: 'EarlyInvestmentItem'
    amount: Maybe<CurrencyAmount>
    beneficiaryAccountId: Scalars['String']
    beneficiaryId: Scalars['String']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A matching investment made into a customers account by the firm. */
export type EarlyMatchItem = PastCoreTradedItem &
  PastEarlyItem &
  PastItem & {
    __typename?: 'EarlyMatchItem'
    amount: CurrencyAmount
    beneficiaryAccountId: Scalars['String']
    beneficiaryId: Scalars['String']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A removal of matching investments made into a customers account by the firm. */
export type EarlyMatchRemovalItem = PastCoreTradedItem &
  PastEarlyItem &
  PastItem & {
    __typename?: 'EarlyMatchRemovalItem'
    amount: CurrencyAmount
    beneficiaryAccountId: Scalars['String']
    beneficiaryId: Scalars['String']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Cash that is reinvested into the investment account */
export type EarlyRefundedItem = PastCoreTradedItem &
  PastEarlyItem &
  PastItem & {
    __typename?: 'EarlyRefundedItem'
    amount: CurrencyAmount
    beneficiaryAccountId: Scalars['String']
    beneficiaryId: Scalars['String']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Cash that is reinvested into the investment account */
export type EarlyReinvestmentItem = PastCoreTradedItem &
  PastEarlyItem &
  PastItem & {
    __typename?: 'EarlyReinvestmentItem'
    amount: CurrencyAmount
    beneficiaryAccountId: Scalars['String']
    beneficiaryId: Scalars['String']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type EarlyWithdrawalItem = PastCoreTradedItem &
  PastEarlyItem &
  PastItem &
  PastUserTransferItem & {
    __typename?: 'EarlyWithdrawalItem'
    amount: CurrencyAmount
    beneficiaryAccountId: Scalars['String']
    beneficiaryId: Scalars['String']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type EarnCtaRecord = {
  __typename?: 'EarnCTARecord'
  ctaDates: Maybe<Array<Maybe<Scalars['Date']>>>
  devicePlatform: Maybe<Scalars['String']>
  partnerName: Maybe<Scalars['String']>
  userId: Scalars['ID']
}

export type EarnOffer = {
  __typename?: 'EarnOffer'
  /** The list of applicable categories for affiliates */
  affiliateCategoryList: Maybe<Array<Scalars['String']>>
  /** Whether affiliateCategoryList is inclusionary or exclusionary */
  affiliateCategoryType: Maybe<Scalars['String']>
  /** For use with colorBackgroundLogoImageUrl */
  backgroundColorHex: Scalars['String']
  /** Non-logo background image */
  backgroundImageUrl: Scalars['URL']
  /** Offer's Badge Category */
  badgeCategory: Maybe<BadgeCategory>
  /** Long description of what is needed to qualify for offer */
  campaignDescription: Scalars['String']
  /** ID associated with the Campaign */
  campaignId: Scalars['ID']
  campaignOfferId: Scalars['ID']
  /** Transparent logo used with backgroundColorHex overlaid on background */
  colorBackgroundLogoImageUrl: Scalars['URL']
  /** @deprecated Use colorBackgroundLogoImageUrl instead */
  colorImageUrl: Scalars['URL']
  ctaDetails: EarnOfferCtaDetails
  /** Offer's Deal Type */
  dealType: Maybe<DealType>
  /** Desktop Background/featured image url */
  desktopBackgroundImageUrl: Maybe<Scalars['URL']>
  /** Offer Details Information */
  details: Array<Scalars['String']>
  /** List of device platforms the campaign offer is eligible for */
  devicePlatforms: Array<Scalars['String']>
  /** The main campaign text used image overlay text */
  displayBody: Maybe<Scalars['String']>
  /** The ending date of a campaign */
  displayEndDate: Maybe<Scalars['String']>
  /** The main campaign name used on tiles and on details */
  displayName: Scalars['String']
  /** The starting date of a campaign */
  displayStartDate: Maybe<Scalars['String']>
  /** Summary of qualification, e.g. "For new customers only" */
  displaySubtitle: Maybe<Scalars['String']>
  /** Display Title for the amount invested, e.g. "Earn 2%" or "Earn $10" */
  displayTitle: Scalars['String']
  /** Offer Exclusion Information */
  exclusions: Array<Scalars['String']>
  /** Denotes the favorite order rank by most recently added */
  favoriteRank: Scalars['Int']
  /** Used for the banner on the categories page */
  featuredCategoryOffer: Scalars['Boolean']
  /** Used for the banner on the categories page */
  featuredCategoryOfferRank: Scalars['Int']
  /** The amount for the reward */
  incentiveAmount: Maybe<Scalars['Float']>
  /** The reward amount rate */
  incentiveRate: Maybe<EarnOfferIncentiveRate>
  /** Amount invested, e.g. "2%" or "$10" */
  incentiveSummary: Scalars['String']
  /** The reward amount structure */
  incentiveType: Maybe<EarnOfferIncentiveType>
  /** Denotes a favorite offer for the current user */
  isFavorite: Scalars['Boolean']
  /** Offer's Keyphrase Categories Names */
  keyphraseCategoryNames: Maybe<Array<Scalars['String']>>
  /** External merchantId associated with owner */
  merchantId: Maybe<Scalars['String']>
  /** Description of the brand */
  ownerDescription: Scalars['String']
  /** ID associated with the Owner */
  ownerId: Scalars['ID']
  /** The name of the Owner */
  ownerName: Scalars['String']
  /** Used for the banner on web */
  promoted: Scalars['Boolean']
  /** Used for the banner on web */
  promotionRank: Scalars['Int']
  /** Identifying slug on the owner level */
  slug: Scalars['String']
  termsAndConditionsUrl: Scalars['String']
  /** The ending time for a campaign */
  visibilityEndTime: Maybe<Scalars['String']>
  /** The starting time for a campaign */
  visibilityStartTime: Maybe<Scalars['String']>
  /** Manages how we launch offers on mobile */
  webviewEnabled: Scalars['Boolean']
}

export type EarnOfferCtaDetails = {
  __typename?: 'EarnOfferCtaDetails'
  android: Maybe<Scalars['String']>
  buttonUrl: Maybe<Scalars['String']>
  chromeExt: Maybe<Scalars['String']>
  email: Maybe<Scalars['String']>
  internallyRouted: Scalars['Boolean']
  ios: Maybe<Scalars['String']>
  notificationTitle: Scalars['String']
  notificationUrl: Scalars['URL']
  repeatTitle: Scalars['String']
  title: Scalars['String']
  type: Scalars['String']
  userMetadata: Maybe<Scalars['String']>
  web: Maybe<Scalars['String']>
}

export enum EarnOfferIncentiveRate {
  Dynamic = 'DYNAMIC',
  Flat = 'FLAT',
}

export enum EarnOfferIncentiveTemplate {
  V1 = 'V1',
}

export enum EarnOfferIncentiveType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE',
}

export type EarnOfferQueryPage = {
  __typename?: 'EarnOfferQueryPage'
  earnOffers: Array<EarnOffer>
  pageInfo: EarnPageInfo
}

export type EarnPageInfo = {
  __typename?: 'EarnPageInfo'
  /** This value is passed back as the 'cursor' parameter to continue pagination. An empty string indicates there are no more pages to fetch. */
  endCursor: Scalars['String']
}

export type EarnReward = {
  __typename?: 'EarnReward'
  /** @deprecated Monetary values have been migrated to new standard `MicrosMoney`. Use `amountV2`. */
  amount: MonetaryAmount
  amountV2: MicrosMoney
  colorBackgroundLogoImageUrl: Scalars['URL']
  displayName: Scalars['String']
  expectedFulfilledAt: Maybe<Scalars['Date']>
  fulfilledAt: Maybe<Scalars['Date']>
  /** @deprecated Use whether `expectedFulfilledAt` is set for pending rewards */
  fulfillmentType: EarnRewardFulfillmentType
  id: Scalars['ID']
  incentiveAmount: Maybe<Scalars['Float']>
  investmentId: Maybe<Scalars['ID']>
  linked: Maybe<Array<EarnReward>>
  /** The purchase or event date associated with the reward */
  originationDate: Scalars['Date']
  status: Maybe<EarnRewardStatus>
  type: EarnRewardType
}

export enum EarnRewardFulfillmentType {
  Standard = 'STANDARD',
  Travel = 'TRAVEL',
}

export enum EarnRewardInvestType {
  AcornsReward = 'ACORNS_REWARD',
  EarnReward = 'EARN_REWARD',
  EarnRewardMatch = 'EARN_REWARD_MATCH',
  EarnRoundUpMatch = 'EARN_ROUND_UP_MATCH',
  EmployeeContribution = 'EMPLOYEE_CONTRIBUTION',
  Referral = 'REFERRAL',
  StreakReward = 'STREAK_REWARD',
  TipsThatGrowMatch = 'TIPS_THAT_GROW_MATCH',
}

export enum EarnRewardPurchaseMethod {
  Android = 'ANDROID',
  ChromeExtension = 'CHROME_EXTENSION',
  EarnRewardEmail = 'EARN_REWARD_EMAIL',
  InStore = 'IN_STORE',
  Iphone = 'IPHONE',
  MicrosoftEdgeExtension = 'MICROSOFT_EDGE_EXTENSION',
  SafariExtension = 'SAFARI_EXTENSION',
  WebApp = 'WEB_APP',
}

export enum EarnRewardStatus {
  Fulfilled = 'FULFILLED',
  Pending = 'PENDING',
}

export enum EarnRewardType {
  AcornsReward = 'ACORNS_REWARD',
  EmployeeBenefit = 'EMPLOYEE_BENEFIT',
  Referral = 'REFERRAL',
  Reward = 'REWARD',
  RewardMatch = 'REWARD_MATCH',
  RoundupMatch = 'ROUNDUP_MATCH',
  StreakReward = 'STREAK_REWARD',
  TipsThatGrowMatch = 'TIPS_THAT_GROW_MATCH',
}

export type Ecbsv = {
  __typename?: 'Ecbsv'
  /** Flag indicating whether eCBSV can be used or not for verification */
  consent: Scalars['Boolean']
  /** UTC timestamp when customer provided eCBSV response */
  providedAt: Maybe<Scalars['DateTime']>
}

export type EducationTip = {
  __typename?: 'EducationTip'
  /** key that maps to client-defined education tip details */
  detailsKey: Scalars['StringKey']
  /** key that maps to client-defined education tip summary */
  summaryKey: Scalars['StringKey']
}

export type Eligibility = {
  __typename?: 'Eligibility'
  eligible: Scalars['Boolean']
}

export enum EligibilityScope {
  FundSpendInActivation = 'fundSpendInActivation',
  Mrdc = 'mrdc',
  RoundUps = 'roundUps',
  SendCheck = 'sendCheck',
  Spend = 'spend',
  SpendRecurringTransfers = 'spendRecurringTransfers',
}

export type EmailAddressValidation = {
  __typename?: 'EmailAddressValidation'
  /** Wether or not credentials are associated with the address or not. */
  credentialsExist: Scalars['Boolean']
  /** Soft check indicating wether or not a DNS MX record exists for the address domain (does not validate that an email can actually be delivered to the email server). */
  deliverable: Scalars['Boolean']
  /** The email that is being validated */
  email: Scalars['EmailAddress']
  /** Indicates if the email credential is enabled for use. */
  nativeCredentialsEnabled: Maybe<Scalars['Boolean']>
  /** Indicates if the email is associated with an OIDC provider. */
  oidcAssociated: Maybe<Scalars['Boolean']>
  /** List of OIDC providers the email is associated with. */
  oidcProviders: Maybe<Array<Maybe<OidcProvider>>>
  /** Indicates wether the address may have common spelling mistakes. */
  possibleTypo: Scalars['Boolean']
  /** Suggestion for corrected address if there was a typo detected. */
  suggestion: Maybe<Scalars['EmailAddress']>
}

export type EmailAddressValidationResult =
  | CredentialExists
  | CredentialsDoNotExist
  | OidcOnlyCredentials

export type EmailAuthChallenge = AuthChallenge & {
  __typename?: 'EmailAuthChallenge'
  alternateAuthenticators: Array<AuthenticatorInfo>
  challengeTrigger: ChallengeTriggers
  completedAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  maskedEmail: Scalars['String']
  sessionId: Maybe<Scalars['ID']>
  updatedAt: Scalars['DateTime']
}

export type EmailAuthenticator = Authenticator & {
  __typename?: 'EmailAuthenticator'
  createdAt: Scalars['DateTime']
  deviceId: Scalars['ID']
  email: Scalars['EmailAddress']
  id: Scalars['ID']
  lastAuthenticatedAt: Maybe<Scalars['DateTime']>
  lastUsedAt: Maybe<Scalars['DateTime']>
  name: Scalars['String']
  type: AuthType
  updatedAt: Scalars['DateTime']
}

export type EmailRedirect = {
  __typename?: 'EmailRedirect'
  title: Scalars['String']
}

export type EmailTakenException = {
  __typename?: 'EmailTakenException'
  message: Maybe<Scalars['String']>
}

export type EmergencyFundHistorySummary = PastSummary & {
  __typename?: 'EmergencyFundHistorySummary'
  interestEarned: Maybe<CurrencyAmount>
  moneyIn: CurrencyAmount
  moneyOut: CurrencyAmount
}

export enum Employees {
  /** User has full or part time employees under their company */
  FullOrPart = 'fullOrPart',
  /** User has no employees under their company */
  None = 'none',
}

/** Employer */
export type Employer = {
  __typename?: 'Employer'
  /**
   * Clickswitch Target ID
   * @deprecated Use SwitchInterface.vendorTargetId instead
   */
  clickSwitchTargetId: Maybe<Scalars['ID']>
  /** DUNS Name */
  dunsName: Maybe<Scalars['String']>
  /** Duns Number */
  dunsNumber: Maybe<Scalars['ID']>
  /** Employer Name */
  employerName: Scalars['String']
  /** Employer ID */
  id: Scalars['ID']
  /** Employer Logo URL */
  logoUrl: Maybe<Scalars['String']>
  /** Switch Type specific information. */
  switch: AbstractSwitch
  /** Switch Type */
  switchType: SwitchType
  /**
   * Employer URL
   * @deprecated Use OnlineSwitch.url instead
   */
  url: Maybe<Scalars['String']>
}

export type EmploymentInput = {
  employer?: InputMaybe<Scalars['String']>
  occupation?: InputMaybe<Scalars['String']>
  suitability?: InputMaybe<Array<InputMaybe<SuitabilityInput>>>
}

export enum EmploymentStatus {
  /** User is a full time employee or contractor */
  FullTime = 'fullTime',
  /** User is a part time employee or contractor */
  PartTime = 'partTime',
  /** User is retired and does not work */
  Retired = 'retired',
  /** User owns their own business or is self employed */
  SelfEmployed = 'selfEmployed',
  /** User is enrolled full time in school */
  Student = 'student',
  /** User currently is not employed */
  Unemployed = 'unemployed',
}

/** Configuration for investment account quarterly recaps. */
export type EnableQuarterlyRecapsInput = {
  /** Wether or not to enable quarterly recaps. */
  enabled: Scalars['Boolean']
  /** The unique identifier of the investment account for which to configure quarterly recaps. */
  investmentAccountId: Scalars['ID']
}

/** Result of configuring investment account recaps. */
export type EnableQuarterlyRecapsResult =
  | InvalidSubscriptionTierException
  | InvestmentAccount
  | InvestmentAccountNotFoundException
  | InvestmentAccountNotSupportedException

export type EnrollInStreaksInput = {
  configId: Scalars['String']
}

export type EnrollInStreaksResult = Streak | StreakConfigNotFoundError

export type EstimatedCheckPaymentDates = {
  __typename?: 'EstimatedCheckPaymentDates'
  estimatedArrivalAt: Scalars['DateTime']
  estimatedShippingAt: Scalars['DateTime']
  estimatedTransferAtText: Scalars['String']
}

/** Input to get estimated dates for a transfer */
export type EstimatedTransferDatesInput = {
  /** Amount of the transfer which will be created. */
  amount?: InputMaybe<CurrencyAmountInput>
  /** Type of account to move money from */
  fromAccountType: TransferableAccountTypeEnum
  /** Type of account to move money into */
  toAccountType: TransferableAccountTypeEnum
  /** UTC datetime when the transfer was/will be created. If omitted, the current datetime will be used */
  transferCreatedAt?: InputMaybe<Scalars['DateTime']>
}

/** Estimated dates for a transfer */
export type EstimatedTransferDatesPayload = {
  __typename?: 'EstimatedTransferDatesPayload'
  /** Estimated UTC datetime when the transfer will be completed by */
  estimatedTransferCompletedAt: Scalars['DateTime']
}

/** Evaluates check deposit session to determine if it is submittable. */
export type EvaluateCheckDepositInput = {
  amount: CurrencyAmountInput
  /** The session to evaluate. */
  sessionToken: Scalars['String']
}

/** Evaluates if a check can be submitted. */
export type EvaluateCheckDepositPayload = {
  __typename?: 'EvaluateCheckDepositPayload'
  /** Recognized amount from check image. */
  ocrAmount: CurrencyAmount
  riskFactors: Array<DepositRiskFactor>
}

export type EvaluatedField = {
  __typename?: 'EvaluatedField'
  fieldPath: Scalars['String']
  resolvedValue: Maybe<Scalars['JSON']>
  unmapped: Scalars['Boolean']
  wasAbsent: Scalars['Boolean']
}

export type ExchangeAcornsEarlyTokenResult =
  | AcornsEarlyUserDetails
  | InvalidAcornsEarlyTokenException

export type ExecuteMoneyInError = {
  __typename?: 'ExecuteMoneyInError'
  message: Scalars['String']
}

export type ExecuteMoneyInInput = {
  moneyInEvent: MoneyInEventInput
}

export type ExecuteMoneyInResult = ExecuteMoneyInError | ExecuteMoneyInSuccess

export type ExecuteMoneyInSuccess = {
  __typename?: 'ExecuteMoneyInSuccess'
  workflowId: Scalars['ID']
}

/** Mirrors the MoneyManagerRebalanceResult type */
export type ExecuteMoneyManagerRebalancesInput = {
  allocations: Array<MoneyManagerRebalanceAllocationInput>
  ruleset: MoneyManagerRebalanceRulesetInput
  sourceAccountId: Scalars['ID']
  sourceAccountType: MoneyManagerRebalanceSourceAccountType
  sourceAmount: MoneyRulesCurrencyAmountInput
}

export type ExecuteMoneyManagerRebalancesResult =
  | ExecuteMoneyManagerRebalancesSuccess
  | RebalanceAlreadyExecutedError
  | RebalanceSourceInsufficientBalanceError

export type ExecuteMoneyManagerRebalancesSuccess = {
  __typename?: 'ExecuteMoneyManagerRebalancesSuccess'
  assignment: MoneyManagerRebalanceAssignment
}

/** Execution Audit */
export type ExecutionAudit = TimestampsInterface & {
  __typename?: 'ExecutionAudit'
  billingCycleId: Scalars['ID']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  decisionName: Scalars['String']
  id: Scalars['ID']
  result: Maybe<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export type ExistingEmailVerifiedException = {
  __typename?: 'ExistingEmailVerifiedException'
  message: Maybe<Scalars['String']>
}

/** A reopen request for this investment account already exists and is pending review */
export type ExistingRequestPendingReview = {
  __typename?: 'ExistingRequestPendingReview'
  /** Reopen request for investment account */
  reopenRequest: InvestmentAccountReopenRequest
}

/** A reopen request for this investment account already exists and is pending user action */
export type ExistingRequestPendingUserAction = {
  __typename?: 'ExistingRequestPendingUserAction'
  /** Reopen request for investment account */
  reopenRequest: InvestmentAccountReopenRequest
}

/** The content that supports and drives the user experience */
export type ExperienceContent = {
  __typename?: 'ExperienceContent'
  /** Campaign ID for the referrer's active campaign */
  campaignId: Maybe<Scalars['ID']>
  pillAmount: Maybe<Scalars['String']>
  /** JSON Content for rendering the referrer experience */
  rawContent: Maybe<Scalars['String']>
  /** Referrer's link to refer new friends */
  shareableLink: Maybe<Scalars['String']>
}

export type ExpirePromotionalWaiverInput = {
  promotion: WaiverPromotion_V2
}

export type ExpirePromotionalWaiverResult =
  | InvalidUserIdException
  | PromotionalWaiver_V2
  | WaiverDeletionException

export type ExtensionOffer = {
  __typename?: 'ExtensionOffer'
  merchantId: Scalars['String']
  merchantName: Scalars['String']
}

export type ExternalContribution = {
  __typename?: 'ExternalContribution'
  contributionAmount: MicrosMoney
  nextAction: Maybe<NextAction>
  requestNonce: Scalars['ID']
  status: ExternalContributionStatus
}

export type ExternalContributionIdempotencyConflictError = {
  __typename?: 'ExternalContributionIdempotencyConflictError'
  requestNonce: Scalars['ID']
}

export type ExternalContributionInvalidAmountError = {
  __typename?: 'ExternalContributionInvalidAmountError'
  maximumAmount: MicrosMoney
  minimumAmount: MicrosMoney
  providedAmount: MicrosMoney
  reason: ExternalContributionInvalidAmountReason
}

export enum ExternalContributionInvalidAmountReason {
  AboveMaximum = 'ABOVE_MAXIMUM',
  BelowMinimum = 'BELOW_MINIMUM',
}

export type ExternalContributionLimits = {
  __typename?: 'ExternalContributionLimits'
  maximumAmount: MicrosMoney
  minimumAmount: MicrosMoney
}

export enum ExternalContributionSource {
  /** Contribution initiated by scanning an on-screen QR code in the app. */
  InAppQr = 'IN_APP_QR',
  /** Contribution initiated from the owner's live page. */
  OwnPage = 'OWN_PAGE',
  /** Contribution initiated by scanning a printed QR code. */
  PrintedQr = 'PRINTED_QR',
  /** Contribution initiated through a shared message or link. */
  ShareLink = 'SHARE_LINK',
  /** Contribution initiated by scanning a sticker QR code. */
  Sticker = 'STICKER',
  /** Contribution source is missing or unrecognized. */
  Unknown = 'UNKNOWN',
}

export enum ExternalContributionStatus {
  Authorized = 'AUTHORIZED',
  AwaitingAuthorization = 'AWAITING_AUTHORIZATION',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Reversed = 'REVERSED',
}

export type ExternalContributionStatusResult = {
  __typename?: 'ExternalContributionStatusResult'
  contributionAmount: MicrosMoney
  status: ExternalContributionStatus
}

export type ExternalContributionUnavailableError = {
  __typename?: 'ExternalContributionUnavailableError'
  reason: ExternalContributionUnavailableReason
}

export enum ExternalContributionUnavailableReason {
  ContributionTargetUnavailable = 'CONTRIBUTION_TARGET_UNAVAILABLE',
}

/** Individual accounts opened by a user at Acorns */
export type ExternalMetadata = {
  __typename?: 'ExternalMetadata'
  /** Flag indicating if user is active customer in external source */
  isSubscriptionActive: Scalars['Boolean']
  /** External subscription type */
  membership: Maybe<ExternalSubscriptionType>
}

export enum ExternalSource {
  DirectBank = 'direct_bank',
  Manual = 'manual',
  Paypal = 'paypal',
  Plaid = 'plaid',
  Spend = 'spend',
}

export enum ExternalSubscriptionType {
  /** Legacy highest tier */
  LegacyPremium = 'LEGACY_PREMIUM',
  /** Highest tier */
  Premium = 'PREMIUM',
}

export enum ExternalUserSource {
  UserExternalSourceGoHenry = 'USER_EXTERNAL_SOURCE_GO_HENRY',
  UserExternalSourceInvalid = 'USER_EXTERNAL_SOURCE_INVALID',
}

export type ExtoleCampaignHistoryConnection = {
  __typename?: 'ExtoleCampaignHistoryConnection'
  edges: Maybe<Array<ExtoleCampaignHistoryEdge>>
  pageInfo: ReferralPaginatedInfo
}

export type ExtoleCampaignHistoryEdge = {
  __typename?: 'ExtoleCampaignHistoryEdge'
  cursor: Scalars['String']
  hurdleMet: Maybe<Scalars['Boolean']>
  node: ExtoleReferralCampaign
}

export type ExtoleReferralCampaign = {
  __typename?: 'ExtoleReferralCampaign'
  /** @deprecated Use advocateRewardAmountMicros. */
  advocateRewardAmount: Scalars['Float']
  advocateRewardAmountMicros: MicrosMoney
  eligibilityEnd: Scalars['DateTime']
  /** @deprecated Use friendRewardAmountMicros. */
  friendRewardAmount: Scalars['Float']
  friendRewardAmountMicros: MicrosMoney
  hurdle: Scalars['Int']
  id: Scalars['ID']
  publishEnd: Scalars['DateTime']
  publishStart: Scalars['DateTime']
  status: PublishedCampaignStatus
  title: Scalars['String']
}

export type ExtoleReferralHistory = {
  __typename?: 'ExtoleReferralHistory'
  extoleFriendHistory: Maybe<FriendHistoryConnection>
  userId: Maybe<Scalars['ID']>
}

export type ExtoleReferralHistoryExtoleFriendHistoryArgs = {
  extoleCampaignId?: InputMaybe<Scalars['ID']>
  filter: ReferralPaginatedFilter
}

export type FailVendorInvoiceResult = BillingVendorError | Invoice

export type FavoritePartnerOfferGroup = {
  __typename?: 'FavoritePartnerOfferGroup'
  /** list of offers in the favorite group */
  offers: Array<PartnerOfferGroupItem>
}

/** Used to customize favorite offer group contents */
export type FavoritePartnerOfferInput = {
  ids: Array<Scalars['String']>
}

export type FeaturedLearnContentPreview =
  | LearnArticlePreview
  | LearnMediaPreview

export type FeaturedMilestones = {
  __typename?: 'FeaturedMilestones'
  /** list of featured milestones to show on widget */
  milestones: Array<Milestone>
}

export type FeaturedMilestonesV2 = AccountSetupMilestones | FeaturedMilestones

/** Fee information */
export type Fee = TimestampsInterface & {
  __typename?: 'Fee'
  accountId: Maybe<Scalars['ID']>
  amount: Scalars['Float']
  amountCollected: Scalars['Float']
  assessedAt: Maybe<Scalars['String']>
  balance: Maybe<Scalars['Float']>
  billingCycle: BillingCycle
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  discount: Maybe<Scalars['Float']>
  discountedAmount: Maybe<Scalars['Float']>
  feeCategoryId: Scalars['String']
  feeExecutions: Array<Maybe<FeeExecution>>
  feeType: FeeType
  id: Scalars['ID']
  state: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId: Maybe<Scalars['ID']>
}

/** Fee execution information */
export type FeeExecution = TimestampsInterface & {
  __typename?: 'FeeExecution'
  accountType: Maybe<Scalars['String']>
  amountCollected: Scalars['Float']
  amountRequested: Scalars['Float']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  executionMethod: Scalars['String']
  externalId: Maybe<Scalars['ID']>
  fundingAccountId: Maybe<Scalars['ID']>
  id: Scalars['ID']
  reason: Maybe<Scalars['String']>
  sourceId: Maybe<Scalars['ID']>
  state: Maybe<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export enum FeeExecutionMethod {
  /** Executed fee by direct ACH */
  Direct = 'DIRECT',
  /** Executed fee by selling shares */
  LiquidateSecurities = 'LIQUIDATE_SECURITIES',
  /** Pre-emptively failed execution due to a known failure reason */
  PreemptiveFailure = 'PREEMPTIVE_FAILURE',
  /** Skipped fee execution */
  Skip = 'SKIP',
  /** Executed by direct ACH from Spend funding source */
  SpendDirect = 'SPEND_DIRECT',
  /** Waived fee execution */
  Waive = 'WAIVE',
}

export type FeeNegotiation = {
  __typename?: 'FeeNegotiation'
  connection: Maybe<BankConnection>
  created: Maybe<Scalars['DateTime']>
  displayStatus: Maybe<Scalars['String']>
  feeSynopsis: Maybe<Scalars['String']>
  id: Scalars['ID']
  internalStatus: Maybe<BankFeeNegotiationInternalStatus>
  negotiatedAmount: Maybe<MonetaryAmount>
  refundAmount: Maybe<MonetaryAmount>
  status: Maybe<BankFeeNegotiationExternalStatus>
  updated: Maybe<Scalars['DateTime']>
}

export type FeeNegotiationSummary = {
  __typename?: 'FeeNegotiationSummary'
  negotiations: Maybe<Array<FeeNegotiation>>
  totalRefundedFees: Maybe<MonetaryAmount>
}

export enum FeeStatus {
  Negotiable = 'NEGOTIABLE',
  Negotiated = 'NEGOTIATED',
  Processing = 'PROCESSING',
  Unnegotiable = 'UNNEGOTIABLE',
}

export enum FeeStatusFilter {
  Negotiable = 'NEGOTIABLE',
  Negotiated = 'NEGOTIATED',
  Processing = 'PROCESSING',
  Unnegotiable = 'UNNEGOTIABLE',
}

export type FeeStatusSummary = {
  __typename?: 'FeeStatusSummary'
  negotiable: Scalars['Int']
  negotiated: Scalars['Int']
  processing: Scalars['Int']
  total: Scalars['Int']
  unnegotiable: Scalars['Int']
}

export enum FeeType {
  /** ADVISORY fee */
  Advisory = 'ADVISORY',
  /** SUBSCRIPTION fee */
  Subscription = 'SUBSCRIPTION',
}

export enum FeedContext {
  /** a4 banking hub */
  A4BankingHub = 'a4_banking_hub',
  /** a4 checking engagement wizard */
  A4CheckingEngagementWizard = 'a4_checking_engagement_wizard',
  /** a4 checking hub */
  A4CheckingHub = 'a4_checking_hub',
  /** a4 early */
  A4Early = 'a4_early',
  /** a4 early details */
  A4EarlyDetails = 'a4_early_details',
  /** a4 home/present */
  A4Home = 'a4_home',
  /** a4 home bottom nav */
  A4HomeBottomNav = 'a4_home_bottom_nav',
  /** a4 invest */
  A4Invest = 'a4_invest',
  /** invest hub */
  A4InvestHub = 'a4_invest_hub',
  /** a4 kids */
  A4Kids = 'a4_kids',
  /** a4 later */
  A4Later = 'a4_later',
  /** a4 learn hub */
  A4LearnHub = 'a4_learn_hub',
  /** a4 savings */
  A4Savings = 'a4_savings',
  /** a4 spend */
  A4Spend = 'a4_spend',
}

/** Grouping category for the admin field picker. */
export enum FieldCategory {
  /** Fields from the user's Acorns account (e.g. customerState.hasDirectDeposit). */
  Account = 'ACCOUNT',
  /** Client/device context derived from request headers (e.g. clientContext.platform, clientContext.appVersion). */
  Client = 'CLIENT',
  /** Fields tracking user dismissal state (e.g. customerState.dismissedWidgets). */
  Dismissals = 'DISMISSALS',
  /**
   * Amplitude feature flag values. Field path is amplitudeState.<raw_flag_key>
   * (e.g. amplitudeState.enable_a4_early_match_widget). Value is boolean.
   */
  FeatureFlags = 'FEATURE_FLAGS',
  /** Fields from the user's investment data (e.g. customerState.portfolioValue). */
  Investment = 'INVESTMENT',
  /** Fields from the user's profile (e.g. customerState.state, customerState.accountAgeDays). */
  User = 'USER',
}

export type FieldRegistryConnection = {
  __typename?: 'FieldRegistryConnection'
  edges: Array<FieldRegistryEntryEdge>
  pageInfo: PageInfo
}

/** Field registry entry — user context field available for rule authoring. */
export type FieldRegistryEntry = {
  __typename?: 'FieldRegistryEntry'
  /** Grouping category for the admin field picker. */
  category: FieldCategory
  /** ISO 8601 timestamp when this row was created. */
  createdAt: Scalars['DateTime']
  /** ID of the actor who created this row. */
  createdBy: Maybe<Scalars['String']>
  /**
   * Backend datasource that provides this field (e.g. legacyUser, investmentAccounts, amplitude).
   * Maps to a graphql_internal_service query. NULL for client-derived fields.
   */
  datasource: Maybe<Scalars['String']>
  /** ISO 8601 timestamp when this field was deprecated. */
  deprecatedAt: Maybe<Scalars['DateTime']>
  /** Reason this field was deprecated. Shown to rule authors editing existing rules. */
  deprecatedReason: Maybe<Scalars['String']>
  /** Help text for rule authors shown in the admin UI. */
  description: Maybe<Scalars['String']>
  /** Human-readable field name shown in the admin field picker. */
  displayName: Scalars['String']
  /** Dot-notation path used in rule trees (e.g. customerState.investedAmount, amplitudeState.earlyMatchEnabled). */
  fieldPath: Scalars['String']
  /** UUID primary key. */
  id: Scalars['ID']
  /** If true, field is hidden from the field picker but valid in existing rule trees. */
  isDeprecated: Scalars['Boolean']
  /** Valid comparison operators for this field (e.g. equals, greater_than). */
  operators: Array<Scalars['String']>
  /** ISO 8601 timestamp when this row was last updated. */
  updatedAt: Scalars['DateTime']
  /** ID of the actor who last updated this row. */
  updatedBy: Maybe<Scalars['String']>
  /** Data type determining valid operators and UI input rendering. */
  valueType: FieldValueType
}

export type FieldRegistryEntryEdge = {
  __typename?: 'FieldRegistryEntryEdge'
  node: FieldRegistryEntry
}

/** Filter for field registry queries. All fields are optional. */
export type FieldRegistryFilterInput = {
  /** Filter by category. */
  category?: InputMaybe<FieldCategory>
  /** If true, return only deprecated fields. If false, return only active fields. */
  deprecated?: InputMaybe<Scalars['Boolean']>
  /** Filter by exact field path. */
  fieldPath?: InputMaybe<Scalars['String']>
  /** Return only the entry with this UUID. */
  id?: InputMaybe<Scalars['ID']>
  /** Filter by value type. */
  valueType?: InputMaybe<FieldValueType>
}

/** Data type of a field. Determines valid operators and UI input rendering. */
export enum FieldValueType {
  /** Boolean. Valid operators: equals. */
  Boolean = 'BOOLEAN',
  /** ISO 8601 date/datetime. Valid operators: equals, greater_than, less_than. */
  Date = 'DATE',
  /** Numeric value. Valid operators: equals, not_equals, greater_than, greater_than_or_equal, less_than, less_than_or_equal. */
  Number = 'NUMBER',
  /** Plain text. Valid operators: equals, not_equals, in, not_in. */
  String = 'STRING',
  /** Array of strings. Valid operators: contains, not_contains. */
  StringArray = 'STRING_ARRAY',
}

export type File = {
  __typename?: 'File'
  documentRequestId: Scalars['ID']
  encoding: Scalars['String']
  filename: Scalars['String']
  mimetype: Scalars['String']
  url: Scalars['URL']
}

/** The file does not exist */
export type FileDoesNotExistError = {
  __typename?: 'FileDoesNotExistError'
  /** message */
  message: Maybe<Scalars['String']>
  /** The upload uuid */
  uploadUuid: Maybe<Scalars['ID']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

/** The file does not exist in s3 */
export type FileDoesNotExistInS3 = {
  __typename?: 'FileDoesNotExistInS3'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export type FileOrException = File | FileSizeError | UploadFailedError

export type FileSizeError = {
  __typename?: 'FileSizeError'
  message: Scalars['String']
}

/** The file uploaded exceeds the max allowed byte size */
export type FileTooLarge = {
  __typename?: 'FileTooLarge'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export enum FilingType {
  /** User files taxes with their spouse */
  Joint = 'joint',
  /** User files taxes living with spouse part of the year */
  SeparatePartYear = 'separatePartYear',
  /** User files taxes living apart from spouse all year */
  SeparateWholeYear = 'separateWholeYear',
}

/**
 * Final pricing information that accounts for active waivers.
 * This represents the price that should be displayed to the user.
 */
export type FinalPrice = {
  __typename?: 'FinalPrice'
  /** The final amount to display, adjusted for any active waivers, in micros format. */
  amount: MicrosMoney
  /** Whether this price is currently waived. */
  isWaived: Scalars['Boolean']
}

export type FinancialAdvisorQuestionResponse = {
  __typename?: 'FinancialAdvisorQuestionResponse'
  interactionId: Scalars['String']
  message: Scalars['String']
}

export type FinancialAdvisorQuestionsResponse = {
  __typename?: 'FinancialAdvisorQuestionsResponse'
  message: Scalars['String']
}

export enum FinancialEducation {
  /** User has little to no experience with financial education */
  Beginner = 'BEGINNER',
  /** User has a lot of experience with financial education */
  Expert = 'EXPERT',
  /** User has some experience with financial education */
  Moderate = 'MODERATE',
}

export type FinancialGoalsInput = {
  age: Scalars['Int']
  annualIncome: Scalars['Int']
  contributionFrequency: Scalars['String']
  employmentStatus: Scalars['String']
  spendPercent: Scalars['Float']
  state: Scalars['String']
  strategy: Scalars['String']
}

export type FinancialGoalsResult = {
  __typename?: 'FinancialGoalsResult'
  age: Array<Scalars['Int']>
  balance: Array<Scalars['Float']>
  cumulativeContributions: Array<Scalars['Float']>
  totalContributions: Array<Scalars['Float']>
}

/** Miscellaneous attributes about a Financial Institution */
export type FinancialInstitution = TimestampsInterface & {
  __typename?: 'FinancialInstitution'
  /** Is this Financial Institution blacklisted within Acorns */
  blacklisted: Scalars['Boolean']
  /** Inorganic ordering for Financial Institutions */
  boost: Scalars['Int']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Is this Financial Institution removed from Plaid's list */
  deleted: Scalars['Boolean']
  /** Is this Financial Institution a Direct Bank type */
  directBank: Scalars['Boolean']
  /** Plaid Financial Institution ID */
  externalId: Scalars['String']
  /** Does this Financial Institution have multi-factor authentication? */
  hasMfa: Scalars['Boolean']
  /** Internal Acorns UUID representing Financial Institution */
  id: Scalars['ID']
  /** The link provider type of the financial institution */
  linkProviderType: Maybe<LinkProviderType>
  /** Location of logo for a Financial Institution */
  logoUrl: Scalars['String']
  /** Name of Financial Institution */
  name: Scalars['String']
  /** URL for signing in with Direct Bank Integration */
  oauthUrl: Maybe<Scalars['String']>
  /** Plaid products this Financial Institution supports */
  products: Array<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** URL of the Financial Institution */
  url: Maybe<Scalars['String']>
}

/** An individual edge within the paginated list of FinancialInstitutionType */
export type FinancialInstitutionTypeEdge = {
  __typename?: 'FinancialInstitutionTypeEdge'
  /** The unique key used for pagination */
  cursor: Scalars['ID']
  /** The FinancialInstitutionType record in the edge */
  node: FinancialInstitution
}

/** Relay style pagination information for FinancialInstitutionType */
export type FinancialInstitutionTypePagination = {
  __typename?: 'FinancialInstitutionTypePagination'
  edges: Array<FinancialInstitutionTypeEdge>
  pageInfo: PageInfo
}

export type FinishSetup = {
  __typename?: 'FinishSetup'
  eyebrow: Scalars['String']
  tips: Array<SetUpTip>
}

export type FirmAllocationInput = {
  /** Product key (e.g. self_directed, self_directed_early) */
  product: Scalars['String']
  /** Quantity of shares to allocate */
  quantity: Scalars['String']
}

export type FooterContent = {
  __typename?: 'FooterContent'
  acornsLogoAsset: Scalars['String']
  disclosures: Scalars['String']
  linkColumn1Header: Scalars['String']
  linkColumn2Header: Scalars['String']
  linkColumn3Header: Scalars['String']
  mainCTAText: Scalars['String']
  mainCTAUrl: Scalars['String']
  mainHeadline: Scalars['String']
}

export enum FormType {
  Form1099 = 'form1099',
  Form1099Bdiv = 'form1099BDIV',
  Form1099Misc = 'form1099MISC',
  Form1099R = 'form1099R',
  Form1099R1 = 'form1099R1',
  Form1099R2 = 'form1099R2',
  Form1099R4 = 'form1099R4',
  Form1099R7 = 'form1099R7',
  Form1099R8 = 'form1099R8',
  Form1099Re = 'form1099RE',
  Form1099Rj = 'form1099RJ',
  Form1099Rq = 'form1099RQ',
  Form1099Rt = 'form1099RT',
  Form5498 = 'form5498',
  Other = 'other',
}

export type FormattedMonetaryAmount = {
  __typename?: 'FormattedMonetaryAmount'
  currency: Currency
  value: Scalars['String']
}

export type FoundMoneyCampaignOfferV2 = {
  __typename?: 'FoundMoneyCampaignOfferV2'
  id: Scalars['ID']
  incentiveSummary: Scalars['String']
}

export type FoundMoneyCampaignV2 = {
  __typename?: 'FoundMoneyCampaignV2'
  backgroundColorHex: Scalars['String']
  backgroundImageUrl: Scalars['URL']
  cohortSlug: Scalars['String']
  colorBackgroundLogoImageUrl: Maybe<Scalars['URL']>
  /** @deprecated Use colorBackgroundLogoImageUrl instead */
  colorImageUrl: Scalars['URL']
  displayName: Scalars['String']
  id: Scalars['ID']
  /** @deprecated Use colorBackgroundLogoImageUrl instead */
  imageUrl: Scalars['URL']
  offers: Array<FoundMoneyCampaignOfferV2>
  ownerId: Scalars['ID']
}

export type FoundMoneyReward = {
  __typename?: 'FoundMoneyReward'
  amount: MicrosMoney
  /** @deprecated Field is deprecated, use colorBackgroundLogoImageUrl instead */
  campaignOwnerImageUrl: Maybe<Scalars['URL']>
  campaignOwnerName: Maybe<Scalars['String']>
  categoryIcon: Maybe<Scalars['String']>
  colorBackgroundLogoImageUrl: Maybe<Scalars['URL']>
  daysFulfilledWithin: Maybe<Scalars['Int']>
  /** @deprecated Monetary values have been migrated to new standard `MicrosMoney`. Use `amount`. */
  dollarValue: Maybe<MonetaryAmount>
  fulfillmentDate: Maybe<Scalars['String']>
  id: Scalars['ID']
  isFoundMoneyPlus: Maybe<Scalars['Boolean']>
  originationDate: Maybe<Scalars['String']>
  originationType: Maybe<Scalars['String']>
  status: Maybe<Scalars['String']>
}

export type FoundMoneySummary = {
  __typename?: 'FoundMoneySummary'
  fulfilledAmount: MicrosMoney
  matchedAmount: MicrosMoney
  pendingAmount: MicrosMoney
  totalAmount: MicrosMoney
  /** @deprecated Monetary values have been migrated to new standard `MicrosMoney`. Use `fulfilledAmount`. */
  totalFulfilledRewardsDollarValue: Maybe<MonetaryAmount>
  /** @deprecated Monetary values have been migrated to new standard `MicrosMoney`. Use `matchedAmount`. */
  totalMatchedDollarValue: Maybe<MonetaryAmount>
  /** @deprecated Monetary values have been migrated to new standard `MicrosMoney`. Use `pendingAmount`. */
  totalPendingRewardsDollarValue: Maybe<MonetaryAmount>
  /** @deprecated Monetary values have been migrated to new standard `MicrosMoney`. Use `totalAmount`. */
  totalRewardsDollarValue: Maybe<MonetaryAmount>
}

/** A user who was referred by an existing Acorns User */
export type Friend = {
  __typename?: 'Friend'
  /** The first name of the referred user's advocate */
  advocateFirstName: Maybe<Scalars['String']>
  /** The last name of the referred user's advocate */
  advocateLastName: Maybe<Scalars['String']>
  /** The baseline advocate incentive they will earn if friend converts */
  advocateMinimumIncentive: Maybe<Scalars['String']>
  /**
   * If the Friend object resolved via the Advocate query, advocateUserId
   * corresponds to the argument passed in at the root level.
   * If Friend object resolved via the Friend query, advocateUserId is the
   * first advocate that is returned by Extole.
   */
  advocateUserId: Maybe<Scalars['ID']>
  /** A list of all campaigns that the friend is participating in */
  campaigns: Maybe<Array<ReferralCampaign>>
  email: Scalars['String']
  friendExperienceContent: Maybe<FriendExperienceContent>
  name: Maybe<Scalars['String']>
  /** Status based on activity of friend */
  status: Maybe<FriendStatus>
  userId: Maybe<Scalars['ID']>
}

/** The content that supports user experience */
export type FriendExperienceContent = {
  __typename?: 'FriendExperienceContent'
  /** The first name of the referred user's advocate */
  advocateFirstName: Maybe<Scalars['String']>
  /** The last name of the referred user's advocate */
  advocateLastName: Maybe<Scalars['String']>
  /** The baseline advocate incentive they will earn if friend converts */
  advocateMinimumIncentive: Maybe<Scalars['String']>
}

/** A summary of information around a referred user */
export type FriendHistory = {
  __typename?: 'FriendHistory'
  /** User ID of the Advocate user */
  advocateUserId: Maybe<Scalars['ID']>
  /** Campaign identifier that the referred user signed up under */
  campaignId: Scalars['ID']
  /** When the friend account was created */
  createdAt: Maybe<Scalars['DateTime']>
  /** The first name of the advocate's friend */
  friendFirstName: Maybe<Scalars['String']>
  /** The last name of the advocate's friend */
  friendLastName: Maybe<Scalars['String']>
  /** High level status indicating referred user reward status */
  status: Maybe<FriendStatusV2>
  /** User ID of the referred user */
  userId: Scalars['ID']
}

export type FriendHistoryConnection = {
  __typename?: 'FriendHistoryConnection'
  edges: Maybe<Array<FriendHistoryEdge>>
  pageInfo: ReferralPaginatedInfo
}

export type FriendHistoryEdge = {
  __typename?: 'FriendHistoryEdge'
  cursor: Scalars['String']
  node: FriendHistory
}

/** Status of friend */
export enum FriendStatus {
  /** Friend has finished required steps to qualify for reward */
  Complete = 'COMPLETE',
  /** Friend did not complete required steps in allotted time frame */
  Expired = 'EXPIRED',
  /** Reward has been given to Friend/Advocate */
  Fulfilled = 'FULFILLED',
  /** Friend has registered */
  Pending = 'PENDING',
  /** Advocate sent invite but user has not completed any steps */
  Sent = 'SENT',
}

/** Status of friend */
export enum FriendStatusV2 {
  /** Friend has finished required steps to qualify for reward */
  Complete = 'COMPLETE',
  /** Friend has invested */
  ConfirmingEligibility = 'CONFIRMING_ELIGIBILITY',
  /** Friend is ineligible for reward */
  Ineligible = 'INELIGIBLE',
  /** Friend has signed up or created first investment */
  InProgress = 'IN_PROGRESS',
}

export type FriendSummary = {
  __typename?: 'FriendSummary'
  /** Campaign identifier that the referred user signed up under */
  campaignId: Scalars['ID']
  /** First name of the referred user */
  name: Maybe<Scalars['String']>
  /** High level status indicating referred user reward status */
  status: Maybe<FriendStatus>
  userId: Scalars['ID']
}

export type FriendV2Output = {
  __typename?: 'FriendV2Output'
  advocate: Maybe<AdvocateV2>
  campaign: Maybe<CampaignV2>
  userId: Maybe<Scalars['ID']>
}

export type Fund = Security & {
  __typename?: 'Fund'
  currentPrice: BigCurrencyAmount
  /** CUSIP identifier for the security, or null when unknown */
  cusip: Maybe<Scalars['String']>
  displayName: Scalars['String']
  earliestPriceDate: Scalars['Date']
  headlines: Array<SecurityHeadline>
  id: Scalars['ID']
  lastClosePrice: BigCurrencyAmount
  lastUpdatedAt: Scalars['DateTime']
  longName: Scalars['String']
  marketCap: Scalars['BigDecimal']
  numberOfHoldings: Scalars['Int']
  openPrice: BigCurrencyAmount
  profile: SecurityProfile
  /** @deprecated Use `Security.headlines` instead. */
  securityHeadlines: Array<SecurityHeadline>
  /** @deprecated Use `Security.profile` instead. */
  securityProfile: SecurityProfile
  shortName: Scalars['String']
  symbol: Scalars['TickerSymbol']
  topHoldings: Array<TopHolding>
  type: SecurityType
  volume: Scalars['BigDecimal']
  week52High: BigCurrencyAmount
  week52Low: BigCurrencyAmount
}

/** Boolean indicating if the user can fund spend in activation */
export type FundSpendInActivationPayload = {
  __typename?: 'FundSpendInActivationPayload'
  /** Boolean indicating if the user can fund spend in activation */
  eligible: Scalars['Boolean']
}

/** A Funding Source for the acorns user */
export type FundingSource = {
  __typename?: 'FundingSource'
  alert: Maybe<Scalars['JSON']>
  /** The type of the funding source. */
  fundingType: Scalars['String']
  /** The bank icon of the funding source */
  icon: Maybe<Scalars['URL']>
  last4: Maybe<Scalars['String']>
  name: Scalars['String']
  rdvSettledAt: Maybe<Scalars['DateTime']>
  rdvTriggeredAt: Maybe<Scalars['DateTime']>
  /** Deprecated - use fundType instead. */
  type: Scalars['String']
  verificationStatus: Scalars['Int']
  verified: Maybe<Scalars['Boolean']>
}

/** A Funding Source for the acorns user */
export type FundingSourceAccount = TimestampsInterface & {
  __typename?: 'FundingSourceAccount'
  accountName: Scalars['String']
  alert: Maybe<Scalars['JSON']>
  balance: Maybe<Scalars['Float']>
  bankRoutingNumber: Maybe<Scalars['String']>
  canCancel: Scalars['Boolean']
  canRetriggerRdv: Scalars['Boolean']
  canTriggerRdv: Scalars['Boolean']
  /** Indicates whether the user is allowed to verify RDV */
  canVerifyRdv: Maybe<Scalars['Boolean']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  deleted: Scalars['Boolean']
  frozen: Scalars['Boolean']
  /** The type of the funding source. */
  fundType: FundingSourceType
  /** The bank icon of the funding source */
  icon: Maybe<Scalars['String']>
  id: Scalars['Int']
  institutionId: Maybe<Scalars['String']>
  institutionName: Scalars['String']
  insufficientFunds: Maybe<Scalars['Boolean']>
  last4: Maybe<Scalars['String']>
  linked: Scalars['Boolean']
  linkedSubaccountId: Maybe<Scalars['ID']>
  /** The logo url from Linked Accounts Service */
  logoUrl: Maybe<Scalars['String']>
  name: Scalars['String']
  /** Identifies whether the user has indicated that they prefer to withdraw funds to this account. */
  preferredWithdrawalAccount: Scalars['Boolean']
  rdvSettledAt: Maybe<Scalars['DateTime']>
  rdvTriggeredAt: Maybe<Scalars['DateTime']>
  /** The role of the funding source. */
  role: Maybe<FundingSourceRoleEnum>
  /** The status of the funding source. */
  status: FundingSourceStatus
  transfersApproved: Scalars['Boolean']
  /** Deprecated - use fundType instead. */
  type: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  uuid: Maybe<Scalars['ID']>
  verificationStatus: Scalars['Int']
  verified: Maybe<Scalars['Boolean']>
}

/** Funding Source with account and routing already exists for user */
export type FundingSourceAlreadyExists = {
  __typename?: 'FundingSourceAlreadyExists'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

/** Account credentials linked by too many users */
export type FundingSourceCredentialsExceedLinkLimit = {
  __typename?: 'FundingSourceCredentialsExceedLinkLimit'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export type FundingSourceInfo = {
  __typename?: 'FundingSourceInfo'
  accountNumberLastFour: Maybe<Scalars['String']>
  alert: Maybe<Scalars['JSON']>
  balance: Maybe<Scalars['Float']>
  /** @deprecated Will move in the future */
  canChange: Scalars['Boolean']
  /** @deprecated Will move in the future */
  changeRequiresApproval: Scalars['Boolean']
  icon: Maybe<Scalars['URL']>
  linkedSubaccountId: Maybe<Scalars['ID']>
  name: Scalars['String']
  rdvSettledAt: Maybe<Scalars['DateTime']>
  rdvTriggeredAt: Maybe<Scalars['DateTime']>
  type: Maybe<FundingSourceType>
  verificationStatus: Maybe<Scalars['Int']>
  verified: Maybe<Scalars['Boolean']>
}

/** The user needs to verify their RDVs to close their early account */
export type FundingSourceRequiresRdvException = {
  __typename?: 'FundingSourceRequiresRdvException'
  /** message */
  message: Maybe<Scalars['String']>
}

export enum FundingSourceRoleEnum {
  /** The subaccount is the primary funding source of the user */
  PrimaryFunding = 'primaryFunding',
  /** The subaccount is the secondary funding source of the user */
  SecondaryFunding = 'secondaryFunding',
}

export enum FundingSourceStatus {
  /** Documents have been requested to verify the funding source. */
  DocsRequired = 'docsRequired',
  /** RDV verification attempts exhausted. */
  Frozen = 'frozen',
  /** Funding Source is waiting on RDV triggers. */
  Pending = 'pending',
  /** RDVs have been sent and are awaiting settlement. */
  RdvsInitiated = 'rdvsInitiated',
  /** RDVs have settled in the user's funding source. User must verify amounts. */
  RdvsSettled = 'rdvsSettled',
  /** Funding Source is verified. No user action is required. */
  Success = 'success',
  /** Awaiting admin approval. No user action is required. */
  Unapproved = 'unapproved',
}

export enum FundingSourceStatusEnum {
  /** Documents have been requested to verify the funding source. */
  DocsRequired = 'docsRequired',
  /** RDV verification attempts exhausted. */
  Frozen = 'frozen',
  /** Funding Source is waiting on RDV triggers. */
  Pending = 'pending',
  /** RDVs have been sent and are awaiting settlement. */
  RdvsInitiated = 'rdvsInitiated',
  /** RDVs have settled in the user's funding source. User must verify amounts. */
  RdvsSettled = 'rdvsSettled',
  /** Funding Source is verified. No user action is required. */
  Success = 'success',
  /** Awaiting admin approval. No user action is required. */
  Unapproved = 'unapproved',
}

export enum FundingSourceType {
  Ach = 'ach',
  Paypal = 'paypal',
  Spend = 'spend',
}

export enum FundsAvailability {
  /** User wants easy access to cash in an emergency */
  Emergency = 'emergency',
  /** User is planning to save and not withdraw until retirement */
  Retirement = 'retirement',
}

export enum Funnel {
  /** Core funnel */
  Core = 'core',
  /** Direct to mobile funnel */
  DirectToMobile = 'direct_to_mobile',
  /** Early funnel */
  Early = 'early',
  /** Later funnel */
  Later = 'later',
  /** Simple registration funnel */
  SimpleReg = 'simple_reg',
  /** Spend funnel */
  Spend = 'spend',
  /** Tiered registration funnel */
  TieredReg = 'tiered_reg',
}

export type FunnelMetadata = {
  __typename?: 'FunnelMetadata'
  name: FunnelName
  version: Scalars['String']
}

export enum FunnelName {
  Default = 'DEFAULT',
  MightyOakCard = 'MIGHTY_OAK_CARD',
  Referrals = 'REFERRALS',
}

export type GenerateDocumentUploadSessionInput = {
  /** Acorns subaccount for identity processing that is requesting to generate a document upload session */
  product: IdentitySubaccount
}

export type GenerateDocumentUploadSessionResult = DocumentUploadSession

/** Attributes for generating a layer linked account session. */
export type GenerateLayerLinkSessionInput = {
  /** Android package name for the Acorns app. */
  androidPackageName?: InputMaybe<Scalars['String']>
  /** ISO 639-1 code representing the language. Default is 'EN'. */
  language?: InputMaybe<LinkSessionLanguage>
  /** The configuration of the Plaid session to generate for the customer. Defaulted to Acorns' standard configuration. */
  linkCustomization?: InputMaybe<LinkCustomization>
  /** The URL to redirect the client to after customer has finished linking account. */
  redirectUrl?: InputMaybe<Scalars['URL']>
}

/** Returns a Link Token to use with Account Linking. */
export type GenerateLayerLinkSessionResult =
  | PlaidLayerLinkSession
  | UnrecoverableError

/** Attributes for generating a linked account session. */
export type GenerateLinkSessionInput = {
  /** Android package name for the Acorns app */
  androidPackageName?: InputMaybe<Scalars['String']>
  /** The URL to redirect the client to after customer has finished linking account. */
  authRequired?: InputMaybe<Scalars['Boolean']>
  /** Acorns Financial Institution ID */
  institutionId: Scalars['ID']
  /** Flag indicating a web view client default is true */
  isWebview?: InputMaybe<Scalars['Boolean']>
  /** ISO 639-1 code representing the language. default is 'EN' */
  language?: InputMaybe<LinkSessionLanguage>
  /** Linked Account ID for Linked Account to relink */
  linkedAccountId?: InputMaybe<Scalars['ID']>
  /** The URL to redirect the client to after customer has finished linking account. */
  redirectUrl?: InputMaybe<Scalars['URL']>
}

export type GenerateReferralCodeResult = Invitation

/** Returns Base 64 encoded string of PDF for Front-end */
export type GenerateUpdatedPdfPayload = {
  __typename?: 'GenerateUpdatedPdfPayload'
  /** Base 64 Encoded String of PDF */
  pdf: Scalars['String']
}

export type GetMarketQuotesInput = {
  symbols: Array<Scalars['TickerSymbol']>
}

/** Input for getting third-party user data */
export type GetThirdPartyDataInput = {
  /** Access token for the third-party provider */
  accessToken?: InputMaybe<Scalars['String']>
  /** Authorization code for the third-party provider */
  authorizationCode?: InputMaybe<Scalars['String']>
  /** The third-party provider */
  provider: Provider
}

/** Result of attempting to retrieve third-party user data */
export type GetThirdPartyDataResult = ThirdPartyData | ThirdPartyDataError

export type GetUsersBankFromAccountTypePayload = {
  __typename?: 'GetUsersBankFromAccountTypePayload'
  bankType: BankType
}

/** Object representing a grow prospect */
export type GrowProspect = Prospect & {
  __typename?: 'GrowProspect'
  email: Scalars['String']
  id: Scalars['ID']
}

export type HelpFormContent = {
  __typename?: 'HelpFormContent'
  body: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
}

export enum HelpFormType {
  Contact = 'CONTACT',
  EarnMissingCredit = 'EARN_MISSING_CREDIT',
  SpendDispute = 'SPEND_DISPUTE',
}

export type HelpcenterBannerContent = {
  __typename?: 'HelpcenterBannerContent'
  bannerText: Scalars['String']
  bannerType: HelpcenterBannerType
  currentVersion: Scalars['String']
  publishedVersion: Maybe<Scalars['String']>
  visible: Scalars['Boolean']
}

export type HelpcenterBannerErrors = {
  __typename?: 'HelpcenterBannerErrors'
  error: Maybe<Scalars['String']>
  message: Maybe<Scalars['String']>
}

export enum HelpcenterBannerType {
  Error = 'ERROR',
  Success = 'SUCCESS',
  Warning = 'WARNING',
}

export type HelpcenterContentInput = {
  bannerText?: InputMaybe<Scalars['String']>
  bannerType?: InputMaybe<HelpcenterBannerType>
  publish?: InputMaybe<Scalars['Boolean']>
  visible?: InputMaybe<Scalars['Boolean']>
}

export type HideMessageByExternalIdInput = {
  externalMessageId: Scalars['ID']
}

export type HideMessageInput = {
  messageId: Scalars['ID']
}

/** The Individual Security on the ETF */
export type Holding = {
  __typename?: 'Holding'
  /** Indicates the amount of every dollar that will go towards buying a share of the stock */
  amount: Scalars['Float']
  /** The name of the stock */
  name: Scalars['String']
  /** Indicates the percent of every dollar that will go towards buying a share of the stock */
  percent: Scalars['Float']
  /** The Symbol of the stock */
  symbol: Scalars['String']
}

/** Holding transfer information; ex: beneficiaryTransfer, external transfer, and external transfer reversed */
export type HoldingsTransfer = {
  __typename?: 'HoldingsTransfer'
  /** Holdings transfer type */
  transferType: HoldingsTransferType
}

/** Defines the different types of holdings transfers. */
export enum HoldingsTransferType {
  BeneficiaryTransfer = 'BENEFICIARY_TRANSFER',
  ExternalTransfer = 'EXTERNAL_TRANSFER',
  ExternalTransferReversed = 'EXTERNAL_TRANSFER_REVERSED',
}

/** An IRA Distribution or a withdraw investment for Later account */
export type IraDistribution = {
  __typename?: 'IRADistribution'
  /** created at date and time of IRA Distribution */
  createdAt: Scalars['DateTime']
  /** Federal withholdings for Later account */
  federalWithholdings: Maybe<MonetaryAmount>
  /** ID of the IRA Distribution */
  id: Scalars['ID']
  /** Investment ID of the IRA Distribution from the investment table */
  investmentId: Scalars['ID']
  /** IRA Distribution reason */
  reason: Maybe<Scalars['String']>
  /** State withholdings for Later account */
  stateWithholdings: Maybe<MonetaryAmount>
  /** update at date and time of IRA Distribution */
  updatedAt: Scalars['DateTime']
}

export enum IconType {
  IconAddGoal = 'ICON_ADD_GOAL',
  IconAlert = 'ICON_ALERT',
  IconAlertGrey = 'ICON_ALERT_GREY',
  IconAlertPause = 'ICON_ALERT_PAUSE',
  IconAlertPending = 'ICON_ALERT_PENDING',
  IconAlertRed = 'ICON_ALERT_RED',
  IconAlertYellow = 'ICON_ALERT_YELLOW',
  IconArrow = 'ICON_ARROW',
  IconArticle = 'ICON_ARTICLE',
  IconArticle12 = 'ICON_ARTICLE12',
  IconAudio = 'ICON_AUDIO',
  IconBabyKids = 'ICON_BABY_KIDS',
  IconCard = 'ICON_CARD',
  IconCategoryBaby = 'ICON_CATEGORY_BABY',
  IconCategoryBeauty = 'ICON_CATEGORY_BEAUTY',
  IconCategoryCar = 'ICON_CATEGORY_CAR',
  IconCategoryClothing = 'ICON_CATEGORY_CLOTHING',
  IconCategoryCollege = 'ICON_CATEGORY_COLLEGE',
  IconCategoryEntertainment = 'ICON_CATEGORY_ENTERTAINMENT',
  IconCategoryFlowers = 'ICON_CATEGORY_FLOWERS',
  IconCategoryFood = 'ICON_CATEGORY_FOOD',
  IconCategoryFootball = 'ICON_CATEGORY_FOOTBALL',
  IconCategoryHealth = 'ICON_CATEGORY_HEALTH',
  IconCategoryHome = 'ICON_CATEGORY_HOME',
  IconCategoryPet = 'ICON_CATEGORY_PET',
  IconCategoryPhone = 'ICON_CATEGORY_PHONE',
  IconCategoryShoe = 'ICON_CATEGORY_SHOE',
  IconCheckHub = 'ICON_CHECK_HUB',
  IconCheckIn = 'ICON_CHECK_IN',
  IconCircleCheck = 'ICON_CIRCLE_CHECK',
  IconCircleClock = 'ICON_CIRCLE_CLOCK',
  IconCircleInfo = 'ICON_CIRCLE_INFO',
  IconCirclePause = 'ICON_CIRCLE_PAUSE',
  IconCircleX = 'ICON_CIRCLE_X',
  IconClose = 'ICON_CLOSE',
  IconClothing = 'ICON_CLOTHING',
  IconDepositCheck = 'ICON_DEPOSIT_CHECK',
  IconDirectDeposit = 'ICON_DIRECT_DEPOSIT',
  IconDisclosureRight = 'ICON_DISCLOSURE_RIGHT',
  IconDropPin = 'ICON_DROP_PIN',
  IconEarnJobs = 'ICON_EARN_JOBS',
  IconElectronics = 'ICON_ELECTRONICS',
  IconEntertainment = 'ICON_ENTERTAINMENT',
  IconExpand = 'ICON_EXPAND',
  IconFastQuote = 'ICON_FAST_QUOTE',
  IconFavorites = 'ICON_FAVORITES',
  IconFinancialWellness = 'ICON_FINANCIAL_WELLNESS',
  IconFlowersGifts = 'ICON_FLOWERS_GIFTS',
  IconFoodGourmet = 'ICON_FOOD_GOURMET',
  IconGradCap = 'ICON_GRAD_CAP',
  IconHealthBeauty = 'ICON_HEALTH_BEAUTY',
  IconHealthWellness = 'ICON_HEALTH_WELLNESS',
  IconHistory = 'ICON_HISTORY',
  IconHomeDecor = 'ICON_HOME_DECOR',
  IconInstant = 'ICON_INSTANT',
  IconInterstitialAchievements = 'ICON_INTERSTITIAL_ACHIEVEMENTS',
  IconInterstitialAdd = 'ICON_INTERSTITIAL_ADD',
  IconInterstitialApy = 'ICON_INTERSTITIAL_APY',
  IconInterstitialAutoRefill = 'ICON_INTERSTITIAL_AUTO_REFILL',
  IconInterstitialBank = 'ICON_INTERSTITIAL_BANK',
  IconInterstitialCalculator = 'ICON_INTERSTITIAL_CALCULATOR',
  IconInterstitialCalendar = 'ICON_INTERSTITIAL_CALENDAR',
  IconInterstitialCheck = 'ICON_INTERSTITIAL_CHECK',
  IconInterstitialCheckActive = 'ICON_INTERSTITIAL_CHECK_ACTIVE',
  IconInterstitialConfident = 'ICON_INTERSTITIAL_CONFIDENT',
  IconInterstitialCreditCard = 'ICON_INTERSTITIAL_CREDIT_CARD',
  IconInterstitialDeposit = 'ICON_INTERSTITIAL_DEPOSIT',
  IconInterstitialDocuments = 'ICON_INTERSTITIAL_DOCUMENTS',
  IconInterstitialDollar = 'ICON_INTERSTITIAL_DOLLAR',
  IconInterstitialDollarSign = 'ICON_INTERSTITIAL_DOLLAR_SIGN',
  IconInterstitialEarnJobs = 'ICON_INTERSTITIAL_EARN_JOBS',
  IconInterstitialEntries = 'ICON_INTERSTITIAL_ENTRIES',
  IconInterstitialFastQuote = 'ICON_INTERSTITIAL_FAST_QUOTE',
  IconInterstitialFeelingGood = 'ICON_INTERSTITIAL_FEELING_GOOD',
  IconInterstitialGettingStarted1 = 'ICON_INTERSTITIAL_GETTING_STARTED1',
  IconInterstitialGettingStarted2 = 'ICON_INTERSTITIAL_GETTING_STARTED2',
  IconInterstitialHealthAdd = 'ICON_INTERSTITIAL_HEALTH_ADD',
  IconInterstitialLearn = 'ICON_INTERSTITIAL_LEARN',
  IconInterstitialMatch = 'ICON_INTERSTITIAL_MATCH',
  IconInterstitialNextDay = 'ICON_INTERSTITIAL_NEXT_DAY',
  IconInterstitialNumber = 'ICON_INTERSTITIAL_NUMBER',
  IconInterstitialOffers = 'ICON_INTERSTITIAL_OFFERS',
  IconInterstitialPie = 'ICON_INTERSTITIAL_PIE',
  IconInterstitialPin = 'ICON_INTERSTITIAL_PIN',
  IconInterstitialProfile = 'ICON_INTERSTITIAL_PROFILE',
  IconInterstitialRecurring = 'ICON_INTERSTITIAL_RECURRING',
  IconInterstitialRenters = 'ICON_INTERSTITIAL_RENTERS',
  IconInterstitialRoundUp = 'ICON_INTERSTITIAL_ROUND_UP',
  IconInterstitialRoundUps = 'ICON_INTERSTITIAL_ROUND_UPS',
  IconInterstitialRoundUpBill = 'ICON_INTERSTITIAL_ROUND_UP_BILL',
  IconInterstitialSave = 'ICON_INTERSTITIAL_SAVE',
  IconInterstitialSendCheck = 'ICON_INTERSTITIAL_SEND_CHECK',
  IconInterstitialShipping = 'ICON_INTERSTITIAL_SHIPPING',
  IconInterstitialSideHustles = 'ICON_INTERSTITIAL_SIDE_HUSTLES',
  IconInterstitialSimplySpend = 'ICON_INTERSTITIAL_SIMPLY_SPEND',
  IconInterstitialSmartDeposit = 'ICON_INTERSTITIAL_SMART_DEPOSIT',
  IconInterstitialSmartDepositActive = 'ICON_INTERSTITIAL_SMART_DEPOSIT_ACTIVE',
  IconInterstitialTimer = 'ICON_INTERSTITIAL_TIMER',
  IconInterstitialTree = 'ICON_INTERSTITIAL_TREE',
  IconInterstitialTwoFactorAuth = 'ICON_INTERSTITIAL_TWO_FACTOR_AUTH',
  IconInterstitialWallet = 'ICON_INTERSTITIAL_WALLET',
  IconInvest = 'ICON_INVEST',
  IconLearningCenter = 'ICON_LEARNING_CENTER',
  IconLightningBolt = 'ICON_LIGHTNING_BOLT',
  IconLive = 'ICON_LIVE',
  IconLocalOffers = 'ICON_LOCAL_OFFERS',
  IconLocation = 'ICON_LOCATION',
  IconLock = 'ICON_LOCK',
  IconLockSolid = 'ICON_LOCK_SOLID',
  IconMiniArrowLrgDown = 'ICON_MINI_ARROW_LRG_DOWN',
  IconMiniArrowLrgUp = 'ICON_MINI_ARROW_LRG_UP',
  IconMiniArrowSmDown = 'ICON_MINI_ARROW_SM_DOWN',
  IconMiniArrowSmUp = 'ICON_MINI_ARROW_SM_UP',
  IconMiniArticle = 'ICON_MINI_ARTICLE',
  IconMiniAudio = 'ICON_MINI_AUDIO',
  IconMiniCheckmark = 'ICON_MINI_CHECKMARK',
  IconMiniIndicatorTriangle = 'ICON_MINI_INDICATOR_TRIANGLE',
  IconMiniLightningBolt = 'ICON_MINI_LIGHTNING_BOLT',
  IconMiniLock = 'ICON_MINI_LOCK',
  IconMiniNew = 'ICON_MINI_NEW',
  IconMiniPlay = 'ICON_MINI_PLAY',
  IconMiniSelectionCheck = 'ICON_MINI_SELECTION_CHECK',
  IconMinus = 'ICON_MINUS',
  IconNew = 'ICON_NEW',
  IconOneTime = 'ICON_ONE_TIME',
  IconPets = 'ICON_PETS',
  IconPlane = 'ICON_PLANE',
  IconPlayMini = 'ICON_PLAY_MINI',
  IconPlayVideo = 'ICON_PLAY_VIDEO',
  IconPlus = 'ICON_PLUS',
  IconProductBanking = 'ICON_PRODUCT_BANKING',
  IconProductBenefits = 'ICON_PRODUCT_BENEFITS',
  IconProductColorAchievements = 'ICON_PRODUCT_COLOR_ACHIEVEMENTS',
  IconProductColorEarly = 'ICON_PRODUCT_COLOR_EARLY',
  IconProductColorEarn = 'ICON_PRODUCT_COLOR_EARN',
  IconProductColorEmergencyFund = 'ICON_PRODUCT_COLOR_EMERGENCY_FUND',
  IconProductColorGrow = 'ICON_PRODUCT_COLOR_GROW',
  IconProductColorInvest = 'ICON_PRODUCT_COLOR_INVEST',
  IconProductColorInvite = 'ICON_PRODUCT_COLOR_INVITE',
  IconProductColorLater = 'ICON_PRODUCT_COLOR_LATER',
  IconProductColorLocalFoundMoney = 'ICON_PRODUCT_COLOR_LOCAL_FOUND_MONEY',
  IconProductColorProtect = 'ICON_PRODUCT_COLOR_PROTECT',
  IconProductColorSave = 'ICON_PRODUCT_COLOR_SAVE',
  IconProductColorSpend = 'ICON_PRODUCT_COLOR_SPEND',
  IconProductEarly = 'ICON_PRODUCT_EARLY',
  IconProductEarn = 'ICON_PRODUCT_EARN',
  IconProductEmergency = 'ICON_PRODUCT_EMERGENCY',
  IconProductGoHenry = 'ICON_PRODUCT_GO_HENRY',
  IconProductGrow = 'ICON_PRODUCT_GROW',
  IconProductInvest = 'ICON_PRODUCT_INVEST',
  IconProductInvestHub = 'ICON_PRODUCT_INVEST_HUB',
  IconProductInvestProduct = 'ICON_PRODUCT_INVEST_PRODUCT',
  IconProductLater = 'ICON_PRODUCT_LATER',
  IconProductProtect = 'ICON_PRODUCT_PROTECT',
  IconProductSave = 'ICON_PRODUCT_SAVE',
  IconProductSpend = 'ICON_PRODUCT_SPEND',
  IconProtected = 'ICON_PROTECTED',
  IconReversal = 'ICON_REVERSAL',
  IconRoundUps = 'ICON_ROUND_UPS',
  IconScooter = 'ICON_SCOOTER',
  IconSearch = 'ICON_SEARCH',
  IconSendCheck = 'ICON_SEND_CHECK',
  IconSendMoneyInstant = 'ICON_SEND_MONEY_INSTANT',
  IconShare = 'ICON_SHARE',
  IconShoesAccessories = 'ICON_SHOES_ACCESSORIES',
  IconSideHustles = 'ICON_SIDE_HUSTLES',
  IconSimplySpend = 'ICON_SIMPLY_SPEND',
  IconSportsOutdoors = 'ICON_SPORTS_OUTDOORS',
  IconTimer = 'ICON_TIMER',
  IconTransactionAcorns = 'ICON_TRANSACTION_ACORNS',
  IconTransactionAtm = 'ICON_TRANSACTION_ATM',
  IconTransactionBankFee = 'ICON_TRANSACTION_BANK_FEE',
  IconTransactionCheck = 'ICON_TRANSACTION_CHECK',
  IconTransactionCheckDeposit = 'ICON_TRANSACTION_CHECK_DEPOSIT',
  IconTransactionDirectDeposit = 'ICON_TRANSACTION_DIRECT_DEPOSIT',
  IconTransactionDistribution = 'ICON_TRANSACTION_DISTRIBUTION',
  IconTransactionDividend = 'ICON_TRANSACTION_DIVIDEND',
  IconTransactionEarnReward = 'ICON_TRANSACTION_EARN_REWARD',
  IconTransactionEarnRewardsMatch = 'ICON_TRANSACTION_EARN_REWARDS_MATCH',
  IconTransactionGift = 'ICON_TRANSACTION_GIFT',
  IconTransactionGoHenry = 'ICON_TRANSACTION_GO_HENRY',
  IconTransactionHamburger = 'ICON_TRANSACTION_HAMBURGER',
  IconTransactionId = 'ICON_TRANSACTION_ID',
  IconTransactionInstantRoundUp = 'ICON_TRANSACTION_INSTANT_ROUND_UP',
  IconTransactionOneTime = 'ICON_TRANSACTION_ONE_TIME',
  IconTransactionOriginalTransaction = 'ICON_TRANSACTION_ORIGINAL_TRANSACTION',
  IconTransactionRebalance = 'ICON_TRANSACTION_REBALANCE',
  IconTransactionRecurringDeposit = 'ICON_TRANSACTION_RECURRING_DEPOSIT',
  IconTransactionRefund = 'ICON_TRANSACTION_REFUND',
  IconTransactionRoundUp = 'ICON_TRANSACTION_ROUND_UP',
  IconTransactionSpendCard = 'ICON_TRANSACTION_SPEND_CARD',
  IconTransactionStatus = 'ICON_TRANSACTION_STATUS',
  IconTransactionTransferIn = 'ICON_TRANSACTION_TRANSFER_IN',
  IconTransactionTransferInOut = 'ICON_TRANSACTION_TRANSFER_IN_OUT',
  IconTransactionTransferOut = 'ICON_TRANSACTION_TRANSFER_OUT',
  IconTransactionType = 'ICON_TRANSACTION_TYPE',
  IconTransfer = 'ICON_TRANSFER',
  IconTravelTransportation = 'ICON_TRAVEL_TRANSPORTATION',
  IconTrustedPartners = 'ICON_TRUSTED_PARTNERS',
  IconUtilityAccessibility = 'ICON_UTILITY_ACCESSIBILITY',
  IconUtilityAccountDetails = 'ICON_UTILITY_ACCOUNT_DETAILS',
  IconUtilityAchievement = 'ICON_UTILITY_ACHIEVEMENT',
  IconUtilityAcorn = 'ICON_UTILITY_ACORN',
  IconUtilityAdd = 'ICON_UTILITY_ADD',
  IconUtilityAi = 'ICON_UTILITY_AI',
  IconUtilityAlert = 'ICON_UTILITY_ALERT',
  IconUtilityApy = 'ICON_UTILITY_APY',
  IconUtilityArrowLeft = 'ICON_UTILITY_ARROW_LEFT',
  IconUtilityArrowRight = 'ICON_UTILITY_ARROW_RIGHT',
  IconUtilityArExperience = 'ICON_UTILITY_AR_EXPERIENCE',
  IconUtilityBackupCodes = 'ICON_UTILITY_BACKUP_CODES',
  IconUtilityBag = 'ICON_UTILITY_BAG',
  IconUtilityBank = 'ICON_UTILITY_BANK',
  IconUtilityBankAdd = 'ICON_UTILITY_BANK_ADD',
  IconUtilityBankFees = 'ICON_UTILITY_BANK_FEES',
  IconUtilityBell = 'ICON_UTILITY_BELL',
  IconUtilityBellFilled = 'ICON_UTILITY_BELL_FILLED',
  IconUtilityBeneficiaries = 'ICON_UTILITY_BENEFICIARIES',
  IconUtilityBinoculars = 'ICON_UTILITY_BINOCULARS',
  IconUtilityBirthday = 'ICON_UTILITY_BIRTHDAY',
  IconUtilityBonds = 'ICON_UTILITY_BONDS',
  IconUtilityBook = 'ICON_UTILITY_BOOK',
  IconUtilityBookmark = 'ICON_UTILITY_BOOKMARK',
  IconUtilityBookmarkFilled = 'ICON_UTILITY_BOOKMARK_FILLED',
  IconUtilityBox = 'ICON_UTILITY_BOX',
  IconUtilityBudgeting = 'ICON_UTILITY_BUDGETING',
  IconUtilityCalendar = 'ICON_UTILITY_CALENDAR',
  IconUtilityCamera = 'ICON_UTILITY_CAMERA',
  IconUtilityCancel = 'ICON_UTILITY_CANCEL',
  IconUtilityCar = 'ICON_UTILITY_CAR',
  IconUtilityCashOwed = 'ICON_UTILITY_CASH_OWED',
  IconUtilityCellTower = 'ICON_UTILITY_CELL_TOWER',
  IconUtilityChatBubble = 'ICON_UTILITY_CHAT_BUBBLE',
  IconUtilityCheckmark = 'ICON_UTILITY_CHECKMARK',
  IconUtilityClose = 'ICON_UTILITY_CLOSE',
  IconUtilityCoin = 'ICON_UTILITY_COIN',
  IconUtilityCollapseMenu = 'ICON_UTILITY_COLLAPSE_MENU',
  IconUtilityCompanyBuilding = 'ICON_UTILITY_COMPANY_BUILDING',
  IconUtilityController = 'ICON_UTILITY_CONTROLLER',
  IconUtilityCopy = 'ICON_UTILITY_COPY',
  IconUtilityCrane = 'ICON_UTILITY_CRANE',
  IconUtilityCredit = 'ICON_UTILITY_CREDIT',
  IconUtilityCrypto = 'ICON_UTILITY_CRYPTO',
  IconUtilityCurrentLocation = 'ICON_UTILITY_CURRENT_LOCATION',
  IconUtilityCustomize = 'ICON_UTILITY_CUSTOMIZE',
  IconUtilityCustomStocks = 'ICON_UTILITY_CUSTOM_STOCKS',
  IconUtilityCyberSecurity = 'ICON_UTILITY_CYBER_SECURITY',
  IconUtilityDelete = 'ICON_UTILITY_DELETE',
  IconUtilityDocuments = 'ICON_UTILITY_DOCUMENTS',
  IconUtilityDocumentDownload = 'ICON_UTILITY_DOCUMENT_DOWNLOAD',
  IconUtilityDocumentUpload = 'ICON_UTILITY_DOCUMENT_UPLOAD',
  IconUtilityDots = 'ICON_UTILITY_DOTS',
  IconUtilityDown = 'ICON_UTILITY_DOWN',
  IconUtilityDownFilled = 'ICON_UTILITY_DOWN_FILLED',
  IconUtilityEarnJobs = 'ICON_UTILITY_EARN_JOBS',
  IconUtilityEdit = 'ICON_UTILITY_EDIT',
  IconUtilityEntries = 'ICON_UTILITY_ENTRIES',
  IconUtilityEth = 'ICON_UTILITY_ETH',
  IconUtilityExpand = 'ICON_UTILITY_EXPAND',
  IconUtilityExpandMenu = 'ICON_UTILITY_EXPAND_MENU',
  IconUtilityFace = 'ICON_UTILITY_FACE',
  IconUtilityFaceId = 'ICON_UTILITY_FACE_ID',
  IconUtilityFastQuote = 'ICON_UTILITY_FAST_QUOTE',
  IconUtilityFilter = 'ICON_UTILITY_FILTER',
  IconUtilityFlame = 'ICON_UTILITY_FLAME',
  IconUtilityFlashOff = 'ICON_UTILITY_FLASH_OFF',
  IconUtilityFlashOn = 'ICON_UTILITY_FLASH_ON',
  IconUtilityFlexible = 'ICON_UTILITY_FLEXIBLE',
  IconUtilityGift = 'ICON_UTILITY_GIFT',
  IconUtilityGoal = 'ICON_UTILITY_GOAL',
  IconUtilityGovernment = 'ICON_UTILITY_GOVERNMENT',
  IconUtilityGradCap = 'ICON_UTILITY_GRAD_CAP',
  IconUtilityHamburgerMenu = 'ICON_UTILITY_HAMBURGER_MENU',
  IconUtilityHealth = 'ICON_UTILITY_HEALTH',
  IconUtilityHeart = 'ICON_UTILITY_HEART',
  IconUtilityHeartAdd = 'ICON_UTILITY_HEART_ADD',
  IconUtilityHeartFilled = 'ICON_UTILITY_HEART_FILLED',
  IconUtilityHelp = 'ICON_UTILITY_HELP',
  IconUtilityHide = 'ICON_UTILITY_HIDE',
  IconUtilityHistory = 'ICON_UTILITY_HISTORY',
  IconUtilityHome = 'ICON_UTILITY_HOME',
  IconUtilityInfo = 'ICON_UTILITY_INFO',
  IconUtilityInvestorProfile = 'ICON_UTILITY_INVESTOR_PROFILE',
  IconUtilityInvite = 'ICON_UTILITY_INVITE',
  IconUtilityJobAlerts = 'ICON_UTILITY_JOB_ALERTS',
  IconUtilityKeypad = 'ICON_UTILITY_KEYPAD',
  IconUtilityLaptop = 'ICON_UTILITY_LAPTOP',
  IconUtilityLargeCheckmark = 'ICON_UTILITY_LARGE_CHECKMARK',
  IconUtilityLargePlus = 'ICON_UTILITY_LARGE_PLUS',
  IconUtilityLeaf = 'ICON_UTILITY_LEAF',
  IconUtilityLibrary = 'ICON_UTILITY_LIBRARY',
  IconUtilityLightbulb = 'ICON_UTILITY_LIGHTBULB',
  IconUtilityLocalOffers = 'ICON_UTILITY_LOCAL_OFFERS',
  IconUtilityLoginActivity = 'ICON_UTILITY_LOGIN_ACTIVITY',
  IconUtilityLogOut = 'ICON_UTILITY_LOG_OUT',
  IconUtilityMail = 'ICON_UTILITY_MAIL',
  IconUtilityManualLinking = 'ICON_UTILITY_MANUAL_LINKING',
  IconUtilityMapPin = 'ICON_UTILITY_MAP_PIN',
  IconUtilityMatch = 'ICON_UTILITY_MATCH',
  IconUtilityMedia = 'ICON_UTILITY_MEDIA',
  IconUtilityMenu = 'ICON_UTILITY_MENU',
  IconUtilityMobilePhone = 'ICON_UTILITY_MOBILE_PHONE',
  IconUtilityMorning = 'ICON_UTILITY_MORNING',
  IconUtilityNew = 'ICON_UTILITY_NEW',
  IconUtilityNight = 'ICON_UTILITY_NIGHT',
  IconUtilityNotifications = 'ICON_UTILITY_NOTIFICATIONS',
  IconUtilityOneTime = 'ICON_UTILITY_ONE_TIME',
  IconUtilityPassword = 'ICON_UTILITY_PASSWORD',
  IconUtilityPause = 'ICON_UTILITY_PAUSE',
  IconUtilityPet = 'ICON_UTILITY_PET',
  IconUtilityPhone = 'ICON_UTILITY_PHONE',
  IconUtilityPin = 'ICON_UTILITY_PIN',
  IconUtilityPlane = 'ICON_UTILITY_PLANE',
  IconUtilityPlug = 'ICON_UTILITY_PLUG',
  IconUtilityPointer = 'ICON_UTILITY_POINTER',
  IconUtilityPortfolioType = 'ICON_UTILITY_PORTFOLIO_TYPE',
  IconUtilityPotential = 'ICON_UTILITY_POTENTIAL',
  IconUtilityPreferences = 'ICON_UTILITY_PREFERENCES',
  IconUtilityProfile = 'ICON_UTILITY_PROFILE',
  IconUtilityQr = 'ICON_UTILITY_QR',
  IconUtilityQuestionnaire = 'ICON_UTILITY_QUESTIONNAIRE',
  IconUtilityQuestionMark = 'ICON_UTILITY_QUESTION_MARK',
  IconUtilityQuickWithdraw = 'ICON_UTILITY_QUICK_WITHDRAW',
  IconUtilityReload = 'ICON_UTILITY_RELOAD',
  IconUtilityRenters = 'ICON_UTILITY_RENTERS',
  IconUtilityRisk = 'ICON_UTILITY_RISK',
  IconUtilityRocket = 'ICON_UTILITY_ROCKET',
  IconUtilityRoundUpsRealTime = 'ICON_UTILITY_ROUND_UPS_REAL_TIME',
  IconUtilitySafari = 'ICON_UTILITY_SAFARI',
  IconUtilityScales = 'ICON_UTILITY_SCALES',
  IconUtilityScience = 'ICON_UTILITY_SCIENCE',
  IconUtilityScooter = 'ICON_UTILITY_SCOOTER',
  IconUtilitySearch = 'ICON_UTILITY_SEARCH',
  IconUtilitySettings = 'ICON_UTILITY_SETTINGS',
  IconUtilityShareAndroid = 'ICON_UTILITY_SHARE_ANDROID',
  IconUtilityShareIos = 'ICON_UTILITY_SHARE_IOS',
  IconUtilityShareLink = 'ICON_UTILITY_SHARE_LINK',
  IconUtilityShieldCheck = 'ICON_UTILITY_SHIELD_CHECK',
  IconUtilityShipping = 'ICON_UTILITY_SHIPPING',
  IconUtilityShow = 'ICON_UTILITY_SHOW',
  IconUtilitySilverware = 'ICON_UTILITY_SILVERWARE',
  IconUtilitySingleCoin = 'ICON_UTILITY_SINGLE_COIN',
  IconUtilitySmartDepositShine = 'ICON_UTILITY_SMART_DEPOSIT_SHINE',
  IconUtilitySort = 'ICON_UTILITY_SORT',
  IconUtilitySpace = 'ICON_UTILITY_SPACE',
  IconUtilitySpendCardDispute = 'ICON_UTILITY_SPEND_CARD_DISPUTE',
  IconUtilitySpendCardLocked = 'ICON_UTILITY_SPEND_CARD_LOCKED',
  IconUtilitySprayBottle = 'ICON_UTILITY_SPRAY_BOTTLE',
  IconUtilitySprout = 'ICON_UTILITY_SPROUT',
  IconUtilityStackedCoins = 'ICON_UTILITY_STACKED_COINS',
  IconUtilityStar = 'ICON_UTILITY_STAR',
  IconUtilityStocks = 'ICON_UTILITY_STOCKS',
  IconUtilitySubscription = 'ICON_UTILITY_SUBSCRIPTION',
  IconUtilitySun = 'ICON_UTILITY_SUN',
  IconUtilityTax = 'ICON_UTILITY_TAX',
  IconUtilityTextMessage = 'ICON_UTILITY_TEXT_MESSAGE',
  IconUtilityThematicInvestments = 'ICON_UTILITY_THEMATIC_INVESTMENTS',
  IconUtilityTimer = 'ICON_UTILITY_TIMER',
  IconUtilityTouchId = 'ICON_UTILITY_TOUCH_ID',
  IconUtilityTrash = 'ICON_UTILITY_TRASH',
  IconUtilityTree = 'ICON_UTILITY_TREE',
  IconUtilityTwoFactorAuth = 'ICON_UTILITY_TWO_FACTOR_AUTH',
  IconUtilityUp = 'ICON_UTILITY_UP',
  IconUtilityUpFilled = 'ICON_UTILITY_UP_FILLED',
  IconUtilityWand = 'ICON_UTILITY_WAND',
  IconUtilityWithdraw = 'ICON_UTILITY_WITHDRAW',
  IconVideo = 'ICON_VIDEO',
  IconVideo12 = 'ICON_VIDEO12',
  IconVideoControls_10SForward = 'ICON_VIDEO_CONTROLS_10S_FORWARD',
  IconVideoControls_10SRewind = 'ICON_VIDEO_CONTROLS_10S_REWIND',
  IconVideoControlsMuted = 'ICON_VIDEO_CONTROLS_MUTED',
  IconVideoControlsPause = 'ICON_VIDEO_CONTROLS_PAUSE',
  IconVideoControlsPlay = 'ICON_VIDEO_CONTROLS_PLAY',
  IconVideoControlsReplay = 'ICON_VIDEO_CONTROLS_REPLAY',
  IconVideoControlsSoundOn = 'ICON_VIDEO_CONTROLS_SOUND_ON',
  IconViews = 'ICON_VIEWS',
  IconWithdraw = 'ICON_WITHDRAW',
}

/** Identity Document Requested Alert. */
export type IdentityDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'IdentityDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export enum IdentitySubaccount {
  Bank = 'BANK',
  Invest = 'INVEST',
}

export type IdentityVerification = {
  canRetry: Maybe<Scalars['Boolean']>
  verificationStatus: VerificationStatus
}

export enum IdentityVerifiedEnum {
  Automated = 'AUTOMATED',
  Manual = 'MANUAL',
}

export type Image = {
  __typename?: 'Image'
  url: Scalars['String']
}

export enum ImageType {
  Back = 'back',
  Front = 'front',
}

export type ImplicitToken = {
  __typename?: 'ImplicitToken'
  token: Scalars['String']
}

/**
 * An abstract representation of some reward a subscriber will be afforded
 * upon subscription to some Offer.
 */
export type Incentive = {
  /**
   * Arbitrary human-readable identifier that can be used by clients
   * to localize related copy.
   */
  copyKey: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  /** Description of what the incentive provides the subscriber. */
  description: Scalars['String']
  id: Scalars['ID']
  updatedAt: Maybe<Scalars['DateTime']>
}

export type IncorrectOldPasswordException = {
  __typename?: 'IncorrectOldPasswordException'
  message: Maybe<Scalars['String']>
}

/** One of the entered deposit amounts was incorrect */
export type IncorrectRdvAmounts = {
  __typename?: 'IncorrectRdvAmounts'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export type IncorrectSecurityAnswerException = {
  __typename?: 'IncorrectSecurityAnswerException'
  message: Maybe<Scalars['String']>
}

export type IncorrectSsnException = {
  __typename?: 'IncorrectSsnException'
  message: Maybe<Scalars['String']>
}

export enum IneligibleReasons {
  CheckingAccountNotReopenable = 'CHECKING_ACCOUNT_NOT_REOPENABLE',
  InvalidCheckingAccount = 'INVALID_CHECKING_ACCOUNT',
  KycFail = 'KYC_FAIL',
  RequiredAccountsNotOpen = 'REQUIRED_ACCOUNTS_NOT_OPEN',
  SubscriptionTierIneligible = 'SUBSCRIPTION_TIER_INELIGIBLE',
}

export type InitiateBankAccountInput = {
  accountType: BankAccountType
  bankType: BankType
  goals?: InputMaybe<Array<InputMaybe<BankAccountGoalInput>>>
}

export type InitiateBankAccountResponse = {
  __typename?: 'InitiateBankAccountResponse'
  accountType: BankAccountType
  bankType: BankType
}

export type InitiateBankingKycInput = {
  accountTypes: Array<BankAccountTypeConfig>
}

export type InitiateBankingKycPayload = {
  __typename?: 'InitiateBankingKYCPayload'
  kycStatus: Maybe<KycStatus>
  message: Maybe<Scalars['String']>
  success: Maybe<Scalars['Boolean']>
}

export type InitiateChallengeInput = {
  authenticatorId: Scalars['ID']
  mfaToken: Scalars['ID']
  userId: Scalars['ID']
}

export type InitiateChallengeResult =
  | AuthenticatorNotFoundException
  | ChallengeRateExceededException
  | EmailAuthChallenge
  | InvalidMfaTokenException
  | PhoneNumberOptedOutException
  | SmsAuthChallenge

export type InitiateEmailChallengeInput = {
  email: Scalars['EmailAddress']
}

export type InitiateEmailChallengeResult =
  | ChallengeRateExceededException
  | EmailAuthChallenge
  | ExistingEmailVerifiedException

export type InitiateMoneyAssignmentInput = {
  transactionId: Scalars['ID']
}

export type InitiateMoneyAssignmentResult =
  | InitiateMoneyAssignmentSuccess
  | MoneyAssignmentAlreadyTransferredError
  | MoneyAssignmentNotFoundError

export type InitiateMoneyAssignmentSuccess = {
  __typename?: 'InitiateMoneyAssignmentSuccess'
  moneyAssignment: MoneyManagerMoneyAssignment
}

export type InitiatePushChallengeResult =
  | ChallengeRateExceededException
  | InitiatePushChallengeSuccess
  | NoRegisteredPushAuthenticatorsException

export type InitiatePushChallengeSuccess = {
  __typename?: 'InitiatePushChallengeSuccess'
  challenges: Maybe<Array<PushAuthChallenge>>
}

export type InitiateSmsChallengeInput = {
  phoneNumber: Scalars['PhoneNumber']
}

export type InitiateSmsChallengeResult =
  | ChallengeRateExceededException
  | InvalidPhoneNumberException
  | PhoneNumberOptedOutException
  | SmsAuthChallenge

export type InitiateTransferInput = {
  /** Amount of currency to transfer */
  amount: CurrencyAmountInput
  /** UUID of account to move money from */
  fromAccountId: Scalars['ID']
  /** Idempotency key for customer request */
  nonce?: InputMaybe<Scalars['ID']>
  /** UUID of account to move money into */
  toAccountId: Scalars['ID']
}

export type InitiateTransferPayload = {
  __typename?: 'InitiateTransferPayload'
  transfer: Maybe<Transfer>
}

export type InitiateVerificationResult = VerificationProfile

export type InstitutionNotSupportedError = {
  __typename?: 'InstitutionNotSupportedError'
  message: Scalars['String']
}

/** Insufficient Funds user alert. */
export type InsufficientFundsUserAlert = UserAlertsItem & {
  __typename?: 'InsufficientFundsUserAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type Intent = {
  __typename?: 'Intent'
  /** @deprecated Use `amountMicros` instead. */
  amount: CurrencyAmount
  amountMicros: MicrosMoney
  /** @deprecated Use `nonce` as the unique identifier for Intents instead. */
  id: Scalars['ID']
  nonce: Scalars['UUID']
  status: Maybe<IntentStatus>
}

/** Input the account types of the transfer. */
export type IntentFilterInput = {
  fromAccountType?: InputMaybe<Scalars['String']>
  toAccountType?: InputMaybe<Scalars['String']>
}

export enum IntentStatus {
  Authorized = 'AUTHORIZED',
  Canceled = 'CANCELED',
  Canceling = 'CANCELING',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Reversed = 'REVERSED',
  Reversing = 'REVERSING',
  Submitted = 'SUBMITTED',
}

export type InteractionRatingResponse = {
  __typename?: 'InteractionRatingResponse'
  interactionId: Scalars['String']
  message: Scalars['String']
}

/** Internal Error */
export type InternalErrorException = {
  __typename?: 'InternalErrorException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type InternalShareTransferFailed = {
  __typename?: 'InternalShareTransferFailed'
  description: Scalars['String']
}

export type InternalShareTransferInput = {
  sharePrice?: InputMaybe<Scalars['BigDecimal']>
  shareQuantity: Scalars['BigDecimal']
  symbol: Scalars['TickerSymbol']
}

/** The account number is invalid */
export type InvalidAccountNumber = {
  __typename?: 'InvalidAccountNumber'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

/** Investment Account must be a Custodial account */
export type InvalidAccountTypeException = {
  __typename?: 'InvalidAccountTypeException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Error occurred while prefilling Acorns Early data */
export type InvalidAcornsEarlyDataException = {
  __typename?: 'InvalidAcornsEarlyDataException'
  message: Maybe<Scalars['String']>
  userId: Scalars['ID']
}

export type InvalidAcornsEarlyTokenException = {
  __typename?: 'InvalidAcornsEarlyTokenException'
  message: Scalars['String']
}

/** Risk Level cannot be changed on Later and Early accounts */
export type InvalidActionOnAccount = {
  __typename?: 'InvalidActionOnAccount'
  /** message */
  message: Maybe<Scalars['String']>
}

export type InvalidAddressError = {
  __typename?: 'InvalidAddressError'
  /** Error details. Not for user display. */
  errorMessage: Maybe<Scalars['String']>
  requestId: Scalars['ID']
}

/** Invalid Address */
export type InvalidAddressException = {
  __typename?: 'InvalidAddressException'
  /** message */
  message: Maybe<Scalars['String']>
  /** List of validation errors */
  reasons: Maybe<Array<InvalidAddressReason>>
}

/** Reason for invalid address */
export type InvalidAddressReason = {
  __typename?: 'InvalidAddressReason'
  /** The address line number (1 or 2) when applicable */
  addressLine: Maybe<Scalars['Int']>
  /** Error code identifying the validation issue */
  code: InvalidAddressReasonCode
  /** Maximum allowed length when applicable */
  maxLength: Maybe<Scalars['Int']>
}

export enum InvalidAddressReasonCode {
  /** Address line exceeds maximum character length */
  AddressLineMaxLength = 'ADDRESS_LINE_MAX_LENGTH',
  /** Address line appears to contain an SSN */
  AddressLineSsnDetected = 'ADDRESS_LINE_SSN_DETECTED',
  /** Address line contains invalid special characters */
  AddressSpecialCharacters = 'ADDRESS_SPECIAL_CHARACTERS',
  /** City exceeds maximum character length */
  CityMaxLength = 'CITY_MAX_LENGTH',
  /** City contains invalid special characters */
  CitySpecialCharacters = 'CITY_SPECIAL_CHARACTERS',
  /** City appears to contain an SSN */
  CitySsnDetected = 'CITY_SSN_DETECTED',
  /** Country is invalid */
  CountryInvalid = 'COUNTRY_INVALID',
  /** Zip code format is invalid */
  InvalidZipCodeFormat = 'INVALID_ZIP_CODE_FORMAT',
  /** Address line is required */
  MissingAddressLine = 'MISSING_ADDRESS_LINE',
  /** City is required */
  MissingCity = 'MISSING_CITY',
  /** Zip code is required */
  MissingZipCode = 'MISSING_ZIP_CODE',
  /** PO Box is not allowed for residential addresses */
  PoBoxNotAllowed = 'PO_BOX_NOT_ALLOWED',
  /** State is invalid */
  StateInvalid = 'STATE_INVALID',
}

/** Allocations exceed max threshold for non managed portfolios */
export type InvalidAllocationPercentError = {
  __typename?: 'InvalidAllocationPercentError'
  /** Maximum allocation percent for the given portfolio Type */
  maxAllocationPercent: Scalars['Int']
}

/** Returned when the `apiKey` does not match the one the server is configured with. */
export type InvalidApiKeyException = {
  __typename?: 'InvalidApiKeyException'
  message: Maybe<Scalars['String']>
}

export type InvalidAppleAccountException = {
  __typename?: 'InvalidAppleAccountException'
  message: Maybe<Scalars['String']>
  subId: Maybe<Scalars['String']>
}

export type InvalidContentTypeException = {
  __typename?: 'InvalidContentTypeException'
  contentType: Scalars['String']
}

/** Occurs when exactly one conversion ID (email, phone, etc) was not provided */
export type InvalidConversionIdentifierException = {
  __typename?: 'InvalidConversionIdentifierException'
  message: Scalars['String']
}

export type InvalidCredentialsException = {
  __typename?: 'InvalidCredentialsException'
  message: Maybe<Scalars['String']>
}

export type InvalidDateException = {
  __typename?: 'InvalidDateException'
  message: Scalars['String']
}

/** Date of birth does not meet validity criteria */
export type InvalidDateOfBirthException = {
  __typename?: 'InvalidDateOfBirthException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type InvalidDeviceParametersException = {
  __typename?: 'InvalidDeviceParametersException'
  message: Maybe<Scalars['String']>
}

/** Invalid email id */
export type InvalidEmailException = {
  __typename?: 'InvalidEmailException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** The file uploaded does not have an allowed file extension */
export type InvalidFile = {
  __typename?: 'InvalidFile'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

/** First Name does not meet validity criteria */
export type InvalidFirstNameException = {
  __typename?: 'InvalidFirstNameException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type InvalidGoogleAccountException = {
  __typename?: 'InvalidGoogleAccountException'
  message: Maybe<Scalars['String']>
  subId: Maybe<Scalars['String']>
}

export type InvalidGracePeriodException = {
  __typename?: 'InvalidGracePeriodException'
  gracePeriodSeconds: Scalars['Int']
  maxGracePeriodSeconds: Scalars['Int']
  minGracePeriodSeconds: Scalars['Int']
}

export type InvalidIdentityTokenException = {
  __typename?: 'InvalidIdentityTokenException'
  message: Maybe<Scalars['String']>
}

/** Invalid Investment Account */
export type InvalidInvestmentAccountException = {
  __typename?: 'InvalidInvestmentAccountException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Last Name does not meet validity criteria */
export type InvalidLastNameException = {
  __typename?: 'InvalidLastNameException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** This account is not supported */
export type InvalidManualLink = {
  __typename?: 'InvalidManualLink'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export type InvalidMfaTokenException = {
  __typename?: 'InvalidMfaTokenException'
  userId: Maybe<Scalars['ID']>
}

export type InvalidOauthAppClientIdException = {
  __typename?: 'InvalidOauthAppClientIdException'
  oauthAppClientId: Scalars['ID']
}

export type InvalidOptionException = {
  __typename?: 'InvalidOptionException'
  message: Scalars['String']
}

export type InvalidPasswordException = {
  __typename?: 'InvalidPasswordException'
  message: Maybe<Scalars['String']>
}

export type InvalidPasswordHashException = {
  __typename?: 'InvalidPasswordHashException'
  message: Maybe<Scalars['String']>
}

export type InvalidPasswordResetException = {
  __typename?: 'InvalidPasswordResetException'
  errors: Array<PasswordResetErrors>
}

export type InvalidPasswordResetTokenException = {
  __typename?: 'InvalidPasswordResetTokenException'
  invalidToken: Scalars['String']
}

/** Invalid Phone Number */
export type InvalidPhoneException = {
  __typename?: 'InvalidPhoneException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type InvalidPhoneNumberException = {
  __typename?: 'InvalidPhoneNumberException'
  message: Maybe<Scalars['String']>
}

export type InvalidPinException = {
  __typename?: 'InvalidPinException'
  message: Maybe<Scalars['String']>
}

/** Portfolio ID must be valid */
export type InvalidPortfolioIdException = {
  __typename?: 'InvalidPortfolioIdException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** User Portfolio Ratios had an invalid sum */
export type InvalidPortfolioRatiosException = {
  __typename?: 'InvalidPortfolioRatiosException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type InvalidPromoCodeError = {
  __typename?: 'InvalidPromoCodeError'
  name: Scalars['String']
}

export type InvalidReferralRelationship = {
  __typename?: 'InvalidReferralRelationship'
  message: Scalars['String']
}

/** The routing number provided is unsupported or invalid */
export type InvalidRoutingNumber = {
  __typename?: 'InvalidRoutingNumber'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

/** The provided security is not valid for allocation */
export type InvalidSecurityError = {
  __typename?: 'InvalidSecurityError'
  /** ID of the invalid security */
  securityId: Scalars['ID']
}

/** Invalid Security For Allocation */
export type InvalidSecurityForAllocationError = {
  __typename?: 'InvalidSecurityForAllocationError'
  reason: InvalidSecurityForAllocationReasonEnum
  /** ID of the invalid security */
  securityId: Scalars['ID']
}

export enum InvalidSecurityForAllocationReasonEnum {
  SecurityDeactivated = 'SECURITY_DEACTIVATED',
}

export type InvalidSecurityForSymbolChangeError = {
  __typename?: 'InvalidSecurityForSymbolChangeError'
  error_reason: Scalars['String']
}

/** Returned when a given singleRuleId does not match with a rule in the ruleset to be updated */
export type InvalidSingleRuleIdError = {
  __typename?: 'InvalidSingleRuleIdError'
  message: Scalars['String']
}

/** Occurs when attribution does not match standardized attributes */
export type InvalidSourceAttributesException = {
  __typename?: 'InvalidSourceAttributesException'
  incorrectAttributes: Array<Scalars['String']>
}

/** SSN does not meet validity criteria */
export type InvalidSsnException = {
  __typename?: 'InvalidSsnException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Custodian is not able to open an account based on their residential address */
export type InvalidStateException = {
  __typename?: 'InvalidStateException'
  /** message */
  message: Maybe<Scalars['String']>
  /** Custodian's State */
  state: Maybe<Scalars['String']>
}

/** User is not in the correct subscription tier for the requested investment account */
export type InvalidSubscriptionTierException = {
  __typename?: 'InvalidSubscriptionTierException'
  /** User current subscription tier */
  currentUserTierKey: Maybe<Scalars['String']>
}

export type InvalidSymbolForSymbolChangeError = {
  __typename?: 'InvalidSymbolForSymbolChangeError'
  error_reason: Scalars['String']
}

/** The given termination age is not valid for the custodian's state */
export type InvalidTerminationAgeException = {
  __typename?: 'InvalidTerminationAgeException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type InvalidTier = {
  __typename?: 'InvalidTier'
  message: Scalars['String']
  validTiers: Array<Tier>
}

export type InvalidTierForMigrationError = {
  __typename?: 'InvalidTierForMigrationError'
  message: Scalars['String']
}

export type InvalidTierPrice = {
  __typename?: 'InvalidTierPrice'
  message: Scalars['String']
  validTierPrices: Array<TierPrice>
}

export type InvalidTierPriceCombination = {
  __typename?: 'InvalidTierPriceCombination'
  message: Scalars['String']
  tier: Tier
}

/** Returned if there is no available tier based on the provided tierPriceId */
export type InvalidTierPriceId = {
  __typename?: 'InvalidTierPriceId'
  message: Scalars['String']
}

export type InvalidUserIdException = {
  __typename?: 'InvalidUserIdException'
  message: Scalars['String']
}

export type InvalidUserTokenException = {
  __typename?: 'InvalidUserTokenException'
  userTokenId: Scalars['ID']
}

export type InvestHistorySummary = PastSummary & {
  __typename?: 'InvestHistorySummary'
  dividends: CurrencyAmount
  earnRewards: CurrencyAmount
  moneyIn: CurrencyAmount
  moneyOut: CurrencyAmount
  referralRewards: CurrencyAmount
  tipsReceived: Maybe<MicrosMoney>
}

/** Enum for valid keys in Investing Strategy Factors */
export enum InvestingStrategyFactorKey {
  Age = 'AGE',
  AnnualIncome = 'ANNUAL_INCOME',
  CombinedAnnualIncome = 'COMBINED_ANNUAL_INCOME',
  Employees = 'EMPLOYEES',
  EmploymentStatus = 'EMPLOYMENT_STATUS',
  FilingType = 'FILING_TYPE',
  FinancialEducation = 'FINANCIAL_EDUCATION',
  InvestmentGoal = 'INVESTMENT_GOAL',
  MaritalStatus = 'MARITAL_STATUS',
  NetWorth = 'NET_WORTH',
  NetWorthEstimate = 'NET_WORTH_ESTIMATE',
  SelfEmployedIncome = 'SELF_EMPLOYED_INCOME',
  Theme = 'THEME',
}

/** Factors affecting outcome of recommendation */
export type InvestingStrategyFactors = {
  key: InvestingStrategyFactorKey
  value: Scalars['JSON']
}

/** Investment class fields declarations and definitions */
export type Investment = {
  __typename?: 'Investment'
  allocations: Maybe<Array<InvestmentAllocation>>
  /**
   * Non-negative dollar amount invested as either a credit or debit. Debit amounts
   * are not guaranteed to match the original requested amount due to market fluctuation.
   * @deprecated Use the more explicit requestedAmount and transferredAmount fields.
   */
  amount: Scalars['Float']
  /** Amount collected by Acorns to cover owed money. */
  amountCollected: Maybe<MonetaryAmount>
  /** Total cash owed across this investment's transfer group (parent + children). */
  cashOwed: Maybe<MonetaryAmount>
  createdAt: Scalars['DateTime']
  /** @deprecated Legacy field do not use will always be null. */
  description: Maybe<Scalars['String']>
  /** @deprecated Legacy field do not use will always be null. */
  details: Maybe<Scalars['JSON']>
  /** Dividend's security name */
  dividendInvestmentSecurityName: Maybe<Scalars['String']>
  /** Dividend's security ticker */
  dividendInvestmentSecurityTicker: Maybe<Scalars['String']>
  /** Stubbed Field: Campaign ID for found money reward investment */
  earnRewardCampaignId: Maybe<Scalars['ID']>
  /** Name of partner for found money reward investment */
  earnRewardInvestmentPartner: Maybe<Scalars['String']>
  /** Url logo for found money reward investment */
  earnRewardInvestmentPartnerLogoUrl: Maybe<Scalars['URL']>
  /** Type of earn reward investment */
  earnRewardInvestmentType: Maybe<EarnRewardInvestType>
  /** Estimated date for an investment to be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>
  executionDate: Maybe<Scalars['DateTime']>
  /** Holdings Transfer Information */
  holdingsTransfer: Maybe<HoldingsTransfer>
  /** Unique identifier of the Investment. */
  id: Scalars['ID']
  /** Investment account details */
  investmentAccount: InvestmentAccount
  /** Stubbed Field: Status of investment */
  investmentStatus: Maybe<InvestmentStatusV2>
  /** Transaction type of the investment */
  investmentTransactionType: InvestmentTransactionType
  /** Stubbed Field: Type of investment */
  investmentType: Maybe<InvestmentType>
  /** An IRA Distribution or a withdraw investment for Later account */
  iraDistribution: Maybe<IraDistribution>
  moneyManagerAllocation: Maybe<MoneyManagerAllocation>
  /** Unique nonce for the investment */
  nonce: Maybe<Scalars['ID']>
  /** Note for outside contribution investment */
  outsideContributionNote: Maybe<Scalars['String']>
  /** Name of the person who made an outside contribution */
  outsideContributionNoteAuthor: Maybe<Scalars['String']>
  pending: Maybe<Scalars['Boolean']>
  /** Percentage of match a credit Match investment received */
  percentageMatch: Maybe<Scalars['Float']>
  receivedAt: Maybe<Scalars['DateTime']>
  /** Reason for the reinvestment */
  reinvestmentReason: Maybe<ReinvestmentReason>
  requestedAmount: MonetaryAmount
  reversible: Scalars['Boolean']
  /** Stubbed Field: Name for round up investment */
  roundUpMerchantName: Maybe<Scalars['String']>
  /** Stubbed Field: Multiplier for round up invesment */
  roundUpMultiplier: Maybe<Scalars['Int']>
  /** Stubbed Field: Transaction amount for round up investment */
  roundUpTransactionAmount: Maybe<MonetaryAmount>
  /** Type of the round up */
  roundUpType: Maybe<InvestmentRoundUpType>
  /** @deprecated Legacy field do not use will always be null. */
  shares: Maybe<Scalars['Int']>
  /** @deprecated Legacy field do not use will cause operations to fail. */
  status: InvestmentStatus
  /** URLs that can be used to download documentation of the trade */
  tradeConfirmationUrls: Maybe<Array<Scalars['URL']>>
  /** Stubbed Field: Exact traded amount for an investment after considering other factors; ex: cash owed deductions */
  tradedAmount: Maybe<MonetaryAmount>
  transferredAmount: Maybe<MonetaryAmount>
  type: Scalars['String']
  /** @deprecated Legacy field do not use will always be null. */
  typeHelp: Maybe<Scalars['String']>
  /** User ID for the investment */
  userId: Scalars['ID']
}

/** Investment Account Object */
export type InvestmentAccount = TimestampsInterface & {
  __typename?: 'InvestmentAccount'
  beneficiary: Maybe<Beneficiary>
  /** Internal ID of the beneficiary */
  beneficiaryId: Maybe<Scalars['ID']>
  cashBalance: MonetaryAmount
  cashOwed: MonetaryAmount
  closedAt: Maybe<Scalars['DateTime']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** The current market value of all holdings in this investment account. */
  currentBalance: Maybe<MonetaryAmount>
  /** Current Balance + Pending Balance */
  currentBalanceWithPending: MonetaryAmount
  /** Whether or not the user has made their first investment on this account. */
  hasInvested: Scalars['Boolean']
  /** Internal UUID of the Investment Account */
  id: Scalars['ID']
  investmentAccountType: InvestmentAccountType
  /** The customer's current match eligibility for this account. */
  matchEligibility: Maybe<CustomerMatchEligibility>
  /** Name of the Investment Account */
  name: Scalars['String']
  /** The net investments in this investment account. */
  netInvestments: MonetaryAmount
  /** The total value of pending transactions (deposits and withdrawals) that have not yet been traded */
  pendingBalance: MonetaryAmount
  pendingWithdrawals: Array<Withdrawal>
  performance: Maybe<Performance>
  portfolio: Maybe<Portfolio>
  portfolios: Maybe<Array<BasePortfolio>>
  product: InvestmentProduct
  /** Recap of the investment account's activity and statistics over the last quarter. */
  quarterlyRecap: Maybe<InvestmentAccountRecap>
  /** Whether or not quarterly recap generation is enabled for this investment account. */
  quarterlyRecapsEnabled: Scalars['Boolean']
  recommendedPortfolio: Maybe<Portfolio>
  recurringInvestmentSettings: Maybe<RecurringInvestmentSettings>
  /** The current status of the account */
  requirements: AccountRequirements
  /** The all-time returns in this investment account. */
  returnsAllTime: MonetaryAmount
  status: InvestmentAccountStatus
  summary: InvestmentAccountSummary
  /** The total account value in this investment account. */
  totalAccountValue: MonetaryAmount
  /** The total amount that is invested in bonds in this investment account. */
  totalBonds: MonetaryAmount
  /** The total amount that is invested in crypto in this investment account. */
  totalCrypto: MonetaryAmount
  /** The total amount that is invested in equities in this investment account. */
  totalEquities: MonetaryAmount
  /** Total matched contributions all-time. */
  totalMatched: MonetaryAmount
  /** Total matched contribution amount by tax year. */
  totalMatchedByYear: MonetaryAmount
  transferability: Maybe<InvestmentAccountTransferability>
  trustedContact: Maybe<TrustedContact>
  type: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Age of the account owner */
  userAge: Maybe<Scalars['Int']>
  /** UUID for the user */
  userId: Scalars['ID']
  /** @deprecated Use id instead. */
  uuid: Scalars['ID']
  /** Withdrawing from this account would incur a tax penalty */
  withdrawalsIncurTaxPenalty: Maybe<Scalars['Boolean']>
  yearToDateReturn: Maybe<MarketReturn>
}

/** Investment Account Object */
export type InvestmentAccountPerformanceArgs = {
  days: Scalars['Int']
}

/** Investment Account Object */
export type InvestmentAccountSummaryArgs = {
  endPeriod?: InputMaybe<Scalars['Date']>
  startPeriod?: InputMaybe<Scalars['Date']>
}

/** Investment Account Object */
export type InvestmentAccountTotalMatchedByYearArgs = {
  year: Scalars['Int']
}

export type InvestmentAccountAlreadyClosed = {
  __typename?: 'InvestmentAccountAlreadyClosed'
  /** Date and Time of account closure if account is already closed */
  accountClosedAt: Scalars['DateTime']
}

export type InvestmentAccountClosureInProgress = {
  __typename?: 'InvestmentAccountClosureInProgress'
  /** Message displayed to customer when closure is already in progress */
  clientMessage: Scalars['String']
}

export enum InvestmentAccountClosureReason {
  /** Can't afford at this time */
  CantAffordAtThisTime = 'CANT_AFFORD_AT_THIS_TIME',
  /** Change age of transfer */
  ChangeAgeOfTransfer = 'CHANGE_AGE_OF_TRANSFER',
  /** Going to a competitor */
  GoingToACompetitor = 'GOING_TO_A_COMPETITOR',
  /** Had a bad experience */
  HadABadExperience = 'HAD_A_BAD_EXPERIENCE',
  /** Not seeing the value */
  NotSeeingTheValue = 'NOT_SEEING_THE_VALUE',
  /** No longer use */
  NoLongerUse = 'NO_LONGER_USE',
  /** Other */
  Other = 'OTHER',
  /** Rolling over to another ira */
  RollingOverToAnotherIra = 'ROLLING_OVER_TO_ANOTHER_IRA',
  /** Switching to another savings plan */
  SwitchingToAnotherSavingsPlan = 'SWITCHING_TO_ANOTHER_SAVINGS_PLAN',
  /** Using funds for another purpose */
  UsingFundsForAnotherPurpose = 'USING_FUNDS_FOR_ANOTHER_PURPOSE',
  /** Using funds for the good of the child */
  WithdrawalForChild = 'WITHDRAWAL_FOR_CHILD',
}

/** The state of a customers request to close an Investment Account. Only one may be active at a time. */
export type InvestmentAccountClosureRequest = {
  __typename?: 'InvestmentAccountClosureRequest'
  id: Scalars['ID']
}

/** Generic Error */
export type InvestmentAccountCreationException = {
  __typename?: 'InvestmentAccountCreationException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Investment account must transfer funds before closure */
export type InvestmentAccountNeedsTransferException = {
  __typename?: 'InvestmentAccountNeedsTransferException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** The investment account is still open. */
export type InvestmentAccountNotClosedException = {
  __typename?: 'InvestmentAccountNotClosedException'
  /** Type of investment account */
  accountType: Maybe<InvestmentAccountType>
}

/** Investment Account Not Found */
export type InvestmentAccountNotFoundException = {
  __typename?: 'InvestmentAccountNotFoundException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Investment Account Not Supported */
export type InvestmentAccountNotSupportedException = {
  __typename?: 'InvestmentAccountNotSupportedException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Outside contribution made to an investment account. */
export type InvestmentAccountOutsideContribution = {
  __typename?: 'InvestmentAccountOutsideContribution'
  /** Monetary amount of the contribution. */
  amount: MonetaryAmount
  /** Name of the contributor */
  contributorName: Scalars['String']
  /** Note from the contributor. */
  note: Maybe<Scalars['String']>
}

/** Aggregation of investment account activity and stats over a period of time. */
export type InvestmentAccountRecap = {
  __typename?: 'InvestmentAccountRecap'
  /** Age of the investment account's beneficiary. */
  beneficiaryAge: Maybe<Scalars['Int']>
  /** Nickname of the investment account's custodian. */
  beneficiaryCustodianNickname: Maybe<Scalars['String']>
  /** First name of the investment account's beneficiary. */
  beneficiaryFirstName: Maybe<Scalars['String']>
  /** Last name of the investment account's beneficiary. */
  beneficiaryLastName: Maybe<Scalars['String']>
  /** Contributions to the investment account made by non-owners. */
  contributionsByOthers: Maybe<Array<InvestmentAccountOutsideContribution>>
  /** Creation date of the investment account recap. */
  createdAt: Scalars['Date']
  /** Start date of the investment account recap. */
  endsAt: Scalars['Date']
  /** Unique identifier of the investment account recap. */
  id: Scalars['ID']
  /** Investment account for which the recap was generated for. */
  investmentAccount: InvestmentAccount
  /** Unique identifier of the investment account for which the investment account recap was generated for. */
  investmentAccountId: Scalars['ID']
  /** Latest value of the investment account over the timeframe of the recap. */
  latestAccountValue: Maybe<MonetaryAmount>
  /** Market value of the investment account over the timeframe. */
  performance: Maybe<Performance>
  /** Whether or not the recap has public access enabled. */
  public: Scalars['Boolean']
  /** Web URL that the recap is publicly available at. */
  publicUrl: Maybe<Scalars['URL']>
  /** Start date of the investment account recap. */
  startsAt: Scalars['Date']
  /** Total amount contributed to the investment account over the timeframe. */
  totalContributions: Maybe<MonetaryAmount>
  /**
   * Total amount contributed to the investment account by non-owners over the
   * timeframe. Only applies to UGMA and UTMA type investment accounts.
   */
  totalContributionsByOthers: Maybe<MonetaryAmount>
  /** Date of last update made to the investment account recap. */
  updatedAt: Scalars['Date']
  /** Record of whether or not the recap has been viewed by the investment account owner. */
  viewed: Scalars['Boolean']
}

/** Investment Account Recap Not Found */
export type InvestmentAccountRecapNotFoundException = {
  __typename?: 'InvestmentAccountRecapNotFoundException'
  /** message */
  message: Maybe<Scalars['String']>
}

export enum InvestmentAccountReopenCheck {
  /** Account locked check */
  AccountLockedCheck = 'ACCOUNT_LOCKED_CHECK',
  /** Account suspended check */
  AccountSuspendedCheck = 'ACCOUNT_SUSPENDED_CHECK',
  /** Backup withholding check */
  BackupWithholdingCheck = 'BACKUP_WITHHOLDING_CHECK',
  /** Investment collections check */
  InvestmentCollectionsCheck = 'INVESTMENT_COLLECTIONS_CHECK',
  /** Spend collections check */
  SpendCollectionsCheck = 'SPEND_COLLECTIONS_CHECK',
  /** Underage check */
  UnderageCheck = 'UNDERAGE_CHECK',
}

/** An investment account reopen request */
export type InvestmentAccountReopenRequest = TimestampsInterface & {
  __typename?: 'InvestmentAccountReopenRequest'
  /** A list of actions performed on this account reopen request */
  adminActions: Array<InvestmentAccountReopenRequestAction>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** The ID of the reopen request */
  id: Scalars['Int']
  /** The investment account for which this reopen request was made */
  investmentAccount: InvestmentAccount
  /** The UUID of the investment account for which this request was made */
  investmentAccountId: Scalars['ID']
  /** A list of update notes for this investment account reopen request */
  notes: Array<InvestmentAccountReopenRequestNote>
  /** A list of reopen checks for this investment account reopen request */
  reopenChecks: Array<UserInvestmentAccountReopenCheck>
  /** The state of the investment account reopen request */
  state: InvestmentAccountReopenRequestState
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** The owner of the investment account associated with the reopen_request */
  user: User_V2
  /** The ID of the user to whom the investment account the request was made for belongs */
  userId: Scalars['Int']
}

/** An admin action performed on an investment account reopen request */
export type InvestmentAccountReopenRequestAction = TimestampsInterface & {
  __typename?: 'InvestmentAccountReopenRequestAction'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** The starting state of the reopen request */
  fromState: Scalars['String']
  /** The UUID of the reopen request admin action */
  id: Scalars['ID']
  /** The investment account for the corresponding reopen request */
  investmentAccount: InvestmentAccount
  /** A note associated with this action */
  note: Maybe<InvestmentAccountReopenRequestNote>
  /** The associated reopen request */
  reopenRequest: InvestmentAccountReopenRequest
  /** The end state of the reopen request */
  toState: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** A note sent to the user regarding an investment account reopen request */
export type InvestmentAccountReopenRequestNote = TimestampsInterface & {
  __typename?: 'InvestmentAccountReopenRequestNote'
  /** The action associated with this note */
  adminAction: InvestmentAccountReopenRequestAction
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** A boolean indicating if an email has been sent for this note */
  emailSent: Scalars['Boolean']
  /** The UUID of the reopen request note */
  id: Scalars['ID']
  /** The note text */
  note: Scalars['String']
  /** The associated reopen request */
  reopenRequest: InvestmentAccountReopenRequest
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export enum InvestmentAccountReopenRequestState {
  /** Indicates that the request has been approved */
  Approved = 'APPROVED',
  /** Indicates that the request must be reviewed by invest ops */
  PendingReview = 'PENDING_REVIEW',
  /** Indicates that the request is pending user action */
  PendingUserAction = 'PENDING_USER_ACTION',
  /** Indicates that the request has been rejected */
  Rejected = 'REJECTED',
  /** Indicates that the request has been made but not yet processed */
  Requested = 'REQUESTED',
}

export enum InvestmentAccountStatus {
  /** Investment account is closed */
  Closed = 'CLOSED',
  /** Investment account has reached transfer age */
  LockedForTransfer = 'LOCKED_FOR_TRANSFER',
  /** Investment account is open */
  Open = 'OPEN',
  /** Account has started account closure process */
  PendingClosure = 'PENDING_CLOSURE',
  /** Account has been created but is not fully activated/open */
  PendingOpen = 'PENDING_OPEN',
  /** Account has started account reopen process */
  PendingReopen = 'PENDING_REOPEN',
}

/** Investment account summary data */
export type InvestmentAccountSummary = {
  __typename?: 'InvestmentAccountSummary'
  /** The date of the user's first investment into this account */
  firstInvestmentDate: Maybe<Scalars['DateTime']>
  /** The date of the user's most recent one-time investment into this account */
  mostRecentOneTimeInvestmentDate: Maybe<Scalars['DateTime']>
  /**
   * The total credits credited to this account.
   * @deprecated Use referral_rewards and found_money_rewards instead
   */
  totalCredits: Scalars['Float']
  /** The total amount deposited by the user into this account. Does not include rewards */
  totalDeposits: Scalars['Float']
  /** The total amount contributed by the user on the current year for this account */
  totalDepositsCurrentYear: Scalars['Float']
  /** The total amount contributed by the user on the current year within the specified timeframe for this account */
  totalDepositsCurrentYearWithinTimeFrame: Scalars['Float']
  /** The total amount contributed by the user on the previous year for this account */
  totalDepositsPreviousYear: Scalars['Float']
  /** The total dividends invested in this account. */
  totalDividends: Scalars['Float']
  /** The total found money rewards allocated to this account */
  totalFoundMoneyRewards: Scalars['Float']
  /** The total amount invested into this account. Includes rewards */
  totalInvested: Scalars['Float']
  /**
   * The total amount contributed by the user on the current year for this account
   * @deprecated Use total_deposits_current_year
   */
  totalInvestedCurrentYear: Scalars['Float']
  /**
   * The total amount invested into this account. Includes rewards but excludes
   * investments created from Acorns Transfer such as from checking or emergency fund
   */
  totalInvestedExcludingAcornsBanking: Scalars['Float']
  /**
   * The total amount contributed by the user on the previous year for this account
   * @deprecated Use total_deposits_previous_year
   */
  totalInvestedPreviousYear: Scalars['Float']
  /** The total amount matched rewarded */
  totalMatchRewards: Scalars['Float']
  /** The total amount of matched rewards removed */
  totalMatchRewardsRemovalAmount: Scalars['Float']
  /** The total one time investments made in this account. */
  totalOneTime: Scalars['Float']
  /** The total outside contributions to this account. */
  totalOutsideContributions: Scalars['Float']
  /** The total plan investments invested with this account. */
  totalPlan: Scalars['Float']
  /** The recurring investment total invested in this account. */
  totalRecurring: Scalars['Float']
  /** The total referral rewards to this account. */
  totalReferralRewards: Scalars['Float']
  /** The total round ups contributed to this account. */
  totalRoundUps: Scalars['Float']
  /** The total real time round ups contributed to this account. */
  totalRtru: Scalars['Float']
  /** The total tips contributed to this account. */
  totalTips: Scalars['Float']
  /** The total amount withdrawn for this account */
  totalWithdrawn: Scalars['Float']
  /** The total amount withdrawn for this account. Excludes withdrawn to Acorns accounts such as from checking or emergency fund */
  totalWithdrawnExcludingAcornsBanking: Scalars['Float']
}

/** Transfer information for the given investment account */
export type InvestmentAccountTransferability = {
  __typename?: 'InvestmentAccountTransferability'
  /** The beneficiary investment account's age of transfer */
  transferAge: Scalars['Int']
  /** The beneficiary investment account's date of transfer */
  transferDate: Scalars['Date']
  /** The beneficiary investment account's age of transfer reached */
  transferReached: Scalars['Boolean']
  /** The beneficiary investment account's state of residence */
  transferStateCode: UsStateCodes
}

export enum InvestmentAccountType {
  /** Basic investment account */
  BasicInvestment = 'BASIC_INVESTMENT',
  /** Roth IRA investment account */
  RothIra = 'ROTH_IRA',
  /** Simplified Employee Pension investment account */
  SimplifiedEmployeePension = 'SIMPLIFIED_EMPLOYEE_PENSION',
  /** Traditional IRA investment account */
  TraditionalIra = 'TRADITIONAL_IRA',
  /** Uniform Gift to Minors Act Custodial Investment Account */
  Ugma = 'UGMA',
  /** Uniform Transfer to Minors Act Custodial Investment Account */
  Utma = 'UTMA',
  /** @deprecated Use BASIC_INVESTMENT. */
  AcornsInvestingAccount = 'acornsInvestingAccount',
  /** @deprecated Use ROTH_IRA */

  /** @deprecated Use SIMPLIFIED_EMPLOYEE_PENSION */

  /** @deprecated Use TRADITIONAL_IRA. */
}

export enum InvestmentAccountTypes {
  RothIra = 'RothIRA',
  SimplifiedEmployeePension = 'SimplifiedEmployeePension',
  TraditionalIra = 'TraditionalIRA',
}

/** Filter for InvestmentAccountsByUserId query */
export type InvestmentAccountsByUserIdFilter = {
  /** Optionally filter by account status */
  accountStatus?: InputMaybe<InvestmentAccountStatus>
  /** Investment Account Product Name */
  product?: InputMaybe<InvestmentProduct>
}

/** Additional pagination information */
export type InvestmentAggregation = {
  __typename?: 'InvestmentAggregation'
  totalPendingAmount: Maybe<MonetaryAmount>
}

/** Amount of an asset that was bought or sold for a specific Investment. */
export type InvestmentAllocation = {
  __typename?: 'InvestmentAllocation'
  /** Dollar amount sold or bought of the associated security. */
  amount: Scalars['Float']
  /** Price that the shares of the associated security were bought or sold at. */
  price: MonetaryAmount
  /** Indicates whether the shares were allocated to a self-directed Portfolio. */
  selfDirected: Scalars['Boolean']
  /** Shares sold or bought of the associated security. */
  shares: Scalars['Float']
  /** Indicates the state of the holding allocated to the portfolio. */
  status: InvestmentAllocationStatus
  /** Trading symbol of the associated security. */
  symbol: Scalars['String']
  /** Indicates the type of holding allocated to the portfolio. */
  type: InvestmentAllocationType
}

export enum InvestmentAllocationStatus {
  /** Shares that have been returned due to a declined funding transfer. */
  Chargeback = 'CHARGEBACK',
  /** Shares that have been bought or sold but are not yet settled to the account. */
  Pending = 'PENDING',
  /** Shares that have settled in the account. */
  Settled = 'SETTLED',
}

export enum InvestmentAllocationType {
  Buy = 'BUY',
  Sell = 'SELL',
}

export type InvestmentCategory = {
  __typename?: 'InvestmentCategory'
  bond: Scalars['Float']
  crypto: Scalars['Float']
  equity: Scalars['Float']
  realEstate: Scalars['Float']
}

/** An individual edge within the paginated list of Investment */
export type InvestmentEdge = {
  __typename?: 'InvestmentEdge'
  /** The unique key used for pagination */
  cursor: Scalars['ID']
  /** The Investment record in the edge */
  node: Investment
}

export enum InvestmentFrequency {
  Daily = 'daily',
  Monthly = 'monthly',
  Weekly = 'weekly',
}

export enum InvestmentGoal {
  /** User is looking for a balanced portfolio */
  Balanced = 'BALANCED',
  /** User is looking for conservative growth in their investments */
  Conservative = 'CONSERVATIVE',
  /** User is looking for exponential growth in their investments */
  ExponentialGrowth = 'EXPONENTIAL_GROWTH',
  /** User is looking for moderate growth in their investments */
  ModerateGrowth = 'MODERATE_GROWTH',
  /** User is looking to reduce risk in their investments */
  ReducedRisk = 'REDUCED_RISK',
}

/** When investment id and investment account id do not match */
export type InvestmentNotFoundException = {
  __typename?: 'InvestmentNotFoundException'
  /** ID */
  id: Maybe<Scalars['ID']>
}

/** Relay style pagination information for Investment */
export type InvestmentPagination = {
  __typename?: 'InvestmentPagination'
  aggregation: Maybe<InvestmentAggregation>
  edges: Array<InvestmentEdge>
  pageInfo: PageInfo
}

/**
 * Chart for one product (EARLY, INVEST, LATER) or ALL of them.
 * `accountId` narrows a product to one of its accounts.
 */
export type InvestmentPerformanceWidget = {
  __typename?: 'InvestmentPerformanceWidget'
  accountId: Maybe<Scalars['String']>
  scope: PerformanceWidgetProductScope
}

export enum InvestmentProduct {
  /** Early investment product */
  Early = 'EARLY',
  /** Invest investment product */
  Invest = 'INVEST',
  /** Later investment product */
  Later = 'LATER',
}

export enum InvestmentRoundUpType {
  Automatic = 'AUTOMATIC',
  RealTime = 'REAL_TIME',
}

export enum InvestmentStatus {
  All = 'all',
  Finished = 'finished',
  Unfinished = 'unfinished',
}

/** Investment statuses that are used by frontend clients and external queries */
export enum InvestmentStatusV2 {
  /** Investment not translated */
  NotTranslated = 'NOT_TRANSLATED',
  /** Investment pending authorization */
  Pending = 'PENDING',
  /** Investment refunded */
  Refunded = 'REFUNDED',
  /** Investment returned */
  Returned = 'RETURNED',
  /** Investment reversed */
  Reversed = 'REVERSED',
  /** Investment revoked */
  Revoked = 'REVOKED',
  /** Investment settled */
  Settled = 'SETTLED',
  /** Investment transferred */
  Transferring = 'TRANSFERRING',
}

export enum InvestmentTransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
}

/** All investment types */
export enum InvestmentType {
  AutomatedRebalance = 'AUTOMATED_REBALANCE',
  CashOwedCollection = 'CASH_OWED_COLLECTION',
  CashReinvestment = 'CASH_REINVESTMENT',
  DirectDepositSplit = 'DIRECT_DEPOSIT_SPLIT',
  Dividend = 'DIVIDEND',
  EarlyGift = 'EARLY_GIFT',
  EarnReward = 'EARN_REWARD',
  Fee = 'FEE',
  GiftCard = 'GIFT_CARD',
  HoldingsTransfer = 'HOLDINGS_TRANSFER',
  IraTransfer = 'IRA_TRANSFER',
  Match = 'MATCH',
  MatchRemoval = 'MATCH_REMOVAL',
  OneTimeInvestment = 'ONE_TIME_INVESTMENT',
  RecurringInvestment = 'RECURRING_INVESTMENT',
  Refund = 'REFUND',
  Reversal = 'REVERSAL',
  RoundUp = 'ROUND_UP',
  SecurityLiquidation = 'SECURITY_LIQUIDATION',
  Tip = 'TIP',
  Withdrawal = 'WITHDRAWAL',
}

/** Types of investments available */
export enum InvestmentTypes {
  /** Credit investment (lump sum deposit) */
  Credit = 'credit',
  /** Debit investment (withdrawal) */
  Debit = 'debit',
}

/** Investment cannot be cancelled */
export type InvestmentUncancellableException = {
  __typename?: 'InvestmentUncancellableException'
  /** ID */
  id: Maybe<Scalars['ID']>
}

/** Investments Paused user alert. */
export type InvestmentsPausedUserAlert = UserAlertsItem & {
  __typename?: 'InvestmentsPausedUserAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type InvestorQuestionsInput = {
  employedAffiliatedWithBrokerDealer?: InputMaybe<Scalars['Boolean']>
  shareholderOrDirector?: InputMaybe<Scalars['Boolean']>
  subjectToBackupWithholding?: InputMaybe<Scalars['Boolean']>
}

export type Invitation = {
  __typename?: 'Invitation'
  createdAt: Scalars['DateTime']
  id: Scalars['ReferralCode']
}

/** Type wrapper for the Invoice object from the billing vendor */
export type Invoice = {
  __typename?: 'Invoice'
  account: Maybe<VendorCustomerAccount>
  id: Maybe<Scalars['String']>
  lineItems: Maybe<Array<Maybe<InvoiceLineItem>>>
  lineItemsAmountSum: Maybe<Scalars['Float']>
  /**
   * Default type for state is 'all'.
   * Possible types are 'open', 'pending', 'processing', 'past_due', 'paid', 'closed', 'failed', 'voided'
   */
  state: Maybe<Scalars['String']>
  uuid: Maybe<Scalars['String']>
}

export type InvoiceCollection = {
  __typename?: 'InvoiceCollection'
  chargeInvoice: Maybe<Invoice>
  creditInvoices: Maybe<Array<Maybe<Invoice>>>
  object: Maybe<Scalars['String']>
}

export type InvoiceFundingSource = {
  __typename?: 'InvoiceFundingSource'
  uuid: Maybe<Scalars['ID']>
}

export type InvoiceItem = {
  __typename?: 'InvoiceItem'
  amount: Scalars['Float']
  createdAt: Scalars['DateTime']
  discount: Maybe<Scalars['Float']>
  discountAmount: Maybe<Scalars['Float']>
  feeCategory: Scalars['String']
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
}

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem'
  addOnCode: Maybe<Scalars['String']>
  addOnId: Maybe<Scalars['String']>
  amount: Maybe<Scalars['Float']>
  description: Maybe<Scalars['String']>
  discount: Maybe<Scalars['Float']>
  id: Maybe<Scalars['String']>
  object: Maybe<Scalars['String']>
  origin: Maybe<Scalars['String']>
  /** Possible types are 'invoiced' and 'pending' */
  state: Maybe<Scalars['String']>
  subtotal: Maybe<Scalars['Float']>
  type: Maybe<Scalars['String']>
}

/** Job alert display info */
export type JobAlert = {
  __typename?: 'JobAlert'
  id: Scalars['ID']
  /** desired job description */
  keyPhrase: Scalars['String']
  /** desired job location */
  location: Scalars['String']
}

/** Specifies the alert criteria */
export type JobAlertCriteriaInput = {
  filters: Array<JobSearchFilterInput>
  location: JobLocationInput
}

export type JobLocation = {
  __typename?: 'JobLocation'
  city: Maybe<Scalars['String']>
  state: Maybe<Scalars['String']>
  value: Maybe<Scalars['String']>
}

export type JobLocationInput = {
  city?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  /** flexible text field to input location as a single string (e.g. "New York, NY 10010" */
  value?: InputMaybe<Scalars['String']>
}

export type JobOffer = {
  __typename?: 'JobOffer'
  /** Company logo or generic default */
  companyLogo: Image
  /** Hiring company */
  companyName: Scalars['String']
  id: Scalars['ID']
  /** Relevant job industry */
  industryName: Maybe<Scalars['String']>
  /** Job role */
  jobName: Scalars['String']
  /** Job location */
  location: OfferLocation
  /** Salary details */
  salary: Maybe<JobOfferSalary>
  /** List of tags to display */
  tags: Array<Scalars['String']>
  /** Redirect URL for job posting */
  url: Scalars['URL']
}

export type JobOfferSalary = {
  __typename?: 'JobOfferSalary'
  interval: SalaryInterval
  maxValue: Scalars['Float']
  minValue: Scalars['Float']
}

/** Specifies the search criteria */
export type JobSearchCriteria = {
  __typename?: 'JobSearchCriteria'
  filters: Array<JobSearchFilter>
  location: JobLocation
  /** Specifies the search radius in miles */
  searchRadius: Maybe<Scalars['Int']>
}

/** Specifies the search criteria */
export type JobSearchCriteriaInput = {
  filters: Array<JobSearchFilterInput>
  location: JobLocationInput
  searchRadius?: InputMaybe<Scalars['Int']>
}

/** Specifies which values to filter jobs by */
export type JobSearchFilter = {
  __typename?: 'JobSearchFilter'
  key: JobSearchFilterKey
  value: Scalars['String']
}

/** Specifies which values to filter jobs by */
export type JobSearchFilterInput = {
  key: JobSearchFilterKey
  value: Scalars['String']
}

/** Supported types of search criteria */
export enum JobSearchFilterKey {
  /** finds jobs with exact match for company name */
  Company = 'COMPANY',
  /** finds jobs that have metadata matching this phrase */
  KeyPhrase = 'KEY_PHRASE',
}

/** Display wrapper for featured job searches */
export type JobSearchOffer = {
  __typename?: 'JobSearchOffer'
  /** Background/featured image */
  backgroundImage: Image
  /** Display body for the offer */
  body: Maybe<Scalars['String']>
  /** Desktop Background/featured image */
  desktopBackgroundImage: Image
  id: Scalars['ID']
  /** Company/partner logo */
  logo: Maybe<Image>
  /** List of filters used when searching for jobs */
  searchFilters: Array<JobSearchFilter>
  /** Display subtitle for the offer */
  subtitle: Maybe<Scalars['String']>
  /** Display title for the offer */
  title: Scalars['String']
}

export type JobSearchPage = {
  __typename?: 'JobSearchPage'
  recentSearches: Array<JobSearchCriteria>
}

export enum KycStatus {
  Accepted = 'accepted',
  ActionRequired = 'actionRequired',
  Failure = 'failure',
  Pending = 'pending',
}

export type LadderLinkResponse = {
  __typename?: 'LadderLinkResponse'
  id: Scalars['ID']
  url: Scalars['String']
  urlExpires: Scalars['Int']
}

export type LadderQuote = {
  __typename?: 'LadderQuote'
  coverage: Maybe<Scalars['Int']>
  monthlyPremium: Maybe<Scalars['Float']>
  term: Maybe<Scalars['Int']>
}

export type LadderQuoteStatus = {
  __typename?: 'LadderQuoteStatus'
  complete: Maybe<Scalars['Boolean']>
  eligible: Maybe<Scalars['Boolean']>
  valid: Maybe<Scalars['Boolean']>
}

export type LadderResponse = {
  __typename?: 'LadderResponse'
  id: Scalars['String']
  quoteStatus: Maybe<LadderQuoteStatus>
  quotes: Array<Maybe<LadderQuote>>
}

/** Object for a Later Account */
export type LaterAccount = {
  __typename?: 'LaterAccount'
  /** Unique identifier of the Later Account. */
  accountId: Scalars['ID']
  /** Account number of the Later Account. */
  accountNumber: Maybe<Scalars['String']>
  /** Amount of the Later Account. */
  amount: Scalars['Float']
  /** Code of the Later Account. */
  code: LaterAccountCodes
  /** Contribution limit of the Later Account. */
  contributionLimit: Scalars['Float']
  /** Name of the Later Account. */
  name: Scalars['String']
  /** Performance of the Later Account. */
  performance: Maybe<LaterPortfolioPerformance>
  /** Portfolio ID of the Later Account. */
  portfolioId: Scalars['ID']
  /** Name of the portfolio of the Later Account. */
  portfolioName: Scalars['String']
  /** Recurring investment settings for the account. */
  recurringSettings: Maybe<RecurringInvestmentSettings>
  /** Status of the Later Account. */
  status: Maybe<LaterAccountStatus>
}

export type LaterAccountAlreadyVerified = LaterTypedException & {
  __typename?: 'LaterAccountAlreadyVerified'
  id: Scalars['ID']
  message: Scalars['String']
}

/** All later account codes */
export enum LaterAccountCodes {
  Roth = 'ROTH',
  Sep = 'SEP',
  Traditional = 'TRADITIONAL',
}

export type LaterAccountIneligibleForVerification = LaterTypedException & {
  __typename?: 'LaterAccountIneligibleForVerification'
  id: Scalars['ID']
  message: Scalars['String']
}

export type LaterAccountInfo = {
  __typename?: 'LaterAccountInfo'
  investmentAccountId: Scalars['ID']
  plan: InvestmentAccountTypes
  status: LaterAccountStatus
  userId: Scalars['ID']
}

export type LaterAccountInfoOrError =
  | LaterAccountAlreadyVerified
  | LaterAccountIneligibleForVerification
  | LaterAccountInfo
  | LaterAccountNotFound

export type LaterAccountNotFound = LaterTypedException & {
  __typename?: 'LaterAccountNotFound'
  id: Scalars['ID']
  message: Scalars['String']
}

/** When required taxWithholdings information was not provided for a Later account */
export type LaterAccountRequiresTaxWithholdings = {
  __typename?: 'LaterAccountRequiresTaxWithholdings'
  /** message */
  errorMessage: Maybe<Scalars['String']>
}

/** When required withdrawalReason information was not provided for a Later account */
export type LaterAccountRequiresWithdrawalReason = {
  __typename?: 'LaterAccountRequiresWithdrawalReason'
  /** message */
  errorMessage: Maybe<Scalars['String']>
}

/** All later account statuses */
export enum LaterAccountStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  FailedToCreate = 'FAILED_TO_CREATE',
  Hidden = 'HIDDEN',
  Inactive = 'INACTIVE',
  Pending = 'PENDING',
}

/** When the sum of the required taxWithholdings information exceeded 100 */
export type LaterAccountTaxWithholdingsPercentageExceeded = {
  __typename?: 'LaterAccountTaxWithholdingsPercentageExceeded'
  /** message */
  errorMessage: Maybe<Scalars['String']>
}

export type LaterBeneficiary = {
  accountId: Scalars['String']
  beneficiaryId: Maybe<Scalars['ID']>
  percentageShare: Maybe<Scalars['Float']>
  type: Maybe<BeneficiaryType>
}

/** Legacy contribution ability response */
export type LaterContributionAbilityResult = ContributionAbilityByYear

export type LaterContributionLimitMet = {
  __typename?: 'LaterContributionLimitMet'
  year: Scalars['Int']
}

/** Sell shares to pay down cash owed by the customer. */
export type LaterDebtCollectionItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'LaterDebtCollectionItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type LaterDividendsItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'LaterDividendsItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    etfCategory: Scalars['String']
    etfTicker: Scalars['String']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Sell shares for the fee. This happens for Paypal users or if users never accepted the new EFT */
export type LaterFeeInvestmentItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'LaterFeeInvestmentItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type LaterFullContributionSuccess = {
  __typename?: 'LaterFullContributionSuccess'
  year: Scalars['Int']
}

export type LaterHistoryItem = {
  amount: Scalars['Float']
  date: Scalars['DateTime']
  pending: Maybe<Scalars['Boolean']>
  reversible: Maybe<Scalars['Boolean']>
  status: Scalars['String']
  taxYear: Scalars['Int']
  tradeConfirmUrl: Maybe<Scalars['String']>
  type: Maybe<LaterHistoryItemType>
}

export enum LaterHistoryItemType {
  Deposit = 'deposit',
  Rollover = 'rollover',
  Transfer = 'transfer',
  Withdrawal = 'withdrawal',
}

export type LaterHistorySummary = PastSummary & {
  __typename?: 'LaterHistorySummary'
  currentYear: Scalars['String']
  currentYearContributions: MicrosMoney
  dividends: CurrencyAmount
  iraMatchRewards: CurrencyAmount
  moneyIn: CurrencyAmount
  moneyOut: CurrencyAmount
  previousYear: Scalars['String']
  previousYearContributions: CurrencyAmount
}

export type LaterIndividualBeneficiary = LaterBeneficiary & {
  __typename?: 'LaterIndividualBeneficiary'
  accountId: Scalars['String']
  addressLine1: Maybe<Scalars['String']>
  addressLine2: Maybe<Scalars['String']>
  beneficiaryId: Maybe<Scalars['ID']>
  birthDate: Scalars['DateTime']
  city: Maybe<Scalars['String']>
  country: Maybe<Scalars['String']>
  firstName: Scalars['String']
  lastName: Scalars['String']
  percentageShare: Maybe<Scalars['Float']>
  relationship: Scalars['String']
  state: Maybe<Scalars['String']>
  type: Maybe<BeneficiaryType>
  zip: Maybe<Scalars['String']>
}

export type LaterIndividualBeneficiaryResponse = {
  __typename?: 'LaterIndividualBeneficiaryResponse'
  accountId: Scalars['ID']
  addressLine1: Maybe<Scalars['String']>
  addressLine2: Maybe<Scalars['String']>
  beneficiaryId: Scalars['ID']
  birthDate: Maybe<Scalars['DateTime']>
  city: Maybe<Scalars['String']>
  country: Maybe<Scalars['String']>
  firstName: Scalars['String']
  lastName: Scalars['String']
  percentageShare: Maybe<Scalars['Float']>
  relationship: Scalars['String']
  state: Maybe<Scalars['String']>
  zip: Maybe<Scalars['String']>
}

/** A generic money movement line item for the Later account */
export type LaterInvestmentItem = PastCoreTradedItem &
  PastItem &
  PastUserTransferItem & {
    __typename?: 'LaterInvestmentItem'
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** The percentage that the user elected for withholding */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A matching investment made into a customers account by the firm. */
export type LaterMatchItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'LaterMatchItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A removal of matching investments made into a customers account by the firm. */
export type LaterMatchRemovalItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'LaterMatchRemovalItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type LaterPartialContributionSuccess = {
  __typename?: 'LaterPartialContributionSuccess'
  acceptedAmount: CurrencyAmount
  year: Scalars['Int']
}

/** Performance of a Later Portfolio */
export type LaterPortfolioPerformance = {
  __typename?: 'LaterPortfolioPerformance'
  /** Period market change of the Later Portfolio. */
  periodMarketChange: Scalars['Float']
  /** Period market change percent of the Later Portfolio. */
  periodMarketChangePercent: Scalars['Float']
  /** Period market change percent without fees of the Later Portfolio. */
  periodMarketChangePercentWithoutFees: Scalars['Float']
  /** Period market change without fees of the Later Portfolio. */
  periodMarketChangeWithoutFees: Scalars['Float']
}

export type LaterProgramAccountContributionInput = {
  amount: CurrencyAmountInput
  fundingTransferCreated?: InputMaybe<Scalars['Boolean']>
  nonce: Scalars['ID']
  programAccountType: ProgramAccountType
  year?: InputMaybe<Scalars['Int']>
}

export type LaterProgramAccountContributionResult =
  | LaterContributionLimitMet
  | LaterFullContributionSuccess
  | LaterPartialContributionSuccess

export type LaterRebalanceItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'LaterRebalanceItem'
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Cash that is refunded to the customer */
export type LaterRefundedItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'LaterRefundedItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Cash that is reinvested into the investment account */
export type LaterReinvestmentItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'LaterReinvestmentItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type LaterTypedException = {
  id: Scalars['ID']
  message: Scalars['String']
}

/** Object representing an outside contribution prospect */
export type LaterWaitlistProspect = Prospect & {
  __typename?: 'LaterWaitlistProspect'
  email: Scalars['String']
  id: Scalars['ID']
}

export type LaterWithdrawal = LaterHistoryItem & {
  __typename?: 'LaterWithdrawal'
  amount: Scalars['Float']
  date: Scalars['DateTime']
  earlyDistributionTaxExceptionReason: Maybe<Scalars['String']>
  federalTaxes: Maybe<Scalars['Float']>
  name: Scalars['String']
  pending: Maybe<Scalars['Boolean']>
  reversible: Maybe<Scalars['Boolean']>
  stateTaxes: Maybe<Scalars['Float']>
  status: Scalars['String']
  taxYear: Scalars['Int']
  tradeConfirmUrl: Maybe<Scalars['String']>
  type: Maybe<LaterHistoryItemType>
  withdrawalId: Scalars['ID']
  withdrawalType: Maybe<LaterWithdrawalType>
}

export type LaterWithdrawalItem = PastCoreTradedItem &
  PastItem &
  PastUserTransferItem & {
    __typename?: 'LaterWithdrawalItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    federalWithholdings: Maybe<LaterWithholdingValues>
    /** Past Item ID */
    id: Scalars['ID']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    stateWithholdings: Maybe<LaterWithholdingValues>
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Reason for withdrawing from a later account */
export enum LaterWithdrawalReason {
  DirectTransfer = 'direct_transfer',
  EarlyWithdrawal = 'early_withdrawal',
  OverContribution = 'over_contribution',
  Retirement = 'retirement',
  Rollover = 'rollover',
}

/** Reason for withdrawing from a later account Deprecated - this can be derived from the LaterWithdrawalReason below */
export enum LaterWithdrawalType {
  EarlyDistribution = 'EarlyDistribution',
  IneligibleContribution = 'IneligibleContribution',
  NormalDistribution = 'NormalDistribution',
}

/** Tuple of fields related to withholdings elected at either the state or federal level */
export type LaterWithholdingValues = {
  __typename?: 'LaterWithholdingValues'
  amount: CurrencyAmount
  /** The percentage that the user elected for withholding */
  percentage: Scalars['Float']
}

/** Customer information used for link session */
export type LayerLinkSession = {
  __typename?: 'LayerLinkSession'
  /** City associated with address of customer */
  city: Maybe<Scalars['String']>
  /** Country associated with address of customer */
  country: Maybe<Scalars['String']>
  /** Date of birth of customer */
  dateOfBirth: Maybe<Scalars['Date']>
  /** First name of customer */
  firstName: Maybe<Scalars['String']>
  /** Last name of customer */
  lastName: Maybe<Scalars['String']>
  linkedSubaccounts: Maybe<Array<LinkedSubaccount>>
  /** Phone number of customer */
  phoneNumber: Scalars['String']
  /** SSN of customer */
  ssn: Maybe<Scalars['String']>
  /** State associated with address of customer */
  state: Maybe<Scalars['String']>
  /** Street associated with address of customer */
  street1: Maybe<Scalars['String']>
  /** Street (line 2) associated with address of customer */
  street2: Maybe<Scalars['String']>
  /** Zip code associated with address of customer */
  zipCode: Maybe<Scalars['String']>
}

/** Attributes for identifiers to create Layer session */
export type LayerLinkSessionInput = {
  /** Code to authorize user-permissioned identity information */
  publicToken: Scalars['String']
}

export type LearnAnswer = {
  __typename?: 'LearnAnswer'
  id: Scalars['ID']
  isCorrect: Scalars['Boolean']
  value: Scalars['String']
}

export type LearnAnswerInput = {
  id: Scalars['ID']
  value: Scalars['String']
}

export type LearnArticle = {
  __typename?: 'LearnArticle'
  authors: Array<LearnAuthor>
  body: Scalars['String']
  contentImage: Maybe<LearnVisualAsset>
  disclaimer: Scalars['String']
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  featuredVideos: Array<LearnMediaReference>
  id: Scalars['ID']
  learnProductKey: Maybe<LearnProductKey>
  mainBody: Scalars['String']
  metadata: LearnMetadata
  publishedAt: Maybe<Scalars['String']>
  summary: Scalars['String']
  tags: Array<LearnTag>
  /** @deprecated Tier will be removed */
  tier: LearnTier
  title: Scalars['String']
  topics: Array<LearnTopic>
}

export type LearnArticlePreview = {
  __typename?: 'LearnArticlePreview'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  isCompleted: Scalars['Boolean']
  primaryTopicName: Scalars['String']
  productRequired: Maybe<Scalars['String']>
  progress: Maybe<LearnProgress>
  /** @deprecated tierName is being replaced by productRequired */
  tierName: Scalars['String']
  title: Scalars['String']
  views: Scalars['Int']
}

export type LearnArticlePreviewLocked = {
  __typename?: 'LearnArticlePreviewLocked'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  lockedReason: Maybe<Scalars['String']>
  primaryTopicName: Scalars['String']
  productRequired: Scalars['String']
  title: Scalars['String']
  views: Scalars['Int']
}

export enum LearnAspectRatioType {
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT',
}

export type LearnAuthor = {
  __typename?: 'LearnAuthor'
  description: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
  photo: Maybe<LearnVisualAsset>
}

export type LearnConnection = {
  edges: Array<LearnEdge>
  pageInfo: LearnPageInfo
}

export type LearnContentCategory = LearnTier | LearnTopic

export type LearnContentCommunityStats = LearnContentStats

export type LearnContentDuration = Milliseconds

export type LearnContentElapsedMillisecondsUpdatedResult = {
  __typename?: 'LearnContentElapsedMillisecondsUpdatedResult'
  contentId: Scalars['ID']
  elapsedTime: Milliseconds
}

export type LearnContentFilterByTierIdInput = {
  contentType?: InputMaybe<LearnSearchContentType>
  durationMillisecondsEnd?: InputMaybe<MillisecondsInput>
  durationMillisecondsStart?: InputMaybe<MillisecondsInput>
  tierId: Scalars['ID']
  topicId?: InputMaybe<Scalars['ID']>
  viewStatus?: InputMaybe<LearnContentViewStatus>
}

export type LearnContentFilterByTopicIdInput = {
  contentType?: InputMaybe<LearnSearchContentType>
  durationMillisecondsEnd?: InputMaybe<MillisecondsInput>
  durationMillisecondsStart?: InputMaybe<MillisecondsInput>
  tierId?: InputMaybe<Scalars['ID']>
  topicId: Scalars['ID']
  viewStatus?: InputMaybe<LearnContentViewStatus>
}

export type LearnContentFilterInput = {
  contentType?: InputMaybe<LearnSearchContentType>
  durationMillisecondsEnd?: InputMaybe<MillisecondsInput>
  durationMillisecondsStart?: InputMaybe<MillisecondsInput>
  tierId?: InputMaybe<Scalars['ID']>
  topicId?: InputMaybe<Scalars['ID']>
  viewStatus?: InputMaybe<LearnContentViewStatus>
}

export type LearnContentInteractionState = LearnInteractionState

export type LearnContentPageInput = {
  after?: InputMaybe<Scalars['ID']>
  limit: Scalars['Int']
}

export type LearnContentPreview =
  | CoursePreview
  | CoursePreviewLocked
  | LearnArticlePreview
  | LearnArticlePreviewLocked
  | LearnMediaPreview
  | LearnMediaPreviewLocked
  | LearnPollPreview
  | LearnPollPreviewLocked
  | LessonPreview
  | LessonPreviewLocked
  | QuizPreview
  | QuizPreviewLocked

export enum LearnContentSortType {
  Duration = 'DURATION',
  MostRecent = 'MOST_RECENT',
  MostRelevant = 'MOST_RELEVANT',
  MostViewed = 'MOST_VIEWED',
  Trending = 'TRENDING',
}

export type LearnContentStats = {
  __typename?: 'LearnContentStats'
  communityAvg: Maybe<Scalars['Int']>
  views: Maybe<Scalars['Int']>
}

export enum LearnContentType {
  Article = 'ARTICLE',
  Course = 'COURSE',
  Lesson = 'LESSON',
  MediaArticle = 'MEDIA_ARTICLE',
  Poll = 'POLL',
  Quiz = 'QUIZ',
}

export enum LearnContentViewStatus {
  Unviewed = 'UNVIEWED',
  Viewed = 'VIEWED',
}

export type LearnCourse = Course | CourseLocked

export type LearnCoursePreview = CoursePreview | CoursePreviewLocked

export type LearnEdge = {
  cursor: Scalars['ID']
}

export type LearnHubCitation = {
  __typename?: 'LearnHubCitation'
  id: Scalars['ID']
}

export type LearnInsight = {
  __typename?: 'LearnInsight'
  cuePointMillis: Milliseconds
  description: Scalars['String']
  id: Scalars['ID']
  title: Scalars['String']
}

export type LearnInteractionState = {
  __typename?: 'LearnInteractionState'
  elapsedTime: Maybe<LearnContentDuration>
  isFavorites: Scalars['Boolean']
  isHelpful: Maybe<Scalars['Boolean']>
  progress: Maybe<LearnProgress>
}

export type LearnMedia = LearnMediaArticle

export type LearnMediaArticle = {
  __typename?: 'LearnMediaArticle'
  audioTheme: Maybe<LearnMediaTheme>
  authors: Array<LearnAuthor>
  featuredImage: Maybe<LearnVisualAsset>
  id: Scalars['ID']
  insights: Array<LearnInsight>
  media: LearnMediaReference
  metadata: LearnMetadata
  polls: Array<LearnPoll>
  preEventDescription: Maybe<Scalars['String']>
  startsAt: Maybe<Scalars['String']>
  tags: Array<LearnTag>
  /** @deprecated Tier will be removed */
  tier: LearnTier
  title: Scalars['String']
  topics: Array<LearnTopic>
}

export type LearnMediaPreview = {
  __typename?: 'LearnMediaPreview'
  audioTheme: Maybe<LearnMediaTheme>
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  isCompleted: Scalars['Boolean']
  mediaType: Maybe<LearnMediaType>
  primaryTopicName: Scalars['String']
  productRequired: Maybe<Scalars['String']>
  progress: Maybe<LearnProgress>
  startsAt: Maybe<Scalars['String']>
  /** @deprecated tierName is being replaced by productRequired */
  tierName: Scalars['String']
  title: Scalars['String']
  views: Scalars['Int']
}

export type LearnMediaPreviewLocked = {
  __typename?: 'LearnMediaPreviewLocked'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  lockedReason: Maybe<Scalars['String']>
  mediaType: Maybe<LearnMediaType>
  primaryTopicName: Scalars['String']
  productRequired: Scalars['String']
  title: Scalars['String']
  views: Scalars['Int']
}

export type LearnMediaReference = {
  __typename?: 'LearnMediaReference'
  aspectRatio: LearnAspectRatioType
  duration: LearnContentDuration
  featuredImage: Maybe<LearnVisualAsset>
  id: Scalars['ID']
  reference: Scalars['String']
  theme: Maybe<LearnMediaTheme>
  title: Maybe<Scalars['String']>
  transcript: Maybe<Scalars['String']>
  type: LearnMediaType
}

export type LearnMediaTheme = LearnThemeLiteral

export enum LearnMediaType {
  Audio = 'AUDIO',
  LiveVideo = 'LIVE_VIDEO',
  Video = 'VIDEO',
}

export type LearnMetadata = {
  __typename?: 'LearnMetadata'
  contentStats: Maybe<LearnContentCommunityStats>
  interactionState: Maybe<LearnContentInteractionState>
}

export type LearnNextStepAction = {
  __typename?: 'LearnNextStepAction'
  ctaLabel: Maybe<Scalars['String']>
  id: Scalars['ID']
  illustration: Maybe<Image>
  title: Scalars['String']
  url: Scalars['String']
}

export type LearnPageInfo = {
  __typename?: 'LearnPageInfo'
  count: Scalars['Int']
  cursor: Scalars['ID']
  hasNextPage: Scalars['Boolean']
}

export type LearnPoll = {
  __typename?: 'LearnPoll'
  cuePointMillis: Maybe<Milliseconds>
  id: Scalars['ID']
  options: Maybe<Array<Scalars['String']>>
  pollType: LearnPollType
  question: Scalars['String']
  title: Scalars['String']
}

export type LearnPollOption = {
  __typename?: 'LearnPollOption'
  count: Scalars['Int']
  option: Scalars['String']
}

export type LearnPollPreview = {
  __typename?: 'LearnPollPreview'
  contentId: Scalars['ID']
  contentType: LearnContentType
  options: Maybe<Array<LearnPollOption>>
  pollType: LearnPollType
  question: Scalars['String']
  title: Scalars['String']
}

export type LearnPollPreviewLocked = {
  __typename?: 'LearnPollPreviewLocked'
  contentId: Scalars['ID']
  contentType: LearnContentType
  lockedReason: Maybe<Scalars['String']>
  productRequired: Scalars['String']
  title: Scalars['String']
}

export type LearnPollResponse = {
  __typename?: 'LearnPollResponse'
  isSuccess: Scalars['Boolean']
  selectedOption: Scalars['String']
  stats: Maybe<Array<LearnPollOption>>
}

export enum LearnPollType {
  Emoji = 'EMOJI',
  Option = 'OPTION',
  YesNo = 'YES_NO',
}

export enum LearnProductKey {
  Learn = 'LEARN',
  LearnPremium = 'LEARN_PREMIUM',
}

export type LearnProgress = {
  __typename?: 'LearnProgress'
  currentValue: Scalars['Int']
  unitType: LearnProgressUnit
}

export type LearnProgressInput = {
  currentValue: Scalars['Int']
  unitType: LearnProgressUnit
}

export enum LearnProgressUnit {
  Percents = 'PERCENTS',
  Seconds = 'SECONDS',
  Stages = 'STAGES',
}

export type LearnProgressUpdatedResult = {
  __typename?: 'LearnProgressUpdatedResult'
  contentId: Scalars['ID']
  progress: LearnProgress
}

export type LearnQuestion = {
  __typename?: 'LearnQuestion'
  answers: Array<LearnAnswer>
  id: Scalars['ID']
  incrementStep: Maybe<Scalars['Int']>
  insight: Maybe<LearnQuestionInsight>
  questionBody: Scalars['String']
  questionType: LearnQuestionType
  rangeEnd: Maybe<Scalars['Int']>
  rangeLabel: Maybe<Scalars['String']>
  rangeStart: Maybe<Scalars['Int']>
  rangeType: Maybe<LearnRangeType>
  statement: Maybe<Scalars['String']>
  statementHighLight: Maybe<Scalars['String']>
  unitType: Maybe<Scalars['String']>
}

export type LearnQuestionInsight = {
  __typename?: 'LearnQuestionInsight'
  featuredImage: Maybe<Image>
  id: Scalars['ID']
  insightText: Scalars['String']
  media: Maybe<LearnMediaReference>
  mediaType: Maybe<LearnMediaType>
  title: Scalars['String']
}

export enum LearnQuestionType {
  FillInTheBlank = 'FILL_IN_THE_BLANK',
  MultiSelect = 'MULTI_SELECT',
  NumericRange = 'NUMERIC_RANGE',
  SingleSelect = 'SINGLE_SELECT',
  TwoOptions = 'TWO_OPTIONS',
}

export type LearnQuiz = Quiz | QuizLocked

export type LearnQuizAnswerResult = {
  __typename?: 'LearnQuizAnswerResult'
  isCorrect: Scalars['Boolean']
  questionId: Scalars['ID']
  quizId: Scalars['ID']
}

export type LearnQuizPreview = QuizPreview | QuizPreviewLocked

export enum LearnRangeType {
  Dial = 'DIAL',
  Slider = 'SLIDER',
}

export enum LearnSearchContentType {
  Article = 'ARTICLE',
  Audio = 'AUDIO',
  Course = 'COURSE',
  Video = 'VIDEO',
}

export type LearnSearchTermSavedResult = {
  __typename?: 'LearnSearchTermSavedResult'
  term: Scalars['String']
}

export type LearnTag = {
  __typename?: 'LearnTag'
  id: Scalars['ID']
  name: Scalars['String']
}

export type LearnThemeLiteral = {
  __typename?: 'LearnThemeLiteral'
  value: Scalars['String']
}

export type LearnTier = {
  __typename?: 'LearnTier'
  icon: LearnVisualAsset
  id: Scalars['ID']
  name: Scalars['String']
}

export type LearnTopic = {
  __typename?: 'LearnTopic'
  icon: LearnVisualAsset
  id: Scalars['ID']
  name: Scalars['String']
}

export type LearnVisualAsset = Image

export type LegacyAlertDismissalSuccess = {
  __typename?: 'LegacyAlertDismissalSuccess'
  id: Scalars['ID']
}

export type LegacyComparisonResult = {
  __typename?: 'LegacyComparisonResult'
  inLegacyOnly: Array<Scalars['String']>
  inNewOnly: Array<Scalars['String']>
  legacyWidgets: Array<Scalars['String']>
  newWidgets: Array<Scalars['String']>
  orderMatches: Scalars['Boolean']
  typesMatch: Scalars['Boolean']
}

/** An upload from backend */
export type LegacyUploadDocument = {
  __typename?: 'LegacyUploadDocument'
  documentType: DocumentType
  id: Scalars['ID']
  userId: Scalars['ID']
}

/** Input for creating a legacy document upload */
export type LegacyUploadDocumentInput = {
  /** the type of document being uploaded */
  documentType: DocumentType
  /** the multipart document upload file */
  upload: Scalars['Upload']
}

/** LegacyUploadDocumentResult */
export type LegacyUploadDocumentResult =
  | FileDoesNotExistInS3
  | FileTooLarge
  | InvalidFile
  | LegacyUploadDocument
  | UploadDoesNotExist

export type Lesson = {
  __typename?: 'Lesson'
  authors: Array<LearnAuthor>
  featuredImage: Image
  id: Scalars['ID']
  insights: Array<LearnInsight>
  media: LearnMediaReference
  metadata: LearnMetadata
  polls: Array<LearnPoll>
  title: Scalars['String']
}

export type LessonPreview = {
  __typename?: 'LessonPreview'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  parentContentId: Scalars['ID']
  title: Scalars['String']
}

export type LessonPreviewLocked = {
  __typename?: 'LessonPreviewLocked'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  lockedReason: Maybe<Scalars['String']>
  parentContentId: Scalars['ID']
  productRequired: Scalars['String']
  title: Scalars['String']
}

/** The IRS contribution limit group that applies to a set of retirement accounts. */
export enum LimitGroup {
  /** Annual IRA contribution limit shared across Traditional and Roth IRAs. */
  AnnualIra = 'ANNUAL_IRA',
  /** SEP-IRA contribution limit, which is separate from the annual IRA limit. */
  Sep = 'SEP',
}

export enum LinkCustomization {
  /** A link customization for optionally accessing the users ssn. */
  CardLink = 'CARD_LINK',
  /** The standard link customization. */
  Default = 'DEFAULT',
  /** A link customization for only accessing funding source information. */
  FundingSourceLink = 'FUNDING_SOURCE_LINK',
  /** A link customization for not requiring the users name. */
  SansNameLink = 'SANS_NAME_LINK',
  /** A link customization for soft defaulting account sorted by highest balance. */
  SortByBalanceLink = 'SORT_BY_BALANCE_LINK',
  /** A link customization for soft defaulting account sorted by primary bank. */
  SortByPrimaryBankLink = 'SORT_BY_PRIMARY_BANK_LINK',
}

/** Input for creating a manual, ACH funding source */
export type LinkManualFundingSourceInput = {
  /** the account number of the funding source being linked */
  accountNumber: Scalars['String']
  /** the routing number of the funding source being linked */
  routingNumber: Scalars['RoutingNumber']
}

/** LinkManualFundingSourceResult */
export type LinkManualFundingSourceResult =
  | CurrentBankStatementNotProvided
  | FundingSourceAccount
  | FundingSourceAlreadyExists
  | FundingSourceCredentialsExceedLinkLimit
  | InvalidAccountNumber
  | InvalidManualLink
  | InvalidRoutingNumber
  | PreviousFundingSourcePending
  | RdvVerificationRequired

export type LinkOidcCredentialsInput = {
  idToken: Scalars['String']
  nonce: Scalars['String']
  oidcProvider: OidcProvider
  udid: Scalars['String']
}

export type LinkOidcCredentialsResult =
  | InvalidAppleAccountException
  | InvalidIdentityTokenException
  | LinkOidcCredentialsSuccess
  | OidcCredentialsAlreadyLinkedException
  | OidcCredentialsTakenException

export type LinkOidcCredentialsSuccess = {
  __typename?: 'LinkOidcCredentialsSuccess'
  email: Scalars['EmailAddress']
  oidcProvider: OidcProvider
  userId: Scalars['ID']
}

export enum LinkProviderType {
  /** Direct bank provider type. */
  DirectBank = 'DIRECT_BANK',
  /** Plaid provider type */
  Plaid = 'PLAID',
  /** Spend provider type. */
  Spend = 'SPEND',
}

/** Attributes for a linked account created through Plaid Link */
export type LinkSessionInput = {
  /** The Authorization Code returned from the Authorization Server */
  authorizationCode: Scalars['String']
  /** Flag to determine if round-ups should be disabled */
  disableRoundUps?: InputMaybe<Scalars['Boolean']>
  /** Financial Institution ID */
  financialInstitutionId: Scalars['String']
  /** Vendor session correlation id */
  linkSessionId?: InputMaybe<Scalars['String']>
  /** Linked Account ID */
  linkedAccountId?: InputMaybe<Scalars['String']>
}

export enum LinkSessionLanguage {
  /** English */
  En = 'EN',
  /** Spanish */
  Es = 'ES',
  /** French */
  Fr = 'FR',
  /** Dutch */
  Nl = 'NL',
}

/** Returns a Link Token or Link URL for use with Account Linking. */
export type LinkSessionResult =
  | RawLinkSession
  | UnrecoverableLinkedAccountError
  | WebviewLinkSession

/** Miscellaneous attributes about a Linked Account */
export type LinkedAccount = TimestampsInterface & {
  __typename?: 'LinkedAccount'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Error code attached to operation done on account */
  errorCode: Maybe<Scalars['String']>
  /** Plaid account ID */
  externalId: Maybe<Scalars['ID']>
  /** Source of linked account (plaid or spend) */
  externalSource: LinkedAccountExternalSourceEnum
  financialInstitution: Maybe<FinancialInstitution>
  /** ID of the financial institution this linked account is for */
  financialInstitutionId: Maybe<Scalars['ID']>
  /** Linked Account ID */
  id: Scalars['ID']
  /** Name of the associated institution this linked account is for */
  institutionName: Maybe<Scalars['String']>
  /** Is the account linked? */
  linked: Scalars['Boolean']
  linkedSubaccounts: Array<LinkedSubaccount>
  /** The logo url for the institution associated with the account */
  logoUrl: Scalars['String']
  /** This field should only be fetched for initializing a Plaid Link session */
  publicToken: Maybe<Scalars['String']>
  /** Status indicating potential user action required */
  status: LinkedAccountStatusEnum
  /** DateTime of when Transactions were last synced for financial institution */
  transactionsLastSyncedAt: Maybe<Scalars['DateTime']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Correlated User UUID */
  userId: Scalars['ID']
}

/** A Linked Account Alert. */
export type LinkedAccountAlert = UserAlertsItem & {
  __typename?: 'LinkedAccountAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Response from linked account alert query */
export type LinkedAccountAlertsResponse =
  | LinkedAccountAlert
  | RelinkLinkedAccountAlert

export enum LinkedAccountExternalSourceEnum {
  /** The link was created directly between the corresponding bank's API and Acorns */
  DirectBank = 'direct_bank',
  /** The user linked by manually entering an account & routing number */
  Manual = 'manual',
  /** PayPal direct connection was used to link this account */
  Paypal = 'paypal',
  /** The link was created through Plaid and represents an external financial institution */
  Plaid = 'plaid',
  /** This account has an internal Acorns spend account associated with it */
  Spend = 'spend',
}

export enum LinkedAccountLinkingErrorsEnum {
  /** Online banking system is down */
  InstitutionDown = 'INSTITUTION_DOWN',
  /** Online banking system is unresponsive */
  InstitutionNotAvailable = 'INSTITUTION_NOT_AVAILABLE',
  /** Online banking system is unresponsive */
  InstitutionNotResponding = 'INSTITUTION_NOT_RESPONDING',
  /** Online banking system is not supported anymore */
  InstitutionNoLongerSupported = 'INSTITUTION_NO_LONGER_SUPPORTED',
  /** Server error */
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  /** Error with incorrect institution security questions */
  InvalidMfa = 'INVALID_MFA',
  /** Online banking credentials have been updated */
  InvalidUpdatedUsername = 'INVALID_UPDATED_USERNAME',
  /** Online banking account is locked */
  ItemLocked = 'ITEM_LOCKED',
  /** Error with institution security settings */
  ItemNotSupported = 'ITEM_NOT_SUPPORTED',
  /** Error with institution security questions */
  MfaNotSupported = 'MFA_NOT_SUPPORTED',
  /** Online banking account is not fully set up */
  UserSetupRequired = 'USER_SETUP_REQUIRED',
}

export type LinkedAccountNotFound = {
  __typename?: 'LinkedAccountNotFound'
  message: Scalars['String']
}

export enum LinkedAccountStatusEnum {
  /** The user must take action with their financial institution to fix the issue */
  ExternalAction = 'externalAction',
  /** The user must relink and update their linked account to continue functioning */
  Relink = 'relink',
  /** The linked account is working and requires no action */
  Success = 'success',
  /** The linked account or financial institution is no longer supported and can be unlinked */
  Unsupported = 'unsupported',
}

/** An individual account between an individual user and financial institution */
export type LinkedSubaccount = TimestampsInterface & {
  __typename?: 'LinkedSubaccount'
  /** Last 4 Digits of Account Number */
  accountNumberLastFour: Maybe<Scalars['String']>
  /** Roles this linked account can be assigned to */
  allowedRoles: Array<LinkedSubaccountRoleEnum>
  /** Balance available (via Plaid/Spend) */
  balanceAvailable: Maybe<Scalars['Float']>
  /** Current balance of subaccount (via Plaid/Spend) */
  balanceCurrent: Maybe<Scalars['Float']>
  /** Spending limit of balance */
  balanceLimit: Maybe<Scalars['Float']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Plaid ID for linked subaccount */
  externalId: Maybe<Scalars['String']>
  /** External source of subaccount (plaid, spend, paypal, manual) */
  externalSource: Maybe<Scalars['String']>
  /** Internal ID for linked subaccount */
  id: Scalars['ID']
  /** Subaccount Linked? */
  linked: Scalars['Boolean']
  linkedAccount: LinkedAccount
  /** Internal ID for the corresponding linked account */
  linkedAccountId: Scalars['ID']
  /** Name of linked subaccount (Department) */
  name: Scalars['String']
  /** Official name (verbose) */
  officialName: Maybe<Scalars['String']>
  paymentEngines: Array<LinkedSubaccountPaymentEngineEnum>
  /** The role of the linked subaccount */
  role: Maybe<LinkedSubaccountRoleEnum>
  /** Financial institution routing number. */
  routingNumber: Maybe<Scalars['String']>
  /** The status of the linked subaccount */
  status: Maybe<FundingSourceStatusEnum>
  /** Subtype (ie checking) */
  subaccountSubtype: Scalars['String']
  /** Type (depository, credit) */
  subaccountType: Scalars['String']
  /** Transactions count */
  transactionsLastSyncedCount: Scalars['Int']
  /** RDVs and docs have been verified and approved for this account */
  transfersApproved: Maybe<Scalars['Boolean']>
  /** Is the account at risk or does it have insufficient funds? */
  transfersAtRisk: Maybe<Scalars['Boolean']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /**
   * Subaccount Verified?
   * @deprecated This will be removed in favor of "transfersApproved"
   */
  verified: Maybe<Scalars['Boolean']>
}

export enum LinkedSubaccountPaymentEngineEnum {
  /** The linked subaccount is linked in ProfitStars */
  ProfitStars = 'profitStars',
}

export enum LinkedSubaccountRoleEnum {
  /** The subaccount is the primary funding source of the user */
  PrimaryFunding = 'primaryFunding',
  /** The subaccount is the secondary funding source of the user */
  SecondaryFunding = 'secondaryFunding',
}

/** Liquidation information */
export type Liquidation = TimestampsInterface & {
  __typename?: 'Liquidation'
  accountId: Scalars['ID']
  billingCycle: BillingCycle
  billingCycleId: Scalars['ID']
  collectedAmount: Scalars['Float']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  feeExecutions: Array<Maybe<FeeExecution>>
  id: Scalars['ID']
  investmentId: Scalars['ID']
  requestedAmount: Scalars['Float']
  state: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** Liquidation of holdings is currently unavailable. */
export type LiquidationUnavailableError = {
  __typename?: 'LiquidationUnavailableError'
  /** Reason for liquidation being unavailable. */
  reason: LiquidationUnavailableReason
}

export enum LiquidationUnavailableReason {
  /** The funding source is frozen. */
  FundingSourceFrozen = 'FUNDING_SOURCE_FROZEN',
  /** The associated funding source requires RDV. */
  FundingSourceRdvRequired = 'FUNDING_SOURCE_RDV_REQUIRED',
  /** No funding source exists for the investment account. */
  FundingSourceRequired = 'FUNDING_SOURCE_REQUIRED',
}

export type LockBankCardInput = {
  lockReason: BankCardTemporaryLockReason
}

export type LockBankCardPayload = {
  __typename?: 'LockBankCardPayload'
  bankCard: Maybe<BankCard>
}

export type LoginAccess = {
  __typename?: 'LoginAccess'
  loginAllowed: Scalars['Boolean']
  loginRevokedAt: Maybe<Scalars['DateTime']>
  loginRevokedReason: Maybe<Scalars['String']>
}

export type LoginRateLimitedException = {
  __typename?: 'LoginRateLimitedException'
  message: Maybe<Scalars['String']>
}

export type LogoutDeviceInput = {
  deviceId: Scalars['ID']
}

export type LogoutDeviceResult =
  | DeviceNotFoundException
  | LogoutDeviceSuccess
  | RefreshTokenNotFoundException

export type LogoutDeviceSuccess = {
  __typename?: 'LogoutDeviceSuccess'
  Device: Device
}

export type LogoutResult =
  | AuthTokenNotFoundException
  | LogoutSuccess
  | RefreshTokenNotFoundException

export type LogoutSuccess = {
  __typename?: 'LogoutSuccess'
  userId: Scalars['ID']
}

/** Lookback window for round-up summaries relative to today */
export type LookbackFilter = {
  unit: LookbackUnit
  value: Scalars['Int']
}

export enum LookbackUnit {
  Days = 'DAYS',
  Months = 'MONTHS',
  Years = 'YEARS',
}

export enum MailInDocumentType {
  BillNegotiation = 'BILL_NEGOTIATION',
  FeeNegotiation = 'FEE_NEGOTIATION',
}

/** Input for makeInvestment mutation */
export type MakeInvestmentInput = {
  /** Dollar amount of investment */
  amount: Scalars['Float']
  /** Correlation ID used to correlate this investment request with device/fraud parameters */
  correlationId?: InputMaybe<Scalars['String']>
  /** Funding source ID */
  fundingSourceId?: InputMaybe<Scalars['ID']>
  /** Investment account ID */
  investmentAccountId?: InputMaybe<Scalars['ID']>
  /** Payment method. Note: This will be overridden by the funding source's payment method in the backend. */
  paymentMethod?: InputMaybe<Scalars['String']>
  /** Type of investment (credit, debit) */
  type: InvestmentTypes
}

/** Return type for makeInvestment mutation */
export type MakeInvestmentPayload = {
  __typename?: 'MakeInvestmentPayload'
  /** ID of the created investment */
  id: Scalars['ID']
  /** Optional success/error message */
  message: Maybe<Scalars['String']>
}

export type MalformedRecurringTransferException = {
  __typename?: 'MalformedRecurringTransferException'
  pathExceptions: Array<RecurringTransferPathException>
}

export enum ManagePayoutRelationshipAction {
  Add = 'ADD',
  Remove = 'REMOVE',
}

export enum ManagePayoutRelationshipResult {
  Fail = 'FAIL',
  Success = 'SUCCESS',
}

export enum MaritalStatus {
  /** User is currently in a civil union */
  CivilUnion = 'civil_union',
  /** User is no longer married due to legal separation */
  Divorced = 'divorced',
  /** User is married currently */
  Married = 'married',
  /** User has never been married */
  Single = 'single',
  /** User is no longer married due to death of spouse */
  Widowed = 'widowed',
}

export type MarkAllAsReadResult = MarkAllAsReadSuccess | UpdateMessageFailed

export type MarkAllAsReadSuccess = {
  __typename?: 'MarkAllAsReadSuccess'
  markedAsReadCount: Scalars['Int']
}

export type MarkLearnContentAsHelpfulInput = {
  contentId: Scalars['ID']
}

export type MarkLearnContentAsHelpfulResult =
  | RecordDoesNotExistError
  | UpdateLearnContentHelpfulnessResult

export type MarkLearnContentAsViewedInput = {
  contentId: Scalars['ID']
}

export type MarkLearnContentAsViewedResult =
  | RecordDoesNotExistError
  | ViewedLearnContentResult

/** Information about the stock market (U.S. only) */
export type Market = {
  __typename?: 'Market'
  /** Indicates whether or not the market is open for trading */
  isOpen: Scalars['Boolean']
}

/** Real-time market data sourced directly from our market data provider for any publicly traded ticker */
export type MarketQuote = {
  __typename?: 'MarketQuote'
  currentPrice: MicrosMoney
  lastClosePrice: Maybe<MicrosMoney>
  longName: Scalars['String']
  marketCap: Scalars['BigDecimal']
  openPrice: MicrosMoney
  profile: MarketQuoteProfile
  shortName: Scalars['String']
  /** Whether this security is currently available for users to invest in on the Acorns platform. A security is supported when it is both active and searchable in our system. */
  supportedByAcorns: Scalars['Boolean']
  symbol: Scalars['TickerSymbol']
  type: SecurityType
  volume: Scalars['BigDecimal']
  week52High: MicrosMoney
  week52Low: MicrosMoney
}

export type MarketQuoteLookupError = {
  __typename?: 'MarketQuoteLookupError'
  message: Scalars['String']
  symbol: Scalars['TickerSymbol']
}

export type MarketQuoteProfile = {
  __typename?: 'MarketQuoteProfile'
  description: Maybe<Scalars['String']>
  tradingSectors: Array<TradingSector>
}

export type MarketQuotesResponse = {
  __typename?: 'MarketQuotesResponse'
  /** Symbols that could not be resolved by the market data provider */
  errors: Array<MarketQuoteLookupError>
  quotes: Array<MarketQuote>
}

export type MarketReturn = {
  __typename?: 'MarketReturn'
  marketValue: MonetaryAmount
  percent: Scalars['Float']
}

/** A masked credential for a matched account */
export type MaskedCredential = {
  __typename?: 'MaskedCredential'
  identifier: Scalars['String']
  type: MaskedCredentialsType
}

/** The type of authentication credential on a masked matched account */
export enum MaskedCredentialsType {
  Apple = 'APPLE',
  Google = 'GOOGLE',
  User = 'USER',
}

/** The type of match eligibility a customer has. */
export enum MatchEligibilityType {
  /** Grandfathered eligibility with no time limit */
  Perpetual = 'PERPETUAL',
  /** Time-limited eligibility with an expiration date */
  Temporary = 'TEMPORARY',
}

/** A match program entitles eligible investment accounts to matching contributions provided by Acorns. */
export type MatchProgram = TimestampsInterface & {
  __typename?: 'MatchProgram'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Description of the Program Match */
  description: Scalars['String']
  /** Investment Account types supports by the program */
  eligibleInvestmentAccountTypes: Array<InvestmentAccountType>
  /** ID of the Program Match */
  id: Scalars['ID']
  /** Match percentage for the program */
  matchPercentage: Scalars['Float']
  /** Name of the Program Match */
  name: Scalars['String']
  /** Description of the Program Match */
  requiredContributionVestingDays: Scalars['Int']
  /** Tier the program is available on. */
  tier: Maybe<Tier>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** A matched account with masked credentials */
export type MatchedAccount = {
  __typename?: 'MatchedAccount'
  credentials: Array<MaskedCredential>
  firstName: Scalars['String']
  formattedName: Scalars['String']
  joinedAt: Scalars['DateTime']
}

/** An error occurred while resolving the matched account */
export type MatchedAccountException = {
  __typename?: 'MatchedAccountException'
  message: Maybe<Scalars['String']>
}

/** No matched account was found for the provided SSN */
export type MatchedAccountNotFound = {
  __typename?: 'MatchedAccountNotFound'
  message: Maybe<Scalars['String']>
}

/** Result of resolving a matched account */
export type MatchedAccountResult =
  | MatchedAccount
  | MatchedAccountException
  | MatchedAccountNotFound

/** Cannot open early account because the custodian is already at max */
export type MaxAccountsCreatedException = {
  __typename?: 'MaxAccountsCreatedException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type Message = {
  body: MessageTextAsset
  cardSubCategory: Maybe<CardSubCategory>
  deepLink: Maybe<Scalars['URL']>
  delay: Maybe<Scalars['Int']>
  externalId: Scalars['ID']
  /** Resolved icon for this message, derived from iconEnum or iconURL. When both are present, iconEnum takes precedence. */
  icon: Maybe<MessageVisualAsset>
  /** Preferred icon representation for this message. When both iconEnum and iconURL are set, iconEnum takes precedence. Exposed separately to allow experimentation while keeping the icon field backward compatible. */
  iconEnum: Maybe<IconType>
  /** URL-based icon representation for this message, used when iconEnum is not set. Exposed separately to allow experimentation while keeping the icon field backward compatible. */
  iconURL: Maybe<Scalars['URL']>
  id: Scalars['ID']
  lifetimeCap: Maybe<Scalars['Int']>
  messageCategory: Maybe<MessageCategory>
  messageType: MessageType
  platforms: Array<Platform>
  priority: Maybe<Scalars['Int']>
  title: MessageTextAsset
  trackingId: Maybe<Scalars['ID']>
}

export enum MessageCategory {
  Account = 'ACCOUNT',
  Banking = 'BANKING',
  BenefitsHub = 'BENEFITS_HUB',
  Braze = 'BRAZE',
  Earn = 'EARN',
  Invest = 'INVEST',
  Later = 'LATER',
  Milestone = 'MILESTONE',
  Onboarding = 'ONBOARDING',
}

export type MessageConfig = {
  __typename?: 'MessageConfig'
  blockDisplay: Scalars['Boolean']
  blockIngestion: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  /** Delays the message for this many days after its createdAt. Null or 0 means no delay. */
  delayByDays: Maybe<Scalars['Int']>
  /** Conditional display blocks. A message is hidden if any rule matches the request platform and client version. Not needed while blockDisplay is true, which hides the message everywhere. */
  displayRules: Array<DisplayRule>
  /** Message trackingId. For Braze-sourced messages this is the Braze campaign ID. */
  trackingId: Scalars['ID']
  updatedAt: Scalars['DateTime']
}

/** Specifies a Message Connection */
export type MessageConnection = {
  __typename?: 'MessageConnection'
  edges: Array<MessageEdge>
  pageInfo: MessagePageInfo
}

/** Specifies a Message Edge */
export type MessageEdge = {
  __typename?: 'MessageEdge'
  cursor: Scalars['ID']
  node: Message
}

export type MessageFeedbackInput = {
  customFeedback?: InputMaybe<Scalars['String']>
  feedbackReason: MessageFeedbackReason
}

export enum MessageFeedbackReason {
  InaccurateInformation = 'INACCURATE_INFORMATION',
  NotHelpful = 'NOT_HELPFUL',
  Offensive = 'OFFENSIVE',
  Other = 'OTHER',
}

/** Specifies Page Information */
export type MessagePageInfo = {
  __typename?: 'MessagePageInfo'
  endCursor: Maybe<Scalars['ID']>
  hasNextPage: Scalars['Boolean']
}

export type MessagePageInput = {
  after?: InputMaybe<Scalars['ID']>
  first?: InputMaybe<Scalars['Int']>
}

export enum MessageStatus {
  Dismissed = 'DISMISSED',
  Read = 'READ',
}

/** A pair of a status and a desired boolean for it. */
export type MessageStatusFilterInput = {
  key: MessageStatus
  value: Scalars['Boolean']
}

export type MessageTextAsset = StringKeyAsset

export enum MessageType {
  Alert = 'ALERT',
  Notification = 'NOTIFICATION',
}

export type MessageVisualAsset = DesignLibraryIcon | Image

export type MessagingSession = {
  __typename?: 'MessagingSession'
  endedAt: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  link: Maybe<Scalars['String']>
  sessionIdentifier: Maybe<Scalars['String']>
  startedAt: Maybe<Scalars['DateTime']>
  status: Maybe<Scalars['String']>
  supportTicketId: Maybe<Scalars['ID']>
}

export type MessagingSessionEdge = {
  __typename?: 'MessagingSessionEdge'
  cursor: Scalars['ID']
  node: Maybe<MessagingSession>
}

export type MessagingSessionResponse = {
  __typename?: 'MessagingSessionResponse'
  edges: Array<MessagingSessionEdge>
  pageInfo: PageInfo
}

export type MfaMissingAuthAlert = AuthAlert & {
  __typename?: 'MfaMissingAuthAlert'
  type: Scalars['String']
  userId: Scalars['ID']
}

/** Value of money measured in currency */
export type MicrosMoney = {
  __typename?: 'MicrosMoney'
  /** System of money that is used in a particular country */
  currency: Currency
  /** Monetary value in micros (1 dollar = 1,000,000 micros) */
  value: Scalars['Micros']
}

/** Representation of a monetary amount in Micros with a currency. */
export type MicrosMoneyInput = {
  /** System of money that is used in a particular country */
  currency: Currency
  /** Monetary value */
  value: Scalars['Micros']
}

/** The mighty oak card waiver for a user */
export type MightyOakCardWaiver = {
  __typename?: 'MightyOakCardWaiver'
  mightyOakCardWaiverPeriodEndDate: Scalars['String']
  userId: Scalars['ID']
}

/** Mighty Oak Waiver expired */
export type MightyOakCardWaiverExpiredException = {
  __typename?: 'MightyOakCardWaiverExpiredException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Mighty Oak Waiver not found */
export type MightyOakCardWaiverNotFoundException = {
  __typename?: 'MightyOakCardWaiverNotFoundException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** result from attempting to create a provisional waiver for a user */
export type MightyOakWaiverResult =
  | BillingProfileNotFoundException
  | MightyOakCardWaiver
  | MightyOakCardWaiverExpiredException
  | MightyOakCardWaiverNotFoundException

export type MigrateCredentialsInput = {
  email: Scalars['EmailAddress']
  passwordHash: Scalars['String']
}

export type MigrateCredentialsResult =
  | AuthSession
  | EmailTakenException
  | InvalidPasswordHashException

export type Milestone = {
  __typename?: 'Milestone'
  /** how many account points the user has earned for this milestone so far */
  accountPoints: AccountPoints
  /**
   * how many challenge points the user has earned for completing this milestone. The specific challenge is indicated by the ID
   * @deprecated This was only relevant for the Path to $1M sweepstakes.
   */
  challengePoints: Maybe<ChallengePointsEarned>
  /** key that maps to client-defined milestone description */
  descriptionKey: Scalars['StringKey']
  /** optional destination label and deep link for milestone action */
  destination: Maybe<Destination>
  /**
   * key that maps to client-defined milestone details
   * @deprecated leverage accountPoints.detailsKey
   */
  detailsKey: Maybe<Scalars['StringKey']>
  /** milestone education tip content */
  educationTip: EducationTip
  /** the first time the user completed the milestone */
  firstCompletedAt: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  /** @deprecated No longer needed since the logo will be dynamically set based on milestone status. Use 'logo' instead */
  inactiveLogo: Maybe<Image>
  /** whether or not this milestone can be completed more than once */
  isRepeatable: Scalars['Boolean']
  /** the most recent time the user completed the milestone */
  lastCompletedAt: Maybe<Scalars['DateTime']>
  /** logo that matches the milestone status */
  logo: Image
  /** @deprecated Do not use anymore. This field has been replaced by nameKey. */
  name: Scalars['String']
  /** key that maps to descriptive identifier */
  nameKey: Scalars['StringKey']
  /** information the user's progress towards completion */
  progress: MilestoneProgress
  /** milestone rule enum which can be used for grouping and fetch string mappings */
  rule: MilestoneRuleType
  /** key that maps to simplified descriptive identifier */
  simpleNameKey: Scalars['StringKey']
  /** the user-specific status */
  status: MilestoneStatus
  /** the milestone category */
  theme: MilestoneTheme
  /** how many times the user completed this milestone */
  timesCompleted: Scalars['Int']
}

export type MilestoneChallengePointsArgs = {
  challengeId: Scalars['ID']
}

export type MilestoneAccountLevelDefinition = {
  __typename?: 'MilestoneAccountLevelDefinition'
  /** image to display as the background when the level is active */
  activeBackground: Image
  /** image to display as the foreground when the level is active */
  activeForeground: Image
  /** level id, e.g. 3 */
  id: Scalars['Int']
  /** image to display as the background when the level is inactive */
  inactiveBackground: Image
  /** max points for the level. If min and max are the same value, there is no higher level */
  max: Scalars['Int']
  /** minimum points needed for the level */
  min: Scalars['Int']
}

export type MilestoneAchievementActionRule = {
  __typename?: 'MilestoneAchievementActionRule'
  actions: Array<MilestoneAchievementActionType>
  milestoneID: Scalars['ID']
}

export enum MilestoneAchievementActionType {
  AnalyticsEvent = 'ANALYTICS_EVENT',
  NativeNotification = 'NATIVE_NOTIFICATION',
}

export type MilestoneByThemeFilterInput = {
  /** No longer in use. Will be ignored if provided. */
  challengeId?: InputMaybe<Scalars['ID']>
  rule?: InputMaybe<MilestoneRuleType>
}

export type MilestoneChallenge = {
  __typename?: 'MilestoneChallenge'
  /** Static date label for when the challenge becomes inactive (NOTE: is relative to PST) */
  closingAt: Scalars['String']
  /** additional information about this challenge */
  details: Maybe<Scalars['String']>
  /** Internal UTC timestamp. For display, use 'closingAt'instead */
  endsAt: Scalars['DateTime']
  /** optional deeplink to challenge FAQ */
  faqDeepLink: Maybe<Scalars['URL']>
  /** list of user milestones, grouped and ordered */
  groupedMilestones: Array<MilestoneGroup>
  id: Scalars['ID']
  /** optional logo for the challenge */
  logo: Maybe<Image>
  /** number of milestones the user has completed for the challenge */
  milestonesCompleted: DiscreteMilestoneProgress
  /** descriptive identifier */
  name: Scalars['String']
  /** number of points the user has earned for the challenge. May be null if not applicable to the current challenge */
  pointsEarned: Maybe<DiscreteMilestoneProgress>
  /** optional deeplink to official challenge rules */
  rulesDeepLink: Maybe<Scalars['URL']>
}

export type MilestoneChallengePointsRule = {
  __typename?: 'MilestoneChallengePointsRule'
  challengeID: Scalars['ID']
  /** legal copy about how points are earned */
  details: Scalars['String']
  /** specifies the max points that can be earned if the milestone is completed more than once */
  maxPointsAllowed: Scalars['Int']
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int']
  /** summarized information about how points are earned */
  summary: Maybe<Scalars['String']>
}

export type MilestoneDefinition = {
  __typename?: 'MilestoneDefinition'
  accountPointsRule: Maybe<AccountPointsRule>
  /** optional datetime arg required for some milestone rules (e.g. ACTIVE_CUSTOMER) */
  arg1DateTime: Maybe<Scalars['DateTime']>
  /** optional integer arg required for some milestone rules (e.g. BALANCED_REACHED) */
  arg1Int: Maybe<Scalars['Int']>
  /** @deprecated This was only relevant for the Path to $1M sweepstakes. */
  challengePointsRule: Maybe<MilestoneChallengePointsRule>
  id: Scalars['ID']
  /** optional logo used for inactive milestone states (e.g. LOCKED, NOT_STARTED) */
  inactiveLogo: Maybe<Image>
  /** whether or not this milestone can be completed more than once */
  isRepeatable: Scalars['Boolean']
  /** default logo */
  logo: Image
  /** list of MilestoneGroupID for groups to which this milestone belongs */
  milestoneGroups: Array<Scalars['ID']>
  /** descriptive identifier */
  name: Scalars['String']
  /** the rule that determines how this milestone changes status */
  rule: MilestoneRule
  /** the milestone category */
  theme: MilestoneTheme
}

export type MilestoneDefinitionChallengePointsRuleArgs = {
  challengeId: Scalars['ID']
}

export type MilestoneEligibility = {
  __typename?: 'MilestoneEligibility'
  eligible: Scalars['Boolean']
  scope: MilestoneEligibilityScope
}

export enum MilestoneEligibilityScope {
  AccountSetupComplete = 'ACCOUNT_SETUP_COMPLETE',
  /** @deprecated this value was only used for the AccountSetup feature experiment that is now over */
  AccountSetupExp = 'ACCOUNT_SETUP_EXP',
}

export type MilestoneGroup = MilestoneRuleGroup | MilestoneThemeGroup

export type MilestoneGroupAchievementActionRule = {
  __typename?: 'MilestoneGroupAchievementActionRule'
  actions: Array<MilestoneAchievementActionType>
  milestoneGroupID: Scalars['ID']
}

export type MilestoneGroupDefinition = {
  __typename?: 'MilestoneGroupDefinition'
  id: Scalars['ID']
  milestoneIDs: Array<Scalars['ID']>
}

export type MilestoneHub = {
  __typename?: 'MilestoneHub'
  /** list of user milestones, grouped and ordered */
  groupedMilestones: Array<MilestoneGroup>
  /** static list of min and max values for each account level */
  levelDefinitions: Array<MilestoneAccountLevelDefinition>
  userAccount: MilestoneHubAccount
}

export type MilestoneHubAccount = {
  __typename?: 'MilestoneHubAccount'
  /** shows progress of points earned vs points needed to move to the next level. NOTE: the currentInt can exceed the targetInt if the user is at the highest level */
  accountPointsProgress: DiscreteMilestoneProgress
  /** current level achieved */
  currentLevel: Scalars['Int']
  /** shows progress of milestones completed vs milestones available */
  milestoneProgress: DiscreteMilestoneProgress
}

export type MilestoneHubDefinition = {
  __typename?: 'MilestoneHubDefinition'
  id: Scalars['ID']
  milestoneIds: Array<Scalars['ID']>
}

export type MilestoneProgress =
  | CurrencyMilestoneProgress
  | DiscreteMilestoneProgress

/** defines how a milestone is completed */
export type MilestoneRule = {
  __typename?: 'MilestoneRule'
  /** denotes if an argument input needs to be provided for the creation of a MilestoneDefinition */
  argInput: MilestoneRuleArgInput
  id: Scalars['ID']
  /** the rule name */
  name: Scalars['String']
  /** the milestone supported themes */
  themes: Array<MilestoneTheme>
}

export enum MilestoneRuleArgInput {
  Datetime = 'DATETIME',
  Int = 'INT',
  None = 'NONE',
}

export type MilestoneRuleGroup = {
  __typename?: 'MilestoneRuleGroup'
  contents: Array<MilestoneRuleGroupContent>
  descriptionKey: Scalars['StringKey']
  groupCompletion: DiscreteMilestoneProgress
  logo: Image
  nameKey: Scalars['StringKey']
  rule: MilestoneRuleType
}

export type MilestoneRuleGroupContent = Milestone

export enum MilestoneRuleType {
  ActiveCustomer = 'ACTIVE_CUSTOMER',
  BalanceReached = 'BALANCE_REACHED',
  CardActivation = 'CARD_ACTIVATION',
  /** @deprecated Use CREATE_ACORNS_ACCOUNT instead */
  CompleteRegistration = 'COMPLETE_REGISTRATION',
  CreateAcornsAccount = 'CREATE_ACORNS_ACCOUNT',
  FirstInvestment = 'FIRST_INVESTMENT',
  FundingSourceLinked = 'FUNDING_SOURCE_LINKED',
  RealtimeRoundup = 'REALTIME_ROUNDUP',
  RecurringInvestmentMonthly = 'RECURRING_INVESTMENT_MONTHLY',
  RewardCreated = 'REWARD_CREATED',
  Roundup = 'ROUNDUP',
  Signup = 'SIGNUP',
  SmartDepositCompleted = 'SMART_DEPOSIT_COMPLETED',
  Verified = 'VERIFIED',
}

export enum MilestoneStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Locked = 'LOCKED',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
}

export enum MilestoneTheme {
  AccountSetup = 'ACCOUNT_SETUP',
  Acorns = 'ACORNS',
  Early = 'EARLY',
  Earn = 'EARN',
  Invest = 'INVEST',
  Later = 'LATER',
  Spend = 'SPEND',
}

export type MilestoneThemeGroup = {
  __typename?: 'MilestoneThemeGroup'
  contents: Array<MilestoneThemeGroupContent>
  descriptionKey: Scalars['StringKey']
  destination: Maybe<Destination>
  groupCompletion: DiscreteMilestoneProgress
  groupPointsProgress: Maybe<DiscreteMilestoneProgress>
  isLocked: Scalars['Boolean']
  logo: Image
  nameKey: Scalars['StringKey']
  theme: MilestoneTheme
}

export type MilestoneThemeGroupContent = Milestone | MilestoneRuleGroup

export type Milliseconds = {
  __typename?: 'Milliseconds'
  value: Scalars['Int']
}

export type MillisecondsInput = {
  value: Scalars['Int']
}

/** Miscellaneous document requested. */
export type MiscDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'MiscDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Returned when the provided distribution units are not all matching */
export type MismatchedDistributionUnitsError = {
  __typename?: 'MismatchedDistributionUnitsError'
  message: Scalars['String']
}

/** Missing required agreements for user */
export type MissingAgreementsException = {
  __typename?: 'MissingAgreementsException'
  userId: Maybe<Scalars['ID']>
}

/** Cannot open early account because the beneficiary does not have an SSN */
export type MissingBeneficiarySsnException = {
  __typename?: 'MissingBeneficiarySsnException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type MissingEarnRewardRequest = {
  __typename?: 'MissingEarnRewardRequest'
  createdAt: Scalars['DateTime']
  extensionMerchantId: Maybe<Scalars['String']>
  id: Scalars['ID']
  method: EarnRewardPurchaseMethod
  orderNumber: Scalars['String']
  ownerId: Maybe<Scalars['ID']>
  proofOfPurchaseUrl: Scalars['URL']
  purchaseDate: Scalars['Date']
  status: MissingEarnRewardRequestStatus
  subTotal: MicrosMoney
  total: MicrosMoney
  userId: Scalars['ID']
}

export type MissingEarnRewardRequestPurchaseDateError = {
  __typename?: 'MissingEarnRewardRequestPurchaseDateError'
  maxDays: Scalars['Int']
  minDays: Scalars['Int']
}

export enum MissingEarnRewardRequestStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
}

/** The user needs to attach a funding source to close their early account */
export type MissingFundingSourceException = {
  __typename?: 'MissingFundingSourceException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type MissingRequiredAgreementsException = {
  __typename?: 'MissingRequiredAgreementsException'
  message: Maybe<Scalars['String']>
}

/** The given beneficiary does not have an associated SSN. */
export type MissingSsnBeneficiaryAlert = Alert & {
  __typename?: 'MissingSsnBeneficiaryAlert'
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary
  /**
   * Internal ID of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  beneficiaryId: Scalars['ID']
  /**
   * First name of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  firstName: Scalars['String']
  /** @deprecated The type of the alert is defined by the gql type. */
  type: Scalars['String']
  userId: Scalars['ID']
}

/** The given beneficiary does not have an associated SSN. */
export type MissingSsnBeneficiaryAlertItem = UserAlertsItem & {
  __typename?: 'MissingSsnBeneficiaryAlertItem'
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Returned when an existing customer ruleset is not found, and no override archetype ruleset was provided. */
export type MissingValidRulesetError = {
  __typename?: 'MissingValidRulesetError'
  message: Scalars['String']
}

export type ModifyMoneyAssignmentInput = {
  /** The target account IDs and amount to assign for each account */
  accountAssignments: Array<AccountMoneyAssignmentInput>
  /** The incoming transaction ID for money assignment between accounts */
  transactionId: Scalars['ID']
}

export type ModifyMoneyAssignmentResult =
  | ModifyMoneyAssignmentSuccess
  | MoneyAssignmentAlreadyTransferredError
  | MoneyAssignmentNotFoundError

export type ModifyMoneyAssignmentSuccess = {
  __typename?: 'ModifyMoneyAssignmentSuccess'
  moneyAssignment: MoneyManagerMoneyAssignment
}

export type MonetaryAmount = {
  __typename?: 'MonetaryAmount'
  currency: Currency
  value: Scalars['Float']
}

/** Input for anything money related */
export type MonetaryAmountInput = {
  /** The currency of the amount */
  currency: Currency
  /** The total amount */
  value: Scalars['Float']
}

/** A monetrary reward that will be provided to a subscriber in some fashion. */
export type MonetaryIncentive = Incentive & {
  __typename?: 'MonetaryIncentive'
  /** Amount of the monetary reward. */
  amount: CurrencyAmount
  copyKey: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  description: Scalars['String']
  id: Scalars['ID']
  /** Is the monetary reward recurring. */
  recurring: Scalars['Boolean']
  /** Total amount of the reward if recurring. */
  totalAmount: CurrencyAmount
  /**
   * Arbitrary string denoting to fulfillment processes how monetary
   * reward should be provided to a subscriber.
   *
   * Ex. "INVESTMENT"
   */
  type: Scalars['String']
  updatedAt: Maybe<Scalars['DateTime']>
}

export type MonetaryPrize = {
  __typename?: 'MonetaryPrize'
  amount: MicrosMoney
}

export type Money = {
  __typename?: 'Money'
  currency: Scalars['String']
  micros: Scalars['String']
}

export type MoneyAssignmentAlreadyTransferredError = {
  __typename?: 'MoneyAssignmentAlreadyTransferredError'
  message: Scalars['String']
}

export type MoneyAssignmentConnection = {
  __typename?: 'MoneyAssignmentConnection'
  edges: Array<MoneyAssignmentEdge>
  pageInfo: MoneyManagerPageInfo
}

export type MoneyAssignmentEdge = {
  __typename?: 'MoneyAssignmentEdge'
  cursor: Scalars['String']
  node: MoneyManagerMoneyAssignment
}

export type MoneyAssignmentNotFoundError = {
  __typename?: 'MoneyAssignmentNotFoundError'
  message: Scalars['String']
}

export type MoneyInEventInput = {
  accountId: Scalars['String']
  customerTag: Scalars['String']
  description: Scalars['String']
  id: Scalars['ID']
  ingestedAt: Scalars['String']
  transactionAmount: Scalars['String']
  transactionId: Scalars['String']
  transactionTag: Scalars['String']
  transactionTypeCode: Scalars['String']
}

/** The target account as the result of a MoneyAssignment */
export type MoneyManagerAllocation = {
  __typename?: 'MoneyManagerAllocation'
  amount: MoneyRulesCurrencyAmount
  associatedTransferId: Maybe<Scalars['ID']>
  beneficiary: Maybe<Beneficiary>
  completedAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  destinationAccount: MoneyRulesDestination
  id: Scalars['ID']
  moneyAssignment: MoneyManagerMoneyAssignment
  /**
   * Deprecated - Use rules instead
   * @deprecated Field no longer supported
   */
  rule: MoneyRulesRule
  rules: Array<MoneyRulesRule>
  status: MoneyManagerAllocationStatus
  transferId: Maybe<Scalars['ID']>
  userId: Scalars['ID']
}

export enum MoneyManagerAllocationNotEditableReason {
  LaterLimitReached = 'LATER_LIMIT_REACHED',
  NoPercentageRemaining = 'NO_PERCENTAGE_REMAINING',
}

/** Represents the allocation amount details. */
export type MoneyManagerAllocationOption = {
  __typename?: 'MoneyManagerAllocationOption'
  /** The amount of the allocation. */
  amount: MoneyRulesCurrencyAmount
  /** Deposit amounts normalized to various cadences. */
  normalizedAmounts: Maybe<MoneyManagerNormalizedAmounts>
  /** The remainder details of the allocation for other accounts. */
  otherAccountsRemainder: MoneyManagerAllocationRemainder
  /** The percentage of the allocation. */
  percent: Scalars['Float']
  /** The remainder details of the allocation. */
  remainder: MoneyManagerAllocationRemainder
}

/** Input object for allocation amounts query. */
export type MoneyManagerAllocationOptionsInput = {
  /** Pass in an archetype to use as a "starting point" for the algorithm instead of the customer's current ruleset */
  archetype?: InputMaybe<MoneyRulesArchetype>
  /** Any staged rules to consider when calculating allocation options */
  stagedRules?: InputMaybe<Array<MoneyManagerStagedRulesInput>>
  /** The target account identifier to get allocation options for */
  targetAccountId: Scalars['ID']
  /** Set as `true` to base the algorithm on all deposit amounts rather than just the next deposit. */
  useTotalDepositAmount?: InputMaybe<Scalars['Boolean']>
}

/** Represents the remainder details for the allocation option */
export type MoneyManagerAllocationRemainder = {
  __typename?: 'MoneyManagerAllocationRemainder'
  /** The amount of the remainder allocation. */
  amount: MoneyRulesCurrencyAmount
  /** The percentage of the remainder allocation. */
  percent: Scalars['Float']
}

/** Similar to a MoneyManagerAllocation, but stripped down */
export type MoneyManagerAllocationResult = {
  __typename?: 'MoneyManagerAllocationResult'
  amount: MoneyRulesCurrencyAmount
  destinationAccount: MoneyRulesDestination
  rulePriority: Scalars['Int']
}

export enum MoneyManagerAllocationStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

export type MoneyManagerAutomationTarget = {
  __typename?: 'MoneyManagerAutomationTarget'
  amount: MoneyRulesCurrencyAmount
  /** Was the goal set by the customer? */
  customSelection: Scalars['Boolean']
  /** The suggested period of the original target suggestion. */
  suggestedPeriod: Maybe<MoneyManagerPeriod>
  type: MoneyManagerAutomationTargetType
}

export enum MoneyManagerAutomationTargetType {
  Checking = 'CHECKING',
  Savings = 'SAVINGS',
}

/** Version of the automation target calculation logic. */
export enum MoneyManagerAutomationTargetVersion {
  V1 = 'V1',
  V2 = 'V2',
}

export enum MoneyManagerCancelReason {
  ClosedAccount = 'CLOSED_ACCOUNT',
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  RequiredAccountsNotEligible = 'REQUIRED_ACCOUNTS_NOT_ELIGIBLE',
  SubscriptionStatus = 'SUBSCRIPTION_STATUS',
  UnknownError = 'UNKNOWN_ERROR',
  UserSuspended = 'USER_SUSPENDED',
  ValidationError = 'VALIDATION_ERROR',
}

export type MoneyManagerCascadeObjective = {
  __typename?: 'MoneyManagerCascadeObjective'
  accountType: ProductAccountType
  /** Is this active for the customer's current state? */
  isLocked: Scalars['Boolean']
  objectiveType: MoneyManagerCascadeObjectiveType
  /** Target & contribution data. Null for OVERFLOW objectives (or in a weird case where we're having trouble getting Later data) */
  target: Maybe<MoneyManagerCascadeTarget>
}

export enum MoneyManagerCascadeObjectiveType {
  Balance = 'BALANCE',
  Overflow = 'OVERFLOW',
}

export type MoneyManagerCascadeTarget = {
  __typename?: 'MoneyManagerCascadeTarget'
  /** Can the customer change this value? */
  isEditable: Scalars['Boolean']
  /** Balance in (or contributions YTD to) the destination account */
  progressAmount: MoneyRulesCurrencyAmount
  /** How close is the customer to the target? 0-100 */
  progressPercentage: Maybe<Scalars['Int']>
  /** The automation target or contribution limit for the accountType */
  targetAmount: Maybe<MoneyRulesCurrencyAmount>
}

export type MoneyManagerCategoriesInput = {
  amount?: InputMaybe<MoneyRulesCurrencyAmountInput>
  archetype?: InputMaybe<MoneyRulesArchetype>
  stagedRules?: InputMaybe<Array<MoneyManagerStagedRulesInput>>
  /** Base calculations on the customer's monthly deposit amount, instead of their next predicted paycheck. Default: False */
  useMonthlyDepositAmount?: InputMaybe<Scalars['Boolean']>
}

export type MoneyManagerCategoriesResult = MoneyManagerCategoriesSuccess

export type MoneyManagerCategoriesSuccess = {
  __typename?: 'MoneyManagerCategoriesSuccess'
  categories: Array<MoneyManagerCategory>
  totalAmount: MoneyRulesCurrencyAmount
}

export type MoneyManagerCategory = {
  __typename?: 'MoneyManagerCategory'
  allocations: Array<MoneyManagerCategoryAllocation>
  categoryAmount: Maybe<MoneyRulesCurrencyAmount>
  categoryPercent: Scalars['Float']
  categoryType: MoneyManagerCategoryType
  isActive: Scalars['Boolean']
}

export type MoneyManagerCategoryAllocation = {
  __typename?: 'MoneyManagerCategoryAllocation'
  accountId: Scalars['ID']
  accountType: ProductAccountType
  amount: Maybe<MoneyRulesCurrencyAmount>
  beneficiary: Maybe<Beneficiary>
  isEditable: Scalars['Boolean']
  /** Deposit amounts normalized to various cadences */
  normalizedAmounts: Maybe<MoneyManagerNormalizedAmounts>
  notEditableReason: Maybe<MoneyManagerAllocationNotEditableReason>
  percent: Scalars['Float']
  singleRuleId: Maybe<Scalars['Int']>
}

export enum MoneyManagerCategoryType {
  Giving = 'GIVING',
  Investing = 'INVESTING',
  Kids = 'KIDS',
  Saving = 'SAVING',
  Spending = 'SPENDING',
}

export type MoneyManagerDeposit = {
  amount: MoneyRulesCurrencyAmount
  category: MoneyManagerDepositCategory
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  userId: Scalars['String']
}

export type MoneyManagerDepositAssignment = MoneyManagerMoneyAssignment & {
  __typename?: 'MoneyManagerDepositAssignment'
  allocations: Array<MoneyManagerAllocation>
  amount: MoneyRulesCurrencyAmount
  cancelReason: Maybe<MoneyManagerCancelReason>
  createdAt: Scalars['DateTime']
  deposit: MoneyManagerDeposit
  id: Scalars['ID']
  status: MoneyManagerMoneyAssignmentStatus
  type: MoneyManagerMoneyAssignmentType
  userId: Scalars['String']
}

export enum MoneyManagerDepositCategory {
  OneTime = 'ONE_TIME',
  Other = 'OTHER',
  Paycheck = 'PAYCHECK',
  Recurring = 'RECURRING',
}

export enum MoneyManagerDepositState {
  /** The customer has never had the Money Manager process a deposit and is waiting for the first deposit to arrive */
  AwaitingFirstDeposit = 'AWAITING_FIRST_DEPOSIT',
  /** The most recent deposit has arrived and has been split and waiting for the next deposit */
  AwaitingNextDeposit = 'AWAITING_NEXT_DEPOSIT',
  /** The current deposit has arrived and is pending */
  DepositArrived = 'DEPOSIT_ARRIVED',
}

/** Represents the current summary and state of money manager deposits */
export type MoneyManagerDepositSummary = {
  __typename?: 'MoneyManagerDepositSummary'
  /**
   * The amount of the deposit based off the deposit state
   * @deprecated Use amountV2 instead
   */
  amount: Maybe<MoneyRulesCurrencyAmount>
  /** The amount of the deposit in micros based off the deposit state */
  amountV2: Maybe<MicrosMoney>
  /** Completed money assignments received today */
  completedMoneyAssignmentsReceivedToday: Maybe<
    Array<MoneyManagerMoneyAssignment>
  >
  /** Total amount of the money assignments in completedMoneyAssignmentsReceivedToday */
  completedMoneyAssignmentsReceivedTodayTotalAmount: Maybe<MicrosMoney>
  /** The type of deposit based off the deposit state */
  depositType: Maybe<MoneyManagerDepositCategory>
  /** The employer name, populated when depositType is PAYCHECK */
  employer: Maybe<Scalars['String']>
  /** The expected date of the next deposit */
  expectedDepositDate: Maybe<Scalars['DateTime']>
  /** Most recently created pending MoneyAssignment that has not yet been split */
  pendingMoneyAssignment: Maybe<MoneyManagerMoneyAssignment>
  /** The projected deposit amount based on annual income */
  predictedDepositAmount: Maybe<MoneyRulesCurrencyAmount>
  /** The state of Money Manager deposits for the customer */
  state: Maybe<MoneyManagerDepositState>
}

export type MoneyManagerEligibilityResult = {
  __typename?: 'MoneyManagerEligibilityResult'
  ineligibleReasons: Array<IneligibleReasons>
  isEligible: Scalars['Boolean']
  isEligibleForOnboarding: Scalars['Boolean']
  isEligibleForUpgrade: Scalars['Boolean']
}

export type MoneyManagerError = {
  message: Scalars['String']
}

export type MoneyManagerGlobalConfig = {
  __typename?: 'MoneyManagerGlobalConfig'
  rebalanceConfig: MoneyManagerRebalanceConfig
  recurringDepositsConfig: MoneyManagerRecurringDepositsConfig
}

export type MoneyManagerInputError = MoneyManagerError & {
  __typename?: 'MoneyManagerInputError'
  message: Scalars['String']
}

export type MoneyManagerMoneyAssignment = {
  allocations: Array<MoneyManagerAllocation>
  amount: MoneyRulesCurrencyAmount
  cancelReason: Maybe<MoneyManagerCancelReason>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  /** The status of the MoneyAssignment as a whole including the Assignment Target Allocations */
  status: MoneyManagerMoneyAssignmentStatus
  type: MoneyManagerMoneyAssignmentType
  userId: Scalars['String']
}

export enum MoneyManagerMoneyAssignmentStatus {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Pending = 'PENDING',
  Skipped = 'SKIPPED',
  Transferring = 'TRANSFERRING',
}

export enum MoneyManagerMoneyAssignmentType {
  Deposit = 'DEPOSIT',
  Rebalance = 'REBALANCE',
}

export type MoneyManagerNormalizedAmounts = {
  __typename?: 'MoneyManagerNormalizedAmounts'
  daily: Maybe<MoneyRulesCurrencyAmount>
  monthly: Maybe<MoneyRulesCurrencyAmount>
  weekly: Maybe<MoneyRulesCurrencyAmount>
  yearly: Maybe<MoneyRulesCurrencyAmount>
}

export type MoneyManagerPageInfo = {
  __typename?: 'MoneyManagerPageInfo'
  hasNextPage: Scalars['Boolean']
  /** We don't actually have the ability to determine if there was a previous page. Will return true if a cursor was provided */
  hasPreviousPage: Scalars['Boolean']
  limit: Scalars['Int']
}

export type MoneyManagerPageInput = {
  after?: InputMaybe<Scalars['ID']>
  first?: InputMaybe<Scalars['Int']>
}

export type MoneyManagerPaycheck = MoneyManagerDeposit & {
  __typename?: 'MoneyManagerPaycheck'
  amount: MoneyRulesCurrencyAmount
  category: MoneyManagerDepositCategory
  createdAt: Scalars['DateTime']
  employer: Scalars['String']
  id: Scalars['ID']
  userId: Scalars['String']
}

export type MoneyManagerPeriod = {
  __typename?: 'MoneyManagerPeriod'
  unit: MoneyManagerPeriodUnit
  value: Scalars['Int']
}

export type MoneyManagerPeriodInput = {
  unit: MoneyManagerPeriodUnit
  value: Scalars['Int']
}

export enum MoneyManagerPeriodUnit {
  Month = 'MONTH',
  Week = 'WEEK',
}

/** Mirrors MoneyManagerAllocationResult */
export type MoneyManagerRebalanceAllocationInput = {
  amount: MoneyRulesCurrencyAmountInput
  destination: MoneyRulesDestinationInput
  rulePriority: Scalars['Int']
}

export type MoneyManagerRebalanceAssignment = MoneyManagerMoneyAssignment & {
  __typename?: 'MoneyManagerRebalanceAssignment'
  accountId: Scalars['ID']
  allocations: Array<MoneyManagerAllocation>
  amount: MoneyRulesCurrencyAmount
  cancelReason: Maybe<MoneyManagerCancelReason>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  sourceAccountType: MoneyManagerRebalanceSourceAccountType
  status: MoneyManagerMoneyAssignmentStatus
  type: MoneyManagerMoneyAssignmentType
  userId: Scalars['String']
}

export type MoneyManagerRebalanceConfig = {
  __typename?: 'MoneyManagerRebalanceConfig'
  checkingRebalanceTriggerAmount: MoneyRulesCurrencyAmount
  savingsRebalanceTriggerAmount: MoneyRulesCurrencyAmount
}

/** Similar to a MoneyManagerAssignment, but stripped down */
export type MoneyManagerRebalanceResult = {
  __typename?: 'MoneyManagerRebalanceResult'
  allocations: Array<MoneyManagerAllocationResult>
  createdAt: Scalars['DateTime']
  ruleset: MoneyManagerRebalanceRuleset
  sourceAccountId: Scalars['ID']
  sourceAccountType: MoneyManagerRebalanceSourceAccountType
  sourceAmount: MoneyRulesCurrencyAmount
  sourceBalance: MoneyRulesCurrencyAmount
  sourceTargetAmount: MoneyRulesCurrencyAmount
}

export type MoneyManagerRebalanceRuleset = {
  __typename?: 'MoneyManagerRebalanceRuleset'
  archetype: MoneyRulesArchetype
  createdAt: Scalars['DateTime']
  version: Scalars['Int']
}

export type MoneyManagerRebalanceRulesetInput = {
  archetype: MoneyRulesArchetype
  createdAt: Scalars['DateTime']
  version: Scalars['Int']
}

/** Contains only SourceAccountTypes allowed for rebalances */
export enum MoneyManagerRebalanceSourceAccountType {
  Checking = 'CHECKING',
}

export enum MoneyManagerRebalanceSuppressionSource {
  ClientHome = 'CLIENT_HOME',
  MoneyManagerLander = 'MONEY_MANAGER_LANDER',
  MoneyManagerRebalanceFlow = 'MONEY_MANAGER_REBALANCE_FLOW',
}

export type MoneyManagerRebalancesResponse = {
  __typename?: 'MoneyManagerRebalancesResponse'
  rebalances: Array<Maybe<MoneyManagerRebalanceResult>>
}

export type MoneyManagerRecurringDeposit = MoneyManagerDeposit & {
  __typename?: 'MoneyManagerRecurringDeposit'
  amount: MoneyRulesCurrencyAmount
  category: MoneyManagerDepositCategory
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  userId: Scalars['String']
}

export type MoneyManagerRecurringDepositsConfig = {
  __typename?: 'MoneyManagerRecurringDepositsConfig'
  allowedFrequencies: Array<MoneyManagerRecurringFrequency>
  maximumAmount: MoneyRulesCurrencyAmount
  minimumAmount: MoneyRulesCurrencyAmount
}

export enum MoneyManagerRecurringFrequency {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
}

export type MoneyManagerRulesetNotFoundError = MoneyManagerError & {
  __typename?: 'MoneyManagerRulesetNotFoundError'
  message: Scalars['String']
}

export type MoneyManagerScheduledDeposit = {
  /** @deprecated Use amountV2 instead */
  amount: MoneyRulesCurrencyAmount
  amountV2: MicrosMoney
  expectedDate: Maybe<Scalars['DateTime']>
}

export type MoneyManagerScheduledPaycheck = MoneyManagerScheduledDeposit & {
  __typename?: 'MoneyManagerScheduledPaycheck'
  /** @deprecated Use amountV2 instead */
  amount: MoneyRulesCurrencyAmount
  amountV2: MicrosMoney
  employer: Scalars['String']
  expectedDate: Maybe<Scalars['DateTime']>
}

export type MoneyManagerScheduledRecurringDeposit =
  MoneyManagerScheduledDeposit & {
    __typename?: 'MoneyManagerScheduledRecurringDeposit'
    /** @deprecated Use amountV2 instead */
    amount: MoneyRulesCurrencyAmount
    amountV2: MicrosMoney
    expectedDate: Maybe<Scalars['DateTime']>
  }

export type MoneyManagerSettings = {
  __typename?: 'MoneyManagerSettings'
  attemptedMoneyManagerOnboarding: Scalars['Boolean']
  depositSources: Array<MoneyRulesSourceSetting>
  processRecurringDeposits: Scalars['Boolean']
  rebalanceSuppressions: Maybe<RebalanceSuppressions>
  status: MoneyManagerStatus
  /** @deprecated Use rebalanceSuppressions instead */
  suppressRebalancesUntil: Maybe<Scalars['DateTime']>
  userId: Scalars['ID']
}

export type MoneyManagerSourceSetting = {
  __typename?: 'MoneyManagerSourceSetting'
  depositType: MoneyRulesDepositType
  displayName: Maybe<Scalars['String']>
  enabled: Scalars['Boolean']
  source: Scalars['String']
}

/** Input type for MoneyManager allocation. */
export type MoneyManagerStagedRulesInput = {
  distribution: MoneyRulesDistributionInput
  singleRuleId: Scalars['Int']
}

export enum MoneyManagerState {
  /** The customer has never had the Money Manager turned on */
  NotSetup = 'NOT_SETUP',
  /** The Money Manager is turned off */
  Off = 'OFF',
  /** The Money Manager is turned on */
  On = 'ON',
}

export enum MoneyManagerStatus {
  NotSetup = 'NOT_SETUP',
  Off = 'OFF',
  On = 'ON',
}

/** Represents the current summary and state of the money manager */
export type MoneyManagerSummary = {
  __typename?: 'MoneyManagerSummary'
  depositSummary: MoneyManagerDepositSummary
  /** The amount received by the Money Manager this month */
  receivedThisPeriodAmount: MoneyRulesCurrencyAmount
  /** The amount scheduled for the Money Manager for this month */
  scheduledThisPeriodAmount: MoneyRulesCurrencyAmount
  /**
   * The state of the Money Manager for the customer
   * @deprecated Use status on MoneyManagerSettings instead
   */
  state: MoneyManagerState
  /** The total amount deposited into Money Manager all time. */
  totalAmountDeposited: MoneyRulesCurrencyAmount
  /** The total amount of money allocated into the customers Invest/Later/Early accounts through Money Manager */
  totalAmountInvested: MoneyRulesCurrencyAmount
  /** The total amount of money allocated into the customers savings account through Money Manager */
  totalAmountSaved: MoneyRulesCurrencyAmount
}

export type MoneyMentorContext = {
  adultContext?: InputMaybe<AdultContextInput>
  childContexts?: InputMaybe<Array<ChildContextInput>>
  refreshPrompt?: InputMaybe<Scalars['Boolean']>
}

export enum MoneyRulesAccountType {
  Checking = 'CHECKING',
  Early = 'EARLY',
  Invest = 'INVEST',
  Later = 'LATER',
  Savings = 'SAVINGS',
}

export enum MoneyRulesArchetype {
  DebtFocused = 'DEBT_FOCUSED',
  Default = 'DEFAULT',
  DefaultRebalance = 'DEFAULT_REBALANCE',
  GivingFocused = 'GIVING_FOCUSED',
}

export type MoneyRulesArchetypesInput = {
  archetypes?: InputMaybe<Array<MoneyRulesArchetype>>
  date?: InputMaybe<Scalars['DateTime']>
}

export type MoneyRulesArchetypesResult = MoneyRulesArchetypesSuccess

export type MoneyRulesArchetypesSuccess = {
  __typename?: 'MoneyRulesArchetypesSuccess'
  rulesets: Array<MoneyRulesRuleset>
}

export type MoneyRulesCancelMoneyAssignmentSuccess = {
  __typename?: 'MoneyRulesCancelMoneyAssignmentSuccess'
  moneyAssignment: MoneyManagerMoneyAssignment
}

export type MoneyRulesCondition = {
  __typename?: 'MoneyRulesCondition'
  fallback: Maybe<MoneyRulesDestination>
  type: MoneyRulesConditionType
  unit: MoneyRulesConditionUnit
  value: Scalars['Float']
}

export type MoneyRulesConditionInput = {
  fallback?: InputMaybe<MoneyRulesDestinationInput>
  type: MoneyRulesConditionType
  unit: MoneyRulesConditionUnit
  value: Scalars['Float']
}

export enum MoneyRulesConditionType {
  DebtExists = 'DEBT_EXISTS',
  HighInterestDebtExists = 'HIGH_INTEREST_DEBT_EXISTS',
  SourceAmountAtLeast = 'SOURCE_AMOUNT_AT_LEAST',
}

export enum MoneyRulesConditionUnit {
  Currency = 'CURRENCY',
}

export type MoneyRulesCurrencyAmount = {
  __typename?: 'MoneyRulesCurrencyAmount'
  currency: Currency
  value: Scalars['Float']
}

export type MoneyRulesCurrencyAmountInput = {
  currency: Currency
  value: Scalars['Float']
}

export enum MoneyRulesDepositType {
  OneTime = 'ONE_TIME',
  Paycheck = 'PAYCHECK',
  Recurring = 'RECURRING',
}

export type MoneyRulesDestination = {
  __typename?: 'MoneyRulesDestination'
  accountId: Scalars['String']
  accountType: MoneyRulesAccountType
  balance: Maybe<MoneyRulesCurrencyAmount>
  targetAmount: Maybe<MoneyRulesCurrencyAmount>
}

export type MoneyRulesDestinationInput = {
  accountId: Scalars['String']
  accountType: MoneyRulesAccountType
}

export type MoneyRulesDistribution = {
  __typename?: 'MoneyRulesDistribution'
  unit: MoneyRulesDistributionUnit
  value: Scalars['Float']
}

export type MoneyRulesDistributionInput = {
  unit: MoneyRulesDistributionUnit
  value: Scalars['Float']
}

export enum MoneyRulesDistributionUnit {
  FixedAmount = 'FIXED_AMOUNT',
  Percentage = 'PERCENTAGE',
}

export type MoneyRulesMoneySource = {
  __typename?: 'MoneyRulesMoneySource'
  accountId: Scalars['String']
  accountType: MoneyRulesAccountType
  amount: MoneyRulesCurrencyAmount
}

export type MoneyRulesMoneySourceInput = {
  accountId: Scalars['String']
  accountType: MoneyRulesAccountType
  amount: MoneyRulesCurrencyAmountInput
}

export type MoneyRulesMoneySplit = {
  __typename?: 'MoneyRulesMoneySplit'
  destination: MoneyRulesDestination
  distribution: MoneyRulesDistribution
}

export type MoneyRulesRule = {
  __typename?: 'MoneyRulesRule'
  conditions: Array<MoneyRulesCondition>
  destination: MoneyRulesDestination
  distribution: MoneyRulesDistribution
  priority: Scalars['Int']
  ruleType: MoneyRulesRuleType
}

export type MoneyRulesRuleInput = {
  conditions: Array<MoneyRulesConditionInput>
  destination: MoneyRulesDestinationInput
  distribution: MoneyRulesDistributionInput
  priority: Scalars['Int']
  ruleType: MoneyRulesRuleType
}

export enum MoneyRulesRuleType {
  FlatPct = 'FLAT_PCT',
  FlatPctUpToLaterGoal = 'FLAT_PCT_UP_TO_LATER_GOAL',
  FlatValue = 'FLAT_VALUE',
  FullRemainder = 'FULL_REMAINDER',
  UpToCheckingGoal = 'UP_TO_CHECKING_GOAL',
  UpToSavingsGoal = 'UP_TO_SAVINGS_GOAL',
}

export type MoneyRulesRuleset = {
  __typename?: 'MoneyRulesRuleset'
  archetype: MoneyRulesArchetype
  createdAt: Scalars['DateTime']
  isCustomized: Scalars['Boolean']
  minimumAmount: Scalars['Int']
  rules: Array<MoneyRulesRule>
}

export type MoneyRulesRulesetInput = {
  archetype: MoneyRulesArchetype
  minimumAmount: Scalars['Int']
  rules: Array<MoneyRulesRuleInput>
}

export type MoneyRulesRulesetNotFoundException = {
  __typename?: 'MoneyRulesRulesetNotFoundException'
  message: Scalars['String']
}

export type MoneyRulesSettings = {
  __typename?: 'MoneyRulesSettings'
  depositSources: Array<MoneyRulesSourceSetting>
  /** @deprecated Use status instead */
  moneyManagerEnabled: Scalars['Boolean']
  processRecurringDeposits: Scalars['Boolean']
  userId: Scalars['ID']
}

export type MoneyRulesSourceSetting = {
  __typename?: 'MoneyRulesSourceSetting'
  depositType: MoneyRulesDepositType
  displayName: Maybe<Scalars['String']>
  enabled: Scalars['Boolean']
  source: Scalars['String']
}

export type MoneyRulesSplitOverridesInput = {
  acornsIncomePercentage?: InputMaybe<Scalars['Float']>
  adjustForAcornsIncomeShare?: InputMaybe<Scalars['Boolean']>
  grossYearlyIncome?: InputMaybe<Scalars['Int']>
  stateOfResidence?: InputMaybe<StateCode>
}

export type MoneyRulesSuggestedSplits = {
  __typename?: 'MoneyRulesSuggestedSplits'
  moneySource: MoneyRulesMoneySource
  rulesetVersion: Maybe<Scalars['Int']>
  splits: Array<Maybe<MoneyRulesMoneySplit>>
}

export type MoneyRulesSuggestionResult = MoneyRulesSuggestedSplits

export type MoneyRulesUpdateArchetypeResult = MoneyRulesUpdateRulesetSuccess

export type MoneyRulesUpdateCustomerMoneyRulesResult =
  MoneyRulesUpdateRulesetSuccess

export type MoneyRulesUpdateRulesetSuccess = {
  __typename?: 'MoneyRulesUpdateRulesetSuccess'
  resultingRuleset: MoneyRulesRuleset
}

export type MonthlyTotal = {
  __typename?: 'MonthlyTotal'
  isPredicted: Scalars['Boolean']
  totalAmount: FormattedMonetaryAmount
  yearMonth: Scalars['String']
}

/** Root mutation type */
export type Mutation = {
  __typename?: 'Mutation'
  _noop: Maybe<Scalars['Boolean']>
  /** DEPRECATED - use agreeToAcceptanceDocument instead */
  acceptDocument: AcceptDocumentResponse
  activateAcornsCredentials: ActivateAcornsCredentialsResult
  activateBankCard: Maybe<ActivateBankCardPayload>
  /** @implicit(userId: ID!) */
  addCohortEligibility: AddCohortEligibilityResult
  /** @implicit(userId: String!) */
  addFavoritePartnerOffers: FavoritePartnerOfferGroup
  /** Saves new search term and returns that term when it is saved */
  addSearchTermToLearnSearchHistory: AddSearchTermToLearnSearchHistoryResult
  /** Adds a security to a portfolio */
  addSecurityToPortfolio: AddSecurityToPortfolioResult
  /** Add a Self Directed Portfolio */
  addSelfDirectedPortfolio: AddSelfDirectedPortfolioResult
  /** Add a trusted contact for a user */
  addTrustedContact: UpdateTrustedContactResult
  agreeToAcceptanceDocument: Maybe<Scalars['Void']>
  /** Validate a challenge. */
  answerChallenge: AnswerChallengeResult
  /** @implicit(userId: ID!) */
  answerLearnQuizQuestion: AnswerLearnQuizQuestionResult
  /** Apply a promotion to an existing subscription. May entitle a subscriber to promotional pricing for their subscription and/or additional incentives. */
  applyPromotion: ApplyPromotionResult
  /** Apply a promotional waiver */
  applyPromotionalWaiver: Maybe<ApplyPromotionalWaiverResult>
  /** Apply a provisional (open ended) waiver */
  applyProvisionalWaiver: Maybe<ApplyProvisionalWaiverResult>
  /** Apply a waiver coupon */
  applyWaiverCoupon: Maybe<ApplyWaiverCouponResult>
  archiveInvalidSmartDepositSettings: ArchiveInvalidSmartDepositRecordsResult
  /** @implicit(userId: String!) */
  askFinancialAdvisorQuestion: FinancialAdvisorQuestionResponse
  /** Assign a linked subaccount to a role (i.e. funding source) */
  assignLinkedSubaccount: Maybe<LinkedSubaccount>
  attachChatTranscript: Maybe<AttachChatTranscriptResult>
  /** Request an AuthSession for the provided credentials. */
  authenticate: AuthenticateResult
  authenticateForFeeNegotiation: AuthenticateForFeeNegotiationResult
  authenticateForFeeNegotiationChallenge: AuthenticateNegotiationStatusResult
  authenticateForFeeNegotiationChallengeMethod: AuthenticateNegotiationStatusResult
  /** Batch adds tier-subscription items for users for specified user uuids, tierIds, tierPriceId */
  batchAddTierSubscriptions: BatchAddTierSubscriptionsResult
  /** @implicit(userId: ID!) */
  blockDevice: BlockDeviceResult
  cancelCheckPayment: Maybe<CancelCheckPaymentResult>
  /** @implicit(userId: UUID!) */
  cancelIntent: CancelIntentResult
  /** Cancel pending investment */
  cancelInvestment: CancelInvestmentResult
  /** Cancel an existing account closure request */
  cancelInvestmentAccountClosureRequest: CancelInvestmentAccountClosureRequestResult
  /** Gives the customer the ability to cancel a pending Money Assignment */
  cancelMoneyAssignment: Maybe<CancelMoneyAssignmentResult>
  /** @implicit(userId: ID!) */
  cancelRecurringTransfer: Maybe<CancelRecurringTransferResult>
  cancelTransfer: Maybe<CancelTransferPayload>
  /** Change the amount of an outside contribution payment intent */
  changeOutsideContributionAmount: ChangeOutsideContributionAmountResult
  /** Changes a users password if password change criteria is met */
  changePassword: Maybe<Scalars['Void']>
  /** @implicit(userId: ID!) */
  changePasswordV2: ChangePasswordResult
  closeBankAccount: CloseBankAccountResult
  /** Start the account closure process for the specified investment account. */
  closeInvestmentAccount: CloseInvestmentAccountResult
  /** Close an open Acorns user account */
  closeUserAccount: CloseUserAccountResult
  completeCheckDeposit: Maybe<CompleteCheckDepositPayload>
  /** Mark account as having completed the registration funnel */
  completeFunnelOnboarding: CompleteFunnelOnboardingResult
  completeRegistration: Maybe<User>
  configureSplitDepositDirectDepositIntentSetting: ConfigureSplitDepositDirectDepositIntentPayload
  configureSplitDepositDirectDepositSetting: ConfigureSplitDepositDirectDepositSettingPayload
  connectACHAccount: ConnectAchAccountResult
  connectLadderCustomer: Maybe<LadderLinkResponse>
  consumeUserToken: ConsumeUserTokenResult
  /** @implicit(userId: ID!) */
  createAuthProfile: CreateAuthProfileResult
  createAuthenticatedSupportTicket: Maybe<SupportTicket>
  /** @deprecated External createBankAccount is no longer supported. For creating a checking account, we use orderBankCard mutation. */
  createBankAccount: Maybe<CreateBankAccountPayload>
  /** Create a beneficiary */
  createBeneficiary: CreateBeneficiaryResult
  /** @implicit(userId: ID!) */
  createDesignatedBeneficiary: CreateDesignatedBeneficiaryResult
  /** @implicit(userId: ID!) */
  createDesignation: CreateDesignationResult
  /** Get Pinwheel Link Token */
  createDirectDepositLinkInfo: CreateDirectDepositLinkInfoSwitch
  createDocumentUpload: CreateDocumentUpload
  createIRAWithProfile: Maybe<CreateInvestmentAccountResponse>
  /** @implicit(userId: ID!) */
  createImplicitTokenForUser: CreateImplicitTokenForUserResult
  /** @implicit(userId: UUID!) */
  createIntent: CreateIntentResult
  /** Calculates portfolio recommendation based off of specific factors for specific account type */
  createInvestingStrategyRecommendation: CreateInvestingStrategyRecommendationResult
  createInvestmentAccount: Maybe<CreateInvestmentAccountResponse>
  /**
   * @implicit(userId: String!)
   * @deprecated Job Alerts are no longer supported
   */
  createJobAlert: Maybe<CreateJobAlertResult>
  createLadderQuote: Maybe<LadderResponse>
  createLaterContribution: Maybe<Scalars['Void']>
  /** (Internal-only) Provision a new offer. */
  createOffer: CreateOfferResult
  /** Create a new Outside Contribution */
  createOutsideContribution: CreateOutsideContributionResult
  /** Generate outside contribution payment token */
  createOutsideContributionCheckoutCart: CreateOutsideContributionCheckoutCartResult
  /** Create a linked account */
  createPlaidLinkedAccount: Maybe<LinkedAccount>
  /** Create a Prospect User */
  createProspectUser: CreateProspectUserResult
  /** (Internal-only) Create a refund for a given invoice */
  createRefund: Maybe<CreateRefundResult>
  createSavingsAccount: CreateSavingsAccountResult
  /** (Internal-only) Provision a new subscription migration. */
  createSubscriptionMigration: CreateSubscriptionMigrationResult
  createSupportTicketOrException: Maybe<SupportTicketResponse>
  /** Create a presigned post for direct to s3 file upload */
  createUploadUrl: CreateUploadUrlResult
  createUser: Maybe<Session>
  /** Creates a new user and user profile */
  createUserProfile: CreateUserProfileResult
  /** Create a billing vendor invoice */
  createVendorInvoice: Maybe<CreateVendorInvoiceResult>
  /** Create a new billing vendor line item */
  createVendorLineItem: Maybe<CreateVendorLineItemResult>
  /** Deactivates the specified account and returns the newley deactived account. */
  deactivateAccount: Maybe<Account>
  /** Deactivate a beneficiary that is no longer used */
  deactivateBeneficiary: DeactivateBeneficiaryResult
  /** Deactivate a user's subscription */
  deactivateTierSubscription: DeactivateTierSubscriptionResult
  /** Delete a chat session and all its messages asynchronously. */
  deleteChatSession: DeleteChatSessionResponse
  deleteExpiredBankCardOrder: Maybe<DeleteExpiredBankCardOrderResult>
  /** Deletes a trusted contact for a user */
  deleteTrustedContact: DeleteTrustedContactResult
  /** Delete/expire any type of waiver or coupon */
  deleteWaiverCoupon: Maybe<DeleteWaiverCouponResult>
  /** Deregister and Authenticator. */
  deregisterAuthenticator: DeregisterAuthenticatorResult
  /** @implicit(userId: ID) */
  destroySession: Maybe<Scalars['Void']>
  /** @implicit(userId: ID!) */
  dismissMessage: UpdateMessageResult
  /** @implicit(userId: ID!) */
  dismissMessages: DismissMessagesResult
  /** Edit a trusted contact for a user */
  editTrustedContact: UpdateTrustedContactResult
  /**
   * DEPRECATED - Quarterly recaps are now always enabled for Early accounts. This
   * mutation is kept for backwards compatibility but has no effect.
   */
  enableQuarterlyRecaps: EnableQuarterlyRecapsResult
  /** Explicitly end the chat session. */
  endChatSession: EndChatSessionResponse
  /** Enroll a user in streaks. Called during onboarding for experiment group. */
  enrollInStreaks: EnrollInStreaksResult
  exchangeAcornsEarlyToken: ExchangeAcornsEarlyTokenResult
  /** Executes money manager rebalances based on the provided rebalance assignments */
  executeMoneyManagerRebalances: ExecuteMoneyManagerRebalancesResult
  /** Expire a promotional waiver */
  expirePromotionalWaiver: Maybe<ExpirePromotionalWaiverResult>
  /** Mark an open billing vendor invoice as failed */
  failVendorInvoice: Maybe<FailVendorInvoiceResult>
  /** Record an action feed event */
  feedEvent: Maybe<ActionFeedEventResponse>
  /** Creates session input to initialize SDK for document upload and verification */
  generateDocumentUploadSession: GenerateDocumentUploadSessionResult
  /** Generate a link token for layer account linking */
  generateLayerLinkSession: GenerateLayerLinkSessionResult
  /** Generate a Link Token and return either the Link Token of Link URL for use with Account Linking. */
  generateLinkSession: LinkSessionResult
  /** @implicit(userId: ID!) */
  hideMessage: UpdateMessageResult
  /** @implicit(userId: ID!) */
  hideMessageByExternalId: UpdateMessageResult
  initiateBankAccountCreation: InitiateBankAccountResponse
  initiateBankingKYC: InitiateBankingKycPayload
  /** Initiate challenge following credentials validation. */
  initiateChallenge: InitiateChallengeResult
  /** Initiate registration of an EmailAuthenticator. */
  initiateEmailChallenge: InitiateEmailChallengeResult
  initiateLaterProgramAccountContribution: Maybe<LaterProgramAccountContributionResult>
  /** Gives the customer the ability to immediately start the allocation of a pending Money Assignment */
  initiateMoneyAssignment: Maybe<InitiateMoneyAssignmentResult>
  /** @implicit(userId: ID!) */
  initiatePartnerDataShare: PartnerDataShareResponse
  /** Initiate sending push notifications to registered PushAuthenticator(s). */
  initiatePushChallenge: InitiatePushChallengeResult
  /** Initiate registration of a PhoneAuthenticator. */
  initiateSMSChallenge: InitiateSmsChallengeResult
  initiateTransfer: Maybe<InitiateTransferPayload>
  /** @implicit(userId: ID!) */
  initiateVerification: InitiateVerificationResult
  laterCreateIndividualBeneficiary: Maybe<LaterIndividualBeneficiaryResponse>
  laterTotalLiquidation: Maybe<Scalars['Void']>
  /** Make a withdrawal from a later account One of either earlyDistributionTaxExceptionReason or reason is required; reason is newer/preferred withdrawalType is no longer supported, since it can be derived */
  laterWithdrawal: Maybe<Scalars['Void']>
  /** Legacy document upload */
  legacyUploadDocument: LegacyUploadDocumentResult
  linkACHAccount: Maybe<Scalars['Void']>
  /** Link a funding source via account and routing number */
  linkManualFundingSource: LinkManualFundingSourceResult
  /** Link OIDC credentials to an existing account */
  linkOidcCredentials: LinkOidcCredentialsResult
  lockBankCard: Maybe<LockBankCardPayload>
  /** @implicit(userId: ID!) */
  logout: LogoutResult
  /** @implicit(userId: ID!) */
  logoutDevice: LogoutDeviceResult
  /** Creates a new investment */
  makeInvestment: MakeInvestmentPayload
  /** @implicit(userId: ID!) */
  markAllAsRead: MarkAllAsReadResult
  /** Marks content with given ID as helpful and returns ID and helpful flag or error if it does not exist */
  markLearnContentAsHelpful: MarkLearnContentAsHelpfulResult
  /** Saves content as viewed and returns id and date when it is viewed or error if content does not exist */
  markLearnContentAsViewed: MarkLearnContentAsViewedResult
  /** Gives the customer the ability update the assignment target amounts for a pending Money Assignment */
  modifyMoneyAssignment: ModifyMoneyAssignmentResult
  /** Open a Core InvestmentAccount */
  openCoreInvestmentAccount: OpenCoreInvestmentAccountResult
  /** Create an Acorns Early Account */
  openEarlyAccount: OpenEarlyAccountResult
  orderBankCard: Maybe<OrderBankCardResult>
  orderPhysicalBankCard: Maybe<OrderPhysicalBankCardResult>
  /** Performs the named blueprint action for the authenticated user. */
  performBlueprintAction: Maybe<BlueprintActionResult>
  /** @implicit(userId: String!) */
  postBankFeeNegotiation: BenefitsMessage
  /** @implicit(userId: String!) */
  postUserReportedBankFeeRefund: BenefitsMessage
  /** Fetch and persist verified Acorns Early customer data */
  prefillAcornsEarlyData: PrefillAcornsEarlyDataResult
  /** Queue users for vendor onboarding by sending each userId as a separate message to the billing vendor onboarding queue */
  queueUsersForVendorOnboarding: Maybe<QueueUsersForVendorOnboardingResult>
  /** Rate a message where canRate is true. */
  rateChatMessage: RateChatMessageResponse
  /** @implicit(userId: String!) */
  rateFinancialAdvisorResponse: InteractionRatingResponse
  /** @implicit(userId: ID!) */
  readMessage: UpdateMessageResult
  /** Record view_at timestamp on investment account recap. */
  recordInvestmentAccountRecapView: RecordInvestmentAccountRecapViewResult
  /**
   * Record streak activity attested by the client.
   * ONE_TIME sets an optimistic overlay while waiting for confirmed investment events.
   * RECURRING durably completes the current period on recurring setup, bridging until
   * a source-of-truth recurring enabled/disabled event is available.
   */
  recordStreakActivity: RecordStreakActivityResult
  /** Records a new tax refund event with associated transactions */
  recordTaxRefund: RecordTaxRefundPayload
  /** Records when a user acts on a notification and makes an investment */
  recordTaxRefundInvestment: RecordTaxRefundInvestmentPayload
  /** Record an external payment for manual billing vendor invoices */
  recordVendorExternalTransaction: Maybe<RecordVendorExternalTransactionResult>
  redeemGiftcard: Maybe<Scalars['Void']>
  refreshAuthToken: RefreshAuthTokenResult
  /** Regenerate public token for an investment account recap. */
  regenerateInvestmentAccountRecapPublicToken: RegenerateInvestmentAccountRecapPublicTokenResult
  registerCredentials: RegisterCredentialsResult
  /** Register a PushAuthenticator and SNS device token. */
  registerDeviceTokenAndPushAuthenticator: RegisterDeviceTokenAndPushAuthenticatorResult
  /** Register an EmailAuthenticator. */
  registerEmailAuthenticator: RegisterEmailAuthenticatorResult
  /** Registers linked subaccount after beginning the link session */
  registerLayerLinkSession: RegisterLayerLinkSessionResult
  /** Save a linked account */
  registerLinkSession: Maybe<RegisterLinkSessionResult>
  /** Register OIDC credentials */
  registerOidcCredentials: RegisterOidcCredentialsResult
  /** Register a PhoneAuthenticator. */
  registerPhoneAuthenticator: RegisterPhoneAuthenticatorResult
  /** Registers a prospect user with associated source attributes */
  registerProspect: RegisterProspectResult
  /** Re-initiate registration of an Authenticator. */
  reinitiateChallenge: ReinitiateSmsChallengeResult
  reissueBankCard: Maybe<ReissueBankCardResult>
  /** @implicit(userId: ID!) */
  removeCohortEligibility: RemoveCohortEligibilityResult
  /** @implicit(userId: ID!) */
  removeDesignation: RemoveDesignationResult
  /** @implicit(userId: String!) */
  removeFavoritePartnerOffers: FavoritePartnerOfferGroup
  /**
   * @implicit(userId: String!)
   * @deprecated Job Alerts are no longer supported
   */
  removeJobAlert: Maybe<RemoveJobAlertResult>
  /** Removes a security from a portfolio */
  removeSecurityFromPortfolio: RemoveSecurityFromPortfolioResult
  /** Start the process for removing a self directed portfolio from an investment account */
  removeSelfDirectedPortfolio: RemoveSelfDirectedPortfolioResult
  /** Reopen a closed Acorns user account */
  reopenUserAccount: ReopenUserAccountResult
  reportBankCardLostStolen: Maybe<ReportBankCardLostStolenPayload>
  requestAccountClosure: Maybe<Scalars['Void']>
  /** Create or retrieve a sticker request for the authenticated recipient's tip link */
  requestContributionStickers: RequestContributionStickersResult
  /** Attempts to close a single or multiple Early investment accounts */
  requestEarlyAccountClosure: Array<RequestEarlyAccountClosureResult>
  /** Attempts to reopen an investment account. */
  requestInvestmentAccountReopen: RequestInvestmentAccountReopenResult
  /** Requests start of layer session for user-permissioned information */
  requestLayerSession: RequestLayerSessionResult
  /** Request login support for a matched account after passing SSN collision KYC */
  requestMatchedAccountLoginSupport: RequestMatchedAccountLoginSupportResult
  /** Request to be waived from being migrated to a new Subscription. */
  requestSubscriptionMigrationWaiver: RequestSubscriptionMigrationWaiverResult
  /** Resends an already sent chat message. For use when the bot does not respond in a reasonable timeframe */
  resendChatMessage: ResendChatMessageResponse
  resetPassword: Maybe<Scalars['Void']>
  /**
   * Resets a password if the password reset token exists (legacy Backend flow)
   * @deprecated Use resetPasswordWithToken instead
   */
  resetPasswordByToken: ResetPasswordByTokenResult
  /** Resets a password if the password reset token exists (updated flow through web app) */
  resetPasswordWithToken: ResetPasswordWithTokenResult
  /** Resolve SSN collision and return matched account information */
  resolveMatchedAccount: MatchedAccountResult
  /** Saves poll respond and returns stats for related poll or error if poll does not exists */
  respondToLearnPoll: RespondToLearnPollResult
  /** Retriggers RDVs for the user. */
  retriggerRdvs: RetriggerRdvsResult
  /** Revokes given reset password token */
  revokePasswordResetToken: RevokePasswordResetTokenResult
  /** Update a single round up profile for a user */
  roundUpProfile: Maybe<RoundUpProfile>
  /** Activate or retrieve the authenticated recipient's tip profile */
  saveTipProfile: SaveTipProfileResult
  /** Save upload url after direct s3 upload and create upload record */
  saveUploadUrl: LegacyUploadDocumentResult
  /** Save uploads url after direct s3 upload and create upload record one by one */
  saveUploadUrls: SaveUploadUrlsResult
  /** @implicit(userId: ID!) */
  scheduleRecurringTransfer: Maybe<ScheduleRecurringTransferResult>
  sendBrazeEvent: Scalars['String']
  /** Send a chat message as a user to the bot. The bot will respond asynchronously on the subscription for the user's session. */
  sendChatMessage: SendChatMessageResponse
  sendCheckPayment: Maybe<SendCheckPaymentResult>
  sessionRefresh: Maybe<Session>
  /** @implicit(userId: ID!) */
  setAuthenticationPIN: SetAuthenticationPinResult
  /** Update a beneficiary's SSN/TIN */
  setBeneficiarySsn: SetBeneficiarySsnResult
  /** @implicit(userId: ID!) */
  setDefaultAuthenticator: SetDefaultAuthenticatorResult
  /** @implicit(userId: String!) */
  setFavoritePartnerOffers: FavoritePartnerOfferGroup
  /** Set a given investment account recap's public access. */
  setInvestmentAccountRecapPublicAccess: SetInvestmentAccountRecapPublicAccessResult
  /** Updates a plaid account with a new linking error code. Returns the updated linked account. */
  setLinkingError: Maybe<LinkedAccount>
  /** Set the manual flag to true on a round up */
  setManualRoundUps: Array<RoundUp>
  /**
   * @implicit(userId: String!)
   * @deprecated Use mutation.updateNegotiationStatus instead
   */
  setNegotiationStatus: SetNegotiationStatusResult
  setPortfolio: User
  /** Set a funding source as preferred withdrawal account */
  setPreferredWithdrawalAccount: SetPreferredWithdrawalAccountResult
  /** @implicit(userId: String!) */
  setUserPartnerStatus: UserPartnerStatusResponse
  splitDeposit: SplitDepositMutation
  splitDepositSettings: SplitDepositSettingsMutation
  /** Add a direct deposit employer */
  startAcornsPdfSwitch: Maybe<Scalars['Boolean']>
  /** Start a chat session with the bot */
  startChatSession: StartChatSessionResponse
  startCheckDeposit: Maybe<StartCheckDepositPayload>
  /** Start the public tip contribution flow for an approved tip link */
  startExternalContribution: StartExternalContributionResult
  /** Persists a user intention of perform an online switch. */
  startOnlineSwitch: StartOnlineSwitchPayload
  /** Submits a direct deposit switch via ClickSwitch */
  startSubmittableSwitch: Maybe<StartSubmittableSwitchPayload>
  stopRecurringInvestment: RecurringInvestmentPayload
  stub: Maybe<Scalars['String']>
  /**
   * @implicit(userId: String!)
   * @deprecated Use mutation.postUserReportedBankFeeRefund instead
   */
  submitBankFeeNegotiation: SubmitBankFeeNegotiationResult
  /** Submit missing Earn reward request */
  submitMissingEarnRewardRequest: SubmitMissingEarnRewardRequestResult
  submitRDVs: Scalars['Boolean']
  submitSpendTransactionsDispute: SpendTransactionsDisputeResult
  /**
   * @implicit(userId: String!)
   * @deprecated Use mutation.postUserReportedBankFeeRefund instead
   */
  submitUserReportedBankFeeRefund: SubmitUserReportedBankFeeRefundResult
  /** Eventually will replace the current 'subscribeUserToTier' mutation */
  subscribeToTier: SubscribeToTierResult
  /**
   * Attempt to subscribe a user to a specific Tier + TierPrice
   * Reliant on some synchronous calls to service (for statuses)
   */
  subscribeUserToTier: SubscribeUserToTierResult
  /**
   * Subscribes a user to the cheapest default tier based on their current open accounts
   * @deprecated Will be removed soon in-favor-of the more generic Mutation.subscribeUserToTier.
   */
  subscribeUserToTierByOpenAccounts: TierSubscription
  /**
   * Subscribes a user to the cheapest default tier available with provided productKey
   * @deprecated Will be removed soon in-favor-of the more generic Mutation.subscribeUserToTier.
   */
  subscribeUserToTierByProductKey: TierSubscription
  /** Mark an open billing vendor invoice as successful */
  succeedVendorInvoice: Maybe<SucceedVendorInvoiceResult>
  /**
   * Suppresses money manager rebalances until a specified future date. This prevents automatic rebalancing of investments
   * for the given user until the specified date. The date must be in the future.
   */
  suppressMoneyManagerRebalances: SuppressMoneyManagerRebalancesResult
  /** @deprecated Use Mutation.suspendUserDeposits or Mutation.unsuspendUserDeposits instead */
  suspendDeposits: Maybe<Scalars['Void']>
  /** Suspend user deposits */
  suspendUserDeposits: Scalars['Void']
  /** @implicit(userId: String!) */
  syncBankFeeTransactions: SyncBankFeeTransactionsResult
  /** Syncs a user's current primary funding source to vendor */
  syncFundingSourceToVendor: Maybe<SyncFundingSourceToVendorResult>
  /**
   * Syncs the user's subscription to the vendor: creates a new subscription when the user has
   * none or an expired one, or changes the existing live subscription to match the subscription record.
   * Only applies when the user is vendor-integrated; otherwise returns skipped.
   */
  syncSubscriptionToVendor: Maybe<SyncSubscriptionToVendorResult>
  /** Returns the tax withholding amounts for state and federal */
  taxWithholdingAmounts: Maybe<TaxWithholdingAmounts>
  /** Unauthenticated mutation for creating a presigned post for direct to s3 file upload */
  unauthenticatedCreateUploadUrl: CreateUploadUrlResult
  /** Unauthenticated mutation for saving upload url after direct s3 upload and create upload record */
  unauthenticatedSaveUploadUrl: UnauthenticatedSaveUploadUrlResult
  /** @implicit(userId: ID!) */
  unblockDevice: UnblockDeviceResult
  /** Unlink account and all attached subaccounts */
  unlinkLinkedAccount: Maybe<LinkedAccount>
  unlockBankCard: Maybe<UnlockBankCardPayload>
  /** Removes content with given ID from helpful section and returns ID and helpful flag or error if it does not exist */
  unmarkLearnContentAsHelpful: UnmarkLearnContentAsHelpfulResult
  /** Unsubscribes a user to from their current tier */
  unsubscribeUserFromTier: UnsubscribeUserFromTierResult
  /** Unsuspend user deposits */
  unsuspendUserDeposits: Scalars['Void']
  /** Updates Account Portfolio */
  updateAccountPortfolio: UpdateAccountPortfolioResponse
  /** Update a single address for a user */
  updateAddress: Maybe<Address>
  /** Updates source attribution data for a user */
  updateAttribution: UpdateAttributionResult
  /** @implicit(userId: ID!) */
  updateAuthPhoneNumber: UpdateAuthPhoneNumberResult
  updateBankAccountGoal: UpdateBankAccountGoalResult
  updateBankCardPin: Maybe<UpdateBankCardPinPayload>
  /** Update a beneficiary's basic info */
  updateBeneficiaryInfo: UpdateBeneficiaryInfoResult
  /** @implicit(userId: String!) */
  updateBenefitStatus: UpdateBenefitStatusResponse
  updateContactInfo: Maybe<User>
  /** @implicit(userId: ID!) */
  updateCredentials: UpdateCredentialsResult
  /** Update a single address for a customer */
  updateCustomerAddress: Maybe<UpdateCustomerAddressResult>
  /** @implicit(userId: ID!) */
  updateCustomerMoneyRules: Maybe<MoneyRulesUpdateCustomerMoneyRulesResult>
  /** @implicit(userId: ID!) */
  updateDesignatedBeneficiary: UpdateDesignatedBeneficiaryResult
  /** @implicit(userId: ID!) */
  updateDesignation: UpdateDesignationResult
  /** Updates elapsed time, the time the user spent in the quiz. */
  updateElapsedTimeForLearnQuiz: UpdateElapsedTimeForLearnQuizResult
  updateEmployment: Maybe<User>
  updateInvestorQuestions: Maybe<User>
  updateLadderQuote: Maybe<LadderResponse>
  /** Updates progress for related content and returns id and progress for that content or error if related content does not exist */
  updateLearnContentProgress: UpdateLearnProgressResult
  /** Updates a plaid account with a new link session id. To be used after re-authenticating a linked account */
  updateLinkedAccount: Maybe<LinkedAccount>
  /** Update money manager allocations */
  updateMoneyManagerAllocations: UpdateMoneyManagerAllocationsResult
  /** Sets a money manager automation target. */
  updateMoneyManagerAutomationTarget: UpdateMoneyManagerAutomationTargetResult
  /** Update the money manager settings for a customer */
  updateMoneyManagerSettings: UpdateMoneyManagerSettingsResult
  /**
   * Update the money rules source settings for a customer
   * @deprecated Use updateMoneyManagerSettings instead
   */
  updateMoneyRulesSourceSettings: Maybe<UpdateMoneyRulesSourceSettingsResult>
  /** @implicit(userId: String!) */
  updateNegotiationStatus: BenefitsMessage
  updateNotification: Maybe<Scalars['Void']>
  /** Returns the user profile with the updated optedOutOfTargeting field */
  updateOptOutOfTargeting: Maybe<Profile>
  /** Updates user profile information */
  updatePersonalInfo: Maybe<User>
  /** Update the securities and target allocation percentages of the portfolio */
  updatePortfolioSecurities: UpdatePortfolioSecuritiesResult
  /** Update a single profile for a user */
  updateProfile: Maybe<Profile>
  /** Update the JSON configuration file associated with promoted brands */
  updatePromotedCampaigns: Maybe<UpdatePromotedCampaignsResult>
  /**
   * Update the recurring investment settings for the specified InvestmentAccount
   * (defaults to the authenticated User's Core InvestmentAccount if not specified).
   */
  updateRecurringInvestment: RecurringInvestmentPayload
  /** Updates a registration record */
  updateRegistration: Result
  /** Update a single Round Up Account for a given ID */
  updateRoundUpAccount: Maybe<RoundUpAccount>
  /** Update a certificate or card signature for a user */
  updateSignature: Maybe<Signature>
  /** Update a user's suitability */
  updateSuitability: Maybe<Suitability_UpdateSuitabilityResult>
  /** Updates a tax refund event */
  updateTaxRefund: UpdateTaxRefundPayload
  /** Update the authenticated recipient's tip profile display name or investing story */
  updateTipProfile: UpdateTipProfileResult
  /** Mutation to update user profile and automation target. */
  updateUserProfileAndAutomationTarget: UpdateUserProfileAndAutomationTargetResult
  /**
   * Update the user switch state in the Direct Deposit Database using the
   * switchState Enum. This switch state provides us insight into the status of a
   * user in the PDF DD flow.
   */
  updateUserSwitchState: UpdateUserSwitchState
  /**
   * Updates the nameOnAccount field of the user's billing info in the vendor system.
   * Useful for correcting names that fell back to the default placeholder.
   */
  updateVendorBillingInfoName: Maybe<SyncFundingSourceToVendorResult>
  /** Updates the next billing date (trial end date) for a user's vendor subscription */
  updateVendorSubscriptionBillingDate: Maybe<UpdateVendorSubscriptionBillingDateResult>
  /** @implicit(userId: ID!) */
  updateVerificationProfile: UpdateVerificationProfileResult
  /** Upgrade to JWT authentication */
  upgradeAuthentication: UpgradeAuthenticationResult
  uploadAudienceList: Scalars['String']
  uploadCheck: Maybe<UploadCheckPayload>
  uploadDocuments: Array<FileOrException>
  uploadUnsolicitedDocuments: Array<FileOrException>
  /** Creates or updates Hedwig runtime configuration for a message trackingId, which for Braze-sourced messages is the Braze campaign ID. */
  upsertMessageConfig: MessageConfig
  /** Creates or updates Hedwig runtime configuration for multiple message trackingIds in one call. Inputs are applied in order; if any input is invalid, earlier inputs in the same call are already saved and are not rolled back. */
  upsertMessageConfigs: Array<MessageConfig>
  /** Create or update a User Match Record */
  upsertUserMatch: UpsertUserMatchResult
  /** Request an MFA token for the provided credentials. */
  validateCredentials: ValidateCredentialsResult
  /** Validate a user suspended upload token */
  validateUserSuspendedUploadToken: ValidateUserSuspendedUploadTokenResult
  vendAuthSession: VendAuthSessionResult
  verifyDevice: VerifyDeviceResult
  /** @implicit(userId: ID!) */
  verifyIdentityByDocuments: VerifyIdentityByDocumentsResult
  /** Verify and create a later account */
  verifyLaterAccountOrError: LaterAccountInfoOrError
  /** @implicit(userId: ID!) */
  verifyPasswords: VerifyPasswordsResult
  /** Verify a user's manually linked funding source with RDVs */
  verifyRdvs: VerifyRdvsResult
}

/** Root mutation type */
export type MutationAcceptDocumentArgs = {
  input: AcceptDocumentInput
}

/** Root mutation type */
export type MutationActivateAcornsCredentialsArgs = {
  email: Scalars['EmailAddress']
  sendEmail?: InputMaybe<Scalars['Boolean']>
}

/** Root mutation type */
export type MutationActivateBankCardArgs = {
  input: ActivateBankCardInput
}

/** Root mutation type */
export type MutationAddCohortEligibilityArgs = {
  input: AddCohortEligibilityInput
}

/** Root mutation type */
export type MutationAddFavoritePartnerOffersArgs = {
  input: FavoritePartnerOfferInput
}

/** Root mutation type */
export type MutationAddSearchTermToLearnSearchHistoryArgs = {
  input: AddSearchTermToLearnSearchHistoryInput
}

/** Root mutation type */
export type MutationAddSecurityToPortfolioArgs = {
  input: AddSecurityToPortfolioInput
}

/** Root mutation type */
export type MutationAddSelfDirectedPortfolioArgs = {
  input: AddSelfDirectedPortfolioInput
}

/** Root mutation type */
export type MutationAddTrustedContactArgs = {
  input: TrustedContactInput
}

/** Root mutation type */
export type MutationAgreeToAcceptanceDocumentArgs = {
  id: Scalars['ID']
}

/** Root mutation type */
export type MutationAnswerChallengeArgs = {
  input: ChallengeAnswerInput
}

/** Root mutation type */
export type MutationAnswerLearnQuizQuestionArgs = {
  input: AnswerLearnQuizQuestionInput
}

/** Root mutation type */
export type MutationApplyPromotionArgs = {
  input: ApplyPromotionInput
}

/** Root mutation type */
export type MutationApplyPromotionalWaiverArgs = {
  input: ApplyPromotionalWaiverInput
}

/** Root mutation type */
export type MutationApplyProvisionalWaiverArgs = {
  waiverPeriodEndDate: Scalars['String']
  waiverReason: Scalars['String']
}

/** Root mutation type */
export type MutationApplyWaiverCouponArgs = {
  couponId?: InputMaybe<Scalars['String']>
  waiverInput: ApplyWaiverCouponInput
}

/** Root mutation type */
export type MutationAskFinancialAdvisorQuestionArgs = {
  question: Scalars['String']
  sessionId: Scalars['String']
}

/** Root mutation type */
export type MutationAssignLinkedSubaccountArgs = {
  input: AssignLinkedSubaccountInput
  linkedSubaccountId: Scalars['ID']
}

/** Root mutation type */
export type MutationAttachChatTranscriptArgs = {
  input: AttachChatTranscriptInput
}

/** Root mutation type */
export type MutationAuthenticateArgs = {
  alternateAuthenticatorId?: InputMaybe<Scalars['ID']>
  challengeAnswerInput?: InputMaybe<ChallengeAnswerInput>
  input: AuthenticateInput
}

/** Root mutation type */
export type MutationAuthenticateForFeeNegotiationArgs = {
  input: AuthenticateForFeeNegotiationInput
}

/** Root mutation type */
export type MutationAuthenticateForFeeNegotiationChallengeArgs = {
  input: AuthenticateForFeeNegotiationChallengeInput
}

/** Root mutation type */
export type MutationAuthenticateForFeeNegotiationChallengeMethodArgs = {
  input: AuthenticateForFeeNegotiationChallengeMethodInput
}

/** Root mutation type */
export type MutationBatchAddTierSubscriptionsArgs = {
  input: BatchAddTierSubscriptionsInput
}

/** Root mutation type */
export type MutationBlockDeviceArgs = {
  input: BlockDeviceInput
}

/** Root mutation type */
export type MutationCancelCheckPaymentArgs = {
  id: Scalars['ID']
}

/** Root mutation type */
export type MutationCancelIntentArgs = {
  nonce: Scalars['UUID']
}

/** Root mutation type */
export type MutationCancelInvestmentArgs = {
  input: CancelInvestmentInput
}

/** Root mutation type */
export type MutationCancelInvestmentAccountClosureRequestArgs = {
  input: CancelInvestmentAccountClosureRequestInput
}

/** Root mutation type */
export type MutationCancelMoneyAssignmentArgs = {
  input: CancelMoneyAssignmentInput
}

/** Root mutation type */
export type MutationCancelRecurringTransferArgs = {
  id: Scalars['ID']
}

/** Root mutation type */
export type MutationCancelTransferArgs = {
  accountId: Scalars['ID']
  id: Scalars['ID']
}

/** Root mutation type */
export type MutationChangeOutsideContributionAmountArgs = {
  input: ChangeOutsideContributionAmountInput
}

/** Root mutation type */
export type MutationChangePasswordArgs = {
  newPassword: Scalars['String']
  oldPassword: Scalars['String']
  securityAnswer?: InputMaybe<SecurityAnswer>
}

/** Root mutation type */
export type MutationChangePasswordV2Args = {
  input: ChangePasswordInput
}

/** Root mutation type */
export type MutationCloseBankAccountArgs = {
  input: CloseBankAccountInput
}

/** Root mutation type */
export type MutationCloseInvestmentAccountArgs = {
  input: CloseInvestmentAccountInput
}

/** Root mutation type */
export type MutationCompleteCheckDepositArgs = {
  input: CompleteCheckDepositInput
}

/** Root mutation type */
export type MutationConfigureSplitDepositDirectDepositIntentSettingArgs = {
  input: ConfigureSplitDepositDirectDepositIntentSettingInput
}

/** Root mutation type */
export type MutationConfigureSplitDepositDirectDepositSettingArgs = {
  input: ConfigureSplitDepositDirectDepositSettingInput
}

/** Root mutation type */
export type MutationConnectAchAccountArgs = {
  input: ConnectAchAccountInput
}

/** Root mutation type */
export type MutationConnectLadderCustomerArgs = {
  quoteId: Scalars['ID']
}

/** Root mutation type */
export type MutationConsumeUserTokenArgs = {
  userTokenId: Scalars['ID']
}

/** Root mutation type */
export type MutationCreateAuthProfileArgs = {
  input?: InputMaybe<CreateAuthProfileInput>
}

/** Root mutation type */
export type MutationCreateAuthenticatedSupportTicketArgs = {
  input: CreateSupportTicketInput
}

/** Root mutation type */
export type MutationCreateBankAccountArgs = {
  input: CreateBankAccountInput
}

/** Root mutation type */
export type MutationCreateBeneficiaryArgs = {
  input: BeneficiaryInput
}

/** Root mutation type */
export type MutationCreateDesignatedBeneficiaryArgs = {
  input: CreateDesignatedBeneficiaryInput
}

/** Root mutation type */
export type MutationCreateDesignationArgs = {
  input: CreateDesignationInput
}

/** Root mutation type */
export type MutationCreateDirectDepositLinkInfoArgs = {
  input: CreateDirectDepositLinkInfoInput
}

/** Root mutation type */
export type MutationCreateDocumentUploadArgs = {
  input: CreateDocumentUploadInput
}

/** Root mutation type */
export type MutationCreateIraWithProfileArgs = {
  iraType?: InputMaybe<InvestmentAccountTypes>
  profileAttributes: Array<InputMaybe<ProfileAttribute>>
}

/** Root mutation type */
export type MutationCreateImplicitTokenForUserArgs = {
  input: CreateImplicitTokenForUserInput
}

/** Root mutation type */
export type MutationCreateIntentArgs = {
  input: CreateIntentInput
}

/** Root mutation type */
export type MutationCreateInvestingStrategyRecommendationArgs = {
  input: CreateInvestingStrategyRecommendationInput
}

/** Root mutation type */
export type MutationCreateInvestmentAccountArgs = {
  iraType?: InputMaybe<InvestmentAccountTypes>
  portfolioId?: InputMaybe<Scalars['String']>
}

/** Root mutation type */
export type MutationCreateJobAlertArgs = {
  alertCriteria: JobAlertCriteriaInput
}

/** Root mutation type */
export type MutationCreateLadderQuoteArgs = {
  address: Scalars['String']
  age: Scalars['Int']
  city: Scalars['String']
  email: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  phone: Scalars['String']
  state: StateCode
  zip: Scalars['String']
}

/** Root mutation type */
export type MutationCreateLaterContributionArgs = {
  accountId: Scalars['ID']
  amount: Scalars['Float']
  year?: InputMaybe<Scalars['Int']>
}

/** Root mutation type */
export type MutationCreateOfferArgs = {
  input: CreateOfferInput
}

/** Root mutation type */
export type MutationCreateOutsideContributionArgs = {
  input: CreateOutsideContributionInput
}

/** Root mutation type */
export type MutationCreateOutsideContributionCheckoutCartArgs = {
  input: CreateOutsideContributionCheckoutCartInput
}

/** Root mutation type */
export type MutationCreatePlaidLinkedAccountArgs = {
  input: CreatePlaidLinkedAccountInput
  publicToken: Scalars['String']
}

/** Root mutation type */
export type MutationCreateProspectUserArgs = {
  input: CreateProspectUserInput
}

/** Root mutation type */
export type MutationCreateRefundArgs = {
  invoiceId: Scalars['ID']
}

/** Root mutation type */
export type MutationCreateSavingsAccountArgs = {
  input: CreateSavingsAccountInput
}

/** Root mutation type */
export type MutationCreateSubscriptionMigrationArgs = {
  input: CreateSubscriptionMigrationInput
}

/** Root mutation type */
export type MutationCreateSupportTicketOrExceptionArgs = {
  input: CreateSupportTicketInput
}

/** Root mutation type */
export type MutationCreateUploadUrlArgs = {
  input: CreateUploadUrlInput
}

/** Root mutation type */
export type MutationCreateUserArgs = {
  input: CreateUserInput
}

/** Root mutation type */
export type MutationCreateUserProfileArgs = {
  input: CreateUserProfileInput
}

/** Root mutation type */
export type MutationCreateVendorInvoiceArgs = {
  input: CreateVendorInvoiceInput
}

/** Root mutation type */
export type MutationCreateVendorLineItemArgs = {
  input: CreateVendorLineItemInput
}

/** Root mutation type */
export type MutationDeactivateAccountArgs = {
  accountId: Scalars['ID']
}

/** Root mutation type */
export type MutationDeactivateBeneficiaryArgs = {
  id: Scalars['ID']
}

/** Root mutation type */
export type MutationDeactivateTierSubscriptionArgs = {
  input: DeactivateTierSubscriptionInput
}

/** Root mutation type */
export type MutationDeleteChatSessionArgs = {
  sessionId: Scalars['ID']
}

/** Root mutation type */
export type MutationDeleteTrustedContactArgs = {
  id: Scalars['ID']
}

/** Root mutation type */
export type MutationDeleteWaiverCouponArgs = {
  waiverInput: DeleteWaiverCouponInput
}

/** Root mutation type */
export type MutationDeregisterAuthenticatorArgs = {
  input: DeregisterAuthenticatorInput
}

/** Root mutation type */
export type MutationDismissMessageArgs = {
  input: DismissMessageInput
}

/** Root mutation type */
export type MutationDismissMessagesArgs = {
  input: DismissMessagesInput
}

/** Root mutation type */
export type MutationEditTrustedContactArgs = {
  id: Scalars['ID']
  input: TrustedContactInput
}

/** Root mutation type */
export type MutationEnableQuarterlyRecapsArgs = {
  input: EnableQuarterlyRecapsInput
}

/** Root mutation type */
export type MutationEndChatSessionArgs = {
  sessionId: Scalars['ID']
}

/** Root mutation type */
export type MutationEnrollInStreaksArgs = {
  input: EnrollInStreaksInput
}

/** Root mutation type */
export type MutationExchangeAcornsEarlyTokenArgs = {
  token: Scalars['String']
}

/** Root mutation type */
export type MutationExecuteMoneyManagerRebalancesArgs = {
  input: ExecuteMoneyManagerRebalancesInput
}

/** Root mutation type */
export type MutationExpirePromotionalWaiverArgs = {
  input: ExpirePromotionalWaiverInput
}

/** Root mutation type */
export type MutationFailVendorInvoiceArgs = {
  invoiceId: Scalars['ID']
}

/** Root mutation type */
export type MutationFeedEventArgs = {
  feedEvent: ActionFeedEvent
}

/** Root mutation type */
export type MutationGenerateDocumentUploadSessionArgs = {
  input: GenerateDocumentUploadSessionInput
}

/** Root mutation type */
export type MutationGenerateLayerLinkSessionArgs = {
  input: GenerateLayerLinkSessionInput
}

/** Root mutation type */
export type MutationGenerateLinkSessionArgs = {
  input: GenerateLinkSessionInput
  userId?: InputMaybe<Scalars['ID']>
}

/** Root mutation type */
export type MutationHideMessageArgs = {
  input: HideMessageInput
}

/** Root mutation type */
export type MutationHideMessageByExternalIdArgs = {
  input: HideMessageByExternalIdInput
}

/** Root mutation type */
export type MutationInitiateBankAccountCreationArgs = {
  input: InitiateBankAccountInput
}

/** Root mutation type */
export type MutationInitiateBankingKycArgs = {
  input: InitiateBankingKycInput
}

/** Root mutation type */
export type MutationInitiateChallengeArgs = {
  input: InitiateChallengeInput
}

/** Root mutation type */
export type MutationInitiateEmailChallengeArgs = {
  input: InitiateEmailChallengeInput
}

/** Root mutation type */
export type MutationInitiateLaterProgramAccountContributionArgs = {
  input: LaterProgramAccountContributionInput
}

/** Root mutation type */
export type MutationInitiateMoneyAssignmentArgs = {
  input: InitiateMoneyAssignmentInput
}

/** Root mutation type */
export type MutationInitiatePartnerDataShareArgs = {
  input: PartnerDataShareInput
}

/** Root mutation type */
export type MutationInitiateSmsChallengeArgs = {
  input: InitiateSmsChallengeInput
}

/** Root mutation type */
export type MutationInitiateTransferArgs = {
  input: InitiateTransferInput
}

/** Root mutation type */
export type MutationLaterCreateIndividualBeneficiaryArgs = {
  accountId: Scalars['ID']
  addressLine1?: InputMaybe<Scalars['String']>
  addressLine2?: InputMaybe<Scalars['String']>
  birthDate: Scalars['DateTime']
  city?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  firstName: Scalars['String']
  lastName: Scalars['String']
  percentageShare?: InputMaybe<Scalars['Float']>
  relationship?: InputMaybe<Scalars['String']>
  ssn?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  zip?: InputMaybe<Scalars['String']>
}

/** Root mutation type */
export type MutationLaterTotalLiquidationArgs = {
  input?: InputMaybe<LaterTotalLiquidationInput>
  investmentAccountId: Scalars['ID']
}

/** Root mutation type */
export type MutationLaterWithdrawalArgs = {
  amount: Scalars['Float']
  earlyDistributionTaxExceptionReason?: InputMaybe<Scalars['String']>
  federalTaxes: Scalars['Float']
  investmentAccountId: Scalars['ID']
  reason?: InputMaybe<LaterWithdrawalReason>
  stateTaxes: Scalars['Float']
  taxYear: Scalars['Int']
  withdrawalType?: InputMaybe<LaterWithdrawalType>
}

/** Root mutation type */
export type MutationLegacyUploadDocumentArgs = {
  input: LegacyUploadDocumentInput
}

/** Root mutation type */
export type MutationLinkAchAccountArgs = {
  account: Scalars['String']
  routing: Scalars['String']
}

/** Root mutation type */
export type MutationLinkManualFundingSourceArgs = {
  input: LinkManualFundingSourceInput
}

/** Root mutation type */
export type MutationLinkOidcCredentialsArgs = {
  input: LinkOidcCredentialsInput
}

/** Root mutation type */
export type MutationLockBankCardArgs = {
  input: LockBankCardInput
}

/** Root mutation type */
export type MutationLogoutDeviceArgs = {
  input: LogoutDeviceInput
}

/** Root mutation type */
export type MutationMakeInvestmentArgs = {
  input: MakeInvestmentInput
}

/** Root mutation type */
export type MutationMarkLearnContentAsHelpfulArgs = {
  input: MarkLearnContentAsHelpfulInput
}

/** Root mutation type */
export type MutationMarkLearnContentAsViewedArgs = {
  input: MarkLearnContentAsViewedInput
}

/** Root mutation type */
export type MutationModifyMoneyAssignmentArgs = {
  input: ModifyMoneyAssignmentInput
}

/** Root mutation type */
export type MutationOpenCoreInvestmentAccountArgs = {
  input: OpenCoreInvestmentAccountInput
}

/** Root mutation type */
export type MutationOpenEarlyAccountArgs = {
  input: OpenEarlyAccountInput
}

/** Root mutation type */
export type MutationOrderBankCardArgs = {
  input: OrderBankCardInput
}

/** Root mutation type */
export type MutationPerformBlueprintActionArgs = {
  action: Scalars['String']
  arguments: Scalars['JSON']
}

/** Root mutation type */
export type MutationPostBankFeeNegotiationArgs = {
  linkedAccountId: Scalars['String']
}

/** Root mutation type */
export type MutationPostUserReportedBankFeeRefundArgs = {
  submissionId: Scalars['String']
  totalRefunds: Scalars['Float']
}

/** Root mutation type */
export type MutationQueueUsersForVendorOnboardingArgs = {
  input: QueueUsersForVendorOnboardingInput
}

/** Root mutation type */
export type MutationRateChatMessageArgs = {
  feedbackInput?: InputMaybe<MessageFeedbackInput>
  messageId: Scalars['ID']
  rating?: InputMaybe<Scalars['Int']>
}

/** Root mutation type */
export type MutationRateFinancialAdvisorResponseArgs = {
  interactionId: Scalars['String']
  rating: Scalars['Int']
}

/** Root mutation type */
export type MutationReadMessageArgs = {
  input: ReadMessageInput
}

/** Root mutation type */
export type MutationRecordInvestmentAccountRecapViewArgs = {
  input: RecordInvestmentAccountRecapViewInput
}

/** Root mutation type */
export type MutationRecordStreakActivityArgs = {
  input: RecordStreakActivityInput
}

/** Root mutation type */
export type MutationRecordTaxRefundArgs = {
  input: RecordTaxRefundInput
}

/** Root mutation type */
export type MutationRecordTaxRefundInvestmentArgs = {
  input: RecordTaxRefundInvestmentInput
}

/** Root mutation type */
export type MutationRecordVendorExternalTransactionArgs = {
  input: RecordVendorExternalTransactionInput
  invoiceId: Scalars['ID']
}

/** Root mutation type */
export type MutationRedeemGiftcardArgs = {
  pin: Scalars['String']
}

/** Root mutation type */
export type MutationRefreshAuthTokenArgs = {
  input: RefreshAuthTokenInput
}

/** Root mutation type */
export type MutationRegenerateInvestmentAccountRecapPublicTokenArgs = {
  input: RegenerateInvestmentAccountRecapPublicTokenInput
}

/** Root mutation type */
export type MutationRegisterCredentialsArgs = {
  input: RegisterCredentialsInput
}

/** Root mutation type */
export type MutationRegisterDeviceTokenAndPushAuthenticatorArgs = {
  input: RegisterDeviceTokenAndPushAuthenticatorInput
}

/** Root mutation type */
export type MutationRegisterEmailAuthenticatorArgs = {
  challengeAnswerInput: ChallengeAnswerInput
  input: RegisterEmailAuthenticatorInput
}

/** Root mutation type */
export type MutationRegisterLayerLinkSessionArgs = {
  input: LayerLinkSessionInput
}

/** Root mutation type */
export type MutationRegisterLinkSessionArgs = {
  input: LinkSessionInput
}

/** Root mutation type */
export type MutationRegisterOidcCredentialsArgs = {
  input: RegisterOidcCredentialsInput
}

/** Root mutation type */
export type MutationRegisterPhoneAuthenticatorArgs = {
  challengeAnswerInput: ChallengeAnswerInput
  input: RegisterPhoneAuthenticatorInput
}

/** Root mutation type */
export type MutationRegisterProspectArgs = {
  input: RegisterProspectInput
}

/** Root mutation type */
export type MutationReinitiateChallengeArgs = {
  input: ReinitiateSmsChallengeInput
}

/** Root mutation type */
export type MutationReissueBankCardArgs = {
  input: ReissueBankCardInput
}

/** Root mutation type */
export type MutationRemoveCohortEligibilityArgs = {
  input: RemoveCohortEligibilityInput
}

/** Root mutation type */
export type MutationRemoveDesignationArgs = {
  designationId: Scalars['ID']
}

/** Root mutation type */
export type MutationRemoveFavoritePartnerOffersArgs = {
  input: FavoritePartnerOfferInput
}

/** Root mutation type */
export type MutationRemoveJobAlertArgs = {
  id: Scalars['String']
}

/** Root mutation type */
export type MutationRemoveSecurityFromPortfolioArgs = {
  input: RemoveSecurityFromPortfolioInput
}

/** Root mutation type */
export type MutationRemoveSelfDirectedPortfolioArgs = {
  input: RemoveSelfDirectedPortfolioInput
}

/** Root mutation type */
export type MutationReportBankCardLostStolenArgs = {
  input: ReportBankCardLostStolenInput
}

/** Root mutation type */
export type MutationRequestAccountClosureArgs = {
  input: RequestAccountClosureInput
}

/** Root mutation type */
export type MutationRequestContributionStickersArgs = {
  input: RequestContributionStickersInput
}

/** Root mutation type */
export type MutationRequestEarlyAccountClosureArgs = {
  input: RequestEarlyAccountClosureInput
}

/** Root mutation type */
export type MutationRequestInvestmentAccountReopenArgs = {
  input: RequestInvestmentAccountReopenInput
}

/** Root mutation type */
export type MutationRequestLayerSessionArgs = {
  input: RequestLayerSessionInput
}

/** Root mutation type */
export type MutationRequestMatchedAccountLoginSupportArgs = {
  input: RequestMatchedAccountLoginSupportInput
}

/** Root mutation type */
export type MutationRequestSubscriptionMigrationWaiverArgs = {
  input: RequestSubscriptionMigrationWaiverInput
}

/** Root mutation type */
export type MutationResendChatMessageArgs = {
  messageId: Scalars['ID']
  sessionId: Scalars['ID']
  supportedChatFeatures?: InputMaybe<Array<ChatFeatures>>
}

/** Root mutation type */
export type MutationResetPasswordArgs = {
  email: Scalars['String']
}

/** Root mutation type */
export type MutationResetPasswordByTokenArgs = {
  input: ResetPasswordByTokenInput
}

/** Root mutation type */
export type MutationResetPasswordWithTokenArgs = {
  input: ResetPasswordWithTokenInput
}

/** Root mutation type */
export type MutationResolveMatchedAccountArgs = {
  ssn: Scalars['String']
}

/** Root mutation type */
export type MutationRespondToLearnPollArgs = {
  input: RespondToLearnPollInput
}

/** Root mutation type */
export type MutationRevokePasswordResetTokenArgs = {
  input: RevokePasswordResetTokenInput
}

/** Root mutation type */
export type MutationRoundUpProfileArgs = {
  input: RoundUpProfileInput
}

/** Root mutation type */
export type MutationSaveTipProfileArgs = {
  input: SaveTipProfileInput
}

/** Root mutation type */
export type MutationSaveUploadUrlArgs = {
  input: SaveUploadUrlInput
}

/** Root mutation type */
export type MutationSaveUploadUrlsArgs = {
  input: SaveUploadUrlsInput
}

/** Root mutation type */
export type MutationScheduleRecurringTransferArgs = {
  input: ScheduleRecurringTransferInput
}

/** Root mutation type */
export type MutationSendBrazeEventArgs = {
  input: SendBrazeEventInput
}

/** Root mutation type */
export type MutationSendChatMessageArgs = {
  hidden?: InputMaybe<Scalars['Boolean']>
  message: Scalars['String']
  metadata?: InputMaybe<ChatMessageMetadataInput>
  sessionId: Scalars['ID']
  supportedChatFeatures?: InputMaybe<Array<ChatFeatures>>
}

/** Root mutation type */
export type MutationSendCheckPaymentArgs = {
  input: SendCheckPaymentInput
}

/** Root mutation type */
export type MutationSessionRefreshArgs = {
  longSession?: InputMaybe<Scalars['Boolean']>
  pin: Scalars['String']
}

/** Root mutation type */
export type MutationSetAuthenticationPinArgs = {
  input: SetAuthenticationPinInput
}

/** Root mutation type */
export type MutationSetBeneficiarySsnArgs = {
  id: Scalars['ID']
  ssn: Scalars['String']
}

/** Root mutation type */
export type MutationSetDefaultAuthenticatorArgs = {
  input: SetDefaultAuthenticatorInput
}

/** Root mutation type */
export type MutationSetFavoritePartnerOffersArgs = {
  input: FavoritePartnerOfferInput
}

/** Root mutation type */
export type MutationSetInvestmentAccountRecapPublicAccessArgs = {
  input: SetInvestmentAccountRecapPublicAccessInput
}

/** Root mutation type */
export type MutationSetLinkingErrorArgs = {
  linkedAccountId: Scalars['ID']
  linkingErrorCode: SetLinkingErrorInput
}

/** Root mutation type */
export type MutationSetManualRoundUpsArgs = {
  roundUpIds: Array<Scalars['ID']>
}

/** Root mutation type */
export type MutationSetNegotiationStatusArgs = {
  input: SetNegotiationStatusInput
}

/** Root mutation type */
export type MutationSetPortfolioArgs = {
  input: SetPortfolioInput
}

/** Root mutation type */
export type MutationSetPreferredWithdrawalAccountArgs = {
  input: SetPreferredWithdrawalAccountInput
}

/** Root mutation type */
export type MutationSetUserPartnerStatusArgs = {
  input: PartnerStatusInput
}

/** Root mutation type */
export type MutationSplitDepositArgs = {
  id: Scalars['ID']
}

/** Root mutation type */
export type MutationSplitDepositSettingsArgs = {
  employerHidden?: InputMaybe<Scalars['Boolean']>
  id: Scalars['ID']
}

/** Root mutation type */
export type MutationStartAcornsPdfSwitchArgs = {
  input: StartAcornsPdfSwitchInput
}

/** Root mutation type */
export type MutationStartChatSessionArgs = {
  applicationType?: ApplicationType
  metadata?: InputMaybe<ChatSessionMetadata>
  moneyMentorContext?: InputMaybe<MoneyMentorContext>
  originatingContext?: InputMaybe<ChatContext>
  supportedChatFeatures?: InputMaybe<Array<ChatFeatures>>
  type?: InputMaybe<SessionType>
}

/** Root mutation type */
export type MutationStartCheckDepositArgs = {
  input: StartCheckDepositInput
}

/** Root mutation type */
export type MutationStartExternalContributionArgs = {
  input: StartExternalContributionInput
}

/** Root mutation type */
export type MutationStartOnlineSwitchArgs = {
  input: StartOnlineSwitchInput
}

/** Root mutation type */
export type MutationStartSubmittableSwitchArgs = {
  input: StartSubmittableSwitchInput
}

/** Root mutation type */
export type MutationStopRecurringInvestmentArgs = {
  investmentAccountId?: InputMaybe<Scalars['String']>
}

/** Root mutation type */
export type MutationStubArgs = {
  id: Scalars['UUID']
}

/** Root mutation type */
export type MutationSubmitBankFeeNegotiationArgs = {
  input: SubmitBankFeeNegotiationInput
}

/** Root mutation type */
export type MutationSubmitMissingEarnRewardRequestArgs = {
  input: SubmitMissingEarnRewardRequestInput
}

/** Root mutation type */
export type MutationSubmitRdVsArgs = {
  deposits: Array<InputMaybe<Scalars['Float']>>
}

/** Root mutation type */
export type MutationSubmitSpendTransactionsDisputeArgs = {
  input: SubmitSpendTransactionsDisputeInput
}

/** Root mutation type */
export type MutationSubmitUserReportedBankFeeRefundArgs = {
  input: SubmitUserReportedBankFeeRefundInput
}

/** Root mutation type */
export type MutationSubscribeToTierArgs = {
  input: SubscribeToTierInput
}

/** Root mutation type */
export type MutationSubscribeUserToTierArgs = {
  input: SubscribeUserToTierInput
}

/** Root mutation type */
export type MutationSubscribeUserToTierByProductKeyArgs = {
  input?: InputMaybe<SubscribeUserToTierByProductKeyInput>
}

/** Root mutation type */
export type MutationSucceedVendorInvoiceArgs = {
  invoiceId: Scalars['ID']
}

/** Root mutation type */
export type MutationSuppressMoneyManagerRebalancesArgs = {
  input: SuppressMoneyManagerRebalancesInput
}

/** Root mutation type */
export type MutationSuspendDepositsArgs = {
  suspended: Scalars['Boolean']
}

/** Root mutation type */
export type MutationSyncBankFeeTransactionsArgs = {
  input: SyncBankFeeTransactionsInput
}

/** Root mutation type */
export type MutationSyncSubscriptionToVendorArgs = {
  billToday?: InputMaybe<Scalars['Boolean']>
}

/** Root mutation type */
export type MutationTaxWithholdingAmountsArgs = {
  investmentId: Scalars['ID']
  totalSharesAmount: CurrencyAmountInput
}

/** Root mutation type */
export type MutationUnauthenticatedCreateUploadUrlArgs = {
  input: UnauthenticatedCreateUploadUrlInput
}

/** Root mutation type */
export type MutationUnauthenticatedSaveUploadUrlArgs = {
  input: UnauthenticatedSaveUploadUrlInput
}

/** Root mutation type */
export type MutationUnblockDeviceArgs = {
  input: UnblockDeviceInput
}

/** Root mutation type */
export type MutationUnlinkLinkedAccountArgs = {
  linkedAccountId: Scalars['ID']
}

/** Root mutation type */
export type MutationUnmarkLearnContentAsHelpfulArgs = {
  input: UnmarkLearnContentAsHelpfulInput
}

/** Root mutation type */
export type MutationUnsubscribeUserFromTierArgs = {
  input?: InputMaybe<UnsubscribeUserFromTierInput>
}

/** Root mutation type */
export type MutationUpdateAccountPortfolioArgs = {
  input: UpdateAccountPortfolioInput
}

/** Root mutation type */
export type MutationUpdateAddressArgs = {
  addressType: AddressType
  input: AddressInput
  ownerId?: InputMaybe<Scalars['ID']>
}

/** Root mutation type */
export type MutationUpdateAttributionArgs = {
  input: UpdateAttributionInput
}

/** Root mutation type */
export type MutationUpdateAuthPhoneNumberArgs = {
  input: UpdateAuthPhoneNumberInput
}

/** Root mutation type */
export type MutationUpdateBankAccountGoalArgs = {
  input: UpdateBankAccountGoalInput
}

/** Root mutation type */
export type MutationUpdateBankCardPinArgs = {
  input: UpdateBankCardPinInput
}

/** Root mutation type */
export type MutationUpdateBeneficiaryInfoArgs = {
  id: Scalars['ID']
  input: BeneficiaryInfoInput
}

/** Root mutation type */
export type MutationUpdateBenefitStatusArgs = {
  input: UpdateBenefitStatusInput
}

/** Root mutation type */
export type MutationUpdateContactInfoArgs = {
  input: ContactInfoInput
}

/** Root mutation type */
export type MutationUpdateCredentialsArgs = {
  input: UserCredentialsInput
}

/** Root mutation type */
export type MutationUpdateCustomerAddressArgs = {
  addressType: AddressType
  input: AddressInput
}

/** Root mutation type */
export type MutationUpdateCustomerMoneyRulesArgs = {
  input: MoneyRulesRulesetInput
}

/** Root mutation type */
export type MutationUpdateDesignatedBeneficiaryArgs = {
  beneficiaryId: Scalars['ID']
  input: UpdateDesignatedBeneficiaryInput
}

/** Root mutation type */
export type MutationUpdateDesignationArgs = {
  input: UpdateDesignationInput
}

/** Root mutation type */
export type MutationUpdateElapsedTimeForLearnQuizArgs = {
  input: UpdateElapsedTimeForLearnQuizInput
}

/** Root mutation type */
export type MutationUpdateEmploymentArgs = {
  input: EmploymentInput
}

/** Root mutation type */
export type MutationUpdateInvestorQuestionsArgs = {
  input: InvestorQuestionsInput
}

/** Root mutation type */
export type MutationUpdateLadderQuoteArgs = {
  coverage: Scalars['Int']
  quoteId: Scalars['ID']
}

/** Root mutation type */
export type MutationUpdateLearnContentProgressArgs = {
  input: UpdateLearnProgressInput
}

/** Root mutation type */
export type MutationUpdateLinkedAccountArgs = {
  input: UpdateLinkedAccountInput
  linkedAccountId: Scalars['ID']
}

/** Root mutation type */
export type MutationUpdateMoneyManagerAllocationsArgs = {
  input: UpdateMoneyManagerAllocationsInput
}

/** Root mutation type */
export type MutationUpdateMoneyManagerAutomationTargetArgs = {
  input: UpdateMoneyManagerAutomationTargetInput
}

/** Root mutation type */
export type MutationUpdateMoneyManagerSettingsArgs = {
  input: UpdateMoneyManagerSettingsInput
}

/** Root mutation type */
export type MutationUpdateMoneyRulesSourceSettingsArgs = {
  input: UpdateMoneyRulesSourceSettingsInput
}

/** Root mutation type */
export type MutationUpdateNegotiationStatusArgs = {
  negotiationStatusInput: NegotiationStatus
}

/** Root mutation type */
export type MutationUpdateNotificationArgs = {
  active: Scalars['Boolean']
  category?: InputMaybe<Scalars['String']>
  channel: Scalars['String']
  subcategory?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
  uuid?: InputMaybe<Scalars['ID']>
}

/** Root mutation type */
export type MutationUpdateOptOutOfTargetingArgs = {
  input: UpdateOptOutOfTargetingInput
}

/** Root mutation type */
export type MutationUpdatePersonalInfoArgs = {
  input: PersonalInfoInput
}

/** Root mutation type */
export type MutationUpdatePortfolioSecuritiesArgs = {
  input: UpdatePortfolioSecuritiesInput
}

/** Root mutation type */
export type MutationUpdateProfileArgs = {
  input: ProfileInput
}

/** Root mutation type */
export type MutationUpdatePromotedCampaignsArgs = {
  input?: InputMaybe<UpdatePromotedCampaignsInput>
}

/** Root mutation type */
export type MutationUpdateRecurringInvestmentArgs = {
  input: RecurringInvestmentInput
}

/** Root mutation type */
export type MutationUpdateRegistrationArgs = {
  input: RegistrationInput
}

/** Root mutation type */
export type MutationUpdateRoundUpAccountArgs = {
  enabled: Scalars['Boolean']
  linkedSubaccountId: Scalars['ID']
}

/** Root mutation type */
export type MutationUpdateSignatureArgs = {
  signatureType: SignatureType
  svgFile: Scalars['String']
}

/** Root mutation type */
export type MutationUpdateSuitabilityArgs = {
  suitabilityInput: Array<Suitability_SuitabilityInput>
}

/** Root mutation type */
export type MutationUpdateTaxRefundArgs = {
  input: UpdateTaxRefundInput
}

/** Root mutation type */
export type MutationUpdateTipProfileArgs = {
  input: UpdateTipProfileInput
}

/** Root mutation type */
export type MutationUpdateUserProfileAndAutomationTargetArgs = {
  input: UpdateUserProfileAndAutomationTargetInput
}

/** Root mutation type */
export type MutationUpdateUserSwitchStateArgs = {
  input: UpdateUserSwitchStateInput
}

/** Root mutation type */
export type MutationUpdateVendorBillingInfoNameArgs = {
  nameOnAccount: Scalars['String']
}

/** Root mutation type */
export type MutationUpdateVendorSubscriptionBillingDateArgs = {
  nextBillDate: Scalars['DateTime']
}

/** Root mutation type */
export type MutationUpdateVerificationProfileArgs = {
  input: VerificationProfileInput
}

/** Root mutation type */
export type MutationUploadAudienceListArgs = {
  input: UploadAudienceListInput
}

/** Root mutation type */
export type MutationUploadCheckArgs = {
  input: UploadCheckInput
}

/** Root mutation type */
export type MutationUploadDocumentsArgs = {
  input: UploadDocumentsInput
}

/** Root mutation type */
export type MutationUploadUnsolicitedDocumentsArgs = {
  input: UploadUnsolicitedDocumentsInput
}

/** Root mutation type */
export type MutationUpsertMessageConfigArgs = {
  input: UpsertMessageConfigInput
}

/** Root mutation type */
export type MutationUpsertMessageConfigsArgs = {
  inputs: Array<UpsertMessageConfigInput>
}

/** Root mutation type */
export type MutationUpsertUserMatchArgs = {
  input: UpsertUserMatchInput
}

/** Root mutation type */
export type MutationValidateCredentialsArgs = {
  input: ValidateCredentialsInput
}

/** Root mutation type */
export type MutationValidateUserSuspendedUploadTokenArgs = {
  input: ValidateUserSuspendedUploadTokenInput
}

/** Root mutation type */
export type MutationVendAuthSessionArgs = {
  input: VendAuthSessionInput
}

/** Root mutation type */
export type MutationVerifyDeviceArgs = {
  challengeAnswerInput?: InputMaybe<ChallengeAnswerInput>
  input: VerifyDeviceInput
}

/** Root mutation type */
export type MutationVerifyIdentityByDocumentsArgs = {
  input: ValidateDocumentsInput
}

/** Root mutation type */
export type MutationVerifyLaterAccountOrErrorArgs = {
  investmentAccountId: Scalars['ID']
}

/** Root mutation type */
export type MutationVerifyPasswordsArgs = {
  input: VerifyPasswordsInput
}

/** Root mutation type */
export type MutationVerifyRdvsArgs = {
  input: VerifyRdvsInput
}

export type NativeLoginInput = {
  email: Scalars['EmailAddress']
  password: Scalars['String']
}

/** The provided security percent is negative */
export type NegativeSecurityPercentError = {
  __typename?: 'NegativeSecurityPercentError'
  /** The security in question */
  securityId: Scalars['ID']
}

export enum NegotiationMethod {
  Automatic = 'AUTOMATIC',
  Letter = 'LETTER',
}

export type NegotiationServiceConnectionFailure = {
  __typename?: 'NegotiationServiceConnectionFailure'
  message: Scalars['String']
}

export type NegotiationStatus = {
  negotiationMethod: NegotiationType
  operator: Scalars['String']
  refundAmount?: InputMaybe<Scalars['Float']>
  status: BankFeeNegotiationInternalStatus
  submissionId: Scalars['ID']
}

export enum NegotiationType {
  AutomatedNegotiation = 'AUTOMATED_NEGOTIATION',
  MailInNegotiation = 'MAIL_IN_NEGOTIATION',
}

export enum NetTermsType {
  Eom = 'eom',
  Net = 'net',
}

export type NextAction = {
  __typename?: 'NextAction'
  payload: Maybe<Scalars['JSON']>
  type: NextActionType
}

export enum NextActionType {
  /** Render inline payment form (e.g. Stripe Elements) */
  CollectPaymentDetails = 'COLLECT_PAYMENT_DETAILS',
  /** No payer action needed */
  None = 'NONE',
  /** Redirect to external provider page or app */
  Redirect = 'REDIRECT',
}

/** The next billing date for a user */
export type NextBillingDate = {
  __typename?: 'NextBillingDate'
  next_billing_date: Maybe<Scalars['String']>
}

export type NextTransferDateResult =
  | MalformedRecurringTransferException
  | RecurringTransferDate

/** Cannot open early account because the beneficiary id is invalid */
export type NoBeneficiaryFoundException = {
  __typename?: 'NoBeneficiaryFoundException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** No Funding Source Alert. */
export type NoFundingSourceUserAlert = UserAlertsItem & {
  __typename?: 'NoFundingSourceUserAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type NoProspectRecord = {
  __typename?: 'NoProspectRecord'
  message: Scalars['String']
}

export type NoRegisteredPushAuthenticatorsException = {
  __typename?: 'NoRegisteredPushAuthenticatorsException'
  userId: Scalars['ID']
}

/** Base interface for entities with unique identifiers */
export type Node = {
  /** Unique identifier for the entity */
  id: Scalars['ID']
}

/** The user needs to close all other investment accounts before closing this account */
export type NonBasicAccountOpenException = {
  __typename?: 'NonBasicAccountOpenException'
  /** message */
  errorMessage: Maybe<Scalars['String']>
}

/** Returned when one or more singleRuleId's are not unique */
export type NonUniqueSingleRuleIdsError = {
  __typename?: 'NonUniqueSingleRuleIdsError'
  message: Scalars['String']
}

export type Notification = {
  __typename?: 'Notification'
  active: Scalars['Boolean']
  category: Maybe<Scalars['String']>
  subcategory: Maybe<Scalars['String']>
  type: Maybe<Scalars['String']>
}

export type NotificationMessage = Message & {
  __typename?: 'NotificationMessage'
  body: MessageTextAsset
  cardSubCategory: Maybe<CardSubCategory>
  createdAt: Scalars['DateTime']
  deepLink: Maybe<Scalars['URL']>
  delay: Maybe<Scalars['Int']>
  externalId: Scalars['ID']
  icon: Maybe<MessageVisualAsset>
  iconEnum: Maybe<IconType>
  iconURL: Maybe<Scalars['URL']>
  id: Scalars['ID']
  isDismissed: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isRead: Scalars['Boolean']
  lifetimeCap: Maybe<Scalars['Int']>
  messageCategory: MessageCategory
  messageType: MessageType
  platforms: Array<Platform>
  priority: Maybe<Scalars['Int']>
  readAt: Maybe<Scalars['DateTime']>
  title: MessageTextAsset
  trackingId: Maybe<Scalars['ID']>
  updatedAt: Scalars['DateTime']
}

export type Notifications = {
  __typename?: 'Notifications'
  emails: Maybe<Array<Maybe<Notification>>>
  pushes: Maybe<Array<Maybe<Notification>>>
}

export type OidcOnlyCredentials = {
  __typename?: 'OIDCOnlyCredentials'
  /** OIDC providers associated with this email (excludes Acorns Early OIDC) */
  oidcProviders: Array<OidcProvider>
}

export type OauthApp = {
  __typename?: 'OauthApp'
  accessTokenAudience: Array<Maybe<Scalars['String']>>
  accessTokenExpiry: Maybe<Scalars['Int']>
  active: Scalars['Boolean']
  contactEmail: Maybe<Scalars['String']>
  contactName: Maybe<Scalars['String']>
  contract: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  externalApp: Scalars['Boolean']
  imageUri: Scalars['String']
  name: Scalars['String']
  oauthAppId: Scalars['ID']
  pageType: Scalars['String']
  redirectUri: Maybe<Scalars['String']>
  refreshTokenExpiry: Maybe<Scalars['Int']>
  scopes: Array<OauthAppScope>
  secret: Maybe<Scalars['String']>
  type: OauthAppType
  updatedAt: Scalars['DateTime']
}

export type OauthAppClient = {
  __typename?: 'OauthAppClient'
  active: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  imageUri: Scalars['String']
  name: Scalars['String']
  oauthAppClientId: Scalars['ID']
  oauthAppId: Scalars['ID']
  updatedAt: Scalars['DateTime']
}

export type OauthAppClientNotFoundException = {
  __typename?: 'OauthAppClientNotFoundException'
  oauthAppClientId: Scalars['ID']
}

export type OauthAppImageUpload = {
  __typename?: 'OauthAppImageUpload'
  expiresAt: Scalars['DateTime']
  uploadUrl: Scalars['URL']
}

export type OauthAppNotFoundException = {
  __typename?: 'OauthAppNotFoundException'
  oauthAppId: Scalars['ID']
}

export type OauthAppScope = {
  __typename?: 'OauthAppScope'
  description: Maybe<Scalars['String']>
  identifier: Scalars['String']
  required: Scalars['Boolean']
  title: Scalars['String']
}

export enum OauthAppType {
  Aggregator = 'AGGREGATOR',
  Partner = 'PARTNER',
}

/** Occupation that a user can select */
export type Occupation = {
  __typename?: 'Occupation'
  id: Scalars['ID']
  name: Scalars['String']
}

export type Offer = {
  __typename?: 'Offer'
  /**
   * Meta field enabling clients to delegate to the backend
   * more logic determining when it is valid to present the Offer.
   *
   * Examples: "SUBSCRIPTION_CANCELLATION", "PASSIONS_PRODUCT_EXPLORATION"
   */
  availableIn: Maybe<Array<Scalars['String']>>
  /** The cohort of subscribers the Offer is available to (driven by the Offer type). */
  availableTo: OfferAvailability
  createdAt: Scalars['DateTime']
  /** Once subscribed to how long is the Offer valid for. */
  expiresAfter: Maybe<OfferExpiration>
  expiresAt: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  /** What the Offer entitles a subscriber access to. */
  offering: Offering
  /** Amount the subscriber agrees to pay for access to the Offer's offering. */
  price: OfferPrice
  /** URL to the terms and conditions of the Offer. */
  termsUrl: Scalars['URL']
  /** Indicates semantics of the Offer (generally whom it is available to and when). */
  type: OfferType
  updatedAt: Maybe<Scalars['DateTime']>
}

export enum OfferAvailability {
  All = 'ALL',
  Cancelled = 'CANCELLED',
  Existing = 'EXISTING',
  New = 'NEW',
  None = 'NONE',
}

export type OfferExpiration = {
  __typename?: 'OfferExpiration'
  period: OfferExpirationPeriod
  value: Scalars['Int']
}

export enum OfferExpirationPeriod {
  Month = 'MONTH',
}

export enum OfferGroupsType {
  Category = 'CATEGORY',
  Ranked = 'RANKED',
}

export type OfferLocation = {
  __typename?: 'OfferLocation'
  city: Maybe<Scalars['String']>
  state: Maybe<Scalars['String']>
}

export type OfferLocationInput = {
  city?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
}

export type OfferPrice = {
  __typename?: 'OfferPrice'
  amount: CurrencyAmount
  type: OfferPriceType
}

export type OfferPriceInput = {
  amount: CurrencyAmountInput
  type: OfferPriceType
}

export enum OfferPriceType {
  Free = 'FREE',
  Monthly = 'MONTHLY',
}

export enum OfferType {
  Promotional = 'PROMOTIONAL',
  Standard = 'STANDARD',
}

/** An Offering is something that a subscriber subscribes to access to. */
export type Offering = Product | Tier

export type OidcCredentialsAlreadyLinkedException = {
  __typename?: 'OidcCredentialsAlreadyLinkedException'
  subId: Maybe<Scalars['String']>
  userId: Scalars['ID']
}

export type OidcCredentialsNotFoundException = {
  __typename?: 'OidcCredentialsNotFoundException'
  oidcProvider: Maybe<OidcProvider>
  userId: Scalars['ID']
}

export type OidcCredentialsTakenException = {
  __typename?: 'OidcCredentialsTakenException'
  subId: Maybe<Scalars['String']>
  userId: Scalars['ID']
}

export type OidcLoginInput = {
  authorizationCode?: InputMaybe<Scalars['String']>
  idToken?: InputMaybe<Scalars['String']>
  nonce: Scalars['String']
}

export enum OidcProvider {
  AcornsEarly = 'ACORNS_EARLY',
  Apple = 'APPLE',
  Google = 'GOOGLE',
}

export type OmnibusShareTransferId = {
  __typename?: 'OmnibusShareTransferId'
  value: Scalars['String']
}

export type OnboardingBenefitsInput = {
  product?: InputMaybe<OnboardingProducts>
}

export enum OnboardingGroups {
  Family = 'FAMILY',
  Featured = 'FEATURED',
  Future = 'FUTURE',
  Security = 'SECURITY',
}

export type OnboardingProductStatus = {
  __typename?: 'OnboardingProductStatus'
  claimStatus: ClaimStatus
  claimedOn: Maybe<Scalars['String']>
  details: Maybe<Array<Maybe<ClaimStatusDetails>>>
  expiresOn: Maybe<Scalars['String']>
  updatedBy: Maybe<Scalars['String']>
  updatedOn: Maybe<Scalars['String']>
}

export type OnboardingProductTile = {
  __typename?: 'OnboardingProductTile'
  claimDetails: OnboardingProductStatus
  product: OnboardingProducts
  status: BenefitProductStatus
}

export enum OnboardingProducts {
  BenefitsGohenryStandard = 'BENEFITS_GOHENRY_STANDARD',
  BenefitsInsuranceStandard = 'BENEFITS_INSURANCE_STANDARD',
  BenefitsTaxfilingStandard = 'BENEFITS_TAXFILING_STANDARD',
  BenefitsWillStandard = 'BENEFITS_WILL_STANDARD',
  Early = 'EARLY',
  Earn = 'EARN',
  EarnChoice = 'EARN_CHOICE',
  EarnPrime = 'EARN_PRIME',
  EmergencyFund = 'EMERGENCY_FUND',
  Invest = 'INVEST',
  Later = 'LATER',
  LaterMatch = 'LATER_MATCH',
  MoneyManager = 'MONEY_MANAGER',
  SelfDirectedInvest = 'SELF_DIRECTED_INVEST',
  Spend = 'SPEND',
}

export enum OnboardingRequirement {
  AffiliatedWithBrokerDealer = 'AFFILIATED_WITH_BROKER_DEALER',
  AnnualIncome = 'ANNUAL_INCOME',
  BrokerageAnnualIncome = 'BROKERAGE_ANNUAL_INCOME',
  CheckingSignature = 'CHECKING_SIGNATURE',
  CombinedAnnualIncome = 'COMBINED_ANNUAL_INCOME',
  DateOfBirth = 'DATE_OF_BIRTH',
  Ecbsv = 'ECBSV',
  Employees = 'EMPLOYEES',
  EmploymentStatus = 'EMPLOYMENT_STATUS',
  FilingType = 'FILING_TYPE',
  FinancialEducation = 'FINANCIAL_EDUCATION',
  FirstName = 'FIRST_NAME',
  IntroInvestmentAccounts = 'INTRO_INVESTMENT_ACCOUNTS',
  InvestmentGoal = 'INVESTMENT_GOAL',
  KidsInvestingInterest = 'KIDS_INVESTING_INTEREST',
  LandingCheckingAccount = 'LANDING_CHECKING_ACCOUNT',
  LastName = 'LAST_NAME',
  LinkedFundingSource = 'LINKED_FUNDING_SOURCE',
  MailingAddress = 'MAILING_ADDRESS',
  MaritalStatus = 'MARITAL_STATUS',
  NetWorth = 'NET_WORTH',
  Occupation = 'OCCUPATION',
  PhoneNumber = 'PHONE_NUMBER',
  ProspectiveBrokerageAnnualIncome = 'PROSPECTIVE_BROKERAGE_ANNUAL_INCOME',
  ProspectiveEmploymentStatus = 'PROSPECTIVE_EMPLOYMENT_STATUS',
  ProspectiveFinancialEducation = 'PROSPECTIVE_FINANCIAL_EDUCATION',
  ProspectiveFinancialGoals = 'PROSPECTIVE_FINANCIAL_GOALS',
  ProspectiveInvestmentGoal = 'PROSPECTIVE_INVESTMENT_GOAL',
  ProspectiveNetWorth = 'PROSPECTIVE_NET_WORTH',
  ResidentialAddress = 'RESIDENTIAL_ADDRESS',
  ResidentialAddressVerification = 'RESIDENTIAL_ADDRESS_VERIFICATION',
  RetirementAnnualIncome = 'RETIREMENT_ANNUAL_INCOME',
  ReviewSavingsAccount = 'REVIEW_SAVINGS_ACCOUNT',
  ReviewSummary = 'REVIEW_SUMMARY',
  SelfEmployedIncome = 'SELF_EMPLOYED_INCOME',
  ShareholderOrDirector = 'SHAREHOLDER_OR_DIRECTOR',
  SocialSecurityNumber = 'SOCIAL_SECURITY_NUMBER',
  SubjectToBackupWithholding = 'SUBJECT_TO_BACKUP_WITHHOLDING',
  Subscription = 'SUBSCRIPTION',
  TermsAndConditions = 'TERMS_AND_CONDITIONS',
}

export type OnboardingTileGroup = {
  __typename?: 'OnboardingTileGroup'
  group: OnboardingGroups
  products: Maybe<Array<Maybe<OnboardingProductTile>>>
}

export type OnboardingTipItem = {
  __typename?: 'OnboardingTipItem'
  body: Scalars['String']
  headline: Scalars['String']
  id: Scalars['ID']
  image: Image
  title: Scalars['String']
  type: OnboardingTipType
}

export enum OnboardingTipType {
  /** feature */
  Feature = 'feature',
  /** introduction */
  Intro = 'intro',
}

export type OnboardingTips = {
  __typename?: 'OnboardingTips'
  items: Array<OnboardingTipItem>
}

export enum OnboardingType {
  Checking = 'CHECKING',
  Early = 'EARLY',
  EmergencySavings = 'EMERGENCY_SAVINGS',
  Invest = 'INVEST',
  Later = 'LATER',
  MoneyManager = 'MONEY_MANAGER',
  Prospect = 'PROSPECT',
}

/** Online Switches are performed through the Employer's URL. */
export type OnlineSwitch = SwitchInterface & {
  __typename?: 'OnlineSwitch'
  source: SwitchSource
  type: SwitchType
  /** Employer URL */
  url: Scalars['String']
  vendorTargetId: Maybe<Scalars['ID']>
}

/** Cannot close user account if user has open spend/investment accounts */
export type OpenAccountsException = {
  __typename?: 'OpenAccountsException'
  /** User's open account types */
  openAccountTypes: Maybe<Array<Scalars['String']>>
}

/** Input for creating a Core InvestmentAccount */
export type OpenCoreInvestmentAccountInput = {
  /** ID of the portfolio for this investment account */
  portfolioId: Scalars['String']
}

/** Result from opening a Core InvestmentAccount */
export type OpenCoreInvestmentAccountResult =
  | CoreAccountAlreadyExistsException
  | InvalidPortfolioIdException
  | InvestmentAccount
  | InvestmentAccountCreationException
  | UserClosedException
  | UserNotFoundException

/** Input for creating an early investment account */
export type OpenEarlyAccountInput = {
  /** Beneficiary ID */
  beneficiaryId: Scalars['ID']
  /** Name of investment account */
  investmentAccountName?: InputMaybe<Scalars['String']>
  /** State in which to open the investment account (defaults to custodian's state) */
  stateCode?: InputMaybe<Scalars['String']>
  /** Termination age of the investment account */
  terminationAge: Scalars['Int']
}

/** Result from opening an Early Investment Account */
export type OpenEarlyAccountResult =
  | BeneficiaryAccountExistsException
  | CoreAccountClosedException
  | InternalErrorException
  | InvalidStateException
  | InvalidSubscriptionTierException
  | InvalidTerminationAgeException
  | InvestmentAccount
  | MaxAccountsCreatedException
  | MissingBeneficiarySsnException
  | NoBeneficiaryFoundException
  | UserClosedException
  | UserNotFoundException
  | UserNotVerifiedException

export enum OperationStage {
  AuthCompleted = 'AUTH_COMPLETED',
  AuthFailed = 'AUTH_FAILED',
  AwaitingTfaCode = 'AWAITING_TFA_CODE',
  AwaitingTfaOption = 'AWAITING_TFA_OPTION',
  ProcessingCredentials = 'PROCESSING_CREDENTIALS',
  ProcessingTfaCode = 'PROCESSING_TFA_CODE',
  ProcessingTfaOption = 'PROCESSING_TFA_OPTION',
}

export enum Order {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type OrderBankCardInput = {
  bankCardTier?: InputMaybe<BankCardTier>
  bankType?: InputMaybe<BankType>
  employmentStatus?: InputMaybe<Scalars['String']>
  isDocumentsAccepted: Scalars['Boolean']
  isReopen?: InputMaybe<Scalars['Boolean']>
  paymentProcessor?: InputMaybe<BankCardPaymentProcessor>
  prefundTransfer?: InputMaybe<BankCardPrefundTransfer>
  requestVersion?: InputMaybe<RequestVersions>
}

export type OrderBankCardResult = BankCardOrder

export type OrderPhysicalBankCardPayload = {
  __typename?: 'OrderPhysicalBankCardPayload'
  cardId: Scalars['String']
}

export type OrderPhysicalBankCardResult = OrderPhysicalBankCardPayload

export enum Origin {
  ExternalGiftCard = 'external_gift_card',
  Prepayment = 'prepayment',
}

/** Outside contribution object */
export type OutsideContribution = TimestampsInterface & {
  __typename?: 'OutsideContribution'
  accountId: Scalars['ID']
  checkoutCart: OutsideContributionCheckoutCart
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  failureReason: Maybe<Scalars['String']>
  id: Scalars['ID']
  investmentId: Maybe<Scalars['ID']>
  note: Maybe<Scalars['String']>
  noteAuthor: Maybe<Scalars['String']>
  paymentMethodId: Scalars['ID']
  state: ContributionState
  transferRequestId: Maybe<Scalars['ID']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** an outside contribution checkout cart object */
export type OutsideContributionCheckoutCart = TimestampsInterface & {
  __typename?: 'OutsideContributionCheckoutCart'
  code: OutsideContributionCode
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  feeAmount: Scalars['String']
  id: Scalars['ID']
  investmentAmount: Scalars['String']
  paymentIntentId: Scalars['ID']
  status: CheckoutCartStatus
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** Code for outside contribution */
export type OutsideContributionCode = TimestampsInterface & {
  __typename?: 'OutsideContributionCode'
  allowCreditCard: Scalars['Boolean']
  /** Unique code that has one-to-one relationship with investment Account */
  code: Scalars['String']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  investmentAccountId: Scalars['ID']
  recipientFirstName: Scalars['String']
  /** This is the id of who the contribution is going to. Most likely beneficiary id */
  recipientId: Scalars['ID']
  signupBonusUrl: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  url: Scalars['String']
  userId: Scalars['ID']
}

/** Object representing an outside contribution prospect */
export type OutsideContributionProspect = Prospect & {
  __typename?: 'OutsideContributionProspect'
  email: Scalars['String']
  id: Scalars['ID']
}

export type OverrideInfo = {
  __typename?: 'OverrideInfo'
  overriddenAt: Scalars['DateTime']
  overriddenBy: Scalars['String']
}

export type OverrideInput = {
  originalAutoAdd?: InputMaybe<Scalars['ID']>
  originalFallback?: InputMaybe<Scalars['ID']>
  originalQa?: InputMaybe<Scalars['ID']>
}

export enum PackageStatus {
  /** Available for Pickup */
  AvailableForPickup = 'availableForPickup',
  /** Customer Recall */
  CustomerRecall = 'customerRecall',
  /** Dead Letter */
  DeadLetter = 'deadLetter',
  /** Delivered */
  Delivered = 'delivered',
  /** Delivery Status Not Updated */
  DeliveryStatusNotUpdated = 'deliveryStatusNotUpdated',
  /** Forwarded to New Address */
  ForwardedToNewAddress = 'forwardedToNewAddress',
  /** Logged at USPS */
  LoggedAtUsps = 'loggedAtUSPS',
  /** New Item */
  NewItem = 'newItem',
  /** Found – No Status */
  NoStatus = 'noStatus',
  /** Not Found */
  NotFound = 'notFound',
  /** Notice Left for Recipient */
  NoticeLeftForRecipient = 'noticeLeftForRecipient',
  /** Other */
  Other = 'other',
  /** Out for Delivery */
  OutForDelivery = 'outForDelivery',
  /** Returned to Sender */
  ReturnedToSender = 'returnedToSender',
  /** Scanned in Route */
  ScannedInRoute = 'scannedInRoute',
  /** Undeliverable */
  Undeliverable = 'undeliverable',
}

/** Pagination meta information about the current response */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** Indicates records exist after the given cursor */
  hasNextPage: Scalars['Boolean']
  /** Indicates records exist before the given cursor */
  hasPreviousPage: Scalars['Boolean']
  /** Number of records returned in the response */
  limit: Scalars['Int']
}

/** Pagination input to fetch pages of records */
export type PageInput = {
  /** Cursor to fetch records starting after */
  after?: InputMaybe<Scalars['ID']>
  /** How many records to return */
  first?: InputMaybe<Scalars['Int']>
}

export enum PageName {
  AboutPortfolio = 'ABOUT_PORTFOLIO',
  AddressEdit = 'ADDRESS_EDIT',
  AddressInvalid = 'ADDRESS_INVALID',
  AddressPreview = 'ADDRESS_PREVIEW',
  AddressSuggestion = 'ADDRESS_SUGGESTION',
  /** @deprecated Animation removed as a page in the web funnel */
  Analyzing = 'ANALYZING',
  BankLinkSuccess = 'BANK_LINK_SUCCESS',
  CardOrderReview = 'CARD_ORDER_REVIEW',
  CardSignature = 'CARD_SIGNATURE',
  ChooseFundingSource = 'CHOOSE_FUNDING_SOURCE',
  ContactInfo = 'CONTACT_INFO',
  CryptoLander = 'CRYPTO_LANDER',
  DateOfBirth = 'DATE_OF_BIRTH',
  DirectBankIntegration = 'DIRECT_BANK_INTEGRATION',
  DirectBankIntegrationRedirect = 'DIRECT_BANK_INTEGRATION_REDIRECT',
  DirectToMobile = 'DIRECT_TO_MOBILE',
  /** @deprecated Page removed from funnel */
  EsgDetails = 'ESG_DETAILS',
  /** @deprecated Page removed from funnel */
  EsgEducation = 'ESG_EDUCATION',
  Funding = 'FUNDING',
  Hdyhau = 'HDYHAU',
  Institutions = 'INSTITUTIONS',
  InvestorQuestions = 'INVESTOR_QUESTIONS',
  InvestInterstitial = 'INVEST_INTERSTITIAL',
  LaterInterstitial = 'LATER_INTERSTITIAL',
  ManualFundingSource = 'MANUAL_FUNDING_SOURCE',
  MfaSetUp = 'MFA_SET_UP',
  MocReferralReminder = 'MOC_REFERRAL_REMINDER',
  MocRoutingInterstitial = 'MOC_ROUTING_INTERSTITIAL',
  MocSuccess = 'MOC_SUCCESS',
  Occupation = 'OCCUPATION',
  OneTimeDeposit = 'ONE_TIME_DEPOSIT',
  OneTimeInvestment = 'ONE_TIME_INVESTMENT',
  PersonalInfo = 'PERSONAL_INFO',
  PhoneNumber = 'PHONE_NUMBER',
  PlaidLinkRedirect = 'PLAID_LINK_REDIRECT',
  PortfolioDetails = 'PORTFOLIO_DETAILS',
  PreviewPortfolio = 'PREVIEW_PORTFOLIO',
  PricingInterstitial = 'PRICING_INTERSTITIAL',
  ProductOnboarding = 'PRODUCT_ONBOARDING',
  ProductSelector = 'PRODUCT_SELECTOR',
  ProgressScreen_1 = 'PROGRESS_SCREEN_1',
  ProgressScreen_2 = 'PROGRESS_SCREEN_2',
  ProgressScreen_3 = 'PROGRESS_SCREEN_3',
  RecurringDeposit = 'RECURRING_DEPOSIT',
  RecurringInvestment = 'RECURRING_INVESTMENT',
  /** @deprecated Page removed from funnel */
  ReferralDisclosure = 'REFERRAL_DISCLOSURE',
  /** @deprecated Page removed from funnel */
  ReferralReward = 'REFERRAL_REWARD',
  RoundUpsFunding = 'ROUND_UPS_FUNDING',
  RoundUpsInterstitial = 'ROUND_UPS_INTERSTITIAL',
  RoundUpsPast = 'ROUND_UPS_PAST',
  RoundUpsSetUp = 'ROUND_UPS_SET_UP',
  SecondChanceBankLink = 'SECOND_CHANCE_BANK_LINK',
  SecondChanceInstitutions = 'SECOND_CHANCE_INSTITUTIONS',
  /** @deprecated Page removed from funnel */
  SelectPortfolioTheme = 'SELECT_PORTFOLIO_THEME',
  /** @deprecated Page removed from funnel */
  SelectTier = 'SELECT_TIER',
  /** @deprecated The shipping address page was originally rolled out with multiple components combined in one. This has been replaced with ADDRESS_EDIT, ADDRESS_INVALID, ADDRESS_PREVIEW, and ADDRESS_SUGGESTION. */
  ShippingAddress = 'SHIPPING_ADDRESS',
  Signup = 'SIGNUP',
  Ssn = 'SSN',
  SubscriptionActive = 'SUBSCRIPTION_ACTIVE',
  Success = 'SUCCESS',
  SuitabilityQuestions = 'SUITABILITY_QUESTIONS',
}

export type PaginationInput = {
  cursor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
}

/** Query attributes for Direct Deposit Parameterized PDF Generation */
export type ParameterizedPdfInput = {
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
  /** Date Signed */
  dateSigned: Scalars['String']
  /** Value of Amount Option Chosen */
  distributionAmount?: InputMaybe<Scalars['Float']>
  /** Amount Option */
  distributionType: DirectDepositDistribution
  /** Employer Name */
  employerName: Scalars['String']
  /** Session ID */
  sessionId?: InputMaybe<Scalars['ID']>
  /** User ID */
  userId?: InputMaybe<Scalars['ID']>
}

export type PartnerDataShare = {
  __typename?: 'PartnerDataShare'
  partner: BenefitsPartner
  userId: Scalars['ID']
}

export type PartnerDataShareInput = {
  product: BenefitsProduct
}

export type PartnerDataShareResponse =
  | PartnerDataShare
  | ProductNotSupportedException

export type PartnerDetailsResponse = {
  __typename?: 'PartnerDetailsResponse'
  partnerLogoUrl: Scalars['String']
  partnerName: BenefitsPartner
}

export type PartnerDocument = {
  __typename?: 'PartnerDocument'
  /** Day (nullable) */
  day: Maybe<Scalars['Int']>
  /** Type of document (e.g., TAX_RETURN, MEMBERSHIP_GUIDE) */
  documentType: Maybe<PartnerDocumentType>
  /** Document URL */
  documentUrl: Scalars['String']
  /** Month (nullable) */
  month: Maybe<Scalars['Int']>
  /** Subtype for the document (e.g., 'US', 'CA', 'NY' for TAX_RETURN) */
  subType: Maybe<Scalars['String']>
  /** Year (nullable) */
  year: Maybe<Scalars['Int']>
}

export type PartnerDocumentInput = {
  product: BenefitsProduct
  /** Tax year for tax filing products (e.g., 2024). Required for BENEFITS_TAXFILING_STANDARD. */
  taxYear?: InputMaybe<Scalars['Int']>
}

export enum PartnerDocumentType {
  MembershipGuide = 'MEMBERSHIP_GUIDE',
  TaxReturn = 'TAX_RETURN',
}

export type PartnerDocumentUrlResponse = {
  __typename?: 'PartnerDocumentUrlResponse'
  /** List of partner documents */
  documents: Array<PartnerDocument>
  /** Error message if the request failed (e.g., unsupported tax year) */
  error: Maybe<Scalars['String']>
}

export type PartnerOfferGroup = {
  __typename?: 'PartnerOfferGroup'
  /** display body for the group */
  body: Maybe<Scalars['String']>
  carouselType: CarouselType
  id: Scalars['ID']
  /** list of offers in the group */
  offers: Array<PartnerOfferGroupItem>
  /** display title for the group */
  title: Maybe<Scalars['String']>
}

/** Used to customize offer group contents */
export type PartnerOfferGroupFilterInput = {
  /** Location is required for job offers */
  location?: InputMaybe<OfferLocationInput>
}

export type PartnerOfferGroupItem =
  | EarnOffer
  | JobOffer
  | JobSearchOffer
  | PromoOffer

/** Specifies the offer group type input */
export type PartnerOfferGroupsTypeInput = {
  type: OfferGroupsType
}

export type PartnerStatusInput = {
  acornsPartnerStatus: AcornsPartnerStatus
  partner: BenefitsPartner
  partnerData?: InputMaybe<Scalars['String']>
  partnerEventPayload?: InputMaybe<Scalars['String']>
  partnerStatus?: InputMaybe<Scalars['String']>
  partnerUpdatedDt?: InputMaybe<Scalars['DateTime']>
  product: BenefitsProduct
}

export type PartnerUrlInput = {
  product: BenefitsProduct
  /** Optional boolean flag to control customer data sharing */
  shareCustomerData?: InputMaybe<Scalars['Boolean']>
}

export type PartnerUrlResponse = {
  __typename?: 'PartnerUrlResponse'
  partnerUrl: Scalars['String']
  status: AcornsPartnerStatus
  updatedAt: Maybe<Scalars['DateTime']>
}

export enum PasswordResetErrors {
  InvalidPasswordLength = 'INVALID_PASSWORD_LENGTH',
  InvalidPasswordMaxLength = 'INVALID_PASSWORD_MAX_LENGTH',
  InvalidPasswordMissingLowerCase = 'INVALID_PASSWORD_MISSING_LOWER_CASE',
  InvalidPasswordMissingNumber = 'INVALID_PASSWORD_MISSING_NUMBER',
  InvalidPasswordMissingSpecialCharacter = 'INVALID_PASSWORD_MISSING_SPECIAL_CHARACTER',
  InvalidPasswordMissingUpperCase = 'INVALID_PASSWORD_MISSING_UPPER_CASE',
  InvalidSsn = 'INVALID_SSN',
  NewPasswordMatchesOldPassword = 'NEW_PASSWORD_MATCHES_OLD_PASSWORD',
  PasswordsDoNotMatch = 'PASSWORDS_DO_NOT_MATCH',
}

export type PasswordResetForm = {
  __typename?: 'PasswordResetForm'
  fields: Array<Maybe<PasswordResetFormFields>>
  userId: Maybe<Scalars['ID']>
}

export type PasswordResetFormFields = {
  __typename?: 'PasswordResetFormFields'
  key: Scalars['String']
  value: Maybe<Scalars['String']>
}

export type PastAcornsRewardInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastAcornsRewardInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    merchantName: Maybe<Scalars['String']>
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    partnerLogoUrl: Maybe<Scalars['URL']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Decorator type for items that have attached notes for display */
export type PastAnnotatedItem = {
  /** Past Item ID */
  id: Scalars['ID']
  /** Annotation on the item */
  note: Maybe<Scalars['String']>
  /** Author of the note */
  noteAuthor: Maybe<Scalars['String']>
}

/** Recurrence setting for a recurring Transfer */
export type PastBeneficiaryInfo = {
  __typename?: 'PastBeneficiaryInfo'
  firstName: Scalars['String']
  id: Scalars['ID']
  lastName: Scalars['String']
}

export type PastBeneficiaryTransferInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastBeneficiaryTransferInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastCashOwedCollectionInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastCashOwedCollectionInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastCashReinvestmentInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastCashReinvestmentInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A base set of fields that each type of PastItem must implement */
export type PastCoreCombinedItem = {
  /** Past Item ID */
  id: Scalars['ID']
  isCombinedInvestment: Scalars['Boolean']
}

/** A generic money movement line item for the Core account */
export type PastCoreItem = PastItem & {
  __typename?: 'PastCoreItem'
  amount: Maybe<CurrencyAmount>
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean']
  /** Past Item ID */
  id: Scalars['ID']
  /** The corresponding product of the item */
  productType: ProductType
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
  /** The current state of the item */
  status: PastItemStatus
  /** The title of the item */
  title: Scalars['String']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
}

/** Metrics for core to be displayed in the summary */
export type PastCoreSummary = {
  __typename?: 'PastCoreSummary'
  dividends: CurrencyAmount
  foundMoneyRewards: CurrencyAmount
  investments: CurrencyAmount
  /** Total gain / loss including fees */
  netReturns: CurrencyAmount
  referralRewards: CurrencyAmount
  withdrawals: CurrencyAmount
}

/** A base set of fields that each traded PastItem must implement */
export type PastCoreTradedItem = {
  /** Past Item ID */
  id: Scalars['ID']
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>
}

export type PastDividendInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastDividendInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A base set of fields all Early items share */
export type PastEarlyItem = {
  beneficiaryAccountId: Scalars['String']
  beneficiaryId: Scalars['String']
}

/** Metrics for early to be displayed in the summary */
export type PastEarlySummary = {
  __typename?: 'PastEarlySummary'
  contributions: CurrencyAmount
  dividends: CurrencyAmount
  /** Total gain / loss including fees */
  netReturns: CurrencyAmount
  withdrawals: CurrencyAmount
}

export type PastEmployeeContributionInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastEmployeeContributionInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastExternalTransferInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastExternalTransferInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastExternalTransferReversedInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastExternalTransferReversedInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastFeeInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastFeeInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastGiftCardInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastGiftCardInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastIraTransferInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastIRATransferInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A base set of fields that each type of PastItem must implement */
export type PastInvestmentItem = {
  accountName: Scalars['String']
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>
  moneyManagerTransfer: Scalars['Boolean']
  nonce: Maybe<Scalars['String']>
  productAccountType: ProductAccountType
  transactionDescription: Scalars['String']
  transactionType: TransactionType
}

export type PastInvestmentTipItem = PastAnnotatedItem &
  PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastInvestmentTipItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    /** Annotation on the item */
    note: Maybe<Scalars['String']>
    /** Author of the note */
    noteAuthor: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A base set of fields that each type of PastItem must implement */
export type PastItem = {
  amount: Maybe<CurrencyAmount>
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean']
  /** Past Item ID */
  id: Scalars['ID']
  /** The corresponding product of the item */
  productType: ProductType
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
  /** The current state of the item */
  status: PastItemStatus
  /** The title of the item */
  title: Scalars['String']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
}

/** PastItem connection object */
export type PastItemConnection = {
  __typename?: 'PastItemConnection'
  edges: Array<PastItemEdge>
  pageInfo: PageInfo
}

export type PastItemEdge = {
  __typename?: 'PastItemEdge'
  cursor: Scalars['ID']
  node: Maybe<PastItem>
}

export enum PastItemStatus {
  Complete = 'complete',
  Pending = 'pending',
  Selling = 'selling',
  Transferring = 'transferring',
}

export type PastItemsAccountFilter = {
  /** Requested Account ID (accounts-service account id). Takes precedence over id. */
  accountGatewayId?: InputMaybe<Scalars['ID']>
  /** Requested Account ID (accounts-service referenceId) */
  id?: InputMaybe<Scalars['ID']>
  /** Product Account Type */
  productAccountType: ProductAccountType
}

export type PastLaterSummary = {
  __typename?: 'PastLaterSummary'
  contributions: CurrencyAmount
  currentYearContributions: CurrencyAmount
  dividends: CurrencyAmount
  netReturns: CurrencyAmount
  priorYearContributions: CurrencyAmount
  withdrawals: CurrencyAmount
}

export type PastLumpSumInvestment = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastLumpSumInvestment'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastMatchInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastMatchInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastMatchRemovalInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastMatchRemovalInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastMoneyManagerAllocation = {
  __typename?: 'PastMoneyManagerAllocation'
  allocationAmount: Maybe<CurrencyAmount>
  allocationPercent: Scalars['Float']
  targetAccountId: Scalars['ID']
  targetAccountType: ProductAccountType
}

export type PastMoneyManagerAllocations = {
  allocations: Array<PastMoneyManagerAllocation>
}

/** Recurring information for a money manager recurring transfer */
export type PastMoneyManagerRecurrenceItem = PastMoneyManagerAllocations &
  PastScheduledItemV2 & {
    __typename?: 'PastMoneyManagerRecurrenceItem'
    accountType: ProductAccountType
    allocations: Array<PastMoneyManagerAllocation>
    amount: CurrencyAmount
    expectedNextDeposit: Maybe<Scalars['String']>
    recurrence: PastRecurrenceSettingsV2
  }

/** Money Manager paycheck information */
export type PastMoneyManagerScheduledPaycheckItem =
  PastMoneyManagerAllocations &
    PastScheduledItemV2 & {
      __typename?: 'PastMoneyManagerScheduledPaycheckItem'
      accountType: ProductAccountType
      allocations: Array<PastMoneyManagerAllocation>
      amount: CurrencyAmount
      employer: Scalars['String']
      expectedNextDeposit: Maybe<Scalars['String']>
      name: Scalars['String']
    }

export type PastOutsideContributionInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastOutsideContributionInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastRealTimeRoundUpInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastRealTimeRoundUpInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastRebalanceInvestmentItem = PastInvestmentItem &
  PastItem & {
    __typename?: 'PastRebalanceInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Recurring information for a recurring transfer */
export type PastRecurrenceItem = PastScheduledItem & {
  __typename?: 'PastRecurrenceItem'
  /** type of account transactions is associated with */
  accountType: ProductAccountType
  /** amount a schedulted transaction is for */
  amount: CurrencyAmount
  beneficiary: Maybe<PastBeneficiaryInfo>
  recurrence: PastRecurrenceSettings
}

/** Recurring information for a recurring transfer */
export type PastRecurrenceItemV2 = PastScheduledItemV2 & {
  __typename?: 'PastRecurrenceItemV2'
  /** type of account transactions is associated with */
  accountType: ProductAccountType
  /** amount a schedulted transaction is for */
  amount: CurrencyAmount
  beneficiary: Maybe<Beneficiary>
  expectedNextDeposit: Maybe<Scalars['String']>
  recurrence: PastRecurrenceSettingsV2
}

/** Recurrence setting for a recurring Transfer */
export type PastRecurrenceSettings = {
  __typename?: 'PastRecurrenceSettings'
  accountId: Scalars['String']
  /** @deprecated Use daysOfMonth instead */
  dayOfMonth: Maybe<Scalars['Float']>
  daysOfMonth: Maybe<Array<Scalars['Float']>>
  frequency: RecurrenceFrequency
  id: Maybe<Scalars['String']>
  weekday: Maybe<DayOfWeek>
}

/** Recurrence setting for a recurring Transfer */
export type PastRecurrenceSettingsV2 = {
  __typename?: 'PastRecurrenceSettingsV2'
  accountId: Scalars['String']
  /** @deprecated Use daysOfMonth instead. */
  dayOfMonth: Maybe<Scalars['Float']>
  daysOfMonth: Maybe<Array<Scalars['Float']>>
  frequency: RecurrenceFrequency
  id: Maybe<Scalars['String']>
  weekday: Maybe<DayOfWeek>
}

export type PastRecurringInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastRecurringInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastReferralRewardInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastReferralRewardInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastReferralRewardMatchInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastReferralRewardMatchInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastRefundInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastRefundInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastReversalInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastReversalInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastRewardInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastRewardInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    merchantName: Maybe<Scalars['String']>
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    partnerLogoUrl: Maybe<Scalars['URL']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastRewardMatchInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastRewardMatchInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    merchantName: Maybe<Scalars['String']>
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    partnerLogoUrl: Maybe<Scalars['URL']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastRoundUpItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastRoundUpItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastRoundUpMatchInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastRoundUpMatchInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Round-up metrics for the Past summary card */
export type PastRoundUpSummary = {
  __typename?: 'PastRoundUpSummary'
  amountPerMonth: Array<PastRoundUpSummaryMonth>
  canceled: MicrosMoney
  canceledCount: Scalars['Int']
  endDate: Scalars['String']
  invested: MicrosMoney
  investedCount: Scalars['Int']
  /** pending + invested; excludes canceled */
  overall: MicrosMoney
  pending: MicrosMoney
  pendingCount: Scalars['Int']
  /** Recent round-up transactions (pending + completed ROUND_UP and INSTANT_ROUND_UP), newest first. estimatedCompletionDate uses the same logic as allPastItems. Limit is required; no pagination. */
  roundUpTransactions: Array<RoundUpTransaction>
  startDate: Scalars['String']
}

/** Round-up metrics for the Past summary card */
export type PastRoundUpSummaryRoundUpTransactionsArgs = {
  limit: Scalars['Int']
}

export type PastRoundUpSummaryFilter = {
  endDate?: InputMaybe<Scalars['String']>
  /** Last X days/months/years ending today */
  roundUpLookbackFilter?: InputMaybe<RoundUpsPastSummaryInput>
  startDate?: InputMaybe<Scalars['String']>
}

export type PastRoundUpSummaryMonth = {
  __typename?: 'PastRoundUpSummaryMonth'
  amount: MicrosMoney
  count: Scalars['Int']
  endDate: Scalars['String']
  startDate: Scalars['String']
}

/** A base set of fields that each type of PastScheduledItem must implement */
export type PastScheduledItem = {
  /** type of account transactions is associated with */
  accountType: ProductAccountType
  /** amount a schedulted transaction is for */
  amount: CurrencyAmount
}

/** A base set of fields that each type of PastScheduledItem must implement */
export type PastScheduledItemV2 = {
  /** type of account transactions is associated with */
  accountType: ProductAccountType
  /** amount a schedulted transaction is for */
  amount: CurrencyAmount
  expectedNextDeposit: Maybe<Scalars['String']>
}

export type PastSecurityLiquidationInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastSecurityLiquidationInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastSmartDepositInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastSmartDepositInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A generic money movement line item for the Spend account */
export type PastSpendItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'PastSpendItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Metrics for spend to be displayed in the summary */
export type PastSpendSummary = {
  __typename?: 'PastSpendSummary'
  /** Primary account's current available balance */
  availableBalance: Maybe<CurrencyAmount>
  /**
   * Withdrawals for this month. Current month is based on current PST time
   * @deprecated Use `debitsLast30Days`
   */
  debits: Maybe<CurrencyAmount>
  /** Withdrawals/purchases for the last 30 days. Based on current PST time */
  debitsLast30Days: Maybe<CurrencyAmount>
  /**
   * One time or direct deposits for this month. Current month is based on current PST time
   * @deprecated Use `depositsLast30Days`
   */
  deposits: Maybe<CurrencyAmount>
  /** One time or direct deposits for the last 30 days. Based on current PST time */
  depositsLast30Days: Maybe<CurrencyAmount>
  /** @deprecated Will be displayed on Past Core Summary */
  foundMoneyPlus: Maybe<CurrencyAmount>
  instantRoundUps: Maybe<CurrencyAmount>
}

/** Recurrence setting for a recurring Transfer */
export type PastSplitDepositAllocationSettings = {
  __typename?: 'PastSplitDepositAllocationSettings'
  allocationList: Array<PastSplitDepositAllocations>
  expectedNextDeposit: Maybe<Scalars['String']>
  id: Scalars['String']
  name: Scalars['String']
}

/** Recurrence setting for a recurring Transfer */
export type PastSplitDepositAllocationSettingsV2 = {
  __typename?: 'PastSplitDepositAllocationSettingsV2'
  allocationList: Array<PastSplitDepositAllocationsV2>
  expectedNextDeposit: Maybe<Scalars['String']>
  id: Scalars['String']
  name: Scalars['String']
}

export type PastSplitDepositAllocations = {
  __typename?: 'PastSplitDepositAllocations'
  allocationAmount: Maybe<CurrencyAmount>
  allocationPercent: Scalars['String']
  name: Maybe<Scalars['String']>
  targetAccountId: Scalars['ID']
  targetAccountType: SplitDepositTargetAccountType
}

export type PastSplitDepositAllocationsV2 = {
  __typename?: 'PastSplitDepositAllocationsV2'
  allocationAmount: Maybe<CurrencyAmount>
  allocationPercent: Scalars['String']
  name: Maybe<Scalars['String']>
  targetAccountId: Scalars['ID']
  targetAccountType: SplitDepositTargetAccountType
}

/** Split Paycheck information for a direct deposit */
export type PastSplitDepositItem = PastScheduledItem & {
  __typename?: 'PastSplitDepositItem'
  /** type of account transactions is associated with */
  accountType: ProductAccountType
  allocations: PastSplitDepositAllocationSettings
  /** amount a schedulted transaction is for */
  amount: CurrencyAmount
  awaitingConfiguration: Scalars['Boolean']
  moneyManagerTransfer: Scalars['Boolean']
}

/** Split Paycheck information for a direct deposit */
export type PastSplitDepositItemV2 = PastScheduledItemV2 & {
  __typename?: 'PastSplitDepositItemV2'
  /** type of account transactions is associated with */
  accountType: ProductAccountType
  allocations: PastSplitDepositAllocationSettingsV2
  /** amount a schedulted transaction is for */
  amount: CurrencyAmount
  awaitingConfiguration: Scalars['Boolean']
  expectedNextDeposit: Maybe<Scalars['String']>
}

export type PastStreakRewardInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastStreakRewardInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A base set of fields for transaction summary that each type of HistorySummary must implement */
export type PastSummary = {
  moneyIn: CurrencyAmount
  moneyOut: CurrencyAmount
}

export type PastSummaryFilter = {
  /** Requested Account ID and Type */
  account?: InputMaybe<PastItemsAccountFilter>
  /** Time to filter transaction by */
  timeframe?: InputMaybe<TimeFrameFilter>
}

/** A base set of fields that each type of PastItem must implement */
export type PastTargetedTransferItem = {
  sourceAccountTitle: Maybe<Scalars['String']>
  targetAccountTitle: Maybe<Scalars['String']>
}

export type PastTipsThatGrowMatchInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastTipsThatGrowMatchInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Adds an estimated completion date field for items that correspond to user external transfers */
export type PastUserTransferItem = {
  /** An estimated completion date for when a user transfer will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>
  /** Indicates whether the user transfer is a recurring investment */
  isRecurring: Maybe<Scalars['Boolean']>
}

export type PastWithdrawalInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastWithdrawalInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    nonce: Maybe<Scalars['String']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PayoutRelationshipResult = {
  __typename?: 'PayoutRelationshipResult'
  action: Maybe<ManagePayoutRelationshipAction>
  result: Maybe<ManagePayoutRelationshipResult>
}

/** Query attributes for Direct Deposit PDF URL Generation */
export type PdfDownloadUrlInput = {
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
  /** Employer Name */
  employerName: Scalars['String']
  /** Session ID */
  sessionId?: InputMaybe<Scalars['ID']>
  /** User ID */
  userId?: InputMaybe<Scalars['ID']>
}

/** Returns URL with JWT token to lambda for Front-end */
export type PdfDownloadUrlPayload = {
  __typename?: 'PdfDownloadUrlPayload'
  /** PDF Download URL */
  url: Scalars['String']
}

/** Performance values for a given Investment Account */
export type Performance = {
  __typename?: 'Performance'
  /** Investment account values based on previous market day's closing prices */
  accountValues: Maybe<Array<Maybe<AccountValue>>>
  /** The dollar change in account value over the reporting period */
  marketChange: Maybe<Scalars['Float']>
  /** The percentage change in account value over the reporting period */
  marketChangePercent: Maybe<Scalars['Float']>
  /** The percentage change in account value over the reporting period (excluding fees) */
  marketChangePercentWithoutFees: Maybe<Scalars['Float']>
  /** The dollar change in account value over the reporting period (excluding fees) */
  marketChangeWithoutFees: Maybe<Scalars['Float']>
  /** Investment account value based on previous market day's closing prices */
  previousCloseAmount: Maybe<Scalars['Float']>
  /**
   * The total dollar amount invested over the reporting period
   * @deprecated Will not be supported in the future
   */
  totalInvested: Maybe<Scalars['Float']>
  /**
   * The total dollar amount invested over the reporting period (including pending investments)
   * @deprecated Will not be supported in the future
   */
  totalInvestedWithPending: Maybe<Scalars['Float']>
}

export enum PerformanceWidgetProductScope {
  All = 'ALL',
  Early = 'EARLY',
  Invest = 'INVEST',
  Later = 'LATER',
}

export enum PeriodType {
  CalendarWeek = 'CALENDAR_WEEK',
}

/** User profile update fields */
export type PersonalInfoInput = {
  address1?: InputMaybe<Scalars['String']>
  address2?: InputMaybe<Scalars['String']>
  city?: InputMaybe<Scalars['String']>
  dob?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  employer?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  occupation?: InputMaybe<Scalars['String']>
  phoneNumber?: InputMaybe<Scalars['String']>
  ssn?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  usCitizen?: InputMaybe<Scalars['Boolean']>
  zip?: InputMaybe<Scalars['String']>
}

/** Miscellaneous attributes and information about a user's phone numbers */
export type Phone = TimestampsInterface & {
  __typename?: 'Phone'
  /** Country code */
  countryCode: Scalars['String']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Internal ID for phone */
  id: Scalars['ID']
  /** Phone Number */
  phoneNumber: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Internal ID for user */
  userId: Scalars['ID']
  /** Phone has been verified */
  verified: Scalars['Boolean']
}

export type PhoneAuthenticator = Authenticator & {
  __typename?: 'PhoneAuthenticator'
  createdAt: Scalars['DateTime']
  deviceId: Scalars['ID']
  id: Scalars['ID']
  lastAuthenticatedAt: Maybe<Scalars['DateTime']>
  lastUsedAt: Maybe<Scalars['DateTime']>
  name: Scalars['String']
  phoneNumber: Scalars['PhoneNumber']
  type: AuthType
  updatedAt: Scalars['DateTime']
}

export type PhoneNumberOptedOutException = {
  __typename?: 'PhoneNumberOptedOutException'
  message: Maybe<Scalars['String']>
}

export type PhoneRedirect = {
  __typename?: 'PhoneRedirect'
  title: Scalars['String']
}

export enum PinwheelLinkTokenRequiredJobs {
  DirectDepositSwitch = 'DirectDepositSwitch',
}

/** The link token for use in the client. */
export type PlaidLayerLinkSession = {
  __typename?: 'PlaidLayerLinkSession'
  /** The Link Token a client should use for account linking. */
  token: Scalars['String']
}

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Undefined = 'UNDEFINED',
  Web = 'WEB',
}

export type PoliciesRecordDoesNotExistException = {
  __typename?: 'PoliciesRecordDoesNotExistException'
  policyInput: Maybe<Scalars['String']>
}

export type Policy = {
  __typename?: 'Policy'
  name: Scalars['String']
}

export type PolicyNotAddedException = {
  __typename?: 'PolicyNotAddedException'
  policyInput: Maybe<Scalars['String']>
}

/** Acorns Managed Portfolio Object */
export type Portfolio = BasePortfolio & {
  __typename?: 'Portfolio'
  /** Indicates the portfolio's allocation percentage */
  accountAllocation: PortfolioAllocation
  cashOwed: MonetaryAmount
  currentAllocationPercentage: Scalars['Float']
  currentBalance: MonetaryAmount
  currentBalanceWithPending: MonetaryAmount
  /** Indicates the extent to which the Portfolio has been customized by an investor. */
  customizationLevel: Maybe<PortfolioCustomizationLevel>
  /** Description of the portfolio */
  description: Scalars['String']
  /**
   * Indicates the ETFs that the portfolio is composed of
   * @deprecated Use BasePortfolio.portfolioSecurityAllocations instead
   */
  etfs: Maybe<Array<Etf>>
  /**
   * Securities currently owned by the Portfolio's InvestmentAccount (will be null
   * if not selected in the context of an InvestmentAccount).
   * @deprecated Use Portfolio.portfolioSecurities instead.
   */
  holdings: Maybe<Array<PortfolioHolding>>
  /** ID of the Portfolio */
  id: Scalars['ID']
  /** Indicates the minimum ratio that must be allocated to the managed portfolio */
  minimumManagedAllocationPercent: Scalars['Float']
  /** Indicates the Acorns-designated portfolio name */
  name: Scalars['String']
  /** Indicates a key based off of the portfolio name */
  nameKey: Scalars['String']
  pendingBalance: MonetaryAmount
  /**
   * Securities currently owned by the Portfolio's InvestmentAccount (will be null
   * if not selected in the context of an InvestmentAccount).
   */
  portfolioSecurities: Maybe<Array<PortfolioSecurity>>
  /** Security Allocations for the given portfolio */
  portfolioSecurityAllocations: Maybe<Array<PortfolioSecurityAllocation>>
  /** Indicates the display priority */
  position: Maybe<Scalars['Int']>
  /** Indicates the projection of the portfolio */
  projection: Maybe<PortfolioProjection>
  /** Indicates how risky the portfolio is */
  riskLevel: PortfolioRiskLevel
  /** Indicates if the portfolio is standard or sustainable */
  theme: PortfolioTheme
  yearToDateReturn: Maybe<MarketReturn>
}

/** Portfolio Allocation Object */
export type PortfolioAllocation = {
  __typename?: 'PortfolioAllocation'
  /** Percentage of investment allocated to this portfolio */
  allocationPercent: Scalars['Float']
  /** ID of the PortfolioAllocation */
  portfolioId: Scalars['ID']
}

/** Error returned when attempting to remove a self directed portfolio that has already been removed */
export type PortfolioAlreadyRemovedError = {
  __typename?: 'PortfolioAlreadyRemovedError'
  /** Date and Time of removal if portfolio is already removed */
  portfolioRemovedAt: Scalars['DateTime']
}

export enum PortfolioCustomizationLevel {
  /** Additional pre-approved Security's may be added to the Portfolio at pre-set allocations. */
  Addon = 'ADDON',
  /** Portfolio holdings and allocation percentages are fully configurable. */
  FullyConfigured = 'FULLY_CONFIGURED',
  /** Portfolio holdings and allocation percentages are pre-set. */
  None = 'NONE',
}

/** Portfolio Holding */
export type PortfolioHolding = {
  __typename?: 'PortfolioHolding'
  /** The dollar amount of shares a user has */
  amount: Scalars['Float']
  id: Scalars['ID']
  /** The Acorns-assigned name of the ETF */
  name: Scalars['String']
  /** The actual percentage of a user's portfolio the ETF accounts for */
  percentage: Scalars['Float']
  /** The quanity of shares a user has */
  shares: Scalars['Float']
  /** The ETF's trading symbol */
  symbol: Scalars['String']
}

/** Self Directed Portfolio Not Found */
export type PortfolioNotFoundException = {
  __typename?: 'PortfolioNotFoundException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Portfolio Not Supported */
export type PortfolioNotSupportedException = {
  __typename?: 'PortfolioNotSupportedException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Portfolio Projection */
export type PortfolioProjection = {
  __typename?: 'PortfolioProjection'
  /** The projected average growth rate */
  averageGrowthRate: Scalars['Float']
  /** The projected highest growth rate */
  highestGrowthRate: Scalars['Float']
  /** The projected lowest growth rate */
  lowestGrowthRate: Scalars['Float']
}

/** Error returned when attempting to remove a self directed portfolio that is already in the process of being removed */
export type PortfolioRemovalInProgressError = {
  __typename?: 'PortfolioRemovalInProgressError'
  /** Message displayed to customer when a self directed portfolio removal is already in progress */
  clientMessage: Scalars['String']
}

export enum PortfolioRiskLevel {
  Aggressive = 'AGGRESSIVE',
  Conservative = 'CONSERVATIVE',
  Custom = 'CUSTOM',
  Moderate = 'MODERATE',
  ModeratelyAggressive = 'MODERATELY_AGGRESSIVE',
  ModeratelyConservative = 'MODERATELY_CONSERVATIVE',
}

/** Portfolio Security */
export type PortfolioSecurity = {
  __typename?: 'PortfolioSecurity'
  /** The current percentage of the market value over the customer's total balance */
  currentAllocationPercentage: Scalars['Float']
  id: Scalars['ID']
  /** The market value of shares owned by the customer */
  marketValue: MonetaryAmount
  /** The Acorns-assigned name of the security */
  name: Scalars['String']
  /** The quantity of shares a user has */
  shares: Scalars['Float']
  /** The security's trading symbol */
  symbol: Scalars['String']
  /**
   * DEPRECATED: The target percentage of the market value over the customer's total balance
   * @deprecated Will not be populated with self directed investments release.
   */
  targetAllocationPercentage: Maybe<Scalars['Float']>
  /** The customer's returns for today */
  todaysReturn: MarketReturn
  /** The customer's returns for all time for the security */
  totalReturn: MarketReturn
}

/** Security allocation */
export type PortfolioSecurityAllocation = {
  __typename?: 'PortfolioSecurityAllocation'
  allocationPercent: Scalars['Float']
  /** @deprecated Use Security.displayName instead */
  displayName: Scalars['String']
  id: Scalars['ID']
  /** Indicates the investment category for the security */
  investmentCategories: InvestmentCategory
  /** @deprecated Use Security.shortName instead */
  name: Scalars['String']
  /** Indicates whether the Security can be removed from an Investment Account's base Portfolio. */
  removableFromBasePortfolio: Scalars['Boolean']
  security: Maybe<Security>
  symbol: Scalars['String']
}

/** Portfolio Security Limit Reached */
export type PortfolioSecurityLimitReached = {
  __typename?: 'PortfolioSecurityLimitReached'
  /** Maximum amount of security allowed */
  limit: Scalars['Int']
}

export enum PortfolioTheme {
  SelfDirected = 'SELF_DIRECTED',
  Standard = 'STANDARD',
  Sustainable = 'SUSTAINABLE',
}

/** Failed to update portfolio on investment account */
export type PortfolioUpdateFailedException = {
  __typename?: 'PortfolioUpdateFailedException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type PositiveCurrencyAmountInput = {
  currency: Currency
  value: Scalars['PositiveFloat']
}

export enum PostProcessStatusEnum {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS',
}

export type PostProcessStep = {
  __typename?: 'PostProcessStep'
  processKey: Scalars['String']
  rawdata: Maybe<Scalars['JSON']>
  status: PostProcessStatusEnum
  updatedAt: Maybe<Scalars['DateTime']>
}

export type PostProcessStepInput = {
  processKey: Scalars['String']
  rawdata?: InputMaybe<Scalars['JSON']>
  status?: InputMaybe<PostProcessStatusEnum>
  updatedAt?: InputMaybe<Scalars['DateTime']>
}

export type PostUploadProcessing = {
  __typename?: 'PostUploadProcessing'
  steps: Array<PostProcessStep>
}

export type PostUploadProcessingInput = {
  steps: Array<PostProcessStepInput>
}

/** the selected funding source is not eligible to be preferred. It's either inactive or unlinked */
export type PreferredAccountNotEligibleError = {
  __typename?: 'PreferredAccountNotEligibleError'
  /** requested funding source is not eligible */
  fundingSourceUuid: Maybe<Scalars['ID']>
}

/** The user has only one active FS. Must have two to set preferred withdrawal account */
export type PreferredAccountNotSupportedError = {
  __typename?: 'PreferredAccountNotSupportedError'
  /** doesn't support setting preferred account for the user. */
  userUuid: Maybe<Scalars['ID']>
}

/** prefillAcornsEarlyData result */
export type PrefillAcornsEarlyDataResult =
  | InvalidAcornsEarlyDataException
  | User

/** Presentation-driven entity for an associated Product */
export type PresentableProduct = {
  __typename?: 'PresentableProduct'
  /**
   * Keys to strings to display description of associated product
   * @deprecated Use `descriptionKeysV2` instead
   */
  descriptionKeys: Array<Scalars['StringKey']>
  /** Keys to strings to display description of associated product */
  descriptionKeysV2: Maybe<Array<PresentableProductDescription>>
  /** Associated product */
  product: Product
}

export type PresentableProductDescription = {
  __typename?: 'PresentableProductDescription'
  subtitle: Maybe<Scalars['StringKey']>
  title: Scalars['StringKey']
}

export enum PresentableWithdrawalStatus {
  Canceled = 'canceled',
  Complete = 'complete',
  Failed = 'failed',
  Pending = 'pending',
  Refunded = 'refunded',
  SellingInvestments = 'sellingInvestments',
  Transferring = 'transferring',
}

/** Existing funding source in pending state */
export type PreviousFundingSourcePending = {
  __typename?: 'PreviousFundingSourcePending'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

/** Canonical representation of an Acorns product that can be used and billed for. */
export type Product = {
  __typename?: 'Product'
  /** Indicates whether or not the Product is available to new Users. */
  active: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  description: Scalars['String']
  descriptionKeys: Maybe<Array<Scalars['String']>>
  /** Highlighted features of product */
  highlights: Maybe<Array<PresentableProductDescription>>
  id: Scalars['ID']
  key: ProductKey
  name: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export enum ProductAccountType {
  Brokerage = 'BROKERAGE',
  Checking = 'CHECKING',
  Custodial = 'CUSTODIAL',
  Retirement = 'RETIREMENT',
  Savings = 'SAVINGS',
}

/** Ref for product name */
export enum ProductKey {
  BenefitsGohenryStandard = 'BENEFITS_GOHENRY_STANDARD',
  BenefitsInsuranceStandard = 'BENEFITS_INSURANCE_STANDARD',
  BenefitsTaxfilingStandard = 'BENEFITS_TAXFILING_STANDARD',
  BenefitsWillStandard = 'BENEFITS_WILL_STANDARD',
  CheckingApy = 'CHECKING_APY',
  Early = 'EARLY',
  EarlyMatch = 'EARLY_MATCH',
  EarlyPublishing = 'EARLY_PUBLISHING',
  EarlySelfDirectedInvest = 'EARLY_SELF_DIRECTED_INVEST',
  Earn = 'EARN',
  EarnChoice = 'EARN_CHOICE',
  EarnPrime = 'EARN_PRIME',
  EmergencyFund = 'EMERGENCY_FUND',
  Invest = 'INVEST',
  Later = 'LATER',
  LaterMatch = 'LATER_MATCH',
  Learn = 'LEARN',
  LearnPremium = 'LEARN_PREMIUM',
  MightyOakCard = 'MIGHTY_OAK_CARD',
  MoneyManager = 'MONEY_MANAGER',
  PremiumEducation = 'PREMIUM_EDUCATION',
  SelfDirectedInvest = 'SELF_DIRECTED_INVEST',
  Spend = 'SPEND',
  StandardBenefitsInsurance = 'STANDARD_BENEFITS_INSURANCE',
}

export type ProductNotSupportedException = {
  __typename?: 'ProductNotSupportedException'
  message: Scalars['String']
}

export enum ProductSetupTipType {
  /** Banking - setup digital wallet */
  BankingDigitalWallet = 'banking_digital_wallet',
  /** Banking - setup direct deposit */
  BankingMightyOakCardDirectDeposit = 'banking_mighty_oak_card_direct_deposit',
  /** home - try benefits hub */
  BenefitsHub = 'benefits_hub',
  /** checking engagement wizard - activate card */
  CheckingEngagementWizardActivateCard = 'checking_engagement_wizard_activate_card',
  /** checking engagement wizard - add to digital wallet */
  CheckingEngagementWizardDigitalWallet = 'checking_engagement_wizard_digital_wallet',
  /** checking engagement wizard - direct deposit */
  CheckingEngagementWizardDirectDeposit = 'checking_engagement_wizard_direct_deposit',
  /** checking engagement wizard - set up emergency fund */
  CheckingEngagementWizardEmergencyFund = 'checking_engagement_wizard_emergency_fund',
  /** checking engagement wizard - go henry account connected */
  CheckingEngagementWizardGoHenry = 'checking_engagement_wizard_go_henry',
  /** checking engagement wizard - pay bills */
  CheckingEngagementWizardPayBills = 'checking_engagement_wizard_pay_bills',
  /** checking engagement wizard - set auto roundups */
  CheckingEngagementWizardSetAutoRoundups = 'checking_engagement_wizard_set_auto_roundups',
  /** early - setup direct deposit */
  EarlyDirectDeposit = 'early_direct_deposit',
  /** early - setup recurring transfers */
  EarlyRecurringTransfer = 'early_recurring_transfer',
  /** early - try sustainable portfolio */
  EarlyTrySustainablePortfolio = 'early_try_sustainable_portfolio',
  /** home - earn android extension */
  EarnAndroidExtension = 'earn_android_extension',
  /** home - earn safari extension */
  EarnSafariExtension = 'earn_safari_extension',
  /**
   * home - harvest bank fees
   * @deprecated deprecated - bank fee negotiations feature removed
   */
  HarvestBankFees = 'harvest_bank_fees',
  /** home - link primary checking */
  HomeLinkPrimaryChecking = 'home_link_primary_checking',
  /** home - link roundup cards */
  HomeLinkRoundupCards = 'home_link_roundup_cards',
  /** home - set auto roundups */
  HomeSetAutoRoundups = 'home_set_auto_roundups',
  /** home - try self-directed portfolio */
  HomeTrySelfDirectedPortfolio = 'home_try_self_directed_portfolio',
  /** home - try sustainable portfolio */
  HomeTrySustainablePortfolio = 'home_try_sustainable_portfolio',
  /** invest - add bitcoin to diversified portfolio */
  InvestAddBitcoin = 'invest_add_bitcoin',
  /** invest hub - link primary checking */
  InvestHubLinkPrimaryChecking = 'invest_hub_link_primary_checking',
  /** invest hub - link roundup cards */
  InvestHubLinkRoundupCards = 'invest_hub_link_roundup_cards',
  /** invest hub - set auto roundups */
  InvestHubSetAutoRoundups = 'invest_hub_set_auto_roundups',
  /** invest hub - try self-directed portfolio */
  InvestHubTrySelfDirectedPortfolio = 'invest_hub_try_self_directed_portfolio',
  /** invest - link primary checking */
  InvestLinkPrimaryChecking = 'invest_link_primary_checking',
  /** invest - link roundup cards */
  InvestLinkRoundupCards = 'invest_link_roundup_cards',
  /** invest - make first investment */
  InvestMakeFirstInvestment = 'invest_make_first_investment',
  /** invest - schedule regular deposits */
  InvestScheduleRegularDeposits = 'invest_schedule_regular_deposits',
  /** invest - set auto roundups */
  InvestSetAutoRoundups = 'invest_set_auto_roundups',
  /** invest - try self-directed portfolio */
  InvestTrySelfDirectedPortfolio = 'invest_try_self_directed_portfolio',
  /** invest - try sustainable portfolio */
  InvestTrySustainablePortfolio = 'invest_try_sustainable_portfolio',
  /** later - link primary checking */
  LaterLinkPrimaryChecking = 'later_link_primary_checking',
  /** later - make first investment */
  LaterMakeFirstInvestment = 'later_make_first_investment',
  /** later schedule regular deposits */
  LaterScheduleRegularDeposits = 'later_schedule_regular_deposits',
  /** later - set a beneficiary */
  LaterSetABeneficiary = 'later_set_a_beneficiary',
  /** later - try sustainable portfolio */
  LaterTrySustainablePortfolio = 'later_try_sustainable_portfolio',
  /**
   * all contexts - nps survey
   * @deprecated deprecated tip no longer used on clients
   */
  NpsSurvey = 'nps_survey',
  /** home - path to million promotion */
  PathToMillion = 'path_to_million',
  /** all contexts - referral promotion */
  ReferralPromotion = 'referral_promotion',
  /** spend - setup direct deposit */
  SpendDirectDeposit = 'spend_direct_deposit',
  /** spend - incentive to setup direct deposit */
  SpendDirectDepositIncentive = 'spend_direct_deposit_incentive',
  /** spend - setup recurring deposit */
  SpendRecurringDeposit = 'spend_recurring_deposit',
  /** spend - set spend as primary */
  SpendSetAsPrimary = 'spend_set_as_primary',
  /** spend - setup smart deposit */
  SpendSmartDeposit = 'spend_smart_deposit',
  /** spend - smart deposit sweepstakes */
  SpendSmartDepositSweepstakes = 'spend_smart_deposit_sweepstakes',
  /** home - wildfire chrome extension */
  WildfireChromeExtension = 'wildfire_chrome_extension',
}

export enum ProductTagEnum {
  AcornsEarly = 'ACORNS_EARLY',
  Checking = 'CHECKING',
  EarlyInvest = 'EARLY_INVEST',
  Earn = 'EARN',
  EmergencySavings = 'EMERGENCY_SAVINGS',
  General = 'GENERAL',
  Invest = 'INVEST',
  Later = 'LATER',
  MoneyManager = 'MONEY_MANAGER',
  Referrals = 'REFERRALS',
  RoundUps = 'ROUND_UPS',
}

export enum ProductType {
  Core = 'core',
  Early = 'early',
  Later = 'later',
  Save = 'save',
  Spend = 'spend',
}

/** Miscellaneous attributes and information about a user */
export type Profile = TimestampsInterface & {
  __typename?: 'Profile'
  /** Annual income */
  annualIncome: Maybe<Scalars['Int']>
  /** Estimated range of annual income */
  annualIncomeEstimate: Maybe<Scalars['String']>
  /** Combined annual income */
  combinedAnnualIncome: Maybe<Scalars['Int']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Debt */
  debt: Maybe<Scalars['Boolean']>
  /** Employees */
  employees: Maybe<Employees>
  /** Employment status */
  employmentStatus: Maybe<EmploymentStatus>
  /** Filing type */
  filingType: Maybe<FilingType>
  /** Financial education */
  financialEducation: Maybe<FinancialEducation>
  /** First name */
  firstName: Maybe<Scalars['String']>
  /** Funds availability */
  fundsAvailability: Maybe<FundsAvailability>
  /** High-interest debt */
  highInterestDebt: Maybe<Scalars['Boolean']>
  /** Investment goal */
  investmentGoal: Maybe<InvestmentGoal>
  /** Last name */
  lastName: Maybe<Scalars['String']>
  /** Marital status */
  maritalStatus: Maybe<MaritalStatus>
  /** Monthly expenses */
  monthlyExpenses: Maybe<Scalars['Float']>
  /** Net worth */
  netWorth: Maybe<Scalars['Float']>
  /** Estimated range of net worth */
  netWorthEstimate: Maybe<Scalars['String']>
  /** has user opted out of targeting */
  optedOutOfTargeting: Scalars['Boolean']
  /** Retirement plan access */
  retirementPlanAccess: Maybe<RetirementPlanAccess>
  /** Self employed income */
  selfEmployedIncome: Maybe<Scalars['Int']>
  /** Signature type */
  signatures: Array<Maybe<Signature>>
  /** Last four of SSN */
  ssnLastFour: Maybe<Scalars['String']>
  /** User has paused their transfers */
  transfersPaused: Maybe<Scalars['Boolean']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Internal ID for user */
  userId: Scalars['ID']
}

export type ProfileAttribute = {
  key: Scalars['String']
  value: Scalars['JSON']
}

/** Changeable attributes for user profiles */
export type ProfileInput = {
  /** Non-self employed income */
  annualIncome?: InputMaybe<Scalars['Int']>
  /** Estimated non-self employed income */
  annualIncomeEstimate?: InputMaybe<Scalars['String']>
  /** Total annual income */
  combinedAnnualIncome?: InputMaybe<Scalars['Int']>
  /** Debt */
  debt?: InputMaybe<Scalars['Boolean']>
  /** Number of employees the user has (if self employed) */
  employees?: InputMaybe<Employees>
  /** Status of user's employment */
  employmentStatus?: InputMaybe<EmploymentStatus>
  /** How the user files their taxes */
  filingType?: InputMaybe<FilingType>
  /** User's level of financial education */
  financialEducation?: InputMaybe<FinancialEducation>
  /** Funds availability */
  fundsAvailability?: InputMaybe<FundsAvailability>
  /** High-interest debt */
  highInterestDebt?: InputMaybe<Scalars['Boolean']>
  /** User's investment goal */
  investmentGoal?: InputMaybe<InvestmentGoal>
  /** Marital status */
  maritalStatus?: InputMaybe<MaritalStatus>
  /** Monthly expenses */
  monthlyExpenses?: InputMaybe<Scalars['Float']>
  /** Net worth */
  netWorth?: InputMaybe<Scalars['Float']>
  /** Estimated net worth */
  netWorthEstimate?: InputMaybe<Scalars['String']>
  /** How the user wants to access their retirement plan */
  retirementPlanAccess?: InputMaybe<RetirementPlanAccess>
  /** Self employed income */
  selfEmployedIncome?: InputMaybe<Scalars['Int']>
  /** Pause transfers */
  transfersPaused?: InputMaybe<Scalars['Boolean']>
}

export enum ProgramAccountType {
  Plan = 'PLAN',
}

export type PromoCode = {
  __typename?: 'PromoCode'
  businessLine: PromoCodeBusinessLine
  channel: Scalars['String']
  condensedTitle: Scalars['String']
  description: Scalars['String']
  id: Scalars['ID']
  internalMemo: Maybe<Scalars['String']>
  name: Scalars['String']
  publishEnd: Maybe<Scalars['DateTime']>
  publishStart: Scalars['DateTime']
  qualificationAction: PromoCodeQualificationAction
  /** @deprecated Use qualificationAmountMicros. */
  qualificationAmount: Scalars['Int']
  /** Same threshold as `qualificationAmount`, in USD micros (redundant field for MicrosMoney clients). */
  qualificationAmountMicros: MicrosMoney
  rewards: Array<PromoCodeReward>
  status: PromoCodeStatus
  termsUrl: Maybe<Scalars['URL']>
  title: Scalars['String']
}

export enum PromoCodeBusinessLine {
  Affiliate = 'AFFILIATE',
  Brand = 'BRAND',
  Organic = 'ORGANIC',
  PaidMedia = 'PAID_MEDIA',
}

export type PromoCodeCustomer = {
  __typename?: 'PromoCodeCustomer'
  promoCode: PromoCode
  userId: Scalars['ID']
}

export type PromoCodeEdge = {
  __typename?: 'PromoCodeEdge'
  cursor: Scalars['String']
  node: PromoCode
}

export type PromoCodeFieldLengthError = {
  __typename?: 'PromoCodeFieldLengthError'
  field: Scalars['String']
  max: Scalars['Int']
}

export type PromoCodePaginatedFilter = {
  /** Cursor to start pagination results for (exclusive) */
  after?: InputMaybe<Scalars['String']>
  /** Number of nodes to return */
  limit?: InputMaybe<Scalars['Int']>
}

export type PromoCodePaginatedInfo = {
  __typename?: 'PromoCodePaginatedInfo'
  /** Cursor corresponding to the last node in the list of edges */
  endCursor: Maybe<Scalars['String']>
  /** Indicates whether more edges exist following the set defined by the filter */
  hasNextPage: Scalars['Boolean']
  /** Indicates whether more edges exist prior to the set defined by the filter */
  hasPreviousPage: Scalars['Boolean']
  /** Cursor corresponding to the first node in the list of edges */
  startCursor: Maybe<Scalars['String']>
}

export enum PromoCodeQualificationAction {
  InitialInvestment = 'INITIAL_INVESTMENT',
  InitialRecurringInvestment = 'INITIAL_RECURRING_INVESTMENT',
  InitialRoundup = 'INITIAL_ROUNDUP',
  InitialSubscriptionPayment = 'INITIAL_SUBSCRIPTION_PAYMENT',
}

export type PromoCodeReward = {
  __typename?: 'PromoCodeReward'
  /** @deprecated Use amountMicros. */
  amount: Scalars['Float']
  amountMicros: MicrosMoney
  id: Scalars['ID']
  type: PromoCodeRewardType
}

export type PromoCodeRewardEdge = {
  __typename?: 'PromoCodeRewardEdge'
  cursor: Scalars['String']
  node: PromoCodeReward
}

export enum PromoCodeRewardType {
  Investment = 'INVESTMENT',
  Other = 'OTHER',
}

export type PromoCodeRewardsConnection = {
  __typename?: 'PromoCodeRewardsConnection'
  edges: Maybe<Array<PromoCodeRewardEdge>>
  pageInfo: PromoCodePaginatedInfo
}

export enum PromoCodeStatus {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED',
}

export type PromoCodesConnection = {
  __typename?: 'PromoCodesConnection'
  edges: Maybe<Array<PromoCodeEdge>>
  pageInfo: PromoCodePaginatedInfo
}

/** Display wrapper for featured promo offer */
export type PromoOffer = {
  __typename?: 'PromoOffer'
  /** Background/featured image */
  backgroundImage: Image
  /** Display body for the offer */
  body: Maybe<Scalars['String']>
  /** Desktop Background/featured image */
  desktopBackgroundImage: Image
  id: Scalars['ID']
  /** Company/partner logo */
  logo: Maybe<Image>
  /** Partner url */
  partnerUrl: Scalars['URL']
  /** Display subtitle for the offer */
  subtitle: Maybe<Scalars['String']>
  /** Display title for the offer */
  title: Scalars['String']
}

export type PromotedBenefit = {
  __typename?: 'PromotedBenefit'
  product: BenefitsTrackerProducts
  promotedThrough: Array<BenefitPromotedThrough>
}

export type PromotedCampaigns = {
  __typename?: 'PromotedCampaigns'
  campaignIds: Array<Maybe<Scalars['ID']>>
}

/** Time-bound pricing and/or additional incentives offered to subscibers of a particular offering (tier or product). */
export type Promotion = {
  __typename?: 'Promotion'
  /** Wether or not the promotion is available for new applications. */
  active: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  description: Scalars['String']
  /** How long the promotion lasts once applied to a subscription. */
  duration: Maybe<PromotionDuration>
  /** When the promotion is set to expire and become inactive. */
  expiresAt: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  /** Additional incentives the promotion entitles subscribers to. */
  incentives: Maybe<Array<Incentive>>
  name: Scalars['String']
  /** Services that the promotion is for. */
  offering: Offering
  /** Metadata indicating in what contexts a client should present the promotion. */
  presentInContexts: Array<Scalars['String']>
  /** Link to legal terms and conditions of the promotion. */
  termsUrl: Scalars['URL']
  updatedAt: Maybe<Scalars['DateTime']>
}

export type PromotionConsumedError = {
  __typename?: 'PromotionConsumedError'
  message: Scalars['String']
}

export type PromotionDuration = {
  __typename?: 'PromotionDuration'
  period: PromotionDurationPeriod
  periodCount: Scalars['Int']
}

export enum PromotionDurationPeriod {
  Month = 'MONTH',
}

export type PromotionExpiredError = {
  __typename?: 'PromotionExpiredError'
  expiredAt: Scalars['DateTime']
  message: Scalars['String']
}

export type PromotionFilterInput = {
  presentInContexts?: InputMaybe<PromotionPresentInContextsFilterInput>
}

export type PromotionNotFoundError = {
  __typename?: 'PromotionNotFoundError'
  message: Scalars['String']
}

export type PromotionPresentInContextsFilterInput = {
  in?: InputMaybe<Array<Scalars['String']>>
}

/** promotional waiver */
export type PromotionalWaiver = {
  __typename?: 'PromotionalWaiver'
  promotion: Maybe<WaiverPromotion>
  promotionalWaiverPeriodEndDate: Scalars['String']
  userId: Scalars['ID']
}

export type PromotionalWaiver_V2 = {
  __typename?: 'PromotionalWaiver_V2'
  promotion: WaiverPromotion_V2
  promotionalWaiverPeriodEndDate: Scalars['String']
  userId: Scalars['ID']
}

export type Prospect = {
  email: Scalars['String']
  id: Scalars['ID']
}

export enum ProspectType {
  Grow = 'GROW',
  LaterWaitlist = 'LATER_WAITLIST',
  OutsideContribution = 'OUTSIDE_CONTRIBUTION',
}

/** Third-party data provider */
export enum Provider {
  /** Acorns Early as a third-party data provider */
  AcornsEarly = 'ACORNS_EARLY',
  /** Google as a third-party data provider */
  Google = 'GOOGLE',
}

/** provisional fee waiver */
export type ProvisionalWaiver = {
  __typename?: 'ProvisionalWaiver'
  userId: Scalars['ID']
  waiverPeriodEndDate: Scalars['String']
  waiverReason: Maybe<Scalars['String']>
}

export type ProvisionalWaiver_V2 = {
  __typename?: 'ProvisionalWaiver_V2'
  userId: Scalars['ID']
  waiverPeriodEndDate: Scalars['String']
  waiverReason: Scalars['String']
}

/** Statuses after a campaign is published */
export enum PublishedCampaignStatus {
  /** Campaign is paid out */
  Complete = 'COMPLETE',
  /** Campaign is live, new relationships can be added */
  Live = 'LIVE',
  /** Campaign can still be paid out, new payouts cannot be added */
  PayoutBuffer = 'PAYOUT_BUFFER',
  /** Campaign is over, new relationships cannot be added, new payouts can be added */
  Pending = 'PENDING',
  /** Campaign is scheduled for future */
  Scheduled = 'SCHEDULED',
}

export type PushAuthChallenge = AuthChallenge & {
  __typename?: 'PushAuthChallenge'
  alternateAuthenticators: Array<AuthenticatorInfo>
  challengeTrigger: ChallengeTriggers
  completedAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  deviceId: Scalars['ID']
  id: Scalars['ID']
  pushState: ChallengePushState
  sessionId: Maybe<Scalars['ID']>
  updatedAt: Scalars['DateTime']
}

export type PushAuthenticator = Authenticator & {
  __typename?: 'PushAuthenticator'
  createdAt: Scalars['DateTime']
  deviceId: Scalars['ID']
  deviceType: DeviceType
  id: Scalars['ID']
  lastAuthenticatedAt: Maybe<Scalars['DateTime']>
  lastUsedAt: Maybe<Scalars['DateTime']>
  name: Scalars['String']
  type: AuthType
  updatedAt: Scalars['DateTime']
}

export type PushAuthenticatorAlreadyExistsException = {
  __typename?: 'PushAuthenticatorAlreadyExistsException'
  authenticatorId: Scalars['ID']
  message: Maybe<Scalars['String']>
}

export type QualificationSubTypeMismatchError = {
  __typename?: 'QualificationSubTypeMismatchError'
  message: Scalars['String']
}

/** Root query type */
export type Query = {
  __typename?: 'Query'
  /** Fetch mighty oak card waiver for user. */
  MightyOakCardWaiver: MightyOakWaiverResult
  _hello: Maybe<Scalars['String']>
  _placeholder: Maybe<Scalars['String']>
  /** Get an acceptance document by type */
  acceptanceDocument: Maybe<AcceptanceDocument>
  /** Get a list of documents the user needs to accept */
  acceptanceDocuments: Maybe<Array<Maybe<AcceptanceDocument>>>
  accountPointsRuleByMilestoneId: Maybe<AccountPointsRule>
  accountPointsRules: Maybe<Array<AccountPointsRule>>
  accountStrength: Maybe<AccountStrengthResult>
  /** Fetch a list of accounts for a user */
  accounts: Array<Maybe<Account>>
  /** query action feed cards */
  actionFeed: Maybe<Array<Maybe<ActionCard>>>
  /** Query for the list of eligible Action Screen widgets for the current user */
  actionScreen: Array<ActionScreenComponent>
  /** @implicit(userId: String) */
  activeEarnOffers: EarnOfferQueryPage
  /** @deprecated Use the past queries instead. */
  activity: Maybe<Array<Maybe<Activity>>>
  /** query account summary information */
  activitySummary: Maybe<ActivitySummaryResponse>
  /** Used to determine if an address is deliverable or offer corrections to make it deliverable. */
  addressDeliverability: Maybe<AddressDeliverabilityResult>
  /** Fetch a list of addresses for a user */
  addresses: Array<Maybe<Address>>
  /** @implicit(userId: ID!) */
  advocate: Maybe<Advocate>
  /** Fetch all beneficiary alerts for a user */
  alertHubBeneficiaryAlerts: Maybe<Array<AlertHubBeneficiaryAlert>>
  /** Get all acceptance documents */
  allAcceptanceDocuments: Maybe<Array<Maybe<AcceptanceDocument>>>
  /** Pulls all accounts for a customer. */
  allAccounts: Array<CustomerAccount>
  allBankAccounts: Maybe<Array<Maybe<BankAccount>>>
  allBankCards: Maybe<Array<Maybe<BankCard>>>
  allBankDocuments: Maybe<Array<Maybe<BankDocument>>>
  allBankStatements: Maybe<Array<Maybe<BankStatement>>>
  allBankTransactions: Maybe<BankTransactionConnection>
  /** Get the Card Delivery Status */
  allCardTrackingStatuses: Maybe<Array<CardDeliveryStatus>>
  /** Fetch pages of messages for the user starting from the most recent message */
  allChatHistoryMessages: AllChatHistoryMessages
  /** Fetch pages of sessions for the user starting from the most recent session */
  allChatSessions: AllChatSessions
  allCheckPayments: Maybe<AllCheckPaymentsResult>
  allCloseAccountReasons: Maybe<Array<Maybe<CloseAccountReason>>>
  /** Returns list of categories and nested subcategories for dynamic values in contact form */
  allContactCategories: Maybe<Array<ContactCategory>>
  /** @deprecated Use Query.investmentAccountsByUserId instead. */
  allInvestmentAccounts: Maybe<Array<InvestmentAccount>>
  /** Fetches all messages for a user. Leverages Hedwig's DB for notifications/alerts and queries external services for alerts. Make sure a `x-client-platform` header is passed in as a string that is a comma-separated list of valid platforms. Will return messages that support any of the passed platforms */
  allMessages: Maybe<Array<Message>>
  /** Fetch all Core items for the Past screen. */
  allPastCoreItemChildren: Maybe<Array<PastItem>>
  /**
   * Fetch all Core items for the Past screen. Defaults to only return non-pending transactions
   * @deprecated Use allPastItems
   */
  allPastCoreItems: Maybe<PastItemConnection>
  /**
   * Fetch all Early items for the Past screen. Defaults to only return non-pending transactions
   * @deprecated Use allPastItems
   */
  allPastEarlyItems: Maybe<PastItemConnection>
  /** @implicit(userId: ID!) */
  allPastItems: Maybe<PastItemConnection>
  /**
   * Fetch all Later items for the Past screen. Defaults to only return non-pending transactions
   * @deprecated Use allPastItems
   */
  allPastLaterItems: Maybe<PastItemConnection>
  /** Fetch all pending items across all product types. */
  allPastPendingItems: Maybe<Array<PastItem>>
  /**
   * Fetch all of a users scheduled transactions from their product accounts
   * @deprecated Use allPastScheduledItemsV2
   */
  allPastScheduledItems: Maybe<Array<PastScheduledItem>>
  /** Fetch all of a users scheduled transactions from their product accounts */
  allPastScheduledItemsV2: Maybe<Array<PastScheduledItemV2>>
  /**
   * @implicit(userId: ID!)
   * @deprecated Use allPastItems
   */
  allPastSpendItems: Maybe<PastItemConnection>
  allReturnedCheckDeposits: Maybe<Array<ReturnedCheckDeposit>>
  allSuitabilityQuestions: Maybe<Array<Maybe<SuitabilityQuestion>>>
  /** Returns all support articles */
  allSupportArticles: Maybe<Array<Maybe<SupportArticle>>>
  /** Returns all the current categories within the Help Center */
  allSupportCategories: Maybe<Array<Maybe<SupportCategory>>>
  /** Returns all support sections */
  allSupportSections: Maybe<Array<Maybe<SupportSection>>>
  /** Returns all support ticket forms */
  allSupportTicketForms: Maybe<Array<Maybe<SupportTicketForm>>>
  allTransferableFrom: Maybe<Array<TransferableFrom>>
  allTransferableTo: Maybe<Array<TransferableTo>>
  /** Fetch all trusted contacts for a user by user uuid */
  allTrustedContactsByUserId: Array<Maybe<TrustedContact>>
  /** @implicit(userId: ID!) */
  authAlerts: Maybe<Array<AuthAlert>>
  /** @implicit(userId: ID!) */
  authProfile: Maybe<AuthProfile>
  authenticateForFeeNegotiationStatusByLinkedAccountId: Maybe<AuthenticateForFeeNegotiationStatus>
  bankAccountClosureReasons: Array<BankAccountClosureReason>
  bankAccountDisclosures: Maybe<Array<Maybe<BankAccountDisclosure>>>
  /** Returns the bank account state for a given account type. */
  bankAccountState: Maybe<BankAccountStateResult>
  bankCardOrder: Maybe<BankCardOrder>
  /** Returns a temporary encrypted token for a digitally active bank card's display details */
  bankCardPanDisplay: BankCardPanDisplayResult
  /** Returns an encrypted token for virtual bank card provisioning */
  bankCardProvisioningDetails: BankCardProvisioningDetailsResult
  bankCardReissue: Maybe<BankCardReissue>
  /** @implicit(userId: String!) */
  bankFeeNegotiationsByUserId: FeeNegotiationSummary
  /**
   * @implicit(userId: ID!)
   * @deprecated Use query.bankFeesByUserId instead
   */
  bankFeeSummaryByUserId: Maybe<BankFeeSummary>
  /** @implicit(userId: ID!) */
  bankFeesByUserId: Maybe<Array<BankFee>>
  /** Returns interest rates for banking products. Omit filter to return data for all products. */
  bankInterestRates: BankInterestRatesResult
  /** @deprecated Incorrect and no longer in use, we are removing this method in the future */
  bankMetadata: Maybe<BankMetadata>
  bankTransaction: Maybe<BankTransaction>
  bankingEmploymentStatuses: Array<Scalars['String']>
  /** Returns banking feature eligibility and action required to satisfy the eligibility requirement */
  bankingFeatureEligibility: Maybe<BankingFeatureEligibility>
  /**
   * Returns the KYC status and verification details for the user, if it exists.
   * This is used to determine if the user has completed Banking KYC and if any action is required.
   */
  bankingKycDetails: Maybe<BankingKyc>
  /** Returns Acorns banners information data */
  banners: Maybe<Array<Maybe<BannersResponse>>>
  /** Fetch all beneficiaries for a user */
  beneficiaries: Maybe<Array<Beneficiary>>
  /** Fetch a beneficiary with a given ID */
  beneficiary: Maybe<Beneficiary>
  /** Fetch all beneficiary alerts for a user */
  beneficiaryAlerts: Maybe<Array<Alert>>
  /** @implicit(userId: String!) */
  benefitPartnerByUserId: BenefitPartnerResponse
  /** Fetch billing cycles given an ID */
  billingCycle: Maybe<BillingCycle>
  /** Fetch billing cycles given a user ID */
  billingCycles: Maybe<Array<BillingCycle>>
  /** Fetch the data used in determining how a user is billed */
  billingProfile: Maybe<BillingProfile>
  /**
   * Renders the requested blueprint for the authenticated user. Returns a typed
   * union so data-fetch failures and unsupported schema versions surface as
   * first-class variants rather than being swallowed into a success response.
   */
  blueprint: Maybe<BlueprintResult>
  /**
   * Returns the named Blueprint DSL JSON Schema, so a client whose committed
   * schema file is older than the newest can still ask for the version that file
   * holds. Requires a valid API key.
   */
  blueprintSchemaAtVersion: Maybe<BlueprintSchemaResult>
  /** @implicit(userId: ID!) */
  calculateMoneySplits: Maybe<MoneyRulesSuggestionResult>
  /** @implicit(userId: ID!) */
  campaignHistory: Maybe<CampaignHistoryConnection>
  /** @implicit(userId: ID!) */
  challenges: Maybe<Array<AuthChallenge>>
  /** Fetch messages for the user in the session starting from the most recent message */
  chatHistoryMessagesBySessionId: AllChatHistoryMessages
  /** Investment account closure reasons */
  closureReasonsByInvestmentAccountType: Array<InvestmentAccountClosureReason>
  /** @implicit(userId: ID!) */
  cohortEligibility: Array<CohortEligibility>
  /** @implicit(userId: ID!) */
  cohortEligibility_v2: Maybe<Array<CohortEligibility_V2>>
  /** Fetch the combined performance of user's investment accounts */
  combinedPerformanceByUserId: CombinedPerformance
  /** Returns info for completed quiz such as user score, average score, number of total and correct questions */
  completedQuizByQuizId: Maybe<CompletedQuiz>
  /** @implicit(userId: String!) */
  connectionsByUserId: ConnectionSummary
  /** Returns contact form alert message if it has been set in Zesty */
  contactFormAlert: Maybe<ContactFormAlert>
  /** Fetch the payer-facing contribution page for an active tip link */
  contributionPage: Maybe<ContributionPageResult>
  /** Fetch the authenticated recipient's sticker requests for a tip link */
  contributionStickerRequests: Array<ContributionStickerRequest>
  /**
   * Returns a course or null if it does not exist
   * @deprecated This endpoint is being removed and being replaced by course_v2 in order to support locked content
   */
  course: Maybe<Course>
  /** Returns a learn course or null if it does not exist */
  course_v2: Maybe<LearnCourse>
  /**
   * Returns a list of courses for given tier
   * @deprecated This endpoint is being removed as tiers are being replaced by product keys
   */
  coursesByTierId: Maybe<Array<CoursePreview>>
  /** Returns a list of courses for given topic */
  coursesByTopicId: Maybe<Array<CoursePreview>>
  /** Returns a list of courses for given topic */
  coursesByTopicId_v2: Maybe<Array<LearnCoursePreview>>
  /** Returns a personalized list of courses */
  coursesPersonalizedByUserId: Maybe<Array<CoursePreview>>
  /** Get the currently offered crypto ETF that can be added to a managed Portfolio. */
  cryptoEtf: Maybe<Etf>
  /** Fetch a user's customer account closure record */
  customerAccountClosureRequest: Maybe<CustomerAccountClosure>
  /** @implicit(userId: ID!) */
  customerMoneyRules: Maybe<CustomerMoneyRulesResult>
  /** @implicit(userId: ID!) */
  designatedBeneficiariesByUserId: Array<DesignatedBeneficiary>
  /** @implicit(userId: ID!) */
  designatedBeneficiary: Maybe<DesignatedBeneficiary>
  /** @implicit(userId: ID!) */
  designationsByUserId: Array<AccountDesignations>
  /** @implicit(userId: ID!) */
  device: Maybe<Device>
  /** @implicit(userId: ID!) */
  devicesByUserId: Maybe<Array<Device>>
  /** Return the user's direct deposit status */
  directDepositInfo: DirectDepositInfoPayload
  /** Return the user switches' state */
  directDepositState: DirectDepositStatePayload
  /** Returns portfolio diversification information for a provided customer */
  diversificationInfoByInvestmentAccountId: Maybe<DiversificationInfo>
  documentRequest: Maybe<DocumentRequest>
  documentRequests: Maybe<DocumentRequestsConnection>
  /** State and Territory regulations for Early Account for the given Custodian */
  earlyAccountClosureReasons: Array<InvestmentAccountClosureReason>
  /** State and Territory regulations for Early Account for the given Custodian */
  earlyAccountStateRegulation: EarlyAccountStateRegulationResult
  /** DEPRECATED - Use InvestmentAccountTransferability instead */
  earlyAccountTransferInfo: Maybe<EarlyAccountTransferInfo>
  /** Get a list of Earn CTA Data */
  earnCTADataByUserId: Maybe<Array<EarnCtaRecord>>
  /** Retrieve EarnOffer by campaignOfferId with fall back support by campaignId */
  earnOfferByCampaignOfferId: Maybe<EarnOffer>
  /** Get the reward information associated with investment IDs */
  earnRewardsByInvestmentIds: Maybe<Array<EarnReward>>
  /** @deprecated Use feature specific eligibility queries. */
  eligibility: Maybe<Eligibility>
  /** Check for existence of credentials and formatting of input for a given email */
  emailAddressValidation: EmailAddressValidation
  /** Check for existence of credentials and determine the appropriate client flow for a given email */
  emailAddressValidationV2: EmailAddressValidationResult
  estimatedCheckPaymentDates: Maybe<EstimatedCheckPaymentDates>
  /** The estimated clawback match */
  estimatedMatchRemoval: Maybe<MonetaryAmount>
  estimatedTransferDates: Maybe<EstimatedTransferDatesPayload>
  /** Evaluates check deposit session to determine if it is submittable. */
  evaluateCheckDeposit: Maybe<EvaluateCheckDepositPayload>
  /** Fetch the current status for an external contribution attempt */
  externalContributionStatus: Maybe<ExternalContributionStatusResult>
  /** Retrieves list of favorite EarnOffers that the user is currently eligible for */
  favoriteEarnOffers: FavoritePartnerOfferGroup
  /** Returns a personalized list of featured learn content */
  featuredLearnContentPersonalizedByUserId: Maybe<
    Array<FeaturedLearnContentPreview>
  >
  /** @implicit(userId: ID!) */
  featuredMilestones: FeaturedMilestones
  /**
   * @implicit(userId: ID!)
   * @deprecated This will no longer be used to support the account setup user state, replace with featuredMilestones
   */
  featuredMilestones_v2: Maybe<FeaturedMilestonesV2>
  /** Fetch a fee given the ID */
  fee: Maybe<Fee>
  /** Fetch all fees given an argument */
  fees: Maybe<Array<Fee>>
  financialAdvisorQuestions: FinancialAdvisorQuestionsResponse
  financialGoalsRecommendation: FinancialGoalsResult
  /** Fetch a Financial Institution by external ID */
  financialInstitution: Maybe<FinancialInstitution>
  /** Fetch all Financial Institutions */
  financialInstitutions: FinancialInstitutionTypePagination
  /** query finish setup information */
  finishSetup: Maybe<FinishSetup>
  /** Returns acorns footer content */
  footerContent: Maybe<FooterContent>
  /**
   * Get a list of Found Money rewards
   * @deprecated This has been replaced by foundMoneyRewardsV2
   */
  foundMoneyRewards: Maybe<Array<Maybe<FoundMoneyReward>>>
  /** Get a list of Found Money rewards */
  foundMoneyRewardsV2: Maybe<Array<EarnReward>>
  /** Get a summary of all Found Money rewards */
  foundMoneySummary: Maybe<FoundMoneySummary>
  fundSpendInActivation: Maybe<FundSpendInActivationPayload>
  /** Fetches a list of funding source(s) for the user */
  fundingSourceAccounts: Maybe<Array<FundingSourceAccount>>
  /** Get information about a user's primary funding source */
  fundingSourceInfo: Maybe<FundingSourceInfo>
  /** Generate Updated Base 64 Encoded PDF String */
  generateUpdatedPdf: Maybe<GenerateUpdatedPdfPayload>
  /** Returns the upcoming billing date for a customer */
  getBillingDate: Maybe<Scalars['String']>
  /** @implicit(userId: ID!) */
  getBillingHistory: Maybe<Array<BillingInvoice>>
  getPartnerDetails: PartnerDetailsResponse
  /** @implicit(userId: String!) */
  getPartnerDocumentByUserId: PartnerDocumentUrlResponse
  /** @implicit(userId: String!) */
  getPartnerUrl: PartnerUrlResponse
  /** Retrieve user data from third-party providers */
  getThirdPartyUserData: Maybe<GetThirdPartyDataResult>
  /** @deprecated No longer in use */
  getUsersBankFromAccountType: Maybe<GetUsersBankFromAccountTypePayload>
  /** Lookup billing vendor invoice by invoice id */
  getVendorInvoice: Maybe<Invoice>
  /** Returns help form submission content */
  helpFormContent: Maybe<HelpFormContent>
  /**
   * Returns helpcenter banner information data
   * @deprecated Replaced with banners query.
   */
  helpcenterBanner: Maybe<HelpcenterBannerResponse>
  /** Returns instant support articles from search term currently in search field */
  instantSearchSupportArticles: Maybe<Array<Maybe<SearchSupportArticleResult>>>
  /** @implicit(userId: UUID!) */
  intent: Maybe<Intent>
  /** @implicit(userId: UUID!) */
  intents: Array<Intent>
  /** Retrieve an Investment by it's unqiue `id`. */
  investment: Maybe<Investment>
  /** Fetches an investment account for the authorized user */
  investmentAccount: Maybe<InvestmentAccount>
  /** Return an investment account by the beneficiary ID */
  investmentAccountByBeneficiaryId: Maybe<InvestmentAccount>
  /** Get an investment account recap by it's unique id. */
  investmentAccountRecap: Maybe<InvestmentAccountRecap>
  /** Get an investment account recap by it's unique public token. */
  investmentAccountRecapByPublicToken: Maybe<InvestmentAccountRecap>
  /** Fetch user's investment accounts */
  investmentAccountsByUserId: Array<InvestmentAccount>
  /** Returns investments between the provided date range (default is 1 month) for the provided investment account id */
  investmentsByInvestmentAccountId: Maybe<InvestmentPagination>
  /** Fetch user's referral invitation */
  invitationForUser: Maybe<Referral>
  /**
   * @implicit(userId: String!)
   * @deprecated Job Alerts are no longer supported
   */
  jobAlerts: Maybe<Array<JobAlert>>
  jobEducationContent: Maybe<Jobs_Education>
  /** @implicit(userId: String!) */
  jobSearch: Maybe<Array<Jobs_Offer>>
  /** @implicit(userId: String!) */
  jobSearchPage: Maybe<JobSearchPage>
  /** @implicit(userId: String!) */
  jobSearchV2: Maybe<Jobs_OfferConnection>
  /** Fetch later accounts for the provided user */
  laterAccounts: Maybe<Array<Maybe<LaterAccount>>>
  laterBeneficiaries: Maybe<Array<Maybe<LaterIndividualBeneficiary>>>
  /** Fetch the tax years with settled contributions for the provided Later account */
  laterContributionHistory: Maybe<Array<ContributionHistoryItem>>
  laterHistory: Maybe<Array<Maybe<LaterHistoryItem>>>
  /** Contribution ability per open tax year for the authenticated user's most recently opened IRA's limit group. */
  laterUserContributionAbility: Maybe<LaterContributionAbilityResult>
  /** Returns the Article with given id */
  learnArticle: Maybe<LearnArticle>
  /** Returns learn content filtered by the user's profile (matched profile tags). Optional contentTypes - filters ARTICLE, MEDIA_ARTICLE, COURSE. */
  learnContentByProfile: Maybe<Array<LearnContentPreview>>
  /** Returns all results that match given term. Results can be filtered and sorted. */
  learnContentBySearchTerm: Maybe<ContentPreviewConnection>
  /**
   * Returns all results that match given tier. Results can be filtered and sorted.
   * @deprecated This endpoint is being removed as tiers are being replaced by product keys
   */
  learnContentByTierId: Maybe<ContentPreviewConnection>
  /** Returns all results that match given topic. Results can be filtered and sorted. */
  learnContentByTopicId: Maybe<ContentPreviewConnection>
  /** Returns a list of all Learn Hub tiers and topics combined */
  learnContentCategories: Maybe<Array<LearnContentCategory>>
  /** Returns a list of content previews corresponding the given content ids */
  learnContentPreviewsByContentIds: Maybe<Array<LearnContentPreview>>
  /** Returns up to 3 recommendations for search terms of at least 3 chars */
  learnContentRecommendationsBySearchTerm: Maybe<Array<LearnContentPreview>>
  /** Returns recent search terms and popular searches */
  learnContentSearchHistoryByUserId: Maybe<SearchHistory>
  /** Returns a learn media content or null if one does not exist for the ID */
  learnMedia: Maybe<LearnMedia>
  /** Returns a list of course next step actions */
  learnNextStepActionsByCourseId: Maybe<Array<LearnNextStepAction>>
  /** Returns a list of next step actions for the requested media */
  learnNextStepActionsByMediaId: Maybe<Array<LearnNextStepAction>>
  /** Returns a list of question insights related to the incorrect questions */
  learnQuestionInsightsByQuizId: Maybe<Array<LearnQuestionInsight>>
  /** Returns a list of learn content for given action feed context */
  learnWidgetContent: Maybe<Array<LearnContentPreview>>
  /** Fetch a linked account */
  linkedAccount: Maybe<LinkedAccount>
  /** Fetch alerts for linked account */
  linkedAccountAlerts: Maybe<Array<LinkedAccountAlertsResponse>>
  /** Fetch webhook URLs */
  linkedAccountWebhooks: Webhooks
  /** Fetch linked accounts for a given user */
  linkedAccounts: Array<LinkedAccount>
  /** Fetch a linked subaccount */
  linkedSubaccount: Maybe<LinkedSubaccount>
  /** Fetch linked subaccounts for a given user */
  linkedSubaccounts: Array<LinkedSubaccount>
  /** Fetch a liquidation given the ID */
  liquidation: Maybe<Liquidation>
  /** Fetch all liquidations given an argument */
  liquidations: Maybe<Array<Liquidation>>
  /** Get a list of all active waiver coupons from the vendor */
  listActiveWaivers: Array<WaiverCoupon>
  /** @implicit(userId: ID!) */
  listBenefitsByUserId: Maybe<Array<BenefitTileGroup>>
  /** Retrieve all currently active coupon redemptions for a user */
  listUserWaiverCoupons: Maybe<Array<RedeemedWaiverCoupon>>
  /** Get information about the stock market (U.S. only) */
  market: Maybe<Market>
  /** Get a match program by it's id. */
  matchProgram: Maybe<MatchProgram>
  /** Fetches a message based on a user ID and internal message ID. */
  message: Maybe<Message>
  /** Fetches a message based on a user ID and external message ID. */
  messageByExternalId: Maybe<Message>
  /** Retrieves the Hedwig runtime configuration for a message trackingId, which for Braze-sourced messages is the Braze campaign ID. */
  messageConfig: Maybe<MessageConfig>
  /** Lists every stored message configuration row across every trackingId, including trackingIds whose ingestion or display is blocked. */
  messageConfigs: Array<MessageConfig>
  /** Fetches messages for a user. Supports pagination (offset/count) and filtering. Make sure an x-client-platform header is passed in as a string that is a comma-separated list of valid platforms. Will return messages that support any of the passed platforms */
  messages: Maybe<MessageConnection>
  /** @implicit(userId: ID!) */
  milestone: Maybe<Milestone>
  milestoneAccountLevelDefinitions: Maybe<
    Array<MilestoneAccountLevelDefinition>
  >
  milestoneAchievementActionRule: Maybe<MilestoneAchievementActionRule>
  milestoneAchievementActionRules: Array<MilestoneAchievementActionRule>
  milestoneAchievementActionTypes: Array<MilestoneAchievementActionType>
  /**
   * @implicit(userId: ID!)
   * @deprecated This was only relevant for the Path to $1M sweepstakes.
   */
  milestoneChallenge: Maybe<MilestoneChallenge>
  /** @deprecated This was only relevant for the Path to $1M sweepstakes. */
  milestoneChallengePointsRuleByMilestoneIdByChallengeId: Maybe<MilestoneChallengePointsRule>
  /** @deprecated This was only relevant for the Path to $1M sweepstakes. */
  milestoneChallengePointsRulesByMilestoneId: Maybe<
    Array<MilestoneChallengePointsRule>
  >
  milestoneDefinition: Maybe<MilestoneDefinition>
  milestoneDefinitions: Maybe<Array<MilestoneDefinition>>
  /** @implicit(userId: ID!) */
  milestoneEligibilityByScopes: Maybe<Array<MilestoneEligibility>>
  milestoneGroupAchievementActionRule: Maybe<MilestoneGroupAchievementActionRule>
  milestoneGroupAchievementActionRules: Maybe<
    Array<MilestoneGroupAchievementActionRule>
  >
  milestoneGroupDefinition: Maybe<MilestoneGroupDefinition>
  milestoneGroupDefinitions: Maybe<Array<MilestoneGroupDefinition>>
  /** @implicit(userId: ID!) */
  milestoneHub: Maybe<MilestoneHub>
  milestoneHubDefinition: Maybe<MilestoneHubDefinition>
  milestoneHubDefinitions: Array<MilestoneHubDefinition>
  /**
   * @implicit(userId: ID!)
   * @deprecated This query was only relevant for the initial rollout of milestone hub, replace with milestoneEligibilityByScopes
   */
  milestoneHubEligible: Maybe<Eligibility>
  milestoneRules: Maybe<Array<MilestoneRule>>
  /** @implicit(userId: ID!) */
  milestonesByTheme: Maybe<MilestoneThemeGroup>
  /** @implicit(userId: ID!) */
  moneyAssignment: Maybe<MoneyManagerMoneyAssignment>
  /** Get the possible allocation amounts for a given account based off the customers existing rules and any staged rules */
  moneyManagerAllocationOptions: Array<MoneyManagerAllocationOption>
  /** @implicit(userId: ID!) */
  moneyManagerAllocationsByTransferIds: Maybe<Array<MoneyManagerAllocation>>
  /** Retrieves the default money manager automation targets for a user based on their income. */
  moneyManagerAutomationTargetDefaults: Array<MoneyManagerAutomationTarget>
  /** @implicit(userId: ID!) */
  moneyManagerAutomationTargets: Array<MoneyManagerAutomationTarget>
  /** @implicit(userId: ID!) */
  moneyManagerCascadeObjectives: Array<MoneyManagerCascadeObjective>
  /** @implicit(userId: ID!) */
  moneyManagerCategories: Maybe<MoneyManagerCategoriesResult>
  /** @implicit(userId: ID!) */
  moneyManagerDepositHistory: MoneyAssignmentConnection
  /** @implicit(userId: ID!) */
  moneyManagerDepositsThisMonth: Array<MoneyManagerMoneyAssignment>
  /** @implicit(userId: ID!) */
  moneyManagerEligibility: MoneyManagerEligibilityResult
  moneyManagerGlobalConfig: MoneyManagerGlobalConfig
  /** @implicit(userId: ID!) */
  moneyManagerMoneyAssignmentsByReferenceIds: Array<MoneyManagerMoneyAssignment>
  /** @implicit(userId: ID!) */
  moneyManagerPaychecks: Array<MoneyManagerPaycheck>
  /** @implicit(userId: ID!) */
  moneyManagerRebalances: MoneyManagerRebalancesResponse
  /** @implicit(userId: ID!) */
  moneyManagerScheduledDeposits: Array<MoneyManagerScheduledDeposit>
  /** @implicit(userId: ID!) */
  moneyManagerScheduledPaycheckPerEmployer: Array<
    Maybe<MoneyManagerScheduledPaycheck>
  >
  /** @implicit(userId: ID!) */
  moneyManagerSettings: MoneyManagerSettings
  /** @implicit(userId: ID!) */
  moneyManagerSummary: Maybe<MoneyManagerSummary>
  moneyRulesArchetypes: Maybe<MoneyRulesArchetypesResult>
  /**
   * @implicit(userId: ID!)
   * @deprecated Use moneyManagerSettings instead
   */
  moneyRulesSettings: Maybe<MoneyRulesSettings>
  /**
   * Fetch the next billing date for a user
   * @deprecated Use .getBillingDate() instead
   */
  nextBillingDate: Maybe<NextBillingDate>
  nextTransferDate: Maybe<NextTransferDateResult>
  notifications: Maybe<Notifications>
  /** Fetch a list of occupations */
  occupations: Maybe<Array<Maybe<Occupation>>>
  offer: Maybe<Offer>
  /** @implicit(userId: ID!) */
  onboardingBenefits: Maybe<Array<OnboardingTileGroup>>
  /** Determines requirements that have not been met yet for specific onboarding flow */
  onboardingRequirements: Maybe<Array<OnboardingRequirement>>
  /** Determines requirements that have not been met yet for specific onboarding flow */
  onboardingRequirementsUnauthed: Maybe<Array<OnboardingRequirement>>
  /** query the account onboarding tips modal */
  onboardingTips: Maybe<OnboardingTips>
  /** Fetch a code given the code uuid */
  outsideContributionCode: Maybe<OutsideContributionCode>
  /** Fetch a code given the code string */
  outsideContributionCodeByCode: Maybe<OutsideContributionCode>
  /** Fetch a code given the investment account id */
  outsideContributionCodeByInvestmentAccountId: Maybe<OutsideContributionCode>
  /** Base 64 Encoded Parameterized PDF String */
  parameterizedPdf: Maybe<GenerateUpdatedPdfPayload>
  partnerOfferGroup: Maybe<PartnerOfferGroup>
  partnerOfferGroupCategories: Maybe<Array<PartnerOfferGroup>>
  /** @implicit(deviceId: String) */
  partnerOfferGroupsByType: Maybe<Array<PartnerOfferGroup>>
  passwordResetFormFieldsByToken: Maybe<PasswordResetForm>
  /**
   * @implicit(userId: ID!)
   * @deprecated Use pastSummary
   */
  pastCoreSummary: Maybe<PastCoreSummary>
  /** @implicit(userId: ID!) */
  pastEarlySummary: Maybe<PastEarlySummary>
  pastLaterSummary: Maybe<PastLaterSummary>
  /** @implicit(userId: ID!) */
  pastRoundUpSummary: Maybe<PastRoundUpSummary>
  /** Totals for Spend */
  pastSpendSummary: Maybe<PastSpendSummary>
  /** @implicit(userId: ID!) */
  pastSpendTransactionItem: Maybe<PastItem>
  /** @implicit(userId: ID!) */
  pastSummary: Maybe<PastSummary>
  /** PDF Download URL */
  pdfDownloadUrl: Maybe<PdfDownloadUrlPayload>
  /** @implicit(userId: ID!) */
  pendingMoneyAssignments: Array<MoneyManagerMoneyAssignment>
  /** @deprecated Calculations have been updated in newer API's. Use InvestmentAccount.performance instead. */
  performance: Maybe<Performance>
  /** @implicit(userId: String) */
  personalizedEarnOffers: Maybe<Array<EarnOffer>>
  /** Get personalized offers for a given user */
  personalizedFoundMoney: Maybe<Array<FoundMoneyCampaignV2>>
  /** Portfolios */
  portfolios: Array<Portfolio>
  /** Lookup a specific Product by it's unique id. */
  product: Maybe<Product>
  /** Lookup a specific Product by it's unique key. */
  productByKey: Maybe<Product>
  /** List all Products. */
  products: Maybe<Array<Product>>
  /** Fetch a single profile for a user */
  profile: Profile
  /** @implicit(userId: ID!) */
  promoCodeApplied: Maybe<PromoCode>
  /**
   * @implicit(userId: ID!)
   * @deprecated This was only relevant for the Path to $1M sweepstakes.
   */
  promoMilestoneChallengeId: Maybe<Scalars['ID']>
  /** @implicit(userId: ID!) */
  promotedBenefitsByUserId: Array<PromotedBenefit>
  promotedCampaigns: Maybe<PromotedCampaigns>
  /** @implicit(userId: String) */
  promotedEarnOffers: Maybe<Array<EarnOffer>>
  /** Lookup a particular promotion by it's unique id. */
  promotion: Maybe<Promotion>
  /** Get a list of promotions to which a user is eligible. */
  promotionsByUserId: Maybe<Array<Promotion>>
  /** Returns quiz with given id or null if it does not exists */
  quiz: Maybe<Quiz>
  /** Fetch the user's recommended portfolio */
  recommendedPortfolio: Maybe<Suitability_Portfolio>
  /** Get recommended search terms for clients to populate the AI search page with */
  recommendedSearchTerms: Array<Scalars['String']>
  /**
   * Fetch recurring investment settings for the specified InvestmentAccount
   * (defaults to the authenticated User's Core InvestmentAccount if not specified).
   */
  recurringInvestmentSettings: Maybe<RecurringInvestmentSettings>
  /** @implicit(userId: ID!) */
  recurringTransfers: Maybe<Array<Maybe<RecurringTransfer>>>
  referralCampaigns: Maybe<ReferralCampaignConnection>
  /** Fetch user's referral */
  referralForUser: Maybe<Referral>
  /** @implicit(userId: ID!) */
  referralHistory: Maybe<ReferralHistory>
  /** @implicit(userId: ID!) */
  referralLedger: Maybe<ReferralLedger>
  /** @implicit(userId: ID!) */
  registeredAuthenticators: Maybe<Array<Authenticator>>
  /** Fetches a registration record for a prospective user */
  registration: Result
  /** Retrieves contextual information to direct user's registration funnel experience */
  registrationFunnel: Maybe<RegistrationFunnel>
  /** Returns related Course for Article */
  relatedCourseByArticleId: Maybe<Course>
  /** Returns related Course for Article */
  relatedCourseByArticleId_v2: Maybe<LearnCourse>
  /** Returns a list of related courses based on shared tags */
  relatedCoursePreviewsByCourseId: Maybe<Array<CoursePreview>>
  /** Returns a list of related courses based on shared tags */
  relatedCoursePreviewsByCourseId_v2: Maybe<Array<LearnCoursePreview>>
  /** Returns a list of related articles based on primary topic */
  relatedLearnContentByArticleId: Maybe<Array<LearnContentPreview>>
  /** Returns a list of learn content related to the provided media ID */
  relatedLearnContentByMediaId: Maybe<Array<LearnContentPreview>>
  /** Returns related Quiz for Course */
  relatedQuizByCourseId: Maybe<Quiz>
  /** Returns related Quiz for Course */
  relatedQuizByCourseId_v2: Maybe<LearnQuiz>
  /** Returns a list of 5 quizzes that are contained in courses with similar tags as the given course */
  relatedQuizzesByCourseId: Maybe<Array<QuizPreview>>
  /** Returns a list of 5 quizzes that are contained in courses with similar tags as the given course */
  relatedQuizzesByCourseId_v2: Maybe<Array<LearnQuizPreview>>
  remoteStrings: Maybe<Scalars['JSON']>
  /** Fetch a round up account for a specified linked subaccount */
  roundUpAccount: Maybe<RoundUpAccount>
  /** List round up accounts for a given user */
  roundUpAccounts: Array<RoundUpAccount>
  /** Fetch a single round up profile for a user */
  roundUpProfile: Maybe<RoundUpProfile>
  /** List round ups for a given user */
  roundUps: RoundUpTypePagination
  sampleMailInDocument: Maybe<SampleMailInDocument>
  savingsAccountEligibilityByUserId: Maybe<SavingsAccountEligibility>
  /** @implicit(deviceId: String) */
  searchActiveEarnOffers: EarnOfferQueryPage
  /** Employer Search */
  searchEmployers: Maybe<SearchEmployersPayload>
  /** Search extension offers by name, returns up to 100 results */
  searchExtensionOffers: Array<ExtensionOffer>
  /** Fuzzy search for securities by symbol and company name */
  searchSecurities: SearchSecuritiesResponse
  /** Returns all relevant support articles and all categories given a query */
  searchSupportArticles: Maybe<SearchSupportResult>
  /** Search for securities by trading sector */
  securitiesBySector: SecuritiesBySectorResponse
  securitiesBySymbols: SecuritiesBySymbolsResponse
  securityBySymbol: Maybe<Security>
  securityPerformanceBySymbol: Maybe<SecurityPerformance>
  /** Provide historical end of day prices for many Securities */
  securityPerformancesBySymbol: Array<SecurityPerformance>
  settings: Maybe<Settings>
  /** Fetch a list of signatures for a user */
  signatures: Array<Maybe<Signature>>
  smartDepositMetadata: Maybe<SmartDepositMetadataResult>
  /**
   * Pulls all accounts a customer can withdraw from.
   * @deprecated Deprecated, replace with AllAccounts.CustomerAccountsByTransferAction(ONE_TIME_DEPOSIT)
   */
  sourceAccounts: Array<CustomerAccount>
  spendAccount: Maybe<SpendAccount>
  spendAlerts: Maybe<Array<Maybe<SpendAlert>>>
  spendAtms: Maybe<SpendAtmsResult>
  splitDepositSettings: Maybe<SplitDepositSettings>
  splitDepositSettingsByUserId: Maybe<Array<SplitDepositSettings>>
  /** Gets a list of the requesting user's statement documents based on investment account and statement type */
  statements: Maybe<Array<Maybe<Statement>>>
  /** Get active streak for a user. Optional streakType filter (defaults to INVESTING). */
  streak: Maybe<Streak>
  stub: Maybe<Scalars['String']>
  subscriptionMigration: Maybe<SubscriptionMigration>
  subscriptionMigrationWaiver: Maybe<SubscriptionMigrationWaiver>
  /** @implicit(userId: ID!) */
  subscriptionMigrationWaiversByUserId: Maybe<
    Array<SubscriptionMigrationWaiver>
  >
  /** @implicit(userId: ID!) */
  suggestedMoneyRules: Maybe<SuggestedMoneyRulesResult>
  /** Fetch all suitability questions and answers */
  suitabilityResponses: Maybe<Array<Suitability_SuitabilityResponse>>
  /** Return if a client should use suitability service for a particular user */
  suitabilityServiceEnabled: Maybe<Scalars['Boolean']>
  /** Returns support article given an id */
  supportArticle: Maybe<SupportArticle>
  /** Returns all articles in section given a sectionId */
  supportArticlesBySectionId: Maybe<Array<Maybe<SupportArticle>>>
  /** Returns support category given an id */
  supportCategory: Maybe<SupportCategory>
  /**
   * See if in-app support chat is currently enabled. This is a fault-tolerant query and thus will return \`false\` rather than fail.
   * @deprecated Replaced with more general supportSchedule query.
   */
  supportChatEnabled: Scalars['Boolean']
  /** Returns most common faq articles if it has been set in Zesty */
  supportMostCommonFaq: Maybe<Array<ContactFaq>>
  /** See if specified support channel is currently enabled. This is a fault-tolerant query and thus will return \`false\` rather than fail. */
  supportSchedule: Maybe<ScheduleResult>
  /** Returns support section given an id */
  supportSection: Maybe<SupportSection>
  /** Returns all support sections by category id */
  supportSectionsByCategoryId: Maybe<Array<Maybe<SupportSection>>>
  /** Return the given support ticket form by id */
  supportTicketForm: Maybe<SupportTicketForm>
  supportTicketFormField: Maybe<SupportTicketFormField>
  /** Returns if a bank is eligible for Plaid Verification. */
  supportsPlaidVerification: SupportsPlaidVerificationResult
  /**
   * Pulls all accounts a customer can deposit into.
   * @deprecated Deprecated, replace with AllAccounts.CustomerAccountsByTransferAction(ONE_TIME_WITHDRAWAL)
   */
  targetAccounts: Array<CustomerAccount>
  /** Get tax refunds for a specific user */
  taxRefundsByUserId: Array<TaxRefund>
  /** Gets the requesting user's Tax Statements for all of the user accounts for the year provided */
  taxStatementsByTaxYear: StatementPagination
  /** Lookup a Tier by it's unique id. */
  tier: Maybe<Tier>
  /**
   * Returns a tier group w/ tiers, products, prices, etc. Can not be tied to
   * a specfic user (needs to support anonymous users).
   * id is optional for case of returning default
   */
  tierGroup: Maybe<TierGroup>
  /** TierGroup for specific user (includes the Tier they are subscribed to) */
  tierGroupForUser: Maybe<TierGroup>
  /**
   * Returns the cheapest tier option for a given user's open accounts
   * @deprecated Use Query.tierGroup to determine available Tier offers.
   */
  tierOptionByOpenAccounts: Maybe<TierOption>
  /**
   * Returns the cheapest tier option for a given product key
   * @deprecated Use Query.tierGroup to determine available Tier offers.
   */
  tierOptionByProductKey: Maybe<TierOption>
  /**
   * For a given TierPriceId, returns the TierOption associated with that price id.
   * Returns InvalidTierPriceId if the tier price id is not found.
   * @deprecated Use Query.tierGroup to determine available Tier offers.
   */
  tierOptionByTierPriceId: Maybe<TierOptionByTierPriceIdResult>
  /** Any arbitrary subscription (current or historical) */
  tierSubscription: Maybe<TierSubscription>
  /** A User's TierSubscription by User.uuid. */
  tierSubscriptionByUserId: Maybe<TierSubscription>
  /**
   * The current subscription for an arbitrary user
   * @deprecated Use Query.tierSubscriptionByUserId.
   */
  tierSubscriptionForUser: Maybe<TierSubscriptionForUser>
  /** All of a Users's TierSubscriptions by User.uuid. */
  tierSubscriptionHistoryByUserId: Maybe<TierSubscriptionConnection>
  /** Show all active tiers */
  tiers: Maybe<Array<Tier>>
  /** Fetch the authenticated recipient's tip profile */
  tipProfile: Maybe<TipProfile>
  /** Fetch setup eligibility and config for the authenticated recipient */
  tipProfileSetup: TipProfileSetup
  /** @deprecated Toggles no longer supported. This will always returns true. */
  toggle: Maybe<Toggle>
  /** Top Employers */
  topEmployers: TopEmployerPayload
  /** Lists every trackingId ever observed on a message, whether or not it has an explicit MessageConfig. */
  trackingIdCatalog: Array<TrackingIdCatalogEntry>
  /**
   * Returns a list of trending content for given tier
   * @deprecated This endpoint is being removed as tiers are being replaced by product keys
   */
  trendingLearnContentByTierId: Maybe<Array<TrendingLearnContentPreview>>
  /**
   * Returns a list of trending content for given topic
   * @deprecated Trending view data is no longer tracked. Results will be stale.
   */
  trendingLearnContentByTopicId: Maybe<Array<TrendingLearnContentPreview>>
  /**
   * Returns a personalized list of trending learn content
   * @deprecated Trending view data is no longer tracked. Results will be stale.
   */
  trendingLearnContentPersonalizedByUserId: Maybe<
    Array<TrendingLearnContentPreview>
  >
  /** Get the currently authenticated user */
  user: Maybe<User>
  /** An array of the alerts for a user. */
  userAlerts: Maybe<Array<UserAlertsResponse>>
  /** @implicit(userId: String!) */
  userBenefitsStatus: BenefitsStatusResponse
  /** Fetch all credentials types for a given user */
  userCredentials: Array<Maybe<UserCredentials>>
  /** Fetch a single user's external matches */
  userMatches: Array<Maybe<UserMatch>>
  /** Gets user status with respect to being closed, verified, or registration complete. */
  userStatus: Maybe<UserStatus>
  /** @implicit(userId: ID!) */
  userTokensByUserId: Array<Maybe<UserToken>>
  validatePasswordResetToken: ValidatePasswordResetTokenResult
  /** @implicit(userId: ID!) */
  verificationProfile: Maybe<VerificationProfile>
  verifyCheckPaymentRecipientAddress: Maybe<VerifyCheckPaymentRecipientAddressResult>
  verifyPromoCode: Maybe<VerifyPromoCodeResponse>
  withholdingDefaults: Maybe<WithholdingDefaults>
  /** Estimated withholding amounts (only on gains for Roth IRAs) */
  withholdingEstimates: Maybe<WithholdingEstimates>
  yearLaterReport: YearLaterReport
}

/** Root query type */
export type QueryAcceptanceDocumentArgs = {
  type: Scalars['String']
}

/** Root query type */
export type QueryAcceptanceDocumentsArgs = {
  requiredFor?: InputMaybe<Scalars['String']>
}

/** Root query type */
export type QueryAccountPointsRuleByMilestoneIdArgs = {
  milestoneID: Scalars['ID']
}

/** Root query type */
export type QueryAccountStrengthArgs = {
  accountId?: InputMaybe<Scalars['String']>
}

/** Root query type */
export type QueryAccountsArgs = {
  status?: InputMaybe<Array<InputMaybe<AccountStatus>>>
}

/** Root query type */
export type QueryActionFeedArgs = {
  input?: InputMaybe<ActionCardsInput>
}

/** Root query type */
export type QueryActionScreenArgs = {
  screenContext?: InputMaybe<ActionScreenContext>
}

/** Root query type */
export type QueryActiveEarnOffersArgs = {
  cursor?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  tag?: InputMaybe<Scalars['String']>
}

/** Root query type */
export type QueryActivityArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
}

/** Root query type */
export type QueryActivitySummaryArgs = {
  accountId?: InputMaybe<Scalars['ID']>
  product?: InputMaybe<ActivitySummaryProduct>
}

/** Root query type */
export type QueryAddressDeliverabilityArgs = {
  input: AddressDeliverabilityInput
}

/** Root query type */
export type QueryAddressesArgs = {
  addressType?: InputMaybe<AddressType>
}

/** Root query type */
export type QueryAllAcceptanceDocumentsArgs = {
  requiredFor?: InputMaybe<Scalars['String']>
}

/** Root query type */
export type QueryAllAccountsArgs = {
  filter?: InputMaybe<AllAccountsFilterInput>
}

/** Root query type */
export type QueryAllBankAccountsArgs = {
  input: AllBankAccountsInput
}

/** Root query type */
export type QueryAllBankCardsArgs = {
  filter?: InputMaybe<AllBankCardsFilter>
}

/** Root query type */
export type QueryAllBankDocumentsArgs = {
  input: AllBankDocumentsInput
}

/** Root query type */
export type QueryAllBankTransactionsArgs = {
  accountId?: InputMaybe<Scalars['ID']>
  pagination?: InputMaybe<PageInput>
}

/** Root query type */
export type QueryAllCardTrackingStatusesArgs = {
  userId?: InputMaybe<Scalars['ID']>
}

/** Root query type */
export type QueryAllChatHistoryMessagesArgs = {
  pagination: PaginationInput
}

/** Root query type */
export type QueryAllChatSessionsArgs = {
  pagination: PaginationInput
}

/** Root query type */
export type QueryAllCheckPaymentsArgs = {
  pageInput?: InputMaybe<PageInput>
}

/** Root query type */
export type QueryAllMessagesArgs = {
  cardSubCategoryFilters?: InputMaybe<Array<CardSubCategory>>
  categoryFilters?: InputMaybe<Array<MessageCategory>>
  statusFilters?: InputMaybe<Array<MessageStatusFilterInput>>
  typeFilters?: InputMaybe<Array<MessageType>>
}

/** Root query type */
export type QueryAllPastCoreItemChildrenArgs = {
  pastItemId: Scalars['ID']
}

/** Root query type */
export type QueryAllPastCoreItemsArgs = {
  excludeFees?: InputMaybe<Scalars['Boolean']>
  filter?: InputMaybe<AllPastCoreItemsSchemaFilter>
  pagination?: InputMaybe<PageInput>
}

/** Root query type */
export type QueryAllPastEarlyItemsArgs = {
  beneficiaryAccountId: Scalars['String']
  excludeFees?: InputMaybe<Scalars['Boolean']>
  filter?: InputMaybe<AllPastEarlyItemsSchemaFilter>
  pagination?: InputMaybe<PageInput>
}

/** Root query type */
export type QueryAllPastItemsArgs = {
  filter?: InputMaybe<AllPastItemsFilter>
  pagination?: InputMaybe<PageInput>
}

/** Root query type */
export type QueryAllPastLaterItemsArgs = {
  excludeFees?: InputMaybe<Scalars['Boolean']>
  filter?: InputMaybe<AllPastLaterItemsSchemaFilter>
  pagination?: InputMaybe<PageInput>
}

/** Root query type */
export type QueryAllPastPendingItemsArgs = {
  excludeFees?: InputMaybe<Scalars['Boolean']>
}

/** Root query type */
export type QueryAllPastScheduledItemsArgs = {
  filter?: InputMaybe<AllPastScheduledItemsFilter>
}

/** Root query type */
export type QueryAllPastScheduledItemsV2Args = {
  filter?: InputMaybe<AllPastScheduledItemsFilterV2>
}

/** Root query type */
export type QueryAllPastSpendItemsArgs = {
  accountId?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<AllPastSpendItemsSchemaFilter>
  pagination?: InputMaybe<PageInput>
}

/** Root query type */
export type QueryAllSupportArticlesArgs = {
  filter?: InputMaybe<AllSupportArticlesFilterInput>
  isPrivate?: InputMaybe<Scalars['Boolean']>
}

/** Root query type */
export type QueryAllSupportSectionsArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']>
}

/** Root query type */
export type QueryAllTransferableToArgs = {
  input: AllTransferableToInput
}

/** Root query type */
export type QueryAuthenticateForFeeNegotiationStatusByLinkedAccountIdArgs = {
  linkedAccountId: Scalars['ID']
}

/** Root query type */
export type QueryBankAccountDisclosuresArgs = {
  input: BankAccountDisclosureFilter
}

/** Root query type */
export type QueryBankAccountStateArgs = {
  accountType?: InputMaybe<BankAccountType>
}

/** Root query type */
export type QueryBankCardProvisioningDetailsArgs = {
  input: BankCardProvisioningDetailsInput
}

/** Root query type */
export type QueryBankFeesByUserIdArgs = {
  filter?: InputMaybe<BankFeeFilter>
  first?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  statusFilter?: InputMaybe<Array<InputMaybe<FeeStatusFilter>>>
}

/** Root query type */
export type QueryBankInterestRatesArgs = {
  productFilter?: InputMaybe<Array<InputMaybe<BankingProduct>>>
}

/** Root query type */
export type QueryBankTransactionArgs = {
  bankAccountType?: InputMaybe<BankAccountType>
  id: Scalars['ID']
}

/** Root query type */
export type QueryBankingFeatureEligibilityArgs = {
  feature: BankingEligibilityFeature
}

/** Root query type */
export type QueryBeneficiariesArgs = {
  filterDeactivated?: InputMaybe<Scalars['Boolean']>
}

/** Root query type */
export type QueryBeneficiaryArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryBenefitPartnerByUserIdArgs = {
  input: BenefitPartnerInput
}

/** Root query type */
export type QueryBillingCycleArgs = {
  id?: InputMaybe<Scalars['ID']>
}

/** Root query type */
export type QueryBillingCyclesArgs = {
  state?: InputMaybe<Array<InputMaybe<BillingCycleState>>>
}

/** Root query type */
export type QueryBlueprintArgs = {
  capabilities: BlueprintCapabilities
  screen: BlueprintScreen
}

/** Root query type */
export type QueryBlueprintSchemaAtVersionArgs = {
  apiKey: Scalars['String']
  version: Scalars['String']
}

/** Root query type */
export type QueryCalculateMoneySplitsArgs = {
  moneySource: MoneyRulesMoneySourceInput
  overrides?: InputMaybe<MoneyRulesSplitOverridesInput>
}

/** Root query type */
export type QueryCampaignHistoryArgs = {
  filter: CampaignHistoryFilter
  page: ReferralPaginatedFilter
}

/** Root query type */
export type QueryChallengesArgs = {
  deliveryType?: InputMaybe<ChallengeDeliveryType>
}

/** Root query type */
export type QueryChatHistoryMessagesBySessionIdArgs = {
  pagination: PaginationInput
  sessionId: Scalars['ID']
}

/** Root query type */
export type QueryClosureReasonsByInvestmentAccountTypeArgs = {
  product?: InputMaybe<InvestmentProduct>
}

/** Root query type */
export type QueryCohortEligibilityArgs = {
  scopes: Array<CohortEligibilityScope>
}

/** Root query type */
export type QueryCohortEligibility_V2Args = {
  filter?: InputMaybe<CohortEligibility_V2FilterInput>
}

/** Root query type */
export type QueryCombinedPerformanceByUserIdArgs = {
  days?: InputMaybe<Scalars['Int']>
  filter?: InputMaybe<InvestmentAccountsByUserIdFilter>
}

/** Root query type */
export type QueryCompletedQuizByQuizIdArgs = {
  quizId: Scalars['ID']
}

/** Root query type */
export type QueryContributionPageArgs = {
  code: Scalars['ID']
}

/** Root query type */
export type QueryContributionStickerRequestsArgs = {
  input: ContributionStickerRequestsInput
}

/** Root query type */
export type QueryCourseArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryCourse_V2Args = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryCoursesByTierIdArgs = {
  tierId: Scalars['ID']
}

/** Root query type */
export type QueryCoursesByTopicIdArgs = {
  topicId: Scalars['ID']
}

/** Root query type */
export type QueryCoursesByTopicId_V2Args = {
  topicId: Scalars['ID']
}

/** Root query type */
export type QueryDesignatedBeneficiaryArgs = {
  beneficiaryId: Scalars['ID']
}

/** Root query type */
export type QueryDevicesByUserIdArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']>
}

/** Root query type */
export type QueryDiversificationInfoByInvestmentAccountIdArgs = {
  input: DiversificationInfoByInvestmentAccountIdInput
}

/** Root query type */
export type QueryDocumentRequestArgs = {
  input: DocumentRequestInput
}

/** Root query type */
export type QueryDocumentRequestsArgs = {
  input: DocumentRequestsInput
}

/** Root query type */
export type QueryEarlyAccountStateRegulationArgs = {
  stateCode?: InputMaybe<Scalars['String']>
}

/** Root query type */
export type QueryEarlyAccountTransferInfoArgs = {
  investmentAccountId: Scalars['ID']
}

/** Root query type */
export type QueryEarnOfferByCampaignOfferIdArgs = {
  campaignOfferId: Scalars['String']
  incentiveTemplate?: InputMaybe<EarnOfferIncentiveTemplate>
  origin: Scalars['String']
  sessionId: Scalars['String']
}

/** Root query type */
export type QueryEarnRewardsByInvestmentIdsArgs = {
  investmentIds: Array<Scalars['ID']>
}

/** Root query type */
export type QueryEligibilityArgs = {
  eligibilityScope: EligibilityScope
}

/** Root query type */
export type QueryEmailAddressValidationArgs = {
  email: Scalars['EmailAddress']
}

/** Root query type */
export type QueryEmailAddressValidationV2Args = {
  email: Scalars['EmailAddress']
}

/** Root query type */
export type QueryEstimatedMatchRemovalArgs = {
  investmentAccountId: Scalars['ID']
  withdrawalAmount: MonetaryAmountInput
}

/** Root query type */
export type QueryEstimatedTransferDatesArgs = {
  input: EstimatedTransferDatesInput
}

/** Root query type */
export type QueryEvaluateCheckDepositArgs = {
  input: EvaluateCheckDepositInput
}

/** Root query type */
export type QueryExternalContributionStatusArgs = {
  requestNonce: Scalars['ID']
}

/** Root query type */
export type QueryFeeArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryFeesArgs = {
  accountId?: InputMaybe<Scalars['ID']>
  billingCycleId?: InputMaybe<Scalars['ID']>
}

/** Root query type */
export type QueryFinancialGoalsRecommendationArgs = {
  input: FinancialGoalsInput
}

/** Root query type */
export type QueryFinancialInstitutionArgs = {
  externalId: Scalars['String']
  linkable?: InputMaybe<Scalars['Boolean']>
}

/** Root query type */
export type QueryFinancialInstitutionsArgs = {
  includeBlacklisted?: InputMaybe<Scalars['Boolean']>
  includeDirectBank?: InputMaybe<Scalars['Boolean']>
  pageInput?: InputMaybe<PageInput>
  q?: InputMaybe<Scalars['String']>
  supportsAuth?: InputMaybe<Scalars['Boolean']>
  supportsFunding?: InputMaybe<Scalars['Boolean']>
}

/** Root query type */
export type QueryFinishSetupArgs = {
  accountId: Scalars['ID']
  feedContext: FeedContext
}

/** Root query type */
export type QueryGenerateUpdatedPdfArgs = {
  input: PdfDownloadUrlInput
}

/** Root query type */
export type QueryGetBillingHistoryArgs = {
  state?: InputMaybe<Array<InputMaybe<BillingCycleState>>>
}

/** Root query type */
export type QueryGetPartnerDetailsArgs = {
  input: PartnerUrlInput
}

/** Root query type */
export type QueryGetPartnerDocumentByUserIdArgs = {
  input: PartnerDocumentInput
}

/** Root query type */
export type QueryGetPartnerUrlArgs = {
  input: PartnerUrlInput
}

/** Root query type */
export type QueryGetThirdPartyUserDataArgs = {
  input: GetThirdPartyDataInput
}

/** Root query type */
export type QueryGetUsersBankFromAccountTypeArgs = {
  type: BankAccountType
}

/** Root query type */
export type QueryGetVendorInvoiceArgs = {
  invoiceId: Scalars['ID']
}

/** Root query type */
export type QueryHelpFormContentArgs = {
  form: HelpFormType
}

/** Root query type */
export type QueryInstantSearchSupportArticlesArgs = {
  brand?: InputMaybe<ArticleBrand>
  isPrivate?: InputMaybe<Scalars['Boolean']>
  query: Scalars['String']
}

/** Root query type */
export type QueryIntentArgs = {
  nonce: Scalars['UUID']
}

/** Root query type */
export type QueryIntentsArgs = {
  filter: IntentFilterInput
}

/** Root query type */
export type QueryInvestmentArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryInvestmentAccountArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryInvestmentAccountByBeneficiaryIdArgs = {
  beneficiaryId: Scalars['ID']
}

/** Root query type */
export type QueryInvestmentAccountRecapArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryInvestmentAccountRecapByPublicTokenArgs = {
  publicToken: Scalars['ID']
}

/** Root query type */
export type QueryInvestmentAccountsByUserIdArgs = {
  filter?: InputMaybe<InvestmentAccountsByUserIdFilter>
}

/** Root query type */
export type QueryInvestmentsByInvestmentAccountIdArgs = {
  endDate?: InputMaybe<Scalars['Date']>
  investmentAccountId: Scalars['ID']
  pageInput?: InputMaybe<PageInput>
  startDate?: InputMaybe<Scalars['Date']>
}

/** Root query type */
export type QueryJobSearchArgs = {
  searchCriteria: JobSearchCriteriaInput
}

/** Root query type */
export type QueryJobSearchV2Args = {
  pagination: PageInput
  saveAsRecentSearch?: InputMaybe<Scalars['Boolean']>
  searchCriteria: JobSearchCriteriaInput
}

/** Root query type */
export type QueryLaterBeneficiariesArgs = {
  investmentAccountId: Scalars['ID']
}

/** Root query type */
export type QueryLaterContributionHistoryArgs = {
  investmentAccountId: Scalars['ID']
}

/** Root query type */
export type QueryLaterHistoryArgs = {
  accountId: Scalars['ID']
  limit?: InputMaybe<Scalars['Int']>
  page?: InputMaybe<Scalars['Int']>
}

/** Root query type */
export type QueryLearnArticleArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryLearnContentByProfileArgs = {
  contentTypes?: InputMaybe<Array<LearnContentType>>
  limit?: InputMaybe<Scalars['Int']>
}

/** Root query type */
export type QueryLearnContentBySearchTermArgs = {
  filter?: InputMaybe<LearnContentFilterInput>
  pagination: LearnContentPageInput
  sort?: InputMaybe<LearnContentSortType>
  term: Scalars['String']
}

/** Root query type */
export type QueryLearnContentByTierIdArgs = {
  filter: LearnContentFilterByTierIdInput
  pagination: LearnContentPageInput
  sort?: InputMaybe<LearnContentSortType>
}

/** Root query type */
export type QueryLearnContentByTopicIdArgs = {
  filter: LearnContentFilterByTopicIdInput
  pagination: LearnContentPageInput
  sort?: InputMaybe<LearnContentSortType>
}

/** Root query type */
export type QueryLearnContentPreviewsByContentIdsArgs = {
  contentIds: Array<Scalars['ID']>
}

/** Root query type */
export type QueryLearnContentRecommendationsBySearchTermArgs = {
  term: Scalars['String']
}

/** Root query type */
export type QueryLearnMediaArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryLearnNextStepActionsByCourseIdArgs = {
  courseId: Scalars['ID']
}

/** Root query type */
export type QueryLearnNextStepActionsByMediaIdArgs = {
  mediaId: Scalars['ID']
}

/** Root query type */
export type QueryLearnQuestionInsightsByQuizIdArgs = {
  quizId: Scalars['ID']
}

/** Root query type */
export type QueryLearnWidgetContentArgs = {
  context: ActionFeedContext
}

/** Root query type */
export type QueryLinkedAccountArgs = {
  linkedAccountId: Scalars['ID']
}

/** Root query type */
export type QueryLinkedAccountsArgs = {
  externalSources?: InputMaybe<Array<LinkedAccountExternalSourceEnum>>
  linked?: InputMaybe<Scalars['Boolean']>
}

/** Root query type */
export type QueryLinkedSubaccountArgs = {
  linkedSubaccountId: Scalars['ID']
}

/** Root query type */
export type QueryLinkedSubaccountsArgs = {
  linked?: InputMaybe<Scalars['Boolean']>
}

/** Root query type */
export type QueryLiquidationArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryLiquidationsArgs = {
  accountId?: InputMaybe<Scalars['ID']>
  billingCycleId?: InputMaybe<Scalars['ID']>
}

/** Root query type */
export type QueryListBenefitsByUserIdArgs = {
  group?: InputMaybe<Scalars['String']>
  product?: InputMaybe<BenefitsTrackerProducts>
}

/** Root query type */
export type QueryMatchProgramArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryMessageArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryMessageByExternalIdArgs = {
  externalId: Scalars['ID']
}

/** Root query type */
export type QueryMessageConfigArgs = {
  trackingId: Scalars['ID']
}

/** Root query type */
export type QueryMessagesArgs = {
  categoryFilters?: InputMaybe<Array<MessageCategory>>
  pagination?: InputMaybe<MessagePageInput>
  statusFilters?: InputMaybe<Array<MessageStatusFilterInput>>
  typeFilters?: InputMaybe<Array<MessageType>>
}

/** Root query type */
export type QueryMilestoneArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryMilestoneAchievementActionRuleArgs = {
  milestoneID: Scalars['ID']
}

/** Root query type */
export type QueryMilestoneChallengeArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryMilestoneChallengePointsRuleByMilestoneIdByChallengeIdArgs = {
  challengeID: Scalars['ID']
  milestoneID: Scalars['ID']
}

/** Root query type */
export type QueryMilestoneChallengePointsRulesByMilestoneIdArgs = {
  milestoneID: Scalars['ID']
}

/** Root query type */
export type QueryMilestoneDefinitionArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryMilestoneEligibilityByScopesArgs = {
  scopes: Array<MilestoneEligibilityScope>
}

/** Root query type */
export type QueryMilestoneGroupAchievementActionRuleArgs = {
  milestoneGroupID: Scalars['ID']
}

/** Root query type */
export type QueryMilestoneGroupDefinitionArgs = {
  groupID: Scalars['ID']
}

/** Root query type */
export type QueryMilestoneHubDefinitionArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryMilestoneHubEligibleArgs = {
  registrationCompletedAt: Scalars['DateTime']
}

/** Root query type */
export type QueryMilestonesByThemeArgs = {
  filter?: InputMaybe<MilestoneByThemeFilterInput>
  theme: MilestoneTheme
}

/** Root query type */
export type QueryMoneyAssignmentArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryMoneyManagerAllocationOptionsArgs = {
  input: MoneyManagerAllocationOptionsInput
}

/** Root query type */
export type QueryMoneyManagerAllocationsByTransferIdsArgs = {
  transferIds: Array<Scalars['ID']>
}

/** Root query type */
export type QueryMoneyManagerAutomationTargetDefaultsArgs = {
  version?: InputMaybe<MoneyManagerAutomationTargetVersion>
}

/** Root query type */
export type QueryMoneyManagerAutomationTargetsArgs = {
  version?: InputMaybe<MoneyManagerAutomationTargetVersion>
}

/** Root query type */
export type QueryMoneyManagerCategoriesArgs = {
  input?: InputMaybe<MoneyManagerCategoriesInput>
}

/** Root query type */
export type QueryMoneyManagerDepositHistoryArgs = {
  pagination?: InputMaybe<MoneyManagerPageInput>
}

/** Root query type */
export type QueryMoneyManagerMoneyAssignmentsByReferenceIdsArgs = {
  referenceIds: Array<Scalars['ID']>
}

/** Root query type */
export type QueryMoneyManagerPaychecksArgs = {
  employer?: InputMaybe<Scalars['String']>
}

/** Root query type */
export type QueryMoneyRulesArchetypesArgs = {
  input?: InputMaybe<MoneyRulesArchetypesInput>
}

/** Root query type */
export type QueryNextTransferDateArgs = {
  recurrenceRule: RecurrenceRuleInput
}

/** Root query type */
export type QueryOfferArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryOnboardingBenefitsArgs = {
  input?: InputMaybe<OnboardingBenefitsInput>
}

/** Root query type */
export type QueryOnboardingRequirementsArgs = {
  onboardingType: OnboardingType
}

/** Root query type */
export type QueryOnboardingRequirementsUnauthedArgs = {
  onboardingType: OnboardingType
}

/** Root query type */
export type QueryOnboardingTipsArgs = {
  feedContext: FeedContext
}

/** Root query type */
export type QueryOutsideContributionCodeArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryOutsideContributionCodeByCodeArgs = {
  code: Scalars['String']
}

/** Root query type */
export type QueryOutsideContributionCodeByInvestmentAccountIdArgs = {
  investmentAccountId: Scalars['ID']
}

/** Root query type */
export type QueryParameterizedPdfArgs = {
  input: ParameterizedPdfInput
}

/** Root query type */
export type QueryPartnerOfferGroupArgs = {
  filter?: InputMaybe<PartnerOfferGroupFilterInput>
  id: Scalars['String']
}

/** Root query type */
export type QueryPartnerOfferGroupCategoriesArgs = {
  ids: Array<Scalars['ID']>
  incentiveTemplate?: InputMaybe<EarnOfferIncentiveTemplate>
}

/** Root query type */
export type QueryPartnerOfferGroupsByTypeArgs = {
  partnerOfferGroupsTypeInput: PartnerOfferGroupsTypeInput
}

/** Root query type */
export type QueryPasswordResetFormFieldsByTokenArgs = {
  resetToken: Scalars['String']
}

/** Root query type */
export type QueryPastEarlySummaryArgs = {
  beneficiaryAccountId: Scalars['String']
}

/** Root query type */
export type QueryPastLaterSummaryArgs = {
  investmentAccountId?: InputMaybe<Scalars['ID']>
}

/** Root query type */
export type QueryPastRoundUpSummaryArgs = {
  filter?: InputMaybe<PastRoundUpSummaryFilter>
}

/** Root query type */
export type QueryPastSpendTransactionItemArgs = {
  accountType?: InputMaybe<BankAccountType>
  transactionId: Scalars['String']
}

/** Root query type */
export type QueryPastSummaryArgs = {
  pastSummaryFilter?: InputMaybe<PastSummaryFilter>
}

/** Root query type */
export type QueryPdfDownloadUrlArgs = {
  input: PdfDownloadUrlInput
}

/** Root query type */
export type QueryPerformanceArgs = {
  days: Scalars['Int']
  investmentAccountId?: InputMaybe<Scalars['ID']>
  start: Scalars['DateTime']
}

/** Root query type */
export type QueryPortfoliosArgs = {
  customizedWithSecuritySymbols?: InputMaybe<Array<Scalars['String']>>
}

/** Root query type */
export type QueryProductArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryProductByKeyArgs = {
  productKey: ProductKey
}

/** Root query type */
export type QueryPromotedBenefitsByUserIdArgs = {
  product?: InputMaybe<BenefitsTrackerProducts>
}

/** Root query type */
export type QueryPromotionArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryPromotionsByUserIdArgs = {
  filter?: InputMaybe<PromotionFilterInput>
  limit?: InputMaybe<Scalars['Int']>
}

/** Root query type */
export type QueryQuizArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryRecommendedSearchTermsArgs = {
  category?: InputMaybe<SearchTermCategory>
}

/** Root query type */
export type QueryRecurringInvestmentSettingsArgs = {
  investmentAccountId?: InputMaybe<Scalars['ID']>
}

/** Root query type */
export type QueryRecurringTransfersArgs = {
  filter?: InputMaybe<RecurringTransfersFilterInput>
}

/** Root query type */
export type QueryReferralCampaignsArgs = {
  campaignId?: InputMaybe<Scalars['ID']>
  filter: ReferralPaginatedFilter
}

/** Root query type */
export type QueryReferralLedgerArgs = {
  filter?: InputMaybe<ReferralLedgerFilter>
}

/** Root query type */
export type QueryRegistrationFunnelArgs = {
  filter: RegistrationFunnelFilter
}

/** Root query type */
export type QueryRelatedCourseByArticleIdArgs = {
  articleId: Scalars['ID']
}

/** Root query type */
export type QueryRelatedCourseByArticleId_V2Args = {
  articleId: Scalars['ID']
}

/** Root query type */
export type QueryRelatedCoursePreviewsByCourseIdArgs = {
  courseId: Scalars['ID']
}

/** Root query type */
export type QueryRelatedCoursePreviewsByCourseId_V2Args = {
  courseId: Scalars['ID']
}

/** Root query type */
export type QueryRelatedLearnContentByArticleIdArgs = {
  articleId: Scalars['ID']
}

/** Root query type */
export type QueryRelatedLearnContentByMediaIdArgs = {
  mediaId: Scalars['ID']
}

/** Root query type */
export type QueryRelatedQuizByCourseIdArgs = {
  courseId: Scalars['ID']
}

/** Root query type */
export type QueryRelatedQuizByCourseId_V2Args = {
  courseId: Scalars['ID']
}

/** Root query type */
export type QueryRelatedQuizzesByCourseIdArgs = {
  courseId: Scalars['ID']
}

/** Root query type */
export type QueryRelatedQuizzesByCourseId_V2Args = {
  courseId: Scalars['ID']
}

/** Root query type */
export type QueryRoundUpAccountArgs = {
  linkedSubaccountId: Scalars['ID']
}

/** Root query type */
export type QueryRoundUpsArgs = {
  autoInvestable?: InputMaybe<Scalars['Boolean']>
  instant?: InputMaybe<Scalars['Boolean']>
  investmentId?: InputMaybe<Scalars['ID']>
  manual?: InputMaybe<Scalars['Boolean']>
  pageInput?: InputMaybe<PageInput>
  state?: InputMaybe<Array<RoundUpState>>
  targetAccountId?: InputMaybe<Scalars['ID']>
  transactionDateAfter?: InputMaybe<Scalars['String']>
  transactionDateBefore?: InputMaybe<Scalars['String']>
}

/** Root query type */
export type QuerySampleMailInDocumentArgs = {
  typeFilter: MailInDocumentType
}

/** Root query type */
export type QuerySavingsAccountEligibilityByUserIdArgs = {
  type: SavingsAccountType
}

/** Root query type */
export type QuerySearchActiveEarnOffersArgs = {
  cursor?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  searchTerm: Scalars['String']
  tag?: InputMaybe<Scalars['String']>
}

/** Root query type */
export type QuerySearchEmployersArgs = {
  input: SearchEmployersInput
}

/** Root query type */
export type QuerySearchExtensionOffersArgs = {
  searchTerm: Scalars['String']
}

/** Root query type */
export type QuerySearchSecuritiesArgs = {
  input: SearchSecuritiesInput
}

/** Root query type */
export type QuerySearchSupportArticlesArgs = {
  brand?: InputMaybe<ArticleBrand>
  isPrivate?: InputMaybe<Scalars['Boolean']>
  page?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
  query: Scalars['String']
}

/** Root query type */
export type QuerySecuritiesBySectorArgs = {
  input: SecuritiesBySectorInput
}

/** Root query type */
export type QuerySecuritiesBySymbolsArgs = {
  input: SecuritiesBySymbolsInput
}

/** Root query type */
export type QuerySecurityBySymbolArgs = {
  input: SecurityBySymbolInput
}

/** Root query type */
export type QuerySecurityPerformanceBySymbolArgs = {
  input: SecurityPerformanceBySymbolInput
}

/** Root query type */
export type QuerySecurityPerformancesBySymbolArgs = {
  input: SecurityPerformancesBySymbolInput
}

/** Root query type */
export type QuerySignaturesArgs = {
  signatureType?: InputMaybe<SignatureType>
}

/** Root query type */
export type QuerySmartDepositMetadataArgs = {
  smartDepositMetadataInput: SmartDepositMetadataInput
}

/** Root query type */
export type QuerySourceAccountsArgs = {
  filter?: InputMaybe<SourceAccountsFilterInput>
}

/** Root query type */
export type QuerySpendAtmsArgs = {
  input: SpendAtmsInput
}

/** Root query type */
export type QuerySplitDepositSettingsArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QuerySplitDepositSettingsByUserIdArgs = {
  filter?: InputMaybe<SplitDepositSettingsFilterInput>
  normalizeToFrequency?: InputMaybe<SplitDepositNormalizationFrequency>
}

/** Root query type */
export type QueryStatementsArgs = {
  investmentAccountId?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  type: Scalars['String']
}

/** Root query type */
export type QueryStreakArgs = {
  streakType?: InputMaybe<StreakType>
}

/** Root query type */
export type QueryStubArgs = {
  id: Scalars['UUID']
}

/** Root query type */
export type QuerySubscriptionMigrationArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QuerySubscriptionMigrationWaiverArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QuerySupportArticleArgs = {
  brand?: InputMaybe<ArticleBrand>
  id: Scalars['ID']
  isPrivate?: InputMaybe<Scalars['Boolean']>
}

/** Root query type */
export type QuerySupportArticlesBySectionIdArgs = {
  brand?: InputMaybe<ArticleBrand>
  isPrivate?: InputMaybe<Scalars['Boolean']>
  page?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
  sectionId: Scalars['ID']
}

/** Root query type */
export type QuerySupportCategoryArgs = {
  categoryId: Scalars['ID']
}

/** Root query type */
export type QuerySupportScheduleArgs = {
  input: ScheduleInput
}

/** Root query type */
export type QuerySupportSectionArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']>
  sectionId: Scalars['ID']
}

/** Root query type */
export type QuerySupportSectionsByCategoryIdArgs = {
  categoryId: Scalars['ID']
  isPrivate?: InputMaybe<Scalars['Boolean']>
}

/** Root query type */
export type QuerySupportTicketFormArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QuerySupportTicketFormFieldArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QuerySupportsPlaidVerificationArgs = {
  routingNumber: Scalars['String']
}

/** Root query type */
export type QueryTargetAccountsArgs = {
  filter?: InputMaybe<TargetAccountsFilterInput>
}

/** Root query type */
export type QueryTaxRefundsByUserIdArgs = {
  filter?: InputMaybe<TaxRefundFilterInput>
  refundSubtype?: InputMaybe<Scalars['String']>
}

/** Root query type */
export type QueryTaxStatementsByTaxYearArgs = {
  pageInput?: InputMaybe<PageInput>
  taxYear: Scalars['Int']
}

/** Root query type */
export type QueryTierArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryTierGroupArgs = {
  id?: InputMaybe<Scalars['ID']>
}

/** Root query type */
export type QueryTierOptionByProductKeyArgs = {
  productKey: ProductKey
  tierGroupId?: InputMaybe<Scalars['ID']>
}

/** Root query type */
export type QueryTierOptionByTierPriceIdArgs = {
  tierPriceId: Scalars['ID']
}

/** Root query type */
export type QueryTierSubscriptionArgs = {
  id: Scalars['ID']
}

/** Root query type */
export type QueryTierSubscriptionHistoryByUserIdArgs = {
  after?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

/** Root query type */
export type QueryToggleArgs = {
  context?: InputMaybe<Scalars['JSON']>
  projectId: Scalars['String']
  toggleId: Scalars['String']
}

/** Root query type */
export type QueryTrendingLearnContentByTierIdArgs = {
  tierId: Scalars['ID']
}

/** Root query type */
export type QueryTrendingLearnContentByTopicIdArgs = {
  topicId: Scalars['ID']
}

/** Root query type */
export type QueryUserBenefitsStatusArgs = {
  benefitProductKey?: InputMaybe<Scalars['String']>
  tierKey: Scalars['String']
}

/** Root query type */
export type QueryUserCredentialsArgs = {
  credentialsType?: InputMaybe<CredentialsType>
  includeDisabled?: InputMaybe<Scalars['Boolean']>
}

/** Root query type */
export type QueryValidatePasswordResetTokenArgs = {
  resetToken: Scalars['String']
}

/** Root query type */
export type QueryVerifyCheckPaymentRecipientAddressArgs = {
  input: VerifyCheckPaymentRecipientAddressInputType
}

/** Root query type */
export type QueryVerifyPromoCodeArgs = {
  name: Scalars['String']
}

/** Root query type */
export type QueryWithholdingDefaultsArgs = {
  earlyDistributionTaxExceptionReason?: InputMaybe<Scalars['String']>
  investmentAccountId: Scalars['ID']
  withdrawalAmount: CurrencyAmountInput
}

/** Root query type */
export type QueryWithholdingEstimatesArgs = {
  federalWithholdingPercentage: Scalars['Float']
  investmentAccountId: Scalars['ID']
  reason?: InputMaybe<LaterWithdrawalReason>
  stateWithholdingPercentage: Scalars['Float']
  withdrawalAmount: CurrencyAmountInput
}

/** Root query type */
export type QueryYearLaterReportArgs = {
  year: Scalars['Int']
}

export type QueueUsersForVendorOnboardingInput = {
  /**
   * Create the Recurly account (and sync billing info unless skipBillingSync) without creating
   * a subscription. The user is marked vendorIntegrated, so internal billing stops.
   */
  accountOnly?: InputMaybe<Scalars['Boolean']>
  skipBillingSync?: InputMaybe<Scalars['Boolean']>
  userIds: Array<Scalars['ID']>
}

export type QueueUsersForVendorOnboardingResult =
  | BillingVendorError
  | QueueUsersForVendorOnboardingSuccess

export type QueueUsersForVendorOnboardingSuccess = {
  __typename?: 'QueueUsersForVendorOnboardingSuccess'
  failedUserIds: Array<Scalars['ID']>
  queuedUserIds: Array<Scalars['ID']>
}

export type Quiz = {
  __typename?: 'Quiz'
  authors: Array<LearnAuthor>
  description: Scalars['String']
  duration: LearnContentDuration
  featuredImage: Maybe<LearnVisualAsset>
  id: Scalars['ID']
  metadata: LearnMetadata
  questions: Array<LearnQuestion>
  theme: QuizTheme
  /** @deprecated Tier will be removed */
  tier: LearnTier
  title: Scalars['String']
  topics: Array<LearnTopic>
}

export type QuizLocked = {
  __typename?: 'QuizLocked'
  duration: LearnContentDuration
  featuredImage: Maybe<LearnVisualAsset>
  id: Scalars['ID']
  numQuestions: Scalars['Int']
  productRequired: Scalars['String']
  title: Scalars['String']
}

export type QuizPreview = {
  __typename?: 'QuizPreview'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  isCompleted: Scalars['Boolean']
  primaryTopicName: Scalars['String']
  productRequired: Maybe<Scalars['String']>
  progress: Maybe<LearnProgress>
  quizTheme: QuizTheme
  /** @deprecated tierName is being replaced by productRequired */
  tierName: Scalars['String']
  title: Scalars['String']
}

export type QuizPreviewLocked = {
  __typename?: 'QuizPreviewLocked'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  lockedReason: Maybe<Scalars['String']>
  primaryTopicName: Scalars['String']
  productRequired: Scalars['String']
  quizTheme: QuizTheme
  title: Scalars['String']
}

export type QuizTheme = LearnThemeLiteral

export type RaffleEntry = {
  __typename?: 'RaffleEntry'
  createdAt: Scalars['DateTime']
  entryCount: Scalars['Int']
  milestoneName: Maybe<Scalars['String']>
  periodEnd: Scalars['Date']
  periodKey: Scalars['String']
  periodStart: Scalars['Date']
}

export type RateLimitDoesNotExistException = {
  __typename?: 'RateLimitDoesNotExistException'
  userId: Maybe<Scalars['ID']>
}

export type RateLimitStatus = {
  __typename?: 'RateLimitStatus'
  /** The remaining duration of the block in milliseconds */
  challengeBlockDurationRemaining: Maybe<Scalars['Int']>
  isBlocked: Scalars['Boolean']
  /** The remaining duration of the block in milliseconds */
  loginBlockDurationRemaining: Maybe<Scalars['Int']>
  /** The remaining duration of the block in milliseconds */
  passwordResetBlockDurationRemaining: Maybe<Scalars['Int']>
}

/** The link token for use in the client created account link URL. */
export type RawLinkSession = {
  __typename?: 'RawLinkSession'
  /** The External ID that should be used in the link creation process. */
  externalId: Scalars['ID']
  /** The Link Token a client should use for account linking. */
  token: Scalars['String']
}

/** RDVs are required user alert. */
export type RdvRequiredUserAlert = UserAlertsItem & {
  __typename?: 'RdvRequiredUserAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** The current funding source must be verified with RDVs prior to linking */
export type RdvVerificationRequired = {
  __typename?: 'RdvVerificationRequired'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

/** The RDVs were unable to be triggered */
export type RdvsNotTriggered = {
  __typename?: 'RdvsNotTriggered'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export type ReadMessageInput = {
  messageId: Scalars['ID']
}

export type RebalanceAlreadyExecutedError = {
  __typename?: 'RebalanceAlreadyExecutedError'
  customerId: Scalars['ID']
}

export type RebalanceSourceInsufficientBalanceError = {
  __typename?: 'RebalanceSourceInsufficientBalanceError'
  customerId: Scalars['ID']
}

export type RebalanceSuppressions = {
  __typename?: 'RebalanceSuppressions'
  clientHome: Maybe<Scalars['DateTime']>
  moneyManagerLander: Maybe<Scalars['DateTime']>
  moneyManagerRebalanceFlow: Maybe<Scalars['DateTime']>
}

export type RecaptchaException = {
  __typename?: 'RecaptchaException'
  errorCodes: Maybe<Array<Maybe<Scalars['String']>>>
}

/** Recommended investing strategy */
export type RecommendedInvestingStrategy = {
  __typename?: 'RecommendedInvestingStrategy'
  accountSubtype: SuitabilityAccountSubtype
  accountType: SuitabilityAccountType
  /** Timestamp when recommendation was recorded */
  createdAt: Scalars['DateTime']
  portfolioId: Maybe<Scalars['ID']>
}

export type RecordDoesNotExistError = {
  __typename?: 'RecordDoesNotExistError'
  message: Scalars['String']
}

/** Record view_at for investment account recap. */
export type RecordInvestmentAccountRecapViewInput = {
  /** The unique identifier of the investment account recap for which to update view_at timestamp. */
  investmentAccountRecapId: Scalars['ID']
}

/** Result of record view_at timestamp for investment account recap. */
export type RecordInvestmentAccountRecapViewResult =
  | InvestmentAccountRecap
  | InvestmentAccountRecapNotFoundException

export type RecordReferralEventInput = {
  /** Time Event got Recorded */
  eventRecordedAt?: InputMaybe<Scalars['DateTime']>
  /** Type of referral event */
  eventType: ReferralEventTypeV2
  /** Friend who triggered the Event */
  friendId: Scalars['ID']
  /** subType of the Event */
  subType?: InputMaybe<ReferralEventType>
}

export type RecordReferralEventResult =
  | QualificationSubTypeMismatchError
  | ReferralEventV2
  | ReferralRelationshipMissingError
  | RelationshipAlreadyQualifiedError

export type RecordStreakActivityInput = {
  activityType: StreakActivityType
}

export type RecordStreakActivityResult = {
  __typename?: 'RecordStreakActivityResult'
  streak: Streak
}

/** Input for recording a new tax refund event */
export type RecordTaxRefundInput = {
  /** Date when the refund arrived */
  arrivalDate: Scalars['Date']
  /** External identifier for the refund */
  externalId: Scalars['String']
  /** Indicates if this transaction is an account funding source */
  isAccountFundingSource: Scalars['Boolean']
  /** Identifier of the linked account if applicable */
  linkedAccountId?: InputMaybe<Scalars['ID']>
  /** Identifier of the linked subaccount if applicable */
  linkedSubaccountId?: InputMaybe<Scalars['ID']>
  /** Notification status (defaults to NOT_SENT if not provided) */
  notificationStatus?: InputMaybe<TaxRefundNotificationStatus>
  /** Timestamp when notification was sent (defaults to now if notificationStatus is SENT and no timestamp is provided) */
  notificationTimestamp?: InputMaybe<Scalars['DateTime']>
  /** Optional subtype specifying more details about the refund (state code or US for federal) */
  refundSubtype?: InputMaybe<Scalars['String']>
  /** Type of tax refund (federal or state) */
  refundType: RefundType
  /** Total monetary amount of the refund */
  totalAmount: MicrosMoneyInput
  /** List of transactions that comprise this tax refund */
  transactions: Array<TaxRefundTransactionInput>
  /** User identifier associated with this tax refund */
  userId: Scalars['ID']
}

/** Input for recording an investment from a tax refund notification */
export type RecordTaxRefundInvestmentInput = {
  /** Amount that was invested (required) */
  investmentAmount: MicrosMoneyInput
  /** Timestamp when the investment was made (defaults to now if not provided) */
  investmentTimestamp?: InputMaybe<Scalars['DateTime']>
  /** Tax refund identifier */
  taxRefundId: Scalars['ID']
}

/** Response payload for the recordTaxRefundInvestment mutation */
export type RecordTaxRefundInvestmentPayload = {
  __typename?: 'RecordTaxRefundInvestmentPayload'
  /** The updated tax refund record */
  taxRefund: TaxRefund
}

/** Response payload for the recordTaxRefund mutation */
export type RecordTaxRefundPayload = {
  __typename?: 'RecordTaxRefundPayload'
  /** The newly created tax refund record */
  taxRefund: TaxRefund
}

export type RecordVendorExternalTransactionInput = {
  amount?: InputMaybe<Scalars['Float']>
  collectedAt?: InputMaybe<Scalars['DateTime']>
  description?: InputMaybe<Scalars['String']>
  paymentMethod?: InputMaybe<SubscriptionPaymentMethod>
}

export type RecordVendorExternalTransactionResult =
  | BillingVendorError
  | Transaction

export enum RecurrenceFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
}

export type RecurrenceRule = {
  __typename?: 'RecurrenceRule'
  byMonthDay: Maybe<Array<Scalars['Int']>>
  byWeekDay: Maybe<Array<DayOfWeek>>
  endDate: Maybe<Scalars['DateTime']>
  frequency: RecurrenceFrequency
  interval: Scalars['Int']
  startDate: Maybe<Scalars['DateTime']>
}

export type RecurrenceRuleInput = {
  byMonthDay?: InputMaybe<Array<Scalars['Int']>>
  byWeekDay?: InputMaybe<Array<DayOfWeek>>
  endDate?: InputMaybe<Scalars['DateTime']>
  frequency: RecurrenceFrequency
  interval: Scalars['Int']
  startDate?: InputMaybe<Scalars['DateTime']>
}

/** Input type for recurring investment settings */
export type RecurringInvestmentInput = {
  /** The amount to invest on a recurring basis */
  amount: Scalars['Float']
  /** The day of the week/month for the recurring investment */
  day: Scalars['Int']
  /** The frequency of the recurring investment (daily, weekly, monthly) */
  frequency: InvestmentFrequency
  /** Investment Account ID */
  investmentAccountId?: InputMaybe<Scalars['String']>
  /** Source Account ID */
  sourceAccountId?: InputMaybe<Scalars['String']>
}

export type RecurringInvestmentPayload = {
  __typename?: 'RecurringInvestmentPayload'
  recurringInvestmentSettings: RecurringInvestmentSettings
}

/** Recurring deposit settings for an account */
export type RecurringInvestmentSettings = TimestampsInterface & {
  __typename?: 'RecurringInvestmentSettings'
  amount: Maybe<Scalars['Float']>
  /** Created at */
  createdAt: Scalars['DateTime']
  day: Maybe<Scalars['Int']>
  frequency: Maybe<InvestmentFrequency>
  /** Investment account ID */
  investmentAccountId: Scalars['ID']
  /** Next scheduled date of a configured recurring investment. */
  nextInvestmentAt: Maybe<Scalars['Date']>
  /** Accounts Gateway ID of the account that will be debited for the recurring investment */
  sourceAccountId: Maybe<Scalars['String']>
  /** Updated at */
  updatedAt: Scalars['DateTime']
}

export type RecurringTransfer = {
  __typename?: 'RecurringTransfer'
  active: Scalars['Boolean']
  id: Scalars['ID']
  nextTransferDate: Maybe<Scalars['Date']>
  recurrenceRule: RecurrenceRule
  transferEvent: RecurringTransferEvent
}

export type RecurringTransferAccount = {
  __typename?: 'RecurringTransferAccount'
  id: Scalars['ID']
  type: RecurringTransferAccountType
}

export type RecurringTransferAccountIdFilterInput = {
  filter?: InputMaybe<RecurringTransferDirectionFilterInput>
  targetAccountId: Scalars['ID']
}

export type RecurringTransferAccountInput = {
  id: Scalars['ID']
  type: RecurringTransferAccountType
}

export enum RecurringTransferAccountType {
  Spend = 'SPEND',
}

export type RecurringTransferDate = {
  __typename?: 'RecurringTransferDate'
  nextTransferDate: Maybe<Scalars['Date']>
}

export enum RecurringTransferDirection {
  Deposit = 'DEPOSIT',
  Withdrawal = 'WITHDRAWAL',
}

export type RecurringTransferDirectionFilterInput = {
  direction: RecurringTransferDirection
}

export type RecurringTransferEvent = {
  __typename?: 'RecurringTransferEvent'
  amount: CurrencyAmount
  direction: RecurringTransferDirection
  fundingSource: RecurringTransferFundingSource
  targetAccount: RecurringTransferAccount
}

export type RecurringTransferEventInput = {
  amount: CurrencyAmountInput
  direction: RecurringTransferDirection
  fundingSource: RecurringTransferFundingSourceInput
  targetAccount: RecurringTransferAccountInput
}

export type RecurringTransferFundingSource = {
  __typename?: 'RecurringTransferFundingSource'
  id: Scalars['ID']
  type: RecurringTransferFundingSourceType
}

export type RecurringTransferFundingSourceInput = {
  id: Scalars['ID']
  type: RecurringTransferFundingSourceType
}

export enum RecurringTransferFundingSourceType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL',
}

export type RecurringTransferPathException = {
  __typename?: 'RecurringTransferPathException'
  exception: RecurringTransferPathExceptionCase
  path: Array<Scalars['String']>
}

export enum RecurringTransferPathExceptionCase {
  Blank = 'BLANK',
  InvalidValue = 'INVALID_VALUE',
}

export type RecurringTransfersFilterInput = {
  filter?: InputMaybe<RecurringTransferAccountIdFilterInput>
  targetAccountType: RecurringTransferAccountType
}

export type RedeemedWaiverCoupon = {
  __typename?: 'RedeemedWaiverCoupon'
  couponId: Maybe<Scalars['String']>
  discountAmount: Scalars['Float']
  discountType: Scalars['String']
  waiverPeriodEndDate: Scalars['String']
  waiverType: Scalars['String']
}

/** Fetch a referral */
export type Referral = {
  __typename?: 'Referral'
  code: Scalars['String']
  referreeRewardAmount: Scalars['Float']
  referrerRewardAmount: Scalars['Float']
  url: Scalars['String']
}

/** Object with friend campaign information such as completed events and reward statuses */
export type ReferralCampaign = {
  __typename?: 'ReferralCampaign'
  /** The email of the advocate participating in the campaign */
  advocateEmail: Scalars['String']
  /**
   * Advocate Reward for completing all necessary steps. The object assumes that the
   * advocateUserId on type ReferralCampaign is the user that will receive the reward, but
   * friends can potentially have multiple advocates. Further investigation may be required.
   */
  advocateRewards: Maybe<Array<ReferralReward>>
  /** The id of the advocate participating in the campaign */
  advocateUserId: Maybe<Scalars['ID']>
  /** The id of the referral campaign that is also associated with the campaign id in Extole */
  campaignId: Scalars['ID']
  /** A list of events and their statuses to earn reward */
  events: Maybe<Array<ReferralEvent>>
  /** The email of the friend participating in the campaign */
  friendEmail: Scalars['String']
  /** Friend Reward for completing all necessary steps */
  friendRewards: Maybe<Array<ReferralReward>>
  /** The id of the friend participating in the campaign */
  friendUserId: Maybe<Scalars['ID']>
  /** The name of the campaign */
  name: Maybe<Scalars['String']>
}

export type ReferralCampaignConnection = {
  __typename?: 'ReferralCampaignConnection'
  autoAddCampaignId: Maybe<Scalars['ID']>
  edges: Maybe<Array<ReferralCampaignEdge>>
  fallbackCampaignId: Maybe<Scalars['ID']>
  pageInfo: ReferralPaginatedInfo
}

export type ReferralCampaignEdge = {
  __typename?: 'ReferralCampaignEdge'
  cursor: Scalars['String']
  node: ReferralCampaignV2
}

export type ReferralCampaignReward = {
  __typename?: 'ReferralCampaignReward'
  /** @deprecated Use amountMicros. */
  amount: Scalars['Float']
  amountMicros: MicrosMoney
  hurdle: Scalars['Int']
  id: Scalars['ID']
  repeated: Scalars['Boolean']
  targets: Array<ReferralCampaignRewardTarget>
  type: ReferralCampaignRewardType
}

export enum ReferralCampaignRewardTarget {
  Advocate = 'ADVOCATE',
  Friend = 'FRIEND',
}

export enum ReferralCampaignRewardType {
  Investment = 'INVESTMENT',
  Other = 'OTHER',
}

export type ReferralCampaignV2 = {
  __typename?: 'ReferralCampaignV2'
  /** Action feed description that appear in the App */
  actionFeedDesc: Maybe<Scalars['String']>
  /** flag to indicate ongoing/live campaign */
  activeInHouseCampaign: Maybe<Scalars['Boolean']>
  /** Default campaign for new signups for the week */
  autoAdd: Scalars['Boolean']
  /** Background for the campaign */
  background: Scalars['String']
  /** Condensed Title that appear in the App */
  condensedTitle: Maybe<Scalars['String']>
  /** Description that appear in the App */
  description: Scalars['String']
  /** qualificationAction can be performed upto */
  eligibilityEnd: Maybe<Scalars['DateTime']>
  /** Default campaign for any non-new signups that are not assigned a campaign */
  fallback: Scalars['Boolean']
  /** Hide a campaign in Admin (Not implemented) */
  hidden: Scalars['Boolean']
  /** Icon for the campaign */
  icon: Scalars['String']
  /** Unique identifier for referral campaign */
  id: Maybe<Scalars['ID']>
  /** Internal use memo for campaign */
  internalMemo: Maybe<Scalars['String']>
  /** Internal name for the campaign */
  name: Maybe<Scalars['String']>
  /** Additional buffer days for disqualified payouts */
  payoutExpiryBufferDays: Maybe<Scalars['Int']>
  /** Campaign available in the App to */
  publishEnd: Maybe<Scalars['DateTime']>
  /** Campaign available in the App from */
  publishStart: Scalars['DateTime']
  /** Status of a campaign after being published */
  publishedStatus: Maybe<PublishedCampaignStatus>
  /** Allows production QA mode for unpublished campaigns */
  qa: Scalars['Boolean']
  /** Qualifying action a freidn need to perform */
  qualificationAction: Scalars['String']
  /**
   * Minimum qualifying amount for the action
   * @deprecated Use qualificationAmountMicros.
   */
  qualificationAmount: Scalars['Int']
  /** Same threshold as `qualificationAmount`, in USD micros (redundant field for MicrosMoney clients). */
  qualificationAmountMicros: MicrosMoney
  /** Rewards associated to the campaign */
  rewards: Array<ReferralCampaignReward>
  /** Publishing Status for a campaign */
  status: CampaignStatus
  /** Title that appear in the App */
  title: Scalars['String']
}

/** Object containing status of event associated with a Referral */
export type ReferralEvent = {
  __typename?: 'ReferralEvent'
  /** Date event was completed if status is 'COMPLETED' */
  dateCompleted: Maybe<Scalars['DateTime']>
  /**
   * Referral event nonce
   * @deprecated Field no longer supported
   */
  referralEventId: Maybe<Scalars['String']>
  /** Type of referral event */
  referralEventType: ReferralEventType
  /** Status based on activity of friend */
  status: ReferralEventStatus
}

/** input type specifying the parameters to create an event */
export type ReferralEventInput = {
  eventDetails?: InputMaybe<Scalars['JSON']>
  eventNonce?: InputMaybe<Scalars['ID']>
  eventType: ReferralEventType
  userId: Scalars['String']
}

/** Status of referral events */
export enum ReferralEventStatus {
  /** Friend has completed event */
  Completed = 'COMPLETED',
  /** Friend has not started or completed event */
  NotStarted = 'NOT_STARTED',
  /** Friend has initiated event but event has not fully processed */
  Pending = 'PENDING',
}

/** Descriptions of User actions needed to earn reward */
export enum ReferralEventType {
  /** User has made a transfer into a Spend Account */
  DepositSpend = 'DEPOSIT_SPEND',
  /** User has opened an Early account */
  EarlyAccountOpened = 'EARLY_ACCOUNT_OPENED',
  /** User has a funding source linked */
  FsLinked = 'FS_LINKED',
  /** User has made initial investment into core account */
  InvestCore = 'INVEST_CORE',
  /** User has made initial investment into early account */
  InvestEarly = 'INVEST_EARLY',
  /** User has made initial investment into later account */
  InvestLater = 'INVEST_LATER',
  /** User has opened a Later account */
  LaterAccountOpened = 'LATER_ACCOUNT_OPENED',
  /** User has signed the referral agreement */
  ReferralAgreementSigned = 'REFERRAL_AGREEMENT_SIGNED',
  /** User has completed registration */
  RegistrationCompleted = 'REGISTRATION_COMPLETED',
  /** User has initialized the registration process */
  SignedUp = 'SIGNED_UP',
  /** User has opened a Spend account */
  SpendAccountOpened = 'SPEND_ACCOUNT_OPENED',
  /** User has paid their subscription */
  SubscriptionPaid = 'SUBSCRIPTION_PAID',
  /** Unknown referral event type */
  Unknown = 'UNKNOWN',
  /** User has been verified */
  UserVerified = 'USER_VERIFIED',
}

/** Descriptions of Friend Events */
export enum ReferralEventTypeV2 {
  /** User has made initial investment */
  FirstHoldingsCreated = 'FIRST_HOLDINGS_CREATED',
  /** User has completed registration */
  UserRegistrationCompleted = 'USER_REGISTRATION_COMPLETED',
}

/** Object containing status of event associated with a Referra In-house platform */
export type ReferralEventV2 = {
  __typename?: 'ReferralEventV2'
  /** Advocate who is associated the Event */
  advocateId: Scalars['ID']
  /** Campaign associated the Event */
  campaignId: Scalars['ID']
  /** Time Event got Created */
  created: Scalars['DateTime']
  /** Is it an Eligible Event */
  eligible: Scalars['Boolean']
  /** Time Event got Recorded */
  eventRecordedAt: Maybe<Scalars['DateTime']>
  /** Type of referral event */
  eventType: ReferralEventTypeV2
  /** Friend who triggered the Event */
  friendId: Scalars['ID']
  /** Referral event Id */
  id: Scalars['ID']
  /** Relationship associated the Event */
  relationshipId: Scalars['ID']
}

/** Object that holds referral statistics for an Acorns User */
export type ReferralHistory = {
  __typename?: 'ReferralHistory'
  friendHistory: Maybe<FriendHistoryConnection>
  friendSummary: Maybe<Array<FriendSummary>>
  /** The number of completed referrals for a user */
  numCompletedReferrals: Maybe<Scalars['Int']>
  /** The number of status pending referrals for a user */
  numPendingReferrals: Maybe<Scalars['Int']>
  /**
   * The total monetary reward amount the user has earned
   * @deprecated Use totalReferralRewardsEarnedMicros.
   */
  totalReferralRewardsEarned: Maybe<CurrencyAmount>
  /** The total monetary reward amount the user has earned (integer micros), when present */
  totalReferralRewardsEarnedMicros: Maybe<MicrosMoney>
  userId: Maybe<Scalars['ID']>
}

/** Object that holds referral statistics for an Acorns User */
export type ReferralHistoryFriendHistoryArgs = {
  campaignId?: InputMaybe<Scalars['ID']>
  filter: ReferralPaginatedFilter
}

export type ReferralLedger = {
  __typename?: 'ReferralLedger'
  failedRewards: ReferralLedgerEntryConnection
  investedRewards: ReferralLedgerEntryConnection
  /**
   * When `page` is omitted, returns all entries in this bucket.
   * When set, `limit` is clamped to 0–100; use `after` with the previous page's `endCursor`.
   */
  pendingRewards: ReferralLedgerEntryConnection
  /** Totals over all rows in each bucket after `referralLedger` filter; ignores connection `page` args. */
  summary: ReferralLedgerSummary
}

export type ReferralLedgerFailedRewardsArgs = {
  page?: InputMaybe<ReferralPaginatedFilter>
}

export type ReferralLedgerInvestedRewardsArgs = {
  page?: InputMaybe<ReferralPaginatedFilter>
}

export type ReferralLedgerPendingRewardsArgs = {
  page?: InputMaybe<ReferralPaginatedFilter>
}

/**
 * Per-bucket aggregates for the same filtered ledger rows as the connections.
 * `totalAmountMicros` sums `reward.amountMicros` for every row in the bucket (one row per target;
 * dual-target rewards count the full reward amount once per target row).
 */
export type ReferralLedgerBucketSummary = {
  __typename?: 'ReferralLedgerBucketSummary'
  entryCount: Scalars['Int']
  totalAmountMicros: MicrosMoney
}

export type ReferralLedgerEntry = {
  __typename?: 'ReferralLedgerEntry'
  campaign: Maybe<ReferralCampaignV2>
  investedAt: Maybe<Scalars['DateTime']>
  investedBy: Maybe<Scalars['DateTime']>
  payoutId: Scalars['ID']
  reward: Maybe<ReferralCampaignReward>
  status: ReferralPayoutStatus
  statusChangeAt: Maybe<Scalars['DateTime']>
  target: ReferralCampaignRewardTarget
}

export type ReferralLedgerEntryConnection = {
  __typename?: 'ReferralLedgerEntryConnection'
  edges: Array<ReferralLedgerEntryEdge>
  pageInfo: ReferralPaginatedInfo
}

export type ReferralLedgerEntryEdge = {
  __typename?: 'ReferralLedgerEntryEdge'
  cursor: Scalars['String']
  node: ReferralLedgerEntry
}

export type ReferralLedgerFilter = {
  rewardTarget?: InputMaybe<ReferralCampaignRewardTarget>
  rewardType?: InputMaybe<ReferralLedgerRewardType>
}

export enum ReferralLedgerRewardType {
  Burst = 'BURST',
  Evergreen = 'EVERGREEN',
}

export type ReferralLedgerSummary = {
  __typename?: 'ReferralLedgerSummary'
  failed: ReferralLedgerBucketSummary
  invested: ReferralLedgerBucketSummary
  /** Sum of pending and invested only; excludes failed (same per-target counting). */
  overall: ReferralLedgerBucketSummary
  pending: ReferralLedgerBucketSummary
}

export type ReferralPaginatedFilter = {
  /** Cursor to start pagination results for (exclusive) */
  after?: InputMaybe<Scalars['String']>
  /** Number of nodes to return */
  limit?: InputMaybe<Scalars['Int']>
}

export type ReferralPaginatedInfo = {
  __typename?: 'ReferralPaginatedInfo'
  /** Cursor corresponding to the last node in the list of edges */
  endCursor: Maybe<Scalars['String']>
  /** Indicates whether more edges exist following the set defined by the filter */
  hasNextPage: Scalars['Boolean']
  /** Indicates whether more edges exist prior to the set defined by the filter */
  hasPreviousPage: Scalars['Boolean']
  /** Cursor corresponding to the first node in the list of edges */
  startCursor: Maybe<Scalars['String']>
}

export type ReferralPayout = {
  __typename?: 'ReferralPayout'
  advocateId: Maybe<Scalars['ID']>
  advocateOfferId: Maybe<Scalars['String']>
  /** When the advocate reward was actually invested (from offer-system). Set only when advocate_offer_id is present. */
  advocateRewardedAt: Maybe<Scalars['DateTime']>
  campaign: Maybe<ReferralCampaignV2>
  created: Maybe<Scalars['DateTime']>
  friendId: Maybe<Scalars['ID']>
  friendOfferId: Maybe<Scalars['String']>
  /** When the friend reward was actually invested (from offer-system). Set only when friend_offer_id is present. */
  friendRewardedAt: Maybe<Scalars['DateTime']>
  payoutId: Scalars['ID']
  payoutRelationships: Maybe<Array<ReferralPayoutRelationship>>
  reason: Maybe<ReferralPayoutDisqualificationReason>
  reward: Maybe<ReferralCampaignReward>
  status: Maybe<ReferralPayoutStatus>
  statusChangeAt: Maybe<Scalars['DateTime']>
  statusChangeBy: Maybe<Scalars['String']>
  updated: Maybe<Scalars['DateTime']>
}

export type ReferralPayoutPayoutRelationshipsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>
}

export type ReferralPayoutConnection = {
  __typename?: 'ReferralPayoutConnection'
  edges: Maybe<Array<ReferralPayoutEdge>>
  pageInfo: ReferralPaginatedInfo
}

export enum ReferralPayoutDisqualificationReason {
  HurdleNoLongerMet = 'HURDLE_NO_LONGER_MET',
  Other = 'OTHER',
  TargetValidationAdvocateEmployeeCheckFailed = 'TARGET_VALIDATION_ADVOCATE_EMPLOYEE_CHECK_FAILED',
  TargetValidationAdvocateInvestmentAccountClosed = 'TARGET_VALIDATION_ADVOCATE_INVESTMENT_ACCOUNT_CLOSED',
  TargetValidationAdvocateNotVerified = 'TARGET_VALIDATION_ADVOCATE_NOT_VERIFIED',
  TargetValidationAdvocateSubscriptionInactive = 'TARGET_VALIDATION_ADVOCATE_SUBSCRIPTION_INACTIVE',
  TargetValidationAdvocateSuspended = 'TARGET_VALIDATION_ADVOCATE_SUSPENDED',
  TargetValidationFailed = 'TARGET_VALIDATION_FAILED',
  TargetValidationFriendInvestmentAccountClosed = 'TARGET_VALIDATION_FRIEND_INVESTMENT_ACCOUNT_CLOSED',
  TargetValidationFriendNotVerified = 'TARGET_VALIDATION_FRIEND_NOT_VERIFIED',
  /** Friend passed account standing checks but had no qualifying investment by campaign eligibility end. */
  TargetValidationFriendNoQualifyingInvestment = 'TARGET_VALIDATION_FRIEND_NO_QUALIFYING_INVESTMENT',
  TargetValidationFriendSubscriptionInactive = 'TARGET_VALIDATION_FRIEND_SUBSCRIPTION_INACTIVE',
  TargetValidationFriendSuspended = 'TARGET_VALIDATION_FRIEND_SUSPENDED',
}

export type ReferralPayoutEdge = {
  __typename?: 'ReferralPayoutEdge'
  cursor: Scalars['String']
  node: ReferralPayout
}

export type ReferralPayoutExistsError = {
  __typename?: 'ReferralPayoutExistsError'
  message: Scalars['String']
}

export type ReferralPayoutRelationship = {
  __typename?: 'ReferralPayoutRelationship'
  advocateId: Maybe<Scalars['ID']>
  archived: Maybe<Scalars['Boolean']>
  created: Maybe<Scalars['DateTime']>
  disqualificationReason: Maybe<ReferralPayoutDisqualificationReason>
  friendId: Maybe<Scalars['ID']>
  payoutId: Scalars['ID']
  payoutRelationshipId: Maybe<Scalars['ID']>
  relationshipId: Scalars['ID']
  updatedAt: Maybe<Scalars['DateTime']>
}

export enum ReferralPayoutStatus {
  /** Only Advocate among multi-targets is rewarded */
  AdvocateOnlyRewarded = 'ADVOCATE_ONLY_REWARDED',
  /** Payout has met the hurdle in the holdout period */
  Approved = 'APPROVED',
  /** Payout have been Cancelled or Paid outside the Automated system */
  Cancelled = 'CANCELLED',
  /** Payout has been disqualified due to validation check fails */
  Disqualified = 'DISQUALIFIED',
  /** Payout have expired as the eligibility end date passed for disqualified payout */
  Expired = 'EXPIRED',
  /** Only Friend among multi-targets is rewarded */
  FriendOnlyRewarded = 'FRIEND_ONLY_REWARDED',
  /** Payout have been sent for fulfillment */
  Fulfilled = 'FULFILLED',
  /** Payout started the process for fulfillment */
  Fulfilling = 'FULFILLING',
  /** Payout is held because advocate joined within the last 3 months; released when advocate reaches 3-month mark. */
  Held = 'HELD',
  /** Payout has been created, but hurdle not met yet */
  Pending = 'PENDING',
  /** Payout has been rejected manually (not used) */
  Rejected = 'REJECTED',
  /** All target rewarded are invested */
  Rewarded = 'REWARDED',
  /** All target rewards failed to be invested */
  RewardFailed = 'REWARD_FAILED',
}

export type ReferralPayoutsFilter = {
  advocateId?: InputMaybe<Scalars['ID']>
  campaignId?: InputMaybe<Scalars['ID']>
  displayCancelled?: InputMaybe<Scalars['Boolean']>
  payoutId?: InputMaybe<Scalars['ID']>
  statusList?: InputMaybe<Array<ReferralPayoutStatus>>
}

export type ReferralRelationship = {
  __typename?: 'ReferralRelationship'
  advocateId: Scalars['ID']
  campaignId: Scalars['ID']
  friendId: Scalars['ID']
  status: ReferralRelationshipStatus
  statusChangeAt: Maybe<Scalars['DateTime']>
}

export type ReferralRelationshipConnection = {
  __typename?: 'ReferralRelationshipConnection'
  edges: Maybe<Array<ReferralRelationshipEdge>>
  pageInfo: ReferralPaginatedInfo
}

export type ReferralRelationshipEdge = {
  __typename?: 'ReferralRelationshipEdge'
  cursor: Scalars['String']
  node: ReferralRelationship
}

export type ReferralRelationshipMissingError = {
  __typename?: 'ReferralRelationshipMissingError'
  message: Scalars['String']
}

/** Status of referral relationship */
export enum ReferralRelationshipStatus {
  /** Relationship has been created */
  Created = 'CREATED',
  /** Relationship is eligible for payout */
  Eligible = 'ELIGIBLE',
  /** Relationship payout has been fulfilled */
  Fulfilled = 'FULFILLED',
  /** Relationship is ineligible for payout */
  Ineligible = 'INELIGIBLE',
  /** Friend has completed first inevestment */
  Invested = 'INVESTED',
  /** Friend has completed registration */
  Registered = 'REGISTERED',
  /** Friend should reinvest since old investement do not qualify */
  ReinvestNeeded = 'REINVEST_NEEDED',
  /** Friend was rewarded */
  Rewarded = 'REWARDED',
  /** Friend reward investment failed - Advocate might have still been rewarded */
  RewardFailed = 'REWARD_FAILED',
}

export type ReferralRelationshipsFilter = {
  friendId?: InputMaybe<Scalars['ID']>
  status?: InputMaybe<ReferralRelationshipStatus>
}

/** Object containing reward information for completing a campaign */
export type ReferralReward = {
  __typename?: 'ReferralReward'
  /** Name of the referral reward */
  name: Maybe<Scalars['String']>
  /** The date the reward was fulfilled (if applicable) */
  rewardFulfilledAtDate: Maybe<Scalars['DateTime']>
  /** The status of the reward associated with activity campaign */
  rewardStatus: Maybe<ReferralRewardStatus>
  /** Value of reward for completing all events in a campaign */
  value: Scalars['String']
  /** Value type for completing all events in a campaign */
  valueType: Maybe<ReferralValueType>
}

export type ReferralRewardEdge = {
  __typename?: 'ReferralRewardEdge'
  cursor: Scalars['String']
  node: ReferralCampaignReward
}

/** The current status of a referral reward */
export enum ReferralRewardStatus {
  /** User has earned reward by completing all campaign steps, but reward still needs to be issued. */
  Earned = 'EARNED',
  /** Reward has been issued by Acorns */
  Fulfilled = 'FULFILLED',
  /** Reward has not been created */
  NotCreated = 'NOT_CREATED',
}

/** Summary of updated reward */
export type ReferralRewardSummary = {
  __typename?: 'ReferralRewardSummary'
  /** The Acorns User acting as an advocate for this referral reward */
  advocateUserId: Maybe<Scalars['ID']>
  /** Status of this referral for Friend/Acorns User */
  status: ReferralRewardStatus
}

export enum ReferralRewardUpdateStatus {
  /** Referral has been cancelled */
  Cancelled = 'CANCELLED',
  /** User and Friend have been rewarded */
  Rewarded = 'REWARDED',
}

export type ReferralRewardsConnection = {
  __typename?: 'ReferralRewardsConnection'
  edges: Maybe<Array<ReferralRewardEdge>>
  pageInfo: ReferralPaginatedInfo
}

export enum ReferralStatus {
  /** Referral has been cancelled */
  Cancelled = 'CANCELLED',
  /** User and Friend have completed referral and should be rewarded */
  Completed = 'COMPLETED',
  /** Referral has expired because events were not finished before campaign end date */
  Expired = 'EXPIRED',
  /** Friend has used referral code but still has events they need to complete */
  Pending = 'PENDING',
  /** User and Friend have been rewarded */
  Rewarded = 'REWARDED',
  /** Referral has been sent to a friend */
  Sent = 'SENT',
}

/** input type specifyig the parameters that can be updated */
export type ReferralUserUpdateInput = {
  email: Scalars['String']
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['ID']>
}

/** Value types of reward associated with completion of a referral */
export enum ReferralValueType {
  Usd = 'USD',
}

export type RefreshAuthTokenInput = {
  pin?: InputMaybe<Scalars['String']>
  refreshToken: Scalars['String']
}

export type RefreshAuthTokenRateLimitedException = {
  __typename?: 'RefreshAuthTokenRateLimitedException'
  message: Maybe<Scalars['String']>
}

export type RefreshAuthTokenResult =
  | AuthSession
  | InvalidPinException
  | RefreshAuthTokenRateLimitedException
  | TokenExpiredException
  | UserSuspendedException

export type RefreshTokenNotFoundException = {
  __typename?: 'RefreshTokenNotFoundException'
  userId: Scalars['ID']
}

/** Types of tax refunds that can be processed */
export enum RefundType {
  /** Federal tax refund from the IRS */
  Federal = 'FEDERAL',
  /** State tax refund from a state tax agency */
  State = 'STATE',
}

/** Configuration for regenerating the public token of an investment account recap. */
export type RegenerateInvestmentAccountRecapPublicTokenInput = {
  /** The unique identifier of the investment account recap for which a public token is being regenerated. */
  id: Scalars['ID']
}

/** Result of regenerating the public token of an investment account recap. */
export type RegenerateInvestmentAccountRecapPublicTokenResult =
  | InvestmentAccountRecap
  | InvestmentAccountRecapNotFoundException

export type RegisterAccountTypeResult = RegisterAccountTypeResultTemporaryImpl

export type RegisterAccountTypeResultTemporaryImpl = {
  __typename?: 'RegisterAccountTypeResultTemporaryImpl'
  someField: Scalars['String']
}

export type RegisterCredentialsInput = {
  acceptanceDocumentVersionUuids?: InputMaybe<
    Array<InputMaybe<Scalars['String']>>
  >
  email: Scalars['EmailAddress']
  password: Scalars['String']
  udid: Scalars['String']
  usResident?: InputMaybe<Scalars['Boolean']>
}

export type RegisterCredentialsResult =
  | AuthSession
  | EmailTakenException
  | InvalidPasswordException
  | MissingRequiredAgreementsException

export type RegisterDeviceTokenAndPushAuthenticatorInput = {
  deviceId: Scalars['ID']
  deviceToken: Scalars['String']
  deviceType: DeviceType
  name?: InputMaybe<Scalars['String']>
}

export type RegisterDeviceTokenAndPushAuthenticatorResult =
  | InvalidDeviceParametersException
  | PushAuthenticator
  | PushAuthenticatorAlreadyExistsException

export type RegisterEmailAuthenticatorInput = {
  email: Scalars['EmailAddress']
  name?: InputMaybe<Scalars['String']>
  setDefault?: InputMaybe<Scalars['Boolean']>
}

export type RegisterEmailAuthenticatorResult =
  | AuthChallengeAnswerAttemptsExhaustedException
  | AuthChallengeAnswerIncorrectException
  | AuthChallengeExpiredException
  | AuthenticatorTypeAlreadyRegisteredException
  | EmailAuthenticator
  | ExistingEmailVerifiedException

/** Returns Layer session information */
export type RegisterLayerLinkSessionResult =
  | LayerLinkSession
  | UnrecoverableError

/** Returns a Linked Account Type or AsyncLinkSessionResult. */
export type RegisterLinkSessionResult = AsyncLinkSessionResult | LinkedAccount

export type RegisterOidcCredentialsInput = {
  /** Identity token signed by external Oidc provider */
  idToken: Scalars['String']
  /** Nonce used in the request to prevent replay attacks. */
  nonce: Scalars['String']
  oidcProvider: OidcProvider
  /** A unique identifier representing the Device the client is running on. */
  udid: Scalars['String']
}

export type RegisterOidcCredentialsResult =
  | AuthSession
  | AuthenticatorUnavailableException
  | EmailTakenException
  | InvalidAppleAccountException
  | InvalidCredentialsException
  | InvalidGoogleAccountException
  | UserSuspendedException
  | ValidateCredentialsSuccess

export type RegisterPhoneAuthenticatorInput = {
  name?: InputMaybe<Scalars['String']>
  phoneNumber: Scalars['PhoneNumber']
  setDefault?: InputMaybe<Scalars['Boolean']>
}

export type RegisterPhoneAuthenticatorResult =
  | AuthChallengeAnswerAttemptsExhaustedException
  | AuthChallengeAnswerIncorrectException
  | AuthChallengeExpiredException
  | AuthenticatorTypeAlreadyRegisteredException
  | InvalidPhoneNumberException
  | PhoneAuthenticator

export type RegisterPhoneAuthenticatorWithoutChallengeResult =
  | InvalidPhoneNumberException
  | PhoneAuthenticator

/** Input for the registerProspect mutation initially registering a prospect user. */
export type RegisterProspectInput = {
  /** Flag indicating if source identifier can be overridden or not */
  amendableSource?: InputMaybe<Scalars['Boolean']>
  /** Email address for prospect used during initial sign-up */
  email?: InputMaybe<Scalars['String']>
  /** Contextual attributes representing parameters surrounding user sign-up */
  sourceAttributes: SourceAttributesInput
}

/** Union for the result of the registerProspect mutation */
export type RegisterProspectResult =
  | InvalidConversionIdentifierException
  | InvalidSourceAttributesException
  | RegistrationFunnel

/** Properties for displaying drawer content on page */
export type RegistrationDrawerContent = {
  __typename?: 'RegistrationDrawerContent'
  body: Scalars['String']
  image: Scalars['URL']
  title: Scalars['String']
}

/** Information about funnel experience */
export type RegistrationFunnel = {
  __typename?: 'RegistrationFunnel'
  /** List of pages within funnel */
  flow: Array<RegistrationPage>
  /** User's funnel information */
  metadata: FunnelMetadata
  sourceAttributes: SourceAttributes
}

/** Available fields to filter for a specific user's funnel experience */
export type RegistrationFunnelFilter = {
  /** Email address for prospect that was used during initial sign up */
  email?: InputMaybe<Scalars['String']>
  /** User's unique identifier */
  userId?: InputMaybe<Scalars['ID']>
}

/** Registration fields */
export type RegistrationInput = {
  /** The entry point for a registration */
  funnel: Funnel
}

/** Single page within registration flow */
export type RegistrationPage = {
  __typename?: 'RegistrationPage'
  actions: Array<RegistrationPageAction>
  content: Maybe<RegistrationPageContent>
  isBackEnabled: Scalars['Boolean']
  name: PageName
}

/** CTAs that can be performed on the page */
export type RegistrationPageAction = {
  __typename?: 'RegistrationPageAction'
  /** Page that CTA will route to */
  nextPage: PageName
  type: ActionType
}

/** Base interface for registration page components */
export type RegistrationPageContent = {
  campaignId: Scalars['String']
  title: Scalars['String']
}

/** Properties for displaying banner on page */
export type RegistrationProminenceBannerContent = RegistrationPageContent & {
  __typename?: 'RegistrationProminenceBannerContent'
  campaignId: Scalars['String']
  drawer: Maybe<RegistrationDrawerContent>
  icon: Scalars['URL']
  title: Scalars['String']
}

export type ReinitiateSmsChallengeInput = {
  challengeId: Scalars['ID']
}

export type ReinitiateSmsChallengeResult =
  | AuthChallengeExpiredException
  | ChallengeRateExceededException
  | EmailAuthChallenge
  | InvalidMfaTokenException
  | PhoneNumberOptedOutException
  | SmsAuthChallenge

/** The reason why the reinvestment was created */
export enum ReinvestmentReason {
  /** Reinvestment was created due to a debit overselling than what was requested */
  Oversell = 'OVERSELL',
}

export type ReissueBankCardEligibility =
  | ReissueBankCardEligible
  | ReissueBankCardIneligible

export type ReissueBankCardEligible = {
  __typename?: 'ReissueBankCardEligible'
  originalCardCreatedAt: Scalars['Date']
}

export type ReissueBankCardExistsError = {
  __typename?: 'ReissueBankCardExistsError'
  /** BankCardRequest id / new bank card id */
  id: Scalars['ID']
}

export type ReissueBankCardIneligible = {
  __typename?: 'ReissueBankCardIneligible'
  issues: Array<Maybe<ReissueBankCardIneligibleIssue>>
}

export enum ReissueBankCardIneligibleIssue {
  ActiveBankCardRequest = 'ACTIVE_BANK_CARD_REQUEST',
  CardAdminLocked = 'CARD_ADMIN_LOCKED',
  FirstCardNotIssuedYet = 'FIRST_CARD_NOT_ISSUED_YET',
}

export type ReissueBankCardInput = {
  mailingAddress?: InputMaybe<BankCardRequestMailingAddressInput>
  reason: BankCardRequestReason
  reasonComment?: InputMaybe<Scalars['String']>
  reasonDate?: InputMaybe<Scalars['Date']>
}

/**
 * Returned when an invalid reason is provided for a digital-only card reissue.
 * Only UNAUTHORIZED and OTHER reasons are allowed for digital-only cards.
 */
export type ReissueBankCardInvalidReasonError = {
  __typename?: 'ReissueBankCardInvalidReasonError'
  /** The list of allowed reasons for digital-only card reissue */
  allowedReasons: Array<BankCardRequestReason>
  /** The reason that was provided in the request */
  providedReason: BankCardRequestReason
}

/** Returned when a mailing address is required but not provided for a physical card reissue. */
export type ReissueBankCardMailingAddressRequiredError = {
  __typename?: 'ReissueBankCardMailingAddressRequiredError'
  /** Indicates this error is for a physical card that requires a mailing address */
  isPhysicalCard: Scalars['Boolean']
}

export type ReissueBankCardResult =
  | BankCardRequest
  | ReissueBankCardExistsError
  | ReissueBankCardInvalidReasonError
  | ReissueBankCardMailingAddressRequiredError

export enum RejectedReason {
  DocumentExpired = 'documentExpired',
  IncorrectDocumentType = 'incorrectDocumentType',
  IncorrectName = 'incorrectName',
  InvalidResidentialAddress = 'invalidResidentialAddress',
  MismatchedName = 'mismatchedName',
  MissingName = 'missingName',
  NoVisibleDate = 'noVisibleDate',
  NotEligibleForPromotion = 'notEligibleForPromotion',
  PoorImageQuality = 'poorImageQuality',
  SsnAlreadyUsed = 'ssnAlreadyUsed',
}

/**
 * Deprecated: recordReferralEvent no longer returns this.
 * When the relationship is already qualified, the API now returns ReferralEventV2 (with eligible set by event type) so the consumer can process payouts. Kept in the union for backward compatibility with clients.
 */
export type RelationshipAlreadyQualifiedError = {
  __typename?: 'RelationshipAlreadyQualifiedError'
  message: Scalars['String']
}

/** Relink Linked Account Alert. */
export type RelinkLinkedAccountAlert = UserAlertsItem & {
  __typename?: 'RelinkLinkedAccountAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type RemoveAccountTypeResult = RemoveAccountTypeResultTemporaryImpl

export type RemoveAccountTypeResultTemporaryImpl = {
  __typename?: 'RemoveAccountTypeResultTemporaryImpl'
  someField: Scalars['String']
}

/** Input for removing cohorts */
export type RemoveCohortEligibilityInput = {
  /** List of cohort slugs to remove */
  remove: Array<Scalars['String']>
}

/** Removed Cohorts Result */
export type RemoveCohortEligibilityResult = UserCohorts

export type RemoveDesignatedBeneficiaryResult =
  | DesignatedBeneficiaryNotFoundException
  | RemoveDesignatedBeneficiarySuccess

export type RemoveDesignatedBeneficiarySuccess = {
  __typename?: 'RemoveDesignatedBeneficiarySuccess'
  beneficiaryId: Scalars['ID']
  userId: Scalars['ID']
}

export type RemoveDesignationResult =
  | DesignationNotFoundException
  | RemoveDesignationSuccess

export type RemoveDesignationSuccess = {
  __typename?: 'RemoveDesignationSuccess'
  accountId: Scalars['ID']
  beneficiaryId: Scalars['ID']
  designationId: Scalars['ID']
  userId: Scalars['ID']
}

export type RemoveJobAlertResult = RemovedJobAlert

export type RemoveLaterBeneficiaryResult = {
  __typename?: 'RemoveLaterBeneficiaryResult'
  investmentAccountId: Maybe<Scalars['ID']>
  message: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type RemovePolicyInput = {
  name: Scalars['String']
}

export type RemovePolicyResult =
  | PoliciesRecordDoesNotExistException
  | ValidPolicies

/** Input to remove a security from a portfolio */
export type RemoveSecurityFromPortfolioInput = {
  /** Investment account ID */
  investmentAccountId: Scalars['ID']
  /** The market exchange symbol of the ETF to remove from the portfolio */
  symbol: Scalars['String']
}

/** Result from removing a security from a portfolio */
export type RemoveSecurityFromPortfolioResult =
  | InvestmentAccountNotFoundException
  | InvestmentAccountNotSupportedException
  | Portfolio
  | PortfolioNotFoundException
  | PortfolioNotSupportedException
  | SecurityNotSupportedException

export type RemoveSecurityOverridesFailed = {
  __typename?: 'RemoveSecurityOverridesFailed'
  description: Scalars['String']
}

export type RemoveSecurityOverridesInput = {
  fields: Array<SecurityOverridableField>
  symbol: Scalars['TickerSymbol']
}

export type RemoveSecurityOverridesResult =
  | RemoveSecurityOverridesFailed
  | RemoveSecurityOverridesSuccess

export type RemoveSecurityOverridesSuccess = {
  __typename?: 'RemoveSecurityOverridesSuccess'
  removedFields: Array<SecurityOverridableField>
  symbol: Scalars['TickerSymbol']
}

/** Remove self directed portfolio from an investment account closure request */
export type RemoveSelfDirectedPortfolioInput = {
  /** List of closure reason keys */
  accountClosureReasons?: InputMaybe<Array<Scalars['String']>>
  /** Any closure reason comments the user may have */
  comments?: InputMaybe<Scalars['String']>
  /** The ID of the investment account to be closed */
  investmentAccountId: Scalars['ID']
}

/** Self Directed Portfolio Closure Response */
export type RemoveSelfDirectedPortfolioResult =
  | AccountNotFoundException
  | InvestmentAccount
  | InvestmentAccountAlreadyClosed
  | InvestmentAccountClosureInProgress
  | InvestmentAccountNeedsTransferException
  | PortfolioAlreadyRemovedError
  | PortfolioNotFoundException
  | PortfolioRemovalInProgressError

/** Indicates remove operation succeeded */
export type RemovedJobAlert = {
  __typename?: 'RemovedJobAlert'
  id: Scalars['ID']
}

/** Reopen User Account Response */
export type ReopenUserAccountResult =
  | UserNotFoundException
  | UserReopenLockedException
  | UserReopenSuspendedException
  | User_V2

export type ReplayMoneyAssignmentError = {
  __typename?: 'ReplayMoneyAssignmentError'
  error: Scalars['String']
}

export type ReplayMoneyAssignmentSuccess = {
  __typename?: 'ReplayMoneyAssignmentSuccess'
  moneyAssignmentId: Scalars['ID']
}

export type ReplayMoneyManagerMoneyAssignmentInput = {
  forceReallocate: Scalars['Boolean']
  moneyAssignmentId: Scalars['ID']
  transferDelayInMilliseconds: Scalars['Int']
}

export type ReplayMoneyManagerMoneyAssignmentResult =
  | ReplayMoneyAssignmentError
  | ReplayMoneyAssignmentSuccess

export type ReportBankCardLostStolenInput = {
  lockReason: BankCardPermanentLockReason
}

export type ReportBankCardLostStolenPayload = {
  __typename?: 'ReportBankCardLostStolenPayload'
  bankCard: Maybe<BankCard>
}

export type RequestAccountClosureInput = {
  comments?: InputMaybe<Scalars['String']>
  reason: Scalars['String']
}

export type RequestContributionStickersInput = {
  code: Scalars['ID']
  orderContext: StickerOrderContext
  shippingAddress: ContributionStickerShippingAddressInput
}

export type RequestContributionStickersResult =
  | ContributionStickerRequest
  | ContributionStickerRequestInvalidInputError

/** Input for closing an early investment account */
export type RequestEarlyAccountClosureInput = {
  /** The ID's of the early accounts to be closed */
  investmentAccountIds: Array<Scalars['ID']>
  /** The reason for the account closure */
  reason: InvestmentAccountClosureReason
}

/** Result from closing an Investment Account */
export type RequestEarlyAccountClosureResult =
  | AccountAlreadyClosedException
  | ClosureRequestExistsException
  | FundingSourceRequiresRdvException
  | InternalErrorException
  | InvalidAccountTypeException
  | InvestmentAccount
  | InvestmentAccountNeedsTransferException
  | MissingFundingSourceException

/** Input for requesting to reopen an investment account */
export type RequestInvestmentAccountReopenInput = {
  /** The ID of the investment account to be reopened */
  investmentAccountId: Scalars['ID']
  /** ID of the portfolio for this investment account */
  portfolioId?: InputMaybe<Scalars['String']>
}

/** Result from requesting to reopen an investment account */
export type RequestInvestmentAccountReopenResult =
  | ExistingRequestPendingReview
  | ExistingRequestPendingUserAction
  | InvalidPortfolioIdException
  | InvalidSubscriptionTierException
  | InvestmentAccountNotClosedException
  | InvestmentAccountNotFoundException
  | InvestmentAccountReopenRequest

export type RequestLayerSessionInput = {
  publicToken: Scalars['String']
}

export type RequestLayerSessionResult =
  | RequestedLayerLinkSession
  | UnrecoverableError

/** Input for requesting login support for a matched account */
export type RequestMatchedAccountLoginSupportInput = {
  /** Email address for support to contact the customer */
  email?: InputMaybe<Scalars['String']>
  /** Phone number for support to contact the customer */
  phone?: InputMaybe<Scalars['PhoneNumber']>
}

/** Result from requesting login support for a matched account */
export type RequestMatchedAccountLoginSupportResult =
  RequestMatchedAccountLoginSupportSuccess

/** Successfully requested login support for a matched account */
export type RequestMatchedAccountLoginSupportSuccess = {
  __typename?: 'RequestMatchedAccountLoginSupportSuccess'
  message: Maybe<Scalars['String']>
}

export type RequestSubscriptionMigrationWaiverInput = {
  reason: SubscriptionMigrationWaiverReason
  subscriptionMigrationId: Scalars['ID']
}

export type RequestSubscriptionMigrationWaiverResult =
  | InvalidTierForMigrationError
  | SubscriptionMigrationInvalidError
  | SubscriptionMigrationWaiver

export enum RequestVersions {
  OptionalPhysicalCard = 'OPTIONAL_PHYSICAL_CARD',
  September_2022 = 'SEPTEMBER_2022',
}

/** Submitted customer information */
export type RequestedLayerLinkSession = {
  __typename?: 'RequestedLayerLinkSession'
  city: Maybe<Scalars['String']>
  country: Maybe<Scalars['String']>
  dateOfBirth: Maybe<Scalars['Date']>
  firstName: Maybe<Scalars['String']>
  lastName: Maybe<Scalars['String']>
  ssnStorageResult: SsnStorageResult
  state: Maybe<Scalars['String']>
  street1: Maybe<Scalars['String']>
  street2: Maybe<Scalars['String']>
  zipCode: Maybe<Scalars['String']>
}

export type ResendChatMessageResponse =
  | ChatHistoryMessage
  | ChatHistoryMessageNotFound

export type ResetPasswordByTokenException = {
  __typename?: 'ResetPasswordByTokenException'
  message: Maybe<Scalars['String']>
}

export type ResetPasswordByTokenInput = {
  last4Ssn?: InputMaybe<Scalars['String']>
  newPw: Scalars['String']
  newPwConfirmation: Scalars['String']
  resetToken: Scalars['String']
  securityAnswer?: InputMaybe<Scalars['String']>
}

export type ResetPasswordByTokenResult =
  | IncorrectSecurityAnswerException
  | IncorrectSsnException
  | InvalidPasswordException
  | ResetPasswordByTokenException
  | ResetPasswordByTokenSuccess
  | UserCredentialsNotFoundException

export type ResetPasswordByTokenSuccess = {
  __typename?: 'ResetPasswordByTokenSuccess'
  userId: Scalars['ID']
}

export type ResetPasswordWithTokenInput = {
  last4Ssn?: InputMaybe<Scalars['String']>
  password: Scalars['String']
  passwordConfirmation: Scalars['String']
  resetToken: Scalars['String']
}

export type ResetPasswordWithTokenResult =
  | InvalidPasswordResetException
  | InvalidPasswordResetTokenException
  | ResetPasswordWithTokenSuccess
  | UserCredentialsNotFoundException

export type ResetPasswordWithTokenSuccess = {
  __typename?: 'ResetPasswordWithTokenSuccess'
  userId: Scalars['ID']
}

export type ResetRateLimitResult =
  | RateLimitDoesNotExistException
  | ResetRateLimitSuccess

export type ResetRateLimitSuccess = {
  __typename?: 'ResetRateLimitSuccess'
  challengeRateLimitReset: Maybe<Scalars['Boolean']>
  loginRateLimitReset: Maybe<Scalars['Boolean']>
  passwordResetSsnBlockReset: Maybe<Scalars['Boolean']>
  userId: Maybe<Scalars['ID']>
}

export type ResourceNotFoundError = {
  __typename?: 'ResourceNotFoundError'
  requestId: Scalars['ID']
}

export type RespondToLearnPollInput = {
  pollId: Scalars['ID']
  selectedOption: Scalars['String']
}

export type RespondToLearnPollResult =
  | InvalidOptionException
  | LearnPollResponse
  | RecordDoesNotExistError

export type RestartTransactionSyncResult =
  | CustodianAccountNotFoundError
  | CustodianAccountSyncDetails
  | RestartTransactionSyncUnknownError
  | SyncNotInErrorStateError
  | SyncRecordNotFoundError

export type RestartTransactionSyncUnknownError = {
  __typename?: 'RestartTransactionSyncUnknownError'
  message: Scalars['String']
}

/** A registration record for a prospective user */
export type Result = {
  __typename?: 'Result'
  funnel: Funnel
}

export enum RetirementPlanAccess {
  /** Married user and spouse have access to a retirement plan */
  Both = 'both',
  /** Neither married user nor spouse have access to a retirement plan */
  Neither = 'neither',
  /** Single user has no access to retirement plan */
  No = 'no',
  /** Married user has access to a retirement plan without spouse */
  OnlyMe = 'onlyMe',
  /** Married user does not have access to a retirement plan, but spouse does */
  Spouse = 'spouse',
  /** Single user has access to an employer's retirement plan */
  Yes = 'yes',
}

/** Result from attempting to retrigger RDVs */
export type RetriggerRdvsResult = FundingSourceAccount | RdvsNotTriggered

export type RetryAccountCreationResult = {
  __typename?: 'RetryAccountCreationResult'
  accountId: Maybe<Scalars['ID']>
  message: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type RetryAccountReopenResult = {
  __typename?: 'RetryAccountReopenResult'
  accountId: Maybe<Scalars['ID']>
  message: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type RetryAccountUpdateResult = {
  __typename?: 'RetryAccountUpdateResult'
  accountId: Maybe<Scalars['ID']>
  message: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

/** A returned check */
export type ReturnedCheckDeposit = {
  __typename?: 'ReturnedCheckDeposit'
  /** Amount for check. */
  amount: CurrencyAmount
  /** Returned Check Deposit Image URL for back of check. */
  backCheckImageUrl: Scalars['String']
  /** Returned Check Deposit Image URL for front of check. */
  frontCheckImageUrl: Scalars['String']
  /** Date check was returned. */
  rejectedDate: Scalars['DateTime']
}

export enum RevenueScheduleType {
  AtInvoice = 'at_invoice',
  AtRangeEnd = 'at_range_end',
  AtRangeStart = 'at_range_start',
  Evenly = 'evenly',
  Never = 'never',
}

export type RevokePasswordResetTokenInput = {
  plaintextToken: Scalars['String']
}

export type RevokePasswordResetTokenResult =
  | InvalidPasswordResetTokenException
  | RevokePasswordResetTokenSuccess

export type RevokePasswordResetTokenSuccess = {
  __typename?: 'RevokePasswordResetTokenSuccess'
  userId: Scalars['String']
}

export enum RiskStatus {
  Confirmable = 'confirmable',
  Fixable = 'fixable',
  HardReject = 'hard_reject',
}

export type RotateOauthAppClientSecretInput = {
  gracePeriodSeconds?: InputMaybe<Scalars['Int']>
}

export type RotateOauthAppClientSecretResult =
  | InvalidGracePeriodException
  | OauthApp
  | OauthAppNotFoundException

/** A transaction with excess change to invest into an Acorns account */
export type RoundUp = TimestampsInterface & {
  __typename?: 'RoundUp'
  amount: Scalars['Float']
  change: Scalars['Float']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  instant: Scalars['Boolean']
  investmentId: Maybe<Scalars['ID']>
  investmentNonce: Maybe<Scalars['ID']>
  linkedSubaccountId: Scalars['ID']
  manual: Scalars['Boolean']
  multiplier: Maybe<Scalars['Float']>
  name: Scalars['String']
  roundUpAccount: RoundUpAccount
  roundUpProfile: RoundUpProfile
  state: RoundUpState
  /** The target account in which this round up has been invested. */
  targetAccountId: Maybe<Scalars['ID']>
  total: Maybe<Scalars['Float']>
  transactionDate: Scalars['DateTime']
  transactionDisplayDate: Scalars['Date']
  transactionId: Scalars['ID']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId: Scalars['ID']
}

/** Round up settings for a specific linked account */
export type RoundUpAccount = TimestampsInterface & {
  __typename?: 'RoundUpAccount'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  enabled: Scalars['Boolean']
  linkedSubaccountId: Scalars['ID']
  roundUpProfile: RoundUpProfile
  roundUps: Array<RoundUp>
  startDate: Maybe<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId: Scalars['ID']
}

/** Round up settings for a user */
export type RoundUpProfile = TimestampsInterface & {
  __typename?: 'RoundUpProfile'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  multiplier: Scalars['Float']
  realTimeRoundUpEligible: Scalars['Boolean']
  roundUpAccounts: Array<RoundUpAccount>
  roundUpCount: Scalars['Int']
  roundUpTotal: Scalars['Float']
  roundUps: Array<RoundUp>
  roundUpsAmountPerMonth: Array<RoundUpSummary>
  roundUpsEnabled: Scalars['Boolean']
  /**
   * Aggregated round-up amount and count for a date range. When lookbackFilter is
   * provided, it takes precedence over startDate and endDate.
   */
  roundUpsSummary: RoundUpSummary
  /** True if user has auto roundups off (making all roundups manual, even from Spend accounts)or at least one enabled non-spend roundup account. */
  showRoundUpsProgress: Scalars['Boolean']
  /** The target account to which a user's round up investments will be made. */
  targetAccountId: Maybe<Scalars['ID']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId: Scalars['ID']
  wholeDollarAmount: Scalars['Float']
}

/** Round up settings for a user */
export type RoundUpProfileRoundUpCountArgs = {
  spend?: InputMaybe<Scalars['Boolean']>
  state?: InputMaybe<Array<RoundUpState>>
  targetAccountId?: InputMaybe<Scalars['ID']>
}

/** Round up settings for a user */
export type RoundUpProfileRoundUpTotalArgs = {
  spend?: InputMaybe<Scalars['Boolean']>
  state?: InputMaybe<Array<RoundUpState>>
  targetAccountId?: InputMaybe<Scalars['ID']>
}

/** Round up settings for a user */
export type RoundUpProfileRoundUpsAmountPerMonthArgs = {
  endDate?: InputMaybe<Scalars['Date']>
  startDate?: InputMaybe<Scalars['Date']>
  state?: InputMaybe<Array<RoundUpState>>
}

/** Round up settings for a user */
export type RoundUpProfileRoundUpsSummaryArgs = {
  endDate?: InputMaybe<Scalars['Date']>
  lookbackFilter?: InputMaybe<LookbackFilter>
  startDate?: InputMaybe<Scalars['Date']>
  state?: InputMaybe<Array<RoundUpState>>
}

/** Changeable attributes for user profiles */
export type RoundUpProfileInput = {
  /** Round up multiplier */
  multiplier?: InputMaybe<Scalars['Float']>
  /** Toggle global user setting for auto round ups */
  roundUpsEnabled?: InputMaybe<Scalars['Boolean']>
  /** Acorns account ID of roundups destination */
  targetAccountId?: InputMaybe<Scalars['ID']>
  /** Round up to custom dollar amount */
  wholeDollarAmount?: InputMaybe<Scalars['Float']>
}

export enum RoundUpState {
  /**
   * Round ups that will be invested automatically
   * @deprecated Use waiting state instead
   */
  AutoInvestable = 'autoInvestable',
  /** Round ups that were canceled, either before or after an investment was created */
  Canceled = 'canceled',
  /** Round ups associated with an investment */
  Invested = 'invested',
  /** Round ups that have yet to be invested */
  Pending = 'pending',
  /** Round ups that requested to be invested but have not been transferred */
  RoundedUp = 'roundedUp',
  /** Round ups which are ready to be invested */
  Waiting = 'waiting',
}

/** Aggregated round-up amount and count for a date range */
export type RoundUpSummary = {
  __typename?: 'RoundUpSummary'
  amount: Scalars['Micros']
  count: Scalars['Int']
  endDate: Scalars['Date']
  startDate: Scalars['Date']
}

/** A round-up investment transaction for Past round-up summary. Subset of allPastItems invest fields (including estimatedCompletionDate). */
export type RoundUpTransaction = {
  __typename?: 'RoundUpTransaction'
  amount: Maybe<MicrosMoney>
  createdAt: Scalars['DateTime']
  /** Same estimatedCompletionDate logic as allPastItems invest path */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  investmentType: RoundUpTransactionInvestmentType
  roundUpType: Maybe<RoundUpTransactionRoundUpType>
  status: PastItemStatus
  title: Scalars['String']
}

/** Backend investment type for a round-up transaction */
export enum RoundUpTransactionInvestmentType {
  InstantRoundUp = 'INSTANT_ROUND_UP',
  RoundUp = 'ROUND_UP',
}

/** Round-up flavor (automatic vs real-time) */
export enum RoundUpTransactionRoundUpType {
  Automatic = 'AUTOMATIC',
  RealTime = 'REAL_TIME',
}

export enum RoundUpType {
  Auto = 'auto',
  RealTime = 'realTime',
}

/** An individual edge within the paginated list of RoundUpType */
export type RoundUpTypeEdge = {
  __typename?: 'RoundUpTypeEdge'
  /** The unique key used for pagination */
  cursor: Scalars['ID']
  /** The RoundUpType record in the edge */
  node: RoundUp
}

/** Relay style pagination information for RoundUpType */
export type RoundUpTypePagination = {
  __typename?: 'RoundUpTypePagination'
  edges: Array<RoundUpTypeEdge>
  pageInfo: PageInfo
}

export type RoundUpsPastSummaryInput = {
  unit: RoundUpsPastSummaryUnit
  value: Scalars['Int']
}

export enum RoundUpsPastSummaryUnit {
  Days = 'DAYS',
  Months = 'MONTHS',
  Years = 'YEARS',
}

/**
 * Rule tree validation error returned when a ruleset mutation fails schema validation (ENR-445).
 * Contains one or more field-level or structural errors describing why the rule tree is invalid.
 */
export type RuleTreeValidationError = {
  __typename?: 'RuleTreeValidationError'
  /** Individual validation errors — one per failing rule node or structural issue. */
  errors: Array<RuleTreeValidationIssue>
  /** Human-readable summary of why validation failed. */
  message: Scalars['String']
}

/** A single validation issue within a rule tree. */
export type RuleTreeValidationIssue = {
  __typename?: 'RuleTreeValidationIssue'
  /** Type of issue. */
  code: RuleTreeValidationIssueCode
  /** Dot-notation field path that caused the issue, if applicable. */
  fieldPath: Maybe<Scalars['String']>
  /** Human-readable description of this specific issue. */
  message: Scalars['String']
}

/** Validation issue codes for rule tree validation. */
export enum RuleTreeValidationIssueCode {
  DeprecatedField = 'DEPRECATED_FIELD',
  InvalidOperator = 'INVALID_OPERATOR',
  InvalidValueType = 'INVALID_VALUE_TYPE',
  MaxDepth = 'MAX_DEPTH',
  Structural = 'STRUCTURAL',
  UnknownField = 'UNKNOWN_FIELD',
}

export type SmsAuthChallenge = AuthChallenge & {
  __typename?: 'SMSAuthChallenge'
  alternateAuthenticators: Array<AuthenticatorInfo>
  challengeTrigger: ChallengeTriggers
  completedAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  maskedPhoneNumber: Scalars['String']
  sessionId: Maybe<Scalars['ID']>
  updatedAt: Scalars['DateTime']
}

/** SSN supporting document requested user alert. */
export type SsnDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'SSNDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export enum SsnStorageResult {
  Exists = 'EXISTS',
  Invalid = 'INVALID',
  Success = 'SUCCESS',
}

export type SvgWidget = {
  __typename?: 'SVGWidget'
  svgContent: Scalars['String']
  title: Maybe<Scalars['String']>
}

export enum SalaryInterval {
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR',
}

export type SamePasswordsException = {
  __typename?: 'SamePasswordsException'
  message: Maybe<Scalars['String']>
}

export type SampleMailInDocument = {
  __typename?: 'SampleMailInDocument'
  letterUrl: Maybe<Scalars['URL']>
  mailType: MailInDocumentType
}

export type SaveInterestPaidItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SaveInterestPaidItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    /** The calendar month in which this interest was earned. */
    monthEarned: Scalars['String']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SaveTipProfileInput = {
  displayName?: InputMaybe<Scalars['String']>
  investingStory?: InputMaybe<Scalars['String']>
  profession: Scalars['String']
  professionSecondary?: InputMaybe<Scalars['String']>
}

export type SaveTipProfileResult =
  | TipProfile
  | TipProfileIneligibleError
  | TipProfileInvalidInputError

export type SaveTransferInItem = PastItem &
  PastTargetedTransferItem &
  PastUserTransferItem &
  SpendItem & {
    __typename?: 'SaveTransferInItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SaveTransferOutItem = PastItem &
  PastTargetedTransferItem &
  PastUserTransferItem &
  SpendItem & {
    __typename?: 'SaveTransferOutItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Input for saving an upload url after direct to s3 upload */
export type SaveUploadUrlInput = {
  /** the upload uuid from the upload object */
  uploadUuid: Scalars['ID']
}

/** Input for saving an upload url after direct to s3 upload */
export type SaveUploadUrlsInput = {
  /** a field where the user can add additional info for their uploads */
  additionalInfo?: InputMaybe<Scalars['String']>
  /** collection of uploads uuid from the uploads object */
  uploadsUuid: Array<Scalars['ID']>
}

/** LegacyUploadDocumentResult */
export type SaveUploadUrlsResult = DocumentUploads | UploadSaveError

export type SavingsAccountEligibility = {
  __typename?: 'SavingsAccountEligibility'
  isEligibleForOpen: Scalars['Boolean']
  notEligibleReasons: Array<SavingsAccountEligibilityRequirement>
}

export enum SavingsAccountEligibilityRequirement {
  NeedsCheckingAccount = 'NEEDS_CHECKING_ACCOUNT',
  NeedsDirectDeposit = 'NEEDS_DIRECT_DEPOSIT',
  NeedsOtherBankingPartner = 'NEEDS_OTHER_BANKING_PARTNER',
}

export enum SavingsAccountType {
  EmergencySavings = 'EMERGENCY_SAVINGS',
}

export type ScheduleInput = {
  type: ScheduleType
}

export type ScheduleRecurringTransferInput = {
  recurrenceRule: RecurrenceRuleInput
  transferEvent: RecurringTransferEventInput
}

export type ScheduleRecurringTransferResult =
  | MalformedRecurringTransferException
  | RecurringTransfer

export type ScheduleResult = {
  __typename?: 'ScheduleResult'
  active: Scalars['Boolean']
  name: Maybe<Scalars['String']>
}

export enum ScheduleType {
  Chat = 'chat',
  Email = 'email',
  Phone = 'phone',
}

export type Scope = {
  __typename?: 'Scope'
  createdAt: Scalars['DateTime']
  description: Maybe<Scalars['String']>
  identifier: Scalars['String']
  required: Scalars['Boolean']
  title: Scalars['String']
  updatedAt: Scalars['DateTime']
}

/** Server-driven UI screen. The client renders `data` using the blueprint for `screen`. */
export type SduiWidget = {
  __typename?: 'SduiWidget'
  blueprint: Scalars['JSON']
  data: Maybe<Scalars['JSON']>
  screen: Scalars['String']
}

/** Query attributes for Employer Search */
export type SearchEmployersInput = {
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
  /** Search Term */
  searchTerm?: InputMaybe<Scalars['String']>
  /** Session ID */
  sessionId?: InputMaybe<Scalars['ID']>
  /** Switch Type */
  switchType?: InputMaybe<SwitchType>
}

/** Search Results */
export type SearchEmployersPayload = {
  __typename?: 'SearchEmployersPayload'
  results: Maybe<Array<Employer>>
  /** Unique Tracking ID */
  trackingId: Scalars['ID']
}

export type SearchHistory = {
  __typename?: 'SearchHistory'
  popularSearches: Maybe<Array<Scalars['String']>>
  recentSearches: Array<Scalars['String']>
}

export type SearchSecuritiesInput = {
  after?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<SearchSecuritiesOrderBy>
  search: Scalars['String']
  securityTypes?: InputMaybe<Array<InputMaybe<SecurityType>>>
}

export enum SearchSecuritiesNoResultSuggestion {
  Bitcoin = 'BITCOIN',
  ExistingEtf = 'EXISTING_ETF',
  NoResult = 'NO_RESULT',
  SAndP = 'S_AND_P',
}

export enum SearchSecuritiesOrderBy {
  /** Securities that match caller input LevenshteinDistanceThreshold or better ordered by match score in descending order */
  BestMatch = 'BEST_MATCH',
  /** Securities that match caller input LevenshteinDistanceThreshold or better ordered by market cap in descending order */
  MarketCap = 'MARKET_CAP',
  /** Securities that match caller input LevenshteinDistanceThreshold or better ordered by share price (open_price) in descending order */
  SharePrice = 'SHARE_PRICE',
}

export type SearchSecuritiesPageInfo = {
  __typename?: 'SearchSecuritiesPageInfo'
  count: Scalars['Int']
  hasNextPage: Scalars['Boolean']
  hasPreviousPage: Scalars['Boolean']
  nextPageCursor: Maybe<Scalars['String']>
  prevPageCursor: Maybe<Scalars['String']>
  totalMatches: Maybe<Scalars['Int']>
}

export type SearchSecuritiesResponse = {
  __typename?: 'SearchSecuritiesResponse'
  pageInfo: Maybe<SearchSecuritiesPageInfo>
  securities: Array<Security>
  suggestion: Maybe<SearchSecuritiesSuggestionResult>
}

export type SearchSecuritiesSuggestionResult = {
  __typename?: 'SearchSecuritiesSuggestionResult'
  securities: Array<Security>
  type: SearchSecuritiesNoResultSuggestion
}

export type SearchSupportArticleResult = {
  __typename?: 'SearchSupportArticleResult'
  author: SupportAuthor
  body: Scalars['String']
  createdAt: Scalars['DateTime']
  draft: Scalars['Boolean']
  editedAt: Scalars['DateTime']
  id: Scalars['ID']
  name: Scalars['String']
  outdated: Scalars['Boolean']
  position: Maybe<Scalars['Int']>
  promoted: Scalars['Boolean']
  resultType: Scalars['String']
  section: SupportSection
  slug: Scalars['String']
  snippet: Scalars['String']
  title: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export type SearchSupportResult = {
  __typename?: 'SearchSupportResult'
  hasMore: Maybe<Scalars['Boolean']>
  pageInfo: Maybe<PageInfo>
  relevantSearchArticles: Array<Maybe<SearchSupportArticleResult>>
  relevantSearchCategories: Array<Maybe<SupportCategory>>
}

export enum SearchTermCategory {
  BenefitsHub = 'BENEFITS_HUB',
  Checking = 'CHECKING',
  Default = 'DEFAULT',
  Early = 'EARLY',
  Earn = 'EARN',
  EmergencySavings = 'EMERGENCY_SAVINGS',
  Home = 'HOME',
  Invest = 'INVEST',
  Later = 'LATER',
  MoneyManager = 'MONEY_MANAGER',
  MoneyMentorHome = 'MONEY_MENTOR_HOME',
  ReferralsLander = 'REFERRALS_LANDER',
  Support = 'SUPPORT',
}

/** Secret Squirrel Error */
export type SecretSquirrelException = {
  __typename?: 'SecretSquirrelException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type SecuritiesBySectorInput = {
  after?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<SecuritiesBySectorOrderBy>
  sectors: Array<TradingSector>
  securityTypes?: InputMaybe<Array<InputMaybe<SecurityType>>>
}

export enum SecuritiesBySectorOrderBy {
  /** Securities that contain the provided trading sector(s) ordered by market cap in descending order */
  MarketCap = 'MARKET_CAP',
  /** Securities that contain the provided trading sector(s) ordered by share price (open_price) in descending order */
  SharePrice = 'SHARE_PRICE',
}

export type SecuritiesBySectorPageInfo = {
  __typename?: 'SecuritiesBySectorPageInfo'
  count: Scalars['Int']
  hasNextPage: Scalars['Boolean']
  hasPreviousPage: Scalars['Boolean']
  nextPageCursor: Maybe<Scalars['String']>
  prevPageCursor: Maybe<Scalars['String']>
  totalMatches: Maybe<Scalars['Int']>
}

export type SecuritiesBySectorResponse = {
  __typename?: 'SecuritiesBySectorResponse'
  pageInfo: Maybe<SecuritiesBySectorPageInfo>
  securities: Array<Security>
}

export type SecuritiesBySymbolsInput = {
  symbols: Array<Scalars['TickerSymbol']>
}

export type SecuritiesBySymbolsResponse = {
  __typename?: 'SecuritiesBySymbolsResponse'
  securities: Array<Security>
}

export type Security = {
  currentPrice: BigCurrencyAmount
  /** CUSIP identifier for the security, or null when unknown */
  cusip: Maybe<Scalars['String']>
  displayName: Scalars['String']
  earliestPriceDate: Scalars['Date']
  headlines: Array<SecurityHeadline>
  id: Scalars['ID']
  lastClosePrice: BigCurrencyAmount
  lastUpdatedAt: Scalars['DateTime']
  longName: Scalars['String']
  marketCap: Scalars['BigDecimal']
  openPrice: BigCurrencyAmount
  profile: SecurityProfile
  /** @deprecated Use Security.headlines. */
  securityHeadlines: Array<SecurityHeadline>
  /** @deprecated Use Security.profile. */
  securityProfile: SecurityProfile
  shortName: Scalars['String']
  symbol: Scalars['TickerSymbol']
  type: SecurityType
  volume: Scalars['BigDecimal']
  week52High: BigCurrencyAmount
  week52Low: BigCurrencyAmount
}

/** Describes a target allocation percentage for the specified security */
export type SecurityAllocationTarget = {
  /** ID or Symbol of the targeted security */
  securityId: Scalars['String']
  /** Target allocation percentage, ex: 33 -> 33% */
  securityPercent: Scalars['Int']
}

export type SecurityAnswer = {
  questionId: Scalars['ID']
  response: Scalars['String']
}

export type SecurityAvailability = {
  __typename?: 'SecurityAvailability'
  driveWealth: SecurityVendorAvailability
  quoteMedia: SecurityVendorAvailability
  symbol: Scalars['TickerSymbol']
}

export type SecurityAvailabilityResults = {
  __typename?: 'SecurityAvailabilityResults'
  results: Array<SecurityAvailability>
}

export type SecurityBySymbolInput = {
  symbol: Scalars['TickerSymbol']
}

/** Individualized diversification information by security */
export type SecurityDiversificationInfo = {
  __typename?: 'SecurityDiversificationInfo'
  /** Metric representing the security's contribution to the overall diversification of the portfolio */
  diversificationFactor: Scalars['Float']
  /** Security symbol */
  symbol: Scalars['String']
}

export type SecurityGain = {
  __typename?: 'SecurityGain'
  marketValue: Maybe<BigCurrencyAmount>
  percent: Maybe<Scalars['BigDecimal']>
}

export type SecurityHeadline = {
  __typename?: 'SecurityHeadline'
  createdAt: Scalars['DateTime']
  headline: Scalars['String']
  source: Scalars['String']
  storyUrl: Scalars['URL']
  thumbnailUrl: Maybe<Scalars['URL']>
}

/** Security Not Supported */
export type SecurityNotSupportedException = {
  __typename?: 'SecurityNotSupportedException'
  /** message */
  message: Maybe<Scalars['String']>
}

export enum SecurityOverridableField {
  Cusip = 'CUSIP',
  Description = 'DESCRIPTION',
  LongDescription = 'LONG_DESCRIPTION',
  LongName = 'LONG_NAME',
  ShortName = 'SHORT_NAME',
  TradingSectors = 'TRADING_SECTORS',
}

export type SecurityOverrides = {
  __typename?: 'SecurityOverrides'
  cusip: Maybe<OverrideInfo>
  description: Maybe<OverrideInfo>
  longDescription: Maybe<OverrideInfo>
  longName: Maybe<OverrideInfo>
  shortName: Maybe<OverrideInfo>
  tradingSectors: Maybe<OverrideInfo>
}

export type SecurityOverridesBySymbolInput = {
  symbol: Scalars['TickerSymbol']
}

export type SecurityPerformance = {
  __typename?: 'SecurityPerformance'
  gain: SecurityGain
  prices: Maybe<Array<SecurityPrice>>
  symbol: Scalars['TickerSymbol']
}

export type SecurityPerformanceBySymbolInput = {
  endDate: Scalars['DateTime']
  /** Reserved; not currently used */
  interval?: InputMaybe<Scalars['Int']>
  maxPoints?: InputMaybe<Scalars['Int']>
  startDate: Scalars['DateTime']
  symbol: Scalars['TickerSymbol']
}

export type SecurityPerformancesBySymbolInput = {
  endDate: Scalars['DateTime']
  /** Reserved; not currently used */
  interval?: InputMaybe<Scalars['Int']>
  maxPoints?: InputMaybe<Scalars['Int']>
  startDate: Scalars['DateTime']
  symbols: Array<Scalars['TickerSymbol']>
}

export type SecurityPrice = {
  __typename?: 'SecurityPrice'
  date: Scalars['Date']
  marketValue: BigCurrencyAmount
  timestamp: Scalars['DateTime']
  unadjustedMarketValue: Maybe<BigCurrencyAmount>
}

export type SecurityProfile = {
  __typename?: 'SecurityProfile'
  defaultLogoUrl: Maybe<Scalars['URL']>
  description: Maybe<Scalars['String']>
  logoUrl: Maybe<Scalars['URL']>
  longDescription: Maybe<Scalars['String']>
  tradingSectors: Array<TradingSector>
}

export enum SecurityType {
  Bond = 'BOND',
  Etf = 'ETF',
  Stock = 'STOCK',
}

export type SecurityVendorAvailability = {
  __typename?: 'SecurityVendorAvailability'
  available: Scalars['Boolean']
  reason: Maybe<Scalars['String']>
}

/** User Directed Portfolio Object */
export type SelfDirectedPortfolio = BasePortfolio & {
  __typename?: 'SelfDirectedPortfolio'
  /** Indicates the portfolio's allocation percentage */
  accountAllocation: PortfolioAllocation
  cashOwed: MonetaryAmount
  currentAllocationPercentage: Scalars['Float']
  currentBalance: MonetaryAmount
  currentBalanceWithPending: MonetaryAmount
  /** Indicates the extent to which the Portfolio has been customized by an investor. */
  customizationLevel: Maybe<PortfolioCustomizationLevel>
  /** Description of the portfolio */
  description: Scalars['String']
  /** ID of the Portfolio */
  id: Scalars['ID']
  /** Indicates the Acorns-designated portfolio name */
  name: Scalars['String']
  pendingBalance: MonetaryAmount
  /**
   * Securities currently owned by the Portfolio's InvestmentAccount (will be null
   * if not selected in the context of an InvestmentAccount).
   */
  portfolioSecurities: Maybe<Array<PortfolioSecurity>>
  /** Security Allocations for the given portfolio */
  portfolioSecurityAllocations: Maybe<Array<PortfolioSecurityAllocation>>
  /** Contains requirement statuses for removing the portfolio */
  requirements: AccountRequirements
  status: SelfDirectedPortfolioStatus
  yearToDateReturn: Maybe<MarketReturn>
}

export enum SelfDirectedPortfolioStatus {
  /** Self Directed Portfolio has been removed */
  Closed = 'CLOSED',
  /** Self Directed Portfolio is open */
  Open = 'OPEN',
  /** Self Directed Portfolio has started the closure process */
  PendingClosure = 'PENDING_CLOSURE',
}

export type SendBrazeEventInput = {
  event: BrazeEvent
  userId: Scalars['ID']
}

export type SendChatMessageResponse =
  | ChatHistoryMessage
  | ChatInProgressException
  | ChatMessageSizeOutOfBounds
  | ChatSessionBlockedException
  | ChatSessionNotFound
  | ChatUnavailableError

export type SendCheckPaymentInput = {
  amount: CurrencyAmountInput
  fromAccountId: Scalars['ID']
  memo?: InputMaybe<Scalars['String']>
  nonce: Scalars['String']
  recipient: CheckPaymentRecipientInput
  recipientAddress: CheckPaymentAddressInput
}

/** Check or errors */
export type SendCheckPaymentResult =
  | AuthorizationError
  | CheckPayment
  | DuplicateActionError
  | InvalidAddressError

export type SendEmailToCustomerInput = {
  caseID: Scalars['ID']
  emailBody?: InputMaybe<Scalars['String']>
  htmlBody?: InputMaybe<Scalars['String']>
  subject?: InputMaybe<Scalars['String']>
  templateId?: InputMaybe<Scalars['String']>
  toAddress: Scalars['String']
}

export type SendEmailToCustomerResult = {
  __typename?: 'SendEmailToCustomerResult'
  emailMessageId: Scalars['ID']
  error: Maybe<Scalars['String']>
  htmlBody: Maybe<Scalars['String']>
  subject: Scalars['String']
  success: Scalars['Boolean']
  textBody: Scalars['String']
  toAddress: Scalars['String']
}

export type Session = {
  __typename?: 'Session'
  redirectUrl: Maybe<Scalars['String']>
  refreshToken: Maybe<Scalars['ID']>
  token: Scalars['ID']
  uuid: Scalars['ID']
}

export enum SessionType {
  Behavioral = 'BEHAVIORAL',
  Default = 'DEFAULT',
}

export type SetAuthenticationPinInput = {
  pin: Scalars['String']
  pinConfirmation: Scalars['String']
}

export type SetAuthenticationPinResult =
  | InvalidPinException
  | SetAuthenticationPinSuccess
  | UserCredentialsNotFoundException

export type SetAuthenticationPinSuccess = {
  __typename?: 'SetAuthenticationPINSuccess'
  userId: Scalars['ID']
}

/** Response to a beneficiary ssn update */
export type SetBeneficiarySsnResult =
  | Beneficiary
  | BeneficiaryNotFoundException
  | InternalErrorException
  | InvalidSsnException
  | SecretSquirrelException
  | SsnAlreadyInUseException
  | SsnMatchesCustodianException
  | SsnUpdateForbiddenException

export type SetDefaultAuthenticatorInput = {
  authenticatorId: Scalars['ID']
}

export type SetDefaultAuthenticatorResult =
  | AuthenticatorAlreadyDefaultException
  | AuthenticatorNotFoundException
  | EmailAuthenticator
  | PhoneAuthenticator

/** Configuration for setting public access of investment account recaps. */
export type SetInvestmentAccountRecapPublicAccessInput = {
  /** The unique identifier of the investment account recap for which public access is being modified. */
  id: Scalars['ID']
  /** Whether or not the recap is public. */
  public: Scalars['Boolean']
}

/** Result of modifying the public access of an investment account recap. */
export type SetInvestmentAccountRecapPublicAccessResult =
  | InvestmentAccountRecap
  | InvestmentAccountRecapNotFoundException

/** Options to set an account with a linking error */
export type SetLinkingErrorInput = {
  /** Error to give the linked account */
  code: LinkedAccountLinkingErrorsEnum
}

export type SetNegotiationStatusInput = {
  negotiationMethod: NegotiationMethod
  operator: Scalars['String']
  refundAmount?: InputMaybe<Scalars['Float']>
  status: BankFeeNegotiationStatus
  submissionId: Scalars['ID']
  userId: Scalars['ID']
}

export type SetNegotiationStatusResult = {
  __typename?: 'SetNegotiationStatusResult'
  message: Scalars['String']
}

export type SetPortfolioInput = {
  id: Scalars['ID']
}

/** Input for setting a funding source as preferred withdrawal account */
export type SetPreferredWithdrawalAccountInput = {
  /** the uuid of the funding source being set */
  fundingSourceUuid: Scalars['ID']
}

/** Result of setting a funding source as preferred withdrawal account. */
export type SetPreferredWithdrawalAccountResult =
  | FundingSourceAccount
  | PreferredAccountNotEligibleError
  | PreferredAccountNotSupportedError

export type SetReferralCampaignFlagsInput = {
  autoAdd?: InputMaybe<Scalars['Boolean']>
  campaignId: Scalars['ID']
  fallback?: InputMaybe<Scalars['Boolean']>
  override?: InputMaybe<OverrideInput>
  qa?: InputMaybe<Scalars['Boolean']>
}

export type SetReferralCampaignFlagsResult = {
  __typename?: 'SetReferralCampaignFlagsResult'
  autoAdd: Scalars['Boolean']
  fallback: Scalars['Boolean']
  id: Scalars['ID']
  qa: Scalars['Boolean']
}

export type SetSecurityOverridesFailed = {
  __typename?: 'SetSecurityOverridesFailed'
  description: Scalars['String']
}

export type SetSecurityOverridesInput = {
  cusip?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  lockedBy: Scalars['String']
  longDescription?: InputMaybe<Scalars['String']>
  longName?: InputMaybe<Scalars['String']>
  shortName?: InputMaybe<Scalars['String']>
  symbol: Scalars['TickerSymbol']
  tradingSectors?: InputMaybe<Array<TradingSector>>
}

export type SetSecurityOverridesResult =
  | SetSecurityOverridesFailed
  | SetSecurityOverridesSuccess

export type SetSecurityOverridesSuccess = {
  __typename?: 'SetSecurityOverridesSuccess'
  overriddenFields: Array<SecurityOverridableField>
  symbol: Scalars['TickerSymbol']
}

export type SetUpTip = {
  __typename?: 'SetUpTip'
  backgroundImage: Image
  body: Scalars['String']
  ctaDetails: ActionFeedCta
  id: Scalars['ID']
  image: Image
  type: ProductSetupTipType
}

export type Settings = {
  __typename?: 'Settings'
  /** @deprecated Highly non-performant! */
  allowDebitCard: Scalars['Boolean']
  /** @deprecated Highly non-performant! */
  automaticRoundup: Scalars['Boolean']
  depositsSuspended: Maybe<Scalars['Boolean']>
  /** @deprecated Highly non-performant! */
  dollarRoundupAmount: Scalars['Float']
  /** @deprecated Highly non-performant! */
  notifications: Notifications
  /** @deprecated Highly non-performant! */
  roundupMultiplier: Scalars['Int']
  /** @deprecated Highly non-performant! */
  threshold: Scalars['Int']
}

/** Determines transfer source and destination accounts based on shareTransferType */
export enum ShareTransferType {
  /** Move shares from trading account to master holding account */
  Buy = 'BUY',
  /** Move shares from chargeback account to holding account */
  ChargebackBuy = 'CHARGEBACK_BUY',
  /** Move shares from holding account to chargeback account */
  ChargebackSell = 'CHARGEBACK_SELL',
  /** Move shares from error account to holding account */
  CorrectionBuy = 'CORRECTION_BUY',
  /** Move shares from holding account to error account */
  CorrectionSell = 'CORRECTION_SELL',
  /** Move shares from master holding account to trading account */
  Sell = 'SELL',
}

export type Signature = TimestampsInterface & {
  __typename?: 'Signature'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Type of profile */
  profile: Maybe<Profile>
  /** Type of signature */
  signatureType: SignatureType
  /** SVG file */
  svgFile: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Internal ID for user */
  userId: Scalars['ID']
}

export enum SignatureType {
  /** A signature used for a user's bank fee negotiation */
  BankFeeNegotiation = 'bankFeeNegotiation',
  /** A signature for the user investment certificate */
  Certificate = 'certificate',
  /** A signature used for the user spend debit card */
  DebitCard = 'debitCard',
  /** A signature used for the user direct deposit PDF form */
  DirectDeposit = 'directDeposit',
  /** A signature used for a user's utility bill negotiation */
  UtilityBillNegotiation = 'utilityBillNegotiation',
}

export type SiteWideBannerContent = {
  __typename?: 'SiteWideBannerContent'
  bannerText: Scalars['String']
  currentVersion: Scalars['String']
  publishedVersion: Maybe<Scalars['String']>
  visible: Scalars['Boolean']
}

export type SiteWideBannerContentInput = {
  bannerText?: InputMaybe<Scalars['String']>
  publish?: InputMaybe<Scalars['Boolean']>
  visible?: InputMaybe<Scalars['Boolean']>
}

export type SmartDepositMetadataInput = {
  supportedTargetAccounts: Array<SplitDepositTargetAccountType>
}

export type SmartDepositMetadataResult = {
  __typename?: 'SmartDepositMetadataResult'
  recommendedAllocations: Array<SplitDepositAllocation>
  targetAccounts: Array<SplitDepositTargetAccount>
}

/** Optional filter for getting customer accounts a user can withdraw from. */
export type SourceAccountsFilterInput = {
  /** Filter accounts that are able to withdraw from at this time. */
  isWithdrawalAllowed?: InputMaybe<Scalars['Boolean']>
  /** Filter accounts that can withdraw to a specified account. */
  targetAccountId?: InputMaybe<Scalars['ID']>
}

/** Extra detailed attributes for source of user's arrival to registration. */
export type SourceAttributes = {
  __typename?: 'SourceAttributes'
  /** s2 - Affiliate for Impact Radius or campaign ID */
  affiliateCampaignID: Maybe<Scalars['String']>
  /** Unique ID for user journey exposed by Button */
  buttonSourceToken: Maybe<Scalars['String']>
  /** carrier - Mobile carrier */
  carrier: Maybe<Scalars['String']>
  /** chatProspectId - Free Ask Acorns attribution */
  chatProspectId: Maybe<Scalars['String']>
  /** clickid - Unique Impact Radius referral ID */
  clickID: Maybe<Scalars['String']>
  /** code - Referral code of advocate the user registered with */
  code: Maybe<Scalars['String']>
  /** s4 - Customer incentive offers */
  freeformIdentifier: Maybe<Scalars['String']>
  /** promoCode - Promotional code name */
  promoCode: Maybe<Scalars['String']>
  /** referral_code - Referral code of referrer (either user-to-user or partner) that the user registered with */
  referralCode: Maybe<Scalars['String']>
  /** s3 - Customer incentive offers */
  s3: Maybe<Scalars['String']>
  /** Identifier for the prospect's attribution channel */
  sourceID: Scalars['String']
}

/** Source attribute object represented as is today. Should be normalized moving forward. */
export type SourceAttributesInput = {
  /** Unnormalized source attributes for supporting backwards compatibility with existing services */
  rawJSON: Scalars['String']
  /** Identifier for the prospect's attribution channel */
  sourceID: Scalars['String']
}

export type SpendAtmReimbursementItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendATMReimbursementItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendAtmWithdrawalItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendATMWithdrawalItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendAccount = {
  __typename?: 'SpendAccount'
  accountId: Maybe<Scalars['ID']>
  bankCardOrder: Maybe<BankCardOrder>
  bankType: Maybe<BankType>
  isDirectDepositIncentiveEligible: Scalars['Boolean']
  isEligible: Scalars['Boolean']
  /** @deprecated This flag is deprecated and will always return false. Premium cards are no longer proactively suggested to customers. */
  isEligibleForPremiumCardUpgrade: Maybe<Scalars['Boolean']>
  isReopenable: Maybe<Scalars['Boolean']>
  lockReason: Maybe<BankAccountLockReason>
  status: SpendAccountStatus
}

export enum SpendAccountStatus {
  Closed = 'CLOSED',
  Locked = 'LOCKED',
  NotOpened = 'NOT_OPENED',
  Open = 'OPEN',
  Opening = 'OPENING',
  Reopening = 'REOPENING',
}

export type SpendAlert = {
  type: Scalars['String']
  userId: Scalars['ID']
}

export type SpendAtm = {
  __typename?: 'SpendAtm'
  address: SpendAtmAddress
  atmName: Scalars['String']
  imageUrl: Maybe<Scalars['String']>
  phoneNumber: Maybe<Scalars['String']>
}

export type SpendAtmAddress = {
  __typename?: 'SpendAtmAddress'
  addressLine: Maybe<Scalars['String']>
  cityName: Maybe<Scalars['String']>
  country: Maybe<Scalars['String']>
  latitude: Scalars['String']
  longitude: Scalars['String']
  postalCode: Maybe<Scalars['String']>
  stateCode: Maybe<Scalars['String']>
}

export type SpendAtmVendorUnavailableError = {
  __typename?: 'SpendAtmVendorUnavailableError'
  requestId: Maybe<Scalars['String']>
}

export type SpendAtmsCoordinateInput = {
  latitude: Scalars['String']
  longitude: Scalars['String']
}

export type SpendAtmsInput = {
  searchCoordinate: SpendAtmsCoordinateInput
  searchRadius?: InputMaybe<Scalars['Float']>
}

export type SpendAtmsPayload = {
  __typename?: 'SpendAtmsPayload'
  atms: Maybe<Array<Maybe<SpendAtm>>>
  executedSearchRadius: Maybe<Scalars['String']>
}

export type SpendAtmsResult = SpendAtmVendorUnavailableError | SpendAtmsPayload

export type SpendBillPayItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendBillPayItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendCheckDepositItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendCheckDepositItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendCheckPaymentItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendCheckPaymentItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendDigitalWalletItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendDigitalWalletItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendDirectDepositItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendDirectDepositItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendDisputesResponse = {
  __typename?: 'SpendDisputesResponse'
  creationDateTime: Maybe<Scalars['DateTime']>
  description: Scalars['String']
  disputeDateTime: Maybe<Scalars['DateTime']>
  id: Maybe<Scalars['Int']>
  questions: Array<SpendTransactionsDisputeQuestions>
  transactions: Array<SpendTransactionsResponse>
}

export type SpendECheckItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendECheckItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendInterestPaidItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendInterestPaidItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    /** The calendar month in which this interest was earned. */
    monthEarned: Scalars['String']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A base set of fields that each PastItem from Spend transactions must implement */
export type SpendItem = {
  accountName: Scalars['String']
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String']
  moneyManagerTransfer: Scalars['Boolean']
  productAccountType: ProductAccountType
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String']
  transactionDescription: Scalars['String']
  transactionType: TransactionType
}

export type SpendPurchaseItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendPurchaseItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendRealTimeRoundUpItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendRealTimeRoundUpItem'
    accountName: Scalars['String']
    /** The investment amount after being multiplied. */
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The investment amount prior to being multiplied */
    initialAmount: Maybe<CurrencyAmount>
    moneyManagerTransfer: Scalars['Boolean']
    multiplier: Maybe<Scalars['Int']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendTransactionsDisputeCustomersResponse = {
  __typename?: 'SpendTransactionsDisputeCustomersResponse'
  accountNumber: Maybe<Scalars['String']>
  applicationCode: Maybe<Scalars['String']>
  customerNumber: Maybe<Scalars['String']>
  disputes: Array<SpendDisputesResponse>
  firstName: Maybe<Scalars['String']>
  lastName: Maybe<Scalars['String']>
  productCode: Maybe<Scalars['String']>
}

export type SpendTransactionsDisputeQuestions = {
  __typename?: 'SpendTransactionsDisputeQuestions'
  answer: Maybe<Scalars['String']>
  question: Maybe<Scalars['String']>
}

export type SpendTransactionsDisputeResponse = {
  __typename?: 'SpendTransactionsDisputeResponse'
  bankType: BankType
  customers: SpendTransactionsDisputeCustomersResponse
}

export type SpendTransactionsDisputeResult = SpendTransactionsDisputeResponse

export type SpendTransactionsInput = {
  amount: Scalars['String']
  availableAt?: InputMaybe<Scalars['DateTime']>
  createdAt?: InputMaybe<Scalars['DateTime']>
  description: Scalars['String']
  id: Scalars['ID']
  settledAt?: InputMaybe<Scalars['DateTime']>
  status: BankTransactionStatus
  tag?: InputMaybe<Scalars['String']>
  type: BankTransactionType
  typeCode: Scalars['String']
  updatedAt?: InputMaybe<Scalars['DateTime']>
  voidedAt?: InputMaybe<Scalars['DateTime']>
}

export type SpendTransactionsResponse = {
  __typename?: 'SpendTransactionsResponse'
  amount: Scalars['Float']
  coreTransactionId: Scalars['String']
  description: Scalars['String']
  disputedAmount: Scalars['Float']
  id: Maybe<Scalars['Int']>
  postingDate: Scalars['DateTime']
  status: Maybe<Scalars['String']>
  transactionCode: Scalars['String']
}

export type SpendTransferInItem = PastItem &
  PastTargetedTransferItem &
  PastUserTransferItem &
  SpendItem & {
    __typename?: 'SpendTransferInItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendTransferOutItem = PastItem &
  PastTargetedTransferItem &
  PastUserTransferItem &
  SpendItem & {
    __typename?: 'SpendTransferOutItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SplitDeposit = {
  __typename?: 'SplitDeposit'
  allocations: Array<SplitDepositAllocation>
  createdAt: Scalars['String']
  distributedAt: Maybe<Scalars['String']>
  expectedNextDepositAmount: Maybe<Scalars['String']>
  expectedNextDepositAt: Maybe<Scalars['String']>
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isCancelable: Scalars['Boolean']
  isCanceled: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
  /** @deprecated deprecated, use allocations instead */
  savingsRatePercent: Scalars['String']
  settingsId: Scalars['ID']
  /** @deprecated deprecated, use allocations instead */
  splitDistribution: DistributionAmounts
  transactionAmount: Scalars['String']
  updatedAt: Scalars['String']
  userId: Scalars['ID']
  willDistributeAutomaticallyAt: Maybe<Scalars['String']>
}

export type SplitDepositAllocation = {
  allocationPercent: Scalars['String']
  nickname: Maybe<Scalars['String']>
  targetAccountId: Scalars['ID']
  targetAccountType: SplitDepositTargetAccountType
}

export type SplitDepositAllocationInput = {
  allocationPercent: Scalars['String']
  nickname?: InputMaybe<Scalars['String']>
  targetAccountId: Scalars['ID']
  targetAccountType: SplitDepositTargetAccountType
}

export type SplitDepositDailyRecurrenceRule = SplitDepositRecurrenceRule & {
  __typename?: 'SplitDepositDailyRecurrenceRule'
  frequency: SplitDepositRecurrenceFrequency
}

export type SplitDepositDirectDepositAllocation = SplitDepositAllocation & {
  __typename?: 'SplitDepositDirectDepositAllocation'
  allocationPercent: Scalars['String']
  nickname: Maybe<Scalars['String']>
  normalizedAmount: Maybe<FormattedMonetaryAmount>
  normalizedDailyAmount: Maybe<Scalars['String']>
  targetAccountId: Scalars['ID']
  targetAccountType: SplitDepositTargetAccountType
}

export type SplitDepositDirectDepositIntentSetting = SplitDepositSettings & {
  __typename?: 'SplitDepositDirectDepositIntentSetting'
  allocations: Array<SplitDepositDirectDepositAllocation>
  createdAt: Scalars['String']
  deposits: Maybe<Array<SplitDeposit>>
  /** @deprecated deprecated */
  distributionType: DistributionType
  /** @deprecated use name instead */
  employer: Scalars['String']
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']
  /** @deprecated deprecated */
  employerName: Scalars['String']
  estimatedPaycheckAmount: CurrencyAmount
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
  name: Scalars['String']
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']
  updatedAt: Scalars['String']
  userId: Scalars['ID']
}

export type SplitDepositDirectDepositIntentSettingDepositsArgs = {
  limit?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Order>
}

export type SplitDepositDirectDepositSetting = SplitDepositSettings & {
  __typename?: 'SplitDepositDirectDepositSetting'
  allocations: Array<SplitDepositDirectDepositAllocation>
  awaitingConfiguration: Scalars['Boolean']
  createdAt: Scalars['String']
  deposits: Maybe<Array<SplitDeposit>>
  /** @deprecated deprecated */
  distributionType: DistributionType
  /** @deprecated use name instead */
  employer: Scalars['String']
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']
  /** @deprecated deprecated */
  employerName: Scalars['String']
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
  monthlyTotals: Array<MonthlyTotal>
  name: Scalars['String']
  normalizedAmount: Maybe<FormattedMonetaryAmount>
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']
  totalAmounts: Maybe<TotalAmounts>
  updatedAt: Scalars['String']
  userId: Scalars['ID']
}

export type SplitDepositDirectDepositSettingDepositsArgs = {
  limit?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Order>
}

export type SplitDepositMonthlyRecurrenceRule = SplitDepositRecurrenceRule & {
  __typename?: 'SplitDepositMonthlyRecurrenceRule'
  byMonthDay: Array<Scalars['Int']>
  frequency: SplitDepositRecurrenceFrequency
}

export type SplitDepositMutation = {
  __typename?: 'SplitDepositMutation'
  cancel: SplitDeposit
  execute: SplitDeposit
  id: Scalars['ID']
  userId: Scalars['ID']
}

export enum SplitDepositNormalizationFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY',
}

export type SplitDepositRecurrenceAllocation = SplitDepositAllocation & {
  __typename?: 'SplitDepositRecurrenceAllocation'
  allocationPercent: Scalars['String']
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  legacyRecurrenceAmount: Maybe<FormattedMonetaryAmount>
  legacyRecurrenceRule: Maybe<SplitDepositRecurrenceRule>
  nickname: Maybe<Scalars['String']>
  targetAccountId: Scalars['ID']
  targetAccountType: SplitDepositTargetAccountType
}

export enum SplitDepositRecurrenceFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
}

export type SplitDepositRecurrenceRule = {
  frequency: SplitDepositRecurrenceFrequency
}

export type SplitDepositRecurrenceSetting = SplitDepositSettings & {
  __typename?: 'SplitDepositRecurrenceSetting'
  allocations: Array<SplitDepositRecurrenceAllocation>
  createdAt: Scalars['String']
  deposits: Maybe<Array<SplitDeposit>>
  /** @deprecated deprecated */
  distributionType: DistributionType
  /** @deprecated use name instead */
  employer: Scalars['String']
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']
  /** @deprecated deprecated */
  employerName: Scalars['String']
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  monthlyTotals: Array<MonthlyTotal>
  name: Scalars['String']
  normalizedAmount: Maybe<FormattedMonetaryAmount>
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']
  updatedAt: Scalars['String']
  userId: Scalars['ID']
}

export type SplitDepositRecurrenceSettingDepositsArgs = {
  limit?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Order>
}

export enum SplitDepositSettingType {
  DirectDeposit = 'DIRECT_DEPOSIT',
  DirectDepositIntent = 'DIRECT_DEPOSIT_INTENT',
  Recurrence = 'RECURRENCE',
}

export type SplitDepositSettings = {
  allocations: Array<SplitDepositAllocation>
  createdAt: Scalars['String']
  deposits: Maybe<Array<SplitDeposit>>
  /** @deprecated deprecated */
  distributionType: DistributionType
  /** @deprecated use name instead */
  employer: Scalars['String']
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']
  /** @deprecated deprecated */
  employerName: Scalars['String']
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  name: Scalars['String']
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']
  updatedAt: Scalars['String']
  userId: Scalars['ID']
}

export type SplitDepositSettingsDepositsArgs = {
  limit?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Order>
}

export type SplitDepositSettingsFilterInput = {
  settingTypes: Array<SplitDepositSettingType>
  showHiddenEmployerSettings?: InputMaybe<Scalars['Boolean']>
}

export type SplitDepositSettingsMutation = {
  __typename?: 'SplitDepositSettingsMutation'
  configure: SplitDepositSettings
  employer: Scalars['String']
  employerHidden: Scalars['Boolean']
  id: Scalars['ID']
  userId: Scalars['ID']
}

export type SplitDepositSettingsMutationConfigureArgs = {
  input: ConfigureSettingsInput
}

export type SplitDepositTargetAccount = {
  __typename?: 'SplitDepositTargetAccount'
  nickname: Maybe<Scalars['String']>
  targetAccountId: Maybe<Scalars['ID']>
  targetAccountType: SplitDepositTargetAccountType
}

export enum SplitDepositTargetAccountType {
  Early = 'EARLY',
  Invest = 'INVEST',
  Later = 'LATER',
  Save = 'SAVE',
  Spend = 'SPEND',
}

export type SplitDepositWeeklyRecurrenceRule = SplitDepositRecurrenceRule & {
  __typename?: 'SplitDepositWeeklyRecurrenceRule'
  byWeekDay: Array<DayOfWeek>
  frequency: SplitDepositRecurrenceFrequency
}

/** This SSN already belongs to another beneficiary for this custodian */
export type SsnAlreadyInUseException = {
  __typename?: 'SsnAlreadyInUseException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** This SSN is a duplicate of the current custodian's SSN */
export type SsnMatchesCustodianException = {
  __typename?: 'SsnMatchesCustodianException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Beneficiary's ssn cannot be updated */
export type SsnUpdateForbiddenException = {
  __typename?: 'SsnUpdateForbiddenException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Attributes for starting PDF Switch */
export type StartAcornsPdfSwitchInput = {
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
  /** Employer Name */
  employerName?: InputMaybe<Scalars['String']>
  /** [DEPRECATED] Use employerName instead. */
  name?: InputMaybe<Scalars['String']>
  /** Session ID */
  sessionId?: InputMaybe<Scalars['ID']>
}

/** Starts a check deposit session. */
export type StartCheckDepositInput = {
  /** The client info to pass to Ensenta for validation purposes */
  clientInfo: ClientInfo
}

/** Starts a check deposit session with our vendor. */
export type StartCheckDepositPayload = {
  __typename?: 'StartCheckDepositPayload'
  /** Token that represents a session with our vendor. */
  sessionToken: Scalars['String']
}

export type StartExternalContributionInput = {
  amount: MicrosMoneyInput
  code: Scalars['ID']
  requestNonce: Scalars['ID']
  source?: InputMaybe<ExternalContributionSource>
}

export type StartExternalContributionResult =
  | ExternalContribution
  | ExternalContributionIdempotencyConflictError
  | ExternalContributionInvalidAmountError
  | ExternalContributionUnavailableError

/** Attributes for starting Online Switch */
export type StartOnlineSwitchInput = {
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
  /** Employer ID */
  employerId: Scalars['ID']
  /** Session ID */
  sessionId?: InputMaybe<Scalars['ID']>
}

export type StartOnlineSwitchPayload = SwitchPayloadInterface & {
  __typename?: 'StartOnlineSwitchPayload'
  userSwitch: UserSwitch
}

/** Changeable attributes for addresses */
export type StartSubmittableSwitchAddressInput = {
  /** City */
  city: Scalars['String']
  /** Country */
  country: Scalars['String']
  /** State */
  state: Scalars['String']
  /** Street 1 */
  street1: Scalars['String']
  /** Street 2 */
  street2?: InputMaybe<Scalars['String']>
  /** Zip code */
  zipCode: Scalars['String']
}

/** Attributes for starting Submittable Switch */
export type StartSubmittableSwitchInput = {
  /** Bank Account ID */
  bankAccountId?: InputMaybe<Scalars['ID']>
  /** Employer ID */
  employerId: Scalars['ID']
  /** Employer Address */
  employerLocationAddress?: InputMaybe<StartSubmittableSwitchAddressInput>
  /** Employee ID */
  nonSsnEmployeeId?: InputMaybe<Scalars['String']>
  /** Session ID */
  sessionId?: InputMaybe<Scalars['ID']>
}

export type StartSubmittableSwitchPayload = SwitchPayloadInterface & {
  __typename?: 'StartSubmittableSwitchPayload'
  userSwitch: UserSwitch
}

export enum StateCode {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Fm = 'FM',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mh = 'MH',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Pw = 'PW',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY',
}

export type StateWithholdingRule = {
  __typename?: 'StateWithholdingRule'
  applicableReasons: Maybe<Array<LaterWithdrawalReason>>
  canOptOut: Scalars['Boolean']
  createdAt: Scalars['String']
  effectiveFrom: Scalars['String']
  effectiveTo: Maybe<Scalars['String']>
  id: Scalars['ID']
  minOptOutAge: Maybe<Scalars['Int']>
  minRate: Scalars['String']
  notes: Maybe<Scalars['String']>
  optOutForm: Maybe<Scalars['String']>
  rateBasis: Scalars['String']
  stateCode: Scalars['String']
  triggerType: Scalars['String']
  updatedAt: Scalars['String']
}

/** Statement */
export type Statement = {
  __typename?: 'Statement'
  /**
   * Deprecated do not use
   * @deprecated Will not be supported in the future
   */
  archivableId: Maybe<Scalars['ID']>
  /**
   * Deprecated do not use
   * @deprecated Will not be supported in the future
   */
  archivableType: Maybe<Scalars['String']>
  /** created at date and time of Statement */
  createdAt: Scalars['DateTime']
  day: Scalars['Int']
  /** update at date and time of Statement */
  endDate: Maybe<Scalars['DateTime']>
  /**
   * Deprecated do not use
   * @deprecated Use taxFormType instead
   */
  formType: Maybe<FormType>
  id: Scalars['ID']
  /** Unique identifier of the investment account for which the statement was generated for. */
  investmentAccountId: Scalars['ID']
  investmentAccountType: Maybe<InvestmentAccountType>
  /**
   * Deprecated do not use
   * @deprecated Use statementLink instead
   */
  link: Maybe<StatementLink>
  month: Scalars['Int']
  portfolioType: StatementPortfolioType
  /**
   * Deprecated do not use
   * @deprecated Will not be supported in the future
   */
  s3Filename: Maybe<Scalars['String']>
  /** created at date and time of Statement */
  startDate: Maybe<Scalars['DateTime']>
  statementLink: Maybe<Scalars['String']>
  statementType: StatementType
  taxFormType: Maybe<TaxFormType>
  /** update at date and time of Statement */
  updatedAt: Maybe<Scalars['DateTime']>
  uploaded: Maybe<Scalars['Boolean']>
  year: Scalars['Int']
}

/** An individual edge within the paginated list of Statement */
export type StatementEdge = {
  __typename?: 'StatementEdge'
  /** The unique key used for pagination */
  cursor: Scalars['ID']
  /** The Statement record in the edge */
  node: Statement
}

/** StatementLink */
export type StatementLink = {
  __typename?: 'StatementLink'
  downloadUrl: Scalars['String']
  url: Scalars['String']
}

/** Relay style pagination information for Statement */
export type StatementPagination = {
  __typename?: 'StatementPagination'
  edges: Array<StatementEdge>
  pageInfo: PageInfo
}

export enum StatementPortfolioType {
  Customized = 'CUSTOMIZED',
  Managed = 'MANAGED',
  SelfDirected = 'SELF_DIRECTED',
}

/** All statement types */
export enum StatementType {
  /** daily user trade confirmation */
  DailyUserTradeConfirmation = 'daily_user_trade_confirmation',
  /** tax statements */
  Tax = 'tax',
  /** monthly statements */
  User = 'user',
  /** user trade cancellation confirmation */
  UserTradeConfirmationChargeback = 'user_trade_confirmation_chargeback',
}

export enum StickerOrderContext {
  Onboarding = 'ONBOARDING',
  PostOnboarding = 'POST_ONBOARDING',
}

export type Stock = Security & {
  __typename?: 'Stock'
  currentPrice: BigCurrencyAmount
  /** CUSIP identifier for the security, or null when unknown */
  cusip: Maybe<Scalars['String']>
  displayName: Scalars['String']
  earliestPriceDate: Scalars['Date']
  headlines: Array<SecurityHeadline>
  id: Scalars['ID']
  lastClosePrice: BigCurrencyAmount
  lastUpdatedAt: Scalars['DateTime']
  longName: Scalars['String']
  marketCap: Scalars['BigDecimal']
  openPrice: BigCurrencyAmount
  profile: SecurityProfile
  /** @deprecated Use Security.headlines. */
  securityHeadlines: Array<SecurityHeadline>
  /** @deprecated Use Security.profile. */
  securityProfile: SecurityProfile
  shortName: Scalars['String']
  symbol: Scalars['TickerSymbol']
  type: SecurityType
  volume: Scalars['BigDecimal']
  week52High: BigCurrencyAmount
  week52Low: BigCurrencyAmount
}

/** Chart for one stock or ETF. */
export type StockPerformanceWidget = {
  __typename?: 'StockPerformanceWidget'
  name: Scalars['String']
  symbol: Scalars['String']
}

/** There was a problem when making the deposits */
export type StoredRdvDepositsInvalid = {
  __typename?: 'StoredRdvDepositsInvalid'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

/** Deposits have not been initiated yet */
export type StoredRdvDepositsMissing = {
  __typename?: 'StoredRdvDepositsMissing'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export type Streak = {
  __typename?: 'Streak'
  /** Commitment reward details. Null for control/unbucketed users. */
  commitmentRewards: Maybe<CommitmentReward>
  configId: Scalars['String']
  currentPeriodCompleted: Scalars['Boolean']
  currentPeriodKey: Scalars['String']
  currentStreak: Scalars['Int']
  /**
   * Recap of the streak that just ended, for the broken-streak lander. Null unless
   * status is BROKEN, and null (fail closed) when the recap can't be computed in time.
   */
  endedStreak: Maybe<StreakEndedRecap>
  enrolledAt: Scalars['DateTime']
  /** Freeze details when status is FROZEN. Null when not frozen. */
  freeze: Maybe<StreakFreeze>
  id: Scalars['ID']
  longestStreak: Scalars['Int']
  /**
   * Milestone ladder progress. Null for users whose config has no tiers
   * (i.e. the control arm) — FE renders the pre-milestones experience.
   */
  milestones: Maybe<StreakMilestones>
  /** End of current period (Sunday 11:59:59 PM PT). Used for at-risk countdown timer. */
  periodEndTime: Scalars['DateTime']
  periodType: PeriodType
  restartCount: Scalars['Int']
  status: StreakStatus
  userId: Scalars['ID']
}

export enum StreakActivityType {
  OneTime = 'ONE_TIME',
  Recurring = 'RECURRING',
}

export type StreakConfigNotFoundError = {
  __typename?: 'StreakConfigNotFoundError'
  configId: Scalars['String']
}

export type StreakEndedRecap = {
  __typename?: 'StreakEndedRecap'
  /**
   * Total of streak-qualifying investments (one-time, recurring, round-ups) into Invest,
   * including its Custom Portfolio, during the ended streak. Excludes investments that
   * failed, were canceled, or were reversed.
   */
  investedAmount: MicrosMoney
  /** Last day (Sunday, Pacific) of the ended streak. */
  periodEnd: Scalars['Date']
  /** First day (Monday, Pacific) of the ended streak. */
  periodStart: Scalars['Date']
  /** Number of periods (weeks) the ended streak lasted. */
  periods: Scalars['Int']
}

export type StreakFreeze = {
  __typename?: 'StreakFreeze'
  count: Scalars['Int']
  frozenAt: Scalars['DateTime']
  frozenUntil: Scalars['DateTime']
  reason: Scalars['String']
}

export type StreakMilestone = {
  __typename?: 'StreakMilestone'
  achieved: Scalars['Boolean']
  /**
   * Opaque asset key clients resolve to the full-width banner artwork
   * (e.g. "/streaks/milestones/banner/mature-acorn").
   */
  bannerAssetPath: Scalars['String']
  /** Number of raffle entries earned at this milestone tier. Null when commitment rewards are not active. */
  entries: Maybe<Scalars['Int']>
  /** Stable slug — reward configs key off this. Never renamed. */
  id: Scalars['ID']
  name: Scalars['String']
  /** Opaque asset key clients resolve to a logo (e.g. "/streaks/milestones/badges/mature-acorn"). */
  remoteAssetPath: Scalars['String']
  /**
   * Streak progress boundary for this milestone. A threshold-0 base milestone remains
   * unachieved until the first streak period is completed.
   */
  threshold: Scalars['Int']
}

export type StreakMilestones = {
  __typename?: 'StreakMilestones'
  /**
   * Display stage — drives hero art and title. At streak 0 this is Acorn with
   * `achieved: false`. Usually also appears in `ladder` when that stage is
   * earnable; `ladder` only lists earnable milestones.
   */
  current: StreakMilestone
  /** The earnable achievements, ascending. Includes the Acorn first milestone. */
  ladder: Array<StreakMilestone>
  /** Next milestone above `current`. Null at the top of the ladder. */
  next: Maybe<StreakMilestone>
  /** Periods remaining to reach `next`. Null at the top. */
  periodsToNext: Maybe<Scalars['Int']>
}

export type StreakNotFoundError = {
  __typename?: 'StreakNotFoundError'
  configId: Scalars['String']
  userId: Scalars['ID']
}

export type StreakStateChangeLogEntry = {
  __typename?: 'StreakStateChangeLogEntry'
  changedBy: Scalars['ID']
  configId: Scalars['String']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  newCurrentStreak: Maybe<Scalars['Int']>
  newStatus: Maybe<StreakStatus>
  oldCurrentStreak: Maybe<Scalars['Int']>
  oldStatus: Maybe<StreakStatus>
  reason: Scalars['String']
  source: Scalars['String']
  userId: Scalars['ID']
}

export enum StreakStatus {
  Active = 'ACTIVE',
  AtRisk = 'AT_RISK',
  Broken = 'BROKEN',
  Frozen = 'FROZEN',
  Uninitialized = 'UNINITIALIZED',
}

export enum StreakType {
  Investing = 'INVESTING',
}

export type StringKeyAsset = {
  __typename?: 'StringKeyAsset'
  args: Array<Scalars['String']>
  key: Scalars['StringKey']
}

export type SubcategoryMessage = {
  __typename?: 'SubcategoryMessage'
  body: Maybe<Scalars['String']>
  ctaText: Maybe<Scalars['String']>
  id: Scalars['ID']
  title: Maybe<Scalars['String']>
  url: Maybe<Scalars['String']>
}

export type Submission = {
  __typename?: 'Submission'
  bank: BankName
  created: Scalars['DateTime']
  feeSynopsis: Maybe<Scalars['String']>
  key: Scalars['String']
  linkedAccountId: Scalars['ID']
  status: SubmissionStatus
  updated: Scalars['DateTime']
}

export type SubmissionError = {
  __typename?: 'SubmissionError'
  errors: Maybe<Array<Maybe<Scalars['String']>>>
}

export enum SubmissionStatus {
  Collect = 'COLLECT',
  Completed = 'COMPLETED',
  ConnectionError = 'CONNECTION_ERROR',
  DelayCharge = 'DELAY_CHARGE',
  MailInError = 'MAIL_IN_ERROR',
  MailInEscalated = 'MAIL_IN_ESCALATED',
  MailInPending = 'MAIL_IN_PENDING',
  MailInSent = 'MAIL_IN_SENT',
  Pending = 'PENDING',
}

export type SubmitBankFeeNegotiationInput = {
  linkedAccountId: Scalars['ID']
}

export type SubmitBankFeeNegotiationResponse = {
  __typename?: 'SubmitBankFeeNegotiationResponse'
  message: Scalars['String']
  status: Scalars['String']
}

export type SubmitBankFeeNegotiationResult =
  | LinkedAccountNotFound
  | SubmitBankFeeNegotiationResponse

export type SubmitMissingEarnRewardRequestInput = {
  extensionMerchantId?: InputMaybe<Scalars['String']>
  method: EarnRewardPurchaseMethod
  orderNumber: Scalars['String']
  ownerId?: InputMaybe<Scalars['ID']>
  proofOfPurchaseUrl: Scalars['URL']
  purchaseDate: Scalars['Date']
  subTotal: MicrosMoneyInput
  total: MicrosMoneyInput
}

export type SubmitMissingEarnRewardRequestResult =
  | MissingEarnRewardRequest
  | MissingEarnRewardRequestPurchaseDateError

export type SubmitSpendTransactionsDisputeInput = {
  cardNumber: Scalars['String']
  disputeReason: Scalars['String']
  eSignature: Scalars['String']
  merchantInfo: Scalars['String']
  message: Scalars['String']
  selectedTransactions: Array<SpendTransactionsInput>
  spendCardDetails: Scalars['String']
}

export type SubmitUserReportedBankFeeRefundInput = {
  refundAmount: Scalars['Amount']
  submissionId: Scalars['ID']
  userId: Scalars['ID']
}

export type SubmitUserReportedBankFeeRefundResult = {
  __typename?: 'SubmitUserReportedBankFeeRefundResult'
  message: Scalars['String']
}

/** Submittable Switches are performed via Click Switch API. */
export type SubmittableSwitch = SwitchInterface & {
  __typename?: 'SubmittableSwitch'
  requiresEmployerMailingAddress: Maybe<Scalars['Boolean']>
  requiresNonSsnEmployeeId: Maybe<Scalars['Boolean']>
  requiresSsnLastFour: Maybe<Scalars['Boolean']>
  source: SwitchSource
  type: SwitchType
  vendorTargetId: Scalars['ID']
}

export type SubscribeToTierInput = {
  createdBy?: InputMaybe<TierSubscriptionCreatedBy>
  feedback?: InputMaybe<Scalars['String']>
  tierId: Scalars['ID']
  tierPriceId: Scalars['ID']
  userId?: InputMaybe<Scalars['ID']>
}

export type SubscribeToTierResult =
  | InvalidTier
  | InvalidTierPrice
  | TierSubscription

export type SubscribeUserToTierByProductKeyInput = {
  /** Deprecated */
  createdBy?: InputMaybe<TierSubscriptionCreatedBy>
  /**
   * Subscription requests with an effective date earlier than the current subscription's createdAt
   * timestamp will be ignored. Defaults to current time.
   */
  effectiveAt?: InputMaybe<Scalars['DateTime']>
  productKey: ProductKey
  tierGroupId?: InputMaybe<Scalars['ID']>
}

export type SubscribeUserToTierInput = {
  /** Deprecated */
  createdBy?: InputMaybe<TierSubscriptionCreatedBy>
  tierPriceId: Scalars['ID']
}

export type SubscribeUserToTierResult =
  | InvalidTierPriceId
  | TierDowngradeActionRequired
  | TierSubscription

export type SubscriberIneligibleError = {
  __typename?: 'SubscriberIneligibleError'
  message: Scalars['String']
}

export type Subscription = {
  __typename?: 'Subscription'
  /** Subscribe to user/bot messages for a particular session */
  onChatMessage: ChatHistoryMessage
  /** Subscribe to user/bot messages for a particular session. This subscription supports both full messages and partial messages. Optionally accepts an initialPrompt to eliminate the race condition between subscription setup and message sending for deeplink flows. */
  onChatMessageStream: ChatMessageStreamResponse
  /** Returns new messages created */
  onMessageCreated: Message
}

export type SubscriptionOnChatMessageArgs = {
  sessionId: Scalars['ID']
}

export type SubscriptionOnChatMessageStreamArgs = {
  initialPrompt?: InputMaybe<Scalars['String']>
  metadata?: InputMaybe<ChatMessageMetadataInput>
  publishInitialPrompt?: InputMaybe<Scalars['Boolean']>
  sessionId: Scalars['ID']
  supportedChatFeatures?: InputMaybe<Array<ChatFeatures>>
}

export type SubscriptionOnMessageCreatedArgs = {
  categoryFilters?: InputMaybe<Array<MessageCategory>>
  typeFilters?: InputMaybe<Array<MessageType>>
}

export type SubscriptionMigration = {
  __typename?: 'SubscriptionMigration'
  createdAt: Scalars['DateTime']
  description: Scalars['String']
  effectiveAt: Scalars['DateTime']
  fromTier: Tier
  id: Scalars['ID']
  toTier: Tier
  updatedAt: Maybe<Scalars['DateTime']>
}

export type SubscriptionMigrationInvalidError = {
  __typename?: 'SubscriptionMigrationInvalidError'
  message: Scalars['String']
}

export type SubscriptionMigrationWaiver = {
  __typename?: 'SubscriptionMigrationWaiver'
  accepted: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  migration: SubscriptionMigration
  reason: SubscriptionMigrationWaiverReason
  updatedAt: Maybe<Scalars['DateTime']>
}

export enum SubscriptionMigrationWaiverReason {
  FinancialHardship = 'FINANCIAL_HARDSHIP',
}

export enum SubscriptionPaymentMethod {
  Ach = 'ach',
  Amazon = 'amazon',
  ApplePay = 'apple_pay',
  Bachs = 'bachs',
  Check = 'check',
  CreditCard = 'credit_card',
  Eft = 'eft',
  GooglePay = 'google_pay',
  MoneyOrder = 'money_order',
  Other = 'other',
  Paypal = 'paypal',
  Roku = 'roku',
  Sepadirectdebit = 'sepadirectdebit',
  WireTransfer = 'wire_transfer',
}

/** transition actions for a subscription */
export enum SubscriptionTransitionAction {
  AddPromotion = 'ADD_PROMOTION',
  Deactivate = 'DEACTIVATE',
  Downgrade = 'DOWNGRADE',
  /** @deprecated Internal value. Frontend should treat as UPGRADE. */
  NewSubscription = 'NEW_SUBSCRIPTION',
  /** @deprecated Internal value. Frontend should treat as UPGRADE. */
  Resubscribe = 'RESUBSCRIBE',
  /** @deprecated Internal value. Frontend should treat as UPGRADE. */
  UpdateBillingFrequency = 'UPDATE_BILLING_FREQUENCY',
  /** @deprecated Internal value. Frontend should treat as UPGRADE. */
  UpdateGroup = 'UPDATE_GROUP',
  Upgrade = 'UPGRADE',
}

export type SucceedVendorInvoiceResult = BillingVendorError | Invoice

export type SuggestedMoneyRulesResult = SuggestedMoneyRulesSuccess

export type SuggestedMoneyRulesSuccess = {
  __typename?: 'SuggestedMoneyRulesSuccess'
  adjustedForIncome: Scalars['Boolean']
  resultingCategories: Array<MoneyManagerCategory>
  resultingRuleset: MoneyRulesRuleset
}

export enum SuitabilityAccountSubtype {
  Individual = 'INDIVIDUAL',
  RothIra = 'ROTH_IRA',
  SepIra = 'SEP_IRA',
  TraditionalIra = 'TRADITIONAL_IRA',
}

export enum SuitabilityAccountType {
  Brokerage = 'BROKERAGE',
  Retirement = 'RETIREMENT',
}

export type SuitabilityAnswer = {
  __typename?: 'SuitabilityAnswer'
  answer: Scalars['String']
  id: Scalars['ID']
}

export type SuitabilityInput = {
  answerId: Scalars['ID']
  questionId: Scalars['ID']
}

export type SuitabilityQuestion = {
  __typename?: 'SuitabilityQuestion'
  answers: Array<Maybe<SuitabilityAnswer>>
  defaultAnswer: SuitabilityAnswer
  id: Scalars['ID']
  pickerId: Scalars['ID']
  placeholder: Scalars['String']
}

export type SummaryItem = {
  __typename?: 'SummaryItem'
  /** @deprecated Use `amountMicros` for standardized money format */
  amount: CurrencyAmount
  amountMicros: MicrosMoney
  title: Scalars['String']
}

export type SupportArticle = {
  __typename?: 'SupportArticle'
  author: SupportAuthor
  body: Scalars['String']
  draft: Maybe<Scalars['Boolean']>
  editedAt: Scalars['DateTime']
  id: Scalars['ID']
  labels: Maybe<Array<Maybe<Scalars['String']>>>
  /** @deprecated Private article access has been removed. */
  private: Maybe<Scalars['Boolean']>
  promoted: Maybe<Scalars['Boolean']>
  section: SupportSection
  sectionId: Scalars['ID']
  slug: Maybe<Scalars['String']>
  title: Scalars['String']
  version: Maybe<Scalars['Int']>
}

export type SupportAuthor = {
  __typename?: 'SupportAuthor'
  id: Scalars['ID']
  name: Scalars['String']
  photo: SupportAuthorPhoto
}

export type SupportAuthorPhoto = {
  __typename?: 'SupportAuthorPhoto'
  contentUrl: Scalars['String']
}

export type SupportCategory = {
  __typename?: 'SupportCategory'
  description: Scalars['String']
  id: Scalars['ID']
  name: Scalars['String']
}

export type SupportCitation = {
  __typename?: 'SupportCitation'
  id: Scalars['ID']
  title: Scalars['String']
}

export type SupportSection = {
  __typename?: 'SupportSection'
  articles: Array<Maybe<SupportArticle>>
  articlesCount: Scalars['Int']
  category: SupportCategory
  categoryId: Scalars['ID']
  id: Scalars['ID']
  name: Scalars['String']
}

export type SupportSectionArticlesArgs = {
  page?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
}

export type SupportTicket = {
  __typename?: 'SupportTicket'
  contactReason: Maybe<Scalars['String']>
  createdAt: Maybe<Scalars['DateTime']>
  description: Scalars['String']
  forethoughtResponseSent: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  identityVerified: Maybe<Scalars['String']>
  origin: Maybe<Scalars['String']>
  ownerId: Maybe<Scalars['ID']>
  parentCaseId: Maybe<Scalars['ID']>
  productTag: Maybe<Scalars['String']>
  reportingTag: Maybe<Scalars['String']>
  status: Maybe<Scalars['String']>
  subCategory: Maybe<Scalars['String']>
  subject: Scalars['String']
  updatedAt: Maybe<Scalars['DateTime']>
  url: Scalars['String']
}

export type SupportTicketEdge = {
  __typename?: 'SupportTicketEdge'
  cursor: Scalars['ID']
  node: Maybe<SupportTicket>
}

export type SupportTicketForm = {
  __typename?: 'SupportTicketForm'
  active: Maybe<Scalars['Boolean']>
  createdAt: Maybe<Scalars['DateTime']>
  displayName: Maybe<Scalars['String']>
  id: Scalars['ID']
  isDefault: Maybe<Scalars['Boolean']>
  ticketFields: Maybe<Array<Maybe<SupportTicketFormField>>>
  updatedAt: Maybe<Scalars['DateTime']>
}

export type SupportTicketFormField = {
  __typename?: 'SupportTicketFormField'
  active: Maybe<Scalars['Boolean']>
  createdAt: Maybe<Scalars['DateTime']>
  customFieldOptions: Maybe<Array<Maybe<CustomFieldOption>>>
  description: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Maybe<Scalars['String']>
  required: Maybe<Scalars['Boolean']>
  systemFieldOptions: Maybe<Array<Maybe<CustomFieldOption>>>
  title: Scalars['String']
  type: Scalars['String']
  updatedAt: Maybe<Scalars['DateTime']>
}

export enum SupportTicketOriginEnum {
  Chat = 'CHAT',
  Email = 'EMAIL',
  Phone = 'PHONE',
  Social = 'SOCIAL',
  Web = 'WEB',
}

export type SupportTicketResponse = RecaptchaException | SupportTicket

export enum SupportTicketStatusEnum {
  Closed = 'CLOSED',
  Escalated = 'ESCALATED',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  Solved = 'SOLVED',
  WaitingOnCustomer = 'WAITING_ON_CUSTOMER',
  WaitingOnCustomerSupport = 'WAITING_ON_CUSTOMER_SUPPORT',
  WaitingOnInternal = 'WAITING_ON_INTERNAL',
}

export type SupportTicketWithCustomFieldsResponse =
  | SubmissionError
  | SupportTicket

export type SupportTicketsResponse = {
  __typename?: 'SupportTicketsResponse'
  edges: Array<SupportTicketEdge>
  pageInfo: PageInfo
}

export type SupportUser = {
  __typename?: 'SupportUser'
  email: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
}

/** Response returned if the bank is supported for Plaid Verification. */
export type SupportsPlaidVerificationResult = {
  __typename?: 'SupportsPlaidVerificationResult'
  /** Plaid Verification supports this Bank */
  supportsPlaidVerificationType: Scalars['Boolean']
}

export type SuppressMoneyManagerRebalancesError = {
  __typename?: 'SuppressMoneyManagerRebalancesError'
  message: Scalars['String']
}

export type SuppressMoneyManagerRebalancesInput = {
  rebalanceSuppressionSource: MoneyManagerRebalanceSuppressionSource
}

export type SuppressMoneyManagerRebalancesResult =
  | SuppressMoneyManagerRebalancesError
  | SuppressMoneyManagerRebalancesSuccess

export type SuppressMoneyManagerRebalancesSuccess = {
  __typename?: 'SuppressMoneyManagerRebalancesSuccess'
  rebalancesSuppressedFrom: MoneyManagerRebalanceSuppressionSource
}

/** Common attributes for all Switch Types */
export type SwitchInterface = {
  source: SwitchSource
  type: SwitchType
}

export enum SwitchMethod {
  /** Used clickswitch */
  Clickswitch = 'clickswitch',
  /** Used clickswitch and online */
  ClickswitchOnline = 'clickswitchOnline',
  /** Used clickswitch, online, and PDF */
  ClickswitchOnlinePdf = 'clickswitchOnlinePdf',
  /** Used clickswitch and PDF */
  ClickswitchPdf = 'clickswitchPdf',
  /** None */
  None = 'none',
  /** Used online */
  Online = 'online',
  /** Used online and PDF */
  OnlinePdf = 'onlinePdf',
  /** Used pdf */
  Pdf = 'pdf',
  /** Unknown */
  Unknown = 'unknown',
}

export type SwitchPayloadInterface = {
  userSwitch: UserSwitch
}

export enum SwitchSource {
  Acorns = 'acorns',
  ClickSwitch = 'clickSwitch',
}

export enum SwitchState {
  /** Attempted to setup direct deposit */
  Attempted = 'attempted',
  /** User has not interacted with direct deposit in Acorns */
  NoInteraction = 'noInteraction',
  /** Completed direct deposit setup */
  Switched = 'switched',
  /** Viewed PDF screen or went to Online Portal */
  Viewed = 'viewed',
}

export enum SwitchStatus {
  /** Deposit confirmed in Spend account */
  Completed = 'completed',
  /** New for processing */
  New = 'new',
  /** PDF downloaded */
  PdfDownloaded = 'pdfDownloaded',
  /** PDF generated */
  PdfGenerated = 'pdfGenerated',
  /** Ready for processing */
  Ready = 'ready',
  /** Sent to ClickSwitch */
  Submitted = 'submitted',
}

export enum SwitchType {
  /** Online */
  Online = 'online',
  /** Default PDF */
  Pdf = 'pdf',
  /** Submittable Generic */
  Submittable = 'submittable',
  /** Submittable Custom */
  SubmittableCustom = 'submittableCustom',
}

export type SyncBankFeeTransactionsInput = {
  userId: Scalars['ID']
}

export type SyncBankFeeTransactionsResult = {
  __typename?: 'SyncBankFeeTransactionsResult'
  message: Scalars['String']
}

export type SyncFundingSourceToVendorResult =
  | BillingVendorError
  | DuplicateBillingInfoError
  | VendorBillingInfo

export type SyncNotInErrorStateError = {
  __typename?: 'SyncNotInErrorStateError'
  currentStatus: Scalars['String']
  message: Scalars['String']
}

export type SyncRecordNotFoundError = {
  __typename?: 'SyncRecordNotFoundError'
  message: Scalars['String']
}

export type SyncSubscriptionToVendorResult =
  | BillingVendorError
  | SyncSubscriptionToVendorSkipped
  | SyncSubscriptionToVendorSuccess

export type SyncSubscriptionToVendorSkipped = {
  __typename?: 'SyncSubscriptionToVendorSkipped'
  reason: Scalars['String']
}

export type SyncSubscriptionToVendorSuccess = {
  __typename?: 'SyncSubscriptionToVendorSuccess'
  action: Scalars['String']
  subscriptionId: Maybe<Scalars['String']>
}

export type SyncSupportAccountInput = {
  id: Scalars['ID']
}

export type SyncSupportAccountResponse = {
  __typename?: 'SyncSupportAccountResponse'
  eventId: Scalars['String']
}

export type SystemCardLockedSpendAlert = SpendAlert & {
  __typename?: 'SystemCardLockedSpendAlert'
  type: Scalars['String']
  userId: Scalars['ID']
}

/** Optional filter for getting customer accounts a user can deposit to. */
export type TargetAccountsFilterInput = {
  /** Filter accounts that are able to be deposited into at this time. */
  isDepositAllowed?: InputMaybe<Scalars['Boolean']>
  /** Filter accounts that a specified account can deposit into. */
  sourceAccountId?: InputMaybe<Scalars['ID']>
}

export enum TaxApplicationStatus {
  Cancelled = 'CANCELLED',
  ExemptFromFiling = 'EXEMPT_FROM_FILING',
  NotStarted = 'NOT_STARTED',
  Started = 'STARTED',
  Submitted = 'SUBMITTED',
}

export type TaxDocument = ChatDocument & {
  __typename?: 'TaxDocument'
  accountName: Scalars['String']
  link: Scalars['String']
  title: Scalars['String']
}

export type TaxFilingPartner = {
  __typename?: 'TaxFilingPartner'
  federalReturn: Maybe<TaxReturn>
  isDataConsentSigned: Maybe<Scalars['Boolean']>
  isStateFiled: Maybe<Scalars['Boolean']>
  /** @deprecated Monetary values have been migrated to new standard `MicrosMoney`. Use `netRefundAmountV2`. */
  netRefundAmount: Maybe<MonetaryAmount>
  netRefundAmountV2: Maybe<MicrosMoney>
  stateReturns: Maybe<Array<Maybe<TaxReturn>>>
  taxAppStatus: TaxApplicationStatus
}

export enum TaxFormType {
  Form1099 = 'form1099',
  Form1099Bdiv = 'form1099BDIV',
  Form1099Misc = 'form1099MISC',
  Form1099R = 'form1099R',
  Form1099R1 = 'form1099R1',
  Form1099R2 = 'form1099R2',
  Form1099R4 = 'form1099R4',
  Form1099R7 = 'form1099R7',
  Form1099R8 = 'form1099R8',
  Form1099Re = 'form1099RE',
  Form1099Rj = 'form1099RJ',
  Form1099Rq = 'form1099RQ',
  Form1099Rt = 'form1099RT',
  Form5498 = 'form5498',
  Other = 'other',
}

/** A tax refund event record with associated transactions and metadata */
export type TaxRefund = Node & {
  __typename?: 'TaxRefund'
  /** Date when the refund arrived */
  arrivalDate: Maybe<Scalars['Date']>
  /** Timestamp when this record was created */
  createdAt: Scalars['DateTime']
  /** External identifier for the refund */
  externalId: Scalars['String']
  /** Unique identifier for the tax refund */
  id: Scalars['ID']
  /** Amount that was invested (may differ from totalAmount) */
  investmentAmount: Maybe<MicrosMoney>
  /** Timestamp when the investment was made (defaults to now if not provided) */
  investmentTimestamp: Maybe<Scalars['DateTime']>
  /** Indicates if this transaction is an account funding source */
  isAccountFundingSource: Maybe<Scalars['Boolean']>
  /** Indicates if this refund represents multiple aggregated transactions */
  isAggregated: Scalars['Boolean']
  /** Indicates if the user has invested from this tax refund */
  isInvested: Scalars['Boolean']
  /** Identifier of the linked account if applicable */
  linkedAccountId: Maybe<Scalars['ID']>
  /** Identifier of the linked subaccount if applicable */
  linkedSubaccountId: Maybe<Scalars['ID']>
  /** Notification status for this tax refund */
  notificationStatus: TaxRefundNotificationStatus
  /** Optional subtype specifying more details about the refund */
  refundSubtype: Maybe<Scalars['String']>
  /** Type of tax refund (federal or state) */
  refundType: RefundType
  /** Total monetary amount of the refund */
  totalAmount: MicrosMoney
  /** Number of individual transactions associated with this refund */
  transactionCount: Scalars['Int']
  /** List of transactions that comprise this tax refund */
  transactions: Array<TaxRefundTransaction>
  /** Timestamp when this record was last updated */
  updatedAt: Scalars['DateTime']
  /** User identifier associated with this tax refund */
  userId: Scalars['ID']
}

/** Input type for filtering tax refunds */
export type TaxRefundFilterInput = {
  /** Notification status filter (defaults to SENT if not provided, null returns all) */
  notificationStatus?: InputMaybe<TaxRefundNotificationStatus>
  /** Optional refund ID filter (filters by tax refund event ID) */
  refundId?: InputMaybe<Scalars['ID']>
  /** Optional jurisdiction filter (state code or "US" for federal) */
  refundSubtype?: InputMaybe<Scalars['String']>
}

/** Notification status enum for tax refunds */
export enum TaxRefundNotificationStatus {
  /** Notification failed to send */
  Failed = 'FAILED',
  /** Notification has not been sent */
  NotSent = 'NOT_SENT',
  /** Notification has been sent successfully */
  Sent = 'SENT',
}

/** A financial transaction associated with a tax refund */
export type TaxRefundTransaction = {
  __typename?: 'TaxRefundTransaction'
  /** Amount of this individual transaction */
  amount: MicrosMoney
  /** Date when the transaction occurred */
  date: Scalars['Date']
  /** Internal transaction identifier */
  id: Scalars['String']
}

/** Input type for creating a tax refund transaction */
export type TaxRefundTransactionInput = {
  /** Amount of this individual transaction */
  amount: MicrosMoneyInput
  /** Date when the transaction occurred */
  date: Scalars['Date']
  /** Internal transaction identifier */
  id: Scalars['String']
}

export type TaxReturn = {
  __typename?: 'TaxReturn'
  /** @deprecated Monetary values have been migrated to new standard `MicrosMoney`. Use `refundAmountV2`. */
  refundAmount: MonetaryAmount
  refundAmountV2: MicrosMoney
  returnStatus: TaxReturnStatus
  taxLocationCode: Scalars['String']
}

export enum TaxReturnStatus {
  Accepted = 'ACCEPTED',
  NotSubmitted = 'NOT_SUBMITTED',
  Rejected = 'REJECTED',
  Retryable = 'RETRYABLE',
  Submitted = 'SUBMITTED',
}

export type TaxWithholdingAmounts = {
  __typename?: 'TaxWithholdingAmounts'
  /** total amount that will be withheld from the feds */
  federalWithholdingAmount: MonetaryAmount
  /** total amount that will be withheld from the state */
  stateWithholdingAmount: MonetaryAmount
}

export type TaxWithholdings = {
  federalTaxPercentage: Scalars['Float']
  stateTaxPercentage: Scalars['Float']
}

/** Whether and how much a user can contribute for a given tax year within a limit group. */
export type TaxYearContributionAbility = {
  __typename?: 'TaxYearContributionAbility'
  /** Whether the user is currently eligible to make contributions for this tax year. */
  canContribute: Scalars['Boolean']
  /** Whether the IRS catch-up contribution allowance has been applied to this limit. */
  catchUpApplied: Scalars['Boolean']
  /** Whether the contribution window for this tax year is currently open. */
  contributionWindowOpen: Scalars['Boolean']
  /** Breakdown of contributions already made toward this tax year's limit. */
  contributions: ContributionProgress
  /** The reason contributions are not allowed, when canContribute is false. */
  ineligibleReason: Maybe<ContributionIneligibleReason>
  /** The last date on which contributions for this tax year will be accepted, null if not yet determined. */
  lastContributionDate: Maybe<Scalars['Date']>
  /** The maximum contribution allowed for this tax year, null when the plan limit is unavailable. */
  planLimit: Maybe<Money>
  /** The amount still available to contribute before hitting the plan limit. */
  remaining: Maybe<Money>
  /** The tax year this ability applies to. */
  taxYear: Scalars['Int']
}

export type TestEvaluationDegradation = {
  __typename?: 'TestEvaluationDegradation'
  absentFields: Array<Scalars['String']>
  amplitudeDegraded: Scalars['Boolean']
  customerStateDegraded: Scalars['Boolean']
}

export type TestEvaluationScreenRow = {
  __typename?: 'TestEvaluationScreenRow'
  id: Scalars['ID']
  isDefault: Scalars['Boolean']
  selectionPriority: Scalars['Int']
  selectionRules: Maybe<Scalars['JSON']>
}

export enum TfaNotification {
  PushNotification = 'PUSH_NOTIFICATION',
}

export type TfaOptions = {
  __typename?: 'TfaOptions'
  email: Maybe<Array<Scalars['String']>>
  notification: Maybe<Array<TfaNotification>>
  phone: Maybe<Array<Scalars['String']>>
  question: Maybe<Array<Scalars['String']>>
}

export enum TfaStatus {
  Authorized = 'AUTHORIZED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Required = 'REQUIRED',
}

export enum TfaType {
  Email = 'EMAIL',
  Notification = 'NOTIFICATION',
  Pending = 'PENDING',
  Phone = 'PHONE',
  Question = 'QUESTION',
}

/** Address information from third-party providers */
export type ThirdPartyAddress = {
  __typename?: 'ThirdPartyAddress'
  /** City */
  city: Maybe<Scalars['String']>
  /**
   * Country
   * @deprecated Not used
   */
  country: Maybe<Scalars['String']>
  /** State or region */
  state: Maybe<Scalars['String']>
  /** Street address line 1 */
  street1: Maybe<Scalars['String']>
  /** Postal/ZIP code */
  zipCode: Maybe<Scalars['String']>
}

/** Third-party user data retrieved from external providers */
export type ThirdPartyData = {
  __typename?: 'ThirdPartyData'
  /** User's address information */
  address: Maybe<ThirdPartyAddress>
  /** User's date of birth */
  dateOfBirth: Maybe<Scalars['DateTime']>
  /** Customer's first name */
  firstName: Maybe<Scalars['String']>
  /** Customer's last name */
  lastName: Maybe<Scalars['String']>
  /** User's phone number */
  phoneNumber: Maybe<Scalars['PhoneNumber']>
}

/** Error occurred while retrieving third-party data */
export type ThirdPartyDataError = {
  __typename?: 'ThirdPartyDataError'
  /** Error message */
  message: Scalars['String']
  /** The provider that failed */
  provider: Maybe<Provider>
}

export type Tier = {
  __typename?: 'Tier'
  /** Indicates whether a tier is active or deprecated */
  active: Scalars['Boolean']
  /**
   * Image asset path in CDN
   * @deprecated Pricing interstitial does not use this field anymore
   */
  assetPath: Maybe<Scalars['String']>
  /** Associated grouping of products */
  bundles: Maybe<Array<Bundle>>
  description: Scalars['String']
  descriptionKey: Scalars['String']
  /** Name of tier to display in certain positions where space is limited */
  displayName: Maybe<Scalars['String']>
  /** @deprecated Use Query.products and Tier.products instead. */
  excludedProducts: Array<TierProduct>
  id: Scalars['ID']
  /** @deprecated Use Query.products and Tier.products instead. */
  includedProducts: Array<TierProduct>
  key: TierKey
  matchProgram: Maybe<MatchProgram>
  name: Scalars['String']
  /** Associated Products available when subscribed to this Tier. */
  products: Maybe<Array<Product>>
  /**
   * (DONT USE) Internal only, may be removed without warning.
   * @deprecated Use Query.tierGroupForUser to determine the subscriber's Tier Group.
   */
  tierGroupId: Scalars['ID']
  /** Price of Tier */
  tierPrice: TierPrice
}

export type TierMatchProgramArgs = {
  investmentAccountType: InvestmentAccountType
}

/** Individual action in a list of required actions */
export type TierDowngradeAction = {
  __typename?: 'TierDowngradeAction'
  key: TierDowngradeActionKey
}

/** Actions that must be taken to complete a downgrade workflow */
export enum TierDowngradeActionKey {
  CloseEarlyAccount = 'CLOSE_EARLY_ACCOUNT',
  CloseEmergencyFundAccount = 'CLOSE_EMERGENCY_FUND_ACCOUNT',
  CloseInvestAccount = 'CLOSE_INVEST_ACCOUNT',
  CloseLaterAccount = 'CLOSE_LATER_ACCOUNT',
  CloseSelfDirectedInvest = 'CLOSE_SELF_DIRECTED_INVEST',
  CloseSpendAccount = 'CLOSE_SPEND_ACCOUNT',
}

/** The list of required actions */
export type TierDowngradeActionRequired = {
  __typename?: 'TierDowngradeActionRequired'
  actions: Array<TierDowngradeAction>
}

/** Grouping of Tiers w/default tier, etc. */
export type TierGroup = {
  __typename?: 'TierGroup'
  active: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  /** Used to key A/B test off of */
  id: Scalars['ID']
  /** Tier ID which is the "preferred" one (i.e "Acorns recommends") */
  preferredTierId: Scalars['ID']
  tierOptions: Array<TierOption>
  updatedAt: Scalars['DateTime']
  winbackTierOption: Maybe<TierOption>
}

export enum TierKey {
  /** Hardship $1 tier for our winback campaign */
  Assist = 'ASSIST',
  /** Legacy $2 SPEND tier */
  Bronze = 'BRONZE',
  Copper = 'COPPER',
  /** Promotional tier for Cricket Wireless subscribers. */
  Cricket = 'CRICKET',
  Gold = 'GOLD',
  /** Promotional free tier for active military and veterans */
  Military = 'MILITARY',
  Null = 'NULL',
  Platinum = 'PLATINUM',
  Silver = 'SILVER',
}

/** Combination of a Tier and available prices to choose from. */
export type TierOption = {
  __typename?: 'TierOption'
  preferredTierPrice: TierPrice
  tier: Tier
  tierPrices: Array<TierPrice>
}

export type TierOptionByTierPriceIdResult = InvalidTierPriceId | TierOption

/** Pricing configuration used for a tier */
export type TierPrice = {
  __typename?: 'TierPrice'
  /** @deprecated Monetary values have been migrated to new standard `MicrosMoney`. Use `amountV2`. */
  amount: CurrencyAmount
  amountV2: MicrosMoney
  billingFrequency: BillingFrequency
  id: Scalars['ID']
  /** (DONT USE) Internal only, may be removed without warning. */
  tierId: Scalars['ID']
}

/** (Deprecated) Minimal representation of an Acorns product. */
export type TierProduct = {
  __typename?: 'TierProduct'
  /** used as unique identifier for this product */
  key: ProductKey
}

/** Unique combo of Tier and TierPrice tied to a User */
export type TierSubscription = {
  __typename?: 'TierSubscription'
  /** Reference to an Promotion the subscriber is actively consuming. */
  activePromotion: Maybe<Promotion>
  createdAt: Scalars['DateTime']
  createdBy: Maybe<TierSubscriptionCreatedBy>
  /**
   * Convenience field for waiver-adjusted price.
   * Equivalent to tierPrice.finalPrice but provided at top level.
   * Returns null if userId context is not available.
   */
  finalPrice: Maybe<FinalPrice>
  id: Scalars['ID']
  migration: Maybe<SubscriptionMigration>
  migrationId: Maybe<Scalars['ID']>
  /** The Offer the subscriber subscribed to for access to their Tier. */
  offer: Maybe<Offer>
  /** Indicates when the subscribers current Offer expires. */
  offerExpiresAt: Maybe<Scalars['DateTime']>
  /** Previous tier subscription the user had before this one. */
  previous: Maybe<TierSubscription>
  /** Indicates when a promotion was applied to the subscription. */
  promotionAppliedAt: Maybe<Scalars['DateTime']>
  /** Indication of when a subscribers promotion ends. */
  promotionExpiresAt: Maybe<Scalars['DateTime']>
  status: TierSubscriptionStatus
  tier: Tier
  tierPrice: TierPrice
  transition: Maybe<TierSubscriptionTransition>
  updatedAt: Scalars['DateTime']
  /** Flag to indicate if the subscription is being managed by our billing/subscription vendor */
  vendorIntegrated: Maybe<Scalars['Boolean']>
  /**
   * Detailed waiver information for this subscription.
   * Equivalent to tierPrice.waiverDetails but provided at top level.
   */
  waiverDetails: Maybe<WaiverDetails>
}

export type TierSubscriptionAlreadyDeactivated = {
  __typename?: 'TierSubscriptionAlreadyDeactivated'
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
}

export type TierSubscriptionConnection = {
  __typename?: 'TierSubscriptionConnection'
  edges: Array<TierSubscription>
  pageInfo: TierSubscriptionPageInfo
}

export enum TierSubscriptionCreatedBy {
  /** Subscription created by billing orchestration process */
  AcornsEarly = 'ACORNS_EARLY',
  /** Subscription created by the pre-launch backfill script */
  Backfill = 'BACKFILL',
  /** Flag to indicate user ought to be billed by the "legacy" billing system */
  LegacyUser = 'LEGACY_USER',
  /** Subscription record that was created as a result of a migration */
  Migration = 'MIGRATION',
  /** User auto-subscribed based on the status of their open accounts */
  SubscribedByOpenAccounts = 'SUBSCRIBED_BY_OPEN_ACCOUNTS',
  /** Subscription created via INTERNAL client request (either an admin or an internal process) */
  System = 'SYSTEM',
  /** Subscription created via EXTERNAL client request */
  User = 'USER',
}

/** account deactivation reasons */
export enum TierSubscriptionDeactivationReason {
  AcornsCostsTooMuch = 'ACORNS_COSTS_TOO_MUCH',
  CantAffordToInvestAtThisTime = 'CANT_AFFORD_TO_INVEST_AT_THIS_TIME',
  ConcernedAboutTheMarket = 'CONCERNED_ABOUT_THE_MARKET',
  DontWantToInvest = 'DONT_WANT_TO_INVEST',
  NotEnoughControlOverMyInvestments = 'NOT_ENOUGH_CONTROL_OVER_MY_INVESTMENTS',
  NotSureHowAcornsWorks = 'NOT_SURE_HOW_ACORNS_WORKS',
  NotTheRightTimeToInvest = 'NOT_THE_RIGHT_TIME_TO_INVEST',
  Other = 'OTHER',
  PoorInvestmentPerformance = 'POOR_INVESTMENT_PERFORMANCE',
  SwitchingToAnotherService = 'SWITCHING_TO_ANOTHER_SERVICE',
  ThisIsTemporaryIllBeBack = 'THIS_IS_TEMPORARY_ILL_BE_BACK',
  TroubleConnectingMyBank = 'TROUBLE_CONNECTING_MY_BANK',
  UnexpectedChargesToMyBank = 'UNEXPECTED_CHARGES_TO_MY_BANK',
}

export type TierSubscriptionForUser =
  | TierSubscription
  | TierSubscriptionNotFound
  | TierSubscriptionUnsubscribed

/** Returned if there is no found tier subscription */
export type TierSubscriptionNotFound = {
  __typename?: 'TierSubscriptionNotFound'
  message: Scalars['String']
}

/** Metadata for pagination of Tier Subscription History */
export type TierSubscriptionPageInfo = {
  __typename?: 'TierSubscriptionPageInfo'
  cursor: Maybe<Scalars['String']>
  hasNext: Scalars['Boolean']
}

/** Status of a tier subscription */
export enum TierSubscriptionStatus {
  /** An active subscription */
  Active = 'ACTIVE',
  /** A cancelled subscription */
  Inactive = 'INACTIVE',
  /** In the process of either upgrading or downgrading a subscription */
  Transitioning = 'TRANSITIONING',
}

/** Information about a transitioning subscription */
export type TierSubscriptionTransition = {
  __typename?: 'TierSubscriptionTransition'
  desiredTier: Maybe<Tier>
  /** Once we've decoupled our Tier and TierPrice, we'll need to make sure we're subscribing the user to the proper Tier and TierPrice */
  desiredTierPrice: Maybe<TierPrice>
  initiatedAt: Scalars['DateTime']
  subscriptionDeactivationReason: Maybe<TierSubscriptionDeactivationReason>
  transitionAction: SubscriptionTransitionAction
}

/** User has unsubscribed from their tier (account closed) */
export type TierSubscriptionUnsubscribed = {
  __typename?: 'TierSubscriptionUnsubscribed'
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
}

export enum TimeFrameFilter {
  Month = 'month',
  NinetyDays = 'ninetyDays',
  ThirtyDays = 'thirtyDays',
  Year = 'year',
}

export type TimestampsInterface = {
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export type TipContributionPageDetails = {
  __typename?: 'TipContributionPageDetails'
  investingStory: Maybe<Scalars['String']>
  targetDisplayName: Scalars['String']
}

export type TipProfessionOption = {
  __typename?: 'TipProfessionOption'
  label: Scalars['String']
  secondaryOptions: Array<TipProfessionOption>
  value: Scalars['String']
}

/** Authenticated recipient tip profile */
export type TipProfile = {
  __typename?: 'TipProfile'
  activatedAt: Scalars['ISO8601DateTime']
  displayName: Scalars['String']
  id: Scalars['ID']
  investingStory: Maybe<Scalars['String']>
  link: ContributionLink
  profession: Scalars['String']
  professionSecondary: Maybe<Scalars['String']>
  stickerOrdering: TipStickerOrdering
}

export type TipProfileIneligibleError = {
  __typename?: 'TipProfileIneligibleError'
  reason: TipProfileIneligibleReason
}

export enum TipProfileIneligibleReason {
  /** Feature is not available to this recipient */
  FeatureNotAvailable = 'FEATURE_NOT_AVAILABLE',
  /** Recipient has no account eligible to receive tips */
  NoEligibleDestinationAccount = 'NO_ELIGIBLE_DESTINATION_ACCOUNT',
  /** Recipient has not accepted the required Invest My Tips terms */
  TermsNotAccepted = 'TERMS_NOT_ACCEPTED',
  /** Recipient's account is suspended */
  UserSuspended = 'USER_SUSPENDED',
  /** Recipient's identity has not been verified */
  UserUnverified = 'USER_UNVERIFIED',
}

export type TipProfileInputViolation = {
  __typename?: 'TipProfileInputViolation'
  path: Array<Scalars['String']>
  reason: TipProfileInvalidInputReason
}

export type TipProfileInvalidInputError = {
  __typename?: 'TipProfileInvalidInputError'
  violations: Array<TipProfileInputViolation>
}

export enum TipProfileInvalidInputReason {
  /** Field value is not valid */
  Invalid = 'INVALID',
  /** A secondary profession is required for this primary profession */
  SecondaryRequired = 'SECONDARY_REQUIRED',
  /** Field value exceeds maximum length */
  TooLong = 'TOO_LONG',
}

/** Preflight setup config for the Tips onboarding flow */
export type TipProfileSetup = {
  __typename?: 'TipProfileSetup'
  isEligible: Scalars['Boolean']
  professions: Array<TipProfessionOption>
  unavailableReason: Maybe<TipProfileSetupUnavailableReason>
}

export enum TipProfileSetupUnavailableReason {
  /** Feature is not available to this recipient */
  FeatureNotAvailable = 'FEATURE_NOT_AVAILABLE',
  /** Recipient has no account eligible to receive tips */
  NoEligibleDestinationAccount = 'NO_ELIGIBLE_DESTINATION_ACCOUNT',
  /** Recipient's account is suspended */
  UserSuspended = 'USER_SUSPENDED',
  /** Recipient's identity has not been verified */
  UserUnverified = 'USER_UNVERIFIED',
}

/** Current sticker ordering configuration for Tips that Grow */
export type TipStickerOrdering = {
  __typename?: 'TipStickerOrdering'
  isEnabled: Scalars['Boolean']
  quantity: Scalars['Int']
}

export type Toggle = {
  __typename?: 'Toggle'
  id: Scalars['String']
  invalid: Maybe<Scalars['Boolean']>
  value: Scalars['Boolean']
}

export type TokenExpiredException = {
  __typename?: 'TokenExpiredException'
  message: Maybe<Scalars['String']>
}

/** Top Employer Name and Logo */
export type TopEmployer = {
  __typename?: 'TopEmployer'
  /** Employer Name */
  employerName: Scalars['String']
  /** Employer switch type */
  employerSwitchType: SwitchType
  /** Employer Logo URL */
  logo: Scalars['String']
  /** Employer online URL */
  onlineSwitchUrl: Maybe<Scalars['String']>
}

/** Top Employer List */
export type TopEmployerPayload = {
  __typename?: 'TopEmployerPayload'
  topEmployersList: Array<TopEmployer>
}

export type TopHolding = {
  __typename?: 'TopHolding'
  /** The market value that this security makes up of the ETF */
  marketValue: BigCurrencyAmount
  /** The number of shares that this security makes up of the ETF */
  numberOfShares: Maybe<Scalars['BigDecimal']>
  securityName: Scalars['String']
  /** The percentage of shares that this security makes up of the ETF */
  sharePercentage: Scalars['BigDecimal']
  symbol: Maybe<Scalars['TickerSymbol']>
}

export type TotalAmounts = {
  __typename?: 'TotalAmounts'
  totalContributedAmount: CurrencyAmount
  totalDepositedAmount: CurrencyAmount
}

export type TrackingIdCatalogEntry = {
  __typename?: 'TrackingIdCatalogEntry'
  createdAt: Scalars['DateTime']
  /** A trackingId that has been observed on at least one message. For Braze-sourced messages this is the Braze campaign ID. */
  trackingId: Scalars['ID']
}

export enum TradingSector {
  BasicMaterials = 'BASIC_MATERIALS',
  CommunicationServices = 'COMMUNICATION_SERVICES',
  ConsumerCyclical = 'CONSUMER_CYCLICAL',
  ConsumerDefensive = 'CONSUMER_DEFENSIVE',
  Energy = 'ENERGY',
  FinancialServices = 'FINANCIAL_SERVICES',
  HealthCare = 'HEALTH_CARE',
  Industrials = 'INDUSTRIALS',
  RealEstate = 'REAL_ESTATE',
  Technology = 'TECHNOLOGY',
  Utilities = 'UTILITIES',
}

export type Transaction = {
  __typename?: 'Transaction'
  amount: Maybe<Scalars['Float']>
  backupPaymentMethodUsed: Maybe<Scalars['Boolean']>
  collectedAt: Maybe<Scalars['DateTime']>
  collectionMethod: Maybe<Scalars['String']>
  createdAt: Maybe<Scalars['DateTime']>
  id: Maybe<Scalars['String']>
  object: Maybe<Scalars['String']>
  origin: Maybe<Scalars['String']>
  originalTransactionId: Maybe<Scalars['String']>
  refunded: Maybe<Scalars['Boolean']>
  status: Maybe<Scalars['String']>
  subscriptionIds: Maybe<Array<Maybe<Scalars['String']>>>
  success: Maybe<Scalars['Boolean']>
  type: Maybe<Scalars['String']>
  updatedAt: Maybe<Scalars['DateTime']>
  uuid: Maybe<Scalars['String']>
  voidedAt: Maybe<Scalars['DateTime']>
}

export enum TransactionCategory {
  Fee = 'FEE',
  Refund = 'REFUND',
}

export enum TransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
}

/** Transfer transactions object */
export type Transfer = {
  __typename?: 'Transfer'
  amount: CurrencyAmount
  /** When this was cancelled. NULL if never cancelled */
  canceledAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  from: TransferableAccount
  id: Scalars['ID']
  state: TransferState
  to: TransferableAccount
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
}

export enum TransferAction {
  /** Initiate a one time deposit to the top level account. */
  OneTimeDeposit = 'ONE_TIME_DEPOSIT',
  /** Initiate a one time withdrawal from the top level account. */
  OneTimeWithdrawal = 'ONE_TIME_WITHDRAWAL',
  /** Initiate a recurring deposit to the top level account. */
  RecurringDeposit = 'RECURRING_DEPOSIT',
}

export type TransferInternalSharesInput = {
  /** Manual input of the source account */
  accountFrom?: InputMaybe<Scalars['String']>
  /** Manual input of the destination account */
  accountTo?: InputMaybe<Scalars['String']>
  /** The key associated to the share transfer */
  idempotencyKey: Scalars['String']
  /** Array of symbols and the share quantities associated to each */
  internalShareTransfer: Array<InternalShareTransferInput>
  /** Determines the source and destination accounts of the transfer */
  shareTransferType?: InputMaybe<ShareTransferType>
}

export type TransferInternalSharesResult =
  | InternalShareTransferFailed
  | OmnibusShareTransferId

export enum TransferState {
  Canceled = 'canceled',
  Completed = 'completed',
  Initiated = 'initiated',
  Transferring = 'transferring',
}

export type TransferableAccount = {
  __typename?: 'TransferableAccount'
  /** The last 4 digits of the account or null if unavailable */
  accountNumberMasked: Maybe<Scalars['String']>
  /** A snapshot of the accounts last balance if available to acorns. External accounts wont have this. This is the value of the AVAILABLE balance. */
  balance: Maybe<CurrencyAmount>
  /** Whether an account is linked from plaid, spend, paypal, direct_bank or manual */
  externalSource: Maybe<ExternalSource>
  id: Scalars['ID']
  /** The name of the account. e.g. Chase Checking */
  name: Scalars['String']
  /** The type of Acorns account we are tracking for the user */
  type: TransferableAccountTypeEnum
}

export enum TransferableAccountTypeEnum {
  Core = 'core',
  Early = 'early',
  External = 'external',
  Later = 'later',
  Save = 'save',
  Spend = 'spend',
}

/** Info on accounts that can be transferred from */
export type TransferableFrom = {
  __typename?: 'TransferableFrom'
  from: TransferableAccount
}

/** Info about accounts that can be transferred to */
export type TransferableTo = {
  __typename?: 'TransferableTo'
  /** This field will be null if there is no max limit */
  max: Maybe<CurrencyAmount>
  /** This field will be null if there is no max limit */
  min: Maybe<CurrencyAmount>
  to: TransferableAccount
}

/** Actions for subscription transitions */
export enum TransitionAction {
  AddPromotion = 'ADD_PROMOTION',
  Downgrade = 'DOWNGRADE',
  NewSubscription = 'NEW_SUBSCRIPTION',
  Resubscribe = 'RESUBSCRIBE',
  Unsubscribe = 'UNSUBSCRIBE',
  UpdateBillingFrequency = 'UPDATE_BILLING_FREQUENCY',
  UpdateGroup = 'UPDATE_GROUP',
  Upgrade = 'UPGRADE',
}

export type TrendingLearnContentPreview =
  | LearnArticlePreview
  | LearnArticlePreviewLocked
  | LearnMediaPreview
  | LearnMediaPreviewLocked

/** Entity describing the TrustedContact for a user's InvestmentAccount(s) */
export type TrustedContact = {
  __typename?: 'TrustedContact'
  /** Email of trusted contact */
  email: Scalars['Email']
  /** First name of the trusted contact */
  firstName: Scalars['String']
  /** ID of the trusted contact */
  id: Scalars['ID']
  investmentAccounts: Array<Maybe<InvestmentAccount>>
  /** Last name of the trusted contact */
  lastName: Scalars['String']
  /** Phone number of trusted contact */
  phoneNumber: Scalars['PhoneNumber']
  /** ID of the user that the contact belongs to */
  userId: Scalars['ID']
}

/** Trusted contact email/phone not unique under user scope */
export type TrustedContactAlreadyExistsException = {
  __typename?: 'TrustedContactAlreadyExistsException'
  /** attributes that failed uniqueness check */
  attributes: Array<Scalars['String']>
  /** error message */
  message: Scalars['String']
}

/** Fields for adding/editing a trusted contact. */
export type TrustedContactInput = {
  /** Email of trusted contact */
  email: Scalars['Email']
  /** First name of the trusted contact */
  firstName: Scalars['String']
  /** All investment account ids that this TrustedContact should be assigned to */
  investmentAccountIds: Array<Scalars['ID']>
  /** Last name of the trusted contact */
  lastName: Scalars['String']
  /** Phone number of trusted contact */
  phoneNumber: Scalars['PhoneNumber']
}

/** Trusted contact email invalid */
export type TrustedContactInvalidEmail = {
  __typename?: 'TrustedContactInvalidEmail'
  /** error message */
  message: Scalars['String']
}

/** Trusted contact phone number invalid */
export type TrustedContactInvalidPhoneNumber = {
  __typename?: 'TrustedContactInvalidPhoneNumber'
  /** error message */
  message: Scalars['String']
}

/** TrustedContact does not exist */
export type TrustedContactNotFoundException = {
  __typename?: 'TrustedContactNotFoundException'
  /** message */
  message: Scalars['String']
}

export enum Type {
  Charge = 'charge',
  Credit = 'credit',
}

export enum UsStateCodes {
  /** Armed Forces America */
  Aa = 'AA',
  /** Armed Forces Europe */
  Ae = 'AE',
  /** Alaska */
  Ak = 'AK',
  /** Alabama */
  Al = 'AL',
  /** Armed Forces Pacific */
  Ap = 'AP',
  /** Arkansas */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Arizona */
  Az = 'AZ',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** District Of Columbia */
  Dc = 'DC',
  /** Delaware */
  De = 'DE',
  /** Florida */
  Fl = 'FL',
  /** Federated States Of Micronesia */
  Fm = 'FM',
  /** Georgia */
  Ga = 'GA',
  /** Guam */
  Gu = 'GU',
  /** Hawaii */
  Hi = 'HI',
  /** Iowa */
  Ia = 'IA',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Massachusetts */
  Ma = 'MA',
  /** Maryland */
  Md = 'MD',
  /** Maine */
  Me = 'ME',
  /** Marshall Islands */
  Mh = 'MH',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Missouri */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Mississippi */
  Ms = 'MS',
  /** Montana */
  Mt = 'MT',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Nebraska */
  Ne = 'NE',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** Nevada */
  Nv = 'NV',
  /** New York */
  Ny = 'NY',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Pennsylvania */
  Pa = 'PA',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palau */
  Pw = 'PW',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Virginia */
  Va = 'VA',
  /** U.S. Virgin Islands */
  Vi = 'VI',
  /** Vermont */
  Vt = 'VT',
  /** Washington */
  Wa = 'WA',
  /** Wisconsin */
  Wi = 'WI',
  /** West Virginia */
  Wv = 'WV',
  /** Wyoming */
  Wy = 'WY',
}

export type UnableToCancelCheckError = {
  __typename?: 'UnableToCancelCheckError'
  requestId: Scalars['ID']
}

/** Input for unauthenticated creation of an upload url for direct to s3 upload */
export type UnauthenticatedCreateUploadUrlInput = {
  /** the document type of the upload document */
  documentType: DocumentType
  /** the file_name upload document */
  fileName: Scalars['String']
  /** the suspended upload token of the user uploading a document */
  token: Scalars['String']
}

/** Input for saving an upload url after direct to s3 upload */
export type UnauthenticatedSaveUploadUrlInput = {
  /** the suspended upload additional info */
  additionalInfo?: InputMaybe<Scalars['String']>
  /** the suspended upload token of the user uploading a document */
  token: Scalars['String']
  /** the upload uuid from the upload object */
  uploadUuids: Array<Scalars['ID']>
}

/** LegacyUploadDocumentResult */
export type UnauthenticatedSaveUploadUrlResult =
  | DocumentUploads
  | UploadSaveError

export type UnauthorizedException = {
  __typename?: 'UnauthorizedException'
  message: Maybe<Scalars['String']>
}

export type UnauthorizedModifyLockedContentError = {
  __typename?: 'UnauthorizedModifyLockedContentError'
  message: Scalars['String']
}

export type UnblockDeviceInput = {
  deviceId: Scalars['ID']
}

export type UnblockDeviceResult = Device | DeviceNotFoundException

export type UnlinkOidcCredentialsInput = {
  oidcProvider: OidcProvider
}

export type UnlinkOidcCredentialsResult =
  | OidcCredentialsNotFoundException
  | UnlinkOidcCredentialsSuccess

export type UnlinkOidcCredentialsSuccess = {
  __typename?: 'UnlinkOidcCredentialsSuccess'
  email: Maybe<Scalars['EmailAddress']>
  oidcProvider: Maybe<OidcProvider>
  status: Maybe<Scalars['Boolean']>
  userId: Scalars['ID']
}

export type UnlockBankCardPayload = {
  __typename?: 'UnlockBankCardPayload'
  bankCard: Maybe<BankCard>
}

export type UnmarkLearnContentAsHelpfulInput = {
  contentId: Scalars['ID']
}

export type UnmarkLearnContentAsHelpfulResult =
  | RecordDoesNotExistError
  | UpdateLearnContentHelpfulnessResult

/** Account is not eligible for onboarding completion due to missing required info */
export type UnmetRequirementsException = {
  __typename?: 'UnmetRequirementsException'
  requirements: Array<OnboardingRequirement>
}

/** Error indicating that request cannot be retried */
export type UnrecoverableError = {
  __typename?: 'UnrecoverableError'
  /** Reason why error occurred */
  reason: Scalars['String']
}

/** The LinkedAccount associated with the linked_account_id will never be valid with the external provider */
export type UnrecoverableLinkedAccountError = {
  __typename?: 'UnrecoverableLinkedAccountError'
  /** ID of the unrecoverable LinkedAccount */
  linkedAccountId: Scalars['ID']
}

export type UnsubscribeUserFromTierInput = {
  /** Deprecated */
  createdBy?: InputMaybe<TierSubscriptionCreatedBy>
}

export type UnsubscribeUserFromTierResult =
  | TierDowngradeActionRequired
  | TierSubscriptionUnsubscribed

/**
 * Returned when the server supports none of the schema versions the client asked
 * for. The client should upgrade or surface a diagnostic.
 */
export type UnsupportedSchemaVersionException = {
  __typename?: 'UnsupportedSchemaVersionException'
  message: Maybe<Scalars['String']>
  /** Schema versions the server supports. */
  serverSupportedVersions: Array<Scalars['String']>
}

/** The associated beneficiary does not have a verified SSN */
export type UnverifiedBeneficiarySsnAlert = Alert & {
  __typename?: 'UnverifiedBeneficiarySsnAlert'
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary
  /**
   * Internal ID of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  beneficiaryId: Scalars['ID']
  /**
   * First name of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  firstName: Scalars['String']
  /** @deprecated The type of the alert is defined by the gql type. */
  type: Scalars['String']
  userId: Scalars['ID']
}

/** The associated beneficiary does not have a verified SSN */
export type UnverifiedBeneficiarySsnAlertItem = UserAlertsItem & {
  __typename?: 'UnverifiedBeneficiarySsnAlertItem'
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Source attribute object containing properties that can be updated. */
export type UpdatableAttributesInput = {
  /** Name of targeted group for ad in Adjust */
  adGroup?: InputMaybe<Scalars['String']>
  /** Name of campaign in Adjust */
  campaign?: InputMaybe<Scalars['String']>
  /** Click label of install with referral ID in Adjust */
  clickLabel?: InputMaybe<Scalars['String']>
  /** Creative content name in Adjust */
  creative?: InputMaybe<Scalars['String']>
  /** Name of funnel user wants to experience */
  funnel?: InputMaybe<FunnelName>
  /** Identifier for the prospect's attribution channel */
  sourceID?: InputMaybe<Scalars['String']>
  /** Full name of tracker in Adjust */
  trackerName?: InputMaybe<Scalars['String']>
  /** Six character token ID in Adjust */
  trackerToken?: InputMaybe<Scalars['String']>
}

/** Input to update account portfolio */
export type UpdateAccountPortfolioInput = {
  /** Investment account ID */
  investmentAccountId: Scalars['ID']
  /** Portfolio Risk Type */
  riskLevel: PortfolioRiskLevel
  /** Portfolio theme */
  theme: PortfolioTheme
}

/** Update Account Portfolio Response */
export type UpdateAccountPortfolioResponse =
  | InvalidActionOnAccount
  | InvestmentAccount
  | InvestmentAccountNotFoundException
  | PortfolioNotFoundException
  | PortfolioUpdateFailedException

export type UpdateAmplitudeFlagInput = {
  amplitudeUrl?: InputMaybe<Scalars['String']>
  changedBy: Scalars['String']
  description?: InputMaybe<Scalars['String']>
  displayName?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  reason?: InputMaybe<Scalars['String']>
  status?: InputMaybe<AmplitudeFlagStatus>
  trackExposure?: InputMaybe<Scalars['Boolean']>
}

export type UpdateAttributionInput = {
  /** Email address for prospect used during initial sign-up */
  email?: InputMaybe<Scalars['String']>
  /** Contextual attributes representing parameters surrounding user sign-up */
  sourceAttributes: UpdatableAttributesInput
  /** Unique user identifier */
  userId?: InputMaybe<Scalars['ID']>
}

/** Union for the result of the updateAttribution mutation */
export type UpdateAttributionResult =
  | InvalidConversionIdentifierException
  | InvalidSourceAttributesException
  | NoProspectRecord
  | RegistrationFunnel

export type UpdateAuthPhoneNumberInput = {
  phoneNumber: Scalars['PhoneNumber']
}

export type UpdateAuthPhoneNumberResult =
  | AuthProfile
  | InvalidPhoneNumberException

export type UpdateBankAccountGoalInput = {
  accountId: Scalars['ID']
  currentGoal: BankAccountGoalInput
}

export type UpdateBankAccountGoalPayload = {
  __typename?: 'UpdateBankAccountGoalPayload'
  requestId: Scalars['ID']
}

export type UpdateBankAccountGoalResult = UpdateBankAccountGoalPayload

export type UpdateBankCardPinInput = {
  newPin: Scalars['BankCardPin']
}

export type UpdateBankCardPinPayload = {
  __typename?: 'UpdateBankCardPinPayload'
  bankCard: Maybe<BankCard>
}

export type UpdateBannersInput = {
  helpcenter?: InputMaybe<HelpcenterContentInput>
  sitewide?: InputMaybe<SiteWideBannerContentInput>
}

/** Response to a beneficiary update */
export type UpdateBeneficiaryInfoResult =
  | Beneficiary
  | BeneficiaryNotFoundException
  | InternalErrorException
  | InvalidAddressException
  | InvalidEmailException
  | InvalidPhoneException

export type UpdateBenefitStatusInput = {
  benefitProductKey: BenefitsTrackerProducts
  claimStatus: ClaimStatus
  claimedOn?: InputMaybe<Scalars['DateTime']>
  details?: InputMaybe<Array<InputMaybe<BenefitStatusDetail>>>
  expiresOn?: InputMaybe<Scalars['DateTime']>
  updatedBy: Scalars['String']
}

export type UpdateBenefitStatusResponse = {
  __typename?: 'UpdateBenefitStatusResponse'
  message: Scalars['String']
}

export type UpdateCredentialsResult =
  | BlockedEmailDomainException
  | Credentials
  | EmailTakenException
  | UserCredentialsNotFoundException

/** Result of updateCustomerAddress mutation */
export type UpdateCustomerAddressResult = Address | InvalidAddressException

export type UpdateDelegateResult = DelegateDefinition

export type UpdateDepositTaxYearResult =
  | CustodianAccountNotFoundError
  | DepositAccountMismatchError
  | DepositNotSyncedError
  | UpdateDepositTaxYearSuccess
  | UpdateDepositTaxYearUnknownError
  | UpdateDepositTaxYearValidationError

export type UpdateDepositTaxYearSuccess = {
  __typename?: 'UpdateDepositTaxYearSuccess'
  investmentAccountId: Scalars['ID']
  investmentUuid: Scalars['ID']
  taxYear: Scalars['Int']
}

export type UpdateDepositTaxYearUnknownError = {
  __typename?: 'UpdateDepositTaxYearUnknownError'
  message: Scalars['String']
}

export type UpdateDepositTaxYearValidationError = {
  __typename?: 'UpdateDepositTaxYearValidationError'
  message: Scalars['String']
}

export type UpdateDesignatedBeneficiaryAddressInput = {
  city?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  street1?: InputMaybe<Scalars['String']>
  street2?: InputMaybe<Scalars['String']>
  zipCode?: InputMaybe<Scalars['String']>
}

export type UpdateDesignatedBeneficiaryInput = {
  address?: InputMaybe<UpdateDesignatedBeneficiaryAddressInput>
  dateOfBirth?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['EmailAddress']>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>
  relationship?: InputMaybe<DesignatedBeneficiaryRelationship>
  ssn?: InputMaybe<Scalars['String']>
}

export type UpdateDesignatedBeneficiaryResult =
  | DesignatedBeneficiary
  | DesignatedBeneficiaryExistsException
  | DesignatedBeneficiaryNotFoundException
  | DesignatedBeneficiaryValidationException

export type UpdateDesignationInput = {
  designationId: Scalars['ID']
  designationType?: InputMaybe<DesignationType>
  pctShare?: InputMaybe<Scalars['Float']>
}

export type UpdateDesignationResult =
  | Designation
  | DesignationNotFoundException
  | DesignationValidationException

export type UpdateElapsedTimeForLearnQuizInput = {
  elapsedTimeMilliseconds: MillisecondsInput
  quizId: Scalars['ID']
}

export type UpdateElapsedTimeForLearnQuizResult =
  | LearnContentElapsedMillisecondsUpdatedResult
  | RecordDoesNotExistError

export type UpdateFieldRegistryEntryInput = {
  /** Updated category. */
  category?: InputMaybe<FieldCategory>
  /** Email of the admin making the change (from Okta). Written to change_log.changed_by. */
  changedBy: Scalars['String']
  /** Reason shown to rule authors when they encounter this field in an existing rule tree. */
  deprecatedReason?: InputMaybe<Scalars['String']>
  /** Updated help text. */
  description?: InputMaybe<Scalars['String']>
  /** Updated human-readable name. */
  displayName?: InputMaybe<Scalars['String']>
  /** Field path can be updated since id is the stable key. */
  fieldPath?: InputMaybe<Scalars['String']>
  /** Primary key of the field_registry row. */
  id: Scalars['ID']
  /** Set to true to deprecate (hides from field picker), false to undeprecate. */
  isDeprecated?: InputMaybe<Scalars['Boolean']>
  /** Updated list of valid operators. */
  operators?: InputMaybe<Array<Scalars['String']>>
  /** Optional reason for the change. Written to change_log.reason. */
  reason?: InputMaybe<Scalars['String']>
}

export type UpdateFieldRegistryEntryResult = FieldRegistryEntry

export type UpdateLaterBeneficiaryInput = {
  addressLine1?: InputMaybe<Scalars['String']>
  addressLine2?: InputMaybe<Scalars['String']>
  /** Address type: Work, Home, Mailing, Previous, or Other. Defaults to "Home". */
  addressType?: InputMaybe<Scalars['String']>
  /** Beneficiary date of birth in ISO-8601 (YYYY-MM-DD) format. */
  birthDate: Scalars['String']
  city?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  firstName: Scalars['String']
  investmentAccountId: Scalars['ID']
  lastName: Scalars['String']
  /** Percentage share of the beneficiary (0.01–100). Defaults to 100. */
  percentageShare?: InputMaybe<Scalars['Float']>
  /** Relationship to the account holder. Defaults to "Other". */
  relationship?: InputMaybe<Scalars['String']>
  ssn?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  zip?: InputMaybe<Scalars['String']>
}

export type UpdateLaterBeneficiaryResult = {
  __typename?: 'UpdateLaterBeneficiaryResult'
  /** The Forge Trust beneficiaryId assigned to the beneficiary (null on failure). */
  beneficiaryId: Maybe<Scalars['ID']>
  investmentAccountId: Maybe<Scalars['ID']>
  message: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type UpdateLearnContentHelpfulnessResult = {
  __typename?: 'UpdateLearnContentHelpfulnessResult'
  contentId: Scalars['ID']
  isHelpful: Scalars['Boolean']
}

export type UpdateLearnProgressInput = {
  contentId: Scalars['ID']
  contentProgress: LearnProgressInput
}

export type UpdateLearnProgressResult =
  | LearnProgressUpdatedResult
  | RecordDoesNotExistError

/** Attributes for updating the linked account */
export type UpdateLinkedAccountInput = {
  /** Plaid link session id */
  linkSessionId: Scalars['String']
}

export type UpdateMessageFailed = {
  __typename?: 'UpdateMessageFailed'
  errorMessage: Scalars['String']
}

export type UpdateMessageIgnored = {
  __typename?: 'UpdateMessageIgnored'
  requestId: Scalars['ID']
}

export type UpdateMessageResult =
  | AlertMessage
  | LegacyAlertDismissalSuccess
  | NotificationMessage
  | UpdateMessageIgnored

export type UpdateMessagesFailure = {
  __typename?: 'UpdateMessagesFailure'
  errorMessage: Scalars['String']
}

/** Input type for updating MoneyManager allocations. */
export type UpdateMoneyManagerAllocationsInput = {
  allocations: Array<MoneyManagerStagedRulesInput>
  archetype?: InputMaybe<MoneyRulesArchetype>
  isCustomized: Scalars['Boolean']
}

/** Represents the result of the updateMoneyManagerAllocations mutation, which can be either a success or an error. */
export type UpdateMoneyManagerAllocationsResult =
  | AcornsValidationError
  | AllocationAmountsSumExceedingMaxError
  | InvalidSingleRuleIdError
  | MismatchedDistributionUnitsError
  | MissingValidRulesetError
  | NonUniqueSingleRuleIdsError
  | UpdateMoneyManagerAllocationsSuccess

/**
 * Represents a successful update of MoneyManager allocations.
 * Returns the list of money rules after the change.
 */
export type UpdateMoneyManagerAllocationsSuccess = {
  __typename?: 'UpdateMoneyManagerAllocationsSuccess'
  categories: Array<MoneyManagerCategory>
  rules: Array<MoneyRulesRule>
}

export type UpdateMoneyManagerAutomationTargetInput = {
  amount: MoneyRulesCurrencyAmountInput
  customSelection: Scalars['Boolean']
  suggestedPeriod?: InputMaybe<MoneyManagerPeriodInput>
  type: MoneyManagerAutomationTargetType
}

export type UpdateMoneyManagerAutomationTargetResult =
  | MoneyManagerInputError
  | UpdateMoneyManagerAutomationTargetSuccess

/** The new state of the user's automation targets */
export type UpdateMoneyManagerAutomationTargetSuccess = {
  __typename?: 'UpdateMoneyManagerAutomationTargetSuccess'
  automationTargets: Array<Maybe<MoneyManagerAutomationTarget>>
}

export type UpdateMoneyManagerSettingsFailure = {
  __typename?: 'UpdateMoneyManagerSettingsFailure'
  reason: Scalars['String']
}

export type UpdateMoneyManagerSettingsInput = {
  attemptedMoneyManagerOnboarding?: InputMaybe<Scalars['Boolean']>
  moneyManagerEnabled?: InputMaybe<Scalars['Boolean']>
  processRecurringDeposits?: InputMaybe<Scalars['Boolean']>
}

export type UpdateMoneyManagerSettingsResult =
  | UpdateMoneyManagerSettingsFailure
  | UpdateMoneyManagerSettingsSuccess

export type UpdateMoneyManagerSettingsSuccess = {
  __typename?: 'UpdateMoneyManagerSettingsSuccess'
  settings: Maybe<MoneyManagerSettings>
}

export type UpdateMoneyRulesSourceSettingsFailure = {
  __typename?: 'UpdateMoneyRulesSourceSettingsFailure'
  reason: Scalars['String']
}

export type UpdateMoneyRulesSourceSettingsInput = {
  moneyManagerEnabled?: InputMaybe<Scalars['Boolean']>
  processRecurringDeposits?: InputMaybe<Scalars['Boolean']>
}

export type UpdateMoneyRulesSourceSettingsResult =
  | UpdateMoneyRulesSourceSettingsFailure
  | UpdateMoneyRulesSourceSettingsSuccess

export type UpdateMoneyRulesSourceSettingsSuccess = {
  __typename?: 'UpdateMoneyRulesSourceSettingsSuccess'
  settings: Maybe<MoneyRulesSettings>
}

export type UpdateOauthAppInput = {
  accessTokenAudience?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  accessTokenExpiry?: InputMaybe<Scalars['Int']>
  active?: InputMaybe<Scalars['Boolean']>
  contactEmail?: InputMaybe<Scalars['String']>
  contactName?: InputMaybe<Scalars['String']>
  contract?: InputMaybe<Scalars['String']>
  externalApp?: InputMaybe<Scalars['Boolean']>
  imageUri?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  pageType?: InputMaybe<Scalars['String']>
  redirectUri?: InputMaybe<Scalars['String']>
  refreshTokenExpiry?: InputMaybe<Scalars['Int']>
  scopeIdentifiers?: InputMaybe<Array<Scalars['String']>>
  type?: InputMaybe<OauthAppType>
}

export type UpdateOauthAppResult = OauthApp | OauthAppNotFoundException

/** Changes opt_out_of_targeting field */
export type UpdateOptOutOfTargetingInput = {
  /** Has user opted out of targeting? */
  optedOutOfTargeting: Scalars['Boolean']
}

/** Input for updatePortfolioSecurities */
export type UpdatePortfolioSecuritiesInput = {
  /** Investment Account ID */
  investmentAccountId: Scalars['ID']
  /** Portfolio ID */
  portfolioId: Scalars['ID']
  /** List of Securities and their target allocation percent */
  securityAllocations: Array<SecurityAllocationTarget>
}

/** Result of updating a portfolio's securities */
export type UpdatePortfolioSecuritiesResult =
  | CustomerAgreementRequiredException
  | InvalidAllocationPercentError
  | InvalidPortfolioRatiosException
  | InvalidSecurityError
  | InvalidSecurityForAllocationError
  | InvestmentAccount
  | LiquidationUnavailableError
  | NegativeSecurityPercentError
  | PortfolioSecurityLimitReached

export type UpdatePromoCodeInput = {
  businessLine: PromoCodeBusinessLine
  channel: Scalars['String']
  condensedTitle: Scalars['String']
  cursor: Scalars['String']
  description: Scalars['String']
  internalMemo?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  publishEnd?: InputMaybe<Scalars['DateTime']>
  publishStart: Scalars['DateTime']
  qualificationAction: PromoCodeQualificationAction
  qualificationAmount: Scalars['Int']
  rewards?: InputMaybe<Array<Scalars['ID']>>
  status: PromoCodeStatus
  termsUrl?: InputMaybe<Scalars['URL']>
  title: Scalars['String']
}

export type UpdatePromoCodeResult =
  | DuplicatePromoCodeError
  | PromoCode
  | PromoCodeFieldLengthError

export type UpdatePromotedCampaignsInput = {
  campaignIds: Array<InputMaybe<Scalars['ID']>>
}

export type UpdatePromotedCampaignsResult = PromotedCampaigns

export type UpdateReferralCampaignInput = {
  actionFeedDesc?: InputMaybe<Scalars['String']>
  background?: InputMaybe<CampaignBackgroundType>
  condensedTitle?: InputMaybe<Scalars['String']>
  cursor: Scalars['String']
  description?: InputMaybe<Scalars['String']>
  eligibilityEnd?: InputMaybe<Scalars['DateTime']>
  hidden?: InputMaybe<Scalars['Boolean']>
  icon?: InputMaybe<CampaignIconType>
  internalMemo?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  payoutExpiryBufferDays?: InputMaybe<Scalars['Int']>
  publishEnd?: InputMaybe<Scalars['DateTime']>
  publishStart?: InputMaybe<Scalars['DateTime']>
  qualificationAction?: InputMaybe<CampaignQualificationActionType>
  qualificationAmount?: InputMaybe<Scalars['Int']>
  rewards?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  status?: InputMaybe<CampaignStatus>
  title?: InputMaybe<Scalars['String']>
}

export type UpdateReferralCampaignResult = ReferralCampaignV2

export type UpdateReferralPayoutInput = {
  advocateOfferId?: InputMaybe<Scalars['String']>
  /** Override: when the advocate reward was invested. Only applied when payout has advocate_offer_id. */
  advocateRewardedAt?: InputMaybe<Scalars['DateTime']>
  friendOfferId?: InputMaybe<Scalars['String']>
  /** Override: when the friend reward was invested. Only applied when payout has friend_offer_id. */
  friendRewardedAt?: InputMaybe<Scalars['DateTime']>
  payoutId: Scalars['ID']
  reason?: InputMaybe<ReferralPayoutDisqualificationReason>
  status: ReferralPayoutStatus
  statusChangeBy: Scalars['String']
}

export type UpdateReferralPayoutResult = ReferralPayout

export type UpdateReferralRelationshipInput = {
  friendId: Scalars['ID']
  status: ReferralRelationshipStatus
  /** Status of the referral relationship */
  statusDetails?: InputMaybe<ReferralStatusDetails>
}

export type UpdateReferralRelationshipResult = ReferralRelationship

/** Returned if failure updating reward */
export type UpdateReferralRewardError = {
  __typename?: 'UpdateReferralRewardError'
  message: Scalars['String']
}

export type UpdateReferralRewardResponse =
  | ReferralRewardSummary
  | UpdateReferralRewardError

export type UpdateScopeException = {
  __typename?: 'UpdateScopeException'
  message: Scalars['String']
}

export type UpdateScopeInput = {
  description?: InputMaybe<Scalars['String']>
  required?: InputMaybe<Scalars['Boolean']>
  title?: InputMaybe<Scalars['String']>
}

export type UpdateScopeResult = Scope | UpdateScopeException

export type UpdateScreenInput = {
  /** Email of the admin making the change. Written to change_log.changed_by. */
  changedBy: Scalars['String']
  /** Updated description. */
  description?: InputMaybe<Scalars['String']>
  /** Updated human-readable name. */
  displayName?: InputMaybe<Scalars['String']>
  /** Primary key of the screens row. */
  id: Scalars['ID']
  /** Updated isDefault flag. */
  isDefault?: InputMaybe<Scalars['Boolean']>
  /** Optional reason for the change. Written to change_log.reason. */
  reason?: InputMaybe<Scalars['String']>
  /** Updated selection priority. */
  selectionPriority?: InputMaybe<Scalars['Int']>
  /** Updated selection rule tree. */
  selectionRules?: InputMaybe<Scalars['JSON']>
  /** Updated lifecycle status. Set to INACTIVE to soft-delete this screen config. */
  status?: InputMaybe<ContentRulesScreenStatus>
  /** Updated ordered list of widget_type strings. */
  widgetPriority?: InputMaybe<Array<Scalars['String']>>
}

export type UpdateScreenResult = ContentRulesScreen | RuleTreeValidationError

export type UpdateSmsMfaEnforcementForUserResult =
  | AuthProfile
  | AuthProfileNotFoundException

export type UpdateStreakStateInput = {
  /** UserId of whoever is changing the streak state */
  changedBy: Scalars['ID']
  configId: Scalars['String']
  currentStreak?: InputMaybe<Scalars['Int']>
  /** Human-readable justification for the manual override, written to the audit log. */
  reason: Scalars['String']
  status?: InputMaybe<StreakStatus>
}

export type UpdateStreakStateResult = Streak | StreakNotFoundError

export type UpdateSupportTicketInput = {
  caseID: Scalars['ID']
  contactReason?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  identityVerified?: InputMaybe<IdentityVerifiedEnum>
  ownerId?: InputMaybe<Scalars['ID']>
  parentCaseId?: InputMaybe<Scalars['ID']>
  priority?: InputMaybe<Scalars['String']>
  productTag?: InputMaybe<ProductTagEnum>
  reason?: InputMaybe<Scalars['String']>
  status?: InputMaybe<SupportTicketStatusEnum>
  subcategory?: InputMaybe<Scalars['String']>
  subject?: InputMaybe<Scalars['String']>
}

/** Input for updating a tax refund event */
export type UpdateTaxRefundInput = {
  /** Tax refund identifier */
  id: Scalars['ID']
  /** Notification status to set */
  notificationStatus?: InputMaybe<TaxRefundNotificationStatus>
  /** Timestamp when notification was sent (defaults to now if notificationStatus is SENT and no timestamp is provided) */
  notificationTimestamp?: InputMaybe<Scalars['DateTime']>
}

/** Response payload for the updateTaxRefund mutation */
export type UpdateTaxRefundPayload = {
  __typename?: 'UpdateTaxRefundPayload'
  /** The updated tax refund record */
  taxRefund: TaxRefund
}

export type UpdateTipProfileInput = {
  displayName?: InputMaybe<Scalars['String']>
  investingStory?: InputMaybe<Scalars['String']>
}

export type UpdateTipProfileResult = TipProfile | TipProfileInvalidInputError

/** Response to a trusted contact update/insert */
export type UpdateTrustedContactResult =
  | InternalErrorException
  | TrustedContact
  | TrustedContactAlreadyExistsException
  | TrustedContactInvalidEmail
  | TrustedContactInvalidPhoneNumber
  | TrustedContactNotFoundException

/** Input type for updating user profile and automation target. */
export type UpdateUserProfileAndAutomationTargetInput = {
  /** The annual income of the user. */
  annualIncome: Scalars['Int']
}

/** Represents the result of the updateUserProfileAndAutomationTarget mutation, which can be either a success or an error. */
export type UpdateUserProfileAndAutomationTargetResult =
  UpdateUserProfileAndAutomationTargetSuccess

/** Represents a successful update of user profile and automation target. */
export type UpdateUserProfileAndAutomationTargetSuccess = {
  __typename?: 'UpdateUserProfileAndAutomationTargetSuccess'
  /** The updated annual income of the user. */
  annualIncome: Scalars['Int']
  /** The newly updated automation targets of the user. */
  automationTargets: Array<MoneyManagerAutomationTarget>
  /** The newly updated objective progress data. */
  cascadeObjectives: Array<MoneyManagerCascadeObjective>
  /** The types of the updated automation targets. */
  updatedTargetTypes: Array<MoneyManagerAutomationTargetType>
}

/** Describes the update user switch state return type. */
export type UpdateUserSwitchState =
  | UpdateUserSwitchStateFailure
  | UpdateUserSwitchStatePayload

/** Update User Switch State Returns Failure */
export type UpdateUserSwitchStateFailure = {
  __typename?: 'UpdateUserSwitchStateFailure'
  failureMessage: Scalars['String']
}

/** Mutation attributes for updating a user switch state in the Direct Deposit database */
export type UpdateUserSwitchStateInput = {
  /** Switch State */
  switchState: SwitchState
}

/** Update User Switch State Return Payload */
export type UpdateUserSwitchStatePayload = {
  __typename?: 'UpdateUserSwitchStatePayload'
  /** Switch State */
  switchState: SwitchState
  /** User ID */
  userId: Scalars['ID']
}

export type UpdateVendorSubscriptionBillingDateResult =
  | BillingVendorError
  | UpdateVendorSubscriptionBillingDateSuccess

export type UpdateVendorSubscriptionBillingDateSuccess = {
  __typename?: 'UpdateVendorSubscriptionBillingDateSuccess'
  nextBillDate: Scalars['DateTime']
  userId: Scalars['ID']
}

export type UpdateVerificationProfileResult = VerificationProfile

export type UpdateWidgetRegistryEntryInput = {
  /** Updated category. */
  category?: InputMaybe<Scalars['String']>
  /** Email of the admin making the change. Written to change_log.changed_by. */
  changedBy: Scalars['String']
  /** When true, show widget when required data is unavailable for rule evaluation. Omit to leave unchanged. */
  degradeToVisible?: InputMaybe<Scalars['Boolean']>
  /** Updated description. */
  description?: InputMaybe<Scalars['String']>
  /** Base dismissal key. SCREEN scope prepends screen_context; ALL uses as-is. Null = proxy to legacy. */
  dismissalKey?: InputMaybe<Scalars['String']>
  /** Controls how the effective dismissal key is built at read time. Omit to leave unchanged. */
  dismissalScope?: InputMaybe<ContentRulesWidgetDismissalScope>
  /** Updated human-readable name. */
  displayName?: InputMaybe<Scalars['String']>
  /** Primary key of the widget_registry row. */
  id: Scalars['ID']
  /** Optional reason for the change. Written to change_log.reason. */
  reason?: InputMaybe<Scalars['String']>
  /** Updated owning team. */
  serviceTeam?: InputMaybe<Scalars['String']>
  /** Updated routing status. */
  status?: InputMaybe<ContentRulesWidgetStatus>
}

export type UpdateWidgetRegistryEntryResult = WidgetRegistryEntry

export type UpdateWidgetRulesetInput = {
  /** Email of the admin making the change (from Okta). Written to change_log.changed_by. */
  changedBy: Scalars['String']
  /** Updated description. */
  description?: InputMaybe<Scalars['String']>
  /** Updated human-readable name. */
  displayName?: InputMaybe<Scalars['String']>
  /** Primary key of the widget_rulesets row. */
  id: Scalars['ID']
  /** Optional reason for the change. Written to change_log.reason. */
  reason?: InputMaybe<Scalars['String']>
  /** Updated JSON rule tree. Null means always eligible. */
  ruleTree?: InputMaybe<Scalars['JSON']>
  /** Updated lifecycle status. Set to INACTIVE to disable eligibility evaluation for this ruleset. */
  status?: InputMaybe<ContentRulesRulesetStatus>
}

export type UpdateWidgetRulesetResult = RuleTreeValidationError | WidgetRuleset

export type UpgradeAuthenticationResult =
  | AuthSession
  | AuthenticationAlreadyUpgradedException
  | UserCredentialsNotFoundException

/** Uploads a check image to the provided session. */
export type UploadCheckInput = {
  checkImage: CheckImage
  /** The session the image will be uploaded to. */
  sessionToken: Scalars['String']
}

/** Response from uploading a check image. */
export type UploadCheckPayload = {
  __typename?: 'UploadCheckPayload'
  /** Session image was uploaded to. */
  sessionToken: Scalars['String']
}

export type UploadDocumentsInput = {
  documentRequestId: Scalars['ID']
  documentType: DocumentType
  documents: Array<Scalars['Upload']>
  namespace?: InputMaybe<Scalars['String']>
  postUploadProcessing?: InputMaybe<PostUploadProcessingInput>
  sourceOperationId?: InputMaybe<Scalars['String']>
}

/** The upload does not exist. Must call CreateUploadUrl first. */
export type UploadDoesNotExist = {
  __typename?: 'UploadDoesNotExist'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

/** The upload does not exist. Must call CreateUploadUrl first. */
export type UploadDoesNotExistError = {
  __typename?: 'UploadDoesNotExistError'
  /** message */
  message: Maybe<Scalars['String']>
  /** The upload uuid */
  uploadUuid: Maybe<Scalars['ID']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export type UploadFailedError = {
  __typename?: 'UploadFailedError'
  message: Scalars['String']
}

export type UploadOauthAppImageResult =
  | InvalidContentTypeException
  | OauthAppImageUpload

/** Errors from backend upload */
export type UploadSaveError = {
  __typename?: 'UploadSaveError'
  uploadExceptions: Array<UploadSaveExceptions>
}

/** Exceptions from upload error */
export type UploadSaveExceptions =
  | FileDoesNotExistError
  | UploadDoesNotExistError

export type UploadUnsolicitedDocumentsInput = {
  documentType: DocumentType
  documents: Array<Scalars['Upload']>
  namespace?: InputMaybe<Scalars['String']>
  postUploadProcessing?: InputMaybe<PostUploadProcessingInput>
  requestKey?: InputMaybe<Scalars['String']>
  sourceOperationId?: InputMaybe<Scalars['String']>
  status?: InputMaybe<DocumentStatus>
}

/** An upload url */
export type UploadUrl = {
  __typename?: 'UploadUrl'
  key: Scalars['String']
  policy: Scalars['String']
  uploadUuid: Scalars['ID']
  url: Scalars['String']
  userId: Scalars['ID']
  xAmzAlgorithm: Scalars['String']
  xAmzCredential: Scalars['String']
  xAmzDate: Scalars['String']
  xAmzSecurityToken: Scalars['String']
  xAmzSignature: Scalars['String']
}

export type UpsertMessageConfigInput = {
  blockDisplay: Scalars['Boolean']
  blockIngestion: Scalars['Boolean']
  /** Delays the message for this many days after its createdAt. Null or 0 means no delay. */
  delayByDays?: InputMaybe<Scalars['Int']>
  /** Conditional display blocks. A message is hidden if any rule matches the request platform and client version. Replaces the existing rules; omit or pass an empty list for none. */
  displayRules?: InputMaybe<Array<DisplayRuleInput>>
  /** Message trackingId. For Braze-sourced messages this is the Braze campaign ID. */
  trackingId: Scalars['ID']
}

/** Changeable attributes for creating user matches */
export type UpsertUserMatchInput = {
  /** ID representation of the user in a external system */
  externalId: Scalars['String']
  /** The external system that the user is in */
  externalSource: ExternalUserSource
  /** Information used to identify the match */
  matchedCriteria?: InputMaybe<Array<Scalars['String']>>
  /** Current match status with external system */
  matchedStatus?: InputMaybe<UserMatchStatus>
}

/** Response to a user match creation or update attempt */
export type UpsertUserMatchResult = InternalErrorException | UserMatch

/** Entity representing the shared User object type used to resolve fields that belong to Auth Service */
export type User = {
  __typename?: 'User'
  address1: Maybe<Scalars['String']>
  address2: Maybe<Scalars['String']>
  alerts: Maybe<Array<UserAlert>>
  allocationProfileId: Maybe<Scalars['ID']>
  city: Maybe<Scalars['String']>
  closedAt: Maybe<Scalars['DateTime']>
  /** @deprecated Use InvestmentAccount.userAge or InvestmentAccount.withdrawalsIncurTaxPenalty instead. */
  dob: Maybe<Scalars['String']>
  email: Scalars['String']
  /** @deprecated Field no longer supported */
  employedAffiliatedWithBrokerDealer: Maybe<Scalars['Boolean']>
  employer: Maybe<Scalars['String']>
  firstName: Maybe<Scalars['String']>
  fundingSource: Maybe<FundingSource>
  fundingSourceChangeRequiresApproval: Maybe<Scalars['Boolean']>
  investmentAccounts: Maybe<Array<InvestmentAccount>>
  lastName: Maybe<Scalars['String']>
  occupation: Maybe<Scalars['String']>
  phoneNumber: Maybe<Scalars['String']>
  pinCreated: Maybe<Scalars['Boolean']>
  portfolio: Maybe<Portfolio>
  registrationComplete: Maybe<Scalars['Boolean']>
  registrationCompletedAt: Maybe<Scalars['DateTime']>
  /** @deprecated Field no longer supported */
  shareholderOrDirector: Maybe<Scalars['Boolean']>
  sourceId: Maybe<Scalars['String']>
  state: Maybe<Scalars['USStateName']>
  /** @deprecated Field no longer supported */
  subjectToBackupWithholding: Maybe<Scalars['Boolean']>
  uploads: Array<UserUpload>
  usCitizen: Maybe<Scalars['Boolean']>
  uuid: Scalars['ID']
  verified: Maybe<Scalars['Boolean']>
  zip: Maybe<Scalars['String']>
}

/** A user alert. */
export type UserAlert = UserAlertsItem & {
  __typename?: 'UserAlert'
  description: Scalars['String']
  id: Scalars['ID']
  key: Scalars['String']
  metadata: Maybe<Scalars['String']>
  title: Scalars['String']
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type UserAlertsItem = {
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Response from user alert query */
export type UserAlertsResponse =
  | AddressDocumentRequestedUserAlert
  | BankDocumentRequestedUserAlert
  | IdentityDocumentRequestedUserAlert
  | InsufficientFundsUserAlert
  | InvestmentsPausedUserAlert
  | MiscDocumentRequestedUserAlert
  | NoFundingSourceUserAlert
  | RdvRequiredUserAlert
  | SsnDocumentRequestedUserAlert
  | UserAlert
  | W9DocumentRequestedUserAlert

export type UserCardLockedSpendAlert = SpendAlert & {
  __typename?: 'UserCardLockedSpendAlert'
  type: Scalars['String']
  userId: Scalars['ID']
}

/** The provided user is closed */
export type UserClosedException = {
  __typename?: 'UserClosedException'
  /** message */
  message: Maybe<Scalars['String']>
  /** The provided user id */
  userId: Maybe<Scalars['ID']>
}

export type UserCohorts = {
  __typename?: 'UserCohorts'
  /** Updated list of cohorts */
  cohorts: Array<Scalars['String']>
  /** User's user_id */
  userId: Scalars['String']
}

export type UserCommunicationHistory = {
  __typename?: 'UserCommunicationHistory'
  messagingSessions: MessagingSessionResponse
  supportTickets: SupportTicketsResponse
  voiceCallTranscripts: VoiceCallTranscriptResponse
}

export type UserCommunicationHistoryMessagingSessionsArgs = {
  pagination?: InputMaybe<UserCommunicationHistoryInput>
}

export type UserCommunicationHistorySupportTicketsArgs = {
  pagination?: InputMaybe<UserCommunicationHistoryInput>
}

export type UserCommunicationHistoryVoiceCallTranscriptsArgs = {
  pagination?: InputMaybe<UserCommunicationHistoryInput>
}

export type UserCommunicationHistoryInput = {
  after?: InputMaybe<Scalars['ID']>
  ascending?: InputMaybe<Scalars['Boolean']>
  first?: InputMaybe<Scalars['Int']>
}

export type UserCredentials = {
  __typename?: 'UserCredentials'
  identifier: Scalars['String']
  type: CredentialsType
  userId: Scalars['ID']
}

export type UserCredentialsInput = {
  email: Scalars['EmailAddress']
}

export type UserCredentialsNotFoundException = {
  __typename?: 'UserCredentialsNotFoundException'
  message: Maybe<Scalars['String']>
}

/** User already exists */
export type UserExistsException = {
  __typename?: 'UserExistsException'
  userId: Maybe<Scalars['ID']>
}

/** A reopen check for an investment account reopen request. */
export type UserInvestmentAccountReopenCheck = TimestampsInterface & {
  __typename?: 'UserInvestmentAccountReopenCheck'
  /** The ID of the reopen request to which this check belongs. */
  accountReopenRequestId: Scalars['Int']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** The UUID of the investment account for which this check was made. */
  investmentAccountId: Scalars['ID']
  /** A boolean indicating whether this check passed or failed. */
  passed: Scalars['Boolean']
  /** The check type. */
  reopenCheckType: InvestmentAccountReopenCheck
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** UUID of the user to whom the account the reopen request was made for belongs. */
  userUuid: Scalars['ID']
}

export type UserLockedException = {
  __typename?: 'UserLockedException'
  message: Maybe<Scalars['String']>
}

/** record of a user matching in an external system */
export type UserMatch = {
  __typename?: 'UserMatch'
  /** Id of user in external system */
  externalId: Scalars['ID']
  externalMetadata: Maybe<ExternalMetadata>
  externalSource: ExternalUserSource
  /** Acorns user id */
  id: Scalars['ID']
  matchedAt: Scalars['DateTime']
  matchedCriteria: Maybe<Array<Scalars['String']>>
  matchedStatus: UserMatchStatus
}

export enum UserMatchStatus {
  UserMatchStatusEligible = 'USER_MATCH_STATUS_ELIGIBLE',
  UserMatchStatusIneligibleCancelled = 'USER_MATCH_STATUS_INELIGIBLE_CANCELLED',
  UserMatchStatusIneligibleIncorrectTier = 'USER_MATCH_STATUS_INELIGIBLE_INCORRECT_TIER',
  UserMatchStatusInvalid = 'USER_MATCH_STATUS_INVALID',
}

/** No user was found for the ID provided */
export type UserNotFound = {
  __typename?: 'UserNotFound'
  /** The provided user id */
  userId: Maybe<Scalars['ID']>
}

/** No user was found for the ID provided */
export type UserNotFoundException = {
  __typename?: 'UserNotFoundException'
  /** message */
  message: Maybe<Scalars['String']>
  /** The provided user id */
  userId: Maybe<Scalars['ID']>
}

/** User is not a US resident */
export type UserNotUsResidentException = {
  __typename?: 'UserNotUSResidentException'
  userId: Maybe<Scalars['ID']>
}

/** Custodian must be verified in order to open an Early Account */
export type UserNotVerifiedException = {
  __typename?: 'UserNotVerifiedException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type UserPartnerStatusResponse = {
  __typename?: 'UserPartnerStatusResponse'
  message: Scalars['String']
}

/** The provided user is locked */
export type UserReopenLockedException = {
  __typename?: 'UserReopenLockedException'
  /** The date the user was locked */
  lockedAt: Scalars['DateTime']
  /** The provided user id */
  userId: Maybe<Scalars['ID']>
}

/** The provided user is suspended */
export type UserReopenSuspendedException = {
  __typename?: 'UserReopenSuspendedException'
  /** The date the user was suspended */
  suspendedAt: Scalars['DateTime']
  /** The reason the user was suspended */
  suspendedReason: Maybe<Scalars['String']>
  /** The provided user id */
  userId: Maybe<Scalars['ID']>
}

/** User Status */
export type UserStatus = {
  __typename?: 'UserStatus'
  age: Scalars['Int']
  closed: Scalars['Boolean']
  closedAt: Maybe<Scalars['DateTime']>
  registrationComplete: Scalars['Boolean']
  registrationCompleteAt: Maybe<Scalars['DateTime']>
  userId: Scalars['String']
  verified: Scalars['Boolean']
  verifiedAt: Maybe<Scalars['DateTime']>
}

export type UserSuspendedException = {
  __typename?: 'UserSuspendedException'
  message: Maybe<Scalars['String']>
  suspendedToken: Maybe<Scalars['String']>
  suspensionReasonValid: Maybe<Scalars['Boolean']>
}

/** Token has incorrect length */
export type UserSuspendedUploadTokenLengthError = {
  __typename?: 'UserSuspendedUploadTokenLengthError'
  /** expected length of token */
  length: Scalars['Int']
}

/** Validation response for suspended upload token */
export type UserSuspendedUploadTokenValidation = {
  __typename?: 'UserSuspendedUploadTokenValidation'
  reason: Scalars['String']
  tokenValid: Scalars['Boolean']
}

/** Describes a user request for a direct deposit switch. */
export type UserSwitch = {
  __typename?: 'UserSwitch'
  /** Creation Date */
  createdAt: Scalars['String']
  /** Switch ID */
  id: Scalars['ID']
  /** Indicates whether the user is already depositing on the Spend account or not. */
  isComplete: Scalars['Boolean']
  /** Status of the direct deposit switch. */
  status: SwitchStatus
  /** Switch Type */
  switchType: SwitchType
  /** Last Updated Date */
  updatedAt: Scalars['String']
  /** User ID */
  userId: Scalars['ID']
  /** Switch ID provided by the vendor. */
  vendorSwitchId: Maybe<Scalars['ID']>
}

export type UserToken = {
  __typename?: 'UserToken'
  consumedAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  expiresAt: Scalars['DateTime']
  oauthAppClientId: Maybe<Scalars['ID']>
  oauthAppId: Scalars['ID']
  updatedAt: Scalars['DateTime']
  userId: Scalars['ID']
  userScopes: Array<Maybe<Scalars['String']>>
  userTokenId: Scalars['ID']
}

export type UserUpload = {
  __typename?: 'UserUpload'
  createdAt: Scalars['DateTime']
  documentType: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Object representing an acorns user */
export type User_V2 = {
  __typename?: 'User_v2'
  closedAt: Maybe<Scalars['Date']>
  email: Scalars['String']
  uuid: Scalars['ID']
}

export type ValidPolicies = {
  __typename?: 'ValidPolicies'
  policies: Maybe<Array<Maybe<Policy>>>
}

export type ValidateCredentialsInput = {
  credentialsType?: CredentialsType
  nativeLoginInput?: InputMaybe<NativeLoginInput>
  oidcLoginInput?: InputMaybe<OidcLoginInput>
  udid: Scalars['String']
}

export type ValidateCredentialsResult =
  | AuthSession
  | AuthenticatorUnavailableException
  | DeviceBlockedException
  | InvalidCredentialsException
  | LoginRateLimitedException
  | OidcCredentialsNotFoundException
  | UserSuspendedException
  | ValidateCredentialsSuccess

export type ValidateCredentialsSuccess = {
  __typename?: 'ValidateCredentialsSuccess'
  authenticators: Maybe<Array<Authenticator>>
  defaultAuthenticator: Authenticator
  mfaToken: Scalars['String']
  userId: Scalars['ID']
}

export type ValidateDocumentsInput = {
  /**
   * ID of document provided by Socure
   * @deprecated APIs have been upgraded to V5. Use transactionToken instead.
   */
  documentId?: InputMaybe<Scalars['ID']>
  /** Acorns subaccount for processing uploaded documents */
  product?: InputMaybe<IdentitySubaccount>
  /** Token retrieved from the API response of the Document Request endpoint */
  transactionToken?: InputMaybe<Scalars['String']>
}

export type ValidatePasswordResetTokenResult =
  | InvalidPasswordResetTokenException
  | ValidatePasswordResetTokenSuccess

export type ValidatePasswordResetTokenSuccess = {
  __typename?: 'ValidatePasswordResetTokenSuccess'
  displaySsnField: Scalars['Boolean']
}

/** Failure validating security availability */
export type ValidateSecurityAvailabilityFailed = {
  __typename?: 'ValidateSecurityAvailabilityFailed'
  description: Scalars['String']
}

export type ValidateSecurityAvailabilityInput = {
  symbols: Array<Scalars['TickerSymbol']>
}

export type ValidateSecurityAvailabilityResult =
  | SecurityAvailabilityResults
  | ValidateSecurityAvailabilityFailed

/** Input for validating a user suspended upload token */
export type ValidateUserSuspendedUploadTokenInput = {
  /** Upload token */
  token: Scalars['String']
}

/** Result from validating document uploader token */
export type ValidateUserSuspendedUploadTokenResult =
  | UserSuspendedUploadTokenLengthError
  | UserSuspendedUploadTokenValidation

export type ValidationError = {
  __typename?: 'ValidationError'
  errorCode: Scalars['String']
  errorMessage: Maybe<Scalars['String']>
  /** The nonce of the intent. */
  intentId: Scalars['UUID']
}

export type VendAuthSessionInput = {
  challengeAnswerInput: ChallengeAnswerInput
  rememberMe?: InputMaybe<Scalars['Boolean']>
  udid: Scalars['String']
  userId: Scalars['ID']
}

export type VendAuthSessionResult =
  | AuthChallengeAnswerAttemptsExhaustedException
  | AuthChallengeAnswerIncorrectException
  | AuthChallengeExpiredException
  | AuthSession
  | ChallengeRateExceededException
  | DeviceBlockedException
  | UserSuspendedException

export type VendorBillingInfo = {
  __typename?: 'VendorBillingInfo'
  accountType: Maybe<Scalars['String']>
  id: Maybe<Scalars['String']>
  lastFour: Maybe<Scalars['String']>
  primary: Maybe<Scalars['Boolean']>
  routingNumber: Maybe<Scalars['String']>
}

export type VendorCustomerAccount = {
  __typename?: 'VendorCustomerAccount'
  billTo: Maybe<Scalars['String']>
  code: Maybe<Scalars['String']>
  company: Maybe<Scalars['String']>
  dunningCampaignId: Maybe<Scalars['String']>
  email: Maybe<Scalars['String']>
  firstName: Maybe<Scalars['String']>
  id: Maybe<Scalars['String']>
  lastName: Maybe<Scalars['String']>
  object: Maybe<Scalars['String']>
  parentAccountId: Maybe<Scalars['String']>
}

export type VendorIntegrationError = {
  __typename?: 'VendorIntegrationError'
  message: Scalars['String']
}

export type VendorRefundInvoiceError = {
  __typename?: 'VendorRefundInvoiceError'
  message: Scalars['String']
}

export type VerificationDetails = {
  __typename?: 'VerificationDetails'
  /**
   * This field indicates whether this KYC verification result is still valid and usable for the user today, regardless of its status (e.g., success, soft fail, hard fail).
   * When true, the banking KYC is either tied to an active account or part of an ongoing KYC process. When false, the user’s account may be closed or archived, making this KYC result no longer reusable.
   * Per our current approved BANK guidelines, a new KYC verification must be initiated within banking if the user goes through a reopen process.
   */
  isActive: Maybe<Scalars['Boolean']>
  response: Maybe<Scalars['String']>
  vendor: Maybe<Scalars['String']>
}

export type VerificationProfile = {
  __typename?: 'VerificationProfile'
  /** Session ID calculated by Socure */
  deviceSessionId: Maybe<Scalars['String']>
  /** Status of submitted documents after initial identity verification */
  documentVerification: Maybe<DocumentVerification>
  /** SSN verification consent */
  eCBSV: Ecbsv
  /**
   * Flag indicating whether eCBSV can be used or not for verification
   * @deprecated Use `eCBSV.consent` instead
   */
  eCBSVConsent: Scalars['Boolean']
  /** Customer's IP address used during registration */
  ipAddress: Maybe<Scalars['String']>
}

export type VerificationProfileInput = {
  /** Session ID calculated by Socure */
  deviceSessionId?: InputMaybe<Scalars['String']>
  /** Customer's acceptance or declination of consent to utilize eCBSV */
  eCBSVConsent?: InputMaybe<Scalars['Boolean']>
}

export enum VerificationStatus {
  ActionRequired = 'actionRequired',
  ActionRequiredDueToFailure = 'actionRequiredDueToFailure',
  Failure = 'failure',
  Pending = 'pending',
  Success = 'success',
}

export type VerifyCheckPaymentRecipientAddressInputType = {
  recipient: CheckPaymentRecipientInput
  recipientAddress: CheckPaymentAddressInput
}

/** Address deliverable by mail carrier or InvalidAddressError */
export type VerifyCheckPaymentRecipientAddressResult =
  | AuthorizationError
  | CheckPaymentRecipientAddressType
  | InvalidAddressError

export type VerifyDeviceInput = {
  deviceId: Scalars['ID']
}

export type VerifyDeviceResult =
  | DeviceNotFoundException
  | EmailAuthChallenge
  | SmsAuthChallenge

export type VerifyIdentityByDocumentsResult = DocumentVerification

export type VerifyPasswordsInput = {
  newPassword: Scalars['String']
  oldPassword: Scalars['String']
}

export type VerifyPasswordsResult =
  | IncorrectOldPasswordException
  | InvalidPasswordException
  | SamePasswordsException
  | UnauthorizedException
  | VerifyPasswordsSuccess

export type VerifyPasswordsSuccess = {
  __typename?: 'VerifyPasswordsSuccess'
  isValid: Scalars['Boolean']
}

export type VerifyPromoCodeResponse = InvalidPromoCodeError | PromoCode

/** Input for verifying RDVs */
export type VerifyRdvsInput = {
  /** Deposit amounts inputted by user. Example: [0.77, 0.23] */
  deposits: Array<Scalars['Float']>
}

/** Result from attempting to verify RDVs */
export type VerifyRdvsResult =
  | AccountFrozen
  | FundingSourceAccount
  | IncorrectRdvAmounts
  | StoredRdvDepositsInvalid
  | StoredRdvDepositsMissing

export type VersionMismatchException = {
  __typename?: 'VersionMismatchException'
  latestVersion: Maybe<Scalars['ID']>
}

export type ViewedLearnContentResult = {
  __typename?: 'ViewedLearnContentResult'
  contentId: Scalars['ID']
}

export type VoiceCallTranscript = {
  __typename?: 'VoiceCallTranscript'
  createdAt: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  link: Maybe<Scalars['String']>
  supportTicketId: Maybe<Scalars['ID']>
  title: Maybe<Scalars['String']>
}

export type VoiceCallTranscriptEdge = {
  __typename?: 'VoiceCallTranscriptEdge'
  cursor: Scalars['ID']
  node: Maybe<VoiceCallTranscript>
}

export type VoiceCallTranscriptResponse = {
  __typename?: 'VoiceCallTranscriptResponse'
  edges: Array<VoiceCallTranscriptEdge>
  pageInfo: PageInfo
}

/** W9 document requested. */
export type W9DocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'W9DocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** result from attempting to create a provisional waiver for a user */
export type Waiver = MightyOakCardWaiver | PromotionalWaiver | ProvisionalWaiver

export type WaiverCoupon = {
  __typename?: 'WaiverCoupon'
  couponId: Scalars['String']
  discountAmount: Scalars['Float']
  discountType: Scalars['String']
  monthsToWaive: Scalars['Int']
  waiverType: Scalars['String']
}

export type WaiverCreationException = {
  __typename?: 'WaiverCreationException'
  message: Scalars['String']
}

export type WaiverDeletionException = {
  __typename?: 'WaiverDeletionException'
  message: Scalars['String']
}

/** Detailed waiver metadata - only present when user has an active waiver. */
export type WaiverDetails = {
  __typename?: 'WaiverDetails'
  /** Recurly coupon identifier. */
  couponId: Maybe<Scalars['String']>
  /** Discount amount or percentage. */
  discountAmount: Scalars['Float']
  /** Type of discount: "percent" or "dollar". */
  discountType: Scalars['String']
  /** When the waiver expires. */
  waiverEndDate: Scalars['String']
  /**
   * Waiver type: "PROVISIONAL", "MIGHTY_OAK_CARD", "CRICKET", etc.
   * Matches waiverType from RedeemedWaiverCoupon.
   */
  waiverType: Scalars['String']
}

export enum WaiverPromotion {
  /** Cricket Wireless Promotion */
  Cricket = 'CRICKET',
  /** Mighty Oak Card Promotion */
  MightyOakCard = 'MIGHTY_OAK_CARD',
}

export enum WaiverPromotion_V2 {
  Cricket = 'CRICKET',
  MightyOakCard = 'MIGHTY_OAK_CARD',
}

export type WebCitation = {
  __typename?: 'WebCitation'
  favicon: Maybe<Scalars['String']>
  title: Scalars['String']
  url: Scalars['String']
}

/** URLs for linked account webhooks */
export type Webhooks = {
  __typename?: 'Webhooks'
  /** URL for plaid webhooks */
  plaid: Scalars['String']
}

/** A URL which represents the location of the account linking source the client should use. */
export type WebviewLinkSession = {
  __typename?: 'WebviewLinkSession'
  /** The URL a client should use for account linking. */
  url: Scalars['URL']
}

export type WeeklyRaffle = {
  __typename?: 'WeeklyRaffle'
  entries: Array<RaffleEntry>
  /**
   * Potential entries for the current week: the already-credited count if
   * hasEntered is true, otherwise the count the user would earn if their
   * streak extends today. See `entries` for entries actually received.
   */
  entriesThisWeek: Scalars['Int']
  hasEntered: Scalars['Boolean']
  prize: MonetaryPrize
  winnersPerWeek: Scalars['Int']
}

export enum WidgetEvaluationOutcome {
  Error = 'ERROR',
  ExcludedDegraded = 'EXCLUDED_DEGRADED',
  ExcludedDismissed = 'EXCLUDED_DISMISSED',
  ExcludedRule = 'EXCLUDED_RULE',
  Inactive = 'INACTIVE',
  Included = 'INCLUDED',
  Legacy = 'LEGACY',
  ShownDegraded = 'SHOWN_DEGRADED',
}

export type WidgetEvaluationTrace = {
  __typename?: 'WidgetEvaluationTrace'
  degraded: Scalars['Boolean']
  dismissalKey: Maybe<Scalars['String']>
  dismissalScope: Maybe<ContentRulesWidgetDismissalScope>
  dismissed: Scalars['Boolean']
  evaluatedFields: Array<EvaluatedField>
  inFeed: Maybe<Scalars['Boolean']>
  outcome: WidgetEvaluationOutcome
  priorityPosition: Maybe<Scalars['Int']>
  reason: Scalars['String']
  ruleEvaluationError: Maybe<Scalars['String']>
  ruleEvaluationErrorType: Maybe<Scalars['String']>
  ruleTree: Maybe<Scalars['JSON']>
  status: ContentRulesWidgetStatus
  widgetDisplayName: Scalars['String']
  widgetType: Scalars['String']
}

export type WidgetRegistryConnection = {
  __typename?: 'WidgetRegistryConnection'
  edges: Array<WidgetRegistryEntryEdge>
  pageInfo: PageInfo
}

/** Widget registry entry — routing control and display metadata per widget type. */
export type WidgetRegistryEntry = {
  __typename?: 'WidgetRegistryEntry'
  /** Widget category for grouping in the admin UI (e.g. onboarding, engagement). */
  category: Maybe<Scalars['String']>
  /** ISO 8601 timestamp when this row was created. */
  createdAt: Scalars['DateTime']
  /** ID of the actor who created this row. */
  createdBy: Maybe<Scalars['String']>
  /**
   * When true, show this widget when required data is unavailable for rule evaluation
   * (e.g. customerState fetch timeout, Amplitude evaluation failure, or unexpected context failure).
   * Default false = hide widget when data is missing (conservative).
   * Set true for widgets where showing is safer than hiding (e.g. always-on onboarding prompts).
   */
  degradeToVisible: Scalars['Boolean']
  /** Optional description of the widget's purpose. */
  description: Maybe<Scalars['String']>
  /**
   * Base dismissal key for this widget. With SCREEN scope, screen_context is
   * prepended automatically (e.g. "tracking_widget" → "a4_home_bottom_nav_tracking_widget").
   * With ALL scope, this key is used as-is.
   * Null = this service does not own the dismissal write (proxy to legacy).
   */
  dismissalKey: Maybe<Scalars['String']>
  /**
   * Controls how the effective dismissal key is built at read time.
   * SCREEN (default) = prepend screen_context to dismissal_key.
   * ALL = use dismissal_key as-is (dismissal applies across all screens).
   */
  dismissalScope: ContentRulesWidgetDismissalScope
  /** Human-readable name for the admin UI. */
  displayName: Scalars['String']
  /** UUID primary key. */
  id: Scalars['ID']
  /** Owning team (e.g. enrichment, growth, engagement). */
  serviceTeam: Maybe<Scalars['String']>
  /** Current routing status for this widget type. */
  status: ContentRulesWidgetStatus
  /** ISO 8601 timestamp when this row was last updated. */
  updatedAt: Scalars['DateTime']
  /** ID of the actor who last updated this row. */
  updatedBy: Maybe<Scalars['String']>
  /** Unique widget type identifier (e.g. referral, earn, roundup_widget). */
  widgetType: Scalars['String']
}

export type WidgetRegistryEntryEdge = {
  __typename?: 'WidgetRegistryEntryEdge'
  node: WidgetRegistryEntry
}

/** Filter for widget registry queries. All fields are optional and combined with AND. */
export type WidgetRegistryFilterInput = {
  /** Filter by widget category. */
  category?: InputMaybe<Scalars['String']>
  /** Return only the entry with this UUID. Use for detail/edit views. */
  id?: InputMaybe<Scalars['ID']>
  /** Filter by owning team. */
  serviceTeam?: InputMaybe<Scalars['String']>
  /** Filter by routing status. */
  status?: InputMaybe<ContentRulesWidgetStatus>
  /** Filter by exact widget type name. */
  widgetType?: InputMaybe<Scalars['String']>
}

/** Widget ruleset — eligibility rule tree per (widget_type, screen_context). */
export type WidgetRuleset = {
  __typename?: 'WidgetRuleset'
  /** ISO 8601 timestamp when this row was created. */
  createdAt: Scalars['DateTime']
  /** ID of the actor who created this row. */
  createdBy: Maybe<Scalars['String']>
  /** Optional description of this ruleset's purpose. */
  description: Maybe<Scalars['String']>
  /** Human-readable name for the admin UI. */
  displayName: Maybe<Scalars['String']>
  /** UUID primary key. */
  id: Scalars['ID']
  /** JSON rule tree for eligibility evaluation. Null means always eligible. */
  ruleTree: Maybe<Scalars['JSON']>
  /** Screen context this ruleset applies to. */
  screenContext: Scalars['String']
  /** Lifecycle status. */
  status: ContentRulesRulesetStatus
  /** ISO 8601 timestamp when this row was last updated. */
  updatedAt: Scalars['DateTime']
  /** ID of the actor who last updated this row. */
  updatedBy: Maybe<Scalars['String']>
  /** Widget type this ruleset applies to. */
  widgetType: Scalars['String']
}

export type WidgetRulesetConnection = {
  __typename?: 'WidgetRulesetConnection'
  edges: Array<WidgetRulesetEdge>
  pageInfo: PageInfo
}

export type WidgetRulesetEdge = {
  __typename?: 'WidgetRulesetEdge'
  node: WidgetRuleset
}

/** Filter for widget ruleset queries. All fields are optional. */
export type WidgetRulesetFilterInput = {
  /** Return only the entry with this UUID. */
  id?: InputMaybe<Scalars['ID']>
  /**
   * Filter by screen context. Use "ALL" to filter for rulesets that apply to every screen.
   * Note: filtering by a specific screen context returns only exact matches — it does not
   * include "ALL" fallback rulesets. To see everything that applies to a widget, omit this
   * filter and search by widgetType only.
   */
  screenContext?: InputMaybe<Scalars['String']>
  /** Filter by lifecycle status. */
  status?: InputMaybe<ContentRulesRulesetStatus>
  /** Filter by widget type. */
  widgetType?: InputMaybe<Scalars['String']>
}

/** Withdrawal Investment Object */
export type Withdrawal = {
  __typename?: 'Withdrawal'
  amount: Scalars['Float']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  presentableWithdrawalStatus: PresentableWithdrawalStatus
}

export type WithholdingDefaults = {
  __typename?: 'WithholdingDefaults'
  federalWithholdingPercentage: Scalars['Float']
  showFederalWithholdingField: Scalars['Boolean']
  showStateWithholdingField: Scalars['Boolean']
  stateWithholdingPercentage: Scalars['Float']
}

export type WithholdingEstimates = {
  __typename?: 'WithholdingEstimates'
  /** estimated amount that will be delivered to the customer */
  estimatedCustomerAmount: MonetaryAmount
  /** estimated total amount that will be withheld for federal taxes */
  estimatedFederalWithholdingAmount: MonetaryAmount
  /** estimated total amount that will be withheld for state taxes */
  estimatedStateWithholdingAmount: MonetaryAmount
  /** estimated earnings that will be taxed */
  estimatedTaxableEarnings: MonetaryAmount
  /** estimated total amount that will be withheld (state and federal) */
  estimatedTotalWithholdingAmount: MonetaryAmount
}

/** When workflow is not found */
export type WorkflowNotFoundException = {
  __typename?: 'WorkflowNotFoundException'
  /** message */
  errorMessage: Maybe<Scalars['String']>
}

export type YearLaterReport = {
  __typename?: 'YearLaterReport'
  accountBalance: Scalars['Float']
  accountCreationDate: Scalars['String']
  accountPerformance: Scalars['Float']
  accountType: Scalars['String']
  firstDepositAmountForYear: Maybe<Scalars['Float']>
  firstDepositDateForYear: Maybe<Scalars['String']>
  recurringContributionAmount: Scalars['Float']
  recurringContributionFrequency: Maybe<InvestmentFrequency>
  totalDeposits: Scalars['Float']
  totalDepositsForYear: Scalars['Float']
  totalDividends: Scalars['Float']
  totalNetReturns: Scalars['Float']
  totalWithdrawals: Scalars['Float']
  userAge: Scalars['Int']
}

/** Filter schema for the allPasyscheduledItems Query */
export type AllPastScheduledItemsFilter = {
  account?: InputMaybe<PastItemsAccountFilter>
}

/** Filter schema for the allPasyscheduledItems Query */
export type AllPastScheduledItemsFilterV2 = {
  account?: InputMaybe<PastItemsAccountFilter>
}

export type DeleteChatSessionResponse =
  | ChatInProgressException
  | ChatSession
  | ChatSessionNotFound
  | DeleteChatSessionError

export type EndChatSessionResponse = ChatSession | ChatSessionNotFound

export type HelpcenterBannerResponse =
  | HelpcenterBannerContent
  | HelpcenterBannerErrors

export type Jobs_Article = {
  __typename?: 'jobs_Article'
  body: Scalars['String']
  cta: Maybe<Cta>
  eyebrow: Scalars['String']
  id: Scalars['ID']
  image: Maybe<Image>
  title: Scalars['String']
}

export type Jobs_Education = {
  __typename?: 'jobs_Education'
  articles: Array<Jobs_Article>
  id: Scalars['ID']
  title: Scalars['String']
}

export type Jobs_Offer = {
  __typename?: 'jobs_Offer'
  /** Company logo or generic default */
  companyLogo: Image
  /** Hiring company */
  companyName: Scalars['String']
  id: Scalars['ID']
  /** Relevant job industry */
  industryName: Maybe<Scalars['String']>
  /** Job role */
  jobName: Scalars['String']
  /** Job location */
  location: JobLocation
  /** Salary details */
  salary: Maybe<Jobs_OfferSalary>
  /** List of tags to display */
  tags: Array<Scalars['String']>
  /** Redirect URL for job posting */
  url: Scalars['URL']
}

/** Specifies a Job Offer Connection */
export type Jobs_OfferConnection = {
  __typename?: 'jobs_OfferConnection'
  edges: Array<Jobs_OfferEdge>
  pageInfo: PageInfo
}

/** Specifies a Job Offer Edge */
export type Jobs_OfferEdge = {
  __typename?: 'jobs_OfferEdge'
  cursor: Scalars['ID']
  node: Jobs_Offer
}

export type Jobs_OfferSalary = {
  __typename?: 'jobs_OfferSalary'
  interval: SalaryInterval
  maxValue: Scalars['Float']
  minValue: Scalars['Float']
}

export type LaterTotalLiquidationInput = {
  earlyDistributionTaxExceptionReason?: InputMaybe<Scalars['String']>
  federalTaxes: Scalars['Float']
  reason?: InputMaybe<LaterWithdrawalReason>
  stateTaxes: Scalars['Float']
  taxYear: Scalars['Int']
  withdrawalType?: InputMaybe<LaterWithdrawalType>
}

export type ManagePayoutRelationshipInput = {
  action: ManagePayoutRelationshipAction
  /** When action is REMOVE, optional reason stored on the relationship (atomic with archive). */
  disqualificationReason?: InputMaybe<ReferralPayoutDisqualificationReason>
  payoutId: Scalars['ID']
  relationshipId: Scalars['ID']
}

export type RateChatMessageResponse =
  | ChatHistoryMessage
  | ChatHistoryMessageCustomFeedbackOutOfBounds
  | ChatHistoryMessageNotFound
  | ChatHistoryMessageNotRatable
  | ChatHistoryMessageRatingFailed
  | ChatHistoryMessageRatingOutOfBounds

export enum ReferralStatusDetails {
  AcornsEmployee = 'ACORNS_EMPLOYEE',
  CampaignExpired = 'CAMPAIGN_EXPIRED',
  InactiveSubscription = 'INACTIVE_SUBSCRIPTION',
  InvestAccountClosed = 'INVEST_ACCOUNT_CLOSED',
  ManualPayout = 'MANUAL_PAYOUT',
  UserSuspened = 'USER_SUSPENED',
}

export type StartChatSessionResponse =
  | ChatSession
  | ChatSessionBlockedException
  | ChatUnavailableError

/** Recommended portfolio for user based off their suitability responses */
export type Suitability_Portfolio = {
  __typename?: 'suitability_Portfolio'
  /** the portfolio description */
  description: Scalars['String']
  /** The portfolio ID */
  id: Scalars['ID']
  /** The portfolio name */
  name: Scalars['String']
}

/** Possible answer for a suitability question */
export type Suitability_SuitabilityAnswer = {
  __typename?: 'suitability_SuitabilityAnswer'
  /** Human readable text to display a description to an answer */
  description: Maybe<Scalars['String']>
  /** Internal ID for a suitability answer */
  id: Scalars['ID']
  /** Value for clients to use to fetch strings */
  key: Scalars['String']
  /** Summary of an answer used for displaying why a portfolio was recommended */
  summary: Maybe<Scalars['String']>
  /** Human readable text to display an answer to a suitability question */
  text: Scalars['String']
}

/** A user's input to update their suitabiliity */
export type Suitability_SuitabilityInput = {
  /** The answer ID */
  answerId: Scalars['ID']
  /** The question ID */
  questionId: Scalars['ID']
}

/** Suitability question asked for recommending portfolios */
export type Suitability_SuitabilityQuestion = {
  __typename?: 'suitability_SuitabilityQuestion'
  /** Default answer to the related suitability question */
  defaultAnswer: Maybe<Suitability_SuitabilityAnswer>
  /** Internal ID for a suitability question */
  id: Scalars['ID']
  /** Value for clients to use to fetch strings */
  key: Scalars['String']
  /** Possible answers to be selected for the related question */
  possibleAnswers: Array<Suitability_SuitabilityAnswer>
  /** Human readable text to display the suitability question */
  text: Scalars['String']
}

/** A given user's suitability response for each question and answer */
export type Suitability_SuitabilityResponse = {
  __typename?: 'suitability_SuitabilityResponse'
  /** Associated answer to the suitability question */
  answer: Maybe<Suitability_SuitabilityAnswer>
  /** Default answer to the related suitability question */
  question: Suitability_SuitabilityQuestion
}

/** Return wrapper type for the UpdateSuitability mutation */
export type Suitability_UpdateSuitabilityResult = {
  __typename?: 'suitability_UpdateSuitabilityResult'
  /** The recommended portfolio for the user's suitability responses */
  recommendedPortfolio: Maybe<Suitability_Portfolio>
  /** Internal ID for a suitability answer */
  suitabilityResponses: Array<Suitability_SuitabilityResponse>
}

export type UploadAudienceListInput = {
  cohortName: Scalars['String']
}

export type UserWinbackErrors = {
  __typename?: 'userWinbackErrors'
  error: Maybe<Scalars['String']>
  message: Maybe<Scalars['String']>
}

export type UserWinbackScore = {
  __typename?: 'userWinbackScore'
  churnProbability: Maybe<Scalars['Float']>
  predictedRevenue: Maybe<Scalars['Float']>
  userId: Maybe<Scalars['String']>
}

export type UserWinbackScoreRes = UserWinbackErrors | UserWinbackScore

export type ChatChoiceWidgetFragment = {
  __typename?: 'ChatChoiceWidget'
  title: string
  choices: Array<{
    __typename?: 'ChatChoice'
    id: string
    title: string
    description: string
    metadata: {
      __typename?: 'ChatChoiceActionMetadata'
      actionType: string
      actionData: { __typename?: 'ChatChoiceActionData'; apiScope: string }
    }
  }>
}

export type CitationWidgetFragment = {
  __typename?: 'CitationWidget'
  citations: Array<
    | { __typename?: 'LearnHubCitation' }
    | { __typename?: 'SupportCitation'; id: string; title: string }
    | { __typename?: 'WebCitation' }
  >
}

export type CustomerSupportChatWidgetFragment = {
  __typename?: 'CustomerSupportChatWidget'
  sessionId: string
  chatRedirect: {
    __typename?: 'ChatRedirect'
    title: string
    ctaExpiresAt: any
    conversationContext: string
    conversationCategory: string
  }
  emailRedirect: { __typename?: 'EmailRedirect'; title: string }
  phoneRedirect: { __typename?: 'PhoneRedirect'; title: string }
}

export type DeeplinkWidgetFragment = {
  __typename?: 'DeeplinkWidget'
  deeplinks: Array<{ __typename?: 'ChatDeeplink'; title: string; url: string }>
}

export type CreateAiChatSupportTicketMutationVariables = Exact<{
  input: CreateSupportTicketInput
}>

export type CreateAiChatSupportTicketMutation = {
  __typename?: 'Mutation'
  createAuthenticatedSupportTicket: {
    __typename?: 'SupportTicket'
    id: string
    description: string
    subject: string
    url: string
  }
}

export type EndChatSessionMutationVariables = Exact<{
  sessionId: Scalars['ID']
}>

export type EndChatSessionMutation = {
  __typename?: 'Mutation'
  endChatSession:
    | {
        __typename?: 'ChatSession'
        id: string
        userId: string
        createdAt: any
        endedAt: any
      }
    | { __typename?: 'ChatSessionNotFound'; id: string; message: string }
}

export type OnChatMessageStreamSubscriptionVariables = Exact<{
  sessionId: Scalars['ID']
}>

export type OnChatMessageStreamSubscription = {
  __typename?: 'Subscription'
  onChatMessageStream:
    | {
        __typename?: 'ChatHistoryMessage'
        id: string
        author: ChatAuthor
        body: string
        sessionId: string
        createdAt: any
        canRate: boolean
        rating: number
        originatingMessageId: string
        citations: Array<{
          __typename?: 'ChatHistoryCitation'
          id: string
          title: string
          type: CitationType
        }>
        deeplinks: Array<{
          __typename?: 'ChatDeeplink'
          title: string
          url: string
        }>
      }
    | {
        __typename?: 'ChatHistoryMessageBody'
        id: string
        text: string
        sentAt: any
      }
    | {
        __typename?: 'ChatHistoryMessageFooter'
        id: string
        sentAt: any
        canRate: boolean
        chatWidgets: Array<
          | {
              __typename?: 'ChatChoiceWidget'
              title: string
              choices: Array<{
                __typename?: 'ChatChoice'
                id: string
                title: string
                description: string
                metadata: {
                  __typename?: 'ChatChoiceActionMetadata'
                  actionType: string
                  actionData: {
                    __typename?: 'ChatChoiceActionData'
                    apiScope: string
                  }
                }
              }>
            }
          | {
              __typename?: 'CitationWidget'
              citations: Array<
                | { __typename?: 'LearnHubCitation' }
                | { __typename?: 'SupportCitation'; id: string; title: string }
                | { __typename?: 'WebCitation' }
              >
            }
          | {
              __typename?: 'CustomerSupportChatWidget'
              sessionId: string
              chatRedirect: {
                __typename?: 'ChatRedirect'
                title: string
                ctaExpiresAt: any
                conversationContext: string
                conversationCategory: string
              }
              emailRedirect: { __typename?: 'EmailRedirect'; title: string }
              phoneRedirect: { __typename?: 'PhoneRedirect'; title: string }
            }
          | {
              __typename?: 'DeeplinkWidget'
              deeplinks: Array<{
                __typename?: 'ChatDeeplink'
                title: string
                url: string
              }>
            }
          | { __typename?: 'DocumentWidget' }
          | { __typename?: 'InvestmentPerformanceWidget' }
          | { __typename?: 'SVGWidget' }
          | { __typename?: 'SduiWidget' }
          | { __typename?: 'StockPerformanceWidget' }
        >
      }
    | {
        __typename?: 'ChatHistoryMessageHeader'
        id: string
        author: ChatAuthor
        sessionId: string
        createdAt: any
        originatingMessageId: string
      }
    | { __typename?: 'ChatStreamStatus' }
    | { __typename?: 'ChatToolProgress' }
}

export type RateChatMessageMutationVariables = Exact<{
  messageId: Scalars['ID']
  rating?: InputMaybe<Scalars['Int']>
  feedbackInput?: InputMaybe<MessageFeedbackInput>
}>

export type RateChatMessageMutation = {
  __typename?: 'Mutation'
  rateChatMessage:
    | {
        __typename?: 'ChatHistoryMessage'
        id: string
        author: ChatAuthor
        body: string
        sessionId: string
        createdAt: any
        canRate: boolean
        rating: number
        citations: Array<{
          __typename?: 'ChatHistoryCitation'
          title: string
          type: CitationType
          id: string
        }>
        deeplinks: Array<{
          __typename?: 'ChatDeeplink'
          title: string
          url: string
        }>
      }
    | { __typename?: 'ChatHistoryMessageCustomFeedbackOutOfBounds' }
    | { __typename?: 'ChatHistoryMessageNotFound'; id: string; message: string }
    | {
        __typename?: 'ChatHistoryMessageNotRatable'
        id: string
        message: string
      }
    | {
        __typename?: 'ChatHistoryMessageRatingFailed'
        id: string
        message: string
      }
    | {
        __typename?: 'ChatHistoryMessageRatingOutOfBounds'
        id: string
        message: string
      }
}

export type SendChatMessageMutationVariables = Exact<{
  sessionId: Scalars['ID']
  message: Scalars['String']
  metadata?: InputMaybe<ChatMessageMetadataInput>
}>

export type SendChatMessageMutation = {
  __typename?: 'Mutation'
  sendChatMessage:
    | {
        __typename?: 'ChatHistoryMessage'
        id: string
        author: ChatAuthor
        body: string
        sessionId: string
        createdAt: any
        canRate: boolean
        rating: number
        citations: Array<{
          __typename?: 'ChatHistoryCitation'
          title: string
          type: CitationType
          id: string
        }>
        deeplinks: Array<{
          __typename?: 'ChatDeeplink'
          title: string
          url: string
        }>
      }
    | { __typename?: 'ChatInProgressException' }
    | { __typename?: 'ChatMessageSizeOutOfBounds' }
    | { __typename?: 'ChatSessionBlockedException' }
    | { __typename?: 'ChatSessionNotFound'; id: string; message: string }
    | { __typename?: 'ChatUnavailableError'; message: string }
}

export type StartChatSessionMutationVariables = Exact<{
  type?: InputMaybe<SessionType>
}>

export type StartChatSessionMutation = {
  __typename?: 'Mutation'
  startChatSession:
    | {
        __typename?: 'ChatSession'
        id: string
        userId: string
        createdAt: any
        endedAt: any
        type: SessionType
      }
    | { __typename?: 'ChatSessionBlockedException' }
    | { __typename?: 'ChatUnavailableError'; message: string }
}

export type AllChatHistoryMessagesQueryVariables = Exact<{
  pagination: PaginationInput
}>

export type AllChatHistoryMessagesQuery = {
  __typename?: 'Query'
  allChatHistoryMessages: {
    __typename?: 'AllChatHistoryMessages'
    edges: Array<{
      __typename?: 'ChatHistoryMessageEdge'
      cursor: string
      node: {
        __typename?: 'ChatHistoryMessage'
        author: ChatAuthor
        body: string
        id: string
        sessionId: string
        createdAt: any
        canRate: boolean
        rating: number
        chatWidgets: Array<
          | {
              __typename?: 'ChatChoiceWidget'
              title: string
              choices: Array<{
                __typename?: 'ChatChoice'
                id: string
                title: string
                description: string
                metadata: {
                  __typename?: 'ChatChoiceActionMetadata'
                  actionType: string
                  actionData: {
                    __typename?: 'ChatChoiceActionData'
                    apiScope: string
                  }
                }
              }>
            }
          | {
              __typename?: 'CitationWidget'
              citations: Array<
                | { __typename?: 'LearnHubCitation' }
                | { __typename?: 'SupportCitation'; id: string; title: string }
                | { __typename?: 'WebCitation' }
              >
            }
          | {
              __typename?: 'CustomerSupportChatWidget'
              sessionId: string
              chatRedirect: {
                __typename?: 'ChatRedirect'
                title: string
                ctaExpiresAt: any
                conversationContext: string
                conversationCategory: string
              }
              emailRedirect: { __typename?: 'EmailRedirect'; title: string }
              phoneRedirect: { __typename?: 'PhoneRedirect'; title: string }
            }
          | {
              __typename?: 'DeeplinkWidget'
              deeplinks: Array<{
                __typename?: 'ChatDeeplink'
                title: string
                url: string
              }>
            }
          | { __typename?: 'DocumentWidget' }
          | { __typename?: 'InvestmentPerformanceWidget' }
          | { __typename?: 'SVGWidget' }
          | { __typename?: 'SduiWidget' }
          | { __typename?: 'StockPerformanceWidget' }
        >
      }
    }>
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; limit: number }
  }
}

export type RecommendedSearchTermsQueryVariables = Exact<{
  [key: string]: never
}>

export type RecommendedSearchTermsQuery = {
  __typename?: 'Query'
  recommendedSearchTerms: Array<string>
}

export type UserQueryQueryVariables = Exact<{ [key: string]: never }>

export type UserQueryQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    firstName: string
    lastName: string
    uuid: string
    email: string
    phoneNumber: string
  }
}

export type InHouseCampaignQueryVariables = Exact<{ [key: string]: never }>

export type InHouseCampaignQuery = {
  __typename?: 'Query'
  advocate: {
    __typename?: 'Advocate'
    campaign: {
      __typename?: 'ReferralCampaignV2'
      activeInHouseCampaign: boolean
    }
  }
}

export type FoundMoneySummaryQueryVariables = Exact<{ [key: string]: never }>

export type FoundMoneySummaryQuery = {
  __typename?: 'Query'
  foundMoneySummary: {
    __typename?: 'FoundMoneySummary'
    totalRewardsDollarValue: { __typename?: 'MonetaryAmount'; value: number }
  }
}

export type EarnDropsCohortEligibilityQueryVariables = Exact<{
  cohort: Scalars['String']
}>

export type EarnDropsCohortEligibilityQuery = {
  __typename?: 'Query'
  cohortEligibility_v2: Array<{
    __typename?: 'CohortEligibility_v2'
    eligible: boolean
  }>
}

export type PartnerOfferGroupCategoriesQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID']
  incentiveTemplate?: InputMaybe<EarnOfferIncentiveTemplate>
}>

export type PartnerOfferGroupCategoriesQuery = {
  __typename?: 'Query'
  partnerOfferGroupCategories: Array<{
    __typename?: 'PartnerOfferGroup'
    id: string
    title: string
    body: string
    offers: Array<
      | {
          __typename?: 'EarnOffer'
          displayName: string
          featuredCategoryOffer: boolean
          featuredCategoryOfferRank: number
          backgroundColorHex: string
          backgroundImageUrl: any
          campaignId: string
          campaignDescription: string
          campaignOfferId: string
          displayTitle: string
          incentiveSummary: string
          termsAndConditionsUrl: string
          displaySubtitle: string
          promoted: boolean
          promotionRank: number
          webviewEnabled: boolean
          colorBackgroundLogoImageUrl: any
          colorImageUrl: any
          ownerId: string
          ownerDescription: string
          incentiveAmount: number
          incentiveType: EarnOfferIncentiveType
          ctaDetails: {
            __typename?: 'EarnOfferCtaDetails'
            type: string
            ios: string
            android: string
            email: string
            web: string
            notificationUrl: any
            chromeExt: string
            title: string
            repeatTitle: string
            notificationTitle: string
          }
        }
      | {
          __typename?: 'JobOffer'
          id: string
          jobName: string
          companyName: string
          industryName: string
          tags: Array<string>
          url: any
          companyLogo: { __typename?: 'Image'; url: string }
          salary: {
            __typename?: 'JobOfferSalary'
            minValue: number
            maxValue: number
            interval: SalaryInterval
          }
          location: {
            __typename?: 'OfferLocation'
            city: string
            state: string
          }
        }
      | {
          __typename?: 'JobSearchOffer'
          id: string
          title: string
          subtitle: string
          backgroundImage: { __typename?: 'Image'; url: string }
          logo: { __typename?: 'Image'; url: string }
          searchFilters: Array<{
            __typename?: 'JobSearchFilter'
            key: JobSearchFilterKey
            value: string
          }>
        }
      | { __typename?: 'PromoOffer' }
    >
  }>
}

export type PersonalizedEarnOffersQueryVariables = Exact<{
  [key: string]: never
}>

export type PersonalizedEarnOffersQuery = {
  __typename?: 'Query'
  personalizedEarnOffers: Array<{
    __typename: 'EarnOffer'
    campaignId: string
    colorBackgroundLogoImageUrl: any
    ownerId: string
    displayName: string
    incentiveSummary: string
  }>
}

export type ActivitySummaryQueryVariables = Exact<{
  product?: InputMaybe<ActivitySummaryProduct>
  accountId?: InputMaybe<Scalars['ID']>
}>

export type ActivitySummaryQuery = {
  __typename?: 'Query'
  activitySummary: {
    __typename?: 'ActivitySummaryResponse'
    numberOfDays: number
    total: { __typename?: 'CurrencyAmount'; value: number; currency: Currency }
    activitySummaryItems: Array<{
      __typename?: 'SummaryItem'
      title: string
      amount: {
        __typename?: 'CurrencyAmount'
        value: number
        currency: Currency
      }
    }>
  }
}

export type LaterInvestmentAccountsByUserIdQueryVariables = Exact<{
  [key: string]: never
}>

export type LaterInvestmentAccountsByUserIdQuery = {
  __typename?: 'Query'
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    closedAt: any
    type: string
    recurringInvestmentSettings: {
      __typename?: 'RecurringInvestmentSettings'
      amount: number
      day: number
      frequency: InvestmentFrequency
    }
  }>
}

export type LaterUserContributionAbilityQueryVariables = Exact<{
  [key: string]: never
}>

export type LaterUserContributionAbilityQuery = {
  __typename?: 'Query'
  laterUserContributionAbility: {
    __typename: 'ContributionAbilityByYear'
    contributionAbilities: Array<{
      __typename: 'ContributionAbility'
      canContribute: boolean
      planLimit: number
      remaining: number
      taxYear: number
      yearToDate: number
    }>
  }
}

export type InvestmentAccountsQueryQueryVariables = Exact<{
  product: InvestmentProduct
}>

export type InvestmentAccountsQueryQuery = {
  __typename?: 'Query'
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    beneficiaryId: string
    id: string
    closedAt: any
    name: string
    status: InvestmentAccountStatus
    cashOwed: { __typename?: 'MonetaryAmount'; value: number }
    portfolio: {
      __typename?: 'Portfolio'
      id: string
      name: string
      theme: PortfolioTheme
      accountAllocation: {
        __typename?: 'PortfolioAllocation'
        allocationPercent: number
      }
      portfolioSecurityAllocations: Array<{
        __typename?: 'PortfolioSecurityAllocation'
        id: string
        symbol: string
        allocationPercent: number
        security:
          | { __typename?: 'Fund'; displayName: string }
          | { __typename?: 'Stock'; displayName: string }
        investmentCategories: {
          __typename?: 'InvestmentCategory'
          bond: number
          crypto: number
          equity: number
        }
      }>
    }
    portfolios: Array<
      | { __typename: 'Portfolio'; id: string; name: string }
      | {
          __typename: 'SelfDirectedPortfolio'
          status: SelfDirectedPortfolioStatus
          id: string
          name: string
          accountAllocation: {
            __typename?: 'PortfolioAllocation'
            allocationPercent: number
          }
        }
    >
  }>
}

export type RecapReadyModuleQueryVariables = Exact<{ [key: string]: never }>

export type RecapReadyModuleQuery = {
  __typename?: 'Query'
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    beneficiaryId: string
    quarterlyRecapsEnabled: boolean
    quarterlyRecap: {
      __typename?: 'InvestmentAccountRecap'
      id: string
      viewed: boolean
    }
  }>
}

export type RecapSetUpModuleQueryVariables = Exact<{ [key: string]: never }>

export type RecapSetUpModuleQuery = {
  __typename?: 'Query'
  tierSubscriptionByUserId: {
    __typename: 'TierSubscription'
    id: string
    tier: {
      __typename: 'Tier'
      id: string
      key: TierKey
      name: string
      products: Array<{ __typename: 'Product'; id: string; key: ProductKey }>
    }
  }
  investmentAccountsByUserId: Array<{
    __typename: 'InvestmentAccount'
    id: string
    beneficiaryId: string
    status: InvestmentAccountStatus
    quarterlyRecapsEnabled: boolean
    quarterlyRecap: {
      __typename: 'InvestmentAccountRecap'
      id: string
      viewed: boolean
    }
  }>
}

export type RecapUpgradeModuleQueryVariables = Exact<{ [key: string]: never }>

export type RecapUpgradeModuleQuery = {
  __typename?: 'Query'
  tierSubscriptionByUserId: {
    __typename?: 'TierSubscription'
    id: string
    tier: {
      __typename?: 'Tier'
      id: string
      key: TierKey
      name: string
      products: Array<{ __typename?: 'Product'; id: string; key: ProductKey }>
    }
  }
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    beneficiaryId: string
    status: InvestmentAccountStatus
  }>
}

export type RecentActivityInvestQueryQueryVariables = Exact<{
  accountId: Scalars['ID']
  first: Scalars['Int']
  pending: Scalars['Boolean']
}>

export type RecentActivityInvestQueryQuery = {
  __typename?: 'Query'
  allPastItems: {
    __typename?: 'PastItemConnection'
    edges: Array<{
      __typename?: 'PastItemEdge'
      node:
        | {
            __typename: 'CoreACHSubscriptionFeeItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreAdjustmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreCashForwardItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreCollectionItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreDebtCollectionItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreDividendsItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreEmployeeCreditItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreFeeInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreFoundMoneyRewardItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreGiftCardCreditRedemptionItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreHoldingsTransferInItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreLocalFoundMoneyItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CorePartnerRewardItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreRebalanceItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreReferralRewardItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreRefundedItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreReinvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreRoundUpsItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreWithdrawalItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyDebtCollectionItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyDividendsItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyFeeInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyGiftItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyMatchItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyMatchRemovalItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyRefundedItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyReinvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyWithdrawalItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterDebtCollectionItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterDividendsItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterFeeInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterMatchItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterMatchRemovalItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterRebalanceItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterRefundedItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterReinvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterWithdrawalItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastAcornsRewardInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastBeneficiaryTransferInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastCashOwedCollectionInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastCashReinvestmentInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastCoreItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastDividendInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastEmployeeContributionInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastExternalTransferInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastExternalTransferReversedInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastFeeInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastGiftCardInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastIRATransferInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastInvestmentTipItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastLumpSumInvestment'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastMatchInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastMatchRemovalInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastOutsideContributionInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRealTimeRoundUpInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRebalanceInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRecurringInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastReferralRewardInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastReferralRewardMatchInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRefundInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastReversalInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRewardInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRewardMatchInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRoundUpItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRoundUpMatchInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastSecurityLiquidationInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastSmartDepositInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastSpendItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastStreakRewardInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastTipsThatGrowMatchInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastWithdrawalInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SaveInterestPaidItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SaveTransferInItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SaveTransferOutItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendATMReimbursementItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendATMWithdrawalItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendBillPayItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendCheckDepositItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendCheckPaymentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendDigitalWalletItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendDirectDepositItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendECheckItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendInterestPaidItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendPurchaseItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendRealTimeRoundUpItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendTransferInItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendTransferOutItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
    }>
  }
}

export type RecentActivityLaterQueryQueryVariables = Exact<{
  first: Scalars['Int']
  pending: Scalars['Boolean']
  accountId: Scalars['ID']
  productAccountType: ProductAccountType
}>

export type RecentActivityLaterQueryQuery = {
  __typename?: 'Query'
  allPastItems: {
    __typename?: 'PastItemConnection'
    edges: Array<{
      __typename?: 'PastItemEdge'
      node:
        | {
            __typename: 'CoreACHSubscriptionFeeItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreAdjustmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreCashForwardItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreCollectionItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreDebtCollectionItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreDividendsItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreEmployeeCreditItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreFeeInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreFoundMoneyRewardItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreGiftCardCreditRedemptionItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreHoldingsTransferInItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreLocalFoundMoneyItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CorePartnerRewardItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreRebalanceItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreReferralRewardItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreRefundedItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreReinvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreRoundUpsItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreWithdrawalItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyDebtCollectionItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyDividendsItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyFeeInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyGiftItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyMatchItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyMatchRemovalItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyRefundedItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyReinvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyWithdrawalItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterDebtCollectionItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterDividendsItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterFeeInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterMatchItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterMatchRemovalItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterRebalanceItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterRefundedItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterReinvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterWithdrawalItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastAcornsRewardInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastBeneficiaryTransferInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastCashOwedCollectionInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastCashReinvestmentInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastCoreItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastDividendInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastEmployeeContributionInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastExternalTransferInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastExternalTransferReversedInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastFeeInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastGiftCardInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastIRATransferInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastInvestmentTipItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastLumpSumInvestment'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastMatchInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastMatchRemovalInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastOutsideContributionInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRealTimeRoundUpInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRebalanceInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRecurringInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastReferralRewardInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastReferralRewardMatchInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRefundInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastReversalInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRewardInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRewardMatchInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRoundUpItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRoundUpMatchInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastSecurityLiquidationInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastSmartDepositInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastSpendItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastStreakRewardInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastTipsThatGrowMatchInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastWithdrawalInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SaveInterestPaidItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SaveTransferInItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SaveTransferOutItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendATMReimbursementItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendATMWithdrawalItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendBillPayItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendCheckDepositItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendCheckPaymentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendDigitalWalletItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendDirectDepositItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendECheckItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendInterestPaidItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendPurchaseItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendRealTimeRoundUpItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendTransferInItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendTransferOutItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
    }>
  }
}

export type RecentActivitySpendQueryQueryVariables = Exact<{
  first: Scalars['Int']
  pending: Scalars['Boolean']
  accountId?: InputMaybe<Scalars['String']>
}>

export type RecentActivitySpendQueryQuery = {
  __typename?: 'Query'
  allPastSpendItems: {
    __typename?: 'PastItemConnection'
    edges: Array<{
      __typename?: 'PastItemEdge'
      node:
        | {
            __typename: 'CoreACHSubscriptionFeeItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreAdjustmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreCashForwardItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreCollectionItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreDebtCollectionItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreDividendsItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreEmployeeCreditItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreFeeInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreFoundMoneyRewardItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreGiftCardCreditRedemptionItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreHoldingsTransferInItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreLocalFoundMoneyItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CorePartnerRewardItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreRebalanceItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreReferralRewardItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreRefundedItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreReinvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreRoundUpsItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreWithdrawalItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyDebtCollectionItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyDividendsItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyFeeInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyGiftItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyMatchItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyMatchRemovalItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyRefundedItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyReinvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyWithdrawalItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterDebtCollectionItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterDividendsItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterFeeInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterMatchItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterMatchRemovalItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterRebalanceItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterRefundedItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterReinvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterWithdrawalItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastAcornsRewardInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastBeneficiaryTransferInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastCashOwedCollectionInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastCashReinvestmentInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastCoreItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastDividendInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastEmployeeContributionInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastExternalTransferInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastExternalTransferReversedInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastFeeInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastGiftCardInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastIRATransferInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastInvestmentTipItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastLumpSumInvestment'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastMatchInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastMatchRemovalInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastOutsideContributionInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRealTimeRoundUpInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRebalanceInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRecurringInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastReferralRewardInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastReferralRewardMatchInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRefundInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastReversalInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRewardInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRewardMatchInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRoundUpItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRoundUpMatchInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastSecurityLiquidationInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastSmartDepositInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastSpendItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastStreakRewardInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastTipsThatGrowMatchInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastWithdrawalInvestmentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SaveInterestPaidItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SaveTransferInItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SaveTransferOutItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendATMReimbursementItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendATMWithdrawalItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendBillPayItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendCheckDepositItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendCheckPaymentItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendDigitalWalletItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendDirectDepositItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendECheckItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendInterestPaidItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendPurchaseItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendRealTimeRoundUpItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendTransferInItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendTransferOutItem'
            title: string
            createdAt: any
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
    }>
  }
}

export type WaitingRoundUpProfileQueryVariables = Exact<{
  [key: string]: never
}>

export type WaitingRoundUpProfileQuery = {
  __typename?: 'Query'
  roundUpProfile: { __typename?: 'RoundUpProfile'; roundUpTotal: number }
}

export type FinishSetupQueryVariables = Exact<{
  feedContext: FeedContext
  accountId: Scalars['ID']
}>

export type FinishSetupQuery = {
  __typename?: 'Query'
  finishSetup: {
    __typename?: 'FinishSetup'
    eyebrow: string
    tips: Array<{
      __typename?: 'SetUpTip'
      body: string
      id: string
      type: ProductSetupTipType
      ctaDetails: {
        __typename?: 'ActionFeedCta'
        id: string
        type: ActionFeedCtaType
        title: string
        image: string
        video: string
        videoUrl: string
      }
      image: { __typename?: 'Image'; url: string }
      backgroundImage: { __typename?: 'Image'; url: string }
    }>
  }
  bankCardOrder: { __typename?: 'BankCardOrder'; bankCardTier: BankCardTier }
}

export type SmartDepositWidgetQueryVariables = Exact<{
  depositsLimit?: InputMaybe<Scalars['Int']>
  settingTypes: Array<SplitDepositSettingType> | SplitDepositSettingType
  metaDataInput:
    | Array<SplitDepositTargetAccountType>
    | SplitDepositTargetAccountType
}>

export type SmartDepositWidgetQuery = {
  __typename?: 'Query'
  splitDepositSettingsByUserId: Array<
    | {
        __typename: 'SplitDepositDirectDepositIntentSetting'
        id: string
        isActive: boolean
        isHidden: boolean
        isUsingRecommendedAllocations: boolean
        name: string
        allocations: Array<{
          __typename: 'SplitDepositDirectDepositAllocation'
          allocationPercent: string
          targetAccountId: string
          targetAccountType: SplitDepositTargetAccountType
          normalizedAmount: {
            __typename?: 'FormattedMonetaryAmount'
            value: string
          }
        }>
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          expectedNextDepositAmount: string
          expectedNextDepositAt: string
          id: string
          isActive: boolean
          isCancelable: boolean
          isCanceled: boolean
          isUsingRecommendedAllocations: boolean
          savingsRatePercent: string
          settingsId: string
          updatedAt: string
          userId: string
          transactionAmount: string
          willDistributeAutomaticallyAt: string
          splitDistribution: {
            __typename?: 'DistributionAmounts'
            investment: string
            retirement: string
            savings: string
          }
          allocations: Array<
            | {
                __typename?: 'SplitDepositDirectDepositAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                normalizedAmount: {
                  __typename?: 'FormattedMonetaryAmount'
                  value: string
                }
              }
            | {
                __typename?: 'SplitDepositRecurrenceAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
              }
          >
        }>
        estimatedPaycheckAmount: {
          __typename?: 'CurrencyAmount'
          value: number
        }
      }
    | {
        __typename: 'SplitDepositDirectDepositSetting'
        id: string
        isActive: boolean
        isHidden: boolean
        isUsingRecommendedAllocations: boolean
        awaitingConfiguration: boolean
        name: string
        allocations: Array<{
          __typename: 'SplitDepositDirectDepositAllocation'
          allocationPercent: string
          targetAccountId: string
          targetAccountType: SplitDepositTargetAccountType
          normalizedAmount: {
            __typename?: 'FormattedMonetaryAmount'
            value: string
          }
        }>
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          expectedNextDepositAmount: string
          expectedNextDepositAt: string
          id: string
          isActive: boolean
          isCancelable: boolean
          isCanceled: boolean
          isUsingRecommendedAllocations: boolean
          savingsRatePercent: string
          settingsId: string
          updatedAt: string
          userId: string
          transactionAmount: string
          willDistributeAutomaticallyAt: string
          splitDistribution: {
            __typename?: 'DistributionAmounts'
            investment: string
            retirement: string
            savings: string
          }
          allocations: Array<
            | {
                __typename?: 'SplitDepositDirectDepositAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                normalizedAmount: {
                  __typename?: 'FormattedMonetaryAmount'
                  value: string
                }
              }
            | {
                __typename?: 'SplitDepositRecurrenceAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
              }
          >
        }>
      }
    | {
        __typename: 'SplitDepositRecurrenceSetting'
        id: string
        isActive: boolean
        isHidden: boolean
        allocations: Array<{ __typename: 'SplitDepositRecurrenceAllocation' }>
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          expectedNextDepositAmount: string
          expectedNextDepositAt: string
          id: string
          isActive: boolean
          isCancelable: boolean
          isCanceled: boolean
          isUsingRecommendedAllocations: boolean
          savingsRatePercent: string
          settingsId: string
          updatedAt: string
          userId: string
          transactionAmount: string
          willDistributeAutomaticallyAt: string
          splitDistribution: {
            __typename?: 'DistributionAmounts'
            investment: string
            retirement: string
            savings: string
          }
          allocations: Array<
            | {
                __typename?: 'SplitDepositDirectDepositAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                normalizedAmount: {
                  __typename?: 'FormattedMonetaryAmount'
                  value: string
                }
              }
            | {
                __typename?: 'SplitDepositRecurrenceAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
              }
          >
        }>
      }
  >
  smartDepositMetadata: {
    __typename?: 'SmartDepositMetadataResult'
    targetAccounts: Array<{
      __typename?: 'SplitDepositTargetAccount'
      targetAccountId: string
      targetAccountType: SplitDepositTargetAccountType
    }>
    recommendedAllocations: Array<
      | {
          __typename?: 'SplitDepositDirectDepositAllocation'
          allocationPercent: string
          targetAccountType: SplitDepositTargetAccountType
          targetAccountId: string
        }
      | {
          __typename?: 'SplitDepositRecurrenceAllocation'
          allocationPercent: string
          targetAccountType: SplitDepositTargetAccountType
          targetAccountId: string
        }
    >
  }
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    routingNumber: string
    number: string
  }>
  bankCardOrder: { __typename?: 'BankCardOrder'; bankCardTier: BankCardTier }
}

export type SmartDepositWidgetAllocationFragmentFragment = {
  __typename?: 'SplitDepositDirectDepositAllocation'
  allocationPercent: string
  targetAccountId: string
  targetAccountType: SplitDepositTargetAccountType
  normalizedAmount: { __typename?: 'FormattedMonetaryAmount'; value: string }
}

export type SmartDepositSplitDepositIntentSettingFragmentFragment = {
  __typename?: 'SplitDepositDirectDepositIntentSetting'
  isUsingRecommendedAllocations: boolean
  name: string
  isActive: boolean
  isHidden: boolean
  id: string
  estimatedPaycheckAmount: { __typename?: 'CurrencyAmount'; value: number }
  allocations: Array<{
    __typename?: 'SplitDepositDirectDepositAllocation'
    allocationPercent: string
    targetAccountId: string
    targetAccountType: SplitDepositTargetAccountType
    normalizedAmount: { __typename?: 'FormattedMonetaryAmount'; value: string }
  }>
}

type SmarDepositSplitDepositSettingFragment_SplitDepositDirectDepositIntentSetting_Fragment =
  {
    __typename?: 'SplitDepositDirectDepositIntentSetting'
    id: string
    isActive: boolean
    isHidden: boolean
    name: string
    allocations: Array<{
      __typename?: 'SplitDepositDirectDepositAllocation'
      allocationPercent: string
      targetAccountId: string
      targetAccountType: SplitDepositTargetAccountType
      normalizedAmount: {
        __typename?: 'FormattedMonetaryAmount'
        value: string
      }
    }>
  }

type SmarDepositSplitDepositSettingFragment_SplitDepositDirectDepositSetting_Fragment =
  {
    __typename?: 'SplitDepositDirectDepositSetting'
    id: string
    isActive: boolean
    isHidden: boolean
    name: string
    allocations: Array<{
      __typename?: 'SplitDepositDirectDepositAllocation'
      allocationPercent: string
      targetAccountId: string
      targetAccountType: SplitDepositTargetAccountType
      normalizedAmount: {
        __typename?: 'FormattedMonetaryAmount'
        value: string
      }
    }>
  }

type SmarDepositSplitDepositSettingFragment_SplitDepositRecurrenceSetting_Fragment =
  {
    __typename?: 'SplitDepositRecurrenceSetting'
    id: string
    isActive: boolean
    isHidden: boolean
    name: string
    allocations: Array<{ __typename?: 'SplitDepositRecurrenceAllocation' }>
  }

export type SmarDepositSplitDepositSettingFragmentFragment =
  | SmarDepositSplitDepositSettingFragment_SplitDepositDirectDepositIntentSetting_Fragment
  | SmarDepositSplitDepositSettingFragment_SplitDepositDirectDepositSetting_Fragment
  | SmarDepositSplitDepositSettingFragment_SplitDepositRecurrenceSetting_Fragment

export type SmartDepositSplitDepositDirectDepositSettingFragmentFragment = {
  __typename?: 'SplitDepositDirectDepositSetting'
  isUsingRecommendedAllocations: boolean
  awaitingConfiguration: boolean
  name: string
  isActive: boolean
  isHidden: boolean
  id: string
  allocations: Array<{
    __typename?: 'SplitDepositDirectDepositAllocation'
    allocationPercent: string
    targetAccountId: string
    targetAccountType: SplitDepositTargetAccountType
    normalizedAmount: { __typename?: 'FormattedMonetaryAmount'; value: string }
  }>
}

export type SmartDepositWidgetSplitDepositFragmentFragment = {
  __typename?: 'SplitDeposit'
  createdAt: string
  distributedAt: string
  expectedNextDepositAmount: string
  expectedNextDepositAt: string
  id: string
  isActive: boolean
  isCancelable: boolean
  isCanceled: boolean
  isUsingRecommendedAllocations: boolean
  savingsRatePercent: string
  settingsId: string
  updatedAt: string
  userId: string
  transactionAmount: string
  willDistributeAutomaticallyAt: string
  splitDistribution: {
    __typename?: 'DistributionAmounts'
    investment: string
    retirement: string
    savings: string
  }
  allocations: Array<
    | {
        __typename?: 'SplitDepositDirectDepositAllocation'
        allocationPercent: string
        targetAccountId: string
        targetAccountType: SplitDepositTargetAccountType
        normalizedAmount: {
          __typename?: 'FormattedMonetaryAmount'
          value: string
        }
      }
    | {
        __typename?: 'SplitDepositRecurrenceAllocation'
        allocationPercent: string
        targetAccountId: string
        targetAccountType: SplitDepositTargetAccountType
      }
  >
}

export type AllBankCardInfoQueryVariables = Exact<{ [key: string]: never }>

export type AllBankCardInfoQuery = {
  __typename?: 'Query'
  allBankCards: Array<{
    __typename?: 'BankCard'
    cardNumberMasked: any
    lockReason: BankCardLockReason
    status: BankCardStatus
    type: BankCardType
    referenceId: string
    createdAt: any
  }>
  allCardTrackingStatuses: Array<{
    __typename?: 'CardDeliveryStatus'
    status: PackageStatus
    picNumber: string
    createdAt: string
  }>
}

export type ActionFeedCardEventMutationVariables = Exact<{
  action: ActionFeedEventAction
  eventType: ActionFeedEventType
  eventKey: Scalars['ID']
  accountId?: InputMaybe<Scalars['ID']>
}>

export type ActionFeedCardEventMutation = {
  __typename?: 'Mutation'
  feedEvent: { __typename?: 'ActionFeedEventResponse'; success: boolean }
}

export type ActionFeedQueryVariables = Exact<{
  feedContext?: InputMaybe<ActionFeedContext>
}>

export type ActionFeedQuery = {
  __typename?: 'Query'
  actionFeed: Array<{
    __typename?: 'ActionCard'
    type: string
    widget: any
    userCardDigest: string
  }>
}

export type TierSubscriptionForPassionsEarlyAccessQueryVariables = Exact<{
  [key: string]: never
}>

export type TierSubscriptionForPassionsEarlyAccessQuery = {
  __typename?: 'Query'
  tierSubscriptionByUserId: {
    __typename?: 'TierSubscription'
    id: string
    tier: {
      __typename?: 'Tier'
      id: string
      name: string
      products: Array<{
        __typename?: 'Product'
        id: string
        key: ProductKey
        name: string
      }>
    }
    tierPrice: {
      __typename?: 'TierPrice'
      amount: { __typename?: 'CurrencyAmount'; value: number }
    }
  }
}

export type LegacyUploadDocumentMutationVariables = Exact<{
  documentType: DocumentType
  upload: Scalars['Upload']
}>

export type LegacyUploadDocumentMutation = {
  __typename?: 'Mutation'
  legacyUploadDocument:
    | { __typename: 'FileDoesNotExistInS3' }
    | { __typename: 'FileTooLarge' }
    | { __typename: 'InvalidFile' }
    | { __typename: 'LegacyUploadDocument' }
    | { __typename: 'UploadDoesNotExist' }
}

export type SubscriptionPricingContentQueryVariables = Exact<{
  [key: string]: never
}>

export type SubscriptionPricingContentQuery = {
  __typename?: 'Query'
  user: { __typename?: 'User'; uuid: string }
  tierSubscriptionHistoryByUserId: {
    __typename?: 'TierSubscriptionConnection'
    edges: Array<{
      __typename?: 'TierSubscription'
      status: TierSubscriptionStatus
      createdAt: any
      tier: { __typename?: 'Tier'; key: TierKey }
    }>
  }
  bankInterestRates:
    | {
        __typename?: 'BankInterestRates'
        bankInterestRates: Array<{
          __typename?: 'BankInterestRate'
          currentApy: string
          productName: BankingProduct
        }>
      }
    | { __typename?: 'BankServiceFailure' }
  tierGroup: {
    __typename?: 'TierGroup'
    id: string
    preferredTierId: string
    tierOptions: Array<{
      __typename?: 'TierOption'
      preferredTierPrice: {
        __typename?: 'TierPrice'
        billingFrequency: BillingFrequency
        amountV2: { __typename?: 'MicrosMoney'; currency: Currency; value: any }
      }
      tier: {
        __typename?: 'Tier'
        id: string
        key: TierKey
        name: string
        descriptionKey: string
        tierPrice: {
          __typename?: 'TierPrice'
          id: string
          amountV2: {
            __typename?: 'MicrosMoney'
            currency: Currency
            value: any
          }
        }
        products: Array<{
          __typename?: 'Product'
          key: ProductKey
          highlights: Array<{
            __typename?: 'PresentableProductDescription'
            title: any
          }>
        }>
        matchProgram: { __typename?: 'MatchProgram'; matchPercentage: number }
        bundles: Array<{
          __typename?: 'Bundle'
          name: string
          iconPath: string
          products: Array<{
            __typename?: 'PresentableProduct'
            descriptionKeysV2: Array<{
              __typename?: 'PresentableProductDescription'
              title: any
              subtitle: any
            }>
            product: { __typename?: 'Product'; key: ProductKey }
          }>
        }>
      }
    }>
  }
}

export type WithLaterDetailsQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type WithLaterDetailsQueryQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    fundingSource: { __typename?: 'FundingSource'; verified: boolean }
  }
  laterAccounts: Array<{
    __typename?: 'LaterAccount'
    amount: number
    name: string
    accountId: string
    accountNumber: string
    status: LaterAccountStatus
  }>
}

export type WithLinkedAccountsFundingSourceInfoQueryVariables = Exact<{
  [key: string]: never
}>

export type WithLinkedAccountsFundingSourceInfoQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    fundingSourceChangeRequiresApproval: boolean
    uploads: Array<{
      __typename?: 'UserUpload'
      id: string
      documentType: string
      createdAt: any
    }>
  }
  fundingSourceInfo: {
    __typename?: 'FundingSourceInfo'
    name: string
    accountNumberLastFour: string
    balance: number
    linkedSubaccountId: string
    verified: boolean
    type: FundingSourceType
    rdvSettledAt: any
  }
}

export type BankCardOrderQueryVariables = Exact<{ [key: string]: never }>

export type BankCardOrderQuery = {
  __typename?: 'Query'
  bankCardOrder: {
    __typename?: 'BankCardOrder'
    failureReason: BankCardOrderFailureReason
    cardOrderStatus: BankCardOrderStatus
    kycStatus: KycStatus
    fundingInitiated: boolean
    requestVersion: RequestVersions
    bankCardTier: BankCardTier
    addressVerification: {
      __typename?: 'BankCardOrderAddressVerification'
      status: BankCardOrderVerificationStatus
      actionRequired: BankCardOrderAddressVerificationActions
    }
    identityVerification: {
      __typename?: 'BankCardOrderIdentityVerification'
      status: BankCardOrderVerificationStatus
      actionRequired: BankCardOrderIdentityVerificationActions
      documentUploadUrl: string
      canRetry: boolean
    }
    prefundVerification: {
      __typename?: 'BankCardOrderPrefundVerification'
      status: BankCardOrderVerificationStatus
      actionRequired: BankCardOrderPrefundVerificationActions
    }
    fundingSourceVerification: {
      __typename?: 'BankCardOrderFundingSourceVerification'
      status: BankCardOrderVerificationStatus
      actionRequired: BankCardOrderFundingSourceVerificationActions
      pendingReason: BankCardOrderFundingSourceVerificationPendingReason
    }
  }
  spendAccount: { __typename?: 'SpendAccount'; isReopenable: boolean }
}

export type SpendAccountInfoQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type SpendAccountInfoQueryQuery = {
  __typename?: 'Query'
  fundingSourceInfo: {
    __typename?: 'FundingSourceInfo'
    verified: boolean
    name: string
  }
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    type: BankAccountType
    id: string
    status: BankAccountStatus
    availableBalance: { __typename?: 'CurrencyAmount'; value: number }
    pendingBalance: { __typename?: 'CurrencyAmount'; value: number }
  }>
  allBankCards: Array<{
    __typename?: 'BankCard'
    cardNumberMasked: any
    lockReason: BankCardLockReason
    status: BankCardStatus
    type: BankCardType
  }>
  allCardTrackingStatuses: Array<{
    __typename?: 'CardDeliveryStatus'
    status: PackageStatus
  }>
  eligibility: { __typename?: 'Eligibility'; eligible: boolean }
  spendAccount: {
    __typename?: 'SpendAccount'
    status: SpendAccountStatus
    isEligible: boolean
    isReopenable: boolean
    isDirectDepositIncentiveEligible: boolean
    bankType: BankType
  }
}

export type SendCheckEligibilityQueryVariables = Exact<{ [key: string]: never }>

export type SendCheckEligibilityQuery = {
  __typename?: 'Query'
  eligibility: { __typename?: 'Eligibility'; eligible: boolean }
}

export type OnboardingTipsQueryVariables = Exact<{
  feedContext: FeedContext
}>

export type OnboardingTipsQuery = {
  __typename?: 'Query'
  onboardingTips: {
    __typename?: 'OnboardingTips'
    items: Array<{
      __typename?: 'OnboardingTipItem'
      id: string
      type: OnboardingTipType
      title: string
      headline: string
      body: string
      image: { __typename?: 'Image'; url: string }
    }>
  }
}

export type BankAccountFragment = {
  __typename?: 'BankAccount'
  createdAt: any
  id: string
  isLocked: boolean
  status: BankAccountStatus
  type: BankAccountType
  availableBalance: {
    __typename?: 'CurrencyAmount'
    currency: Currency
    value: number
  }
  goals: {
    __typename?: 'BankAccountGoals'
    currentGoal: { __typename?: 'BankAccountGoal'; type: BankAccountGoalType }
  }
  pendingBalance: {
    __typename?: 'CurrencyAmount'
    currency: Currency
    value: number
  }
}

export type BankCardOrderFragment = {
  __typename?: 'BankCardOrder'
  cardOrderStatus: BankCardOrderStatus
  kycStatus: KycStatus
  fundingInitiated: boolean
  requestVersion: RequestVersions
  bankCardTier: BankCardTier
}

export type EarlyBeneficiariesFragment = {
  __typename?: 'Beneficiary'
  avatarUrl: string
  createdAt: any
  firstName: string
  id: string
  lastName: string
  updatedAt: any
  investmentAccount: {
    __typename?: 'InvestmentAccount'
    beneficiaryId: string
    id: string
    name: string
    type: string
    currentBalance: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
    performance: {
      __typename?: 'Performance'
      marketChangePercentWithoutFees: number
    }
    transferability: {
      __typename?: 'InvestmentAccountTransferability'
      transferAge: number
      transferDate: any
      transferReached: boolean
    }
  }
}

export type InvestProductAccountPropsFragment = {
  __typename?: 'InvestmentAccount'
  id: string
  name: string
  createdAt: any
  closedAt: any
  type: string
  beneficiaryId: string
  performance: { __typename?: 'Performance'; marketChangePercent: number }
  currentBalance: { __typename?: 'MonetaryAmount'; value: number }
}

export type ProductKeyFragment = {
  __typename?: 'Product'
  key: ProductKey
  id: string
}

export type SpendAccountFragment = {
  __typename?: 'SpendAccount'
  status: SpendAccountStatus
  isEligible: boolean
  isReopenable: boolean
  isDirectDepositIncentiveEligible: boolean
}

export type ProductAccountValuesQueryVariables = Exact<{
  product?: InputMaybe<InvestmentProduct>
}>

export type ProductAccountValuesQuery = {
  __typename?: 'Query'
  investmentAccounts: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    name: string
    createdAt: any
    closedAt: any
    type: string
    beneficiaryId: string
    performance: { __typename?: 'Performance'; marketChangePercent: number }
    currentBalance: { __typename?: 'MonetaryAmount'; value: number }
  }>
}

export type TrackAllBankCardsQueryVariables = Exact<{ [key: string]: never }>

export type TrackAllBankCardsQuery = {
  __typename?: 'Query'
  allBankCards: Array<{
    __typename?: 'BankCard'
    status: BankCardStatus
    lockReason: BankCardLockReason
  }>
}

export type FundingSourceDataQueryVariables = Exact<{ [key: string]: never }>

export type FundingSourceDataQuery = {
  __typename?: 'Query'
  fundingSourceInfo: { __typename?: 'FundingSourceInfo'; verified: boolean }
  user: { __typename?: 'User'; verified: boolean }
}

export type GetEarlyBeneficiariesQueryVariables = Exact<{
  [key: string]: never
}>

export type GetEarlyBeneficiariesQuery = {
  __typename?: 'Query'
  beneficiaries: Array<{
    __typename?: 'Beneficiary'
    avatarUrl: string
    createdAt: any
    firstName: string
    id: string
    lastName: string
    updatedAt: any
    investmentAccount: {
      __typename?: 'InvestmentAccount'
      beneficiaryId: string
      id: string
      name: string
      type: string
      currentBalance: {
        __typename?: 'MonetaryAmount'
        currency: Currency
        value: number
      }
      transferability: {
        __typename?: 'InvestmentAccountTransferability'
        transferAge: number
        transferDate: any
        transferReached: boolean
      }
      performance: {
        __typename?: 'Performance'
        marketChangePercentWithoutFees: number
      }
    }
  }>
}

export type TierSubscriptionForUserDataQueryVariables = Exact<{
  [key: string]: never
}>

export type TierSubscriptionForUserDataQuery = {
  __typename?: 'Query'
  tierSubscriptionByUserId: {
    __typename?: 'TierSubscription'
    id: string
    tier: {
      __typename?: 'Tier'
      id: string
      products: Array<{ __typename?: 'Product'; key: ProductKey; id: string }>
    }
  }
}

export type ReferralAgreeToAcceptanceDocumentMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type ReferralAgreeToAcceptanceDocumentMutation = {
  __typename?: 'Mutation'
  agreeToAcceptanceDocument: any
}

export type AllCampaignHistoryQueryVariables = Exact<{ [key: string]: never }>

export type AllCampaignHistoryQuery = {
  __typename?: 'Query'
  pendingCampaigns: {
    __typename?: 'CampaignHistoryConnection'
    edges: Array<{
      __typename: 'CampaignHistoryEdge'
      cursor: string
      hurdleMet: boolean
      numCompletedReferrals: number
      numPendingReferrals: number
      eligibilityMet: boolean
      node: {
        __typename?: 'ReferralCampaignV2'
        icon: string
        condensedTitle: string
        eligibilityEnd: any
        id: string
        internalMemo: string
        publishEnd: any
        publishStart: any
        qualificationAction: string
        qualificationAmount: number
        status: CampaignStatus
        rewards: Array<{
          __typename?: 'ReferralCampaignReward'
          amount: number
          hurdle: number
          id: string
          targets: Array<ReferralCampaignRewardTarget>
          type: ReferralCampaignRewardType
        }>
      }
    }>
    pageInfo: {
      __typename?: 'ReferralPaginatedInfo'
      endCursor: string
      hasNextPage: boolean
      hasPreviousPage: boolean
      startCursor: string
    }
  }
  activeCampaigns: {
    __typename?: 'CampaignHistoryConnection'
    edges: Array<{
      __typename: 'CampaignHistoryEdge'
      cursor: string
      hurdleMet: boolean
      numCompletedReferrals: number
      numPendingReferrals: number
      eligibilityMet: boolean
      node: {
        __typename?: 'ReferralCampaignV2'
        icon: string
        condensedTitle: string
        eligibilityEnd: any
        id: string
        internalMemo: string
        publishEnd: any
        publishStart: any
        qualificationAction: string
        qualificationAmount: number
        status: CampaignStatus
        rewards: Array<{
          __typename?: 'ReferralCampaignReward'
          amount: number
          hurdle: number
          id: string
          targets: Array<ReferralCampaignRewardTarget>
          type: ReferralCampaignRewardType
        }>
      }
    }>
    pageInfo: {
      __typename?: 'ReferralPaginatedInfo'
      endCursor: string
      hasNextPage: boolean
      hasPreviousPage: boolean
      startCursor: string
    }
  }
  pastCompletedCampaigns: {
    __typename?: 'CampaignHistoryConnection'
    edges: Array<{
      __typename: 'CampaignHistoryEdge'
      cursor: string
      hurdleMet: boolean
      numCompletedReferrals: number
      numPendingReferrals: number
      eligibilityMet: boolean
      node: {
        __typename?: 'ReferralCampaignV2'
        icon: string
        condensedTitle: string
        eligibilityEnd: any
        id: string
        internalMemo: string
        publishEnd: any
        publishStart: any
        qualificationAction: string
        qualificationAmount: number
        status: CampaignStatus
        rewards: Array<{
          __typename?: 'ReferralCampaignReward'
          amount: number
          hurdle: number
          id: string
          targets: Array<ReferralCampaignRewardTarget>
          type: ReferralCampaignRewardType
        }>
      }
    }>
    pageInfo: {
      __typename?: 'ReferralPaginatedInfo'
      endCursor: string
      hasNextPage: boolean
      hasPreviousPage: boolean
      startCursor: string
    }
  }
  pastPendingCampaigns: {
    __typename?: 'CampaignHistoryConnection'
    edges: Array<{
      __typename: 'CampaignHistoryEdge'
      cursor: string
      hurdleMet: boolean
      numCompletedReferrals: number
      numPendingReferrals: number
      eligibilityMet: boolean
      node: {
        __typename?: 'ReferralCampaignV2'
        icon: string
        condensedTitle: string
        eligibilityEnd: any
        id: string
        internalMemo: string
        publishEnd: any
        publishStart: any
        qualificationAction: string
        qualificationAmount: number
        status: CampaignStatus
        rewards: Array<{
          __typename?: 'ReferralCampaignReward'
          amount: number
          hurdle: number
          id: string
          targets: Array<ReferralCampaignRewardTarget>
          type: ReferralCampaignRewardType
        }>
      }
    }>
    pageInfo: {
      __typename?: 'ReferralPaginatedInfo'
      endCursor: string
      hasNextPage: boolean
      hasPreviousPage: boolean
      startCursor: string
    }
  }
}

export type CampaignFriendsHistoryQueryVariables = Exact<{
  campaignId: Scalars['ID']
  filterFriend: ReferralPaginatedFilter
  filterCampaign: ReferralPaginatedFilter
}>

export type CampaignFriendsHistoryQuery = {
  __typename?: 'Query'
  referralCampaigns: {
    __typename?: 'ReferralCampaignConnection'
    edges: Array<{
      __typename?: 'ReferralCampaignEdge'
      cursor: string
      node: {
        __typename?: 'ReferralCampaignV2'
        icon: string
        condensedTitle: string
        eligibilityEnd: any
        id: string
        internalMemo: string
        publishEnd: any
        publishStart: any
        qualificationAction: string
        qualificationAmount: number
        status: CampaignStatus
        rewards: Array<{
          __typename?: 'ReferralCampaignReward'
          amount: number
          hurdle: number
          id: string
          targets: Array<ReferralCampaignRewardTarget>
          type: ReferralCampaignRewardType
        }>
      }
    }>
  }
  referralHistory: {
    __typename?: 'ReferralHistory'
    numCompletedReferrals: number
    numPendingReferrals: number
    friendHistory: {
      __typename?: 'FriendHistoryConnection'
      edges: Array<{
        __typename?: 'FriendHistoryEdge'
        cursor: string
        node: {
          __typename: 'FriendHistory'
          advocateUserId: string
          campaignId: string
          createdAt: any
          friendFirstName: string
          friendLastName: string
          status: FriendStatusV2
          userId: string
        }
      }>
    }
  }
}

export type ReferralCampaignIdQueryVariables = Exact<{ [key: string]: never }>

export type ReferralCampaignIdQuery = {
  __typename?: 'Query'
  advocate: {
    __typename?: 'Advocate'
    campaign: { __typename?: 'ReferralCampaignV2'; id: string }
  }
}

export type UserInvestmentAccountsQueryVariables = Exact<{
  [key: string]: never
}>

export type UserInvestmentAccountsQuery = {
  __typename?: 'Query'
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    type: string
    closedAt: any
    portfolio: { __typename?: 'Portfolio'; id: string }
  }>
}

export type ReferralFriendHistoryQueryVariables = Exact<{
  filter: ReferralPaginatedFilter
}>

export type ReferralFriendHistoryQuery = {
  __typename?: 'Query'
  referralHistory: {
    __typename?: 'ReferralHistory'
    friendHistory: {
      __typename?: 'FriendHistoryConnection'
      edges: Array<{
        __typename?: 'FriendHistoryEdge'
        cursor: string
        node: {
          __typename?: 'FriendHistory'
          advocateUserId: string
          campaignId: string
          createdAt: any
          friendFirstName: string
          friendLastName: string
          status: FriendStatusV2
          userId: string
        }
      }>
    }
  }
}

export type SendBrazeEventMutationVariables = Exact<{
  input: SendBrazeEventInput
}>

export type SendBrazeEventMutation = {
  __typename?: 'Mutation'
  sendBrazeEvent: string
}

export type ReferralDetailsQueryQueryVariables = Exact<{ [key: string]: never }>

export type ReferralDetailsQueryQuery = {
  __typename?: 'Query'
  acceptanceDocuments: Array<{
    __typename?: 'AcceptanceDocument'
    name: string
    type: string
    summaryUrl: any
    id: string
    url: any
  }>
  user: {
    __typename?: 'User'
    uuid: string
    email: string
    firstName: string
    lastName: string
  }
}

export type ReferralDetailsWithAdvocateQueryVariables = Exact<{
  [key: string]: never
}>

export type ReferralDetailsWithAdvocateQuery = {
  __typename?: 'Query'
  acceptanceDocuments: Array<{
    __typename?: 'AcceptanceDocument'
    name: string
    type: string
    summaryUrl: any
    id: string
    url: any
  }>
  user: {
    __typename?: 'User'
    uuid: string
    email: string
    firstName: string
    lastName: string
  }
  advocate: {
    __typename?: 'Advocate'
    campaign: {
      __typename?: 'ReferralCampaignV2'
      id: string
      title: string
      description: string
      eligibilityEnd: any
      publishEnd: any
      activeInHouseCampaign: boolean
      actionFeedDesc: string
      qualificationAction: string
      qualificationAmount: number
      autoAdd: boolean
      background: string
      rewards: Array<{
        __typename?: 'ReferralCampaignReward'
        amount: number
        hurdle: number
        id: string
        targets: Array<ReferralCampaignRewardTarget>
        type: ReferralCampaignRewardType
      }>
    }
    experienceContent: {
      __typename?: 'ExperienceContent'
      shareableLink: string
    }
  }
}

export type CheckingAccountDisclosureQueryVariables = Exact<{
  [key: string]: never
}>

export type CheckingAccountDisclosureQuery = {
  __typename: 'Query'
  spendAccount: {
    __typename: 'SpendAccount'
    bankCardOrder: { __typename: 'BankCardOrder'; bankCardTier: BankCardTier }
  }
}

export type UserEmailQueryVariables = Exact<{ [key: string]: never }>

export type UserEmailQuery = {
  __typename?: 'Query'
  user: { __typename?: 'User'; email: string }
}

export type UpgradeLanderTierSubscriptionQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type UpgradeLanderTierSubscriptionQueryQuery = {
  __typename?: 'Query'
  userStatus: { __typename?: 'UserStatus'; age: number }
  tierSubscriptionByUserId: {
    __typename: 'TierSubscription'
    id: string
    tier: {
      __typename: 'Tier'
      id: string
      displayName: string
      name: string
      products: Array<{
        __typename: 'Product'
        key: ProductKey
        active: boolean
        name: string
        createdAt: any
        description: string
        descriptionKeys: Array<string>
        id: string
        updatedAt: any
      }>
      matchProgram: { __typename?: 'MatchProgram'; matchPercentage: number }
    }
    tierPrice: {
      __typename: 'TierPrice'
      id: string
      billingFrequency: BillingFrequency
      amount: { __typename?: 'CurrencyAmount'; value: number }
    }
  }
  tierGroupForUser: {
    __typename: 'TierGroup'
    tierOptions: Array<{
      __typename: 'TierOption'
      tier: {
        __typename: 'Tier'
        id: string
        assetPath: string
        key: TierKey
        name: string
        displayName: string
        description: string
        tierPrice: {
          __typename: 'TierPrice'
          id: string
          billingFrequency: BillingFrequency
          amount: { __typename?: 'CurrencyAmount'; value: number }
        }
        products: Array<{
          __typename: 'Product'
          key: ProductKey
          active: boolean
          name: string
          createdAt: any
          description: string
          descriptionKeys: Array<string>
          id: string
          updatedAt: any
        }>
        matchProgram: { __typename?: 'MatchProgram'; matchPercentage: number }
      }
    }>
  }
}

export type LogoutMutationVariables = Exact<{ [key: string]: never }>

export type LogoutMutation = {
  __typename?: 'Mutation'
  logout:
    | { __typename: 'AuthTokenNotFoundException' }
    | { __typename: 'LogoutSuccess' }
    | { __typename: 'RefreshTokenNotFoundException' }
}

export type RefreshAuthTokensMutationVariables = Exact<{
  refreshToken: Scalars['String']
}>

export type RefreshAuthTokensMutation = {
  __typename?: 'Mutation'
  refreshAuthToken:
    | { __typename?: 'AuthSession'; token: string; refreshToken: string }
    | { __typename?: 'InvalidPinException' }
    | { __typename?: 'RefreshAuthTokenRateLimitedException' }
    | { __typename?: 'TokenExpiredException' }
    | { __typename?: 'UserSuspendedException' }
}

export type UpdateOptOutOfTargetingMutationVariables = Exact<{
  optOutPreference: Scalars['Boolean']
}>

export type UpdateOptOutOfTargetingMutation = {
  __typename?: 'Mutation'
  updateOptOutOfTargeting: {
    __typename?: 'Profile'
    optedOutOfTargeting: boolean
  }
}

export type BankInterestRatesQueryVariables = Exact<{
  productFilter?: InputMaybe<
    Array<InputMaybe<BankingProduct>> | InputMaybe<BankingProduct>
  >
}>

export type BankInterestRatesQuery = {
  __typename?: 'Query'
  bankInterestRates:
    | {
        __typename: 'BankInterestRates'
        bankInterestRates: Array<{
          __typename: 'BankInterestRate'
          currentApy: string
          liveDate: string
          productName: BankingProduct
        }>
      }
    | { __typename: 'BankServiceFailure'; reason: string; retryable: boolean }
}

export type BeneficiaryRecapQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type BeneficiaryRecapQuery = {
  __typename?: 'Query'
  beneficiary: {
    __typename?: 'Beneficiary'
    createdAt: any
    custodianId: string
    firstName: string
    id: string
    lastName: string
    updatedAt: any
    custodianNickname: string
    investmentAccount: {
      __typename?: 'InvestmentAccount'
      id: string
      name: string
      type: string
      investmentAccountType: InvestmentAccountType
      quarterlyRecapsEnabled: boolean
      quarterlyRecap: {
        __typename?: 'InvestmentAccountRecap'
        id: string
        public: boolean
        publicUrl: any
      }
    }
  }
}

export type EarlyBeneficiaryRecapFieldsFragment = {
  __typename?: 'Beneficiary'
  createdAt: any
  custodianId: string
  firstName: string
  id: string
  lastName: string
  updatedAt: any
  custodianNickname: string
  investmentAccount: {
    __typename?: 'InvestmentAccount'
    id: string
    name: string
    type: string
    investmentAccountType: InvestmentAccountType
    quarterlyRecapsEnabled: boolean
    quarterlyRecap: {
      __typename?: 'InvestmentAccountRecap'
      id: string
      public: boolean
      publicUrl: any
    }
  }
}

export type EarlyInvestmentAccountRecapFieldsFragment = {
  __typename?: 'InvestmentAccount'
  id: string
  name: string
  type: string
  investmentAccountType: InvestmentAccountType
  quarterlyRecapsEnabled: boolean
  quarterlyRecap: {
    __typename?: 'InvestmentAccountRecap'
    id: string
    public: boolean
    publicUrl: any
  }
}

export type OptOutOfTargetingQueryVariables = Exact<{ [key: string]: never }>

export type OptOutOfTargetingQuery = {
  __typename?: 'Query'
  profile: { __typename?: 'Profile'; optedOutOfTargeting: boolean }
}

export type FundingSourceAccountsStateQueryVariables = Exact<{
  [key: string]: never
}>

export type FundingSourceAccountsStateQuery = {
  __typename?: 'Query'
  fundingSourceAccounts: Array<{
    __typename?: 'FundingSourceAccount'
    role: FundingSourceRoleEnum
  }>
  settings: { __typename?: 'Settings'; depositsSuspended: boolean }
}

export type OnboardingRequirementsQueryVariables = Exact<{
  onboardingType: OnboardingType
}>

export type OnboardingRequirementsQuery = {
  __typename?: 'Query'
  onboardingRequirements: Array<OnboardingRequirement>
}

export type TierSubscriptionByUserIdQueryVariables = Exact<{
  [key: string]: never
}>

export type TierSubscriptionByUserIdQuery = {
  __typename?: 'Query'
  tierSubscriptionByUserId: {
    __typename?: 'TierSubscription'
    id: string
    tier: {
      __typename?: 'Tier'
      id: string
      key: TierKey
      displayName: string
      name: string
      products: Array<{
        __typename?: 'Product'
        key: ProductKey
        active: boolean
        name: string
      }>
    }
    tierPrice: {
      __typename?: 'TierPrice'
      id: string
      billingFrequency: BillingFrequency
      amount: { __typename?: 'CurrencyAmount'; value: number }
    }
  }
  tierGroupForUser: {
    __typename?: 'TierGroup'
    id: string
    preferredTierId: string
    tierOptions: Array<{
      __typename?: 'TierOption'
      preferredTierPrice: {
        __typename?: 'TierPrice'
        billingFrequency: BillingFrequency
        amount: { __typename?: 'CurrencyAmount'; value: number }
      }
      tier: {
        __typename?: 'Tier'
        id: string
        assetPath: string
        key: TierKey
        name: string
        displayName: string
        description: string
        tierPrice: {
          __typename?: 'TierPrice'
          id: string
          amount: { __typename?: 'CurrencyAmount'; value: number }
        }
        products: Array<{ __typename?: 'Product'; key: ProductKey }>
      }
    }>
  }
}

export type UpdateRecurringInvestmentMutationVariables = Exact<{
  amount: Scalars['Float']
  day: Scalars['Int']
  frequency: InvestmentFrequency
  investment_account_id: Scalars['String']
}>

export type UpdateRecurringInvestmentMutation = {
  __typename?: 'Mutation'
  updateRecurringInvestment: {
    __typename?: 'RecurringInvestmentPayload'
    recurringInvestmentSettings: {
      __typename?: 'RecurringInvestmentSettings'
      amount: number
      day: number
      frequency: InvestmentFrequency
    }
  }
}

export type TierGroupForUserQueryVariables = Exact<{ [key: string]: never }>

export type TierGroupForUserQuery = {
  __typename?: 'Query'
  tierGroupForUser: {
    __typename?: 'TierGroup'
    id: string
    preferredTierId: string
    tierOptions: Array<{
      __typename?: 'TierOption'
      preferredTierPrice: {
        __typename?: 'TierPrice'
        billingFrequency: BillingFrequency
        amount: { __typename?: 'CurrencyAmount'; value: number }
      }
      tier: {
        __typename?: 'Tier'
        id: string
        assetPath: string
        key: TierKey
        name: string
        displayName: string
        description: string
        tierPrice: {
          __typename?: 'TierPrice'
          id: string
          amount: { __typename?: 'CurrencyAmount'; value: number }
        }
        products: Array<{ __typename?: 'Product'; key: ProductKey }>
        bundles: Array<{
          __typename?: 'Bundle'
          name: string
          iconPath: string
          products: Array<{
            __typename?: 'PresentableProduct'
            descriptionKeys: Array<any>
            product: { __typename?: 'Product'; key: ProductKey }
          }>
        }>
      }
    }>
  }
}

export type AgreeToSingleAcceptanceDocumentMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type AgreeToSingleAcceptanceDocumentMutation = {
  __typename?: 'Mutation'
  agreeToAcceptanceDocument: any
}

export type AllPastSpendSummaryQueryVariables = Exact<{ [key: string]: never }>

export type AllPastSpendSummaryQuery = {
  __typename?: 'Query'
  pastSpendSummary: {
    __typename?: 'PastSpendSummary'
    debitsLast30Days: {
      __typename?: 'CurrencyAmount'
      currency: Currency
      value: number
    }
    depositsLast30Days: {
      __typename?: 'CurrencyAmount'
      currency: Currency
      value: number
    }
    availableBalance: {
      __typename?: 'CurrencyAmount'
      currency: Currency
      value: number
    }
  }
}

export type BankingHubQueryVariables = Exact<{ [key: string]: never }>

export type BankingHubQuery = {
  __typename?: 'Query'
  pastSpendSummary: {
    __typename?: 'PastSpendSummary'
    debitsLast30Days: {
      __typename?: 'CurrencyAmount'
      currency: Currency
      value: number
    }
    depositsLast30Days: {
      __typename?: 'CurrencyAmount'
      currency: Currency
      value: number
    }
    availableBalance: {
      __typename?: 'CurrencyAmount'
      currency: Currency
      value: number
    }
  }
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    type: BankAccountType
    availableBalance: { __typename?: 'CurrencyAmount'; value: number }
    goals: {
      __typename?: 'BankAccountGoals'
      currentGoal: { __typename?: 'BankAccountGoal'; type: BankAccountGoalType }
    }
    currentBalance: {
      __typename?: 'CurrencyAmount'
      currency: Currency
      value: number
    }
  }>
  bankCardOrder: {
    __typename?: 'BankCardOrder'
    fundingInitiated: boolean
    requestVersion: RequestVersions
    kycStatus: KycStatus
    bankCardTier: BankCardTier
  }
  spendAccount: {
    __typename?: 'SpendAccount'
    status: SpendAccountStatus
    isReopenable: boolean
  }
}

export type BankCardOrderFragmentFragment = {
  __typename?: 'BankCardOrder'
  fundingInitiated: boolean
  requestVersion: RequestVersions
  kycStatus: KycStatus
  bankCardTier: BankCardTier
}

export type SpendAccountFragmentFragment = {
  __typename?: 'SpendAccount'
  status: SpendAccountStatus
  isReopenable: boolean
}

export type BenefitsHubAgreeToAcceptanceDocumentMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type BenefitsHubAgreeToAcceptanceDocumentMutation = {
  __typename?: 'Mutation'
  agreeToAcceptanceDocument: any
}

export type BenefitsHubAvailableTiersQueryVariables = Exact<{
  [key: string]: never
}>

export type BenefitsHubAvailableTiersQuery = {
  __typename?: 'Query'
  tierGroupForUser: {
    __typename?: 'TierGroup'
    id: string
    tierOptions: Array<{
      __typename?: 'TierOption'
      tier: {
        __typename?: 'Tier'
        id: string
        active: boolean
        key: TierKey
        name: string
        products: Array<{
          __typename?: 'Product'
          active: boolean
          key: ProductKey
          name: string
        }>
        tierPrice: {
          __typename?: 'TierPrice'
          billingFrequency: BillingFrequency
          id: string
          amount: { __typename?: 'CurrencyAmount'; value: number }
        }
      }
    }>
  }
}

export type BenefitsHubCustomAllocationPercentageQueryVariables = Exact<{
  product?: InputMaybe<InvestmentProduct>
}>

export type BenefitsHubCustomAllocationPercentageQuery = {
  __typename?: 'Query'
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    portfolio: {
      __typename?: 'Portfolio'
      minimumManagedAllocationPercent: number
    }
  }>
}

export type BenefitsHubOnboardingBenefitsQueryVariables = Exact<{
  product: OnboardingProducts
}>

export type BenefitsHubOnboardingBenefitsQuery = {
  __typename?: 'Query'
  onboardingBenefits: Array<{
    __typename?: 'OnboardingTileGroup'
    products: Array<{
      __typename?: 'OnboardingProductTile'
      product: OnboardingProducts
      status: BenefitProductStatus
      claimDetails: {
        __typename?: 'OnboardingProductStatus'
        claimStatus: ClaimStatus
        claimedOn: string
        expiresOn: string
        details: Array<{
          __typename?: 'ClaimStatusDetails'
          statusCode: BenefitStatusDetail
          message: string
        }>
      }
    }>
  }>
}

export type TaxFilingAddCohortEligibilityMutationVariables = Exact<{
  cohort: Scalars['String']
}>

export type TaxFilingAddCohortEligibilityMutation = {
  __typename?: 'Mutation'
  addCohortEligibility: {
    __typename?: 'UserCohorts'
    userId: string
    cohorts: Array<string>
  }
}

export type BenefitsHubTaxFilingPartnerByUserIdQueryVariables = Exact<{
  [key: string]: never
}>

export type BenefitsHubTaxFilingPartnerByUserIdQuery = {
  __typename?: 'Query'
  benefitPartnerByUserId:
    | { __typename: 'ProductNotSupportedException' }
    | {
        __typename: 'TaxFilingPartner'
        taxAppStatus: TaxApplicationStatus
        isDataConsentSigned: boolean
        isStateFiled: boolean
        netRefundAmountV2: {
          __typename: 'MicrosMoney'
          currency: Currency
          value: any
        }
        federalReturn: {
          __typename: 'TaxReturn'
          taxLocationCode: string
          returnStatus: TaxReturnStatus
          refundAmountV2: {
            __typename: 'MicrosMoney'
            currency: Currency
            value: any
          }
        }
        stateReturns: Array<{
          __typename: 'TaxReturn'
          taxLocationCode: string
          returnStatus: TaxReturnStatus
          refundAmountV2: {
            __typename: 'MicrosMoney'
            currency: Currency
            value: any
          }
        }>
      }
}

export type BenefitsHubTaxFilingPartnerStatusQueryVariables = Exact<{
  [key: string]: never
}>

export type BenefitsHubTaxFilingPartnerStatusQuery = {
  __typename?: 'Query'
  getPartnerUrl: {
    __typename: 'PartnerUrlResponse'
    status: AcornsPartnerStatus
  }
}

export type BenefitsHubTaxFilingPartnerUrlQueryVariables = Exact<{
  shareCustomerData: Scalars['Boolean']
}>

export type BenefitsHubTaxFilingPartnerUrlQuery = {
  __typename?: 'Query'
  getPartnerUrl: { __typename: 'PartnerUrlResponse'; partnerUrl: string }
}

export type RecordTaxRefundInvestmentMutationVariables = Exact<{
  input: RecordTaxRefundInvestmentInput
}>

export type RecordTaxRefundInvestmentMutation = {
  __typename?: 'Mutation'
  recordTaxRefundInvestment: {
    __typename?: 'RecordTaxRefundInvestmentPayload'
    taxRefund: { __typename?: 'TaxRefund'; id: string }
  }
}

export type TaxFilingSubscribeUserToTierMutationVariables = Exact<{
  tierPriceId: Scalars['ID']
}>

export type TaxFilingSubscribeUserToTierMutation = {
  __typename?: 'Mutation'
  subscribeUserToTier:
    | { __typename?: 'InvalidTierPriceId'; message: string }
    | {
        __typename?: 'TierDowngradeActionRequired'
        actions: Array<{
          __typename?: 'TierDowngradeAction'
          key: TierDowngradeActionKey
        }>
      }
    | {
        __typename?: 'TierSubscription'
        tier: {
          __typename?: 'Tier'
          name: string
          tierPrice: { __typename?: 'TierPrice'; id: string }
        }
      }
}

export type BenefitsHubTaxRefundsByUserIdQueryVariables = Exact<{
  filter?: InputMaybe<TaxRefundFilterInput>
}>

export type BenefitsHubTaxRefundsByUserIdQuery = {
  __typename?: 'Query'
  taxRefundsByUserId: Array<{
    __typename?: 'TaxRefund'
    id: string
    refundType: RefundType
    isInvested: boolean
    totalAmount: { __typename?: 'MicrosMoney'; currency: Currency; value: any }
  }>
}

export type BenefitsHubUserQueryVariables = Exact<{ [key: string]: never }>

export type BenefitsHubUserQuery = {
  __typename?: 'Query'
  user: { __typename?: 'User'; verified: boolean }
}

export type BenefitsHubUserTierQueryVariables = Exact<{ [key: string]: never }>

export type BenefitsHubUserTierQuery = {
  __typename?: 'Query'
  tierSubscriptionByUserId: {
    __typename?: 'TierSubscription'
    id: string
    tier: {
      __typename?: 'Tier'
      key: TierKey
      id: string
      name: string
      products: Array<{
        __typename?: 'Product'
        active: boolean
        key: ProductKey
        name: string
      }>
    }
    tierPrice: {
      __typename?: 'TierPrice'
      id: string
      billingFrequency: BillingFrequency
      amount: { __typename?: 'CurrencyAmount'; value: number }
    }
  }
}

export type BenefitsPartnerStatusMutationVariables = Exact<{
  input: PartnerStatusInput
}>

export type BenefitsPartnerStatusMutation = {
  __typename?: 'Mutation'
  setUserPartnerStatus: {
    __typename?: 'UserPartnerStatusResponse'
    message: string
  }
}

export type GetCohortEligibilityQueryVariables = Exact<{
  cohorts?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
}>

export type GetCohortEligibilityQuery = {
  __typename?: 'Query'
  cohortEligibility_v2: Array<{
    __typename?: 'CohortEligibility_v2'
    cohort: string
    eligible: boolean
  }>
}

export type GetPartnerUrlQueryVariables = Exact<{
  input: PartnerUrlInput
}>

export type GetPartnerUrlQuery = {
  __typename?: 'Query'
  getPartnerUrl: {
    __typename?: 'PartnerUrlResponse'
    partnerUrl: string
    status: AcornsPartnerStatus
  }
}

export type ListBenefitsQueryVariables = Exact<{ [key: string]: never }>

export type ListBenefitsQuery = {
  __typename?: 'Query'
  listBenefitsByUserId: Array<{
    __typename: 'BenefitTileGroup'
    groupName: string
    products: Array<{
      __typename: 'BenefitProductTile'
      product: BenefitsTrackerProducts
      status: BenefitProductStatus
    }>
  }>
}

export type PartnerDataShareMutationVariables = Exact<{
  product: BenefitsProduct
}>

export type PartnerDataShareMutation = {
  __typename?: 'Mutation'
  initiatePartnerDataShare:
    | {
        __typename?: 'PartnerDataShare'
        userId: string
        partner: BenefitsPartner
      }
    | { __typename: 'ProductNotSupportedException'; message: string }
}

export type RequireForAllAcceptanceDocumentsQueryVariables = Exact<{
  requiredFor?: InputMaybe<Scalars['String']>
}>

export type RequireForAllAcceptanceDocumentsQuery = {
  __typename?: 'Query'
  allAcceptanceDocuments: Array<{
    __typename?: 'AcceptanceDocument'
    id: string
    name: string
    type: string
    url: any
    summaryUrl: any
  }>
}

export type UserBenefitsStatusQueryVariables = Exact<{
  tierKey: Scalars['String']
  benefitProductKey?: InputMaybe<Scalars['String']>
}>

export type UserBenefitsStatusQuery = {
  __typename?: 'Query'
  userBenefitsStatus: {
    __typename?: 'BenefitsStatusResponse'
    benefitsStatus: Array<{
      __typename: 'BenefitStatus'
      benefitProductKey: string
      expiresOn: string
      claimStatus: ClaimStatus
      details: Array<{
        __typename: 'ClaimStatusDetails'
        message: string
        statusCode: BenefitStatusDetail
      }>
    }>
  }
}

export type EarlyClosureReasonsQueryVariables = Exact<{ [key: string]: never }>

export type EarlyClosureReasonsQuery = {
  __typename?: 'Query'
  earlyAccountClosureReasons: Array<InvestmentAccountClosureReason>
}

export type StopRecurringInvestmentMutationVariables = Exact<{
  investmentAccountId?: InputMaybe<Scalars['String']>
}>

export type StopRecurringInvestmentMutation = {
  __typename?: 'Mutation'
  stopRecurringInvestment: {
    __typename?: 'RecurringInvestmentPayload'
    recurringInvestmentSettings: {
      __typename?: 'RecurringInvestmentSettings'
      amount: number
    }
  }
}

export type CloseAccountCancelRecurringTransferMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type CloseAccountCancelRecurringTransferMutation = {
  __typename?: 'Mutation'
  cancelRecurringTransfer:
    | {
        __typename: 'RecurringTransfer'
        active: boolean
        id: string
        nextTransferDate: any
        recurrenceRule: {
          __typename?: 'RecurrenceRule'
          byMonthDay: Array<number>
          byWeekDay: Array<DayOfWeek>
          endDate: any
          frequency: RecurrenceFrequency
          interval: number
          startDate: any
        }
        transferEvent: {
          __typename?: 'RecurringTransferEvent'
          direction: RecurringTransferDirection
          targetAccount: {
            __typename?: 'RecurringTransferAccount'
            type: RecurringTransferAccountType
            id: string
          }
          fundingSource: {
            __typename?: 'RecurringTransferFundingSource'
            type: RecurringTransferFundingSourceType
            id: string
          }
          amount: {
            __typename?: 'CurrencyAmount'
            value: number
            currency: Currency
          }
        }
      }
    | { __typename: 'VersionMismatchException' }
}

export type CloseUserAccountMutationVariables = Exact<{ [key: string]: never }>

export type CloseUserAccountMutation = {
  __typename?: 'Mutation'
  closeUserAccount:
    | { __typename: 'OpenAccountsException'; openAccountTypes: Array<string> }
    | { __typename: 'UserNotFoundException'; message: string; userId: string }
    | { __typename: 'User_v2'; closedAt: any; email: string; uuid: string }
}

export type CloseAccountRequestAccountClosureMutationVariables = Exact<{
  input: DeactivateTierSubscriptionInput
}>

export type CloseAccountRequestAccountClosureMutation = {
  __typename?: 'Mutation'
  deactivateTierSubscription:
    | { __typename: 'TierSubscription' }
    | { __typename: 'TierSubscriptionAlreadyDeactivated' }
}

export type EarlyAccountClosureMutationVariables = Exact<{
  input: RequestEarlyAccountClosureInput
}>

export type EarlyAccountClosureMutation = {
  __typename?: 'Mutation'
  requestEarlyAccountClosure: Array<
    | { __typename: 'AccountAlreadyClosedException'; message: string }
    | { __typename: 'ClosureRequestExistsException'; message: string }
    | { __typename: 'FundingSourceRequiresRdvException'; message: string }
    | { __typename: 'InternalErrorException'; message: string }
    | { __typename: 'InvalidAccountTypeException'; message: string }
    | { __typename: 'InvestmentAccount'; id: string; closedAt: any }
    | { __typename: 'InvestmentAccountNeedsTransferException' }
    | { __typename: 'MissingFundingSourceException'; message: string }
  >
}

export type RequestAccountClosureMutationVariables = Exact<{
  comments?: InputMaybe<Scalars['String']>
  reason: Scalars['String']
}>

export type RequestAccountClosureMutation = {
  __typename?: 'Mutation'
  requestAccountClosure: any
}

export type RequestCloseAccountMutationVariables = Exact<{
  input: CreateSupportTicketInput
}>

export type RequestCloseAccountMutation = {
  __typename?: 'Mutation'
  createAuthenticatedSupportTicket: {
    __typename?: 'SupportTicket'
    description: string
    id: string
    subject: string
    url: string
  }
}

export type LaterLiquidationMutationMutationVariables = Exact<{
  investmentAccountId: Scalars['ID']
  federalTaxes: Scalars['Float']
  stateTaxes: Scalars['Float']
  taxYear: Scalars['Int']
  reason: LaterWithdrawalReason
}>

export type LaterLiquidationMutationMutation = {
  __typename?: 'Mutation'
  laterTotalLiquidation: any
}

export type CloseAccountInvestmentAccountsQueryVariables = Exact<{
  [key: string]: never
}>

export type CloseAccountInvestmentAccountsQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    uuid: string
    email: string
    firstName: string
    lastName: string
    phoneNumber: string
    fundingSource: {
      __typename?: 'FundingSource'
      name: string
      last4: string
      fundingType: string
      type: string
    }
  }
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    name: string
    type: string
    product: InvestmentProduct
    closedAt: any
    beneficiaryId: string
    status: InvestmentAccountStatus
    beneficiary: { __typename?: 'Beneficiary'; firstName: string }
    currentBalance: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
    pendingBalance: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
    recurringInvestmentSettings: {
      __typename?: 'RecurringInvestmentSettings'
      amount: number
    }
  }>
}

export type LaterBalancesQueryQueryVariables = Exact<{ [key: string]: never }>

export type LaterBalancesQueryQuery = {
  __typename?: 'Query'
  laterAccounts: Array<{
    __typename?: 'LaterAccount'
    status: LaterAccountStatus
    amount: number
    accountId: string
    accountNumber: string
    recurringSettings: {
      __typename?: 'RecurringInvestmentSettings'
      amount: number
    }
  }>
  allPastItems: {
    __typename?: 'PastItemConnection'
    edges: Array<{
      __typename?: 'PastItemEdge'
      cursor: string
      node:
        | {
            __typename: 'CoreACHSubscriptionFeeItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'CoreAdjustmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'CoreCashForwardItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'CoreCollectionItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'CoreDebtCollectionItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'CoreDividendsItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'CoreEmployeeCreditItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'CoreFeeInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'CoreFoundMoneyRewardItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'CoreGiftCardCreditRedemptionItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'CoreHoldingsTransferInItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'CoreInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'CoreLocalFoundMoneyItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'CorePartnerRewardItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'CoreRebalanceItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'CoreReferralRewardItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'CoreRefundedItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'CoreReinvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'CoreRoundUpsItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'CoreWithdrawalItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'EarlyDebtCollectionItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'EarlyDividendsItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'EarlyFeeInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'EarlyGiftItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'EarlyInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'EarlyMatchItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'EarlyMatchRemovalItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'EarlyRefundedItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'EarlyReinvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'EarlyWithdrawalItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'LaterDebtCollectionItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'LaterDividendsItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'LaterFeeInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'LaterInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'LaterMatchItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'LaterMatchRemovalItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'LaterRebalanceItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'LaterRefundedItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'LaterReinvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'LaterWithdrawalItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastAcornsRewardInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastBeneficiaryTransferInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastCashOwedCollectionInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastCashReinvestmentInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastCoreItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastDividendInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastEmployeeContributionInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastExternalTransferInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastExternalTransferReversedInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastFeeInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastGiftCardInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastIRATransferInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastInvestmentTipItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastLumpSumInvestment'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastMatchInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastMatchRemovalInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastOutsideContributionInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastRealTimeRoundUpInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastRebalanceInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastRecurringInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastReferralRewardInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastReferralRewardMatchInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastRefundInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastReversalInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastRewardInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastRewardMatchInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastRoundUpItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastRoundUpMatchInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastSecurityLiquidationInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastSmartDepositInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastSpendItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastStreakRewardInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastTipsThatGrowMatchInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'PastWithdrawalInvestmentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'SaveInterestPaidItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'SaveTransferInItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'SaveTransferOutItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'SpendATMReimbursementItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'SpendATMWithdrawalItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'SpendBillPayItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'SpendCheckDepositItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'SpendCheckPaymentItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'SpendDigitalWalletItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'SpendDirectDepositItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'SpendECheckItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'SpendInterestPaidItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'SpendPurchaseItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'SpendRealTimeRoundUpItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'SpendTransferInItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
        | {
            __typename: 'SpendTransferOutItem'
            id: string
            reversible: boolean
            title: string
            status: PastItemStatus
            amount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
          }
    }>
  }
}

export type SpendInfoQueryQueryVariables = Exact<{ [key: string]: never }>

export type SpendInfoQueryQuery = {
  __typename?: 'Query'
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    id: string
    status: BankAccountStatus
    balance: { __typename?: 'CurrencyAmount'; value: number }
  }>
  recurringTransfers: Array<{
    __typename?: 'RecurringTransfer'
    id: string
    active: boolean
  }>
}

export type UserTierQueryVariables = Exact<{ [key: string]: never }>

export type UserTierQuery = {
  __typename?: 'Query'
  tierSubscriptionForUser:
    | {
        __typename: 'TierSubscription'
        id: string
        tier: { __typename?: 'Tier'; id: string; key: TierKey; name: string }
      }
    | { __typename: 'TierSubscriptionNotFound'; message: string }
    | {
        __typename: 'TierSubscriptionUnsubscribed'
        id: string
        createdAt: any
        updatedAt: any
      }
}

export type CloseAccountUserQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type CloseAccountUserQueryQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    uuid: string
    email: string
    firstName: string
    lastName: string
    phoneNumber: string
    fundingSource: {
      __typename?: 'FundingSource'
      name: string
      last4: string
      fundingType: string
      type: string
    }
  }
  linkedAccounts: Array<{
    __typename?: 'LinkedAccount'
    linkedSubaccounts: Array<{
      __typename?: 'LinkedSubaccount'
      accountNumberLastFour: string
      allowedRoles: Array<LinkedSubaccountRoleEnum>
      externalSource: string
      id: string
      name: string
      role: LinkedSubaccountRoleEnum
    }>
  }>
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    closedAt: any
    name: string
    type: string
    product: InvestmentProduct
    portfolios: Array<
      | { __typename?: 'Portfolio' }
      | {
          __typename: 'SelfDirectedPortfolio'
          status: SelfDirectedPortfolioStatus
          pendingBalance: { __typename?: 'MonetaryAmount'; value: number }
        }
    >
  }>
}

export type ReopenUserAccountMutationVariables = Exact<{ [key: string]: never }>

export type ReopenUserAccountMutation = {
  __typename?: 'Mutation'
  reopenUserAccount:
    | { __typename: 'UserNotFoundException' }
    | { __typename: 'UserReopenLockedException' }
    | { __typename: 'UserReopenSuspendedException' }
    | { __typename: 'User_v2' }
}

export type SubscribeToTierMutationVariables = Exact<{
  input: SubscribeToTierInput
}>

export type SubscribeToTierMutation = {
  __typename?: 'Mutation'
  subscribeToTier:
    | { __typename: 'InvalidTier' }
    | { __typename: 'InvalidTierPrice' }
    | { __typename: 'TierSubscription' }
}

export type ClosedAccountAgreeToAcceptanceDocumentMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type ClosedAccountAgreeToAcceptanceDocumentMutation = {
  __typename?: 'Mutation'
  agreeToAcceptanceDocument: any
}

export type AllAcceptanceDocumentsQueryVariables = Exact<{
  [key: string]: never
}>

export type AllAcceptanceDocumentsQuery = {
  __typename?: 'Query'
  allAcceptanceDocuments: Array<{
    __typename?: 'AcceptanceDocument'
    id: string
    version: string
    url: any
    type: string
    name: string
  }>
}

export type InvestAccountQueryVariables = Exact<{ [key: string]: never }>

export type InvestAccountQuery = {
  __typename?: 'Query'
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    product: InvestmentProduct
    type: string
    portfolio: {
      __typename?: 'Portfolio'
      id: string
      name: string
      riskLevel: PortfolioRiskLevel
      theme: PortfolioTheme
      accountAllocation: {
        __typename?: 'PortfolioAllocation'
        allocationPercent: number
      }
      portfolioSecurityAllocations: Array<{
        __typename?: 'PortfolioSecurityAllocation'
        id: string
        symbol: string
        allocationPercent: number
        security:
          | { __typename?: 'Fund'; displayName: string; symbol: any }
          | { __typename?: 'Stock'; displayName: string; symbol: any }
        investmentCategories: {
          __typename?: 'InvestmentCategory'
          bond: number
          crypto: number
          equity: number
        }
      }>
      projection: {
        __typename?: 'PortfolioProjection'
        lowestGrowthRate: number
        highestGrowthRate: number
        averageGrowthRate: number
      }
    }
  }>
}

export type RequestInvestmentAccountReopenMutationVariables = Exact<{
  accountId: Scalars['ID']
}>

export type RequestInvestmentAccountReopenMutation = {
  __typename?: 'Mutation'
  requestInvestmentAccountReopen:
    | { __typename: 'ExistingRequestPendingReview' }
    | { __typename: 'ExistingRequestPendingUserAction' }
    | { __typename: 'InvalidPortfolioIdException' }
    | { __typename: 'InvalidSubscriptionTierException' }
    | { __typename: 'InvestmentAccountNotClosedException' }
    | { __typename: 'InvestmentAccountNotFoundException' }
    | {
        __typename: 'InvestmentAccountReopenRequest'
        state: InvestmentAccountReopenRequestState
      }
}

export type ClosedAccountUserQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type ClosedAccountUserQueryQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    uuid: string
    email: string
    firstName: string
    lastName: string
    phoneNumber: string
    closedAt: any
  }
}

export type VerifyIdentityByDocumentsMutationVariables = Exact<{
  input: ValidateDocumentsInput
}>

export type VerifyIdentityByDocumentsMutation = {
  __typename?: 'Mutation'
  verifyIdentityByDocuments: {
    __typename: 'DocumentVerification'
    verificationCriteriaMet: boolean
  }
}

export type UnauthenticatedCreateUploadUrlMutationVariables = Exact<{
  token: Scalars['String']
  documentType: DocumentType
  fileName: Scalars['String']
}>

export type UnauthenticatedCreateUploadUrlMutation = {
  __typename?: 'Mutation'
  unauthenticatedCreateUploadUrl: {
    __typename: 'UploadUrl'
    key: string
    userId: string
    policy: string
    url: string
    uploadUuid: string
    xAmzAlgorithm: string
    xAmzCredential: string
    xAmzDate: string
    xAmzSecurityToken: string
    xAmzSignature: string
  }
}

export type UnauthenticatedSaveUploadMutationVariables = Exact<{
  uploadUuids: Array<Scalars['ID']> | Scalars['ID']
  token: Scalars['String']
  additionalInfo?: InputMaybe<Scalars['String']>
}>

export type UnauthenticatedSaveUploadMutation = {
  __typename?: 'Mutation'
  unauthenticatedSaveUploadUrl:
    | {
        __typename: 'DocumentUploads'
        uploadDocuments: Array<{
          __typename?: 'LegacyUploadDocument'
          id: string
          userId: string
        }>
      }
    | {
        __typename: 'UploadSaveError'
        uploadExceptions: Array<
          | {
              __typename?: 'FileDoesNotExistError'
              message: string
              userId: string
            }
          | {
              __typename?: 'UploadDoesNotExistError'
              message: string
              userId: string
              uploadUuid: string
            }
        >
      }
}

export type ValidateSuspendedUploadTokenMutationVariables = Exact<{
  uploadToken: Scalars['String']
}>

export type ValidateSuspendedUploadTokenMutation = {
  __typename?: 'Mutation'
  validateUserSuspendedUploadToken:
    | { __typename: 'UserSuspendedUploadTokenLengthError'; length: number }
    | {
        __typename: 'UserSuspendedUploadTokenValidation'
        reason: string
        tokenValid: boolean
      }
}

export type UserAlertsQueryVariables = Exact<{ [key: string]: never }>

export type UserAlertsQuery = {
  __typename?: 'Query'
  userAlerts: Array<
    | {
        __typename?: 'AddressDocumentRequestedUserAlert'
        requestedDocumentType: DocumentType
      }
    | {
        __typename?: 'BankDocumentRequestedUserAlert'
        requestedDocumentType: DocumentType
      }
    | {
        __typename?: 'IdentityDocumentRequestedUserAlert'
        requestedDocumentType: DocumentType
      }
    | { __typename?: 'InsufficientFundsUserAlert' }
    | { __typename?: 'InvestmentsPausedUserAlert' }
    | {
        __typename?: 'MiscDocumentRequestedUserAlert'
        requestedDocumentType: DocumentType
      }
    | { __typename?: 'NoFundingSourceUserAlert' }
    | { __typename?: 'RdvRequiredUserAlert' }
    | {
        __typename?: 'SSNDocumentRequestedUserAlert'
        requestedDocumentType: DocumentType
      }
    | {
        __typename?: 'UserAlert'
        description: string
        id: string
        key: string
        metadata: string
        title: string
        type: string
      }
    | {
        __typename?: 'W9DocumentRequestedUserAlert'
        requestedDocumentType: DocumentType
      }
  >
}

export type GenerateDocumentUploadSessionMutationVariables = Exact<{
  input: GenerateDocumentUploadSessionInput
}>

export type GenerateDocumentUploadSessionMutation = {
  __typename?: 'Mutation'
  generateDocumentUploadSession: {
    __typename?: 'DocumentUploadSession'
    token: string
  }
}

export type AllInvestmentAccountsQueryVariables = Exact<{
  [key: string]: never
}>

export type AllInvestmentAccountsQuery = {
  __typename?: 'Query'
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    type: string
    closedAt: any
    beneficiary: { __typename?: 'Beneficiary'; firstName: string }
  }>
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    id: string
    type: BankAccountType
    closedAt: any
    status: BankAccountStatus
  }>
}

export type AllReturnedCheckDepositsQueryVariables = Exact<{
  [key: string]: never
}>

export type AllReturnedCheckDepositsQuery = {
  __typename?: 'Query'
  allReturnedCheckDeposits: Array<{
    __typename?: 'ReturnedCheckDeposit'
    rejectedDate: any
    frontCheckImageUrl: string
    backCheckImageUrl: string
    amount: { __typename?: 'CurrencyAmount'; currency: Currency; value: number }
  }>
}

export type SpendStatementsQueryQueryVariables = Exact<{ [key: string]: never }>

export type SpendStatementsQueryQuery = {
  __typename?: 'Query'
  allBankStatements: Array<{
    __typename?: 'BankStatement'
    type: BankStatementType
    createdAt: any
    year: string
    month: string
    url: string
  }>
}

export type EarlyInvestOnboardingBenefitsQueryVariables = Exact<{
  [key: string]: never
}>

export type EarlyInvestOnboardingBenefitsQuery = {
  __typename?: 'Query'
  onboardingBenefits: Array<{
    __typename?: 'OnboardingTileGroup'
    products: Array<{
      __typename?: 'OnboardingProductTile'
      product: OnboardingProducts
      status: BenefitProductStatus
      claimDetails: {
        __typename?: 'OnboardingProductStatus'
        claimStatus: ClaimStatus
        details: Array<{
          __typename?: 'ClaimStatusDetails'
          statusCode: BenefitStatusDetail
        }>
      }
    }>
  }>
}

export type EarlyAgreeToAcceptanceDocumentMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type EarlyAgreeToAcceptanceDocumentMutation = {
  __typename?: 'Mutation'
  agreeToAcceptanceDocument: any
}

export type CreateEarlyBeneficiaryMutationVariables = Exact<{
  firstName: Scalars['String']
  lastName: Scalars['String']
  dateOfBirth: Scalars['String']
}>

export type CreateEarlyBeneficiaryMutation = {
  __typename?: 'Mutation'
  createBeneficiary:
    | { __typename: 'Beneficiary'; id: string }
    | { __typename: 'BeneficiaryExceedsAgeLimitException'; message: string }
    | { __typename: 'InternalErrorException'; message: string }
    | { __typename: 'InvalidDateOfBirthException'; message: string }
    | { __typename: 'InvalidFirstNameException'; message: string }
    | { __typename: 'InvalidLastNameException'; message: string }
}

export type DeactivateBeneficiaryMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type DeactivateBeneficiaryMutation = {
  __typename?: 'Mutation'
  deactivateBeneficiary:
    | { __typename: 'Beneficiary'; id: string }
    | { __typename: 'BeneficiaryNotFoundException'; message: string }
    | { __typename: 'InternalErrorException'; message: string }
}

export type OpenEarlyAccountMutationMutationVariables = Exact<{
  investmentAccountName: Scalars['String']
  beneficiaryId: Scalars['ID']
  terminationAge: Scalars['Int']
  stateCode?: InputMaybe<Scalars['String']>
}>

export type OpenEarlyAccountMutationMutation = {
  __typename?: 'Mutation'
  openEarlyAccount:
    | { __typename: 'BeneficiaryAccountExistsException' }
    | { __typename: 'CoreAccountClosedException'; message: string }
    | { __typename: 'InternalErrorException'; message: string }
    | { __typename: 'InvalidStateException' }
    | { __typename: 'InvalidSubscriptionTierException' }
    | { __typename: 'InvalidTerminationAgeException' }
    | {
        __typename: 'InvestmentAccount'
        id: string
        beneficiaryId: string
        investmentAccountType: InvestmentAccountType
      }
    | { __typename: 'MaxAccountsCreatedException' }
    | { __typename: 'MissingBeneficiarySsnException' }
    | { __typename: 'NoBeneficiaryFoundException' }
    | { __typename: 'UserClosedException' }
    | { __typename: 'UserNotFoundException'; message: string }
    | { __typename: 'UserNotVerifiedException'; message: string }
}

export type SetBeneficiarySsnMutationVariables = Exact<{
  id: Scalars['ID']
  ssn: Scalars['String']
}>

export type SetBeneficiarySsnMutation = {
  __typename?: 'Mutation'
  setBeneficiarySsn:
    | { __typename: 'Beneficiary'; id: string }
    | { __typename: 'BeneficiaryNotFoundException'; message: string }
    | { __typename: 'InternalErrorException'; message: string }
    | { __typename: 'InvalidSsnException'; message: string }
    | { __typename: 'SecretSquirrelException'; message: string }
    | { __typename: 'SsnAlreadyInUseException'; message: string }
    | { __typename: 'SsnMatchesCustodianException' }
    | { __typename: 'SsnUpdateForbiddenException'; message: string }
}

export type StopRecurringInvestmentMutationMutationVariables = Exact<{
  investment_account_id: Scalars['String']
}>

export type StopRecurringInvestmentMutationMutation = {
  __typename?: 'Mutation'
  stopRecurringInvestment: {
    __typename?: 'RecurringInvestmentPayload'
    recurringInvestmentSettings: {
      __typename?: 'RecurringInvestmentSettings'
      amount: number
      day: number
      frequency: InvestmentFrequency
    }
  }
}

export type EarlySubscribeUserToTierMutationVariables = Exact<{
  tierPriceId: Scalars['ID']
}>

export type EarlySubscribeUserToTierMutation = {
  __typename?: 'Mutation'
  subscribeUserToTier:
    | { __typename: 'InvalidTierPriceId' }
    | { __typename: 'TierDowngradeActionRequired' }
    | { __typename: 'TierSubscription'; id: string }
}

export type SuspendDepositsMutationVariables = Exact<{
  suspended: Scalars['Boolean']
}>

export type SuspendDepositsMutation = {
  __typename?: 'Mutation'
  suspendDeposits: any
}

export type UpdateRecurringInvestmentMutationMutationVariables = Exact<{
  amount: Scalars['Float']
  day: Scalars['Int']
  frequency: InvestmentFrequency
  investment_account_id: Scalars['String']
}>

export type UpdateRecurringInvestmentMutationMutation = {
  __typename?: 'Mutation'
  updateRecurringInvestment: {
    __typename?: 'RecurringInvestmentPayload'
    recurringInvestmentSettings: {
      __typename?: 'RecurringInvestmentSettings'
      amount: number
      day: number
      frequency: InvestmentFrequency
    }
  }
}

export type EarlyOneTimeFundingSourceInfoQueryVariables = Exact<{
  [key: string]: never
}>

export type EarlyOneTimeFundingSourceInfoQuery = {
  __typename?: 'Query'
  fundingSourceAccounts: Array<{
    __typename?: 'FundingSourceAccount'
    balance: number
    last4: string
    institutionName: string
    status: FundingSourceStatus
    verified: boolean
    role: FundingSourceRoleEnum
    id: number
    fundType: FundingSourceType
    accountName: string
  }>
  settings: { __typename?: 'Settings'; depositsSuspended: boolean }
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    availableBalance: { __typename?: 'CurrencyAmount'; value: number }
  }>
}

export type EarlyPotentialAgreeToAcceptanceDocumentMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type EarlyPotentialAgreeToAcceptanceDocumentMutation = {
  __typename?: 'Mutation'
  agreeToAcceptanceDocument: any
}

export type InvestmentAccountsByUserIdQueryVariables = Exact<{
  [key: string]: never
}>

export type InvestmentAccountsByUserIdQuery = {
  __typename?: 'Query'
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    beneficiaryId: string
    id: string
    beneficiary: { __typename?: 'Beneficiary'; age: number; firstName: string }
    currentBalance: { __typename?: 'MonetaryAmount'; value: number }
    pendingBalance: { __typename?: 'MonetaryAmount'; value: number }
    recurringInvestmentSettings: {
      __typename?: 'RecurringInvestmentSettings'
      frequency: InvestmentFrequency
      day: number
      amount: number
    }
    transferability: {
      __typename?: 'InvestmentAccountTransferability'
      transferAge: number
    }
  }>
  acceptanceDocuments: Array<{ __typename?: 'AcceptanceDocument'; id: string }>
}

export type OpenedAccountsQueryVariables = Exact<{ [key: string]: never }>

export type OpenedAccountsQuery = {
  __typename?: 'Query'
  accounts: Array<{ __typename?: 'Account'; accountType: AccountType }>
}

export type SplitDepositSettingsByUserIdQueryVariables = Exact<{
  withSmartDeposit?: InputMaybe<Scalars['Boolean']>
}>

export type SplitDepositSettingsByUserIdQuery = {
  __typename?: 'Query'
  splitDepositSettingsByUserId?: Array<
    | {
        __typename: 'SplitDepositDirectDepositIntentSetting'
        id: string
        isActive: boolean
        isHidden: boolean
        isUsingRecommendedAllocations: boolean
        name: string
        allocations: Array<{
          __typename?: 'SplitDepositDirectDepositAllocation'
          allocationPercent: string
          targetAccountId: string
          targetAccountType: SplitDepositTargetAccountType
          nickname: string
          normalizedAmount: {
            __typename?: 'FormattedMonetaryAmount'
            value: string
          }
        }>
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          expectedNextDepositAmount: string
          expectedNextDepositAt: string
          id: string
          isActive: boolean
          isCancelable: boolean
          isUsingRecommendedAllocations: boolean
          transactionAmount: string
          willDistributeAutomaticallyAt: string
          allocations: Array<
            | {
                __typename?: 'SplitDepositDirectDepositAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                nickname: string
                normalizedAmount: {
                  __typename?: 'FormattedMonetaryAmount'
                  value: string
                }
              }
            | { __typename?: 'SplitDepositRecurrenceAllocation' }
          >
        }>
        estimatedPaycheckAmount: {
          __typename?: 'CurrencyAmount'
          value: number
        }
      }
    | {
        __typename: 'SplitDepositDirectDepositSetting'
        id: string
        isActive: boolean
        isHidden: boolean
        isUsingRecommendedAllocations: boolean
        awaitingConfiguration: boolean
        name: string
        allocations: Array<{
          __typename?: 'SplitDepositDirectDepositAllocation'
          allocationPercent: string
          targetAccountId: string
          targetAccountType: SplitDepositTargetAccountType
          nickname: string
          normalizedAmount: {
            __typename?: 'FormattedMonetaryAmount'
            value: string
          }
        }>
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          expectedNextDepositAmount: string
          expectedNextDepositAt: string
          id: string
          isActive: boolean
          isCancelable: boolean
          isUsingRecommendedAllocations: boolean
          transactionAmount: string
          willDistributeAutomaticallyAt: string
          allocations: Array<
            | {
                __typename?: 'SplitDepositDirectDepositAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                nickname: string
                normalizedAmount: {
                  __typename?: 'FormattedMonetaryAmount'
                  value: string
                }
              }
            | { __typename?: 'SplitDepositRecurrenceAllocation' }
          >
        }>
      }
    | {
        __typename: 'SplitDepositRecurrenceSetting'
        id: string
        isActive: boolean
        isHidden: boolean
        allocations: Array<{ __typename?: 'SplitDepositRecurrenceAllocation' }>
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          expectedNextDepositAmount: string
          expectedNextDepositAt: string
          id: string
          isActive: boolean
          isCancelable: boolean
          isUsingRecommendedAllocations: boolean
          transactionAmount: string
          willDistributeAutomaticallyAt: string
          allocations: Array<
            | {
                __typename?: 'SplitDepositDirectDepositAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                nickname: string
                normalizedAmount: {
                  __typename?: 'FormattedMonetaryAmount'
                  value: string
                }
              }
            | { __typename?: 'SplitDepositRecurrenceAllocation' }
          >
        }>
      }
  >
}

export type EnableQuarterlyRecapsMutationVariables = Exact<{
  investmentAccountId: Scalars['ID']
  enabled: Scalars['Boolean']
}>

export type EnableQuarterlyRecapsMutation = {
  __typename?: 'Mutation'
  enableQuarterlyRecaps:
    | {
        __typename: 'InvalidSubscriptionTierException'
        currentUserTierKey: string
      }
    | {
        __typename: 'InvestmentAccount'
        id: string
        beneficiaryId: string
        investmentAccountType: InvestmentAccountType
      }
    | { __typename: 'InvestmentAccountNotFoundException'; message: string }
    | { __typename: 'InvestmentAccountNotSupportedException'; message: string }
}

export type UpdateBeneficiaryInfoMutationVariables = Exact<{
  id: Scalars['ID']
  input: BeneficiaryInfoInput
}>

export type UpdateBeneficiaryInfoMutation = {
  __typename?: 'Mutation'
  updateBeneficiaryInfo:
    | {
        __typename: 'Beneficiary'
        custodianNickname: string
        investmentAccount: {
          __typename?: 'InvestmentAccount'
          id: string
          beneficiaryId: string
          investmentAccountType: InvestmentAccountType
        }
      }
    | { __typename: 'BeneficiaryNotFoundException'; message: string }
    | { __typename: 'InternalErrorException'; message: string }
    | { __typename: 'InvalidAddressException'; message: string }
    | { __typename: 'InvalidEmailException'; message: string }
    | { __typename: 'InvalidPhoneException'; message: string }
}

export type RegenerateInvestmentAccountRecapPublicTokenMutationVariables =
  Exact<{
    id: Scalars['ID']
  }>

export type RegenerateInvestmentAccountRecapPublicTokenMutation = {
  __typename?: 'Mutation'
  regenerateInvestmentAccountRecapPublicToken:
    | {
        __typename: 'InvestmentAccountRecap'
        id: string
        public: boolean
        publicUrl: any
      }
    | { __typename: 'InvestmentAccountRecapNotFoundException'; message: string }
}

export type SetInvestmentAccountRecapPublicAccessMutationVariables = Exact<{
  id: Scalars['ID']
  public: Scalars['Boolean']
}>

export type SetInvestmentAccountRecapPublicAccessMutation = {
  __typename?: 'Mutation'
  setInvestmentAccountRecapPublicAccess:
    | {
        __typename: 'InvestmentAccountRecap'
        id: string
        public: boolean
        publicUrl: any
      }
    | { __typename: 'InvestmentAccountRecapNotFoundException'; message: string }
}

export type SubscribeUserToTierMutationVariables = Exact<{
  tierPriceId: Scalars['ID']
}>

export type SubscribeUserToTierMutation = {
  __typename?: 'Mutation'
  subscribeUserToTier:
    | { __typename?: 'InvalidTierPriceId'; message: string }
    | {
        __typename?: 'TierDowngradeActionRequired'
        actions: Array<{
          __typename?: 'TierDowngradeAction'
          key: TierDowngradeActionKey
        }>
      }
    | {
        __typename?: 'TierSubscription'
        tier: {
          __typename?: 'Tier'
          name: string
          tierPrice: { __typename?: 'TierPrice'; id: string }
        }
      }
}

export type AllPastEarlyTransactionsQueryVariables = Exact<{
  filter?: InputMaybe<AllPastItemsFilter>
  pagination: PageInput
}>

export type AllPastEarlyTransactionsQuery = {
  __typename?: 'Query'
  allPastItems: {
    __typename?: 'PastItemConnection'
    edges: Array<{
      __typename?: 'PastItemEdge'
      cursor: string
      node:
        | {
            __typename: 'CoreACHSubscriptionFeeItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreAdjustmentItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreCashForwardItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreCollectionItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreDebtCollectionItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreDividendsItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreEmployeeCreditItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreFeeInvestmentItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreFoundMoneyRewardItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreGiftCardCreditRedemptionItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreHoldingsTransferInItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreInvestmentItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreLocalFoundMoneyItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CorePartnerRewardItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreRebalanceItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreReferralRewardItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreRefundedItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreReinvestmentItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreRoundUpsItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreWithdrawalItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyDebtCollectionItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyDividendsItem'
            tradeConfirmationUrl: any
            etfCategory: string
            etfTicker: string
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyFeeInvestmentItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyGiftItem'
            tradeConfirmationUrl: any
            note: string
            noteAuthor: string
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyInvestmentItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyMatchItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyMatchRemovalItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyRefundedItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyReinvestmentItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyWithdrawalItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterDebtCollectionItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterDividendsItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterFeeInvestmentItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterInvestmentItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterMatchItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterMatchRemovalItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterRebalanceItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterRefundedItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterReinvestmentItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterWithdrawalItem'
            tradeConfirmationUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastAcornsRewardInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastBeneficiaryTransferInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastCashOwedCollectionInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastCashReinvestmentInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastCoreItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastDividendInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastEmployeeContributionInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastExternalTransferInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastExternalTransferReversedInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastFeeInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastGiftCardInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastIRATransferInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastInvestmentTipItem'
            note: string
            noteAuthor: string
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastLumpSumInvestment'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastMatchInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastMatchRemovalInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastOutsideContributionInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRealTimeRoundUpInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRebalanceInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRecurringInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastReferralRewardInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastReferralRewardMatchInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRefundInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastReversalInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRewardInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRewardMatchInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRoundUpItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRoundUpMatchInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastSecurityLiquidationInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastSmartDepositInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastSpendItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastStreakRewardInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastTipsThatGrowMatchInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastWithdrawalInvestmentItem'
            productAccountType: ProductAccountType
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SaveInterestPaidItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SaveTransferInItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SaveTransferOutItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendATMReimbursementItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendATMWithdrawalItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendBillPayItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendCheckDepositItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendCheckPaymentItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendDigitalWalletItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendDirectDepositItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendECheckItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendInterestPaidItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendPurchaseItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendRealTimeRoundUpItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendTransferInItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendTransferOutItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            updatedAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      hasPreviousPage: boolean
      hasNextPage: boolean
      limit: number
    }
  }
}

export type EarlyPastSummaryQueryVariables = Exact<{
  filter: PastSummaryFilter
}>

export type EarlyPastSummaryQuery = {
  __typename?: 'Query'
  pastSummary:
    | { __typename?: 'AllAccountHistorySummary' }
    | { __typename?: 'CheckingHistorySummary' }
    | {
        __typename?: 'EarlyHistorySummary'
        moneyIn: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        moneyOut: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        dividends: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        giftsReceived: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        earlyInvestMatches: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | { __typename?: 'EmergencyFundHistorySummary' }
    | { __typename?: 'InvestHistorySummary' }
    | { __typename?: 'LaterHistorySummary' }
}

export type AcceptanceDocumentQueryVariables = Exact<{
  type: Scalars['String']
}>

export type AcceptanceDocumentQuery = {
  __typename?: 'Query'
  acceptanceDocument: {
    __typename?: 'AcceptanceDocument'
    id: string
    name: string
    url: any
    type: string
  }
}

export type EarlyBeneficiariesQueryVariables = Exact<{ [key: string]: never }>

export type EarlyBeneficiariesQuery = {
  __typename?: 'Query'
  beneficiaries: Array<{
    __typename?: 'Beneficiary'
    avatarUrl: string
    createdAt: any
    custodianId: string
    age: number
    eligibleForContributionTooltip: boolean
    firstName: string
    id: string
    lastName: string
    ssnPresent: boolean
    updatedAt: any
    custodianNickname: string
    investmentAccount: {
      __typename?: 'InvestmentAccount'
      id: string
      name: string
      type: string
      investmentAccountType: InvestmentAccountType
      status: InvestmentAccountStatus
      quarterlyRecapsEnabled: boolean
      createdAt: any
      closedAt: any
      updatedAt: any
      currentBalance: {
        __typename?: 'MonetaryAmount'
        currency: Currency
        value: number
      }
      pendingBalance: {
        __typename?: 'MonetaryAmount'
        currency: Currency
        value: number
      }
      transferability: {
        __typename?: 'InvestmentAccountTransferability'
        transferAge: number
        transferDate: any
        transferStateCode: UsStateCodes
        transferReached: boolean
      }
      recurringInvestmentSettings: {
        __typename?: 'RecurringInvestmentSettings'
        amount: number
        frequency: InvestmentFrequency
        day: number
        createdAt: any
        updatedAt: any
      }
      portfolio: {
        __typename?: 'Portfolio'
        id: string
        name: string
        description: string
        riskLevel: PortfolioRiskLevel
        theme: PortfolioTheme
        accountAllocation: {
          __typename?: 'PortfolioAllocation'
          allocationPercent: number
        }
        portfolioSecurityAllocations: Array<{
          __typename?: 'PortfolioSecurityAllocation'
          id: string
          symbol: string
          allocationPercent: number
          security:
            | { __typename?: 'Fund'; displayName: string }
            | { __typename?: 'Stock'; displayName: string }
          investmentCategories: {
            __typename?: 'InvestmentCategory'
            bond: number
            crypto: number
            equity: number
          }
        }>
      }
      portfolios: Array<
        | {
            __typename: 'Portfolio'
            id: string
            name: string
            description: string
            currentAllocationPercentage: number
            currentBalance: { __typename?: 'MonetaryAmount'; value: number }
            accountAllocation: {
              __typename?: 'PortfolioAllocation'
              allocationPercent: number
            }
            yearToDateReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
            }
            portfolioSecurities: Array<{
              __typename: 'PortfolioSecurity'
              name: string
              currentAllocationPercentage: number
              shares: number
              symbol: string
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
              todaysReturn: {
                __typename?: 'MarketReturn'
                percent: number
                marketValue: { __typename?: 'MonetaryAmount'; value: number }
              }
              totalReturn: {
                __typename?: 'MarketReturn'
                percent: number
                marketValue: { __typename?: 'MonetaryAmount'; value: number }
              }
            }>
            portfolioSecurityAllocations: Array<{
              __typename?: 'PortfolioSecurityAllocation'
              id: string
              allocationPercent: number
              symbol: string
              security:
                | {
                    __typename?: 'Fund'
                    displayName: string
                    profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                  }
                | {
                    __typename?: 'Stock'
                    displayName: string
                    profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                  }
              investmentCategories: {
                __typename?: 'InvestmentCategory'
                bond: number
                crypto: number
                equity: number
                realEstate: number
              }
            }>
          }
        | {
            __typename: 'SelfDirectedPortfolio'
            status: SelfDirectedPortfolioStatus
            id: string
            name: string
            description: string
            currentAllocationPercentage: number
            currentBalance: { __typename?: 'MonetaryAmount'; value: number }
            accountAllocation: {
              __typename?: 'PortfolioAllocation'
              allocationPercent: number
            }
            yearToDateReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
            }
            portfolioSecurities: Array<{
              __typename: 'PortfolioSecurity'
              name: string
              currentAllocationPercentage: number
              shares: number
              symbol: string
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
              todaysReturn: {
                __typename?: 'MarketReturn'
                percent: number
                marketValue: { __typename?: 'MonetaryAmount'; value: number }
              }
              totalReturn: {
                __typename?: 'MarketReturn'
                percent: number
                marketValue: { __typename?: 'MonetaryAmount'; value: number }
              }
            }>
            portfolioSecurityAllocations: Array<{
              __typename?: 'PortfolioSecurityAllocation'
              id: string
              allocationPercent: number
              symbol: string
              security:
                | {
                    __typename?: 'Fund'
                    displayName: string
                    profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                  }
                | {
                    __typename?: 'Stock'
                    displayName: string
                    profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                  }
              investmentCategories: {
                __typename?: 'InvestmentCategory'
                bond: number
                crypto: number
                equity: number
                realEstate: number
              }
            }>
          }
      >
      quarterlyRecap: {
        __typename?: 'InvestmentAccountRecap'
        id: string
        public: boolean
        publicUrl: any
      }
      yearToDateReturn: {
        __typename?: 'MarketReturn'
        percent: number
        marketValue: {
          __typename?: 'MonetaryAmount'
          currency: Currency
          value: number
        }
      }
      returnsAllTime: { __typename?: 'MonetaryAmount'; value: number }
      netInvestments: { __typename?: 'MonetaryAmount'; value: number }
      totalAccountValue: { __typename?: 'MonetaryAmount'; value: number }
    }
  }>
}

export type EarlyBeneficiaryFieldsFragment = {
  __typename?: 'Beneficiary'
  avatarUrl: string
  createdAt: any
  custodianId: string
  age: number
  eligibleForContributionTooltip: boolean
  firstName: string
  id: string
  lastName: string
  ssnPresent: boolean
  updatedAt: any
  custodianNickname: string
  investmentAccount: {
    __typename?: 'InvestmentAccount'
    id: string
    name: string
    type: string
    investmentAccountType: InvestmentAccountType
    status: InvestmentAccountStatus
    quarterlyRecapsEnabled: boolean
    createdAt: any
    closedAt: any
    updatedAt: any
    currentBalance: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
    pendingBalance: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
    transferability: {
      __typename?: 'InvestmentAccountTransferability'
      transferAge: number
      transferDate: any
      transferStateCode: UsStateCodes
      transferReached: boolean
    }
    recurringInvestmentSettings: {
      __typename?: 'RecurringInvestmentSettings'
      amount: number
      frequency: InvestmentFrequency
      day: number
      createdAt: any
      updatedAt: any
    }
    portfolio: {
      __typename?: 'Portfolio'
      id: string
      name: string
      description: string
      riskLevel: PortfolioRiskLevel
      theme: PortfolioTheme
      accountAllocation: {
        __typename?: 'PortfolioAllocation'
        allocationPercent: number
      }
      portfolioSecurityAllocations: Array<{
        __typename?: 'PortfolioSecurityAllocation'
        id: string
        symbol: string
        allocationPercent: number
        security:
          | { __typename?: 'Fund'; displayName: string }
          | { __typename?: 'Stock'; displayName: string }
        investmentCategories: {
          __typename?: 'InvestmentCategory'
          bond: number
          crypto: number
          equity: number
        }
      }>
    }
    portfolios: Array<
      | {
          __typename: 'Portfolio'
          id: string
          name: string
          description: string
          currentAllocationPercentage: number
          currentBalance: { __typename?: 'MonetaryAmount'; value: number }
          accountAllocation: {
            __typename?: 'PortfolioAllocation'
            allocationPercent: number
          }
          yearToDateReturn: {
            __typename?: 'MarketReturn'
            percent: number
            marketValue: { __typename?: 'MonetaryAmount'; value: number }
          }
          portfolioSecurities: Array<{
            __typename: 'PortfolioSecurity'
            name: string
            currentAllocationPercentage: number
            shares: number
            symbol: string
            marketValue: { __typename?: 'MonetaryAmount'; value: number }
            todaysReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
            }
            totalReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
            }
          }>
          portfolioSecurityAllocations: Array<{
            __typename?: 'PortfolioSecurityAllocation'
            id: string
            allocationPercent: number
            symbol: string
            security:
              | {
                  __typename?: 'Fund'
                  displayName: string
                  profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                }
              | {
                  __typename?: 'Stock'
                  displayName: string
                  profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                }
            investmentCategories: {
              __typename?: 'InvestmentCategory'
              bond: number
              crypto: number
              equity: number
              realEstate: number
            }
          }>
        }
      | {
          __typename: 'SelfDirectedPortfolio'
          status: SelfDirectedPortfolioStatus
          id: string
          name: string
          description: string
          currentAllocationPercentage: number
          currentBalance: { __typename?: 'MonetaryAmount'; value: number }
          accountAllocation: {
            __typename?: 'PortfolioAllocation'
            allocationPercent: number
          }
          yearToDateReturn: {
            __typename?: 'MarketReturn'
            percent: number
            marketValue: { __typename?: 'MonetaryAmount'; value: number }
          }
          portfolioSecurities: Array<{
            __typename: 'PortfolioSecurity'
            name: string
            currentAllocationPercentage: number
            shares: number
            symbol: string
            marketValue: { __typename?: 'MonetaryAmount'; value: number }
            todaysReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
            }
            totalReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
            }
          }>
          portfolioSecurityAllocations: Array<{
            __typename?: 'PortfolioSecurityAllocation'
            id: string
            allocationPercent: number
            symbol: string
            security:
              | {
                  __typename?: 'Fund'
                  displayName: string
                  profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                }
              | {
                  __typename?: 'Stock'
                  displayName: string
                  profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                }
            investmentCategories: {
              __typename?: 'InvestmentCategory'
              bond: number
              crypto: number
              equity: number
              realEstate: number
            }
          }>
        }
    >
    quarterlyRecap: {
      __typename?: 'InvestmentAccountRecap'
      id: string
      public: boolean
      publicUrl: any
    }
    yearToDateReturn: {
      __typename?: 'MarketReturn'
      percent: number
      marketValue: {
        __typename?: 'MonetaryAmount'
        currency: Currency
        value: number
      }
    }
    returnsAllTime: { __typename?: 'MonetaryAmount'; value: number }
    netInvestments: { __typename?: 'MonetaryAmount'; value: number }
    totalAccountValue: { __typename?: 'MonetaryAmount'; value: number }
  }
}

export type EarlyInvestmentAccountFieldsFragment = {
  __typename?: 'InvestmentAccount'
  id: string
  name: string
  type: string
  investmentAccountType: InvestmentAccountType
  status: InvestmentAccountStatus
  quarterlyRecapsEnabled: boolean
  createdAt: any
  closedAt: any
  updatedAt: any
  currentBalance: {
    __typename?: 'MonetaryAmount'
    currency: Currency
    value: number
  }
  pendingBalance: {
    __typename?: 'MonetaryAmount'
    currency: Currency
    value: number
  }
  transferability: {
    __typename?: 'InvestmentAccountTransferability'
    transferAge: number
    transferDate: any
    transferStateCode: UsStateCodes
    transferReached: boolean
  }
  recurringInvestmentSettings: {
    __typename?: 'RecurringInvestmentSettings'
    amount: number
    frequency: InvestmentFrequency
    day: number
    createdAt: any
    updatedAt: any
  }
  portfolio: {
    __typename?: 'Portfolio'
    id: string
    name: string
    description: string
    riskLevel: PortfolioRiskLevel
    theme: PortfolioTheme
    accountAllocation: {
      __typename?: 'PortfolioAllocation'
      allocationPercent: number
    }
    portfolioSecurityAllocations: Array<{
      __typename?: 'PortfolioSecurityAllocation'
      id: string
      symbol: string
      allocationPercent: number
      security:
        | { __typename?: 'Fund'; displayName: string }
        | { __typename?: 'Stock'; displayName: string }
      investmentCategories: {
        __typename?: 'InvestmentCategory'
        bond: number
        crypto: number
        equity: number
      }
    }>
  }
  portfolios: Array<
    | {
        __typename: 'Portfolio'
        id: string
        name: string
        description: string
        currentAllocationPercentage: number
        currentBalance: { __typename?: 'MonetaryAmount'; value: number }
        accountAllocation: {
          __typename?: 'PortfolioAllocation'
          allocationPercent: number
        }
        yearToDateReturn: {
          __typename?: 'MarketReturn'
          percent: number
          marketValue: { __typename?: 'MonetaryAmount'; value: number }
        }
        portfolioSecurities: Array<{
          __typename: 'PortfolioSecurity'
          name: string
          currentAllocationPercentage: number
          shares: number
          symbol: string
          marketValue: { __typename?: 'MonetaryAmount'; value: number }
          todaysReturn: {
            __typename?: 'MarketReturn'
            percent: number
            marketValue: { __typename?: 'MonetaryAmount'; value: number }
          }
          totalReturn: {
            __typename?: 'MarketReturn'
            percent: number
            marketValue: { __typename?: 'MonetaryAmount'; value: number }
          }
        }>
        portfolioSecurityAllocations: Array<{
          __typename?: 'PortfolioSecurityAllocation'
          id: string
          allocationPercent: number
          symbol: string
          security:
            | {
                __typename?: 'Fund'
                displayName: string
                profile: { __typename?: 'SecurityProfile'; logoUrl: any }
              }
            | {
                __typename?: 'Stock'
                displayName: string
                profile: { __typename?: 'SecurityProfile'; logoUrl: any }
              }
          investmentCategories: {
            __typename?: 'InvestmentCategory'
            bond: number
            crypto: number
            equity: number
            realEstate: number
          }
        }>
      }
    | {
        __typename: 'SelfDirectedPortfolio'
        status: SelfDirectedPortfolioStatus
        id: string
        name: string
        description: string
        currentAllocationPercentage: number
        currentBalance: { __typename?: 'MonetaryAmount'; value: number }
        accountAllocation: {
          __typename?: 'PortfolioAllocation'
          allocationPercent: number
        }
        yearToDateReturn: {
          __typename?: 'MarketReturn'
          percent: number
          marketValue: { __typename?: 'MonetaryAmount'; value: number }
        }
        portfolioSecurities: Array<{
          __typename: 'PortfolioSecurity'
          name: string
          currentAllocationPercentage: number
          shares: number
          symbol: string
          marketValue: { __typename?: 'MonetaryAmount'; value: number }
          todaysReturn: {
            __typename?: 'MarketReturn'
            percent: number
            marketValue: { __typename?: 'MonetaryAmount'; value: number }
          }
          totalReturn: {
            __typename?: 'MarketReturn'
            percent: number
            marketValue: { __typename?: 'MonetaryAmount'; value: number }
          }
        }>
        portfolioSecurityAllocations: Array<{
          __typename?: 'PortfolioSecurityAllocation'
          id: string
          allocationPercent: number
          symbol: string
          security:
            | {
                __typename?: 'Fund'
                displayName: string
                profile: { __typename?: 'SecurityProfile'; logoUrl: any }
              }
            | {
                __typename?: 'Stock'
                displayName: string
                profile: { __typename?: 'SecurityProfile'; logoUrl: any }
              }
          investmentCategories: {
            __typename?: 'InvestmentCategory'
            bond: number
            crypto: number
            equity: number
            realEstate: number
          }
        }>
      }
  >
  quarterlyRecap: {
    __typename?: 'InvestmentAccountRecap'
    id: string
    public: boolean
    publicUrl: any
  }
  yearToDateReturn: {
    __typename?: 'MarketReturn'
    percent: number
    marketValue: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
  }
  returnsAllTime: { __typename?: 'MonetaryAmount'; value: number }
  netInvestments: { __typename?: 'MonetaryAmount'; value: number }
  totalAccountValue: { __typename?: 'MonetaryAmount'; value: number }
}

export type AvailableTiersQueryVariables = Exact<{ [key: string]: never }>

export type AvailableTiersQuery = {
  __typename?: 'Query'
  tierGroupForUser: {
    __typename?: 'TierGroup'
    id: string
    tierOptions: Array<{
      __typename?: 'TierOption'
      tier: {
        __typename?: 'Tier'
        id: string
        active: boolean
        key: TierKey
        name: string
        products: Array<{
          __typename?: 'Product'
          key: ProductKey
          name: string
        }>
        tierPrice: {
          __typename?: 'TierPrice'
          billingFrequency: BillingFrequency
          id: string
          amount: {
            __typename?: 'CurrencyAmount'
            currency: Currency
            value: number
          }
        }
      }
    }>
  }
}

export type RequestedBeneficiarydDocumentsQueryVariables = Exact<{
  [key: string]: never
}>

export type RequestedBeneficiarydDocumentsQuery = {
  __typename?: 'Query'
  documentRequests: {
    __typename?: 'DocumentRequestsConnection'
    edges: Array<{
      __typename?: 'DocumentRequestEdge'
      node: { __typename?: 'DocumentRequest'; id: string; externalId: string }
    }>
  }
}

export type EarlyAccountStateRegulationQueryVariables = Exact<{
  stateCode?: InputMaybe<Scalars['String']>
}>

export type EarlyAccountStateRegulationQuery = {
  __typename?: 'Query'
  earlyAccountStateRegulation:
    | {
        __typename: 'EarlyAccountStateRegulation'
        state: string
        stateCode: string
        defaultAge: number
        minAge: number
        maxAge: number
        accountType: EarlyInvestmentAccountType
      }
    | { __typename: 'InternalErrorException'; message: string }
    | { __typename: 'InvalidStateException'; message: string }
    | { __typename: 'UserNotFoundException'; message: string }
}

export type EarlyAccountTransferInfoQueryVariables = Exact<{
  investmentAccountId: Scalars['ID']
}>

export type EarlyAccountTransferInfoQuery = {
  __typename?: 'Query'
  earlyAccountTransferInfo: {
    __typename?: 'EarlyAccountTransferInfo'
    terminationAge: number
    terminationDate: any
  }
}

export type EarlyInvestmentAccountsQueryVariables = Exact<{
  [key: string]: never
}>

export type EarlyInvestmentAccountsQuery = {
  __typename?: 'Query'
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    type: string
    name: string
    beneficiaryId: string
    status: InvestmentAccountStatus
    beneficiary: {
      __typename?: 'Beneficiary'
      id: string
      firstName: string
      lastName: string
    }
    currentBalance: { __typename?: 'MonetaryAmount'; value: number }
    transferability: {
      __typename?: 'InvestmentAccountTransferability'
      transferStateCode: UsStateCodes
    }
  }>
}

export type EarlyFundingSourceInfoQueryVariables = Exact<{
  [key: string]: never
}>

export type EarlyFundingSourceInfoQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    fundingSource: { __typename?: 'FundingSource'; verified: boolean }
  }
  fundingSourceInfo: {
    __typename?: 'FundingSourceInfo'
    balance: number
    accountNumberLastFour: string
    name: string
    verified: boolean
  }
  linkedAccounts: Array<{
    __typename?: 'LinkedAccount'
    institutionName: string
  }>
  settings: { __typename?: 'Settings'; depositsSuspended: boolean }
}

export type OutsideContributionCodeByInvestmentAccountIdQueryVariables = Exact<{
  investmentAccountId: Scalars['ID']
}>

export type OutsideContributionCodeByInvestmentAccountIdQuery = {
  __typename?: 'Query'
  outsideContributionCodeByInvestmentAccountId: {
    __typename?: 'OutsideContributionCode'
    code: string
    url: string
  }
}

export type PortfoliosQueryQueryVariables = Exact<{ [key: string]: never }>

export type PortfoliosQueryQuery = {
  __typename?: 'Query'
  portfolios: Array<{
    __typename?: 'Portfolio'
    id: string
    name: string
    nameKey: string
    description: string
    portfolioSecurityAllocations: Array<{
      __typename?: 'PortfolioSecurityAllocation'
      id: string
      symbol: string
      allocationPercent: number
      security:
        | { __typename?: 'Fund'; displayName: string }
        | { __typename?: 'Stock'; displayName: string }
      investmentCategories: {
        __typename?: 'InvestmentCategory'
        bond: number
        crypto: number
        equity: number
      }
    }>
  }>
}

export type RecurringSettingsQueryVariables = Exact<{ [key: string]: never }>

export type RecurringSettingsQuery = {
  __typename?: 'Query'
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    beneficiaryId: string
    closedAt: any
    recurringInvestmentSettings: {
      __typename?: 'RecurringInvestmentSettings'
      amount: number
      frequency: InvestmentFrequency
      day: number
    }
  }>
}

export type TierOptionByProductKeyQueryVariables = Exact<{
  [key: string]: never
}>

export type TierOptionByProductKeyQuery = {
  __typename?: 'Query'
  tierOptionByProductKey: {
    __typename?: 'TierOption'
    tier: {
      __typename?: 'Tier'
      id: string
      key: TierKey
      includedProducts: Array<{ __typename?: 'TierProduct'; key: ProductKey }>
    }
    tierPrices: Array<{
      __typename?: 'TierPrice'
      id: string
      billingFrequency: BillingFrequency
      amount: {
        __typename?: 'CurrencyAmount'
        value: number
        currency: Currency
      }
    }>
  }
}

export type TierForEarlyFragment = {
  __typename?: 'Tier'
  id: string
  name: string
  key: TierKey
  products: Array<{
    __typename?: 'Product'
    active: boolean
    key: ProductKey
    name: string
  }>
}

export type EarlyTierSubscriptionForUserQueryVariables = Exact<{
  [key: string]: never
}>

export type EarlyTierSubscriptionForUserQuery = {
  __typename?: 'Query'
  tierSubscriptionForUser:
    | {
        __typename?: 'TierSubscription'
        id: string
        tier: {
          __typename?: 'Tier'
          id: string
          name: string
          key: TierKey
          products: Array<{
            __typename?: 'Product'
            active: boolean
            key: ProductKey
            name: string
          }>
        }
        tierPrice: {
          __typename?: 'TierPrice'
          id: string
          billingFrequency: BillingFrequency
          amount: {
            __typename?: 'CurrencyAmount'
            value: number
            currency: Currency
          }
        }
      }
    | { __typename?: 'TierSubscriptionNotFound' }
    | { __typename?: 'TierSubscriptionUnsubscribed' }
}

export type UnverifiedSsnBeneficiariesAlertsQueryVariables = Exact<{
  [key: string]: never
}>

export type UnverifiedSsnBeneficiariesAlertsQuery = {
  __typename?: 'Query'
  beneficiaryAlerts: Array<
    | { __typename?: 'MissingSsnBeneficiaryAlert' }
    | {
        __typename?: 'UnverifiedBeneficiarySsnAlert'
        beneficiary: {
          __typename?: 'Beneficiary'
          id: string
          custodianId: string
          firstName: string
        }
      }
  >
}

export type EarlyUserQueryVariables = Exact<{ [key: string]: never }>

export type EarlyUserQuery = {
  __typename?: 'Query'
  user: { __typename?: 'User'; state: any; verified: boolean }
  userAlerts: Array<
    | { __typename?: 'AddressDocumentRequestedUserAlert' }
    | { __typename?: 'BankDocumentRequestedUserAlert' }
    | { __typename?: 'IdentityDocumentRequestedUserAlert' }
    | { __typename?: 'InsufficientFundsUserAlert' }
    | { __typename?: 'InvestmentsPausedUserAlert' }
    | { __typename?: 'MiscDocumentRequestedUserAlert' }
    | { __typename?: 'NoFundingSourceUserAlert' }
    | { __typename?: 'RdvRequiredUserAlert' }
    | { __typename?: 'SSNDocumentRequestedUserAlert' }
    | { __typename?: 'UserAlert'; type: string }
    | { __typename?: 'W9DocumentRequestedUserAlert' }
  >
  tierSubscriptionForUser:
    | {
        __typename?: 'TierSubscription'
        id: string
        tier: {
          __typename?: 'Tier'
          id: string
          key: TierKey
          name: string
          includedProducts: Array<{
            __typename?: 'TierProduct'
            key: ProductKey
          }>
        }
      }
    | { __typename?: 'TierSubscriptionNotFound' }
    | { __typename?: 'TierSubscriptionUnsubscribed' }
}

export type EarlyReferralDetailsQueryVariables = Exact<{ [key: string]: never }>

export type EarlyReferralDetailsQuery = {
  __typename?: 'Query'
  acceptanceDocuments: Array<{
    __typename?: 'AcceptanceDocument'
    name: string
    type: string
    summaryUrl: any
    id: string
    url: any
  }>
  user: {
    __typename?: 'User'
    uuid: string
    email: string
    firstName: string
    lastName: string
  }
}

export type SsnFileUploadMutationVariables = Exact<{
  file: Scalars['Upload']
  documentRequestId: Scalars['ID']
}>

export type SsnFileUploadMutation = {
  __typename?: 'Mutation'
  uploadDocuments: Array<
    | {
        __typename?: 'File'
        encoding: string
        filename: string
        mimetype: string
        url: any
      }
    | { __typename?: 'FileSizeError' }
    | { __typename?: 'UploadFailedError' }
  >
}

export type EarlyWithdrawFundingSourceInfoQueryVariables = Exact<{
  [key: string]: never
}>

export type EarlyWithdrawFundingSourceInfoQuery = {
  __typename?: 'Query'
  fundingSourceAccounts: Array<{
    __typename?: 'FundingSourceAccount'
    balance: number
    last4: string
    institutionName: string
    status: FundingSourceStatus
    verified: boolean
    role: FundingSourceRoleEnum
    id: number
    fundType: FundingSourceType
    accountName: string
  }>
  settings: { __typename?: 'Settings'; depositsSuspended: boolean }
  user: {
    __typename?: 'User'
    fundingSource: {
      __typename?: 'FundingSource'
      verified: boolean
      name: string
      last4: string
    }
  }
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    availableBalance: { __typename?: 'CurrencyAmount'; value: number }
  }>
}

export type AgreeToAcceptanceDocumentMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type AgreeToAcceptanceDocumentMutation = {
  __typename?: 'Mutation'
  agreeToAcceptanceDocument: any
}

export type EarnSubscribeUserToTierMutationVariables = Exact<{
  tierPriceId: Scalars['ID']
}>

export type EarnSubscribeUserToTierMutation = {
  __typename?: 'Mutation'
  subscribeUserToTier:
    | { __typename: 'InvalidTierPriceId' }
    | { __typename: 'TierDowngradeActionRequired' }
    | { __typename: 'TierSubscription'; id: string }
}

export type LinkedAccountsForEarnOfferQueryVariables = Exact<{
  [key: string]: never
}>

export type LinkedAccountsForEarnOfferQuery = {
  __typename?: 'Query'
  linkedAccounts: Array<{
    __typename?: 'LinkedAccount'
    id: string
    institutionName: string
    logoUrl: string
    status: LinkedAccountStatusEnum
    externalSource: LinkedAccountExternalSourceEnum
    linkedSubaccounts: Array<{
      __typename?: 'LinkedSubaccount'
      id: string
      accountNumberLastFour: string
      name: string
    }>
  }>
  roundUpAccounts: Array<{
    __typename?: 'RoundUpAccount'
    linkedSubaccountId: string
    enabled: boolean
  }>
}

export type AddFavoritePartnerOffersMutationVariables = Exact<{
  input: FavoritePartnerOfferInput
}>

export type AddFavoritePartnerOffersMutation = {
  __typename?: 'Mutation'
  addFavoritePartnerOffers: {
    __typename?: 'FavoritePartnerOfferGroup'
    offers: Array<
      | {
          __typename?: 'EarnOffer'
          displayName: string
          displayTitle: string
          dealType: DealType
          badgeCategory: BadgeCategory
          backgroundImageUrl: any
          campaignId: string
          campaignOfferId: string
          incentiveSummary: string
          isFavorite: boolean
          displaySubtitle: string
          colorBackgroundLogoImageUrl: any
          ownerId: string
          ownerDescription: string
        }
      | { __typename?: 'JobOffer' }
      | { __typename?: 'JobSearchOffer' }
      | { __typename?: 'PromoOffer' }
    >
  }
}

export type EarnIndexQueryQueryVariables = Exact<{
  partnerOfferGroupsTypeInput: PartnerOfferGroupsTypeInput
}>

export type EarnIndexQueryQuery = {
  __typename?: 'Query'
  activeEarnOffers: {
    __typename?: 'EarnOfferQueryPage'
    earnOffers: Array<{
      __typename?: 'EarnOffer'
      backgroundImageUrl: any
      badgeCategory: BadgeCategory
      colorBackgroundLogoImageUrl: any
      campaignId: string
      campaignOfferId: string
      dealType: DealType
      displayName: string
      displaySubtitle: string
      displayTitle: string
      ownerDescription: string
      ownerId: string
      promoted: boolean
      promotionRank: number
      incentiveSummary: string
    }>
  }
  partnerOfferGroupsByType: Array<{
    __typename?: 'PartnerOfferGroup'
    id: string
    title: string
    body: string
    offers: Array<
      | {
          __typename?: 'EarnOffer'
          keyphraseCategoryNames: Array<string>
          displayName: string
          dealType: DealType
          badgeCategory: BadgeCategory
          backgroundImageUrl: any
          campaignId: string
          campaignOfferId: string
          incentiveSummary: string
          displaySubtitle: string
          displayTitle: string
          colorBackgroundLogoImageUrl: any
          ownerId: string
          ownerDescription: string
        }
      | { __typename?: 'JobOffer' }
      | { __typename?: 'JobSearchOffer' }
      | { __typename?: 'PromoOffer' }
    >
  }>
}

export type EarnOfferDetailQueryQueryVariables = Exact<{
  campaignOfferId: Scalars['String']
  sessionId: Scalars['String']
  origin: Scalars['String']
}>

export type EarnOfferDetailQueryQuery = {
  __typename?: 'Query'
  earnOfferByCampaignOfferId: {
    __typename: 'EarnOffer'
    campaignId: string
    campaignOfferId: string
    backgroundImageUrl: any
    badgeCategory: BadgeCategory
    colorBackgroundLogoImageUrl: any
    dealType: DealType
    details: Array<string>
    displayBody: string
    displayName: string
    displayTitle: string
    displaySubtitle: string
    exclusions: Array<string>
    incentiveSummary: string
    isFavorite: boolean
    keyphraseCategoryNames: Array<string>
    ownerDescription: string
    ownerId: string
    promoted: boolean
    promotionRank: number
    termsAndConditionsUrl: string
    ctaDetails: {
      __typename?: 'EarnOfferCtaDetails'
      title: string
      web: string
    }
  }
  user: { __typename?: 'User'; uuid: string }
}

export type FavoriteEarnOffersQueryVariables = Exact<{ [key: string]: never }>

export type FavoriteEarnOffersQuery = {
  __typename?: 'Query'
  favoriteEarnOffers: {
    __typename?: 'FavoritePartnerOfferGroup'
    offers: Array<
      | {
          __typename: 'EarnOffer'
          campaignId: string
          campaignOfferId: string
          backgroundImageUrl: any
          badgeCategory: BadgeCategory
          colorBackgroundLogoImageUrl: any
          dealType: DealType
          details: Array<string>
          displayBody: string
          displayName: string
          displayTitle: string
          displaySubtitle: string
          exclusions: Array<string>
          incentiveSummary: string
          isFavorite: boolean
          ownerDescription: string
          ownerId: string
          ctaDetails: {
            __typename?: 'EarnOfferCtaDetails'
            title: string
            web: string
          }
        }
      | { __typename?: 'JobOffer' }
      | { __typename?: 'JobSearchOffer' }
      | { __typename?: 'PromoOffer' }
    >
  }
}

export type FoundMoneyRewardsQueryVariables = Exact<{ [key: string]: never }>

export type FoundMoneyRewardsQuery = {
  __typename?: 'Query'
  foundMoneySummary: {
    __typename?: 'FoundMoneySummary'
    totalAmount: { __typename?: 'MicrosMoney'; currency: Currency; value: any }
  }
}

export type FoundMoneyRewardsV2QueryVariables = Exact<{ [key: string]: never }>

export type FoundMoneyRewardsV2Query = {
  __typename?: 'Query'
  foundMoneyRewardsV2: Array<{
    __typename: 'EarnReward'
    id: string
    displayName: string
    colorBackgroundLogoImageUrl: any
    originationDate: any
    status: EarnRewardStatus
    expectedFulfilledAt: any
    fulfilledAt: any
    investmentId: string
    incentiveAmount: number
    amountV2: { __typename?: 'MicrosMoney'; currency: Currency; value: any }
    linked: Array<{
      __typename?: 'EarnReward'
      id: string
      incentiveAmount: number
      amountV2: { __typename?: 'MicrosMoney'; currency: Currency; value: any }
    }>
  }>
}

export type FoundMoneySummaryDetailQueryVariables = Exact<{
  [key: string]: never
}>

export type FoundMoneySummaryDetailQuery = {
  __typename?: 'Query'
  foundMoneySummary: {
    __typename?: 'FoundMoneySummary'
    totalAmount: { __typename?: 'MicrosMoney'; value: any }
    pendingAmount: { __typename?: 'MicrosMoney'; value: any }
    fulfilledAmount: { __typename?: 'MicrosMoney'; value: any }
    matchedAmount: {
      __typename?: 'MicrosMoney'
      currency: Currency
      value: any
    }
  }
}

export type EarnInvestmentAccountsQueryVariables = Exact<{
  [key: string]: never
}>

export type EarnInvestmentAccountsQuery = {
  __typename?: 'Query'
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    type: string
    closedAt: any
    portfolio: { __typename?: 'Portfolio'; id: string }
  }>
}

export type PromotedEarnOffersQueryVariables = Exact<{ [key: string]: never }>

export type PromotedEarnOffersQuery = {
  __typename?: 'Query'
  promotedEarnOffers: Array<{
    __typename?: 'EarnOffer'
    backgroundImageUrl: any
    badgeCategory: BadgeCategory
    campaignId: string
    campaignOfferId: string
    colorBackgroundLogoImageUrl: any
    dealType: DealType
    displayName: string
    displaySubtitle: string
    displayTitle: string
    incentiveSummary: string
    ownerDescription: string
    ownerId: string
    promoted: boolean
    promotionRank: number
  }>
}

export type RemoveFavoritePartnerOffersMutationVariables = Exact<{
  input: FavoritePartnerOfferInput
}>

export type RemoveFavoritePartnerOffersMutation = {
  __typename?: 'Mutation'
  removeFavoritePartnerOffers: {
    __typename?: 'FavoritePartnerOfferGroup'
    offers: Array<
      | {
          __typename: 'EarnOffer'
          displayName: string
          displayTitle: string
          dealType: DealType
          badgeCategory: BadgeCategory
          backgroundImageUrl: any
          campaignId: string
          campaignOfferId: string
          incentiveSummary: string
          isFavorite: boolean
          displaySubtitle: string
          colorBackgroundLogoImageUrl: any
          ownerId: string
          ownerDescription: string
        }
      | { __typename?: 'JobOffer' }
      | { __typename?: 'JobSearchOffer' }
      | { __typename?: 'PromoOffer' }
    >
  }
}

export type SearchActiveEarnOffersQueryVariables = Exact<{
  searchTerm: Scalars['String']
  tag: Scalars['String']
}>

export type SearchActiveEarnOffersQuery = {
  __typename?: 'Query'
  searchActiveEarnOffers: {
    __typename: 'EarnOfferQueryPage'
    earnOffers: Array<{
      __typename?: 'EarnOffer'
      displayName: string
      displayTitle: string
      campaignId: string
      campaignOfferId: string
      incentiveSummary: string
      colorBackgroundLogoImageUrl: any
      ownerId: string
    }>
  }
}

export type EmergencyFundHomeQueryVariables = Exact<{ [key: string]: never }>

export type EmergencyFundHomeQuery = {
  __typename?: 'Query'
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    id: string
    createdAt: any
    status: BankAccountStatus
    closedAt: any
    isLocked: boolean
    type: BankAccountType
    availableBalance: { __typename?: 'CurrencyAmount'; value: number }
    pendingBalance: { __typename?: 'CurrencyAmount'; value: number }
    totalBalance: { __typename?: 'CurrencyAmount'; value: number }
    goals: {
      __typename?: 'BankAccountGoals'
      currentGoal: {
        __typename?: 'BankAccountGoal'
        type: BankAccountGoalType
        amount: {
          __typename?: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    }
  }>
  bankCardOrder: { __typename?: 'BankCardOrder'; bankCardTier: BankCardTier }
}

export type BankAccountQueryQueryVariables = Exact<{ [key: string]: never }>

export type BankAccountQueryQuery = {
  __typename?: 'Query'
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    isLocked: boolean
    lockReason: BankAccountLockReason
    id: string
  }>
}

export type EmergencyFundCompletedItemsQueryVariables = Exact<{
  accountId: Scalars['ID']
}>

export type EmergencyFundCompletedItemsQuery = {
  __typename?: 'Query'
  allPastItems: {
    __typename?: 'PastItemConnection'
    edges: Array<{
      __typename?: 'PastItemEdge'
      node:
        | { __typename?: 'CoreACHSubscriptionFeeItem'; id: string }
        | { __typename?: 'CoreAdjustmentItem'; id: string }
        | { __typename?: 'CoreCashForwardItem'; id: string }
        | { __typename?: 'CoreCollectionItem'; id: string }
        | { __typename?: 'CoreDebtCollectionItem'; id: string }
        | { __typename?: 'CoreDividendsItem'; id: string }
        | { __typename?: 'CoreEmployeeCreditItem'; id: string }
        | { __typename?: 'CoreFeeInvestmentItem'; id: string }
        | { __typename?: 'CoreFoundMoneyRewardItem'; id: string }
        | { __typename?: 'CoreGiftCardCreditRedemptionItem'; id: string }
        | { __typename?: 'CoreHoldingsTransferInItem'; id: string }
        | { __typename?: 'CoreInvestmentItem'; id: string }
        | { __typename?: 'CoreLocalFoundMoneyItem'; id: string }
        | { __typename?: 'CorePartnerRewardItem'; id: string }
        | { __typename?: 'CoreRebalanceItem'; id: string }
        | { __typename?: 'CoreReferralRewardItem'; id: string }
        | { __typename?: 'CoreRefundedItem'; id: string }
        | { __typename?: 'CoreReinvestmentItem'; id: string }
        | { __typename?: 'CoreRoundUpsItem'; id: string }
        | { __typename?: 'CoreWithdrawalItem'; id: string }
        | { __typename?: 'EarlyDebtCollectionItem'; id: string }
        | { __typename?: 'EarlyDividendsItem'; id: string }
        | { __typename?: 'EarlyFeeInvestmentItem'; id: string }
        | { __typename?: 'EarlyGiftItem'; id: string }
        | { __typename?: 'EarlyInvestmentItem'; id: string }
        | { __typename?: 'EarlyMatchItem'; id: string }
        | { __typename?: 'EarlyMatchRemovalItem'; id: string }
        | { __typename?: 'EarlyRefundedItem'; id: string }
        | { __typename?: 'EarlyReinvestmentItem'; id: string }
        | { __typename?: 'EarlyWithdrawalItem'; id: string }
        | { __typename?: 'LaterDebtCollectionItem'; id: string }
        | { __typename?: 'LaterDividendsItem'; id: string }
        | { __typename?: 'LaterFeeInvestmentItem'; id: string }
        | { __typename?: 'LaterInvestmentItem'; id: string }
        | { __typename?: 'LaterMatchItem'; id: string }
        | { __typename?: 'LaterMatchRemovalItem'; id: string }
        | { __typename?: 'LaterRebalanceItem'; id: string }
        | { __typename?: 'LaterRefundedItem'; id: string }
        | { __typename?: 'LaterReinvestmentItem'; id: string }
        | { __typename?: 'LaterWithdrawalItem'; id: string }
        | { __typename?: 'PastAcornsRewardInvestmentItem'; id: string }
        | { __typename?: 'PastBeneficiaryTransferInvestmentItem'; id: string }
        | { __typename?: 'PastCashOwedCollectionInvestmentItem'; id: string }
        | { __typename?: 'PastCashReinvestmentInvestmentItem'; id: string }
        | { __typename?: 'PastCoreItem'; id: string }
        | { __typename?: 'PastDividendInvestmentItem'; id: string }
        | { __typename?: 'PastEmployeeContributionInvestmentItem'; id: string }
        | { __typename?: 'PastExternalTransferInvestmentItem'; id: string }
        | {
            __typename?: 'PastExternalTransferReversedInvestmentItem'
            id: string
          }
        | { __typename?: 'PastFeeInvestmentItem'; id: string }
        | { __typename?: 'PastGiftCardInvestmentItem'; id: string }
        | { __typename?: 'PastIRATransferInvestmentItem'; id: string }
        | { __typename?: 'PastInvestmentTipItem'; id: string }
        | { __typename?: 'PastLumpSumInvestment'; id: string }
        | { __typename?: 'PastMatchInvestmentItem'; id: string }
        | { __typename?: 'PastMatchRemovalInvestmentItem'; id: string }
        | { __typename?: 'PastOutsideContributionInvestmentItem'; id: string }
        | { __typename?: 'PastRealTimeRoundUpInvestmentItem'; id: string }
        | { __typename?: 'PastRebalanceInvestmentItem'; id: string }
        | { __typename?: 'PastRecurringInvestmentItem'; id: string }
        | { __typename?: 'PastReferralRewardInvestmentItem'; id: string }
        | { __typename?: 'PastReferralRewardMatchInvestmentItem'; id: string }
        | { __typename?: 'PastRefundInvestmentItem'; id: string }
        | { __typename?: 'PastReversalInvestmentItem'; id: string }
        | { __typename?: 'PastRewardInvestmentItem'; id: string }
        | { __typename?: 'PastRewardMatchInvestmentItem'; id: string }
        | { __typename?: 'PastRoundUpItem'; id: string }
        | { __typename?: 'PastRoundUpMatchInvestmentItem'; id: string }
        | { __typename?: 'PastSecurityLiquidationInvestmentItem'; id: string }
        | { __typename?: 'PastSmartDepositInvestmentItem'; id: string }
        | { __typename?: 'PastSpendItem'; id: string }
        | { __typename?: 'PastStreakRewardInvestmentItem'; id: string }
        | { __typename?: 'PastTipsThatGrowMatchInvestmentItem'; id: string }
        | { __typename?: 'PastWithdrawalInvestmentItem'; id: string }
        | { __typename?: 'SaveInterestPaidItem'; id: string }
        | { __typename?: 'SaveTransferInItem'; id: string }
        | { __typename?: 'SaveTransferOutItem'; id: string }
        | { __typename?: 'SpendATMReimbursementItem'; id: string }
        | { __typename?: 'SpendATMWithdrawalItem'; id: string }
        | { __typename?: 'SpendBillPayItem'; id: string }
        | { __typename?: 'SpendCheckDepositItem'; id: string }
        | { __typename?: 'SpendCheckPaymentItem'; id: string }
        | { __typename?: 'SpendDigitalWalletItem'; id: string }
        | { __typename?: 'SpendDirectDepositItem'; id: string }
        | { __typename?: 'SpendECheckItem'; id: string }
        | { __typename?: 'SpendInterestPaidItem'; id: string }
        | { __typename?: 'SpendPurchaseItem'; id: string }
        | { __typename?: 'SpendRealTimeRoundUpItem'; id: string }
        | { __typename?: 'SpendTransferInItem'; id: string }
        | { __typename?: 'SpendTransferOutItem'; id: string }
    }>
  }
}

export type RecentActivityQueryQueryVariables = Exact<{ [key: string]: never }>

export type RecentActivityQueryQuery = {
  __typename?: 'Query'
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    id: string
    status: BankAccountStatus
  }>
}

export type EmergencySavingsSettingsQueryVariables = Exact<{
  [key: string]: never
}>

export type EmergencySavingsSettingsQuery = {
  __typename?: 'Query'
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    id: string
    number: string
    routingNumber: string
    status: BankAccountStatus
    type: BankAccountType
  }>
}

export type AllBankAccountsQueryQueryVariables = Exact<{ [key: string]: never }>

export type AllBankAccountsQueryQuery = {
  __typename?: 'Query'
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    id: string
    number: string
    accountName: string
    type: BankAccountType
    isLocked: boolean
    lockReason: BankAccountLockReason
    status: BankAccountStatus
    availableBalance: { __typename?: 'CurrencyAmount'; value: number }
  }>
}

export type CreateEmergencySavingsIntentMutationVariables = Exact<{
  input: CreateIntentInput
}>

export type CreateEmergencySavingsIntentMutation = {
  __typename?: 'Mutation'
  createIntent:
    | {
        __typename?: 'Intent'
        status: IntentStatus
        nonce: any
        amount: { __typename?: 'CurrencyAmount'; value: number }
      }
    | { __typename?: 'ValidationError'; errorCode: string }
}

export type EmergencySavingsTransferQueryVariables = Exact<{
  transferAction: TransferAction
}>

export type EmergencySavingsTransferQuery = {
  __typename?: 'Query'
  allAccounts: Array<{
    __typename?: 'CustomerAccount'
    id: string
    referenceId: string
    name: string
    mask: string
    status: CustomerAccountStatus
    type: string
    customerNotice: boolean
    customerAccountsByTransferAction: Array<{
      __typename?: 'CustomerAccount'
      id: string
      referenceId: string
      name: string
      mask: string
      status: CustomerAccountStatus
      type: string
      customerNotice: boolean
      institution: {
        __typename?: 'FinancialInstitution'
        logoUrl: string
        name: string
      }
      beneficiary: {
        __typename?: 'Beneficiary'
        firstName: string
        investmentAccount: {
          __typename?: 'InvestmentAccount'
          transferability: {
            __typename?: 'InvestmentAccountTransferability'
            transferReached: boolean
          }
        }
      }
      balance: {
        __typename?: 'CurrencyAmount'
        currency: Currency
        value: number
      }
    }>
    institution: {
      __typename?: 'FinancialInstitution'
      logoUrl: string
      name: string
    }
    beneficiary: {
      __typename?: 'Beneficiary'
      firstName: string
      investmentAccount: {
        __typename?: 'InvestmentAccount'
        transferability: {
          __typename?: 'InvestmentAccountTransferability'
          transferReached: boolean
        }
      }
    }
    balance: {
      __typename?: 'CurrencyAmount'
      currency: Currency
      value: number
    }
  }>
  fundingSourceAccounts: Array<{
    __typename?: 'FundingSourceAccount'
    id: number
    uuid: string
    fundType: FundingSourceType
    role: FundingSourceRoleEnum
    accountName: string
    verified: boolean
    last4: string
    balance: number
    linkedSubaccountId: string
    rdvTriggeredAt: any
    rdvSettledAt: any
    bankRoutingNumber: string
  }>
  settings: { __typename?: 'Settings'; depositsSuspended: boolean }
}

export type CustomerAccountFragmentFragment = {
  __typename?: 'CustomerAccount'
  id: string
  referenceId: string
  name: string
  mask: string
  status: CustomerAccountStatus
  type: string
  customerNotice: boolean
  institution: {
    __typename?: 'FinancialInstitution'
    logoUrl: string
    name: string
  }
  beneficiary: {
    __typename?: 'Beneficiary'
    firstName: string
    investmentAccount: {
      __typename?: 'InvestmentAccount'
      transferability: {
        __typename?: 'InvestmentAccountTransferability'
        transferReached: boolean
      }
    }
  }
  balance: { __typename?: 'CurrencyAmount'; currency: Currency; value: number }
}

export type InitiateTransferEmergencyFundMutationVariables = Exact<{
  amount: Scalars['Float']
  fromAccountId: Scalars['ID']
  toAccountId: Scalars['ID']
  nonce?: InputMaybe<Scalars['ID']>
}>

export type InitiateTransferEmergencyFundMutation = {
  __typename?: 'Mutation'
  initiateTransfer: {
    __typename?: 'InitiateTransferPayload'
    transfer: { __typename?: 'Transfer'; id: string }
  }
}

export type CancelInvestmentMutationVariables = Exact<{
  cancelInvestmentInput: CancelInvestmentInput
}>

export type CancelInvestmentMutation = {
  __typename?: 'Mutation'
  cancelInvestment:
    | {
        __typename: 'CancelInvestmentPayload'
        cancelInvestmentPayloadId: string
      }
    | {
        __typename: 'InvestmentNotFoundException'
        investmentNotFoundExceptionId: string
      }
    | {
        __typename: 'InvestmentUncancellableException'
        investmentUncancellableExceptionId: string
      }
}

export type InvestmentByIdQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type InvestmentByIdQuery = {
  __typename?: 'Query'
  investment: {
    __typename?: 'Investment'
    id: string
    createdAt: any
    type: string
    tradeConfirmationUrls: Array<any>
    requestedAmount: {
      __typename?: 'MonetaryAmount'
      value: number
      currency: Currency
    }
    transferredAmount: {
      __typename?: 'MonetaryAmount'
      value: number
      currency: Currency
    }
    amountCollected: { __typename?: 'MonetaryAmount'; value: number }
    iraDistribution: {
      __typename?: 'IRADistribution'
      federalWithholdings: {
        __typename?: 'MonetaryAmount'
        value: number
        currency: Currency
      }
      stateWithholdings: {
        __typename?: 'MonetaryAmount'
        value: number
        currency: Currency
      }
    }
    allocations: Array<{
      __typename?: 'InvestmentAllocation'
      amount: number
      selfDirected: boolean
      shares: number
      symbol: string
      price: {
        __typename?: 'MonetaryAmount'
        currency: Currency
        value: number
      }
    }>
  }
}

export type SpendTransactionItemQueryVariables = Exact<{
  transactionId: Scalars['String']
}>

export type SpendTransactionItemQuery = {
  __typename?: 'Query'
  pastSpendTransactionItem:
    | {
        __typename: 'CoreACHSubscriptionFeeItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'CoreAdjustmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'CoreCashForwardItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'CoreCollectionItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'CoreDebtCollectionItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'CoreDividendsItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'CoreEmployeeCreditItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'CoreFeeInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'CoreFoundMoneyRewardItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'CoreGiftCardCreditRedemptionItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'CoreHoldingsTransferInItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'CoreInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'CoreLocalFoundMoneyItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'CorePartnerRewardItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'CoreRebalanceItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'CoreReferralRewardItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'CoreRefundedItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'CoreReinvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'CoreRoundUpsItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'CoreWithdrawalItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'EarlyDebtCollectionItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'EarlyDividendsItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'EarlyFeeInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'EarlyGiftItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'EarlyInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'EarlyMatchItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'EarlyMatchRemovalItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'EarlyRefundedItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'EarlyReinvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'EarlyWithdrawalItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'LaterDebtCollectionItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'LaterDividendsItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'LaterFeeInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'LaterInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'LaterMatchItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'LaterMatchRemovalItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'LaterRebalanceItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'LaterRefundedItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'LaterReinvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'LaterWithdrawalItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastAcornsRewardInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastBeneficiaryTransferInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastCashOwedCollectionInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastCashReinvestmentInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastCoreItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastDividendInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastEmployeeContributionInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastExternalTransferInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastExternalTransferReversedInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastFeeInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastGiftCardInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastIRATransferInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastInvestmentTipItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastLumpSumInvestment'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastMatchInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastMatchRemovalInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastOutsideContributionInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastRealTimeRoundUpInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastRebalanceInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastRecurringInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastReferralRewardInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastReferralRewardMatchInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastRefundInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastReversalInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastRewardInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastRewardMatchInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastRoundUpItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastRoundUpMatchInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastSecurityLiquidationInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastSmartDepositInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastSpendItem'
        availableAt: any
        description: string
        summary: string
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastStreakRewardInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastTipsThatGrowMatchInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'PastWithdrawalInvestmentItem'
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'SaveInterestPaidItem'
        availableAt: any
        description: string
        summary: string
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'SaveTransferInItem'
        availableAt: any
        description: string
        summary: string
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'SaveTransferOutItem'
        availableAt: any
        description: string
        summary: string
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'SpendATMReimbursementItem'
        availableAt: any
        description: string
        summary: string
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'SpendATMWithdrawalItem'
        availableAt: any
        description: string
        summary: string
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'SpendBillPayItem'
        availableAt: any
        description: string
        summary: string
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'SpendCheckDepositItem'
        availableAt: any
        description: string
        summary: string
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'SpendCheckPaymentItem'
        availableAt: any
        description: string
        summary: string
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'SpendDigitalWalletItem'
        availableAt: any
        description: string
        summary: string
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'SpendDirectDepositItem'
        availableAt: any
        description: string
        summary: string
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'SpendECheckItem'
        availableAt: any
        description: string
        summary: string
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'SpendInterestPaidItem'
        availableAt: any
        description: string
        summary: string
        monthEarned: string
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'SpendPurchaseItem'
        availableAt: any
        description: string
        summary: string
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'SpendRealTimeRoundUpItem'
        availableAt: any
        description: string
        summary: string
        multiplier: number
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        initialAmount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'SpendTransferInItem'
        availableAt: any
        description: string
        summary: string
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
    | {
        __typename: 'SpendTransferOutItem'
        availableAt: any
        description: string
        summary: string
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        reversible: boolean
        amount: {
          __typename: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
  bankCardOrder: { __typename?: 'BankCardOrder'; bankCardTier: BankCardTier }
}

export type PastSpendSummaryQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type PastSpendSummaryQueryQuery = {
  __typename?: 'Query'
  pastSpendSummary: {
    __typename?: 'PastSpendSummary'
    debitsLast30Days: {
      __typename?: 'CurrencyAmount'
      value: number
      currency: Currency
    }
    depositsLast30Days: {
      __typename?: 'CurrencyAmount'
      value: number
      currency: Currency
    }
    availableBalance: {
      __typename?: 'CurrencyAmount'
      value: number
      currency: Currency
    }
  }
  pending: {
    __typename?: 'PastItemConnection'
    edges: Array<{
      __typename?: 'PastItemEdge'
      node:
        | { __typename?: 'CoreACHSubscriptionFeeItem'; id: string }
        | { __typename?: 'CoreAdjustmentItem'; id: string }
        | { __typename?: 'CoreCashForwardItem'; id: string }
        | { __typename?: 'CoreCollectionItem'; id: string }
        | { __typename?: 'CoreDebtCollectionItem'; id: string }
        | { __typename?: 'CoreDividendsItem'; id: string }
        | { __typename?: 'CoreEmployeeCreditItem'; id: string }
        | { __typename?: 'CoreFeeInvestmentItem'; id: string }
        | { __typename?: 'CoreFoundMoneyRewardItem'; id: string }
        | { __typename?: 'CoreGiftCardCreditRedemptionItem'; id: string }
        | { __typename?: 'CoreHoldingsTransferInItem'; id: string }
        | { __typename?: 'CoreInvestmentItem'; id: string }
        | { __typename?: 'CoreLocalFoundMoneyItem'; id: string }
        | { __typename?: 'CorePartnerRewardItem'; id: string }
        | { __typename?: 'CoreRebalanceItem'; id: string }
        | { __typename?: 'CoreReferralRewardItem'; id: string }
        | { __typename?: 'CoreRefundedItem'; id: string }
        | { __typename?: 'CoreReinvestmentItem'; id: string }
        | { __typename?: 'CoreRoundUpsItem'; id: string }
        | { __typename?: 'CoreWithdrawalItem'; id: string }
        | { __typename?: 'EarlyDebtCollectionItem'; id: string }
        | { __typename?: 'EarlyDividendsItem'; id: string }
        | { __typename?: 'EarlyFeeInvestmentItem'; id: string }
        | { __typename?: 'EarlyGiftItem'; id: string }
        | { __typename?: 'EarlyInvestmentItem'; id: string }
        | { __typename?: 'EarlyMatchItem'; id: string }
        | { __typename?: 'EarlyMatchRemovalItem'; id: string }
        | { __typename?: 'EarlyRefundedItem'; id: string }
        | { __typename?: 'EarlyReinvestmentItem'; id: string }
        | { __typename?: 'EarlyWithdrawalItem'; id: string }
        | { __typename?: 'LaterDebtCollectionItem'; id: string }
        | { __typename?: 'LaterDividendsItem'; id: string }
        | { __typename?: 'LaterFeeInvestmentItem'; id: string }
        | { __typename?: 'LaterInvestmentItem'; id: string }
        | { __typename?: 'LaterMatchItem'; id: string }
        | { __typename?: 'LaterMatchRemovalItem'; id: string }
        | { __typename?: 'LaterRebalanceItem'; id: string }
        | { __typename?: 'LaterRefundedItem'; id: string }
        | { __typename?: 'LaterReinvestmentItem'; id: string }
        | { __typename?: 'LaterWithdrawalItem'; id: string }
        | { __typename?: 'PastAcornsRewardInvestmentItem'; id: string }
        | { __typename?: 'PastBeneficiaryTransferInvestmentItem'; id: string }
        | { __typename?: 'PastCashOwedCollectionInvestmentItem'; id: string }
        | { __typename?: 'PastCashReinvestmentInvestmentItem'; id: string }
        | { __typename?: 'PastCoreItem'; id: string }
        | { __typename?: 'PastDividendInvestmentItem'; id: string }
        | { __typename?: 'PastEmployeeContributionInvestmentItem'; id: string }
        | { __typename?: 'PastExternalTransferInvestmentItem'; id: string }
        | {
            __typename?: 'PastExternalTransferReversedInvestmentItem'
            id: string
          }
        | { __typename?: 'PastFeeInvestmentItem'; id: string }
        | { __typename?: 'PastGiftCardInvestmentItem'; id: string }
        | { __typename?: 'PastIRATransferInvestmentItem'; id: string }
        | { __typename?: 'PastInvestmentTipItem'; id: string }
        | { __typename?: 'PastLumpSumInvestment'; id: string }
        | { __typename?: 'PastMatchInvestmentItem'; id: string }
        | { __typename?: 'PastMatchRemovalInvestmentItem'; id: string }
        | { __typename?: 'PastOutsideContributionInvestmentItem'; id: string }
        | { __typename?: 'PastRealTimeRoundUpInvestmentItem'; id: string }
        | { __typename?: 'PastRebalanceInvestmentItem'; id: string }
        | { __typename?: 'PastRecurringInvestmentItem'; id: string }
        | { __typename?: 'PastReferralRewardInvestmentItem'; id: string }
        | { __typename?: 'PastReferralRewardMatchInvestmentItem'; id: string }
        | { __typename?: 'PastRefundInvestmentItem'; id: string }
        | { __typename?: 'PastReversalInvestmentItem'; id: string }
        | { __typename?: 'PastRewardInvestmentItem'; id: string }
        | { __typename?: 'PastRewardMatchInvestmentItem'; id: string }
        | { __typename?: 'PastRoundUpItem'; id: string }
        | { __typename?: 'PastRoundUpMatchInvestmentItem'; id: string }
        | { __typename?: 'PastSecurityLiquidationInvestmentItem'; id: string }
        | { __typename?: 'PastSmartDepositInvestmentItem'; id: string }
        | { __typename?: 'PastSpendItem'; id: string }
        | { __typename?: 'PastStreakRewardInvestmentItem'; id: string }
        | { __typename?: 'PastTipsThatGrowMatchInvestmentItem'; id: string }
        | { __typename?: 'PastWithdrawalInvestmentItem'; id: string }
        | { __typename?: 'SaveInterestPaidItem'; id: string }
        | { __typename?: 'SaveTransferInItem'; id: string }
        | { __typename?: 'SaveTransferOutItem'; id: string }
        | { __typename?: 'SpendATMReimbursementItem'; id: string }
        | { __typename?: 'SpendATMWithdrawalItem'; id: string }
        | { __typename?: 'SpendBillPayItem'; id: string }
        | { __typename?: 'SpendCheckDepositItem'; id: string }
        | { __typename?: 'SpendCheckPaymentItem'; id: string }
        | { __typename?: 'SpendDigitalWalletItem'; id: string }
        | { __typename?: 'SpendDirectDepositItem'; id: string }
        | { __typename?: 'SpendECheckItem'; id: string }
        | { __typename?: 'SpendInterestPaidItem'; id: string }
        | { __typename?: 'SpendPurchaseItem'; id: string }
        | { __typename?: 'SpendRealTimeRoundUpItem'; id: string }
        | { __typename?: 'SpendTransferInItem'; id: string }
        | { __typename?: 'SpendTransferOutItem'; id: string }
    }>
  }
  completed: {
    __typename?: 'PastItemConnection'
    edges: Array<{
      __typename?: 'PastItemEdge'
      node:
        | { __typename?: 'CoreACHSubscriptionFeeItem'; id: string }
        | { __typename?: 'CoreAdjustmentItem'; id: string }
        | { __typename?: 'CoreCashForwardItem'; id: string }
        | { __typename?: 'CoreCollectionItem'; id: string }
        | { __typename?: 'CoreDebtCollectionItem'; id: string }
        | { __typename?: 'CoreDividendsItem'; id: string }
        | { __typename?: 'CoreEmployeeCreditItem'; id: string }
        | { __typename?: 'CoreFeeInvestmentItem'; id: string }
        | { __typename?: 'CoreFoundMoneyRewardItem'; id: string }
        | { __typename?: 'CoreGiftCardCreditRedemptionItem'; id: string }
        | { __typename?: 'CoreHoldingsTransferInItem'; id: string }
        | { __typename?: 'CoreInvestmentItem'; id: string }
        | { __typename?: 'CoreLocalFoundMoneyItem'; id: string }
        | { __typename?: 'CorePartnerRewardItem'; id: string }
        | { __typename?: 'CoreRebalanceItem'; id: string }
        | { __typename?: 'CoreReferralRewardItem'; id: string }
        | { __typename?: 'CoreRefundedItem'; id: string }
        | { __typename?: 'CoreReinvestmentItem'; id: string }
        | { __typename?: 'CoreRoundUpsItem'; id: string }
        | { __typename?: 'CoreWithdrawalItem'; id: string }
        | { __typename?: 'EarlyDebtCollectionItem'; id: string }
        | { __typename?: 'EarlyDividendsItem'; id: string }
        | { __typename?: 'EarlyFeeInvestmentItem'; id: string }
        | { __typename?: 'EarlyGiftItem'; id: string }
        | { __typename?: 'EarlyInvestmentItem'; id: string }
        | { __typename?: 'EarlyMatchItem'; id: string }
        | { __typename?: 'EarlyMatchRemovalItem'; id: string }
        | { __typename?: 'EarlyRefundedItem'; id: string }
        | { __typename?: 'EarlyReinvestmentItem'; id: string }
        | { __typename?: 'EarlyWithdrawalItem'; id: string }
        | { __typename?: 'LaterDebtCollectionItem'; id: string }
        | { __typename?: 'LaterDividendsItem'; id: string }
        | { __typename?: 'LaterFeeInvestmentItem'; id: string }
        | { __typename?: 'LaterInvestmentItem'; id: string }
        | { __typename?: 'LaterMatchItem'; id: string }
        | { __typename?: 'LaterMatchRemovalItem'; id: string }
        | { __typename?: 'LaterRebalanceItem'; id: string }
        | { __typename?: 'LaterRefundedItem'; id: string }
        | { __typename?: 'LaterReinvestmentItem'; id: string }
        | { __typename?: 'LaterWithdrawalItem'; id: string }
        | { __typename?: 'PastAcornsRewardInvestmentItem'; id: string }
        | { __typename?: 'PastBeneficiaryTransferInvestmentItem'; id: string }
        | { __typename?: 'PastCashOwedCollectionInvestmentItem'; id: string }
        | { __typename?: 'PastCashReinvestmentInvestmentItem'; id: string }
        | { __typename?: 'PastCoreItem'; id: string }
        | { __typename?: 'PastDividendInvestmentItem'; id: string }
        | { __typename?: 'PastEmployeeContributionInvestmentItem'; id: string }
        | { __typename?: 'PastExternalTransferInvestmentItem'; id: string }
        | {
            __typename?: 'PastExternalTransferReversedInvestmentItem'
            id: string
          }
        | { __typename?: 'PastFeeInvestmentItem'; id: string }
        | { __typename?: 'PastGiftCardInvestmentItem'; id: string }
        | { __typename?: 'PastIRATransferInvestmentItem'; id: string }
        | { __typename?: 'PastInvestmentTipItem'; id: string }
        | { __typename?: 'PastLumpSumInvestment'; id: string }
        | { __typename?: 'PastMatchInvestmentItem'; id: string }
        | { __typename?: 'PastMatchRemovalInvestmentItem'; id: string }
        | { __typename?: 'PastOutsideContributionInvestmentItem'; id: string }
        | { __typename?: 'PastRealTimeRoundUpInvestmentItem'; id: string }
        | { __typename?: 'PastRebalanceInvestmentItem'; id: string }
        | { __typename?: 'PastRecurringInvestmentItem'; id: string }
        | { __typename?: 'PastReferralRewardInvestmentItem'; id: string }
        | { __typename?: 'PastReferralRewardMatchInvestmentItem'; id: string }
        | { __typename?: 'PastRefundInvestmentItem'; id: string }
        | { __typename?: 'PastReversalInvestmentItem'; id: string }
        | { __typename?: 'PastRewardInvestmentItem'; id: string }
        | { __typename?: 'PastRewardMatchInvestmentItem'; id: string }
        | { __typename?: 'PastRoundUpItem'; id: string }
        | { __typename?: 'PastRoundUpMatchInvestmentItem'; id: string }
        | { __typename?: 'PastSecurityLiquidationInvestmentItem'; id: string }
        | { __typename?: 'PastSmartDepositInvestmentItem'; id: string }
        | { __typename?: 'PastSpendItem'; id: string }
        | { __typename?: 'PastStreakRewardInvestmentItem'; id: string }
        | { __typename?: 'PastTipsThatGrowMatchInvestmentItem'; id: string }
        | { __typename?: 'PastWithdrawalInvestmentItem'; id: string }
        | { __typename?: 'SaveInterestPaidItem'; id: string }
        | { __typename?: 'SaveTransferInItem'; id: string }
        | { __typename?: 'SaveTransferOutItem'; id: string }
        | { __typename?: 'SpendATMReimbursementItem'; id: string }
        | { __typename?: 'SpendATMWithdrawalItem'; id: string }
        | { __typename?: 'SpendBillPayItem'; id: string }
        | { __typename?: 'SpendCheckDepositItem'; id: string }
        | { __typename?: 'SpendCheckPaymentItem'; id: string }
        | { __typename?: 'SpendDigitalWalletItem'; id: string }
        | { __typename?: 'SpendDirectDepositItem'; id: string }
        | { __typename?: 'SpendECheckItem'; id: string }
        | { __typename?: 'SpendInterestPaidItem'; id: string }
        | { __typename?: 'SpendPurchaseItem'; id: string }
        | { __typename?: 'SpendRealTimeRoundUpItem'; id: string }
        | { __typename?: 'SpendTransferInItem'; id: string }
        | { __typename?: 'SpendTransferOutItem'; id: string }
    }>
  }
  bankCardOrder: { __typename?: 'BankCardOrder'; bankCardTier: BankCardTier }
}

export type AllPastTransactionsQueryVariables = Exact<{
  filter?: InputMaybe<AllPastItemsFilter>
  pagination: PageInput
}>

export type AllPastTransactionsQuery = {
  __typename?: 'Query'
  allPastItems: {
    __typename?: 'PastItemConnection'
    edges: Array<{
      __typename?: 'PastItemEdge'
      cursor: string
      node:
        | {
            __typename: 'CoreACHSubscriptionFeeItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreAdjustmentItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreCashForwardItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreCollectionItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreDebtCollectionItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreDividendsItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreEmployeeCreditItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreFeeInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreFoundMoneyRewardItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreGiftCardCreditRedemptionItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreHoldingsTransferInItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreInvestmentItem'
            estimatedCompletionDate: any
            isRecurring: boolean
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreLocalFoundMoneyItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CorePartnerRewardItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreRebalanceItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreReferralRewardItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreRefundedItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreReinvestmentItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreRoundUpsItem'
            estimatedCompletionDate: any
            isRecurring: boolean
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'CoreWithdrawalItem'
            estimatedCompletionDate: any
            isRecurring: boolean
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyDebtCollectionItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyDividendsItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyFeeInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyGiftItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyInvestmentItem'
            estimatedCompletionDate: any
            isRecurring: boolean
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyMatchItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyMatchRemovalItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyRefundedItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyReinvestmentItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'EarlyWithdrawalItem'
            estimatedCompletionDate: any
            isRecurring: boolean
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterDebtCollectionItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterDividendsItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterFeeInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterInvestmentItem'
            estimatedCompletionDate: any
            isRecurring: boolean
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterMatchItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterMatchRemovalItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterRebalanceItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterRefundedItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterReinvestmentItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'LaterWithdrawalItem'
            estimatedCompletionDate: any
            isRecurring: boolean
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastAcornsRewardInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastBeneficiaryTransferInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastCashOwedCollectionInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastCashReinvestmentInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastCoreItem'
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastDividendInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastEmployeeContributionInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastExternalTransferInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastExternalTransferReversedInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastFeeInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastGiftCardInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastIRATransferInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastInvestmentTipItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastLumpSumInvestment'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastMatchInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastMatchRemovalInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastOutsideContributionInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRealTimeRoundUpInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRebalanceInvestmentItem'
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRecurringInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastReferralRewardInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastReferralRewardMatchInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRefundInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastReversalInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRewardInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            merchantName: string
            partnerLogoUrl: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRewardMatchInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRoundUpItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastRoundUpMatchInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastSecurityLiquidationInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastSmartDepositInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastSpendItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            availableAt: any
            description: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            summary: string
            transactionDescription: string
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastStreakRewardInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastTipsThatGrowMatchInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'PastWithdrawalInvestmentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            transactionDescription: string
            transactionType: TransactionType
            estimatedCompletionDate: any
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SaveInterestPaidItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            availableAt: any
            description: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            summary: string
            transactionDescription: string
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SaveTransferInItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            estimatedCompletionDate: any
            isRecurring: boolean
            accountName: string
            availableAt: any
            description: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            summary: string
            transactionDescription: string
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SaveTransferOutItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            estimatedCompletionDate: any
            isRecurring: boolean
            accountName: string
            availableAt: any
            description: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            summary: string
            transactionDescription: string
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendATMReimbursementItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            availableAt: any
            description: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            summary: string
            transactionDescription: string
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendATMWithdrawalItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            availableAt: any
            description: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            summary: string
            transactionDescription: string
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendBillPayItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            availableAt: any
            description: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            summary: string
            transactionDescription: string
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendCheckDepositItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            availableAt: any
            description: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            summary: string
            transactionDescription: string
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendCheckPaymentItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            availableAt: any
            description: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            summary: string
            transactionDescription: string
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendDigitalWalletItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            availableAt: any
            description: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            summary: string
            transactionDescription: string
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendDirectDepositItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            availableAt: any
            description: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            summary: string
            transactionDescription: string
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendECheckItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            availableAt: any
            description: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            summary: string
            transactionDescription: string
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendInterestPaidItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            availableAt: any
            description: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            summary: string
            transactionDescription: string
            transactionType: TransactionType
            monthEarned: string
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendPurchaseItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            availableAt: any
            description: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            summary: string
            transactionDescription: string
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendRealTimeRoundUpItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            accountName: string
            availableAt: any
            description: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            summary: string
            transactionDescription: string
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            initialAmount: {
              __typename?: 'CurrencyAmount'
              value: number
              currency: Currency
            }
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendTransferInItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            estimatedCompletionDate: any
            isRecurring: boolean
            accountName: string
            availableAt: any
            description: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            summary: string
            transactionDescription: string
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
        | {
            __typename: 'SpendTransferOutItem'
            sourceAccountTitle: string
            targetAccountTitle: string
            estimatedCompletionDate: any
            isRecurring: boolean
            accountName: string
            availableAt: any
            description: string
            moneyManagerTransfer: boolean
            productAccountType: ProductAccountType
            summary: string
            transactionDescription: string
            transactionType: TransactionType
            id: string
            title: string
            status: PastItemStatus
            createdAt: any
            reversible: boolean
            amount: {
              __typename?: 'CurrencyAmount'
              currency: Currency
              value: number
            }
          }
    }>
    pageInfo: {
      __typename?: 'PageInfo'
      hasPreviousPage: boolean
      hasNextPage: boolean
      limit: number
    }
  }
}

export type PastInvestAccountIdQueryVariables = Exact<{ [key: string]: never }>

export type PastInvestAccountIdQuery = {
  __typename?: 'Query'
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    closedAt: any
  }>
}

export type PastSpendAccountIdQueryVariables = Exact<{ [key: string]: never }>

export type PastSpendAccountIdQuery = {
  __typename?: 'Query'
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    id: string
    status: BankAccountStatus
  }>
}

export type TransactionsSummaryQueryVariables = Exact<{
  filter: PastSummaryFilter
}>

export type TransactionsSummaryQuery = {
  __typename?: 'Query'
  pastSummary:
    | {
        __typename?: 'AllAccountHistorySummary'
        moneyIn: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        moneyOut: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        dividends: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        earnRewards: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        referralRewards: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename?: 'CheckingHistorySummary'
        moneyIn: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        moneyOut: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        interestEarned: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename?: 'EarlyHistorySummary'
        moneyIn: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        moneyOut: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        dividends: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        giftsReceived: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        earlyInvestMatches: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename?: 'EmergencyFundHistorySummary'
        moneyIn: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        moneyOut: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        interestEarned: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename?: 'InvestHistorySummary'
        moneyIn: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        moneyOut: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        dividends: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        earnRewards: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        referralRewards: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename?: 'LaterHistorySummary'
        currentYear: string
        previousYear: string
        moneyIn: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        moneyOut: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        dividends: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        iraMatchRewards: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        previousYearContributions: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
        currentYearContributions: {
          __typename?: 'MicrosMoney'
          currency: Currency
          value: any
        }
      }
}

export type AllTransferableFromQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type AllTransferableFromQueryQuery = {
  __typename?: 'Query'
  allTransferableFrom: Array<{
    __typename?: 'TransferableFrom'
    from: {
      __typename?: 'TransferableAccount'
      accountNumberMasked: string
      externalSource: ExternalSource
      id: string
      name: string
      type: TransferableAccountTypeEnum
      balance: { __typename?: 'CurrencyAmount'; value: number }
    }
  }>
}

export type DeleteCardOrderMutationMutationVariables = Exact<{
  [key: string]: never
}>

export type DeleteCardOrderMutationMutation = {
  __typename?: 'Mutation'
  deleteExpiredBankCardOrder:
    | { __typename: 'BankCardOrder' }
    | { __typename: 'DeleteExpiredBankCardOrderCardTierNotFoundError' }
    | { __typename: 'DeleteExpiredBankCardOrderNotExpiredError' }
    | { __typename: 'DeleteExpiredBankCardOrderNotFoundError' }
}

export type AllPastPendingItemsQueryVariables = Exact<{ [key: string]: never }>

export type AllPastPendingItemsQuery = {
  __typename?: 'Query'
  allPastPendingItems: Array<
    | {
        __typename: 'CoreACHSubscriptionFeeItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'CoreAdjustmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'CoreCashForwardItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'CoreCollectionItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'CoreDebtCollectionItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'CoreDividendsItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'CoreEmployeeCreditItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'CoreFeeInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'CoreFoundMoneyRewardItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'CoreGiftCardCreditRedemptionItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'CoreHoldingsTransferInItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'CoreInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'CoreLocalFoundMoneyItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'CorePartnerRewardItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'CoreRebalanceItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'CoreReferralRewardItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'CoreRefundedItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'CoreReinvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'CoreRoundUpsItem'
        type: RoundUpType
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'CoreWithdrawalItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'EarlyDebtCollectionItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'EarlyDividendsItem'
        beneficiaryId: string
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'EarlyFeeInvestmentItem'
        beneficiaryId: string
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'EarlyGiftItem'
        beneficiaryId: string
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'EarlyInvestmentItem'
        beneficiaryId: string
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'EarlyMatchItem'
        beneficiaryId: string
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'EarlyMatchRemovalItem'
        beneficiaryId: string
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'EarlyRefundedItem'
        beneficiaryId: string
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'EarlyReinvestmentItem'
        beneficiaryId: string
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'EarlyWithdrawalItem'
        beneficiaryId: string
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'LaterDebtCollectionItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'LaterDividendsItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'LaterFeeInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'LaterInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'LaterMatchItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'LaterMatchRemovalItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'LaterRebalanceItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'LaterRefundedItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'LaterReinvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'LaterWithdrawalItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastAcornsRewardInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastBeneficiaryTransferInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastCashOwedCollectionInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastCashReinvestmentInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastCoreItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastDividendInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastEmployeeContributionInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastExternalTransferInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastExternalTransferReversedInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastFeeInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastGiftCardInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastIRATransferInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastInvestmentTipItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastLumpSumInvestment'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastMatchInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastMatchRemovalInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastOutsideContributionInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastRealTimeRoundUpInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastRebalanceInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastRecurringInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastReferralRewardInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastReferralRewardMatchInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastRefundInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastReversalInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastRewardInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastRewardMatchInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastRoundUpItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastRoundUpMatchInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastSecurityLiquidationInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastSmartDepositInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastSpendItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastStreakRewardInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastTipsThatGrowMatchInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'PastWithdrawalInvestmentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'SaveInterestPaidItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'SaveTransferInItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'SaveTransferOutItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'SpendATMReimbursementItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'SpendATMWithdrawalItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'SpendBillPayItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'SpendCheckDepositItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'SpendCheckPaymentItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'SpendDigitalWalletItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'SpendDirectDepositItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'SpendECheckItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'SpendInterestPaidItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'SpendPurchaseItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'SpendRealTimeRoundUpItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'SpendTransferInItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
    | {
        __typename: 'SpendTransferOutItem'
        productType: ProductType
        id: string
        createdAt: any
        updatedAt: any
        title: string
        status: PastItemStatus
        drawerInclusion: boolean
        amount: {
          __typename?: 'CurrencyAmount'
          currency: Currency
          value: number
        }
      }
  >
  beneficiaries: Array<{
    __typename?: 'Beneficiary'
    id: string
    firstName: string
  }>
}

export type HomeTierSubscriptionForUserQueryVariables = Exact<{
  [key: string]: never
}>

export type HomeTierSubscriptionForUserQuery = {
  __typename?: 'Query'
  tierSubscriptionForUser:
    | {
        __typename?: 'TierSubscription'
        id: string
        tier: {
          __typename?: 'Tier'
          id: string
          key: TierKey
          name: string
          includedProducts: Array<{
            __typename?: 'TierProduct'
            key: ProductKey
          }>
          excludedProducts: Array<{
            __typename?: 'TierProduct'
            key: ProductKey
          }>
          products: Array<{
            __typename?: 'Product'
            active: boolean
            key: ProductKey
            name: string
          }>
        }
        tierPrice: {
          __typename?: 'TierPrice'
          id: string
          billingFrequency: BillingFrequency
          amount: {
            __typename?: 'CurrencyAmount'
            value: number
            currency: Currency
          }
        }
      }
    | { __typename?: 'TierSubscriptionNotFound' }
    | { __typename?: 'TierSubscriptionUnsubscribed' }
}

type SplitDepositSettingsPartial_SplitDepositDirectDepositIntentSetting_Fragment =
  {
    __typename: 'SplitDepositDirectDepositIntentSetting'
    id: string
    isActive: boolean
    isHidden: boolean
    isUsingRecommendedAllocations: boolean
    name: string
    allocations: Array<{
      __typename?: 'SplitDepositDirectDepositAllocation'
      allocationPercent: string
      targetAccountId: string
      targetAccountType: SplitDepositTargetAccountType
      nickname: string
      normalizedAmount: {
        __typename?: 'FormattedMonetaryAmount'
        value: string
      }
    }>
    deposits: Array<{
      __typename?: 'SplitDeposit'
      createdAt: string
      distributedAt: string
      expectedNextDepositAmount: string
      expectedNextDepositAt: string
      id: string
      isActive: boolean
      isCancelable: boolean
      isUsingRecommendedAllocations: boolean
      transactionAmount: string
      willDistributeAutomaticallyAt: string
      allocations: Array<
        | {
            __typename?: 'SplitDepositDirectDepositAllocation'
            allocationPercent: string
            targetAccountId: string
            targetAccountType: SplitDepositTargetAccountType
            nickname: string
            normalizedAmount: {
              __typename?: 'FormattedMonetaryAmount'
              value: string
            }
          }
        | { __typename?: 'SplitDepositRecurrenceAllocation' }
      >
    }>
    estimatedPaycheckAmount: { __typename?: 'CurrencyAmount'; value: number }
  }

type SplitDepositSettingsPartial_SplitDepositDirectDepositSetting_Fragment = {
  __typename: 'SplitDepositDirectDepositSetting'
  id: string
  isActive: boolean
  isHidden: boolean
  isUsingRecommendedAllocations: boolean
  awaitingConfiguration: boolean
  name: string
  allocations: Array<{
    __typename?: 'SplitDepositDirectDepositAllocation'
    allocationPercent: string
    targetAccountId: string
    targetAccountType: SplitDepositTargetAccountType
    nickname: string
    normalizedAmount: { __typename?: 'FormattedMonetaryAmount'; value: string }
  }>
  deposits: Array<{
    __typename?: 'SplitDeposit'
    createdAt: string
    distributedAt: string
    expectedNextDepositAmount: string
    expectedNextDepositAt: string
    id: string
    isActive: boolean
    isCancelable: boolean
    isUsingRecommendedAllocations: boolean
    transactionAmount: string
    willDistributeAutomaticallyAt: string
    allocations: Array<
      | {
          __typename?: 'SplitDepositDirectDepositAllocation'
          allocationPercent: string
          targetAccountId: string
          targetAccountType: SplitDepositTargetAccountType
          nickname: string
          normalizedAmount: {
            __typename?: 'FormattedMonetaryAmount'
            value: string
          }
        }
      | { __typename?: 'SplitDepositRecurrenceAllocation' }
    >
  }>
}

type SplitDepositSettingsPartial_SplitDepositRecurrenceSetting_Fragment = {
  __typename: 'SplitDepositRecurrenceSetting'
  id: string
  isActive: boolean
  isHidden: boolean
  allocations: Array<{ __typename?: 'SplitDepositRecurrenceAllocation' }>
  deposits: Array<{
    __typename?: 'SplitDeposit'
    createdAt: string
    distributedAt: string
    expectedNextDepositAmount: string
    expectedNextDepositAt: string
    id: string
    isActive: boolean
    isCancelable: boolean
    isUsingRecommendedAllocations: boolean
    transactionAmount: string
    willDistributeAutomaticallyAt: string
    allocations: Array<
      | {
          __typename?: 'SplitDepositDirectDepositAllocation'
          allocationPercent: string
          targetAccountId: string
          targetAccountType: SplitDepositTargetAccountType
          nickname: string
          normalizedAmount: {
            __typename?: 'FormattedMonetaryAmount'
            value: string
          }
        }
      | { __typename?: 'SplitDepositRecurrenceAllocation' }
    >
  }>
}

export type SplitDepositSettingsPartialFragment =
  | SplitDepositSettingsPartial_SplitDepositDirectDepositIntentSetting_Fragment
  | SplitDepositSettingsPartial_SplitDepositDirectDepositSetting_Fragment
  | SplitDepositSettingsPartial_SplitDepositRecurrenceSetting_Fragment

export type PresentInvestmentsTotalsQueryQueryVariables = Exact<{
  settingTypes: Array<SplitDepositSettingType> | SplitDepositSettingType
}>

export type PresentInvestmentsTotalsQueryQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    firstName: string
    verified: boolean
    closedAt: any
    state: any
    fundingSource: {
      __typename?: 'FundingSource'
      name: string
      verified: boolean
    }
  }
  userAlerts: Array<
    | { __typename: 'AddressDocumentRequestedUserAlert' }
    | { __typename: 'BankDocumentRequestedUserAlert' }
    | { __typename: 'IdentityDocumentRequestedUserAlert' }
    | { __typename: 'InsufficientFundsUserAlert' }
    | { __typename: 'InvestmentsPausedUserAlert' }
    | { __typename: 'MiscDocumentRequestedUserAlert' }
    | { __typename: 'NoFundingSourceUserAlert' }
    | { __typename: 'RdvRequiredUserAlert' }
    | { __typename: 'SSNDocumentRequestedUserAlert' }
    | { __typename: 'UserAlert' }
    | { __typename: 'W9DocumentRequestedUserAlert' }
  >
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    createdAt: any
    isLocked: boolean
    id: string
    type: BankAccountType
    status: BankAccountStatus
    isEligible: boolean
    availableBalance: {
      __typename?: 'CurrencyAmount'
      currency: Currency
      value: number
    }
    pendingBalance: {
      __typename?: 'CurrencyAmount'
      currency: Currency
      value: number
    }
    goals: {
      __typename?: 'BankAccountGoals'
      currentGoal: { __typename?: 'BankAccountGoal'; type: BankAccountGoalType }
    }
  }>
  allInvestmentAccounts: Array<{
    __typename?: 'InvestmentAccount'
    type: string
    name: string
    currentBalance: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
  }>
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    type: string
    name: string
    closedAt: any
    currentBalance: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
  }>
  eligibility: { __typename?: 'Eligibility'; eligible: boolean }
  beneficiaries: Array<{
    __typename?: 'Beneficiary'
    firstName: string
    id: string
    investmentAccount: {
      __typename?: 'InvestmentAccount'
      id: string
      netInvestments: { __typename?: 'MonetaryAmount'; value: number }
    }
  }>
  splitDepositSettingsByUserId: Array<
    | {
        __typename: 'SplitDepositDirectDepositIntentSetting'
        id: string
        isActive: boolean
        isHidden: boolean
        isUsingRecommendedAllocations: boolean
        name: string
        allocations: Array<{
          __typename?: 'SplitDepositDirectDepositAllocation'
          allocationPercent: string
          targetAccountId: string
          targetAccountType: SplitDepositTargetAccountType
          nickname: string
          normalizedAmount: {
            __typename?: 'FormattedMonetaryAmount'
            value: string
          }
        }>
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          expectedNextDepositAmount: string
          expectedNextDepositAt: string
          id: string
          isActive: boolean
          isCancelable: boolean
          isUsingRecommendedAllocations: boolean
          transactionAmount: string
          willDistributeAutomaticallyAt: string
          allocations: Array<
            | {
                __typename?: 'SplitDepositDirectDepositAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                nickname: string
                normalizedAmount: {
                  __typename?: 'FormattedMonetaryAmount'
                  value: string
                }
              }
            | { __typename?: 'SplitDepositRecurrenceAllocation' }
          >
        }>
        estimatedPaycheckAmount: {
          __typename?: 'CurrencyAmount'
          value: number
        }
      }
    | {
        __typename: 'SplitDepositDirectDepositSetting'
        id: string
        isActive: boolean
        isHidden: boolean
        isUsingRecommendedAllocations: boolean
        awaitingConfiguration: boolean
        name: string
        allocations: Array<{
          __typename?: 'SplitDepositDirectDepositAllocation'
          allocationPercent: string
          targetAccountId: string
          targetAccountType: SplitDepositTargetAccountType
          nickname: string
          normalizedAmount: {
            __typename?: 'FormattedMonetaryAmount'
            value: string
          }
        }>
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          expectedNextDepositAmount: string
          expectedNextDepositAt: string
          id: string
          isActive: boolean
          isCancelable: boolean
          isUsingRecommendedAllocations: boolean
          transactionAmount: string
          willDistributeAutomaticallyAt: string
          allocations: Array<
            | {
                __typename?: 'SplitDepositDirectDepositAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                nickname: string
                normalizedAmount: {
                  __typename?: 'FormattedMonetaryAmount'
                  value: string
                }
              }
            | { __typename?: 'SplitDepositRecurrenceAllocation' }
          >
        }>
      }
    | {
        __typename: 'SplitDepositRecurrenceSetting'
        id: string
        isActive: boolean
        isHidden: boolean
        allocations: Array<{ __typename?: 'SplitDepositRecurrenceAllocation' }>
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          expectedNextDepositAmount: string
          expectedNextDepositAt: string
          id: string
          isActive: boolean
          isCancelable: boolean
          isUsingRecommendedAllocations: boolean
          transactionAmount: string
          willDistributeAutomaticallyAt: string
          allocations: Array<
            | {
                __typename?: 'SplitDepositDirectDepositAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                nickname: string
                normalizedAmount: {
                  __typename?: 'FormattedMonetaryAmount'
                  value: string
                }
              }
            | { __typename?: 'SplitDepositRecurrenceAllocation' }
          >
        }>
      }
  >
}

export type BeneficiaryFieldsFragment = {
  __typename?: 'Beneficiary'
  firstName: string
  id: string
  investmentAccount: {
    __typename?: 'InvestmentAccount'
    id: string
    netInvestments: { __typename?: 'MonetaryAmount'; value: number }
  }
}

export type InvestmentAccountFieldsFragment = {
  __typename?: 'InvestmentAccount'
  id: string
  netInvestments: { __typename?: 'MonetaryAmount'; value: number }
}

export type ReferralPillQueryVariables = Exact<{ [key: string]: never }>

export type ReferralPillQuery = {
  __typename?: 'Query'
  advocate: {
    __typename?: 'Advocate'
    experienceContent: { __typename?: 'ExperienceContent'; pillAmount: string }
  }
}

export type ResumeDepositsMutationVariables = Exact<{ [key: string]: never }>

export type ResumeDepositsMutation = {
  __typename?: 'Mutation'
  suspendDeposits: any
}

export type RecurringInvestmentSettingsDetailsFragment = {
  __typename?: 'RecurringInvestmentSettings'
  amount: number
  day: number
  frequency: InvestmentFrequency
}

export type RoundUpProfileDetailsFragment = {
  __typename: 'RoundUpProfile'
  roundUpsEnabled: boolean
  multiplier: number
  roundUpAccounts: Array<{ __typename?: 'RoundUpAccount'; enabled: boolean }>
}

export type CoreInfoQueryVariables = Exact<{ [key: string]: never }>

export type CoreInfoQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    fundingSource: {
      __typename?: 'FundingSource'
      alert: any
      name: string
      verified: boolean
    }
    investmentAccounts: Array<{
      __typename?: 'InvestmentAccount'
      closedAt: any
      product: InvestmentProduct
      portfolio: {
        __typename?: 'Portfolio'
        id: string
        name: string
        theme: PortfolioTheme
      }
    }>
  }
  investmentAccount: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    closedAt: any
    currentBalance: { __typename?: 'MonetaryAmount'; value: number }
    portfolio: {
      __typename?: 'Portfolio'
      id: string
      name: string
      theme: PortfolioTheme
    }
    portfolios: Array<
      | {
          __typename: 'Portfolio'
          id: string
          portfolioSecurities: Array<{
            __typename?: 'PortfolioSecurity'
            symbol: string
          }>
        }
      | {
          __typename: 'SelfDirectedPortfolio'
          id: string
          portfolioSecurities: Array<{
            __typename?: 'PortfolioSecurity'
            symbol: string
          }>
        }
    >
  }>
  userStatus: { __typename?: 'UserStatus'; verified: boolean }
  recurringInvestmentSettings: {
    __typename?: 'RecurringInvestmentSettings'
    amount: number
    day: number
    frequency: InvestmentFrequency
  }
  roundUpProfile: {
    __typename: 'RoundUpProfile'
    roundUpsEnabled: boolean
    multiplier: number
    roundUpAccounts: Array<{ __typename?: 'RoundUpAccount'; enabled: boolean }>
  }
  tierSubscriptionByUserId: {
    __typename?: 'TierSubscription'
    id: string
    tier: { __typename?: 'Tier'; id: string; name: string }
  }
  spendAccount: { __typename?: 'SpendAccount'; status: SpendAccountStatus }
}

export type InvestmentAccountCoreQueryVariables = Exact<{
  withSmartDeposit?: InputMaybe<Scalars['Boolean']>
}>

export type InvestmentAccountCoreQuery = {
  __typename?: 'Query'
  investAccount: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    closedAt: any
    status: InvestmentAccountStatus
    userAge: number
    currentBalance: { __typename?: 'MonetaryAmount'; value: number }
    recurringInvestmentSettings: {
      __typename?: 'RecurringInvestmentSettings'
      frequency: InvestmentFrequency
      day: number
      amount: number
    }
  }>
  laterAccount: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    status: InvestmentAccountStatus
    currentBalance: { __typename?: 'MonetaryAmount'; value: number }
    recurringInvestmentSettings: {
      __typename?: 'RecurringInvestmentSettings'
      frequency: InvestmentFrequency
      day: number
      amount: number
    }
  }>
  user: {
    __typename?: 'User'
    fundingSource: { __typename?: 'FundingSource'; verified: boolean }
  }
  roundUpProfile: {
    __typename?: 'RoundUpProfile'
    roundUpsEnabled: boolean
    multiplier: number
    roundUpAccounts: Array<{
      __typename?: 'RoundUpAccount'
      linkedSubaccountId: string
    }>
  }
  roundUpAccounts: Array<{ __typename?: 'RoundUpAccount'; enabled: boolean }>
  settings: { __typename?: 'Settings'; depositsSuspended: boolean }
  tierSubscriptionForUser:
    | {
        __typename: 'TierSubscription'
        id: string
        tier: {
          __typename?: 'Tier'
          id: string
          key: TierKey
          includedProducts: Array<{
            __typename?: 'TierProduct'
            key: ProductKey
          }>
          excludedProducts: Array<{
            __typename?: 'TierProduct'
            key: ProductKey
          }>
        }
      }
    | { __typename: 'TierSubscriptionNotFound' }
    | { __typename: 'TierSubscriptionUnsubscribed' }
  splitDepositSettingsByUserId?: Array<
    | {
        __typename: 'SplitDepositDirectDepositIntentSetting'
        id: string
        isActive: boolean
        isHidden: boolean
        isUsingRecommendedAllocations: boolean
        name: string
        allocations: Array<{
          __typename?: 'SplitDepositDirectDepositAllocation'
          allocationPercent: string
          targetAccountId: string
          targetAccountType: SplitDepositTargetAccountType
          nickname: string
          normalizedAmount: {
            __typename?: 'FormattedMonetaryAmount'
            value: string
          }
        }>
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          expectedNextDepositAmount: string
          expectedNextDepositAt: string
          id: string
          isActive: boolean
          isCancelable: boolean
          isUsingRecommendedAllocations: boolean
          transactionAmount: string
          willDistributeAutomaticallyAt: string
          allocations: Array<
            | {
                __typename?: 'SplitDepositDirectDepositAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                nickname: string
                normalizedAmount: {
                  __typename?: 'FormattedMonetaryAmount'
                  value: string
                }
              }
            | { __typename?: 'SplitDepositRecurrenceAllocation' }
          >
        }>
        estimatedPaycheckAmount: {
          __typename?: 'CurrencyAmount'
          value: number
        }
      }
    | {
        __typename: 'SplitDepositDirectDepositSetting'
        id: string
        isActive: boolean
        isHidden: boolean
        isUsingRecommendedAllocations: boolean
        awaitingConfiguration: boolean
        name: string
        allocations: Array<{
          __typename?: 'SplitDepositDirectDepositAllocation'
          allocationPercent: string
          targetAccountId: string
          targetAccountType: SplitDepositTargetAccountType
          nickname: string
          normalizedAmount: {
            __typename?: 'FormattedMonetaryAmount'
            value: string
          }
        }>
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          expectedNextDepositAmount: string
          expectedNextDepositAt: string
          id: string
          isActive: boolean
          isCancelable: boolean
          isUsingRecommendedAllocations: boolean
          transactionAmount: string
          willDistributeAutomaticallyAt: string
          allocations: Array<
            | {
                __typename?: 'SplitDepositDirectDepositAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                nickname: string
                normalizedAmount: {
                  __typename?: 'FormattedMonetaryAmount'
                  value: string
                }
              }
            | { __typename?: 'SplitDepositRecurrenceAllocation' }
          >
        }>
      }
    | {
        __typename: 'SplitDepositRecurrenceSetting'
        id: string
        isActive: boolean
        isHidden: boolean
        allocations: Array<{ __typename?: 'SplitDepositRecurrenceAllocation' }>
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          expectedNextDepositAmount: string
          expectedNextDepositAt: string
          id: string
          isActive: boolean
          isCancelable: boolean
          isUsingRecommendedAllocations: boolean
          transactionAmount: string
          willDistributeAutomaticallyAt: string
          allocations: Array<
            | {
                __typename?: 'SplitDepositDirectDepositAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                nickname: string
                normalizedAmount: {
                  __typename?: 'FormattedMonetaryAmount'
                  value: string
                }
              }
            | { __typename?: 'SplitDepositRecurrenceAllocation' }
          >
        }>
      }
  >
  spendAccount: {
    __typename?: 'SpendAccount'
    isEligible: boolean
    status: SpendAccountStatus
  }
}

export type UpdateRoundupProfileMutationVariables = Exact<{
  input: RoundUpProfileInput
}>

export type UpdateRoundupProfileMutation = {
  __typename?: 'Mutation'
  roundUpProfile: {
    __typename?: 'RoundUpProfile'
    multiplier: number
    roundUpsEnabled: boolean
  }
}

export type ProductPortfolioFundDetailsQueryVariables = Exact<{
  product: InvestmentProduct
}>

export type ProductPortfolioFundDetailsQuery = {
  __typename?: 'Query'
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    closedAt: any
    portfolios: Array<
      | {
          __typename: 'Portfolio'
          id: string
          customizationLevel: PortfolioCustomizationLevel
          portfolioSecurities: Array<{
            __typename?: 'PortfolioSecurity'
            id: string
            name: string
            shares: number
            symbol: string
            currentAllocationPercentage: number
            marketValue: {
              __typename?: 'MonetaryAmount'
              currency: Currency
              value: number
            }
            todaysReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: {
                __typename?: 'MonetaryAmount'
                currency: Currency
                value: number
              }
            }
            totalReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: {
                __typename?: 'MonetaryAmount'
                currency: Currency
                value: number
              }
            }
          }>
          portfolioSecurityAllocations: Array<{
            __typename?: 'PortfolioSecurityAllocation'
            allocationPercent: number
            symbol: string
          }>
        }
      | {
          __typename: 'SelfDirectedPortfolio'
          id: string
          name: string
          accountAllocation: {
            __typename?: 'PortfolioAllocation'
            allocationPercent: number
          }
          portfolioSecurityAllocations: Array<{
            __typename?: 'PortfolioSecurityAllocation'
            allocationPercent: number
            symbol: string
          }>
          portfolioSecurities: Array<{
            __typename?: 'PortfolioSecurity'
            id: string
            name: string
            shares: number
            symbol: string
            currentAllocationPercentage: number
            marketValue: {
              __typename?: 'MonetaryAmount'
              currency: Currency
              value: number
            }
            todaysReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: {
                __typename?: 'MonetaryAmount'
                currency: Currency
                value: number
              }
            }
            totalReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: {
                __typename?: 'MonetaryAmount'
                currency: Currency
                value: number
              }
            }
          }>
        }
    >
    recurringInvestmentSettings: {
      __typename?: 'RecurringInvestmentSettings'
      nextInvestmentAt: any
    }
  }>
}

export type MarketValueFieldsFragment = {
  __typename?: 'MarketReturn'
  marketValue: {
    __typename?: 'MonetaryAmount'
    currency: Currency
    value: number
  }
}

export type PortfolioSecuritiesFragment = {
  __typename?: 'PortfolioSecurity'
  id: string
  name: string
  shares: number
  symbol: string
  currentAllocationPercentage: number
  marketValue: {
    __typename?: 'MonetaryAmount'
    currency: Currency
    value: number
  }
  todaysReturn: {
    __typename?: 'MarketReturn'
    percent: number
    marketValue: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
  }
  totalReturn: {
    __typename?: 'MarketReturn'
    percent: number
    marketValue: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
  }
}

type SecurityBySymbolInfo_Fund_Fragment = {
  __typename?: 'Fund'
  displayName: string
  numberOfHoldings: number
  type: SecurityType
  symbol: any
  longName: string
  shortName: string
  marketCap: any
  volume: any
  lastUpdatedAt: any
  topHoldings: Array<{
    __typename?: 'TopHolding'
    securityName: string
    symbol: any
    sharePercentage: any
    marketValue: {
      __typename?: 'BigCurrencyAmount'
      value: any
      currency: Currency
    }
  }>
  currentPrice: { __typename?: 'BigCurrencyAmount'; value: any }
  profile: {
    __typename?: 'SecurityProfile'
    description: string
    tradingSectors: Array<TradingSector>
    logoUrl: any
  }
  lastClosePrice: { __typename?: 'BigCurrencyAmount'; value: any }
  openPrice: { __typename?: 'BigCurrencyAmount'; value: any }
  week52High: { __typename?: 'BigCurrencyAmount'; value: any }
  week52Low: { __typename?: 'BigCurrencyAmount'; value: any }
}

type SecurityBySymbolInfo_Stock_Fragment = {
  __typename?: 'Stock'
  type: SecurityType
  symbol: any
  longName: string
  shortName: string
  marketCap: any
  volume: any
  lastUpdatedAt: any
  displayName: string
  currentPrice: { __typename?: 'BigCurrencyAmount'; value: any }
  profile: {
    __typename?: 'SecurityProfile'
    description: string
    tradingSectors: Array<TradingSector>
    logoUrl: any
  }
  lastClosePrice: { __typename?: 'BigCurrencyAmount'; value: any }
  openPrice: { __typename?: 'BigCurrencyAmount'; value: any }
  week52High: { __typename?: 'BigCurrencyAmount'; value: any }
  week52Low: { __typename?: 'BigCurrencyAmount'; value: any }
}

export type SecurityBySymbolInfoFragment =
  | SecurityBySymbolInfo_Fund_Fragment
  | SecurityBySymbolInfo_Stock_Fragment

export type SecurityInfoQueryVariables = Exact<{
  symbol: Scalars['TickerSymbol']
}>

export type SecurityInfoQuery = {
  __typename?: 'Query'
  securityBySymbol:
    | {
        __typename?: 'Fund'
        displayName: string
        numberOfHoldings: number
        type: SecurityType
        symbol: any
        longName: string
        shortName: string
        marketCap: any
        volume: any
        lastUpdatedAt: any
        topHoldings: Array<{
          __typename?: 'TopHolding'
          securityName: string
          symbol: any
          sharePercentage: any
          marketValue: {
            __typename?: 'BigCurrencyAmount'
            value: any
            currency: Currency
          }
        }>
        currentPrice: { __typename?: 'BigCurrencyAmount'; value: any }
        profile: {
          __typename?: 'SecurityProfile'
          description: string
          tradingSectors: Array<TradingSector>
          logoUrl: any
        }
        lastClosePrice: { __typename?: 'BigCurrencyAmount'; value: any }
        openPrice: { __typename?: 'BigCurrencyAmount'; value: any }
        week52High: { __typename?: 'BigCurrencyAmount'; value: any }
        week52Low: { __typename?: 'BigCurrencyAmount'; value: any }
      }
    | {
        __typename?: 'Stock'
        type: SecurityType
        symbol: any
        longName: string
        shortName: string
        marketCap: any
        volume: any
        lastUpdatedAt: any
        displayName: string
        currentPrice: { __typename?: 'BigCurrencyAmount'; value: any }
        profile: {
          __typename?: 'SecurityProfile'
          description: string
          tradingSectors: Array<TradingSector>
          logoUrl: any
        }
        lastClosePrice: { __typename?: 'BigCurrencyAmount'; value: any }
        openPrice: { __typename?: 'BigCurrencyAmount'; value: any }
        week52High: { __typename?: 'BigCurrencyAmount'; value: any }
        week52Low: { __typename?: 'BigCurrencyAmount'; value: any }
      }
}

export type SecurityPerformanceBySymbolFragment = {
  __typename?: 'SecurityPerformance'
  gain: {
    __typename?: 'SecurityGain'
    percent: any
    marketValue: { __typename?: 'BigCurrencyAmount'; value: any }
  }
  prices: Array<{
    __typename?: 'SecurityPrice'
    timestamp: any
    marketValue: { __typename?: 'BigCurrencyAmount'; value: any }
  }>
}

export type SecurityPerformanceQueryVariables = Exact<{
  symbol: Scalars['TickerSymbol']
  startDate: Scalars['DateTime']
  endDate: Scalars['DateTime']
}>

export type SecurityPerformanceQuery = {
  __typename?: 'Query'
  securityPerformanceBySymbol: {
    __typename?: 'SecurityPerformance'
    gain: {
      __typename?: 'SecurityGain'
      percent: any
      marketValue: { __typename?: 'BigCurrencyAmount'; value: any }
    }
    prices: Array<{
      __typename?: 'SecurityPrice'
      timestamp: any
      marketValue: { __typename?: 'BigCurrencyAmount'; value: any }
    }>
  }
}

export type FundingSourceQueryQueryVariables = Exact<{ [key: string]: never }>

export type FundingSourceQueryQuery = {
  __typename?: 'Query'
  fundingSourceAccounts: Array<{
    __typename?: 'FundingSourceAccount'
    institutionName: string
    verified: boolean
    role: FundingSourceRoleEnum
    id: number
    accountName: string
  }>
  investmentAccount: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    closedAt: any
    currentBalance: { __typename?: 'MonetaryAmount'; value: number }
    portfolio: {
      __typename?: 'Portfolio'
      id: string
      name: string
      theme: PortfolioTheme
    }
    portfolios: Array<
      | {
          __typename: 'Portfolio'
          id: string
          portfolioSecurities: Array<{
            __typename?: 'PortfolioSecurity'
            symbol: string
          }>
        }
      | {
          __typename: 'SelfDirectedPortfolio'
          id: string
          portfolioSecurities: Array<{
            __typename?: 'PortfolioSecurity'
            symbol: string
          }>
        }
    >
  }>
}

export type CustomPortfolioAcceptDocumentMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type CustomPortfolioAcceptDocumentMutation = {
  __typename?: 'Mutation'
  agreeToAcceptanceDocument: any
}

export type AddSelfDirectedPortfolioMutationVariables = Exact<{
  input: AddSelfDirectedPortfolioInput
}>

export type AddSelfDirectedPortfolioMutation = {
  __typename?: 'Mutation'
  addSelfDirectedPortfolio:
    | { __typename: 'CustomerAgreementRequiredException' }
    | { __typename: 'InvalidInvestmentAccountException' }
    | { __typename: 'InvalidSubscriptionTierException' }
    | {
        __typename: 'InvestmentAccount'
        portfolios: Array<
          | { __typename: 'Portfolio'; id: string }
          | {
              __typename: 'SelfDirectedPortfolio'
              id: string
              portfolioSecurityAllocations: Array<{
                __typename?: 'PortfolioSecurityAllocation'
                id: string
                allocationPercent: number
                symbol: string
              }>
            }
        >
      }
    | { __typename: 'PortfolioNotFoundException' }
}

export type CustomPortfolioAllAcceptanceDocumentsQueryVariables = Exact<{
  [key: string]: never
}>

export type CustomPortfolioAllAcceptanceDocumentsQuery = {
  __typename?: 'Query'
  allAcceptanceDocuments: Array<{
    __typename?: 'AcceptanceDocument'
    id: string
    name: string
    url: any
  }>
}

export type CustomPortfolioAllTiersQueryVariables = Exact<{
  [key: string]: never
}>

export type CustomPortfolioAllTiersQuery = {
  __typename?: 'Query'
  tierGroupForUser: {
    __typename?: 'TierGroup'
    id: string
    tierOptions: Array<{
      __typename?: 'TierOption'
      tier: {
        __typename?: 'Tier'
        id: string
        key: TierKey
        name: string
        products: Array<{ __typename?: 'Product'; key: ProductKey }>
        tierPrice: {
          __typename?: 'TierPrice'
          id: string
          amount: { __typename?: 'CurrencyAmount'; value: number }
        }
      }
    }>
  }
}

export type CustomPortfolioFundingSourceInfoQueryVariables = Exact<{
  [key: string]: never
}>

export type CustomPortfolioFundingSourceInfoQuery = {
  __typename?: 'Query'
  fundingSourceInfo: {
    __typename?: 'FundingSourceInfo'
    type: FundingSourceType
  }
}

export type InvestCorePortfolioQueryVariables = Exact<{
  product?: InputMaybe<InvestmentProduct>
}>

export type InvestCorePortfolioQuery = {
  __typename?: 'Query'
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    closedAt: any
    product: InvestmentProduct
    name: string
    status: InvestmentAccountStatus
    currentBalance: { __typename?: 'MonetaryAmount'; value: number }
    portfolio: {
      __typename?: 'Portfolio'
      id: string
      riskLevel: PortfolioRiskLevel
      theme: PortfolioTheme
    }
    portfolios: Array<
      | {
          __typename: 'Portfolio'
          id: string
          name: string
          description: string
          accountAllocation: {
            __typename?: 'PortfolioAllocation'
            allocationPercent: number
          }
          portfolioSecurities: Array<{
            __typename?: 'PortfolioSecurity'
            symbol: string
            marketValue: {
              __typename?: 'MonetaryAmount'
              currency: Currency
              value: number
            }
          }>
          portfolioSecurityAllocations: Array<{
            __typename?: 'PortfolioSecurityAllocation'
            id: string
            symbol: string
            allocationPercent: number
            security:
              | {
                  __typename?: 'Fund'
                  displayName: string
                  longName: string
                  type: SecurityType
                  currentPrice: {
                    __typename?: 'BigCurrencyAmount'
                    value: any
                    currency: Currency
                  }
                  profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                }
              | {
                  __typename?: 'Stock'
                  displayName: string
                  longName: string
                  type: SecurityType
                  currentPrice: {
                    __typename?: 'BigCurrencyAmount'
                    value: any
                    currency: Currency
                  }
                  profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                }
          }>
        }
      | {
          __typename: 'SelfDirectedPortfolio'
          status: SelfDirectedPortfolioStatus
          id: string
          name: string
          description: string
          accountAllocation: {
            __typename?: 'PortfolioAllocation'
            allocationPercent: number
          }
          portfolioSecurities: Array<{
            __typename?: 'PortfolioSecurity'
            symbol: string
            marketValue: {
              __typename?: 'MonetaryAmount'
              currency: Currency
              value: number
            }
          }>
          portfolioSecurityAllocations: Array<{
            __typename?: 'PortfolioSecurityAllocation'
            id: string
            symbol: string
            allocationPercent: number
            security:
              | {
                  __typename?: 'Fund'
                  displayName: string
                  longName: string
                  type: SecurityType
                  currentPrice: {
                    __typename?: 'BigCurrencyAmount'
                    value: any
                    currency: Currency
                  }
                  profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                }
              | {
                  __typename?: 'Stock'
                  displayName: string
                  longName: string
                  type: SecurityType
                  currentPrice: {
                    __typename?: 'BigCurrencyAmount'
                    value: any
                    currency: Currency
                  }
                  profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                }
          }>
        }
    >
    recommendedPortfolio: {
      __typename?: 'Portfolio'
      id: string
      minimumManagedAllocationPercent: number
      riskLevel: PortfolioRiskLevel
    }
    recurringInvestmentSettings: {
      __typename?: 'RecurringInvestmentSettings'
      amount: number
      day: number
      frequency: InvestmentFrequency
      createdAt: any
      nextInvestmentAt: any
      updatedAt: any
    }
  }>
}

export type LanderOperationsQueryVariables = Exact<{ [key: string]: never }>

export type LanderOperationsQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    verified: boolean
    investmentAccounts: Array<{
      __typename?: 'InvestmentAccount'
      product: InvestmentProduct
    }>
  }
  userAlerts: Array<
    | { __typename?: 'AddressDocumentRequestedUserAlert' }
    | { __typename?: 'BankDocumentRequestedUserAlert' }
    | { __typename?: 'IdentityDocumentRequestedUserAlert' }
    | { __typename?: 'InsufficientFundsUserAlert' }
    | { __typename?: 'InvestmentsPausedUserAlert' }
    | { __typename?: 'MiscDocumentRequestedUserAlert' }
    | { __typename?: 'NoFundingSourceUserAlert' }
    | { __typename?: 'RdvRequiredUserAlert' }
    | { __typename?: 'SSNDocumentRequestedUserAlert' }
    | { __typename?: 'UserAlert'; type: string }
    | { __typename?: 'W9DocumentRequestedUserAlert' }
  >
}

export type SearchForSecurityQueryVariables = Exact<{
  input: SearchSecuritiesInput
}>

export type SearchForSecurityQuery = {
  __typename?: 'Query'
  searchSecurities: {
    __typename?: 'SearchSecuritiesResponse'
    securities: Array<
      | {
          __typename?: 'Fund'
          symbol: any
          longName: string
          shortName: string
          type: SecurityType
          currentPrice: { __typename?: 'BigCurrencyAmount'; value: any }
          profile: { __typename?: 'SecurityProfile'; logoUrl: any }
          lastClosePrice: { __typename?: 'BigCurrencyAmount'; value: any }
          openPrice: { __typename?: 'BigCurrencyAmount'; value: any }
        }
      | {
          __typename?: 'Stock'
          symbol: any
          longName: string
          shortName: string
          type: SecurityType
          currentPrice: { __typename?: 'BigCurrencyAmount'; value: any }
          profile: { __typename?: 'SecurityProfile'; logoUrl: any }
          lastClosePrice: { __typename?: 'BigCurrencyAmount'; value: any }
          openPrice: { __typename?: 'BigCurrencyAmount'; value: any }
        }
    >
    pageInfo: {
      __typename?: 'SearchSecuritiesPageInfo'
      count: number
      hasPreviousPage: boolean
      totalMatches: number
      hasNextPage: boolean
      nextPageCursor: string
      prevPageCursor: string
    }
  }
}

export type SearchForSecurityBySectorQueryVariables = Exact<{
  input: SecuritiesBySectorInput
}>

export type SearchForSecurityBySectorQuery = {
  __typename?: 'Query'
  securitiesBySector: {
    __typename?: 'SecuritiesBySectorResponse'
    securities: Array<
      | {
          __typename?: 'Fund'
          symbol: any
          longName: string
          shortName: string
          type: SecurityType
          currentPrice: { __typename?: 'BigCurrencyAmount'; value: any }
          profile: { __typename?: 'SecurityProfile'; logoUrl: any }
          lastClosePrice: { __typename?: 'BigCurrencyAmount'; value: any }
          openPrice: { __typename?: 'BigCurrencyAmount'; value: any }
        }
      | {
          __typename?: 'Stock'
          symbol: any
          longName: string
          shortName: string
          type: SecurityType
          currentPrice: { __typename?: 'BigCurrencyAmount'; value: any }
          profile: { __typename?: 'SecurityProfile'; logoUrl: any }
          lastClosePrice: { __typename?: 'BigCurrencyAmount'; value: any }
          openPrice: { __typename?: 'BigCurrencyAmount'; value: any }
        }
    >
    pageInfo: {
      __typename?: 'SecuritiesBySectorPageInfo'
      count: number
      hasPreviousPage: boolean
      totalMatches: number
      hasNextPage: boolean
      nextPageCursor: string
      prevPageCursor: string
    }
  }
}

export type CustomPortfolioSubscribeUserToTierMutationVariables = Exact<{
  input: SubscribeUserToTierInput
}>

export type CustomPortfolioSubscribeUserToTierMutation = {
  __typename?: 'Mutation'
  subscribeUserToTier:
    | { __typename: 'InvalidTierPriceId' }
    | { __typename: 'TierDowngradeActionRequired' }
    | { __typename: 'TierSubscription'; id: string }
}

export type CustomPortfolioTierSubscriptionQueryVariables = Exact<{
  [key: string]: never
}>

export type CustomPortfolioTierSubscriptionQuery = {
  __typename?: 'Query'
  tierSubscriptionByUserId: {
    __typename?: 'TierSubscription'
    id: string
    tier: {
      __typename?: 'Tier'
      id: string
      active: boolean
      name: string
      tierPrice: {
        __typename?: 'TierPrice'
        id: string
        amount: { __typename?: 'CurrencyAmount'; value: number }
      }
      products: Array<{
        __typename?: 'Product'
        id: string
        key: ProductKey
        name: string
      }>
    }
  }
}

export type UpdatePortfolioSecuritiesMutationVariables = Exact<{
  investmentAccountId: Scalars['ID']
  portfolioId: Scalars['ID']
  securityAllocations:
    | Array<SecurityAllocationTarget>
    | SecurityAllocationTarget
}>

export type UpdatePortfolioSecuritiesMutation = {
  __typename?: 'Mutation'
  updatePortfolioSecurities:
    | { __typename: 'CustomerAgreementRequiredException' }
    | {
        __typename: 'InvalidAllocationPercentError'
        maxAllocationPercent: number
      }
    | { __typename: 'InvalidPortfolioRatiosException' }
    | { __typename: 'InvalidSecurityError'; securityId: string }
    | { __typename: 'InvalidSecurityForAllocationError' }
    | {
        __typename: 'InvestmentAccount'
        id: string
        product: InvestmentProduct
        name: string
        currentBalance: { __typename?: 'MonetaryAmount'; value: number }
        portfolio: {
          __typename?: 'Portfolio'
          id: string
          riskLevel: PortfolioRiskLevel
          theme: PortfolioTheme
        }
        portfolios: Array<
          | {
              __typename: 'Portfolio'
              id: string
              name: string
              description: string
              accountAllocation: {
                __typename?: 'PortfolioAllocation'
                allocationPercent: number
              }
              portfolioSecurityAllocations: Array<{
                __typename?: 'PortfolioSecurityAllocation'
                id: string
                symbol: string
                allocationPercent: number
                security:
                  | {
                      __typename?: 'Fund'
                      longName: string
                      displayName: string
                      profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                    }
                  | {
                      __typename?: 'Stock'
                      longName: string
                      displayName: string
                      profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                    }
              }>
            }
          | {
              __typename: 'SelfDirectedPortfolio'
              id: string
              name: string
              description: string
              accountAllocation: {
                __typename?: 'PortfolioAllocation'
                allocationPercent: number
              }
              portfolioSecurityAllocations: Array<{
                __typename?: 'PortfolioSecurityAllocation'
                id: string
                symbol: string
                allocationPercent: number
                security:
                  | {
                      __typename?: 'Fund'
                      longName: string
                      displayName: string
                      profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                    }
                  | {
                      __typename?: 'Stock'
                      longName: string
                      displayName: string
                      profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                    }
              }>
            }
        >
      }
    | { __typename: 'LiquidationUnavailableError' }
    | { __typename: 'NegativeSecurityPercentError'; securityId: string }
    | { __typename: 'PortfolioSecurityLimitReached' }
}

export type CoreRecurringPastEdgeFragment = {
  __typename?: 'PastItemEdge'
  node:
    | {
        __typename?: 'CoreACHSubscriptionFeeItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreAdjustmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreCashForwardItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreCollectionItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreDebtCollectionItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreDividendsItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreEmployeeCreditItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreFeeInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreFoundMoneyRewardItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreGiftCardCreditRedemptionItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreHoldingsTransferInItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreLocalFoundMoneyItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CorePartnerRewardItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreRebalanceItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreReferralRewardItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreRefundedItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreReinvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreRoundUpsItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreWithdrawalItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyDebtCollectionItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyDividendsItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyFeeInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyGiftItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyMatchItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyMatchRemovalItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyRefundedItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyReinvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyWithdrawalItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterDebtCollectionItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterDividendsItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterFeeInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterMatchItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterMatchRemovalItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterRebalanceItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterRefundedItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterReinvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterWithdrawalItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastAcornsRewardInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastBeneficiaryTransferInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastCashOwedCollectionInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastCashReinvestmentInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastCoreItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastDividendInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastEmployeeContributionInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastExternalTransferInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastExternalTransferReversedInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastFeeInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastGiftCardInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastIRATransferInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastInvestmentTipItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastLumpSumInvestment'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastMatchInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastMatchRemovalInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastOutsideContributionInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastRealTimeRoundUpInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastRebalanceInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastRecurringInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastReferralRewardInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastReferralRewardMatchInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastRefundInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastReversalInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastRewardInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastRewardMatchInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastRoundUpItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastRoundUpMatchInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastSecurityLiquidationInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastSmartDepositInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastSpendItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastStreakRewardInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastTipsThatGrowMatchInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastWithdrawalInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SaveInterestPaidItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SaveTransferInItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SaveTransferOutItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendATMReimbursementItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendATMWithdrawalItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendBillPayItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendCheckDepositItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendCheckPaymentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendDigitalWalletItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendDirectDepositItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendECheckItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendInterestPaidItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendPurchaseItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendRealTimeRoundUpItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendTransferInItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendTransferOutItem'
        id: string
        title: string
        status: PastItemStatus
      }
}

export type AllPastItemsCoreRecurringQueryVariables = Exact<{
  filter?: InputMaybe<AllPastItemsFilter>
  pagination?: InputMaybe<PageInput>
}>

export type AllPastItemsCoreRecurringQuery = {
  __typename?: 'Query'
  allPastItems: {
    __typename?: 'PastItemConnection'
    edges: Array<{
      __typename?: 'PastItemEdge'
      node:
        | {
            __typename?: 'CoreACHSubscriptionFeeItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreAdjustmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreCashForwardItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreCollectionItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreDebtCollectionItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreDividendsItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreEmployeeCreditItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreFeeInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreFoundMoneyRewardItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreGiftCardCreditRedemptionItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreHoldingsTransferInItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreLocalFoundMoneyItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CorePartnerRewardItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreRebalanceItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreReferralRewardItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreRefundedItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreReinvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreRoundUpsItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreWithdrawalItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyDebtCollectionItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyDividendsItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyFeeInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyGiftItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyMatchItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyMatchRemovalItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyRefundedItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyReinvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyWithdrawalItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterDebtCollectionItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterDividendsItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterFeeInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterMatchItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterMatchRemovalItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterRebalanceItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterRefundedItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterReinvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterWithdrawalItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastAcornsRewardInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastBeneficiaryTransferInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastCashOwedCollectionInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastCashReinvestmentInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastCoreItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastDividendInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastEmployeeContributionInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastExternalTransferInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastExternalTransferReversedInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastFeeInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastGiftCardInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastIRATransferInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastInvestmentTipItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastLumpSumInvestment'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastMatchInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastMatchRemovalInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastOutsideContributionInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastRealTimeRoundUpInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastRebalanceInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastRecurringInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastReferralRewardInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastReferralRewardMatchInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastRefundInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastReversalInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastRewardInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastRewardMatchInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastRoundUpItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastRoundUpMatchInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastSecurityLiquidationInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastSmartDepositInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastSpendItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastStreakRewardInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastTipsThatGrowMatchInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastWithdrawalInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SaveInterestPaidItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SaveTransferInItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SaveTransferOutItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendATMReimbursementItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendATMWithdrawalItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendBillPayItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendCheckDepositItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendCheckPaymentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendDigitalWalletItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendDirectDepositItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendECheckItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendInterestPaidItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendPurchaseItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendRealTimeRoundUpItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendTransferInItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendTransferOutItem'
            id: string
            title: string
            status: PastItemStatus
          }
    }>
  }
}

export type RoundupProfileQueryVariables = Exact<{ [key: string]: never }>

export type RoundupProfileQuery = {
  __typename?: 'Query'
  roundUpProfile: {
    __typename?: 'RoundUpProfile'
    roundUpsEnabled: boolean
    multiplier: number
    wholeDollarAmount: number
    roundUpTotal: number
    roundUpAccounts: Array<{
      __typename?: 'RoundUpAccount'
      linkedSubaccountId: string
      enabled: boolean
    }>
  }
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    createdAt: any
    id: string
  }>
}

export type UpdateRoundUpEnabledAndMultiplierMutationVariables = Exact<{
  input: RoundUpProfileInput
}>

export type UpdateRoundUpEnabledAndMultiplierMutation = {
  __typename?: 'Mutation'
  roundUpProfile: {
    __typename?: 'RoundUpProfile'
    multiplier: number
    roundUpsEnabled: boolean
  }
}

export type UpdateWholeDollarRoundupMutationVariables = Exact<{
  input: RoundUpProfileInput
}>

export type UpdateWholeDollarRoundupMutation = {
  __typename?: 'Mutation'
  roundUpProfile: { __typename?: 'RoundUpProfile'; wholeDollarAmount: number }
}

export type RoundUpsDepositsSuspendedQueryVariables = Exact<{
  [key: string]: never
}>

export type RoundUpsDepositsSuspendedQuery = {
  __typename?: 'Query'
  settings: { __typename: 'Settings'; depositsSuspended: boolean }
}

export type ManualRoundupMutationVariables = Exact<{
  roundUpIds: Array<Scalars['ID']> | Scalars['ID']
}>

export type ManualRoundupMutation = {
  __typename?: 'Mutation'
  setManualRoundUps: Array<{
    __typename: 'RoundUp'
    transactionId: string
    state: RoundUpState
    multiplier: number
    manual: boolean
    amount: number
    change: number
    name: string
    total: number
    transactionDate: any
    instant: boolean
    roundUpProfile: {
      __typename: 'RoundUpProfile'
      multiplier: number
      roundUpCount: number
      showRoundUpsProgress: boolean
      totalWaiting: number
      roundUpsInvested: number
      totalInvested: number
    }
  }>
}

export type RoundUpFieldsFragment = {
  __typename: 'RoundUp'
  transactionId: string
  state: RoundUpState
  multiplier: number
  manual: boolean
  amount: number
  change: number
  name: string
  total: number
  transactionDate: any
  instant: boolean
}

export type RoundUpProfileFieldsFragment = {
  __typename: 'RoundUpProfile'
  multiplier: number
  roundUpCount: number
  showRoundUpsProgress: boolean
  totalWaiting: number
  roundUpsInvested: number
  totalInvested: number
}

export type RoundUpsQueryVariables = Exact<{
  states: Array<RoundUpState> | RoundUpState
  after?: InputMaybe<Scalars['ID']>
  targetAccountId?: InputMaybe<Scalars['ID']>
}>

export type RoundUpsQuery = {
  __typename?: 'Query'
  roundUps: {
    __typename: 'RoundUpTypePagination'
    edges: Array<{
      __typename?: 'RoundUpTypeEdge'
      cursor: string
      node: {
        __typename: 'RoundUp'
        transactionId: string
        state: RoundUpState
        multiplier: number
        manual: boolean
        amount: number
        change: number
        name: string
        total: number
        transactionDate: any
        instant: boolean
      }
    }>
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean }
  }
}

export type RoundupsPageQueryVariables = Exact<{ [key: string]: never }>

export type RoundupsPageQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    fundingSource: { __typename?: 'FundingSource'; name: string }
  }
  settings: { __typename: 'Settings'; depositsSuspended: boolean }
  linkedAccounts: Array<{
    __typename?: 'LinkedAccount'
    id: string
    status: LinkedAccountStatusEnum
  }>
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    closedAt: any
    product: InvestmentProduct
  }>
  roundUpAccounts: Array<{ __typename?: 'RoundUpAccount'; enabled: boolean }>
  userStatus: { __typename?: 'UserStatus'; verified: boolean }
  roundUpProfile: {
    __typename: 'RoundUpProfile'
    multiplier: number
    roundUpCount: number
    showRoundUpsProgress: boolean
    totalWaiting: number
    roundUpsInvested: number
    totalInvested: number
  }
}

export type EstimatedTransferDateQueryVariables = Exact<{
  amount?: InputMaybe<CurrencyAmountInput>
  fromAccountType: TransferableAccountTypeEnum
  toAccountType: TransferableAccountTypeEnum
}>

export type EstimatedTransferDateQuery = {
  __typename?: 'Query'
  estimatedTransferDates: {
    __typename?: 'EstimatedTransferDatesPayload'
    estimatedTransferCompletedAt: any
  }
}

export type FundingSourceAccountsQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type FundingSourceAccountsQueryQuery = {
  __typename?: 'Query'
  fundingSourceAccounts: Array<{
    __typename?: 'FundingSourceAccount'
    accountName: string
    institutionName: string
    last4: string
    id: number
    role: FundingSourceRoleEnum
    fundType: FundingSourceType
    uuid: string
    verified: boolean
    preferredWithdrawalAccount: boolean
  }>
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    isLocked: boolean
    lockReason: BankAccountLockReason
    availableBalance: { __typename?: 'CurrencyAmount'; value: number }
  }>
}

export type UpdatePreferredWithdrawalAccountMutationVariables = Exact<{
  accountId: Scalars['ID']
}>

export type UpdatePreferredWithdrawalAccountMutation = {
  __typename?: 'Mutation'
  setPreferredWithdrawalAccount:
    | { __typename: 'FundingSourceAccount' }
    | { __typename: 'PreferredAccountNotEligibleError' }
    | { __typename: 'PreferredAccountNotSupportedError' }
}

export type MakeWithdrawalMutationVariables = Exact<{
  amount: Scalars['Float']
  fundingSourceId: Scalars['ID']
  type: InvestmentTypes
  investmentAccountId?: InputMaybe<Scalars['ID']>
}>

export type MakeWithdrawalMutation = {
  __typename?: 'Mutation'
  makeInvestment: { __typename?: 'MakeInvestmentPayload'; id: string }
}

export type InvestDetailsQueryVariables = Exact<{ [key: string]: never }>

export type InvestDetailsQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    fundingSource: {
      __typename?: 'FundingSource'
      alert: any
      name: string
      verified: boolean
    }
  }
  profile: { __typename?: 'Profile'; transfersPaused: boolean }
  investmentAccount: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    closedAt: any
    currentBalance: { __typename?: 'MonetaryAmount'; value: number }
    portfolio: {
      __typename?: 'Portfolio'
      id: string
      name: string
      theme: PortfolioTheme
    }
    portfolios: Array<
      | {
          __typename: 'Portfolio'
          id: string
          portfolioSecurities: Array<{
            __typename?: 'PortfolioSecurity'
            symbol: string
          }>
        }
      | {
          __typename: 'SelfDirectedPortfolio'
          id: string
          portfolioSecurities: Array<{
            __typename?: 'PortfolioSecurity'
            symbol: string
          }>
        }
    >
  }>
  spendAccount: { __typename?: 'SpendAccount'; status: SpendAccountStatus }
}

export type InvestOverviewQueryQueryVariables = Exact<{
  start: Scalars['DateTime']
}>

export type InvestOverviewQueryQuery = {
  __typename?: 'Query'
  user: { __typename?: 'User'; verified: boolean }
  laterAccounts: Array<{
    __typename?: 'LaterAccount'
    amount: number
    performance: {
      __typename?: 'LaterPortfolioPerformance'
      periodMarketChange: number
      periodMarketChangePercent: number
    }
  }>
  performance: {
    __typename?: 'Performance'
    marketChange: number
    marketChangePercent: number
    accountValues: Array<{ __typename?: 'AccountValue'; amount: number }>
  }
}

export type LaterTotalLiquidationlMutationMutationVariables = Exact<{
  investmentAccountId: Scalars['ID']
  federalTaxes: Scalars['Float']
  stateTaxes: Scalars['Float']
  withdrawalType?: InputMaybe<LaterWithdrawalType>
  taxYear: Scalars['Int']
  reason: LaterWithdrawalReason
}>

export type LaterTotalLiquidationlMutationMutation = {
  __typename?: 'Mutation'
  laterTotalLiquidation: any
}

export type LaterWithdrawalMutationMutationVariables = Exact<{
  investmentAccountId: Scalars['ID']
  amount: Scalars['Float']
  federalTaxes: Scalars['Float']
  stateTaxes: Scalars['Float']
  taxYear: Scalars['Int']
  reason: LaterWithdrawalReason
}>

export type LaterWithdrawalMutationMutation = {
  __typename?: 'Mutation'
  laterWithdrawal: any
}

export type OneTimeContributionMutationMutationVariables = Exact<{
  accountId: Scalars['ID']
  amount: Scalars['Float']
  year?: InputMaybe<Scalars['Int']>
}>

export type OneTimeContributionMutationMutation = {
  __typename?: 'Mutation'
  createLaterContribution: any
}

export type StopRecurringContributionMutationMutationVariables = Exact<{
  investment_account_id: Scalars['String']
}>

export type StopRecurringContributionMutationMutation = {
  __typename?: 'Mutation'
  stopRecurringInvestment: {
    __typename?: 'RecurringInvestmentPayload'
    recurringInvestmentSettings: {
      __typename?: 'RecurringInvestmentSettings'
      amount: number
      day: number
      frequency: InvestmentFrequency
    }
  }
}

export type UpdateLaterBeneficiariesMutationVariables = Exact<{
  firstName: Scalars['String']
  lastName: Scalars['String']
  birthDate: Scalars['DateTime']
  ssn?: InputMaybe<Scalars['String']>
  relationship?: InputMaybe<Scalars['String']>
  addressLine1?: InputMaybe<Scalars['String']>
  addressLine2?: InputMaybe<Scalars['String']>
  city?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  zip?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  accountId: Scalars['ID']
}>

export type UpdateLaterBeneficiariesMutation = {
  __typename?: 'Mutation'
  laterCreateIndividualBeneficiary: {
    __typename?: 'LaterIndividualBeneficiaryResponse'
    beneficiaryId: string
  }
}

export type UpdateRecurringContributionMutationMutationVariables = Exact<{
  amount: Scalars['Float']
  day: Scalars['Int']
  frequency: InvestmentFrequency
  investment_account_id: Scalars['String']
}>

export type UpdateRecurringContributionMutationMutation = {
  __typename?: 'Mutation'
  updateRecurringInvestment: {
    __typename?: 'RecurringInvestmentPayload'
    recurringInvestmentSettings: {
      __typename?: 'RecurringInvestmentSettings'
      amount: number
      day: number
      frequency: InvestmentFrequency
    }
  }
}

export type FundingSourceAccountsLaterOneTimeFragment = {
  __typename?: 'FundingSourceAccount'
  balance: number
  last4: string
  institutionName: string
  status: FundingSourceStatus
  verified: boolean
  role: FundingSourceRoleEnum
  id: number
  fundType: FundingSourceType
  accountName: string
}

export type AllBankAccountsLaterOneTimeFragment = {
  __typename?: 'BankAccount'
  availableBalance: { __typename?: 'CurrencyAmount'; value: number }
}

export type LaterOneTimeQueryVariables = Exact<{ [key: string]: never }>

export type LaterOneTimeQuery = {
  __typename?: 'Query'
  laterUserContributionAbility: {
    __typename: 'ContributionAbilityByYear'
    contributionAbilities: Array<{
      __typename: 'ContributionAbility'
      canContribute: boolean
      planLimit: number
      remaining: number
      taxYear: number
      yearToDate: number
    }>
  }
  fundingSourceAccounts: Array<{
    __typename?: 'FundingSourceAccount'
    balance: number
    last4: string
    institutionName: string
    status: FundingSourceStatus
    verified: boolean
    role: FundingSourceRoleEnum
    id: number
    fundType: FundingSourceType
    accountName: string
  }>
  laterAccounts: Array<{
    __typename?: 'LaterAccount'
    amount: number
    name: string
    accountId: string
    accountNumber: string
    contributionLimit: number
    portfolioName: string
    code: LaterAccountCodes
    recurringSettings: {
      __typename?: 'RecurringInvestmentSettings'
      amount: number
      frequency: InvestmentFrequency
      day: number
    }
  }>
  settings: { __typename?: 'Settings'; depositsSuspended: boolean }
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    availableBalance: { __typename?: 'CurrencyAmount'; value: number }
  }>
  profile: { __typename?: 'Profile'; maritalStatus: MaritalStatus }
}

export type LaterRecurringPastEdgeFragment = {
  __typename?: 'PastItemEdge'
  node:
    | {
        __typename?: 'CoreACHSubscriptionFeeItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreAdjustmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreCashForwardItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreCollectionItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreDebtCollectionItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreDividendsItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreEmployeeCreditItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreFeeInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreFoundMoneyRewardItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreGiftCardCreditRedemptionItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreHoldingsTransferInItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreLocalFoundMoneyItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CorePartnerRewardItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreRebalanceItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreReferralRewardItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreRefundedItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreReinvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreRoundUpsItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'CoreWithdrawalItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyDebtCollectionItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyDividendsItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyFeeInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyGiftItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyMatchItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyMatchRemovalItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyRefundedItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyReinvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'EarlyWithdrawalItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterDebtCollectionItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterDividendsItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterFeeInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterMatchItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterMatchRemovalItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterRebalanceItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterRefundedItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterReinvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'LaterWithdrawalItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastAcornsRewardInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastBeneficiaryTransferInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastCashOwedCollectionInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastCashReinvestmentInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastCoreItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastDividendInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastEmployeeContributionInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastExternalTransferInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastExternalTransferReversedInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastFeeInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastGiftCardInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastIRATransferInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastInvestmentTipItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastLumpSumInvestment'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastMatchInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastMatchRemovalInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastOutsideContributionInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastRealTimeRoundUpInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastRebalanceInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastRecurringInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastReferralRewardInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastReferralRewardMatchInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastRefundInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastReversalInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastRewardInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastRewardMatchInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastRoundUpItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastRoundUpMatchInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastSecurityLiquidationInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastSmartDepositInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastSpendItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastStreakRewardInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastTipsThatGrowMatchInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'PastWithdrawalInvestmentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SaveInterestPaidItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SaveTransferInItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SaveTransferOutItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendATMReimbursementItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendATMWithdrawalItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendBillPayItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendCheckDepositItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendCheckPaymentItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendDigitalWalletItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendDirectDepositItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendECheckItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendInterestPaidItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendPurchaseItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendRealTimeRoundUpItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendTransferInItem'
        id: string
        title: string
        status: PastItemStatus
      }
    | {
        __typename?: 'SpendTransferOutItem'
        id: string
        title: string
        status: PastItemStatus
      }
}

export type AllPastItemsLaterRecurringQueryVariables = Exact<{
  filter?: InputMaybe<AllPastItemsFilter>
  pagination?: InputMaybe<PageInput>
}>

export type AllPastItemsLaterRecurringQuery = {
  __typename?: 'Query'
  allPastItems: {
    __typename?: 'PastItemConnection'
    edges: Array<{
      __typename?: 'PastItemEdge'
      node:
        | {
            __typename?: 'CoreACHSubscriptionFeeItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreAdjustmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreCashForwardItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreCollectionItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreDebtCollectionItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreDividendsItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreEmployeeCreditItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreFeeInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreFoundMoneyRewardItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreGiftCardCreditRedemptionItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreHoldingsTransferInItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreLocalFoundMoneyItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CorePartnerRewardItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreRebalanceItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreReferralRewardItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreRefundedItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreReinvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreRoundUpsItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'CoreWithdrawalItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyDebtCollectionItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyDividendsItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyFeeInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyGiftItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyMatchItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyMatchRemovalItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyRefundedItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyReinvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'EarlyWithdrawalItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterDebtCollectionItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterDividendsItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterFeeInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterMatchItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterMatchRemovalItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterRebalanceItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterRefundedItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterReinvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'LaterWithdrawalItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastAcornsRewardInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastBeneficiaryTransferInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastCashOwedCollectionInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastCashReinvestmentInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastCoreItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastDividendInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastEmployeeContributionInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastExternalTransferInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastExternalTransferReversedInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastFeeInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastGiftCardInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastIRATransferInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastInvestmentTipItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastLumpSumInvestment'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastMatchInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastMatchRemovalInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastOutsideContributionInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastRealTimeRoundUpInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastRebalanceInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastRecurringInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastReferralRewardInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastReferralRewardMatchInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastRefundInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastReversalInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastRewardInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastRewardMatchInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastRoundUpItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastRoundUpMatchInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastSecurityLiquidationInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastSmartDepositInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastSpendItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastStreakRewardInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastTipsThatGrowMatchInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'PastWithdrawalInvestmentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SaveInterestPaidItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SaveTransferInItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SaveTransferOutItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendATMReimbursementItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendATMWithdrawalItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendBillPayItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendCheckDepositItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendCheckPaymentItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendDigitalWalletItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendDirectDepositItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendECheckItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendInterestPaidItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendPurchaseItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendRealTimeRoundUpItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendTransferInItem'
            id: string
            title: string
            status: PastItemStatus
          }
        | {
            __typename?: 'SpendTransferOutItem'
            id: string
            title: string
            status: PastItemStatus
          }
    }>
  }
}

export type DepositSettingsQueryVariables = Exact<{ [key: string]: never }>

export type DepositSettingsQuery = {
  __typename?: 'Query'
  settings: { __typename?: 'Settings'; depositsSuspended: boolean }
}

export type HasLaterAccountsQueryVariables = Exact<{ [key: string]: never }>

export type HasLaterAccountsQuery = {
  __typename?: 'Query'
  laterAccounts: Array<{
    __typename?: 'LaterAccount'
    name: string
    accountId: string
  }>
}

export type LaterBeneficiariesQueryVariables = Exact<{
  investmentAccountId: Scalars['ID']
}>

export type LaterBeneficiariesQuery = {
  __typename?: 'Query'
  laterBeneficiaries: Array<{
    __typename?: 'LaterIndividualBeneficiary'
    beneficiaryId: string
    firstName: string
    lastName: string
    birthDate: any
    relationship: string
    percentageShare: number
    addressLine1: string
    addressLine2: string
    city: string
    state: string
    zip: string
    country: string
    type: BeneficiaryType
    accountId: string
  }>
}

export type LaterContributionHistoryQueryVariables = Exact<{
  investmentAccountId: Scalars['ID']
}>

export type LaterContributionHistoryQuery = {
  __typename?: 'Query'
  laterContributionHistory: Array<{
    __typename?: 'ContributionHistoryItem'
    year: number
  }>
}

export type LaterWithholdingDefaultsQueryVariables = Exact<{
  investmentAccountId: Scalars['ID']
  withdrawalAmount: CurrencyAmountInput
  earlyDistributionTaxExceptionReason?: InputMaybe<Scalars['String']>
}>

export type LaterWithholdingDefaultsQuery = {
  __typename?: 'Query'
  withholdingDefaults: {
    __typename?: 'WithholdingDefaults'
    federalWithholdingPercentage: number
    stateWithholdingPercentage: number
    showStateWithholdingField: boolean
    showFederalWithholdingField: boolean
  }
}

export type RecurringSettingsLaterDetailsFragment = {
  __typename?: 'RecurringInvestmentSettings'
  amount: number
  frequency: InvestmentFrequency
  day: number
}

export type LaterDetailsQueryVariables = Exact<{ [key: string]: never }>

export type LaterDetailsQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    state: any
    fundingSource: {
      __typename?: 'FundingSource'
      verified: boolean
      name: string
      last4: string
    }
  }
  profile: { __typename?: 'Profile'; maritalStatus: MaritalStatus }
  laterAccounts: Array<{
    __typename?: 'LaterAccount'
    amount: number
    name: string
    accountId: string
    accountNumber: string
    contributionLimit: number
    portfolioName: string
    code: LaterAccountCodes
    status: LaterAccountStatus
    recurringSettings: {
      __typename?: 'RecurringInvestmentSettings'
      amount: number
      frequency: InvestmentFrequency
      day: number
    }
  }>
  tierSubscriptionByUserId: {
    __typename?: 'TierSubscription'
    id: string
    tier: { __typename?: 'Tier'; id: string; name: string }
  }
}

export type WithholdingEstimatesQueryVariables = Exact<{
  investmentAccountId: Scalars['ID']
  withdrawalAmount: CurrencyAmountInput
  stateWithholdingPercentage: Scalars['Float']
  federalWithholdingPercentage: Scalars['Float']
  reason: LaterWithdrawalReason
}>

export type WithholdingEstimatesQuery = {
  __typename?: 'Query'
  withholdingEstimates: {
    __typename?: 'WithholdingEstimates'
    estimatedCustomerAmount: {
      __typename?: 'MonetaryAmount'
      value: number
      currency: Currency
    }
    estimatedTotalWithholdingAmount: {
      __typename?: 'MonetaryAmount'
      value: number
      currency: Currency
    }
    estimatedFederalWithholdingAmount: {
      __typename?: 'MonetaryAmount'
      value: number
      currency: Currency
    }
    estimatedStateWithholdingAmount: {
      __typename?: 'MonetaryAmount'
      value: number
      currency: Currency
    }
    estimatedTaxableEarnings: {
      __typename?: 'MonetaryAmount'
      value: number
      currency: Currency
    }
  }
}

export type LaterWithdrawQueryQueryVariables = Exact<{ [key: string]: never }>

export type LaterWithdrawQueryQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    uuid: string
    fundingSource: {
      __typename?: 'FundingSource'
      alert: any
      name: string
      verified: boolean
    }
  }
  laterAccounts: Array<{
    __typename?: 'LaterAccount'
    accountId: string
    amount: number
    portfolioId: string
  }>
  portfolios: Array<{
    __typename?: 'Portfolio'
    id: string
    riskLevel: PortfolioRiskLevel
    theme: PortfolioTheme
  }>
}

export type FundingSourceAccountsFragment = {
  __typename?: 'FundingSourceAccount'
  balance: number
  last4: string
  institutionName: string
  status: FundingSourceStatus
  verified: boolean
  role: FundingSourceRoleEnum
  id: number
  fundType: FundingSourceType
  accountName: string
}

export type LaterWithdrawQueryVariables = Exact<{ [key: string]: never }>

export type LaterWithdrawQuery = {
  __typename?: 'Query'
  fundingSourceAccounts: Array<{
    __typename?: 'FundingSourceAccount'
    balance: number
    last4: string
    institutionName: string
    status: FundingSourceStatus
    verified: boolean
    role: FundingSourceRoleEnum
    id: number
    fundType: FundingSourceType
    accountName: string
  }>
  settings: { __typename?: 'Settings'; depositsSuspended: boolean }
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    availableBalance: { __typename?: 'CurrencyAmount'; value: number }
  }>
  profile: { __typename?: 'Profile'; maritalStatus: MaritalStatus }
  laterAccounts: Array<{
    __typename?: 'LaterAccount'
    amount: number
    name: string
    accountId: string
    accountNumber: string
    contributionLimit: number
    portfolioName: string
    status: LaterAccountStatus
    code: LaterAccountCodes
    recurringSettings: {
      __typename?: 'RecurringInvestmentSettings'
      amount: number
      frequency: InvestmentFrequency
      day: number
    }
  }>
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    status: InvestmentAccountStatus
    withdrawalsIncurTaxPenalty: boolean
  }>
}

export type InvestRecurringInvestmentSettingsQueryVariables = Exact<{
  investmentAccountId?: InputMaybe<Scalars['ID']>
}>

export type InvestRecurringInvestmentSettingsQuery = {
  __typename?: 'Query'
  recurringInvestmentSettings: {
    __typename?: 'RecurringInvestmentSettings'
    amount: number
    day: number
    frequency: InvestmentFrequency
  }
  user: {
    __typename?: 'User'
    fundingSource: {
      __typename?: 'FundingSource'
      verified: boolean
      name: string
      last4: string
    }
  }
  spendAccount: { __typename?: 'SpendAccount'; status: SpendAccountStatus }
}

export type MonetaryAmountFragmentFragment = {
  __typename?: 'MonetaryAmount'
  currency: Currency
  value: number
}

export type AccountValueFragmentFragment = {
  __typename?: 'AccountValue'
  amount: number
  timestamp: any
}

export type CombinedPerformanceAccountBreakdownFragmentFragment = {
  __typename?: 'CombinedPerformance'
  netInvestments: {
    __typename?: 'MonetaryAmount'
    currency: Currency
    value: number
  }
  stockValue: {
    __typename?: 'MonetaryAmount'
    currency: Currency
    value: number
  }
  bondValue: {
    __typename?: 'MonetaryAmount'
    currency: Currency
    value: number
  }
  cryptoValue: {
    __typename?: 'MonetaryAmount'
    currency: Currency
    value: number
  }
  marketChange: {
    __typename?: 'MonetaryAmount'
    currency: Currency
    value: number
  }
  currentBalance: {
    __typename?: 'MonetaryAmount'
    currency: Currency
    value: number
  }
}

export type CombinedPerformanceQueryVariables = Exact<{
  days?: InputMaybe<Scalars['Int']>
}>

export type CombinedPerformanceQuery = {
  __typename?: 'Query'
  market: { __typename?: 'Market'; isOpen: boolean }
  combinedPerformanceByUserId: {
    __typename?: 'CombinedPerformance'
    marketChangePercent: number
    accountValues: Array<{
      __typename?: 'AccountValue'
      amount: number
      timestamp: any
    }>
    netInvestments: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
    stockValue: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
    bondValue: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
    cryptoValue: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
    marketChange: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
    currentBalance: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
  }
}

export type StringKeyAssetFragmentFragment = {
  __typename?: 'StringKeyAsset'
  key: any
  args: Array<string>
}

export type AllMessagesQueryVariables = Exact<{
  statusFilters?: InputMaybe<
    Array<MessageStatusFilterInput> | MessageStatusFilterInput
  >
  typeFilters?: InputMaybe<Array<MessageType> | MessageType>
}>

export type AllMessagesQuery = {
  __typename?: 'Query'
  allMessages: Array<
    | {
        __typename: 'AlertMessage'
        id: string
        messageType: MessageType
        messageCategory: MessageCategory
        isRead: boolean
        trackingId: string
        deepLink: any
        createdAt: any
        updatedAt: any
        readAt: any
        title: { __typename?: 'StringKeyAsset'; key: any; args: Array<string> }
        body: { __typename?: 'StringKeyAsset'; key: any; args: Array<string> }
        icon:
          | { __typename?: 'DesignLibraryIcon'; icon: IconType }
          | { __typename?: 'Image'; url: string }
      }
    | {
        __typename?: 'NotificationMessage'
        id: string
        messageType: MessageType
        messageCategory: MessageCategory
        isRead: boolean
        isDismissed: boolean
        isHidden: boolean
        trackingId: string
        deepLink: any
        createdAt: any
        updatedAt: any
        readAt: any
        externalId: string
        title: { __typename?: 'StringKeyAsset'; key: any; args: Array<string> }
        body: { __typename?: 'StringKeyAsset'; key: any; args: Array<string> }
        icon:
          | { __typename?: 'DesignLibraryIcon'; icon: IconType }
          | { __typename?: 'Image'; url: string }
      }
  >
}

export type DismissMessagesMutationVariables = Exact<{
  input: DismissMessagesInput
}>

export type DismissMessagesMutation = {
  __typename?: 'Mutation'
  dismissMessages:
    | { __typename?: 'DismissMessagesSuccess'; dismissedCount: number }
    | { __typename?: 'UpdateMessagesFailure'; errorMessage: string }
}

export type IsAuthenticatedQueryVariables = Exact<{ [key: string]: never }>

export type IsAuthenticatedQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    closedAt: any
    email: string
    firstName: string
    lastName: string
    registrationComplete: boolean
    uuid: string
    verified: boolean
  }
}

export type MarkAllAsReadMutationVariables = Exact<{ [key: string]: never }>

export type MarkAllAsReadMutation = {
  __typename?: 'Mutation'
  markAllAsRead:
    | { __typename: 'MarkAllAsReadSuccess'; markedAsReadCount: number }
    | { __typename: 'UpdateMessageFailed' }
}

export type OnMessageCreatedSubscriptionVariables = Exact<{
  typeFilters?: InputMaybe<Array<MessageType> | MessageType>
}>

export type OnMessageCreatedSubscription = {
  __typename?: 'Subscription'
  onMessageCreated:
    | {
        __typename: 'AlertMessage'
        id: string
        messageType: MessageType
        messageCategory: MessageCategory
        isRead: boolean
        trackingId: string
        deepLink: any
        createdAt: any
        updatedAt: any
        readAt: any
        title: { __typename?: 'StringKeyAsset'; key: any; args: Array<string> }
        body: { __typename?: 'StringKeyAsset'; key: any; args: Array<string> }
        icon:
          | { __typename?: 'DesignLibraryIcon'; icon: IconType }
          | { __typename?: 'Image' }
      }
    | {
        __typename: 'NotificationMessage'
        id: string
        messageType: MessageType
        messageCategory: MessageCategory
        isRead: boolean
        isDismissed: boolean
        isHidden: boolean
        trackingId: string
        deepLink: any
        createdAt: any
        updatedAt: any
        readAt: any
        externalId: string
        title: { __typename?: 'StringKeyAsset'; key: any; args: Array<string> }
        body: { __typename?: 'StringKeyAsset'; key: any; args: Array<string> }
        icon:
          | { __typename?: 'DesignLibraryIcon'; icon: IconType }
          | { __typename?: 'Image'; url: string }
      }
}

export type ReadMessageMutationVariables = Exact<{
  input: ReadMessageInput
}>

export type ReadMessageMutation = {
  __typename?: 'Mutation'
  readMessage:
    | {
        __typename?: 'AlertMessage'
        id: string
        isRead: boolean
        isDismissed: boolean
        isHidden: boolean
      }
    | { __typename?: 'LegacyAlertDismissalSuccess' }
    | { __typename?: 'NotificationMessage'; id: string }
    | { __typename?: 'UpdateMessageIgnored'; requestId: string }
}

export type UpdateVerificationProfileMutationVariables = Exact<{
  deviceSessionId?: InputMaybe<Scalars['String']>
}>

export type UpdateVerificationProfileMutation = {
  __typename?: 'Mutation'
  updateVerificationProfile: { __typename: 'VerificationProfile' }
}

export type MoneyHubSettingsQueryVariables = Exact<{ [key: string]: never }>

export type MoneyHubSettingsQuery = {
  __typename?: 'Query'
  splitDepositSettingsByUserId: Array<
    | {
        __typename?: 'SplitDepositDirectDepositIntentSetting'
        id: string
        isActive: boolean
        isHidden: boolean
        name: string
        isUsingRecommendedAllocations: boolean
        allocations: Array<{
          __typename?: 'SplitDepositDirectDepositAllocation'
          normalizedDailyAmount: string
          allocationPercent: string
          targetAccountId: string
          targetAccountType: SplitDepositTargetAccountType
          nickname: string
        }>
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          expectedNextDepositAmount: string
          expectedNextDepositAt: string
          id: string
          isActive: boolean
          isCancelable: boolean
          transactionAmount: string
        }>
        estimatedPaycheckAmount: {
          __typename?: 'CurrencyAmount'
          value: number
        }
      }
    | {
        __typename?: 'SplitDepositDirectDepositSetting'
        id: string
        isActive: boolean
        isHidden: boolean
        name: string
        isUsingRecommendedAllocations: boolean
        awaitingConfiguration: boolean
        monthlyTotals: Array<{
          __typename?: 'MonthlyTotal'
          yearMonth: string
          totalAmount: { __typename?: 'FormattedMonetaryAmount'; value: string }
        }>
        allocations: Array<{
          __typename?: 'SplitDepositDirectDepositAllocation'
          normalizedDailyAmount: string
          allocationPercent: string
          targetAccountId: string
          targetAccountType: SplitDepositTargetAccountType
          nickname: string
        }>
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          expectedNextDepositAmount: string
          expectedNextDepositAt: string
          id: string
          isActive: boolean
          isCancelable: boolean
          transactionAmount: string
        }>
      }
    | {
        __typename?: 'SplitDepositRecurrenceSetting'
        id: string
        isActive: boolean
        isHidden: boolean
        name: string
        monthlyTotals: Array<{
          __typename?: 'MonthlyTotal'
          yearMonth: string
          totalAmount: { __typename?: 'FormattedMonetaryAmount'; value: string }
        }>
        allocations: Array<{
          __typename?: 'SplitDepositRecurrenceAllocation'
          isActive: boolean
          allocationPercent: string
          targetAccountId: string
          targetAccountType: SplitDepositTargetAccountType
          nickname: string
          legacyRecurrenceAmount: {
            __typename?: 'FormattedMonetaryAmount'
            value: string
          }
          legacyRecurrenceRule:
            | {
                __typename?: 'SplitDepositDailyRecurrenceRule'
                frequency: SplitDepositRecurrenceFrequency
              }
            | {
                __typename?: 'SplitDepositMonthlyRecurrenceRule'
                byMonthDay: Array<number>
                frequency: SplitDepositRecurrenceFrequency
              }
            | {
                __typename?: 'SplitDepositWeeklyRecurrenceRule'
                byWeekDay: Array<DayOfWeek>
                frequency: SplitDepositRecurrenceFrequency
              }
        }>
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          expectedNextDepositAmount: string
          expectedNextDepositAt: string
          id: string
          isActive: boolean
          isCancelable: boolean
          transactionAmount: string
        }>
      }
  >
  tierSubscriptionByUserId: {
    __typename?: 'TierSubscription'
    id: string
    tierPrice: {
      __typename?: 'TierPrice'
      amount: { __typename?: 'CurrencyAmount'; value: number }
    }
    tier: {
      __typename?: 'Tier'
      id: string
      products: Array<{
        __typename?: 'Product'
        id: string
        name: string
        active: boolean
        key: ProductKey
      }>
    }
  }
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    beneficiaryId: string
    transferability: {
      __typename?: 'InvestmentAccountTransferability'
      transferAge: number
      transferDate: any
    }
  }>
  spendAccount: {
    __typename?: 'SpendAccount'
    status: SpendAccountStatus
    isEligible: boolean
    isReopenable: boolean
    bankCardOrder: { __typename?: 'BankCardOrder'; bankCardTier: BankCardTier }
  }
  user: { __typename?: 'User'; verified: boolean; uuid: string }
}

type MoneyHubSplitDepositSettingFragment_SplitDepositDirectDepositIntentSetting_Fragment =
  {
    __typename?: 'SplitDepositDirectDepositIntentSetting'
    id: string
    isActive: boolean
    isHidden: boolean
    name: string
    allocations: Array<{
      __typename?: 'SplitDepositDirectDepositAllocation'
      normalizedDailyAmount: string
      allocationPercent: string
      targetAccountId: string
      targetAccountType: SplitDepositTargetAccountType
      nickname: string
    }>
  }

type MoneyHubSplitDepositSettingFragment_SplitDepositDirectDepositSetting_Fragment =
  {
    __typename?: 'SplitDepositDirectDepositSetting'
    id: string
    isActive: boolean
    isHidden: boolean
    name: string
    allocations: Array<{
      __typename?: 'SplitDepositDirectDepositAllocation'
      normalizedDailyAmount: string
      allocationPercent: string
      targetAccountId: string
      targetAccountType: SplitDepositTargetAccountType
      nickname: string
    }>
  }

type MoneyHubSplitDepositSettingFragment_SplitDepositRecurrenceSetting_Fragment =
  {
    __typename?: 'SplitDepositRecurrenceSetting'
    id: string
    isActive: boolean
    isHidden: boolean
    name: string
    allocations: Array<{
      __typename?: 'SplitDepositRecurrenceAllocation'
      allocationPercent: string
      targetAccountId: string
      targetAccountType: SplitDepositTargetAccountType
      nickname: string
    }>
  }

export type MoneyHubSplitDepositSettingFragmentFragment =
  | MoneyHubSplitDepositSettingFragment_SplitDepositDirectDepositIntentSetting_Fragment
  | MoneyHubSplitDepositSettingFragment_SplitDepositDirectDepositSetting_Fragment
  | MoneyHubSplitDepositSettingFragment_SplitDepositRecurrenceSetting_Fragment

export type MoneyHubSplitDepositDirectDepositSettingFragmentFragment = {
  __typename?: 'SplitDepositDirectDepositSetting'
  isUsingRecommendedAllocations: boolean
  awaitingConfiguration: boolean
  id: string
  isActive: boolean
  isHidden: boolean
  name: string
  allocations: Array<{
    __typename?: 'SplitDepositDirectDepositAllocation'
    normalizedDailyAmount: string
    allocationPercent: string
    targetAccountId: string
    targetAccountType: SplitDepositTargetAccountType
    nickname: string
  }>
}

export type MoneyHubSplitDepositIntentSettingFragmentFragment = {
  __typename?: 'SplitDepositDirectDepositIntentSetting'
  isUsingRecommendedAllocations: boolean
  id: string
  isActive: boolean
  isHidden: boolean
  name: string
  estimatedPaycheckAmount: { __typename?: 'CurrencyAmount'; value: number }
  allocations: Array<{
    __typename?: 'SplitDepositDirectDepositAllocation'
    normalizedDailyAmount: string
    allocationPercent: string
    targetAccountId: string
    targetAccountType: SplitDepositTargetAccountType
    nickname: string
  }>
}

export type MoneyHubSplitDepositFragmentFragment = {
  __typename?: 'SplitDeposit'
  createdAt: string
  distributedAt: string
  expectedNextDepositAmount: string
  expectedNextDepositAt: string
  id: string
  isActive: boolean
  isCancelable: boolean
  transactionAmount: string
}

export type DepositMonthlyTotalFragmentFragment = {
  __typename?: 'MonthlyTotal'
  yearMonth: string
  totalAmount: { __typename?: 'FormattedMonetaryAmount'; value: string }
}

export type SpendSignupTransferableFromQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type SpendSignupTransferableFromQueryQuery = {
  __typename?: 'Query'
  allTransferableFrom: Array<{
    __typename?: 'TransferableFrom'
    from: {
      __typename?: 'TransferableAccount'
      accountNumberMasked: string
      externalSource: ExternalSource
      id: string
      name: string
      type: TransferableAccountTypeEnum
      balance: { __typename?: 'CurrencyAmount'; value: number }
    }
  }>
  eligibility: { __typename?: 'Eligibility'; eligible: boolean }
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    id: string
    type: BankAccountType
    balance: { __typename?: 'CurrencyAmount'; value: number }
    pendingBalance: { __typename?: 'CurrencyAmount'; value: number }
  }>
}

export type PerformanceGraphQueryQueryVariables = Exact<{
  days: Scalars['Int']
  investmentAccountId: Scalars['ID']
}>

export type PerformanceGraphQueryQuery = {
  __typename?: 'Query'
  market: { __typename?: 'Market'; isOpen: boolean }
  investmentAccount: {
    __typename?: 'InvestmentAccount'
    performance: {
      __typename?: 'Performance'
      marketChange: number
      marketChangePercent: number
      marketChangePercentWithoutFees: number
      previousCloseAmount: number
      accountValues: Array<{
        __typename?: 'AccountValue'
        amount: number
        timestamp: any
      }>
    }
  }
}

export type PerformanceHoldingsQueryVariables = Exact<{
  product?: InputMaybe<InvestmentProduct>
}>

export type PerformanceHoldingsQuery = {
  __typename?: 'Query'
  investmentAccounts: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    name: string
    createdAt: any
    closedAt: any
    beneficiaryId: string
    netInvestments: { __typename?: 'MonetaryAmount'; value: number }
    currentBalance: { __typename?: 'MonetaryAmount'; value: number }
    totalAccountValue: { __typename?: 'MonetaryAmount'; value: number }
    returnsAllTime: { __typename?: 'MonetaryAmount'; value: number }
    totalBonds: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
    portfolio: {
      __typename?: 'Portfolio'
      name: string
      theme: PortfolioTheme
      description: string
      holdings: Array<{
        __typename?: 'PortfolioHolding'
        name: string
        amount: number
        percentage: number
        shares: number
        symbol: string
      }>
    }
    portfolios: Array<
      | {
          __typename: 'Portfolio'
          portfolioSecurities: Array<{
            __typename?: 'PortfolioSecurity'
            name: string
            currentAllocationPercentage: number
            shares: number
            symbol: string
            marketValue: { __typename?: 'MonetaryAmount'; value: number }
            todaysReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
            }
            totalReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
            }
          }>
          portfolioSecurityAllocations: Array<{
            __typename?: 'PortfolioSecurityAllocation'
            allocationPercent: number
            symbol: string
            name: string
            security:
              | {
                  __typename?: 'Fund'
                  type: SecurityType
                  profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                }
              | {
                  __typename?: 'Stock'
                  type: SecurityType
                  profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                }
          }>
        }
      | {
          __typename: 'SelfDirectedPortfolio'
          portfolioSecurities: Array<{
            __typename?: 'PortfolioSecurity'
            name: string
            currentAllocationPercentage: number
            shares: number
            symbol: string
            marketValue: { __typename?: 'MonetaryAmount'; value: number }
            todaysReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
            }
            totalReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
            }
          }>
          portfolioSecurityAllocations: Array<{
            __typename?: 'PortfolioSecurityAllocation'
            allocationPercent: number
            symbol: string
            name: string
            security:
              | {
                  __typename?: 'Fund'
                  type: SecurityType
                  profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                }
              | {
                  __typename?: 'Stock'
                  type: SecurityType
                  profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                }
          }>
        }
    >
  }>
  user: { __typename?: 'User'; firstName: string }
}

export type PortfolioSecuritiesDetailsFragment = {
  __typename: 'PortfolioSecurity'
  id: string
  name: string
  currentAllocationPercentage: number
  shares: number
  symbol: string
  marketValue: { __typename?: 'MonetaryAmount'; value: number }
  todaysReturn: {
    __typename?: 'MarketReturn'
    percent: number
    marketValue: { __typename?: 'MonetaryAmount'; value: number }
  }
  totalReturn: {
    __typename?: 'MarketReturn'
    percent: number
    marketValue: { __typename?: 'MonetaryAmount'; value: number }
  }
}

type PortfolioDetails_Portfolio_Fragment = {
  __typename: 'Portfolio'
  id: string
  name: string
  portfolioSecurities: Array<{
    __typename: 'PortfolioSecurity'
    id: string
    name: string
    currentAllocationPercentage: number
    shares: number
    symbol: string
    marketValue: { __typename?: 'MonetaryAmount'; value: number }
    todaysReturn: {
      __typename?: 'MarketReturn'
      percent: number
      marketValue: { __typename?: 'MonetaryAmount'; value: number }
    }
    totalReturn: {
      __typename?: 'MarketReturn'
      percent: number
      marketValue: { __typename?: 'MonetaryAmount'; value: number }
    }
  }>
  portfolioSecurityAllocations: Array<{
    __typename: 'PortfolioSecurityAllocation'
    allocationPercent: number
    symbol: string
    name: string
    security:
      | {
          __typename?: 'Fund'
          type: SecurityType
          profile: { __typename?: 'SecurityProfile'; logoUrl: any }
        }
      | {
          __typename?: 'Stock'
          type: SecurityType
          profile: { __typename?: 'SecurityProfile'; logoUrl: any }
        }
  }>
}

type PortfolioDetails_SelfDirectedPortfolio_Fragment = {
  __typename: 'SelfDirectedPortfolio'
  id: string
  name: string
  portfolioSecurities: Array<{
    __typename: 'PortfolioSecurity'
    id: string
    name: string
    currentAllocationPercentage: number
    shares: number
    symbol: string
    marketValue: { __typename?: 'MonetaryAmount'; value: number }
    todaysReturn: {
      __typename?: 'MarketReturn'
      percent: number
      marketValue: { __typename?: 'MonetaryAmount'; value: number }
    }
    totalReturn: {
      __typename?: 'MarketReturn'
      percent: number
      marketValue: { __typename?: 'MonetaryAmount'; value: number }
    }
  }>
  portfolioSecurityAllocations: Array<{
    __typename: 'PortfolioSecurityAllocation'
    allocationPercent: number
    symbol: string
    name: string
    security:
      | {
          __typename?: 'Fund'
          type: SecurityType
          profile: { __typename?: 'SecurityProfile'; logoUrl: any }
        }
      | {
          __typename?: 'Stock'
          type: SecurityType
          profile: { __typename?: 'SecurityProfile'; logoUrl: any }
        }
  }>
}

export type PortfolioDetailsFragment =
  | PortfolioDetails_Portfolio_Fragment
  | PortfolioDetails_SelfDirectedPortfolio_Fragment

export type InvestmentAccountDetailsFragment = {
  __typename: 'InvestmentAccount'
  id: string
  name: string
  createdAt: any
  closedAt: any
  beneficiaryId: string
  netInvestments: { __typename?: 'MonetaryAmount'; value: number }
  currentBalance: { __typename?: 'MonetaryAmount'; value: number }
  totalBonds: {
    __typename?: 'MonetaryAmount'
    currency: Currency
    value: number
  }
  totalAccountValue: { __typename?: 'MonetaryAmount'; value: number }
  returnsAllTime: { __typename?: 'MonetaryAmount'; value: number }
  portfolio: {
    __typename: 'Portfolio'
    id: string
    name: string
    theme: PortfolioTheme
    description: string
    holdings: Array<{
      __typename?: 'PortfolioHolding'
      name: string
      amount: number
      percentage: number
      shares: number
      symbol: string
    }>
  }
  portfolios: Array<
    | {
        __typename: 'Portfolio'
        id: string
        name: string
        portfolioSecurities: Array<{
          __typename: 'PortfolioSecurity'
          id: string
          name: string
          currentAllocationPercentage: number
          shares: number
          symbol: string
          marketValue: { __typename?: 'MonetaryAmount'; value: number }
          todaysReturn: {
            __typename?: 'MarketReturn'
            percent: number
            marketValue: { __typename?: 'MonetaryAmount'; value: number }
          }
          totalReturn: {
            __typename?: 'MarketReturn'
            percent: number
            marketValue: { __typename?: 'MonetaryAmount'; value: number }
          }
        }>
        portfolioSecurityAllocations: Array<{
          __typename: 'PortfolioSecurityAllocation'
          allocationPercent: number
          symbol: string
          name: string
          security:
            | {
                __typename?: 'Fund'
                type: SecurityType
                profile: { __typename?: 'SecurityProfile'; logoUrl: any }
              }
            | {
                __typename?: 'Stock'
                type: SecurityType
                profile: { __typename?: 'SecurityProfile'; logoUrl: any }
              }
        }>
      }
    | {
        __typename: 'SelfDirectedPortfolio'
        id: string
        name: string
        portfolioSecurities: Array<{
          __typename: 'PortfolioSecurity'
          id: string
          name: string
          currentAllocationPercentage: number
          shares: number
          symbol: string
          marketValue: { __typename?: 'MonetaryAmount'; value: number }
          todaysReturn: {
            __typename?: 'MarketReturn'
            percent: number
            marketValue: { __typename?: 'MonetaryAmount'; value: number }
          }
          totalReturn: {
            __typename?: 'MarketReturn'
            percent: number
            marketValue: { __typename?: 'MonetaryAmount'; value: number }
          }
        }>
        portfolioSecurityAllocations: Array<{
          __typename: 'PortfolioSecurityAllocation'
          allocationPercent: number
          symbol: string
          name: string
          security:
            | {
                __typename?: 'Fund'
                type: SecurityType
                profile: { __typename?: 'SecurityProfile'; logoUrl: any }
              }
            | {
                __typename?: 'Stock'
                type: SecurityType
                profile: { __typename?: 'SecurityProfile'; logoUrl: any }
              }
        }>
      }
  >
  totalEquities: { __typename?: 'MonetaryAmount'; value: number }
}

export type PerformanceHoldingsPassionsQueryVariables = Exact<{
  product?: InputMaybe<InvestmentProduct>
}>

export type PerformanceHoldingsPassionsQuery = {
  __typename?: 'Query'
  investmentAccounts: Array<{
    __typename: 'InvestmentAccount'
    id: string
    name: string
    createdAt: any
    closedAt: any
    beneficiaryId: string
    portfolios: Array<
      | {
          __typename: 'Portfolio'
          id: string
          name: string
          portfolioSecurities: Array<{
            __typename: 'PortfolioSecurity'
            id: string
            name: string
            currentAllocationPercentage: number
            shares: number
            symbol: string
            marketValue: { __typename?: 'MonetaryAmount'; value: number }
            todaysReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
            }
            totalReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
            }
          }>
          portfolioSecurityAllocations: Array<{
            __typename: 'PortfolioSecurityAllocation'
            allocationPercent: number
            symbol: string
            name: string
            security:
              | {
                  __typename?: 'Fund'
                  type: SecurityType
                  profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                }
              | {
                  __typename?: 'Stock'
                  type: SecurityType
                  profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                }
          }>
        }
      | {
          __typename: 'SelfDirectedPortfolio'
          id: string
          name: string
          portfolioSecurities: Array<{
            __typename: 'PortfolioSecurity'
            id: string
            name: string
            currentAllocationPercentage: number
            shares: number
            symbol: string
            marketValue: { __typename?: 'MonetaryAmount'; value: number }
            todaysReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
            }
            totalReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
            }
          }>
          portfolioSecurityAllocations: Array<{
            __typename: 'PortfolioSecurityAllocation'
            allocationPercent: number
            symbol: string
            name: string
            security:
              | {
                  __typename?: 'Fund'
                  type: SecurityType
                  profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                }
              | {
                  __typename?: 'Stock'
                  type: SecurityType
                  profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                }
          }>
        }
    >
    netInvestments: { __typename?: 'MonetaryAmount'; value: number }
    currentBalance: { __typename?: 'MonetaryAmount'; value: number }
    totalBonds: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
    totalAccountValue: { __typename?: 'MonetaryAmount'; value: number }
    returnsAllTime: { __typename?: 'MonetaryAmount'; value: number }
    portfolio: {
      __typename: 'Portfolio'
      id: string
      name: string
      theme: PortfolioTheme
      description: string
      holdings: Array<{
        __typename?: 'PortfolioHolding'
        name: string
        amount: number
        percentage: number
        shares: number
        symbol: string
      }>
    }
    totalEquities: { __typename?: 'MonetaryAmount'; value: number }
  }>
  user: { __typename?: 'User'; firstName: string }
}

export type SecurityPerformancesBySymbolQueryVariables = Exact<{
  input: SecurityPerformancesBySymbolInput
}>

export type SecurityPerformancesBySymbolQuery = {
  __typename?: 'Query'
  securityPerformancesBySymbol: Array<{
    __typename?: 'SecurityPerformance'
    symbol: any
    gain: {
      __typename?: 'SecurityGain'
      percent: any
      marketValue: { __typename?: 'BigCurrencyAmount'; value: any }
    }
  }>
}

export type AddSecurityToPortfolioMutationVariables = Exact<{
  input: AddSecurityToPortfolioInput
}>

export type AddSecurityToPortfolioMutation = {
  __typename?: 'Mutation'
  addSecurityToPortfolio:
    | { __typename: 'InvestmentAccountNotFoundException' }
    | { __typename: 'InvestmentAccountNotSupportedException' }
    | {
        __typename: 'Portfolio'
        customizationLevel: PortfolioCustomizationLevel
        id: string
        portfolioSecurityAllocations: Array<{
          __typename?: 'PortfolioSecurityAllocation'
          id: string
          symbol: string
          allocationPercent: number
          removableFromBasePortfolio: boolean
          security:
            | { __typename?: 'Fund'; displayName: string }
            | { __typename?: 'Stock'; displayName: string }
          investmentCategories: {
            __typename?: 'InvestmentCategory'
            bond: number
            crypto: number
            equity: number
            realEstate: number
          }
        }>
      }
    | { __typename: 'PortfolioNotFoundException' }
    | { __typename: 'PortfolioNotSupportedException' }
    | { __typename: 'SecurityNotSupportedException' }
}

export type RemoveSecurityFromPortfolioMutationVariables = Exact<{
  input: RemoveSecurityFromPortfolioInput
}>

export type RemoveSecurityFromPortfolioMutation = {
  __typename?: 'Mutation'
  removeSecurityFromPortfolio:
    | { __typename: 'InvestmentAccountNotFoundException' }
    | { __typename: 'InvestmentAccountNotSupportedException' }
    | {
        __typename: 'Portfolio'
        customizationLevel: PortfolioCustomizationLevel
        id: string
        portfolioSecurityAllocations: Array<{
          __typename?: 'PortfolioSecurityAllocation'
          id: string
          symbol: string
          allocationPercent: number
          removableFromBasePortfolio: boolean
          security:
            | { __typename?: 'Fund'; displayName: string }
            | { __typename?: 'Stock'; displayName: string }
          investmentCategories: {
            __typename?: 'InvestmentCategory'
            bond: number
            crypto: number
            equity: number
            realEstate: number
          }
        }>
      }
    | { __typename: 'PortfolioNotFoundException' }
    | { __typename: 'PortfolioNotSupportedException' }
    | { __typename: 'SecurityNotSupportedException' }
}

export type CryptoEtfQueryVariables = Exact<{ [key: string]: never }>

export type CryptoEtfQuery = {
  __typename?: 'Query'
  cryptoEtf: { __typename?: 'ETF'; symbol: string }
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    closedAt: any
    investmentAccountType: InvestmentAccountType
    totalCrypto: { __typename?: 'MonetaryAmount'; value: number }
    portfolio: {
      __typename?: 'Portfolio'
      customizationLevel: PortfolioCustomizationLevel
      id: string
      portfolioSecurityAllocations: Array<{
        __typename?: 'PortfolioSecurityAllocation'
        id: string
        symbol: string
        allocationPercent: number
        removableFromBasePortfolio: boolean
        security:
          | {
              __typename?: 'Fund'
              displayName: string
              profile: { __typename?: 'SecurityProfile'; logoUrl: any }
            }
          | {
              __typename?: 'Stock'
              displayName: string
              profile: { __typename?: 'SecurityProfile'; logoUrl: any }
            }
        investmentCategories: {
          __typename?: 'InvestmentCategory'
          bond: number
          crypto: number
          equity: number
          realEstate: number
        }
      }>
    }
  }>
}

export type SetPortfolioMutationMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type SetPortfolioMutationMutation = {
  __typename?: 'Mutation'
  setPortfolio: {
    __typename?: 'User'
    portfolio: { __typename?: 'Portfolio'; id: string }
  }
}

export type UpdateAccountPortfolioMutationVariables = Exact<{
  investmentAccountId: Scalars['ID']
  theme: PortfolioTheme
  riskLevel: PortfolioRiskLevel
}>

export type UpdateAccountPortfolioMutation = {
  __typename?: 'Mutation'
  updateAccountPortfolio:
    | { __typename?: 'InvalidActionOnAccount' }
    | { __typename?: 'InvestmentAccount'; id: string }
    | { __typename?: 'InvestmentAccountNotFoundException' }
    | { __typename?: 'PortfolioNotFoundException' }
    | { __typename?: 'PortfolioUpdateFailedException' }
}

export type AllPortfoliosWithCryptoQueryVariables = Exact<{
  customizedWithSecuritySymbols?: InputMaybe<
    Array<Scalars['String']> | Scalars['String']
  >
}>

export type AllPortfoliosWithCryptoQuery = {
  __typename?: 'Query'
  portfolios: Array<{
    __typename?: 'Portfolio'
    id: string
    name: string
    description: string
    position: number
    riskLevel: PortfolioRiskLevel
    theme: PortfolioTheme
    projection: {
      __typename?: 'PortfolioProjection'
      averageGrowthRate: number
      highestGrowthRate: number
      lowestGrowthRate: number
    }
    portfolioSecurityAllocations: Array<{
      __typename?: 'PortfolioSecurityAllocation'
      symbol: string
      allocationPercent: number
      security:
        | { __typename?: 'Fund'; id: string; displayName: string }
        | { __typename?: 'Stock'; id: string; displayName: string }
      investmentCategories: {
        __typename?: 'InvestmentCategory'
        bond: number
        crypto: number
      }
    }>
  }>
  recommendedPortfolio: {
    __typename?: 'suitability_Portfolio'
    id: string
    name: string
    description: string
  }
  user: {
    __typename?: 'User'
    investmentAccounts: Array<{
      __typename?: 'InvestmentAccount'
      closedAt: any
      product: InvestmentProduct
      currentBalance: { __typename?: 'MonetaryAmount'; value: number }
      portfolio: {
        __typename?: 'Portfolio'
        id: string
        name: string
        description: string
        riskLevel: PortfolioRiskLevel
        theme: PortfolioTheme
        portfolioSecurityAllocations: Array<{
          __typename?: 'PortfolioSecurityAllocation'
          symbol: string
          allocationPercent: number
          security:
            | { __typename?: 'Fund'; id: string; displayName: string }
            | { __typename?: 'Stock'; id: string; displayName: string }
          investmentCategories: {
            __typename?: 'InvestmentCategory'
            bond: number
            crypto: number
          }
        }>
      }
    }>
  }
}

export type ProductPortfoliosPassionsQueryVariables = Exact<{
  [key: string]: never
}>

export type ProductPortfoliosPassionsQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    uuid: string
    investmentAccounts: Array<{
      __typename?: 'InvestmentAccount'
      id: string
      closedAt: any
      product: InvestmentProduct
      status: InvestmentAccountStatus
      currentBalance: { __typename?: 'MonetaryAmount'; value: number }
      totalBonds: {
        __typename?: 'MonetaryAmount'
        currency: Currency
        value: number
      }
      totalEquities: {
        __typename?: 'MonetaryAmount'
        currency: Currency
        value: number
      }
      totalCrypto: {
        __typename?: 'MonetaryAmount'
        currency: Currency
        value: number
      }
      portfolio: {
        __typename?: 'Portfolio'
        id: string
        name: string
        description: string
        riskLevel: PortfolioRiskLevel
        theme: PortfolioTheme
        portfolioSecurityAllocations: Array<{
          __typename?: 'PortfolioSecurityAllocation'
          id: string
          symbol: string
          allocationPercent: number
          security:
            | {
                __typename?: 'Fund'
                displayName: string
                type: SecurityType
                profile: { __typename?: 'SecurityProfile'; logoUrl: any }
              }
            | {
                __typename?: 'Stock'
                displayName: string
                type: SecurityType
                profile: { __typename?: 'SecurityProfile'; logoUrl: any }
              }
          investmentCategories: {
            __typename?: 'InvestmentCategory'
            bond: number
            crypto: number
            equity: number
          }
        }>
      }
      portfolios: Array<
        | {
            __typename: 'Portfolio'
            id: string
            name: string
            description: string
            currentAllocationPercentage: number
            currentBalance: { __typename?: 'MonetaryAmount'; value: number }
            accountAllocation: {
              __typename?: 'PortfolioAllocation'
              allocationPercent: number
            }
            yearToDateReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
            }
            portfolioSecurities: Array<{
              __typename: 'PortfolioSecurity'
              name: string
              currentAllocationPercentage: number
              shares: number
              symbol: string
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
              todaysReturn: {
                __typename?: 'MarketReturn'
                percent: number
                marketValue: { __typename?: 'MonetaryAmount'; value: number }
              }
              totalReturn: {
                __typename?: 'MarketReturn'
                percent: number
                marketValue: { __typename?: 'MonetaryAmount'; value: number }
              }
            }>
            portfolioSecurityAllocations: Array<{
              __typename?: 'PortfolioSecurityAllocation'
              id: string
              symbol: string
              allocationPercent: number
              security:
                | {
                    __typename?: 'Fund'
                    displayName: string
                    type: SecurityType
                    profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                  }
                | {
                    __typename?: 'Stock'
                    displayName: string
                    type: SecurityType
                    profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                  }
              investmentCategories: {
                __typename?: 'InvestmentCategory'
                bond: number
                crypto: number
                equity: number
              }
            }>
          }
        | {
            __typename: 'SelfDirectedPortfolio'
            status: SelfDirectedPortfolioStatus
            id: string
            name: string
            description: string
            currentAllocationPercentage: number
            currentBalance: { __typename?: 'MonetaryAmount'; value: number }
            accountAllocation: {
              __typename?: 'PortfolioAllocation'
              allocationPercent: number
            }
            yearToDateReturn: {
              __typename?: 'MarketReturn'
              percent: number
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
            }
            portfolioSecurities: Array<{
              __typename: 'PortfolioSecurity'
              name: string
              currentAllocationPercentage: number
              shares: number
              symbol: string
              marketValue: { __typename?: 'MonetaryAmount'; value: number }
              todaysReturn: {
                __typename?: 'MarketReturn'
                percent: number
                marketValue: { __typename?: 'MonetaryAmount'; value: number }
              }
              totalReturn: {
                __typename?: 'MarketReturn'
                percent: number
                marketValue: { __typename?: 'MonetaryAmount'; value: number }
              }
            }>
            portfolioSecurityAllocations: Array<{
              __typename?: 'PortfolioSecurityAllocation'
              id: string
              symbol: string
              allocationPercent: number
              security:
                | {
                    __typename?: 'Fund'
                    displayName: string
                    type: SecurityType
                    profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                  }
                | {
                    __typename?: 'Stock'
                    displayName: string
                    type: SecurityType
                    profile: { __typename?: 'SecurityProfile'; logoUrl: any }
                  }
              investmentCategories: {
                __typename?: 'InvestmentCategory'
                bond: number
                crypto: number
                equity: number
              }
            }>
          }
      >
      recommendedPortfolio: {
        __typename?: 'Portfolio'
        id: string
        name: string
        minimumManagedAllocationPercent: number
      }
      yearToDateReturn: {
        __typename?: 'MarketReturn'
        percent: number
        marketValue: {
          __typename?: 'MonetaryAmount'
          currency: Currency
          value: number
        }
      }
    }>
  }
}

export type RecurringInvestmentSettingsQueryVariables = Exact<{
  product?: InputMaybe<InvestmentProduct>
}>

export type RecurringInvestmentSettingsQuery = {
  __typename?: 'Query'
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    closedAt: any
    recurringInvestmentSettings: {
      __typename?: 'RecurringInvestmentSettings'
      amount: number
      frequency: InvestmentFrequency
      day: number
      nextInvestmentAt: any
    }
  }>
}

export type PortfolioSuitabilityResponsesQueryVariables = Exact<{
  [key: string]: never
}>

export type PortfolioSuitabilityResponsesQuery = {
  __typename?: 'Query'
  suitabilityResponses: Array<{
    __typename?: 'suitability_SuitabilityResponse'
    answer: {
      __typename?: 'suitability_SuitabilityAnswer'
      id: string
      summary: string
    }
  }>
}

export type TierSubscriptionForUserQueryVariables = Exact<{
  [key: string]: never
}>

export type TierSubscriptionForUserQuery = {
  __typename?: 'Query'
  tierSubscriptionByUserId: {
    __typename?: 'TierSubscription'
    id: string
    tier: {
      __typename?: 'Tier'
      id: string
      name: string
      key: TierKey
      products: Array<{ __typename?: 'Product'; key: ProductKey }>
    }
  }
}

export type SubscribeAfterRegistrationCompleteMutationVariables = Exact<{
  input: SubscribeToTierInput
}>

export type SubscribeAfterRegistrationCompleteMutation = {
  __typename?: 'Mutation'
  subscribeToTier:
    | { __typename: 'InvalidTier' }
    | { __typename: 'InvalidTierPrice' }
    | { __typename: 'TierSubscription' }
}

export type RecapItemsFragment = {
  __typename?: 'InvestmentAccountRecap'
  id: string
  beneficiaryAge: number
  beneficiaryCustodianNickname: string
  beneficiaryFirstName: string
  beneficiaryLastName: string
  endsAt: any
  startsAt: any
  public: boolean
  publicUrl: any
  contributionsByOthers: Array<{
    __typename?: 'InvestmentAccountOutsideContribution'
    contributorName: string
    note: string
    amount: { __typename?: 'MonetaryAmount'; currency: Currency; value: number }
  }>
  totalContributions: {
    __typename?: 'MonetaryAmount'
    currency: Currency
    value: number
  }
  totalContributionsByOthers: {
    __typename?: 'MonetaryAmount'
    currency: Currency
    value: number
  }
  investmentAccount: {
    __typename?: 'InvestmentAccount'
    id: string
    beneficiaryId: string
    beneficiary: {
      __typename?: 'Beneficiary'
      custodianNickname: string
      firstName: string
    }
    currentBalance: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
    transferability: {
      __typename?: 'InvestmentAccountTransferability'
      transferAge: number
    }
    recurringInvestmentSettings: {
      __typename?: 'RecurringInvestmentSettings'
      amount: number
      day: number
      frequency: InvestmentFrequency
    }
  }
  performance: {
    __typename?: 'Performance'
    marketChange: number
    marketChangePercent: number
    marketChangeWithoutFees: number
    marketChangePercentWithoutFees: number
    accountValues: Array<{
      __typename?: 'AccountValue'
      amount: number
      timestamp: any
    }>
  }
  latestAccountValue: {
    __typename?: 'MonetaryAmount'
    value: number
    currency: Currency
  }
}

type SplitDepositSettingFragment_SplitDepositDirectDepositIntentSetting_Fragment =
  {
    __typename?: 'SplitDepositDirectDepositIntentSetting'
    id: string
    isActive: boolean
    isHidden: boolean
    name: string
    allocations: Array<{
      __typename?: 'SplitDepositDirectDepositAllocation'
      allocationPercent: string
      targetAccountId: string
      targetAccountType: SplitDepositTargetAccountType
      nickname: string
      normalizedAmount: {
        __typename?: 'FormattedMonetaryAmount'
        value: string
      }
    }>
  }

type SplitDepositSettingFragment_SplitDepositDirectDepositSetting_Fragment = {
  __typename?: 'SplitDepositDirectDepositSetting'
  id: string
  isActive: boolean
  isHidden: boolean
  name: string
  allocations: Array<{
    __typename?: 'SplitDepositDirectDepositAllocation'
    allocationPercent: string
    targetAccountId: string
    targetAccountType: SplitDepositTargetAccountType
    nickname: string
    normalizedAmount: { __typename?: 'FormattedMonetaryAmount'; value: string }
  }>
}

type SplitDepositSettingFragment_SplitDepositRecurrenceSetting_Fragment = {
  __typename?: 'SplitDepositRecurrenceSetting'
  id: string
  isActive: boolean
  isHidden: boolean
  name: string
  allocations: Array<{ __typename?: 'SplitDepositRecurrenceAllocation' }>
}

export type SplitDepositSettingFragmentFragment =
  | SplitDepositSettingFragment_SplitDepositDirectDepositIntentSetting_Fragment
  | SplitDepositSettingFragment_SplitDepositDirectDepositSetting_Fragment
  | SplitDepositSettingFragment_SplitDepositRecurrenceSetting_Fragment

export type SplitDepositFragmentFragment = {
  __typename?: 'SplitDeposit'
  createdAt: string
  distributedAt: string
  expectedNextDepositAmount: string
  expectedNextDepositAt: string
  id: string
  isActive: boolean
  isCancelable: boolean
  isUsingRecommendedAllocations: boolean
  transactionAmount: string
  willDistributeAutomaticallyAt: string
  allocations: Array<
    | {
        __typename?: 'SplitDepositDirectDepositAllocation'
        allocationPercent: string
        targetAccountId: string
        targetAccountType: SplitDepositTargetAccountType
        nickname: string
        normalizedAmount: {
          __typename?: 'FormattedMonetaryAmount'
          value: string
        }
      }
    | { __typename?: 'SplitDepositRecurrenceAllocation' }
  >
}

export type SplitDepositDirectDepositSettingFragmentFragment = {
  __typename?: 'SplitDepositDirectDepositSetting'
  isUsingRecommendedAllocations: boolean
  awaitingConfiguration: boolean
  name: string
  isActive: boolean
  isHidden: boolean
  id: string
  allocations: Array<{
    __typename?: 'SplitDepositDirectDepositAllocation'
    allocationPercent: string
    targetAccountId: string
    targetAccountType: SplitDepositTargetAccountType
    nickname: string
    normalizedAmount: { __typename?: 'FormattedMonetaryAmount'; value: string }
  }>
}

export type SplitDepositIntentSettingFragmentFragment = {
  __typename?: 'SplitDepositDirectDepositIntentSetting'
  isUsingRecommendedAllocations: boolean
  name: string
  isActive: boolean
  isHidden: boolean
  id: string
  estimatedPaycheckAmount: { __typename?: 'CurrencyAmount'; value: number }
  allocations: Array<{
    __typename?: 'SplitDepositDirectDepositAllocation'
    allocationPercent: string
    targetAccountId: string
    targetAccountType: SplitDepositTargetAccountType
    nickname: string
    normalizedAmount: { __typename?: 'FormattedMonetaryAmount'; value: string }
  }>
}

export type SmartDepositAllocationFragmentFragment = {
  __typename?: 'SplitDepositDirectDepositAllocation'
  allocationPercent: string
  targetAccountId: string
  targetAccountType: SplitDepositTargetAccountType
  nickname: string
  normalizedAmount: { __typename?: 'FormattedMonetaryAmount'; value: string }
}

export type SetRecapPublicAccessMutationVariables = Exact<{
  recapId: Scalars['ID']
  enablePublic: Scalars['Boolean']
}>

export type SetRecapPublicAccessMutation = {
  __typename?: 'Mutation'
  setInvestmentAccountRecapPublicAccess:
    | { __typename: 'InvestmentAccountRecap'; public: boolean }
    | { __typename: 'InvestmentAccountRecapNotFoundException' }
}

export type CustodianRecapQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type CustodianRecapQuery = {
  __typename?: 'Query'
  investmentAccountRecap: {
    __typename?: 'InvestmentAccountRecap'
    id: string
    beneficiaryAge: number
    beneficiaryCustodianNickname: string
    beneficiaryFirstName: string
    beneficiaryLastName: string
    endsAt: any
    startsAt: any
    public: boolean
    publicUrl: any
    contributionsByOthers: Array<{
      __typename?: 'InvestmentAccountOutsideContribution'
      contributorName: string
      note: string
      amount: {
        __typename?: 'MonetaryAmount'
        currency: Currency
        value: number
      }
    }>
    totalContributions: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
    totalContributionsByOthers: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
    investmentAccount: {
      __typename?: 'InvestmentAccount'
      id: string
      beneficiaryId: string
      beneficiary: {
        __typename?: 'Beneficiary'
        custodianNickname: string
        firstName: string
      }
      currentBalance: {
        __typename?: 'MonetaryAmount'
        currency: Currency
        value: number
      }
      transferability: {
        __typename?: 'InvestmentAccountTransferability'
        transferAge: number
      }
      recurringInvestmentSettings: {
        __typename?: 'RecurringInvestmentSettings'
        amount: number
        day: number
        frequency: InvestmentFrequency
      }
    }
    performance: {
      __typename?: 'Performance'
      marketChange: number
      marketChangePercent: number
      marketChangeWithoutFees: number
      marketChangePercentWithoutFees: number
      accountValues: Array<{
        __typename?: 'AccountValue'
        amount: number
        timestamp: any
      }>
    }
    latestAccountValue: {
      __typename?: 'MonetaryAmount'
      value: number
      currency: Currency
    }
  }
}

export type PublicRecapQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type PublicRecapQuery = {
  __typename?: 'Query'
  investmentAccountRecapByPublicToken: {
    __typename?: 'InvestmentAccountRecap'
    id: string
    beneficiaryAge: number
    beneficiaryCustodianNickname: string
    beneficiaryFirstName: string
    beneficiaryLastName: string
    endsAt: any
    startsAt: any
    public: boolean
    publicUrl: any
    contributionsByOthers: Array<{
      __typename?: 'InvestmentAccountOutsideContribution'
      contributorName: string
      note: string
      amount: {
        __typename?: 'MonetaryAmount'
        currency: Currency
        value: number
      }
    }>
    totalContributions: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
    totalContributionsByOthers: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
    investmentAccount: {
      __typename?: 'InvestmentAccount'
      id: string
      beneficiaryId: string
      beneficiary: {
        __typename?: 'Beneficiary'
        custodianNickname: string
        firstName: string
      }
      currentBalance: {
        __typename?: 'MonetaryAmount'
        currency: Currency
        value: number
      }
      transferability: {
        __typename?: 'InvestmentAccountTransferability'
        transferAge: number
      }
      recurringInvestmentSettings: {
        __typename?: 'RecurringInvestmentSettings'
        amount: number
        day: number
        frequency: InvestmentFrequency
      }
    }
    performance: {
      __typename?: 'Performance'
      marketChange: number
      marketChangePercent: number
      marketChangeWithoutFees: number
      marketChangePercentWithoutFees: number
      accountValues: Array<{
        __typename?: 'AccountValue'
        amount: number
        timestamp: any
      }>
    }
    latestAccountValue: {
      __typename?: 'MonetaryAmount'
      value: number
      currency: Currency
    }
  }
}

export type UserPublishingQueryQueryVariables = Exact<{ [key: string]: never }>

export type UserPublishingQueryQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    uuid: string
    email: string
    firstName: string
    lastName: string
  }
}

export type RedeemGiftcardMutationVariables = Exact<{
  pin: Scalars['String']
}>

export type RedeemGiftcardMutation = {
  __typename?: 'Mutation'
  redeemGiftcard: any
}

export type CampaignHistoryStatusByCampaignQueryVariables = Exact<{
  campaignId: Scalars['ID']
}>

export type CampaignHistoryStatusByCampaignQuery = {
  __typename?: 'Query'
  campaignHistory: {
    __typename?: 'CampaignHistoryConnection'
    edges: Array<{
      __typename: 'CampaignHistoryEdge'
      numCompletedReferrals: number
      node: {
        __typename?: 'ReferralCampaignV2'
        publishedStatus: PublishedCampaignStatus
      }
    }>
  }
}

export type ChangePasswordV2MutationVariables = Exact<{
  input: ChangePasswordInput
}>

export type ChangePasswordV2Mutation = {
  __typename?: 'Mutation'
  changePasswordV2:
    | { __typename: 'ChangePasswordSuccess'; userId: string }
    | { __typename: 'IncorrectOldPasswordException'; message: string }
    | { __typename: 'InvalidPasswordException'; message: string }
    | { __typename: 'SamePasswordsException'; message: string }
}

export type InvestorFlowSetPortfolioMutationVariables = Exact<{
  input: SetPortfolioInput
}>

export type InvestorFlowSetPortfolioMutation = {
  __typename?: 'Mutation'
  setPortfolio: {
    __typename?: 'User'
    portfolio: { __typename?: 'Portfolio'; id: string }
  }
}

export type InvestorAllPortfoliosQueryVariables = Exact<{
  customizedWithSecuritySymbols?: InputMaybe<
    Array<Scalars['String']> | Scalars['String']
  >
}>

export type InvestorAllPortfoliosQuery = {
  __typename?: 'Query'
  portfolios: Array<{
    __typename?: 'Portfolio'
    id: string
    name: string
    description: string
    riskLevel: PortfolioRiskLevel
    theme: PortfolioTheme
    portfolioSecurityAllocations: Array<{
      __typename?: 'PortfolioSecurityAllocation'
      symbol: string
      allocationPercent: number
      security:
        | { __typename?: 'Fund'; id: string; displayName: string }
        | { __typename?: 'Stock'; id: string; displayName: string }
      investmentCategories: {
        __typename?: 'InvestmentCategory'
        bond: number
        crypto: number
      }
    }>
  }>
}

export type InvestAccountIdQueryVariables = Exact<{ [key: string]: never }>

export type InvestAccountIdQuery = {
  __typename?: 'Query'
  investmentAccounts: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    closedAt: any
    portfolio: {
      __typename?: 'Portfolio'
      id: string
      name: string
      riskLevel: PortfolioRiskLevel
    }
  }>
}

export type InvestorySuitabilityResponsesQueryVariables = Exact<{
  [key: string]: never
}>

export type InvestorySuitabilityResponsesQuery = {
  __typename?: 'Query'
  investmentAccounts: Array<{
    __typename?: 'InvestmentAccount'
    closedAt: any
    portfolio: { __typename?: 'Portfolio'; theme: PortfolioTheme }
  }>
  suitabilityResponses: Array<{
    __typename?: 'suitability_SuitabilityResponse'
    answer: { __typename?: 'suitability_SuitabilityAnswer'; id: string }
    question: {
      __typename?: 'suitability_SuitabilityQuestion'
      id: string
      key: string
      possibleAnswers: Array<{
        __typename?: 'suitability_SuitabilityAnswer'
        id: string
        key: string
      }>
    }
  }>
  recommendedPortfolio: { __typename?: 'suitability_Portfolio'; id: string }
}

export type UpdateSuitabilityMutationVariables = Exact<{
  suitabilityInput:
    | Array<Suitability_SuitabilityInput>
    | Suitability_SuitabilityInput
}>

export type UpdateSuitabilityMutation = {
  __typename?: 'Mutation'
  updateSuitability: {
    __typename?: 'suitability_UpdateSuitabilityResult'
    recommendedPortfolio: {
      __typename?: 'suitability_Portfolio'
      id: string
      name: string
    }
  }
}

export type RoundUpAccountQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type RoundUpAccountQuery = {
  __typename?: 'Query'
  roundUpAccount: {
    __typename: 'RoundUpAccount'
    linkedSubaccountId: string
    enabled: boolean
  }
}

export type UserFundingSourceInfoQueryVariables = Exact<{
  [key: string]: never
}>

export type UserFundingSourceInfoQuery = {
  __typename?: 'Query'
  fundingSourceInfo: {
    __typename?: 'FundingSourceInfo'
    name: string
    accountNumberLastFour: string
    balance: number
    linkedSubaccountId: string
    verified: boolean
    type: FundingSourceType
    rdvSettledAt: any
  }
}

export type PlaidLinkWebhookQueryVariables = Exact<{ [key: string]: never }>

export type PlaidLinkWebhookQuery = {
  __typename?: 'Query'
  linkedAccountWebhooks: { __typename?: 'Webhooks'; plaid: string }
}

export type FinancialInstitutionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>
  supportsAuth?: InputMaybe<Scalars['Boolean']>
  includeDirectBank?: InputMaybe<Scalars['Boolean']>
}>

export type FinancialInstitutionsQuery = {
  __typename?: 'Query'
  financialInstitutions: {
    __typename?: 'FinancialInstitutionTypePagination'
    edges: Array<{
      __typename?: 'FinancialInstitutionTypeEdge'
      node: {
        __typename?: 'FinancialInstitution'
        externalId: string
        id: string
        linkProviderType: LinkProviderType
        logoUrl: string
        name: string
        products: Array<string>
      }
    }>
  }
}

export type ManageFundingSourceInfoQueryVariables = Exact<{
  [key: string]: never
}>

export type ManageFundingSourceInfoQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    fundingSourceChangeRequiresApproval: boolean
    uploads: Array<{
      __typename?: 'UserUpload'
      id: string
      documentType: string
      createdAt: any
    }>
  }
  fundingSourceInfo: {
    __typename?: 'FundingSourceInfo'
    name: string
    accountNumberLastFour: string
    balance: number
    linkedSubaccountId: string
    verified: boolean
    type: FundingSourceType
    rdvSettledAt: any
  }
}

export type SetPrimaryFundingSourceMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type SetPrimaryFundingSourceMutation = {
  __typename?: 'Mutation'
  assignLinkedSubaccount: {
    __typename?: 'LinkedSubaccount'
    id: string
    updatedAt: any
  }
}

export type LinkedAccountFieldsFragment = {
  __typename?: 'LinkedAccount'
  errorCode: string
  externalId: string
  externalSource: LinkedAccountExternalSourceEnum
  id: string
  institutionName: string
  linked: boolean
  status: LinkedAccountStatusEnum
  logoUrl: string
  transactionsLastSyncedAt: any
  financialInstitution: {
    __typename?: 'FinancialInstitution'
    deleted: boolean
    externalId: string
    id: string
    logoUrl: string
    name: string
    linkProviderType: LinkProviderType
  }
}

export type LinkedSubaccountFieldsFragment = {
  __typename?: 'LinkedSubaccount'
  accountNumberLastFour: string
  allowedRoles: Array<LinkedSubaccountRoleEnum>
  balanceAvailable: number
  balanceCurrent: number
  externalSource: string
  id: string
  linked: boolean
  name: string
  role: LinkedSubaccountRoleEnum
  subaccountType: string
}

export type CreatePlaidLinkedAccountMutationMutationVariables = Exact<{
  linkToken: Scalars['String']
  input: CreatePlaidLinkedAccountInput
}>

export type CreatePlaidLinkedAccountMutationMutation = {
  __typename?: 'Mutation'
  createPlaidLinkedAccount: {
    __typename?: 'LinkedAccount'
    errorCode: string
    externalId: string
    externalSource: LinkedAccountExternalSourceEnum
    id: string
    institutionName: string
    linked: boolean
    status: LinkedAccountStatusEnum
    logoUrl: string
    transactionsLastSyncedAt: any
    linkedSubaccounts: Array<{
      __typename?: 'LinkedSubaccount'
      accountNumberLastFour: string
      allowedRoles: Array<LinkedSubaccountRoleEnum>
      balanceAvailable: number
      balanceCurrent: number
      externalSource: string
      id: string
      linked: boolean
      name: string
      role: LinkedSubaccountRoleEnum
      subaccountType: string
    }>
    financialInstitution: {
      __typename?: 'FinancialInstitution'
      deleted: boolean
      externalId: string
      id: string
      logoUrl: string
      name: string
      linkProviderType: LinkProviderType
    }
  }
}

export type LinkAchAccountMutationVariables = Exact<{
  routing: Scalars['String']
  account: Scalars['String']
}>

export type LinkAchAccountMutation = {
  __typename?: 'Mutation'
  linkACHAccount: any
}

export type UpdatePrimaryCheckingMutationMutationVariables = Exact<{
  linkedSubaccountId: Scalars['ID']
}>

export type UpdatePrimaryCheckingMutationMutation = {
  __typename?: 'Mutation'
  assignLinkedSubaccount: {
    __typename?: 'LinkedSubaccount'
    accountNumberLastFour: string
    allowedRoles: Array<LinkedSubaccountRoleEnum>
    balanceAvailable: number
    balanceCurrent: number
    externalSource: string
    id: string
    linked: boolean
    name: string
    role: LinkedSubaccountRoleEnum
    subaccountType: string
    linkedAccount: {
      __typename?: 'LinkedAccount'
      errorCode: string
      externalId: string
      externalSource: LinkedAccountExternalSourceEnum
      id: string
      institutionName: string
      linked: boolean
      status: LinkedAccountStatusEnum
      logoUrl: string
      transactionsLastSyncedAt: any
      financialInstitution: {
        __typename?: 'FinancialInstitution'
        deleted: boolean
        externalId: string
        id: string
        logoUrl: string
        name: string
        linkProviderType: LinkProviderType
      }
    }
  }
}

export type ChangePrimaryCheckingQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type ChangePrimaryCheckingQueryQuery = {
  __typename?: 'Query'
  linkedSubaccounts: Array<{
    __typename?: 'LinkedSubaccount'
    accountNumberLastFour: string
    allowedRoles: Array<LinkedSubaccountRoleEnum>
    balanceAvailable: number
    balanceCurrent: number
    externalSource: string
    id: string
    linked: boolean
    name: string
    role: LinkedSubaccountRoleEnum
    subaccountType: string
    linkedAccount: {
      __typename?: 'LinkedAccount'
      errorCode: string
      externalId: string
      externalSource: LinkedAccountExternalSourceEnum
      id: string
      institutionName: string
      linked: boolean
      status: LinkedAccountStatusEnum
      logoUrl: string
      transactionsLastSyncedAt: any
      financialInstitution: {
        __typename?: 'FinancialInstitution'
        deleted: boolean
        externalId: string
        id: string
        logoUrl: string
        name: string
        linkProviderType: LinkProviderType
      }
    }
  }>
  fundingSourceAccounts: Array<{
    __typename?: 'FundingSourceAccount'
    name: string
    last4: string
    role: FundingSourceRoleEnum
  }>
  user: { __typename?: 'User'; fundingSourceChangeRequiresApproval: boolean }
}

export type LinkedAccountDetailQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type LinkedAccountDetailQueryQuery = {
  __typename?: 'Query'
  linkedAccounts: Array<{
    __typename?: 'LinkedAccount'
    errorCode: string
    externalId: string
    externalSource: LinkedAccountExternalSourceEnum
    id: string
    institutionName: string
    linked: boolean
    status: LinkedAccountStatusEnum
    logoUrl: string
    transactionsLastSyncedAt: any
    linkedSubaccounts: Array<{
      __typename?: 'LinkedSubaccount'
      accountNumberLastFour: string
      allowedRoles: Array<LinkedSubaccountRoleEnum>
      balanceAvailable: number
      balanceCurrent: number
      externalSource: string
      id: string
      linked: boolean
      name: string
      role: LinkedSubaccountRoleEnum
      subaccountType: string
    }>
    financialInstitution: {
      __typename?: 'FinancialInstitution'
      deleted: boolean
      externalId: string
      id: string
      logoUrl: string
      name: string
      linkProviderType: LinkProviderType
    }
  }>
  fundingSourceAccounts: Array<{
    __typename?: 'FundingSourceAccount'
    verified: boolean
    rdvSettledAt: any
    rdvTriggeredAt: any
    role: FundingSourceRoleEnum
    frozen: boolean
    canRetriggerRdv: boolean
  }>
}

export type LinkedAccountsIndexQueryVariables = Exact<{ [key: string]: never }>

export type LinkedAccountsIndexQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    fundingSourceChangeRequiresApproval: boolean
    uploads: Array<{
      __typename?: 'UserUpload'
      id: string
      documentType: string
      createdAt: any
    }>
  }
  fundingSourceAccounts: Array<{
    __typename?: 'FundingSourceAccount'
    name: string
    balance: number
    verified: boolean
    linkedSubaccountId: string
    rdvSettledAt: any
    last4: string
    role: FundingSourceRoleEnum
    frozen: boolean
    canRetriggerRdv: boolean
  }>
  linkedAccounts: Array<{
    __typename?: 'LinkedAccount'
    errorCode: string
    externalId: string
    externalSource: LinkedAccountExternalSourceEnum
    id: string
    institutionName: string
    linked: boolean
    status: LinkedAccountStatusEnum
    logoUrl: string
    transactionsLastSyncedAt: any
    linkedSubaccounts: Array<{
      __typename?: 'LinkedSubaccount'
      accountNumberLastFour: string
      allowedRoles: Array<LinkedSubaccountRoleEnum>
      balanceAvailable: number
      balanceCurrent: number
      externalSource: string
      id: string
      linked: boolean
      name: string
      role: LinkedSubaccountRoleEnum
      subaccountType: string
    }>
    financialInstitution: {
      __typename?: 'FinancialInstitution'
      deleted: boolean
      externalId: string
      id: string
      logoUrl: string
      name: string
      linkProviderType: LinkProviderType
    }
  }>
  settings: { __typename?: 'Settings'; depositsSuspended: boolean }
  linkedSubaccounts: Array<{
    __typename?: 'LinkedSubaccount'
    accountNumberLastFour: string
    allowedRoles: Array<LinkedSubaccountRoleEnum>
    balanceAvailable: number
    balanceCurrent: number
    externalSource: string
    id: string
    linked: boolean
    name: string
    role: LinkedSubaccountRoleEnum
    subaccountType: string
    linkedAccount: {
      __typename?: 'LinkedAccount'
      errorCode: string
      externalId: string
      externalSource: LinkedAccountExternalSourceEnum
      id: string
      institutionName: string
      linked: boolean
      status: LinkedAccountStatusEnum
      logoUrl: string
      transactionsLastSyncedAt: any
      financialInstitution: {
        __typename?: 'FinancialInstitution'
        deleted: boolean
        externalId: string
        id: string
        logoUrl: string
        name: string
        linkProviderType: LinkProviderType
      }
    }
  }>
}

export type HasFundingSourceQueryVariables = Exact<{ [key: string]: never }>

export type HasFundingSourceQuery = {
  __typename?: 'Query'
  fundingSourceAccounts: Array<{
    __typename?: 'FundingSourceAccount'
    linkedSubaccountId: string
    name: string
    role: FundingSourceRoleEnum
  }>
}

export type UpdateRoundUpAccountMutationVariables = Exact<{
  enabled: Scalars['Boolean']
  id: Scalars['ID']
}>

export type UpdateRoundUpAccountMutation = {
  __typename?: 'Mutation'
  updateRoundUpAccount: {
    __typename: 'RoundUpAccount'
    linkedSubaccountId: string
    enabled: boolean
  }
}

export type GenerateLinkSessionMutationVariables = Exact<{
  userId: Scalars['ID']
  institutionId: Scalars['ID']
  linkedAccountId?: InputMaybe<Scalars['ID']>
  redirectUrl?: InputMaybe<Scalars['URL']>
  authRequired?: InputMaybe<Scalars['Boolean']>
}>

export type GenerateLinkSessionMutation = {
  __typename?: 'Mutation'
  generateLinkSession:
    | { __typename: 'RawLinkSession'; token: string; externalId: string }
    | { __typename: 'UnrecoverableLinkedAccountError' }
    | { __typename: 'WebviewLinkSession' }
}

export type RelinkLinkedAccountMutationVariables = Exact<{
  id: Scalars['ID']
  linkSessionId: Scalars['String']
}>

export type RelinkLinkedAccountMutation = {
  __typename?: 'Mutation'
  updateLinkedAccount: {
    __typename?: 'LinkedAccount'
    id: string
    status: LinkedAccountStatusEnum
  }
}

export type RetriggerRdvsMutationVariables = Exact<{ [key: string]: never }>

export type RetriggerRdvsMutation = {
  __typename?: 'Mutation'
  retriggerRdvs:
    | { __typename?: 'FundingSourceAccount'; id: number }
    | { __typename?: 'RdvsNotTriggered'; message: string }
}

export type SetLinkingErrorMutationVariables = Exact<{
  id: Scalars['ID']
  errorCode: LinkedAccountLinkingErrorsEnum
}>

export type SetLinkingErrorMutation = {
  __typename?: 'Mutation'
  setLinkingError: {
    __typename?: 'LinkedAccount'
    id: string
    status: LinkedAccountStatusEnum
    errorCode: string
  }
}

export type UnlinkLinkedAccountMutationVariables = Exact<{
  linkedAccountId: Scalars['ID']
}>

export type UnlinkLinkedAccountMutation = {
  __typename?: 'Mutation'
  unlinkLinkedAccount: {
    __typename?: 'LinkedAccount'
    id: string
    linkedSubaccounts: Array<{ __typename?: 'LinkedSubaccount'; id: string }>
  }
}

export type VerifyRdvsMutationVariables = Exact<{
  deposits: Array<Scalars['Float']> | Scalars['Float']
}>

export type VerifyRdvsMutation = {
  __typename?: 'Mutation'
  verifyRdvs:
    | { __typename?: 'AccountFrozen'; message: string }
    | {
        __typename?: 'FundingSourceAccount'
        id: number
        status: FundingSourceStatus
      }
    | { __typename?: 'IncorrectRdvAmounts'; message: string }
    | { __typename?: 'StoredRdvDepositsInvalid'; message: string }
    | { __typename?: 'StoredRdvDepositsMissing'; message: string }
}

export type MySubscriptionFetchUsersTierQueryVariables = Exact<{
  [key: string]: never
}>

export type MySubscriptionFetchUsersTierQuery = {
  __typename?: 'Query'
  tierSubscriptionForUser:
    | {
        __typename: 'TierSubscription'
        id: string
        createdAt: any
        updatedAt: any
        tier: {
          __typename?: 'Tier'
          id: string
          key: TierKey
          name: string
          includedProducts: Array<{
            __typename?: 'TierProduct'
            key: ProductKey
          }>
          excludedProducts: Array<{
            __typename?: 'TierProduct'
            key: ProductKey
          }>
        }
        tierPrice: {
          __typename?: 'TierPrice'
          id: string
          billingFrequency: BillingFrequency
          amount: {
            __typename?: 'CurrencyAmount'
            value: number
            currency: Currency
          }
        }
      }
    | { __typename: 'TierSubscriptionNotFound'; message: string }
    | {
        __typename: 'TierSubscriptionUnsubscribed'
        id: string
        createdAt: any
        updatedAt: any
      }
}

export type SubscriptionCenterCancelRecurringTransferMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type SubscriptionCenterCancelRecurringTransferMutation = {
  __typename?: 'Mutation'
  cancelRecurringTransfer:
    | {
        __typename: 'RecurringTransfer'
        active: boolean
        id: string
        nextTransferDate: any
      }
    | { __typename: 'VersionMismatchException' }
}

export type SubscriptionCenterSubscribeUserToTierMutationVariables = Exact<{
  tierPriceId: Scalars['ID']
}>

export type SubscriptionCenterSubscribeUserToTierMutation = {
  __typename?: 'Mutation'
  subscribeUserToTier:
    | { __typename: 'InvalidTierPriceId' }
    | {
        __typename: 'TierDowngradeActionRequired'
        actions: Array<{
          __typename?: 'TierDowngradeAction'
          key: TierDowngradeActionKey
        }>
      }
    | {
        __typename: 'TierSubscription'
        id: string
        createdAt: any
        updatedAt: any
        tier: {
          __typename?: 'Tier'
          includedProducts: Array<{
            __typename?: 'TierProduct'
            key: ProductKey
          }>
          excludedProducts: Array<{
            __typename?: 'TierProduct'
            key: ProductKey
          }>
        }
        tierPrice: {
          __typename?: 'TierPrice'
          billingFrequency: BillingFrequency
          amount: {
            __typename?: 'CurrencyAmount'
            value: number
            currency: Currency
          }
        }
      }
}

export type NextBillingDateQueryVariables = Exact<{ [key: string]: never }>

export type NextBillingDateQuery = {
  __typename?: 'Query'
  nextBillingDate: { __typename?: 'NextBillingDate'; next_billing_date: string }
}

export type SpendPendingItemsQueryVariables = Exact<{
  accountId: Scalars['ID']
  productAccountType: ProductAccountType
}>

export type SpendPendingItemsQuery = {
  __typename?: 'Query'
  allPastItems: {
    __typename?: 'PastItemConnection'
    edges: Array<{
      __typename?: 'PastItemEdge'
      node:
        | { __typename?: 'CoreACHSubscriptionFeeItem'; id: string }
        | { __typename?: 'CoreAdjustmentItem'; id: string }
        | { __typename?: 'CoreCashForwardItem'; id: string }
        | { __typename?: 'CoreCollectionItem'; id: string }
        | { __typename?: 'CoreDebtCollectionItem'; id: string }
        | { __typename?: 'CoreDividendsItem'; id: string }
        | { __typename?: 'CoreEmployeeCreditItem'; id: string }
        | { __typename?: 'CoreFeeInvestmentItem'; id: string }
        | { __typename?: 'CoreFoundMoneyRewardItem'; id: string }
        | { __typename?: 'CoreGiftCardCreditRedemptionItem'; id: string }
        | { __typename?: 'CoreHoldingsTransferInItem'; id: string }
        | { __typename?: 'CoreInvestmentItem'; id: string }
        | { __typename?: 'CoreLocalFoundMoneyItem'; id: string }
        | { __typename?: 'CorePartnerRewardItem'; id: string }
        | { __typename?: 'CoreRebalanceItem'; id: string }
        | { __typename?: 'CoreReferralRewardItem'; id: string }
        | { __typename?: 'CoreRefundedItem'; id: string }
        | { __typename?: 'CoreReinvestmentItem'; id: string }
        | { __typename?: 'CoreRoundUpsItem'; id: string }
        | { __typename?: 'CoreWithdrawalItem'; id: string }
        | { __typename?: 'EarlyDebtCollectionItem'; id: string }
        | { __typename?: 'EarlyDividendsItem'; id: string }
        | { __typename?: 'EarlyFeeInvestmentItem'; id: string }
        | { __typename?: 'EarlyGiftItem'; id: string }
        | { __typename?: 'EarlyInvestmentItem'; id: string }
        | { __typename?: 'EarlyMatchItem'; id: string }
        | { __typename?: 'EarlyMatchRemovalItem'; id: string }
        | { __typename?: 'EarlyRefundedItem'; id: string }
        | { __typename?: 'EarlyReinvestmentItem'; id: string }
        | { __typename?: 'EarlyWithdrawalItem'; id: string }
        | { __typename?: 'LaterDebtCollectionItem'; id: string }
        | { __typename?: 'LaterDividendsItem'; id: string }
        | { __typename?: 'LaterFeeInvestmentItem'; id: string }
        | { __typename?: 'LaterInvestmentItem'; id: string }
        | { __typename?: 'LaterMatchItem'; id: string }
        | { __typename?: 'LaterMatchRemovalItem'; id: string }
        | { __typename?: 'LaterRebalanceItem'; id: string }
        | { __typename?: 'LaterRefundedItem'; id: string }
        | { __typename?: 'LaterReinvestmentItem'; id: string }
        | { __typename?: 'LaterWithdrawalItem'; id: string }
        | { __typename?: 'PastAcornsRewardInvestmentItem'; id: string }
        | { __typename?: 'PastBeneficiaryTransferInvestmentItem'; id: string }
        | { __typename?: 'PastCashOwedCollectionInvestmentItem'; id: string }
        | { __typename?: 'PastCashReinvestmentInvestmentItem'; id: string }
        | { __typename?: 'PastCoreItem'; id: string }
        | { __typename?: 'PastDividendInvestmentItem'; id: string }
        | { __typename?: 'PastEmployeeContributionInvestmentItem'; id: string }
        | { __typename?: 'PastExternalTransferInvestmentItem'; id: string }
        | {
            __typename?: 'PastExternalTransferReversedInvestmentItem'
            id: string
          }
        | { __typename?: 'PastFeeInvestmentItem'; id: string }
        | { __typename?: 'PastGiftCardInvestmentItem'; id: string }
        | { __typename?: 'PastIRATransferInvestmentItem'; id: string }
        | { __typename?: 'PastInvestmentTipItem'; id: string }
        | { __typename?: 'PastLumpSumInvestment'; id: string }
        | { __typename?: 'PastMatchInvestmentItem'; id: string }
        | { __typename?: 'PastMatchRemovalInvestmentItem'; id: string }
        | { __typename?: 'PastOutsideContributionInvestmentItem'; id: string }
        | { __typename?: 'PastRealTimeRoundUpInvestmentItem'; id: string }
        | { __typename?: 'PastRebalanceInvestmentItem'; id: string }
        | { __typename?: 'PastRecurringInvestmentItem'; id: string }
        | { __typename?: 'PastReferralRewardInvestmentItem'; id: string }
        | { __typename?: 'PastReferralRewardMatchInvestmentItem'; id: string }
        | { __typename?: 'PastRefundInvestmentItem'; id: string }
        | { __typename?: 'PastReversalInvestmentItem'; id: string }
        | { __typename?: 'PastRewardInvestmentItem'; id: string }
        | { __typename?: 'PastRewardMatchInvestmentItem'; id: string }
        | { __typename?: 'PastRoundUpItem'; id: string }
        | { __typename?: 'PastRoundUpMatchInvestmentItem'; id: string }
        | { __typename?: 'PastSecurityLiquidationInvestmentItem'; id: string }
        | { __typename?: 'PastSmartDepositInvestmentItem'; id: string }
        | { __typename?: 'PastSpendItem'; id: string }
        | { __typename?: 'PastStreakRewardInvestmentItem'; id: string }
        | { __typename?: 'PastTipsThatGrowMatchInvestmentItem'; id: string }
        | { __typename?: 'PastWithdrawalInvestmentItem'; id: string }
        | { __typename?: 'SaveInterestPaidItem'; id: string }
        | { __typename?: 'SaveTransferInItem'; id: string }
        | { __typename?: 'SaveTransferOutItem'; id: string }
        | { __typename?: 'SpendATMReimbursementItem'; id: string }
        | { __typename?: 'SpendATMWithdrawalItem'; id: string }
        | { __typename?: 'SpendBillPayItem'; id: string }
        | { __typename?: 'SpendCheckDepositItem'; id: string }
        | { __typename?: 'SpendCheckPaymentItem'; id: string }
        | { __typename?: 'SpendDigitalWalletItem'; id: string }
        | { __typename?: 'SpendDirectDepositItem'; id: string }
        | { __typename?: 'SpendECheckItem'; id: string }
        | { __typename?: 'SpendInterestPaidItem'; id: string }
        | { __typename?: 'SpendPurchaseItem'; id: string }
        | { __typename?: 'SpendRealTimeRoundUpItem'; id: string }
        | { __typename?: 'SpendTransferInItem'; id: string }
        | { __typename?: 'SpendTransferOutItem'; id: string }
    }>
  }
}

export type SubscriptionTierQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type SubscriptionTierQueryQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    uuid: string
    verified: boolean
    fundingSource: {
      __typename?: 'FundingSource'
      name: string
      verified: boolean
    }
  }
  bankCardOrder: {
    __typename?: 'BankCardOrder'
    cardOrderStatus: BankCardOrderStatus
  }
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    createdAt: any
    status: BankAccountStatus
    id: string
    balance: { __typename?: 'CurrencyAmount'; value: number }
  }>
  linkedAccounts: Array<{
    __typename?: 'LinkedAccount'
    linked: boolean
    id: string
  }>
  recurringTransfers: Array<{
    __typename?: 'RecurringTransfer'
    id: string
    active: boolean
  }>
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    name: string
    type: string
    product: InvestmentProduct
    status: InvestmentAccountStatus
    beneficiaryId: string
    closedAt: any
    currentBalance: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
    pendingBalance: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
    recurringInvestmentSettings: {
      __typename?: 'RecurringInvestmentSettings'
      amount: number
    }
    portfolios: Array<
      | { __typename?: 'Portfolio' }
      | {
          __typename: 'SelfDirectedPortfolio'
          status: SelfDirectedPortfolioStatus
        }
    >
  }>
}

export type TiersQueryVariables = Exact<{ [key: string]: never }>

export type TiersQuery = {
  __typename?: 'Query'
  tierGroupForUser: {
    __typename?: 'TierGroup'
    id: string
    preferredTierId: string
    createdAt: any
    updatedAt: any
    tierOptions: Array<{
      __typename?: 'TierOption'
      preferredTierPrice: {
        __typename?: 'TierPrice'
        id: string
        billingFrequency: BillingFrequency
        amount: {
          __typename?: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
      tier: {
        __typename?: 'Tier'
        id: string
        key: TierKey
        name: string
        includedProducts: Array<{ __typename?: 'TierProduct'; key: ProductKey }>
        excludedProducts: Array<{ __typename?: 'TierProduct'; key: ProductKey }>
      }
      tierPrices: Array<{
        __typename?: 'TierPrice'
        id: string
        billingFrequency: BillingFrequency
        amount: {
          __typename?: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }>
    }>
  }
}

export type EarlyTierGroupQueryVariables = Exact<{ [key: string]: never }>

export type EarlyTierGroupQuery = {
  __typename?: 'Query'
  tierGroup: {
    __typename?: 'TierGroup'
    id: string
    preferredTierId: string
    createdAt: any
    updatedAt: any
    tierOptions: Array<{
      __typename?: 'TierOption'
      preferredTierPrice: {
        __typename?: 'TierPrice'
        id: string
        billingFrequency: BillingFrequency
        amount: {
          __typename?: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }
      tier: {
        __typename?: 'Tier'
        id: string
        key: TierKey
        name: string
        description: string
        includedProducts: Array<{ __typename?: 'TierProduct'; key: ProductKey }>
        excludedProducts: Array<{ __typename?: 'TierProduct'; key: ProductKey }>
      }
      tierPrices: Array<{
        __typename?: 'TierPrice'
        id: string
        billingFrequency: BillingFrequency
        amount: {
          __typename?: 'CurrencyAmount'
          value: number
          currency: Currency
        }
      }>
    }>
  }
}

export type SubscriptionCenterFetchUsersTierQueryVariables = Exact<{
  [key: string]: never
}>

export type SubscriptionCenterFetchUsersTierQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    uuid: string
    verified: boolean
    fundingSource: {
      __typename?: 'FundingSource'
      name: string
      verified: boolean
    }
  }
  tierSubscriptionForUser:
    | {
        __typename: 'TierSubscription'
        id: string
        createdAt: any
        updatedAt: any
        tier: {
          __typename?: 'Tier'
          id: string
          key: TierKey
          name: string
          includedProducts: Array<{
            __typename?: 'TierProduct'
            key: ProductKey
          }>
          excludedProducts: Array<{
            __typename?: 'TierProduct'
            key: ProductKey
          }>
        }
        tierPrice: {
          __typename?: 'TierPrice'
          id: string
          billingFrequency: BillingFrequency
          amount: {
            __typename?: 'CurrencyAmount'
            value: number
            currency: Currency
          }
        }
      }
    | { __typename: 'TierSubscriptionNotFound'; message: string }
    | {
        __typename: 'TierSubscriptionUnsubscribed'
        id: string
        createdAt: any
        updatedAt: any
      }
}

export type UpdateCustomerAddressMutationVariables = Exact<{
  addressType: AddressType
  input: AddressInput
}>

export type UpdateCustomerAddressMutation = {
  __typename?: 'Mutation'
  updateCustomerAddress:
    | {
        __typename?: 'Address'
        addressType: AddressType
        city: string
        country: string
        createdAt: any
        id: string
        state: string
        street1: string
        street2: string
        updatedAt: any
        verified: boolean
        zipCode: string
      }
    | {
        __typename: 'InvalidAddressException'
        message: string
        reasons: Array<{
          __typename: 'InvalidAddressReason'
          addressLine: number
          code: InvalidAddressReasonCode
          maxLength: number
        }>
      }
}

export type UpdateShippingInfoMutationVariables = Exact<{
  street1?: InputMaybe<Scalars['String']>
  street2?: InputMaybe<Scalars['String']>
  city?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  zipCode?: InputMaybe<Scalars['String']>
}>

export type UpdateShippingInfoMutation = {
  __typename?: 'Mutation'
  updateAddress: { __typename?: 'Address'; id: string }
}

export type UpdatePersonalInfoMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  phoneNumber?: InputMaybe<Scalars['String']>
}>

export type UpdatePersonalInfoMutation = {
  __typename?: 'Mutation'
  updatePersonalInfo: { __typename?: 'User'; uuid: string }
}

export type AuthAndUserProfileQueryVariables = Exact<{ [key: string]: never }>

export type AuthAndUserProfileQuery = {
  __typename?: 'Query'
  authProfile: {
    __typename?: 'AuthProfile'
    email: any
    userId: string
    emailVerifiedAt: any
    phoneNumber: string
    phoneNumberVerifiedAt: any
    requireLoginChallenge: boolean
  }
  user: {
    __typename?: 'User'
    firstName: string
    lastName: string
    phoneNumber: string
    email: string
    registrationComplete: boolean
    verified: boolean
  }
}

export type AuthProfileQueryVariables = Exact<{ [key: string]: never }>

export type AuthProfileQuery = {
  __typename?: 'Query'
  authProfile: {
    __typename?: 'AuthProfile'
    phoneNumber: string
    phoneNumberVerifiedAt: any
    email: any
    emailVerifiedAt: any
  }
}

export type VerifyDeliveryAddressQueryVariables = Exact<{
  street1: Scalars['String']
  street2?: InputMaybe<Scalars['String']>
  city: Scalars['String']
  state: Scalars['String']
  zip: Scalars['String']
  country: Scalars['String']
}>

export type VerifyDeliveryAddressQuery = {
  __typename?: 'Query'
  addressDeliverability:
    | {
        __typename: 'AddressDeliverabilityCorrectedAddress'
        city: string
        country: string
        state: string
        street1: string
        street2: string
        zipCode: string
      }
    | { __typename: 'AddressDeliverabilityUnavailableError'; requestId: string }
    | {
        __typename: 'AddressDeliverabilityVerificationError'
        requestId: string
      }
    | { __typename: 'AddressDeliverabilityVerified'; requestId: string }
}

export type SettingsBankCardReissueQueryVariables = Exact<{
  [key: string]: never
}>

export type SettingsBankCardReissueQuery = {
  __typename?: 'Query'
  bankCardReissue: {
    __typename?: 'BankCardReissue'
    bankCardRequest: {
      __typename?: 'BankCardRequest'
      id: string
      userId: string
      requestedDate: any
      status: BankCardRequestStatus
      reason: BankCardRequestReason
      reasonComment: string
      reasonDate: any
      issuedDate: any
      isActivated: boolean
      isReissue: boolean
      previousBankCardId: string
    }
    reissueBankCardEligibility:
      | { __typename: 'ReissueBankCardEligible'; originalCardCreatedAt: any }
      | {
          __typename: 'ReissueBankCardIneligible'
          issues: Array<ReissueBankCardIneligibleIssue>
        }
  }
  spendAlerts: Array<
    | { __typename?: 'SystemCardLockedSpendAlert'; type: string }
    | { __typename?: 'UserCardLockedSpendAlert'; type: string }
  >
}

export type LockSpendCardMutationMutationVariables = Exact<{
  [key: string]: never
}>

export type LockSpendCardMutationMutation = {
  __typename?: 'Mutation'
  lockBankCard: {
    __typename?: 'LockBankCardPayload'
    bankCard: { __typename?: 'BankCard'; id: string }
  }
}

export type UpdateBankCardPinMutationVariables = Exact<{
  newPin: Scalars['BankCardPin']
}>

export type UpdateBankCardPinMutation = {
  __typename?: 'Mutation'
  updateBankCardPin: {
    __typename?: 'UpdateBankCardPinPayload'
    bankCard: { __typename?: 'BankCard'; id: string }
  }
}

export type SettingsSpendCardQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type SettingsSpendCardQueryQuery = {
  __typename?: 'Query'
  user: { __typename?: 'User'; firstName: string; lastName: string }
  allBankCards: Array<{
    __typename?: 'BankCard'
    id: string
    cardNumberMasked: any
    createdAt: any
    isDigitalOnly: boolean
    type: BankCardType
    lockReason: BankCardLockReason
    status: BankCardStatus
    tier: BankCardTier
  }>
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    id: string
    number: string
    routingNumber: string
  }>
}

export type RequestEligibilityQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type RequestEligibilityQueryQuery = {
  __typename?: 'Query'
  allBankCards: Array<{
    __typename?: 'BankCard'
    lockReason: BankCardLockReason
    type: BankCardType
  }>
}

export type AddressQueryQueryVariables = Exact<{ [key: string]: never }>

export type AddressQueryQuery = {
  __typename?: 'Query'
  addresses: Array<{
    __typename?: 'Address'
    city: string
    country: string
    state: string
    street1: string
    street2: string
    zipCode: string
  }>
}

export type UnlockSpendCardMutationVariables = Exact<{ [key: string]: never }>

export type UnlockSpendCardMutation = {
  __typename?: 'Mutation'
  unlockBankCard: {
    __typename?: 'UnlockBankCardPayload'
    bankCard: { __typename?: 'BankCard'; id: string }
  }
}

export type SettingsFetchUsersTierQueryVariables = Exact<{
  [key: string]: never
}>

export type SettingsFetchUsersTierQuery = {
  __typename?: 'Query'
  tierSubscriptionForUser:
    | {
        __typename: 'TierSubscription'
        id: string
        createdAt: any
        tier: {
          __typename?: 'Tier'
          active: boolean
          id: string
          key: TierKey
          name: string
        }
      }
    | { __typename: 'TierSubscriptionNotFound'; message: string }
    | {
        __typename: 'TierSubscriptionUnsubscribed'
        id: string
        createdAt: any
        updatedAt: any
      }
}

export type AddTrustedContactMutationVariables = Exact<{
  input: TrustedContactInput
}>

export type AddTrustedContactMutation = {
  __typename?: 'Mutation'
  addTrustedContact:
    | {
        __typename: 'InternalErrorException'
        internalExceptionErrorMessage: string
      }
    | { __typename: 'TrustedContact'; firstName: string; lastName: string }
    | {
        __typename?: 'TrustedContactAlreadyExistsException'
        message: string
        attributes: Array<string>
      }
    | { __typename?: 'TrustedContactInvalidEmail'; message: string }
    | { __typename?: 'TrustedContactInvalidPhoneNumber'; message: string }
    | { __typename?: 'TrustedContactNotFoundException' }
}

export type DeleteTrustedContactMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type DeleteTrustedContactMutation = {
  __typename?: 'Mutation'
  deleteTrustedContact:
    | {
        __typename: 'InternalErrorException'
        internalExceptionErrorMessage: string
      }
    | { __typename: 'TrustedContact'; firstName: string; lastName: string }
    | { __typename?: 'TrustedContactNotFoundException'; message: string }
}

export type EditTrustedContactMutationVariables = Exact<{
  id: Scalars['ID']
  input: TrustedContactInput
}>

export type EditTrustedContactMutation = {
  __typename?: 'Mutation'
  editTrustedContact:
    | {
        __typename: 'InternalErrorException'
        internalExceptionErrorMessage: string
      }
    | { __typename: 'TrustedContact'; firstName: string; lastName: string }
    | {
        __typename?: 'TrustedContactAlreadyExistsException'
        message: string
        attributes: Array<string>
      }
    | { __typename?: 'TrustedContactInvalidEmail'; message: string }
    | { __typename?: 'TrustedContactInvalidPhoneNumber'; message: string }
    | { __typename?: 'TrustedContactNotFoundException'; message: string }
}

export type GetAllTrustedContactsByUserIdQueryVariables = Exact<{
  [key: string]: never
}>

export type GetAllTrustedContactsByUserIdQuery = {
  __typename?: 'Query'
  allTrustedContactsByUserId: Array<{
    __typename: 'TrustedContact'
    email: any
    firstName: string
    id: string
    lastName: string
    phoneNumber: any
    userId: string
    investmentAccounts: Array<{
      __typename?: 'InvestmentAccount'
      id: string
      investmentAccountType: InvestmentAccountType
      name: string
      product: InvestmentProduct
      type: string
      beneficiary: { __typename?: 'Beneficiary'; id: string; firstName: string }
      portfolios: Array<
        | { __typename?: 'Portfolio'; id: string; name: string }
        | {
            __typename?: 'SelfDirectedPortfolio'
            status: SelfDirectedPortfolioStatus
            id: string
            name: string
          }
      >
    }>
  }>
}

export type TrustedContactInvestmentAccountsByUserIdQueryVariables = Exact<{
  [key: string]: never
}>

export type TrustedContactInvestmentAccountsByUserIdQuery = {
  __typename?: 'Query'
  investmentAccountsByUserId: Array<{
    __typename?: 'InvestmentAccount'
    id: string
    investmentAccountType: InvestmentAccountType
    name: string
    product: InvestmentProduct
    type: string
    beneficiary: { __typename?: 'Beneficiary'; id: string; firstName: string }
    portfolios: Array<
      | { __typename?: 'Portfolio'; id: string; name: string }
      | {
          __typename?: 'SelfDirectedPortfolio'
          status: SelfDirectedPortfolioStatus
          id: string
          name: string
        }
    >
    trustedContact: {
      __typename?: 'TrustedContact'
      id: string
      firstName: string
      lastName: string
      email: any
      phoneNumber: any
    }
  }>
}

export type ParameterizedPdfQueryVariables = Exact<{
  bankAccountId: Scalars['ID']
  userId: Scalars['ID']
  employerName: Scalars['String']
  dateSigned: Scalars['String']
  distributionType: DirectDepositDistribution
  distributionAmount?: InputMaybe<Scalars['Float']>
  sessionId?: InputMaybe<Scalars['ID']>
}>

export type ParameterizedPdfQuery = {
  __typename?: 'Query'
  parameterizedPdf: { __typename?: 'GenerateUpdatedPdfPayload'; pdf: string }
}

export type SpendAccountIdQueryQueryVariables = Exact<{ [key: string]: never }>

export type SpendAccountIdQueryQuery = {
  __typename?: 'Query'
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    id: string
    bankType: BankType
  }>
}

export type UpdateSignatureMutationMutationVariables = Exact<{
  svgFile: Scalars['String']
}>

export type UpdateSignatureMutationMutation = {
  __typename?: 'Mutation'
  updateSignature: { __typename?: 'Signature'; svgFile: string }
}

export type DirectDepositBankAccountQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type DirectDepositBankAccountQueryQuery = {
  __typename?: 'Query'
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    routingNumber: string
    number: string
    id: string
  }>
}

export type StartOnlineSwitchMutationVariables = Exact<{
  employerId: Scalars['ID']
  bankAccountId: Scalars['ID']
  sessionId?: InputMaybe<Scalars['ID']>
}>

export type StartOnlineSwitchMutation = {
  __typename?: 'Mutation'
  startOnlineSwitch: {
    __typename?: 'StartOnlineSwitchPayload'
    userSwitch: {
      __typename?: 'UserSwitch'
      id: string
      userId: string
      status: SwitchStatus
      switchType: SwitchType
      isComplete: boolean
      vendorSwitchId: string
      createdAt: string
      updatedAt: string
    }
  }
}

export type StartAcornsPdfSwitchMutationVariables = Exact<{
  name: Scalars['String']
  bankAccountId: Scalars['ID']
  sessionId: Scalars['ID']
}>

export type StartAcornsPdfSwitchMutation = {
  __typename?: 'Mutation'
  startAcornsPdfSwitch: boolean
}

export type GenerateUpdatedPdfQueryVariables = Exact<{
  bankAccountId: Scalars['ID']
  userId: Scalars['ID']
  employerName: Scalars['String']
  sessionId: Scalars['ID']
}>

export type GenerateUpdatedPdfQuery = {
  __typename?: 'Query'
  generateUpdatedPdf: { __typename?: 'GenerateUpdatedPdfPayload'; pdf: string }
}

export type PdfDownloadUrlQueryVariables = Exact<{
  bankAccountId: Scalars['ID']
  userId: Scalars['ID']
  sessionId: Scalars['ID']
  employerName: Scalars['String']
}>

export type PdfDownloadUrlQuery = {
  __typename?: 'Query'
  pdfDownloadUrl: { __typename?: 'PdfDownloadUrlPayload'; url: string }
}

export type SpendAccountsQueryVariables = Exact<{ [key: string]: never }>

export type SpendAccountsQuery = {
  __typename?: 'Query'
  user: { __typename?: 'User'; uuid: string; email: string }
  profile: { __typename?: 'Profile'; ssnLastFour: string }
  spendAccounts: Array<{
    __typename?: 'BankAccount'
    id: string
    number: string
    routingNumber: string
    bankType: BankType
    balance: { __typename?: 'CurrencyAmount'; value: number }
  }>
  topEmployersData: {
    __typename?: 'TopEmployerPayload'
    topEmployersList: Array<{
      __typename?: 'TopEmployer'
      employerName: string
      logo: string
    }>
  }
  spendAccount: {
    __typename?: 'SpendAccount'
    isDirectDepositIncentiveEligible: boolean
    bankCardOrder: { __typename?: 'BankCardOrder'; bankCardTier: BankCardTier }
  }
}

export type CreateDdLinkInfoMutationVariables = Exact<{
  userId: Scalars['ID']
  accountId: Scalars['ID']
}>

export type CreateDdLinkInfoMutation = {
  __typename?: 'Mutation'
  createDirectDepositLinkInfo:
    | {
        __typename: 'CreateDirectDepositLinkInfoFailure'
        failureMessage: string
      }
    | {
        __typename: 'CreateDirectDepositLinkInfoPayload'
        vendor: string
        results: {
          __typename?: 'CreatePinwheelLinkToken'
          id: string
          expires: any
          mode: string
          token: string
        }
      }
}

export type SearchEmployersQueryVariables = Exact<{
  searchTerm: Scalars['String']
  sessionId: Scalars['ID']
  bankAccountId: Scalars['ID']
}>

export type SearchEmployersQuery = {
  __typename?: 'Query'
  searchEmployers: {
    __typename?: 'SearchEmployersPayload'
    trackingId: string
    results: Array<{
      __typename?: 'Employer'
      id: string
      employerName: string
      logoUrl: string
      switchType: SwitchType
      switch:
        | { __typename?: 'AcornsPdfSwitch' }
        | {
            __typename: 'OnlineSwitch'
            url: string
            onlineVendorTargetId: string
          }
        | {
            __typename: 'SubmittableSwitch'
            requiresEmployerMailingAddress: boolean
            submittableVendorTargetId: string
          }
    }>
  }
}

export type SubmitSwitchMutationVariables = Exact<{
  employerId: Scalars['ID']
  bankAccountId: Scalars['ID']
  sessionId: Scalars['ID']
  employerLocationAddress: StartSubmittableSwitchAddressInput
}>

export type SubmitSwitchMutation = {
  __typename?: 'Mutation'
  startSubmittableSwitch: {
    __typename?: 'StartSubmittableSwitchPayload'
    userSwitch: {
      __typename?: 'UserSwitch'
      id: string
      isComplete: boolean
      status: SwitchStatus
      switchType: SwitchType
      createdAt: string
      updatedAt: string
      userId: string
      vendorSwitchId: string
    }
  }
}

export type LockedAccountBankAccountQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type LockedAccountBankAccountQueryQuery = {
  __typename?: 'Query'
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    isLocked: boolean
    lockReason: BankAccountLockReason
    id: string
  }>
}

export type OccupationQueryQueryVariables = Exact<{ [key: string]: never }>

export type OccupationQueryQuery = {
  __typename?: 'Query'
  bankingEmploymentStatuses: Array<string>
  occupations: Array<{ __typename?: 'Occupation'; name: string }>
  user: { __typename?: 'User'; occupation: string }
  spendAccount: { __typename?: 'SpendAccount'; isReopenable: boolean }
}

export type SpendHomeQueryVariables = Exact<{ [key: string]: never }>

export type SpendHomeQuery = {
  __typename?: 'Query'
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    id: string
    createdAt: any
    status: BankAccountStatus
    closedAt: any
    availableBalance: { __typename?: 'CurrencyAmount'; value: number }
    pendingBalance: { __typename?: 'CurrencyAmount'; value: number }
    balance: { __typename?: 'CurrencyAmount'; value: number }
  }>
  user: { __typename?: 'User'; firstName: string }
  allBankCards: Array<{
    __typename?: 'BankCard'
    cardNumberMasked: any
    lockReason: BankCardLockReason
    status: BankCardStatus
    type: BankCardType
  }>
  directDepositState: {
    __typename?: 'DirectDepositStatePayload'
    state: {
      __typename?: 'DirectDepositState'
      createdAt: any
      switchState: SwitchState
      switchMethod: SwitchMethod
      updatedAt: any
    }
  }
  spendAccount: {
    __typename?: 'SpendAccount'
    status: SpendAccountStatus
    isReopenable: boolean
  }
  bankCardOrder: { __typename?: 'BankCardOrder'; bankCardTier: BankCardTier }
  roundUpProfile: { __typename?: 'RoundUpProfile'; roundUpsEnabled: boolean }
}

export type RecurringTransfersQueryVariables = Exact<{ [key: string]: never }>

export type RecurringTransfersQuery = {
  __typename?: 'Query'
  recurringTransfers: Array<{
    __typename?: 'RecurringTransfer'
    id: string
    active: boolean
    nextTransferDate: any
    recurrenceRule: {
      __typename?: 'RecurrenceRule'
      frequency: RecurrenceFrequency
      byWeekDay: Array<DayOfWeek>
      byMonthDay: Array<number>
      interval: number
      startDate: any
      endDate: any
    }
    transferEvent: {
      __typename?: 'RecurringTransferEvent'
      direction: RecurringTransferDirection
      targetAccount: { __typename?: 'RecurringTransferAccount'; id: string }
      amount: {
        __typename?: 'CurrencyAmount'
        value: number
        currency: Currency
      }
    }
  }>
}

export type CancelRecurringTransferMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type CancelRecurringTransferMutation = {
  __typename?: 'Mutation'
  cancelRecurringTransfer:
    | {
        __typename: 'RecurringTransfer'
        active: boolean
        id: string
        nextTransferDate: any
        recurrenceRule: {
          __typename?: 'RecurrenceRule'
          byMonthDay: Array<number>
          byWeekDay: Array<DayOfWeek>
          endDate: any
          frequency: RecurrenceFrequency
          interval: number
          startDate: any
        }
        transferEvent: {
          __typename?: 'RecurringTransferEvent'
          direction: RecurringTransferDirection
          targetAccount: {
            __typename?: 'RecurringTransferAccount'
            type: RecurringTransferAccountType
            id: string
          }
          fundingSource: {
            __typename?: 'RecurringTransferFundingSource'
            type: RecurringTransferFundingSourceType
            id: string
          }
          amount: {
            __typename?: 'CurrencyAmount'
            value: number
            currency: Currency
          }
        }
      }
    | { __typename: 'VersionMismatchException' }
}

export type NextTransferDateQueryVariables = Exact<{
  frequencyObject: RecurrenceRuleInput
}>

export type NextTransferDateQuery = {
  __typename?: 'Query'
  nextTransferDate:
    | {
        __typename: 'MalformedRecurringTransferException'
        pathExceptions: Array<{
          __typename?: 'RecurringTransferPathException'
          exception: RecurringTransferPathExceptionCase
          path: Array<string>
        }>
      }
    | { __typename: 'RecurringTransferDate'; nextTransferDate: any }
}

export type RecurringTransfersQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type RecurringTransfersQueryQuery = {
  __typename?: 'Query'
  allTransferableFrom: Array<{
    __typename?: 'TransferableFrom'
    from: {
      __typename?: 'TransferableAccount'
      accountNumberMasked: string
      externalSource: ExternalSource
      id: string
      name: string
      type: TransferableAccountTypeEnum
      balance: { __typename?: 'CurrencyAmount'; value: number }
    }
  }>
  recurringTransfers: Array<{
    __typename?: 'RecurringTransfer'
    id: string
    active: boolean
    nextTransferDate: any
    recurrenceRule: {
      __typename?: 'RecurrenceRule'
      frequency: RecurrenceFrequency
      byWeekDay: Array<DayOfWeek>
      byMonthDay: Array<number>
      interval: number
      startDate: any
      endDate: any
    }
    transferEvent: {
      __typename?: 'RecurringTransferEvent'
      direction: RecurringTransferDirection
      targetAccount: { __typename?: 'RecurringTransferAccount'; id: string }
      amount: {
        __typename?: 'CurrencyAmount'
        value: number
        currency: Currency
      }
    }
  }>
}

export type ResumeUserDepositsMutationVariables = Exact<{
  [key: string]: never
}>

export type ResumeUserDepositsMutation = {
  __typename?: 'Mutation'
  suspendDeposits: any
}

export type ScheduleRecurringTransferMutationVariables = Exact<{
  input: ScheduleRecurringTransferInput
}>

export type ScheduleRecurringTransferMutation = {
  __typename?: 'Mutation'
  scheduleRecurringTransfer:
    | {
        __typename: 'MalformedRecurringTransferException'
        pathExceptions: Array<{
          __typename?: 'RecurringTransferPathException'
          exception: RecurringTransferPathExceptionCase
          path: Array<string>
        }>
      }
    | {
        __typename: 'RecurringTransfer'
        active: boolean
        id: string
        nextTransferDate: any
        recurrenceRule: {
          __typename?: 'RecurrenceRule'
          byMonthDay: Array<number>
          byWeekDay: Array<DayOfWeek>
          endDate: any
          frequency: RecurrenceFrequency
          interval: number
          startDate: any
        }
        transferEvent: {
          __typename?: 'RecurringTransferEvent'
          direction: RecurringTransferDirection
          targetAccount: {
            __typename?: 'RecurringTransferAccount'
            type: RecurringTransferAccountType
            id: string
          }
          fundingSource: {
            __typename?: 'RecurringTransferFundingSource'
            type: RecurringTransferFundingSourceType
            id: string
          }
          amount: {
            __typename?: 'CurrencyAmount'
            value: number
            currency: Currency
          }
        }
      }
}

export type ReissueBankCardMutationMutationVariables = Exact<{
  reason: BankCardRequestReason
  reasonComment?: InputMaybe<Scalars['String']>
  reasonDate?: InputMaybe<Scalars['Date']>
  mailingAddress: BankCardRequestMailingAddressInput
}>

export type ReissueBankCardMutationMutation = {
  __typename?: 'Mutation'
  reissueBankCard:
    | { __typename: 'BankCardRequest' }
    | { __typename: 'ReissueBankCardExistsError' }
    | { __typename: 'ReissueBankCardInvalidReasonError' }
    | { __typename: 'ReissueBankCardMailingAddressRequiredError' }
}

export type UpdateResidentialAddressMutationVariables = Exact<{
  street1?: InputMaybe<Scalars['String']>
  street2?: InputMaybe<Scalars['String']>
  city?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  zipCode?: InputMaybe<Scalars['String']>
}>

export type UpdateResidentialAddressMutation = {
  __typename?: 'Mutation'
  updateAddress: { __typename?: 'Address'; id: string }
}

export type CardShippedQueryQueryVariables = Exact<{ [key: string]: never }>

export type CardShippedQueryQuery = {
  __typename?: 'Query'
  directDepositInfo: {
    __typename?: 'DirectDepositInfoPayload'
    info: { __typename?: 'DirectDepositInfo'; status: DirectDepositStatus }
  }
  allCardTrackingStatuses: Array<{
    __typename?: 'CardDeliveryStatus'
    picNumber: string
  }>
}

export type BankCardReissueQueryVariables = Exact<{ [key: string]: never }>

export type BankCardReissueQuery = {
  __typename?: 'Query'
  bankCardReissue: {
    __typename?: 'BankCardReissue'
    bankCardRequest: {
      __typename?: 'BankCardRequest'
      id: string
      userId: string
      requestedDate: any
      status: BankCardRequestStatus
      reason: BankCardRequestReason
      reasonComment: string
      reasonDate: any
      issuedDate: any
      isActivated: boolean
      previousBankCardId: string
      mailingAddress: {
        __typename?: 'BankCardRequestMailingAddress'
        city: string
        state: string
        zipCode: string
        street1: string
        street2: string
      }
    }
    reissueBankCardEligibility:
      | { __typename: 'ReissueBankCardEligible'; originalCardCreatedAt: any }
      | {
          __typename: 'ReissueBankCardIneligible'
          issues: Array<ReissueBankCardIneligibleIssue>
        }
  }
}

export type ResidentialAddressQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type ResidentialAddressQueryQuery = {
  __typename?: 'Query'
  addresses: Array<{
    __typename?: 'Address'
    street1: string
    street2: string
    state: string
    city: string
    zipCode: string
    updatedAt: any
  }>
}

export type SpendCardQueryQueryVariables = Exact<{ [key: string]: never }>

export type SpendCardQueryQuery = {
  __typename?: 'Query'
  user: { __typename?: 'User'; firstName: string; lastName: string }
  allBankCards: Array<{
    __typename?: 'BankCard'
    cardNumberMasked: any
    lockReason: BankCardLockReason
    status: BankCardStatus
  }>
  addresses: Array<{
    __typename?: 'Address'
    street1: string
    street2: string
    state: string
    city: string
    zipCode: string
    updatedAt: any
  }>
}

export type SpendReopenSubscriptionQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type SpendReopenSubscriptionQueryQuery = {
  __typename?: 'Query'
  tierSubscriptionForUser:
    | {
        __typename: 'TierSubscription'
        id: string
        tier: {
          __typename?: 'Tier'
          id: string
          key: TierKey
          products: Array<{ __typename?: 'Product'; key: ProductKey }>
        }
        tierPrice: {
          __typename?: 'TierPrice'
          id: string
          amount: { __typename?: 'CurrencyAmount'; value: number }
        }
      }
    | { __typename: 'TierSubscriptionNotFound' }
    | { __typename: 'TierSubscriptionUnsubscribed' }
  tierOptionByProductKey: {
    __typename?: 'TierOption'
    tier: { __typename?: 'Tier'; id: string; key: TierKey }
    preferredTierPrice: {
      __typename?: 'TierPrice'
      id: string
      amount: {
        __typename?: 'CurrencyAmount'
        value: number
        currency: Currency
      }
    }
  }
  spendAccount: {
    __typename?: 'SpendAccount'
    status: SpendAccountStatus
    isEligible: boolean
    isReopenable: boolean
    bankType: BankType
  }
}

export type SpendReopenSubscribeUserToTierMutationMutationVariables = Exact<{
  tierPriceId: Scalars['ID']
}>

export type SpendReopenSubscribeUserToTierMutationMutation = {
  __typename?: 'Mutation'
  subscribeUserToTier:
    | { __typename: 'InvalidTierPriceId' }
    | { __typename: 'TierDowngradeActionRequired' }
    | { __typename: 'TierSubscription'; id: string }
}

export type OrderBankCardMutationMutationVariables = Exact<{
  bankType?: InputMaybe<BankType>
  isDocumentsAccepted: Scalars['Boolean']
  isReopen?: InputMaybe<Scalars['Boolean']>
  paymentProcessor?: InputMaybe<BankCardPaymentProcessor>
  prefundTransfer?: InputMaybe<BankCardPrefundTransfer>
  employmentStatus?: InputMaybe<Scalars['String']>
  requestVersion?: InputMaybe<RequestVersions>
  bankCardTier?: InputMaybe<BankCardTier>
}>

export type OrderBankCardMutationMutation = {
  __typename?: 'Mutation'
  orderBankCard: {
    __typename?: 'BankCardOrder'
    cardOrderStatus: BankCardOrderStatus
  }
}

export type SpendAccountFundingSourceVerificationQueryVariables = Exact<{
  [key: string]: never
}>

export type SpendAccountFundingSourceVerificationQuery = {
  __typename?: 'Query'
  spendAccount: {
    __typename?: 'SpendAccount'
    bankCardOrder: {
      __typename?: 'BankCardOrder'
      fundingSourceVerification: {
        __typename?: 'BankCardOrderFundingSourceVerification'
        status: BankCardOrderVerificationStatus
        pendingReason: BankCardOrderFundingSourceVerificationPendingReason
        actionRequired: BankCardOrderFundingSourceVerificationActions
      }
    }
  }
}

export type PinwheelQueryQueryVariables = Exact<{ [key: string]: never }>

export type PinwheelQueryQuery = {
  __typename?: 'Query'
  user: { __typename?: 'User'; uuid: string }
  spendAccounts: Array<{ __typename?: 'BankAccount'; id: string }>
}

export type SignupQueryQueryVariables = Exact<{ [key: string]: never }>

export type SignupQueryQuery = {
  __typename?: 'Query'
  bankingEmploymentStatuses: Array<string>
  tierSubscriptionForUser:
    | {
        __typename: 'TierSubscription'
        id: string
        tier: {
          __typename?: 'Tier'
          id: string
          key: TierKey
          products: Array<{ __typename?: 'Product'; key: ProductKey }>
        }
        tierPrice: {
          __typename?: 'TierPrice'
          id: string
          amount: { __typename?: 'CurrencyAmount'; value: number }
        }
      }
    | { __typename: 'TierSubscriptionNotFound' }
    | { __typename: 'TierSubscriptionUnsubscribed' }
  tierOptionByProductKey: {
    __typename?: 'TierOption'
    tier: { __typename?: 'Tier'; id: string; key: TierKey }
    preferredTierPrice: {
      __typename?: 'TierPrice'
      id: string
      amount: {
        __typename?: 'CurrencyAmount'
        value: number
        currency: Currency
      }
    }
  }
  isDirectDepositIncentiveEligible: {
    __typename?: 'SpendAccount'
    isDirectDepositIncentiveEligible: boolean
  }
  user: {
    __typename?: 'User'
    firstName: string
    lastName: string
    phoneNumber: string
    occupation: string
    verified: boolean
  }
  residential: Array<{
    __typename?: 'Address'
    street1: string
    street2: string
    city: string
    state: string
    zipCode: string
    addressType: AddressType
  }>
  mailing: Array<{
    __typename?: 'Address'
    street1: string
    street2: string
    city: string
    state: string
    zipCode: string
    addressType: AddressType
  }>
  occupations: Array<{ __typename?: 'Occupation'; name: string }>
  spendAccount: {
    __typename?: 'SpendAccount'
    isEligible: boolean
    accountId: string
    isReopenable: boolean
    status: SpendAccountStatus
    bankType: BankType
    bankCardOrder: {
      __typename?: 'BankCardOrder'
      cardOrderStatus: BankCardOrderStatus
      kycStatus: KycStatus
      fundingSourceVerification: {
        __typename?: 'BankCardOrderFundingSourceVerification'
        status: BankCardOrderVerificationStatus
      }
    }
  }
  signatures: Array<{ __typename?: 'Signature'; svgFile: string }>
  acceptanceDocuments: Array<{
    __typename?: 'AcceptanceDocument'
    id: string
    name: string
    type: string
    url: any
    requiredFor: string
  }>
  nbkcdocs: Array<{
    __typename?: 'BankAccountDisclosure'
    id: string
    name: string
    type: string
    url: string
    summaryName: string
    summaryUrl: string
    mustScrollToBottom: boolean
    requiredFor: string
  }>
  profile: { __typename?: 'Profile'; transfersPaused: boolean }
  fundingSourceAccounts: Array<{
    __typename?: 'FundingSourceAccount'
    name: string
    last4: string
    fundType: FundingSourceType
    id: number
    status: FundingSourceStatus
    verified: boolean
    uuid: string
    role: FundingSourceRoleEnum
  }>
  linkedSubaccounts: Array<{
    __typename?: 'LinkedSubaccount'
    role: LinkedSubaccountRoleEnum
    linkedAccount: {
      __typename?: 'LinkedAccount'
      id: string
      linkedSubaccounts: Array<{
        __typename?: 'LinkedSubaccount'
        linkedAccountId: string
        id: string
      }>
    }
  }>
  eligibility: { __typename?: 'Eligibility'; eligible: boolean }
  roundUpProfile: { __typename?: 'RoundUpProfile'; roundUpsEnabled: boolean }
}

export type ActivateBankCardMutationVariables = Exact<{
  cardNumberMasked: Scalars['CardNumberMasked']
}>

export type ActivateBankCardMutation = {
  __typename?: 'Mutation'
  activateBankCard: {
    __typename?: 'ActivateBankCardPayload'
    bankCard: { __typename?: 'BankCard'; status: BankCardStatus }
  }
}

export type GetSpendCardLast4QueryVariables = Exact<{ [key: string]: never }>

export type GetSpendCardLast4Query = {
  __typename?: 'Query'
  allBankCards: Array<{
    __typename?: 'BankCard'
    cardNumberMasked: any
    type: BankCardType
    status: BankCardStatus
  }>
}

export type SpendActivationTransferableFromQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type SpendActivationTransferableFromQueryQuery = {
  __typename?: 'Query'
  allTransferableFrom: Array<{
    __typename?: 'TransferableFrom'
    from: {
      __typename?: 'TransferableAccount'
      accountNumberMasked: string
      externalSource: ExternalSource
      id: string
      name: string
      type: TransferableAccountTypeEnum
      balance: { __typename?: 'CurrencyAmount'; value: number }
    }
  }>
  eligibility: { __typename?: 'Eligibility'; eligible: boolean }
}

export type SpendActivationAgreeToAcceptanceDocumentMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type SpendActivationAgreeToAcceptanceDocumentMutation = {
  __typename?: 'Mutation'
  agreeToAcceptanceDocument: any
}

export type AcceptanceDocumentsQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type AcceptanceDocumentsQueryQuery = {
  __typename?: 'Query'
  acceptanceDocuments: Array<{
    __typename?: 'BankAccountDisclosure'
    id: string
    name: string
    type: string
    url: string
    summaryName: string
    summaryUrl: string
    mustScrollToBottom: boolean
    requiredFor: string
  }>
  allBankCards: Array<{
    __typename?: 'BankCard'
    paymentProcessor: BankCardPaymentProcessor
    status: BankCardStatus
    createdAt: any
    bankType: BankType
  }>
  nbkcdocs: Array<{
    __typename?: 'BankAccountDisclosure'
    id: string
    name: string
    type: string
    url: string
    summaryName: string
    summaryUrl: string
    mustScrollToBottom: boolean
    requiredFor: string
  }>
  spendAccount: {
    __typename?: 'SpendAccount'
    isReopenable: boolean
    bankType: BankType
  }
}

export type InitiateTransferActivationMutationVariables = Exact<{
  amount: Scalars['Float']
  fromAccountId: Scalars['ID']
  toAccountId: Scalars['ID']
  nonce?: InputMaybe<Scalars['ID']>
}>

export type InitiateTransferActivationMutation = {
  __typename?: 'Mutation'
  initiateTransfer: {
    __typename?: 'InitiateTransferPayload'
    transfer: { __typename?: 'Transfer'; createdAt: any }
  }
}

export type CancelCheckPaymentMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type CancelCheckPaymentMutation = {
  __typename?: 'Mutation'
  cancelCheckPayment:
    | { __typename?: 'AuthorizationError'; requestId: string }
    | { __typename?: 'CheckPayment'; checkNumber: string }
    | { __typename?: 'ResourceNotFoundError'; requestId: string }
    | { __typename?: 'UnableToCancelCheckError'; requestId: string }
}

export type CheckHistoryQueryVariables = Exact<{
  after?: InputMaybe<Scalars['ID']>
}>

export type CheckHistoryQuery = {
  __typename?: 'Query'
  allCheckPayments:
    | { __typename?: 'AuthorizationError' }
    | {
        __typename?: 'CheckPaymentConnection'
        pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean }
        edges: Array<{
          __typename?: 'CheckPaymentEdge'
          cursor: string
          node: {
            __typename?: 'CheckPayment'
            checkNumber: string
            fromAccountId: string
            recipientName: string
            estimatedArrivalAt: any
            status: CheckPaymentStatus
            memo: string
            id: string
            createdAt: any
            failedAt: any
            failureReason: CheckPaymentFailureReason
            canceledAt: any
            amount: { __typename?: 'CurrencyAmount'; value: number }
            recipientAddress: {
              __typename?: 'CheckPaymentAddress'
              street1: string
              state: string
              zipCode: string
              street2: string
              city: string
            }
          }
        }>
      }
}

export type AddressesQueryVariables = Exact<{ [key: string]: never }>

export type AddressesQuery = {
  __typename?: 'Query'
  addresses: Array<{
    __typename?: 'Address'
    street1: string
    city: string
    country: string
  }>
}

export type SpendAtmFragmentFragment = {
  __typename?: 'SpendAtm'
  atmName: string
  address: {
    __typename?: 'SpendAtmAddress'
    latitude: string
    longitude: string
    addressLine: string
    cityName: string
    stateCode: string
    postalCode: string
    country: string
  }
}

export type SpendAtMsQueryVariables = Exact<{
  latitude: Scalars['String']
  longitude: Scalars['String']
  searchRadius: Scalars['Float']
}>

export type SpendAtMsQuery = {
  __typename?: 'Query'
  spendAtms:
    | { __typename: 'SpendAtmVendorUnavailableError'; requestId: string }
    | {
        __typename: 'SpendAtmsPayload'
        executedSearchRadius: string
        atms: Array<{
          __typename?: 'SpendAtm'
          atmName: string
          address: {
            __typename?: 'SpendAtmAddress'
            latitude: string
            longitude: string
            addressLine: string
            cityName: string
            stateCode: string
            postalCode: string
            country: string
          }
        }>
      }
}

export type SendCheckAgreeToAcceptanceDocumentMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type SendCheckAgreeToAcceptanceDocumentMutation = {
  __typename?: 'Mutation'
  agreeToAcceptanceDocument: any
}

export type AcceptancedocsQueryVariables = Exact<{ [key: string]: never }>

export type AcceptancedocsQuery = {
  __typename?: 'Query'
  acceptanceDocuments: Array<{
    __typename?: 'AcceptanceDocument'
    id: string
    type: string
    url: any
  }>
  spendAccount: { __typename?: 'SpendAccount'; bankType: BankType }
}

export type SpendSendCheckTransferableFromQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type SpendSendCheckTransferableFromQueryQuery = {
  __typename?: 'Query'
  allTransferableFrom: Array<{
    __typename?: 'TransferableFrom'
    from: {
      __typename?: 'TransferableAccount'
      accountNumberMasked: string
      externalSource: ExternalSource
      id: string
      name: string
      type: TransferableAccountTypeEnum
      balance: { __typename?: 'CurrencyAmount'; value: number }
    }
  }>
  estimatedCheckPaymentDates: {
    __typename?: 'EstimatedCheckPaymentDates'
    estimatedShippingAt: any
    estimatedArrivalAt: any
    estimatedTransferAtText: string
  }
}

export type SendCheckPaymentMutationVariables = Exact<{
  recipientName: CheckPaymentRecipientInput
  city: Scalars['String']
  state: Scalars['String']
  address1: Scalars['String']
  address2?: InputMaybe<Scalars['String']>
  zip: Scalars['String']
  amount: Scalars['Float']
  memo?: InputMaybe<Scalars['String']>
  country: Scalars['String']
  fromAccountId: Scalars['ID']
  nonce: Scalars['String']
}>

export type SendCheckPaymentMutation = {
  __typename?: 'Mutation'
  sendCheckPayment:
    | { __typename: 'AuthorizationError'; requestId: string }
    | {
        __typename: 'CheckPayment'
        createdAt: any
        id: string
        status: CheckPaymentStatus
      }
    | { __typename: 'DuplicateActionError'; requestId: string }
    | {
        __typename: 'InvalidAddressError'
        requestId: string
        errorMessage: string
      }
}

export type VerifyCheckPaymentRecipientAddressQueryVariables = Exact<{
  recipient: CheckPaymentRecipientInput
  street1: Scalars['String']
  street2?: InputMaybe<Scalars['String']>
  city: Scalars['String']
  state: Scalars['String']
  zip: Scalars['String']
  country: Scalars['String']
}>

export type VerifyCheckPaymentRecipientAddressQuery = {
  __typename?: 'Query'
  verifyCheckPaymentRecipientAddress:
    | { __typename: 'AuthorizationError'; requestId: string }
    | {
        __typename: 'CheckPaymentRecipientAddressType'
        recipient: {
          __typename?: 'CheckPaymentRecipient'
          firstName: string
          lastName: string
          businessName: string
        }
        recipientAddress: {
          __typename?: 'CheckPaymentAddress'
          street1: string
          street2: string
          city: string
          state: string
          zipCode: string
          country: string
        }
      }
    | {
        __typename: 'InvalidAddressError'
        requestId: string
        errorMessage: string
      }
}

export type InitiateTransferSignupMutationVariables = Exact<{
  amount: Scalars['Float']
  fromAccountId: Scalars['ID']
  toAccountId: Scalars['ID']
  nonce?: InputMaybe<Scalars['ID']>
}>

export type InitiateTransferSignupMutation = {
  __typename?: 'Mutation'
  initiateTransfer: {
    __typename?: 'InitiateTransferPayload'
    transfer: { __typename?: 'Transfer'; createdAt: any }
  }
}

export type AddressFileUploadMutationVariables = Exact<{
  file: Scalars['Upload']
  documentRequestId: Scalars['ID']
}>

export type AddressFileUploadMutation = {
  __typename?: 'Mutation'
  uploadDocuments: Array<
    | {
        __typename?: 'File'
        encoding: string
        filename: string
        mimetype: string
        url: any
      }
    | { __typename?: 'FileSizeError' }
    | { __typename?: 'UploadFailedError' }
  >
}

export type UserQueryVariables = Exact<{ [key: string]: never }>

export type UserQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    address1: string
    address2: string
    state: any
    zip: string
    city: string
  }
  documentRequests: {
    __typename?: 'DocumentRequestsConnection'
    edges: Array<{
      __typename?: 'DocumentRequestEdge'
      node: {
        __typename?: 'DocumentRequest'
        id: string
        documentType: DocumentType
        status: DocumentStatus
        parentRequest: {
          __typename?: 'DocumentRequest'
          rejectedReason: RejectedReason
          id: string
          status: DocumentStatus
        }
      }
    }>
  }
}

export type BankVerifyIdentityByDocumentsMutationVariables = Exact<{
  input: ValidateDocumentsInput
}>

export type BankVerifyIdentityByDocumentsMutation = {
  __typename?: 'Mutation'
  verifyIdentityByDocuments: {
    __typename?: 'DocumentVerification'
    decision: DocumentVerificationDecision
    outstandingIssues: Array<string>
    verificationCriteriaMet: boolean
  }
}

export type DocumentRequestsQueryVariables = Exact<{ [key: string]: never }>

export type DocumentRequestsQuery = {
  __typename?: 'Query'
  documentRequests: {
    __typename?: 'DocumentRequestsConnection'
    edges: Array<{
      __typename?: 'DocumentRequestEdge'
      node: {
        __typename?: 'DocumentRequest'
        id: string
        documentType: DocumentType
        status: DocumentStatus
        parentRequest: {
          __typename?: 'DocumentRequest'
          rejectedReason: RejectedReason
          id: string
          status: DocumentStatus
        }
      }
    }>
  }
}

export type IdentityFileUploadMutationVariables = Exact<{
  file: Scalars['Upload']
  documentRequestId: Scalars['ID']
}>

export type IdentityFileUploadMutation = {
  __typename?: 'Mutation'
  uploadDocuments: Array<
    | {
        __typename?: 'File'
        encoding: string
        filename: string
        mimetype: string
        url: any
      }
    | { __typename?: 'FileSizeError' }
    | { __typename?: 'UploadFailedError' }
  >
}

export type ConfigureSmartDepositDirectDepositSettingMutationVariables = Exact<{
  input: ConfigureSplitDepositDirectDepositSettingInput
}>

export type ConfigureSmartDepositDirectDepositSettingMutation = {
  __typename?: 'Mutation'
  configureSplitDepositDirectDepositSetting: {
    __typename?: 'ConfigureSplitDepositDirectDepositSettingPayload'
    setting: { __typename?: 'SplitDepositDirectDepositSetting'; id: string }
  }
}

export type ConfigureSplitDepositDirectDepositIntentSettingMutationVariables =
  Exact<{
    input: ConfigureSplitDepositDirectDepositIntentSettingInput
  }>

export type ConfigureSplitDepositDirectDepositIntentSettingMutation = {
  __typename?: 'Mutation'
  configureSplitDepositDirectDepositIntentSetting: {
    __typename?: 'ConfigureSplitDepositDirectDepositIntentPayload'
    intent: {
      __typename?: 'SplitDepositDirectDepositIntentSetting'
      id: string
    }
  }
}

export type ExecuteSplitDepositMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type ExecuteSplitDepositMutation = {
  __typename?: 'Mutation'
  splitDeposit: {
    __typename?: 'SplitDepositMutation'
    execute: { __typename?: 'SplitDeposit'; id: string }
  }
}

export type SmartDepositSettingsByIdQueryVariables = Exact<{
  settingId: Scalars['ID']
  depositsLimit?: InputMaybe<Scalars['Int']>
}>

export type SmartDepositSettingsByIdQuery = {
  __typename?: 'Query'
  splitDepositSettings:
    | {
        __typename?: 'SplitDepositDirectDepositIntentSetting'
        id: string
        name: string
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          id: string
          isUsingRecommendedAllocations: boolean
          transactionAmount: string
          willDistributeAutomaticallyAt: string
          isActive: boolean
          isCancelable: boolean
          allocations: Array<
            | {
                __typename?: 'SplitDepositDirectDepositAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                nickname: string
              }
            | {
                __typename?: 'SplitDepositRecurrenceAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                nickname: string
              }
          >
        }>
      }
    | {
        __typename?: 'SplitDepositDirectDepositSetting'
        updatedAt: string
        id: string
        name: string
        totalAmounts: {
          __typename?: 'TotalAmounts'
          totalContributedAmount: {
            __typename?: 'CurrencyAmount'
            value: number
          }
          totalDepositedAmount: { __typename?: 'CurrencyAmount'; value: number }
        }
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          id: string
          isUsingRecommendedAllocations: boolean
          transactionAmount: string
          willDistributeAutomaticallyAt: string
          isActive: boolean
          isCancelable: boolean
          allocations: Array<
            | {
                __typename?: 'SplitDepositDirectDepositAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                nickname: string
              }
            | {
                __typename?: 'SplitDepositRecurrenceAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                nickname: string
              }
          >
        }>
      }
    | {
        __typename?: 'SplitDepositRecurrenceSetting'
        id: string
        name: string
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          id: string
          isUsingRecommendedAllocations: boolean
          transactionAmount: string
          willDistributeAutomaticallyAt: string
          isActive: boolean
          isCancelable: boolean
          allocations: Array<
            | {
                __typename?: 'SplitDepositDirectDepositAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                nickname: string
              }
            | {
                __typename?: 'SplitDepositRecurrenceAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                nickname: string
              }
          >
        }>
      }
}

export type SmartDepositSettingsQueryVariables = Exact<{
  depositsLimit?: InputMaybe<Scalars['Int']>
  settingTypes: Array<SplitDepositSettingType> | SplitDepositSettingType
  metaDataInput:
    | Array<SplitDepositTargetAccountType>
    | SplitDepositTargetAccountType
  showHiddenEmployerSettings?: InputMaybe<Scalars['Boolean']>
}>

export type SmartDepositSettingsQuery = {
  __typename?: 'Query'
  splitDepositSettingsByUserId: Array<
    | {
        __typename: 'SplitDepositDirectDepositIntentSetting'
        id: string
        isActive: boolean
        isHidden: boolean
        isUsingRecommendedAllocations: boolean
        name: string
        allocations: Array<{
          __typename?: 'SplitDepositDirectDepositAllocation'
          allocationPercent: string
          targetAccountId: string
          targetAccountType: SplitDepositTargetAccountType
          nickname: string
          normalizedAmount: {
            __typename?: 'FormattedMonetaryAmount'
            value: string
          }
        }>
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          expectedNextDepositAmount: string
          expectedNextDepositAt: string
          id: string
          isActive: boolean
          isCancelable: boolean
          isUsingRecommendedAllocations: boolean
          transactionAmount: string
          willDistributeAutomaticallyAt: string
          allocations: Array<
            | {
                __typename?: 'SplitDepositDirectDepositAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                nickname: string
                normalizedAmount: {
                  __typename?: 'FormattedMonetaryAmount'
                  value: string
                }
              }
            | { __typename?: 'SplitDepositRecurrenceAllocation' }
          >
        }>
        estimatedPaycheckAmount: {
          __typename?: 'CurrencyAmount'
          value: number
        }
      }
    | {
        __typename: 'SplitDepositDirectDepositSetting'
        id: string
        isActive: boolean
        isHidden: boolean
        isUsingRecommendedAllocations: boolean
        awaitingConfiguration: boolean
        name: string
        allocations: Array<{
          __typename?: 'SplitDepositDirectDepositAllocation'
          allocationPercent: string
          targetAccountId: string
          targetAccountType: SplitDepositTargetAccountType
          nickname: string
          normalizedAmount: {
            __typename?: 'FormattedMonetaryAmount'
            value: string
          }
        }>
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          expectedNextDepositAmount: string
          expectedNextDepositAt: string
          id: string
          isActive: boolean
          isCancelable: boolean
          isUsingRecommendedAllocations: boolean
          transactionAmount: string
          willDistributeAutomaticallyAt: string
          allocations: Array<
            | {
                __typename?: 'SplitDepositDirectDepositAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                nickname: string
                normalizedAmount: {
                  __typename?: 'FormattedMonetaryAmount'
                  value: string
                }
              }
            | { __typename?: 'SplitDepositRecurrenceAllocation' }
          >
        }>
      }
    | {
        __typename: 'SplitDepositRecurrenceSetting'
        id: string
        isActive: boolean
        isHidden: boolean
        allocations: Array<{ __typename?: 'SplitDepositRecurrenceAllocation' }>
        deposits: Array<{
          __typename?: 'SplitDeposit'
          createdAt: string
          distributedAt: string
          expectedNextDepositAmount: string
          expectedNextDepositAt: string
          id: string
          isActive: boolean
          isCancelable: boolean
          isUsingRecommendedAllocations: boolean
          transactionAmount: string
          willDistributeAutomaticallyAt: string
          allocations: Array<
            | {
                __typename?: 'SplitDepositDirectDepositAllocation'
                allocationPercent: string
                targetAccountId: string
                targetAccountType: SplitDepositTargetAccountType
                nickname: string
                normalizedAmount: {
                  __typename?: 'FormattedMonetaryAmount'
                  value: string
                }
              }
            | { __typename?: 'SplitDepositRecurrenceAllocation' }
          >
        }>
      }
  >
  smartDepositMetadata: {
    __typename?: 'SmartDepositMetadataResult'
    targetAccounts: Array<{
      __typename?: 'SplitDepositTargetAccount'
      targetAccountId: string
      targetAccountType: SplitDepositTargetAccountType
    }>
    recommendedAllocations: Array<
      | {
          __typename?: 'SplitDepositDirectDepositAllocation'
          allocationPercent: string
          targetAccountType: SplitDepositTargetAccountType
          targetAccountId: string
          nickname: string
        }
      | {
          __typename?: 'SplitDepositRecurrenceAllocation'
          allocationPercent: string
          targetAccountType: SplitDepositTargetAccountType
          targetAccountId: string
          nickname: string
        }
    >
  }
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    routingNumber: string
    number: string
    type: BankAccountType
  }>
}

export type SpendSignupSubscriptionQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type SpendSignupSubscriptionQueryQuery = {
  __typename?: 'Query'
  tierSubscriptionForUser:
    | {
        __typename: 'TierSubscription'
        id: string
        tier: {
          __typename?: 'Tier'
          id: string
          key: TierKey
          includedProducts: Array<{
            __typename?: 'TierProduct'
            key: ProductKey
          }>
          excludedProducts: Array<{
            __typename?: 'TierProduct'
            key: ProductKey
          }>
        }
        tierPrice: {
          __typename?: 'TierPrice'
          id: string
          amount: { __typename?: 'CurrencyAmount'; value: number }
        }
      }
    | { __typename: 'TierSubscriptionNotFound' }
    | { __typename: 'TierSubscriptionUnsubscribed' }
  tierOptionByProductKey: {
    __typename?: 'TierOption'
    tier: { __typename?: 'Tier'; id: string; key: TierKey }
    preferredTierPrice: {
      __typename?: 'TierPrice'
      id: string
      amount: {
        __typename?: 'CurrencyAmount'
        value: number
        currency: Currency
      }
    }
  }
  spendAccount: {
    __typename?: 'SpendAccount'
    isDirectDepositIncentiveEligible: boolean
  }
}

export type SpendTransferableFromQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type SpendTransferableFromQueryQuery = {
  __typename?: 'Query'
  allTransferableFrom: Array<{
    __typename?: 'TransferableFrom'
    from: {
      __typename?: 'TransferableAccount'
      accountNumberMasked: string
      externalSource: ExternalSource
      id: string
      name: string
      type: TransferableAccountTypeEnum
      balance: { __typename?: 'CurrencyAmount'; value: number }
    }
  }>
}

export type SpendFundingSourceAccountsQueryVariables = Exact<{
  [key: string]: never
}>

export type SpendFundingSourceAccountsQuery = {
  __typename?: 'Query'
  fundingSourceAccounts: Array<{
    __typename?: 'FundingSourceAccount'
    accountName: string
    institutionName: string
    last4: string
    id: number
    role: FundingSourceRoleEnum
    fundType: FundingSourceType
    uuid: string
    verified: boolean
  }>
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    id: string
    number: string
    accountName: string
    type: BankAccountType
    isLocked: boolean
    lockReason: BankAccountLockReason
    status: BankAccountStatus
    availableBalance: { __typename?: 'CurrencyAmount'; value: number }
  }>
}

export type InitialStateQueryQueryVariables = Exact<{ [key: string]: never }>

export type InitialStateQueryQuery = {
  __typename?: 'Query'
  fundingSourceInfo: {
    __typename?: 'FundingSourceInfo'
    accountNumberLastFour: string
    name: string
    verified: boolean
  }
  settings: { __typename?: 'Settings'; depositsSuspended: boolean }
  recurringTransfers: Array<{
    __typename?: 'RecurringTransfer'
    id: string
    active: boolean
  }>
}

export type InitiateTransferMutationVariables = Exact<{
  amount: Scalars['Float']
  fromAccountId: Scalars['ID']
  toAccountId: Scalars['ID']
  nonce?: InputMaybe<Scalars['ID']>
}>

export type InitiateTransferMutation = {
  __typename?: 'Mutation'
  initiateTransfer: {
    __typename?: 'InitiateTransferPayload'
    transfer: { __typename?: 'Transfer'; createdAt: any }
  }
}

export type TransferableToQueryQueryVariables = Exact<{
  from: Scalars['ID']
}>

export type TransferableToQueryQuery = {
  __typename?: 'Query'
  allTransferableTo: Array<{
    __typename?: 'TransferableTo'
    to: {
      __typename?: 'TransferableAccount'
      externalSource: ExternalSource
      id: string
      name: string
      type: TransferableAccountTypeEnum
      balance: { __typename?: 'CurrencyAmount'; value: number }
    }
  }>
}

export type UpdateOccupationMutationMutationVariables = Exact<{
  occupation?: InputMaybe<Scalars['String']>
}>

export type UpdateOccupationMutationMutation = {
  __typename?: 'Mutation'
  updateEmployment: { __typename?: 'User'; uuid: string }
}

export type SpendSignupSubscribeUserToTierMutationMutationVariables = Exact<{
  tierPriceId: Scalars['ID']
}>

export type SpendSignupSubscribeUserToTierMutationMutation = {
  __typename?: 'Mutation'
  subscribeUserToTier:
    | { __typename: 'InvalidTierPriceId' }
    | { __typename: 'TierDowngradeActionRequired' }
    | { __typename: 'TierSubscription'; id: string }
}

export type SubscriptionMigrationQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type SubscriptionMigrationQuery = {
  __typename?: 'Query'
  subscriptionMigration: {
    __typename?: 'SubscriptionMigration'
    id: string
    effectiveAt: any
    toTier: { __typename?: 'Tier'; id: string; key: TierKey }
    fromTier: { __typename?: 'Tier'; id: string; key: TierKey }
  }
  tierSubscriptionByUserId: {
    __typename?: 'TierSubscription'
    id: string
    tierPrice: {
      __typename?: 'TierPrice'
      billingFrequency: BillingFrequency
      amount: { __typename?: 'CurrencyAmount'; value: number }
    }
    tier: { __typename?: 'Tier'; key: TierKey; id: string; name: string }
  }
  subscriptionMigrationWaiversByUserId: Array<{
    __typename?: 'SubscriptionMigrationWaiver'
    id: string
    migration: { __typename?: 'SubscriptionMigration'; id: string }
  }>
}

export type RequestSubscriptionMigrationWaiverMutationVariables = Exact<{
  input: RequestSubscriptionMigrationWaiverInput
}>

export type RequestSubscriptionMigrationWaiverMutation = {
  __typename?: 'Mutation'
  requestSubscriptionMigrationWaiver:
    | { __typename?: 'InvalidTierForMigrationError' }
    | { __typename?: 'SubscriptionMigrationInvalidError' }
    | { __typename?: 'SubscriptionMigrationWaiver'; createdAt: any }
}

export type CurrentTierQueryVariables = Exact<{ [key: string]: never }>

export type CurrentTierQuery = {
  __typename?: 'Query'
  tierSubscriptionByUserId: {
    __typename?: 'TierSubscription'
    id: string
    tierPrice: {
      __typename?: 'TierPrice'
      id: string
      billingFrequency: BillingFrequency
      amount: { __typename?: 'CurrencyAmount'; value: number }
    }
  }
}

export type TaxCenterAccountsAndBankStatementsQueryVariables = Exact<{
  [key: string]: never
}>

export type TaxCenterAccountsAndBankStatementsQuery = {
  __typename?: 'Query'
  investmentAccountsByUserId: Array<{
    __typename: 'InvestmentAccount'
    id: string
    createdAt: any
    closedAt: any
    type: string
    product: InvestmentProduct
    investmentAccountType: InvestmentAccountType
    beneficiary: { __typename: 'Beneficiary'; firstName: string; id: string }
  }>
  allBankStatements: Array<{
    __typename: 'BankStatement'
    year: string
    type: BankStatementType
    url: string
  }>
}

export type GetPartnerDocumentByUserIdQueryVariables = Exact<{
  input: PartnerDocumentInput
}>

export type GetPartnerDocumentByUserIdQuery = {
  __typename?: 'Query'
  getPartnerDocumentByUserId: {
    __typename?: 'PartnerDocumentUrlResponse'
    documents: Array<{
      __typename?: 'PartnerDocument'
      documentUrl: string
      subType: string
    }>
  }
}

export type TaxCenterTaxStatementsByTaxYearQueryVariables = Exact<{
  taxYear: Scalars['Int']
  input: PageInput
}>

export type TaxCenterTaxStatementsByTaxYearQuery = {
  __typename?: 'Query'
  taxStatementsByTaxYear: {
    __typename?: 'StatementPagination'
    edges: Array<{
      __typename?: 'StatementEdge'
      node: {
        __typename?: 'Statement'
        createdAt: any
        id: string
        investmentAccountId: string
        investmentAccountType: InvestmentAccountType
        statementLink: string
        statementType: StatementType
        taxFormType: TaxFormType
        updatedAt: any
        uploaded: boolean
        year: number
      }
    }>
  }
}

export type RootUserQueryQueryVariables = Exact<{ [key: string]: never }>

export type RootUserQueryQuery = {
  __typename?: 'Query'
  user: { __typename?: 'User'; uuid: string }
}

export type CustomerAccountClosureQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type CustomerAccountClosureQueryQuery = {
  __typename?: 'Query'
  customerAccountClosureRequest: {
    __typename?: 'CustomerAccountClosure'
    closedAt: any
    closureState: CustomerAccountClosureState
  }
}

export type TransitionActionQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type TransitionActionQueryQuery = {
  __typename?: 'Query'
  tierSubscriptionByUserId: {
    __typename?: 'TierSubscription'
    transition: {
      __typename?: 'TierSubscriptionTransition'
      transitionAction: SubscriptionTransitionAction
    }
  }
}

export type UtilsInvestmentsTotalsQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type UtilsInvestmentsTotalsQueryQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    firstName: string
    verified: boolean
    closedAt: any
    fundingSource: { __typename?: 'FundingSource'; name: string }
  }
  allBankAccounts: Array<{
    __typename?: 'BankAccount'
    createdAt: any
    id: string
    availableBalance: {
      __typename?: 'CurrencyAmount'
      currency: Currency
      value: number
    }
  }>
  allInvestmentAccounts: Array<{
    __typename?: 'InvestmentAccount'
    type: string
    currentBalance: {
      __typename?: 'MonetaryAmount'
      currency: Currency
      value: number
    }
  }>
  acceptanceDocuments: Array<{
    __typename?: 'AcceptanceDocument'
    id: string
    type: string
    url: any
  }>
}

export type GraphQlTestUserQueryQueryVariables = Exact<{ [key: string]: never }>

export type GraphQlTestUserQueryQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    uuid: string
    firstName: string
    lastName: string
  }
}

export type ReactTestingUserQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type ReactTestingUserQueryQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    uuid: string
    firstName: string
    lastName: string
  }
}

export type DepositsSuspendedQueryVariables = Exact<{ [key: string]: never }>

export type DepositsSuspendedQuery = {
  __typename?: 'Query'
  settings: { __typename?: 'Settings'; depositsSuspended: boolean }
}

export type AccountsQueryVariables = Exact<{ [key: string]: never }>

export type AccountsQuery = {
  __typename?: 'Query'
  accounts: Array<{
    __typename?: 'Account'
    accountType: AccountType
    status: AccountStatus
    id: string
  }>
}

export type UserDataQueryVariables = Exact<{ [key: string]: never }>

export type UserDataQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    uuid: string
    email: string
    firstName: string
    lastName: string
  }
}

export const ChatChoiceWidgetFragmentDoc = /*#__PURE__*/ gql`
  fragment ChatChoiceWidget on ChatChoiceWidget {
    title
    choices {
      id
      title
      description
      metadata {
        actionType
        actionData {
          apiScope
        }
      }
    }
  }
`
export const CitationWidgetFragmentDoc = /*#__PURE__*/ gql`
  fragment CitationWidget on CitationWidget {
    citations {
      ... on SupportCitation {
        id
        title
      }
    }
  }
`
export const CustomerSupportChatWidgetFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerSupportChatWidget on CustomerSupportChatWidget {
    sessionId
    chatRedirect {
      title
      ctaExpiresAt
      conversationContext
      conversationCategory
    }
    emailRedirect {
      title
    }
    phoneRedirect {
      title
    }
  }
`
export const DeeplinkWidgetFragmentDoc = /*#__PURE__*/ gql`
  fragment DeeplinkWidget on DeeplinkWidget {
    deeplinks {
      title
      url
    }
  }
`
export const SmartDepositWidgetAllocationFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment SmartDepositWidgetAllocationFragment on SplitDepositDirectDepositAllocation {
    allocationPercent
    targetAccountId
    targetAccountType
    normalizedAmount {
      value
    }
  }
`
export const SmarDepositSplitDepositSettingFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment SmarDepositSplitDepositSettingFragment on SplitDepositSettings {
    allocations {
      ...SmartDepositWidgetAllocationFragment
    }
    id
    isActive
    isHidden
    name
  }
  ${SmartDepositWidgetAllocationFragmentFragmentDoc}
`
export const SmartDepositSplitDepositIntentSettingFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment SmartDepositSplitDepositIntentSettingFragment on SplitDepositDirectDepositIntentSetting {
    ...SmarDepositSplitDepositSettingFragment
    isUsingRecommendedAllocations
    estimatedPaycheckAmount {
      value
    }
    name
    isActive
    isHidden
  }
  ${SmarDepositSplitDepositSettingFragmentFragmentDoc}
`
export const SmartDepositSplitDepositDirectDepositSettingFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment SmartDepositSplitDepositDirectDepositSettingFragment on SplitDepositDirectDepositSetting {
    ...SmarDepositSplitDepositSettingFragment
    isUsingRecommendedAllocations
    awaitingConfiguration
    name
    isActive
    isHidden
  }
  ${SmarDepositSplitDepositSettingFragmentFragmentDoc}
`
export const SmartDepositWidgetSplitDepositFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment SmartDepositWidgetSplitDepositFragment on SplitDeposit {
    createdAt
    distributedAt
    expectedNextDepositAmount
    expectedNextDepositAt
    id
    isActive
    isCancelable
    isCanceled
    isUsingRecommendedAllocations
    savingsRatePercent
    settingsId
    splitDistribution {
      investment
      retirement
      savings
    }
    updatedAt
    userId
    transactionAmount
    willDistributeAutomaticallyAt
    allocations {
      ...SmartDepositWidgetAllocationFragment
      allocationPercent
      targetAccountId
      targetAccountType
    }
  }
  ${SmartDepositWidgetAllocationFragmentFragmentDoc}
`
export const BankAccountFragmentDoc = /*#__PURE__*/ gql`
  fragment BankAccount on BankAccount {
    availableBalance {
      currency
      value
    }
    createdAt
    goals {
      currentGoal {
        type
      }
    }
    id
    isLocked
    pendingBalance {
      currency
      value
    }
    status
    type
  }
`
export const BankCardOrderFragmentDoc = /*#__PURE__*/ gql`
  fragment BankCardOrder on BankCardOrder {
    cardOrderStatus
    kycStatus
    fundingInitiated
    requestVersion
    bankCardTier
  }
`
export const EarlyBeneficiariesFragmentDoc = /*#__PURE__*/ gql`
  fragment earlyBeneficiaries on Beneficiary {
    avatarUrl
    createdAt
    firstName
    id
    lastName
    updatedAt
    investmentAccount {
      beneficiaryId
      id
      name
      type
      currentBalance {
        currency
        value
      }
      performance(days: -1) {
        marketChangePercentWithoutFees
      }
      transferability {
        transferAge
        transferDate
        transferReached
      }
    }
  }
`
export const InvestProductAccountPropsFragmentDoc = /*#__PURE__*/ gql`
  fragment InvestProductAccountProps on InvestmentAccount {
    id
    name
    createdAt
    closedAt
    type
    beneficiaryId
    performance(days: -1) {
      marketChangePercent
    }
    currentBalance {
      value
    }
  }
`
export const ProductKeyFragmentDoc = /*#__PURE__*/ gql`
  fragment productKey on Product {
    key
    id
  }
`
export const SpendAccountFragmentDoc = /*#__PURE__*/ gql`
  fragment SpendAccount on SpendAccount {
    status
    isEligible
    isReopenable
    isDirectDepositIncentiveEligible
  }
`
export const EarlyInvestmentAccountRecapFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment EarlyInvestmentAccountRecapFields on InvestmentAccount {
    id
    name
    type
    investmentAccountType
    quarterlyRecapsEnabled
    quarterlyRecap {
      id
      public
      publicUrl
    }
  }
`
export const EarlyBeneficiaryRecapFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment EarlyBeneficiaryRecapFields on Beneficiary {
    createdAt
    custodianId
    firstName
    id
    lastName
    updatedAt
    investmentAccount {
      ...EarlyInvestmentAccountRecapFields
    }
    custodianNickname
  }
  ${EarlyInvestmentAccountRecapFieldsFragmentDoc}
`
export const BankCardOrderFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment bankCardOrderFragment on BankCardOrder {
    fundingInitiated
    requestVersion
    kycStatus
    bankCardTier
  }
`
export const SpendAccountFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment spendAccountFragment on SpendAccount {
    status
    isReopenable
  }
`
export const EarlyInvestmentAccountFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment EarlyInvestmentAccountFields on InvestmentAccount {
    id
    name
    type
    investmentAccountType
    status
    currentBalance {
      currency
      value
    }
    pendingBalance {
      currency
      value
    }
    currentBalance {
      currency
      value
    }
    transferability {
      transferAge
      transferDate
      transferStateCode
      transferReached
    }
    recurringInvestmentSettings {
      amount
      frequency
      day
      createdAt
      updatedAt
    }
    portfolio {
      id
      name
      description
      accountAllocation {
        allocationPercent
      }
      portfolioSecurityAllocations {
        id
        symbol
        allocationPercent
        security {
          displayName
        }
        investmentCategories {
          bond
          crypto
          equity
        }
      }
      riskLevel
      theme
    }
    portfolios {
      id
      __typename
      name
      description
      currentAllocationPercentage
      currentBalance {
        value
      }
      accountAllocation {
        allocationPercent
      }
      yearToDateReturn {
        percent
        marketValue {
          value
        }
      }
      portfolioSecurities {
        __typename
        name
        currentAllocationPercentage
        shares
        symbol
        marketValue {
          value
        }
        todaysReturn {
          marketValue {
            value
          }
          percent
        }
        totalReturn {
          marketValue {
            value
          }
          percent
        }
      }
      portfolioSecurityAllocations {
        id
        allocationPercent
        symbol
        security {
          displayName
          profile {
            logoUrl
          }
        }
        investmentCategories {
          bond
          crypto
          equity
          realEstate
        }
      }
      ... on SelfDirectedPortfolio {
        status
      }
    }
    quarterlyRecapsEnabled
    quarterlyRecap {
      id
      public
      publicUrl
    }
    yearToDateReturn {
      marketValue {
        currency
        value
      }
      percent
    }
    createdAt
    closedAt
    updatedAt
    returnsAllTime {
      value
    }
    netInvestments {
      value
    }
    totalAccountValue {
      value
    }
  }
`
export const EarlyBeneficiaryFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment EarlyBeneficiaryFields on Beneficiary {
    avatarUrl
    createdAt
    custodianId
    age
    eligibleForContributionTooltip
    firstName
    id
    lastName
    ssnPresent
    updatedAt
    investmentAccount {
      ...EarlyInvestmentAccountFields
    }
    custodianNickname
  }
  ${EarlyInvestmentAccountFieldsFragmentDoc}
`
export const TierForEarlyFragmentDoc = /*#__PURE__*/ gql`
  fragment TierForEarly on Tier {
    id
    name
    key
    products {
      active
      key
      name
    }
  }
`
export const CustomerAccountFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerAccountFragment on CustomerAccount {
    id
    referenceId
    name
    mask
    status
    type
    customerNotice
    institution {
      logoUrl
      name
    }
    beneficiary {
      firstName
      investmentAccount {
        transferability {
          transferReached
        }
      }
    }
    balance {
      currency
      value
    }
  }
`
export const SmartDepositAllocationFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment SmartDepositAllocationFragment on SplitDepositDirectDepositAllocation {
    allocationPercent
    targetAccountId
    targetAccountType
    nickname
    normalizedAmount {
      value
    }
  }
`
export const SplitDepositSettingFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment SplitDepositSettingFragment on SplitDepositSettings {
    allocations {
      ...SmartDepositAllocationFragment
    }
    id
    isActive
    isHidden
    name
  }
  ${SmartDepositAllocationFragmentFragmentDoc}
`
export const SplitDepositIntentSettingFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment SplitDepositIntentSettingFragment on SplitDepositDirectDepositIntentSetting {
    ...SplitDepositSettingFragment
    isUsingRecommendedAllocations
    estimatedPaycheckAmount {
      value
    }
    name
    isActive
    isHidden
  }
  ${SplitDepositSettingFragmentFragmentDoc}
`
export const SplitDepositDirectDepositSettingFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment SplitDepositDirectDepositSettingFragment on SplitDepositDirectDepositSetting {
    ...SplitDepositSettingFragment
    isUsingRecommendedAllocations
    awaitingConfiguration
    name
    isActive
    isHidden
  }
  ${SplitDepositSettingFragmentFragmentDoc}
`
export const SplitDepositFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment SplitDepositFragment on SplitDeposit {
    createdAt
    distributedAt
    expectedNextDepositAmount
    expectedNextDepositAt
    id
    isActive
    isCancelable
    isUsingRecommendedAllocations
    transactionAmount
    willDistributeAutomaticallyAt
    allocations {
      ...SmartDepositAllocationFragment
    }
  }
  ${SmartDepositAllocationFragmentFragmentDoc}
`
export const SplitDepositSettingsPartialFragmentDoc = /*#__PURE__*/ gql`
  fragment SplitDepositSettingsPartial on SplitDepositSettings {
    allocations {
      ...SmartDepositAllocationFragment
    }
    id
    isActive
    isHidden
    ... on SplitDepositDirectDepositIntentSetting {
      ...SplitDepositIntentSettingFragment
    }
    ... on SplitDepositDirectDepositSetting {
      ...SplitDepositDirectDepositSettingFragment
    }
    deposits(orderBy: DESC, limit: 1) {
      ...SplitDepositFragment
    }
    __typename
  }
  ${SmartDepositAllocationFragmentFragmentDoc}
  ${SplitDepositIntentSettingFragmentFragmentDoc}
  ${SplitDepositDirectDepositSettingFragmentFragmentDoc}
  ${SplitDepositFragmentFragmentDoc}
`
export const InvestmentAccountFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment InvestmentAccountFields on InvestmentAccount {
    id
    netInvestments {
      value
    }
  }
`
export const BeneficiaryFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment BeneficiaryFields on Beneficiary {
    firstName
    id
    investmentAccount {
      ...InvestmentAccountFields
    }
  }
  ${InvestmentAccountFieldsFragmentDoc}
`
export const RecurringInvestmentSettingsDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecurringInvestmentSettingsDetails on RecurringInvestmentSettings {
    amount
    day
    frequency
  }
`
export const RoundUpProfileDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment RoundUpProfileDetails on RoundUpProfile {
    __typename
    roundUpsEnabled
    multiplier
    roundUpAccounts {
      enabled
    }
  }
`
export const MarketValueFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment MarketValueFields on MarketReturn {
    marketValue {
      currency
      value
    }
  }
`
export const PortfolioSecuritiesFragmentDoc = /*#__PURE__*/ gql`
  fragment PortfolioSecurities on PortfolioSecurity {
    id
    name
    shares
    symbol
    currentAllocationPercentage
    marketValue {
      currency
      value
    }
    todaysReturn {
      ...MarketValueFields
      percent
    }
    totalReturn {
      ...MarketValueFields
      percent
    }
  }
  ${MarketValueFieldsFragmentDoc}
`
export const SecurityBySymbolInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment SecurityBySymbolInfo on Security {
    type
    symbol
    longName
    shortName
    marketCap
    volume
    lastUpdatedAt
    displayName
    currentPrice {
      value
    }
    profile {
      description
      tradingSectors
      logoUrl
    }
    lastClosePrice {
      value
    }
    openPrice {
      value
    }
    week52High {
      value
    }
    week52Low {
      value
    }
    ... on Fund {
      displayName
      numberOfHoldings
      topHoldings {
        securityName
        symbol
        sharePercentage
        marketValue {
          value
          currency
        }
      }
    }
  }
`
export const SecurityPerformanceBySymbolFragmentDoc = /*#__PURE__*/ gql`
  fragment SecurityPerformanceBySymbol on SecurityPerformance {
    gain {
      percent
      marketValue {
        value
      }
    }
    prices {
      marketValue {
        value
      }
      timestamp
    }
  }
`
export const CoreRecurringPastEdgeFragmentDoc = /*#__PURE__*/ gql`
  fragment CoreRecurringPastEdge on PastItemEdge {
    node {
      id
      title
      status
    }
  }
`
export const RoundUpFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RoundUpFields on RoundUp {
    __typename
    transactionId
    state
    multiplier
    manual
    amount
    change
    name
    total
    transactionDate
    instant
  }
`
export const RoundUpProfileFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RoundUpProfileFields on RoundUpProfile {
    __typename
    multiplier
    roundUpCount(state: [pending, waiting, roundedUp, invested])
    totalWaiting: roundUpTotal(state: [waiting])
    roundUpsInvested: roundUpCount(state: [roundedUp, invested])
    totalInvested: roundUpTotal(state: [roundedUp, invested])
    showRoundUpsProgress
  }
`
export const FundingSourceAccountsLaterOneTimeFragmentDoc = /*#__PURE__*/ gql`
  fragment fundingSourceAccountsLaterOneTime on FundingSourceAccount {
    balance
    last4
    institutionName
    status
    verified
    role
    id
    fundType
    accountName
  }
`
export const AllBankAccountsLaterOneTimeFragmentDoc = /*#__PURE__*/ gql`
  fragment allBankAccountsLaterOneTime on BankAccount {
    availableBalance {
      value
    }
  }
`
export const LaterRecurringPastEdgeFragmentDoc = /*#__PURE__*/ gql`
  fragment LaterRecurringPastEdge on PastItemEdge {
    node {
      id
      title
      status
    }
  }
`
export const RecurringSettingsLaterDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment recurringSettingsLaterDetails on RecurringInvestmentSettings {
    amount
    frequency
    day
  }
`
export const FundingSourceAccountsFragmentDoc = /*#__PURE__*/ gql`
  fragment FundingSourceAccounts on FundingSourceAccount {
    balance
    last4
    institutionName
    status
    verified
    role
    id
    fundType
    accountName
  }
`
export const AccountValueFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment AccountValueFragment on AccountValue {
    amount
    timestamp
  }
`
export const MonetaryAmountFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment MonetaryAmountFragment on MonetaryAmount {
    currency
    value
  }
`
export const CombinedPerformanceAccountBreakdownFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment CombinedPerformanceAccountBreakdownFragment on CombinedPerformance {
    netInvestments {
      ...MonetaryAmountFragment
    }
    stockValue {
      ...MonetaryAmountFragment
    }
    bondValue {
      ...MonetaryAmountFragment
    }
    cryptoValue {
      ...MonetaryAmountFragment
    }
    marketChange {
      ...MonetaryAmountFragment
    }
    currentBalance {
      ...MonetaryAmountFragment
    }
  }
  ${MonetaryAmountFragmentFragmentDoc}
`
export const StringKeyAssetFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment StringKeyAssetFragment on StringKeyAsset {
    key
    args
  }
`
export const MoneyHubSplitDepositSettingFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment MoneyHubSplitDepositSettingFragment on SplitDepositSettings {
    allocations {
      allocationPercent
      targetAccountId
      targetAccountType
      nickname
      ... on SplitDepositDirectDepositAllocation {
        normalizedDailyAmount
      }
    }
    id
    isActive
    isHidden
    name
  }
`
export const MoneyHubSplitDepositDirectDepositSettingFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment MoneyHubSplitDepositDirectDepositSettingFragment on SplitDepositDirectDepositSetting {
    ...MoneyHubSplitDepositSettingFragment
    isUsingRecommendedAllocations
    awaitingConfiguration
  }
  ${MoneyHubSplitDepositSettingFragmentFragmentDoc}
`
export const MoneyHubSplitDepositIntentSettingFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment MoneyHubSplitDepositIntentSettingFragment on SplitDepositDirectDepositIntentSetting {
    ...MoneyHubSplitDepositSettingFragment
    isUsingRecommendedAllocations
    estimatedPaycheckAmount {
      value
    }
  }
  ${MoneyHubSplitDepositSettingFragmentFragmentDoc}
`
export const MoneyHubSplitDepositFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment MoneyHubSplitDepositFragment on SplitDeposit {
    createdAt
    distributedAt
    expectedNextDepositAmount
    expectedNextDepositAt
    id
    isActive
    isCancelable
    transactionAmount
  }
`
export const DepositMonthlyTotalFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment DepositMonthlyTotalFragment on MonthlyTotal {
    totalAmount {
      value
    }
    yearMonth
  }
`
export const PortfolioSecuritiesDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment PortfolioSecuritiesDetails on PortfolioSecurity {
    __typename
    id
    name
    currentAllocationPercentage
    shares
    symbol
    marketValue {
      value
    }
    todaysReturn {
      marketValue {
        value
      }
      percent
    }
    totalReturn {
      marketValue {
        value
      }
      percent
    }
  }
`
export const PortfolioDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment PortfolioDetails on BasePortfolio {
    __typename
    id
    name
    portfolioSecurities {
      ...PortfolioSecuritiesDetails
    }
    portfolioSecurityAllocations {
      __typename
      allocationPercent
      symbol
      name
      security {
        type
        profile {
          logoUrl
        }
      }
    }
  }
  ${PortfolioSecuritiesDetailsFragmentDoc}
`
export const InvestmentAccountDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment InvestmentAccountDetails on InvestmentAccount {
    __typename
    id
    name
    createdAt
    closedAt
    beneficiaryId
    netInvestments {
      value
    }
    currentBalance {
      value
    }
    totalBonds {
      currency
      value
    }
    totalAccountValue {
      value
    }
    returnsAllTime {
      value
    }
    netInvestments {
      value
    }
    portfolio {
      __typename
      id
      name
      theme
      description
      holdings {
        name
        amount
        percentage
        shares
        symbol
      }
    }
    portfolios {
      ...PortfolioDetails
    }
    totalBonds {
      value
    }
    totalEquities {
      value
    }
  }
  ${PortfolioDetailsFragmentDoc}
`
export const RecapItemsFragmentDoc = /*#__PURE__*/ gql`
  fragment RecapItems on InvestmentAccountRecap {
    id
    beneficiaryAge
    beneficiaryCustodianNickname
    beneficiaryFirstName
    beneficiaryLastName
    endsAt
    startsAt
    contributionsByOthers {
      contributorName
      amount {
        currency
        value
      }
      note
    }
    totalContributions {
      currency
      value
    }
    totalContributionsByOthers {
      currency
      value
    }
    investmentAccount {
      id
      beneficiary {
        custodianNickname
        firstName
      }
      beneficiaryId
      currentBalance {
        currency
        value
      }
      transferability {
        transferAge
      }
      recurringInvestmentSettings {
        amount
        day
        frequency
      }
    }
    performance {
      accountValues {
        amount
        timestamp
      }
      marketChange
      marketChangePercent
      marketChangeWithoutFees
      marketChangePercentWithoutFees
    }
    public
    publicUrl
    latestAccountValue {
      value
      currency
    }
  }
`
export const LinkedAccountFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment LinkedAccountFields on LinkedAccount {
    errorCode
    externalId
    externalSource
    id
    institutionName
    linked
    status
    logoUrl
    transactionsLastSyncedAt
    financialInstitution {
      deleted
      externalId
      id
      logoUrl
      name
      linkProviderType
    }
  }
`
export const LinkedSubaccountFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment LinkedSubaccountFields on LinkedSubaccount {
    accountNumberLastFour
    allowedRoles
    balanceAvailable
    balanceCurrent
    externalSource
    id
    linked
    name
    role
    subaccountType
  }
`
export const SpendAtmFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment SpendAtmFragment on SpendAtm {
    address {
      latitude
      longitude
      addressLine
      cityName
      stateCode
      postalCode
      country
    }
    atmName
  }
`
export const CreateAiChatSupportTicketDocument = /*#__PURE__*/ gql`
  mutation CreateAIChatSupportTicket($input: CreateSupportTicketInput!) {
    createAuthenticatedSupportTicket(input: $input) {
      id
      description
      subject
      url
    }
  }
`
export type CreateAiChatSupportTicketMutationFn =
  ApolloReactCommon.MutationFunction<
    CreateAiChatSupportTicketMutation,
    CreateAiChatSupportTicketMutationVariables
  >

/**
 * __useCreateAiChatSupportTicketMutation__
 *
 * To run a mutation, you first call `useCreateAiChatSupportTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiChatSupportTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiChatSupportTicketMutation, { data, loading, error }] = useCreateAiChatSupportTicketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAiChatSupportTicketMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateAiChatSupportTicketMutation,
    CreateAiChatSupportTicketMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateAiChatSupportTicketMutation,
    CreateAiChatSupportTicketMutationVariables
  >(CreateAiChatSupportTicketDocument, options)
}
export type CreateAiChatSupportTicketMutationHookResult = ReturnType<
  typeof useCreateAiChatSupportTicketMutation
>
export type CreateAiChatSupportTicketMutationResult =
  ApolloReactCommon.MutationResult<CreateAiChatSupportTicketMutation>
export type CreateAiChatSupportTicketMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateAiChatSupportTicketMutation,
    CreateAiChatSupportTicketMutationVariables
  >
export const EndChatSessionDocument = /*#__PURE__*/ gql`
  mutation EndChatSession($sessionId: ID!) {
    endChatSession(sessionId: $sessionId) {
      ... on ChatSession {
        id
        userId
        createdAt
        endedAt
      }
      ... on ChatSessionNotFound {
        id
        message
      }
    }
  }
`
export type EndChatSessionMutationFn = ApolloReactCommon.MutationFunction<
  EndChatSessionMutation,
  EndChatSessionMutationVariables
>

/**
 * __useEndChatSessionMutation__
 *
 * To run a mutation, you first call `useEndChatSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndChatSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endChatSessionMutation, { data, loading, error }] = useEndChatSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useEndChatSessionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EndChatSessionMutation,
    EndChatSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    EndChatSessionMutation,
    EndChatSessionMutationVariables
  >(EndChatSessionDocument, options)
}
export type EndChatSessionMutationHookResult = ReturnType<
  typeof useEndChatSessionMutation
>
export type EndChatSessionMutationResult =
  ApolloReactCommon.MutationResult<EndChatSessionMutation>
export type EndChatSessionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    EndChatSessionMutation,
    EndChatSessionMutationVariables
  >
export const OnChatMessageStreamDocument = /*#__PURE__*/ gql`
  subscription OnChatMessageStream($sessionId: ID!) {
    onChatMessageStream(sessionId: $sessionId) {
      ... on ChatHistoryMessage {
        id
        author
        body
        sessionId
        createdAt
        canRate
        rating
        originatingMessageId
        citations {
          id
          title
          type
        }
        deeplinks {
          title
          url
        }
      }
      ... on ChatHistoryMessageHeader {
        id
        author
        sessionId
        createdAt
        originatingMessageId
      }
      ... on ChatHistoryMessageBody {
        id
        text
        sentAt
      }
      ... on ChatHistoryMessageFooter {
        id
        sentAt
        canRate
        chatWidgets {
          ...CitationWidget
          ...CustomerSupportChatWidget
          ...DeeplinkWidget
          ...ChatChoiceWidget
        }
      }
    }
  }
  ${CitationWidgetFragmentDoc}
  ${CustomerSupportChatWidgetFragmentDoc}
  ${DeeplinkWidgetFragmentDoc}
  ${ChatChoiceWidgetFragmentDoc}
`

/**
 * __useOnChatMessageStreamSubscription__
 *
 * To run a query within a React component, call `useOnChatMessageStreamSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnChatMessageStreamSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnChatMessageStreamSubscription({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useOnChatMessageStreamSubscription(
  baseOptions: ApolloReactHooks.SubscriptionHookOptions<
    OnChatMessageStreamSubscription,
    OnChatMessageStreamSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    OnChatMessageStreamSubscription,
    OnChatMessageStreamSubscriptionVariables
  >(OnChatMessageStreamDocument, options)
}
export type OnChatMessageStreamSubscriptionHookResult = ReturnType<
  typeof useOnChatMessageStreamSubscription
>
export type OnChatMessageStreamSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<OnChatMessageStreamSubscription>
export const RateChatMessageDocument = /*#__PURE__*/ gql`
  mutation RateChatMessage(
    $messageId: ID!
    $rating: Int
    $feedbackInput: MessageFeedbackInput
  ) {
    rateChatMessage(
      messageId: $messageId
      rating: $rating
      feedbackInput: $feedbackInput
    ) {
      ... on ChatHistoryMessage {
        id
        author
        body
        sessionId
        createdAt
        canRate
        rating
        citations {
          title
          type
          id
        }
        deeplinks {
          title
          url
        }
      }
      ... on ChatHistoryMessageNotFound {
        id
        message
      }
      ... on ChatHistoryMessageNotRatable {
        id
        message
      }
      ... on ChatHistoryMessageRatingOutOfBounds {
        id
        message
      }
      ... on ChatHistoryMessageRatingFailed {
        id
        message
      }
    }
  }
`
export type RateChatMessageMutationFn = ApolloReactCommon.MutationFunction<
  RateChatMessageMutation,
  RateChatMessageMutationVariables
>

/**
 * __useRateChatMessageMutation__
 *
 * To run a mutation, you first call `useRateChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateChatMessageMutation, { data, loading, error }] = useRateChatMessageMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      rating: // value for 'rating'
 *      feedbackInput: // value for 'feedbackInput'
 *   },
 * });
 */
export function useRateChatMessageMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RateChatMessageMutation,
    RateChatMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RateChatMessageMutation,
    RateChatMessageMutationVariables
  >(RateChatMessageDocument, options)
}
export type RateChatMessageMutationHookResult = ReturnType<
  typeof useRateChatMessageMutation
>
export type RateChatMessageMutationResult =
  ApolloReactCommon.MutationResult<RateChatMessageMutation>
export type RateChatMessageMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RateChatMessageMutation,
    RateChatMessageMutationVariables
  >
export const SendChatMessageDocument = /*#__PURE__*/ gql`
  mutation SendChatMessage(
    $sessionId: ID!
    $message: String!
    $metadata: ChatMessageMetadataInput
  ) {
    sendChatMessage(
      sessionId: $sessionId
      message: $message
      metadata: $metadata
    ) {
      ... on ChatHistoryMessage {
        id
        author
        body
        sessionId
        createdAt
        canRate
        rating
        citations {
          title
          type
          id
        }
        deeplinks {
          title
          url
        }
      }
      ... on ChatSessionNotFound {
        id
        message
      }
      ... on ChatUnavailableError {
        message
      }
    }
  }
`
export type SendChatMessageMutationFn = ApolloReactCommon.MutationFunction<
  SendChatMessageMutation,
  SendChatMessageMutationVariables
>

/**
 * __useSendChatMessageMutation__
 *
 * To run a mutation, you first call `useSendChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendChatMessageMutation, { data, loading, error }] = useSendChatMessageMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      message: // value for 'message'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useSendChatMessageMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SendChatMessageMutation,
    SendChatMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SendChatMessageMutation,
    SendChatMessageMutationVariables
  >(SendChatMessageDocument, options)
}
export type SendChatMessageMutationHookResult = ReturnType<
  typeof useSendChatMessageMutation
>
export type SendChatMessageMutationResult =
  ApolloReactCommon.MutationResult<SendChatMessageMutation>
export type SendChatMessageMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SendChatMessageMutation,
    SendChatMessageMutationVariables
  >
export const StartChatSessionDocument = /*#__PURE__*/ gql`
  mutation StartChatSession($type: SessionType) {
    startChatSession(
      type: $type
      supportedChatFeatures: [BASIC, SUPPORT, CHOICE_SELECTION]
      originatingContext: SUPPORT
    ) {
      ... on ChatSession {
        id
        userId
        createdAt
        endedAt
        type
      }
      ... on ChatUnavailableError {
        message
      }
    }
  }
`
export type StartChatSessionMutationFn = ApolloReactCommon.MutationFunction<
  StartChatSessionMutation,
  StartChatSessionMutationVariables
>

/**
 * __useStartChatSessionMutation__
 *
 * To run a mutation, you first call `useStartChatSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartChatSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startChatSessionMutation, { data, loading, error }] = useStartChatSessionMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useStartChatSessionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    StartChatSessionMutation,
    StartChatSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    StartChatSessionMutation,
    StartChatSessionMutationVariables
  >(StartChatSessionDocument, options)
}
export type StartChatSessionMutationHookResult = ReturnType<
  typeof useStartChatSessionMutation
>
export type StartChatSessionMutationResult =
  ApolloReactCommon.MutationResult<StartChatSessionMutation>
export type StartChatSessionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    StartChatSessionMutation,
    StartChatSessionMutationVariables
  >
export const AllChatHistoryMessagesDocument = /*#__PURE__*/ gql`
  query AllChatHistoryMessages($pagination: PaginationInput!) {
    allChatHistoryMessages(pagination: $pagination) {
      edges {
        cursor
        node {
          author
          body
          id
          sessionId
          createdAt
          canRate
          rating
          chatWidgets {
            ...CitationWidget
            ...CustomerSupportChatWidget
            ...DeeplinkWidget
            ...ChatChoiceWidget
          }
        }
      }
      pageInfo {
        hasNextPage
        limit
      }
    }
  }
  ${CitationWidgetFragmentDoc}
  ${CustomerSupportChatWidgetFragmentDoc}
  ${DeeplinkWidgetFragmentDoc}
  ${ChatChoiceWidgetFragmentDoc}
`

/**
 * __useAllChatHistoryMessagesQuery__
 *
 * To run a query within a React component, call `useAllChatHistoryMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllChatHistoryMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllChatHistoryMessagesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAllChatHistoryMessagesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    AllChatHistoryMessagesQuery,
    AllChatHistoryMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AllChatHistoryMessagesQuery,
    AllChatHistoryMessagesQueryVariables
  >(AllChatHistoryMessagesDocument, options)
}
export function useAllChatHistoryMessagesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AllChatHistoryMessagesQuery,
    AllChatHistoryMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AllChatHistoryMessagesQuery,
    AllChatHistoryMessagesQueryVariables
  >(AllChatHistoryMessagesDocument, options)
}
export type AllChatHistoryMessagesQueryHookResult = ReturnType<
  typeof useAllChatHistoryMessagesQuery
>
export type AllChatHistoryMessagesLazyQueryHookResult = ReturnType<
  typeof useAllChatHistoryMessagesLazyQuery
>
export type AllChatHistoryMessagesQueryResult = ApolloReactCommon.QueryResult<
  AllChatHistoryMessagesQuery,
  AllChatHistoryMessagesQueryVariables
>
export const RecommendedSearchTermsDocument = /*#__PURE__*/ gql`
  query RecommendedSearchTerms {
    recommendedSearchTerms(category: SUPPORT)
  }
`

/**
 * __useRecommendedSearchTermsQuery__
 *
 * To run a query within a React component, call `useRecommendedSearchTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedSearchTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedSearchTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecommendedSearchTermsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    RecommendedSearchTermsQuery,
    RecommendedSearchTermsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RecommendedSearchTermsQuery,
    RecommendedSearchTermsQueryVariables
  >(RecommendedSearchTermsDocument, options)
}
export function useRecommendedSearchTermsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RecommendedSearchTermsQuery,
    RecommendedSearchTermsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RecommendedSearchTermsQuery,
    RecommendedSearchTermsQueryVariables
  >(RecommendedSearchTermsDocument, options)
}
export type RecommendedSearchTermsQueryHookResult = ReturnType<
  typeof useRecommendedSearchTermsQuery
>
export type RecommendedSearchTermsLazyQueryHookResult = ReturnType<
  typeof useRecommendedSearchTermsLazyQuery
>
export type RecommendedSearchTermsQueryResult = ApolloReactCommon.QueryResult<
  RecommendedSearchTermsQuery,
  RecommendedSearchTermsQueryVariables
>
export const UserQueryDocument = /*#__PURE__*/ gql`
  query UserQuery {
    user {
      firstName
      lastName
      uuid
      email
      phoneNumber
    }
  }
`

/**
 * __useUserQueryQuery__
 *
 * To run a query within a React component, call `useUserQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserQueryQuery,
    UserQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<UserQueryQuery, UserQueryQueryVariables>(
    UserQueryDocument,
    options,
  )
}
export function useUserQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserQueryQuery,
    UserQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<UserQueryQuery, UserQueryQueryVariables>(
    UserQueryDocument,
    options,
  )
}
export type UserQueryQueryHookResult = ReturnType<typeof useUserQueryQuery>
export type UserQueryLazyQueryHookResult = ReturnType<
  typeof useUserQueryLazyQuery
>
export type UserQueryQueryResult = ApolloReactCommon.QueryResult<
  UserQueryQuery,
  UserQueryQueryVariables
>
export const InHouseCampaignDocument = /*#__PURE__*/ gql`
  query InHouseCampaign {
    advocate {
      campaign {
        activeInHouseCampaign
      }
    }
  }
`

/**
 * __useInHouseCampaignQuery__
 *
 * To run a query within a React component, call `useInHouseCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useInHouseCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInHouseCampaignQuery({
 *   variables: {
 *   },
 * });
 */
export function useInHouseCampaignQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    InHouseCampaignQuery,
    InHouseCampaignQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    InHouseCampaignQuery,
    InHouseCampaignQueryVariables
  >(InHouseCampaignDocument, options)
}
export function useInHouseCampaignLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InHouseCampaignQuery,
    InHouseCampaignQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    InHouseCampaignQuery,
    InHouseCampaignQueryVariables
  >(InHouseCampaignDocument, options)
}
export type InHouseCampaignQueryHookResult = ReturnType<
  typeof useInHouseCampaignQuery
>
export type InHouseCampaignLazyQueryHookResult = ReturnType<
  typeof useInHouseCampaignLazyQuery
>
export type InHouseCampaignQueryResult = ApolloReactCommon.QueryResult<
  InHouseCampaignQuery,
  InHouseCampaignQueryVariables
>
export const FoundMoneySummaryDocument = /*#__PURE__*/ gql`
  query FoundMoneySummary {
    foundMoneySummary {
      totalRewardsDollarValue {
        value
      }
    }
  }
`

/**
 * __useFoundMoneySummaryQuery__
 *
 * To run a query within a React component, call `useFoundMoneySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoundMoneySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoundMoneySummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFoundMoneySummaryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FoundMoneySummaryQuery,
    FoundMoneySummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FoundMoneySummaryQuery,
    FoundMoneySummaryQueryVariables
  >(FoundMoneySummaryDocument, options)
}
export function useFoundMoneySummaryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FoundMoneySummaryQuery,
    FoundMoneySummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FoundMoneySummaryQuery,
    FoundMoneySummaryQueryVariables
  >(FoundMoneySummaryDocument, options)
}
export type FoundMoneySummaryQueryHookResult = ReturnType<
  typeof useFoundMoneySummaryQuery
>
export type FoundMoneySummaryLazyQueryHookResult = ReturnType<
  typeof useFoundMoneySummaryLazyQuery
>
export type FoundMoneySummaryQueryResult = ApolloReactCommon.QueryResult<
  FoundMoneySummaryQuery,
  FoundMoneySummaryQueryVariables
>
export const EarnDropsCohortEligibilityDocument = /*#__PURE__*/ gql`
  query EarnDropsCohortEligibility($cohort: String!) {
    cohortEligibility_v2(filter: { cohorts: [$cohort] }) {
      eligible
    }
  }
`

/**
 * __useEarnDropsCohortEligibilityQuery__
 *
 * To run a query within a React component, call `useEarnDropsCohortEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarnDropsCohortEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarnDropsCohortEligibilityQuery({
 *   variables: {
 *      cohort: // value for 'cohort'
 *   },
 * });
 */
export function useEarnDropsCohortEligibilityQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    EarnDropsCohortEligibilityQuery,
    EarnDropsCohortEligibilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EarnDropsCohortEligibilityQuery,
    EarnDropsCohortEligibilityQueryVariables
  >(EarnDropsCohortEligibilityDocument, options)
}
export function useEarnDropsCohortEligibilityLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EarnDropsCohortEligibilityQuery,
    EarnDropsCohortEligibilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EarnDropsCohortEligibilityQuery,
    EarnDropsCohortEligibilityQueryVariables
  >(EarnDropsCohortEligibilityDocument, options)
}
export type EarnDropsCohortEligibilityQueryHookResult = ReturnType<
  typeof useEarnDropsCohortEligibilityQuery
>
export type EarnDropsCohortEligibilityLazyQueryHookResult = ReturnType<
  typeof useEarnDropsCohortEligibilityLazyQuery
>
export type EarnDropsCohortEligibilityQueryResult =
  ApolloReactCommon.QueryResult<
    EarnDropsCohortEligibilityQuery,
    EarnDropsCohortEligibilityQueryVariables
  >
export const PartnerOfferGroupCategoriesDocument = /*#__PURE__*/ gql`
  query PartnerOfferGroupCategories(
    $ids: [ID!]!
    $incentiveTemplate: EarnOfferIncentiveTemplate
  ) {
    partnerOfferGroupCategories(
      ids: $ids
      incentiveTemplate: $incentiveTemplate
    ) {
      id
      title
      body
      offers {
        ... on JobOffer {
          id
          jobName
          companyName
          companyLogo {
            url
          }
          industryName
          salary {
            minValue
            maxValue
            interval
          }
          location {
            city
            state
          }
          tags
          url
        }
        ... on JobSearchOffer {
          id
          backgroundImage {
            url
          }
          title
          subtitle
          logo {
            url
          }
          searchFilters {
            key
            value
          }
        }
        ... on EarnOffer {
          displayName
          featuredCategoryOffer
          featuredCategoryOfferRank
          backgroundColorHex
          backgroundImageUrl
          campaignId
          campaignDescription
          campaignOfferId
          displayTitle
          incentiveSummary
          termsAndConditionsUrl
          displaySubtitle
          promoted
          promotionRank
          webviewEnabled
          ctaDetails {
            type
            ios
            android
            email
            web
            notificationUrl
            chromeExt
            title
            repeatTitle
            notificationTitle
          }
          colorBackgroundLogoImageUrl
          colorImageUrl
          ownerId
          ownerDescription
          incentiveAmount
          incentiveType
        }
      }
    }
  }
`

/**
 * __usePartnerOfferGroupCategoriesQuery__
 *
 * To run a query within a React component, call `usePartnerOfferGroupCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerOfferGroupCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerOfferGroupCategoriesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      incentiveTemplate: // value for 'incentiveTemplate'
 *   },
 * });
 */
export function usePartnerOfferGroupCategoriesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    PartnerOfferGroupCategoriesQuery,
    PartnerOfferGroupCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PartnerOfferGroupCategoriesQuery,
    PartnerOfferGroupCategoriesQueryVariables
  >(PartnerOfferGroupCategoriesDocument, options)
}
export function usePartnerOfferGroupCategoriesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PartnerOfferGroupCategoriesQuery,
    PartnerOfferGroupCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PartnerOfferGroupCategoriesQuery,
    PartnerOfferGroupCategoriesQueryVariables
  >(PartnerOfferGroupCategoriesDocument, options)
}
export type PartnerOfferGroupCategoriesQueryHookResult = ReturnType<
  typeof usePartnerOfferGroupCategoriesQuery
>
export type PartnerOfferGroupCategoriesLazyQueryHookResult = ReturnType<
  typeof usePartnerOfferGroupCategoriesLazyQuery
>
export type PartnerOfferGroupCategoriesQueryResult =
  ApolloReactCommon.QueryResult<
    PartnerOfferGroupCategoriesQuery,
    PartnerOfferGroupCategoriesQueryVariables
  >
export const PersonalizedEarnOffersDocument = /*#__PURE__*/ gql`
  query PersonalizedEarnOffers {
    personalizedEarnOffers {
      __typename
      campaignId
      colorBackgroundLogoImageUrl
      ownerId
      displayName
      incentiveSummary
    }
  }
`

/**
 * __usePersonalizedEarnOffersQuery__
 *
 * To run a query within a React component, call `usePersonalizedEarnOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalizedEarnOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalizedEarnOffersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePersonalizedEarnOffersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PersonalizedEarnOffersQuery,
    PersonalizedEarnOffersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PersonalizedEarnOffersQuery,
    PersonalizedEarnOffersQueryVariables
  >(PersonalizedEarnOffersDocument, options)
}
export function usePersonalizedEarnOffersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PersonalizedEarnOffersQuery,
    PersonalizedEarnOffersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PersonalizedEarnOffersQuery,
    PersonalizedEarnOffersQueryVariables
  >(PersonalizedEarnOffersDocument, options)
}
export type PersonalizedEarnOffersQueryHookResult = ReturnType<
  typeof usePersonalizedEarnOffersQuery
>
export type PersonalizedEarnOffersLazyQueryHookResult = ReturnType<
  typeof usePersonalizedEarnOffersLazyQuery
>
export type PersonalizedEarnOffersQueryResult = ApolloReactCommon.QueryResult<
  PersonalizedEarnOffersQuery,
  PersonalizedEarnOffersQueryVariables
>
export const ActivitySummaryDocument = /*#__PURE__*/ gql`
  query activitySummary($product: ActivitySummaryProduct, $accountId: ID) {
    activitySummary(product: $product, accountId: $accountId) {
      total {
        value
        currency
      }
      numberOfDays
      activitySummaryItems {
        title
        amount {
          value
          currency
        }
      }
    }
  }
`

/**
 * __useActivitySummaryQuery__
 *
 * To run a query within a React component, call `useActivitySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitySummaryQuery({
 *   variables: {
 *      product: // value for 'product'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useActivitySummaryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ActivitySummaryQuery,
    ActivitySummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ActivitySummaryQuery,
    ActivitySummaryQueryVariables
  >(ActivitySummaryDocument, options)
}
export function useActivitySummaryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ActivitySummaryQuery,
    ActivitySummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ActivitySummaryQuery,
    ActivitySummaryQueryVariables
  >(ActivitySummaryDocument, options)
}
export type ActivitySummaryQueryHookResult = ReturnType<
  typeof useActivitySummaryQuery
>
export type ActivitySummaryLazyQueryHookResult = ReturnType<
  typeof useActivitySummaryLazyQuery
>
export type ActivitySummaryQueryResult = ApolloReactCommon.QueryResult<
  ActivitySummaryQuery,
  ActivitySummaryQueryVariables
>
export const LaterInvestmentAccountsByUserIdDocument = /*#__PURE__*/ gql`
  query laterInvestmentAccountsByUserId {
    investmentAccountsByUserId(filter: { product: LATER }) {
      closedAt
      type
      recurringInvestmentSettings {
        amount
        day
        frequency
      }
    }
  }
`

/**
 * __useLaterInvestmentAccountsByUserIdQuery__
 *
 * To run a query within a React component, call `useLaterInvestmentAccountsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaterInvestmentAccountsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaterInvestmentAccountsByUserIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useLaterInvestmentAccountsByUserIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    LaterInvestmentAccountsByUserIdQuery,
    LaterInvestmentAccountsByUserIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LaterInvestmentAccountsByUserIdQuery,
    LaterInvestmentAccountsByUserIdQueryVariables
  >(LaterInvestmentAccountsByUserIdDocument, options)
}
export function useLaterInvestmentAccountsByUserIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LaterInvestmentAccountsByUserIdQuery,
    LaterInvestmentAccountsByUserIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LaterInvestmentAccountsByUserIdQuery,
    LaterInvestmentAccountsByUserIdQueryVariables
  >(LaterInvestmentAccountsByUserIdDocument, options)
}
export type LaterInvestmentAccountsByUserIdQueryHookResult = ReturnType<
  typeof useLaterInvestmentAccountsByUserIdQuery
>
export type LaterInvestmentAccountsByUserIdLazyQueryHookResult = ReturnType<
  typeof useLaterInvestmentAccountsByUserIdLazyQuery
>
export type LaterInvestmentAccountsByUserIdQueryResult =
  ApolloReactCommon.QueryResult<
    LaterInvestmentAccountsByUserIdQuery,
    LaterInvestmentAccountsByUserIdQueryVariables
  >
export const LaterUserContributionAbilityDocument = /*#__PURE__*/ gql`
  query LaterUserContributionAbility {
    laterUserContributionAbility {
      ... on ContributionAbilityByYear {
        contributionAbilities {
          canContribute
          planLimit
          remaining
          taxYear
          yearToDate
          __typename
        }
      }
      __typename
    }
  }
`

/**
 * __useLaterUserContributionAbilityQuery__
 *
 * To run a query within a React component, call `useLaterUserContributionAbilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaterUserContributionAbilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaterUserContributionAbilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useLaterUserContributionAbilityQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    LaterUserContributionAbilityQuery,
    LaterUserContributionAbilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LaterUserContributionAbilityQuery,
    LaterUserContributionAbilityQueryVariables
  >(LaterUserContributionAbilityDocument, options)
}
export function useLaterUserContributionAbilityLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LaterUserContributionAbilityQuery,
    LaterUserContributionAbilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LaterUserContributionAbilityQuery,
    LaterUserContributionAbilityQueryVariables
  >(LaterUserContributionAbilityDocument, options)
}
export type LaterUserContributionAbilityQueryHookResult = ReturnType<
  typeof useLaterUserContributionAbilityQuery
>
export type LaterUserContributionAbilityLazyQueryHookResult = ReturnType<
  typeof useLaterUserContributionAbilityLazyQuery
>
export type LaterUserContributionAbilityQueryResult =
  ApolloReactCommon.QueryResult<
    LaterUserContributionAbilityQuery,
    LaterUserContributionAbilityQueryVariables
  >
export const InvestmentAccountsQueryDocument = /*#__PURE__*/ gql`
  query InvestmentAccountsQuery($product: InvestmentProduct!) {
    investmentAccountsByUserId(filter: { product: $product }) {
      beneficiaryId
      id
      closedAt
      name
      status
      cashOwed {
        value
      }
      portfolio {
        id
        name
        theme
        accountAllocation {
          allocationPercent
        }
        portfolioSecurityAllocations {
          id
          symbol
          allocationPercent
          security {
            displayName
          }
          investmentCategories {
            bond
            crypto
            equity
          }
        }
      }
      portfolios {
        __typename
        id
        name
        ... on SelfDirectedPortfolio {
          accountAllocation {
            allocationPercent
          }
          status
        }
      }
    }
  }
`

/**
 * __useInvestmentAccountsQueryQuery__
 *
 * To run a query within a React component, call `useInvestmentAccountsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestmentAccountsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestmentAccountsQueryQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useInvestmentAccountsQueryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    InvestmentAccountsQueryQuery,
    InvestmentAccountsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    InvestmentAccountsQueryQuery,
    InvestmentAccountsQueryQueryVariables
  >(InvestmentAccountsQueryDocument, options)
}
export function useInvestmentAccountsQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InvestmentAccountsQueryQuery,
    InvestmentAccountsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    InvestmentAccountsQueryQuery,
    InvestmentAccountsQueryQueryVariables
  >(InvestmentAccountsQueryDocument, options)
}
export type InvestmentAccountsQueryQueryHookResult = ReturnType<
  typeof useInvestmentAccountsQueryQuery
>
export type InvestmentAccountsQueryLazyQueryHookResult = ReturnType<
  typeof useInvestmentAccountsQueryLazyQuery
>
export type InvestmentAccountsQueryQueryResult = ApolloReactCommon.QueryResult<
  InvestmentAccountsQueryQuery,
  InvestmentAccountsQueryQueryVariables
>
export const RecapReadyModuleDocument = /*#__PURE__*/ gql`
  query RecapReadyModule {
    investmentAccountsByUserId(filter: { product: EARLY }) {
      beneficiaryId
      quarterlyRecap {
        id
        viewed
      }
      quarterlyRecapsEnabled
    }
  }
`

/**
 * __useRecapReadyModuleQuery__
 *
 * To run a query within a React component, call `useRecapReadyModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecapReadyModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecapReadyModuleQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecapReadyModuleQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    RecapReadyModuleQuery,
    RecapReadyModuleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RecapReadyModuleQuery,
    RecapReadyModuleQueryVariables
  >(RecapReadyModuleDocument, options)
}
export function useRecapReadyModuleLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RecapReadyModuleQuery,
    RecapReadyModuleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RecapReadyModuleQuery,
    RecapReadyModuleQueryVariables
  >(RecapReadyModuleDocument, options)
}
export type RecapReadyModuleQueryHookResult = ReturnType<
  typeof useRecapReadyModuleQuery
>
export type RecapReadyModuleLazyQueryHookResult = ReturnType<
  typeof useRecapReadyModuleLazyQuery
>
export type RecapReadyModuleQueryResult = ApolloReactCommon.QueryResult<
  RecapReadyModuleQuery,
  RecapReadyModuleQueryVariables
>
export const RecapSetUpModuleDocument = /*#__PURE__*/ gql`
  query RecapSetUpModule {
    tierSubscriptionByUserId {
      __typename
      id
      tier {
        __typename
        id
        key
        name
        products {
          __typename
          id
          key
        }
      }
    }
    investmentAccountsByUserId(filter: { product: EARLY }) {
      __typename
      id
      beneficiaryId
      status
      quarterlyRecap {
        __typename
        id
        viewed
      }
      quarterlyRecapsEnabled
    }
  }
`

/**
 * __useRecapSetUpModuleQuery__
 *
 * To run a query within a React component, call `useRecapSetUpModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecapSetUpModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecapSetUpModuleQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecapSetUpModuleQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    RecapSetUpModuleQuery,
    RecapSetUpModuleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RecapSetUpModuleQuery,
    RecapSetUpModuleQueryVariables
  >(RecapSetUpModuleDocument, options)
}
export function useRecapSetUpModuleLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RecapSetUpModuleQuery,
    RecapSetUpModuleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RecapSetUpModuleQuery,
    RecapSetUpModuleQueryVariables
  >(RecapSetUpModuleDocument, options)
}
export type RecapSetUpModuleQueryHookResult = ReturnType<
  typeof useRecapSetUpModuleQuery
>
export type RecapSetUpModuleLazyQueryHookResult = ReturnType<
  typeof useRecapSetUpModuleLazyQuery
>
export type RecapSetUpModuleQueryResult = ApolloReactCommon.QueryResult<
  RecapSetUpModuleQuery,
  RecapSetUpModuleQueryVariables
>
export const RecapUpgradeModuleDocument = /*#__PURE__*/ gql`
  query RecapUpgradeModule {
    tierSubscriptionByUserId {
      id
      tier {
        id
        key
        name
        products {
          id
          key
        }
      }
    }
    investmentAccountsByUserId(filter: { product: EARLY }) {
      id
      beneficiaryId
      status
    }
  }
`

/**
 * __useRecapUpgradeModuleQuery__
 *
 * To run a query within a React component, call `useRecapUpgradeModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecapUpgradeModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecapUpgradeModuleQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecapUpgradeModuleQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    RecapUpgradeModuleQuery,
    RecapUpgradeModuleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RecapUpgradeModuleQuery,
    RecapUpgradeModuleQueryVariables
  >(RecapUpgradeModuleDocument, options)
}
export function useRecapUpgradeModuleLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RecapUpgradeModuleQuery,
    RecapUpgradeModuleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RecapUpgradeModuleQuery,
    RecapUpgradeModuleQueryVariables
  >(RecapUpgradeModuleDocument, options)
}
export type RecapUpgradeModuleQueryHookResult = ReturnType<
  typeof useRecapUpgradeModuleQuery
>
export type RecapUpgradeModuleLazyQueryHookResult = ReturnType<
  typeof useRecapUpgradeModuleLazyQuery
>
export type RecapUpgradeModuleQueryResult = ApolloReactCommon.QueryResult<
  RecapUpgradeModuleQuery,
  RecapUpgradeModuleQueryVariables
>
export const RecentActivityInvestQueryDocument = /*#__PURE__*/ gql`
  query recentActivityInvestQuery(
    $accountId: ID!
    $first: Int!
    $pending: Boolean!
  ) {
    allPastItems(
      filter: {
        pastItemsAccountFilter: {
          id: $accountId
          productAccountType: BROKERAGE
        }
        pending: $pending
      }
      pagination: { first: $first }
    ) {
      edges {
        node {
          __typename
          title
          amount {
            currency
            value
          }
          createdAt
          status
        }
      }
    }
  }
`

/**
 * __useRecentActivityInvestQueryQuery__
 *
 * To run a query within a React component, call `useRecentActivityInvestQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentActivityInvestQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentActivityInvestQueryQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      first: // value for 'first'
 *      pending: // value for 'pending'
 *   },
 * });
 */
export function useRecentActivityInvestQueryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    RecentActivityInvestQueryQuery,
    RecentActivityInvestQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RecentActivityInvestQueryQuery,
    RecentActivityInvestQueryQueryVariables
  >(RecentActivityInvestQueryDocument, options)
}
export function useRecentActivityInvestQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RecentActivityInvestQueryQuery,
    RecentActivityInvestQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RecentActivityInvestQueryQuery,
    RecentActivityInvestQueryQueryVariables
  >(RecentActivityInvestQueryDocument, options)
}
export type RecentActivityInvestQueryQueryHookResult = ReturnType<
  typeof useRecentActivityInvestQueryQuery
>
export type RecentActivityInvestQueryLazyQueryHookResult = ReturnType<
  typeof useRecentActivityInvestQueryLazyQuery
>
export type RecentActivityInvestQueryQueryResult =
  ApolloReactCommon.QueryResult<
    RecentActivityInvestQueryQuery,
    RecentActivityInvestQueryQueryVariables
  >
export const RecentActivityLaterQueryDocument = /*#__PURE__*/ gql`
  query recentActivityLaterQuery(
    $first: Int!
    $pending: Boolean!
    $accountId: ID!
    $productAccountType: ProductAccountType!
  ) {
    allPastItems(
      filter: {
        pastItemsAccountFilter: {
          id: $accountId
          productAccountType: $productAccountType
        }
        pending: $pending
      }
      pagination: { first: $first }
    ) {
      edges {
        node {
          __typename
          title
          amount {
            currency
            value
          }
          createdAt
          status
        }
      }
    }
  }
`

/**
 * __useRecentActivityLaterQueryQuery__
 *
 * To run a query within a React component, call `useRecentActivityLaterQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentActivityLaterQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentActivityLaterQueryQuery({
 *   variables: {
 *      first: // value for 'first'
 *      pending: // value for 'pending'
 *      accountId: // value for 'accountId'
 *      productAccountType: // value for 'productAccountType'
 *   },
 * });
 */
export function useRecentActivityLaterQueryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    RecentActivityLaterQueryQuery,
    RecentActivityLaterQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RecentActivityLaterQueryQuery,
    RecentActivityLaterQueryQueryVariables
  >(RecentActivityLaterQueryDocument, options)
}
export function useRecentActivityLaterQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RecentActivityLaterQueryQuery,
    RecentActivityLaterQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RecentActivityLaterQueryQuery,
    RecentActivityLaterQueryQueryVariables
  >(RecentActivityLaterQueryDocument, options)
}
export type RecentActivityLaterQueryQueryHookResult = ReturnType<
  typeof useRecentActivityLaterQueryQuery
>
export type RecentActivityLaterQueryLazyQueryHookResult = ReturnType<
  typeof useRecentActivityLaterQueryLazyQuery
>
export type RecentActivityLaterQueryQueryResult = ApolloReactCommon.QueryResult<
  RecentActivityLaterQueryQuery,
  RecentActivityLaterQueryQueryVariables
>
export const RecentActivitySpendQueryDocument = /*#__PURE__*/ gql`
  query recentActivitySpendQuery(
    $first: Int!
    $pending: Boolean!
    $accountId: String
  ) {
    allPastSpendItems(
      pagination: { first: $first }
      filter: { pending: $pending }
      accountId: $accountId
    ) {
      edges {
        node {
          __typename
          title
          amount {
            currency
            value
          }
          createdAt
          status
        }
      }
    }
  }
`

/**
 * __useRecentActivitySpendQueryQuery__
 *
 * To run a query within a React component, call `useRecentActivitySpendQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentActivitySpendQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentActivitySpendQueryQuery({
 *   variables: {
 *      first: // value for 'first'
 *      pending: // value for 'pending'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useRecentActivitySpendQueryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    RecentActivitySpendQueryQuery,
    RecentActivitySpendQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RecentActivitySpendQueryQuery,
    RecentActivitySpendQueryQueryVariables
  >(RecentActivitySpendQueryDocument, options)
}
export function useRecentActivitySpendQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RecentActivitySpendQueryQuery,
    RecentActivitySpendQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RecentActivitySpendQueryQuery,
    RecentActivitySpendQueryQueryVariables
  >(RecentActivitySpendQueryDocument, options)
}
export type RecentActivitySpendQueryQueryHookResult = ReturnType<
  typeof useRecentActivitySpendQueryQuery
>
export type RecentActivitySpendQueryLazyQueryHookResult = ReturnType<
  typeof useRecentActivitySpendQueryLazyQuery
>
export type RecentActivitySpendQueryQueryResult = ApolloReactCommon.QueryResult<
  RecentActivitySpendQueryQuery,
  RecentActivitySpendQueryQueryVariables
>
export const WaitingRoundUpProfileDocument = /*#__PURE__*/ gql`
  query WaitingRoundUpProfile {
    roundUpProfile {
      roundUpTotal(state: [waiting])
    }
  }
`

/**
 * __useWaitingRoundUpProfileQuery__
 *
 * To run a query within a React component, call `useWaitingRoundUpProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useWaitingRoundUpProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaitingRoundUpProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useWaitingRoundUpProfileQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    WaitingRoundUpProfileQuery,
    WaitingRoundUpProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    WaitingRoundUpProfileQuery,
    WaitingRoundUpProfileQueryVariables
  >(WaitingRoundUpProfileDocument, options)
}
export function useWaitingRoundUpProfileLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    WaitingRoundUpProfileQuery,
    WaitingRoundUpProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    WaitingRoundUpProfileQuery,
    WaitingRoundUpProfileQueryVariables
  >(WaitingRoundUpProfileDocument, options)
}
export type WaitingRoundUpProfileQueryHookResult = ReturnType<
  typeof useWaitingRoundUpProfileQuery
>
export type WaitingRoundUpProfileLazyQueryHookResult = ReturnType<
  typeof useWaitingRoundUpProfileLazyQuery
>
export type WaitingRoundUpProfileQueryResult = ApolloReactCommon.QueryResult<
  WaitingRoundUpProfileQuery,
  WaitingRoundUpProfileQueryVariables
>
export const FinishSetupDocument = /*#__PURE__*/ gql`
  query FinishSetup($feedContext: FeedContext!, $accountId: ID!) {
    finishSetup(feedContext: $feedContext, accountId: $accountId) {
      eyebrow
      tips {
        body
        ctaDetails {
          id
          type
          title
          image
          video
          videoUrl
        }
        id
        image {
          url
        }
        backgroundImage {
          url
        }
        type
      }
    }
    bankCardOrder {
      bankCardTier
    }
  }
`

/**
 * __useFinishSetupQuery__
 *
 * To run a query within a React component, call `useFinishSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinishSetupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinishSetupQuery({
 *   variables: {
 *      feedContext: // value for 'feedContext'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useFinishSetupQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    FinishSetupQuery,
    FinishSetupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<FinishSetupQuery, FinishSetupQueryVariables>(
    FinishSetupDocument,
    options,
  )
}
export function useFinishSetupLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FinishSetupQuery,
    FinishSetupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FinishSetupQuery,
    FinishSetupQueryVariables
  >(FinishSetupDocument, options)
}
export type FinishSetupQueryHookResult = ReturnType<typeof useFinishSetupQuery>
export type FinishSetupLazyQueryHookResult = ReturnType<
  typeof useFinishSetupLazyQuery
>
export type FinishSetupQueryResult = ApolloReactCommon.QueryResult<
  FinishSetupQuery,
  FinishSetupQueryVariables
>
export const SmartDepositWidgetDocument = /*#__PURE__*/ gql`
  query SmartDepositWidget(
    $depositsLimit: Int
    $settingTypes: [SplitDepositSettingType!]!
    $metaDataInput: [SplitDepositTargetAccountType!]!
  ) {
    splitDepositSettingsByUserId(filter: { settingTypes: $settingTypes }) {
      allocations {
        ...SmartDepositWidgetAllocationFragment
        __typename
      }
      id
      isActive
      isHidden
      ... on SplitDepositDirectDepositIntentSetting {
        ...SmartDepositSplitDepositIntentSettingFragment
      }
      ... on SplitDepositDirectDepositSetting {
        ...SmartDepositSplitDepositDirectDepositSettingFragment
      }
      deposits(orderBy: DESC, limit: $depositsLimit) {
        ...SmartDepositWidgetSplitDepositFragment
      }
      __typename
    }
    smartDepositMetadata(
      smartDepositMetadataInput: { supportedTargetAccounts: $metaDataInput }
    ) {
      targetAccounts {
        targetAccountId
        targetAccountType
      }
      recommendedAllocations {
        allocationPercent
        targetAccountType
        targetAccountId
      }
    }
    allBankAccounts(input: { type: spend }) {
      routingNumber
      number
    }
    bankCardOrder {
      bankCardTier
    }
  }
  ${SmartDepositWidgetAllocationFragmentFragmentDoc}
  ${SmartDepositSplitDepositIntentSettingFragmentFragmentDoc}
  ${SmartDepositSplitDepositDirectDepositSettingFragmentFragmentDoc}
  ${SmartDepositWidgetSplitDepositFragmentFragmentDoc}
`

/**
 * __useSmartDepositWidgetQuery__
 *
 * To run a query within a React component, call `useSmartDepositWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartDepositWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartDepositWidgetQuery({
 *   variables: {
 *      depositsLimit: // value for 'depositsLimit'
 *      settingTypes: // value for 'settingTypes'
 *      metaDataInput: // value for 'metaDataInput'
 *   },
 * });
 */
export function useSmartDepositWidgetQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SmartDepositWidgetQuery,
    SmartDepositWidgetQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SmartDepositWidgetQuery,
    SmartDepositWidgetQueryVariables
  >(SmartDepositWidgetDocument, options)
}
export function useSmartDepositWidgetLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SmartDepositWidgetQuery,
    SmartDepositWidgetQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SmartDepositWidgetQuery,
    SmartDepositWidgetQueryVariables
  >(SmartDepositWidgetDocument, options)
}
export type SmartDepositWidgetQueryHookResult = ReturnType<
  typeof useSmartDepositWidgetQuery
>
export type SmartDepositWidgetLazyQueryHookResult = ReturnType<
  typeof useSmartDepositWidgetLazyQuery
>
export type SmartDepositWidgetQueryResult = ApolloReactCommon.QueryResult<
  SmartDepositWidgetQuery,
  SmartDepositWidgetQueryVariables
>
export const AllBankCardInfoDocument = /*#__PURE__*/ gql`
  query allBankCardInfo {
    allBankCards {
      cardNumberMasked
      lockReason
      status
      type
      referenceId
      createdAt
    }
    allCardTrackingStatuses {
      status
      picNumber
      createdAt
    }
  }
`

/**
 * __useAllBankCardInfoQuery__
 *
 * To run a query within a React component, call `useAllBankCardInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllBankCardInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBankCardInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllBankCardInfoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AllBankCardInfoQuery,
    AllBankCardInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AllBankCardInfoQuery,
    AllBankCardInfoQueryVariables
  >(AllBankCardInfoDocument, options)
}
export function useAllBankCardInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AllBankCardInfoQuery,
    AllBankCardInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AllBankCardInfoQuery,
    AllBankCardInfoQueryVariables
  >(AllBankCardInfoDocument, options)
}
export type AllBankCardInfoQueryHookResult = ReturnType<
  typeof useAllBankCardInfoQuery
>
export type AllBankCardInfoLazyQueryHookResult = ReturnType<
  typeof useAllBankCardInfoLazyQuery
>
export type AllBankCardInfoQueryResult = ApolloReactCommon.QueryResult<
  AllBankCardInfoQuery,
  AllBankCardInfoQueryVariables
>
export const ActionFeedCardEventDocument = /*#__PURE__*/ gql`
  mutation ActionFeedCardEvent(
    $action: ActionFeedEventAction!
    $eventType: ActionFeedEventType!
    $eventKey: ID!
    $accountId: ID
  ) {
    feedEvent(
      feedEvent: {
        action: $action
        eventType: $eventType
        eventKey: $eventKey
        accountId: $accountId
      }
    ) {
      success
    }
  }
`
export type ActionFeedCardEventMutationFn = ApolloReactCommon.MutationFunction<
  ActionFeedCardEventMutation,
  ActionFeedCardEventMutationVariables
>

/**
 * __useActionFeedCardEventMutation__
 *
 * To run a mutation, you first call `useActionFeedCardEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActionFeedCardEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actionFeedCardEventMutation, { data, loading, error }] = useActionFeedCardEventMutation({
 *   variables: {
 *      action: // value for 'action'
 *      eventType: // value for 'eventType'
 *      eventKey: // value for 'eventKey'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useActionFeedCardEventMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ActionFeedCardEventMutation,
    ActionFeedCardEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ActionFeedCardEventMutation,
    ActionFeedCardEventMutationVariables
  >(ActionFeedCardEventDocument, options)
}
export type ActionFeedCardEventMutationHookResult = ReturnType<
  typeof useActionFeedCardEventMutation
>
export type ActionFeedCardEventMutationResult =
  ApolloReactCommon.MutationResult<ActionFeedCardEventMutation>
export type ActionFeedCardEventMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ActionFeedCardEventMutation,
    ActionFeedCardEventMutationVariables
  >
export const ActionFeedDocument = /*#__PURE__*/ gql`
  query ActionFeed($feedContext: ActionFeedContext) {
    actionFeed(input: { feedContext: $feedContext }) {
      type
      widget
      userCardDigest
    }
  }
`

/**
 * __useActionFeedQuery__
 *
 * To run a query within a React component, call `useActionFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionFeedQuery({
 *   variables: {
 *      feedContext: // value for 'feedContext'
 *   },
 * });
 */
export function useActionFeedQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ActionFeedQuery,
    ActionFeedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<ActionFeedQuery, ActionFeedQueryVariables>(
    ActionFeedDocument,
    options,
  )
}
export function useActionFeedLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ActionFeedQuery,
    ActionFeedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ActionFeedQuery,
    ActionFeedQueryVariables
  >(ActionFeedDocument, options)
}
export type ActionFeedQueryHookResult = ReturnType<typeof useActionFeedQuery>
export type ActionFeedLazyQueryHookResult = ReturnType<
  typeof useActionFeedLazyQuery
>
export type ActionFeedQueryResult = ApolloReactCommon.QueryResult<
  ActionFeedQuery,
  ActionFeedQueryVariables
>
export const TierSubscriptionForPassionsEarlyAccessDocument = /*#__PURE__*/ gql`
  query TierSubscriptionForPassionsEarlyAccess {
    tierSubscriptionByUserId {
      id
      tier {
        id
        name
        products {
          id
          key
          name
        }
      }
      tierPrice {
        amount {
          value
        }
      }
    }
  }
`

/**
 * __useTierSubscriptionForPassionsEarlyAccessQuery__
 *
 * To run a query within a React component, call `useTierSubscriptionForPassionsEarlyAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useTierSubscriptionForPassionsEarlyAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTierSubscriptionForPassionsEarlyAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useTierSubscriptionForPassionsEarlyAccessQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    TierSubscriptionForPassionsEarlyAccessQuery,
    TierSubscriptionForPassionsEarlyAccessQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    TierSubscriptionForPassionsEarlyAccessQuery,
    TierSubscriptionForPassionsEarlyAccessQueryVariables
  >(TierSubscriptionForPassionsEarlyAccessDocument, options)
}
export function useTierSubscriptionForPassionsEarlyAccessLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TierSubscriptionForPassionsEarlyAccessQuery,
    TierSubscriptionForPassionsEarlyAccessQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    TierSubscriptionForPassionsEarlyAccessQuery,
    TierSubscriptionForPassionsEarlyAccessQueryVariables
  >(TierSubscriptionForPassionsEarlyAccessDocument, options)
}
export type TierSubscriptionForPassionsEarlyAccessQueryHookResult = ReturnType<
  typeof useTierSubscriptionForPassionsEarlyAccessQuery
>
export type TierSubscriptionForPassionsEarlyAccessLazyQueryHookResult =
  ReturnType<typeof useTierSubscriptionForPassionsEarlyAccessLazyQuery>
export type TierSubscriptionForPassionsEarlyAccessQueryResult =
  ApolloReactCommon.QueryResult<
    TierSubscriptionForPassionsEarlyAccessQuery,
    TierSubscriptionForPassionsEarlyAccessQueryVariables
  >
export const LegacyUploadDocumentDocument = /*#__PURE__*/ gql`
  mutation LegacyUploadDocument(
    $documentType: DocumentType!
    $upload: Upload!
  ) {
    legacyUploadDocument(
      input: { documentType: $documentType, upload: $upload }
    ) {
      __typename
    }
  }
`
export type LegacyUploadDocumentMutationFn = ApolloReactCommon.MutationFunction<
  LegacyUploadDocumentMutation,
  LegacyUploadDocumentMutationVariables
>

/**
 * __useLegacyUploadDocumentMutation__
 *
 * To run a mutation, you first call `useLegacyUploadDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLegacyUploadDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [legacyUploadDocumentMutation, { data, loading, error }] = useLegacyUploadDocumentMutation({
 *   variables: {
 *      documentType: // value for 'documentType'
 *      upload: // value for 'upload'
 *   },
 * });
 */
export function useLegacyUploadDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    LegacyUploadDocumentMutation,
    LegacyUploadDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    LegacyUploadDocumentMutation,
    LegacyUploadDocumentMutationVariables
  >(LegacyUploadDocumentDocument, options)
}
export type LegacyUploadDocumentMutationHookResult = ReturnType<
  typeof useLegacyUploadDocumentMutation
>
export type LegacyUploadDocumentMutationResult =
  ApolloReactCommon.MutationResult<LegacyUploadDocumentMutation>
export type LegacyUploadDocumentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    LegacyUploadDocumentMutation,
    LegacyUploadDocumentMutationVariables
  >
export const SubscriptionPricingContentDocument = /*#__PURE__*/ gql`
  query SubscriptionPricingContent {
    user {
      uuid
    }
    tierSubscriptionHistoryByUserId {
      edges {
        status
        createdAt
        tier {
          key
        }
      }
    }
    bankInterestRates {
      ... on BankInterestRates {
        bankInterestRates {
          currentApy
          productName
        }
      }
    }
    tierGroup {
      id
      preferredTierId
      tierOptions {
        preferredTierPrice {
          amountV2 {
            currency
            value
          }
          billingFrequency
        }
        tier {
          id
          key
          name
          descriptionKey
          tierPrice {
            id
            amountV2 {
              currency
              value
            }
          }
          products {
            key
            highlights {
              title
            }
          }
          matchProgram(investmentAccountType: ROTH_IRA) {
            matchPercentage
          }
          bundles {
            name
            iconPath
            products {
              descriptionKeysV2 {
                title
                subtitle
              }
              product {
                key
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useSubscriptionPricingContentQuery__
 *
 * To run a query within a React component, call `useSubscriptionPricingContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionPricingContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionPricingContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionPricingContentQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SubscriptionPricingContentQuery,
    SubscriptionPricingContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SubscriptionPricingContentQuery,
    SubscriptionPricingContentQueryVariables
  >(SubscriptionPricingContentDocument, options)
}
export function useSubscriptionPricingContentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SubscriptionPricingContentQuery,
    SubscriptionPricingContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SubscriptionPricingContentQuery,
    SubscriptionPricingContentQueryVariables
  >(SubscriptionPricingContentDocument, options)
}
export type SubscriptionPricingContentQueryHookResult = ReturnType<
  typeof useSubscriptionPricingContentQuery
>
export type SubscriptionPricingContentLazyQueryHookResult = ReturnType<
  typeof useSubscriptionPricingContentLazyQuery
>
export type SubscriptionPricingContentQueryResult =
  ApolloReactCommon.QueryResult<
    SubscriptionPricingContentQuery,
    SubscriptionPricingContentQueryVariables
  >
export const WithLaterDetailsQueryDocument = /*#__PURE__*/ gql`
  query WithLaterDetailsQuery {
    user {
      fundingSource {
        verified
      }
    }
    laterAccounts {
      amount
      name
      accountId
      accountNumber
      status
    }
  }
`

/**
 * __useWithLaterDetailsQueryQuery__
 *
 * To run a query within a React component, call `useWithLaterDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useWithLaterDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWithLaterDetailsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useWithLaterDetailsQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    WithLaterDetailsQueryQuery,
    WithLaterDetailsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    WithLaterDetailsQueryQuery,
    WithLaterDetailsQueryQueryVariables
  >(WithLaterDetailsQueryDocument, options)
}
export function useWithLaterDetailsQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    WithLaterDetailsQueryQuery,
    WithLaterDetailsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    WithLaterDetailsQueryQuery,
    WithLaterDetailsQueryQueryVariables
  >(WithLaterDetailsQueryDocument, options)
}
export type WithLaterDetailsQueryQueryHookResult = ReturnType<
  typeof useWithLaterDetailsQueryQuery
>
export type WithLaterDetailsQueryLazyQueryHookResult = ReturnType<
  typeof useWithLaterDetailsQueryLazyQuery
>
export type WithLaterDetailsQueryQueryResult = ApolloReactCommon.QueryResult<
  WithLaterDetailsQueryQuery,
  WithLaterDetailsQueryQueryVariables
>
export const WithLinkedAccountsFundingSourceInfoDocument = /*#__PURE__*/ gql`
  query WithLinkedAccountsFundingSourceInfo {
    user {
      uploads {
        id
        documentType
        createdAt
      }
      fundingSourceChangeRequiresApproval
    }
    fundingSourceInfo {
      name
      accountNumberLastFour
      balance
      linkedSubaccountId
      verified
      type
      rdvSettledAt
    }
  }
`

/**
 * __useWithLinkedAccountsFundingSourceInfoQuery__
 *
 * To run a query within a React component, call `useWithLinkedAccountsFundingSourceInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useWithLinkedAccountsFundingSourceInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWithLinkedAccountsFundingSourceInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useWithLinkedAccountsFundingSourceInfoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    WithLinkedAccountsFundingSourceInfoQuery,
    WithLinkedAccountsFundingSourceInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    WithLinkedAccountsFundingSourceInfoQuery,
    WithLinkedAccountsFundingSourceInfoQueryVariables
  >(WithLinkedAccountsFundingSourceInfoDocument, options)
}
export function useWithLinkedAccountsFundingSourceInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    WithLinkedAccountsFundingSourceInfoQuery,
    WithLinkedAccountsFundingSourceInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    WithLinkedAccountsFundingSourceInfoQuery,
    WithLinkedAccountsFundingSourceInfoQueryVariables
  >(WithLinkedAccountsFundingSourceInfoDocument, options)
}
export type WithLinkedAccountsFundingSourceInfoQueryHookResult = ReturnType<
  typeof useWithLinkedAccountsFundingSourceInfoQuery
>
export type WithLinkedAccountsFundingSourceInfoLazyQueryHookResult = ReturnType<
  typeof useWithLinkedAccountsFundingSourceInfoLazyQuery
>
export type WithLinkedAccountsFundingSourceInfoQueryResult =
  ApolloReactCommon.QueryResult<
    WithLinkedAccountsFundingSourceInfoQuery,
    WithLinkedAccountsFundingSourceInfoQueryVariables
  >
export const BankCardOrderDocument = /*#__PURE__*/ gql`
  query BankCardOrder {
    bankCardOrder {
      failureReason
      cardOrderStatus
      addressVerification {
        status
        actionRequired
      }
      identityVerification {
        status
        actionRequired
        documentUploadUrl
        canRetry
      }
      prefundVerification {
        status
        actionRequired
      }
      fundingSourceVerification {
        status
        actionRequired
        pendingReason
      }
      kycStatus
      fundingInitiated
      requestVersion
      bankCardTier
    }
    spendAccount {
      isReopenable
    }
  }
`

/**
 * __useBankCardOrderQuery__
 *
 * To run a query within a React component, call `useBankCardOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankCardOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankCardOrderQuery({
 *   variables: {
 *   },
 * });
 */
export function useBankCardOrderQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    BankCardOrderQuery,
    BankCardOrderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    BankCardOrderQuery,
    BankCardOrderQueryVariables
  >(BankCardOrderDocument, options)
}
export function useBankCardOrderLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BankCardOrderQuery,
    BankCardOrderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    BankCardOrderQuery,
    BankCardOrderQueryVariables
  >(BankCardOrderDocument, options)
}
export type BankCardOrderQueryHookResult = ReturnType<
  typeof useBankCardOrderQuery
>
export type BankCardOrderLazyQueryHookResult = ReturnType<
  typeof useBankCardOrderLazyQuery
>
export type BankCardOrderQueryResult = ApolloReactCommon.QueryResult<
  BankCardOrderQuery,
  BankCardOrderQueryVariables
>
export const SpendAccountInfoQueryDocument = /*#__PURE__*/ gql`
  query SpendAccountInfoQuery {
    fundingSourceInfo {
      verified
      name
    }
    allBankAccounts(input: { type: spend }) {
      type
      id
      status
      availableBalance {
        value
      }
      pendingBalance {
        value
      }
    }
    allBankCards {
      cardNumberMasked
      lockReason
      status
      type
    }
    allCardTrackingStatuses {
      status
    }
    eligibility(eligibilityScope: spend) {
      eligible
    }
    spendAccount {
      status
      isEligible
      isReopenable
      isDirectDepositIncentiveEligible
      bankType
    }
  }
`

/**
 * __useSpendAccountInfoQueryQuery__
 *
 * To run a query within a React component, call `useSpendAccountInfoQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpendAccountInfoQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpendAccountInfoQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpendAccountInfoQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SpendAccountInfoQueryQuery,
    SpendAccountInfoQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SpendAccountInfoQueryQuery,
    SpendAccountInfoQueryQueryVariables
  >(SpendAccountInfoQueryDocument, options)
}
export function useSpendAccountInfoQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SpendAccountInfoQueryQuery,
    SpendAccountInfoQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SpendAccountInfoQueryQuery,
    SpendAccountInfoQueryQueryVariables
  >(SpendAccountInfoQueryDocument, options)
}
export type SpendAccountInfoQueryQueryHookResult = ReturnType<
  typeof useSpendAccountInfoQueryQuery
>
export type SpendAccountInfoQueryLazyQueryHookResult = ReturnType<
  typeof useSpendAccountInfoQueryLazyQuery
>
export type SpendAccountInfoQueryQueryResult = ApolloReactCommon.QueryResult<
  SpendAccountInfoQueryQuery,
  SpendAccountInfoQueryQueryVariables
>
export const SendCheckEligibilityDocument = /*#__PURE__*/ gql`
  query SendCheckEligibility {
    eligibility(eligibilityScope: sendCheck) {
      eligible
    }
  }
`

/**
 * __useSendCheckEligibilityQuery__
 *
 * To run a query within a React component, call `useSendCheckEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendCheckEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendCheckEligibilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useSendCheckEligibilityQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SendCheckEligibilityQuery,
    SendCheckEligibilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SendCheckEligibilityQuery,
    SendCheckEligibilityQueryVariables
  >(SendCheckEligibilityDocument, options)
}
export function useSendCheckEligibilityLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SendCheckEligibilityQuery,
    SendCheckEligibilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SendCheckEligibilityQuery,
    SendCheckEligibilityQueryVariables
  >(SendCheckEligibilityDocument, options)
}
export type SendCheckEligibilityQueryHookResult = ReturnType<
  typeof useSendCheckEligibilityQuery
>
export type SendCheckEligibilityLazyQueryHookResult = ReturnType<
  typeof useSendCheckEligibilityLazyQuery
>
export type SendCheckEligibilityQueryResult = ApolloReactCommon.QueryResult<
  SendCheckEligibilityQuery,
  SendCheckEligibilityQueryVariables
>
export const OnboardingTipsDocument = /*#__PURE__*/ gql`
  query OnboardingTips($feedContext: FeedContext!) {
    onboardingTips(feedContext: $feedContext) {
      items {
        id
        type
        title
        headline
        body
        image {
          url
        }
      }
    }
  }
`

/**
 * __useOnboardingTipsQuery__
 *
 * To run a query within a React component, call `useOnboardingTipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingTipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingTipsQuery({
 *   variables: {
 *      feedContext: // value for 'feedContext'
 *   },
 * });
 */
export function useOnboardingTipsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    OnboardingTipsQuery,
    OnboardingTipsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    OnboardingTipsQuery,
    OnboardingTipsQueryVariables
  >(OnboardingTipsDocument, options)
}
export function useOnboardingTipsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    OnboardingTipsQuery,
    OnboardingTipsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    OnboardingTipsQuery,
    OnboardingTipsQueryVariables
  >(OnboardingTipsDocument, options)
}
export type OnboardingTipsQueryHookResult = ReturnType<
  typeof useOnboardingTipsQuery
>
export type OnboardingTipsLazyQueryHookResult = ReturnType<
  typeof useOnboardingTipsLazyQuery
>
export type OnboardingTipsQueryResult = ApolloReactCommon.QueryResult<
  OnboardingTipsQuery,
  OnboardingTipsQueryVariables
>
export const ProductAccountValuesDocument = /*#__PURE__*/ gql`
  query ProductAccountValues($product: InvestmentProduct) {
    investmentAccounts: investmentAccountsByUserId(
      filter: { product: $product }
    ) {
      id
      name
      createdAt
      closedAt
      type
      beneficiaryId
      performance(days: -1) {
        marketChangePercent
      }
      currentBalance {
        value
      }
    }
  }
`

/**
 * __useProductAccountValuesQuery__
 *
 * To run a query within a React component, call `useProductAccountValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductAccountValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductAccountValuesQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useProductAccountValuesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ProductAccountValuesQuery,
    ProductAccountValuesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ProductAccountValuesQuery,
    ProductAccountValuesQueryVariables
  >(ProductAccountValuesDocument, options)
}
export function useProductAccountValuesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ProductAccountValuesQuery,
    ProductAccountValuesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ProductAccountValuesQuery,
    ProductAccountValuesQueryVariables
  >(ProductAccountValuesDocument, options)
}
export type ProductAccountValuesQueryHookResult = ReturnType<
  typeof useProductAccountValuesQuery
>
export type ProductAccountValuesLazyQueryHookResult = ReturnType<
  typeof useProductAccountValuesLazyQuery
>
export type ProductAccountValuesQueryResult = ApolloReactCommon.QueryResult<
  ProductAccountValuesQuery,
  ProductAccountValuesQueryVariables
>
export const TrackAllBankCardsDocument = /*#__PURE__*/ gql`
  query trackAllBankCards {
    allBankCards {
      status
      lockReason
    }
  }
`

/**
 * __useTrackAllBankCardsQuery__
 *
 * To run a query within a React component, call `useTrackAllBankCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackAllBankCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackAllBankCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTrackAllBankCardsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    TrackAllBankCardsQuery,
    TrackAllBankCardsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    TrackAllBankCardsQuery,
    TrackAllBankCardsQueryVariables
  >(TrackAllBankCardsDocument, options)
}
export function useTrackAllBankCardsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TrackAllBankCardsQuery,
    TrackAllBankCardsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    TrackAllBankCardsQuery,
    TrackAllBankCardsQueryVariables
  >(TrackAllBankCardsDocument, options)
}
export type TrackAllBankCardsQueryHookResult = ReturnType<
  typeof useTrackAllBankCardsQuery
>
export type TrackAllBankCardsLazyQueryHookResult = ReturnType<
  typeof useTrackAllBankCardsLazyQuery
>
export type TrackAllBankCardsQueryResult = ApolloReactCommon.QueryResult<
  TrackAllBankCardsQuery,
  TrackAllBankCardsQueryVariables
>
export const FundingSourceDataDocument = /*#__PURE__*/ gql`
  query FundingSourceData {
    fundingSourceInfo {
      verified
    }
    user {
      verified
    }
  }
`

/**
 * __useFundingSourceDataQuery__
 *
 * To run a query within a React component, call `useFundingSourceDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundingSourceDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundingSourceDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useFundingSourceDataQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FundingSourceDataQuery,
    FundingSourceDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FundingSourceDataQuery,
    FundingSourceDataQueryVariables
  >(FundingSourceDataDocument, options)
}
export function useFundingSourceDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FundingSourceDataQuery,
    FundingSourceDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FundingSourceDataQuery,
    FundingSourceDataQueryVariables
  >(FundingSourceDataDocument, options)
}
export type FundingSourceDataQueryHookResult = ReturnType<
  typeof useFundingSourceDataQuery
>
export type FundingSourceDataLazyQueryHookResult = ReturnType<
  typeof useFundingSourceDataLazyQuery
>
export type FundingSourceDataQueryResult = ApolloReactCommon.QueryResult<
  FundingSourceDataQuery,
  FundingSourceDataQueryVariables
>
export const GetEarlyBeneficiariesDocument = /*#__PURE__*/ gql`
  query GetEarlyBeneficiaries {
    beneficiaries {
      avatarUrl
      createdAt
      firstName
      id
      lastName
      updatedAt
      investmentAccount {
        beneficiaryId
        id
        name
        type
        currentBalance {
          currency
          value
        }
        transferability {
          transferAge
          transferDate
          transferReached
        }
        performance(days: -1) {
          marketChangePercentWithoutFees
        }
      }
    }
  }
`

/**
 * __useGetEarlyBeneficiariesQuery__
 *
 * To run a query within a React component, call `useGetEarlyBeneficiariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEarlyBeneficiariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEarlyBeneficiariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEarlyBeneficiariesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetEarlyBeneficiariesQuery,
    GetEarlyBeneficiariesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetEarlyBeneficiariesQuery,
    GetEarlyBeneficiariesQueryVariables
  >(GetEarlyBeneficiariesDocument, options)
}
export function useGetEarlyBeneficiariesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetEarlyBeneficiariesQuery,
    GetEarlyBeneficiariesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetEarlyBeneficiariesQuery,
    GetEarlyBeneficiariesQueryVariables
  >(GetEarlyBeneficiariesDocument, options)
}
export type GetEarlyBeneficiariesQueryHookResult = ReturnType<
  typeof useGetEarlyBeneficiariesQuery
>
export type GetEarlyBeneficiariesLazyQueryHookResult = ReturnType<
  typeof useGetEarlyBeneficiariesLazyQuery
>
export type GetEarlyBeneficiariesQueryResult = ApolloReactCommon.QueryResult<
  GetEarlyBeneficiariesQuery,
  GetEarlyBeneficiariesQueryVariables
>
export const TierSubscriptionForUserDataDocument = /*#__PURE__*/ gql`
  query TierSubscriptionForUserData {
    tierSubscriptionByUserId {
      id
      tier {
        id
        products {
          key
          id
        }
      }
    }
  }
`

/**
 * __useTierSubscriptionForUserDataQuery__
 *
 * To run a query within a React component, call `useTierSubscriptionForUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTierSubscriptionForUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTierSubscriptionForUserDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useTierSubscriptionForUserDataQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    TierSubscriptionForUserDataQuery,
    TierSubscriptionForUserDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    TierSubscriptionForUserDataQuery,
    TierSubscriptionForUserDataQueryVariables
  >(TierSubscriptionForUserDataDocument, options)
}
export function useTierSubscriptionForUserDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TierSubscriptionForUserDataQuery,
    TierSubscriptionForUserDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    TierSubscriptionForUserDataQuery,
    TierSubscriptionForUserDataQueryVariables
  >(TierSubscriptionForUserDataDocument, options)
}
export type TierSubscriptionForUserDataQueryHookResult = ReturnType<
  typeof useTierSubscriptionForUserDataQuery
>
export type TierSubscriptionForUserDataLazyQueryHookResult = ReturnType<
  typeof useTierSubscriptionForUserDataLazyQuery
>
export type TierSubscriptionForUserDataQueryResult =
  ApolloReactCommon.QueryResult<
    TierSubscriptionForUserDataQuery,
    TierSubscriptionForUserDataQueryVariables
  >
export const ReferralAgreeToAcceptanceDocumentDocument = /*#__PURE__*/ gql`
  mutation ReferralAgreeToAcceptanceDocument($id: ID!) {
    agreeToAcceptanceDocument(id: $id)
  }
`
export type ReferralAgreeToAcceptanceDocumentMutationFn =
  ApolloReactCommon.MutationFunction<
    ReferralAgreeToAcceptanceDocumentMutation,
    ReferralAgreeToAcceptanceDocumentMutationVariables
  >

/**
 * __useReferralAgreeToAcceptanceDocumentMutation__
 *
 * To run a mutation, you first call `useReferralAgreeToAcceptanceDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReferralAgreeToAcceptanceDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [referralAgreeToAcceptanceDocumentMutation, { data, loading, error }] = useReferralAgreeToAcceptanceDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReferralAgreeToAcceptanceDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ReferralAgreeToAcceptanceDocumentMutation,
    ReferralAgreeToAcceptanceDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ReferralAgreeToAcceptanceDocumentMutation,
    ReferralAgreeToAcceptanceDocumentMutationVariables
  >(ReferralAgreeToAcceptanceDocumentDocument, options)
}
export type ReferralAgreeToAcceptanceDocumentMutationHookResult = ReturnType<
  typeof useReferralAgreeToAcceptanceDocumentMutation
>
export type ReferralAgreeToAcceptanceDocumentMutationResult =
  ApolloReactCommon.MutationResult<ReferralAgreeToAcceptanceDocumentMutation>
export type ReferralAgreeToAcceptanceDocumentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ReferralAgreeToAcceptanceDocumentMutation,
    ReferralAgreeToAcceptanceDocumentMutationVariables
  >
export const AllCampaignHistoryDocument = /*#__PURE__*/ gql`
  query AllCampaignHistory {
    pendingCampaigns: campaignHistory(
      filter: { type: PARTICIPATED, publishedStatus: PENDING, hurdleMet: true }
      page: { limit: 100 }
    ) {
      edges {
        cursor
        hurdleMet
        numCompletedReferrals
        numPendingReferrals
        eligibilityMet
        __typename
        node {
          icon
          condensedTitle
          eligibilityEnd
          id
          internalMemo
          publishEnd
          publishStart
          rewards {
            amount
            hurdle
            id
            targets
            type
          }
          qualificationAction
          qualificationAmount
          status
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    activeCampaigns: campaignHistory(
      filter: { type: PARTICIPATED, publishedStatus: LIVE }
      page: { limit: 100 }
    ) {
      edges {
        cursor
        hurdleMet
        numCompletedReferrals
        numPendingReferrals
        eligibilityMet
        __typename
        node {
          icon
          condensedTitle
          eligibilityEnd
          id
          internalMemo
          publishEnd
          publishStart
          rewards {
            amount
            hurdle
            id
            targets
            type
          }
          qualificationAction
          qualificationAmount
          status
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    pastCompletedCampaigns: campaignHistory(
      filter: { type: PARTICIPATED, publishedStatus: COMPLETE }
      page: { limit: 100 }
    ) {
      edges {
        cursor
        hurdleMet
        numCompletedReferrals
        numPendingReferrals
        eligibilityMet
        __typename
        node {
          icon
          condensedTitle
          eligibilityEnd
          id
          internalMemo
          publishEnd
          publishStart
          rewards {
            amount
            hurdle
            id
            targets
            type
          }
          qualificationAction
          qualificationAmount
          status
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    pastPendingCampaigns: campaignHistory(
      filter: { type: PARTICIPATED, publishedStatus: PENDING, hurdleMet: false }
      page: { limit: 100 }
    ) {
      edges {
        cursor
        hurdleMet
        numCompletedReferrals
        numPendingReferrals
        eligibilityMet
        __typename
        node {
          icon
          condensedTitle
          eligibilityEnd
          id
          internalMemo
          publishEnd
          publishStart
          rewards {
            amount
            hurdle
            id
            targets
            type
          }
          qualificationAction
          qualificationAmount
          status
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`

/**
 * __useAllCampaignHistoryQuery__
 *
 * To run a query within a React component, call `useAllCampaignHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCampaignHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCampaignHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCampaignHistoryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AllCampaignHistoryQuery,
    AllCampaignHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AllCampaignHistoryQuery,
    AllCampaignHistoryQueryVariables
  >(AllCampaignHistoryDocument, options)
}
export function useAllCampaignHistoryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AllCampaignHistoryQuery,
    AllCampaignHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AllCampaignHistoryQuery,
    AllCampaignHistoryQueryVariables
  >(AllCampaignHistoryDocument, options)
}
export type AllCampaignHistoryQueryHookResult = ReturnType<
  typeof useAllCampaignHistoryQuery
>
export type AllCampaignHistoryLazyQueryHookResult = ReturnType<
  typeof useAllCampaignHistoryLazyQuery
>
export type AllCampaignHistoryQueryResult = ApolloReactCommon.QueryResult<
  AllCampaignHistoryQuery,
  AllCampaignHistoryQueryVariables
>
export const CampaignFriendsHistoryDocument = /*#__PURE__*/ gql`
  query CampaignFriendsHistory(
    $campaignId: ID!
    $filterFriend: ReferralPaginatedFilter!
    $filterCampaign: ReferralPaginatedFilter!
  ) {
    referralCampaigns(campaignId: $campaignId, filter: $filterCampaign) {
      edges {
        cursor
        node {
          icon
          condensedTitle
          eligibilityEnd
          id
          internalMemo
          publishEnd
          publishStart
          rewards {
            amount
            hurdle
            id
            targets
            type
          }
          qualificationAction
          qualificationAmount
          status
        }
      }
    }
    referralHistory {
      numCompletedReferrals
      numPendingReferrals
      friendHistory(campaignId: $campaignId, filter: $filterFriend) {
        edges {
          cursor
          node {
            advocateUserId
            campaignId
            createdAt
            friendFirstName
            friendLastName
            status
            userId
            __typename
          }
        }
      }
    }
  }
`

/**
 * __useCampaignFriendsHistoryQuery__
 *
 * To run a query within a React component, call `useCampaignFriendsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignFriendsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignFriendsHistoryQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      filterFriend: // value for 'filterFriend'
 *      filterCampaign: // value for 'filterCampaign'
 *   },
 * });
 */
export function useCampaignFriendsHistoryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    CampaignFriendsHistoryQuery,
    CampaignFriendsHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CampaignFriendsHistoryQuery,
    CampaignFriendsHistoryQueryVariables
  >(CampaignFriendsHistoryDocument, options)
}
export function useCampaignFriendsHistoryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CampaignFriendsHistoryQuery,
    CampaignFriendsHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CampaignFriendsHistoryQuery,
    CampaignFriendsHistoryQueryVariables
  >(CampaignFriendsHistoryDocument, options)
}
export type CampaignFriendsHistoryQueryHookResult = ReturnType<
  typeof useCampaignFriendsHistoryQuery
>
export type CampaignFriendsHistoryLazyQueryHookResult = ReturnType<
  typeof useCampaignFriendsHistoryLazyQuery
>
export type CampaignFriendsHistoryQueryResult = ApolloReactCommon.QueryResult<
  CampaignFriendsHistoryQuery,
  CampaignFriendsHistoryQueryVariables
>
export const ReferralCampaignIdDocument = /*#__PURE__*/ gql`
  query ReferralCampaignId {
    advocate {
      campaign {
        id
      }
    }
  }
`

/**
 * __useReferralCampaignIdQuery__
 *
 * To run a query within a React component, call `useReferralCampaignIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralCampaignIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralCampaignIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useReferralCampaignIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ReferralCampaignIdQuery,
    ReferralCampaignIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ReferralCampaignIdQuery,
    ReferralCampaignIdQueryVariables
  >(ReferralCampaignIdDocument, options)
}
export function useReferralCampaignIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ReferralCampaignIdQuery,
    ReferralCampaignIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ReferralCampaignIdQuery,
    ReferralCampaignIdQueryVariables
  >(ReferralCampaignIdDocument, options)
}
export type ReferralCampaignIdQueryHookResult = ReturnType<
  typeof useReferralCampaignIdQuery
>
export type ReferralCampaignIdLazyQueryHookResult = ReturnType<
  typeof useReferralCampaignIdLazyQuery
>
export type ReferralCampaignIdQueryResult = ApolloReactCommon.QueryResult<
  ReferralCampaignIdQuery,
  ReferralCampaignIdQueryVariables
>
export const UserInvestmentAccountsDocument = /*#__PURE__*/ gql`
  query UserInvestmentAccounts {
    investmentAccountsByUserId {
      id
      type
      closedAt
      portfolio {
        id
      }
    }
  }
`

/**
 * __useUserInvestmentAccountsQuery__
 *
 * To run a query within a React component, call `useUserInvestmentAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInvestmentAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInvestmentAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserInvestmentAccountsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserInvestmentAccountsQuery,
    UserInvestmentAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    UserInvestmentAccountsQuery,
    UserInvestmentAccountsQueryVariables
  >(UserInvestmentAccountsDocument, options)
}
export function useUserInvestmentAccountsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserInvestmentAccountsQuery,
    UserInvestmentAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    UserInvestmentAccountsQuery,
    UserInvestmentAccountsQueryVariables
  >(UserInvestmentAccountsDocument, options)
}
export type UserInvestmentAccountsQueryHookResult = ReturnType<
  typeof useUserInvestmentAccountsQuery
>
export type UserInvestmentAccountsLazyQueryHookResult = ReturnType<
  typeof useUserInvestmentAccountsLazyQuery
>
export type UserInvestmentAccountsQueryResult = ApolloReactCommon.QueryResult<
  UserInvestmentAccountsQuery,
  UserInvestmentAccountsQueryVariables
>
export const ReferralFriendHistoryDocument = /*#__PURE__*/ gql`
  query ReferralFriendHistory($filter: ReferralPaginatedFilter!) {
    referralHistory {
      friendHistory(filter: $filter) {
        edges {
          cursor
          node {
            advocateUserId
            campaignId
            createdAt
            friendFirstName
            friendLastName
            status
            userId
          }
        }
      }
    }
  }
`

/**
 * __useReferralFriendHistoryQuery__
 *
 * To run a query within a React component, call `useReferralFriendHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralFriendHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralFriendHistoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReferralFriendHistoryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ReferralFriendHistoryQuery,
    ReferralFriendHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ReferralFriendHistoryQuery,
    ReferralFriendHistoryQueryVariables
  >(ReferralFriendHistoryDocument, options)
}
export function useReferralFriendHistoryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ReferralFriendHistoryQuery,
    ReferralFriendHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ReferralFriendHistoryQuery,
    ReferralFriendHistoryQueryVariables
  >(ReferralFriendHistoryDocument, options)
}
export type ReferralFriendHistoryQueryHookResult = ReturnType<
  typeof useReferralFriendHistoryQuery
>
export type ReferralFriendHistoryLazyQueryHookResult = ReturnType<
  typeof useReferralFriendHistoryLazyQuery
>
export type ReferralFriendHistoryQueryResult = ApolloReactCommon.QueryResult<
  ReferralFriendHistoryQuery,
  ReferralFriendHistoryQueryVariables
>
export const SendBrazeEventDocument = /*#__PURE__*/ gql`
  mutation SendBrazeEvent($input: SendBrazeEventInput!) {
    sendBrazeEvent(input: $input)
  }
`
export type SendBrazeEventMutationFn = ApolloReactCommon.MutationFunction<
  SendBrazeEventMutation,
  SendBrazeEventMutationVariables
>

/**
 * __useSendBrazeEventMutation__
 *
 * To run a mutation, you first call `useSendBrazeEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBrazeEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBrazeEventMutation, { data, loading, error }] = useSendBrazeEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendBrazeEventMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SendBrazeEventMutation,
    SendBrazeEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SendBrazeEventMutation,
    SendBrazeEventMutationVariables
  >(SendBrazeEventDocument, options)
}
export type SendBrazeEventMutationHookResult = ReturnType<
  typeof useSendBrazeEventMutation
>
export type SendBrazeEventMutationResult =
  ApolloReactCommon.MutationResult<SendBrazeEventMutation>
export type SendBrazeEventMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SendBrazeEventMutation,
    SendBrazeEventMutationVariables
  >
export const ReferralDetailsQueryDocument = /*#__PURE__*/ gql`
  query ReferralDetailsQuery {
    acceptanceDocuments {
      name
      type
      summaryUrl
      id
      url
    }
    user {
      uuid
      email
      firstName
      lastName
    }
  }
`

/**
 * __useReferralDetailsQueryQuery__
 *
 * To run a query within a React component, call `useReferralDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralDetailsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useReferralDetailsQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ReferralDetailsQueryQuery,
    ReferralDetailsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ReferralDetailsQueryQuery,
    ReferralDetailsQueryQueryVariables
  >(ReferralDetailsQueryDocument, options)
}
export function useReferralDetailsQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ReferralDetailsQueryQuery,
    ReferralDetailsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ReferralDetailsQueryQuery,
    ReferralDetailsQueryQueryVariables
  >(ReferralDetailsQueryDocument, options)
}
export type ReferralDetailsQueryQueryHookResult = ReturnType<
  typeof useReferralDetailsQueryQuery
>
export type ReferralDetailsQueryLazyQueryHookResult = ReturnType<
  typeof useReferralDetailsQueryLazyQuery
>
export type ReferralDetailsQueryQueryResult = ApolloReactCommon.QueryResult<
  ReferralDetailsQueryQuery,
  ReferralDetailsQueryQueryVariables
>
export const ReferralDetailsWithAdvocateDocument = /*#__PURE__*/ gql`
  query ReferralDetailsWithAdvocate {
    acceptanceDocuments {
      name
      type
      summaryUrl
      id
      url
    }
    user {
      uuid
      email
      firstName
      lastName
    }
    advocate {
      campaign {
        id
        title
        description
        eligibilityEnd
        publishEnd
        activeInHouseCampaign
        actionFeedDesc
        qualificationAction
        qualificationAmount
        autoAdd
        background
        rewards {
          amount
          hurdle
          id
          targets
          type
        }
      }
      experienceContent {
        shareableLink
      }
    }
  }
`

/**
 * __useReferralDetailsWithAdvocateQuery__
 *
 * To run a query within a React component, call `useReferralDetailsWithAdvocateQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralDetailsWithAdvocateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralDetailsWithAdvocateQuery({
 *   variables: {
 *   },
 * });
 */
export function useReferralDetailsWithAdvocateQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ReferralDetailsWithAdvocateQuery,
    ReferralDetailsWithAdvocateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ReferralDetailsWithAdvocateQuery,
    ReferralDetailsWithAdvocateQueryVariables
  >(ReferralDetailsWithAdvocateDocument, options)
}
export function useReferralDetailsWithAdvocateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ReferralDetailsWithAdvocateQuery,
    ReferralDetailsWithAdvocateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ReferralDetailsWithAdvocateQuery,
    ReferralDetailsWithAdvocateQueryVariables
  >(ReferralDetailsWithAdvocateDocument, options)
}
export type ReferralDetailsWithAdvocateQueryHookResult = ReturnType<
  typeof useReferralDetailsWithAdvocateQuery
>
export type ReferralDetailsWithAdvocateLazyQueryHookResult = ReturnType<
  typeof useReferralDetailsWithAdvocateLazyQuery
>
export type ReferralDetailsWithAdvocateQueryResult =
  ApolloReactCommon.QueryResult<
    ReferralDetailsWithAdvocateQuery,
    ReferralDetailsWithAdvocateQueryVariables
  >
export const CheckingAccountDisclosureDocument = /*#__PURE__*/ gql`
  query CheckingAccountDisclosure {
    __typename
    spendAccount {
      __typename
      bankCardOrder {
        __typename
        bankCardTier
      }
    }
  }
`

/**
 * __useCheckingAccountDisclosureQuery__
 *
 * To run a query within a React component, call `useCheckingAccountDisclosureQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckingAccountDisclosureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckingAccountDisclosureQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckingAccountDisclosureQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CheckingAccountDisclosureQuery,
    CheckingAccountDisclosureQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CheckingAccountDisclosureQuery,
    CheckingAccountDisclosureQueryVariables
  >(CheckingAccountDisclosureDocument, options)
}
export function useCheckingAccountDisclosureLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CheckingAccountDisclosureQuery,
    CheckingAccountDisclosureQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CheckingAccountDisclosureQuery,
    CheckingAccountDisclosureQueryVariables
  >(CheckingAccountDisclosureDocument, options)
}
export type CheckingAccountDisclosureQueryHookResult = ReturnType<
  typeof useCheckingAccountDisclosureQuery
>
export type CheckingAccountDisclosureLazyQueryHookResult = ReturnType<
  typeof useCheckingAccountDisclosureLazyQuery
>
export type CheckingAccountDisclosureQueryResult =
  ApolloReactCommon.QueryResult<
    CheckingAccountDisclosureQuery,
    CheckingAccountDisclosureQueryVariables
  >
export const UserEmailDocument = /*#__PURE__*/ gql`
  query UserEmail {
    user {
      email
    }
  }
`

/**
 * __useUserEmailQuery__
 *
 * To run a query within a React component, call `useUserEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEmailQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserEmailQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserEmailQuery,
    UserEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<UserEmailQuery, UserEmailQueryVariables>(
    UserEmailDocument,
    options,
  )
}
export function useUserEmailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserEmailQuery,
    UserEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<UserEmailQuery, UserEmailQueryVariables>(
    UserEmailDocument,
    options,
  )
}
export type UserEmailQueryHookResult = ReturnType<typeof useUserEmailQuery>
export type UserEmailLazyQueryHookResult = ReturnType<
  typeof useUserEmailLazyQuery
>
export type UserEmailQueryResult = ApolloReactCommon.QueryResult<
  UserEmailQuery,
  UserEmailQueryVariables
>
export const UpgradeLanderTierSubscriptionQueryDocument = /*#__PURE__*/ gql`
  query UpgradeLanderTierSubscriptionQuery {
    userStatus {
      age
    }
    tierSubscriptionByUserId {
      __typename
      id
      tier {
        __typename
        id
        displayName
        name
        products {
          __typename
          key
          active
          name
          createdAt
          description
          descriptionKeys
          id
          updatedAt
        }
        matchProgram(investmentAccountType: ROTH_IRA) {
          matchPercentage
        }
      }
      tierPrice {
        __typename
        id
        amount {
          value
        }
        billingFrequency
      }
    }
    tierGroupForUser {
      __typename
      tierOptions {
        __typename
        tier {
          __typename
          id
          assetPath
          key
          name
          displayName
          description
          tierPrice {
            __typename
            id
            amount {
              value
            }
            billingFrequency
          }
          products {
            __typename
            key
            active
            name
            createdAt
            description
            descriptionKeys
            id
            updatedAt
          }
          matchProgram(investmentAccountType: ROTH_IRA) {
            matchPercentage
          }
        }
      }
    }
  }
`

/**
 * __useUpgradeLanderTierSubscriptionQueryQuery__
 *
 * To run a query within a React component, call `useUpgradeLanderTierSubscriptionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpgradeLanderTierSubscriptionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpgradeLanderTierSubscriptionQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpgradeLanderTierSubscriptionQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UpgradeLanderTierSubscriptionQueryQuery,
    UpgradeLanderTierSubscriptionQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    UpgradeLanderTierSubscriptionQueryQuery,
    UpgradeLanderTierSubscriptionQueryQueryVariables
  >(UpgradeLanderTierSubscriptionQueryDocument, options)
}
export function useUpgradeLanderTierSubscriptionQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UpgradeLanderTierSubscriptionQueryQuery,
    UpgradeLanderTierSubscriptionQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    UpgradeLanderTierSubscriptionQueryQuery,
    UpgradeLanderTierSubscriptionQueryQueryVariables
  >(UpgradeLanderTierSubscriptionQueryDocument, options)
}
export type UpgradeLanderTierSubscriptionQueryQueryHookResult = ReturnType<
  typeof useUpgradeLanderTierSubscriptionQueryQuery
>
export type UpgradeLanderTierSubscriptionQueryLazyQueryHookResult = ReturnType<
  typeof useUpgradeLanderTierSubscriptionQueryLazyQuery
>
export type UpgradeLanderTierSubscriptionQueryQueryResult =
  ApolloReactCommon.QueryResult<
    UpgradeLanderTierSubscriptionQueryQuery,
    UpgradeLanderTierSubscriptionQueryQueryVariables
  >
export const LogoutDocument = /*#__PURE__*/ gql`
  mutation Logout {
    logout {
      __typename
    }
  }
`
export type LogoutMutationFn = ApolloReactCommon.MutationFunction<
  LogoutMutation,
  LogoutMutationVariables
>

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    LogoutMutation,
    LogoutMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<LogoutMutation, LogoutMutationVariables>(
    LogoutDocument,
    options,
  )
}
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>
export type LogoutMutationResult =
  ApolloReactCommon.MutationResult<LogoutMutation>
export type LogoutMutationOptions = ApolloReactCommon.BaseMutationOptions<
  LogoutMutation,
  LogoutMutationVariables
>
export const RefreshAuthTokensDocument = /*#__PURE__*/ gql`
  mutation RefreshAuthTokens($refreshToken: String!) {
    refreshAuthToken(input: { refreshToken: $refreshToken }) {
      ... on AuthSession {
        token
        refreshToken
      }
    }
  }
`
export type RefreshAuthTokensMutationFn = ApolloReactCommon.MutationFunction<
  RefreshAuthTokensMutation,
  RefreshAuthTokensMutationVariables
>

/**
 * __useRefreshAuthTokensMutation__
 *
 * To run a mutation, you first call `useRefreshAuthTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshAuthTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshAuthTokensMutation, { data, loading, error }] = useRefreshAuthTokensMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshAuthTokensMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RefreshAuthTokensMutation,
    RefreshAuthTokensMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RefreshAuthTokensMutation,
    RefreshAuthTokensMutationVariables
  >(RefreshAuthTokensDocument, options)
}
export type RefreshAuthTokensMutationHookResult = ReturnType<
  typeof useRefreshAuthTokensMutation
>
export type RefreshAuthTokensMutationResult =
  ApolloReactCommon.MutationResult<RefreshAuthTokensMutation>
export type RefreshAuthTokensMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RefreshAuthTokensMutation,
    RefreshAuthTokensMutationVariables
  >
export const UpdateOptOutOfTargetingDocument = /*#__PURE__*/ gql`
  mutation UpdateOptOutOfTargeting($optOutPreference: Boolean!) {
    updateOptOutOfTargeting(input: { optedOutOfTargeting: $optOutPreference }) {
      optedOutOfTargeting
    }
  }
`
export type UpdateOptOutOfTargetingMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdateOptOutOfTargetingMutation,
    UpdateOptOutOfTargetingMutationVariables
  >

/**
 * __useUpdateOptOutOfTargetingMutation__
 *
 * To run a mutation, you first call `useUpdateOptOutOfTargetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOptOutOfTargetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOptOutOfTargetingMutation, { data, loading, error }] = useUpdateOptOutOfTargetingMutation({
 *   variables: {
 *      optOutPreference: // value for 'optOutPreference'
 *   },
 * });
 */
export function useUpdateOptOutOfTargetingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateOptOutOfTargetingMutation,
    UpdateOptOutOfTargetingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateOptOutOfTargetingMutation,
    UpdateOptOutOfTargetingMutationVariables
  >(UpdateOptOutOfTargetingDocument, options)
}
export type UpdateOptOutOfTargetingMutationHookResult = ReturnType<
  typeof useUpdateOptOutOfTargetingMutation
>
export type UpdateOptOutOfTargetingMutationResult =
  ApolloReactCommon.MutationResult<UpdateOptOutOfTargetingMutation>
export type UpdateOptOutOfTargetingMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateOptOutOfTargetingMutation,
    UpdateOptOutOfTargetingMutationVariables
  >
export const BankInterestRatesDocument = /*#__PURE__*/ gql`
  query BankInterestRates($productFilter: [BankingProduct]) {
    bankInterestRates(productFilter: $productFilter) {
      __typename
      ... on BankInterestRates {
        __typename
        bankInterestRates {
          __typename
          currentApy
          liveDate
          productName
        }
      }
      ... on BankServiceFailure {
        __typename
        reason
        retryable
      }
    }
  }
`

/**
 * __useBankInterestRatesQuery__
 *
 * To run a query within a React component, call `useBankInterestRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankInterestRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankInterestRatesQuery({
 *   variables: {
 *      productFilter: // value for 'productFilter'
 *   },
 * });
 */
export function useBankInterestRatesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    BankInterestRatesQuery,
    BankInterestRatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    BankInterestRatesQuery,
    BankInterestRatesQueryVariables
  >(BankInterestRatesDocument, options)
}
export function useBankInterestRatesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BankInterestRatesQuery,
    BankInterestRatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    BankInterestRatesQuery,
    BankInterestRatesQueryVariables
  >(BankInterestRatesDocument, options)
}
export type BankInterestRatesQueryHookResult = ReturnType<
  typeof useBankInterestRatesQuery
>
export type BankInterestRatesLazyQueryHookResult = ReturnType<
  typeof useBankInterestRatesLazyQuery
>
export type BankInterestRatesQueryResult = ApolloReactCommon.QueryResult<
  BankInterestRatesQuery,
  BankInterestRatesQueryVariables
>
export const BeneficiaryRecapDocument = /*#__PURE__*/ gql`
  query BeneficiaryRecap($id: ID!) {
    beneficiary(id: $id) {
      ...EarlyBeneficiaryRecapFields
    }
  }
  ${EarlyBeneficiaryRecapFieldsFragmentDoc}
`

/**
 * __useBeneficiaryRecapQuery__
 *
 * To run a query within a React component, call `useBeneficiaryRecapQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeneficiaryRecapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeneficiaryRecapQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBeneficiaryRecapQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    BeneficiaryRecapQuery,
    BeneficiaryRecapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    BeneficiaryRecapQuery,
    BeneficiaryRecapQueryVariables
  >(BeneficiaryRecapDocument, options)
}
export function useBeneficiaryRecapLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BeneficiaryRecapQuery,
    BeneficiaryRecapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    BeneficiaryRecapQuery,
    BeneficiaryRecapQueryVariables
  >(BeneficiaryRecapDocument, options)
}
export type BeneficiaryRecapQueryHookResult = ReturnType<
  typeof useBeneficiaryRecapQuery
>
export type BeneficiaryRecapLazyQueryHookResult = ReturnType<
  typeof useBeneficiaryRecapLazyQuery
>
export type BeneficiaryRecapQueryResult = ApolloReactCommon.QueryResult<
  BeneficiaryRecapQuery,
  BeneficiaryRecapQueryVariables
>
export const OptOutOfTargetingDocument = /*#__PURE__*/ gql`
  query optOutOfTargeting {
    profile {
      optedOutOfTargeting
    }
  }
`

/**
 * __useOptOutOfTargetingQuery__
 *
 * To run a query within a React component, call `useOptOutOfTargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptOutOfTargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptOutOfTargetingQuery({
 *   variables: {
 *   },
 * });
 */
export function useOptOutOfTargetingQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    OptOutOfTargetingQuery,
    OptOutOfTargetingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    OptOutOfTargetingQuery,
    OptOutOfTargetingQueryVariables
  >(OptOutOfTargetingDocument, options)
}
export function useOptOutOfTargetingLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    OptOutOfTargetingQuery,
    OptOutOfTargetingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    OptOutOfTargetingQuery,
    OptOutOfTargetingQueryVariables
  >(OptOutOfTargetingDocument, options)
}
export type OptOutOfTargetingQueryHookResult = ReturnType<
  typeof useOptOutOfTargetingQuery
>
export type OptOutOfTargetingLazyQueryHookResult = ReturnType<
  typeof useOptOutOfTargetingLazyQuery
>
export type OptOutOfTargetingQueryResult = ApolloReactCommon.QueryResult<
  OptOutOfTargetingQuery,
  OptOutOfTargetingQueryVariables
>
export const FundingSourceAccountsStateDocument = /*#__PURE__*/ gql`
  query FundingSourceAccountsState {
    fundingSourceAccounts {
      role
    }
    settings {
      depositsSuspended
    }
  }
`

/**
 * __useFundingSourceAccountsStateQuery__
 *
 * To run a query within a React component, call `useFundingSourceAccountsStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundingSourceAccountsStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundingSourceAccountsStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useFundingSourceAccountsStateQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FundingSourceAccountsStateQuery,
    FundingSourceAccountsStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FundingSourceAccountsStateQuery,
    FundingSourceAccountsStateQueryVariables
  >(FundingSourceAccountsStateDocument, options)
}
export function useFundingSourceAccountsStateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FundingSourceAccountsStateQuery,
    FundingSourceAccountsStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FundingSourceAccountsStateQuery,
    FundingSourceAccountsStateQueryVariables
  >(FundingSourceAccountsStateDocument, options)
}
export type FundingSourceAccountsStateQueryHookResult = ReturnType<
  typeof useFundingSourceAccountsStateQuery
>
export type FundingSourceAccountsStateLazyQueryHookResult = ReturnType<
  typeof useFundingSourceAccountsStateLazyQuery
>
export type FundingSourceAccountsStateQueryResult =
  ApolloReactCommon.QueryResult<
    FundingSourceAccountsStateQuery,
    FundingSourceAccountsStateQueryVariables
  >
export const OnboardingRequirementsDocument = /*#__PURE__*/ gql`
  query OnboardingRequirements($onboardingType: OnboardingType!) {
    onboardingRequirements(onboardingType: $onboardingType)
  }
`

/**
 * __useOnboardingRequirementsQuery__
 *
 * To run a query within a React component, call `useOnboardingRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingRequirementsQuery({
 *   variables: {
 *      onboardingType: // value for 'onboardingType'
 *   },
 * });
 */
export function useOnboardingRequirementsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    OnboardingRequirementsQuery,
    OnboardingRequirementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    OnboardingRequirementsQuery,
    OnboardingRequirementsQueryVariables
  >(OnboardingRequirementsDocument, options)
}
export function useOnboardingRequirementsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    OnboardingRequirementsQuery,
    OnboardingRequirementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    OnboardingRequirementsQuery,
    OnboardingRequirementsQueryVariables
  >(OnboardingRequirementsDocument, options)
}
export type OnboardingRequirementsQueryHookResult = ReturnType<
  typeof useOnboardingRequirementsQuery
>
export type OnboardingRequirementsLazyQueryHookResult = ReturnType<
  typeof useOnboardingRequirementsLazyQuery
>
export type OnboardingRequirementsQueryResult = ApolloReactCommon.QueryResult<
  OnboardingRequirementsQuery,
  OnboardingRequirementsQueryVariables
>
export const TierSubscriptionByUserIdDocument = /*#__PURE__*/ gql`
  query TierSubscriptionByUserId {
    tierSubscriptionByUserId {
      id
      tier {
        id
        key
        displayName
        name
        products {
          key
          active
          name
        }
      }
      tierPrice {
        id
        amount {
          value
        }
        billingFrequency
      }
    }
    tierGroupForUser {
      id
      preferredTierId
      tierOptions {
        preferredTierPrice {
          amount {
            value
          }
          billingFrequency
        }
        tier {
          id
          assetPath
          key
          name
          displayName
          description
          tierPrice {
            id
            amount {
              value
            }
          }
          products {
            key
          }
        }
      }
    }
  }
`

/**
 * __useTierSubscriptionByUserIdQuery__
 *
 * To run a query within a React component, call `useTierSubscriptionByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTierSubscriptionByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTierSubscriptionByUserIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useTierSubscriptionByUserIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    TierSubscriptionByUserIdQuery,
    TierSubscriptionByUserIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    TierSubscriptionByUserIdQuery,
    TierSubscriptionByUserIdQueryVariables
  >(TierSubscriptionByUserIdDocument, options)
}
export function useTierSubscriptionByUserIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TierSubscriptionByUserIdQuery,
    TierSubscriptionByUserIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    TierSubscriptionByUserIdQuery,
    TierSubscriptionByUserIdQueryVariables
  >(TierSubscriptionByUserIdDocument, options)
}
export type TierSubscriptionByUserIdQueryHookResult = ReturnType<
  typeof useTierSubscriptionByUserIdQuery
>
export type TierSubscriptionByUserIdLazyQueryHookResult = ReturnType<
  typeof useTierSubscriptionByUserIdLazyQuery
>
export type TierSubscriptionByUserIdQueryResult = ApolloReactCommon.QueryResult<
  TierSubscriptionByUserIdQuery,
  TierSubscriptionByUserIdQueryVariables
>
export const UpdateRecurringInvestmentDocument = /*#__PURE__*/ gql`
  mutation UpdateRecurringInvestment(
    $amount: Float!
    $day: Int!
    $frequency: InvestmentFrequency!
    $investment_account_id: String!
  ) {
    updateRecurringInvestment(
      input: {
        amount: $amount
        day: $day
        frequency: $frequency
        investmentAccountId: $investment_account_id
      }
    ) {
      recurringInvestmentSettings {
        amount
        day
        frequency
      }
    }
  }
`
export type UpdateRecurringInvestmentMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdateRecurringInvestmentMutation,
    UpdateRecurringInvestmentMutationVariables
  >

/**
 * __useUpdateRecurringInvestmentMutation__
 *
 * To run a mutation, you first call `useUpdateRecurringInvestmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecurringInvestmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecurringInvestmentMutation, { data, loading, error }] = useUpdateRecurringInvestmentMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      day: // value for 'day'
 *      frequency: // value for 'frequency'
 *      investment_account_id: // value for 'investment_account_id'
 *   },
 * });
 */
export function useUpdateRecurringInvestmentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateRecurringInvestmentMutation,
    UpdateRecurringInvestmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateRecurringInvestmentMutation,
    UpdateRecurringInvestmentMutationVariables
  >(UpdateRecurringInvestmentDocument, options)
}
export type UpdateRecurringInvestmentMutationHookResult = ReturnType<
  typeof useUpdateRecurringInvestmentMutation
>
export type UpdateRecurringInvestmentMutationResult =
  ApolloReactCommon.MutationResult<UpdateRecurringInvestmentMutation>
export type UpdateRecurringInvestmentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateRecurringInvestmentMutation,
    UpdateRecurringInvestmentMutationVariables
  >
export const TierGroupForUserDocument = /*#__PURE__*/ gql`
  query TierGroupForUser {
    tierGroupForUser {
      id
      preferredTierId
      tierOptions {
        preferredTierPrice {
          amount {
            value
          }
          billingFrequency
        }
        tier {
          id
          assetPath
          key
          name
          displayName
          description
          tierPrice {
            id
            amount {
              value
            }
          }
          products {
            key
          }
          bundles {
            name
            iconPath
            products {
              descriptionKeys
              product {
                key
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useTierGroupForUserQuery__
 *
 * To run a query within a React component, call `useTierGroupForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useTierGroupForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTierGroupForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useTierGroupForUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    TierGroupForUserQuery,
    TierGroupForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    TierGroupForUserQuery,
    TierGroupForUserQueryVariables
  >(TierGroupForUserDocument, options)
}
export function useTierGroupForUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TierGroupForUserQuery,
    TierGroupForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    TierGroupForUserQuery,
    TierGroupForUserQueryVariables
  >(TierGroupForUserDocument, options)
}
export type TierGroupForUserQueryHookResult = ReturnType<
  typeof useTierGroupForUserQuery
>
export type TierGroupForUserLazyQueryHookResult = ReturnType<
  typeof useTierGroupForUserLazyQuery
>
export type TierGroupForUserQueryResult = ApolloReactCommon.QueryResult<
  TierGroupForUserQuery,
  TierGroupForUserQueryVariables
>
export const AgreeToSingleAcceptanceDocumentDocument = /*#__PURE__*/ gql`
  mutation AgreeToSingleAcceptanceDocument($id: ID!) {
    agreeToAcceptanceDocument(id: $id)
  }
`
export type AgreeToSingleAcceptanceDocumentMutationFn =
  ApolloReactCommon.MutationFunction<
    AgreeToSingleAcceptanceDocumentMutation,
    AgreeToSingleAcceptanceDocumentMutationVariables
  >

/**
 * __useAgreeToSingleAcceptanceDocumentMutation__
 *
 * To run a mutation, you first call `useAgreeToSingleAcceptanceDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgreeToSingleAcceptanceDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agreeToSingleAcceptanceDocumentMutation, { data, loading, error }] = useAgreeToSingleAcceptanceDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgreeToSingleAcceptanceDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AgreeToSingleAcceptanceDocumentMutation,
    AgreeToSingleAcceptanceDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AgreeToSingleAcceptanceDocumentMutation,
    AgreeToSingleAcceptanceDocumentMutationVariables
  >(AgreeToSingleAcceptanceDocumentDocument, options)
}
export type AgreeToSingleAcceptanceDocumentMutationHookResult = ReturnType<
  typeof useAgreeToSingleAcceptanceDocumentMutation
>
export type AgreeToSingleAcceptanceDocumentMutationResult =
  ApolloReactCommon.MutationResult<AgreeToSingleAcceptanceDocumentMutation>
export type AgreeToSingleAcceptanceDocumentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AgreeToSingleAcceptanceDocumentMutation,
    AgreeToSingleAcceptanceDocumentMutationVariables
  >
export const AllPastSpendSummaryDocument = /*#__PURE__*/ gql`
  query AllPastSpendSummary {
    pastSpendSummary {
      debitsLast30Days {
        currency
        value
      }
      depositsLast30Days {
        currency
        value
      }
      availableBalance {
        currency
        value
      }
    }
  }
`

/**
 * __useAllPastSpendSummaryQuery__
 *
 * To run a query within a React component, call `useAllPastSpendSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPastSpendSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPastSpendSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPastSpendSummaryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AllPastSpendSummaryQuery,
    AllPastSpendSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AllPastSpendSummaryQuery,
    AllPastSpendSummaryQueryVariables
  >(AllPastSpendSummaryDocument, options)
}
export function useAllPastSpendSummaryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AllPastSpendSummaryQuery,
    AllPastSpendSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AllPastSpendSummaryQuery,
    AllPastSpendSummaryQueryVariables
  >(AllPastSpendSummaryDocument, options)
}
export type AllPastSpendSummaryQueryHookResult = ReturnType<
  typeof useAllPastSpendSummaryQuery
>
export type AllPastSpendSummaryLazyQueryHookResult = ReturnType<
  typeof useAllPastSpendSummaryLazyQuery
>
export type AllPastSpendSummaryQueryResult = ApolloReactCommon.QueryResult<
  AllPastSpendSummaryQuery,
  AllPastSpendSummaryQueryVariables
>
export const BankingHubDocument = /*#__PURE__*/ gql`
  query BankingHub {
    pastSpendSummary {
      debitsLast30Days {
        currency
        value
      }
      depositsLast30Days {
        currency
        value
      }
      availableBalance {
        currency
        value
      }
    }
    allBankAccounts(input: { types: [spend, save] }) {
      type
      availableBalance {
        value
      }
      goals {
        currentGoal {
          type
        }
      }
      currentBalance {
        currency
        value
      }
    }
    bankCardOrder {
      fundingInitiated
      requestVersion
      kycStatus
      bankCardTier
    }
    spendAccount {
      status
      isReopenable
    }
  }
`

/**
 * __useBankingHubQuery__
 *
 * To run a query within a React component, call `useBankingHubQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankingHubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankingHubQuery({
 *   variables: {
 *   },
 * });
 */
export function useBankingHubQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    BankingHubQuery,
    BankingHubQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<BankingHubQuery, BankingHubQueryVariables>(
    BankingHubDocument,
    options,
  )
}
export function useBankingHubLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BankingHubQuery,
    BankingHubQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    BankingHubQuery,
    BankingHubQueryVariables
  >(BankingHubDocument, options)
}
export type BankingHubQueryHookResult = ReturnType<typeof useBankingHubQuery>
export type BankingHubLazyQueryHookResult = ReturnType<
  typeof useBankingHubLazyQuery
>
export type BankingHubQueryResult = ApolloReactCommon.QueryResult<
  BankingHubQuery,
  BankingHubQueryVariables
>
export const BenefitsHubAgreeToAcceptanceDocumentDocument = /*#__PURE__*/ gql`
  mutation BenefitsHubAgreeToAcceptanceDocument($id: ID!) {
    agreeToAcceptanceDocument(id: $id)
  }
`
export type BenefitsHubAgreeToAcceptanceDocumentMutationFn =
  ApolloReactCommon.MutationFunction<
    BenefitsHubAgreeToAcceptanceDocumentMutation,
    BenefitsHubAgreeToAcceptanceDocumentMutationVariables
  >

/**
 * __useBenefitsHubAgreeToAcceptanceDocumentMutation__
 *
 * To run a mutation, you first call `useBenefitsHubAgreeToAcceptanceDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBenefitsHubAgreeToAcceptanceDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [benefitsHubAgreeToAcceptanceDocumentMutation, { data, loading, error }] = useBenefitsHubAgreeToAcceptanceDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBenefitsHubAgreeToAcceptanceDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    BenefitsHubAgreeToAcceptanceDocumentMutation,
    BenefitsHubAgreeToAcceptanceDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    BenefitsHubAgreeToAcceptanceDocumentMutation,
    BenefitsHubAgreeToAcceptanceDocumentMutationVariables
  >(BenefitsHubAgreeToAcceptanceDocumentDocument, options)
}
export type BenefitsHubAgreeToAcceptanceDocumentMutationHookResult = ReturnType<
  typeof useBenefitsHubAgreeToAcceptanceDocumentMutation
>
export type BenefitsHubAgreeToAcceptanceDocumentMutationResult =
  ApolloReactCommon.MutationResult<BenefitsHubAgreeToAcceptanceDocumentMutation>
export type BenefitsHubAgreeToAcceptanceDocumentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    BenefitsHubAgreeToAcceptanceDocumentMutation,
    BenefitsHubAgreeToAcceptanceDocumentMutationVariables
  >
export const BenefitsHubAvailableTiersDocument = /*#__PURE__*/ gql`
  query BenefitsHubAvailableTiers {
    tierGroupForUser {
      id
      tierOptions {
        tier {
          id
          active
          key
          name
          products {
            active
            key
            name
          }
          tierPrice {
            amount {
              value
            }
            billingFrequency
            id
          }
        }
      }
    }
  }
`

/**
 * __useBenefitsHubAvailableTiersQuery__
 *
 * To run a query within a React component, call `useBenefitsHubAvailableTiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenefitsHubAvailableTiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenefitsHubAvailableTiersQuery({
 *   variables: {
 *   },
 * });
 */
export function useBenefitsHubAvailableTiersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    BenefitsHubAvailableTiersQuery,
    BenefitsHubAvailableTiersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    BenefitsHubAvailableTiersQuery,
    BenefitsHubAvailableTiersQueryVariables
  >(BenefitsHubAvailableTiersDocument, options)
}
export function useBenefitsHubAvailableTiersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BenefitsHubAvailableTiersQuery,
    BenefitsHubAvailableTiersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    BenefitsHubAvailableTiersQuery,
    BenefitsHubAvailableTiersQueryVariables
  >(BenefitsHubAvailableTiersDocument, options)
}
export type BenefitsHubAvailableTiersQueryHookResult = ReturnType<
  typeof useBenefitsHubAvailableTiersQuery
>
export type BenefitsHubAvailableTiersLazyQueryHookResult = ReturnType<
  typeof useBenefitsHubAvailableTiersLazyQuery
>
export type BenefitsHubAvailableTiersQueryResult =
  ApolloReactCommon.QueryResult<
    BenefitsHubAvailableTiersQuery,
    BenefitsHubAvailableTiersQueryVariables
  >
export const BenefitsHubCustomAllocationPercentageDocument = /*#__PURE__*/ gql`
  query BenefitsHubCustomAllocationPercentage($product: InvestmentProduct) {
    investmentAccountsByUserId(filter: { product: $product }) {
      portfolio {
        minimumManagedAllocationPercent
      }
    }
  }
`

/**
 * __useBenefitsHubCustomAllocationPercentageQuery__
 *
 * To run a query within a React component, call `useBenefitsHubCustomAllocationPercentageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenefitsHubCustomAllocationPercentageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenefitsHubCustomAllocationPercentageQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useBenefitsHubCustomAllocationPercentageQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    BenefitsHubCustomAllocationPercentageQuery,
    BenefitsHubCustomAllocationPercentageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    BenefitsHubCustomAllocationPercentageQuery,
    BenefitsHubCustomAllocationPercentageQueryVariables
  >(BenefitsHubCustomAllocationPercentageDocument, options)
}
export function useBenefitsHubCustomAllocationPercentageLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BenefitsHubCustomAllocationPercentageQuery,
    BenefitsHubCustomAllocationPercentageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    BenefitsHubCustomAllocationPercentageQuery,
    BenefitsHubCustomAllocationPercentageQueryVariables
  >(BenefitsHubCustomAllocationPercentageDocument, options)
}
export type BenefitsHubCustomAllocationPercentageQueryHookResult = ReturnType<
  typeof useBenefitsHubCustomAllocationPercentageQuery
>
export type BenefitsHubCustomAllocationPercentageLazyQueryHookResult =
  ReturnType<typeof useBenefitsHubCustomAllocationPercentageLazyQuery>
export type BenefitsHubCustomAllocationPercentageQueryResult =
  ApolloReactCommon.QueryResult<
    BenefitsHubCustomAllocationPercentageQuery,
    BenefitsHubCustomAllocationPercentageQueryVariables
  >
export const BenefitsHubOnboardingBenefitsDocument = /*#__PURE__*/ gql`
  query BenefitsHubOnboardingBenefits($product: OnboardingProducts!) {
    onboardingBenefits(input: { product: $product }) {
      products {
        product
        status
        claimDetails {
          claimStatus
          claimedOn
          expiresOn
          details {
            statusCode
            message
          }
        }
      }
    }
  }
`

/**
 * __useBenefitsHubOnboardingBenefitsQuery__
 *
 * To run a query within a React component, call `useBenefitsHubOnboardingBenefitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenefitsHubOnboardingBenefitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenefitsHubOnboardingBenefitsQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useBenefitsHubOnboardingBenefitsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    BenefitsHubOnboardingBenefitsQuery,
    BenefitsHubOnboardingBenefitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    BenefitsHubOnboardingBenefitsQuery,
    BenefitsHubOnboardingBenefitsQueryVariables
  >(BenefitsHubOnboardingBenefitsDocument, options)
}
export function useBenefitsHubOnboardingBenefitsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BenefitsHubOnboardingBenefitsQuery,
    BenefitsHubOnboardingBenefitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    BenefitsHubOnboardingBenefitsQuery,
    BenefitsHubOnboardingBenefitsQueryVariables
  >(BenefitsHubOnboardingBenefitsDocument, options)
}
export type BenefitsHubOnboardingBenefitsQueryHookResult = ReturnType<
  typeof useBenefitsHubOnboardingBenefitsQuery
>
export type BenefitsHubOnboardingBenefitsLazyQueryHookResult = ReturnType<
  typeof useBenefitsHubOnboardingBenefitsLazyQuery
>
export type BenefitsHubOnboardingBenefitsQueryResult =
  ApolloReactCommon.QueryResult<
    BenefitsHubOnboardingBenefitsQuery,
    BenefitsHubOnboardingBenefitsQueryVariables
  >
export const TaxFilingAddCohortEligibilityDocument = /*#__PURE__*/ gql`
  mutation TaxFilingAddCohortEligibility($cohort: String!) {
    addCohortEligibility(input: { add: [$cohort] }) {
      ... on UserCohorts {
        userId
        cohorts
      }
    }
  }
`
export type TaxFilingAddCohortEligibilityMutationFn =
  ApolloReactCommon.MutationFunction<
    TaxFilingAddCohortEligibilityMutation,
    TaxFilingAddCohortEligibilityMutationVariables
  >

/**
 * __useTaxFilingAddCohortEligibilityMutation__
 *
 * To run a mutation, you first call `useTaxFilingAddCohortEligibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaxFilingAddCohortEligibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taxFilingAddCohortEligibilityMutation, { data, loading, error }] = useTaxFilingAddCohortEligibilityMutation({
 *   variables: {
 *      cohort: // value for 'cohort'
 *   },
 * });
 */
export function useTaxFilingAddCohortEligibilityMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    TaxFilingAddCohortEligibilityMutation,
    TaxFilingAddCohortEligibilityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    TaxFilingAddCohortEligibilityMutation,
    TaxFilingAddCohortEligibilityMutationVariables
  >(TaxFilingAddCohortEligibilityDocument, options)
}
export type TaxFilingAddCohortEligibilityMutationHookResult = ReturnType<
  typeof useTaxFilingAddCohortEligibilityMutation
>
export type TaxFilingAddCohortEligibilityMutationResult =
  ApolloReactCommon.MutationResult<TaxFilingAddCohortEligibilityMutation>
export type TaxFilingAddCohortEligibilityMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    TaxFilingAddCohortEligibilityMutation,
    TaxFilingAddCohortEligibilityMutationVariables
  >
export const BenefitsHubTaxFilingPartnerByUserIdDocument = /*#__PURE__*/ gql`
  query BenefitsHubTaxFilingPartnerByUserId {
    benefitPartnerByUserId(input: { product: BENEFITS_TAXFILING_STANDARD }) {
      __typename
      ... on TaxFilingPartner {
        __typename
        taxAppStatus
        isDataConsentSigned
        netRefundAmountV2 {
          __typename
          currency
          value
        }
        federalReturn {
          __typename
          taxLocationCode
          returnStatus
          refundAmountV2 {
            __typename
            currency
            value
          }
        }
        isStateFiled
        stateReturns {
          __typename
          taxLocationCode
          returnStatus
          refundAmountV2 {
            __typename
            currency
            value
          }
        }
      }
    }
  }
`

/**
 * __useBenefitsHubTaxFilingPartnerByUserIdQuery__
 *
 * To run a query within a React component, call `useBenefitsHubTaxFilingPartnerByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenefitsHubTaxFilingPartnerByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenefitsHubTaxFilingPartnerByUserIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useBenefitsHubTaxFilingPartnerByUserIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    BenefitsHubTaxFilingPartnerByUserIdQuery,
    BenefitsHubTaxFilingPartnerByUserIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    BenefitsHubTaxFilingPartnerByUserIdQuery,
    BenefitsHubTaxFilingPartnerByUserIdQueryVariables
  >(BenefitsHubTaxFilingPartnerByUserIdDocument, options)
}
export function useBenefitsHubTaxFilingPartnerByUserIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BenefitsHubTaxFilingPartnerByUserIdQuery,
    BenefitsHubTaxFilingPartnerByUserIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    BenefitsHubTaxFilingPartnerByUserIdQuery,
    BenefitsHubTaxFilingPartnerByUserIdQueryVariables
  >(BenefitsHubTaxFilingPartnerByUserIdDocument, options)
}
export type BenefitsHubTaxFilingPartnerByUserIdQueryHookResult = ReturnType<
  typeof useBenefitsHubTaxFilingPartnerByUserIdQuery
>
export type BenefitsHubTaxFilingPartnerByUserIdLazyQueryHookResult = ReturnType<
  typeof useBenefitsHubTaxFilingPartnerByUserIdLazyQuery
>
export type BenefitsHubTaxFilingPartnerByUserIdQueryResult =
  ApolloReactCommon.QueryResult<
    BenefitsHubTaxFilingPartnerByUserIdQuery,
    BenefitsHubTaxFilingPartnerByUserIdQueryVariables
  >
export const BenefitsHubTaxFilingPartnerStatusDocument = /*#__PURE__*/ gql`
  query BenefitsHubTaxFilingPartnerStatus {
    getPartnerUrl(input: { product: BENEFITS_TAXFILING_STANDARD }) {
      __typename
      status
    }
  }
`

/**
 * __useBenefitsHubTaxFilingPartnerStatusQuery__
 *
 * To run a query within a React component, call `useBenefitsHubTaxFilingPartnerStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenefitsHubTaxFilingPartnerStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenefitsHubTaxFilingPartnerStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useBenefitsHubTaxFilingPartnerStatusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    BenefitsHubTaxFilingPartnerStatusQuery,
    BenefitsHubTaxFilingPartnerStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    BenefitsHubTaxFilingPartnerStatusQuery,
    BenefitsHubTaxFilingPartnerStatusQueryVariables
  >(BenefitsHubTaxFilingPartnerStatusDocument, options)
}
export function useBenefitsHubTaxFilingPartnerStatusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BenefitsHubTaxFilingPartnerStatusQuery,
    BenefitsHubTaxFilingPartnerStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    BenefitsHubTaxFilingPartnerStatusQuery,
    BenefitsHubTaxFilingPartnerStatusQueryVariables
  >(BenefitsHubTaxFilingPartnerStatusDocument, options)
}
export type BenefitsHubTaxFilingPartnerStatusQueryHookResult = ReturnType<
  typeof useBenefitsHubTaxFilingPartnerStatusQuery
>
export type BenefitsHubTaxFilingPartnerStatusLazyQueryHookResult = ReturnType<
  typeof useBenefitsHubTaxFilingPartnerStatusLazyQuery
>
export type BenefitsHubTaxFilingPartnerStatusQueryResult =
  ApolloReactCommon.QueryResult<
    BenefitsHubTaxFilingPartnerStatusQuery,
    BenefitsHubTaxFilingPartnerStatusQueryVariables
  >
export const BenefitsHubTaxFilingPartnerUrlDocument = /*#__PURE__*/ gql`
  query BenefitsHubTaxFilingPartnerUrl($shareCustomerData: Boolean!) {
    getPartnerUrl(
      input: {
        product: BENEFITS_TAXFILING_STANDARD
        shareCustomerData: $shareCustomerData
      }
    ) {
      __typename
      partnerUrl
    }
  }
`

/**
 * __useBenefitsHubTaxFilingPartnerUrlQuery__
 *
 * To run a query within a React component, call `useBenefitsHubTaxFilingPartnerUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenefitsHubTaxFilingPartnerUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenefitsHubTaxFilingPartnerUrlQuery({
 *   variables: {
 *      shareCustomerData: // value for 'shareCustomerData'
 *   },
 * });
 */
export function useBenefitsHubTaxFilingPartnerUrlQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    BenefitsHubTaxFilingPartnerUrlQuery,
    BenefitsHubTaxFilingPartnerUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    BenefitsHubTaxFilingPartnerUrlQuery,
    BenefitsHubTaxFilingPartnerUrlQueryVariables
  >(BenefitsHubTaxFilingPartnerUrlDocument, options)
}
export function useBenefitsHubTaxFilingPartnerUrlLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BenefitsHubTaxFilingPartnerUrlQuery,
    BenefitsHubTaxFilingPartnerUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    BenefitsHubTaxFilingPartnerUrlQuery,
    BenefitsHubTaxFilingPartnerUrlQueryVariables
  >(BenefitsHubTaxFilingPartnerUrlDocument, options)
}
export type BenefitsHubTaxFilingPartnerUrlQueryHookResult = ReturnType<
  typeof useBenefitsHubTaxFilingPartnerUrlQuery
>
export type BenefitsHubTaxFilingPartnerUrlLazyQueryHookResult = ReturnType<
  typeof useBenefitsHubTaxFilingPartnerUrlLazyQuery
>
export type BenefitsHubTaxFilingPartnerUrlQueryResult =
  ApolloReactCommon.QueryResult<
    BenefitsHubTaxFilingPartnerUrlQuery,
    BenefitsHubTaxFilingPartnerUrlQueryVariables
  >
export const RecordTaxRefundInvestmentDocument = /*#__PURE__*/ gql`
  mutation RecordTaxRefundInvestment($input: RecordTaxRefundInvestmentInput!) {
    recordTaxRefundInvestment(input: $input) {
      taxRefund {
        id
      }
    }
  }
`
export type RecordTaxRefundInvestmentMutationFn =
  ApolloReactCommon.MutationFunction<
    RecordTaxRefundInvestmentMutation,
    RecordTaxRefundInvestmentMutationVariables
  >

/**
 * __useRecordTaxRefundInvestmentMutation__
 *
 * To run a mutation, you first call `useRecordTaxRefundInvestmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordTaxRefundInvestmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordTaxRefundInvestmentMutation, { data, loading, error }] = useRecordTaxRefundInvestmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordTaxRefundInvestmentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RecordTaxRefundInvestmentMutation,
    RecordTaxRefundInvestmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RecordTaxRefundInvestmentMutation,
    RecordTaxRefundInvestmentMutationVariables
  >(RecordTaxRefundInvestmentDocument, options)
}
export type RecordTaxRefundInvestmentMutationHookResult = ReturnType<
  typeof useRecordTaxRefundInvestmentMutation
>
export type RecordTaxRefundInvestmentMutationResult =
  ApolloReactCommon.MutationResult<RecordTaxRefundInvestmentMutation>
export type RecordTaxRefundInvestmentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RecordTaxRefundInvestmentMutation,
    RecordTaxRefundInvestmentMutationVariables
  >
export const TaxFilingSubscribeUserToTierDocument = /*#__PURE__*/ gql`
  mutation TaxFilingSubscribeUserToTier($tierPriceId: ID!) {
    subscribeUserToTier(input: { createdBy: USER, tierPriceId: $tierPriceId }) {
      ... on TierSubscription {
        tier {
          name
          tierPrice {
            id
          }
        }
      }
      ... on InvalidTierPriceId {
        message
      }
      ... on TierDowngradeActionRequired {
        actions {
          key
        }
      }
    }
  }
`
export type TaxFilingSubscribeUserToTierMutationFn =
  ApolloReactCommon.MutationFunction<
    TaxFilingSubscribeUserToTierMutation,
    TaxFilingSubscribeUserToTierMutationVariables
  >

/**
 * __useTaxFilingSubscribeUserToTierMutation__
 *
 * To run a mutation, you first call `useTaxFilingSubscribeUserToTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaxFilingSubscribeUserToTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taxFilingSubscribeUserToTierMutation, { data, loading, error }] = useTaxFilingSubscribeUserToTierMutation({
 *   variables: {
 *      tierPriceId: // value for 'tierPriceId'
 *   },
 * });
 */
export function useTaxFilingSubscribeUserToTierMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    TaxFilingSubscribeUserToTierMutation,
    TaxFilingSubscribeUserToTierMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    TaxFilingSubscribeUserToTierMutation,
    TaxFilingSubscribeUserToTierMutationVariables
  >(TaxFilingSubscribeUserToTierDocument, options)
}
export type TaxFilingSubscribeUserToTierMutationHookResult = ReturnType<
  typeof useTaxFilingSubscribeUserToTierMutation
>
export type TaxFilingSubscribeUserToTierMutationResult =
  ApolloReactCommon.MutationResult<TaxFilingSubscribeUserToTierMutation>
export type TaxFilingSubscribeUserToTierMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    TaxFilingSubscribeUserToTierMutation,
    TaxFilingSubscribeUserToTierMutationVariables
  >
export const BenefitsHubTaxRefundsByUserIdDocument = /*#__PURE__*/ gql`
  query BenefitsHubTaxRefundsByUserId($filter: TaxRefundFilterInput) {
    taxRefundsByUserId(filter: $filter) {
      id
      refundType
      isInvested
      totalAmount {
        currency
        value
      }
    }
  }
`

/**
 * __useBenefitsHubTaxRefundsByUserIdQuery__
 *
 * To run a query within a React component, call `useBenefitsHubTaxRefundsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenefitsHubTaxRefundsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenefitsHubTaxRefundsByUserIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBenefitsHubTaxRefundsByUserIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    BenefitsHubTaxRefundsByUserIdQuery,
    BenefitsHubTaxRefundsByUserIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    BenefitsHubTaxRefundsByUserIdQuery,
    BenefitsHubTaxRefundsByUserIdQueryVariables
  >(BenefitsHubTaxRefundsByUserIdDocument, options)
}
export function useBenefitsHubTaxRefundsByUserIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BenefitsHubTaxRefundsByUserIdQuery,
    BenefitsHubTaxRefundsByUserIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    BenefitsHubTaxRefundsByUserIdQuery,
    BenefitsHubTaxRefundsByUserIdQueryVariables
  >(BenefitsHubTaxRefundsByUserIdDocument, options)
}
export type BenefitsHubTaxRefundsByUserIdQueryHookResult = ReturnType<
  typeof useBenefitsHubTaxRefundsByUserIdQuery
>
export type BenefitsHubTaxRefundsByUserIdLazyQueryHookResult = ReturnType<
  typeof useBenefitsHubTaxRefundsByUserIdLazyQuery
>
export type BenefitsHubTaxRefundsByUserIdQueryResult =
  ApolloReactCommon.QueryResult<
    BenefitsHubTaxRefundsByUserIdQuery,
    BenefitsHubTaxRefundsByUserIdQueryVariables
  >
export const BenefitsHubUserDocument = /*#__PURE__*/ gql`
  query BenefitsHubUser {
    user {
      verified
    }
  }
`

/**
 * __useBenefitsHubUserQuery__
 *
 * To run a query within a React component, call `useBenefitsHubUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenefitsHubUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenefitsHubUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useBenefitsHubUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    BenefitsHubUserQuery,
    BenefitsHubUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    BenefitsHubUserQuery,
    BenefitsHubUserQueryVariables
  >(BenefitsHubUserDocument, options)
}
export function useBenefitsHubUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BenefitsHubUserQuery,
    BenefitsHubUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    BenefitsHubUserQuery,
    BenefitsHubUserQueryVariables
  >(BenefitsHubUserDocument, options)
}
export type BenefitsHubUserQueryHookResult = ReturnType<
  typeof useBenefitsHubUserQuery
>
export type BenefitsHubUserLazyQueryHookResult = ReturnType<
  typeof useBenefitsHubUserLazyQuery
>
export type BenefitsHubUserQueryResult = ApolloReactCommon.QueryResult<
  BenefitsHubUserQuery,
  BenefitsHubUserQueryVariables
>
export const BenefitsHubUserTierDocument = /*#__PURE__*/ gql`
  query BenefitsHubUserTier {
    tierSubscriptionByUserId {
      id
      tier {
        key
        id
        name
        products {
          active
          key
          name
        }
      }
      tierPrice {
        id
        amount {
          value
        }
        billingFrequency
      }
    }
  }
`

/**
 * __useBenefitsHubUserTierQuery__
 *
 * To run a query within a React component, call `useBenefitsHubUserTierQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenefitsHubUserTierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenefitsHubUserTierQuery({
 *   variables: {
 *   },
 * });
 */
export function useBenefitsHubUserTierQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    BenefitsHubUserTierQuery,
    BenefitsHubUserTierQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    BenefitsHubUserTierQuery,
    BenefitsHubUserTierQueryVariables
  >(BenefitsHubUserTierDocument, options)
}
export function useBenefitsHubUserTierLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BenefitsHubUserTierQuery,
    BenefitsHubUserTierQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    BenefitsHubUserTierQuery,
    BenefitsHubUserTierQueryVariables
  >(BenefitsHubUserTierDocument, options)
}
export type BenefitsHubUserTierQueryHookResult = ReturnType<
  typeof useBenefitsHubUserTierQuery
>
export type BenefitsHubUserTierLazyQueryHookResult = ReturnType<
  typeof useBenefitsHubUserTierLazyQuery
>
export type BenefitsHubUserTierQueryResult = ApolloReactCommon.QueryResult<
  BenefitsHubUserTierQuery,
  BenefitsHubUserTierQueryVariables
>
export const BenefitsPartnerStatusDocument = /*#__PURE__*/ gql`
  mutation BenefitsPartnerStatus($input: PartnerStatusInput!) {
    setUserPartnerStatus(input: $input) {
      ... on UserPartnerStatusResponse {
        message
      }
    }
  }
`
export type BenefitsPartnerStatusMutationFn =
  ApolloReactCommon.MutationFunction<
    BenefitsPartnerStatusMutation,
    BenefitsPartnerStatusMutationVariables
  >

/**
 * __useBenefitsPartnerStatusMutation__
 *
 * To run a mutation, you first call `useBenefitsPartnerStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBenefitsPartnerStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [benefitsPartnerStatusMutation, { data, loading, error }] = useBenefitsPartnerStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBenefitsPartnerStatusMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    BenefitsPartnerStatusMutation,
    BenefitsPartnerStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    BenefitsPartnerStatusMutation,
    BenefitsPartnerStatusMutationVariables
  >(BenefitsPartnerStatusDocument, options)
}
export type BenefitsPartnerStatusMutationHookResult = ReturnType<
  typeof useBenefitsPartnerStatusMutation
>
export type BenefitsPartnerStatusMutationResult =
  ApolloReactCommon.MutationResult<BenefitsPartnerStatusMutation>
export type BenefitsPartnerStatusMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    BenefitsPartnerStatusMutation,
    BenefitsPartnerStatusMutationVariables
  >
export const GetCohortEligibilityDocument = /*#__PURE__*/ gql`
  query GetCohortEligibility($cohorts: [String!]) {
    cohortEligibility_v2(filter: { cohorts: $cohorts }) {
      cohort
      eligible
    }
  }
`

/**
 * __useGetCohortEligibilityQuery__
 *
 * To run a query within a React component, call `useGetCohortEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCohortEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCohortEligibilityQuery({
 *   variables: {
 *      cohorts: // value for 'cohorts'
 *   },
 * });
 */
export function useGetCohortEligibilityQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetCohortEligibilityQuery,
    GetCohortEligibilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetCohortEligibilityQuery,
    GetCohortEligibilityQueryVariables
  >(GetCohortEligibilityDocument, options)
}
export function useGetCohortEligibilityLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetCohortEligibilityQuery,
    GetCohortEligibilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetCohortEligibilityQuery,
    GetCohortEligibilityQueryVariables
  >(GetCohortEligibilityDocument, options)
}
export type GetCohortEligibilityQueryHookResult = ReturnType<
  typeof useGetCohortEligibilityQuery
>
export type GetCohortEligibilityLazyQueryHookResult = ReturnType<
  typeof useGetCohortEligibilityLazyQuery
>
export type GetCohortEligibilityQueryResult = ApolloReactCommon.QueryResult<
  GetCohortEligibilityQuery,
  GetCohortEligibilityQueryVariables
>
export const GetPartnerUrlDocument = /*#__PURE__*/ gql`
  query GetPartnerUrl($input: PartnerUrlInput!) {
    getPartnerUrl(input: $input) {
      partnerUrl
      status
    }
  }
`

/**
 * __useGetPartnerUrlQuery__
 *
 * To run a query within a React component, call `useGetPartnerUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPartnerUrlQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetPartnerUrlQuery,
    GetPartnerUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetPartnerUrlQuery,
    GetPartnerUrlQueryVariables
  >(GetPartnerUrlDocument, options)
}
export function useGetPartnerUrlLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPartnerUrlQuery,
    GetPartnerUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetPartnerUrlQuery,
    GetPartnerUrlQueryVariables
  >(GetPartnerUrlDocument, options)
}
export type GetPartnerUrlQueryHookResult = ReturnType<
  typeof useGetPartnerUrlQuery
>
export type GetPartnerUrlLazyQueryHookResult = ReturnType<
  typeof useGetPartnerUrlLazyQuery
>
export type GetPartnerUrlQueryResult = ApolloReactCommon.QueryResult<
  GetPartnerUrlQuery,
  GetPartnerUrlQueryVariables
>
export const ListBenefitsDocument = /*#__PURE__*/ gql`
  query ListBenefits {
    listBenefitsByUserId {
      __typename
      groupName
      products {
        __typename
        product
        status
      }
    }
  }
`

/**
 * __useListBenefitsQuery__
 *
 * To run a query within a React component, call `useListBenefitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBenefitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBenefitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListBenefitsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ListBenefitsQuery,
    ListBenefitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ListBenefitsQuery,
    ListBenefitsQueryVariables
  >(ListBenefitsDocument, options)
}
export function useListBenefitsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ListBenefitsQuery,
    ListBenefitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ListBenefitsQuery,
    ListBenefitsQueryVariables
  >(ListBenefitsDocument, options)
}
export type ListBenefitsQueryHookResult = ReturnType<
  typeof useListBenefitsQuery
>
export type ListBenefitsLazyQueryHookResult = ReturnType<
  typeof useListBenefitsLazyQuery
>
export type ListBenefitsQueryResult = ApolloReactCommon.QueryResult<
  ListBenefitsQuery,
  ListBenefitsQueryVariables
>
export const PartnerDataShareDocument = /*#__PURE__*/ gql`
  mutation PartnerDataShare($product: BenefitsProduct!) {
    initiatePartnerDataShare(input: { product: $product }) {
      ... on PartnerDataShare {
        userId
        partner
      }
      ... on ProductNotSupportedException {
        __typename
        message
      }
    }
  }
`
export type PartnerDataShareMutationFn = ApolloReactCommon.MutationFunction<
  PartnerDataShareMutation,
  PartnerDataShareMutationVariables
>

/**
 * __usePartnerDataShareMutation__
 *
 * To run a mutation, you first call `usePartnerDataShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDataShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDataShareMutation, { data, loading, error }] = usePartnerDataShareMutation({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function usePartnerDataShareMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    PartnerDataShareMutation,
    PartnerDataShareMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    PartnerDataShareMutation,
    PartnerDataShareMutationVariables
  >(PartnerDataShareDocument, options)
}
export type PartnerDataShareMutationHookResult = ReturnType<
  typeof usePartnerDataShareMutation
>
export type PartnerDataShareMutationResult =
  ApolloReactCommon.MutationResult<PartnerDataShareMutation>
export type PartnerDataShareMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    PartnerDataShareMutation,
    PartnerDataShareMutationVariables
  >
export const RequireForAllAcceptanceDocumentsDocument = /*#__PURE__*/ gql`
  query RequireForAllAcceptanceDocuments($requiredFor: String) {
    allAcceptanceDocuments(requiredFor: $requiredFor) {
      id
      name
      type
      url
      summaryUrl
    }
  }
`

/**
 * __useRequireForAllAcceptanceDocumentsQuery__
 *
 * To run a query within a React component, call `useRequireForAllAcceptanceDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequireForAllAcceptanceDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequireForAllAcceptanceDocumentsQuery({
 *   variables: {
 *      requiredFor: // value for 'requiredFor'
 *   },
 * });
 */
export function useRequireForAllAcceptanceDocumentsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    RequireForAllAcceptanceDocumentsQuery,
    RequireForAllAcceptanceDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RequireForAllAcceptanceDocumentsQuery,
    RequireForAllAcceptanceDocumentsQueryVariables
  >(RequireForAllAcceptanceDocumentsDocument, options)
}
export function useRequireForAllAcceptanceDocumentsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RequireForAllAcceptanceDocumentsQuery,
    RequireForAllAcceptanceDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RequireForAllAcceptanceDocumentsQuery,
    RequireForAllAcceptanceDocumentsQueryVariables
  >(RequireForAllAcceptanceDocumentsDocument, options)
}
export type RequireForAllAcceptanceDocumentsQueryHookResult = ReturnType<
  typeof useRequireForAllAcceptanceDocumentsQuery
>
export type RequireForAllAcceptanceDocumentsLazyQueryHookResult = ReturnType<
  typeof useRequireForAllAcceptanceDocumentsLazyQuery
>
export type RequireForAllAcceptanceDocumentsQueryResult =
  ApolloReactCommon.QueryResult<
    RequireForAllAcceptanceDocumentsQuery,
    RequireForAllAcceptanceDocumentsQueryVariables
  >
export const UserBenefitsStatusDocument = /*#__PURE__*/ gql`
  query UserBenefitsStatus($tierKey: String!, $benefitProductKey: String) {
    userBenefitsStatus(
      tierKey: $tierKey
      benefitProductKey: $benefitProductKey
    ) {
      benefitsStatus {
        __typename
        benefitProductKey
        expiresOn
        claimStatus
        details {
          __typename
          message
          statusCode
        }
      }
    }
  }
`

/**
 * __useUserBenefitsStatusQuery__
 *
 * To run a query within a React component, call `useUserBenefitsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserBenefitsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBenefitsStatusQuery({
 *   variables: {
 *      tierKey: // value for 'tierKey'
 *      benefitProductKey: // value for 'benefitProductKey'
 *   },
 * });
 */
export function useUserBenefitsStatusQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    UserBenefitsStatusQuery,
    UserBenefitsStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    UserBenefitsStatusQuery,
    UserBenefitsStatusQueryVariables
  >(UserBenefitsStatusDocument, options)
}
export function useUserBenefitsStatusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserBenefitsStatusQuery,
    UserBenefitsStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    UserBenefitsStatusQuery,
    UserBenefitsStatusQueryVariables
  >(UserBenefitsStatusDocument, options)
}
export type UserBenefitsStatusQueryHookResult = ReturnType<
  typeof useUserBenefitsStatusQuery
>
export type UserBenefitsStatusLazyQueryHookResult = ReturnType<
  typeof useUserBenefitsStatusLazyQuery
>
export type UserBenefitsStatusQueryResult = ApolloReactCommon.QueryResult<
  UserBenefitsStatusQuery,
  UserBenefitsStatusQueryVariables
>
export const EarlyClosureReasonsDocument = /*#__PURE__*/ gql`
  query earlyClosureReasons {
    earlyAccountClosureReasons
  }
`

/**
 * __useEarlyClosureReasonsQuery__
 *
 * To run a query within a React component, call `useEarlyClosureReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarlyClosureReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarlyClosureReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEarlyClosureReasonsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    EarlyClosureReasonsQuery,
    EarlyClosureReasonsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EarlyClosureReasonsQuery,
    EarlyClosureReasonsQueryVariables
  >(EarlyClosureReasonsDocument, options)
}
export function useEarlyClosureReasonsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EarlyClosureReasonsQuery,
    EarlyClosureReasonsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EarlyClosureReasonsQuery,
    EarlyClosureReasonsQueryVariables
  >(EarlyClosureReasonsDocument, options)
}
export type EarlyClosureReasonsQueryHookResult = ReturnType<
  typeof useEarlyClosureReasonsQuery
>
export type EarlyClosureReasonsLazyQueryHookResult = ReturnType<
  typeof useEarlyClosureReasonsLazyQuery
>
export type EarlyClosureReasonsQueryResult = ApolloReactCommon.QueryResult<
  EarlyClosureReasonsQuery,
  EarlyClosureReasonsQueryVariables
>
export const StopRecurringInvestmentDocument = /*#__PURE__*/ gql`
  mutation stopRecurringInvestment($investmentAccountId: String) {
    stopRecurringInvestment(investmentAccountId: $investmentAccountId) {
      recurringInvestmentSettings {
        amount
      }
    }
  }
`
export type StopRecurringInvestmentMutationFn =
  ApolloReactCommon.MutationFunction<
    StopRecurringInvestmentMutation,
    StopRecurringInvestmentMutationVariables
  >

/**
 * __useStopRecurringInvestmentMutation__
 *
 * To run a mutation, you first call `useStopRecurringInvestmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopRecurringInvestmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopRecurringInvestmentMutation, { data, loading, error }] = useStopRecurringInvestmentMutation({
 *   variables: {
 *      investmentAccountId: // value for 'investmentAccountId'
 *   },
 * });
 */
export function useStopRecurringInvestmentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    StopRecurringInvestmentMutation,
    StopRecurringInvestmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    StopRecurringInvestmentMutation,
    StopRecurringInvestmentMutationVariables
  >(StopRecurringInvestmentDocument, options)
}
export type StopRecurringInvestmentMutationHookResult = ReturnType<
  typeof useStopRecurringInvestmentMutation
>
export type StopRecurringInvestmentMutationResult =
  ApolloReactCommon.MutationResult<StopRecurringInvestmentMutation>
export type StopRecurringInvestmentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    StopRecurringInvestmentMutation,
    StopRecurringInvestmentMutationVariables
  >
export const CloseAccountCancelRecurringTransferDocument = /*#__PURE__*/ gql`
  mutation CloseAccountCancelRecurringTransfer($id: ID!) {
    cancelRecurringTransfer(id: $id) {
      __typename
      ... on RecurringTransfer {
        active
        id
        nextTransferDate
        recurrenceRule {
          byMonthDay
          byWeekDay
          endDate
          frequency
          interval
          startDate
        }
        transferEvent {
          targetAccount {
            type
            id
          }
          fundingSource {
            type
            id
          }
          direction
          amount {
            value
            currency
          }
        }
      }
    }
  }
`
export type CloseAccountCancelRecurringTransferMutationFn =
  ApolloReactCommon.MutationFunction<
    CloseAccountCancelRecurringTransferMutation,
    CloseAccountCancelRecurringTransferMutationVariables
  >

/**
 * __useCloseAccountCancelRecurringTransferMutation__
 *
 * To run a mutation, you first call `useCloseAccountCancelRecurringTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseAccountCancelRecurringTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeAccountCancelRecurringTransferMutation, { data, loading, error }] = useCloseAccountCancelRecurringTransferMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloseAccountCancelRecurringTransferMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CloseAccountCancelRecurringTransferMutation,
    CloseAccountCancelRecurringTransferMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CloseAccountCancelRecurringTransferMutation,
    CloseAccountCancelRecurringTransferMutationVariables
  >(CloseAccountCancelRecurringTransferDocument, options)
}
export type CloseAccountCancelRecurringTransferMutationHookResult = ReturnType<
  typeof useCloseAccountCancelRecurringTransferMutation
>
export type CloseAccountCancelRecurringTransferMutationResult =
  ApolloReactCommon.MutationResult<CloseAccountCancelRecurringTransferMutation>
export type CloseAccountCancelRecurringTransferMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CloseAccountCancelRecurringTransferMutation,
    CloseAccountCancelRecurringTransferMutationVariables
  >
export const CloseUserAccountDocument = /*#__PURE__*/ gql`
  mutation CloseUserAccount {
    closeUserAccount {
      __typename
      ... on OpenAccountsException {
        openAccountTypes
      }
      ... on UserNotFoundException {
        message
        userId
      }
      ... on User_v2 {
        closedAt
        email
        uuid
      }
    }
  }
`
export type CloseUserAccountMutationFn = ApolloReactCommon.MutationFunction<
  CloseUserAccountMutation,
  CloseUserAccountMutationVariables
>

/**
 * __useCloseUserAccountMutation__
 *
 * To run a mutation, you first call `useCloseUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeUserAccountMutation, { data, loading, error }] = useCloseUserAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useCloseUserAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CloseUserAccountMutation,
    CloseUserAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CloseUserAccountMutation,
    CloseUserAccountMutationVariables
  >(CloseUserAccountDocument, options)
}
export type CloseUserAccountMutationHookResult = ReturnType<
  typeof useCloseUserAccountMutation
>
export type CloseUserAccountMutationResult =
  ApolloReactCommon.MutationResult<CloseUserAccountMutation>
export type CloseUserAccountMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CloseUserAccountMutation,
    CloseUserAccountMutationVariables
  >
export const CloseAccountRequestAccountClosureDocument = /*#__PURE__*/ gql`
  mutation CloseAccountRequestAccountClosure(
    $input: DeactivateTierSubscriptionInput!
  ) {
    deactivateTierSubscription(input: $input) {
      __typename
    }
  }
`
export type CloseAccountRequestAccountClosureMutationFn =
  ApolloReactCommon.MutationFunction<
    CloseAccountRequestAccountClosureMutation,
    CloseAccountRequestAccountClosureMutationVariables
  >

/**
 * __useCloseAccountRequestAccountClosureMutation__
 *
 * To run a mutation, you first call `useCloseAccountRequestAccountClosureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseAccountRequestAccountClosureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeAccountRequestAccountClosureMutation, { data, loading, error }] = useCloseAccountRequestAccountClosureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseAccountRequestAccountClosureMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CloseAccountRequestAccountClosureMutation,
    CloseAccountRequestAccountClosureMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CloseAccountRequestAccountClosureMutation,
    CloseAccountRequestAccountClosureMutationVariables
  >(CloseAccountRequestAccountClosureDocument, options)
}
export type CloseAccountRequestAccountClosureMutationHookResult = ReturnType<
  typeof useCloseAccountRequestAccountClosureMutation
>
export type CloseAccountRequestAccountClosureMutationResult =
  ApolloReactCommon.MutationResult<CloseAccountRequestAccountClosureMutation>
export type CloseAccountRequestAccountClosureMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CloseAccountRequestAccountClosureMutation,
    CloseAccountRequestAccountClosureMutationVariables
  >
export const EarlyAccountClosureDocument = /*#__PURE__*/ gql`
  mutation EarlyAccountClosure($input: RequestEarlyAccountClosureInput!) {
    requestEarlyAccountClosure(input: $input) {
      __typename
      ... on InvestmentAccount {
        id
        closedAt
      }
      ... on InternalErrorException {
        message
      }
      ... on FundingSourceRequiresRdvException {
        message
      }
      ... on MissingFundingSourceException {
        message
      }
      ... on ClosureRequestExistsException {
        message
      }
      ... on InvalidAccountTypeException {
        message
      }
      ... on AccountAlreadyClosedException {
        message
      }
    }
  }
`
export type EarlyAccountClosureMutationFn = ApolloReactCommon.MutationFunction<
  EarlyAccountClosureMutation,
  EarlyAccountClosureMutationVariables
>

/**
 * __useEarlyAccountClosureMutation__
 *
 * To run a mutation, you first call `useEarlyAccountClosureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEarlyAccountClosureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [earlyAccountClosureMutation, { data, loading, error }] = useEarlyAccountClosureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEarlyAccountClosureMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EarlyAccountClosureMutation,
    EarlyAccountClosureMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    EarlyAccountClosureMutation,
    EarlyAccountClosureMutationVariables
  >(EarlyAccountClosureDocument, options)
}
export type EarlyAccountClosureMutationHookResult = ReturnType<
  typeof useEarlyAccountClosureMutation
>
export type EarlyAccountClosureMutationResult =
  ApolloReactCommon.MutationResult<EarlyAccountClosureMutation>
export type EarlyAccountClosureMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    EarlyAccountClosureMutation,
    EarlyAccountClosureMutationVariables
  >
export const RequestAccountClosureDocument = /*#__PURE__*/ gql`
  mutation RequestAccountClosure($comments: String, $reason: String!) {
    requestAccountClosure(input: { comments: $comments, reason: $reason })
  }
`
export type RequestAccountClosureMutationFn =
  ApolloReactCommon.MutationFunction<
    RequestAccountClosureMutation,
    RequestAccountClosureMutationVariables
  >

/**
 * __useRequestAccountClosureMutation__
 *
 * To run a mutation, you first call `useRequestAccountClosureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAccountClosureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAccountClosureMutation, { data, loading, error }] = useRequestAccountClosureMutation({
 *   variables: {
 *      comments: // value for 'comments'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRequestAccountClosureMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RequestAccountClosureMutation,
    RequestAccountClosureMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RequestAccountClosureMutation,
    RequestAccountClosureMutationVariables
  >(RequestAccountClosureDocument, options)
}
export type RequestAccountClosureMutationHookResult = ReturnType<
  typeof useRequestAccountClosureMutation
>
export type RequestAccountClosureMutationResult =
  ApolloReactCommon.MutationResult<RequestAccountClosureMutation>
export type RequestAccountClosureMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RequestAccountClosureMutation,
    RequestAccountClosureMutationVariables
  >
export const RequestCloseAccountDocument = /*#__PURE__*/ gql`
  mutation requestCloseAccount($input: CreateSupportTicketInput!) {
    createAuthenticatedSupportTicket(input: $input) {
      description
      id
      subject
      url
    }
  }
`
export type RequestCloseAccountMutationFn = ApolloReactCommon.MutationFunction<
  RequestCloseAccountMutation,
  RequestCloseAccountMutationVariables
>

/**
 * __useRequestCloseAccountMutation__
 *
 * To run a mutation, you first call `useRequestCloseAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCloseAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCloseAccountMutation, { data, loading, error }] = useRequestCloseAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCloseAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RequestCloseAccountMutation,
    RequestCloseAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RequestCloseAccountMutation,
    RequestCloseAccountMutationVariables
  >(RequestCloseAccountDocument, options)
}
export type RequestCloseAccountMutationHookResult = ReturnType<
  typeof useRequestCloseAccountMutation
>
export type RequestCloseAccountMutationResult =
  ApolloReactCommon.MutationResult<RequestCloseAccountMutation>
export type RequestCloseAccountMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RequestCloseAccountMutation,
    RequestCloseAccountMutationVariables
  >
export const LaterLiquidationMutationDocument = /*#__PURE__*/ gql`
  mutation laterLiquidationMutation(
    $investmentAccountId: ID!
    $federalTaxes: Float!
    $stateTaxes: Float!
    $taxYear: Int!
    $reason: LaterWithdrawalReason!
  ) {
    laterTotalLiquidation(
      investmentAccountId: $investmentAccountId
      input: {
        federalTaxes: $federalTaxes
        stateTaxes: $stateTaxes
        withdrawalType: null
        taxYear: $taxYear
        reason: $reason
      }
    )
  }
`
export type LaterLiquidationMutationMutationFn =
  ApolloReactCommon.MutationFunction<
    LaterLiquidationMutationMutation,
    LaterLiquidationMutationMutationVariables
  >

/**
 * __useLaterLiquidationMutationMutation__
 *
 * To run a mutation, you first call `useLaterLiquidationMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaterLiquidationMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [laterLiquidationMutationMutation, { data, loading, error }] = useLaterLiquidationMutationMutation({
 *   variables: {
 *      investmentAccountId: // value for 'investmentAccountId'
 *      federalTaxes: // value for 'federalTaxes'
 *      stateTaxes: // value for 'stateTaxes'
 *      taxYear: // value for 'taxYear'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useLaterLiquidationMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    LaterLiquidationMutationMutation,
    LaterLiquidationMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    LaterLiquidationMutationMutation,
    LaterLiquidationMutationMutationVariables
  >(LaterLiquidationMutationDocument, options)
}
export type LaterLiquidationMutationMutationHookResult = ReturnType<
  typeof useLaterLiquidationMutationMutation
>
export type LaterLiquidationMutationMutationResult =
  ApolloReactCommon.MutationResult<LaterLiquidationMutationMutation>
export type LaterLiquidationMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    LaterLiquidationMutationMutation,
    LaterLiquidationMutationMutationVariables
  >
export const CloseAccountInvestmentAccountsDocument = /*#__PURE__*/ gql`
  query CloseAccountInvestmentAccounts {
    user {
      uuid
      email
      firstName
      lastName
      phoneNumber
      fundingSource {
        name
        last4
        fundingType
        type
      }
    }
    investmentAccountsByUserId(filter: { product: EARLY }) {
      id
      name
      type
      product
      closedAt
      beneficiary {
        firstName
      }
      beneficiaryId
      currentBalance {
        currency
        value
      }
      pendingBalance {
        currency
        value
      }
      recurringInvestmentSettings {
        amount
      }
      status
    }
  }
`

/**
 * __useCloseAccountInvestmentAccountsQuery__
 *
 * To run a query within a React component, call `useCloseAccountInvestmentAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCloseAccountInvestmentAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCloseAccountInvestmentAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCloseAccountInvestmentAccountsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CloseAccountInvestmentAccountsQuery,
    CloseAccountInvestmentAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CloseAccountInvestmentAccountsQuery,
    CloseAccountInvestmentAccountsQueryVariables
  >(CloseAccountInvestmentAccountsDocument, options)
}
export function useCloseAccountInvestmentAccountsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CloseAccountInvestmentAccountsQuery,
    CloseAccountInvestmentAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CloseAccountInvestmentAccountsQuery,
    CloseAccountInvestmentAccountsQueryVariables
  >(CloseAccountInvestmentAccountsDocument, options)
}
export type CloseAccountInvestmentAccountsQueryHookResult = ReturnType<
  typeof useCloseAccountInvestmentAccountsQuery
>
export type CloseAccountInvestmentAccountsLazyQueryHookResult = ReturnType<
  typeof useCloseAccountInvestmentAccountsLazyQuery
>
export type CloseAccountInvestmentAccountsQueryResult =
  ApolloReactCommon.QueryResult<
    CloseAccountInvestmentAccountsQuery,
    CloseAccountInvestmentAccountsQueryVariables
  >
export const LaterBalancesQueryDocument = /*#__PURE__*/ gql`
  query laterBalancesQuery {
    laterAccounts {
      status
      amount
      accountId
      accountNumber
      recurringSettings {
        amount
      }
    }
    allPastItems(filter: { pending: true }, pagination: { first: 1 }) {
      edges {
        cursor
        node {
          __typename
          id
          reversible
          title
          amount {
            value
            currency
          }
          status
        }
      }
    }
  }
`

/**
 * __useLaterBalancesQueryQuery__
 *
 * To run a query within a React component, call `useLaterBalancesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaterBalancesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaterBalancesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useLaterBalancesQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    LaterBalancesQueryQuery,
    LaterBalancesQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LaterBalancesQueryQuery,
    LaterBalancesQueryQueryVariables
  >(LaterBalancesQueryDocument, options)
}
export function useLaterBalancesQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LaterBalancesQueryQuery,
    LaterBalancesQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LaterBalancesQueryQuery,
    LaterBalancesQueryQueryVariables
  >(LaterBalancesQueryDocument, options)
}
export type LaterBalancesQueryQueryHookResult = ReturnType<
  typeof useLaterBalancesQueryQuery
>
export type LaterBalancesQueryLazyQueryHookResult = ReturnType<
  typeof useLaterBalancesQueryLazyQuery
>
export type LaterBalancesQueryQueryResult = ApolloReactCommon.QueryResult<
  LaterBalancesQueryQuery,
  LaterBalancesQueryQueryVariables
>
export const SpendInfoQueryDocument = /*#__PURE__*/ gql`
  query spendInfoQuery {
    allBankAccounts(input: { type: spend }) {
      id
      status
      balance {
        value
      }
    }
    recurringTransfers(filter: { targetAccountType: SPEND }) {
      id
      active
    }
  }
`

/**
 * __useSpendInfoQueryQuery__
 *
 * To run a query within a React component, call `useSpendInfoQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpendInfoQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpendInfoQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpendInfoQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SpendInfoQueryQuery,
    SpendInfoQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SpendInfoQueryQuery,
    SpendInfoQueryQueryVariables
  >(SpendInfoQueryDocument, options)
}
export function useSpendInfoQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SpendInfoQueryQuery,
    SpendInfoQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SpendInfoQueryQuery,
    SpendInfoQueryQueryVariables
  >(SpendInfoQueryDocument, options)
}
export type SpendInfoQueryQueryHookResult = ReturnType<
  typeof useSpendInfoQueryQuery
>
export type SpendInfoQueryLazyQueryHookResult = ReturnType<
  typeof useSpendInfoQueryLazyQuery
>
export type SpendInfoQueryQueryResult = ApolloReactCommon.QueryResult<
  SpendInfoQueryQuery,
  SpendInfoQueryQueryVariables
>
export const UserTierDocument = /*#__PURE__*/ gql`
  query UserTier {
    tierSubscriptionForUser {
      __typename
      ... on TierSubscription {
        id
        tier {
          id
          key
          name
        }
      }
      ... on TierSubscriptionNotFound {
        message
      }
      ... on TierSubscriptionUnsubscribed {
        id
        createdAt
        updatedAt
      }
    }
  }
`

/**
 * __useUserTierQuery__
 *
 * To run a query within a React component, call `useUserTierQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTierQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserTierQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserTierQuery,
    UserTierQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<UserTierQuery, UserTierQueryVariables>(
    UserTierDocument,
    options,
  )
}
export function useUserTierLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserTierQuery,
    UserTierQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<UserTierQuery, UserTierQueryVariables>(
    UserTierDocument,
    options,
  )
}
export type UserTierQueryHookResult = ReturnType<typeof useUserTierQuery>
export type UserTierLazyQueryHookResult = ReturnType<
  typeof useUserTierLazyQuery
>
export type UserTierQueryResult = ApolloReactCommon.QueryResult<
  UserTierQuery,
  UserTierQueryVariables
>
export const CloseAccountUserQueryDocument = /*#__PURE__*/ gql`
  query CloseAccountUserQuery {
    user {
      uuid
      email
      firstName
      lastName
      phoneNumber
      fundingSource {
        name
        last4
        fundingType
        type
      }
    }
    linkedAccounts(linked: true) {
      linkedSubaccounts {
        accountNumberLastFour
        allowedRoles
        externalSource
        id
        name
        role
      }
    }
    investmentAccountsByUserId {
      id
      closedAt
      name
      type
      product
      portfolios {
        ... on SelfDirectedPortfolio {
          __typename
          status
          pendingBalance {
            value
          }
        }
      }
    }
  }
`

/**
 * __useCloseAccountUserQueryQuery__
 *
 * To run a query within a React component, call `useCloseAccountUserQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCloseAccountUserQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCloseAccountUserQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCloseAccountUserQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CloseAccountUserQueryQuery,
    CloseAccountUserQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CloseAccountUserQueryQuery,
    CloseAccountUserQueryQueryVariables
  >(CloseAccountUserQueryDocument, options)
}
export function useCloseAccountUserQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CloseAccountUserQueryQuery,
    CloseAccountUserQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CloseAccountUserQueryQuery,
    CloseAccountUserQueryQueryVariables
  >(CloseAccountUserQueryDocument, options)
}
export type CloseAccountUserQueryQueryHookResult = ReturnType<
  typeof useCloseAccountUserQueryQuery
>
export type CloseAccountUserQueryLazyQueryHookResult = ReturnType<
  typeof useCloseAccountUserQueryLazyQuery
>
export type CloseAccountUserQueryQueryResult = ApolloReactCommon.QueryResult<
  CloseAccountUserQueryQuery,
  CloseAccountUserQueryQueryVariables
>
export const ReopenUserAccountDocument = /*#__PURE__*/ gql`
  mutation reopenUserAccount {
    reopenUserAccount {
      __typename
    }
  }
`
export type ReopenUserAccountMutationFn = ApolloReactCommon.MutationFunction<
  ReopenUserAccountMutation,
  ReopenUserAccountMutationVariables
>

/**
 * __useReopenUserAccountMutation__
 *
 * To run a mutation, you first call `useReopenUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenUserAccountMutation, { data, loading, error }] = useReopenUserAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useReopenUserAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ReopenUserAccountMutation,
    ReopenUserAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ReopenUserAccountMutation,
    ReopenUserAccountMutationVariables
  >(ReopenUserAccountDocument, options)
}
export type ReopenUserAccountMutationHookResult = ReturnType<
  typeof useReopenUserAccountMutation
>
export type ReopenUserAccountMutationResult =
  ApolloReactCommon.MutationResult<ReopenUserAccountMutation>
export type ReopenUserAccountMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ReopenUserAccountMutation,
    ReopenUserAccountMutationVariables
  >
export const SubscribeToTierDocument = /*#__PURE__*/ gql`
  mutation subscribeToTier($input: SubscribeToTierInput!) {
    subscribeToTier(input: $input) {
      __typename
    }
  }
`
export type SubscribeToTierMutationFn = ApolloReactCommon.MutationFunction<
  SubscribeToTierMutation,
  SubscribeToTierMutationVariables
>

/**
 * __useSubscribeToTierMutation__
 *
 * To run a mutation, you first call `useSubscribeToTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToTierMutation, { data, loading, error }] = useSubscribeToTierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeToTierMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SubscribeToTierMutation,
    SubscribeToTierMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SubscribeToTierMutation,
    SubscribeToTierMutationVariables
  >(SubscribeToTierDocument, options)
}
export type SubscribeToTierMutationHookResult = ReturnType<
  typeof useSubscribeToTierMutation
>
export type SubscribeToTierMutationResult =
  ApolloReactCommon.MutationResult<SubscribeToTierMutation>
export type SubscribeToTierMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SubscribeToTierMutation,
    SubscribeToTierMutationVariables
  >
export const ClosedAccountAgreeToAcceptanceDocumentDocument = /*#__PURE__*/ gql`
  mutation ClosedAccountAgreeToAcceptanceDocument($id: ID!) {
    agreeToAcceptanceDocument(id: $id)
  }
`
export type ClosedAccountAgreeToAcceptanceDocumentMutationFn =
  ApolloReactCommon.MutationFunction<
    ClosedAccountAgreeToAcceptanceDocumentMutation,
    ClosedAccountAgreeToAcceptanceDocumentMutationVariables
  >

/**
 * __useClosedAccountAgreeToAcceptanceDocumentMutation__
 *
 * To run a mutation, you first call `useClosedAccountAgreeToAcceptanceDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClosedAccountAgreeToAcceptanceDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closedAccountAgreeToAcceptanceDocumentMutation, { data, loading, error }] = useClosedAccountAgreeToAcceptanceDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClosedAccountAgreeToAcceptanceDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ClosedAccountAgreeToAcceptanceDocumentMutation,
    ClosedAccountAgreeToAcceptanceDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ClosedAccountAgreeToAcceptanceDocumentMutation,
    ClosedAccountAgreeToAcceptanceDocumentMutationVariables
  >(ClosedAccountAgreeToAcceptanceDocumentDocument, options)
}
export type ClosedAccountAgreeToAcceptanceDocumentMutationHookResult =
  ReturnType<typeof useClosedAccountAgreeToAcceptanceDocumentMutation>
export type ClosedAccountAgreeToAcceptanceDocumentMutationResult =
  ApolloReactCommon.MutationResult<ClosedAccountAgreeToAcceptanceDocumentMutation>
export type ClosedAccountAgreeToAcceptanceDocumentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ClosedAccountAgreeToAcceptanceDocumentMutation,
    ClosedAccountAgreeToAcceptanceDocumentMutationVariables
  >
export const AllAcceptanceDocumentsDocument = /*#__PURE__*/ gql`
  query allAcceptanceDocuments {
    allAcceptanceDocuments {
      id
      version
      url
      type
      name
    }
  }
`

/**
 * __useAllAcceptanceDocumentsQuery__
 *
 * To run a query within a React component, call `useAllAcceptanceDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAcceptanceDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAcceptanceDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAcceptanceDocumentsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AllAcceptanceDocumentsQuery,
    AllAcceptanceDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AllAcceptanceDocumentsQuery,
    AllAcceptanceDocumentsQueryVariables
  >(AllAcceptanceDocumentsDocument, options)
}
export function useAllAcceptanceDocumentsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AllAcceptanceDocumentsQuery,
    AllAcceptanceDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AllAcceptanceDocumentsQuery,
    AllAcceptanceDocumentsQueryVariables
  >(AllAcceptanceDocumentsDocument, options)
}
export type AllAcceptanceDocumentsQueryHookResult = ReturnType<
  typeof useAllAcceptanceDocumentsQuery
>
export type AllAcceptanceDocumentsLazyQueryHookResult = ReturnType<
  typeof useAllAcceptanceDocumentsLazyQuery
>
export type AllAcceptanceDocumentsQueryResult = ApolloReactCommon.QueryResult<
  AllAcceptanceDocumentsQuery,
  AllAcceptanceDocumentsQueryVariables
>
export const InvestAccountDocument = /*#__PURE__*/ gql`
  query InvestAccount {
    investmentAccountsByUserId(filter: { product: INVEST }) {
      id
      product
      type
      portfolio {
        id
        name
        riskLevel
        theme
        accountAllocation {
          allocationPercent
        }
        portfolioSecurityAllocations {
          id
          symbol
          allocationPercent
          security {
            displayName
            symbol
          }
          investmentCategories {
            bond
            crypto
            equity
          }
        }
        projection {
          lowestGrowthRate
          highestGrowthRate
          averageGrowthRate
        }
      }
    }
  }
`

/**
 * __useInvestAccountQuery__
 *
 * To run a query within a React component, call `useInvestAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvestAccountQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    InvestAccountQuery,
    InvestAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    InvestAccountQuery,
    InvestAccountQueryVariables
  >(InvestAccountDocument, options)
}
export function useInvestAccountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InvestAccountQuery,
    InvestAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    InvestAccountQuery,
    InvestAccountQueryVariables
  >(InvestAccountDocument, options)
}
export type InvestAccountQueryHookResult = ReturnType<
  typeof useInvestAccountQuery
>
export type InvestAccountLazyQueryHookResult = ReturnType<
  typeof useInvestAccountLazyQuery
>
export type InvestAccountQueryResult = ApolloReactCommon.QueryResult<
  InvestAccountQuery,
  InvestAccountQueryVariables
>
export const RequestInvestmentAccountReopenDocument = /*#__PURE__*/ gql`
  mutation RequestInvestmentAccountReopen($accountId: ID!) {
    requestInvestmentAccountReopen(input: { investmentAccountId: $accountId }) {
      __typename
      ... on InvestmentAccountReopenRequest {
        state
      }
    }
  }
`
export type RequestInvestmentAccountReopenMutationFn =
  ApolloReactCommon.MutationFunction<
    RequestInvestmentAccountReopenMutation,
    RequestInvestmentAccountReopenMutationVariables
  >

/**
 * __useRequestInvestmentAccountReopenMutation__
 *
 * To run a mutation, you first call `useRequestInvestmentAccountReopenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestInvestmentAccountReopenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestInvestmentAccountReopenMutation, { data, loading, error }] = useRequestInvestmentAccountReopenMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useRequestInvestmentAccountReopenMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RequestInvestmentAccountReopenMutation,
    RequestInvestmentAccountReopenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RequestInvestmentAccountReopenMutation,
    RequestInvestmentAccountReopenMutationVariables
  >(RequestInvestmentAccountReopenDocument, options)
}
export type RequestInvestmentAccountReopenMutationHookResult = ReturnType<
  typeof useRequestInvestmentAccountReopenMutation
>
export type RequestInvestmentAccountReopenMutationResult =
  ApolloReactCommon.MutationResult<RequestInvestmentAccountReopenMutation>
export type RequestInvestmentAccountReopenMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RequestInvestmentAccountReopenMutation,
    RequestInvestmentAccountReopenMutationVariables
  >
export const ClosedAccountUserQueryDocument = /*#__PURE__*/ gql`
  query ClosedAccountUserQuery {
    user {
      uuid
      email
      firstName
      lastName
      phoneNumber
      closedAt
    }
  }
`

/**
 * __useClosedAccountUserQueryQuery__
 *
 * To run a query within a React component, call `useClosedAccountUserQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useClosedAccountUserQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClosedAccountUserQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useClosedAccountUserQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ClosedAccountUserQueryQuery,
    ClosedAccountUserQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ClosedAccountUserQueryQuery,
    ClosedAccountUserQueryQueryVariables
  >(ClosedAccountUserQueryDocument, options)
}
export function useClosedAccountUserQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ClosedAccountUserQueryQuery,
    ClosedAccountUserQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ClosedAccountUserQueryQuery,
    ClosedAccountUserQueryQueryVariables
  >(ClosedAccountUserQueryDocument, options)
}
export type ClosedAccountUserQueryQueryHookResult = ReturnType<
  typeof useClosedAccountUserQueryQuery
>
export type ClosedAccountUserQueryLazyQueryHookResult = ReturnType<
  typeof useClosedAccountUserQueryLazyQuery
>
export type ClosedAccountUserQueryQueryResult = ApolloReactCommon.QueryResult<
  ClosedAccountUserQueryQuery,
  ClosedAccountUserQueryQueryVariables
>
export const VerifyIdentityByDocumentsDocument = /*#__PURE__*/ gql`
  mutation VerifyIdentityByDocuments($input: ValidateDocumentsInput!) {
    verifyIdentityByDocuments(input: $input) {
      __typename
      ... on DocumentVerification {
        verificationCriteriaMet
      }
    }
  }
`
export type VerifyIdentityByDocumentsMutationFn =
  ApolloReactCommon.MutationFunction<
    VerifyIdentityByDocumentsMutation,
    VerifyIdentityByDocumentsMutationVariables
  >

/**
 * __useVerifyIdentityByDocumentsMutation__
 *
 * To run a mutation, you first call `useVerifyIdentityByDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyIdentityByDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyIdentityByDocumentsMutation, { data, loading, error }] = useVerifyIdentityByDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyIdentityByDocumentsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    VerifyIdentityByDocumentsMutation,
    VerifyIdentityByDocumentsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    VerifyIdentityByDocumentsMutation,
    VerifyIdentityByDocumentsMutationVariables
  >(VerifyIdentityByDocumentsDocument, options)
}
export type VerifyIdentityByDocumentsMutationHookResult = ReturnType<
  typeof useVerifyIdentityByDocumentsMutation
>
export type VerifyIdentityByDocumentsMutationResult =
  ApolloReactCommon.MutationResult<VerifyIdentityByDocumentsMutation>
export type VerifyIdentityByDocumentsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    VerifyIdentityByDocumentsMutation,
    VerifyIdentityByDocumentsMutationVariables
  >
export const UnauthenticatedCreateUploadUrlDocument = /*#__PURE__*/ gql`
  mutation UnauthenticatedCreateUploadUrl(
    $token: String!
    $documentType: DocumentType!
    $fileName: String!
  ) {
    unauthenticatedCreateUploadUrl(
      input: { token: $token, documentType: $documentType, fileName: $fileName }
    ) {
      __typename
      ... on UploadUrl {
        key
        userId
        policy
        url
        uploadUuid
        xAmzAlgorithm
        xAmzCredential
        xAmzDate
        xAmzSecurityToken
        xAmzSignature
      }
    }
  }
`
export type UnauthenticatedCreateUploadUrlMutationFn =
  ApolloReactCommon.MutationFunction<
    UnauthenticatedCreateUploadUrlMutation,
    UnauthenticatedCreateUploadUrlMutationVariables
  >

/**
 * __useUnauthenticatedCreateUploadUrlMutation__
 *
 * To run a mutation, you first call `useUnauthenticatedCreateUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnauthenticatedCreateUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unauthenticatedCreateUploadUrlMutation, { data, loading, error }] = useUnauthenticatedCreateUploadUrlMutation({
 *   variables: {
 *      token: // value for 'token'
 *      documentType: // value for 'documentType'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useUnauthenticatedCreateUploadUrlMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UnauthenticatedCreateUploadUrlMutation,
    UnauthenticatedCreateUploadUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UnauthenticatedCreateUploadUrlMutation,
    UnauthenticatedCreateUploadUrlMutationVariables
  >(UnauthenticatedCreateUploadUrlDocument, options)
}
export type UnauthenticatedCreateUploadUrlMutationHookResult = ReturnType<
  typeof useUnauthenticatedCreateUploadUrlMutation
>
export type UnauthenticatedCreateUploadUrlMutationResult =
  ApolloReactCommon.MutationResult<UnauthenticatedCreateUploadUrlMutation>
export type UnauthenticatedCreateUploadUrlMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UnauthenticatedCreateUploadUrlMutation,
    UnauthenticatedCreateUploadUrlMutationVariables
  >
export const UnauthenticatedSaveUploadDocument = /*#__PURE__*/ gql`
  mutation UnauthenticatedSaveUpload(
    $uploadUuids: [ID!]!
    $token: String!
    $additionalInfo: String
  ) {
    unauthenticatedSaveUploadUrl(
      input: {
        uploadUuids: $uploadUuids
        token: $token
        additionalInfo: $additionalInfo
      }
    ) {
      __typename
      ... on UploadSaveError {
        uploadExceptions {
          ... on FileDoesNotExistError {
            message
            userId
          }
          ... on UploadDoesNotExistError {
            message
            userId
            uploadUuid
          }
        }
      }
      ... on DocumentUploads {
        uploadDocuments {
          id
          userId
        }
      }
    }
  }
`
export type UnauthenticatedSaveUploadMutationFn =
  ApolloReactCommon.MutationFunction<
    UnauthenticatedSaveUploadMutation,
    UnauthenticatedSaveUploadMutationVariables
  >

/**
 * __useUnauthenticatedSaveUploadMutation__
 *
 * To run a mutation, you first call `useUnauthenticatedSaveUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnauthenticatedSaveUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unauthenticatedSaveUploadMutation, { data, loading, error }] = useUnauthenticatedSaveUploadMutation({
 *   variables: {
 *      uploadUuids: // value for 'uploadUuids'
 *      token: // value for 'token'
 *      additionalInfo: // value for 'additionalInfo'
 *   },
 * });
 */
export function useUnauthenticatedSaveUploadMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UnauthenticatedSaveUploadMutation,
    UnauthenticatedSaveUploadMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UnauthenticatedSaveUploadMutation,
    UnauthenticatedSaveUploadMutationVariables
  >(UnauthenticatedSaveUploadDocument, options)
}
export type UnauthenticatedSaveUploadMutationHookResult = ReturnType<
  typeof useUnauthenticatedSaveUploadMutation
>
export type UnauthenticatedSaveUploadMutationResult =
  ApolloReactCommon.MutationResult<UnauthenticatedSaveUploadMutation>
export type UnauthenticatedSaveUploadMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UnauthenticatedSaveUploadMutation,
    UnauthenticatedSaveUploadMutationVariables
  >
export const ValidateSuspendedUploadTokenDocument = /*#__PURE__*/ gql`
  mutation ValidateSuspendedUploadToken($uploadToken: String!) {
    validateUserSuspendedUploadToken(input: { token: $uploadToken }) {
      __typename
      ... on UserSuspendedUploadTokenLengthError {
        length
      }
      ... on UserSuspendedUploadTokenValidation {
        reason
        tokenValid
      }
    }
  }
`
export type ValidateSuspendedUploadTokenMutationFn =
  ApolloReactCommon.MutationFunction<
    ValidateSuspendedUploadTokenMutation,
    ValidateSuspendedUploadTokenMutationVariables
  >

/**
 * __useValidateSuspendedUploadTokenMutation__
 *
 * To run a mutation, you first call `useValidateSuspendedUploadTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateSuspendedUploadTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateSuspendedUploadTokenMutation, { data, loading, error }] = useValidateSuspendedUploadTokenMutation({
 *   variables: {
 *      uploadToken: // value for 'uploadToken'
 *   },
 * });
 */
export function useValidateSuspendedUploadTokenMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ValidateSuspendedUploadTokenMutation,
    ValidateSuspendedUploadTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ValidateSuspendedUploadTokenMutation,
    ValidateSuspendedUploadTokenMutationVariables
  >(ValidateSuspendedUploadTokenDocument, options)
}
export type ValidateSuspendedUploadTokenMutationHookResult = ReturnType<
  typeof useValidateSuspendedUploadTokenMutation
>
export type ValidateSuspendedUploadTokenMutationResult =
  ApolloReactCommon.MutationResult<ValidateSuspendedUploadTokenMutation>
export type ValidateSuspendedUploadTokenMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ValidateSuspendedUploadTokenMutation,
    ValidateSuspendedUploadTokenMutationVariables
  >
export const UserAlertsDocument = /*#__PURE__*/ gql`
  query UserAlerts {
    userAlerts {
      ... on AddressDocumentRequestedUserAlert {
        requestedDocumentType
      }
      ... on BankDocumentRequestedUserAlert {
        requestedDocumentType
      }
      ... on IdentityDocumentRequestedUserAlert {
        requestedDocumentType
      }
      ... on MiscDocumentRequestedUserAlert {
        requestedDocumentType
      }
      ... on SSNDocumentRequestedUserAlert {
        requestedDocumentType
      }
      ... on W9DocumentRequestedUserAlert {
        requestedDocumentType
      }
      ... on UserAlert {
        description
        id
        key
        metadata
        title
        type
      }
    }
  }
`

/**
 * __useUserAlertsQuery__
 *
 * To run a query within a React component, call `useUserAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAlertsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserAlertsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserAlertsQuery,
    UserAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<UserAlertsQuery, UserAlertsQueryVariables>(
    UserAlertsDocument,
    options,
  )
}
export function useUserAlertsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserAlertsQuery,
    UserAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    UserAlertsQuery,
    UserAlertsQueryVariables
  >(UserAlertsDocument, options)
}
export type UserAlertsQueryHookResult = ReturnType<typeof useUserAlertsQuery>
export type UserAlertsLazyQueryHookResult = ReturnType<
  typeof useUserAlertsLazyQuery
>
export type UserAlertsQueryResult = ApolloReactCommon.QueryResult<
  UserAlertsQuery,
  UserAlertsQueryVariables
>
export const GenerateDocumentUploadSessionDocument = /*#__PURE__*/ gql`
  mutation GenerateDocumentUploadSession(
    $input: GenerateDocumentUploadSessionInput!
  ) {
    generateDocumentUploadSession(input: $input) {
      ... on DocumentUploadSession {
        token
      }
    }
  }
`
export type GenerateDocumentUploadSessionMutationFn =
  ApolloReactCommon.MutationFunction<
    GenerateDocumentUploadSessionMutation,
    GenerateDocumentUploadSessionMutationVariables
  >

/**
 * __useGenerateDocumentUploadSessionMutation__
 *
 * To run a mutation, you first call `useGenerateDocumentUploadSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDocumentUploadSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDocumentUploadSessionMutation, { data, loading, error }] = useGenerateDocumentUploadSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateDocumentUploadSessionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    GenerateDocumentUploadSessionMutation,
    GenerateDocumentUploadSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    GenerateDocumentUploadSessionMutation,
    GenerateDocumentUploadSessionMutationVariables
  >(GenerateDocumentUploadSessionDocument, options)
}
export type GenerateDocumentUploadSessionMutationHookResult = ReturnType<
  typeof useGenerateDocumentUploadSessionMutation
>
export type GenerateDocumentUploadSessionMutationResult =
  ApolloReactCommon.MutationResult<GenerateDocumentUploadSessionMutation>
export type GenerateDocumentUploadSessionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    GenerateDocumentUploadSessionMutation,
    GenerateDocumentUploadSessionMutationVariables
  >
export const AllInvestmentAccountsDocument = /*#__PURE__*/ gql`
  query AllInvestmentAccounts {
    investmentAccountsByUserId {
      id
      type
      closedAt
      beneficiary {
        firstName
      }
    }
    allBankAccounts(input: { types: [spend, save] }) {
      id
      type
      closedAt
      status
    }
  }
`

/**
 * __useAllInvestmentAccountsQuery__
 *
 * To run a query within a React component, call `useAllInvestmentAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllInvestmentAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllInvestmentAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllInvestmentAccountsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AllInvestmentAccountsQuery,
    AllInvestmentAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AllInvestmentAccountsQuery,
    AllInvestmentAccountsQueryVariables
  >(AllInvestmentAccountsDocument, options)
}
export function useAllInvestmentAccountsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AllInvestmentAccountsQuery,
    AllInvestmentAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AllInvestmentAccountsQuery,
    AllInvestmentAccountsQueryVariables
  >(AllInvestmentAccountsDocument, options)
}
export type AllInvestmentAccountsQueryHookResult = ReturnType<
  typeof useAllInvestmentAccountsQuery
>
export type AllInvestmentAccountsLazyQueryHookResult = ReturnType<
  typeof useAllInvestmentAccountsLazyQuery
>
export type AllInvestmentAccountsQueryResult = ApolloReactCommon.QueryResult<
  AllInvestmentAccountsQuery,
  AllInvestmentAccountsQueryVariables
>
export const AllReturnedCheckDepositsDocument = /*#__PURE__*/ gql`
  query AllReturnedCheckDeposits {
    allReturnedCheckDeposits {
      amount {
        currency
        value
      }
      rejectedDate
      frontCheckImageUrl
      backCheckImageUrl
    }
  }
`

/**
 * __useAllReturnedCheckDepositsQuery__
 *
 * To run a query within a React component, call `useAllReturnedCheckDepositsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllReturnedCheckDepositsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllReturnedCheckDepositsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllReturnedCheckDepositsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AllReturnedCheckDepositsQuery,
    AllReturnedCheckDepositsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AllReturnedCheckDepositsQuery,
    AllReturnedCheckDepositsQueryVariables
  >(AllReturnedCheckDepositsDocument, options)
}
export function useAllReturnedCheckDepositsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AllReturnedCheckDepositsQuery,
    AllReturnedCheckDepositsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AllReturnedCheckDepositsQuery,
    AllReturnedCheckDepositsQueryVariables
  >(AllReturnedCheckDepositsDocument, options)
}
export type AllReturnedCheckDepositsQueryHookResult = ReturnType<
  typeof useAllReturnedCheckDepositsQuery
>
export type AllReturnedCheckDepositsLazyQueryHookResult = ReturnType<
  typeof useAllReturnedCheckDepositsLazyQuery
>
export type AllReturnedCheckDepositsQueryResult = ApolloReactCommon.QueryResult<
  AllReturnedCheckDepositsQuery,
  AllReturnedCheckDepositsQueryVariables
>
export const SpendStatementsQueryDocument = /*#__PURE__*/ gql`
  query SpendStatementsQuery {
    allBankStatements {
      type
      createdAt
      year
      month
      url
    }
  }
`

/**
 * __useSpendStatementsQueryQuery__
 *
 * To run a query within a React component, call `useSpendStatementsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpendStatementsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpendStatementsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpendStatementsQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SpendStatementsQueryQuery,
    SpendStatementsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SpendStatementsQueryQuery,
    SpendStatementsQueryQueryVariables
  >(SpendStatementsQueryDocument, options)
}
export function useSpendStatementsQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SpendStatementsQueryQuery,
    SpendStatementsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SpendStatementsQueryQuery,
    SpendStatementsQueryQueryVariables
  >(SpendStatementsQueryDocument, options)
}
export type SpendStatementsQueryQueryHookResult = ReturnType<
  typeof useSpendStatementsQueryQuery
>
export type SpendStatementsQueryLazyQueryHookResult = ReturnType<
  typeof useSpendStatementsQueryLazyQuery
>
export type SpendStatementsQueryQueryResult = ApolloReactCommon.QueryResult<
  SpendStatementsQueryQuery,
  SpendStatementsQueryQueryVariables
>
export const EarlyInvestOnboardingBenefitsDocument = /*#__PURE__*/ gql`
  query EarlyInvestOnboardingBenefits {
    onboardingBenefits(input: { product: EARLY }) {
      products {
        product
        status
        claimDetails {
          claimStatus
          details {
            statusCode
          }
        }
      }
    }
  }
`

/**
 * __useEarlyInvestOnboardingBenefitsQuery__
 *
 * To run a query within a React component, call `useEarlyInvestOnboardingBenefitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarlyInvestOnboardingBenefitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarlyInvestOnboardingBenefitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEarlyInvestOnboardingBenefitsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    EarlyInvestOnboardingBenefitsQuery,
    EarlyInvestOnboardingBenefitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EarlyInvestOnboardingBenefitsQuery,
    EarlyInvestOnboardingBenefitsQueryVariables
  >(EarlyInvestOnboardingBenefitsDocument, options)
}
export function useEarlyInvestOnboardingBenefitsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EarlyInvestOnboardingBenefitsQuery,
    EarlyInvestOnboardingBenefitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EarlyInvestOnboardingBenefitsQuery,
    EarlyInvestOnboardingBenefitsQueryVariables
  >(EarlyInvestOnboardingBenefitsDocument, options)
}
export type EarlyInvestOnboardingBenefitsQueryHookResult = ReturnType<
  typeof useEarlyInvestOnboardingBenefitsQuery
>
export type EarlyInvestOnboardingBenefitsLazyQueryHookResult = ReturnType<
  typeof useEarlyInvestOnboardingBenefitsLazyQuery
>
export type EarlyInvestOnboardingBenefitsQueryResult =
  ApolloReactCommon.QueryResult<
    EarlyInvestOnboardingBenefitsQuery,
    EarlyInvestOnboardingBenefitsQueryVariables
  >
export const EarlyAgreeToAcceptanceDocumentDocument = /*#__PURE__*/ gql`
  mutation EarlyAgreeToAcceptanceDocument($id: ID!) {
    agreeToAcceptanceDocument(id: $id)
  }
`
export type EarlyAgreeToAcceptanceDocumentMutationFn =
  ApolloReactCommon.MutationFunction<
    EarlyAgreeToAcceptanceDocumentMutation,
    EarlyAgreeToAcceptanceDocumentMutationVariables
  >

/**
 * __useEarlyAgreeToAcceptanceDocumentMutation__
 *
 * To run a mutation, you first call `useEarlyAgreeToAcceptanceDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEarlyAgreeToAcceptanceDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [earlyAgreeToAcceptanceDocumentMutation, { data, loading, error }] = useEarlyAgreeToAcceptanceDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEarlyAgreeToAcceptanceDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EarlyAgreeToAcceptanceDocumentMutation,
    EarlyAgreeToAcceptanceDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    EarlyAgreeToAcceptanceDocumentMutation,
    EarlyAgreeToAcceptanceDocumentMutationVariables
  >(EarlyAgreeToAcceptanceDocumentDocument, options)
}
export type EarlyAgreeToAcceptanceDocumentMutationHookResult = ReturnType<
  typeof useEarlyAgreeToAcceptanceDocumentMutation
>
export type EarlyAgreeToAcceptanceDocumentMutationResult =
  ApolloReactCommon.MutationResult<EarlyAgreeToAcceptanceDocumentMutation>
export type EarlyAgreeToAcceptanceDocumentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    EarlyAgreeToAcceptanceDocumentMutation,
    EarlyAgreeToAcceptanceDocumentMutationVariables
  >
export const CreateEarlyBeneficiaryDocument = /*#__PURE__*/ gql`
  mutation CreateEarlyBeneficiary(
    $firstName: String!
    $lastName: String!
    $dateOfBirth: String!
  ) {
    createBeneficiary(
      input: {
        firstName: $firstName
        lastName: $lastName
        dateOfBirth: $dateOfBirth
      }
    ) {
      __typename
      ... on Beneficiary {
        id
      }
      ... on InvalidDateOfBirthException {
        message
      }
      ... on BeneficiaryExceedsAgeLimitException {
        message
      }
      ... on InvalidLastNameException {
        message
      }
      ... on InvalidFirstNameException {
        message
      }
      ... on InternalErrorException {
        message
      }
    }
  }
`
export type CreateEarlyBeneficiaryMutationFn =
  ApolloReactCommon.MutationFunction<
    CreateEarlyBeneficiaryMutation,
    CreateEarlyBeneficiaryMutationVariables
  >

/**
 * __useCreateEarlyBeneficiaryMutation__
 *
 * To run a mutation, you first call `useCreateEarlyBeneficiaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEarlyBeneficiaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEarlyBeneficiaryMutation, { data, loading, error }] = useCreateEarlyBeneficiaryMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      dateOfBirth: // value for 'dateOfBirth'
 *   },
 * });
 */
export function useCreateEarlyBeneficiaryMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateEarlyBeneficiaryMutation,
    CreateEarlyBeneficiaryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateEarlyBeneficiaryMutation,
    CreateEarlyBeneficiaryMutationVariables
  >(CreateEarlyBeneficiaryDocument, options)
}
export type CreateEarlyBeneficiaryMutationHookResult = ReturnType<
  typeof useCreateEarlyBeneficiaryMutation
>
export type CreateEarlyBeneficiaryMutationResult =
  ApolloReactCommon.MutationResult<CreateEarlyBeneficiaryMutation>
export type CreateEarlyBeneficiaryMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateEarlyBeneficiaryMutation,
    CreateEarlyBeneficiaryMutationVariables
  >
export const DeactivateBeneficiaryDocument = /*#__PURE__*/ gql`
  mutation DeactivateBeneficiary($id: ID!) {
    deactivateBeneficiary(id: $id) {
      __typename
      ... on Beneficiary {
        id
      }
      ... on BeneficiaryNotFoundException {
        message
      }
      ... on InternalErrorException {
        message
      }
    }
  }
`
export type DeactivateBeneficiaryMutationFn =
  ApolloReactCommon.MutationFunction<
    DeactivateBeneficiaryMutation,
    DeactivateBeneficiaryMutationVariables
  >

/**
 * __useDeactivateBeneficiaryMutation__
 *
 * To run a mutation, you first call `useDeactivateBeneficiaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateBeneficiaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateBeneficiaryMutation, { data, loading, error }] = useDeactivateBeneficiaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateBeneficiaryMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeactivateBeneficiaryMutation,
    DeactivateBeneficiaryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeactivateBeneficiaryMutation,
    DeactivateBeneficiaryMutationVariables
  >(DeactivateBeneficiaryDocument, options)
}
export type DeactivateBeneficiaryMutationHookResult = ReturnType<
  typeof useDeactivateBeneficiaryMutation
>
export type DeactivateBeneficiaryMutationResult =
  ApolloReactCommon.MutationResult<DeactivateBeneficiaryMutation>
export type DeactivateBeneficiaryMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeactivateBeneficiaryMutation,
    DeactivateBeneficiaryMutationVariables
  >
export const OpenEarlyAccountMutationDocument = /*#__PURE__*/ gql`
  mutation openEarlyAccountMutation(
    $investmentAccountName: String!
    $beneficiaryId: ID!
    $terminationAge: Int!
    $stateCode: String
  ) {
    openEarlyAccount(
      input: {
        investmentAccountName: $investmentAccountName
        beneficiaryId: $beneficiaryId
        terminationAge: $terminationAge
        stateCode: $stateCode
      }
    ) {
      __typename
      ... on InvestmentAccount {
        id
        beneficiaryId
        investmentAccountType
      }
      ... on UserNotFoundException {
        message
      }
      ... on UserNotVerifiedException {
        message
      }
      ... on CoreAccountClosedException {
        message
      }
      ... on InternalErrorException {
        message
      }
    }
  }
`
export type OpenEarlyAccountMutationMutationFn =
  ApolloReactCommon.MutationFunction<
    OpenEarlyAccountMutationMutation,
    OpenEarlyAccountMutationMutationVariables
  >

/**
 * __useOpenEarlyAccountMutationMutation__
 *
 * To run a mutation, you first call `useOpenEarlyAccountMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenEarlyAccountMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openEarlyAccountMutationMutation, { data, loading, error }] = useOpenEarlyAccountMutationMutation({
 *   variables: {
 *      investmentAccountName: // value for 'investmentAccountName'
 *      beneficiaryId: // value for 'beneficiaryId'
 *      terminationAge: // value for 'terminationAge'
 *      stateCode: // value for 'stateCode'
 *   },
 * });
 */
export function useOpenEarlyAccountMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    OpenEarlyAccountMutationMutation,
    OpenEarlyAccountMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    OpenEarlyAccountMutationMutation,
    OpenEarlyAccountMutationMutationVariables
  >(OpenEarlyAccountMutationDocument, options)
}
export type OpenEarlyAccountMutationMutationHookResult = ReturnType<
  typeof useOpenEarlyAccountMutationMutation
>
export type OpenEarlyAccountMutationMutationResult =
  ApolloReactCommon.MutationResult<OpenEarlyAccountMutationMutation>
export type OpenEarlyAccountMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    OpenEarlyAccountMutationMutation,
    OpenEarlyAccountMutationMutationVariables
  >
export const SetBeneficiarySsnDocument = /*#__PURE__*/ gql`
  mutation SetBeneficiarySsn($id: ID!, $ssn: String!) {
    setBeneficiarySsn(id: $id, ssn: $ssn) {
      __typename
      ... on Beneficiary {
        id
      }
      ... on BeneficiaryNotFoundException {
        message
      }
      ... on InvalidSsnException {
        message
      }
      ... on SsnAlreadyInUseException {
        message
      }
      ... on SecretSquirrelException {
        message
      }
      ... on SsnUpdateForbiddenException {
        message
      }
      ... on InternalErrorException {
        message
      }
    }
  }
`
export type SetBeneficiarySsnMutationFn = ApolloReactCommon.MutationFunction<
  SetBeneficiarySsnMutation,
  SetBeneficiarySsnMutationVariables
>

/**
 * __useSetBeneficiarySsnMutation__
 *
 * To run a mutation, you first call `useSetBeneficiarySsnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBeneficiarySsnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBeneficiarySsnMutation, { data, loading, error }] = useSetBeneficiarySsnMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ssn: // value for 'ssn'
 *   },
 * });
 */
export function useSetBeneficiarySsnMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SetBeneficiarySsnMutation,
    SetBeneficiarySsnMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SetBeneficiarySsnMutation,
    SetBeneficiarySsnMutationVariables
  >(SetBeneficiarySsnDocument, options)
}
export type SetBeneficiarySsnMutationHookResult = ReturnType<
  typeof useSetBeneficiarySsnMutation
>
export type SetBeneficiarySsnMutationResult =
  ApolloReactCommon.MutationResult<SetBeneficiarySsnMutation>
export type SetBeneficiarySsnMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SetBeneficiarySsnMutation,
    SetBeneficiarySsnMutationVariables
  >
export const StopRecurringInvestmentMutationDocument = /*#__PURE__*/ gql`
  mutation stopRecurringInvestmentMutation($investment_account_id: String!) {
    stopRecurringInvestment(investmentAccountId: $investment_account_id) {
      recurringInvestmentSettings {
        amount
        day
        frequency
      }
    }
  }
`
export type StopRecurringInvestmentMutationMutationFn =
  ApolloReactCommon.MutationFunction<
    StopRecurringInvestmentMutationMutation,
    StopRecurringInvestmentMutationMutationVariables
  >

/**
 * __useStopRecurringInvestmentMutationMutation__
 *
 * To run a mutation, you first call `useStopRecurringInvestmentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopRecurringInvestmentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopRecurringInvestmentMutationMutation, { data, loading, error }] = useStopRecurringInvestmentMutationMutation({
 *   variables: {
 *      investment_account_id: // value for 'investment_account_id'
 *   },
 * });
 */
export function useStopRecurringInvestmentMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    StopRecurringInvestmentMutationMutation,
    StopRecurringInvestmentMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    StopRecurringInvestmentMutationMutation,
    StopRecurringInvestmentMutationMutationVariables
  >(StopRecurringInvestmentMutationDocument, options)
}
export type StopRecurringInvestmentMutationMutationHookResult = ReturnType<
  typeof useStopRecurringInvestmentMutationMutation
>
export type StopRecurringInvestmentMutationMutationResult =
  ApolloReactCommon.MutationResult<StopRecurringInvestmentMutationMutation>
export type StopRecurringInvestmentMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    StopRecurringInvestmentMutationMutation,
    StopRecurringInvestmentMutationMutationVariables
  >
export const EarlySubscribeUserToTierDocument = /*#__PURE__*/ gql`
  mutation EarlySubscribeUserToTier($tierPriceId: ID!) {
    subscribeUserToTier(input: { tierPriceId: $tierPriceId }) {
      __typename
      ... on TierSubscription {
        id
      }
    }
  }
`
export type EarlySubscribeUserToTierMutationFn =
  ApolloReactCommon.MutationFunction<
    EarlySubscribeUserToTierMutation,
    EarlySubscribeUserToTierMutationVariables
  >

/**
 * __useEarlySubscribeUserToTierMutation__
 *
 * To run a mutation, you first call `useEarlySubscribeUserToTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEarlySubscribeUserToTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [earlySubscribeUserToTierMutation, { data, loading, error }] = useEarlySubscribeUserToTierMutation({
 *   variables: {
 *      tierPriceId: // value for 'tierPriceId'
 *   },
 * });
 */
export function useEarlySubscribeUserToTierMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EarlySubscribeUserToTierMutation,
    EarlySubscribeUserToTierMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    EarlySubscribeUserToTierMutation,
    EarlySubscribeUserToTierMutationVariables
  >(EarlySubscribeUserToTierDocument, options)
}
export type EarlySubscribeUserToTierMutationHookResult = ReturnType<
  typeof useEarlySubscribeUserToTierMutation
>
export type EarlySubscribeUserToTierMutationResult =
  ApolloReactCommon.MutationResult<EarlySubscribeUserToTierMutation>
export type EarlySubscribeUserToTierMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    EarlySubscribeUserToTierMutation,
    EarlySubscribeUserToTierMutationVariables
  >
export const SuspendDepositsDocument = /*#__PURE__*/ gql`
  mutation SuspendDeposits($suspended: Boolean!) {
    suspendDeposits(suspended: $suspended)
  }
`
export type SuspendDepositsMutationFn = ApolloReactCommon.MutationFunction<
  SuspendDepositsMutation,
  SuspendDepositsMutationVariables
>

/**
 * __useSuspendDepositsMutation__
 *
 * To run a mutation, you first call `useSuspendDepositsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendDepositsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendDepositsMutation, { data, loading, error }] = useSuspendDepositsMutation({
 *   variables: {
 *      suspended: // value for 'suspended'
 *   },
 * });
 */
export function useSuspendDepositsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SuspendDepositsMutation,
    SuspendDepositsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SuspendDepositsMutation,
    SuspendDepositsMutationVariables
  >(SuspendDepositsDocument, options)
}
export type SuspendDepositsMutationHookResult = ReturnType<
  typeof useSuspendDepositsMutation
>
export type SuspendDepositsMutationResult =
  ApolloReactCommon.MutationResult<SuspendDepositsMutation>
export type SuspendDepositsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SuspendDepositsMutation,
    SuspendDepositsMutationVariables
  >
export const UpdateRecurringInvestmentMutationDocument = /*#__PURE__*/ gql`
  mutation updateRecurringInvestmentMutation(
    $amount: Float!
    $day: Int!
    $frequency: InvestmentFrequency!
    $investment_account_id: String!
  ) {
    updateRecurringInvestment(
      input: {
        amount: $amount
        day: $day
        frequency: $frequency
        investmentAccountId: $investment_account_id
      }
    ) {
      recurringInvestmentSettings {
        amount
        day
        frequency
      }
    }
  }
`
export type UpdateRecurringInvestmentMutationMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdateRecurringInvestmentMutationMutation,
    UpdateRecurringInvestmentMutationMutationVariables
  >

/**
 * __useUpdateRecurringInvestmentMutationMutation__
 *
 * To run a mutation, you first call `useUpdateRecurringInvestmentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecurringInvestmentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecurringInvestmentMutationMutation, { data, loading, error }] = useUpdateRecurringInvestmentMutationMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      day: // value for 'day'
 *      frequency: // value for 'frequency'
 *      investment_account_id: // value for 'investment_account_id'
 *   },
 * });
 */
export function useUpdateRecurringInvestmentMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateRecurringInvestmentMutationMutation,
    UpdateRecurringInvestmentMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateRecurringInvestmentMutationMutation,
    UpdateRecurringInvestmentMutationMutationVariables
  >(UpdateRecurringInvestmentMutationDocument, options)
}
export type UpdateRecurringInvestmentMutationMutationHookResult = ReturnType<
  typeof useUpdateRecurringInvestmentMutationMutation
>
export type UpdateRecurringInvestmentMutationMutationResult =
  ApolloReactCommon.MutationResult<UpdateRecurringInvestmentMutationMutation>
export type UpdateRecurringInvestmentMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateRecurringInvestmentMutationMutation,
    UpdateRecurringInvestmentMutationMutationVariables
  >
export const EarlyOneTimeFundingSourceInfoDocument = /*#__PURE__*/ gql`
  query EarlyOneTimeFundingSourceInfo {
    fundingSourceAccounts {
      balance
      last4
      institutionName
      status
      verified
      role
      id
      fundType
      accountName
    }
    settings {
      depositsSuspended
    }
    allBankAccounts(input: { type: spend }) {
      availableBalance {
        value
      }
    }
  }
`

/**
 * __useEarlyOneTimeFundingSourceInfoQuery__
 *
 * To run a query within a React component, call `useEarlyOneTimeFundingSourceInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarlyOneTimeFundingSourceInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarlyOneTimeFundingSourceInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useEarlyOneTimeFundingSourceInfoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    EarlyOneTimeFundingSourceInfoQuery,
    EarlyOneTimeFundingSourceInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EarlyOneTimeFundingSourceInfoQuery,
    EarlyOneTimeFundingSourceInfoQueryVariables
  >(EarlyOneTimeFundingSourceInfoDocument, options)
}
export function useEarlyOneTimeFundingSourceInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EarlyOneTimeFundingSourceInfoQuery,
    EarlyOneTimeFundingSourceInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EarlyOneTimeFundingSourceInfoQuery,
    EarlyOneTimeFundingSourceInfoQueryVariables
  >(EarlyOneTimeFundingSourceInfoDocument, options)
}
export type EarlyOneTimeFundingSourceInfoQueryHookResult = ReturnType<
  typeof useEarlyOneTimeFundingSourceInfoQuery
>
export type EarlyOneTimeFundingSourceInfoLazyQueryHookResult = ReturnType<
  typeof useEarlyOneTimeFundingSourceInfoLazyQuery
>
export type EarlyOneTimeFundingSourceInfoQueryResult =
  ApolloReactCommon.QueryResult<
    EarlyOneTimeFundingSourceInfoQuery,
    EarlyOneTimeFundingSourceInfoQueryVariables
  >
export const EarlyPotentialAgreeToAcceptanceDocumentDocument = /*#__PURE__*/ gql`
  mutation EarlyPotentialAgreeToAcceptanceDocument($id: ID!) {
    agreeToAcceptanceDocument(id: $id)
  }
`
export type EarlyPotentialAgreeToAcceptanceDocumentMutationFn =
  ApolloReactCommon.MutationFunction<
    EarlyPotentialAgreeToAcceptanceDocumentMutation,
    EarlyPotentialAgreeToAcceptanceDocumentMutationVariables
  >

/**
 * __useEarlyPotentialAgreeToAcceptanceDocumentMutation__
 *
 * To run a mutation, you first call `useEarlyPotentialAgreeToAcceptanceDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEarlyPotentialAgreeToAcceptanceDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [earlyPotentialAgreeToAcceptanceDocumentMutation, { data, loading, error }] = useEarlyPotentialAgreeToAcceptanceDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEarlyPotentialAgreeToAcceptanceDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EarlyPotentialAgreeToAcceptanceDocumentMutation,
    EarlyPotentialAgreeToAcceptanceDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    EarlyPotentialAgreeToAcceptanceDocumentMutation,
    EarlyPotentialAgreeToAcceptanceDocumentMutationVariables
  >(EarlyPotentialAgreeToAcceptanceDocumentDocument, options)
}
export type EarlyPotentialAgreeToAcceptanceDocumentMutationHookResult =
  ReturnType<typeof useEarlyPotentialAgreeToAcceptanceDocumentMutation>
export type EarlyPotentialAgreeToAcceptanceDocumentMutationResult =
  ApolloReactCommon.MutationResult<EarlyPotentialAgreeToAcceptanceDocumentMutation>
export type EarlyPotentialAgreeToAcceptanceDocumentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    EarlyPotentialAgreeToAcceptanceDocumentMutation,
    EarlyPotentialAgreeToAcceptanceDocumentMutationVariables
  >
export const InvestmentAccountsByUserIdDocument = /*#__PURE__*/ gql`
  query InvestmentAccountsByUserId {
    investmentAccountsByUserId(filter: { product: EARLY }) {
      beneficiaryId
      id
      beneficiary {
        age
        firstName
      }
      currentBalance {
        value
      }
      pendingBalance {
        value
      }
      currentBalance {
        value
      }
      recurringInvestmentSettings {
        frequency
        day
        amount
      }
      transferability {
        transferAge
      }
    }
    acceptanceDocuments(requiredFor: "early_hypothetical_potential") {
      id
    }
  }
`

/**
 * __useInvestmentAccountsByUserIdQuery__
 *
 * To run a query within a React component, call `useInvestmentAccountsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestmentAccountsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestmentAccountsByUserIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvestmentAccountsByUserIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    InvestmentAccountsByUserIdQuery,
    InvestmentAccountsByUserIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    InvestmentAccountsByUserIdQuery,
    InvestmentAccountsByUserIdQueryVariables
  >(InvestmentAccountsByUserIdDocument, options)
}
export function useInvestmentAccountsByUserIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InvestmentAccountsByUserIdQuery,
    InvestmentAccountsByUserIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    InvestmentAccountsByUserIdQuery,
    InvestmentAccountsByUserIdQueryVariables
  >(InvestmentAccountsByUserIdDocument, options)
}
export type InvestmentAccountsByUserIdQueryHookResult = ReturnType<
  typeof useInvestmentAccountsByUserIdQuery
>
export type InvestmentAccountsByUserIdLazyQueryHookResult = ReturnType<
  typeof useInvestmentAccountsByUserIdLazyQuery
>
export type InvestmentAccountsByUserIdQueryResult =
  ApolloReactCommon.QueryResult<
    InvestmentAccountsByUserIdQuery,
    InvestmentAccountsByUserIdQueryVariables
  >
export const OpenedAccountsDocument = /*#__PURE__*/ gql`
  query openedAccounts {
    accounts(status: open) {
      accountType
    }
  }
`

/**
 * __useOpenedAccountsQuery__
 *
 * To run a query within a React component, call `useOpenedAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenedAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenedAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOpenedAccountsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    OpenedAccountsQuery,
    OpenedAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    OpenedAccountsQuery,
    OpenedAccountsQueryVariables
  >(OpenedAccountsDocument, options)
}
export function useOpenedAccountsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    OpenedAccountsQuery,
    OpenedAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    OpenedAccountsQuery,
    OpenedAccountsQueryVariables
  >(OpenedAccountsDocument, options)
}
export type OpenedAccountsQueryHookResult = ReturnType<
  typeof useOpenedAccountsQuery
>
export type OpenedAccountsLazyQueryHookResult = ReturnType<
  typeof useOpenedAccountsLazyQuery
>
export type OpenedAccountsQueryResult = ApolloReactCommon.QueryResult<
  OpenedAccountsQuery,
  OpenedAccountsQueryVariables
>
export const SplitDepositSettingsByUserIdDocument = /*#__PURE__*/ gql`
  query splitDepositSettingsByUserId($withSmartDeposit: Boolean = false) {
    splitDepositSettingsByUserId(
      filter: {
        settingTypes: [DIRECT_DEPOSIT, DIRECT_DEPOSIT_INTENT]
        showHiddenEmployerSettings: false
      }
      normalizeToFrequency: DAILY
    ) @include(if: $withSmartDeposit) {
      allocations {
        ...SmartDepositAllocationFragment
      }
      id
      isActive
      isHidden
      ... on SplitDepositDirectDepositIntentSetting {
        ...SplitDepositIntentSettingFragment
      }
      ... on SplitDepositDirectDepositSetting {
        ...SplitDepositDirectDepositSettingFragment
      }
      deposits(orderBy: DESC, limit: 1) {
        ...SplitDepositFragment
      }
      __typename
    }
  }
  ${SmartDepositAllocationFragmentFragmentDoc}
  ${SplitDepositIntentSettingFragmentFragmentDoc}
  ${SplitDepositDirectDepositSettingFragmentFragmentDoc}
  ${SplitDepositFragmentFragmentDoc}
`

/**
 * __useSplitDepositSettingsByUserIdQuery__
 *
 * To run a query within a React component, call `useSplitDepositSettingsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSplitDepositSettingsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSplitDepositSettingsByUserIdQuery({
 *   variables: {
 *      withSmartDeposit: // value for 'withSmartDeposit'
 *   },
 * });
 */
export function useSplitDepositSettingsByUserIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SplitDepositSettingsByUserIdQuery,
    SplitDepositSettingsByUserIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SplitDepositSettingsByUserIdQuery,
    SplitDepositSettingsByUserIdQueryVariables
  >(SplitDepositSettingsByUserIdDocument, options)
}
export function useSplitDepositSettingsByUserIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SplitDepositSettingsByUserIdQuery,
    SplitDepositSettingsByUserIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SplitDepositSettingsByUserIdQuery,
    SplitDepositSettingsByUserIdQueryVariables
  >(SplitDepositSettingsByUserIdDocument, options)
}
export type SplitDepositSettingsByUserIdQueryHookResult = ReturnType<
  typeof useSplitDepositSettingsByUserIdQuery
>
export type SplitDepositSettingsByUserIdLazyQueryHookResult = ReturnType<
  typeof useSplitDepositSettingsByUserIdLazyQuery
>
export type SplitDepositSettingsByUserIdQueryResult =
  ApolloReactCommon.QueryResult<
    SplitDepositSettingsByUserIdQuery,
    SplitDepositSettingsByUserIdQueryVariables
  >
export const EnableQuarterlyRecapsDocument = /*#__PURE__*/ gql`
  mutation EnableQuarterlyRecaps(
    $investmentAccountId: ID!
    $enabled: Boolean!
  ) {
    enableQuarterlyRecaps(
      input: { investmentAccountId: $investmentAccountId, enabled: $enabled }
    ) {
      __typename
      ... on InvestmentAccount {
        id
        beneficiaryId
        investmentAccountType
      }
      ... on InvalidSubscriptionTierException {
        currentUserTierKey
      }
      ... on InvestmentAccountNotFoundException {
        message
      }
      ... on InvestmentAccountNotSupportedException {
        message
      }
    }
  }
`
export type EnableQuarterlyRecapsMutationFn =
  ApolloReactCommon.MutationFunction<
    EnableQuarterlyRecapsMutation,
    EnableQuarterlyRecapsMutationVariables
  >

/**
 * __useEnableQuarterlyRecapsMutation__
 *
 * To run a mutation, you first call `useEnableQuarterlyRecapsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableQuarterlyRecapsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableQuarterlyRecapsMutation, { data, loading, error }] = useEnableQuarterlyRecapsMutation({
 *   variables: {
 *      investmentAccountId: // value for 'investmentAccountId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useEnableQuarterlyRecapsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EnableQuarterlyRecapsMutation,
    EnableQuarterlyRecapsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    EnableQuarterlyRecapsMutation,
    EnableQuarterlyRecapsMutationVariables
  >(EnableQuarterlyRecapsDocument, options)
}
export type EnableQuarterlyRecapsMutationHookResult = ReturnType<
  typeof useEnableQuarterlyRecapsMutation
>
export type EnableQuarterlyRecapsMutationResult =
  ApolloReactCommon.MutationResult<EnableQuarterlyRecapsMutation>
export type EnableQuarterlyRecapsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    EnableQuarterlyRecapsMutation,
    EnableQuarterlyRecapsMutationVariables
  >
export const UpdateBeneficiaryInfoDocument = /*#__PURE__*/ gql`
  mutation UpdateBeneficiaryInfo($id: ID!, $input: BeneficiaryInfoInput!) {
    updateBeneficiaryInfo(id: $id, input: $input) {
      __typename
      ... on Beneficiary {
        investmentAccount {
          id
          beneficiaryId
          investmentAccountType
        }
        custodianNickname
      }
      ... on BeneficiaryNotFoundException {
        message
      }
      ... on InternalErrorException {
        message
      }
      ... on InvalidAddressException {
        message
      }
      ... on InvalidEmailException {
        message
      }
      ... on InvalidPhoneException {
        message
      }
    }
  }
`
export type UpdateBeneficiaryInfoMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdateBeneficiaryInfoMutation,
    UpdateBeneficiaryInfoMutationVariables
  >

/**
 * __useUpdateBeneficiaryInfoMutation__
 *
 * To run a mutation, you first call `useUpdateBeneficiaryInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBeneficiaryInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBeneficiaryInfoMutation, { data, loading, error }] = useUpdateBeneficiaryInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBeneficiaryInfoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateBeneficiaryInfoMutation,
    UpdateBeneficiaryInfoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateBeneficiaryInfoMutation,
    UpdateBeneficiaryInfoMutationVariables
  >(UpdateBeneficiaryInfoDocument, options)
}
export type UpdateBeneficiaryInfoMutationHookResult = ReturnType<
  typeof useUpdateBeneficiaryInfoMutation
>
export type UpdateBeneficiaryInfoMutationResult =
  ApolloReactCommon.MutationResult<UpdateBeneficiaryInfoMutation>
export type UpdateBeneficiaryInfoMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateBeneficiaryInfoMutation,
    UpdateBeneficiaryInfoMutationVariables
  >
export const RegenerateInvestmentAccountRecapPublicTokenDocument = /*#__PURE__*/ gql`
  mutation RegenerateInvestmentAccountRecapPublicToken($id: ID!) {
    regenerateInvestmentAccountRecapPublicToken(input: { id: $id }) {
      __typename
      ... on InvestmentAccountRecap {
        id
        public
        publicUrl
      }
      ... on InvestmentAccountRecapNotFoundException {
        message
      }
    }
  }
`
export type RegenerateInvestmentAccountRecapPublicTokenMutationFn =
  ApolloReactCommon.MutationFunction<
    RegenerateInvestmentAccountRecapPublicTokenMutation,
    RegenerateInvestmentAccountRecapPublicTokenMutationVariables
  >

/**
 * __useRegenerateInvestmentAccountRecapPublicTokenMutation__
 *
 * To run a mutation, you first call `useRegenerateInvestmentAccountRecapPublicTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateInvestmentAccountRecapPublicTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateInvestmentAccountRecapPublicTokenMutation, { data, loading, error }] = useRegenerateInvestmentAccountRecapPublicTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegenerateInvestmentAccountRecapPublicTokenMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RegenerateInvestmentAccountRecapPublicTokenMutation,
    RegenerateInvestmentAccountRecapPublicTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RegenerateInvestmentAccountRecapPublicTokenMutation,
    RegenerateInvestmentAccountRecapPublicTokenMutationVariables
  >(RegenerateInvestmentAccountRecapPublicTokenDocument, options)
}
export type RegenerateInvestmentAccountRecapPublicTokenMutationHookResult =
  ReturnType<typeof useRegenerateInvestmentAccountRecapPublicTokenMutation>
export type RegenerateInvestmentAccountRecapPublicTokenMutationResult =
  ApolloReactCommon.MutationResult<RegenerateInvestmentAccountRecapPublicTokenMutation>
export type RegenerateInvestmentAccountRecapPublicTokenMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RegenerateInvestmentAccountRecapPublicTokenMutation,
    RegenerateInvestmentAccountRecapPublicTokenMutationVariables
  >
export const SetInvestmentAccountRecapPublicAccessDocument = /*#__PURE__*/ gql`
  mutation SetInvestmentAccountRecapPublicAccess($id: ID!, $public: Boolean!) {
    setInvestmentAccountRecapPublicAccess(input: { id: $id, public: $public }) {
      __typename
      ... on InvestmentAccountRecap {
        id
        public
        publicUrl
      }
      ... on InvestmentAccountRecapNotFoundException {
        message
      }
    }
  }
`
export type SetInvestmentAccountRecapPublicAccessMutationFn =
  ApolloReactCommon.MutationFunction<
    SetInvestmentAccountRecapPublicAccessMutation,
    SetInvestmentAccountRecapPublicAccessMutationVariables
  >

/**
 * __useSetInvestmentAccountRecapPublicAccessMutation__
 *
 * To run a mutation, you first call `useSetInvestmentAccountRecapPublicAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInvestmentAccountRecapPublicAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInvestmentAccountRecapPublicAccessMutation, { data, loading, error }] = useSetInvestmentAccountRecapPublicAccessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      public: // value for 'public'
 *   },
 * });
 */
export function useSetInvestmentAccountRecapPublicAccessMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SetInvestmentAccountRecapPublicAccessMutation,
    SetInvestmentAccountRecapPublicAccessMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SetInvestmentAccountRecapPublicAccessMutation,
    SetInvestmentAccountRecapPublicAccessMutationVariables
  >(SetInvestmentAccountRecapPublicAccessDocument, options)
}
export type SetInvestmentAccountRecapPublicAccessMutationHookResult =
  ReturnType<typeof useSetInvestmentAccountRecapPublicAccessMutation>
export type SetInvestmentAccountRecapPublicAccessMutationResult =
  ApolloReactCommon.MutationResult<SetInvestmentAccountRecapPublicAccessMutation>
export type SetInvestmentAccountRecapPublicAccessMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SetInvestmentAccountRecapPublicAccessMutation,
    SetInvestmentAccountRecapPublicAccessMutationVariables
  >
export const SubscribeUserToTierDocument = /*#__PURE__*/ gql`
  mutation SubscribeUserToTier($tierPriceId: ID!) {
    subscribeUserToTier(input: { createdBy: USER, tierPriceId: $tierPriceId }) {
      ... on TierSubscription {
        tier {
          name
          tierPrice {
            id
          }
        }
      }
      ... on InvalidTierPriceId {
        message
      }
      ... on TierDowngradeActionRequired {
        actions {
          key
        }
      }
    }
  }
`
export type SubscribeUserToTierMutationFn = ApolloReactCommon.MutationFunction<
  SubscribeUserToTierMutation,
  SubscribeUserToTierMutationVariables
>

/**
 * __useSubscribeUserToTierMutation__
 *
 * To run a mutation, you first call `useSubscribeUserToTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeUserToTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeUserToTierMutation, { data, loading, error }] = useSubscribeUserToTierMutation({
 *   variables: {
 *      tierPriceId: // value for 'tierPriceId'
 *   },
 * });
 */
export function useSubscribeUserToTierMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SubscribeUserToTierMutation,
    SubscribeUserToTierMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SubscribeUserToTierMutation,
    SubscribeUserToTierMutationVariables
  >(SubscribeUserToTierDocument, options)
}
export type SubscribeUserToTierMutationHookResult = ReturnType<
  typeof useSubscribeUserToTierMutation
>
export type SubscribeUserToTierMutationResult =
  ApolloReactCommon.MutationResult<SubscribeUserToTierMutation>
export type SubscribeUserToTierMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SubscribeUserToTierMutation,
    SubscribeUserToTierMutationVariables
  >
export const AllPastEarlyTransactionsDocument = /*#__PURE__*/ gql`
  query AllPastEarlyTransactions(
    $filter: AllPastItemsFilter
    $pagination: PageInput!
  ) {
    allPastItems(filter: $filter, pagination: $pagination) {
      edges {
        cursor
        node {
          __typename
          id
          title
          status
          createdAt
          updatedAt
          amount {
            currency
            value
          }
          reversible
          ... on PastCoreTradedItem {
            tradeConfirmationUrl
          }
          ... on PastAnnotatedItem {
            note
            noteAuthor
          }
          ... on EarlyDividendsItem {
            etfCategory
            etfTicker
          }
          ... on PastInvestmentItem {
            productAccountType
            transactionType
          }
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        limit
      }
    }
  }
`

/**
 * __useAllPastEarlyTransactionsQuery__
 *
 * To run a query within a React component, call `useAllPastEarlyTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPastEarlyTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPastEarlyTransactionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAllPastEarlyTransactionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    AllPastEarlyTransactionsQuery,
    AllPastEarlyTransactionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AllPastEarlyTransactionsQuery,
    AllPastEarlyTransactionsQueryVariables
  >(AllPastEarlyTransactionsDocument, options)
}
export function useAllPastEarlyTransactionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AllPastEarlyTransactionsQuery,
    AllPastEarlyTransactionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AllPastEarlyTransactionsQuery,
    AllPastEarlyTransactionsQueryVariables
  >(AllPastEarlyTransactionsDocument, options)
}
export type AllPastEarlyTransactionsQueryHookResult = ReturnType<
  typeof useAllPastEarlyTransactionsQuery
>
export type AllPastEarlyTransactionsLazyQueryHookResult = ReturnType<
  typeof useAllPastEarlyTransactionsLazyQuery
>
export type AllPastEarlyTransactionsQueryResult = ApolloReactCommon.QueryResult<
  AllPastEarlyTransactionsQuery,
  AllPastEarlyTransactionsQueryVariables
>
export const EarlyPastSummaryDocument = /*#__PURE__*/ gql`
  query EarlyPastSummary($filter: PastSummaryFilter!) {
    pastSummary(pastSummaryFilter: $filter) {
      ... on EarlyHistorySummary {
        moneyIn {
          currency
          value
        }
        moneyOut {
          currency
          value
        }
        dividends {
          currency
          value
        }
        giftsReceived {
          currency
          value
        }
        earlyInvestMatches {
          currency
          value
        }
      }
    }
  }
`

/**
 * __useEarlyPastSummaryQuery__
 *
 * To run a query within a React component, call `useEarlyPastSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarlyPastSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarlyPastSummaryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEarlyPastSummaryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    EarlyPastSummaryQuery,
    EarlyPastSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EarlyPastSummaryQuery,
    EarlyPastSummaryQueryVariables
  >(EarlyPastSummaryDocument, options)
}
export function useEarlyPastSummaryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EarlyPastSummaryQuery,
    EarlyPastSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EarlyPastSummaryQuery,
    EarlyPastSummaryQueryVariables
  >(EarlyPastSummaryDocument, options)
}
export type EarlyPastSummaryQueryHookResult = ReturnType<
  typeof useEarlyPastSummaryQuery
>
export type EarlyPastSummaryLazyQueryHookResult = ReturnType<
  typeof useEarlyPastSummaryLazyQuery
>
export type EarlyPastSummaryQueryResult = ApolloReactCommon.QueryResult<
  EarlyPastSummaryQuery,
  EarlyPastSummaryQueryVariables
>
export const AcceptanceDocumentDocument = /*#__PURE__*/ gql`
  query AcceptanceDocument($type: String!) {
    acceptanceDocument(type: $type) {
      id
      name
      url
      type
    }
  }
`

/**
 * __useAcceptanceDocumentQuery__
 *
 * To run a query within a React component, call `useAcceptanceDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcceptanceDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcceptanceDocumentQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAcceptanceDocumentQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    AcceptanceDocumentQuery,
    AcceptanceDocumentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AcceptanceDocumentQuery,
    AcceptanceDocumentQueryVariables
  >(AcceptanceDocumentDocument, options)
}
export function useAcceptanceDocumentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AcceptanceDocumentQuery,
    AcceptanceDocumentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AcceptanceDocumentQuery,
    AcceptanceDocumentQueryVariables
  >(AcceptanceDocumentDocument, options)
}
export type AcceptanceDocumentQueryHookResult = ReturnType<
  typeof useAcceptanceDocumentQuery
>
export type AcceptanceDocumentLazyQueryHookResult = ReturnType<
  typeof useAcceptanceDocumentLazyQuery
>
export type AcceptanceDocumentQueryResult = ApolloReactCommon.QueryResult<
  AcceptanceDocumentQuery,
  AcceptanceDocumentQueryVariables
>
export const EarlyBeneficiariesDocument = /*#__PURE__*/ gql`
  query EarlyBeneficiaries {
    beneficiaries {
      ...EarlyBeneficiaryFields
    }
  }
  ${EarlyBeneficiaryFieldsFragmentDoc}
`

/**
 * __useEarlyBeneficiariesQuery__
 *
 * To run a query within a React component, call `useEarlyBeneficiariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarlyBeneficiariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarlyBeneficiariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEarlyBeneficiariesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    EarlyBeneficiariesQuery,
    EarlyBeneficiariesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EarlyBeneficiariesQuery,
    EarlyBeneficiariesQueryVariables
  >(EarlyBeneficiariesDocument, options)
}
export function useEarlyBeneficiariesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EarlyBeneficiariesQuery,
    EarlyBeneficiariesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EarlyBeneficiariesQuery,
    EarlyBeneficiariesQueryVariables
  >(EarlyBeneficiariesDocument, options)
}
export type EarlyBeneficiariesQueryHookResult = ReturnType<
  typeof useEarlyBeneficiariesQuery
>
export type EarlyBeneficiariesLazyQueryHookResult = ReturnType<
  typeof useEarlyBeneficiariesLazyQuery
>
export type EarlyBeneficiariesQueryResult = ApolloReactCommon.QueryResult<
  EarlyBeneficiariesQuery,
  EarlyBeneficiariesQueryVariables
>
export const AvailableTiersDocument = /*#__PURE__*/ gql`
  query AvailableTiers {
    tierGroupForUser {
      id
      tierOptions {
        tier {
          id
          active
          key
          name
          products {
            key
            name
          }
          tierPrice {
            amount {
              currency
              value
            }
            billingFrequency
            id
          }
        }
      }
    }
  }
`

/**
 * __useAvailableTiersQuery__
 *
 * To run a query within a React component, call `useAvailableTiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableTiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableTiersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableTiersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AvailableTiersQuery,
    AvailableTiersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AvailableTiersQuery,
    AvailableTiersQueryVariables
  >(AvailableTiersDocument, options)
}
export function useAvailableTiersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AvailableTiersQuery,
    AvailableTiersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AvailableTiersQuery,
    AvailableTiersQueryVariables
  >(AvailableTiersDocument, options)
}
export type AvailableTiersQueryHookResult = ReturnType<
  typeof useAvailableTiersQuery
>
export type AvailableTiersLazyQueryHookResult = ReturnType<
  typeof useAvailableTiersLazyQuery
>
export type AvailableTiersQueryResult = ApolloReactCommon.QueryResult<
  AvailableTiersQuery,
  AvailableTiersQueryVariables
>
export const RequestedBeneficiarydDocumentsDocument = /*#__PURE__*/ gql`
  query RequestedBeneficiarydDocuments {
    documentRequests(input: { type: beneficiarySsn, status: requested }) {
      edges {
        node {
          id
          externalId
        }
      }
    }
  }
`

/**
 * __useRequestedBeneficiarydDocumentsQuery__
 *
 * To run a query within a React component, call `useRequestedBeneficiarydDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestedBeneficiarydDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestedBeneficiarydDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRequestedBeneficiarydDocumentsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    RequestedBeneficiarydDocumentsQuery,
    RequestedBeneficiarydDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RequestedBeneficiarydDocumentsQuery,
    RequestedBeneficiarydDocumentsQueryVariables
  >(RequestedBeneficiarydDocumentsDocument, options)
}
export function useRequestedBeneficiarydDocumentsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RequestedBeneficiarydDocumentsQuery,
    RequestedBeneficiarydDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RequestedBeneficiarydDocumentsQuery,
    RequestedBeneficiarydDocumentsQueryVariables
  >(RequestedBeneficiarydDocumentsDocument, options)
}
export type RequestedBeneficiarydDocumentsQueryHookResult = ReturnType<
  typeof useRequestedBeneficiarydDocumentsQuery
>
export type RequestedBeneficiarydDocumentsLazyQueryHookResult = ReturnType<
  typeof useRequestedBeneficiarydDocumentsLazyQuery
>
export type RequestedBeneficiarydDocumentsQueryResult =
  ApolloReactCommon.QueryResult<
    RequestedBeneficiarydDocumentsQuery,
    RequestedBeneficiarydDocumentsQueryVariables
  >
export const EarlyAccountStateRegulationDocument = /*#__PURE__*/ gql`
  query earlyAccountStateRegulation($stateCode: String) {
    earlyAccountStateRegulation(stateCode: $stateCode) {
      __typename
      ... on EarlyAccountStateRegulation {
        state
        stateCode
        defaultAge
        minAge
        maxAge
        accountType
      }
      ... on InvalidStateException {
        message
      }
      ... on UserNotFoundException {
        message
      }
      ... on InternalErrorException {
        message
      }
    }
  }
`

/**
 * __useEarlyAccountStateRegulationQuery__
 *
 * To run a query within a React component, call `useEarlyAccountStateRegulationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarlyAccountStateRegulationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarlyAccountStateRegulationQuery({
 *   variables: {
 *      stateCode: // value for 'stateCode'
 *   },
 * });
 */
export function useEarlyAccountStateRegulationQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    EarlyAccountStateRegulationQuery,
    EarlyAccountStateRegulationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EarlyAccountStateRegulationQuery,
    EarlyAccountStateRegulationQueryVariables
  >(EarlyAccountStateRegulationDocument, options)
}
export function useEarlyAccountStateRegulationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EarlyAccountStateRegulationQuery,
    EarlyAccountStateRegulationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EarlyAccountStateRegulationQuery,
    EarlyAccountStateRegulationQueryVariables
  >(EarlyAccountStateRegulationDocument, options)
}
export type EarlyAccountStateRegulationQueryHookResult = ReturnType<
  typeof useEarlyAccountStateRegulationQuery
>
export type EarlyAccountStateRegulationLazyQueryHookResult = ReturnType<
  typeof useEarlyAccountStateRegulationLazyQuery
>
export type EarlyAccountStateRegulationQueryResult =
  ApolloReactCommon.QueryResult<
    EarlyAccountStateRegulationQuery,
    EarlyAccountStateRegulationQueryVariables
  >
export const EarlyAccountTransferInfoDocument = /*#__PURE__*/ gql`
  query EarlyAccountTransferInfo($investmentAccountId: ID!) {
    earlyAccountTransferInfo(investmentAccountId: $investmentAccountId) {
      terminationAge
      terminationDate
    }
  }
`

/**
 * __useEarlyAccountTransferInfoQuery__
 *
 * To run a query within a React component, call `useEarlyAccountTransferInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarlyAccountTransferInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarlyAccountTransferInfoQuery({
 *   variables: {
 *      investmentAccountId: // value for 'investmentAccountId'
 *   },
 * });
 */
export function useEarlyAccountTransferInfoQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    EarlyAccountTransferInfoQuery,
    EarlyAccountTransferInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EarlyAccountTransferInfoQuery,
    EarlyAccountTransferInfoQueryVariables
  >(EarlyAccountTransferInfoDocument, options)
}
export function useEarlyAccountTransferInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EarlyAccountTransferInfoQuery,
    EarlyAccountTransferInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EarlyAccountTransferInfoQuery,
    EarlyAccountTransferInfoQueryVariables
  >(EarlyAccountTransferInfoDocument, options)
}
export type EarlyAccountTransferInfoQueryHookResult = ReturnType<
  typeof useEarlyAccountTransferInfoQuery
>
export type EarlyAccountTransferInfoLazyQueryHookResult = ReturnType<
  typeof useEarlyAccountTransferInfoLazyQuery
>
export type EarlyAccountTransferInfoQueryResult = ApolloReactCommon.QueryResult<
  EarlyAccountTransferInfoQuery,
  EarlyAccountTransferInfoQueryVariables
>
export const EarlyInvestmentAccountsDocument = /*#__PURE__*/ gql`
  query earlyInvestmentAccounts {
    investmentAccountsByUserId(filter: { product: EARLY }) {
      id
      type
      name
      beneficiaryId
      status
      beneficiary {
        id
        firstName
        lastName
      }
      currentBalance {
        value
      }
      transferability {
        transferStateCode
      }
    }
  }
`

/**
 * __useEarlyInvestmentAccountsQuery__
 *
 * To run a query within a React component, call `useEarlyInvestmentAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarlyInvestmentAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarlyInvestmentAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEarlyInvestmentAccountsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    EarlyInvestmentAccountsQuery,
    EarlyInvestmentAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EarlyInvestmentAccountsQuery,
    EarlyInvestmentAccountsQueryVariables
  >(EarlyInvestmentAccountsDocument, options)
}
export function useEarlyInvestmentAccountsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EarlyInvestmentAccountsQuery,
    EarlyInvestmentAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EarlyInvestmentAccountsQuery,
    EarlyInvestmentAccountsQueryVariables
  >(EarlyInvestmentAccountsDocument, options)
}
export type EarlyInvestmentAccountsQueryHookResult = ReturnType<
  typeof useEarlyInvestmentAccountsQuery
>
export type EarlyInvestmentAccountsLazyQueryHookResult = ReturnType<
  typeof useEarlyInvestmentAccountsLazyQuery
>
export type EarlyInvestmentAccountsQueryResult = ApolloReactCommon.QueryResult<
  EarlyInvestmentAccountsQuery,
  EarlyInvestmentAccountsQueryVariables
>
export const EarlyFundingSourceInfoDocument = /*#__PURE__*/ gql`
  query EarlyFundingSourceInfo {
    user {
      fundingSource {
        verified
      }
    }
    fundingSourceInfo {
      balance
      accountNumberLastFour
      name
      verified
    }
    linkedAccounts(linked: true) {
      institutionName
    }
    settings {
      depositsSuspended
    }
  }
`

/**
 * __useEarlyFundingSourceInfoQuery__
 *
 * To run a query within a React component, call `useEarlyFundingSourceInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarlyFundingSourceInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarlyFundingSourceInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useEarlyFundingSourceInfoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    EarlyFundingSourceInfoQuery,
    EarlyFundingSourceInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EarlyFundingSourceInfoQuery,
    EarlyFundingSourceInfoQueryVariables
  >(EarlyFundingSourceInfoDocument, options)
}
export function useEarlyFundingSourceInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EarlyFundingSourceInfoQuery,
    EarlyFundingSourceInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EarlyFundingSourceInfoQuery,
    EarlyFundingSourceInfoQueryVariables
  >(EarlyFundingSourceInfoDocument, options)
}
export type EarlyFundingSourceInfoQueryHookResult = ReturnType<
  typeof useEarlyFundingSourceInfoQuery
>
export type EarlyFundingSourceInfoLazyQueryHookResult = ReturnType<
  typeof useEarlyFundingSourceInfoLazyQuery
>
export type EarlyFundingSourceInfoQueryResult = ApolloReactCommon.QueryResult<
  EarlyFundingSourceInfoQuery,
  EarlyFundingSourceInfoQueryVariables
>
export const OutsideContributionCodeByInvestmentAccountIdDocument = /*#__PURE__*/ gql`
  query outsideContributionCodeByInvestmentAccountId(
    $investmentAccountId: ID!
  ) {
    outsideContributionCodeByInvestmentAccountId(
      investmentAccountId: $investmentAccountId
    ) {
      code
      url
    }
  }
`

/**
 * __useOutsideContributionCodeByInvestmentAccountIdQuery__
 *
 * To run a query within a React component, call `useOutsideContributionCodeByInvestmentAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutsideContributionCodeByInvestmentAccountIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutsideContributionCodeByInvestmentAccountIdQuery({
 *   variables: {
 *      investmentAccountId: // value for 'investmentAccountId'
 *   },
 * });
 */
export function useOutsideContributionCodeByInvestmentAccountIdQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    OutsideContributionCodeByInvestmentAccountIdQuery,
    OutsideContributionCodeByInvestmentAccountIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    OutsideContributionCodeByInvestmentAccountIdQuery,
    OutsideContributionCodeByInvestmentAccountIdQueryVariables
  >(OutsideContributionCodeByInvestmentAccountIdDocument, options)
}
export function useOutsideContributionCodeByInvestmentAccountIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    OutsideContributionCodeByInvestmentAccountIdQuery,
    OutsideContributionCodeByInvestmentAccountIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    OutsideContributionCodeByInvestmentAccountIdQuery,
    OutsideContributionCodeByInvestmentAccountIdQueryVariables
  >(OutsideContributionCodeByInvestmentAccountIdDocument, options)
}
export type OutsideContributionCodeByInvestmentAccountIdQueryHookResult =
  ReturnType<typeof useOutsideContributionCodeByInvestmentAccountIdQuery>
export type OutsideContributionCodeByInvestmentAccountIdLazyQueryHookResult =
  ReturnType<typeof useOutsideContributionCodeByInvestmentAccountIdLazyQuery>
export type OutsideContributionCodeByInvestmentAccountIdQueryResult =
  ApolloReactCommon.QueryResult<
    OutsideContributionCodeByInvestmentAccountIdQuery,
    OutsideContributionCodeByInvestmentAccountIdQueryVariables
  >
export const PortfoliosQueryDocument = /*#__PURE__*/ gql`
  query portfoliosQuery {
    portfolios {
      id
      name
      nameKey
      description
      portfolioSecurityAllocations {
        id
        symbol
        allocationPercent
        security {
          displayName
        }
        investmentCategories {
          bond
          crypto
          equity
        }
      }
    }
  }
`

/**
 * __usePortfoliosQueryQuery__
 *
 * To run a query within a React component, call `usePortfoliosQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfoliosQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfoliosQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePortfoliosQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PortfoliosQueryQuery,
    PortfoliosQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PortfoliosQueryQuery,
    PortfoliosQueryQueryVariables
  >(PortfoliosQueryDocument, options)
}
export function usePortfoliosQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PortfoliosQueryQuery,
    PortfoliosQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PortfoliosQueryQuery,
    PortfoliosQueryQueryVariables
  >(PortfoliosQueryDocument, options)
}
export type PortfoliosQueryQueryHookResult = ReturnType<
  typeof usePortfoliosQueryQuery
>
export type PortfoliosQueryLazyQueryHookResult = ReturnType<
  typeof usePortfoliosQueryLazyQuery
>
export type PortfoliosQueryQueryResult = ApolloReactCommon.QueryResult<
  PortfoliosQueryQuery,
  PortfoliosQueryQueryVariables
>
export const RecurringSettingsDocument = /*#__PURE__*/ gql`
  query recurringSettings {
    investmentAccountsByUserId {
      beneficiaryId
      closedAt
      recurringInvestmentSettings {
        amount
        frequency
        day
      }
    }
  }
`

/**
 * __useRecurringSettingsQuery__
 *
 * To run a query within a React component, call `useRecurringSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecurringSettingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    RecurringSettingsQuery,
    RecurringSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RecurringSettingsQuery,
    RecurringSettingsQueryVariables
  >(RecurringSettingsDocument, options)
}
export function useRecurringSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RecurringSettingsQuery,
    RecurringSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RecurringSettingsQuery,
    RecurringSettingsQueryVariables
  >(RecurringSettingsDocument, options)
}
export type RecurringSettingsQueryHookResult = ReturnType<
  typeof useRecurringSettingsQuery
>
export type RecurringSettingsLazyQueryHookResult = ReturnType<
  typeof useRecurringSettingsLazyQuery
>
export type RecurringSettingsQueryResult = ApolloReactCommon.QueryResult<
  RecurringSettingsQuery,
  RecurringSettingsQueryVariables
>
export const TierOptionByProductKeyDocument = /*#__PURE__*/ gql`
  query TierOptionByProductKey {
    tierOptionByProductKey(productKey: EARLY) {
      ... on TierOption {
        tier {
          id
          key
          includedProducts {
            key
          }
        }
        tierPrices {
          id
          billingFrequency
          amount {
            value
            currency
          }
        }
      }
    }
  }
`

/**
 * __useTierOptionByProductKeyQuery__
 *
 * To run a query within a React component, call `useTierOptionByProductKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTierOptionByProductKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTierOptionByProductKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useTierOptionByProductKeyQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    TierOptionByProductKeyQuery,
    TierOptionByProductKeyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    TierOptionByProductKeyQuery,
    TierOptionByProductKeyQueryVariables
  >(TierOptionByProductKeyDocument, options)
}
export function useTierOptionByProductKeyLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TierOptionByProductKeyQuery,
    TierOptionByProductKeyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    TierOptionByProductKeyQuery,
    TierOptionByProductKeyQueryVariables
  >(TierOptionByProductKeyDocument, options)
}
export type TierOptionByProductKeyQueryHookResult = ReturnType<
  typeof useTierOptionByProductKeyQuery
>
export type TierOptionByProductKeyLazyQueryHookResult = ReturnType<
  typeof useTierOptionByProductKeyLazyQuery
>
export type TierOptionByProductKeyQueryResult = ApolloReactCommon.QueryResult<
  TierOptionByProductKeyQuery,
  TierOptionByProductKeyQueryVariables
>
export const EarlyTierSubscriptionForUserDocument = /*#__PURE__*/ gql`
  query EarlyTierSubscriptionForUser {
    tierSubscriptionForUser {
      ... on TierSubscription {
        id
        tier {
          ...TierForEarly
        }
        tierPrice {
          id
          billingFrequency
          amount {
            value
            currency
          }
        }
      }
    }
  }
  ${TierForEarlyFragmentDoc}
`

/**
 * __useEarlyTierSubscriptionForUserQuery__
 *
 * To run a query within a React component, call `useEarlyTierSubscriptionForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarlyTierSubscriptionForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarlyTierSubscriptionForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useEarlyTierSubscriptionForUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    EarlyTierSubscriptionForUserQuery,
    EarlyTierSubscriptionForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EarlyTierSubscriptionForUserQuery,
    EarlyTierSubscriptionForUserQueryVariables
  >(EarlyTierSubscriptionForUserDocument, options)
}
export function useEarlyTierSubscriptionForUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EarlyTierSubscriptionForUserQuery,
    EarlyTierSubscriptionForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EarlyTierSubscriptionForUserQuery,
    EarlyTierSubscriptionForUserQueryVariables
  >(EarlyTierSubscriptionForUserDocument, options)
}
export type EarlyTierSubscriptionForUserQueryHookResult = ReturnType<
  typeof useEarlyTierSubscriptionForUserQuery
>
export type EarlyTierSubscriptionForUserLazyQueryHookResult = ReturnType<
  typeof useEarlyTierSubscriptionForUserLazyQuery
>
export type EarlyTierSubscriptionForUserQueryResult =
  ApolloReactCommon.QueryResult<
    EarlyTierSubscriptionForUserQuery,
    EarlyTierSubscriptionForUserQueryVariables
  >
export const UnverifiedSsnBeneficiariesAlertsDocument = /*#__PURE__*/ gql`
  query unverifiedSsnBeneficiariesAlerts {
    beneficiaryAlerts {
      ... on UnverifiedBeneficiarySsnAlert {
        beneficiary {
          id
          custodianId
          firstName
        }
      }
    }
  }
`

/**
 * __useUnverifiedSsnBeneficiariesAlertsQuery__
 *
 * To run a query within a React component, call `useUnverifiedSsnBeneficiariesAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnverifiedSsnBeneficiariesAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnverifiedSsnBeneficiariesAlertsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnverifiedSsnBeneficiariesAlertsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UnverifiedSsnBeneficiariesAlertsQuery,
    UnverifiedSsnBeneficiariesAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    UnverifiedSsnBeneficiariesAlertsQuery,
    UnverifiedSsnBeneficiariesAlertsQueryVariables
  >(UnverifiedSsnBeneficiariesAlertsDocument, options)
}
export function useUnverifiedSsnBeneficiariesAlertsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UnverifiedSsnBeneficiariesAlertsQuery,
    UnverifiedSsnBeneficiariesAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    UnverifiedSsnBeneficiariesAlertsQuery,
    UnverifiedSsnBeneficiariesAlertsQueryVariables
  >(UnverifiedSsnBeneficiariesAlertsDocument, options)
}
export type UnverifiedSsnBeneficiariesAlertsQueryHookResult = ReturnType<
  typeof useUnverifiedSsnBeneficiariesAlertsQuery
>
export type UnverifiedSsnBeneficiariesAlertsLazyQueryHookResult = ReturnType<
  typeof useUnverifiedSsnBeneficiariesAlertsLazyQuery
>
export type UnverifiedSsnBeneficiariesAlertsQueryResult =
  ApolloReactCommon.QueryResult<
    UnverifiedSsnBeneficiariesAlertsQuery,
    UnverifiedSsnBeneficiariesAlertsQueryVariables
  >
export const EarlyUserDocument = /*#__PURE__*/ gql`
  query EarlyUser {
    user {
      state
      verified
    }
    userAlerts {
      ... on UserAlert {
        type
      }
    }
    tierSubscriptionForUser {
      ... on TierSubscription {
        id
        tier {
          id
          key
          name
          includedProducts {
            key
          }
        }
      }
    }
  }
`

/**
 * __useEarlyUserQuery__
 *
 * To run a query within a React component, call `useEarlyUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarlyUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarlyUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useEarlyUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    EarlyUserQuery,
    EarlyUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<EarlyUserQuery, EarlyUserQueryVariables>(
    EarlyUserDocument,
    options,
  )
}
export function useEarlyUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EarlyUserQuery,
    EarlyUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<EarlyUserQuery, EarlyUserQueryVariables>(
    EarlyUserDocument,
    options,
  )
}
export type EarlyUserQueryHookResult = ReturnType<typeof useEarlyUserQuery>
export type EarlyUserLazyQueryHookResult = ReturnType<
  typeof useEarlyUserLazyQuery
>
export type EarlyUserQueryResult = ApolloReactCommon.QueryResult<
  EarlyUserQuery,
  EarlyUserQueryVariables
>
export const EarlyReferralDetailsDocument = /*#__PURE__*/ gql`
  query EarlyReferralDetails {
    acceptanceDocuments {
      name
      type
      summaryUrl
      id
      url
    }
    user {
      uuid
      email
      firstName
      lastName
    }
  }
`

/**
 * __useEarlyReferralDetailsQuery__
 *
 * To run a query within a React component, call `useEarlyReferralDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarlyReferralDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarlyReferralDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEarlyReferralDetailsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    EarlyReferralDetailsQuery,
    EarlyReferralDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EarlyReferralDetailsQuery,
    EarlyReferralDetailsQueryVariables
  >(EarlyReferralDetailsDocument, options)
}
export function useEarlyReferralDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EarlyReferralDetailsQuery,
    EarlyReferralDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EarlyReferralDetailsQuery,
    EarlyReferralDetailsQueryVariables
  >(EarlyReferralDetailsDocument, options)
}
export type EarlyReferralDetailsQueryHookResult = ReturnType<
  typeof useEarlyReferralDetailsQuery
>
export type EarlyReferralDetailsLazyQueryHookResult = ReturnType<
  typeof useEarlyReferralDetailsLazyQuery
>
export type EarlyReferralDetailsQueryResult = ApolloReactCommon.QueryResult<
  EarlyReferralDetailsQuery,
  EarlyReferralDetailsQueryVariables
>
export const SsnFileUploadDocument = /*#__PURE__*/ gql`
  mutation SSNFileUpload($file: Upload!, $documentRequestId: ID!) {
    uploadDocuments(
      input: {
        documents: [$file]
        documentType: beneficiarySsn
        documentRequestId: $documentRequestId
      }
    ) {
      ... on File {
        encoding
        filename
        mimetype
        url
      }
    }
  }
`
export type SsnFileUploadMutationFn = ApolloReactCommon.MutationFunction<
  SsnFileUploadMutation,
  SsnFileUploadMutationVariables
>

/**
 * __useSsnFileUploadMutation__
 *
 * To run a mutation, you first call `useSsnFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSsnFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ssnFileUploadMutation, { data, loading, error }] = useSsnFileUploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *      documentRequestId: // value for 'documentRequestId'
 *   },
 * });
 */
export function useSsnFileUploadMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SsnFileUploadMutation,
    SsnFileUploadMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SsnFileUploadMutation,
    SsnFileUploadMutationVariables
  >(SsnFileUploadDocument, options)
}
export type SsnFileUploadMutationHookResult = ReturnType<
  typeof useSsnFileUploadMutation
>
export type SsnFileUploadMutationResult =
  ApolloReactCommon.MutationResult<SsnFileUploadMutation>
export type SsnFileUploadMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SsnFileUploadMutation,
    SsnFileUploadMutationVariables
  >
export const EarlyWithdrawFundingSourceInfoDocument = /*#__PURE__*/ gql`
  query EarlyWithdrawFundingSourceInfo {
    fundingSourceAccounts {
      balance
      last4
      institutionName
      status
      verified
      role
      id
      fundType
      accountName
    }
    settings {
      depositsSuspended
    }
    user {
      fundingSource {
        verified
        name
        last4
      }
    }
    allBankAccounts(input: { type: spend }) {
      availableBalance {
        value
      }
    }
  }
`

/**
 * __useEarlyWithdrawFundingSourceInfoQuery__
 *
 * To run a query within a React component, call `useEarlyWithdrawFundingSourceInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarlyWithdrawFundingSourceInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarlyWithdrawFundingSourceInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useEarlyWithdrawFundingSourceInfoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    EarlyWithdrawFundingSourceInfoQuery,
    EarlyWithdrawFundingSourceInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EarlyWithdrawFundingSourceInfoQuery,
    EarlyWithdrawFundingSourceInfoQueryVariables
  >(EarlyWithdrawFundingSourceInfoDocument, options)
}
export function useEarlyWithdrawFundingSourceInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EarlyWithdrawFundingSourceInfoQuery,
    EarlyWithdrawFundingSourceInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EarlyWithdrawFundingSourceInfoQuery,
    EarlyWithdrawFundingSourceInfoQueryVariables
  >(EarlyWithdrawFundingSourceInfoDocument, options)
}
export type EarlyWithdrawFundingSourceInfoQueryHookResult = ReturnType<
  typeof useEarlyWithdrawFundingSourceInfoQuery
>
export type EarlyWithdrawFundingSourceInfoLazyQueryHookResult = ReturnType<
  typeof useEarlyWithdrawFundingSourceInfoLazyQuery
>
export type EarlyWithdrawFundingSourceInfoQueryResult =
  ApolloReactCommon.QueryResult<
    EarlyWithdrawFundingSourceInfoQuery,
    EarlyWithdrawFundingSourceInfoQueryVariables
  >
export const AgreeToAcceptanceDocumentDocument = /*#__PURE__*/ gql`
  mutation AgreeToAcceptanceDocument($id: ID!) {
    agreeToAcceptanceDocument(id: $id)
  }
`
export type AgreeToAcceptanceDocumentMutationFn =
  ApolloReactCommon.MutationFunction<
    AgreeToAcceptanceDocumentMutation,
    AgreeToAcceptanceDocumentMutationVariables
  >

/**
 * __useAgreeToAcceptanceDocumentMutation__
 *
 * To run a mutation, you first call `useAgreeToAcceptanceDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgreeToAcceptanceDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agreeToAcceptanceDocumentMutation, { data, loading, error }] = useAgreeToAcceptanceDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgreeToAcceptanceDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AgreeToAcceptanceDocumentMutation,
    AgreeToAcceptanceDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AgreeToAcceptanceDocumentMutation,
    AgreeToAcceptanceDocumentMutationVariables
  >(AgreeToAcceptanceDocumentDocument, options)
}
export type AgreeToAcceptanceDocumentMutationHookResult = ReturnType<
  typeof useAgreeToAcceptanceDocumentMutation
>
export type AgreeToAcceptanceDocumentMutationResult =
  ApolloReactCommon.MutationResult<AgreeToAcceptanceDocumentMutation>
export type AgreeToAcceptanceDocumentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AgreeToAcceptanceDocumentMutation,
    AgreeToAcceptanceDocumentMutationVariables
  >
export const EarnSubscribeUserToTierDocument = /*#__PURE__*/ gql`
  mutation EarnSubscribeUserToTier($tierPriceId: ID!) {
    subscribeUserToTier(input: { tierPriceId: $tierPriceId }) {
      __typename
      ... on TierSubscription {
        id
      }
    }
  }
`
export type EarnSubscribeUserToTierMutationFn =
  ApolloReactCommon.MutationFunction<
    EarnSubscribeUserToTierMutation,
    EarnSubscribeUserToTierMutationVariables
  >

/**
 * __useEarnSubscribeUserToTierMutation__
 *
 * To run a mutation, you first call `useEarnSubscribeUserToTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEarnSubscribeUserToTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [earnSubscribeUserToTierMutation, { data, loading, error }] = useEarnSubscribeUserToTierMutation({
 *   variables: {
 *      tierPriceId: // value for 'tierPriceId'
 *   },
 * });
 */
export function useEarnSubscribeUserToTierMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EarnSubscribeUserToTierMutation,
    EarnSubscribeUserToTierMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    EarnSubscribeUserToTierMutation,
    EarnSubscribeUserToTierMutationVariables
  >(EarnSubscribeUserToTierDocument, options)
}
export type EarnSubscribeUserToTierMutationHookResult = ReturnType<
  typeof useEarnSubscribeUserToTierMutation
>
export type EarnSubscribeUserToTierMutationResult =
  ApolloReactCommon.MutationResult<EarnSubscribeUserToTierMutation>
export type EarnSubscribeUserToTierMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    EarnSubscribeUserToTierMutation,
    EarnSubscribeUserToTierMutationVariables
  >
export const LinkedAccountsForEarnOfferDocument = /*#__PURE__*/ gql`
  query LinkedAccountsForEarnOffer {
    linkedAccounts(linked: true) {
      id
      institutionName
      logoUrl
      status
      externalSource
      linkedSubaccounts {
        id
        accountNumberLastFour
        name
      }
    }
    roundUpAccounts {
      linkedSubaccountId
      enabled
    }
  }
`

/**
 * __useLinkedAccountsForEarnOfferQuery__
 *
 * To run a query within a React component, call `useLinkedAccountsForEarnOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkedAccountsForEarnOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkedAccountsForEarnOfferQuery({
 *   variables: {
 *   },
 * });
 */
export function useLinkedAccountsForEarnOfferQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    LinkedAccountsForEarnOfferQuery,
    LinkedAccountsForEarnOfferQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LinkedAccountsForEarnOfferQuery,
    LinkedAccountsForEarnOfferQueryVariables
  >(LinkedAccountsForEarnOfferDocument, options)
}
export function useLinkedAccountsForEarnOfferLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LinkedAccountsForEarnOfferQuery,
    LinkedAccountsForEarnOfferQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LinkedAccountsForEarnOfferQuery,
    LinkedAccountsForEarnOfferQueryVariables
  >(LinkedAccountsForEarnOfferDocument, options)
}
export type LinkedAccountsForEarnOfferQueryHookResult = ReturnType<
  typeof useLinkedAccountsForEarnOfferQuery
>
export type LinkedAccountsForEarnOfferLazyQueryHookResult = ReturnType<
  typeof useLinkedAccountsForEarnOfferLazyQuery
>
export type LinkedAccountsForEarnOfferQueryResult =
  ApolloReactCommon.QueryResult<
    LinkedAccountsForEarnOfferQuery,
    LinkedAccountsForEarnOfferQueryVariables
  >
export const AddFavoritePartnerOffersDocument = /*#__PURE__*/ gql`
  mutation AddFavoritePartnerOffers($input: FavoritePartnerOfferInput!) {
    addFavoritePartnerOffers(input: $input) {
      offers {
        ... on EarnOffer {
          displayName
          displayTitle
          dealType
          badgeCategory
          backgroundImageUrl
          campaignId
          campaignOfferId
          incentiveSummary
          isFavorite
          displaySubtitle
          colorBackgroundLogoImageUrl
          ownerId
          ownerDescription
        }
      }
    }
  }
`
export type AddFavoritePartnerOffersMutationFn =
  ApolloReactCommon.MutationFunction<
    AddFavoritePartnerOffersMutation,
    AddFavoritePartnerOffersMutationVariables
  >

/**
 * __useAddFavoritePartnerOffersMutation__
 *
 * To run a mutation, you first call `useAddFavoritePartnerOffersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoritePartnerOffersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoritePartnerOffersMutation, { data, loading, error }] = useAddFavoritePartnerOffersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFavoritePartnerOffersMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddFavoritePartnerOffersMutation,
    AddFavoritePartnerOffersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AddFavoritePartnerOffersMutation,
    AddFavoritePartnerOffersMutationVariables
  >(AddFavoritePartnerOffersDocument, options)
}
export type AddFavoritePartnerOffersMutationHookResult = ReturnType<
  typeof useAddFavoritePartnerOffersMutation
>
export type AddFavoritePartnerOffersMutationResult =
  ApolloReactCommon.MutationResult<AddFavoritePartnerOffersMutation>
export type AddFavoritePartnerOffersMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AddFavoritePartnerOffersMutation,
    AddFavoritePartnerOffersMutationVariables
  >
export const EarnIndexQueryDocument = /*#__PURE__*/ gql`
  query EarnIndexQuery(
    $partnerOfferGroupsTypeInput: PartnerOfferGroupsTypeInput!
  ) {
    activeEarnOffers {
      earnOffers {
        backgroundImageUrl
        badgeCategory
        colorBackgroundLogoImageUrl
        campaignId
        campaignOfferId
        dealType
        displayName
        displaySubtitle
        displayTitle
        ownerDescription
        ownerId
        promoted
        promotionRank
        incentiveSummary
      }
    }
    partnerOfferGroupsByType(
      partnerOfferGroupsTypeInput: $partnerOfferGroupsTypeInput
    ) {
      id
      title
      body
      offers {
        ... on EarnOffer {
          keyphraseCategoryNames
          displayName
          dealType
          badgeCategory
          backgroundImageUrl
          campaignId
          campaignOfferId
          incentiveSummary
          displaySubtitle
          displayTitle
          colorBackgroundLogoImageUrl
          ownerId
          ownerDescription
        }
      }
    }
  }
`

/**
 * __useEarnIndexQueryQuery__
 *
 * To run a query within a React component, call `useEarnIndexQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarnIndexQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarnIndexQueryQuery({
 *   variables: {
 *      partnerOfferGroupsTypeInput: // value for 'partnerOfferGroupsTypeInput'
 *   },
 * });
 */
export function useEarnIndexQueryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    EarnIndexQueryQuery,
    EarnIndexQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EarnIndexQueryQuery,
    EarnIndexQueryQueryVariables
  >(EarnIndexQueryDocument, options)
}
export function useEarnIndexQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EarnIndexQueryQuery,
    EarnIndexQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EarnIndexQueryQuery,
    EarnIndexQueryQueryVariables
  >(EarnIndexQueryDocument, options)
}
export type EarnIndexQueryQueryHookResult = ReturnType<
  typeof useEarnIndexQueryQuery
>
export type EarnIndexQueryLazyQueryHookResult = ReturnType<
  typeof useEarnIndexQueryLazyQuery
>
export type EarnIndexQueryQueryResult = ApolloReactCommon.QueryResult<
  EarnIndexQueryQuery,
  EarnIndexQueryQueryVariables
>
export const EarnOfferDetailQueryDocument = /*#__PURE__*/ gql`
  query EarnOfferDetailQuery(
    $campaignOfferId: String!
    $sessionId: String!
    $origin: String!
  ) {
    earnOfferByCampaignOfferId(
      campaignOfferId: $campaignOfferId
      sessionId: $sessionId
      origin: $origin
    ) {
      __typename
      ... on EarnOffer {
        __typename
        campaignId
        campaignOfferId
        backgroundImageUrl
        badgeCategory
        colorBackgroundLogoImageUrl
        dealType
        details
        displayBody
        ctaDetails {
          title
          web
        }
        displayName
        displayTitle
        displaySubtitle
        exclusions
        incentiveSummary
        isFavorite
        keyphraseCategoryNames
        ownerDescription
        ownerId
        promoted
        promotionRank
        termsAndConditionsUrl
      }
    }
    user {
      uuid
    }
  }
`

/**
 * __useEarnOfferDetailQueryQuery__
 *
 * To run a query within a React component, call `useEarnOfferDetailQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarnOfferDetailQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarnOfferDetailQueryQuery({
 *   variables: {
 *      campaignOfferId: // value for 'campaignOfferId'
 *      sessionId: // value for 'sessionId'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useEarnOfferDetailQueryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    EarnOfferDetailQueryQuery,
    EarnOfferDetailQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EarnOfferDetailQueryQuery,
    EarnOfferDetailQueryQueryVariables
  >(EarnOfferDetailQueryDocument, options)
}
export function useEarnOfferDetailQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EarnOfferDetailQueryQuery,
    EarnOfferDetailQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EarnOfferDetailQueryQuery,
    EarnOfferDetailQueryQueryVariables
  >(EarnOfferDetailQueryDocument, options)
}
export type EarnOfferDetailQueryQueryHookResult = ReturnType<
  typeof useEarnOfferDetailQueryQuery
>
export type EarnOfferDetailQueryLazyQueryHookResult = ReturnType<
  typeof useEarnOfferDetailQueryLazyQuery
>
export type EarnOfferDetailQueryQueryResult = ApolloReactCommon.QueryResult<
  EarnOfferDetailQueryQuery,
  EarnOfferDetailQueryQueryVariables
>
export const FavoriteEarnOffersDocument = /*#__PURE__*/ gql`
  query favoriteEarnOffers {
    favoriteEarnOffers {
      offers {
        ... on EarnOffer {
          __typename
          campaignId
          campaignOfferId
          backgroundImageUrl
          badgeCategory
          colorBackgroundLogoImageUrl
          dealType
          details
          displayBody
          ctaDetails {
            title
            web
          }
          displayName
          displayTitle
          displaySubtitle
          exclusions
          incentiveSummary
          isFavorite
          ownerDescription
          ownerId
        }
      }
    }
  }
`

/**
 * __useFavoriteEarnOffersQuery__
 *
 * To run a query within a React component, call `useFavoriteEarnOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoriteEarnOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoriteEarnOffersQuery({
 *   variables: {
 *   },
 * });
 */
export function useFavoriteEarnOffersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FavoriteEarnOffersQuery,
    FavoriteEarnOffersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FavoriteEarnOffersQuery,
    FavoriteEarnOffersQueryVariables
  >(FavoriteEarnOffersDocument, options)
}
export function useFavoriteEarnOffersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FavoriteEarnOffersQuery,
    FavoriteEarnOffersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FavoriteEarnOffersQuery,
    FavoriteEarnOffersQueryVariables
  >(FavoriteEarnOffersDocument, options)
}
export type FavoriteEarnOffersQueryHookResult = ReturnType<
  typeof useFavoriteEarnOffersQuery
>
export type FavoriteEarnOffersLazyQueryHookResult = ReturnType<
  typeof useFavoriteEarnOffersLazyQuery
>
export type FavoriteEarnOffersQueryResult = ApolloReactCommon.QueryResult<
  FavoriteEarnOffersQuery,
  FavoriteEarnOffersQueryVariables
>
export const FoundMoneyRewardsDocument = /*#__PURE__*/ gql`
  query FoundMoneyRewards {
    foundMoneySummary {
      totalAmount {
        currency
        value
      }
    }
  }
`

/**
 * __useFoundMoneyRewardsQuery__
 *
 * To run a query within a React component, call `useFoundMoneyRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoundMoneyRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoundMoneyRewardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFoundMoneyRewardsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FoundMoneyRewardsQuery,
    FoundMoneyRewardsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FoundMoneyRewardsQuery,
    FoundMoneyRewardsQueryVariables
  >(FoundMoneyRewardsDocument, options)
}
export function useFoundMoneyRewardsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FoundMoneyRewardsQuery,
    FoundMoneyRewardsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FoundMoneyRewardsQuery,
    FoundMoneyRewardsQueryVariables
  >(FoundMoneyRewardsDocument, options)
}
export type FoundMoneyRewardsQueryHookResult = ReturnType<
  typeof useFoundMoneyRewardsQuery
>
export type FoundMoneyRewardsLazyQueryHookResult = ReturnType<
  typeof useFoundMoneyRewardsLazyQuery
>
export type FoundMoneyRewardsQueryResult = ApolloReactCommon.QueryResult<
  FoundMoneyRewardsQuery,
  FoundMoneyRewardsQueryVariables
>
export const FoundMoneyRewardsV2Document = /*#__PURE__*/ gql`
  query FoundMoneyRewardsV2 {
    foundMoneyRewardsV2 {
      ... on EarnReward {
        __typename
        id
        displayName
        colorBackgroundLogoImageUrl
        amountV2 {
          currency
          value
        }
        originationDate
        status
        expectedFulfilledAt
        linked {
          id
          amountV2 {
            currency
            value
          }
          incentiveAmount
        }
        fulfilledAt
        investmentId
        incentiveAmount
      }
    }
  }
`

/**
 * __useFoundMoneyRewardsV2Query__
 *
 * To run a query within a React component, call `useFoundMoneyRewardsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useFoundMoneyRewardsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoundMoneyRewardsV2Query({
 *   variables: {
 *   },
 * });
 */
export function useFoundMoneyRewardsV2Query(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FoundMoneyRewardsV2Query,
    FoundMoneyRewardsV2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FoundMoneyRewardsV2Query,
    FoundMoneyRewardsV2QueryVariables
  >(FoundMoneyRewardsV2Document, options)
}
export function useFoundMoneyRewardsV2LazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FoundMoneyRewardsV2Query,
    FoundMoneyRewardsV2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FoundMoneyRewardsV2Query,
    FoundMoneyRewardsV2QueryVariables
  >(FoundMoneyRewardsV2Document, options)
}
export type FoundMoneyRewardsV2QueryHookResult = ReturnType<
  typeof useFoundMoneyRewardsV2Query
>
export type FoundMoneyRewardsV2LazyQueryHookResult = ReturnType<
  typeof useFoundMoneyRewardsV2LazyQuery
>
export type FoundMoneyRewardsV2QueryResult = ApolloReactCommon.QueryResult<
  FoundMoneyRewardsV2Query,
  FoundMoneyRewardsV2QueryVariables
>
export const FoundMoneySummaryDetailDocument = /*#__PURE__*/ gql`
  query FoundMoneySummaryDetail {
    foundMoneySummary {
      totalAmount {
        value
      }
      pendingAmount {
        value
      }
      fulfilledAmount {
        value
      }
      matchedAmount {
        currency
        value
      }
    }
  }
`

/**
 * __useFoundMoneySummaryDetailQuery__
 *
 * To run a query within a React component, call `useFoundMoneySummaryDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoundMoneySummaryDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoundMoneySummaryDetailQuery({
 *   variables: {
 *   },
 * });
 */
export function useFoundMoneySummaryDetailQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FoundMoneySummaryDetailQuery,
    FoundMoneySummaryDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FoundMoneySummaryDetailQuery,
    FoundMoneySummaryDetailQueryVariables
  >(FoundMoneySummaryDetailDocument, options)
}
export function useFoundMoneySummaryDetailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FoundMoneySummaryDetailQuery,
    FoundMoneySummaryDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FoundMoneySummaryDetailQuery,
    FoundMoneySummaryDetailQueryVariables
  >(FoundMoneySummaryDetailDocument, options)
}
export type FoundMoneySummaryDetailQueryHookResult = ReturnType<
  typeof useFoundMoneySummaryDetailQuery
>
export type FoundMoneySummaryDetailLazyQueryHookResult = ReturnType<
  typeof useFoundMoneySummaryDetailLazyQuery
>
export type FoundMoneySummaryDetailQueryResult = ApolloReactCommon.QueryResult<
  FoundMoneySummaryDetailQuery,
  FoundMoneySummaryDetailQueryVariables
>
export const EarnInvestmentAccountsDocument = /*#__PURE__*/ gql`
  query EarnInvestmentAccounts {
    investmentAccountsByUserId(
      filter: { accountStatus: OPEN, product: INVEST }
    ) {
      id
      type
      closedAt
      portfolio {
        id
      }
    }
  }
`

/**
 * __useEarnInvestmentAccountsQuery__
 *
 * To run a query within a React component, call `useEarnInvestmentAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarnInvestmentAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarnInvestmentAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEarnInvestmentAccountsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    EarnInvestmentAccountsQuery,
    EarnInvestmentAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EarnInvestmentAccountsQuery,
    EarnInvestmentAccountsQueryVariables
  >(EarnInvestmentAccountsDocument, options)
}
export function useEarnInvestmentAccountsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EarnInvestmentAccountsQuery,
    EarnInvestmentAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EarnInvestmentAccountsQuery,
    EarnInvestmentAccountsQueryVariables
  >(EarnInvestmentAccountsDocument, options)
}
export type EarnInvestmentAccountsQueryHookResult = ReturnType<
  typeof useEarnInvestmentAccountsQuery
>
export type EarnInvestmentAccountsLazyQueryHookResult = ReturnType<
  typeof useEarnInvestmentAccountsLazyQuery
>
export type EarnInvestmentAccountsQueryResult = ApolloReactCommon.QueryResult<
  EarnInvestmentAccountsQuery,
  EarnInvestmentAccountsQueryVariables
>
export const PromotedEarnOffersDocument = /*#__PURE__*/ gql`
  query PromotedEarnOffers {
    promotedEarnOffers {
      ... on EarnOffer {
        backgroundImageUrl
        badgeCategory
        campaignId
        campaignOfferId
        colorBackgroundLogoImageUrl
        dealType
        displayName
        displaySubtitle
        displayTitle
        incentiveSummary
        ownerDescription
        ownerId
        promoted
        promotionRank
      }
    }
  }
`

/**
 * __usePromotedEarnOffersQuery__
 *
 * To run a query within a React component, call `usePromotedEarnOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromotedEarnOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromotedEarnOffersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePromotedEarnOffersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PromotedEarnOffersQuery,
    PromotedEarnOffersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PromotedEarnOffersQuery,
    PromotedEarnOffersQueryVariables
  >(PromotedEarnOffersDocument, options)
}
export function usePromotedEarnOffersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PromotedEarnOffersQuery,
    PromotedEarnOffersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PromotedEarnOffersQuery,
    PromotedEarnOffersQueryVariables
  >(PromotedEarnOffersDocument, options)
}
export type PromotedEarnOffersQueryHookResult = ReturnType<
  typeof usePromotedEarnOffersQuery
>
export type PromotedEarnOffersLazyQueryHookResult = ReturnType<
  typeof usePromotedEarnOffersLazyQuery
>
export type PromotedEarnOffersQueryResult = ApolloReactCommon.QueryResult<
  PromotedEarnOffersQuery,
  PromotedEarnOffersQueryVariables
>
export const RemoveFavoritePartnerOffersDocument = /*#__PURE__*/ gql`
  mutation RemoveFavoritePartnerOffers($input: FavoritePartnerOfferInput!) {
    removeFavoritePartnerOffers(input: $input) {
      offers {
        ... on EarnOffer {
          __typename
          displayName
          displayTitle
          dealType
          badgeCategory
          backgroundImageUrl
          campaignId
          campaignOfferId
          incentiveSummary
          isFavorite
          displaySubtitle
          colorBackgroundLogoImageUrl
          ownerId
          ownerDescription
        }
      }
    }
  }
`
export type RemoveFavoritePartnerOffersMutationFn =
  ApolloReactCommon.MutationFunction<
    RemoveFavoritePartnerOffersMutation,
    RemoveFavoritePartnerOffersMutationVariables
  >

/**
 * __useRemoveFavoritePartnerOffersMutation__
 *
 * To run a mutation, you first call `useRemoveFavoritePartnerOffersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFavoritePartnerOffersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFavoritePartnerOffersMutation, { data, loading, error }] = useRemoveFavoritePartnerOffersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveFavoritePartnerOffersMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RemoveFavoritePartnerOffersMutation,
    RemoveFavoritePartnerOffersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RemoveFavoritePartnerOffersMutation,
    RemoveFavoritePartnerOffersMutationVariables
  >(RemoveFavoritePartnerOffersDocument, options)
}
export type RemoveFavoritePartnerOffersMutationHookResult = ReturnType<
  typeof useRemoveFavoritePartnerOffersMutation
>
export type RemoveFavoritePartnerOffersMutationResult =
  ApolloReactCommon.MutationResult<RemoveFavoritePartnerOffersMutation>
export type RemoveFavoritePartnerOffersMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RemoveFavoritePartnerOffersMutation,
    RemoveFavoritePartnerOffersMutationVariables
  >
export const SearchActiveEarnOffersDocument = /*#__PURE__*/ gql`
  query SearchActiveEarnOffers($searchTerm: String!, $tag: String!) {
    searchActiveEarnOffers(searchTerm: $searchTerm, tag: $tag) {
      __typename
      ... on EarnOfferQueryPage {
        earnOffers {
          displayName
          displayTitle
          campaignId
          campaignOfferId
          incentiveSummary
          colorBackgroundLogoImageUrl
          ownerId
        }
      }
    }
  }
`

/**
 * __useSearchActiveEarnOffersQuery__
 *
 * To run a query within a React component, call `useSearchActiveEarnOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchActiveEarnOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchActiveEarnOffersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useSearchActiveEarnOffersQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SearchActiveEarnOffersQuery,
    SearchActiveEarnOffersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SearchActiveEarnOffersQuery,
    SearchActiveEarnOffersQueryVariables
  >(SearchActiveEarnOffersDocument, options)
}
export function useSearchActiveEarnOffersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SearchActiveEarnOffersQuery,
    SearchActiveEarnOffersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SearchActiveEarnOffersQuery,
    SearchActiveEarnOffersQueryVariables
  >(SearchActiveEarnOffersDocument, options)
}
export type SearchActiveEarnOffersQueryHookResult = ReturnType<
  typeof useSearchActiveEarnOffersQuery
>
export type SearchActiveEarnOffersLazyQueryHookResult = ReturnType<
  typeof useSearchActiveEarnOffersLazyQuery
>
export type SearchActiveEarnOffersQueryResult = ApolloReactCommon.QueryResult<
  SearchActiveEarnOffersQuery,
  SearchActiveEarnOffersQueryVariables
>
export const EmergencyFundHomeDocument = /*#__PURE__*/ gql`
  query EmergencyFundHome {
    allBankAccounts(input: { types: [spend, save] }) {
      id
      availableBalance {
        value
      }
      pendingBalance {
        value
      }
      totalBalance {
        value
      }
      createdAt
      status
      closedAt
      goals {
        currentGoal {
          type
          amount {
            value
            currency
          }
        }
      }
      isLocked
      type
    }
    bankCardOrder {
      bankCardTier
    }
  }
`

/**
 * __useEmergencyFundHomeQuery__
 *
 * To run a query within a React component, call `useEmergencyFundHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmergencyFundHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmergencyFundHomeQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmergencyFundHomeQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    EmergencyFundHomeQuery,
    EmergencyFundHomeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EmergencyFundHomeQuery,
    EmergencyFundHomeQueryVariables
  >(EmergencyFundHomeDocument, options)
}
export function useEmergencyFundHomeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EmergencyFundHomeQuery,
    EmergencyFundHomeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EmergencyFundHomeQuery,
    EmergencyFundHomeQueryVariables
  >(EmergencyFundHomeDocument, options)
}
export type EmergencyFundHomeQueryHookResult = ReturnType<
  typeof useEmergencyFundHomeQuery
>
export type EmergencyFundHomeLazyQueryHookResult = ReturnType<
  typeof useEmergencyFundHomeLazyQuery
>
export type EmergencyFundHomeQueryResult = ApolloReactCommon.QueryResult<
  EmergencyFundHomeQuery,
  EmergencyFundHomeQueryVariables
>
export const BankAccountQueryDocument = /*#__PURE__*/ gql`
  query BankAccountQuery {
    allBankAccounts(input: { type: save }) {
      isLocked
      lockReason
      id
    }
  }
`

/**
 * __useBankAccountQueryQuery__
 *
 * To run a query within a React component, call `useBankAccountQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankAccountQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankAccountQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useBankAccountQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    BankAccountQueryQuery,
    BankAccountQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    BankAccountQueryQuery,
    BankAccountQueryQueryVariables
  >(BankAccountQueryDocument, options)
}
export function useBankAccountQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BankAccountQueryQuery,
    BankAccountQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    BankAccountQueryQuery,
    BankAccountQueryQueryVariables
  >(BankAccountQueryDocument, options)
}
export type BankAccountQueryQueryHookResult = ReturnType<
  typeof useBankAccountQueryQuery
>
export type BankAccountQueryLazyQueryHookResult = ReturnType<
  typeof useBankAccountQueryLazyQuery
>
export type BankAccountQueryQueryResult = ApolloReactCommon.QueryResult<
  BankAccountQueryQuery,
  BankAccountQueryQueryVariables
>
export const EmergencyFundCompletedItemsDocument = /*#__PURE__*/ gql`
  query EmergencyFundCompletedItems($accountId: ID!) {
    allPastItems(
      filter: {
        pending: false
        pastItemsAccountFilter: { id: $accountId, productAccountType: SAVINGS }
      }
      pagination: { first: 1 }
    ) {
      edges {
        node {
          id
        }
      }
    }
  }
`

/**
 * __useEmergencyFundCompletedItemsQuery__
 *
 * To run a query within a React component, call `useEmergencyFundCompletedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmergencyFundCompletedItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmergencyFundCompletedItemsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useEmergencyFundCompletedItemsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    EmergencyFundCompletedItemsQuery,
    EmergencyFundCompletedItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EmergencyFundCompletedItemsQuery,
    EmergencyFundCompletedItemsQueryVariables
  >(EmergencyFundCompletedItemsDocument, options)
}
export function useEmergencyFundCompletedItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EmergencyFundCompletedItemsQuery,
    EmergencyFundCompletedItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EmergencyFundCompletedItemsQuery,
    EmergencyFundCompletedItemsQueryVariables
  >(EmergencyFundCompletedItemsDocument, options)
}
export type EmergencyFundCompletedItemsQueryHookResult = ReturnType<
  typeof useEmergencyFundCompletedItemsQuery
>
export type EmergencyFundCompletedItemsLazyQueryHookResult = ReturnType<
  typeof useEmergencyFundCompletedItemsLazyQuery
>
export type EmergencyFundCompletedItemsQueryResult =
  ApolloReactCommon.QueryResult<
    EmergencyFundCompletedItemsQuery,
    EmergencyFundCompletedItemsQueryVariables
  >
export const RecentActivityQueryDocument = /*#__PURE__*/ gql`
  query RecentActivityQuery {
    allBankAccounts(input: { types: [save] }) {
      id
      status
    }
  }
`

/**
 * __useRecentActivityQueryQuery__
 *
 * To run a query within a React component, call `useRecentActivityQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentActivityQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentActivityQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecentActivityQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    RecentActivityQueryQuery,
    RecentActivityQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RecentActivityQueryQuery,
    RecentActivityQueryQueryVariables
  >(RecentActivityQueryDocument, options)
}
export function useRecentActivityQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RecentActivityQueryQuery,
    RecentActivityQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RecentActivityQueryQuery,
    RecentActivityQueryQueryVariables
  >(RecentActivityQueryDocument, options)
}
export type RecentActivityQueryQueryHookResult = ReturnType<
  typeof useRecentActivityQueryQuery
>
export type RecentActivityQueryLazyQueryHookResult = ReturnType<
  typeof useRecentActivityQueryLazyQuery
>
export type RecentActivityQueryQueryResult = ApolloReactCommon.QueryResult<
  RecentActivityQueryQuery,
  RecentActivityQueryQueryVariables
>
export const EmergencySavingsSettingsDocument = /*#__PURE__*/ gql`
  query EmergencySavingsSettings {
    allBankAccounts(input: { type: save }) {
      id
      number
      routingNumber
      status
      type
    }
  }
`

/**
 * __useEmergencySavingsSettingsQuery__
 *
 * To run a query within a React component, call `useEmergencySavingsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmergencySavingsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmergencySavingsSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmergencySavingsSettingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    EmergencySavingsSettingsQuery,
    EmergencySavingsSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EmergencySavingsSettingsQuery,
    EmergencySavingsSettingsQueryVariables
  >(EmergencySavingsSettingsDocument, options)
}
export function useEmergencySavingsSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EmergencySavingsSettingsQuery,
    EmergencySavingsSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EmergencySavingsSettingsQuery,
    EmergencySavingsSettingsQueryVariables
  >(EmergencySavingsSettingsDocument, options)
}
export type EmergencySavingsSettingsQueryHookResult = ReturnType<
  typeof useEmergencySavingsSettingsQuery
>
export type EmergencySavingsSettingsLazyQueryHookResult = ReturnType<
  typeof useEmergencySavingsSettingsLazyQuery
>
export type EmergencySavingsSettingsQueryResult = ApolloReactCommon.QueryResult<
  EmergencySavingsSettingsQuery,
  EmergencySavingsSettingsQueryVariables
>
export const AllBankAccountsQueryDocument = /*#__PURE__*/ gql`
  query AllBankAccountsQuery {
    allBankAccounts(input: { types: [spend, save] }) {
      id
      number
      accountName
      availableBalance {
        value
      }
      type
      isLocked
      lockReason
      status
    }
  }
`

/**
 * __useAllBankAccountsQueryQuery__
 *
 * To run a query within a React component, call `useAllBankAccountsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllBankAccountsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBankAccountsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllBankAccountsQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AllBankAccountsQueryQuery,
    AllBankAccountsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AllBankAccountsQueryQuery,
    AllBankAccountsQueryQueryVariables
  >(AllBankAccountsQueryDocument, options)
}
export function useAllBankAccountsQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AllBankAccountsQueryQuery,
    AllBankAccountsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AllBankAccountsQueryQuery,
    AllBankAccountsQueryQueryVariables
  >(AllBankAccountsQueryDocument, options)
}
export type AllBankAccountsQueryQueryHookResult = ReturnType<
  typeof useAllBankAccountsQueryQuery
>
export type AllBankAccountsQueryLazyQueryHookResult = ReturnType<
  typeof useAllBankAccountsQueryLazyQuery
>
export type AllBankAccountsQueryQueryResult = ApolloReactCommon.QueryResult<
  AllBankAccountsQueryQuery,
  AllBankAccountsQueryQueryVariables
>
export const CreateEmergencySavingsIntentDocument = /*#__PURE__*/ gql`
  mutation createEmergencySavingsIntent($input: CreateIntentInput!) {
    createIntent(input: $input) {
      ... on Intent {
        amount {
          value
        }
        status
        nonce
      }
      ... on ValidationError {
        errorCode
      }
    }
  }
`
export type CreateEmergencySavingsIntentMutationFn =
  ApolloReactCommon.MutationFunction<
    CreateEmergencySavingsIntentMutation,
    CreateEmergencySavingsIntentMutationVariables
  >

/**
 * __useCreateEmergencySavingsIntentMutation__
 *
 * To run a mutation, you first call `useCreateEmergencySavingsIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmergencySavingsIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmergencySavingsIntentMutation, { data, loading, error }] = useCreateEmergencySavingsIntentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmergencySavingsIntentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateEmergencySavingsIntentMutation,
    CreateEmergencySavingsIntentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateEmergencySavingsIntentMutation,
    CreateEmergencySavingsIntentMutationVariables
  >(CreateEmergencySavingsIntentDocument, options)
}
export type CreateEmergencySavingsIntentMutationHookResult = ReturnType<
  typeof useCreateEmergencySavingsIntentMutation
>
export type CreateEmergencySavingsIntentMutationResult =
  ApolloReactCommon.MutationResult<CreateEmergencySavingsIntentMutation>
export type CreateEmergencySavingsIntentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateEmergencySavingsIntentMutation,
    CreateEmergencySavingsIntentMutationVariables
  >
export const EmergencySavingsTransferDocument = /*#__PURE__*/ gql`
  query EmergencySavingsTransfer($transferAction: TransferAction!) {
    allAccounts {
      ...CustomerAccountFragment
      customerAccountsByTransferAction(transferAction: $transferAction) {
        ...CustomerAccountFragment
      }
    }
    fundingSourceAccounts {
      id
      uuid
      fundType
      role
      accountName
      verified
      last4
      balance
      linkedSubaccountId
      rdvTriggeredAt
      rdvSettledAt
      bankRoutingNumber
    }
    settings {
      depositsSuspended
    }
  }
  ${CustomerAccountFragmentFragmentDoc}
`

/**
 * __useEmergencySavingsTransferQuery__
 *
 * To run a query within a React component, call `useEmergencySavingsTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmergencySavingsTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmergencySavingsTransferQuery({
 *   variables: {
 *      transferAction: // value for 'transferAction'
 *   },
 * });
 */
export function useEmergencySavingsTransferQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    EmergencySavingsTransferQuery,
    EmergencySavingsTransferQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EmergencySavingsTransferQuery,
    EmergencySavingsTransferQueryVariables
  >(EmergencySavingsTransferDocument, options)
}
export function useEmergencySavingsTransferLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EmergencySavingsTransferQuery,
    EmergencySavingsTransferQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EmergencySavingsTransferQuery,
    EmergencySavingsTransferQueryVariables
  >(EmergencySavingsTransferDocument, options)
}
export type EmergencySavingsTransferQueryHookResult = ReturnType<
  typeof useEmergencySavingsTransferQuery
>
export type EmergencySavingsTransferLazyQueryHookResult = ReturnType<
  typeof useEmergencySavingsTransferLazyQuery
>
export type EmergencySavingsTransferQueryResult = ApolloReactCommon.QueryResult<
  EmergencySavingsTransferQuery,
  EmergencySavingsTransferQueryVariables
>
export const InitiateTransferEmergencyFundDocument = /*#__PURE__*/ gql`
  mutation InitiateTransferEmergencyFund(
    $amount: Float!
    $fromAccountId: ID!
    $toAccountId: ID!
    $nonce: ID
  ) {
    initiateTransfer(
      input: {
        amount: { value: $amount, currency: USD }
        fromAccountId: $fromAccountId
        toAccountId: $toAccountId
        nonce: $nonce
      }
    ) {
      transfer {
        id
      }
    }
  }
`
export type InitiateTransferEmergencyFundMutationFn =
  ApolloReactCommon.MutationFunction<
    InitiateTransferEmergencyFundMutation,
    InitiateTransferEmergencyFundMutationVariables
  >

/**
 * __useInitiateTransferEmergencyFundMutation__
 *
 * To run a mutation, you first call `useInitiateTransferEmergencyFundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateTransferEmergencyFundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateTransferEmergencyFundMutation, { data, loading, error }] = useInitiateTransferEmergencyFundMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      fromAccountId: // value for 'fromAccountId'
 *      toAccountId: // value for 'toAccountId'
 *      nonce: // value for 'nonce'
 *   },
 * });
 */
export function useInitiateTransferEmergencyFundMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    InitiateTransferEmergencyFundMutation,
    InitiateTransferEmergencyFundMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    InitiateTransferEmergencyFundMutation,
    InitiateTransferEmergencyFundMutationVariables
  >(InitiateTransferEmergencyFundDocument, options)
}
export type InitiateTransferEmergencyFundMutationHookResult = ReturnType<
  typeof useInitiateTransferEmergencyFundMutation
>
export type InitiateTransferEmergencyFundMutationResult =
  ApolloReactCommon.MutationResult<InitiateTransferEmergencyFundMutation>
export type InitiateTransferEmergencyFundMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    InitiateTransferEmergencyFundMutation,
    InitiateTransferEmergencyFundMutationVariables
  >
export const CancelInvestmentDocument = /*#__PURE__*/ gql`
  mutation CancelInvestment($cancelInvestmentInput: CancelInvestmentInput!) {
    cancelInvestment(input: $cancelInvestmentInput) {
      __typename
      ... on CancelInvestmentPayload {
        cancelInvestmentPayloadId: id
      }
      ... on InvestmentNotFoundException {
        investmentNotFoundExceptionId: id
      }
      ... on InvestmentUncancellableException {
        investmentUncancellableExceptionId: id
      }
    }
  }
`
export type CancelInvestmentMutationFn = ApolloReactCommon.MutationFunction<
  CancelInvestmentMutation,
  CancelInvestmentMutationVariables
>

/**
 * __useCancelInvestmentMutation__
 *
 * To run a mutation, you first call `useCancelInvestmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelInvestmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelInvestmentMutation, { data, loading, error }] = useCancelInvestmentMutation({
 *   variables: {
 *      cancelInvestmentInput: // value for 'cancelInvestmentInput'
 *   },
 * });
 */
export function useCancelInvestmentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CancelInvestmentMutation,
    CancelInvestmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CancelInvestmentMutation,
    CancelInvestmentMutationVariables
  >(CancelInvestmentDocument, options)
}
export type CancelInvestmentMutationHookResult = ReturnType<
  typeof useCancelInvestmentMutation
>
export type CancelInvestmentMutationResult =
  ApolloReactCommon.MutationResult<CancelInvestmentMutation>
export type CancelInvestmentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CancelInvestmentMutation,
    CancelInvestmentMutationVariables
  >
export const InvestmentByIdDocument = /*#__PURE__*/ gql`
  query InvestmentById($id: ID!) {
    investment(id: $id) {
      id
      createdAt
      type
      requestedAmount {
        value
        currency
      }
      transferredAmount {
        value
        currency
      }
      amountCollected {
        value
      }
      tradeConfirmationUrls
      iraDistribution {
        federalWithholdings {
          value
          currency
        }
        stateWithholdings {
          value
          currency
        }
      }
      allocations {
        amount
        price {
          currency
          value
        }
        selfDirected
        shares
        symbol
      }
    }
  }
`

/**
 * __useInvestmentByIdQuery__
 *
 * To run a query within a React component, call `useInvestmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestmentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvestmentByIdQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    InvestmentByIdQuery,
    InvestmentByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    InvestmentByIdQuery,
    InvestmentByIdQueryVariables
  >(InvestmentByIdDocument, options)
}
export function useInvestmentByIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InvestmentByIdQuery,
    InvestmentByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    InvestmentByIdQuery,
    InvestmentByIdQueryVariables
  >(InvestmentByIdDocument, options)
}
export type InvestmentByIdQueryHookResult = ReturnType<
  typeof useInvestmentByIdQuery
>
export type InvestmentByIdLazyQueryHookResult = ReturnType<
  typeof useInvestmentByIdLazyQuery
>
export type InvestmentByIdQueryResult = ApolloReactCommon.QueryResult<
  InvestmentByIdQuery,
  InvestmentByIdQueryVariables
>
export const SpendTransactionItemDocument = /*#__PURE__*/ gql`
  query SpendTransactionItem($transactionId: String!) {
    pastSpendTransactionItem(transactionId: $transactionId) {
      id
      createdAt
      updatedAt
      title
      status
      amount {
        value
        currency
        __typename
      }
      reversible
      __typename
      ... on SpendItem {
        availableAt
        description
        summary
      }
      ... on SpendRealTimeRoundUpItem {
        availableAt
        description
        summary
        multiplier
        initialAmount {
          value
          currency
          __typename
        }
      }
      ... on SpendInterestPaidItem {
        summary
        description
        monthEarned
      }
    }
    bankCardOrder {
      bankCardTier
    }
  }
`

/**
 * __useSpendTransactionItemQuery__
 *
 * To run a query within a React component, call `useSpendTransactionItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpendTransactionItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpendTransactionItemQuery({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useSpendTransactionItemQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SpendTransactionItemQuery,
    SpendTransactionItemQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SpendTransactionItemQuery,
    SpendTransactionItemQueryVariables
  >(SpendTransactionItemDocument, options)
}
export function useSpendTransactionItemLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SpendTransactionItemQuery,
    SpendTransactionItemQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SpendTransactionItemQuery,
    SpendTransactionItemQueryVariables
  >(SpendTransactionItemDocument, options)
}
export type SpendTransactionItemQueryHookResult = ReturnType<
  typeof useSpendTransactionItemQuery
>
export type SpendTransactionItemLazyQueryHookResult = ReturnType<
  typeof useSpendTransactionItemLazyQuery
>
export type SpendTransactionItemQueryResult = ApolloReactCommon.QueryResult<
  SpendTransactionItemQuery,
  SpendTransactionItemQueryVariables
>
export const PastSpendSummaryQueryDocument = /*#__PURE__*/ gql`
  query PastSpendSummaryQuery {
    pastSpendSummary {
      debitsLast30Days {
        value
        currency
      }
      depositsLast30Days {
        value
        currency
      }
      availableBalance {
        value
        currency
      }
    }
    pending: allPastSpendItems(filter: { pending: true })
      @connection(key: "allPastSpendItems", filter: ["filter"]) {
      edges {
        node {
          id
        }
      }
    }
    completed: allPastSpendItems(filter: { pending: false })
      @connection(key: "allPastSpendItems", filter: ["filter"]) {
      edges {
        node {
          id
        }
      }
    }
    bankCardOrder {
      bankCardTier
    }
  }
`

/**
 * __usePastSpendSummaryQueryQuery__
 *
 * To run a query within a React component, call `usePastSpendSummaryQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePastSpendSummaryQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePastSpendSummaryQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePastSpendSummaryQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PastSpendSummaryQueryQuery,
    PastSpendSummaryQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PastSpendSummaryQueryQuery,
    PastSpendSummaryQueryQueryVariables
  >(PastSpendSummaryQueryDocument, options)
}
export function usePastSpendSummaryQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PastSpendSummaryQueryQuery,
    PastSpendSummaryQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PastSpendSummaryQueryQuery,
    PastSpendSummaryQueryQueryVariables
  >(PastSpendSummaryQueryDocument, options)
}
export type PastSpendSummaryQueryQueryHookResult = ReturnType<
  typeof usePastSpendSummaryQueryQuery
>
export type PastSpendSummaryQueryLazyQueryHookResult = ReturnType<
  typeof usePastSpendSummaryQueryLazyQuery
>
export type PastSpendSummaryQueryQueryResult = ApolloReactCommon.QueryResult<
  PastSpendSummaryQueryQuery,
  PastSpendSummaryQueryQueryVariables
>
export const AllPastTransactionsDocument = /*#__PURE__*/ gql`
  query AllPastTransactions(
    $filter: AllPastItemsFilter
    $pagination: PageInput!
  ) {
    allPastItems(filter: $filter, pagination: $pagination) {
      edges {
        cursor
        node {
          __typename
          id
          title
          status
          createdAt
          amount {
            currency
            value
          }
          reversible
          ... on PastTargetedTransferItem {
            sourceAccountTitle
            targetAccountTitle
          }
          ... on PastUserTransferItem {
            estimatedCompletionDate
            isRecurring
          }
          ... on PastInvestmentItem {
            accountName
            moneyManagerTransfer
            productAccountType
            transactionDescription
            transactionType
            estimatedCompletionDate
          }
          ... on SpendItem {
            accountName
            availableAt
            description
            moneyManagerTransfer
            productAccountType
            summary
            transactionDescription
            transactionType
          }
          ... on SpendRealTimeRoundUpItem {
            initialAmount {
              value
              currency
            }
          }
          ... on SpendInterestPaidItem {
            monthEarned
          }
          ... on PastRewardInvestmentItem {
            merchantName
            partnerLogoUrl
          }
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        limit
      }
    }
  }
`

/**
 * __useAllPastTransactionsQuery__
 *
 * To run a query within a React component, call `useAllPastTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPastTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPastTransactionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAllPastTransactionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    AllPastTransactionsQuery,
    AllPastTransactionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AllPastTransactionsQuery,
    AllPastTransactionsQueryVariables
  >(AllPastTransactionsDocument, options)
}
export function useAllPastTransactionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AllPastTransactionsQuery,
    AllPastTransactionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AllPastTransactionsQuery,
    AllPastTransactionsQueryVariables
  >(AllPastTransactionsDocument, options)
}
export type AllPastTransactionsQueryHookResult = ReturnType<
  typeof useAllPastTransactionsQuery
>
export type AllPastTransactionsLazyQueryHookResult = ReturnType<
  typeof useAllPastTransactionsLazyQuery
>
export type AllPastTransactionsQueryResult = ApolloReactCommon.QueryResult<
  AllPastTransactionsQuery,
  AllPastTransactionsQueryVariables
>
export const PastInvestAccountIdDocument = /*#__PURE__*/ gql`
  query PastInvestAccountId {
    investmentAccountsByUserId(filter: { product: INVEST }) {
      id
      closedAt
    }
  }
`

/**
 * __usePastInvestAccountIdQuery__
 *
 * To run a query within a React component, call `usePastInvestAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePastInvestAccountIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePastInvestAccountIdQuery({
 *   variables: {
 *   },
 * });
 */
export function usePastInvestAccountIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PastInvestAccountIdQuery,
    PastInvestAccountIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PastInvestAccountIdQuery,
    PastInvestAccountIdQueryVariables
  >(PastInvestAccountIdDocument, options)
}
export function usePastInvestAccountIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PastInvestAccountIdQuery,
    PastInvestAccountIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PastInvestAccountIdQuery,
    PastInvestAccountIdQueryVariables
  >(PastInvestAccountIdDocument, options)
}
export type PastInvestAccountIdQueryHookResult = ReturnType<
  typeof usePastInvestAccountIdQuery
>
export type PastInvestAccountIdLazyQueryHookResult = ReturnType<
  typeof usePastInvestAccountIdLazyQuery
>
export type PastInvestAccountIdQueryResult = ApolloReactCommon.QueryResult<
  PastInvestAccountIdQuery,
  PastInvestAccountIdQueryVariables
>
export const PastSpendAccountIdDocument = /*#__PURE__*/ gql`
  query PastSpendAccountId {
    allBankAccounts(input: { type: spend }) {
      id
      status
    }
  }
`

/**
 * __usePastSpendAccountIdQuery__
 *
 * To run a query within a React component, call `usePastSpendAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePastSpendAccountIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePastSpendAccountIdQuery({
 *   variables: {
 *   },
 * });
 */
export function usePastSpendAccountIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PastSpendAccountIdQuery,
    PastSpendAccountIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PastSpendAccountIdQuery,
    PastSpendAccountIdQueryVariables
  >(PastSpendAccountIdDocument, options)
}
export function usePastSpendAccountIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PastSpendAccountIdQuery,
    PastSpendAccountIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PastSpendAccountIdQuery,
    PastSpendAccountIdQueryVariables
  >(PastSpendAccountIdDocument, options)
}
export type PastSpendAccountIdQueryHookResult = ReturnType<
  typeof usePastSpendAccountIdQuery
>
export type PastSpendAccountIdLazyQueryHookResult = ReturnType<
  typeof usePastSpendAccountIdLazyQuery
>
export type PastSpendAccountIdQueryResult = ApolloReactCommon.QueryResult<
  PastSpendAccountIdQuery,
  PastSpendAccountIdQueryVariables
>
export const TransactionsSummaryDocument = /*#__PURE__*/ gql`
  query TransactionsSummary($filter: PastSummaryFilter!) {
    pastSummary(pastSummaryFilter: $filter) {
      ... on AllAccountHistorySummary {
        moneyIn {
          currency
          value
        }
        moneyOut {
          currency
          value
        }
        dividends {
          currency
          value
        }
        earnRewards {
          currency
          value
        }
        referralRewards {
          currency
          value
        }
      }
      ... on InvestHistorySummary {
        moneyIn {
          currency
          value
        }
        moneyOut {
          currency
          value
        }
        dividends {
          currency
          value
        }
        earnRewards {
          currency
          value
        }
        referralRewards {
          currency
          value
        }
      }
      ... on LaterHistorySummary {
        moneyIn {
          currency
          value
        }
        moneyOut {
          currency
          value
        }
        dividends {
          currency
          value
        }
        iraMatchRewards {
          currency
          value
        }
        previousYearContributions {
          currency
          value
        }
        currentYearContributions {
          currency
          value
        }
        currentYear
        previousYear
      }
      ... on EarlyHistorySummary {
        moneyIn {
          currency
          value
        }
        moneyOut {
          currency
          value
        }
        dividends {
          currency
          value
        }
        giftsReceived {
          currency
          value
        }
        earlyInvestMatches {
          currency
          value
        }
      }
      ... on CheckingHistorySummary {
        moneyIn {
          currency
          value
        }
        moneyOut {
          currency
          value
        }
        interestEarned {
          currency
          value
        }
      }
      ... on EmergencyFundHistorySummary {
        moneyIn {
          currency
          value
        }
        moneyOut {
          currency
          value
        }
        interestEarned {
          currency
          value
        }
      }
    }
  }
`

/**
 * __useTransactionsSummaryQuery__
 *
 * To run a query within a React component, call `useTransactionsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionsSummaryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTransactionsSummaryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    TransactionsSummaryQuery,
    TransactionsSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    TransactionsSummaryQuery,
    TransactionsSummaryQueryVariables
  >(TransactionsSummaryDocument, options)
}
export function useTransactionsSummaryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TransactionsSummaryQuery,
    TransactionsSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    TransactionsSummaryQuery,
    TransactionsSummaryQueryVariables
  >(TransactionsSummaryDocument, options)
}
export type TransactionsSummaryQueryHookResult = ReturnType<
  typeof useTransactionsSummaryQuery
>
export type TransactionsSummaryLazyQueryHookResult = ReturnType<
  typeof useTransactionsSummaryLazyQuery
>
export type TransactionsSummaryQueryResult = ApolloReactCommon.QueryResult<
  TransactionsSummaryQuery,
  TransactionsSummaryQueryVariables
>
export const AllTransferableFromQueryDocument = /*#__PURE__*/ gql`
  query AllTransferableFromQuery {
    allTransferableFrom {
      from {
        accountNumberMasked
        balance {
          value
        }
        externalSource
        id
        name
        type
      }
    }
  }
`

/**
 * __useAllTransferableFromQueryQuery__
 *
 * To run a query within a React component, call `useAllTransferableFromQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTransferableFromQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTransferableFromQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllTransferableFromQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AllTransferableFromQueryQuery,
    AllTransferableFromQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AllTransferableFromQueryQuery,
    AllTransferableFromQueryQueryVariables
  >(AllTransferableFromQueryDocument, options)
}
export function useAllTransferableFromQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AllTransferableFromQueryQuery,
    AllTransferableFromQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AllTransferableFromQueryQuery,
    AllTransferableFromQueryQueryVariables
  >(AllTransferableFromQueryDocument, options)
}
export type AllTransferableFromQueryQueryHookResult = ReturnType<
  typeof useAllTransferableFromQueryQuery
>
export type AllTransferableFromQueryLazyQueryHookResult = ReturnType<
  typeof useAllTransferableFromQueryLazyQuery
>
export type AllTransferableFromQueryQueryResult = ApolloReactCommon.QueryResult<
  AllTransferableFromQueryQuery,
  AllTransferableFromQueryQueryVariables
>
export const DeleteCardOrderMutationDocument = /*#__PURE__*/ gql`
  mutation deleteCardOrderMutation {
    deleteExpiredBankCardOrder {
      __typename
    }
  }
`
export type DeleteCardOrderMutationMutationFn =
  ApolloReactCommon.MutationFunction<
    DeleteCardOrderMutationMutation,
    DeleteCardOrderMutationMutationVariables
  >

/**
 * __useDeleteCardOrderMutationMutation__
 *
 * To run a mutation, you first call `useDeleteCardOrderMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCardOrderMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCardOrderMutationMutation, { data, loading, error }] = useDeleteCardOrderMutationMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteCardOrderMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteCardOrderMutationMutation,
    DeleteCardOrderMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeleteCardOrderMutationMutation,
    DeleteCardOrderMutationMutationVariables
  >(DeleteCardOrderMutationDocument, options)
}
export type DeleteCardOrderMutationMutationHookResult = ReturnType<
  typeof useDeleteCardOrderMutationMutation
>
export type DeleteCardOrderMutationMutationResult =
  ApolloReactCommon.MutationResult<DeleteCardOrderMutationMutation>
export type DeleteCardOrderMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteCardOrderMutationMutation,
    DeleteCardOrderMutationMutationVariables
  >
export const AllPastPendingItemsDocument = /*#__PURE__*/ gql`
  query AllPastPendingItems {
    allPastPendingItems(excludeFees: true) {
      __typename
      productType
      id
      createdAt
      updatedAt
      title
      status
      amount {
        currency
        value
      }
      drawerInclusion
      ... on PastEarlyItem {
        beneficiaryId
      }
      ... on CoreRoundUpsItem {
        type
      }
    }
    beneficiaries {
      id
      firstName
    }
  }
`

/**
 * __useAllPastPendingItemsQuery__
 *
 * To run a query within a React component, call `useAllPastPendingItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPastPendingItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPastPendingItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPastPendingItemsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AllPastPendingItemsQuery,
    AllPastPendingItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AllPastPendingItemsQuery,
    AllPastPendingItemsQueryVariables
  >(AllPastPendingItemsDocument, options)
}
export function useAllPastPendingItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AllPastPendingItemsQuery,
    AllPastPendingItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AllPastPendingItemsQuery,
    AllPastPendingItemsQueryVariables
  >(AllPastPendingItemsDocument, options)
}
export type AllPastPendingItemsQueryHookResult = ReturnType<
  typeof useAllPastPendingItemsQuery
>
export type AllPastPendingItemsLazyQueryHookResult = ReturnType<
  typeof useAllPastPendingItemsLazyQuery
>
export type AllPastPendingItemsQueryResult = ApolloReactCommon.QueryResult<
  AllPastPendingItemsQuery,
  AllPastPendingItemsQueryVariables
>
export const HomeTierSubscriptionForUserDocument = /*#__PURE__*/ gql`
  query HomeTierSubscriptionForUser {
    tierSubscriptionForUser {
      ... on TierSubscription {
        id
        tier {
          id
          key
          name
          includedProducts {
            key
          }
          excludedProducts {
            key
          }
          products {
            active
            key
            name
          }
        }
        tierPrice {
          id
          billingFrequency
          amount {
            value
            currency
          }
        }
      }
    }
  }
`

/**
 * __useHomeTierSubscriptionForUserQuery__
 *
 * To run a query within a React component, call `useHomeTierSubscriptionForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeTierSubscriptionForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeTierSubscriptionForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeTierSubscriptionForUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    HomeTierSubscriptionForUserQuery,
    HomeTierSubscriptionForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    HomeTierSubscriptionForUserQuery,
    HomeTierSubscriptionForUserQueryVariables
  >(HomeTierSubscriptionForUserDocument, options)
}
export function useHomeTierSubscriptionForUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    HomeTierSubscriptionForUserQuery,
    HomeTierSubscriptionForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    HomeTierSubscriptionForUserQuery,
    HomeTierSubscriptionForUserQueryVariables
  >(HomeTierSubscriptionForUserDocument, options)
}
export type HomeTierSubscriptionForUserQueryHookResult = ReturnType<
  typeof useHomeTierSubscriptionForUserQuery
>
export type HomeTierSubscriptionForUserLazyQueryHookResult = ReturnType<
  typeof useHomeTierSubscriptionForUserLazyQuery
>
export type HomeTierSubscriptionForUserQueryResult =
  ApolloReactCommon.QueryResult<
    HomeTierSubscriptionForUserQuery,
    HomeTierSubscriptionForUserQueryVariables
  >
export const PresentInvestmentsTotalsQueryDocument = /*#__PURE__*/ gql`
  query PresentInvestmentsTotalsQuery(
    $settingTypes: [SplitDepositSettingType!]!
  ) {
    user {
      firstName
      verified
      closedAt
      state
      fundingSource {
        name
        verified
      }
    }
    userAlerts {
      __typename
    }
    allBankAccounts(input: { types: [spend, save] }) {
      createdAt
      isLocked
      availableBalance {
        currency
        value
      }
      pendingBalance {
        currency
        value
      }
      id
      goals {
        currentGoal {
          type
        }
      }
      type
      status
      isEligible
    }
    allInvestmentAccounts {
      type
      name
      currentBalance {
        currency
        value
      }
    }
    investmentAccountsByUserId {
      id
      type
      name
      closedAt
      currentBalance {
        currency
        value
      }
    }
    eligibility(eligibilityScope: fundSpendInActivation) {
      eligible
    }
    beneficiaries {
      ...BeneficiaryFields
    }
    splitDepositSettingsByUserId(
      filter: { settingTypes: $settingTypes, showHiddenEmployerSettings: false }
    ) {
      ...SplitDepositSettingsPartial
    }
  }
  ${BeneficiaryFieldsFragmentDoc}
  ${SplitDepositSettingsPartialFragmentDoc}
`

/**
 * __usePresentInvestmentsTotalsQueryQuery__
 *
 * To run a query within a React component, call `usePresentInvestmentsTotalsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePresentInvestmentsTotalsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePresentInvestmentsTotalsQueryQuery({
 *   variables: {
 *      settingTypes: // value for 'settingTypes'
 *   },
 * });
 */
export function usePresentInvestmentsTotalsQueryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    PresentInvestmentsTotalsQueryQuery,
    PresentInvestmentsTotalsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PresentInvestmentsTotalsQueryQuery,
    PresentInvestmentsTotalsQueryQueryVariables
  >(PresentInvestmentsTotalsQueryDocument, options)
}
export function usePresentInvestmentsTotalsQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PresentInvestmentsTotalsQueryQuery,
    PresentInvestmentsTotalsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PresentInvestmentsTotalsQueryQuery,
    PresentInvestmentsTotalsQueryQueryVariables
  >(PresentInvestmentsTotalsQueryDocument, options)
}
export type PresentInvestmentsTotalsQueryQueryHookResult = ReturnType<
  typeof usePresentInvestmentsTotalsQueryQuery
>
export type PresentInvestmentsTotalsQueryLazyQueryHookResult = ReturnType<
  typeof usePresentInvestmentsTotalsQueryLazyQuery
>
export type PresentInvestmentsTotalsQueryQueryResult =
  ApolloReactCommon.QueryResult<
    PresentInvestmentsTotalsQueryQuery,
    PresentInvestmentsTotalsQueryQueryVariables
  >
export const ReferralPillDocument = /*#__PURE__*/ gql`
  query ReferralPill {
    advocate {
      experienceContent {
        pillAmount
      }
    }
  }
`

/**
 * __useReferralPillQuery__
 *
 * To run a query within a React component, call `useReferralPillQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralPillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralPillQuery({
 *   variables: {
 *   },
 * });
 */
export function useReferralPillQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ReferralPillQuery,
    ReferralPillQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ReferralPillQuery,
    ReferralPillQueryVariables
  >(ReferralPillDocument, options)
}
export function useReferralPillLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ReferralPillQuery,
    ReferralPillQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ReferralPillQuery,
    ReferralPillQueryVariables
  >(ReferralPillDocument, options)
}
export type ReferralPillQueryHookResult = ReturnType<
  typeof useReferralPillQuery
>
export type ReferralPillLazyQueryHookResult = ReturnType<
  typeof useReferralPillLazyQuery
>
export type ReferralPillQueryResult = ApolloReactCommon.QueryResult<
  ReferralPillQuery,
  ReferralPillQueryVariables
>
export const ResumeDepositsDocument = /*#__PURE__*/ gql`
  mutation ResumeDeposits {
    suspendDeposits(suspended: false)
  }
`
export type ResumeDepositsMutationFn = ApolloReactCommon.MutationFunction<
  ResumeDepositsMutation,
  ResumeDepositsMutationVariables
>

/**
 * __useResumeDepositsMutation__
 *
 * To run a mutation, you first call `useResumeDepositsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeDepositsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeDepositsMutation, { data, loading, error }] = useResumeDepositsMutation({
 *   variables: {
 *   },
 * });
 */
export function useResumeDepositsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ResumeDepositsMutation,
    ResumeDepositsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ResumeDepositsMutation,
    ResumeDepositsMutationVariables
  >(ResumeDepositsDocument, options)
}
export type ResumeDepositsMutationHookResult = ReturnType<
  typeof useResumeDepositsMutation
>
export type ResumeDepositsMutationResult =
  ApolloReactCommon.MutationResult<ResumeDepositsMutation>
export type ResumeDepositsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ResumeDepositsMutation,
    ResumeDepositsMutationVariables
  >
export const CoreInfoDocument = /*#__PURE__*/ gql`
  query CoreInfo {
    user {
      fundingSource {
        alert
        name
        verified
      }
      investmentAccounts {
        closedAt
        product
        portfolio {
          id
          name
          theme
        }
      }
    }
    investmentAccount: investmentAccountsByUserId(filter: { product: INVEST }) {
      id
      closedAt
      currentBalance {
        value
      }
      portfolio {
        id
        name
        theme
      }
      portfolios {
        __typename
        id
        portfolioSecurities {
          symbol
        }
      }
    }
    userStatus {
      verified
    }
    recurringInvestmentSettings {
      ...RecurringInvestmentSettingsDetails
    }
    roundUpProfile {
      ...RoundUpProfileDetails
    }
    tierSubscriptionByUserId {
      id
      tier {
        id
        name
      }
    }
    spendAccount {
      status
    }
  }
  ${RecurringInvestmentSettingsDetailsFragmentDoc}
  ${RoundUpProfileDetailsFragmentDoc}
`

/**
 * __useCoreInfoQuery__
 *
 * To run a query within a React component, call `useCoreInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoreInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoreInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoreInfoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CoreInfoQuery,
    CoreInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<CoreInfoQuery, CoreInfoQueryVariables>(
    CoreInfoDocument,
    options,
  )
}
export function useCoreInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CoreInfoQuery,
    CoreInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<CoreInfoQuery, CoreInfoQueryVariables>(
    CoreInfoDocument,
    options,
  )
}
export type CoreInfoQueryHookResult = ReturnType<typeof useCoreInfoQuery>
export type CoreInfoLazyQueryHookResult = ReturnType<
  typeof useCoreInfoLazyQuery
>
export type CoreInfoQueryResult = ApolloReactCommon.QueryResult<
  CoreInfoQuery,
  CoreInfoQueryVariables
>
export const InvestmentAccountCoreDocument = /*#__PURE__*/ gql`
  query InvestmentAccountCore($withSmartDeposit: Boolean = false) {
    investAccount: investmentAccountsByUserId(filter: { product: INVEST }) {
      id
      closedAt
      currentBalance {
        value
      }
      recurringInvestmentSettings {
        frequency
        day
        amount
      }
      status
      userAge
    }
    laterAccount: investmentAccountsByUserId(filter: { product: LATER }) {
      id
      currentBalance {
        value
      }
      recurringInvestmentSettings {
        frequency
        day
        amount
      }
      status
    }
    user {
      fundingSource {
        verified
      }
    }
    roundUpProfile {
      roundUpsEnabled
      multiplier
      roundUpAccounts {
        linkedSubaccountId
      }
    }
    roundUpAccounts {
      enabled
    }
    settings {
      depositsSuspended
    }
    tierSubscriptionForUser {
      __typename
      ... on TierSubscription {
        id
        tier {
          id
          key
          includedProducts {
            key
          }
          excludedProducts {
            key
          }
        }
      }
    }
    splitDepositSettingsByUserId(
      filter: {
        settingTypes: [DIRECT_DEPOSIT, DIRECT_DEPOSIT_INTENT]
        showHiddenEmployerSettings: false
      }
      normalizeToFrequency: DAILY
    ) @include(if: $withSmartDeposit) {
      allocations {
        ...SmartDepositAllocationFragment
      }
      id
      isActive
      isHidden
      ... on SplitDepositDirectDepositIntentSetting {
        ...SplitDepositIntentSettingFragment
      }
      ... on SplitDepositDirectDepositSetting {
        ...SplitDepositDirectDepositSettingFragment
      }
      deposits(orderBy: DESC, limit: 1) {
        ...SplitDepositFragment
      }
      __typename
    }
    spendAccount {
      isEligible
      status
    }
  }
  ${SmartDepositAllocationFragmentFragmentDoc}
  ${SplitDepositIntentSettingFragmentFragmentDoc}
  ${SplitDepositDirectDepositSettingFragmentFragmentDoc}
  ${SplitDepositFragmentFragmentDoc}
`

/**
 * __useInvestmentAccountCoreQuery__
 *
 * To run a query within a React component, call `useInvestmentAccountCoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestmentAccountCoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestmentAccountCoreQuery({
 *   variables: {
 *      withSmartDeposit: // value for 'withSmartDeposit'
 *   },
 * });
 */
export function useInvestmentAccountCoreQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    InvestmentAccountCoreQuery,
    InvestmentAccountCoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    InvestmentAccountCoreQuery,
    InvestmentAccountCoreQueryVariables
  >(InvestmentAccountCoreDocument, options)
}
export function useInvestmentAccountCoreLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InvestmentAccountCoreQuery,
    InvestmentAccountCoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    InvestmentAccountCoreQuery,
    InvestmentAccountCoreQueryVariables
  >(InvestmentAccountCoreDocument, options)
}
export type InvestmentAccountCoreQueryHookResult = ReturnType<
  typeof useInvestmentAccountCoreQuery
>
export type InvestmentAccountCoreLazyQueryHookResult = ReturnType<
  typeof useInvestmentAccountCoreLazyQuery
>
export type InvestmentAccountCoreQueryResult = ApolloReactCommon.QueryResult<
  InvestmentAccountCoreQuery,
  InvestmentAccountCoreQueryVariables
>
export const UpdateRoundupProfileDocument = /*#__PURE__*/ gql`
  mutation updateRoundupProfile($input: RoundUpProfileInput!) {
    roundUpProfile(input: $input) {
      multiplier
      roundUpsEnabled
    }
  }
`
export type UpdateRoundupProfileMutationFn = ApolloReactCommon.MutationFunction<
  UpdateRoundupProfileMutation,
  UpdateRoundupProfileMutationVariables
>

/**
 * __useUpdateRoundupProfileMutation__
 *
 * To run a mutation, you first call `useUpdateRoundupProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoundupProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoundupProfileMutation, { data, loading, error }] = useUpdateRoundupProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoundupProfileMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateRoundupProfileMutation,
    UpdateRoundupProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateRoundupProfileMutation,
    UpdateRoundupProfileMutationVariables
  >(UpdateRoundupProfileDocument, options)
}
export type UpdateRoundupProfileMutationHookResult = ReturnType<
  typeof useUpdateRoundupProfileMutation
>
export type UpdateRoundupProfileMutationResult =
  ApolloReactCommon.MutationResult<UpdateRoundupProfileMutation>
export type UpdateRoundupProfileMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateRoundupProfileMutation,
    UpdateRoundupProfileMutationVariables
  >
export const ProductPortfolioFundDetailsDocument = /*#__PURE__*/ gql`
  query ProductPortfolioFundDetails($product: InvestmentProduct!) {
    investmentAccountsByUserId(filter: { product: $product }) {
      id
      closedAt
      portfolios {
        ... on SelfDirectedPortfolio {
          __typename
          id
          accountAllocation {
            allocationPercent
          }
          portfolioSecurityAllocations {
            allocationPercent
            symbol
          }
          name
          portfolioSecurities {
            ...PortfolioSecurities
          }
        }
        ... on Portfolio {
          __typename
          id
          customizationLevel
          portfolioSecurities {
            ...PortfolioSecurities
          }
          portfolioSecurityAllocations {
            allocationPercent
            symbol
          }
        }
      }
      recurringInvestmentSettings {
        nextInvestmentAt
      }
    }
  }
  ${PortfolioSecuritiesFragmentDoc}
`

/**
 * __useProductPortfolioFundDetailsQuery__
 *
 * To run a query within a React component, call `useProductPortfolioFundDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPortfolioFundDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPortfolioFundDetailsQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useProductPortfolioFundDetailsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ProductPortfolioFundDetailsQuery,
    ProductPortfolioFundDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ProductPortfolioFundDetailsQuery,
    ProductPortfolioFundDetailsQueryVariables
  >(ProductPortfolioFundDetailsDocument, options)
}
export function useProductPortfolioFundDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ProductPortfolioFundDetailsQuery,
    ProductPortfolioFundDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ProductPortfolioFundDetailsQuery,
    ProductPortfolioFundDetailsQueryVariables
  >(ProductPortfolioFundDetailsDocument, options)
}
export type ProductPortfolioFundDetailsQueryHookResult = ReturnType<
  typeof useProductPortfolioFundDetailsQuery
>
export type ProductPortfolioFundDetailsLazyQueryHookResult = ReturnType<
  typeof useProductPortfolioFundDetailsLazyQuery
>
export type ProductPortfolioFundDetailsQueryResult =
  ApolloReactCommon.QueryResult<
    ProductPortfolioFundDetailsQuery,
    ProductPortfolioFundDetailsQueryVariables
  >
export const SecurityInfoDocument = /*#__PURE__*/ gql`
  query SecurityInfo($symbol: TickerSymbol!) {
    securityBySymbol(input: { symbol: $symbol }) {
      ...SecurityBySymbolInfo
    }
  }
  ${SecurityBySymbolInfoFragmentDoc}
`

/**
 * __useSecurityInfoQuery__
 *
 * To run a query within a React component, call `useSecurityInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecurityInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecurityInfoQuery({
 *   variables: {
 *      symbol: // value for 'symbol'
 *   },
 * });
 */
export function useSecurityInfoQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SecurityInfoQuery,
    SecurityInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SecurityInfoQuery,
    SecurityInfoQueryVariables
  >(SecurityInfoDocument, options)
}
export function useSecurityInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SecurityInfoQuery,
    SecurityInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SecurityInfoQuery,
    SecurityInfoQueryVariables
  >(SecurityInfoDocument, options)
}
export type SecurityInfoQueryHookResult = ReturnType<
  typeof useSecurityInfoQuery
>
export type SecurityInfoLazyQueryHookResult = ReturnType<
  typeof useSecurityInfoLazyQuery
>
export type SecurityInfoQueryResult = ApolloReactCommon.QueryResult<
  SecurityInfoQuery,
  SecurityInfoQueryVariables
>
export const SecurityPerformanceDocument = /*#__PURE__*/ gql`
  query SecurityPerformance(
    $symbol: TickerSymbol!
    $startDate: DateTime!
    $endDate: DateTime!
  ) {
    securityPerformanceBySymbol(
      input: { symbol: $symbol, startDate: $startDate, endDate: $endDate }
    ) {
      ...SecurityPerformanceBySymbol
    }
  }
  ${SecurityPerformanceBySymbolFragmentDoc}
`

/**
 * __useSecurityPerformanceQuery__
 *
 * To run a query within a React component, call `useSecurityPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecurityPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecurityPerformanceQuery({
 *   variables: {
 *      symbol: // value for 'symbol'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useSecurityPerformanceQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SecurityPerformanceQuery,
    SecurityPerformanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SecurityPerformanceQuery,
    SecurityPerformanceQueryVariables
  >(SecurityPerformanceDocument, options)
}
export function useSecurityPerformanceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SecurityPerformanceQuery,
    SecurityPerformanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SecurityPerformanceQuery,
    SecurityPerformanceQueryVariables
  >(SecurityPerformanceDocument, options)
}
export type SecurityPerformanceQueryHookResult = ReturnType<
  typeof useSecurityPerformanceQuery
>
export type SecurityPerformanceLazyQueryHookResult = ReturnType<
  typeof useSecurityPerformanceLazyQuery
>
export type SecurityPerformanceQueryResult = ApolloReactCommon.QueryResult<
  SecurityPerformanceQuery,
  SecurityPerformanceQueryVariables
>
export const FundingSourceQueryDocument = /*#__PURE__*/ gql`
  query FundingSourceQuery {
    fundingSourceAccounts {
      institutionName
      verified
      role
      id
      accountName
    }
    investmentAccount: investmentAccountsByUserId(filter: { product: INVEST }) {
      id
      closedAt
      currentBalance {
        value
      }
      portfolio {
        id
        name
        theme
      }
      portfolios {
        __typename
        id
        portfolioSecurities {
          symbol
        }
      }
    }
  }
`

/**
 * __useFundingSourceQueryQuery__
 *
 * To run a query within a React component, call `useFundingSourceQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundingSourceQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundingSourceQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFundingSourceQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FundingSourceQueryQuery,
    FundingSourceQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FundingSourceQueryQuery,
    FundingSourceQueryQueryVariables
  >(FundingSourceQueryDocument, options)
}
export function useFundingSourceQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FundingSourceQueryQuery,
    FundingSourceQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FundingSourceQueryQuery,
    FundingSourceQueryQueryVariables
  >(FundingSourceQueryDocument, options)
}
export type FundingSourceQueryQueryHookResult = ReturnType<
  typeof useFundingSourceQueryQuery
>
export type FundingSourceQueryLazyQueryHookResult = ReturnType<
  typeof useFundingSourceQueryLazyQuery
>
export type FundingSourceQueryQueryResult = ApolloReactCommon.QueryResult<
  FundingSourceQueryQuery,
  FundingSourceQueryQueryVariables
>
export const CustomPortfolioAcceptDocumentDocument = /*#__PURE__*/ gql`
  mutation CustomPortfolioAcceptDocument($id: ID!) {
    agreeToAcceptanceDocument(id: $id)
  }
`
export type CustomPortfolioAcceptDocumentMutationFn =
  ApolloReactCommon.MutationFunction<
    CustomPortfolioAcceptDocumentMutation,
    CustomPortfolioAcceptDocumentMutationVariables
  >

/**
 * __useCustomPortfolioAcceptDocumentMutation__
 *
 * To run a mutation, you first call `useCustomPortfolioAcceptDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomPortfolioAcceptDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customPortfolioAcceptDocumentMutation, { data, loading, error }] = useCustomPortfolioAcceptDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomPortfolioAcceptDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CustomPortfolioAcceptDocumentMutation,
    CustomPortfolioAcceptDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CustomPortfolioAcceptDocumentMutation,
    CustomPortfolioAcceptDocumentMutationVariables
  >(CustomPortfolioAcceptDocumentDocument, options)
}
export type CustomPortfolioAcceptDocumentMutationHookResult = ReturnType<
  typeof useCustomPortfolioAcceptDocumentMutation
>
export type CustomPortfolioAcceptDocumentMutationResult =
  ApolloReactCommon.MutationResult<CustomPortfolioAcceptDocumentMutation>
export type CustomPortfolioAcceptDocumentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CustomPortfolioAcceptDocumentMutation,
    CustomPortfolioAcceptDocumentMutationVariables
  >
export const AddSelfDirectedPortfolioDocument = /*#__PURE__*/ gql`
  mutation AddSelfDirectedPortfolio($input: AddSelfDirectedPortfolioInput!) {
    addSelfDirectedPortfolio(input: $input) {
      __typename
      ... on InvestmentAccount {
        portfolios {
          ... on SelfDirectedPortfolio {
            portfolioSecurityAllocations {
              id
              allocationPercent
              symbol
            }
          }
          id
          __typename
        }
      }
    }
  }
`
export type AddSelfDirectedPortfolioMutationFn =
  ApolloReactCommon.MutationFunction<
    AddSelfDirectedPortfolioMutation,
    AddSelfDirectedPortfolioMutationVariables
  >

/**
 * __useAddSelfDirectedPortfolioMutation__
 *
 * To run a mutation, you first call `useAddSelfDirectedPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSelfDirectedPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSelfDirectedPortfolioMutation, { data, loading, error }] = useAddSelfDirectedPortfolioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSelfDirectedPortfolioMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddSelfDirectedPortfolioMutation,
    AddSelfDirectedPortfolioMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AddSelfDirectedPortfolioMutation,
    AddSelfDirectedPortfolioMutationVariables
  >(AddSelfDirectedPortfolioDocument, options)
}
export type AddSelfDirectedPortfolioMutationHookResult = ReturnType<
  typeof useAddSelfDirectedPortfolioMutation
>
export type AddSelfDirectedPortfolioMutationResult =
  ApolloReactCommon.MutationResult<AddSelfDirectedPortfolioMutation>
export type AddSelfDirectedPortfolioMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AddSelfDirectedPortfolioMutation,
    AddSelfDirectedPortfolioMutationVariables
  >
export const CustomPortfolioAllAcceptanceDocumentsDocument = /*#__PURE__*/ gql`
  query CustomPortfolioAllAcceptanceDocuments {
    allAcceptanceDocuments(requiredFor: "self_directed_invest") {
      id
      name
      url
    }
  }
`

/**
 * __useCustomPortfolioAllAcceptanceDocumentsQuery__
 *
 * To run a query within a React component, call `useCustomPortfolioAllAcceptanceDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomPortfolioAllAcceptanceDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomPortfolioAllAcceptanceDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomPortfolioAllAcceptanceDocumentsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CustomPortfolioAllAcceptanceDocumentsQuery,
    CustomPortfolioAllAcceptanceDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CustomPortfolioAllAcceptanceDocumentsQuery,
    CustomPortfolioAllAcceptanceDocumentsQueryVariables
  >(CustomPortfolioAllAcceptanceDocumentsDocument, options)
}
export function useCustomPortfolioAllAcceptanceDocumentsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CustomPortfolioAllAcceptanceDocumentsQuery,
    CustomPortfolioAllAcceptanceDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CustomPortfolioAllAcceptanceDocumentsQuery,
    CustomPortfolioAllAcceptanceDocumentsQueryVariables
  >(CustomPortfolioAllAcceptanceDocumentsDocument, options)
}
export type CustomPortfolioAllAcceptanceDocumentsQueryHookResult = ReturnType<
  typeof useCustomPortfolioAllAcceptanceDocumentsQuery
>
export type CustomPortfolioAllAcceptanceDocumentsLazyQueryHookResult =
  ReturnType<typeof useCustomPortfolioAllAcceptanceDocumentsLazyQuery>
export type CustomPortfolioAllAcceptanceDocumentsQueryResult =
  ApolloReactCommon.QueryResult<
    CustomPortfolioAllAcceptanceDocumentsQuery,
    CustomPortfolioAllAcceptanceDocumentsQueryVariables
  >
export const CustomPortfolioAllTiersDocument = /*#__PURE__*/ gql`
  query CustomPortfolioAllTiers {
    tierGroupForUser {
      id
      tierOptions {
        tier {
          id
          key
          name
          products {
            key
          }
          tierPrice {
            id
            amount {
              value
            }
          }
        }
      }
    }
  }
`

/**
 * __useCustomPortfolioAllTiersQuery__
 *
 * To run a query within a React component, call `useCustomPortfolioAllTiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomPortfolioAllTiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomPortfolioAllTiersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomPortfolioAllTiersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CustomPortfolioAllTiersQuery,
    CustomPortfolioAllTiersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CustomPortfolioAllTiersQuery,
    CustomPortfolioAllTiersQueryVariables
  >(CustomPortfolioAllTiersDocument, options)
}
export function useCustomPortfolioAllTiersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CustomPortfolioAllTiersQuery,
    CustomPortfolioAllTiersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CustomPortfolioAllTiersQuery,
    CustomPortfolioAllTiersQueryVariables
  >(CustomPortfolioAllTiersDocument, options)
}
export type CustomPortfolioAllTiersQueryHookResult = ReturnType<
  typeof useCustomPortfolioAllTiersQuery
>
export type CustomPortfolioAllTiersLazyQueryHookResult = ReturnType<
  typeof useCustomPortfolioAllTiersLazyQuery
>
export type CustomPortfolioAllTiersQueryResult = ApolloReactCommon.QueryResult<
  CustomPortfolioAllTiersQuery,
  CustomPortfolioAllTiersQueryVariables
>
export const CustomPortfolioFundingSourceInfoDocument = /*#__PURE__*/ gql`
  query CustomPortfolioFundingSourceInfo {
    fundingSourceInfo {
      type
    }
  }
`

/**
 * __useCustomPortfolioFundingSourceInfoQuery__
 *
 * To run a query within a React component, call `useCustomPortfolioFundingSourceInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomPortfolioFundingSourceInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomPortfolioFundingSourceInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomPortfolioFundingSourceInfoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CustomPortfolioFundingSourceInfoQuery,
    CustomPortfolioFundingSourceInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CustomPortfolioFundingSourceInfoQuery,
    CustomPortfolioFundingSourceInfoQueryVariables
  >(CustomPortfolioFundingSourceInfoDocument, options)
}
export function useCustomPortfolioFundingSourceInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CustomPortfolioFundingSourceInfoQuery,
    CustomPortfolioFundingSourceInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CustomPortfolioFundingSourceInfoQuery,
    CustomPortfolioFundingSourceInfoQueryVariables
  >(CustomPortfolioFundingSourceInfoDocument, options)
}
export type CustomPortfolioFundingSourceInfoQueryHookResult = ReturnType<
  typeof useCustomPortfolioFundingSourceInfoQuery
>
export type CustomPortfolioFundingSourceInfoLazyQueryHookResult = ReturnType<
  typeof useCustomPortfolioFundingSourceInfoLazyQuery
>
export type CustomPortfolioFundingSourceInfoQueryResult =
  ApolloReactCommon.QueryResult<
    CustomPortfolioFundingSourceInfoQuery,
    CustomPortfolioFundingSourceInfoQueryVariables
  >
export const InvestCorePortfolioDocument = /*#__PURE__*/ gql`
  query InvestCorePortfolio($product: InvestmentProduct) {
    investmentAccountsByUserId(filter: { product: $product }) {
      id
      closedAt
      product
      name
      currentBalance {
        value
      }
      portfolio {
        id
        riskLevel
        theme
      }
      status
      portfolios {
        __typename
        id
        name
        description
        ... on SelfDirectedPortfolio {
          status
        }
        accountAllocation {
          allocationPercent
        }
        portfolioSecurities {
          symbol
          marketValue {
            currency
            value
          }
        }
        portfolioSecurityAllocations {
          id
          symbol
          allocationPercent
          security {
            displayName
            longName
            type
            currentPrice {
              value
              currency
            }
            profile {
              logoUrl
            }
          }
        }
      }
      recommendedPortfolio {
        id
        minimumManagedAllocationPercent
        riskLevel
      }
      recurringInvestmentSettings {
        amount
        day
        frequency
        createdAt
        nextInvestmentAt
        updatedAt
      }
    }
  }
`

/**
 * __useInvestCorePortfolioQuery__
 *
 * To run a query within a React component, call `useInvestCorePortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestCorePortfolioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestCorePortfolioQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useInvestCorePortfolioQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    InvestCorePortfolioQuery,
    InvestCorePortfolioQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    InvestCorePortfolioQuery,
    InvestCorePortfolioQueryVariables
  >(InvestCorePortfolioDocument, options)
}
export function useInvestCorePortfolioLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InvestCorePortfolioQuery,
    InvestCorePortfolioQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    InvestCorePortfolioQuery,
    InvestCorePortfolioQueryVariables
  >(InvestCorePortfolioDocument, options)
}
export type InvestCorePortfolioQueryHookResult = ReturnType<
  typeof useInvestCorePortfolioQuery
>
export type InvestCorePortfolioLazyQueryHookResult = ReturnType<
  typeof useInvestCorePortfolioLazyQuery
>
export type InvestCorePortfolioQueryResult = ApolloReactCommon.QueryResult<
  InvestCorePortfolioQuery,
  InvestCorePortfolioQueryVariables
>
export const LanderOperationsDocument = /*#__PURE__*/ gql`
  query LanderOperations {
    user {
      verified
      investmentAccounts {
        product
      }
    }
    userAlerts {
      ... on UserAlert {
        type
      }
    }
  }
`

/**
 * __useLanderOperationsQuery__
 *
 * To run a query within a React component, call `useLanderOperationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanderOperationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanderOperationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLanderOperationsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    LanderOperationsQuery,
    LanderOperationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LanderOperationsQuery,
    LanderOperationsQueryVariables
  >(LanderOperationsDocument, options)
}
export function useLanderOperationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LanderOperationsQuery,
    LanderOperationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LanderOperationsQuery,
    LanderOperationsQueryVariables
  >(LanderOperationsDocument, options)
}
export type LanderOperationsQueryHookResult = ReturnType<
  typeof useLanderOperationsQuery
>
export type LanderOperationsLazyQueryHookResult = ReturnType<
  typeof useLanderOperationsLazyQuery
>
export type LanderOperationsQueryResult = ApolloReactCommon.QueryResult<
  LanderOperationsQuery,
  LanderOperationsQueryVariables
>
export const SearchForSecurityDocument = /*#__PURE__*/ gql`
  query SearchForSecurity($input: SearchSecuritiesInput!) {
    searchSecurities(input: $input) {
      securities {
        symbol
        longName
        shortName
        type
        currentPrice {
          value
        }
        profile {
          logoUrl
        }
        lastClosePrice {
          value
        }
        openPrice {
          value
        }
      }
      pageInfo {
        count
        hasPreviousPage
        totalMatches
        hasNextPage
        nextPageCursor
        prevPageCursor
      }
    }
  }
`

/**
 * __useSearchForSecurityQuery__
 *
 * To run a query within a React component, call `useSearchForSecurityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchForSecurityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchForSecurityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchForSecurityQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SearchForSecurityQuery,
    SearchForSecurityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SearchForSecurityQuery,
    SearchForSecurityQueryVariables
  >(SearchForSecurityDocument, options)
}
export function useSearchForSecurityLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SearchForSecurityQuery,
    SearchForSecurityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SearchForSecurityQuery,
    SearchForSecurityQueryVariables
  >(SearchForSecurityDocument, options)
}
export type SearchForSecurityQueryHookResult = ReturnType<
  typeof useSearchForSecurityQuery
>
export type SearchForSecurityLazyQueryHookResult = ReturnType<
  typeof useSearchForSecurityLazyQuery
>
export type SearchForSecurityQueryResult = ApolloReactCommon.QueryResult<
  SearchForSecurityQuery,
  SearchForSecurityQueryVariables
>
export const SearchForSecurityBySectorDocument = /*#__PURE__*/ gql`
  query SearchForSecurityBySector($input: SecuritiesBySectorInput!) {
    securitiesBySector(input: $input) {
      securities {
        symbol
        longName
        shortName
        type
        currentPrice {
          value
        }
        profile {
          logoUrl
        }
        lastClosePrice {
          value
        }
        openPrice {
          value
        }
      }
      pageInfo {
        count
        hasPreviousPage
        totalMatches
        hasNextPage
        nextPageCursor
        prevPageCursor
      }
    }
  }
`

/**
 * __useSearchForSecurityBySectorQuery__
 *
 * To run a query within a React component, call `useSearchForSecurityBySectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchForSecurityBySectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchForSecurityBySectorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchForSecurityBySectorQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SearchForSecurityBySectorQuery,
    SearchForSecurityBySectorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SearchForSecurityBySectorQuery,
    SearchForSecurityBySectorQueryVariables
  >(SearchForSecurityBySectorDocument, options)
}
export function useSearchForSecurityBySectorLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SearchForSecurityBySectorQuery,
    SearchForSecurityBySectorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SearchForSecurityBySectorQuery,
    SearchForSecurityBySectorQueryVariables
  >(SearchForSecurityBySectorDocument, options)
}
export type SearchForSecurityBySectorQueryHookResult = ReturnType<
  typeof useSearchForSecurityBySectorQuery
>
export type SearchForSecurityBySectorLazyQueryHookResult = ReturnType<
  typeof useSearchForSecurityBySectorLazyQuery
>
export type SearchForSecurityBySectorQueryResult =
  ApolloReactCommon.QueryResult<
    SearchForSecurityBySectorQuery,
    SearchForSecurityBySectorQueryVariables
  >
export const CustomPortfolioSubscribeUserToTierDocument = /*#__PURE__*/ gql`
  mutation CustomPortfolioSubscribeUserToTier(
    $input: SubscribeUserToTierInput!
  ) {
    subscribeUserToTier(input: $input) {
      __typename
      ... on TierSubscription {
        id
      }
    }
  }
`
export type CustomPortfolioSubscribeUserToTierMutationFn =
  ApolloReactCommon.MutationFunction<
    CustomPortfolioSubscribeUserToTierMutation,
    CustomPortfolioSubscribeUserToTierMutationVariables
  >

/**
 * __useCustomPortfolioSubscribeUserToTierMutation__
 *
 * To run a mutation, you first call `useCustomPortfolioSubscribeUserToTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomPortfolioSubscribeUserToTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customPortfolioSubscribeUserToTierMutation, { data, loading, error }] = useCustomPortfolioSubscribeUserToTierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomPortfolioSubscribeUserToTierMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CustomPortfolioSubscribeUserToTierMutation,
    CustomPortfolioSubscribeUserToTierMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CustomPortfolioSubscribeUserToTierMutation,
    CustomPortfolioSubscribeUserToTierMutationVariables
  >(CustomPortfolioSubscribeUserToTierDocument, options)
}
export type CustomPortfolioSubscribeUserToTierMutationHookResult = ReturnType<
  typeof useCustomPortfolioSubscribeUserToTierMutation
>
export type CustomPortfolioSubscribeUserToTierMutationResult =
  ApolloReactCommon.MutationResult<CustomPortfolioSubscribeUserToTierMutation>
export type CustomPortfolioSubscribeUserToTierMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CustomPortfolioSubscribeUserToTierMutation,
    CustomPortfolioSubscribeUserToTierMutationVariables
  >
export const CustomPortfolioTierSubscriptionDocument = /*#__PURE__*/ gql`
  query CustomPortfolioTierSubscription {
    tierSubscriptionByUserId {
      id
      tier {
        id
        active
        name
        tierPrice {
          id
          amount {
            value
          }
        }
        products {
          id
          key
          name
        }
      }
    }
  }
`

/**
 * __useCustomPortfolioTierSubscriptionQuery__
 *
 * To run a query within a React component, call `useCustomPortfolioTierSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomPortfolioTierSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomPortfolioTierSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomPortfolioTierSubscriptionQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CustomPortfolioTierSubscriptionQuery,
    CustomPortfolioTierSubscriptionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CustomPortfolioTierSubscriptionQuery,
    CustomPortfolioTierSubscriptionQueryVariables
  >(CustomPortfolioTierSubscriptionDocument, options)
}
export function useCustomPortfolioTierSubscriptionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CustomPortfolioTierSubscriptionQuery,
    CustomPortfolioTierSubscriptionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CustomPortfolioTierSubscriptionQuery,
    CustomPortfolioTierSubscriptionQueryVariables
  >(CustomPortfolioTierSubscriptionDocument, options)
}
export type CustomPortfolioTierSubscriptionQueryHookResult = ReturnType<
  typeof useCustomPortfolioTierSubscriptionQuery
>
export type CustomPortfolioTierSubscriptionLazyQueryHookResult = ReturnType<
  typeof useCustomPortfolioTierSubscriptionLazyQuery
>
export type CustomPortfolioTierSubscriptionQueryResult =
  ApolloReactCommon.QueryResult<
    CustomPortfolioTierSubscriptionQuery,
    CustomPortfolioTierSubscriptionQueryVariables
  >
export const UpdatePortfolioSecuritiesDocument = /*#__PURE__*/ gql`
  mutation UpdatePortfolioSecurities(
    $investmentAccountId: ID!
    $portfolioId: ID!
    $securityAllocations: [SecurityAllocationTarget!]!
  ) {
    updatePortfolioSecurities(
      input: {
        investmentAccountId: $investmentAccountId
        portfolioId: $portfolioId
        securityAllocations: $securityAllocations
      }
    ) {
      __typename
      ... on InvestmentAccount {
        id
        product
        name
        currentBalance {
          value
        }
        portfolio {
          id
          riskLevel
          theme
        }
        portfolios {
          __typename
          id
          name
          description
          accountAllocation {
            allocationPercent
          }
          portfolioSecurityAllocations {
            id
            symbol
            allocationPercent
            security {
              longName
              displayName
              profile {
                logoUrl
              }
            }
          }
        }
      }
      ... on InvalidSecurityError {
        securityId
      }
      ... on InvalidAllocationPercentError {
        maxAllocationPercent
      }
      ... on NegativeSecurityPercentError {
        securityId
      }
    }
  }
`
export type UpdatePortfolioSecuritiesMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdatePortfolioSecuritiesMutation,
    UpdatePortfolioSecuritiesMutationVariables
  >

/**
 * __useUpdatePortfolioSecuritiesMutation__
 *
 * To run a mutation, you first call `useUpdatePortfolioSecuritiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortfolioSecuritiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortfolioSecuritiesMutation, { data, loading, error }] = useUpdatePortfolioSecuritiesMutation({
 *   variables: {
 *      investmentAccountId: // value for 'investmentAccountId'
 *      portfolioId: // value for 'portfolioId'
 *      securityAllocations: // value for 'securityAllocations'
 *   },
 * });
 */
export function useUpdatePortfolioSecuritiesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdatePortfolioSecuritiesMutation,
    UpdatePortfolioSecuritiesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdatePortfolioSecuritiesMutation,
    UpdatePortfolioSecuritiesMutationVariables
  >(UpdatePortfolioSecuritiesDocument, options)
}
export type UpdatePortfolioSecuritiesMutationHookResult = ReturnType<
  typeof useUpdatePortfolioSecuritiesMutation
>
export type UpdatePortfolioSecuritiesMutationResult =
  ApolloReactCommon.MutationResult<UpdatePortfolioSecuritiesMutation>
export type UpdatePortfolioSecuritiesMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdatePortfolioSecuritiesMutation,
    UpdatePortfolioSecuritiesMutationVariables
  >
export const AllPastItemsCoreRecurringDocument = /*#__PURE__*/ gql`
  query AllPastItemsCoreRecurring(
    $filter: AllPastItemsFilter
    $pagination: PageInput
  ) {
    allPastItems(filter: $filter, pagination: $pagination) {
      edges {
        ...CoreRecurringPastEdge
      }
    }
  }
  ${CoreRecurringPastEdgeFragmentDoc}
`

/**
 * __useAllPastItemsCoreRecurringQuery__
 *
 * To run a query within a React component, call `useAllPastItemsCoreRecurringQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPastItemsCoreRecurringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPastItemsCoreRecurringQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAllPastItemsCoreRecurringQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AllPastItemsCoreRecurringQuery,
    AllPastItemsCoreRecurringQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AllPastItemsCoreRecurringQuery,
    AllPastItemsCoreRecurringQueryVariables
  >(AllPastItemsCoreRecurringDocument, options)
}
export function useAllPastItemsCoreRecurringLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AllPastItemsCoreRecurringQuery,
    AllPastItemsCoreRecurringQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AllPastItemsCoreRecurringQuery,
    AllPastItemsCoreRecurringQueryVariables
  >(AllPastItemsCoreRecurringDocument, options)
}
export type AllPastItemsCoreRecurringQueryHookResult = ReturnType<
  typeof useAllPastItemsCoreRecurringQuery
>
export type AllPastItemsCoreRecurringLazyQueryHookResult = ReturnType<
  typeof useAllPastItemsCoreRecurringLazyQuery
>
export type AllPastItemsCoreRecurringQueryResult =
  ApolloReactCommon.QueryResult<
    AllPastItemsCoreRecurringQuery,
    AllPastItemsCoreRecurringQueryVariables
  >
export const RoundupProfileDocument = /*#__PURE__*/ gql`
  query roundupProfile {
    roundUpProfile {
      roundUpsEnabled
      multiplier
      roundUpAccounts {
        linkedSubaccountId
        enabled
      }
      wholeDollarAmount
      roundUpTotal(state: [invested, roundedUp])
    }
    allBankAccounts(input: { type: spend }) {
      createdAt
      id
    }
  }
`

/**
 * __useRoundupProfileQuery__
 *
 * To run a query within a React component, call `useRoundupProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoundupProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoundupProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoundupProfileQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    RoundupProfileQuery,
    RoundupProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RoundupProfileQuery,
    RoundupProfileQueryVariables
  >(RoundupProfileDocument, options)
}
export function useRoundupProfileLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RoundupProfileQuery,
    RoundupProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RoundupProfileQuery,
    RoundupProfileQueryVariables
  >(RoundupProfileDocument, options)
}
export type RoundupProfileQueryHookResult = ReturnType<
  typeof useRoundupProfileQuery
>
export type RoundupProfileLazyQueryHookResult = ReturnType<
  typeof useRoundupProfileLazyQuery
>
export type RoundupProfileQueryResult = ApolloReactCommon.QueryResult<
  RoundupProfileQuery,
  RoundupProfileQueryVariables
>
export const UpdateRoundUpEnabledAndMultiplierDocument = /*#__PURE__*/ gql`
  mutation UpdateRoundUpEnabledAndMultiplier($input: RoundUpProfileInput!) {
    roundUpProfile(input: $input) {
      multiplier
      roundUpsEnabled
    }
  }
`
export type UpdateRoundUpEnabledAndMultiplierMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdateRoundUpEnabledAndMultiplierMutation,
    UpdateRoundUpEnabledAndMultiplierMutationVariables
  >

/**
 * __useUpdateRoundUpEnabledAndMultiplierMutation__
 *
 * To run a mutation, you first call `useUpdateRoundUpEnabledAndMultiplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoundUpEnabledAndMultiplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoundUpEnabledAndMultiplierMutation, { data, loading, error }] = useUpdateRoundUpEnabledAndMultiplierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoundUpEnabledAndMultiplierMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateRoundUpEnabledAndMultiplierMutation,
    UpdateRoundUpEnabledAndMultiplierMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateRoundUpEnabledAndMultiplierMutation,
    UpdateRoundUpEnabledAndMultiplierMutationVariables
  >(UpdateRoundUpEnabledAndMultiplierDocument, options)
}
export type UpdateRoundUpEnabledAndMultiplierMutationHookResult = ReturnType<
  typeof useUpdateRoundUpEnabledAndMultiplierMutation
>
export type UpdateRoundUpEnabledAndMultiplierMutationResult =
  ApolloReactCommon.MutationResult<UpdateRoundUpEnabledAndMultiplierMutation>
export type UpdateRoundUpEnabledAndMultiplierMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateRoundUpEnabledAndMultiplierMutation,
    UpdateRoundUpEnabledAndMultiplierMutationVariables
  >
export const UpdateWholeDollarRoundupDocument = /*#__PURE__*/ gql`
  mutation UpdateWholeDollarRoundup($input: RoundUpProfileInput!) {
    roundUpProfile(input: $input) {
      wholeDollarAmount
    }
  }
`
export type UpdateWholeDollarRoundupMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdateWholeDollarRoundupMutation,
    UpdateWholeDollarRoundupMutationVariables
  >

/**
 * __useUpdateWholeDollarRoundupMutation__
 *
 * To run a mutation, you first call `useUpdateWholeDollarRoundupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWholeDollarRoundupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWholeDollarRoundupMutation, { data, loading, error }] = useUpdateWholeDollarRoundupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWholeDollarRoundupMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateWholeDollarRoundupMutation,
    UpdateWholeDollarRoundupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateWholeDollarRoundupMutation,
    UpdateWholeDollarRoundupMutationVariables
  >(UpdateWholeDollarRoundupDocument, options)
}
export type UpdateWholeDollarRoundupMutationHookResult = ReturnType<
  typeof useUpdateWholeDollarRoundupMutation
>
export type UpdateWholeDollarRoundupMutationResult =
  ApolloReactCommon.MutationResult<UpdateWholeDollarRoundupMutation>
export type UpdateWholeDollarRoundupMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateWholeDollarRoundupMutation,
    UpdateWholeDollarRoundupMutationVariables
  >
export const RoundUpsDepositsSuspendedDocument = /*#__PURE__*/ gql`
  query RoundUpsDepositsSuspended {
    settings {
      __typename
      depositsSuspended
    }
  }
`

/**
 * __useRoundUpsDepositsSuspendedQuery__
 *
 * To run a query within a React component, call `useRoundUpsDepositsSuspendedQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoundUpsDepositsSuspendedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoundUpsDepositsSuspendedQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoundUpsDepositsSuspendedQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    RoundUpsDepositsSuspendedQuery,
    RoundUpsDepositsSuspendedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RoundUpsDepositsSuspendedQuery,
    RoundUpsDepositsSuspendedQueryVariables
  >(RoundUpsDepositsSuspendedDocument, options)
}
export function useRoundUpsDepositsSuspendedLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RoundUpsDepositsSuspendedQuery,
    RoundUpsDepositsSuspendedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RoundUpsDepositsSuspendedQuery,
    RoundUpsDepositsSuspendedQueryVariables
  >(RoundUpsDepositsSuspendedDocument, options)
}
export type RoundUpsDepositsSuspendedQueryHookResult = ReturnType<
  typeof useRoundUpsDepositsSuspendedQuery
>
export type RoundUpsDepositsSuspendedLazyQueryHookResult = ReturnType<
  typeof useRoundUpsDepositsSuspendedLazyQuery
>
export type RoundUpsDepositsSuspendedQueryResult =
  ApolloReactCommon.QueryResult<
    RoundUpsDepositsSuspendedQuery,
    RoundUpsDepositsSuspendedQueryVariables
  >
export const ManualRoundupDocument = /*#__PURE__*/ gql`
  mutation ManualRoundup($roundUpIds: [ID!]!) {
    setManualRoundUps(roundUpIds: $roundUpIds) {
      ...RoundUpFields
      roundUpProfile {
        ...RoundUpProfileFields
      }
    }
  }
  ${RoundUpFieldsFragmentDoc}
  ${RoundUpProfileFieldsFragmentDoc}
`
export type ManualRoundupMutationFn = ApolloReactCommon.MutationFunction<
  ManualRoundupMutation,
  ManualRoundupMutationVariables
>

/**
 * __useManualRoundupMutation__
 *
 * To run a mutation, you first call `useManualRoundupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManualRoundupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manualRoundupMutation, { data, loading, error }] = useManualRoundupMutation({
 *   variables: {
 *      roundUpIds: // value for 'roundUpIds'
 *   },
 * });
 */
export function useManualRoundupMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ManualRoundupMutation,
    ManualRoundupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ManualRoundupMutation,
    ManualRoundupMutationVariables
  >(ManualRoundupDocument, options)
}
export type ManualRoundupMutationHookResult = ReturnType<
  typeof useManualRoundupMutation
>
export type ManualRoundupMutationResult =
  ApolloReactCommon.MutationResult<ManualRoundupMutation>
export type ManualRoundupMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ManualRoundupMutation,
    ManualRoundupMutationVariables
  >
export const RoundUpsDocument = /*#__PURE__*/ gql`
  query RoundUps($states: [RoundUpState!]!, $after: ID, $targetAccountId: ID) {
    roundUps(
      state: $states
      pageInput: { first: 50, after: $after }
      targetAccountId: $targetAccountId
    ) @connection(key: "roundUps") {
      __typename
      edges {
        cursor
        node {
          ...RoundUpFields
        }
      }
      pageInfo {
        hasNextPage
      }
    }
  }
  ${RoundUpFieldsFragmentDoc}
`

/**
 * __useRoundUpsQuery__
 *
 * To run a query within a React component, call `useRoundUpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoundUpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoundUpsQuery({
 *   variables: {
 *      states: // value for 'states'
 *      after: // value for 'after'
 *      targetAccountId: // value for 'targetAccountId'
 *   },
 * });
 */
export function useRoundUpsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    RoundUpsQuery,
    RoundUpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<RoundUpsQuery, RoundUpsQueryVariables>(
    RoundUpsDocument,
    options,
  )
}
export function useRoundUpsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RoundUpsQuery,
    RoundUpsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<RoundUpsQuery, RoundUpsQueryVariables>(
    RoundUpsDocument,
    options,
  )
}
export type RoundUpsQueryHookResult = ReturnType<typeof useRoundUpsQuery>
export type RoundUpsLazyQueryHookResult = ReturnType<
  typeof useRoundUpsLazyQuery
>
export type RoundUpsQueryResult = ApolloReactCommon.QueryResult<
  RoundUpsQuery,
  RoundUpsQueryVariables
>
export const RoundupsPageDocument = /*#__PURE__*/ gql`
  query RoundupsPage {
    user {
      fundingSource {
        name
      }
    }
    settings {
      __typename
      depositsSuspended
    }
    linkedAccounts(linked: true) {
      id
      status
    }
    investmentAccountsByUserId {
      id
      closedAt
      product
    }
    roundUpAccounts {
      enabled
    }
    userStatus {
      verified
    }
    roundUpProfile {
      ...RoundUpProfileFields
    }
  }
  ${RoundUpProfileFieldsFragmentDoc}
`

/**
 * __useRoundupsPageQuery__
 *
 * To run a query within a React component, call `useRoundupsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoundupsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoundupsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoundupsPageQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    RoundupsPageQuery,
    RoundupsPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RoundupsPageQuery,
    RoundupsPageQueryVariables
  >(RoundupsPageDocument, options)
}
export function useRoundupsPageLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RoundupsPageQuery,
    RoundupsPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RoundupsPageQuery,
    RoundupsPageQueryVariables
  >(RoundupsPageDocument, options)
}
export type RoundupsPageQueryHookResult = ReturnType<
  typeof useRoundupsPageQuery
>
export type RoundupsPageLazyQueryHookResult = ReturnType<
  typeof useRoundupsPageLazyQuery
>
export type RoundupsPageQueryResult = ApolloReactCommon.QueryResult<
  RoundupsPageQuery,
  RoundupsPageQueryVariables
>
export const EstimatedTransferDateDocument = /*#__PURE__*/ gql`
  query EstimatedTransferDate(
    $amount: CurrencyAmountInput
    $fromAccountType: TransferableAccountTypeEnum!
    $toAccountType: TransferableAccountTypeEnum!
  ) {
    estimatedTransferDates(
      input: {
        amount: $amount
        fromAccountType: $fromAccountType
        toAccountType: $toAccountType
      }
    ) {
      estimatedTransferCompletedAt
    }
  }
`

/**
 * __useEstimatedTransferDateQuery__
 *
 * To run a query within a React component, call `useEstimatedTransferDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstimatedTransferDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstimatedTransferDateQuery({
 *   variables: {
 *      amount: // value for 'amount'
 *      fromAccountType: // value for 'fromAccountType'
 *      toAccountType: // value for 'toAccountType'
 *   },
 * });
 */
export function useEstimatedTransferDateQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    EstimatedTransferDateQuery,
    EstimatedTransferDateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EstimatedTransferDateQuery,
    EstimatedTransferDateQueryVariables
  >(EstimatedTransferDateDocument, options)
}
export function useEstimatedTransferDateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EstimatedTransferDateQuery,
    EstimatedTransferDateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EstimatedTransferDateQuery,
    EstimatedTransferDateQueryVariables
  >(EstimatedTransferDateDocument, options)
}
export type EstimatedTransferDateQueryHookResult = ReturnType<
  typeof useEstimatedTransferDateQuery
>
export type EstimatedTransferDateLazyQueryHookResult = ReturnType<
  typeof useEstimatedTransferDateLazyQuery
>
export type EstimatedTransferDateQueryResult = ApolloReactCommon.QueryResult<
  EstimatedTransferDateQuery,
  EstimatedTransferDateQueryVariables
>
export const FundingSourceAccountsQueryDocument = /*#__PURE__*/ gql`
  query FundingSourceAccountsQuery {
    fundingSourceAccounts {
      accountName
      institutionName
      last4
      id
      role
      fundType
      uuid
      verified
      preferredWithdrawalAccount
    }
    allBankAccounts(input: { type: spend }) {
      availableBalance {
        value
      }
      isLocked
      lockReason
    }
  }
`

/**
 * __useFundingSourceAccountsQueryQuery__
 *
 * To run a query within a React component, call `useFundingSourceAccountsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundingSourceAccountsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundingSourceAccountsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFundingSourceAccountsQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FundingSourceAccountsQueryQuery,
    FundingSourceAccountsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FundingSourceAccountsQueryQuery,
    FundingSourceAccountsQueryQueryVariables
  >(FundingSourceAccountsQueryDocument, options)
}
export function useFundingSourceAccountsQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FundingSourceAccountsQueryQuery,
    FundingSourceAccountsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FundingSourceAccountsQueryQuery,
    FundingSourceAccountsQueryQueryVariables
  >(FundingSourceAccountsQueryDocument, options)
}
export type FundingSourceAccountsQueryQueryHookResult = ReturnType<
  typeof useFundingSourceAccountsQueryQuery
>
export type FundingSourceAccountsQueryLazyQueryHookResult = ReturnType<
  typeof useFundingSourceAccountsQueryLazyQuery
>
export type FundingSourceAccountsQueryQueryResult =
  ApolloReactCommon.QueryResult<
    FundingSourceAccountsQueryQuery,
    FundingSourceAccountsQueryQueryVariables
  >
export const UpdatePreferredWithdrawalAccountDocument = /*#__PURE__*/ gql`
  mutation UpdatePreferredWithdrawalAccount($accountId: ID!) {
    setPreferredWithdrawalAccount(input: { fundingSourceUuid: $accountId }) {
      __typename
    }
  }
`
export type UpdatePreferredWithdrawalAccountMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdatePreferredWithdrawalAccountMutation,
    UpdatePreferredWithdrawalAccountMutationVariables
  >

/**
 * __useUpdatePreferredWithdrawalAccountMutation__
 *
 * To run a mutation, you first call `useUpdatePreferredWithdrawalAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreferredWithdrawalAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreferredWithdrawalAccountMutation, { data, loading, error }] = useUpdatePreferredWithdrawalAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useUpdatePreferredWithdrawalAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdatePreferredWithdrawalAccountMutation,
    UpdatePreferredWithdrawalAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdatePreferredWithdrawalAccountMutation,
    UpdatePreferredWithdrawalAccountMutationVariables
  >(UpdatePreferredWithdrawalAccountDocument, options)
}
export type UpdatePreferredWithdrawalAccountMutationHookResult = ReturnType<
  typeof useUpdatePreferredWithdrawalAccountMutation
>
export type UpdatePreferredWithdrawalAccountMutationResult =
  ApolloReactCommon.MutationResult<UpdatePreferredWithdrawalAccountMutation>
export type UpdatePreferredWithdrawalAccountMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdatePreferredWithdrawalAccountMutation,
    UpdatePreferredWithdrawalAccountMutationVariables
  >
export const MakeWithdrawalDocument = /*#__PURE__*/ gql`
  mutation MakeWithdrawal(
    $amount: Float!
    $fundingSourceId: ID!
    $type: InvestmentTypes!
    $investmentAccountId: ID
  ) {
    makeInvestment(
      input: {
        amount: $amount
        fundingSourceId: $fundingSourceId
        investmentAccountId: $investmentAccountId
        type: $type
      }
    ) {
      id
    }
  }
`
export type MakeWithdrawalMutationFn = ApolloReactCommon.MutationFunction<
  MakeWithdrawalMutation,
  MakeWithdrawalMutationVariables
>

/**
 * __useMakeWithdrawalMutation__
 *
 * To run a mutation, you first call `useMakeWithdrawalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeWithdrawalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeWithdrawalMutation, { data, loading, error }] = useMakeWithdrawalMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      fundingSourceId: // value for 'fundingSourceId'
 *      type: // value for 'type'
 *      investmentAccountId: // value for 'investmentAccountId'
 *   },
 * });
 */
export function useMakeWithdrawalMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    MakeWithdrawalMutation,
    MakeWithdrawalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    MakeWithdrawalMutation,
    MakeWithdrawalMutationVariables
  >(MakeWithdrawalDocument, options)
}
export type MakeWithdrawalMutationHookResult = ReturnType<
  typeof useMakeWithdrawalMutation
>
export type MakeWithdrawalMutationResult =
  ApolloReactCommon.MutationResult<MakeWithdrawalMutation>
export type MakeWithdrawalMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    MakeWithdrawalMutation,
    MakeWithdrawalMutationVariables
  >
export const InvestDetailsDocument = /*#__PURE__*/ gql`
  query InvestDetails {
    user {
      fundingSource {
        alert
        name
        verified
      }
    }
    profile {
      transfersPaused
    }
    investmentAccount: investmentAccountsByUserId(filter: { product: INVEST }) {
      id
      closedAt
      currentBalance {
        value
      }
      portfolio {
        id
        name
        theme
      }
      portfolios {
        __typename
        id
        portfolioSecurities {
          symbol
        }
      }
    }
    spendAccount {
      status
    }
  }
`

/**
 * __useInvestDetailsQuery__
 *
 * To run a query within a React component, call `useInvestDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvestDetailsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    InvestDetailsQuery,
    InvestDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    InvestDetailsQuery,
    InvestDetailsQueryVariables
  >(InvestDetailsDocument, options)
}
export function useInvestDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InvestDetailsQuery,
    InvestDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    InvestDetailsQuery,
    InvestDetailsQueryVariables
  >(InvestDetailsDocument, options)
}
export type InvestDetailsQueryHookResult = ReturnType<
  typeof useInvestDetailsQuery
>
export type InvestDetailsLazyQueryHookResult = ReturnType<
  typeof useInvestDetailsLazyQuery
>
export type InvestDetailsQueryResult = ApolloReactCommon.QueryResult<
  InvestDetailsQuery,
  InvestDetailsQueryVariables
>
export const InvestOverviewQueryDocument = /*#__PURE__*/ gql`
  query InvestOverviewQuery($start: DateTime!) {
    user {
      verified
    }
    laterAccounts {
      amount
      performance {
        periodMarketChange
        periodMarketChangePercent
      }
    }
    performance(start: $start, days: -1) {
      accountValues {
        amount
      }
      marketChange
      marketChangePercent
    }
  }
`

/**
 * __useInvestOverviewQueryQuery__
 *
 * To run a query within a React component, call `useInvestOverviewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestOverviewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestOverviewQueryQuery({
 *   variables: {
 *      start: // value for 'start'
 *   },
 * });
 */
export function useInvestOverviewQueryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    InvestOverviewQueryQuery,
    InvestOverviewQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    InvestOverviewQueryQuery,
    InvestOverviewQueryQueryVariables
  >(InvestOverviewQueryDocument, options)
}
export function useInvestOverviewQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InvestOverviewQueryQuery,
    InvestOverviewQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    InvestOverviewQueryQuery,
    InvestOverviewQueryQueryVariables
  >(InvestOverviewQueryDocument, options)
}
export type InvestOverviewQueryQueryHookResult = ReturnType<
  typeof useInvestOverviewQueryQuery
>
export type InvestOverviewQueryLazyQueryHookResult = ReturnType<
  typeof useInvestOverviewQueryLazyQuery
>
export type InvestOverviewQueryQueryResult = ApolloReactCommon.QueryResult<
  InvestOverviewQueryQuery,
  InvestOverviewQueryQueryVariables
>
export const LaterTotalLiquidationlMutationDocument = /*#__PURE__*/ gql`
  mutation laterTotalLiquidationlMutation(
    $investmentAccountId: ID!
    $federalTaxes: Float!
    $stateTaxes: Float!
    $withdrawalType: LaterWithdrawalType
    $taxYear: Int!
    $reason: LaterWithdrawalReason!
  ) {
    laterTotalLiquidation(
      investmentAccountId: $investmentAccountId
      input: {
        federalTaxes: $federalTaxes
        stateTaxes: $stateTaxes
        withdrawalType: $withdrawalType
        taxYear: $taxYear
        reason: $reason
      }
    )
  }
`
export type LaterTotalLiquidationlMutationMutationFn =
  ApolloReactCommon.MutationFunction<
    LaterTotalLiquidationlMutationMutation,
    LaterTotalLiquidationlMutationMutationVariables
  >

/**
 * __useLaterTotalLiquidationlMutationMutation__
 *
 * To run a mutation, you first call `useLaterTotalLiquidationlMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaterTotalLiquidationlMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [laterTotalLiquidationlMutationMutation, { data, loading, error }] = useLaterTotalLiquidationlMutationMutation({
 *   variables: {
 *      investmentAccountId: // value for 'investmentAccountId'
 *      federalTaxes: // value for 'federalTaxes'
 *      stateTaxes: // value for 'stateTaxes'
 *      withdrawalType: // value for 'withdrawalType'
 *      taxYear: // value for 'taxYear'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useLaterTotalLiquidationlMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    LaterTotalLiquidationlMutationMutation,
    LaterTotalLiquidationlMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    LaterTotalLiquidationlMutationMutation,
    LaterTotalLiquidationlMutationMutationVariables
  >(LaterTotalLiquidationlMutationDocument, options)
}
export type LaterTotalLiquidationlMutationMutationHookResult = ReturnType<
  typeof useLaterTotalLiquidationlMutationMutation
>
export type LaterTotalLiquidationlMutationMutationResult =
  ApolloReactCommon.MutationResult<LaterTotalLiquidationlMutationMutation>
export type LaterTotalLiquidationlMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    LaterTotalLiquidationlMutationMutation,
    LaterTotalLiquidationlMutationMutationVariables
  >
export const LaterWithdrawalMutationDocument = /*#__PURE__*/ gql`
  mutation laterWithdrawalMutation(
    $investmentAccountId: ID!
    $amount: Float!
    $federalTaxes: Float!
    $stateTaxes: Float!
    $taxYear: Int!
    $reason: LaterWithdrawalReason!
  ) {
    laterWithdrawal(
      investmentAccountId: $investmentAccountId
      amount: $amount
      federalTaxes: $federalTaxes
      stateTaxes: $stateTaxes
      taxYear: $taxYear
      reason: $reason
    )
  }
`
export type LaterWithdrawalMutationMutationFn =
  ApolloReactCommon.MutationFunction<
    LaterWithdrawalMutationMutation,
    LaterWithdrawalMutationMutationVariables
  >

/**
 * __useLaterWithdrawalMutationMutation__
 *
 * To run a mutation, you first call `useLaterWithdrawalMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaterWithdrawalMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [laterWithdrawalMutationMutation, { data, loading, error }] = useLaterWithdrawalMutationMutation({
 *   variables: {
 *      investmentAccountId: // value for 'investmentAccountId'
 *      amount: // value for 'amount'
 *      federalTaxes: // value for 'federalTaxes'
 *      stateTaxes: // value for 'stateTaxes'
 *      taxYear: // value for 'taxYear'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useLaterWithdrawalMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    LaterWithdrawalMutationMutation,
    LaterWithdrawalMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    LaterWithdrawalMutationMutation,
    LaterWithdrawalMutationMutationVariables
  >(LaterWithdrawalMutationDocument, options)
}
export type LaterWithdrawalMutationMutationHookResult = ReturnType<
  typeof useLaterWithdrawalMutationMutation
>
export type LaterWithdrawalMutationMutationResult =
  ApolloReactCommon.MutationResult<LaterWithdrawalMutationMutation>
export type LaterWithdrawalMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    LaterWithdrawalMutationMutation,
    LaterWithdrawalMutationMutationVariables
  >
export const OneTimeContributionMutationDocument = /*#__PURE__*/ gql`
  mutation oneTimeContributionMutation(
    $accountId: ID!
    $amount: Float!
    $year: Int
  ) {
    createLaterContribution(accountId: $accountId, amount: $amount, year: $year)
  }
`
export type OneTimeContributionMutationMutationFn =
  ApolloReactCommon.MutationFunction<
    OneTimeContributionMutationMutation,
    OneTimeContributionMutationMutationVariables
  >

/**
 * __useOneTimeContributionMutationMutation__
 *
 * To run a mutation, you first call `useOneTimeContributionMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOneTimeContributionMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oneTimeContributionMutationMutation, { data, loading, error }] = useOneTimeContributionMutationMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      amount: // value for 'amount'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useOneTimeContributionMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    OneTimeContributionMutationMutation,
    OneTimeContributionMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    OneTimeContributionMutationMutation,
    OneTimeContributionMutationMutationVariables
  >(OneTimeContributionMutationDocument, options)
}
export type OneTimeContributionMutationMutationHookResult = ReturnType<
  typeof useOneTimeContributionMutationMutation
>
export type OneTimeContributionMutationMutationResult =
  ApolloReactCommon.MutationResult<OneTimeContributionMutationMutation>
export type OneTimeContributionMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    OneTimeContributionMutationMutation,
    OneTimeContributionMutationMutationVariables
  >
export const StopRecurringContributionMutationDocument = /*#__PURE__*/ gql`
  mutation stopRecurringContributionMutation($investment_account_id: String!) {
    stopRecurringInvestment(investmentAccountId: $investment_account_id) {
      recurringInvestmentSettings {
        amount
        day
        frequency
      }
    }
  }
`
export type StopRecurringContributionMutationMutationFn =
  ApolloReactCommon.MutationFunction<
    StopRecurringContributionMutationMutation,
    StopRecurringContributionMutationMutationVariables
  >

/**
 * __useStopRecurringContributionMutationMutation__
 *
 * To run a mutation, you first call `useStopRecurringContributionMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopRecurringContributionMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopRecurringContributionMutationMutation, { data, loading, error }] = useStopRecurringContributionMutationMutation({
 *   variables: {
 *      investment_account_id: // value for 'investment_account_id'
 *   },
 * });
 */
export function useStopRecurringContributionMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    StopRecurringContributionMutationMutation,
    StopRecurringContributionMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    StopRecurringContributionMutationMutation,
    StopRecurringContributionMutationMutationVariables
  >(StopRecurringContributionMutationDocument, options)
}
export type StopRecurringContributionMutationMutationHookResult = ReturnType<
  typeof useStopRecurringContributionMutationMutation
>
export type StopRecurringContributionMutationMutationResult =
  ApolloReactCommon.MutationResult<StopRecurringContributionMutationMutation>
export type StopRecurringContributionMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    StopRecurringContributionMutationMutation,
    StopRecurringContributionMutationMutationVariables
  >
export const UpdateLaterBeneficiariesDocument = /*#__PURE__*/ gql`
  mutation updateLaterBeneficiaries(
    $firstName: String!
    $lastName: String!
    $birthDate: DateTime!
    $ssn: String
    $relationship: String
    $addressLine1: String
    $addressLine2: String
    $city: String
    $state: String
    $zip: String
    $country: String
    $accountId: ID!
  ) {
    laterCreateIndividualBeneficiary(
      firstName: $firstName
      lastName: $lastName
      birthDate: $birthDate
      ssn: $ssn
      relationship: $relationship
      addressLine1: $addressLine1
      addressLine2: $addressLine2
      city: $city
      state: $state
      zip: $zip
      country: $country
      accountId: $accountId
    ) {
      beneficiaryId
    }
  }
`
export type UpdateLaterBeneficiariesMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdateLaterBeneficiariesMutation,
    UpdateLaterBeneficiariesMutationVariables
  >

/**
 * __useUpdateLaterBeneficiariesMutation__
 *
 * To run a mutation, you first call `useUpdateLaterBeneficiariesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaterBeneficiariesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaterBeneficiariesMutation, { data, loading, error }] = useUpdateLaterBeneficiariesMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      birthDate: // value for 'birthDate'
 *      ssn: // value for 'ssn'
 *      relationship: // value for 'relationship'
 *      addressLine1: // value for 'addressLine1'
 *      addressLine2: // value for 'addressLine2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zip: // value for 'zip'
 *      country: // value for 'country'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useUpdateLaterBeneficiariesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateLaterBeneficiariesMutation,
    UpdateLaterBeneficiariesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateLaterBeneficiariesMutation,
    UpdateLaterBeneficiariesMutationVariables
  >(UpdateLaterBeneficiariesDocument, options)
}
export type UpdateLaterBeneficiariesMutationHookResult = ReturnType<
  typeof useUpdateLaterBeneficiariesMutation
>
export type UpdateLaterBeneficiariesMutationResult =
  ApolloReactCommon.MutationResult<UpdateLaterBeneficiariesMutation>
export type UpdateLaterBeneficiariesMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateLaterBeneficiariesMutation,
    UpdateLaterBeneficiariesMutationVariables
  >
export const UpdateRecurringContributionMutationDocument = /*#__PURE__*/ gql`
  mutation updateRecurringContributionMutation(
    $amount: Float!
    $day: Int!
    $frequency: InvestmentFrequency!
    $investment_account_id: String!
  ) {
    updateRecurringInvestment(
      input: {
        amount: $amount
        day: $day
        frequency: $frequency
        investmentAccountId: $investment_account_id
      }
    ) {
      recurringInvestmentSettings {
        amount
        day
        frequency
      }
    }
  }
`
export type UpdateRecurringContributionMutationMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdateRecurringContributionMutationMutation,
    UpdateRecurringContributionMutationMutationVariables
  >

/**
 * __useUpdateRecurringContributionMutationMutation__
 *
 * To run a mutation, you first call `useUpdateRecurringContributionMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecurringContributionMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecurringContributionMutationMutation, { data, loading, error }] = useUpdateRecurringContributionMutationMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      day: // value for 'day'
 *      frequency: // value for 'frequency'
 *      investment_account_id: // value for 'investment_account_id'
 *   },
 * });
 */
export function useUpdateRecurringContributionMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateRecurringContributionMutationMutation,
    UpdateRecurringContributionMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateRecurringContributionMutationMutation,
    UpdateRecurringContributionMutationMutationVariables
  >(UpdateRecurringContributionMutationDocument, options)
}
export type UpdateRecurringContributionMutationMutationHookResult = ReturnType<
  typeof useUpdateRecurringContributionMutationMutation
>
export type UpdateRecurringContributionMutationMutationResult =
  ApolloReactCommon.MutationResult<UpdateRecurringContributionMutationMutation>
export type UpdateRecurringContributionMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateRecurringContributionMutationMutation,
    UpdateRecurringContributionMutationMutationVariables
  >
export const LaterOneTimeDocument = /*#__PURE__*/ gql`
  query LaterOneTime {
    laterUserContributionAbility {
      ... on ContributionAbilityByYear {
        contributionAbilities {
          canContribute
          planLimit
          remaining
          taxYear
          yearToDate
          __typename
        }
      }
      __typename
    }
    fundingSourceAccounts {
      ...fundingSourceAccountsLaterOneTime
    }
    laterAccounts {
      amount
      name
      accountId
      accountNumber
      contributionLimit
      portfolioName
      recurringSettings {
        amount
        frequency
        day
      }
      code
    }
    settings {
      depositsSuspended
    }
    allBankAccounts(input: { type: spend }) {
      ...allBankAccountsLaterOneTime
    }
    profile {
      maritalStatus
    }
  }
  ${FundingSourceAccountsLaterOneTimeFragmentDoc}
  ${AllBankAccountsLaterOneTimeFragmentDoc}
`

/**
 * __useLaterOneTimeQuery__
 *
 * To run a query within a React component, call `useLaterOneTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaterOneTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaterOneTimeQuery({
 *   variables: {
 *   },
 * });
 */
export function useLaterOneTimeQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    LaterOneTimeQuery,
    LaterOneTimeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LaterOneTimeQuery,
    LaterOneTimeQueryVariables
  >(LaterOneTimeDocument, options)
}
export function useLaterOneTimeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LaterOneTimeQuery,
    LaterOneTimeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LaterOneTimeQuery,
    LaterOneTimeQueryVariables
  >(LaterOneTimeDocument, options)
}
export type LaterOneTimeQueryHookResult = ReturnType<
  typeof useLaterOneTimeQuery
>
export type LaterOneTimeLazyQueryHookResult = ReturnType<
  typeof useLaterOneTimeLazyQuery
>
export type LaterOneTimeQueryResult = ApolloReactCommon.QueryResult<
  LaterOneTimeQuery,
  LaterOneTimeQueryVariables
>
export const AllPastItemsLaterRecurringDocument = /*#__PURE__*/ gql`
  query AllPastItemsLaterRecurring(
    $filter: AllPastItemsFilter
    $pagination: PageInput
  ) {
    allPastItems(filter: $filter, pagination: $pagination) {
      edges {
        ...LaterRecurringPastEdge
      }
    }
  }
  ${LaterRecurringPastEdgeFragmentDoc}
`

/**
 * __useAllPastItemsLaterRecurringQuery__
 *
 * To run a query within a React component, call `useAllPastItemsLaterRecurringQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPastItemsLaterRecurringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPastItemsLaterRecurringQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAllPastItemsLaterRecurringQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AllPastItemsLaterRecurringQuery,
    AllPastItemsLaterRecurringQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AllPastItemsLaterRecurringQuery,
    AllPastItemsLaterRecurringQueryVariables
  >(AllPastItemsLaterRecurringDocument, options)
}
export function useAllPastItemsLaterRecurringLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AllPastItemsLaterRecurringQuery,
    AllPastItemsLaterRecurringQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AllPastItemsLaterRecurringQuery,
    AllPastItemsLaterRecurringQueryVariables
  >(AllPastItemsLaterRecurringDocument, options)
}
export type AllPastItemsLaterRecurringQueryHookResult = ReturnType<
  typeof useAllPastItemsLaterRecurringQuery
>
export type AllPastItemsLaterRecurringLazyQueryHookResult = ReturnType<
  typeof useAllPastItemsLaterRecurringLazyQuery
>
export type AllPastItemsLaterRecurringQueryResult =
  ApolloReactCommon.QueryResult<
    AllPastItemsLaterRecurringQuery,
    AllPastItemsLaterRecurringQueryVariables
  >
export const DepositSettingsDocument = /*#__PURE__*/ gql`
  query depositSettings {
    settings {
      depositsSuspended
    }
  }
`

/**
 * __useDepositSettingsQuery__
 *
 * To run a query within a React component, call `useDepositSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepositSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepositSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDepositSettingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    DepositSettingsQuery,
    DepositSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    DepositSettingsQuery,
    DepositSettingsQueryVariables
  >(DepositSettingsDocument, options)
}
export function useDepositSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    DepositSettingsQuery,
    DepositSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    DepositSettingsQuery,
    DepositSettingsQueryVariables
  >(DepositSettingsDocument, options)
}
export type DepositSettingsQueryHookResult = ReturnType<
  typeof useDepositSettingsQuery
>
export type DepositSettingsLazyQueryHookResult = ReturnType<
  typeof useDepositSettingsLazyQuery
>
export type DepositSettingsQueryResult = ApolloReactCommon.QueryResult<
  DepositSettingsQuery,
  DepositSettingsQueryVariables
>
export const HasLaterAccountsDocument = /*#__PURE__*/ gql`
  query hasLaterAccounts {
    laterAccounts {
      name
      accountId
    }
  }
`

/**
 * __useHasLaterAccountsQuery__
 *
 * To run a query within a React component, call `useHasLaterAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasLaterAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasLaterAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasLaterAccountsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    HasLaterAccountsQuery,
    HasLaterAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    HasLaterAccountsQuery,
    HasLaterAccountsQueryVariables
  >(HasLaterAccountsDocument, options)
}
export function useHasLaterAccountsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    HasLaterAccountsQuery,
    HasLaterAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    HasLaterAccountsQuery,
    HasLaterAccountsQueryVariables
  >(HasLaterAccountsDocument, options)
}
export type HasLaterAccountsQueryHookResult = ReturnType<
  typeof useHasLaterAccountsQuery
>
export type HasLaterAccountsLazyQueryHookResult = ReturnType<
  typeof useHasLaterAccountsLazyQuery
>
export type HasLaterAccountsQueryResult = ApolloReactCommon.QueryResult<
  HasLaterAccountsQuery,
  HasLaterAccountsQueryVariables
>
export const LaterBeneficiariesDocument = /*#__PURE__*/ gql`
  query LaterBeneficiaries($investmentAccountId: ID!) {
    laterBeneficiaries(investmentAccountId: $investmentAccountId) {
      beneficiaryId
      firstName
      lastName
      birthDate
      relationship
      percentageShare
      addressLine1
      addressLine2
      city
      state
      zip
      country
      type
      accountId
    }
  }
`

/**
 * __useLaterBeneficiariesQuery__
 *
 * To run a query within a React component, call `useLaterBeneficiariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaterBeneficiariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaterBeneficiariesQuery({
 *   variables: {
 *      investmentAccountId: // value for 'investmentAccountId'
 *   },
 * });
 */
export function useLaterBeneficiariesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    LaterBeneficiariesQuery,
    LaterBeneficiariesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LaterBeneficiariesQuery,
    LaterBeneficiariesQueryVariables
  >(LaterBeneficiariesDocument, options)
}
export function useLaterBeneficiariesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LaterBeneficiariesQuery,
    LaterBeneficiariesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LaterBeneficiariesQuery,
    LaterBeneficiariesQueryVariables
  >(LaterBeneficiariesDocument, options)
}
export type LaterBeneficiariesQueryHookResult = ReturnType<
  typeof useLaterBeneficiariesQuery
>
export type LaterBeneficiariesLazyQueryHookResult = ReturnType<
  typeof useLaterBeneficiariesLazyQuery
>
export type LaterBeneficiariesQueryResult = ApolloReactCommon.QueryResult<
  LaterBeneficiariesQuery,
  LaterBeneficiariesQueryVariables
>
export const LaterContributionHistoryDocument = /*#__PURE__*/ gql`
  query LaterContributionHistory($investmentAccountId: ID!) {
    laterContributionHistory(investmentAccountId: $investmentAccountId) {
      year
    }
  }
`

/**
 * __useLaterContributionHistoryQuery__
 *
 * To run a query within a React component, call `useLaterContributionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaterContributionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaterContributionHistoryQuery({
 *   variables: {
 *      investmentAccountId: // value for 'investmentAccountId'
 *   },
 * });
 */
export function useLaterContributionHistoryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    LaterContributionHistoryQuery,
    LaterContributionHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LaterContributionHistoryQuery,
    LaterContributionHistoryQueryVariables
  >(LaterContributionHistoryDocument, options)
}
export function useLaterContributionHistoryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LaterContributionHistoryQuery,
    LaterContributionHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LaterContributionHistoryQuery,
    LaterContributionHistoryQueryVariables
  >(LaterContributionHistoryDocument, options)
}
export type LaterContributionHistoryQueryHookResult = ReturnType<
  typeof useLaterContributionHistoryQuery
>
export type LaterContributionHistoryLazyQueryHookResult = ReturnType<
  typeof useLaterContributionHistoryLazyQuery
>
export type LaterContributionHistoryQueryResult = ApolloReactCommon.QueryResult<
  LaterContributionHistoryQuery,
  LaterContributionHistoryQueryVariables
>
export const LaterWithholdingDefaultsDocument = /*#__PURE__*/ gql`
  query LaterWithholdingDefaults(
    $investmentAccountId: ID!
    $withdrawalAmount: CurrencyAmountInput!
    $earlyDistributionTaxExceptionReason: String
  ) {
    withholdingDefaults(
      investmentAccountId: $investmentAccountId
      withdrawalAmount: $withdrawalAmount
      earlyDistributionTaxExceptionReason: $earlyDistributionTaxExceptionReason
    ) {
      federalWithholdingPercentage
      stateWithholdingPercentage
      showStateWithholdingField
      showFederalWithholdingField
    }
  }
`

/**
 * __useLaterWithholdingDefaultsQuery__
 *
 * To run a query within a React component, call `useLaterWithholdingDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaterWithholdingDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaterWithholdingDefaultsQuery({
 *   variables: {
 *      investmentAccountId: // value for 'investmentAccountId'
 *      withdrawalAmount: // value for 'withdrawalAmount'
 *      earlyDistributionTaxExceptionReason: // value for 'earlyDistributionTaxExceptionReason'
 *   },
 * });
 */
export function useLaterWithholdingDefaultsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    LaterWithholdingDefaultsQuery,
    LaterWithholdingDefaultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LaterWithholdingDefaultsQuery,
    LaterWithholdingDefaultsQueryVariables
  >(LaterWithholdingDefaultsDocument, options)
}
export function useLaterWithholdingDefaultsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LaterWithholdingDefaultsQuery,
    LaterWithholdingDefaultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LaterWithholdingDefaultsQuery,
    LaterWithholdingDefaultsQueryVariables
  >(LaterWithholdingDefaultsDocument, options)
}
export type LaterWithholdingDefaultsQueryHookResult = ReturnType<
  typeof useLaterWithholdingDefaultsQuery
>
export type LaterWithholdingDefaultsLazyQueryHookResult = ReturnType<
  typeof useLaterWithholdingDefaultsLazyQuery
>
export type LaterWithholdingDefaultsQueryResult = ApolloReactCommon.QueryResult<
  LaterWithholdingDefaultsQuery,
  LaterWithholdingDefaultsQueryVariables
>
export const LaterDetailsDocument = /*#__PURE__*/ gql`
  query LaterDetails {
    user {
      fundingSource {
        verified
        name
        last4
      }
      state
    }
    profile {
      maritalStatus
    }
    laterAccounts {
      amount
      name
      accountId
      accountNumber
      contributionLimit
      portfolioName
      recurringSettings {
        ...recurringSettingsLaterDetails
      }
      code
      status
    }
    tierSubscriptionByUserId {
      id
      tier {
        id
        name
      }
    }
  }
  ${RecurringSettingsLaterDetailsFragmentDoc}
`

/**
 * __useLaterDetailsQuery__
 *
 * To run a query within a React component, call `useLaterDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaterDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaterDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLaterDetailsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    LaterDetailsQuery,
    LaterDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LaterDetailsQuery,
    LaterDetailsQueryVariables
  >(LaterDetailsDocument, options)
}
export function useLaterDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LaterDetailsQuery,
    LaterDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LaterDetailsQuery,
    LaterDetailsQueryVariables
  >(LaterDetailsDocument, options)
}
export type LaterDetailsQueryHookResult = ReturnType<
  typeof useLaterDetailsQuery
>
export type LaterDetailsLazyQueryHookResult = ReturnType<
  typeof useLaterDetailsLazyQuery
>
export type LaterDetailsQueryResult = ApolloReactCommon.QueryResult<
  LaterDetailsQuery,
  LaterDetailsQueryVariables
>
export const WithholdingEstimatesDocument = /*#__PURE__*/ gql`
  query WithholdingEstimates(
    $investmentAccountId: ID!
    $withdrawalAmount: CurrencyAmountInput!
    $stateWithholdingPercentage: Float!
    $federalWithholdingPercentage: Float!
    $reason: LaterWithdrawalReason!
  ) {
    withholdingEstimates(
      investmentAccountId: $investmentAccountId
      withdrawalAmount: $withdrawalAmount
      stateWithholdingPercentage: $stateWithholdingPercentage
      federalWithholdingPercentage: $federalWithholdingPercentage
      reason: $reason
    ) {
      estimatedCustomerAmount {
        value
        currency
      }
      estimatedTotalWithholdingAmount {
        value
        currency
      }
      estimatedFederalWithholdingAmount {
        value
        currency
      }
      estimatedStateWithholdingAmount {
        value
        currency
      }
      estimatedTaxableEarnings {
        value
        currency
      }
    }
  }
`

/**
 * __useWithholdingEstimatesQuery__
 *
 * To run a query within a React component, call `useWithholdingEstimatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWithholdingEstimatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWithholdingEstimatesQuery({
 *   variables: {
 *      investmentAccountId: // value for 'investmentAccountId'
 *      withdrawalAmount: // value for 'withdrawalAmount'
 *      stateWithholdingPercentage: // value for 'stateWithholdingPercentage'
 *      federalWithholdingPercentage: // value for 'federalWithholdingPercentage'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useWithholdingEstimatesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    WithholdingEstimatesQuery,
    WithholdingEstimatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    WithholdingEstimatesQuery,
    WithholdingEstimatesQueryVariables
  >(WithholdingEstimatesDocument, options)
}
export function useWithholdingEstimatesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    WithholdingEstimatesQuery,
    WithholdingEstimatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    WithholdingEstimatesQuery,
    WithholdingEstimatesQueryVariables
  >(WithholdingEstimatesDocument, options)
}
export type WithholdingEstimatesQueryHookResult = ReturnType<
  typeof useWithholdingEstimatesQuery
>
export type WithholdingEstimatesLazyQueryHookResult = ReturnType<
  typeof useWithholdingEstimatesLazyQuery
>
export type WithholdingEstimatesQueryResult = ApolloReactCommon.QueryResult<
  WithholdingEstimatesQuery,
  WithholdingEstimatesQueryVariables
>
export const LaterWithdrawQueryDocument = /*#__PURE__*/ gql`
  query LaterWithdrawQuery {
    user {
      uuid
      fundingSource {
        alert
        name
        verified
      }
    }
    laterAccounts {
      accountId
      amount
      portfolioId
    }
    portfolios {
      id
      riskLevel
      theme
    }
  }
`

/**
 * __useLaterWithdrawQueryQuery__
 *
 * To run a query within a React component, call `useLaterWithdrawQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaterWithdrawQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaterWithdrawQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useLaterWithdrawQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    LaterWithdrawQueryQuery,
    LaterWithdrawQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LaterWithdrawQueryQuery,
    LaterWithdrawQueryQueryVariables
  >(LaterWithdrawQueryDocument, options)
}
export function useLaterWithdrawQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LaterWithdrawQueryQuery,
    LaterWithdrawQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LaterWithdrawQueryQuery,
    LaterWithdrawQueryQueryVariables
  >(LaterWithdrawQueryDocument, options)
}
export type LaterWithdrawQueryQueryHookResult = ReturnType<
  typeof useLaterWithdrawQueryQuery
>
export type LaterWithdrawQueryLazyQueryHookResult = ReturnType<
  typeof useLaterWithdrawQueryLazyQuery
>
export type LaterWithdrawQueryQueryResult = ApolloReactCommon.QueryResult<
  LaterWithdrawQueryQuery,
  LaterWithdrawQueryQueryVariables
>
export const LaterWithdrawDocument = /*#__PURE__*/ gql`
  query LaterWithdraw {
    fundingSourceAccounts {
      ...FundingSourceAccounts
    }
    settings {
      depositsSuspended
    }
    allBankAccounts(input: { type: spend }) {
      availableBalance {
        value
      }
    }
    profile {
      maritalStatus
    }
    laterAccounts {
      amount
      name
      accountId
      accountNumber
      contributionLimit
      portfolioName
      status
      recurringSettings {
        amount
        frequency
        day
      }
      code
    }
    investmentAccountsByUserId(filter: { product: LATER }) {
      status
      withdrawalsIncurTaxPenalty
    }
  }
  ${FundingSourceAccountsFragmentDoc}
`

/**
 * __useLaterWithdrawQuery__
 *
 * To run a query within a React component, call `useLaterWithdrawQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaterWithdrawQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaterWithdrawQuery({
 *   variables: {
 *   },
 * });
 */
export function useLaterWithdrawQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    LaterWithdrawQuery,
    LaterWithdrawQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LaterWithdrawQuery,
    LaterWithdrawQueryVariables
  >(LaterWithdrawDocument, options)
}
export function useLaterWithdrawLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LaterWithdrawQuery,
    LaterWithdrawQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LaterWithdrawQuery,
    LaterWithdrawQueryVariables
  >(LaterWithdrawDocument, options)
}
export type LaterWithdrawQueryHookResult = ReturnType<
  typeof useLaterWithdrawQuery
>
export type LaterWithdrawLazyQueryHookResult = ReturnType<
  typeof useLaterWithdrawLazyQuery
>
export type LaterWithdrawQueryResult = ApolloReactCommon.QueryResult<
  LaterWithdrawQuery,
  LaterWithdrawQueryVariables
>
export const InvestRecurringInvestmentSettingsDocument = /*#__PURE__*/ gql`
  query InvestRecurringInvestmentSettings($investmentAccountId: ID) {
    recurringInvestmentSettings(investmentAccountId: $investmentAccountId) {
      amount
      day
      frequency
    }
    user {
      fundingSource {
        verified
        name
        last4
      }
    }
    spendAccount {
      status
    }
  }
`

/**
 * __useInvestRecurringInvestmentSettingsQuery__
 *
 * To run a query within a React component, call `useInvestRecurringInvestmentSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestRecurringInvestmentSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestRecurringInvestmentSettingsQuery({
 *   variables: {
 *      investmentAccountId: // value for 'investmentAccountId'
 *   },
 * });
 */
export function useInvestRecurringInvestmentSettingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    InvestRecurringInvestmentSettingsQuery,
    InvestRecurringInvestmentSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    InvestRecurringInvestmentSettingsQuery,
    InvestRecurringInvestmentSettingsQueryVariables
  >(InvestRecurringInvestmentSettingsDocument, options)
}
export function useInvestRecurringInvestmentSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InvestRecurringInvestmentSettingsQuery,
    InvestRecurringInvestmentSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    InvestRecurringInvestmentSettingsQuery,
    InvestRecurringInvestmentSettingsQueryVariables
  >(InvestRecurringInvestmentSettingsDocument, options)
}
export type InvestRecurringInvestmentSettingsQueryHookResult = ReturnType<
  typeof useInvestRecurringInvestmentSettingsQuery
>
export type InvestRecurringInvestmentSettingsLazyQueryHookResult = ReturnType<
  typeof useInvestRecurringInvestmentSettingsLazyQuery
>
export type InvestRecurringInvestmentSettingsQueryResult =
  ApolloReactCommon.QueryResult<
    InvestRecurringInvestmentSettingsQuery,
    InvestRecurringInvestmentSettingsQueryVariables
  >
export const CombinedPerformanceDocument = /*#__PURE__*/ gql`
  query CombinedPerformance($days: Int) {
    market {
      isOpen
    }
    combinedPerformanceByUserId(days: $days, filter: { accountStatus: OPEN }) {
      marketChangePercent
      accountValues {
        ...AccountValueFragment
      }
      ...CombinedPerformanceAccountBreakdownFragment
    }
  }
  ${AccountValueFragmentFragmentDoc}
  ${CombinedPerformanceAccountBreakdownFragmentFragmentDoc}
`

/**
 * __useCombinedPerformanceQuery__
 *
 * To run a query within a React component, call `useCombinedPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCombinedPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCombinedPerformanceQuery({
 *   variables: {
 *      days: // value for 'days'
 *   },
 * });
 */
export function useCombinedPerformanceQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CombinedPerformanceQuery,
    CombinedPerformanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CombinedPerformanceQuery,
    CombinedPerformanceQueryVariables
  >(CombinedPerformanceDocument, options)
}
export function useCombinedPerformanceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CombinedPerformanceQuery,
    CombinedPerformanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CombinedPerformanceQuery,
    CombinedPerformanceQueryVariables
  >(CombinedPerformanceDocument, options)
}
export type CombinedPerformanceQueryHookResult = ReturnType<
  typeof useCombinedPerformanceQuery
>
export type CombinedPerformanceLazyQueryHookResult = ReturnType<
  typeof useCombinedPerformanceLazyQuery
>
export type CombinedPerformanceQueryResult = ApolloReactCommon.QueryResult<
  CombinedPerformanceQuery,
  CombinedPerformanceQueryVariables
>
export const AllMessagesDocument = /*#__PURE__*/ gql`
  query allMessages(
    $statusFilters: [MessageStatusFilterInput!]
    $typeFilters: [MessageType!]
  ) {
    allMessages(statusFilters: $statusFilters, typeFilters: $typeFilters) {
      ... on NotificationMessage {
        id
        messageType
        messageCategory
        title {
          ...StringKeyAssetFragment
        }
        body {
          ...StringKeyAssetFragment
        }
        isRead
        isDismissed
        isHidden
        icon {
          ... on Image {
            url
          }
          ... on DesignLibraryIcon {
            icon
          }
        }
        trackingId
        deepLink
        createdAt
        updatedAt
        readAt
        externalId
      }
      ... on AlertMessage {
        id
        __typename
        messageType
        messageCategory
        title {
          ...StringKeyAssetFragment
        }
        body {
          ...StringKeyAssetFragment
        }
        isRead
        icon {
          ... on Image {
            url
          }
          ... on DesignLibraryIcon {
            icon
          }
        }
        trackingId
        deepLink
        createdAt
        updatedAt
        readAt
      }
    }
  }
  ${StringKeyAssetFragmentFragmentDoc}
`

/**
 * __useAllMessagesQuery__
 *
 * To run a query within a React component, call `useAllMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMessagesQuery({
 *   variables: {
 *      statusFilters: // value for 'statusFilters'
 *      typeFilters: // value for 'typeFilters'
 *   },
 * });
 */
export function useAllMessagesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AllMessagesQuery,
    AllMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<AllMessagesQuery, AllMessagesQueryVariables>(
    AllMessagesDocument,
    options,
  )
}
export function useAllMessagesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AllMessagesQuery,
    AllMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AllMessagesQuery,
    AllMessagesQueryVariables
  >(AllMessagesDocument, options)
}
export type AllMessagesQueryHookResult = ReturnType<typeof useAllMessagesQuery>
export type AllMessagesLazyQueryHookResult = ReturnType<
  typeof useAllMessagesLazyQuery
>
export type AllMessagesQueryResult = ApolloReactCommon.QueryResult<
  AllMessagesQuery,
  AllMessagesQueryVariables
>
export const DismissMessagesDocument = /*#__PURE__*/ gql`
  mutation DismissMessages($input: DismissMessagesInput!) {
    dismissMessages(input: $input) {
      ... on DismissMessagesSuccess {
        dismissedCount
      }
      ... on UpdateMessagesFailure {
        errorMessage
      }
    }
  }
`
export type DismissMessagesMutationFn = ApolloReactCommon.MutationFunction<
  DismissMessagesMutation,
  DismissMessagesMutationVariables
>

/**
 * __useDismissMessagesMutation__
 *
 * To run a mutation, you first call `useDismissMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissMessagesMutation, { data, loading, error }] = useDismissMessagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDismissMessagesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DismissMessagesMutation,
    DismissMessagesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DismissMessagesMutation,
    DismissMessagesMutationVariables
  >(DismissMessagesDocument, options)
}
export type DismissMessagesMutationHookResult = ReturnType<
  typeof useDismissMessagesMutation
>
export type DismissMessagesMutationResult =
  ApolloReactCommon.MutationResult<DismissMessagesMutation>
export type DismissMessagesMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DismissMessagesMutation,
    DismissMessagesMutationVariables
  >
export const IsAuthenticatedDocument = /*#__PURE__*/ gql`
  query IsAuthenticated {
    user {
      closedAt
      email
      firstName
      lastName
      registrationComplete
      uuid
      verified
    }
  }
`

/**
 * __useIsAuthenticatedQuery__
 *
 * To run a query within a React component, call `useIsAuthenticatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsAuthenticatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsAuthenticatedQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsAuthenticatedQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    IsAuthenticatedQuery,
    IsAuthenticatedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    IsAuthenticatedQuery,
    IsAuthenticatedQueryVariables
  >(IsAuthenticatedDocument, options)
}
export function useIsAuthenticatedLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    IsAuthenticatedQuery,
    IsAuthenticatedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    IsAuthenticatedQuery,
    IsAuthenticatedQueryVariables
  >(IsAuthenticatedDocument, options)
}
export type IsAuthenticatedQueryHookResult = ReturnType<
  typeof useIsAuthenticatedQuery
>
export type IsAuthenticatedLazyQueryHookResult = ReturnType<
  typeof useIsAuthenticatedLazyQuery
>
export type IsAuthenticatedQueryResult = ApolloReactCommon.QueryResult<
  IsAuthenticatedQuery,
  IsAuthenticatedQueryVariables
>
export const MarkAllAsReadDocument = /*#__PURE__*/ gql`
  mutation markAllAsRead {
    markAllAsRead {
      __typename
      ... on MarkAllAsReadSuccess {
        markedAsReadCount
      }
    }
  }
`
export type MarkAllAsReadMutationFn = ApolloReactCommon.MutationFunction<
  MarkAllAsReadMutation,
  MarkAllAsReadMutationVariables
>

/**
 * __useMarkAllAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllAsReadMutation, { data, loading, error }] = useMarkAllAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllAsReadMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    MarkAllAsReadMutation,
    MarkAllAsReadMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    MarkAllAsReadMutation,
    MarkAllAsReadMutationVariables
  >(MarkAllAsReadDocument, options)
}
export type MarkAllAsReadMutationHookResult = ReturnType<
  typeof useMarkAllAsReadMutation
>
export type MarkAllAsReadMutationResult =
  ApolloReactCommon.MutationResult<MarkAllAsReadMutation>
export type MarkAllAsReadMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    MarkAllAsReadMutation,
    MarkAllAsReadMutationVariables
  >
export const OnMessageCreatedDocument = /*#__PURE__*/ gql`
  subscription onMessageCreated($typeFilters: [MessageType!]) {
    onMessageCreated(typeFilters: $typeFilters) {
      ... on NotificationMessage {
        id
        __typename
        messageType
        messageCategory
        title {
          ...StringKeyAssetFragment
        }
        body {
          ...StringKeyAssetFragment
        }
        isRead
        isDismissed
        isHidden
        icon {
          ... on Image {
            url
          }
          ... on DesignLibraryIcon {
            icon
          }
        }
        trackingId
        deepLink
        createdAt
        updatedAt
        readAt
        externalId
      }
      ... on AlertMessage {
        id
        __typename
        messageType
        messageCategory
        title {
          ...StringKeyAssetFragment
        }
        body {
          ...StringKeyAssetFragment
        }
        isRead
        icon {
          ... on DesignLibraryIcon {
            icon
          }
        }
        trackingId
        deepLink
        createdAt
        updatedAt
        readAt
      }
    }
  }
  ${StringKeyAssetFragmentFragmentDoc}
`

/**
 * __useOnMessageCreatedSubscription__
 *
 * To run a query within a React component, call `useOnMessageCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMessageCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMessageCreatedSubscription({
 *   variables: {
 *      typeFilters: // value for 'typeFilters'
 *   },
 * });
 */
export function useOnMessageCreatedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    OnMessageCreatedSubscription,
    OnMessageCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    OnMessageCreatedSubscription,
    OnMessageCreatedSubscriptionVariables
  >(OnMessageCreatedDocument, options)
}
export type OnMessageCreatedSubscriptionHookResult = ReturnType<
  typeof useOnMessageCreatedSubscription
>
export type OnMessageCreatedSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<OnMessageCreatedSubscription>
export const ReadMessageDocument = /*#__PURE__*/ gql`
  mutation readMessage($input: ReadMessageInput!) {
    readMessage(input: $input) {
      ... on NotificationMessage {
        id
      }
      ... on AlertMessage {
        id
        isRead
        isDismissed
        isHidden
      }
      ... on UpdateMessageIgnored {
        requestId
      }
    }
  }
`
export type ReadMessageMutationFn = ApolloReactCommon.MutationFunction<
  ReadMessageMutation,
  ReadMessageMutationVariables
>

/**
 * __useReadMessageMutation__
 *
 * To run a mutation, you first call `useReadMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readMessageMutation, { data, loading, error }] = useReadMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReadMessageMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ReadMessageMutation,
    ReadMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ReadMessageMutation,
    ReadMessageMutationVariables
  >(ReadMessageDocument, options)
}
export type ReadMessageMutationHookResult = ReturnType<
  typeof useReadMessageMutation
>
export type ReadMessageMutationResult =
  ApolloReactCommon.MutationResult<ReadMessageMutation>
export type ReadMessageMutationOptions = ApolloReactCommon.BaseMutationOptions<
  ReadMessageMutation,
  ReadMessageMutationVariables
>
export const UpdateVerificationProfileDocument = /*#__PURE__*/ gql`
  mutation UpdateVerificationProfile($deviceSessionId: String) {
    updateVerificationProfile(input: { deviceSessionId: $deviceSessionId }) {
      __typename
    }
  }
`
export type UpdateVerificationProfileMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdateVerificationProfileMutation,
    UpdateVerificationProfileMutationVariables
  >

/**
 * __useUpdateVerificationProfileMutation__
 *
 * To run a mutation, you first call `useUpdateVerificationProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVerificationProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVerificationProfileMutation, { data, loading, error }] = useUpdateVerificationProfileMutation({
 *   variables: {
 *      deviceSessionId: // value for 'deviceSessionId'
 *   },
 * });
 */
export function useUpdateVerificationProfileMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateVerificationProfileMutation,
    UpdateVerificationProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateVerificationProfileMutation,
    UpdateVerificationProfileMutationVariables
  >(UpdateVerificationProfileDocument, options)
}
export type UpdateVerificationProfileMutationHookResult = ReturnType<
  typeof useUpdateVerificationProfileMutation
>
export type UpdateVerificationProfileMutationResult =
  ApolloReactCommon.MutationResult<UpdateVerificationProfileMutation>
export type UpdateVerificationProfileMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateVerificationProfileMutation,
    UpdateVerificationProfileMutationVariables
  >
export const MoneyHubSettingsDocument = /*#__PURE__*/ gql`
  query MoneyHubSettings {
    splitDepositSettingsByUserId(
      filter: {
        settingTypes: [RECURRENCE, DIRECT_DEPOSIT, DIRECT_DEPOSIT_INTENT]
        showHiddenEmployerSettings: true
      }
      normalizeToFrequency: MONTHLY
    ) {
      ... on SplitDepositDirectDepositIntentSetting {
        ...MoneyHubSplitDepositIntentSettingFragment
      }
      ... on SplitDepositDirectDepositSetting {
        ...MoneyHubSplitDepositDirectDepositSettingFragment
        monthlyTotals {
          ...DepositMonthlyTotalFragment
        }
      }
      ... on SplitDepositRecurrenceSetting {
        monthlyTotals {
          ...DepositMonthlyTotalFragment
        }
      }
      id
      isActive
      isHidden
      name
      allocations {
        allocationPercent
        targetAccountId
        targetAccountType
        nickname
        ... on SplitDepositDirectDepositAllocation {
          normalizedDailyAmount
        }
        ... on SplitDepositRecurrenceAllocation {
          legacyRecurrenceAmount {
            value
          }
          legacyRecurrenceRule {
            frequency
            ... on SplitDepositWeeklyRecurrenceRule {
              byWeekDay
            }
            ... on SplitDepositMonthlyRecurrenceRule {
              byMonthDay
            }
          }
          isActive
        }
      }
      deposits(orderBy: DESC, limit: 1) {
        ...MoneyHubSplitDepositFragment
      }
    }
    tierSubscriptionByUserId {
      id
      tierPrice {
        amount {
          value
        }
      }
      tier {
        id
        products {
          id
          name
          active
          key
        }
      }
    }
    investmentAccountsByUserId(filter: { product: EARLY }) {
      id
      beneficiaryId
      transferability {
        transferAge
        transferDate
      }
    }
    spendAccount {
      status
      isEligible
      isReopenable
      bankCardOrder {
        bankCardTier
      }
    }
    user {
      verified
      uuid
    }
  }
  ${MoneyHubSplitDepositIntentSettingFragmentFragmentDoc}
  ${MoneyHubSplitDepositDirectDepositSettingFragmentFragmentDoc}
  ${DepositMonthlyTotalFragmentFragmentDoc}
  ${MoneyHubSplitDepositFragmentFragmentDoc}
`

/**
 * __useMoneyHubSettingsQuery__
 *
 * To run a query within a React component, call `useMoneyHubSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMoneyHubSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMoneyHubSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMoneyHubSettingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    MoneyHubSettingsQuery,
    MoneyHubSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    MoneyHubSettingsQuery,
    MoneyHubSettingsQueryVariables
  >(MoneyHubSettingsDocument, options)
}
export function useMoneyHubSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MoneyHubSettingsQuery,
    MoneyHubSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    MoneyHubSettingsQuery,
    MoneyHubSettingsQueryVariables
  >(MoneyHubSettingsDocument, options)
}
export type MoneyHubSettingsQueryHookResult = ReturnType<
  typeof useMoneyHubSettingsQuery
>
export type MoneyHubSettingsLazyQueryHookResult = ReturnType<
  typeof useMoneyHubSettingsLazyQuery
>
export type MoneyHubSettingsQueryResult = ApolloReactCommon.QueryResult<
  MoneyHubSettingsQuery,
  MoneyHubSettingsQueryVariables
>
export const SpendSignupTransferableFromQueryDocument = /*#__PURE__*/ gql`
  query SpendSignupTransferableFromQuery {
    allTransferableFrom {
      from {
        accountNumberMasked
        balance {
          value
        }
        externalSource
        id
        name
        type
      }
    }
    eligibility(eligibilityScope: fundSpendInActivation) {
      eligible
    }
    allBankAccounts(input: { type: spend }) {
      id
      type
      balance {
        value
      }
      pendingBalance {
        value
      }
    }
  }
`

/**
 * __useSpendSignupTransferableFromQueryQuery__
 *
 * To run a query within a React component, call `useSpendSignupTransferableFromQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpendSignupTransferableFromQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpendSignupTransferableFromQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpendSignupTransferableFromQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SpendSignupTransferableFromQueryQuery,
    SpendSignupTransferableFromQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SpendSignupTransferableFromQueryQuery,
    SpendSignupTransferableFromQueryQueryVariables
  >(SpendSignupTransferableFromQueryDocument, options)
}
export function useSpendSignupTransferableFromQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SpendSignupTransferableFromQueryQuery,
    SpendSignupTransferableFromQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SpendSignupTransferableFromQueryQuery,
    SpendSignupTransferableFromQueryQueryVariables
  >(SpendSignupTransferableFromQueryDocument, options)
}
export type SpendSignupTransferableFromQueryQueryHookResult = ReturnType<
  typeof useSpendSignupTransferableFromQueryQuery
>
export type SpendSignupTransferableFromQueryLazyQueryHookResult = ReturnType<
  typeof useSpendSignupTransferableFromQueryLazyQuery
>
export type SpendSignupTransferableFromQueryQueryResult =
  ApolloReactCommon.QueryResult<
    SpendSignupTransferableFromQueryQuery,
    SpendSignupTransferableFromQueryQueryVariables
  >
export const PerformanceGraphQueryDocument = /*#__PURE__*/ gql`
  query PerformanceGraphQuery($days: Int!, $investmentAccountId: ID!) {
    market {
      isOpen
    }
    investmentAccount(id: $investmentAccountId) {
      performance(days: $days) {
        marketChange
        marketChangePercent
        marketChangePercentWithoutFees
        previousCloseAmount
        accountValues {
          amount
          timestamp
        }
      }
    }
  }
`

/**
 * __usePerformanceGraphQueryQuery__
 *
 * To run a query within a React component, call `usePerformanceGraphQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceGraphQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceGraphQueryQuery({
 *   variables: {
 *      days: // value for 'days'
 *      investmentAccountId: // value for 'investmentAccountId'
 *   },
 * });
 */
export function usePerformanceGraphQueryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    PerformanceGraphQueryQuery,
    PerformanceGraphQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PerformanceGraphQueryQuery,
    PerformanceGraphQueryQueryVariables
  >(PerformanceGraphQueryDocument, options)
}
export function usePerformanceGraphQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PerformanceGraphQueryQuery,
    PerformanceGraphQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PerformanceGraphQueryQuery,
    PerformanceGraphQueryQueryVariables
  >(PerformanceGraphQueryDocument, options)
}
export type PerformanceGraphQueryQueryHookResult = ReturnType<
  typeof usePerformanceGraphQueryQuery
>
export type PerformanceGraphQueryLazyQueryHookResult = ReturnType<
  typeof usePerformanceGraphQueryLazyQuery
>
export type PerformanceGraphQueryQueryResult = ApolloReactCommon.QueryResult<
  PerformanceGraphQueryQuery,
  PerformanceGraphQueryQueryVariables
>
export const PerformanceHoldingsDocument = /*#__PURE__*/ gql`
  query PerformanceHoldings($product: InvestmentProduct) {
    investmentAccounts: investmentAccountsByUserId(
      filter: { product: $product }
    ) {
      id
      name
      createdAt
      closedAt
      beneficiaryId
      netInvestments {
        value
      }
      currentBalance {
        value
      }
      totalAccountValue {
        value
      }
      returnsAllTime {
        value
      }
      netInvestments {
        value
      }
      totalBonds {
        currency
        value
      }
      portfolio {
        name
        theme
        description
        holdings {
          name
          amount
          percentage
          shares
          symbol
        }
      }
      portfolios {
        __typename
        portfolioSecurities {
          name
          currentAllocationPercentage
          shares
          symbol
          marketValue {
            value
          }
          todaysReturn {
            marketValue {
              value
            }
            percent
          }
          totalReturn {
            marketValue {
              value
            }
            percent
          }
        }
        portfolioSecurityAllocations {
          allocationPercent
          symbol
          name
          security {
            type
            profile {
              logoUrl
            }
          }
        }
      }
    }
    user {
      firstName
    }
  }
`

/**
 * __usePerformanceHoldingsQuery__
 *
 * To run a query within a React component, call `usePerformanceHoldingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceHoldingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceHoldingsQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function usePerformanceHoldingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PerformanceHoldingsQuery,
    PerformanceHoldingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PerformanceHoldingsQuery,
    PerformanceHoldingsQueryVariables
  >(PerformanceHoldingsDocument, options)
}
export function usePerformanceHoldingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PerformanceHoldingsQuery,
    PerformanceHoldingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PerformanceHoldingsQuery,
    PerformanceHoldingsQueryVariables
  >(PerformanceHoldingsDocument, options)
}
export type PerformanceHoldingsQueryHookResult = ReturnType<
  typeof usePerformanceHoldingsQuery
>
export type PerformanceHoldingsLazyQueryHookResult = ReturnType<
  typeof usePerformanceHoldingsLazyQuery
>
export type PerformanceHoldingsQueryResult = ApolloReactCommon.QueryResult<
  PerformanceHoldingsQuery,
  PerformanceHoldingsQueryVariables
>
export const PerformanceHoldingsPassionsDocument = /*#__PURE__*/ gql`
  query PerformanceHoldingsPassions($product: InvestmentProduct) {
    investmentAccounts: investmentAccountsByUserId(
      filter: { product: $product }
    ) {
      ...InvestmentAccountDetails
      portfolios {
        ...PortfolioDetails
      }
    }
    user {
      firstName
    }
  }
  ${InvestmentAccountDetailsFragmentDoc}
  ${PortfolioDetailsFragmentDoc}
`

/**
 * __usePerformanceHoldingsPassionsQuery__
 *
 * To run a query within a React component, call `usePerformanceHoldingsPassionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceHoldingsPassionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceHoldingsPassionsQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function usePerformanceHoldingsPassionsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PerformanceHoldingsPassionsQuery,
    PerformanceHoldingsPassionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PerformanceHoldingsPassionsQuery,
    PerformanceHoldingsPassionsQueryVariables
  >(PerformanceHoldingsPassionsDocument, options)
}
export function usePerformanceHoldingsPassionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PerformanceHoldingsPassionsQuery,
    PerformanceHoldingsPassionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PerformanceHoldingsPassionsQuery,
    PerformanceHoldingsPassionsQueryVariables
  >(PerformanceHoldingsPassionsDocument, options)
}
export type PerformanceHoldingsPassionsQueryHookResult = ReturnType<
  typeof usePerformanceHoldingsPassionsQuery
>
export type PerformanceHoldingsPassionsLazyQueryHookResult = ReturnType<
  typeof usePerformanceHoldingsPassionsLazyQuery
>
export type PerformanceHoldingsPassionsQueryResult =
  ApolloReactCommon.QueryResult<
    PerformanceHoldingsPassionsQuery,
    PerformanceHoldingsPassionsQueryVariables
  >
export const SecurityPerformancesBySymbolDocument = /*#__PURE__*/ gql`
  query SecurityPerformancesBySymbol(
    $input: SecurityPerformancesBySymbolInput!
  ) {
    securityPerformancesBySymbol(input: $input) {
      symbol
      gain {
        percent
        marketValue {
          value
        }
      }
    }
  }
`

/**
 * __useSecurityPerformancesBySymbolQuery__
 *
 * To run a query within a React component, call `useSecurityPerformancesBySymbolQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecurityPerformancesBySymbolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecurityPerformancesBySymbolQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSecurityPerformancesBySymbolQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SecurityPerformancesBySymbolQuery,
    SecurityPerformancesBySymbolQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SecurityPerformancesBySymbolQuery,
    SecurityPerformancesBySymbolQueryVariables
  >(SecurityPerformancesBySymbolDocument, options)
}
export function useSecurityPerformancesBySymbolLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SecurityPerformancesBySymbolQuery,
    SecurityPerformancesBySymbolQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SecurityPerformancesBySymbolQuery,
    SecurityPerformancesBySymbolQueryVariables
  >(SecurityPerformancesBySymbolDocument, options)
}
export type SecurityPerformancesBySymbolQueryHookResult = ReturnType<
  typeof useSecurityPerformancesBySymbolQuery
>
export type SecurityPerformancesBySymbolLazyQueryHookResult = ReturnType<
  typeof useSecurityPerformancesBySymbolLazyQuery
>
export type SecurityPerformancesBySymbolQueryResult =
  ApolloReactCommon.QueryResult<
    SecurityPerformancesBySymbolQuery,
    SecurityPerformancesBySymbolQueryVariables
  >
export const AddSecurityToPortfolioDocument = /*#__PURE__*/ gql`
  mutation AddSecurityToPortfolio($input: AddSecurityToPortfolioInput!) {
    addSecurityToPortfolio(input: $input) {
      __typename
      ... on Portfolio {
        customizationLevel
        id
        portfolioSecurityAllocations {
          id
          symbol
          allocationPercent
          removableFromBasePortfolio
          security {
            displayName
          }
          investmentCategories {
            bond
            crypto
            equity
            realEstate
          }
        }
      }
    }
  }
`
export type AddSecurityToPortfolioMutationFn =
  ApolloReactCommon.MutationFunction<
    AddSecurityToPortfolioMutation,
    AddSecurityToPortfolioMutationVariables
  >

/**
 * __useAddSecurityToPortfolioMutation__
 *
 * To run a mutation, you first call `useAddSecurityToPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSecurityToPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSecurityToPortfolioMutation, { data, loading, error }] = useAddSecurityToPortfolioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSecurityToPortfolioMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddSecurityToPortfolioMutation,
    AddSecurityToPortfolioMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AddSecurityToPortfolioMutation,
    AddSecurityToPortfolioMutationVariables
  >(AddSecurityToPortfolioDocument, options)
}
export type AddSecurityToPortfolioMutationHookResult = ReturnType<
  typeof useAddSecurityToPortfolioMutation
>
export type AddSecurityToPortfolioMutationResult =
  ApolloReactCommon.MutationResult<AddSecurityToPortfolioMutation>
export type AddSecurityToPortfolioMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AddSecurityToPortfolioMutation,
    AddSecurityToPortfolioMutationVariables
  >
export const RemoveSecurityFromPortfolioDocument = /*#__PURE__*/ gql`
  mutation RemoveSecurityFromPortfolio(
    $input: RemoveSecurityFromPortfolioInput!
  ) {
    removeSecurityFromPortfolio(input: $input) {
      __typename
      ... on Portfolio {
        customizationLevel
        id
        portfolioSecurityAllocations {
          id
          symbol
          allocationPercent
          removableFromBasePortfolio
          security {
            displayName
          }
          investmentCategories {
            bond
            crypto
            equity
            realEstate
          }
        }
      }
    }
  }
`
export type RemoveSecurityFromPortfolioMutationFn =
  ApolloReactCommon.MutationFunction<
    RemoveSecurityFromPortfolioMutation,
    RemoveSecurityFromPortfolioMutationVariables
  >

/**
 * __useRemoveSecurityFromPortfolioMutation__
 *
 * To run a mutation, you first call `useRemoveSecurityFromPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSecurityFromPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSecurityFromPortfolioMutation, { data, loading, error }] = useRemoveSecurityFromPortfolioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveSecurityFromPortfolioMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RemoveSecurityFromPortfolioMutation,
    RemoveSecurityFromPortfolioMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RemoveSecurityFromPortfolioMutation,
    RemoveSecurityFromPortfolioMutationVariables
  >(RemoveSecurityFromPortfolioDocument, options)
}
export type RemoveSecurityFromPortfolioMutationHookResult = ReturnType<
  typeof useRemoveSecurityFromPortfolioMutation
>
export type RemoveSecurityFromPortfolioMutationResult =
  ApolloReactCommon.MutationResult<RemoveSecurityFromPortfolioMutation>
export type RemoveSecurityFromPortfolioMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RemoveSecurityFromPortfolioMutation,
    RemoveSecurityFromPortfolioMutationVariables
  >
export const CryptoEtfDocument = /*#__PURE__*/ gql`
  query CryptoEtf {
    cryptoEtf {
      symbol
    }
    investmentAccountsByUserId {
      id
      closedAt
      totalCrypto {
        value
      }
      investmentAccountType
      portfolio {
        customizationLevel
        id
        portfolioSecurityAllocations {
          id
          symbol
          allocationPercent
          removableFromBasePortfolio
          security {
            displayName
            profile {
              logoUrl
            }
          }
          investmentCategories {
            bond
            crypto
            equity
            realEstate
          }
        }
      }
    }
  }
`

/**
 * __useCryptoEtfQuery__
 *
 * To run a query within a React component, call `useCryptoEtfQuery` and pass it any options that fit your needs.
 * When your component renders, `useCryptoEtfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCryptoEtfQuery({
 *   variables: {
 *   },
 * });
 */
export function useCryptoEtfQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CryptoEtfQuery,
    CryptoEtfQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<CryptoEtfQuery, CryptoEtfQueryVariables>(
    CryptoEtfDocument,
    options,
  )
}
export function useCryptoEtfLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CryptoEtfQuery,
    CryptoEtfQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<CryptoEtfQuery, CryptoEtfQueryVariables>(
    CryptoEtfDocument,
    options,
  )
}
export type CryptoEtfQueryHookResult = ReturnType<typeof useCryptoEtfQuery>
export type CryptoEtfLazyQueryHookResult = ReturnType<
  typeof useCryptoEtfLazyQuery
>
export type CryptoEtfQueryResult = ApolloReactCommon.QueryResult<
  CryptoEtfQuery,
  CryptoEtfQueryVariables
>
export const SetPortfolioMutationDocument = /*#__PURE__*/ gql`
  mutation SetPortfolioMutation($id: ID!) {
    setPortfolio(input: { id: $id }) {
      portfolio {
        id
      }
    }
  }
`
export type SetPortfolioMutationMutationFn = ApolloReactCommon.MutationFunction<
  SetPortfolioMutationMutation,
  SetPortfolioMutationMutationVariables
>

/**
 * __useSetPortfolioMutationMutation__
 *
 * To run a mutation, you first call `useSetPortfolioMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPortfolioMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPortfolioMutationMutation, { data, loading, error }] = useSetPortfolioMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetPortfolioMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SetPortfolioMutationMutation,
    SetPortfolioMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SetPortfolioMutationMutation,
    SetPortfolioMutationMutationVariables
  >(SetPortfolioMutationDocument, options)
}
export type SetPortfolioMutationMutationHookResult = ReturnType<
  typeof useSetPortfolioMutationMutation
>
export type SetPortfolioMutationMutationResult =
  ApolloReactCommon.MutationResult<SetPortfolioMutationMutation>
export type SetPortfolioMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SetPortfolioMutationMutation,
    SetPortfolioMutationMutationVariables
  >
export const UpdateAccountPortfolioDocument = /*#__PURE__*/ gql`
  mutation UpdateAccountPortfolio(
    $investmentAccountId: ID!
    $theme: PortfolioTheme!
    $riskLevel: PortfolioRiskLevel!
  ) {
    updateAccountPortfolio(
      input: {
        investmentAccountId: $investmentAccountId
        theme: $theme
        riskLevel: $riskLevel
      }
    ) {
      ... on InvestmentAccount {
        id
      }
    }
  }
`
export type UpdateAccountPortfolioMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdateAccountPortfolioMutation,
    UpdateAccountPortfolioMutationVariables
  >

/**
 * __useUpdateAccountPortfolioMutation__
 *
 * To run a mutation, you first call `useUpdateAccountPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountPortfolioMutation, { data, loading, error }] = useUpdateAccountPortfolioMutation({
 *   variables: {
 *      investmentAccountId: // value for 'investmentAccountId'
 *      theme: // value for 'theme'
 *      riskLevel: // value for 'riskLevel'
 *   },
 * });
 */
export function useUpdateAccountPortfolioMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateAccountPortfolioMutation,
    UpdateAccountPortfolioMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateAccountPortfolioMutation,
    UpdateAccountPortfolioMutationVariables
  >(UpdateAccountPortfolioDocument, options)
}
export type UpdateAccountPortfolioMutationHookResult = ReturnType<
  typeof useUpdateAccountPortfolioMutation
>
export type UpdateAccountPortfolioMutationResult =
  ApolloReactCommon.MutationResult<UpdateAccountPortfolioMutation>
export type UpdateAccountPortfolioMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateAccountPortfolioMutation,
    UpdateAccountPortfolioMutationVariables
  >
export const AllPortfoliosWithCryptoDocument = /*#__PURE__*/ gql`
  query AllPortfoliosWithCrypto($customizedWithSecuritySymbols: [String!]) {
    portfolios(customizedWithSecuritySymbols: $customizedWithSecuritySymbols) {
      id
      name
      description
      position
      projection {
        averageGrowthRate
        highestGrowthRate
        lowestGrowthRate
      }
      portfolioSecurityAllocations {
        symbol
        allocationPercent
        security {
          id
          displayName
        }
        investmentCategories {
          bond
          crypto
        }
      }
      riskLevel
      theme
    }
    recommendedPortfolio {
      id
      name
      description
    }
    user {
      investmentAccounts {
        closedAt
        product
        currentBalance {
          value
        }
        portfolio {
          id
          name
          description
          portfolioSecurityAllocations {
            symbol
            allocationPercent
            security {
              id
              displayName
            }
            investmentCategories {
              bond
              crypto
            }
          }
          riskLevel
          theme
        }
      }
    }
  }
`

/**
 * __useAllPortfoliosWithCryptoQuery__
 *
 * To run a query within a React component, call `useAllPortfoliosWithCryptoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPortfoliosWithCryptoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPortfoliosWithCryptoQuery({
 *   variables: {
 *      customizedWithSecuritySymbols: // value for 'customizedWithSecuritySymbols'
 *   },
 * });
 */
export function useAllPortfoliosWithCryptoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AllPortfoliosWithCryptoQuery,
    AllPortfoliosWithCryptoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AllPortfoliosWithCryptoQuery,
    AllPortfoliosWithCryptoQueryVariables
  >(AllPortfoliosWithCryptoDocument, options)
}
export function useAllPortfoliosWithCryptoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AllPortfoliosWithCryptoQuery,
    AllPortfoliosWithCryptoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AllPortfoliosWithCryptoQuery,
    AllPortfoliosWithCryptoQueryVariables
  >(AllPortfoliosWithCryptoDocument, options)
}
export type AllPortfoliosWithCryptoQueryHookResult = ReturnType<
  typeof useAllPortfoliosWithCryptoQuery
>
export type AllPortfoliosWithCryptoLazyQueryHookResult = ReturnType<
  typeof useAllPortfoliosWithCryptoLazyQuery
>
export type AllPortfoliosWithCryptoQueryResult = ApolloReactCommon.QueryResult<
  AllPortfoliosWithCryptoQuery,
  AllPortfoliosWithCryptoQueryVariables
>
export const ProductPortfoliosPassionsDocument = /*#__PURE__*/ gql`
  query ProductPortfoliosPassions {
    user {
      uuid
      investmentAccounts {
        id
        closedAt
        product
        currentBalance {
          value
        }
        totalBonds {
          currency
          value
        }
        totalEquities {
          currency
          value
        }
        totalCrypto {
          currency
          value
        }
        portfolio {
          id
          name
          description
          riskLevel
          theme
          portfolioSecurityAllocations {
            id
            symbol
            allocationPercent
            security {
              displayName
              type
              profile {
                logoUrl
              }
            }
            investmentCategories {
              bond
              crypto
              equity
            }
          }
        }
        portfolios {
          id
          __typename
          name
          description
          currentAllocationPercentage
          currentBalance {
            value
          }
          accountAllocation {
            allocationPercent
          }
          yearToDateReturn {
            percent
            marketValue {
              value
            }
          }
          portfolioSecurities {
            __typename
            name
            currentAllocationPercentage
            shares
            symbol
            marketValue {
              value
            }
            todaysReturn {
              marketValue {
                value
              }
              percent
            }
            totalReturn {
              marketValue {
                value
              }
              percent
            }
          }
          portfolioSecurityAllocations {
            id
            symbol
            allocationPercent
            security {
              displayName
              type
              profile {
                logoUrl
              }
            }
            investmentCategories {
              bond
              crypto
              equity
            }
          }
          ... on SelfDirectedPortfolio {
            status
          }
        }
        recommendedPortfolio {
          id
          name
          minimumManagedAllocationPercent
        }
        yearToDateReturn {
          marketValue {
            currency
            value
          }
          percent
        }
        status
      }
    }
  }
`

/**
 * __useProductPortfoliosPassionsQuery__
 *
 * To run a query within a React component, call `useProductPortfoliosPassionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPortfoliosPassionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPortfoliosPassionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductPortfoliosPassionsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ProductPortfoliosPassionsQuery,
    ProductPortfoliosPassionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ProductPortfoliosPassionsQuery,
    ProductPortfoliosPassionsQueryVariables
  >(ProductPortfoliosPassionsDocument, options)
}
export function useProductPortfoliosPassionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ProductPortfoliosPassionsQuery,
    ProductPortfoliosPassionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ProductPortfoliosPassionsQuery,
    ProductPortfoliosPassionsQueryVariables
  >(ProductPortfoliosPassionsDocument, options)
}
export type ProductPortfoliosPassionsQueryHookResult = ReturnType<
  typeof useProductPortfoliosPassionsQuery
>
export type ProductPortfoliosPassionsLazyQueryHookResult = ReturnType<
  typeof useProductPortfoliosPassionsLazyQuery
>
export type ProductPortfoliosPassionsQueryResult =
  ApolloReactCommon.QueryResult<
    ProductPortfoliosPassionsQuery,
    ProductPortfoliosPassionsQueryVariables
  >
export const RecurringInvestmentSettingsDocument = /*#__PURE__*/ gql`
  query recurringInvestmentSettings($product: InvestmentProduct) {
    investmentAccountsByUserId(filter: { product: $product }) {
      closedAt
      recurringInvestmentSettings {
        amount
        frequency
        day
        nextInvestmentAt
      }
    }
  }
`

/**
 * __useRecurringInvestmentSettingsQuery__
 *
 * To run a query within a React component, call `useRecurringInvestmentSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringInvestmentSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringInvestmentSettingsQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useRecurringInvestmentSettingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    RecurringInvestmentSettingsQuery,
    RecurringInvestmentSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RecurringInvestmentSettingsQuery,
    RecurringInvestmentSettingsQueryVariables
  >(RecurringInvestmentSettingsDocument, options)
}
export function useRecurringInvestmentSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RecurringInvestmentSettingsQuery,
    RecurringInvestmentSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RecurringInvestmentSettingsQuery,
    RecurringInvestmentSettingsQueryVariables
  >(RecurringInvestmentSettingsDocument, options)
}
export type RecurringInvestmentSettingsQueryHookResult = ReturnType<
  typeof useRecurringInvestmentSettingsQuery
>
export type RecurringInvestmentSettingsLazyQueryHookResult = ReturnType<
  typeof useRecurringInvestmentSettingsLazyQuery
>
export type RecurringInvestmentSettingsQueryResult =
  ApolloReactCommon.QueryResult<
    RecurringInvestmentSettingsQuery,
    RecurringInvestmentSettingsQueryVariables
  >
export const PortfolioSuitabilityResponsesDocument = /*#__PURE__*/ gql`
  query PortfolioSuitabilityResponses {
    suitabilityResponses {
      answer {
        id
        summary
      }
    }
  }
`

/**
 * __usePortfolioSuitabilityResponsesQuery__
 *
 * To run a query within a React component, call `usePortfolioSuitabilityResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfolioSuitabilityResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfolioSuitabilityResponsesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePortfolioSuitabilityResponsesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PortfolioSuitabilityResponsesQuery,
    PortfolioSuitabilityResponsesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PortfolioSuitabilityResponsesQuery,
    PortfolioSuitabilityResponsesQueryVariables
  >(PortfolioSuitabilityResponsesDocument, options)
}
export function usePortfolioSuitabilityResponsesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PortfolioSuitabilityResponsesQuery,
    PortfolioSuitabilityResponsesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PortfolioSuitabilityResponsesQuery,
    PortfolioSuitabilityResponsesQueryVariables
  >(PortfolioSuitabilityResponsesDocument, options)
}
export type PortfolioSuitabilityResponsesQueryHookResult = ReturnType<
  typeof usePortfolioSuitabilityResponsesQuery
>
export type PortfolioSuitabilityResponsesLazyQueryHookResult = ReturnType<
  typeof usePortfolioSuitabilityResponsesLazyQuery
>
export type PortfolioSuitabilityResponsesQueryResult =
  ApolloReactCommon.QueryResult<
    PortfolioSuitabilityResponsesQuery,
    PortfolioSuitabilityResponsesQueryVariables
  >
export const TierSubscriptionForUserDocument = /*#__PURE__*/ gql`
  query TierSubscriptionForUser {
    tierSubscriptionByUserId {
      id
      tier {
        id
        name
        key
        products {
          key
        }
      }
    }
  }
`

/**
 * __useTierSubscriptionForUserQuery__
 *
 * To run a query within a React component, call `useTierSubscriptionForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useTierSubscriptionForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTierSubscriptionForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useTierSubscriptionForUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    TierSubscriptionForUserQuery,
    TierSubscriptionForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    TierSubscriptionForUserQuery,
    TierSubscriptionForUserQueryVariables
  >(TierSubscriptionForUserDocument, options)
}
export function useTierSubscriptionForUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TierSubscriptionForUserQuery,
    TierSubscriptionForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    TierSubscriptionForUserQuery,
    TierSubscriptionForUserQueryVariables
  >(TierSubscriptionForUserDocument, options)
}
export type TierSubscriptionForUserQueryHookResult = ReturnType<
  typeof useTierSubscriptionForUserQuery
>
export type TierSubscriptionForUserLazyQueryHookResult = ReturnType<
  typeof useTierSubscriptionForUserLazyQuery
>
export type TierSubscriptionForUserQueryResult = ApolloReactCommon.QueryResult<
  TierSubscriptionForUserQuery,
  TierSubscriptionForUserQueryVariables
>
export const SubscribeAfterRegistrationCompleteDocument = /*#__PURE__*/ gql`
  mutation SubscribeAfterRegistrationComplete($input: SubscribeToTierInput!) {
    subscribeToTier(input: $input) {
      __typename
    }
  }
`
export type SubscribeAfterRegistrationCompleteMutationFn =
  ApolloReactCommon.MutationFunction<
    SubscribeAfterRegistrationCompleteMutation,
    SubscribeAfterRegistrationCompleteMutationVariables
  >

/**
 * __useSubscribeAfterRegistrationCompleteMutation__
 *
 * To run a mutation, you first call `useSubscribeAfterRegistrationCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeAfterRegistrationCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeAfterRegistrationCompleteMutation, { data, loading, error }] = useSubscribeAfterRegistrationCompleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeAfterRegistrationCompleteMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SubscribeAfterRegistrationCompleteMutation,
    SubscribeAfterRegistrationCompleteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SubscribeAfterRegistrationCompleteMutation,
    SubscribeAfterRegistrationCompleteMutationVariables
  >(SubscribeAfterRegistrationCompleteDocument, options)
}
export type SubscribeAfterRegistrationCompleteMutationHookResult = ReturnType<
  typeof useSubscribeAfterRegistrationCompleteMutation
>
export type SubscribeAfterRegistrationCompleteMutationResult =
  ApolloReactCommon.MutationResult<SubscribeAfterRegistrationCompleteMutation>
export type SubscribeAfterRegistrationCompleteMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SubscribeAfterRegistrationCompleteMutation,
    SubscribeAfterRegistrationCompleteMutationVariables
  >
export const SetRecapPublicAccessDocument = /*#__PURE__*/ gql`
  mutation SetRecapPublicAccess($recapId: ID!, $enablePublic: Boolean!) {
    setInvestmentAccountRecapPublicAccess(
      input: { id: $recapId, public: $enablePublic }
    ) {
      __typename
      ... on InvestmentAccountRecap {
        public
      }
    }
  }
`
export type SetRecapPublicAccessMutationFn = ApolloReactCommon.MutationFunction<
  SetRecapPublicAccessMutation,
  SetRecapPublicAccessMutationVariables
>

/**
 * __useSetRecapPublicAccessMutation__
 *
 * To run a mutation, you first call `useSetRecapPublicAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRecapPublicAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRecapPublicAccessMutation, { data, loading, error }] = useSetRecapPublicAccessMutation({
 *   variables: {
 *      recapId: // value for 'recapId'
 *      enablePublic: // value for 'enablePublic'
 *   },
 * });
 */
export function useSetRecapPublicAccessMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SetRecapPublicAccessMutation,
    SetRecapPublicAccessMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SetRecapPublicAccessMutation,
    SetRecapPublicAccessMutationVariables
  >(SetRecapPublicAccessDocument, options)
}
export type SetRecapPublicAccessMutationHookResult = ReturnType<
  typeof useSetRecapPublicAccessMutation
>
export type SetRecapPublicAccessMutationResult =
  ApolloReactCommon.MutationResult<SetRecapPublicAccessMutation>
export type SetRecapPublicAccessMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SetRecapPublicAccessMutation,
    SetRecapPublicAccessMutationVariables
  >
export const CustodianRecapDocument = /*#__PURE__*/ gql`
  query CustodianRecap($id: ID!) {
    investmentAccountRecap(id: $id) {
      ...RecapItems
    }
  }
  ${RecapItemsFragmentDoc}
`

/**
 * __useCustodianRecapQuery__
 *
 * To run a query within a React component, call `useCustodianRecapQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustodianRecapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustodianRecapQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustodianRecapQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    CustodianRecapQuery,
    CustodianRecapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CustodianRecapQuery,
    CustodianRecapQueryVariables
  >(CustodianRecapDocument, options)
}
export function useCustodianRecapLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CustodianRecapQuery,
    CustodianRecapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CustodianRecapQuery,
    CustodianRecapQueryVariables
  >(CustodianRecapDocument, options)
}
export type CustodianRecapQueryHookResult = ReturnType<
  typeof useCustodianRecapQuery
>
export type CustodianRecapLazyQueryHookResult = ReturnType<
  typeof useCustodianRecapLazyQuery
>
export type CustodianRecapQueryResult = ApolloReactCommon.QueryResult<
  CustodianRecapQuery,
  CustodianRecapQueryVariables
>
export const PublicRecapDocument = /*#__PURE__*/ gql`
  query PublicRecap($id: ID!) {
    investmentAccountRecapByPublicToken(publicToken: $id) {
      ...RecapItems
    }
  }
  ${RecapItemsFragmentDoc}
`

/**
 * __usePublicRecapQuery__
 *
 * To run a query within a React component, call `usePublicRecapQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicRecapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicRecapQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublicRecapQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    PublicRecapQuery,
    PublicRecapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<PublicRecapQuery, PublicRecapQueryVariables>(
    PublicRecapDocument,
    options,
  )
}
export function usePublicRecapLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PublicRecapQuery,
    PublicRecapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PublicRecapQuery,
    PublicRecapQueryVariables
  >(PublicRecapDocument, options)
}
export type PublicRecapQueryHookResult = ReturnType<typeof usePublicRecapQuery>
export type PublicRecapLazyQueryHookResult = ReturnType<
  typeof usePublicRecapLazyQuery
>
export type PublicRecapQueryResult = ApolloReactCommon.QueryResult<
  PublicRecapQuery,
  PublicRecapQueryVariables
>
export const UserPublishingQueryDocument = /*#__PURE__*/ gql`
  query UserPublishingQuery {
    user {
      uuid
      email
      firstName
      lastName
    }
  }
`

/**
 * __useUserPublishingQueryQuery__
 *
 * To run a query within a React component, call `useUserPublishingQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPublishingQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPublishingQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPublishingQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserPublishingQueryQuery,
    UserPublishingQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    UserPublishingQueryQuery,
    UserPublishingQueryQueryVariables
  >(UserPublishingQueryDocument, options)
}
export function useUserPublishingQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserPublishingQueryQuery,
    UserPublishingQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    UserPublishingQueryQuery,
    UserPublishingQueryQueryVariables
  >(UserPublishingQueryDocument, options)
}
export type UserPublishingQueryQueryHookResult = ReturnType<
  typeof useUserPublishingQueryQuery
>
export type UserPublishingQueryLazyQueryHookResult = ReturnType<
  typeof useUserPublishingQueryLazyQuery
>
export type UserPublishingQueryQueryResult = ApolloReactCommon.QueryResult<
  UserPublishingQueryQuery,
  UserPublishingQueryQueryVariables
>
export const RedeemGiftcardDocument = /*#__PURE__*/ gql`
  mutation RedeemGiftcard($pin: String!) {
    redeemGiftcard(pin: $pin)
  }
`
export type RedeemGiftcardMutationFn = ApolloReactCommon.MutationFunction<
  RedeemGiftcardMutation,
  RedeemGiftcardMutationVariables
>

/**
 * __useRedeemGiftcardMutation__
 *
 * To run a mutation, you first call `useRedeemGiftcardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemGiftcardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemGiftcardMutation, { data, loading, error }] = useRedeemGiftcardMutation({
 *   variables: {
 *      pin: // value for 'pin'
 *   },
 * });
 */
export function useRedeemGiftcardMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RedeemGiftcardMutation,
    RedeemGiftcardMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RedeemGiftcardMutation,
    RedeemGiftcardMutationVariables
  >(RedeemGiftcardDocument, options)
}
export type RedeemGiftcardMutationHookResult = ReturnType<
  typeof useRedeemGiftcardMutation
>
export type RedeemGiftcardMutationResult =
  ApolloReactCommon.MutationResult<RedeemGiftcardMutation>
export type RedeemGiftcardMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RedeemGiftcardMutation,
    RedeemGiftcardMutationVariables
  >
export const CampaignHistoryStatusByCampaignDocument = /*#__PURE__*/ gql`
  query CampaignHistoryStatusByCampaign($campaignId: ID!) {
    campaignHistory(
      filter: { type: PARTICIPATED, campaignId: $campaignId }
      page: { after: null }
    ) {
      edges {
        numCompletedReferrals
        __typename
        node {
          publishedStatus
        }
      }
    }
  }
`

/**
 * __useCampaignHistoryStatusByCampaignQuery__
 *
 * To run a query within a React component, call `useCampaignHistoryStatusByCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignHistoryStatusByCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignHistoryStatusByCampaignQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignHistoryStatusByCampaignQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    CampaignHistoryStatusByCampaignQuery,
    CampaignHistoryStatusByCampaignQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CampaignHistoryStatusByCampaignQuery,
    CampaignHistoryStatusByCampaignQueryVariables
  >(CampaignHistoryStatusByCampaignDocument, options)
}
export function useCampaignHistoryStatusByCampaignLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CampaignHistoryStatusByCampaignQuery,
    CampaignHistoryStatusByCampaignQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CampaignHistoryStatusByCampaignQuery,
    CampaignHistoryStatusByCampaignQueryVariables
  >(CampaignHistoryStatusByCampaignDocument, options)
}
export type CampaignHistoryStatusByCampaignQueryHookResult = ReturnType<
  typeof useCampaignHistoryStatusByCampaignQuery
>
export type CampaignHistoryStatusByCampaignLazyQueryHookResult = ReturnType<
  typeof useCampaignHistoryStatusByCampaignLazyQuery
>
export type CampaignHistoryStatusByCampaignQueryResult =
  ApolloReactCommon.QueryResult<
    CampaignHistoryStatusByCampaignQuery,
    CampaignHistoryStatusByCampaignQueryVariables
  >
export const ChangePasswordV2Document = /*#__PURE__*/ gql`
  mutation ChangePasswordV2($input: ChangePasswordInput!) {
    changePasswordV2(input: $input) {
      __typename
      ... on ChangePasswordSuccess {
        userId
      }
      ... on IncorrectOldPasswordException {
        message
      }
      ... on InvalidPasswordException {
        message
      }
      ... on SamePasswordsException {
        message
      }
    }
  }
`
export type ChangePasswordV2MutationFn = ApolloReactCommon.MutationFunction<
  ChangePasswordV2Mutation,
  ChangePasswordV2MutationVariables
>

/**
 * __useChangePasswordV2Mutation__
 *
 * To run a mutation, you first call `useChangePasswordV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordV2Mutation, { data, loading, error }] = useChangePasswordV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordV2Mutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ChangePasswordV2Mutation,
    ChangePasswordV2MutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ChangePasswordV2Mutation,
    ChangePasswordV2MutationVariables
  >(ChangePasswordV2Document, options)
}
export type ChangePasswordV2MutationHookResult = ReturnType<
  typeof useChangePasswordV2Mutation
>
export type ChangePasswordV2MutationResult =
  ApolloReactCommon.MutationResult<ChangePasswordV2Mutation>
export type ChangePasswordV2MutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ChangePasswordV2Mutation,
    ChangePasswordV2MutationVariables
  >
export const InvestorFlowSetPortfolioDocument = /*#__PURE__*/ gql`
  mutation InvestorFlowSetPortfolio($input: SetPortfolioInput!) {
    setPortfolio(input: $input) {
      portfolio {
        id
      }
    }
  }
`
export type InvestorFlowSetPortfolioMutationFn =
  ApolloReactCommon.MutationFunction<
    InvestorFlowSetPortfolioMutation,
    InvestorFlowSetPortfolioMutationVariables
  >

/**
 * __useInvestorFlowSetPortfolioMutation__
 *
 * To run a mutation, you first call `useInvestorFlowSetPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvestorFlowSetPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [investorFlowSetPortfolioMutation, { data, loading, error }] = useInvestorFlowSetPortfolioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvestorFlowSetPortfolioMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    InvestorFlowSetPortfolioMutation,
    InvestorFlowSetPortfolioMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    InvestorFlowSetPortfolioMutation,
    InvestorFlowSetPortfolioMutationVariables
  >(InvestorFlowSetPortfolioDocument, options)
}
export type InvestorFlowSetPortfolioMutationHookResult = ReturnType<
  typeof useInvestorFlowSetPortfolioMutation
>
export type InvestorFlowSetPortfolioMutationResult =
  ApolloReactCommon.MutationResult<InvestorFlowSetPortfolioMutation>
export type InvestorFlowSetPortfolioMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    InvestorFlowSetPortfolioMutation,
    InvestorFlowSetPortfolioMutationVariables
  >
export const InvestorAllPortfoliosDocument = /*#__PURE__*/ gql`
  query InvestorAllPortfolios($customizedWithSecuritySymbols: [String!]) {
    portfolios(customizedWithSecuritySymbols: $customizedWithSecuritySymbols) {
      id
      name
      description
      portfolioSecurityAllocations {
        symbol
        allocationPercent
        security {
          id
          displayName
        }
        investmentCategories {
          bond
          crypto
        }
      }
      riskLevel
      theme
    }
  }
`

/**
 * __useInvestorAllPortfoliosQuery__
 *
 * To run a query within a React component, call `useInvestorAllPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorAllPortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorAllPortfoliosQuery({
 *   variables: {
 *      customizedWithSecuritySymbols: // value for 'customizedWithSecuritySymbols'
 *   },
 * });
 */
export function useInvestorAllPortfoliosQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    InvestorAllPortfoliosQuery,
    InvestorAllPortfoliosQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    InvestorAllPortfoliosQuery,
    InvestorAllPortfoliosQueryVariables
  >(InvestorAllPortfoliosDocument, options)
}
export function useInvestorAllPortfoliosLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InvestorAllPortfoliosQuery,
    InvestorAllPortfoliosQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    InvestorAllPortfoliosQuery,
    InvestorAllPortfoliosQueryVariables
  >(InvestorAllPortfoliosDocument, options)
}
export type InvestorAllPortfoliosQueryHookResult = ReturnType<
  typeof useInvestorAllPortfoliosQuery
>
export type InvestorAllPortfoliosLazyQueryHookResult = ReturnType<
  typeof useInvestorAllPortfoliosLazyQuery
>
export type InvestorAllPortfoliosQueryResult = ApolloReactCommon.QueryResult<
  InvestorAllPortfoliosQuery,
  InvestorAllPortfoliosQueryVariables
>
export const InvestAccountIdDocument = /*#__PURE__*/ gql`
  query InvestAccountId {
    investmentAccounts: investmentAccountsByUserId(
      filter: { product: INVEST }
    ) {
      id
      closedAt
      portfolio {
        id
        name
        riskLevel
      }
    }
  }
`

/**
 * __useInvestAccountIdQuery__
 *
 * To run a query within a React component, call `useInvestAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestAccountIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestAccountIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvestAccountIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    InvestAccountIdQuery,
    InvestAccountIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    InvestAccountIdQuery,
    InvestAccountIdQueryVariables
  >(InvestAccountIdDocument, options)
}
export function useInvestAccountIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InvestAccountIdQuery,
    InvestAccountIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    InvestAccountIdQuery,
    InvestAccountIdQueryVariables
  >(InvestAccountIdDocument, options)
}
export type InvestAccountIdQueryHookResult = ReturnType<
  typeof useInvestAccountIdQuery
>
export type InvestAccountIdLazyQueryHookResult = ReturnType<
  typeof useInvestAccountIdLazyQuery
>
export type InvestAccountIdQueryResult = ApolloReactCommon.QueryResult<
  InvestAccountIdQuery,
  InvestAccountIdQueryVariables
>
export const InvestorySuitabilityResponsesDocument = /*#__PURE__*/ gql`
  query InvestorySuitabilityResponses {
    investmentAccounts: investmentAccountsByUserId(
      filter: { product: INVEST }
    ) {
      closedAt
      portfolio {
        theme
      }
    }
    suitabilityResponses {
      answer {
        id
      }
      question {
        id
        key
        possibleAnswers {
          id
          key
        }
      }
    }
    recommendedPortfolio {
      id
    }
  }
`

/**
 * __useInvestorySuitabilityResponsesQuery__
 *
 * To run a query within a React component, call `useInvestorySuitabilityResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorySuitabilityResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorySuitabilityResponsesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvestorySuitabilityResponsesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    InvestorySuitabilityResponsesQuery,
    InvestorySuitabilityResponsesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    InvestorySuitabilityResponsesQuery,
    InvestorySuitabilityResponsesQueryVariables
  >(InvestorySuitabilityResponsesDocument, options)
}
export function useInvestorySuitabilityResponsesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InvestorySuitabilityResponsesQuery,
    InvestorySuitabilityResponsesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    InvestorySuitabilityResponsesQuery,
    InvestorySuitabilityResponsesQueryVariables
  >(InvestorySuitabilityResponsesDocument, options)
}
export type InvestorySuitabilityResponsesQueryHookResult = ReturnType<
  typeof useInvestorySuitabilityResponsesQuery
>
export type InvestorySuitabilityResponsesLazyQueryHookResult = ReturnType<
  typeof useInvestorySuitabilityResponsesLazyQuery
>
export type InvestorySuitabilityResponsesQueryResult =
  ApolloReactCommon.QueryResult<
    InvestorySuitabilityResponsesQuery,
    InvestorySuitabilityResponsesQueryVariables
  >
export const UpdateSuitabilityDocument = /*#__PURE__*/ gql`
  mutation UpdateSuitability(
    $suitabilityInput: [suitability_SuitabilityInput!]!
  ) {
    updateSuitability(suitabilityInput: $suitabilityInput) {
      recommendedPortfolio {
        id
        name
      }
    }
  }
`
export type UpdateSuitabilityMutationFn = ApolloReactCommon.MutationFunction<
  UpdateSuitabilityMutation,
  UpdateSuitabilityMutationVariables
>

/**
 * __useUpdateSuitabilityMutation__
 *
 * To run a mutation, you first call `useUpdateSuitabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSuitabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSuitabilityMutation, { data, loading, error }] = useUpdateSuitabilityMutation({
 *   variables: {
 *      suitabilityInput: // value for 'suitabilityInput'
 *   },
 * });
 */
export function useUpdateSuitabilityMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateSuitabilityMutation,
    UpdateSuitabilityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateSuitabilityMutation,
    UpdateSuitabilityMutationVariables
  >(UpdateSuitabilityDocument, options)
}
export type UpdateSuitabilityMutationHookResult = ReturnType<
  typeof useUpdateSuitabilityMutation
>
export type UpdateSuitabilityMutationResult =
  ApolloReactCommon.MutationResult<UpdateSuitabilityMutation>
export type UpdateSuitabilityMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateSuitabilityMutation,
    UpdateSuitabilityMutationVariables
  >
export const RoundUpAccountDocument = /*#__PURE__*/ gql`
  query RoundUpAccount($id: ID!) {
    roundUpAccount(linkedSubaccountId: $id) {
      __typename
      linkedSubaccountId
      enabled
    }
  }
`

/**
 * __useRoundUpAccountQuery__
 *
 * To run a query within a React component, call `useRoundUpAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoundUpAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoundUpAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoundUpAccountQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    RoundUpAccountQuery,
    RoundUpAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RoundUpAccountQuery,
    RoundUpAccountQueryVariables
  >(RoundUpAccountDocument, options)
}
export function useRoundUpAccountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RoundUpAccountQuery,
    RoundUpAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RoundUpAccountQuery,
    RoundUpAccountQueryVariables
  >(RoundUpAccountDocument, options)
}
export type RoundUpAccountQueryHookResult = ReturnType<
  typeof useRoundUpAccountQuery
>
export type RoundUpAccountLazyQueryHookResult = ReturnType<
  typeof useRoundUpAccountLazyQuery
>
export type RoundUpAccountQueryResult = ApolloReactCommon.QueryResult<
  RoundUpAccountQuery,
  RoundUpAccountQueryVariables
>
export const UserFundingSourceInfoDocument = /*#__PURE__*/ gql`
  query UserFundingSourceInfo {
    fundingSourceInfo {
      name
      accountNumberLastFour
      balance
      linkedSubaccountId
      verified
      type
      rdvSettledAt
    }
  }
`

/**
 * __useUserFundingSourceInfoQuery__
 *
 * To run a query within a React component, call `useUserFundingSourceInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFundingSourceInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFundingSourceInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserFundingSourceInfoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserFundingSourceInfoQuery,
    UserFundingSourceInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    UserFundingSourceInfoQuery,
    UserFundingSourceInfoQueryVariables
  >(UserFundingSourceInfoDocument, options)
}
export function useUserFundingSourceInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserFundingSourceInfoQuery,
    UserFundingSourceInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    UserFundingSourceInfoQuery,
    UserFundingSourceInfoQueryVariables
  >(UserFundingSourceInfoDocument, options)
}
export type UserFundingSourceInfoQueryHookResult = ReturnType<
  typeof useUserFundingSourceInfoQuery
>
export type UserFundingSourceInfoLazyQueryHookResult = ReturnType<
  typeof useUserFundingSourceInfoLazyQuery
>
export type UserFundingSourceInfoQueryResult = ApolloReactCommon.QueryResult<
  UserFundingSourceInfoQuery,
  UserFundingSourceInfoQueryVariables
>
export const PlaidLinkWebhookDocument = /*#__PURE__*/ gql`
  query PlaidLinkWebhook {
    linkedAccountWebhooks {
      plaid
    }
  }
`

/**
 * __usePlaidLinkWebhookQuery__
 *
 * To run a query within a React component, call `usePlaidLinkWebhookQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaidLinkWebhookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaidLinkWebhookQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlaidLinkWebhookQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PlaidLinkWebhookQuery,
    PlaidLinkWebhookQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PlaidLinkWebhookQuery,
    PlaidLinkWebhookQueryVariables
  >(PlaidLinkWebhookDocument, options)
}
export function usePlaidLinkWebhookLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PlaidLinkWebhookQuery,
    PlaidLinkWebhookQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PlaidLinkWebhookQuery,
    PlaidLinkWebhookQueryVariables
  >(PlaidLinkWebhookDocument, options)
}
export type PlaidLinkWebhookQueryHookResult = ReturnType<
  typeof usePlaidLinkWebhookQuery
>
export type PlaidLinkWebhookLazyQueryHookResult = ReturnType<
  typeof usePlaidLinkWebhookLazyQuery
>
export type PlaidLinkWebhookQueryResult = ApolloReactCommon.QueryResult<
  PlaidLinkWebhookQuery,
  PlaidLinkWebhookQueryVariables
>
export const FinancialInstitutionsDocument = /*#__PURE__*/ gql`
  query FinancialInstitutions(
    $search: String
    $supportsAuth: Boolean
    $includeDirectBank: Boolean
  ) {
    financialInstitutions(
      q: $search
      supportsAuth: $supportsAuth
      includeDirectBank: $includeDirectBank
    ) {
      edges {
        node {
          externalId
          id
          linkProviderType
          logoUrl
          name
          products
        }
      }
    }
  }
`

/**
 * __useFinancialInstitutionsQuery__
 *
 * To run a query within a React component, call `useFinancialInstitutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialInstitutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialInstitutionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      supportsAuth: // value for 'supportsAuth'
 *      includeDirectBank: // value for 'includeDirectBank'
 *   },
 * });
 */
export function useFinancialInstitutionsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FinancialInstitutionsQuery,
    FinancialInstitutionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FinancialInstitutionsQuery,
    FinancialInstitutionsQueryVariables
  >(FinancialInstitutionsDocument, options)
}
export function useFinancialInstitutionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FinancialInstitutionsQuery,
    FinancialInstitutionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FinancialInstitutionsQuery,
    FinancialInstitutionsQueryVariables
  >(FinancialInstitutionsDocument, options)
}
export type FinancialInstitutionsQueryHookResult = ReturnType<
  typeof useFinancialInstitutionsQuery
>
export type FinancialInstitutionsLazyQueryHookResult = ReturnType<
  typeof useFinancialInstitutionsLazyQuery
>
export type FinancialInstitutionsQueryResult = ApolloReactCommon.QueryResult<
  FinancialInstitutionsQuery,
  FinancialInstitutionsQueryVariables
>
export const ManageFundingSourceInfoDocument = /*#__PURE__*/ gql`
  query ManageFundingSourceInfo {
    user {
      uploads {
        id
        documentType
        createdAt
      }
      fundingSourceChangeRequiresApproval
    }
    fundingSourceInfo {
      name
      accountNumberLastFour
      balance
      linkedSubaccountId
      verified
      type
      rdvSettledAt
    }
  }
`

/**
 * __useManageFundingSourceInfoQuery__
 *
 * To run a query within a React component, call `useManageFundingSourceInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageFundingSourceInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageFundingSourceInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useManageFundingSourceInfoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ManageFundingSourceInfoQuery,
    ManageFundingSourceInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ManageFundingSourceInfoQuery,
    ManageFundingSourceInfoQueryVariables
  >(ManageFundingSourceInfoDocument, options)
}
export function useManageFundingSourceInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ManageFundingSourceInfoQuery,
    ManageFundingSourceInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ManageFundingSourceInfoQuery,
    ManageFundingSourceInfoQueryVariables
  >(ManageFundingSourceInfoDocument, options)
}
export type ManageFundingSourceInfoQueryHookResult = ReturnType<
  typeof useManageFundingSourceInfoQuery
>
export type ManageFundingSourceInfoLazyQueryHookResult = ReturnType<
  typeof useManageFundingSourceInfoLazyQuery
>
export type ManageFundingSourceInfoQueryResult = ApolloReactCommon.QueryResult<
  ManageFundingSourceInfoQuery,
  ManageFundingSourceInfoQueryVariables
>
export const SetPrimaryFundingSourceDocument = /*#__PURE__*/ gql`
  mutation SetPrimaryFundingSource($id: ID!) {
    assignLinkedSubaccount(
      linkedSubaccountId: $id
      input: { role: primaryFunding }
    ) {
      id
      updatedAt
    }
  }
`
export type SetPrimaryFundingSourceMutationFn =
  ApolloReactCommon.MutationFunction<
    SetPrimaryFundingSourceMutation,
    SetPrimaryFundingSourceMutationVariables
  >

/**
 * __useSetPrimaryFundingSourceMutation__
 *
 * To run a mutation, you first call `useSetPrimaryFundingSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPrimaryFundingSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPrimaryFundingSourceMutation, { data, loading, error }] = useSetPrimaryFundingSourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetPrimaryFundingSourceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SetPrimaryFundingSourceMutation,
    SetPrimaryFundingSourceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SetPrimaryFundingSourceMutation,
    SetPrimaryFundingSourceMutationVariables
  >(SetPrimaryFundingSourceDocument, options)
}
export type SetPrimaryFundingSourceMutationHookResult = ReturnType<
  typeof useSetPrimaryFundingSourceMutation
>
export type SetPrimaryFundingSourceMutationResult =
  ApolloReactCommon.MutationResult<SetPrimaryFundingSourceMutation>
export type SetPrimaryFundingSourceMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SetPrimaryFundingSourceMutation,
    SetPrimaryFundingSourceMutationVariables
  >
export const CreatePlaidLinkedAccountMutationDocument = /*#__PURE__*/ gql`
  mutation CreatePlaidLinkedAccountMutation(
    $linkToken: String!
    $input: CreatePlaidLinkedAccountInput!
  ) {
    createPlaidLinkedAccount(publicToken: $linkToken, input: $input) {
      ...LinkedAccountFields
      linkedSubaccounts {
        ...LinkedSubaccountFields
      }
    }
  }
  ${LinkedAccountFieldsFragmentDoc}
  ${LinkedSubaccountFieldsFragmentDoc}
`
export type CreatePlaidLinkedAccountMutationMutationFn =
  ApolloReactCommon.MutationFunction<
    CreatePlaidLinkedAccountMutationMutation,
    CreatePlaidLinkedAccountMutationMutationVariables
  >

/**
 * __useCreatePlaidLinkedAccountMutationMutation__
 *
 * To run a mutation, you first call `useCreatePlaidLinkedAccountMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlaidLinkedAccountMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlaidLinkedAccountMutationMutation, { data, loading, error }] = useCreatePlaidLinkedAccountMutationMutation({
 *   variables: {
 *      linkToken: // value for 'linkToken'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlaidLinkedAccountMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreatePlaidLinkedAccountMutationMutation,
    CreatePlaidLinkedAccountMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreatePlaidLinkedAccountMutationMutation,
    CreatePlaidLinkedAccountMutationMutationVariables
  >(CreatePlaidLinkedAccountMutationDocument, options)
}
export type CreatePlaidLinkedAccountMutationMutationHookResult = ReturnType<
  typeof useCreatePlaidLinkedAccountMutationMutation
>
export type CreatePlaidLinkedAccountMutationMutationResult =
  ApolloReactCommon.MutationResult<CreatePlaidLinkedAccountMutationMutation>
export type CreatePlaidLinkedAccountMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreatePlaidLinkedAccountMutationMutation,
    CreatePlaidLinkedAccountMutationMutationVariables
  >
export const LinkAchAccountDocument = /*#__PURE__*/ gql`
  mutation LinkAchAccount($routing: String!, $account: String!) {
    linkACHAccount(routing: $routing, account: $account)
  }
`
export type LinkAchAccountMutationFn = ApolloReactCommon.MutationFunction<
  LinkAchAccountMutation,
  LinkAchAccountMutationVariables
>

/**
 * __useLinkAchAccountMutation__
 *
 * To run a mutation, you first call `useLinkAchAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkAchAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkAchAccountMutation, { data, loading, error }] = useLinkAchAccountMutation({
 *   variables: {
 *      routing: // value for 'routing'
 *      account: // value for 'account'
 *   },
 * });
 */
export function useLinkAchAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    LinkAchAccountMutation,
    LinkAchAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    LinkAchAccountMutation,
    LinkAchAccountMutationVariables
  >(LinkAchAccountDocument, options)
}
export type LinkAchAccountMutationHookResult = ReturnType<
  typeof useLinkAchAccountMutation
>
export type LinkAchAccountMutationResult =
  ApolloReactCommon.MutationResult<LinkAchAccountMutation>
export type LinkAchAccountMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    LinkAchAccountMutation,
    LinkAchAccountMutationVariables
  >
export const UpdatePrimaryCheckingMutationDocument = /*#__PURE__*/ gql`
  mutation UpdatePrimaryCheckingMutation($linkedSubaccountId: ID!) {
    assignLinkedSubaccount(
      linkedSubaccountId: $linkedSubaccountId
      input: { role: primaryFunding }
    ) {
      ...LinkedSubaccountFields
      linkedAccount {
        ...LinkedAccountFields
      }
    }
  }
  ${LinkedSubaccountFieldsFragmentDoc}
  ${LinkedAccountFieldsFragmentDoc}
`
export type UpdatePrimaryCheckingMutationMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdatePrimaryCheckingMutationMutation,
    UpdatePrimaryCheckingMutationMutationVariables
  >

/**
 * __useUpdatePrimaryCheckingMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePrimaryCheckingMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrimaryCheckingMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrimaryCheckingMutationMutation, { data, loading, error }] = useUpdatePrimaryCheckingMutationMutation({
 *   variables: {
 *      linkedSubaccountId: // value for 'linkedSubaccountId'
 *   },
 * });
 */
export function useUpdatePrimaryCheckingMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdatePrimaryCheckingMutationMutation,
    UpdatePrimaryCheckingMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdatePrimaryCheckingMutationMutation,
    UpdatePrimaryCheckingMutationMutationVariables
  >(UpdatePrimaryCheckingMutationDocument, options)
}
export type UpdatePrimaryCheckingMutationMutationHookResult = ReturnType<
  typeof useUpdatePrimaryCheckingMutationMutation
>
export type UpdatePrimaryCheckingMutationMutationResult =
  ApolloReactCommon.MutationResult<UpdatePrimaryCheckingMutationMutation>
export type UpdatePrimaryCheckingMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdatePrimaryCheckingMutationMutation,
    UpdatePrimaryCheckingMutationMutationVariables
  >
export const ChangePrimaryCheckingQueryDocument = /*#__PURE__*/ gql`
  query ChangePrimaryCheckingQuery {
    linkedSubaccounts(linked: true) {
      ...LinkedSubaccountFields
      linkedAccount {
        ...LinkedAccountFields
      }
    }
    fundingSourceAccounts {
      name
      last4
      role
    }
    user {
      fundingSourceChangeRequiresApproval
    }
  }
  ${LinkedSubaccountFieldsFragmentDoc}
  ${LinkedAccountFieldsFragmentDoc}
`

/**
 * __useChangePrimaryCheckingQueryQuery__
 *
 * To run a query within a React component, call `useChangePrimaryCheckingQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangePrimaryCheckingQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangePrimaryCheckingQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useChangePrimaryCheckingQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ChangePrimaryCheckingQueryQuery,
    ChangePrimaryCheckingQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ChangePrimaryCheckingQueryQuery,
    ChangePrimaryCheckingQueryQueryVariables
  >(ChangePrimaryCheckingQueryDocument, options)
}
export function useChangePrimaryCheckingQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ChangePrimaryCheckingQueryQuery,
    ChangePrimaryCheckingQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ChangePrimaryCheckingQueryQuery,
    ChangePrimaryCheckingQueryQueryVariables
  >(ChangePrimaryCheckingQueryDocument, options)
}
export type ChangePrimaryCheckingQueryQueryHookResult = ReturnType<
  typeof useChangePrimaryCheckingQueryQuery
>
export type ChangePrimaryCheckingQueryLazyQueryHookResult = ReturnType<
  typeof useChangePrimaryCheckingQueryLazyQuery
>
export type ChangePrimaryCheckingQueryQueryResult =
  ApolloReactCommon.QueryResult<
    ChangePrimaryCheckingQueryQuery,
    ChangePrimaryCheckingQueryQueryVariables
  >
export const LinkedAccountDetailQueryDocument = /*#__PURE__*/ gql`
  query LinkedAccountDetailQuery {
    linkedAccounts(linked: true) {
      ...LinkedAccountFields
      linkedSubaccounts {
        ...LinkedSubaccountFields
      }
    }
    fundingSourceAccounts {
      verified
      rdvSettledAt
      rdvTriggeredAt
      role
      frozen
      canRetriggerRdv
    }
  }
  ${LinkedAccountFieldsFragmentDoc}
  ${LinkedSubaccountFieldsFragmentDoc}
`

/**
 * __useLinkedAccountDetailQueryQuery__
 *
 * To run a query within a React component, call `useLinkedAccountDetailQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkedAccountDetailQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkedAccountDetailQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useLinkedAccountDetailQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    LinkedAccountDetailQueryQuery,
    LinkedAccountDetailQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LinkedAccountDetailQueryQuery,
    LinkedAccountDetailQueryQueryVariables
  >(LinkedAccountDetailQueryDocument, options)
}
export function useLinkedAccountDetailQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LinkedAccountDetailQueryQuery,
    LinkedAccountDetailQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LinkedAccountDetailQueryQuery,
    LinkedAccountDetailQueryQueryVariables
  >(LinkedAccountDetailQueryDocument, options)
}
export type LinkedAccountDetailQueryQueryHookResult = ReturnType<
  typeof useLinkedAccountDetailQueryQuery
>
export type LinkedAccountDetailQueryLazyQueryHookResult = ReturnType<
  typeof useLinkedAccountDetailQueryLazyQuery
>
export type LinkedAccountDetailQueryQueryResult = ApolloReactCommon.QueryResult<
  LinkedAccountDetailQueryQuery,
  LinkedAccountDetailQueryQueryVariables
>
export const LinkedAccountsIndexDocument = /*#__PURE__*/ gql`
  query LinkedAccountsIndex {
    user {
      uploads {
        id
        documentType
        createdAt
      }
      fundingSourceChangeRequiresApproval
    }
    fundingSourceAccounts {
      name
      balance
      verified
      linkedSubaccountId
      rdvSettledAt
      last4
      role
      frozen
      canRetriggerRdv
    }
    linkedAccounts(linked: true) {
      ...LinkedAccountFields
      linkedSubaccounts {
        ...LinkedSubaccountFields
      }
    }
    settings {
      depositsSuspended
    }
    linkedSubaccounts(linked: true) {
      ...LinkedSubaccountFields
      linkedAccount {
        ...LinkedAccountFields
      }
    }
  }
  ${LinkedAccountFieldsFragmentDoc}
  ${LinkedSubaccountFieldsFragmentDoc}
`

/**
 * __useLinkedAccountsIndexQuery__
 *
 * To run a query within a React component, call `useLinkedAccountsIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkedAccountsIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkedAccountsIndexQuery({
 *   variables: {
 *   },
 * });
 */
export function useLinkedAccountsIndexQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    LinkedAccountsIndexQuery,
    LinkedAccountsIndexQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LinkedAccountsIndexQuery,
    LinkedAccountsIndexQueryVariables
  >(LinkedAccountsIndexDocument, options)
}
export function useLinkedAccountsIndexLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LinkedAccountsIndexQuery,
    LinkedAccountsIndexQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LinkedAccountsIndexQuery,
    LinkedAccountsIndexQueryVariables
  >(LinkedAccountsIndexDocument, options)
}
export type LinkedAccountsIndexQueryHookResult = ReturnType<
  typeof useLinkedAccountsIndexQuery
>
export type LinkedAccountsIndexLazyQueryHookResult = ReturnType<
  typeof useLinkedAccountsIndexLazyQuery
>
export type LinkedAccountsIndexQueryResult = ApolloReactCommon.QueryResult<
  LinkedAccountsIndexQuery,
  LinkedAccountsIndexQueryVariables
>
export const HasFundingSourceDocument = /*#__PURE__*/ gql`
  query HasFundingSource {
    fundingSourceAccounts {
      linkedSubaccountId
      name
      role
    }
  }
`

/**
 * __useHasFundingSourceQuery__
 *
 * To run a query within a React component, call `useHasFundingSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasFundingSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasFundingSourceQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasFundingSourceQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    HasFundingSourceQuery,
    HasFundingSourceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    HasFundingSourceQuery,
    HasFundingSourceQueryVariables
  >(HasFundingSourceDocument, options)
}
export function useHasFundingSourceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    HasFundingSourceQuery,
    HasFundingSourceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    HasFundingSourceQuery,
    HasFundingSourceQueryVariables
  >(HasFundingSourceDocument, options)
}
export type HasFundingSourceQueryHookResult = ReturnType<
  typeof useHasFundingSourceQuery
>
export type HasFundingSourceLazyQueryHookResult = ReturnType<
  typeof useHasFundingSourceLazyQuery
>
export type HasFundingSourceQueryResult = ApolloReactCommon.QueryResult<
  HasFundingSourceQuery,
  HasFundingSourceQueryVariables
>
export const UpdateRoundUpAccountDocument = /*#__PURE__*/ gql`
  mutation UpdateRoundUpAccount($enabled: Boolean!, $id: ID!) {
    updateRoundUpAccount(enabled: $enabled, linkedSubaccountId: $id) {
      __typename
      linkedSubaccountId
      enabled
    }
  }
`
export type UpdateRoundUpAccountMutationFn = ApolloReactCommon.MutationFunction<
  UpdateRoundUpAccountMutation,
  UpdateRoundUpAccountMutationVariables
>

/**
 * __useUpdateRoundUpAccountMutation__
 *
 * To run a mutation, you first call `useUpdateRoundUpAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoundUpAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoundUpAccountMutation, { data, loading, error }] = useUpdateRoundUpAccountMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateRoundUpAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateRoundUpAccountMutation,
    UpdateRoundUpAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateRoundUpAccountMutation,
    UpdateRoundUpAccountMutationVariables
  >(UpdateRoundUpAccountDocument, options)
}
export type UpdateRoundUpAccountMutationHookResult = ReturnType<
  typeof useUpdateRoundUpAccountMutation
>
export type UpdateRoundUpAccountMutationResult =
  ApolloReactCommon.MutationResult<UpdateRoundUpAccountMutation>
export type UpdateRoundUpAccountMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateRoundUpAccountMutation,
    UpdateRoundUpAccountMutationVariables
  >
export const GenerateLinkSessionDocument = /*#__PURE__*/ gql`
  mutation generateLinkSession(
    $userId: ID!
    $institutionId: ID!
    $linkedAccountId: ID
    $redirectUrl: URL
    $authRequired: Boolean
  ) {
    generateLinkSession(
      userId: $userId
      input: {
        institutionId: $institutionId
        linkedAccountId: $linkedAccountId
        isWebview: false
        language: EN
        redirectUrl: $redirectUrl
        authRequired: $authRequired
      }
    ) {
      __typename
      ... on RawLinkSession {
        token
        externalId
      }
    }
  }
`
export type GenerateLinkSessionMutationFn = ApolloReactCommon.MutationFunction<
  GenerateLinkSessionMutation,
  GenerateLinkSessionMutationVariables
>

/**
 * __useGenerateLinkSessionMutation__
 *
 * To run a mutation, you first call `useGenerateLinkSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLinkSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLinkSessionMutation, { data, loading, error }] = useGenerateLinkSessionMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      institutionId: // value for 'institutionId'
 *      linkedAccountId: // value for 'linkedAccountId'
 *      redirectUrl: // value for 'redirectUrl'
 *      authRequired: // value for 'authRequired'
 *   },
 * });
 */
export function useGenerateLinkSessionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    GenerateLinkSessionMutation,
    GenerateLinkSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    GenerateLinkSessionMutation,
    GenerateLinkSessionMutationVariables
  >(GenerateLinkSessionDocument, options)
}
export type GenerateLinkSessionMutationHookResult = ReturnType<
  typeof useGenerateLinkSessionMutation
>
export type GenerateLinkSessionMutationResult =
  ApolloReactCommon.MutationResult<GenerateLinkSessionMutation>
export type GenerateLinkSessionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    GenerateLinkSessionMutation,
    GenerateLinkSessionMutationVariables
  >
export const RelinkLinkedAccountDocument = /*#__PURE__*/ gql`
  mutation RelinkLinkedAccount($id: ID!, $linkSessionId: String!) {
    updateLinkedAccount(
      linkedAccountId: $id
      input: { linkSessionId: $linkSessionId }
    ) {
      id
      status
    }
  }
`
export type RelinkLinkedAccountMutationFn = ApolloReactCommon.MutationFunction<
  RelinkLinkedAccountMutation,
  RelinkLinkedAccountMutationVariables
>

/**
 * __useRelinkLinkedAccountMutation__
 *
 * To run a mutation, you first call `useRelinkLinkedAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRelinkLinkedAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [relinkLinkedAccountMutation, { data, loading, error }] = useRelinkLinkedAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      linkSessionId: // value for 'linkSessionId'
 *   },
 * });
 */
export function useRelinkLinkedAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RelinkLinkedAccountMutation,
    RelinkLinkedAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RelinkLinkedAccountMutation,
    RelinkLinkedAccountMutationVariables
  >(RelinkLinkedAccountDocument, options)
}
export type RelinkLinkedAccountMutationHookResult = ReturnType<
  typeof useRelinkLinkedAccountMutation
>
export type RelinkLinkedAccountMutationResult =
  ApolloReactCommon.MutationResult<RelinkLinkedAccountMutation>
export type RelinkLinkedAccountMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RelinkLinkedAccountMutation,
    RelinkLinkedAccountMutationVariables
  >
export const RetriggerRdvsDocument = /*#__PURE__*/ gql`
  mutation RetriggerRdvs {
    retriggerRdvs {
      ... on FundingSourceAccount {
        id
      }
      ... on RdvsNotTriggered {
        message
      }
    }
  }
`
export type RetriggerRdvsMutationFn = ApolloReactCommon.MutationFunction<
  RetriggerRdvsMutation,
  RetriggerRdvsMutationVariables
>

/**
 * __useRetriggerRdvsMutation__
 *
 * To run a mutation, you first call `useRetriggerRdvsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetriggerRdvsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retriggerRdvsMutation, { data, loading, error }] = useRetriggerRdvsMutation({
 *   variables: {
 *   },
 * });
 */
export function useRetriggerRdvsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RetriggerRdvsMutation,
    RetriggerRdvsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RetriggerRdvsMutation,
    RetriggerRdvsMutationVariables
  >(RetriggerRdvsDocument, options)
}
export type RetriggerRdvsMutationHookResult = ReturnType<
  typeof useRetriggerRdvsMutation
>
export type RetriggerRdvsMutationResult =
  ApolloReactCommon.MutationResult<RetriggerRdvsMutation>
export type RetriggerRdvsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RetriggerRdvsMutation,
    RetriggerRdvsMutationVariables
  >
export const SetLinkingErrorDocument = /*#__PURE__*/ gql`
  mutation setLinkingError(
    $id: ID!
    $errorCode: LinkedAccountLinkingErrorsEnum!
  ) {
    setLinkingError(
      linkedAccountId: $id
      linkingErrorCode: { code: $errorCode }
    ) {
      id
      status
      errorCode
    }
  }
`
export type SetLinkingErrorMutationFn = ApolloReactCommon.MutationFunction<
  SetLinkingErrorMutation,
  SetLinkingErrorMutationVariables
>

/**
 * __useSetLinkingErrorMutation__
 *
 * To run a mutation, you first call `useSetLinkingErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLinkingErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLinkingErrorMutation, { data, loading, error }] = useSetLinkingErrorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      errorCode: // value for 'errorCode'
 *   },
 * });
 */
export function useSetLinkingErrorMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SetLinkingErrorMutation,
    SetLinkingErrorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SetLinkingErrorMutation,
    SetLinkingErrorMutationVariables
  >(SetLinkingErrorDocument, options)
}
export type SetLinkingErrorMutationHookResult = ReturnType<
  typeof useSetLinkingErrorMutation
>
export type SetLinkingErrorMutationResult =
  ApolloReactCommon.MutationResult<SetLinkingErrorMutation>
export type SetLinkingErrorMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SetLinkingErrorMutation,
    SetLinkingErrorMutationVariables
  >
export const UnlinkLinkedAccountDocument = /*#__PURE__*/ gql`
  mutation UnlinkLinkedAccount($linkedAccountId: ID!) {
    unlinkLinkedAccount(linkedAccountId: $linkedAccountId) {
      id
      linkedSubaccounts {
        id
      }
    }
  }
`
export type UnlinkLinkedAccountMutationFn = ApolloReactCommon.MutationFunction<
  UnlinkLinkedAccountMutation,
  UnlinkLinkedAccountMutationVariables
>

/**
 * __useUnlinkLinkedAccountMutation__
 *
 * To run a mutation, you first call `useUnlinkLinkedAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkLinkedAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkLinkedAccountMutation, { data, loading, error }] = useUnlinkLinkedAccountMutation({
 *   variables: {
 *      linkedAccountId: // value for 'linkedAccountId'
 *   },
 * });
 */
export function useUnlinkLinkedAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UnlinkLinkedAccountMutation,
    UnlinkLinkedAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UnlinkLinkedAccountMutation,
    UnlinkLinkedAccountMutationVariables
  >(UnlinkLinkedAccountDocument, options)
}
export type UnlinkLinkedAccountMutationHookResult = ReturnType<
  typeof useUnlinkLinkedAccountMutation
>
export type UnlinkLinkedAccountMutationResult =
  ApolloReactCommon.MutationResult<UnlinkLinkedAccountMutation>
export type UnlinkLinkedAccountMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UnlinkLinkedAccountMutation,
    UnlinkLinkedAccountMutationVariables
  >
export const VerifyRdvsDocument = /*#__PURE__*/ gql`
  mutation VerifyRdvs($deposits: [Float!]!) {
    verifyRdvs(input: { deposits: $deposits }) {
      ... on AccountFrozen {
        message
      }
      ... on FundingSourceAccount {
        id
        status
      }
      ... on IncorrectRdvAmounts {
        message
      }
      ... on StoredRdvDepositsInvalid {
        message
      }
      ... on StoredRdvDepositsMissing {
        message
      }
    }
  }
`
export type VerifyRdvsMutationFn = ApolloReactCommon.MutationFunction<
  VerifyRdvsMutation,
  VerifyRdvsMutationVariables
>

/**
 * __useVerifyRdvsMutation__
 *
 * To run a mutation, you first call `useVerifyRdvsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyRdvsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyRdvsMutation, { data, loading, error }] = useVerifyRdvsMutation({
 *   variables: {
 *      deposits: // value for 'deposits'
 *   },
 * });
 */
export function useVerifyRdvsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    VerifyRdvsMutation,
    VerifyRdvsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    VerifyRdvsMutation,
    VerifyRdvsMutationVariables
  >(VerifyRdvsDocument, options)
}
export type VerifyRdvsMutationHookResult = ReturnType<
  typeof useVerifyRdvsMutation
>
export type VerifyRdvsMutationResult =
  ApolloReactCommon.MutationResult<VerifyRdvsMutation>
export type VerifyRdvsMutationOptions = ApolloReactCommon.BaseMutationOptions<
  VerifyRdvsMutation,
  VerifyRdvsMutationVariables
>
export const MySubscriptionFetchUsersTierDocument = /*#__PURE__*/ gql`
  query MySubscriptionFetchUsersTier {
    tierSubscriptionForUser {
      __typename
      ... on TierSubscription {
        id
        tier {
          id
          key
          name
          includedProducts {
            key
          }
          excludedProducts {
            key
          }
        }
        tierPrice {
          id
          amount {
            value
            currency
          }
          billingFrequency
        }
        createdAt
        updatedAt
      }
      ... on TierSubscriptionNotFound {
        message
      }
      ... on TierSubscriptionUnsubscribed {
        id
        createdAt
        updatedAt
      }
    }
  }
`

/**
 * __useMySubscriptionFetchUsersTierQuery__
 *
 * To run a query within a React component, call `useMySubscriptionFetchUsersTierQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySubscriptionFetchUsersTierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySubscriptionFetchUsersTierQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySubscriptionFetchUsersTierQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    MySubscriptionFetchUsersTierQuery,
    MySubscriptionFetchUsersTierQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    MySubscriptionFetchUsersTierQuery,
    MySubscriptionFetchUsersTierQueryVariables
  >(MySubscriptionFetchUsersTierDocument, options)
}
export function useMySubscriptionFetchUsersTierLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MySubscriptionFetchUsersTierQuery,
    MySubscriptionFetchUsersTierQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    MySubscriptionFetchUsersTierQuery,
    MySubscriptionFetchUsersTierQueryVariables
  >(MySubscriptionFetchUsersTierDocument, options)
}
export type MySubscriptionFetchUsersTierQueryHookResult = ReturnType<
  typeof useMySubscriptionFetchUsersTierQuery
>
export type MySubscriptionFetchUsersTierLazyQueryHookResult = ReturnType<
  typeof useMySubscriptionFetchUsersTierLazyQuery
>
export type MySubscriptionFetchUsersTierQueryResult =
  ApolloReactCommon.QueryResult<
    MySubscriptionFetchUsersTierQuery,
    MySubscriptionFetchUsersTierQueryVariables
  >
export const SubscriptionCenterCancelRecurringTransferDocument = /*#__PURE__*/ gql`
  mutation SubscriptionCenterCancelRecurringTransfer($id: ID!) {
    cancelRecurringTransfer(id: $id) {
      __typename
      ... on RecurringTransfer {
        active
        id
        nextTransferDate
      }
    }
  }
`
export type SubscriptionCenterCancelRecurringTransferMutationFn =
  ApolloReactCommon.MutationFunction<
    SubscriptionCenterCancelRecurringTransferMutation,
    SubscriptionCenterCancelRecurringTransferMutationVariables
  >

/**
 * __useSubscriptionCenterCancelRecurringTransferMutation__
 *
 * To run a mutation, you first call `useSubscriptionCenterCancelRecurringTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionCenterCancelRecurringTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionCenterCancelRecurringTransferMutation, { data, loading, error }] = useSubscriptionCenterCancelRecurringTransferMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscriptionCenterCancelRecurringTransferMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SubscriptionCenterCancelRecurringTransferMutation,
    SubscriptionCenterCancelRecurringTransferMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SubscriptionCenterCancelRecurringTransferMutation,
    SubscriptionCenterCancelRecurringTransferMutationVariables
  >(SubscriptionCenterCancelRecurringTransferDocument, options)
}
export type SubscriptionCenterCancelRecurringTransferMutationHookResult =
  ReturnType<typeof useSubscriptionCenterCancelRecurringTransferMutation>
export type SubscriptionCenterCancelRecurringTransferMutationResult =
  ApolloReactCommon.MutationResult<SubscriptionCenterCancelRecurringTransferMutation>
export type SubscriptionCenterCancelRecurringTransferMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SubscriptionCenterCancelRecurringTransferMutation,
    SubscriptionCenterCancelRecurringTransferMutationVariables
  >
export const SubscriptionCenterSubscribeUserToTierDocument = /*#__PURE__*/ gql`
  mutation SubscriptionCenterSubscribeUserToTier($tierPriceId: ID!) {
    subscribeUserToTier(input: { tierPriceId: $tierPriceId }) {
      __typename
      ... on TierDowngradeActionRequired {
        actions {
          key
        }
      }
      ... on TierSubscription {
        id
        createdAt
        updatedAt
        tier {
          includedProducts {
            key
          }
          excludedProducts {
            key
          }
        }
        tierPrice {
          billingFrequency
          amount {
            value
            currency
          }
        }
      }
    }
  }
`
export type SubscriptionCenterSubscribeUserToTierMutationFn =
  ApolloReactCommon.MutationFunction<
    SubscriptionCenterSubscribeUserToTierMutation,
    SubscriptionCenterSubscribeUserToTierMutationVariables
  >

/**
 * __useSubscriptionCenterSubscribeUserToTierMutation__
 *
 * To run a mutation, you first call `useSubscriptionCenterSubscribeUserToTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionCenterSubscribeUserToTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionCenterSubscribeUserToTierMutation, { data, loading, error }] = useSubscriptionCenterSubscribeUserToTierMutation({
 *   variables: {
 *      tierPriceId: // value for 'tierPriceId'
 *   },
 * });
 */
export function useSubscriptionCenterSubscribeUserToTierMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SubscriptionCenterSubscribeUserToTierMutation,
    SubscriptionCenterSubscribeUserToTierMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SubscriptionCenterSubscribeUserToTierMutation,
    SubscriptionCenterSubscribeUserToTierMutationVariables
  >(SubscriptionCenterSubscribeUserToTierDocument, options)
}
export type SubscriptionCenterSubscribeUserToTierMutationHookResult =
  ReturnType<typeof useSubscriptionCenterSubscribeUserToTierMutation>
export type SubscriptionCenterSubscribeUserToTierMutationResult =
  ApolloReactCommon.MutationResult<SubscriptionCenterSubscribeUserToTierMutation>
export type SubscriptionCenterSubscribeUserToTierMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SubscriptionCenterSubscribeUserToTierMutation,
    SubscriptionCenterSubscribeUserToTierMutationVariables
  >
export const NextBillingDateDocument = /*#__PURE__*/ gql`
  query nextBillingDate {
    nextBillingDate {
      next_billing_date
    }
  }
`

/**
 * __useNextBillingDateQuery__
 *
 * To run a query within a React component, call `useNextBillingDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextBillingDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextBillingDateQuery({
 *   variables: {
 *   },
 * });
 */
export function useNextBillingDateQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    NextBillingDateQuery,
    NextBillingDateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    NextBillingDateQuery,
    NextBillingDateQueryVariables
  >(NextBillingDateDocument, options)
}
export function useNextBillingDateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    NextBillingDateQuery,
    NextBillingDateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    NextBillingDateQuery,
    NextBillingDateQueryVariables
  >(NextBillingDateDocument, options)
}
export type NextBillingDateQueryHookResult = ReturnType<
  typeof useNextBillingDateQuery
>
export type NextBillingDateLazyQueryHookResult = ReturnType<
  typeof useNextBillingDateLazyQuery
>
export type NextBillingDateQueryResult = ApolloReactCommon.QueryResult<
  NextBillingDateQuery,
  NextBillingDateQueryVariables
>
export const SpendPendingItemsDocument = /*#__PURE__*/ gql`
  query SpendPendingItems(
    $accountId: ID!
    $productAccountType: ProductAccountType!
  ) {
    allPastItems(
      filter: {
        pending: true
        pastItemsAccountFilter: {
          id: $accountId
          productAccountType: $productAccountType
        }
      }
      pagination: { first: 1 }
    ) {
      edges {
        node {
          id
        }
      }
    }
  }
`

/**
 * __useSpendPendingItemsQuery__
 *
 * To run a query within a React component, call `useSpendPendingItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpendPendingItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpendPendingItemsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      productAccountType: // value for 'productAccountType'
 *   },
 * });
 */
export function useSpendPendingItemsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SpendPendingItemsQuery,
    SpendPendingItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SpendPendingItemsQuery,
    SpendPendingItemsQueryVariables
  >(SpendPendingItemsDocument, options)
}
export function useSpendPendingItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SpendPendingItemsQuery,
    SpendPendingItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SpendPendingItemsQuery,
    SpendPendingItemsQueryVariables
  >(SpendPendingItemsDocument, options)
}
export type SpendPendingItemsQueryHookResult = ReturnType<
  typeof useSpendPendingItemsQuery
>
export type SpendPendingItemsLazyQueryHookResult = ReturnType<
  typeof useSpendPendingItemsLazyQuery
>
export type SpendPendingItemsQueryResult = ApolloReactCommon.QueryResult<
  SpendPendingItemsQuery,
  SpendPendingItemsQueryVariables
>
export const SubscriptionTierQueryDocument = /*#__PURE__*/ gql`
  query SubscriptionTierQuery {
    user {
      uuid
      verified
      fundingSource {
        name
        verified
      }
    }
    bankCardOrder {
      cardOrderStatus
    }
    allBankAccounts(input: { type: spend }) {
      balance {
        value
      }
      createdAt
      status
      id
    }
    linkedAccounts(linked: true) {
      linked
      id
    }
    recurringTransfers(filter: { targetAccountType: SPEND }) {
      id
      active
    }
    investmentAccountsByUserId {
      id
      name
      type
      product
      currentBalance {
        currency
        value
      }
      pendingBalance {
        currency
        value
      }
      recurringInvestmentSettings {
        amount
      }
      status
      beneficiaryId
      portfolios {
        ... on SelfDirectedPortfolio {
          __typename
          status
        }
      }
      closedAt
    }
  }
`

/**
 * __useSubscriptionTierQueryQuery__
 *
 * To run a query within a React component, call `useSubscriptionTierQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionTierQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionTierQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionTierQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SubscriptionTierQueryQuery,
    SubscriptionTierQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SubscriptionTierQueryQuery,
    SubscriptionTierQueryQueryVariables
  >(SubscriptionTierQueryDocument, options)
}
export function useSubscriptionTierQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SubscriptionTierQueryQuery,
    SubscriptionTierQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SubscriptionTierQueryQuery,
    SubscriptionTierQueryQueryVariables
  >(SubscriptionTierQueryDocument, options)
}
export type SubscriptionTierQueryQueryHookResult = ReturnType<
  typeof useSubscriptionTierQueryQuery
>
export type SubscriptionTierQueryLazyQueryHookResult = ReturnType<
  typeof useSubscriptionTierQueryLazyQuery
>
export type SubscriptionTierQueryQueryResult = ApolloReactCommon.QueryResult<
  SubscriptionTierQueryQuery,
  SubscriptionTierQueryQueryVariables
>
export const TiersDocument = /*#__PURE__*/ gql`
  query Tiers {
    tierGroupForUser {
      id
      preferredTierId
      tierOptions {
        preferredTierPrice {
          id
          amount {
            value
            currency
          }
          billingFrequency
        }
        tier {
          id
          key
          name
          includedProducts {
            key
          }
          excludedProducts {
            key
          }
        }
        tierPrices {
          id
          billingFrequency
          amount {
            value
            currency
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`

/**
 * __useTiersQuery__
 *
 * To run a query within a React component, call `useTiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTiersQuery({
 *   variables: {
 *   },
 * });
 */
export function useTiersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    TiersQuery,
    TiersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<TiersQuery, TiersQueryVariables>(
    TiersDocument,
    options,
  )
}
export function useTiersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TiersQuery,
    TiersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<TiersQuery, TiersQueryVariables>(
    TiersDocument,
    options,
  )
}
export type TiersQueryHookResult = ReturnType<typeof useTiersQuery>
export type TiersLazyQueryHookResult = ReturnType<typeof useTiersLazyQuery>
export type TiersQueryResult = ApolloReactCommon.QueryResult<
  TiersQuery,
  TiersQueryVariables
>
export const EarlyTierGroupDocument = /*#__PURE__*/ gql`
  query EarlyTierGroup {
    tierGroup(id: "d85b2a7a-2300-4cb2-8d7f-bf502430c494") {
      id
      preferredTierId
      tierOptions {
        preferredTierPrice {
          id
          amount {
            value
            currency
          }
          billingFrequency
        }
        tier {
          id
          key
          name
          description
          includedProducts {
            key
          }
          excludedProducts {
            key
          }
        }
        tierPrices {
          id
          billingFrequency
          amount {
            value
            currency
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`

/**
 * __useEarlyTierGroupQuery__
 *
 * To run a query within a React component, call `useEarlyTierGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarlyTierGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarlyTierGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useEarlyTierGroupQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    EarlyTierGroupQuery,
    EarlyTierGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EarlyTierGroupQuery,
    EarlyTierGroupQueryVariables
  >(EarlyTierGroupDocument, options)
}
export function useEarlyTierGroupLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EarlyTierGroupQuery,
    EarlyTierGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EarlyTierGroupQuery,
    EarlyTierGroupQueryVariables
  >(EarlyTierGroupDocument, options)
}
export type EarlyTierGroupQueryHookResult = ReturnType<
  typeof useEarlyTierGroupQuery
>
export type EarlyTierGroupLazyQueryHookResult = ReturnType<
  typeof useEarlyTierGroupLazyQuery
>
export type EarlyTierGroupQueryResult = ApolloReactCommon.QueryResult<
  EarlyTierGroupQuery,
  EarlyTierGroupQueryVariables
>
export const SubscriptionCenterFetchUsersTierDocument = /*#__PURE__*/ gql`
  query SubscriptionCenterFetchUsersTier {
    user {
      uuid
      verified
      fundingSource {
        name
        verified
      }
    }
    tierSubscriptionForUser {
      __typename
      ... on TierSubscription {
        id
        tier {
          id
          key
          name
          includedProducts {
            key
          }
          excludedProducts {
            key
          }
        }
        tierPrice {
          id
          amount {
            value
            currency
          }
          billingFrequency
        }
        createdAt
        updatedAt
      }
      ... on TierSubscriptionNotFound {
        message
      }
      ... on TierSubscriptionUnsubscribed {
        id
        createdAt
        updatedAt
      }
    }
  }
`

/**
 * __useSubscriptionCenterFetchUsersTierQuery__
 *
 * To run a query within a React component, call `useSubscriptionCenterFetchUsersTierQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionCenterFetchUsersTierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionCenterFetchUsersTierQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionCenterFetchUsersTierQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SubscriptionCenterFetchUsersTierQuery,
    SubscriptionCenterFetchUsersTierQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SubscriptionCenterFetchUsersTierQuery,
    SubscriptionCenterFetchUsersTierQueryVariables
  >(SubscriptionCenterFetchUsersTierDocument, options)
}
export function useSubscriptionCenterFetchUsersTierLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SubscriptionCenterFetchUsersTierQuery,
    SubscriptionCenterFetchUsersTierQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SubscriptionCenterFetchUsersTierQuery,
    SubscriptionCenterFetchUsersTierQueryVariables
  >(SubscriptionCenterFetchUsersTierDocument, options)
}
export type SubscriptionCenterFetchUsersTierQueryHookResult = ReturnType<
  typeof useSubscriptionCenterFetchUsersTierQuery
>
export type SubscriptionCenterFetchUsersTierLazyQueryHookResult = ReturnType<
  typeof useSubscriptionCenterFetchUsersTierLazyQuery
>
export type SubscriptionCenterFetchUsersTierQueryResult =
  ApolloReactCommon.QueryResult<
    SubscriptionCenterFetchUsersTierQuery,
    SubscriptionCenterFetchUsersTierQueryVariables
  >
export const UpdateCustomerAddressDocument = /*#__PURE__*/ gql`
  mutation UpdateCustomerAddress(
    $addressType: AddressType!
    $input: AddressInput!
  ) {
    updateCustomerAddress(addressType: $addressType, input: $input) {
      ... on Address {
        addressType
        city
        country
        createdAt
        id
        state
        street1
        street2
        updatedAt
        verified
        zipCode
      }
      ... on InvalidAddressException {
        __typename
        message
        reasons {
          __typename
          addressLine
          code
          maxLength
        }
      }
    }
  }
`
export type UpdateCustomerAddressMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdateCustomerAddressMutation,
    UpdateCustomerAddressMutationVariables
  >

/**
 * __useUpdateCustomerAddressMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerAddressMutation, { data, loading, error }] = useUpdateCustomerAddressMutation({
 *   variables: {
 *      addressType: // value for 'addressType'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerAddressMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateCustomerAddressMutation,
    UpdateCustomerAddressMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateCustomerAddressMutation,
    UpdateCustomerAddressMutationVariables
  >(UpdateCustomerAddressDocument, options)
}
export type UpdateCustomerAddressMutationHookResult = ReturnType<
  typeof useUpdateCustomerAddressMutation
>
export type UpdateCustomerAddressMutationResult =
  ApolloReactCommon.MutationResult<UpdateCustomerAddressMutation>
export type UpdateCustomerAddressMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateCustomerAddressMutation,
    UpdateCustomerAddressMutationVariables
  >
export const UpdateShippingInfoDocument = /*#__PURE__*/ gql`
  mutation UpdateShippingInfo(
    $street1: String
    $street2: String
    $city: String
    $state: String
    $zipCode: String
  ) {
    updateAddress(
      addressType: mailing
      input: {
        street1: $street1
        street2: $street2
        city: $city
        state: $state
        zipCode: $zipCode
      }
    ) {
      id
    }
  }
`
export type UpdateShippingInfoMutationFn = ApolloReactCommon.MutationFunction<
  UpdateShippingInfoMutation,
  UpdateShippingInfoMutationVariables
>

/**
 * __useUpdateShippingInfoMutation__
 *
 * To run a mutation, you first call `useUpdateShippingInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShippingInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShippingInfoMutation, { data, loading, error }] = useUpdateShippingInfoMutation({
 *   variables: {
 *      street1: // value for 'street1'
 *      street2: // value for 'street2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useUpdateShippingInfoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateShippingInfoMutation,
    UpdateShippingInfoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateShippingInfoMutation,
    UpdateShippingInfoMutationVariables
  >(UpdateShippingInfoDocument, options)
}
export type UpdateShippingInfoMutationHookResult = ReturnType<
  typeof useUpdateShippingInfoMutation
>
export type UpdateShippingInfoMutationResult =
  ApolloReactCommon.MutationResult<UpdateShippingInfoMutation>
export type UpdateShippingInfoMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateShippingInfoMutation,
    UpdateShippingInfoMutationVariables
  >
export const UpdatePersonalInfoDocument = /*#__PURE__*/ gql`
  mutation UpdatePersonalInfo(
    $firstName: String
    $lastName: String
    $phoneNumber: String
  ) {
    updatePersonalInfo(
      input: {
        firstName: $firstName
        lastName: $lastName
        phoneNumber: $phoneNumber
      }
    ) {
      uuid
    }
  }
`
export type UpdatePersonalInfoMutationFn = ApolloReactCommon.MutationFunction<
  UpdatePersonalInfoMutation,
  UpdatePersonalInfoMutationVariables
>

/**
 * __useUpdatePersonalInfoMutation__
 *
 * To run a mutation, you first call `useUpdatePersonalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonalInfoMutation, { data, loading, error }] = useUpdatePersonalInfoMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdatePersonalInfoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdatePersonalInfoMutation,
    UpdatePersonalInfoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdatePersonalInfoMutation,
    UpdatePersonalInfoMutationVariables
  >(UpdatePersonalInfoDocument, options)
}
export type UpdatePersonalInfoMutationHookResult = ReturnType<
  typeof useUpdatePersonalInfoMutation
>
export type UpdatePersonalInfoMutationResult =
  ApolloReactCommon.MutationResult<UpdatePersonalInfoMutation>
export type UpdatePersonalInfoMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdatePersonalInfoMutation,
    UpdatePersonalInfoMutationVariables
  >
export const AuthAndUserProfileDocument = /*#__PURE__*/ gql`
  query AuthAndUserProfile {
    authProfile {
      email
      userId
      emailVerifiedAt
      phoneNumber
      phoneNumberVerifiedAt
      requireLoginChallenge
    }
    user {
      firstName
      lastName
      phoneNumber
      email
      registrationComplete
      verified
    }
  }
`

/**
 * __useAuthAndUserProfileQuery__
 *
 * To run a query within a React component, call `useAuthAndUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthAndUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthAndUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthAndUserProfileQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AuthAndUserProfileQuery,
    AuthAndUserProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AuthAndUserProfileQuery,
    AuthAndUserProfileQueryVariables
  >(AuthAndUserProfileDocument, options)
}
export function useAuthAndUserProfileLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AuthAndUserProfileQuery,
    AuthAndUserProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AuthAndUserProfileQuery,
    AuthAndUserProfileQueryVariables
  >(AuthAndUserProfileDocument, options)
}
export type AuthAndUserProfileQueryHookResult = ReturnType<
  typeof useAuthAndUserProfileQuery
>
export type AuthAndUserProfileLazyQueryHookResult = ReturnType<
  typeof useAuthAndUserProfileLazyQuery
>
export type AuthAndUserProfileQueryResult = ApolloReactCommon.QueryResult<
  AuthAndUserProfileQuery,
  AuthAndUserProfileQueryVariables
>
export const AuthProfileDocument = /*#__PURE__*/ gql`
  query AuthProfile {
    authProfile {
      phoneNumber
      phoneNumberVerifiedAt
      email
      emailVerifiedAt
    }
  }
`

/**
 * __useAuthProfileQuery__
 *
 * To run a query within a React component, call `useAuthProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthProfileQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AuthProfileQuery,
    AuthProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<AuthProfileQuery, AuthProfileQueryVariables>(
    AuthProfileDocument,
    options,
  )
}
export function useAuthProfileLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AuthProfileQuery,
    AuthProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AuthProfileQuery,
    AuthProfileQueryVariables
  >(AuthProfileDocument, options)
}
export type AuthProfileQueryHookResult = ReturnType<typeof useAuthProfileQuery>
export type AuthProfileLazyQueryHookResult = ReturnType<
  typeof useAuthProfileLazyQuery
>
export type AuthProfileQueryResult = ApolloReactCommon.QueryResult<
  AuthProfileQuery,
  AuthProfileQueryVariables
>
export const VerifyDeliveryAddressDocument = /*#__PURE__*/ gql`
  query VerifyDeliveryAddress(
    $street1: String!
    $street2: String
    $city: String!
    $state: String!
    $zip: String!
    $country: String!
  ) {
    addressDeliverability(
      input: {
        street1: $street1
        street2: $street2
        city: $city
        state: $state
        zipCode: $zip
        country: $country
      }
    ) {
      __typename
      ... on AddressDeliverabilityVerified {
        requestId
      }
      ... on AddressDeliverabilityVerificationError {
        requestId
      }
      ... on AddressDeliverabilityCorrectedAddress {
        city
        country
        state
        street1
        street2
        zipCode
      }
      ... on AddressDeliverabilityUnavailableError {
        requestId
      }
    }
  }
`

/**
 * __useVerifyDeliveryAddressQuery__
 *
 * To run a query within a React component, call `useVerifyDeliveryAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyDeliveryAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyDeliveryAddressQuery({
 *   variables: {
 *      street1: // value for 'street1'
 *      street2: // value for 'street2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zip: // value for 'zip'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useVerifyDeliveryAddressQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    VerifyDeliveryAddressQuery,
    VerifyDeliveryAddressQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    VerifyDeliveryAddressQuery,
    VerifyDeliveryAddressQueryVariables
  >(VerifyDeliveryAddressDocument, options)
}
export function useVerifyDeliveryAddressLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    VerifyDeliveryAddressQuery,
    VerifyDeliveryAddressQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    VerifyDeliveryAddressQuery,
    VerifyDeliveryAddressQueryVariables
  >(VerifyDeliveryAddressDocument, options)
}
export type VerifyDeliveryAddressQueryHookResult = ReturnType<
  typeof useVerifyDeliveryAddressQuery
>
export type VerifyDeliveryAddressLazyQueryHookResult = ReturnType<
  typeof useVerifyDeliveryAddressLazyQuery
>
export type VerifyDeliveryAddressQueryResult = ApolloReactCommon.QueryResult<
  VerifyDeliveryAddressQuery,
  VerifyDeliveryAddressQueryVariables
>
export const SettingsBankCardReissueDocument = /*#__PURE__*/ gql`
  query SettingsBankCardReissue {
    bankCardReissue {
      bankCardRequest {
        id
        userId
        requestedDate
        status
        reason
        reasonComment
        reasonDate
        issuedDate
        isActivated
        isReissue
        previousBankCardId
      }
      reissueBankCardEligibility {
        ... on ReissueBankCardEligible {
          __typename
          originalCardCreatedAt
        }
        ... on ReissueBankCardIneligible {
          __typename
          issues
        }
      }
    }
    spendAlerts {
      type
    }
  }
`

/**
 * __useSettingsBankCardReissueQuery__
 *
 * To run a query within a React component, call `useSettingsBankCardReissueQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsBankCardReissueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsBankCardReissueQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingsBankCardReissueQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SettingsBankCardReissueQuery,
    SettingsBankCardReissueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SettingsBankCardReissueQuery,
    SettingsBankCardReissueQueryVariables
  >(SettingsBankCardReissueDocument, options)
}
export function useSettingsBankCardReissueLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SettingsBankCardReissueQuery,
    SettingsBankCardReissueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SettingsBankCardReissueQuery,
    SettingsBankCardReissueQueryVariables
  >(SettingsBankCardReissueDocument, options)
}
export type SettingsBankCardReissueQueryHookResult = ReturnType<
  typeof useSettingsBankCardReissueQuery
>
export type SettingsBankCardReissueLazyQueryHookResult = ReturnType<
  typeof useSettingsBankCardReissueLazyQuery
>
export type SettingsBankCardReissueQueryResult = ApolloReactCommon.QueryResult<
  SettingsBankCardReissueQuery,
  SettingsBankCardReissueQueryVariables
>
export const LockSpendCardMutationDocument = /*#__PURE__*/ gql`
  mutation LockSpendCardMutation {
    lockBankCard(input: { lockReason: unknown }) {
      bankCard {
        id
      }
    }
  }
`
export type LockSpendCardMutationMutationFn =
  ApolloReactCommon.MutationFunction<
    LockSpendCardMutationMutation,
    LockSpendCardMutationMutationVariables
  >

/**
 * __useLockSpendCardMutationMutation__
 *
 * To run a mutation, you first call `useLockSpendCardMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockSpendCardMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockSpendCardMutationMutation, { data, loading, error }] = useLockSpendCardMutationMutation({
 *   variables: {
 *   },
 * });
 */
export function useLockSpendCardMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    LockSpendCardMutationMutation,
    LockSpendCardMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    LockSpendCardMutationMutation,
    LockSpendCardMutationMutationVariables
  >(LockSpendCardMutationDocument, options)
}
export type LockSpendCardMutationMutationHookResult = ReturnType<
  typeof useLockSpendCardMutationMutation
>
export type LockSpendCardMutationMutationResult =
  ApolloReactCommon.MutationResult<LockSpendCardMutationMutation>
export type LockSpendCardMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    LockSpendCardMutationMutation,
    LockSpendCardMutationMutationVariables
  >
export const UpdateBankCardPinDocument = /*#__PURE__*/ gql`
  mutation UpdateBankCardPin($newPin: BankCardPin!) {
    updateBankCardPin(input: { newPin: $newPin }) {
      bankCard {
        id
      }
    }
  }
`
export type UpdateBankCardPinMutationFn = ApolloReactCommon.MutationFunction<
  UpdateBankCardPinMutation,
  UpdateBankCardPinMutationVariables
>

/**
 * __useUpdateBankCardPinMutation__
 *
 * To run a mutation, you first call `useUpdateBankCardPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBankCardPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBankCardPinMutation, { data, loading, error }] = useUpdateBankCardPinMutation({
 *   variables: {
 *      newPin: // value for 'newPin'
 *   },
 * });
 */
export function useUpdateBankCardPinMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateBankCardPinMutation,
    UpdateBankCardPinMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateBankCardPinMutation,
    UpdateBankCardPinMutationVariables
  >(UpdateBankCardPinDocument, options)
}
export type UpdateBankCardPinMutationHookResult = ReturnType<
  typeof useUpdateBankCardPinMutation
>
export type UpdateBankCardPinMutationResult =
  ApolloReactCommon.MutationResult<UpdateBankCardPinMutation>
export type UpdateBankCardPinMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateBankCardPinMutation,
    UpdateBankCardPinMutationVariables
  >
export const SettingsSpendCardQueryDocument = /*#__PURE__*/ gql`
  query SettingsSpendCardQuery {
    user {
      firstName
      lastName
    }
    allBankCards {
      id
      cardNumberMasked
      createdAt
      isDigitalOnly
      type
      lockReason
      status
      tier
    }
    allBankAccounts(input: { type: spend }) {
      id
      number
      routingNumber
    }
  }
`

/**
 * __useSettingsSpendCardQueryQuery__
 *
 * To run a query within a React component, call `useSettingsSpendCardQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsSpendCardQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsSpendCardQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingsSpendCardQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SettingsSpendCardQueryQuery,
    SettingsSpendCardQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SettingsSpendCardQueryQuery,
    SettingsSpendCardQueryQueryVariables
  >(SettingsSpendCardQueryDocument, options)
}
export function useSettingsSpendCardQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SettingsSpendCardQueryQuery,
    SettingsSpendCardQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SettingsSpendCardQueryQuery,
    SettingsSpendCardQueryQueryVariables
  >(SettingsSpendCardQueryDocument, options)
}
export type SettingsSpendCardQueryQueryHookResult = ReturnType<
  typeof useSettingsSpendCardQueryQuery
>
export type SettingsSpendCardQueryLazyQueryHookResult = ReturnType<
  typeof useSettingsSpendCardQueryLazyQuery
>
export type SettingsSpendCardQueryQueryResult = ApolloReactCommon.QueryResult<
  SettingsSpendCardQueryQuery,
  SettingsSpendCardQueryQueryVariables
>
export const RequestEligibilityQueryDocument = /*#__PURE__*/ gql`
  query RequestEligibilityQuery {
    allBankCards {
      lockReason
      type
    }
  }
`

/**
 * __useRequestEligibilityQueryQuery__
 *
 * To run a query within a React component, call `useRequestEligibilityQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestEligibilityQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestEligibilityQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useRequestEligibilityQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    RequestEligibilityQueryQuery,
    RequestEligibilityQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RequestEligibilityQueryQuery,
    RequestEligibilityQueryQueryVariables
  >(RequestEligibilityQueryDocument, options)
}
export function useRequestEligibilityQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RequestEligibilityQueryQuery,
    RequestEligibilityQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RequestEligibilityQueryQuery,
    RequestEligibilityQueryQueryVariables
  >(RequestEligibilityQueryDocument, options)
}
export type RequestEligibilityQueryQueryHookResult = ReturnType<
  typeof useRequestEligibilityQueryQuery
>
export type RequestEligibilityQueryLazyQueryHookResult = ReturnType<
  typeof useRequestEligibilityQueryLazyQuery
>
export type RequestEligibilityQueryQueryResult = ApolloReactCommon.QueryResult<
  RequestEligibilityQueryQuery,
  RequestEligibilityQueryQueryVariables
>
export const AddressQueryDocument = /*#__PURE__*/ gql`
  query AddressQuery {
    addresses(addressType: mailing) {
      city
      country
      state
      street1
      street2
      zipCode
    }
  }
`

/**
 * __useAddressQueryQuery__
 *
 * To run a query within a React component, call `useAddressQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAddressQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AddressQueryQuery,
    AddressQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AddressQueryQuery,
    AddressQueryQueryVariables
  >(AddressQueryDocument, options)
}
export function useAddressQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AddressQueryQuery,
    AddressQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AddressQueryQuery,
    AddressQueryQueryVariables
  >(AddressQueryDocument, options)
}
export type AddressQueryQueryHookResult = ReturnType<
  typeof useAddressQueryQuery
>
export type AddressQueryLazyQueryHookResult = ReturnType<
  typeof useAddressQueryLazyQuery
>
export type AddressQueryQueryResult = ApolloReactCommon.QueryResult<
  AddressQueryQuery,
  AddressQueryQueryVariables
>
export const UnlockSpendCardDocument = /*#__PURE__*/ gql`
  mutation UnlockSpendCard {
    unlockBankCard {
      bankCard {
        id
      }
    }
  }
`
export type UnlockSpendCardMutationFn = ApolloReactCommon.MutationFunction<
  UnlockSpendCardMutation,
  UnlockSpendCardMutationVariables
>

/**
 * __useUnlockSpendCardMutation__
 *
 * To run a mutation, you first call `useUnlockSpendCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockSpendCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockSpendCardMutation, { data, loading, error }] = useUnlockSpendCardMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnlockSpendCardMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UnlockSpendCardMutation,
    UnlockSpendCardMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UnlockSpendCardMutation,
    UnlockSpendCardMutationVariables
  >(UnlockSpendCardDocument, options)
}
export type UnlockSpendCardMutationHookResult = ReturnType<
  typeof useUnlockSpendCardMutation
>
export type UnlockSpendCardMutationResult =
  ApolloReactCommon.MutationResult<UnlockSpendCardMutation>
export type UnlockSpendCardMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UnlockSpendCardMutation,
    UnlockSpendCardMutationVariables
  >
export const SettingsFetchUsersTierDocument = /*#__PURE__*/ gql`
  query SettingsFetchUsersTier {
    tierSubscriptionForUser {
      __typename
      ... on TierSubscription {
        id
        tier {
          active
          id
          key
          name
        }
        createdAt
      }
      ... on TierSubscriptionNotFound {
        message
      }
      ... on TierSubscriptionUnsubscribed {
        id
        createdAt
        updatedAt
      }
    }
  }
`

/**
 * __useSettingsFetchUsersTierQuery__
 *
 * To run a query within a React component, call `useSettingsFetchUsersTierQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsFetchUsersTierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsFetchUsersTierQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingsFetchUsersTierQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SettingsFetchUsersTierQuery,
    SettingsFetchUsersTierQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SettingsFetchUsersTierQuery,
    SettingsFetchUsersTierQueryVariables
  >(SettingsFetchUsersTierDocument, options)
}
export function useSettingsFetchUsersTierLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SettingsFetchUsersTierQuery,
    SettingsFetchUsersTierQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SettingsFetchUsersTierQuery,
    SettingsFetchUsersTierQueryVariables
  >(SettingsFetchUsersTierDocument, options)
}
export type SettingsFetchUsersTierQueryHookResult = ReturnType<
  typeof useSettingsFetchUsersTierQuery
>
export type SettingsFetchUsersTierLazyQueryHookResult = ReturnType<
  typeof useSettingsFetchUsersTierLazyQuery
>
export type SettingsFetchUsersTierQueryResult = ApolloReactCommon.QueryResult<
  SettingsFetchUsersTierQuery,
  SettingsFetchUsersTierQueryVariables
>
export const AddTrustedContactDocument = /*#__PURE__*/ gql`
  mutation AddTrustedContact($input: TrustedContactInput!) {
    addTrustedContact(input: $input) {
      ... on TrustedContact {
        __typename
        firstName
        lastName
      }
      ... on InternalErrorException {
        __typename
        internalExceptionErrorMessage: message
      }
      ... on TrustedContactInvalidEmail {
        message
      }
      ... on TrustedContactInvalidPhoneNumber {
        message
      }
      ... on TrustedContactAlreadyExistsException {
        message
        attributes
      }
    }
  }
`
export type AddTrustedContactMutationFn = ApolloReactCommon.MutationFunction<
  AddTrustedContactMutation,
  AddTrustedContactMutationVariables
>

/**
 * __useAddTrustedContactMutation__
 *
 * To run a mutation, you first call `useAddTrustedContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTrustedContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTrustedContactMutation, { data, loading, error }] = useAddTrustedContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTrustedContactMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddTrustedContactMutation,
    AddTrustedContactMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AddTrustedContactMutation,
    AddTrustedContactMutationVariables
  >(AddTrustedContactDocument, options)
}
export type AddTrustedContactMutationHookResult = ReturnType<
  typeof useAddTrustedContactMutation
>
export type AddTrustedContactMutationResult =
  ApolloReactCommon.MutationResult<AddTrustedContactMutation>
export type AddTrustedContactMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AddTrustedContactMutation,
    AddTrustedContactMutationVariables
  >
export const DeleteTrustedContactDocument = /*#__PURE__*/ gql`
  mutation deleteTrustedContact($id: ID!) {
    deleteTrustedContact(id: $id) {
      ... on TrustedContact {
        __typename
        firstName
        lastName
      }
      ... on InternalErrorException {
        __typename
        internalExceptionErrorMessage: message
      }
      ... on TrustedContactNotFoundException {
        message
      }
    }
  }
`
export type DeleteTrustedContactMutationFn = ApolloReactCommon.MutationFunction<
  DeleteTrustedContactMutation,
  DeleteTrustedContactMutationVariables
>

/**
 * __useDeleteTrustedContactMutation__
 *
 * To run a mutation, you first call `useDeleteTrustedContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrustedContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrustedContactMutation, { data, loading, error }] = useDeleteTrustedContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTrustedContactMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteTrustedContactMutation,
    DeleteTrustedContactMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeleteTrustedContactMutation,
    DeleteTrustedContactMutationVariables
  >(DeleteTrustedContactDocument, options)
}
export type DeleteTrustedContactMutationHookResult = ReturnType<
  typeof useDeleteTrustedContactMutation
>
export type DeleteTrustedContactMutationResult =
  ApolloReactCommon.MutationResult<DeleteTrustedContactMutation>
export type DeleteTrustedContactMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteTrustedContactMutation,
    DeleteTrustedContactMutationVariables
  >
export const EditTrustedContactDocument = /*#__PURE__*/ gql`
  mutation editTrustedContact($id: ID!, $input: TrustedContactInput!) {
    editTrustedContact(id: $id, input: $input) {
      ... on TrustedContact {
        __typename
        firstName
        lastName
      }
      ... on InternalErrorException {
        __typename
        internalExceptionErrorMessage: message
      }
      ... on TrustedContactInvalidEmail {
        message
      }
      ... on TrustedContactInvalidPhoneNumber {
        message
      }
      ... on TrustedContactNotFoundException {
        message
      }
      ... on TrustedContactAlreadyExistsException {
        message
        attributes
      }
    }
  }
`
export type EditTrustedContactMutationFn = ApolloReactCommon.MutationFunction<
  EditTrustedContactMutation,
  EditTrustedContactMutationVariables
>

/**
 * __useEditTrustedContactMutation__
 *
 * To run a mutation, you first call `useEditTrustedContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTrustedContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTrustedContactMutation, { data, loading, error }] = useEditTrustedContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTrustedContactMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EditTrustedContactMutation,
    EditTrustedContactMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    EditTrustedContactMutation,
    EditTrustedContactMutationVariables
  >(EditTrustedContactDocument, options)
}
export type EditTrustedContactMutationHookResult = ReturnType<
  typeof useEditTrustedContactMutation
>
export type EditTrustedContactMutationResult =
  ApolloReactCommon.MutationResult<EditTrustedContactMutation>
export type EditTrustedContactMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    EditTrustedContactMutation,
    EditTrustedContactMutationVariables
  >
export const GetAllTrustedContactsByUserIdDocument = /*#__PURE__*/ gql`
  query GetAllTrustedContactsByUserId {
    allTrustedContactsByUserId {
      __typename
      email
      firstName
      id
      lastName
      phoneNumber
      userId
      investmentAccounts {
        id
        investmentAccountType
        name
        product
        type
        beneficiary {
          id
          firstName
        }
        portfolios {
          id
          name
          ... on SelfDirectedPortfolio {
            status
          }
        }
      }
    }
  }
`

/**
 * __useGetAllTrustedContactsByUserIdQuery__
 *
 * To run a query within a React component, call `useGetAllTrustedContactsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTrustedContactsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTrustedContactsByUserIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllTrustedContactsByUserIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAllTrustedContactsByUserIdQuery,
    GetAllTrustedContactsByUserIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetAllTrustedContactsByUserIdQuery,
    GetAllTrustedContactsByUserIdQueryVariables
  >(GetAllTrustedContactsByUserIdDocument, options)
}
export function useGetAllTrustedContactsByUserIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAllTrustedContactsByUserIdQuery,
    GetAllTrustedContactsByUserIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetAllTrustedContactsByUserIdQuery,
    GetAllTrustedContactsByUserIdQueryVariables
  >(GetAllTrustedContactsByUserIdDocument, options)
}
export type GetAllTrustedContactsByUserIdQueryHookResult = ReturnType<
  typeof useGetAllTrustedContactsByUserIdQuery
>
export type GetAllTrustedContactsByUserIdLazyQueryHookResult = ReturnType<
  typeof useGetAllTrustedContactsByUserIdLazyQuery
>
export type GetAllTrustedContactsByUserIdQueryResult =
  ApolloReactCommon.QueryResult<
    GetAllTrustedContactsByUserIdQuery,
    GetAllTrustedContactsByUserIdQueryVariables
  >
export const TrustedContactInvestmentAccountsByUserIdDocument = /*#__PURE__*/ gql`
  query trustedContactInvestmentAccountsByUserId {
    investmentAccountsByUserId(filter: { accountStatus: OPEN }) {
      id
      investmentAccountType
      name
      product
      type
      beneficiary {
        id
        firstName
      }
      portfolios {
        id
        name
        ... on SelfDirectedPortfolio {
          status
        }
      }
      trustedContact {
        id
        firstName
        lastName
        email
        phoneNumber
      }
    }
  }
`

/**
 * __useTrustedContactInvestmentAccountsByUserIdQuery__
 *
 * To run a query within a React component, call `useTrustedContactInvestmentAccountsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrustedContactInvestmentAccountsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrustedContactInvestmentAccountsByUserIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useTrustedContactInvestmentAccountsByUserIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    TrustedContactInvestmentAccountsByUserIdQuery,
    TrustedContactInvestmentAccountsByUserIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    TrustedContactInvestmentAccountsByUserIdQuery,
    TrustedContactInvestmentAccountsByUserIdQueryVariables
  >(TrustedContactInvestmentAccountsByUserIdDocument, options)
}
export function useTrustedContactInvestmentAccountsByUserIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TrustedContactInvestmentAccountsByUserIdQuery,
    TrustedContactInvestmentAccountsByUserIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    TrustedContactInvestmentAccountsByUserIdQuery,
    TrustedContactInvestmentAccountsByUserIdQueryVariables
  >(TrustedContactInvestmentAccountsByUserIdDocument, options)
}
export type TrustedContactInvestmentAccountsByUserIdQueryHookResult =
  ReturnType<typeof useTrustedContactInvestmentAccountsByUserIdQuery>
export type TrustedContactInvestmentAccountsByUserIdLazyQueryHookResult =
  ReturnType<typeof useTrustedContactInvestmentAccountsByUserIdLazyQuery>
export type TrustedContactInvestmentAccountsByUserIdQueryResult =
  ApolloReactCommon.QueryResult<
    TrustedContactInvestmentAccountsByUserIdQuery,
    TrustedContactInvestmentAccountsByUserIdQueryVariables
  >
export const ParameterizedPdfDocument = /*#__PURE__*/ gql`
  query parameterizedPdf(
    $bankAccountId: ID!
    $userId: ID!
    $employerName: String!
    $dateSigned: String!
    $distributionType: DirectDepositDistribution!
    $distributionAmount: Float
    $sessionId: ID
  ) {
    parameterizedPdf(
      input: {
        userId: $userId
        bankAccountId: $bankAccountId
        employerName: $employerName
        dateSigned: $dateSigned
        distributionType: $distributionType
        distributionAmount: $distributionAmount
        sessionId: $sessionId
      }
    ) {
      pdf
    }
  }
`

/**
 * __useParameterizedPdfQuery__
 *
 * To run a query within a React component, call `useParameterizedPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useParameterizedPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParameterizedPdfQuery({
 *   variables: {
 *      bankAccountId: // value for 'bankAccountId'
 *      userId: // value for 'userId'
 *      employerName: // value for 'employerName'
 *      dateSigned: // value for 'dateSigned'
 *      distributionType: // value for 'distributionType'
 *      distributionAmount: // value for 'distributionAmount'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useParameterizedPdfQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ParameterizedPdfQuery,
    ParameterizedPdfQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ParameterizedPdfQuery,
    ParameterizedPdfQueryVariables
  >(ParameterizedPdfDocument, options)
}
export function useParameterizedPdfLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ParameterizedPdfQuery,
    ParameterizedPdfQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ParameterizedPdfQuery,
    ParameterizedPdfQueryVariables
  >(ParameterizedPdfDocument, options)
}
export type ParameterizedPdfQueryHookResult = ReturnType<
  typeof useParameterizedPdfQuery
>
export type ParameterizedPdfLazyQueryHookResult = ReturnType<
  typeof useParameterizedPdfLazyQuery
>
export type ParameterizedPdfQueryResult = ApolloReactCommon.QueryResult<
  ParameterizedPdfQuery,
  ParameterizedPdfQueryVariables
>
export const SpendAccountIdQueryDocument = /*#__PURE__*/ gql`
  query SpendAccountIdQuery {
    allBankAccounts(input: { type: spend }) {
      id
      bankType
    }
  }
`

/**
 * __useSpendAccountIdQueryQuery__
 *
 * To run a query within a React component, call `useSpendAccountIdQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpendAccountIdQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpendAccountIdQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpendAccountIdQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SpendAccountIdQueryQuery,
    SpendAccountIdQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SpendAccountIdQueryQuery,
    SpendAccountIdQueryQueryVariables
  >(SpendAccountIdQueryDocument, options)
}
export function useSpendAccountIdQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SpendAccountIdQueryQuery,
    SpendAccountIdQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SpendAccountIdQueryQuery,
    SpendAccountIdQueryQueryVariables
  >(SpendAccountIdQueryDocument, options)
}
export type SpendAccountIdQueryQueryHookResult = ReturnType<
  typeof useSpendAccountIdQueryQuery
>
export type SpendAccountIdQueryLazyQueryHookResult = ReturnType<
  typeof useSpendAccountIdQueryLazyQuery
>
export type SpendAccountIdQueryQueryResult = ApolloReactCommon.QueryResult<
  SpendAccountIdQueryQuery,
  SpendAccountIdQueryQueryVariables
>
export const UpdateSignatureMutationDocument = /*#__PURE__*/ gql`
  mutation updateSignatureMutation($svgFile: String!) {
    updateSignature(signatureType: directDeposit, svgFile: $svgFile) {
      svgFile
    }
  }
`
export type UpdateSignatureMutationMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdateSignatureMutationMutation,
    UpdateSignatureMutationMutationVariables
  >

/**
 * __useUpdateSignatureMutationMutation__
 *
 * To run a mutation, you first call `useUpdateSignatureMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSignatureMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSignatureMutationMutation, { data, loading, error }] = useUpdateSignatureMutationMutation({
 *   variables: {
 *      svgFile: // value for 'svgFile'
 *   },
 * });
 */
export function useUpdateSignatureMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateSignatureMutationMutation,
    UpdateSignatureMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateSignatureMutationMutation,
    UpdateSignatureMutationMutationVariables
  >(UpdateSignatureMutationDocument, options)
}
export type UpdateSignatureMutationMutationHookResult = ReturnType<
  typeof useUpdateSignatureMutationMutation
>
export type UpdateSignatureMutationMutationResult =
  ApolloReactCommon.MutationResult<UpdateSignatureMutationMutation>
export type UpdateSignatureMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateSignatureMutationMutation,
    UpdateSignatureMutationMutationVariables
  >
export const DirectDepositBankAccountQueryDocument = /*#__PURE__*/ gql`
  query DirectDepositBankAccountQuery {
    allBankAccounts(input: { type: spend }) {
      routingNumber
      number
      id
    }
  }
`

/**
 * __useDirectDepositBankAccountQueryQuery__
 *
 * To run a query within a React component, call `useDirectDepositBankAccountQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDirectDepositBankAccountQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectDepositBankAccountQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useDirectDepositBankAccountQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    DirectDepositBankAccountQueryQuery,
    DirectDepositBankAccountQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    DirectDepositBankAccountQueryQuery,
    DirectDepositBankAccountQueryQueryVariables
  >(DirectDepositBankAccountQueryDocument, options)
}
export function useDirectDepositBankAccountQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    DirectDepositBankAccountQueryQuery,
    DirectDepositBankAccountQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    DirectDepositBankAccountQueryQuery,
    DirectDepositBankAccountQueryQueryVariables
  >(DirectDepositBankAccountQueryDocument, options)
}
export type DirectDepositBankAccountQueryQueryHookResult = ReturnType<
  typeof useDirectDepositBankAccountQueryQuery
>
export type DirectDepositBankAccountQueryLazyQueryHookResult = ReturnType<
  typeof useDirectDepositBankAccountQueryLazyQuery
>
export type DirectDepositBankAccountQueryQueryResult =
  ApolloReactCommon.QueryResult<
    DirectDepositBankAccountQueryQuery,
    DirectDepositBankAccountQueryQueryVariables
  >
export const StartOnlineSwitchDocument = /*#__PURE__*/ gql`
  mutation StartOnlineSwitch(
    $employerId: ID!
    $bankAccountId: ID!
    $sessionId: ID
  ) {
    startOnlineSwitch(
      input: {
        employerId: $employerId
        bankAccountId: $bankAccountId
        sessionId: $sessionId
      }
    ) {
      userSwitch {
        id
        userId
        status
        switchType
        isComplete
        vendorSwitchId
        createdAt
        updatedAt
      }
    }
  }
`
export type StartOnlineSwitchMutationFn = ApolloReactCommon.MutationFunction<
  StartOnlineSwitchMutation,
  StartOnlineSwitchMutationVariables
>

/**
 * __useStartOnlineSwitchMutation__
 *
 * To run a mutation, you first call `useStartOnlineSwitchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartOnlineSwitchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startOnlineSwitchMutation, { data, loading, error }] = useStartOnlineSwitchMutation({
 *   variables: {
 *      employerId: // value for 'employerId'
 *      bankAccountId: // value for 'bankAccountId'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useStartOnlineSwitchMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    StartOnlineSwitchMutation,
    StartOnlineSwitchMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    StartOnlineSwitchMutation,
    StartOnlineSwitchMutationVariables
  >(StartOnlineSwitchDocument, options)
}
export type StartOnlineSwitchMutationHookResult = ReturnType<
  typeof useStartOnlineSwitchMutation
>
export type StartOnlineSwitchMutationResult =
  ApolloReactCommon.MutationResult<StartOnlineSwitchMutation>
export type StartOnlineSwitchMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    StartOnlineSwitchMutation,
    StartOnlineSwitchMutationVariables
  >
export const StartAcornsPdfSwitchDocument = /*#__PURE__*/ gql`
  mutation StartAcornsPdfSwitch(
    $name: String!
    $bankAccountId: ID!
    $sessionId: ID!
  ) {
    startAcornsPdfSwitch(
      input: {
        name: $name
        bankAccountId: $bankAccountId
        sessionId: $sessionId
      }
    )
  }
`
export type StartAcornsPdfSwitchMutationFn = ApolloReactCommon.MutationFunction<
  StartAcornsPdfSwitchMutation,
  StartAcornsPdfSwitchMutationVariables
>

/**
 * __useStartAcornsPdfSwitchMutation__
 *
 * To run a mutation, you first call `useStartAcornsPdfSwitchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAcornsPdfSwitchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAcornsPdfSwitchMutation, { data, loading, error }] = useStartAcornsPdfSwitchMutation({
 *   variables: {
 *      name: // value for 'name'
 *      bankAccountId: // value for 'bankAccountId'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useStartAcornsPdfSwitchMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    StartAcornsPdfSwitchMutation,
    StartAcornsPdfSwitchMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    StartAcornsPdfSwitchMutation,
    StartAcornsPdfSwitchMutationVariables
  >(StartAcornsPdfSwitchDocument, options)
}
export type StartAcornsPdfSwitchMutationHookResult = ReturnType<
  typeof useStartAcornsPdfSwitchMutation
>
export type StartAcornsPdfSwitchMutationResult =
  ApolloReactCommon.MutationResult<StartAcornsPdfSwitchMutation>
export type StartAcornsPdfSwitchMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    StartAcornsPdfSwitchMutation,
    StartAcornsPdfSwitchMutationVariables
  >
export const GenerateUpdatedPdfDocument = /*#__PURE__*/ gql`
  query generateUpdatedPDF(
    $bankAccountId: ID!
    $userId: ID!
    $employerName: String!
    $sessionId: ID!
  ) {
    generateUpdatedPdf(
      input: {
        userId: $userId
        bankAccountId: $bankAccountId
        employerName: $employerName
        sessionId: $sessionId
      }
    ) {
      pdf
    }
  }
`

/**
 * __useGenerateUpdatedPdfQuery__
 *
 * To run a query within a React component, call `useGenerateUpdatedPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateUpdatedPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateUpdatedPdfQuery({
 *   variables: {
 *      bankAccountId: // value for 'bankAccountId'
 *      userId: // value for 'userId'
 *      employerName: // value for 'employerName'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGenerateUpdatedPdfQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GenerateUpdatedPdfQuery,
    GenerateUpdatedPdfQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GenerateUpdatedPdfQuery,
    GenerateUpdatedPdfQueryVariables
  >(GenerateUpdatedPdfDocument, options)
}
export function useGenerateUpdatedPdfLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GenerateUpdatedPdfQuery,
    GenerateUpdatedPdfQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GenerateUpdatedPdfQuery,
    GenerateUpdatedPdfQueryVariables
  >(GenerateUpdatedPdfDocument, options)
}
export type GenerateUpdatedPdfQueryHookResult = ReturnType<
  typeof useGenerateUpdatedPdfQuery
>
export type GenerateUpdatedPdfLazyQueryHookResult = ReturnType<
  typeof useGenerateUpdatedPdfLazyQuery
>
export type GenerateUpdatedPdfQueryResult = ApolloReactCommon.QueryResult<
  GenerateUpdatedPdfQuery,
  GenerateUpdatedPdfQueryVariables
>
export const PdfDownloadUrlDocument = /*#__PURE__*/ gql`
  query PDFDownloadUrl(
    $bankAccountId: ID!
    $userId: ID!
    $sessionId: ID!
    $employerName: String!
  ) {
    pdfDownloadUrl(
      input: {
        bankAccountId: $bankAccountId
        sessionId: $sessionId
        userId: $userId
        employerName: $employerName
      }
    ) {
      url
    }
  }
`

/**
 * __usePdfDownloadUrlQuery__
 *
 * To run a query within a React component, call `usePdfDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdfDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdfDownloadUrlQuery({
 *   variables: {
 *      bankAccountId: // value for 'bankAccountId'
 *      userId: // value for 'userId'
 *      sessionId: // value for 'sessionId'
 *      employerName: // value for 'employerName'
 *   },
 * });
 */
export function usePdfDownloadUrlQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    PdfDownloadUrlQuery,
    PdfDownloadUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PdfDownloadUrlQuery,
    PdfDownloadUrlQueryVariables
  >(PdfDownloadUrlDocument, options)
}
export function usePdfDownloadUrlLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PdfDownloadUrlQuery,
    PdfDownloadUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PdfDownloadUrlQuery,
    PdfDownloadUrlQueryVariables
  >(PdfDownloadUrlDocument, options)
}
export type PdfDownloadUrlQueryHookResult = ReturnType<
  typeof usePdfDownloadUrlQuery
>
export type PdfDownloadUrlLazyQueryHookResult = ReturnType<
  typeof usePdfDownloadUrlLazyQuery
>
export type PdfDownloadUrlQueryResult = ApolloReactCommon.QueryResult<
  PdfDownloadUrlQuery,
  PdfDownloadUrlQueryVariables
>
export const SpendAccountsDocument = /*#__PURE__*/ gql`
  query SpendAccounts {
    user {
      uuid
      email
    }
    profile {
      ssnLastFour
    }
    spendAccounts: allBankAccounts(input: { type: spend }) {
      id
      number
      routingNumber
      bankType
      balance {
        value
      }
    }
    topEmployersData: topEmployers {
      topEmployersList {
        employerName
        logo
      }
    }
    spendAccount {
      isDirectDepositIncentiveEligible
      bankCardOrder {
        bankCardTier
      }
    }
  }
`

/**
 * __useSpendAccountsQuery__
 *
 * To run a query within a React component, call `useSpendAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpendAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpendAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpendAccountsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SpendAccountsQuery,
    SpendAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SpendAccountsQuery,
    SpendAccountsQueryVariables
  >(SpendAccountsDocument, options)
}
export function useSpendAccountsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SpendAccountsQuery,
    SpendAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SpendAccountsQuery,
    SpendAccountsQueryVariables
  >(SpendAccountsDocument, options)
}
export type SpendAccountsQueryHookResult = ReturnType<
  typeof useSpendAccountsQuery
>
export type SpendAccountsLazyQueryHookResult = ReturnType<
  typeof useSpendAccountsLazyQuery
>
export type SpendAccountsQueryResult = ApolloReactCommon.QueryResult<
  SpendAccountsQuery,
  SpendAccountsQueryVariables
>
export const CreateDdLinkInfoDocument = /*#__PURE__*/ gql`
  mutation CreateDDLinkInfo($userId: ID!, $accountId: ID!) {
    createDirectDepositLinkInfo(
      input: {
        userId: $userId
        accountId: $accountId
        requiredJobs: [DirectDepositSwitch]
        vendor: Pinwheel
      }
    ) {
      __typename
      ... on CreateDirectDepositLinkInfoPayload {
        results {
          id
          expires
          mode
          token
        }
        vendor
      }
      ... on CreateDirectDepositLinkInfoFailure {
        failureMessage
      }
    }
  }
`
export type CreateDdLinkInfoMutationFn = ApolloReactCommon.MutationFunction<
  CreateDdLinkInfoMutation,
  CreateDdLinkInfoMutationVariables
>

/**
 * __useCreateDdLinkInfoMutation__
 *
 * To run a mutation, you first call `useCreateDdLinkInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDdLinkInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDdLinkInfoMutation, { data, loading, error }] = useCreateDdLinkInfoMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCreateDdLinkInfoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateDdLinkInfoMutation,
    CreateDdLinkInfoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateDdLinkInfoMutation,
    CreateDdLinkInfoMutationVariables
  >(CreateDdLinkInfoDocument, options)
}
export type CreateDdLinkInfoMutationHookResult = ReturnType<
  typeof useCreateDdLinkInfoMutation
>
export type CreateDdLinkInfoMutationResult =
  ApolloReactCommon.MutationResult<CreateDdLinkInfoMutation>
export type CreateDdLinkInfoMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateDdLinkInfoMutation,
    CreateDdLinkInfoMutationVariables
  >
export const SearchEmployersDocument = /*#__PURE__*/ gql`
  query SearchEmployers(
    $searchTerm: String!
    $sessionId: ID!
    $bankAccountId: ID!
  ) {
    searchEmployers(
      input: {
        sessionId: $sessionId
        searchTerm: $searchTerm
        bankAccountId: $bankAccountId
      }
    ) {
      trackingId
      results {
        id
        employerName
        logoUrl
        switchType
        switch {
          ... on OnlineSwitch {
            __typename
            onlineVendorTargetId: vendorTargetId
            url
          }
          ... on SubmittableSwitch {
            __typename
            submittableVendorTargetId: vendorTargetId
            requiresEmployerMailingAddress
          }
        }
      }
    }
  }
`

/**
 * __useSearchEmployersQuery__
 *
 * To run a query within a React component, call `useSearchEmployersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEmployersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEmployersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      sessionId: // value for 'sessionId'
 *      bankAccountId: // value for 'bankAccountId'
 *   },
 * });
 */
export function useSearchEmployersQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SearchEmployersQuery,
    SearchEmployersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SearchEmployersQuery,
    SearchEmployersQueryVariables
  >(SearchEmployersDocument, options)
}
export function useSearchEmployersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SearchEmployersQuery,
    SearchEmployersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SearchEmployersQuery,
    SearchEmployersQueryVariables
  >(SearchEmployersDocument, options)
}
export type SearchEmployersQueryHookResult = ReturnType<
  typeof useSearchEmployersQuery
>
export type SearchEmployersLazyQueryHookResult = ReturnType<
  typeof useSearchEmployersLazyQuery
>
export type SearchEmployersQueryResult = ApolloReactCommon.QueryResult<
  SearchEmployersQuery,
  SearchEmployersQueryVariables
>
export const SubmitSwitchDocument = /*#__PURE__*/ gql`
  mutation SubmitSwitch(
    $employerId: ID!
    $bankAccountId: ID!
    $sessionId: ID!
    $employerLocationAddress: StartSubmittableSwitchAddressInput!
  ) {
    startSubmittableSwitch(
      input: {
        employerId: $employerId
        sessionId: $sessionId
        bankAccountId: $bankAccountId
        employerLocationAddress: $employerLocationAddress
      }
    ) {
      userSwitch {
        id
        isComplete
        status
        switchType
        createdAt
        updatedAt
        userId
        vendorSwitchId
      }
    }
  }
`
export type SubmitSwitchMutationFn = ApolloReactCommon.MutationFunction<
  SubmitSwitchMutation,
  SubmitSwitchMutationVariables
>

/**
 * __useSubmitSwitchMutation__
 *
 * To run a mutation, you first call `useSubmitSwitchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSwitchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSwitchMutation, { data, loading, error }] = useSubmitSwitchMutation({
 *   variables: {
 *      employerId: // value for 'employerId'
 *      bankAccountId: // value for 'bankAccountId'
 *      sessionId: // value for 'sessionId'
 *      employerLocationAddress: // value for 'employerLocationAddress'
 *   },
 * });
 */
export function useSubmitSwitchMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SubmitSwitchMutation,
    SubmitSwitchMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SubmitSwitchMutation,
    SubmitSwitchMutationVariables
  >(SubmitSwitchDocument, options)
}
export type SubmitSwitchMutationHookResult = ReturnType<
  typeof useSubmitSwitchMutation
>
export type SubmitSwitchMutationResult =
  ApolloReactCommon.MutationResult<SubmitSwitchMutation>
export type SubmitSwitchMutationOptions = ApolloReactCommon.BaseMutationOptions<
  SubmitSwitchMutation,
  SubmitSwitchMutationVariables
>
export const LockedAccountBankAccountQueryDocument = /*#__PURE__*/ gql`
  query LockedAccountBankAccountQuery {
    allBankAccounts(input: { type: spend }) {
      isLocked
      lockReason
      id
    }
  }
`

/**
 * __useLockedAccountBankAccountQueryQuery__
 *
 * To run a query within a React component, call `useLockedAccountBankAccountQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLockedAccountBankAccountQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLockedAccountBankAccountQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useLockedAccountBankAccountQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    LockedAccountBankAccountQueryQuery,
    LockedAccountBankAccountQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LockedAccountBankAccountQueryQuery,
    LockedAccountBankAccountQueryQueryVariables
  >(LockedAccountBankAccountQueryDocument, options)
}
export function useLockedAccountBankAccountQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LockedAccountBankAccountQueryQuery,
    LockedAccountBankAccountQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LockedAccountBankAccountQueryQuery,
    LockedAccountBankAccountQueryQueryVariables
  >(LockedAccountBankAccountQueryDocument, options)
}
export type LockedAccountBankAccountQueryQueryHookResult = ReturnType<
  typeof useLockedAccountBankAccountQueryQuery
>
export type LockedAccountBankAccountQueryLazyQueryHookResult = ReturnType<
  typeof useLockedAccountBankAccountQueryLazyQuery
>
export type LockedAccountBankAccountQueryQueryResult =
  ApolloReactCommon.QueryResult<
    LockedAccountBankAccountQueryQuery,
    LockedAccountBankAccountQueryQueryVariables
  >
export const OccupationQueryDocument = /*#__PURE__*/ gql`
  query OccupationQuery {
    occupations {
      name
    }
    user {
      occupation
    }
    spendAccount {
      isReopenable
    }
    bankingEmploymentStatuses
  }
`

/**
 * __useOccupationQueryQuery__
 *
 * To run a query within a React component, call `useOccupationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOccupationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOccupationQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useOccupationQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    OccupationQueryQuery,
    OccupationQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    OccupationQueryQuery,
    OccupationQueryQueryVariables
  >(OccupationQueryDocument, options)
}
export function useOccupationQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    OccupationQueryQuery,
    OccupationQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    OccupationQueryQuery,
    OccupationQueryQueryVariables
  >(OccupationQueryDocument, options)
}
export type OccupationQueryQueryHookResult = ReturnType<
  typeof useOccupationQueryQuery
>
export type OccupationQueryLazyQueryHookResult = ReturnType<
  typeof useOccupationQueryLazyQuery
>
export type OccupationQueryQueryResult = ApolloReactCommon.QueryResult<
  OccupationQueryQuery,
  OccupationQueryQueryVariables
>
export const SpendHomeDocument = /*#__PURE__*/ gql`
  query SpendHome {
    allBankAccounts(input: { type: spend }) {
      id
      availableBalance {
        value
      }
      pendingBalance {
        value
      }
      balance {
        value
      }
      createdAt
      status
      closedAt
    }
    user {
      firstName
    }
    allBankCards {
      cardNumberMasked
      lockReason
      status
      type
    }
    directDepositState {
      state {
        createdAt
        switchState
        switchMethod
        updatedAt
      }
    }
    spendAccount {
      status
      isReopenable
    }
    bankCardOrder {
      bankCardTier
    }
    roundUpProfile {
      roundUpsEnabled
    }
  }
`

/**
 * __useSpendHomeQuery__
 *
 * To run a query within a React component, call `useSpendHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpendHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpendHomeQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpendHomeQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SpendHomeQuery,
    SpendHomeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<SpendHomeQuery, SpendHomeQueryVariables>(
    SpendHomeDocument,
    options,
  )
}
export function useSpendHomeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SpendHomeQuery,
    SpendHomeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<SpendHomeQuery, SpendHomeQueryVariables>(
    SpendHomeDocument,
    options,
  )
}
export type SpendHomeQueryHookResult = ReturnType<typeof useSpendHomeQuery>
export type SpendHomeLazyQueryHookResult = ReturnType<
  typeof useSpendHomeLazyQuery
>
export type SpendHomeQueryResult = ApolloReactCommon.QueryResult<
  SpendHomeQuery,
  SpendHomeQueryVariables
>
export const RecurringTransfersDocument = /*#__PURE__*/ gql`
  query RecurringTransfers {
    recurringTransfers(filter: { targetAccountType: SPEND }) {
      ... on RecurringTransfer {
        id
        recurrenceRule {
          frequency
          byWeekDay
          byMonthDay
          interval
          startDate
          endDate
        }
        active
        transferEvent {
          targetAccount {
            id
          }
          direction
          amount {
            value
            currency
          }
        }
        nextTransferDate
      }
    }
  }
`

/**
 * __useRecurringTransfersQuery__
 *
 * To run a query within a React component, call `useRecurringTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringTransfersQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecurringTransfersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    RecurringTransfersQuery,
    RecurringTransfersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RecurringTransfersQuery,
    RecurringTransfersQueryVariables
  >(RecurringTransfersDocument, options)
}
export function useRecurringTransfersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RecurringTransfersQuery,
    RecurringTransfersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RecurringTransfersQuery,
    RecurringTransfersQueryVariables
  >(RecurringTransfersDocument, options)
}
export type RecurringTransfersQueryHookResult = ReturnType<
  typeof useRecurringTransfersQuery
>
export type RecurringTransfersLazyQueryHookResult = ReturnType<
  typeof useRecurringTransfersLazyQuery
>
export type RecurringTransfersQueryResult = ApolloReactCommon.QueryResult<
  RecurringTransfersQuery,
  RecurringTransfersQueryVariables
>
export const CancelRecurringTransferDocument = /*#__PURE__*/ gql`
  mutation CancelRecurringTransfer($id: ID!) {
    cancelRecurringTransfer(id: $id) {
      __typename
      ... on RecurringTransfer {
        active
        id
        nextTransferDate
        recurrenceRule {
          byMonthDay
          byWeekDay
          endDate
          frequency
          interval
          startDate
        }
        transferEvent {
          targetAccount {
            type
            id
          }
          fundingSource {
            type
            id
          }
          direction
          amount {
            value
            currency
          }
        }
      }
    }
  }
`
export type CancelRecurringTransferMutationFn =
  ApolloReactCommon.MutationFunction<
    CancelRecurringTransferMutation,
    CancelRecurringTransferMutationVariables
  >

/**
 * __useCancelRecurringTransferMutation__
 *
 * To run a mutation, you first call `useCancelRecurringTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRecurringTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRecurringTransferMutation, { data, loading, error }] = useCancelRecurringTransferMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelRecurringTransferMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CancelRecurringTransferMutation,
    CancelRecurringTransferMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CancelRecurringTransferMutation,
    CancelRecurringTransferMutationVariables
  >(CancelRecurringTransferDocument, options)
}
export type CancelRecurringTransferMutationHookResult = ReturnType<
  typeof useCancelRecurringTransferMutation
>
export type CancelRecurringTransferMutationResult =
  ApolloReactCommon.MutationResult<CancelRecurringTransferMutation>
export type CancelRecurringTransferMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CancelRecurringTransferMutation,
    CancelRecurringTransferMutationVariables
  >
export const NextTransferDateDocument = /*#__PURE__*/ gql`
  query NextTransferDate($frequencyObject: RecurrenceRuleInput!) {
    nextTransferDate(recurrenceRule: $frequencyObject) {
      __typename
      ... on RecurringTransferDate {
        nextTransferDate
      }
      ... on MalformedRecurringTransferException {
        pathExceptions {
          exception
          path
        }
      }
    }
  }
`

/**
 * __useNextTransferDateQuery__
 *
 * To run a query within a React component, call `useNextTransferDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextTransferDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextTransferDateQuery({
 *   variables: {
 *      frequencyObject: // value for 'frequencyObject'
 *   },
 * });
 */
export function useNextTransferDateQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    NextTransferDateQuery,
    NextTransferDateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    NextTransferDateQuery,
    NextTransferDateQueryVariables
  >(NextTransferDateDocument, options)
}
export function useNextTransferDateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    NextTransferDateQuery,
    NextTransferDateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    NextTransferDateQuery,
    NextTransferDateQueryVariables
  >(NextTransferDateDocument, options)
}
export type NextTransferDateQueryHookResult = ReturnType<
  typeof useNextTransferDateQuery
>
export type NextTransferDateLazyQueryHookResult = ReturnType<
  typeof useNextTransferDateLazyQuery
>
export type NextTransferDateQueryResult = ApolloReactCommon.QueryResult<
  NextTransferDateQuery,
  NextTransferDateQueryVariables
>
export const RecurringTransfersQueryDocument = /*#__PURE__*/ gql`
  query RecurringTransfersQuery {
    allTransferableFrom {
      from {
        accountNumberMasked
        balance {
          value
        }
        externalSource
        id
        name
        type
      }
    }
    recurringTransfers(filter: { targetAccountType: SPEND }) {
      ... on RecurringTransfer {
        id
        recurrenceRule {
          frequency
          byWeekDay
          byMonthDay
          interval
          startDate
          endDate
        }
        active
        transferEvent {
          targetAccount {
            id
          }
          direction
          amount {
            value
            currency
          }
        }
        nextTransferDate
      }
    }
  }
`

/**
 * __useRecurringTransfersQueryQuery__
 *
 * To run a query within a React component, call `useRecurringTransfersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringTransfersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringTransfersQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecurringTransfersQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    RecurringTransfersQueryQuery,
    RecurringTransfersQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RecurringTransfersQueryQuery,
    RecurringTransfersQueryQueryVariables
  >(RecurringTransfersQueryDocument, options)
}
export function useRecurringTransfersQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RecurringTransfersQueryQuery,
    RecurringTransfersQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RecurringTransfersQueryQuery,
    RecurringTransfersQueryQueryVariables
  >(RecurringTransfersQueryDocument, options)
}
export type RecurringTransfersQueryQueryHookResult = ReturnType<
  typeof useRecurringTransfersQueryQuery
>
export type RecurringTransfersQueryLazyQueryHookResult = ReturnType<
  typeof useRecurringTransfersQueryLazyQuery
>
export type RecurringTransfersQueryQueryResult = ApolloReactCommon.QueryResult<
  RecurringTransfersQueryQuery,
  RecurringTransfersQueryQueryVariables
>
export const ResumeUserDepositsDocument = /*#__PURE__*/ gql`
  mutation ResumeUserDeposits {
    suspendDeposits(suspended: false)
  }
`
export type ResumeUserDepositsMutationFn = ApolloReactCommon.MutationFunction<
  ResumeUserDepositsMutation,
  ResumeUserDepositsMutationVariables
>

/**
 * __useResumeUserDepositsMutation__
 *
 * To run a mutation, you first call `useResumeUserDepositsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeUserDepositsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeUserDepositsMutation, { data, loading, error }] = useResumeUserDepositsMutation({
 *   variables: {
 *   },
 * });
 */
export function useResumeUserDepositsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ResumeUserDepositsMutation,
    ResumeUserDepositsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ResumeUserDepositsMutation,
    ResumeUserDepositsMutationVariables
  >(ResumeUserDepositsDocument, options)
}
export type ResumeUserDepositsMutationHookResult = ReturnType<
  typeof useResumeUserDepositsMutation
>
export type ResumeUserDepositsMutationResult =
  ApolloReactCommon.MutationResult<ResumeUserDepositsMutation>
export type ResumeUserDepositsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ResumeUserDepositsMutation,
    ResumeUserDepositsMutationVariables
  >
export const ScheduleRecurringTransferDocument = /*#__PURE__*/ gql`
  mutation ScheduleRecurringTransfer($input: ScheduleRecurringTransferInput!) {
    scheduleRecurringTransfer(input: $input) {
      __typename
      ... on RecurringTransfer {
        active
        id
        nextTransferDate
        recurrenceRule {
          byMonthDay
          byWeekDay
          endDate
          frequency
          interval
          startDate
        }
        transferEvent {
          targetAccount {
            type
            id
          }
          fundingSource {
            type
            id
          }
          direction
          amount {
            value
            currency
          }
        }
      }
      ... on MalformedRecurringTransferException {
        pathExceptions {
          exception
          path
        }
      }
    }
  }
`
export type ScheduleRecurringTransferMutationFn =
  ApolloReactCommon.MutationFunction<
    ScheduleRecurringTransferMutation,
    ScheduleRecurringTransferMutationVariables
  >

/**
 * __useScheduleRecurringTransferMutation__
 *
 * To run a mutation, you first call `useScheduleRecurringTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleRecurringTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleRecurringTransferMutation, { data, loading, error }] = useScheduleRecurringTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleRecurringTransferMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ScheduleRecurringTransferMutation,
    ScheduleRecurringTransferMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ScheduleRecurringTransferMutation,
    ScheduleRecurringTransferMutationVariables
  >(ScheduleRecurringTransferDocument, options)
}
export type ScheduleRecurringTransferMutationHookResult = ReturnType<
  typeof useScheduleRecurringTransferMutation
>
export type ScheduleRecurringTransferMutationResult =
  ApolloReactCommon.MutationResult<ScheduleRecurringTransferMutation>
export type ScheduleRecurringTransferMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ScheduleRecurringTransferMutation,
    ScheduleRecurringTransferMutationVariables
  >
export const ReissueBankCardMutationDocument = /*#__PURE__*/ gql`
  mutation ReissueBankCardMutation(
    $reason: BankCardRequestReason!
    $reasonComment: String
    $reasonDate: Date
    $mailingAddress: BankCardRequestMailingAddressInput!
  ) {
    reissueBankCard(
      input: {
        reason: $reason
        reasonComment: $reasonComment
        reasonDate: $reasonDate
        mailingAddress: $mailingAddress
      }
    ) {
      __typename
    }
  }
`
export type ReissueBankCardMutationMutationFn =
  ApolloReactCommon.MutationFunction<
    ReissueBankCardMutationMutation,
    ReissueBankCardMutationMutationVariables
  >

/**
 * __useReissueBankCardMutationMutation__
 *
 * To run a mutation, you first call `useReissueBankCardMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReissueBankCardMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reissueBankCardMutationMutation, { data, loading, error }] = useReissueBankCardMutationMutation({
 *   variables: {
 *      reason: // value for 'reason'
 *      reasonComment: // value for 'reasonComment'
 *      reasonDate: // value for 'reasonDate'
 *      mailingAddress: // value for 'mailingAddress'
 *   },
 * });
 */
export function useReissueBankCardMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ReissueBankCardMutationMutation,
    ReissueBankCardMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ReissueBankCardMutationMutation,
    ReissueBankCardMutationMutationVariables
  >(ReissueBankCardMutationDocument, options)
}
export type ReissueBankCardMutationMutationHookResult = ReturnType<
  typeof useReissueBankCardMutationMutation
>
export type ReissueBankCardMutationMutationResult =
  ApolloReactCommon.MutationResult<ReissueBankCardMutationMutation>
export type ReissueBankCardMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ReissueBankCardMutationMutation,
    ReissueBankCardMutationMutationVariables
  >
export const UpdateResidentialAddressDocument = /*#__PURE__*/ gql`
  mutation UpdateResidentialAddress(
    $street1: String
    $street2: String
    $city: String
    $state: String
    $zipCode: String
  ) {
    updateAddress(
      addressType: residential
      input: {
        street1: $street1
        street2: $street2
        city: $city
        state: $state
        zipCode: $zipCode
      }
    ) {
      id
    }
  }
`
export type UpdateResidentialAddressMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdateResidentialAddressMutation,
    UpdateResidentialAddressMutationVariables
  >

/**
 * __useUpdateResidentialAddressMutation__
 *
 * To run a mutation, you first call `useUpdateResidentialAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResidentialAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResidentialAddressMutation, { data, loading, error }] = useUpdateResidentialAddressMutation({
 *   variables: {
 *      street1: // value for 'street1'
 *      street2: // value for 'street2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useUpdateResidentialAddressMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateResidentialAddressMutation,
    UpdateResidentialAddressMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateResidentialAddressMutation,
    UpdateResidentialAddressMutationVariables
  >(UpdateResidentialAddressDocument, options)
}
export type UpdateResidentialAddressMutationHookResult = ReturnType<
  typeof useUpdateResidentialAddressMutation
>
export type UpdateResidentialAddressMutationResult =
  ApolloReactCommon.MutationResult<UpdateResidentialAddressMutation>
export type UpdateResidentialAddressMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateResidentialAddressMutation,
    UpdateResidentialAddressMutationVariables
  >
export const CardShippedQueryDocument = /*#__PURE__*/ gql`
  query CardShippedQuery {
    directDepositInfo {
      info {
        status
      }
    }
    allCardTrackingStatuses {
      picNumber
    }
  }
`

/**
 * __useCardShippedQueryQuery__
 *
 * To run a query within a React component, call `useCardShippedQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardShippedQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardShippedQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCardShippedQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CardShippedQueryQuery,
    CardShippedQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CardShippedQueryQuery,
    CardShippedQueryQueryVariables
  >(CardShippedQueryDocument, options)
}
export function useCardShippedQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CardShippedQueryQuery,
    CardShippedQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CardShippedQueryQuery,
    CardShippedQueryQueryVariables
  >(CardShippedQueryDocument, options)
}
export type CardShippedQueryQueryHookResult = ReturnType<
  typeof useCardShippedQueryQuery
>
export type CardShippedQueryLazyQueryHookResult = ReturnType<
  typeof useCardShippedQueryLazyQuery
>
export type CardShippedQueryQueryResult = ApolloReactCommon.QueryResult<
  CardShippedQueryQuery,
  CardShippedQueryQueryVariables
>
export const BankCardReissueDocument = /*#__PURE__*/ gql`
  query BankCardReissue {
    bankCardReissue {
      bankCardRequest {
        id
        userId
        requestedDate
        status
        reason
        reasonComment
        reasonDate
        issuedDate
        isActivated
        previousBankCardId
        mailingAddress {
          city
          state
          zipCode
          street1
          street2
        }
      }
      reissueBankCardEligibility {
        ... on ReissueBankCardEligible {
          __typename
          originalCardCreatedAt
        }
        ... on ReissueBankCardIneligible {
          __typename
          issues
        }
      }
    }
  }
`

/**
 * __useBankCardReissueQuery__
 *
 * To run a query within a React component, call `useBankCardReissueQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankCardReissueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankCardReissueQuery({
 *   variables: {
 *   },
 * });
 */
export function useBankCardReissueQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    BankCardReissueQuery,
    BankCardReissueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    BankCardReissueQuery,
    BankCardReissueQueryVariables
  >(BankCardReissueDocument, options)
}
export function useBankCardReissueLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BankCardReissueQuery,
    BankCardReissueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    BankCardReissueQuery,
    BankCardReissueQueryVariables
  >(BankCardReissueDocument, options)
}
export type BankCardReissueQueryHookResult = ReturnType<
  typeof useBankCardReissueQuery
>
export type BankCardReissueLazyQueryHookResult = ReturnType<
  typeof useBankCardReissueLazyQuery
>
export type BankCardReissueQueryResult = ApolloReactCommon.QueryResult<
  BankCardReissueQuery,
  BankCardReissueQueryVariables
>
export const ResidentialAddressQueryDocument = /*#__PURE__*/ gql`
  query ResidentialAddressQuery {
    addresses(addressType: residential) {
      street1
      street2
      state
      city
      zipCode
      updatedAt
    }
  }
`

/**
 * __useResidentialAddressQueryQuery__
 *
 * To run a query within a React component, call `useResidentialAddressQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useResidentialAddressQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResidentialAddressQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useResidentialAddressQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ResidentialAddressQueryQuery,
    ResidentialAddressQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ResidentialAddressQueryQuery,
    ResidentialAddressQueryQueryVariables
  >(ResidentialAddressQueryDocument, options)
}
export function useResidentialAddressQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ResidentialAddressQueryQuery,
    ResidentialAddressQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ResidentialAddressQueryQuery,
    ResidentialAddressQueryQueryVariables
  >(ResidentialAddressQueryDocument, options)
}
export type ResidentialAddressQueryQueryHookResult = ReturnType<
  typeof useResidentialAddressQueryQuery
>
export type ResidentialAddressQueryLazyQueryHookResult = ReturnType<
  typeof useResidentialAddressQueryLazyQuery
>
export type ResidentialAddressQueryQueryResult = ApolloReactCommon.QueryResult<
  ResidentialAddressQueryQuery,
  ResidentialAddressQueryQueryVariables
>
export const SpendCardQueryDocument = /*#__PURE__*/ gql`
  query SpendCardQuery {
    user {
      firstName
      lastName
    }
    allBankCards {
      cardNumberMasked
      lockReason
      status
    }
    addresses(addressType: mailing) {
      street1
      street2
      state
      city
      zipCode
      updatedAt
    }
  }
`

/**
 * __useSpendCardQueryQuery__
 *
 * To run a query within a React component, call `useSpendCardQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpendCardQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpendCardQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpendCardQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SpendCardQueryQuery,
    SpendCardQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SpendCardQueryQuery,
    SpendCardQueryQueryVariables
  >(SpendCardQueryDocument, options)
}
export function useSpendCardQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SpendCardQueryQuery,
    SpendCardQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SpendCardQueryQuery,
    SpendCardQueryQueryVariables
  >(SpendCardQueryDocument, options)
}
export type SpendCardQueryQueryHookResult = ReturnType<
  typeof useSpendCardQueryQuery
>
export type SpendCardQueryLazyQueryHookResult = ReturnType<
  typeof useSpendCardQueryLazyQuery
>
export type SpendCardQueryQueryResult = ApolloReactCommon.QueryResult<
  SpendCardQueryQuery,
  SpendCardQueryQueryVariables
>
export const SpendReopenSubscriptionQueryDocument = /*#__PURE__*/ gql`
  query SpendReopenSubscriptionQuery {
    tierSubscriptionForUser {
      __typename
      ... on TierSubscription {
        id
        tier {
          id
          key
          products {
            key
          }
        }
        tierPrice {
          id
          amount {
            value
          }
        }
      }
    }
    tierOptionByProductKey(productKey: SPEND) {
      tier {
        id
        key
      }
      preferredTierPrice {
        id
        amount {
          value
          currency
        }
      }
    }
    spendAccount {
      status
      isEligible
      isReopenable
      bankType
    }
  }
`

/**
 * __useSpendReopenSubscriptionQueryQuery__
 *
 * To run a query within a React component, call `useSpendReopenSubscriptionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpendReopenSubscriptionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpendReopenSubscriptionQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpendReopenSubscriptionQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SpendReopenSubscriptionQueryQuery,
    SpendReopenSubscriptionQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SpendReopenSubscriptionQueryQuery,
    SpendReopenSubscriptionQueryQueryVariables
  >(SpendReopenSubscriptionQueryDocument, options)
}
export function useSpendReopenSubscriptionQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SpendReopenSubscriptionQueryQuery,
    SpendReopenSubscriptionQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SpendReopenSubscriptionQueryQuery,
    SpendReopenSubscriptionQueryQueryVariables
  >(SpendReopenSubscriptionQueryDocument, options)
}
export type SpendReopenSubscriptionQueryQueryHookResult = ReturnType<
  typeof useSpendReopenSubscriptionQueryQuery
>
export type SpendReopenSubscriptionQueryLazyQueryHookResult = ReturnType<
  typeof useSpendReopenSubscriptionQueryLazyQuery
>
export type SpendReopenSubscriptionQueryQueryResult =
  ApolloReactCommon.QueryResult<
    SpendReopenSubscriptionQueryQuery,
    SpendReopenSubscriptionQueryQueryVariables
  >
export const SpendReopenSubscribeUserToTierMutationDocument = /*#__PURE__*/ gql`
  mutation SpendReopenSubscribeUserToTierMutation($tierPriceId: ID!) {
    subscribeUserToTier(input: { tierPriceId: $tierPriceId }) {
      __typename
      ... on TierSubscription {
        id
      }
    }
  }
`
export type SpendReopenSubscribeUserToTierMutationMutationFn =
  ApolloReactCommon.MutationFunction<
    SpendReopenSubscribeUserToTierMutationMutation,
    SpendReopenSubscribeUserToTierMutationMutationVariables
  >

/**
 * __useSpendReopenSubscribeUserToTierMutationMutation__
 *
 * To run a mutation, you first call `useSpendReopenSubscribeUserToTierMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSpendReopenSubscribeUserToTierMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [spendReopenSubscribeUserToTierMutationMutation, { data, loading, error }] = useSpendReopenSubscribeUserToTierMutationMutation({
 *   variables: {
 *      tierPriceId: // value for 'tierPriceId'
 *   },
 * });
 */
export function useSpendReopenSubscribeUserToTierMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SpendReopenSubscribeUserToTierMutationMutation,
    SpendReopenSubscribeUserToTierMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SpendReopenSubscribeUserToTierMutationMutation,
    SpendReopenSubscribeUserToTierMutationMutationVariables
  >(SpendReopenSubscribeUserToTierMutationDocument, options)
}
export type SpendReopenSubscribeUserToTierMutationMutationHookResult =
  ReturnType<typeof useSpendReopenSubscribeUserToTierMutationMutation>
export type SpendReopenSubscribeUserToTierMutationMutationResult =
  ApolloReactCommon.MutationResult<SpendReopenSubscribeUserToTierMutationMutation>
export type SpendReopenSubscribeUserToTierMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SpendReopenSubscribeUserToTierMutationMutation,
    SpendReopenSubscribeUserToTierMutationMutationVariables
  >
export const OrderBankCardMutationDocument = /*#__PURE__*/ gql`
  mutation OrderBankCardMutation(
    $bankType: BankType
    $isDocumentsAccepted: Boolean!
    $isReopen: Boolean
    $paymentProcessor: BankCardPaymentProcessor
    $prefundTransfer: BankCardPrefundTransfer
    $employmentStatus: String
    $requestVersion: RequestVersions
    $bankCardTier: BankCardTier
  ) {
    orderBankCard(
      input: {
        bankType: $bankType
        isDocumentsAccepted: $isDocumentsAccepted
        isReopen: $isReopen
        paymentProcessor: $paymentProcessor
        prefundTransfer: $prefundTransfer
        employmentStatus: $employmentStatus
        requestVersion: $requestVersion
        bankCardTier: $bankCardTier
      }
    ) {
      ... on BankCardOrder {
        cardOrderStatus
      }
    }
  }
`
export type OrderBankCardMutationMutationFn =
  ApolloReactCommon.MutationFunction<
    OrderBankCardMutationMutation,
    OrderBankCardMutationMutationVariables
  >

/**
 * __useOrderBankCardMutationMutation__
 *
 * To run a mutation, you first call `useOrderBankCardMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderBankCardMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderBankCardMutationMutation, { data, loading, error }] = useOrderBankCardMutationMutation({
 *   variables: {
 *      bankType: // value for 'bankType'
 *      isDocumentsAccepted: // value for 'isDocumentsAccepted'
 *      isReopen: // value for 'isReopen'
 *      paymentProcessor: // value for 'paymentProcessor'
 *      prefundTransfer: // value for 'prefundTransfer'
 *      employmentStatus: // value for 'employmentStatus'
 *      requestVersion: // value for 'requestVersion'
 *      bankCardTier: // value for 'bankCardTier'
 *   },
 * });
 */
export function useOrderBankCardMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    OrderBankCardMutationMutation,
    OrderBankCardMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    OrderBankCardMutationMutation,
    OrderBankCardMutationMutationVariables
  >(OrderBankCardMutationDocument, options)
}
export type OrderBankCardMutationMutationHookResult = ReturnType<
  typeof useOrderBankCardMutationMutation
>
export type OrderBankCardMutationMutationResult =
  ApolloReactCommon.MutationResult<OrderBankCardMutationMutation>
export type OrderBankCardMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    OrderBankCardMutationMutation,
    OrderBankCardMutationMutationVariables
  >
export const SpendAccountFundingSourceVerificationDocument = /*#__PURE__*/ gql`
  query SpendAccountFundingSourceVerification {
    spendAccount {
      bankCardOrder {
        fundingSourceVerification {
          status
          pendingReason
          actionRequired
        }
      }
    }
  }
`

/**
 * __useSpendAccountFundingSourceVerificationQuery__
 *
 * To run a query within a React component, call `useSpendAccountFundingSourceVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpendAccountFundingSourceVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpendAccountFundingSourceVerificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpendAccountFundingSourceVerificationQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SpendAccountFundingSourceVerificationQuery,
    SpendAccountFundingSourceVerificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SpendAccountFundingSourceVerificationQuery,
    SpendAccountFundingSourceVerificationQueryVariables
  >(SpendAccountFundingSourceVerificationDocument, options)
}
export function useSpendAccountFundingSourceVerificationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SpendAccountFundingSourceVerificationQuery,
    SpendAccountFundingSourceVerificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SpendAccountFundingSourceVerificationQuery,
    SpendAccountFundingSourceVerificationQueryVariables
  >(SpendAccountFundingSourceVerificationDocument, options)
}
export type SpendAccountFundingSourceVerificationQueryHookResult = ReturnType<
  typeof useSpendAccountFundingSourceVerificationQuery
>
export type SpendAccountFundingSourceVerificationLazyQueryHookResult =
  ReturnType<typeof useSpendAccountFundingSourceVerificationLazyQuery>
export type SpendAccountFundingSourceVerificationQueryResult =
  ApolloReactCommon.QueryResult<
    SpendAccountFundingSourceVerificationQuery,
    SpendAccountFundingSourceVerificationQueryVariables
  >
export const PinwheelQueryDocument = /*#__PURE__*/ gql`
  query PinwheelQuery {
    user {
      uuid
    }
    spendAccounts: allBankAccounts(input: { type: spend }) {
      id
    }
  }
`

/**
 * __usePinwheelQueryQuery__
 *
 * To run a query within a React component, call `usePinwheelQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePinwheelQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePinwheelQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePinwheelQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PinwheelQueryQuery,
    PinwheelQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PinwheelQueryQuery,
    PinwheelQueryQueryVariables
  >(PinwheelQueryDocument, options)
}
export function usePinwheelQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PinwheelQueryQuery,
    PinwheelQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PinwheelQueryQuery,
    PinwheelQueryQueryVariables
  >(PinwheelQueryDocument, options)
}
export type PinwheelQueryQueryHookResult = ReturnType<
  typeof usePinwheelQueryQuery
>
export type PinwheelQueryLazyQueryHookResult = ReturnType<
  typeof usePinwheelQueryLazyQuery
>
export type PinwheelQueryQueryResult = ApolloReactCommon.QueryResult<
  PinwheelQueryQuery,
  PinwheelQueryQueryVariables
>
export const SignupQueryDocument = /*#__PURE__*/ gql`
  query SignupQuery {
    tierSubscriptionForUser {
      __typename
      ... on TierSubscription {
        id
        tier {
          id
          key
          products {
            key
          }
        }
        tierPrice {
          id
          amount {
            value
          }
        }
      }
    }
    tierOptionByProductKey(productKey: SPEND) {
      tier {
        id
        key
      }
      preferredTierPrice {
        id
        amount {
          value
          currency
        }
      }
    }
    isDirectDepositIncentiveEligible: spendAccount {
      isDirectDepositIncentiveEligible
    }
    user {
      firstName
      lastName
      phoneNumber
      occupation
      verified
    }
    residential: addresses(addressType: residential) {
      street1
      street2
      city
      state
      zipCode
      addressType
    }
    mailing: addresses(addressType: mailing) {
      street1
      street2
      city
      state
      zipCode
      addressType
    }
    occupations {
      name
    }
    bankingEmploymentStatuses
    spendAccount {
      isEligible
      accountId
      isReopenable
      status
      bankCardOrder {
        cardOrderStatus
        kycStatus
        fundingSourceVerification {
          status
        }
      }
      bankType
    }
    signatures(signatureType: debitCard) {
      svgFile
    }
    acceptanceDocuments: allAcceptanceDocuments {
      id
      name
      type
      url
      requiredFor
    }
    nbkcdocs: bankAccountDisclosures(
      input: { bankType: NBKC, paymentProcessor: DPS }
    ) {
      id
      name
      type
      url
      summaryName
      summaryUrl
      mustScrollToBottom
      requiredFor
    }
    profile {
      transfersPaused
    }
    fundingSourceAccounts {
      name
      last4
      fundType
      id
      status
      verified
      uuid
      role
    }
    linkedSubaccounts {
      role
      linkedAccount {
        id
        linkedSubaccounts {
          linkedAccountId
          id
        }
      }
    }
    eligibility(eligibilityScope: fundSpendInActivation) {
      eligible
    }
    roundUpProfile {
      roundUpsEnabled
    }
  }
`

/**
 * __useSignupQueryQuery__
 *
 * To run a query within a React component, call `useSignupQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignupQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignupQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignupQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SignupQueryQuery,
    SignupQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<SignupQueryQuery, SignupQueryQueryVariables>(
    SignupQueryDocument,
    options,
  )
}
export function useSignupQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SignupQueryQuery,
    SignupQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SignupQueryQuery,
    SignupQueryQueryVariables
  >(SignupQueryDocument, options)
}
export type SignupQueryQueryHookResult = ReturnType<typeof useSignupQueryQuery>
export type SignupQueryLazyQueryHookResult = ReturnType<
  typeof useSignupQueryLazyQuery
>
export type SignupQueryQueryResult = ApolloReactCommon.QueryResult<
  SignupQueryQuery,
  SignupQueryQueryVariables
>
export const ActivateBankCardDocument = /*#__PURE__*/ gql`
  mutation ActivateBankCard($cardNumberMasked: CardNumberMasked!) {
    activateBankCard(input: { cardNumberMasked: $cardNumberMasked }) {
      bankCard {
        status
      }
    }
  }
`
export type ActivateBankCardMutationFn = ApolloReactCommon.MutationFunction<
  ActivateBankCardMutation,
  ActivateBankCardMutationVariables
>

/**
 * __useActivateBankCardMutation__
 *
 * To run a mutation, you first call `useActivateBankCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateBankCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateBankCardMutation, { data, loading, error }] = useActivateBankCardMutation({
 *   variables: {
 *      cardNumberMasked: // value for 'cardNumberMasked'
 *   },
 * });
 */
export function useActivateBankCardMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ActivateBankCardMutation,
    ActivateBankCardMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ActivateBankCardMutation,
    ActivateBankCardMutationVariables
  >(ActivateBankCardDocument, options)
}
export type ActivateBankCardMutationHookResult = ReturnType<
  typeof useActivateBankCardMutation
>
export type ActivateBankCardMutationResult =
  ApolloReactCommon.MutationResult<ActivateBankCardMutation>
export type ActivateBankCardMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ActivateBankCardMutation,
    ActivateBankCardMutationVariables
  >
export const GetSpendCardLast4Document = /*#__PURE__*/ gql`
  query GetSpendCardLast4 {
    allBankCards(filter: { showNonActive: true }) {
      cardNumberMasked
      type
      status
    }
  }
`

/**
 * __useGetSpendCardLast4Query__
 *
 * To run a query within a React component, call `useGetSpendCardLast4Query` and pass it any options that fit your needs.
 * When your component renders, `useGetSpendCardLast4Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpendCardLast4Query({
 *   variables: {
 *   },
 * });
 */
export function useGetSpendCardLast4Query(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetSpendCardLast4Query,
    GetSpendCardLast4QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetSpendCardLast4Query,
    GetSpendCardLast4QueryVariables
  >(GetSpendCardLast4Document, options)
}
export function useGetSpendCardLast4LazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetSpendCardLast4Query,
    GetSpendCardLast4QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetSpendCardLast4Query,
    GetSpendCardLast4QueryVariables
  >(GetSpendCardLast4Document, options)
}
export type GetSpendCardLast4QueryHookResult = ReturnType<
  typeof useGetSpendCardLast4Query
>
export type GetSpendCardLast4LazyQueryHookResult = ReturnType<
  typeof useGetSpendCardLast4LazyQuery
>
export type GetSpendCardLast4QueryResult = ApolloReactCommon.QueryResult<
  GetSpendCardLast4Query,
  GetSpendCardLast4QueryVariables
>
export const SpendActivationTransferableFromQueryDocument = /*#__PURE__*/ gql`
  query SpendActivationTransferableFromQuery {
    allTransferableFrom {
      from {
        accountNumberMasked
        balance {
          value
        }
        externalSource
        id
        name
        type
      }
    }
    eligibility(eligibilityScope: fundSpendInActivation) {
      eligible
    }
  }
`

/**
 * __useSpendActivationTransferableFromQueryQuery__
 *
 * To run a query within a React component, call `useSpendActivationTransferableFromQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpendActivationTransferableFromQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpendActivationTransferableFromQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpendActivationTransferableFromQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SpendActivationTransferableFromQueryQuery,
    SpendActivationTransferableFromQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SpendActivationTransferableFromQueryQuery,
    SpendActivationTransferableFromQueryQueryVariables
  >(SpendActivationTransferableFromQueryDocument, options)
}
export function useSpendActivationTransferableFromQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SpendActivationTransferableFromQueryQuery,
    SpendActivationTransferableFromQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SpendActivationTransferableFromQueryQuery,
    SpendActivationTransferableFromQueryQueryVariables
  >(SpendActivationTransferableFromQueryDocument, options)
}
export type SpendActivationTransferableFromQueryQueryHookResult = ReturnType<
  typeof useSpendActivationTransferableFromQueryQuery
>
export type SpendActivationTransferableFromQueryLazyQueryHookResult =
  ReturnType<typeof useSpendActivationTransferableFromQueryLazyQuery>
export type SpendActivationTransferableFromQueryQueryResult =
  ApolloReactCommon.QueryResult<
    SpendActivationTransferableFromQueryQuery,
    SpendActivationTransferableFromQueryQueryVariables
  >
export const SpendActivationAgreeToAcceptanceDocumentDocument = /*#__PURE__*/ gql`
  mutation SpendActivationAgreeToAcceptanceDocument($id: ID!) {
    agreeToAcceptanceDocument(id: $id)
  }
`
export type SpendActivationAgreeToAcceptanceDocumentMutationFn =
  ApolloReactCommon.MutationFunction<
    SpendActivationAgreeToAcceptanceDocumentMutation,
    SpendActivationAgreeToAcceptanceDocumentMutationVariables
  >

/**
 * __useSpendActivationAgreeToAcceptanceDocumentMutation__
 *
 * To run a mutation, you first call `useSpendActivationAgreeToAcceptanceDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSpendActivationAgreeToAcceptanceDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [spendActivationAgreeToAcceptanceDocumentMutation, { data, loading, error }] = useSpendActivationAgreeToAcceptanceDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSpendActivationAgreeToAcceptanceDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SpendActivationAgreeToAcceptanceDocumentMutation,
    SpendActivationAgreeToAcceptanceDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SpendActivationAgreeToAcceptanceDocumentMutation,
    SpendActivationAgreeToAcceptanceDocumentMutationVariables
  >(SpendActivationAgreeToAcceptanceDocumentDocument, options)
}
export type SpendActivationAgreeToAcceptanceDocumentMutationHookResult =
  ReturnType<typeof useSpendActivationAgreeToAcceptanceDocumentMutation>
export type SpendActivationAgreeToAcceptanceDocumentMutationResult =
  ApolloReactCommon.MutationResult<SpendActivationAgreeToAcceptanceDocumentMutation>
export type SpendActivationAgreeToAcceptanceDocumentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SpendActivationAgreeToAcceptanceDocumentMutation,
    SpendActivationAgreeToAcceptanceDocumentMutationVariables
  >
export const AcceptanceDocumentsQueryDocument = /*#__PURE__*/ gql`
  query AcceptanceDocumentsQuery {
    acceptanceDocuments: bankAccountDisclosures(
      input: { bankType: LSB, paymentProcessor: DPS }
    ) {
      id
      name
      type
      url
      summaryName
      summaryUrl
      mustScrollToBottom
      requiredFor
    }
    allBankCards {
      paymentProcessor
      status
      createdAt
      bankType
    }
    nbkcdocs: bankAccountDisclosures(
      input: { bankType: NBKC, paymentProcessor: DPS }
    ) {
      id
      name
      type
      url
      summaryName
      summaryUrl
      mustScrollToBottom
      requiredFor
    }
    spendAccount {
      isReopenable
      bankType
    }
  }
`

/**
 * __useAcceptanceDocumentsQueryQuery__
 *
 * To run a query within a React component, call `useAcceptanceDocumentsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcceptanceDocumentsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcceptanceDocumentsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAcceptanceDocumentsQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AcceptanceDocumentsQueryQuery,
    AcceptanceDocumentsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AcceptanceDocumentsQueryQuery,
    AcceptanceDocumentsQueryQueryVariables
  >(AcceptanceDocumentsQueryDocument, options)
}
export function useAcceptanceDocumentsQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AcceptanceDocumentsQueryQuery,
    AcceptanceDocumentsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AcceptanceDocumentsQueryQuery,
    AcceptanceDocumentsQueryQueryVariables
  >(AcceptanceDocumentsQueryDocument, options)
}
export type AcceptanceDocumentsQueryQueryHookResult = ReturnType<
  typeof useAcceptanceDocumentsQueryQuery
>
export type AcceptanceDocumentsQueryLazyQueryHookResult = ReturnType<
  typeof useAcceptanceDocumentsQueryLazyQuery
>
export type AcceptanceDocumentsQueryQueryResult = ApolloReactCommon.QueryResult<
  AcceptanceDocumentsQueryQuery,
  AcceptanceDocumentsQueryQueryVariables
>
export const InitiateTransferActivationDocument = /*#__PURE__*/ gql`
  mutation InitiateTransferActivation(
    $amount: Float!
    $fromAccountId: ID!
    $toAccountId: ID!
    $nonce: ID
  ) {
    initiateTransfer(
      input: {
        amount: { value: $amount, currency: USD }
        fromAccountId: $fromAccountId
        toAccountId: $toAccountId
        nonce: $nonce
      }
    ) {
      transfer {
        createdAt
      }
    }
  }
`
export type InitiateTransferActivationMutationFn =
  ApolloReactCommon.MutationFunction<
    InitiateTransferActivationMutation,
    InitiateTransferActivationMutationVariables
  >

/**
 * __useInitiateTransferActivationMutation__
 *
 * To run a mutation, you first call `useInitiateTransferActivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateTransferActivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateTransferActivationMutation, { data, loading, error }] = useInitiateTransferActivationMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      fromAccountId: // value for 'fromAccountId'
 *      toAccountId: // value for 'toAccountId'
 *      nonce: // value for 'nonce'
 *   },
 * });
 */
export function useInitiateTransferActivationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    InitiateTransferActivationMutation,
    InitiateTransferActivationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    InitiateTransferActivationMutation,
    InitiateTransferActivationMutationVariables
  >(InitiateTransferActivationDocument, options)
}
export type InitiateTransferActivationMutationHookResult = ReturnType<
  typeof useInitiateTransferActivationMutation
>
export type InitiateTransferActivationMutationResult =
  ApolloReactCommon.MutationResult<InitiateTransferActivationMutation>
export type InitiateTransferActivationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    InitiateTransferActivationMutation,
    InitiateTransferActivationMutationVariables
  >
export const CancelCheckPaymentDocument = /*#__PURE__*/ gql`
  mutation CancelCheckPayment($id: ID!) {
    cancelCheckPayment(id: $id) {
      ... on CheckPayment {
        checkNumber
      }
      ... on UnableToCancelCheckError {
        requestId
      }
      ... on ResourceNotFoundError {
        requestId
      }
      ... on AuthorizationError {
        requestId
      }
    }
  }
`
export type CancelCheckPaymentMutationFn = ApolloReactCommon.MutationFunction<
  CancelCheckPaymentMutation,
  CancelCheckPaymentMutationVariables
>

/**
 * __useCancelCheckPaymentMutation__
 *
 * To run a mutation, you first call `useCancelCheckPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCheckPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCheckPaymentMutation, { data, loading, error }] = useCancelCheckPaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelCheckPaymentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CancelCheckPaymentMutation,
    CancelCheckPaymentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CancelCheckPaymentMutation,
    CancelCheckPaymentMutationVariables
  >(CancelCheckPaymentDocument, options)
}
export type CancelCheckPaymentMutationHookResult = ReturnType<
  typeof useCancelCheckPaymentMutation
>
export type CancelCheckPaymentMutationResult =
  ApolloReactCommon.MutationResult<CancelCheckPaymentMutation>
export type CancelCheckPaymentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CancelCheckPaymentMutation,
    CancelCheckPaymentMutationVariables
  >
export const CheckHistoryDocument = /*#__PURE__*/ gql`
  query CheckHistory($after: ID) {
    allCheckPayments(pageInput: { first: 25, after: $after }) {
      ... on CheckPaymentConnection {
        pageInfo {
          hasNextPage
        }
        edges {
          cursor
          node {
            amount {
              value
            }
            checkNumber
            fromAccountId
            recipientName
            recipientAddress {
              street1
              state
              zipCode
              street2
              city
            }
            estimatedArrivalAt
            status
            memo
            id
            createdAt
            failedAt
            failureReason
            canceledAt
          }
        }
      }
    }
  }
`

/**
 * __useCheckHistoryQuery__
 *
 * To run a query within a React component, call `useCheckHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckHistoryQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCheckHistoryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CheckHistoryQuery,
    CheckHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CheckHistoryQuery,
    CheckHistoryQueryVariables
  >(CheckHistoryDocument, options)
}
export function useCheckHistoryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CheckHistoryQuery,
    CheckHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CheckHistoryQuery,
    CheckHistoryQueryVariables
  >(CheckHistoryDocument, options)
}
export type CheckHistoryQueryHookResult = ReturnType<
  typeof useCheckHistoryQuery
>
export type CheckHistoryLazyQueryHookResult = ReturnType<
  typeof useCheckHistoryLazyQuery
>
export type CheckHistoryQueryResult = ApolloReactCommon.QueryResult<
  CheckHistoryQuery,
  CheckHistoryQueryVariables
>
export const AddressesDocument = /*#__PURE__*/ gql`
  query addresses {
    addresses(addressType: residential) {
      street1
      city
      country
    }
  }
`

/**
 * __useAddressesQuery__
 *
 * To run a query within a React component, call `useAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAddressesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AddressesQuery,
    AddressesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<AddressesQuery, AddressesQueryVariables>(
    AddressesDocument,
    options,
  )
}
export function useAddressesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AddressesQuery,
    AddressesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<AddressesQuery, AddressesQueryVariables>(
    AddressesDocument,
    options,
  )
}
export type AddressesQueryHookResult = ReturnType<typeof useAddressesQuery>
export type AddressesLazyQueryHookResult = ReturnType<
  typeof useAddressesLazyQuery
>
export type AddressesQueryResult = ApolloReactCommon.QueryResult<
  AddressesQuery,
  AddressesQueryVariables
>
export const SpendAtMsDocument = /*#__PURE__*/ gql`
  query spendATMs(
    $latitude: String!
    $longitude: String!
    $searchRadius: Float!
  ) {
    spendAtms(
      input: {
        searchCoordinate: { latitude: $latitude, longitude: $longitude }
        searchRadius: $searchRadius
      }
    ) {
      __typename
      ... on SpendAtmVendorUnavailableError {
        requestId
      }
      ... on SpendAtmsPayload {
        atms {
          ...SpendAtmFragment
        }
        executedSearchRadius
      }
    }
  }
  ${SpendAtmFragmentFragmentDoc}
`

/**
 * __useSpendAtMsQuery__
 *
 * To run a query within a React component, call `useSpendAtMsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpendAtMsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpendAtMsQuery({
 *   variables: {
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      searchRadius: // value for 'searchRadius'
 *   },
 * });
 */
export function useSpendAtMsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SpendAtMsQuery,
    SpendAtMsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<SpendAtMsQuery, SpendAtMsQueryVariables>(
    SpendAtMsDocument,
    options,
  )
}
export function useSpendAtMsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SpendAtMsQuery,
    SpendAtMsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<SpendAtMsQuery, SpendAtMsQueryVariables>(
    SpendAtMsDocument,
    options,
  )
}
export type SpendAtMsQueryHookResult = ReturnType<typeof useSpendAtMsQuery>
export type SpendAtMsLazyQueryHookResult = ReturnType<
  typeof useSpendAtMsLazyQuery
>
export type SpendAtMsQueryResult = ApolloReactCommon.QueryResult<
  SpendAtMsQuery,
  SpendAtMsQueryVariables
>
export const SendCheckAgreeToAcceptanceDocumentDocument = /*#__PURE__*/ gql`
  mutation SendCheckAgreeToAcceptanceDocument($id: ID!) {
    agreeToAcceptanceDocument(id: $id)
  }
`
export type SendCheckAgreeToAcceptanceDocumentMutationFn =
  ApolloReactCommon.MutationFunction<
    SendCheckAgreeToAcceptanceDocumentMutation,
    SendCheckAgreeToAcceptanceDocumentMutationVariables
  >

/**
 * __useSendCheckAgreeToAcceptanceDocumentMutation__
 *
 * To run a mutation, you first call `useSendCheckAgreeToAcceptanceDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCheckAgreeToAcceptanceDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCheckAgreeToAcceptanceDocumentMutation, { data, loading, error }] = useSendCheckAgreeToAcceptanceDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendCheckAgreeToAcceptanceDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SendCheckAgreeToAcceptanceDocumentMutation,
    SendCheckAgreeToAcceptanceDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SendCheckAgreeToAcceptanceDocumentMutation,
    SendCheckAgreeToAcceptanceDocumentMutationVariables
  >(SendCheckAgreeToAcceptanceDocumentDocument, options)
}
export type SendCheckAgreeToAcceptanceDocumentMutationHookResult = ReturnType<
  typeof useSendCheckAgreeToAcceptanceDocumentMutation
>
export type SendCheckAgreeToAcceptanceDocumentMutationResult =
  ApolloReactCommon.MutationResult<SendCheckAgreeToAcceptanceDocumentMutation>
export type SendCheckAgreeToAcceptanceDocumentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SendCheckAgreeToAcceptanceDocumentMutation,
    SendCheckAgreeToAcceptanceDocumentMutationVariables
  >
export const AcceptancedocsDocument = /*#__PURE__*/ gql`
  query acceptancedocs {
    acceptanceDocuments {
      id
      type
      url
    }
    spendAccount {
      bankType
    }
  }
`

/**
 * __useAcceptancedocsQuery__
 *
 * To run a query within a React component, call `useAcceptancedocsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcceptancedocsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcceptancedocsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAcceptancedocsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AcceptancedocsQuery,
    AcceptancedocsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AcceptancedocsQuery,
    AcceptancedocsQueryVariables
  >(AcceptancedocsDocument, options)
}
export function useAcceptancedocsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AcceptancedocsQuery,
    AcceptancedocsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AcceptancedocsQuery,
    AcceptancedocsQueryVariables
  >(AcceptancedocsDocument, options)
}
export type AcceptancedocsQueryHookResult = ReturnType<
  typeof useAcceptancedocsQuery
>
export type AcceptancedocsLazyQueryHookResult = ReturnType<
  typeof useAcceptancedocsLazyQuery
>
export type AcceptancedocsQueryResult = ApolloReactCommon.QueryResult<
  AcceptancedocsQuery,
  AcceptancedocsQueryVariables
>
export const SpendSendCheckTransferableFromQueryDocument = /*#__PURE__*/ gql`
  query SpendSendCheckTransferableFromQuery {
    allTransferableFrom {
      from {
        accountNumberMasked
        balance {
          value
        }
        externalSource
        id
        name
        type
      }
    }
    estimatedCheckPaymentDates {
      estimatedShippingAt
      estimatedArrivalAt
      estimatedTransferAtText
    }
  }
`

/**
 * __useSpendSendCheckTransferableFromQueryQuery__
 *
 * To run a query within a React component, call `useSpendSendCheckTransferableFromQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpendSendCheckTransferableFromQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpendSendCheckTransferableFromQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpendSendCheckTransferableFromQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SpendSendCheckTransferableFromQueryQuery,
    SpendSendCheckTransferableFromQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SpendSendCheckTransferableFromQueryQuery,
    SpendSendCheckTransferableFromQueryQueryVariables
  >(SpendSendCheckTransferableFromQueryDocument, options)
}
export function useSpendSendCheckTransferableFromQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SpendSendCheckTransferableFromQueryQuery,
    SpendSendCheckTransferableFromQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SpendSendCheckTransferableFromQueryQuery,
    SpendSendCheckTransferableFromQueryQueryVariables
  >(SpendSendCheckTransferableFromQueryDocument, options)
}
export type SpendSendCheckTransferableFromQueryQueryHookResult = ReturnType<
  typeof useSpendSendCheckTransferableFromQueryQuery
>
export type SpendSendCheckTransferableFromQueryLazyQueryHookResult = ReturnType<
  typeof useSpendSendCheckTransferableFromQueryLazyQuery
>
export type SpendSendCheckTransferableFromQueryQueryResult =
  ApolloReactCommon.QueryResult<
    SpendSendCheckTransferableFromQueryQuery,
    SpendSendCheckTransferableFromQueryQueryVariables
  >
export const SendCheckPaymentDocument = /*#__PURE__*/ gql`
  mutation SendCheckPayment(
    $recipientName: CheckPaymentRecipientInput!
    $city: String!
    $state: String!
    $address1: String!
    $address2: String
    $zip: String!
    $amount: Float!
    $memo: String
    $country: String!
    $fromAccountId: ID!
    $nonce: String!
  ) {
    sendCheckPayment(
      input: {
        recipient: $recipientName
        recipientAddress: {
          city: $city
          country: $country
          state: $state
          street1: $address1
          street2: $address2
          zipCode: $zip
        }
        amount: { value: $amount, currency: USD }
        memo: $memo
        fromAccountId: $fromAccountId
        nonce: $nonce
      }
    ) {
      __typename
      ... on CheckPayment {
        createdAt
        id
        status
      }
      ... on DuplicateActionError {
        requestId
      }
      ... on InvalidAddressError {
        requestId
        errorMessage
      }
      ... on AuthorizationError {
        requestId
      }
    }
  }
`
export type SendCheckPaymentMutationFn = ApolloReactCommon.MutationFunction<
  SendCheckPaymentMutation,
  SendCheckPaymentMutationVariables
>

/**
 * __useSendCheckPaymentMutation__
 *
 * To run a mutation, you first call `useSendCheckPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCheckPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCheckPaymentMutation, { data, loading, error }] = useSendCheckPaymentMutation({
 *   variables: {
 *      recipientName: // value for 'recipientName'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      address1: // value for 'address1'
 *      address2: // value for 'address2'
 *      zip: // value for 'zip'
 *      amount: // value for 'amount'
 *      memo: // value for 'memo'
 *      country: // value for 'country'
 *      fromAccountId: // value for 'fromAccountId'
 *      nonce: // value for 'nonce'
 *   },
 * });
 */
export function useSendCheckPaymentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SendCheckPaymentMutation,
    SendCheckPaymentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SendCheckPaymentMutation,
    SendCheckPaymentMutationVariables
  >(SendCheckPaymentDocument, options)
}
export type SendCheckPaymentMutationHookResult = ReturnType<
  typeof useSendCheckPaymentMutation
>
export type SendCheckPaymentMutationResult =
  ApolloReactCommon.MutationResult<SendCheckPaymentMutation>
export type SendCheckPaymentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SendCheckPaymentMutation,
    SendCheckPaymentMutationVariables
  >
export const VerifyCheckPaymentRecipientAddressDocument = /*#__PURE__*/ gql`
  query VerifyCheckPaymentRecipientAddress(
    $recipient: CheckPaymentRecipientInput!
    $street1: String!
    $street2: String
    $city: String!
    $state: String!
    $zip: String!
    $country: String!
  ) {
    verifyCheckPaymentRecipientAddress(
      input: {
        recipient: $recipient
        recipientAddress: {
          street1: $street1
          street2: $street2
          city: $city
          state: $state
          zipCode: $zip
          country: $country
        }
      }
    ) {
      __typename
      ... on CheckPaymentRecipientAddressType {
        recipient {
          firstName
          lastName
          businessName
        }
        recipientAddress {
          street1
          street2
          city
          state
          zipCode
          country
        }
      }
      ... on InvalidAddressError {
        requestId
        errorMessage
      }
      ... on AuthorizationError {
        requestId
      }
    }
  }
`

/**
 * __useVerifyCheckPaymentRecipientAddressQuery__
 *
 * To run a query within a React component, call `useVerifyCheckPaymentRecipientAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyCheckPaymentRecipientAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyCheckPaymentRecipientAddressQuery({
 *   variables: {
 *      recipient: // value for 'recipient'
 *      street1: // value for 'street1'
 *      street2: // value for 'street2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zip: // value for 'zip'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useVerifyCheckPaymentRecipientAddressQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    VerifyCheckPaymentRecipientAddressQuery,
    VerifyCheckPaymentRecipientAddressQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    VerifyCheckPaymentRecipientAddressQuery,
    VerifyCheckPaymentRecipientAddressQueryVariables
  >(VerifyCheckPaymentRecipientAddressDocument, options)
}
export function useVerifyCheckPaymentRecipientAddressLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    VerifyCheckPaymentRecipientAddressQuery,
    VerifyCheckPaymentRecipientAddressQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    VerifyCheckPaymentRecipientAddressQuery,
    VerifyCheckPaymentRecipientAddressQueryVariables
  >(VerifyCheckPaymentRecipientAddressDocument, options)
}
export type VerifyCheckPaymentRecipientAddressQueryHookResult = ReturnType<
  typeof useVerifyCheckPaymentRecipientAddressQuery
>
export type VerifyCheckPaymentRecipientAddressLazyQueryHookResult = ReturnType<
  typeof useVerifyCheckPaymentRecipientAddressLazyQuery
>
export type VerifyCheckPaymentRecipientAddressQueryResult =
  ApolloReactCommon.QueryResult<
    VerifyCheckPaymentRecipientAddressQuery,
    VerifyCheckPaymentRecipientAddressQueryVariables
  >
export const InitiateTransferSignupDocument = /*#__PURE__*/ gql`
  mutation InitiateTransferSignup(
    $amount: Float!
    $fromAccountId: ID!
    $toAccountId: ID!
    $nonce: ID
  ) {
    initiateTransfer(
      input: {
        amount: { value: $amount, currency: USD }
        fromAccountId: $fromAccountId
        toAccountId: $toAccountId
        nonce: $nonce
      }
    ) {
      transfer {
        createdAt
      }
    }
  }
`
export type InitiateTransferSignupMutationFn =
  ApolloReactCommon.MutationFunction<
    InitiateTransferSignupMutation,
    InitiateTransferSignupMutationVariables
  >

/**
 * __useInitiateTransferSignupMutation__
 *
 * To run a mutation, you first call `useInitiateTransferSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateTransferSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateTransferSignupMutation, { data, loading, error }] = useInitiateTransferSignupMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      fromAccountId: // value for 'fromAccountId'
 *      toAccountId: // value for 'toAccountId'
 *      nonce: // value for 'nonce'
 *   },
 * });
 */
export function useInitiateTransferSignupMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    InitiateTransferSignupMutation,
    InitiateTransferSignupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    InitiateTransferSignupMutation,
    InitiateTransferSignupMutationVariables
  >(InitiateTransferSignupDocument, options)
}
export type InitiateTransferSignupMutationHookResult = ReturnType<
  typeof useInitiateTransferSignupMutation
>
export type InitiateTransferSignupMutationResult =
  ApolloReactCommon.MutationResult<InitiateTransferSignupMutation>
export type InitiateTransferSignupMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    InitiateTransferSignupMutation,
    InitiateTransferSignupMutationVariables
  >
export const AddressFileUploadDocument = /*#__PURE__*/ gql`
  mutation AddressFileUpload($file: Upload!, $documentRequestId: ID!) {
    uploadDocuments(
      input: {
        documents: [$file]
        documentType: spendAddress
        documentRequestId: $documentRequestId
      }
    ) {
      ... on File {
        encoding
        filename
        mimetype
        url
      }
    }
  }
`
export type AddressFileUploadMutationFn = ApolloReactCommon.MutationFunction<
  AddressFileUploadMutation,
  AddressFileUploadMutationVariables
>

/**
 * __useAddressFileUploadMutation__
 *
 * To run a mutation, you first call `useAddressFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddressFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addressFileUploadMutation, { data, loading, error }] = useAddressFileUploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *      documentRequestId: // value for 'documentRequestId'
 *   },
 * });
 */
export function useAddressFileUploadMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddressFileUploadMutation,
    AddressFileUploadMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AddressFileUploadMutation,
    AddressFileUploadMutationVariables
  >(AddressFileUploadDocument, options)
}
export type AddressFileUploadMutationHookResult = ReturnType<
  typeof useAddressFileUploadMutation
>
export type AddressFileUploadMutationResult =
  ApolloReactCommon.MutationResult<AddressFileUploadMutation>
export type AddressFileUploadMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AddressFileUploadMutation,
    AddressFileUploadMutationVariables
  >
export const UserDocument = /*#__PURE__*/ gql`
  query User {
    user {
      address1
      address2
      state
      zip
      city
    }
    documentRequests(
      input: { type: spendAddress, pageInput: { ascending: false, limit: 50 } }
    ) {
      edges {
        node {
          id
          documentType
          status
          parentRequest {
            rejectedReason
            id
            status
          }
        }
      }
    }
  }
`

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserQuery,
    UserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<UserQuery, UserQueryVariables>(
    UserDocument,
    options,
  )
}
export function useUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserQuery,
    UserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<UserQuery, UserQueryVariables>(
    UserDocument,
    options,
  )
}
export type UserQueryHookResult = ReturnType<typeof useUserQuery>
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>
export type UserQueryResult = ApolloReactCommon.QueryResult<
  UserQuery,
  UserQueryVariables
>
export const BankVerifyIdentityByDocumentsDocument = /*#__PURE__*/ gql`
  mutation bankVerifyIdentityByDocuments($input: ValidateDocumentsInput!) {
    verifyIdentityByDocuments(input: $input) {
      ... on DocumentVerification {
        decision
        outstandingIssues
        verificationCriteriaMet
      }
    }
  }
`
export type BankVerifyIdentityByDocumentsMutationFn =
  ApolloReactCommon.MutationFunction<
    BankVerifyIdentityByDocumentsMutation,
    BankVerifyIdentityByDocumentsMutationVariables
  >

/**
 * __useBankVerifyIdentityByDocumentsMutation__
 *
 * To run a mutation, you first call `useBankVerifyIdentityByDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBankVerifyIdentityByDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bankVerifyIdentityByDocumentsMutation, { data, loading, error }] = useBankVerifyIdentityByDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBankVerifyIdentityByDocumentsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    BankVerifyIdentityByDocumentsMutation,
    BankVerifyIdentityByDocumentsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    BankVerifyIdentityByDocumentsMutation,
    BankVerifyIdentityByDocumentsMutationVariables
  >(BankVerifyIdentityByDocumentsDocument, options)
}
export type BankVerifyIdentityByDocumentsMutationHookResult = ReturnType<
  typeof useBankVerifyIdentityByDocumentsMutation
>
export type BankVerifyIdentityByDocumentsMutationResult =
  ApolloReactCommon.MutationResult<BankVerifyIdentityByDocumentsMutation>
export type BankVerifyIdentityByDocumentsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    BankVerifyIdentityByDocumentsMutation,
    BankVerifyIdentityByDocumentsMutationVariables
  >
export const DocumentRequestsDocument = /*#__PURE__*/ gql`
  query DocumentRequests {
    documentRequests(
      input: { type: spendId, pageInput: { ascending: false, limit: 50 } }
    ) {
      edges {
        node {
          id
          documentType
          status
          parentRequest {
            rejectedReason
            id
            status
          }
        }
      }
    }
  }
`

/**
 * __useDocumentRequestsQuery__
 *
 * To run a query within a React component, call `useDocumentRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDocumentRequestsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    DocumentRequestsQuery,
    DocumentRequestsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    DocumentRequestsQuery,
    DocumentRequestsQueryVariables
  >(DocumentRequestsDocument, options)
}
export function useDocumentRequestsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    DocumentRequestsQuery,
    DocumentRequestsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    DocumentRequestsQuery,
    DocumentRequestsQueryVariables
  >(DocumentRequestsDocument, options)
}
export type DocumentRequestsQueryHookResult = ReturnType<
  typeof useDocumentRequestsQuery
>
export type DocumentRequestsLazyQueryHookResult = ReturnType<
  typeof useDocumentRequestsLazyQuery
>
export type DocumentRequestsQueryResult = ApolloReactCommon.QueryResult<
  DocumentRequestsQuery,
  DocumentRequestsQueryVariables
>
export const IdentityFileUploadDocument = /*#__PURE__*/ gql`
  mutation IdentityFileUpload($file: Upload!, $documentRequestId: ID!) {
    uploadDocuments(
      input: {
        documents: [$file]
        documentType: spendId
        documentRequestId: $documentRequestId
      }
    ) {
      ... on File {
        encoding
        filename
        mimetype
        url
      }
    }
  }
`
export type IdentityFileUploadMutationFn = ApolloReactCommon.MutationFunction<
  IdentityFileUploadMutation,
  IdentityFileUploadMutationVariables
>

/**
 * __useIdentityFileUploadMutation__
 *
 * To run a mutation, you first call `useIdentityFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIdentityFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [identityFileUploadMutation, { data, loading, error }] = useIdentityFileUploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *      documentRequestId: // value for 'documentRequestId'
 *   },
 * });
 */
export function useIdentityFileUploadMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    IdentityFileUploadMutation,
    IdentityFileUploadMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    IdentityFileUploadMutation,
    IdentityFileUploadMutationVariables
  >(IdentityFileUploadDocument, options)
}
export type IdentityFileUploadMutationHookResult = ReturnType<
  typeof useIdentityFileUploadMutation
>
export type IdentityFileUploadMutationResult =
  ApolloReactCommon.MutationResult<IdentityFileUploadMutation>
export type IdentityFileUploadMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    IdentityFileUploadMutation,
    IdentityFileUploadMutationVariables
  >
export const ConfigureSmartDepositDirectDepositSettingDocument = /*#__PURE__*/ gql`
  mutation ConfigureSmartDepositDirectDepositSetting(
    $input: ConfigureSplitDepositDirectDepositSettingInput!
  ) {
    configureSplitDepositDirectDepositSetting(input: $input) {
      ... on ConfigureSplitDepositDirectDepositSettingPayload {
        setting {
          id
        }
      }
    }
  }
`
export type ConfigureSmartDepositDirectDepositSettingMutationFn =
  ApolloReactCommon.MutationFunction<
    ConfigureSmartDepositDirectDepositSettingMutation,
    ConfigureSmartDepositDirectDepositSettingMutationVariables
  >

/**
 * __useConfigureSmartDepositDirectDepositSettingMutation__
 *
 * To run a mutation, you first call `useConfigureSmartDepositDirectDepositSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureSmartDepositDirectDepositSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureSmartDepositDirectDepositSettingMutation, { data, loading, error }] = useConfigureSmartDepositDirectDepositSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigureSmartDepositDirectDepositSettingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ConfigureSmartDepositDirectDepositSettingMutation,
    ConfigureSmartDepositDirectDepositSettingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ConfigureSmartDepositDirectDepositSettingMutation,
    ConfigureSmartDepositDirectDepositSettingMutationVariables
  >(ConfigureSmartDepositDirectDepositSettingDocument, options)
}
export type ConfigureSmartDepositDirectDepositSettingMutationHookResult =
  ReturnType<typeof useConfigureSmartDepositDirectDepositSettingMutation>
export type ConfigureSmartDepositDirectDepositSettingMutationResult =
  ApolloReactCommon.MutationResult<ConfigureSmartDepositDirectDepositSettingMutation>
export type ConfigureSmartDepositDirectDepositSettingMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ConfigureSmartDepositDirectDepositSettingMutation,
    ConfigureSmartDepositDirectDepositSettingMutationVariables
  >
export const ConfigureSplitDepositDirectDepositIntentSettingDocument = /*#__PURE__*/ gql`
  mutation ConfigureSplitDepositDirectDepositIntentSetting(
    $input: ConfigureSplitDepositDirectDepositIntentSettingInput!
  ) {
    configureSplitDepositDirectDepositIntentSetting(input: $input) {
      ... on ConfigureSplitDepositDirectDepositIntentPayload {
        intent {
          id
        }
      }
    }
  }
`
export type ConfigureSplitDepositDirectDepositIntentSettingMutationFn =
  ApolloReactCommon.MutationFunction<
    ConfigureSplitDepositDirectDepositIntentSettingMutation,
    ConfigureSplitDepositDirectDepositIntentSettingMutationVariables
  >

/**
 * __useConfigureSplitDepositDirectDepositIntentSettingMutation__
 *
 * To run a mutation, you first call `useConfigureSplitDepositDirectDepositIntentSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureSplitDepositDirectDepositIntentSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureSplitDepositDirectDepositIntentSettingMutation, { data, loading, error }] = useConfigureSplitDepositDirectDepositIntentSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigureSplitDepositDirectDepositIntentSettingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ConfigureSplitDepositDirectDepositIntentSettingMutation,
    ConfigureSplitDepositDirectDepositIntentSettingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ConfigureSplitDepositDirectDepositIntentSettingMutation,
    ConfigureSplitDepositDirectDepositIntentSettingMutationVariables
  >(ConfigureSplitDepositDirectDepositIntentSettingDocument, options)
}
export type ConfigureSplitDepositDirectDepositIntentSettingMutationHookResult =
  ReturnType<typeof useConfigureSplitDepositDirectDepositIntentSettingMutation>
export type ConfigureSplitDepositDirectDepositIntentSettingMutationResult =
  ApolloReactCommon.MutationResult<ConfigureSplitDepositDirectDepositIntentSettingMutation>
export type ConfigureSplitDepositDirectDepositIntentSettingMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ConfigureSplitDepositDirectDepositIntentSettingMutation,
    ConfigureSplitDepositDirectDepositIntentSettingMutationVariables
  >
export const ExecuteSplitDepositDocument = /*#__PURE__*/ gql`
  mutation ExecuteSplitDeposit($id: ID!) {
    splitDeposit(id: $id) {
      execute {
        id
      }
    }
  }
`
export type ExecuteSplitDepositMutationFn = ApolloReactCommon.MutationFunction<
  ExecuteSplitDepositMutation,
  ExecuteSplitDepositMutationVariables
>

/**
 * __useExecuteSplitDepositMutation__
 *
 * To run a mutation, you first call `useExecuteSplitDepositMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteSplitDepositMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeSplitDepositMutation, { data, loading, error }] = useExecuteSplitDepositMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExecuteSplitDepositMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ExecuteSplitDepositMutation,
    ExecuteSplitDepositMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ExecuteSplitDepositMutation,
    ExecuteSplitDepositMutationVariables
  >(ExecuteSplitDepositDocument, options)
}
export type ExecuteSplitDepositMutationHookResult = ReturnType<
  typeof useExecuteSplitDepositMutation
>
export type ExecuteSplitDepositMutationResult =
  ApolloReactCommon.MutationResult<ExecuteSplitDepositMutation>
export type ExecuteSplitDepositMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ExecuteSplitDepositMutation,
    ExecuteSplitDepositMutationVariables
  >
export const SmartDepositSettingsByIdDocument = /*#__PURE__*/ gql`
  query SmartDepositSettingsById($settingId: ID!, $depositsLimit: Int) {
    splitDepositSettings(id: $settingId) {
      id
      name
      deposits(orderBy: DESC, limit: $depositsLimit) {
        createdAt
        distributedAt
        id
        isUsingRecommendedAllocations
        transactionAmount
        willDistributeAutomaticallyAt
        isActive
        isCancelable
        allocations {
          allocationPercent
          targetAccountId
          targetAccountType
          nickname
        }
      }
      ... on SplitDepositDirectDepositSetting {
        totalAmounts {
          totalContributedAmount {
            value
          }
          totalDepositedAmount {
            value
          }
        }
        updatedAt
      }
    }
  }
`

/**
 * __useSmartDepositSettingsByIdQuery__
 *
 * To run a query within a React component, call `useSmartDepositSettingsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartDepositSettingsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartDepositSettingsByIdQuery({
 *   variables: {
 *      settingId: // value for 'settingId'
 *      depositsLimit: // value for 'depositsLimit'
 *   },
 * });
 */
export function useSmartDepositSettingsByIdQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SmartDepositSettingsByIdQuery,
    SmartDepositSettingsByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SmartDepositSettingsByIdQuery,
    SmartDepositSettingsByIdQueryVariables
  >(SmartDepositSettingsByIdDocument, options)
}
export function useSmartDepositSettingsByIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SmartDepositSettingsByIdQuery,
    SmartDepositSettingsByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SmartDepositSettingsByIdQuery,
    SmartDepositSettingsByIdQueryVariables
  >(SmartDepositSettingsByIdDocument, options)
}
export type SmartDepositSettingsByIdQueryHookResult = ReturnType<
  typeof useSmartDepositSettingsByIdQuery
>
export type SmartDepositSettingsByIdLazyQueryHookResult = ReturnType<
  typeof useSmartDepositSettingsByIdLazyQuery
>
export type SmartDepositSettingsByIdQueryResult = ApolloReactCommon.QueryResult<
  SmartDepositSettingsByIdQuery,
  SmartDepositSettingsByIdQueryVariables
>
export const SmartDepositSettingsDocument = /*#__PURE__*/ gql`
  query SmartDepositSettings(
    $depositsLimit: Int
    $settingTypes: [SplitDepositSettingType!]!
    $metaDataInput: [SplitDepositTargetAccountType!]!
    $showHiddenEmployerSettings: Boolean
  ) {
    splitDepositSettingsByUserId(
      filter: {
        settingTypes: $settingTypes
        showHiddenEmployerSettings: $showHiddenEmployerSettings
      }
    ) {
      allocations {
        ...SmartDepositAllocationFragment
      }
      id
      isActive
      isHidden
      ... on SplitDepositDirectDepositIntentSetting {
        ...SplitDepositIntentSettingFragment
      }
      ... on SplitDepositDirectDepositSetting {
        ...SplitDepositDirectDepositSettingFragment
      }
      deposits(orderBy: DESC, limit: $depositsLimit) {
        ...SplitDepositFragment
      }
      __typename
    }
    smartDepositMetadata(
      smartDepositMetadataInput: { supportedTargetAccounts: $metaDataInput }
    ) {
      targetAccounts {
        targetAccountId
        targetAccountType
      }
      recommendedAllocations {
        allocationPercent
        targetAccountType
        targetAccountId
        nickname
      }
    }
    allBankAccounts(input: { types: [spend, save] }) {
      routingNumber
      number
      type
    }
  }
  ${SmartDepositAllocationFragmentFragmentDoc}
  ${SplitDepositIntentSettingFragmentFragmentDoc}
  ${SplitDepositDirectDepositSettingFragmentFragmentDoc}
  ${SplitDepositFragmentFragmentDoc}
`

/**
 * __useSmartDepositSettingsQuery__
 *
 * To run a query within a React component, call `useSmartDepositSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartDepositSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartDepositSettingsQuery({
 *   variables: {
 *      depositsLimit: // value for 'depositsLimit'
 *      settingTypes: // value for 'settingTypes'
 *      metaDataInput: // value for 'metaDataInput'
 *      showHiddenEmployerSettings: // value for 'showHiddenEmployerSettings'
 *   },
 * });
 */
export function useSmartDepositSettingsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SmartDepositSettingsQuery,
    SmartDepositSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SmartDepositSettingsQuery,
    SmartDepositSettingsQueryVariables
  >(SmartDepositSettingsDocument, options)
}
export function useSmartDepositSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SmartDepositSettingsQuery,
    SmartDepositSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SmartDepositSettingsQuery,
    SmartDepositSettingsQueryVariables
  >(SmartDepositSettingsDocument, options)
}
export type SmartDepositSettingsQueryHookResult = ReturnType<
  typeof useSmartDepositSettingsQuery
>
export type SmartDepositSettingsLazyQueryHookResult = ReturnType<
  typeof useSmartDepositSettingsLazyQuery
>
export type SmartDepositSettingsQueryResult = ApolloReactCommon.QueryResult<
  SmartDepositSettingsQuery,
  SmartDepositSettingsQueryVariables
>
export const SpendSignupSubscriptionQueryDocument = /*#__PURE__*/ gql`
  query SpendSignupSubscriptionQuery {
    tierSubscriptionForUser {
      __typename
      ... on TierSubscription {
        id
        tier {
          id
          key
          includedProducts {
            key
          }
          excludedProducts {
            key
          }
        }
        tierPrice {
          id
          amount {
            value
          }
        }
      }
    }
    tierOptionByProductKey(productKey: SPEND) {
      tier {
        id
        key
      }
      preferredTierPrice {
        id
        amount {
          value
          currency
        }
      }
    }
    spendAccount {
      isDirectDepositIncentiveEligible
    }
  }
`

/**
 * __useSpendSignupSubscriptionQueryQuery__
 *
 * To run a query within a React component, call `useSpendSignupSubscriptionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpendSignupSubscriptionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpendSignupSubscriptionQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpendSignupSubscriptionQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SpendSignupSubscriptionQueryQuery,
    SpendSignupSubscriptionQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SpendSignupSubscriptionQueryQuery,
    SpendSignupSubscriptionQueryQueryVariables
  >(SpendSignupSubscriptionQueryDocument, options)
}
export function useSpendSignupSubscriptionQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SpendSignupSubscriptionQueryQuery,
    SpendSignupSubscriptionQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SpendSignupSubscriptionQueryQuery,
    SpendSignupSubscriptionQueryQueryVariables
  >(SpendSignupSubscriptionQueryDocument, options)
}
export type SpendSignupSubscriptionQueryQueryHookResult = ReturnType<
  typeof useSpendSignupSubscriptionQueryQuery
>
export type SpendSignupSubscriptionQueryLazyQueryHookResult = ReturnType<
  typeof useSpendSignupSubscriptionQueryLazyQuery
>
export type SpendSignupSubscriptionQueryQueryResult =
  ApolloReactCommon.QueryResult<
    SpendSignupSubscriptionQueryQuery,
    SpendSignupSubscriptionQueryQueryVariables
  >
export const SpendTransferableFromQueryDocument = /*#__PURE__*/ gql`
  query SpendTransferableFromQuery {
    allTransferableFrom {
      from {
        accountNumberMasked
        balance {
          value
        }
        externalSource
        id
        name
        type
      }
    }
  }
`

/**
 * __useSpendTransferableFromQueryQuery__
 *
 * To run a query within a React component, call `useSpendTransferableFromQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpendTransferableFromQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpendTransferableFromQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpendTransferableFromQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SpendTransferableFromQueryQuery,
    SpendTransferableFromQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SpendTransferableFromQueryQuery,
    SpendTransferableFromQueryQueryVariables
  >(SpendTransferableFromQueryDocument, options)
}
export function useSpendTransferableFromQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SpendTransferableFromQueryQuery,
    SpendTransferableFromQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SpendTransferableFromQueryQuery,
    SpendTransferableFromQueryQueryVariables
  >(SpendTransferableFromQueryDocument, options)
}
export type SpendTransferableFromQueryQueryHookResult = ReturnType<
  typeof useSpendTransferableFromQueryQuery
>
export type SpendTransferableFromQueryLazyQueryHookResult = ReturnType<
  typeof useSpendTransferableFromQueryLazyQuery
>
export type SpendTransferableFromQueryQueryResult =
  ApolloReactCommon.QueryResult<
    SpendTransferableFromQueryQuery,
    SpendTransferableFromQueryQueryVariables
  >
export const SpendFundingSourceAccountsDocument = /*#__PURE__*/ gql`
  query SpendFundingSourceAccounts {
    fundingSourceAccounts {
      accountName
      institutionName
      last4
      id
      role
      fundType
      uuid
      verified
    }
    allBankAccounts(input: { types: [spend, save] }) {
      id
      number
      accountName
      availableBalance {
        value
      }
      type
      isLocked
      lockReason
      status
    }
  }
`

/**
 * __useSpendFundingSourceAccountsQuery__
 *
 * To run a query within a React component, call `useSpendFundingSourceAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpendFundingSourceAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpendFundingSourceAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpendFundingSourceAccountsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SpendFundingSourceAccountsQuery,
    SpendFundingSourceAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SpendFundingSourceAccountsQuery,
    SpendFundingSourceAccountsQueryVariables
  >(SpendFundingSourceAccountsDocument, options)
}
export function useSpendFundingSourceAccountsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SpendFundingSourceAccountsQuery,
    SpendFundingSourceAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SpendFundingSourceAccountsQuery,
    SpendFundingSourceAccountsQueryVariables
  >(SpendFundingSourceAccountsDocument, options)
}
export type SpendFundingSourceAccountsQueryHookResult = ReturnType<
  typeof useSpendFundingSourceAccountsQuery
>
export type SpendFundingSourceAccountsLazyQueryHookResult = ReturnType<
  typeof useSpendFundingSourceAccountsLazyQuery
>
export type SpendFundingSourceAccountsQueryResult =
  ApolloReactCommon.QueryResult<
    SpendFundingSourceAccountsQuery,
    SpendFundingSourceAccountsQueryVariables
  >
export const InitialStateQueryDocument = /*#__PURE__*/ gql`
  query InitialStateQuery {
    fundingSourceInfo {
      accountNumberLastFour
      name
      verified
    }
    settings {
      depositsSuspended
    }
    recurringTransfers(filter: { targetAccountType: SPEND }) {
      ... on RecurringTransfer {
        id
        active
      }
    }
  }
`

/**
 * __useInitialStateQueryQuery__
 *
 * To run a query within a React component, call `useInitialStateQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitialStateQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitialStateQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useInitialStateQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    InitialStateQueryQuery,
    InitialStateQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    InitialStateQueryQuery,
    InitialStateQueryQueryVariables
  >(InitialStateQueryDocument, options)
}
export function useInitialStateQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InitialStateQueryQuery,
    InitialStateQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    InitialStateQueryQuery,
    InitialStateQueryQueryVariables
  >(InitialStateQueryDocument, options)
}
export type InitialStateQueryQueryHookResult = ReturnType<
  typeof useInitialStateQueryQuery
>
export type InitialStateQueryLazyQueryHookResult = ReturnType<
  typeof useInitialStateQueryLazyQuery
>
export type InitialStateQueryQueryResult = ApolloReactCommon.QueryResult<
  InitialStateQueryQuery,
  InitialStateQueryQueryVariables
>
export const InitiateTransferDocument = /*#__PURE__*/ gql`
  mutation InitiateTransfer(
    $amount: Float!
    $fromAccountId: ID!
    $toAccountId: ID!
    $nonce: ID
  ) {
    initiateTransfer(
      input: {
        amount: { value: $amount, currency: USD }
        fromAccountId: $fromAccountId
        toAccountId: $toAccountId
        nonce: $nonce
      }
    ) {
      transfer {
        createdAt
      }
    }
  }
`
export type InitiateTransferMutationFn = ApolloReactCommon.MutationFunction<
  InitiateTransferMutation,
  InitiateTransferMutationVariables
>

/**
 * __useInitiateTransferMutation__
 *
 * To run a mutation, you first call `useInitiateTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateTransferMutation, { data, loading, error }] = useInitiateTransferMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      fromAccountId: // value for 'fromAccountId'
 *      toAccountId: // value for 'toAccountId'
 *      nonce: // value for 'nonce'
 *   },
 * });
 */
export function useInitiateTransferMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    InitiateTransferMutation,
    InitiateTransferMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    InitiateTransferMutation,
    InitiateTransferMutationVariables
  >(InitiateTransferDocument, options)
}
export type InitiateTransferMutationHookResult = ReturnType<
  typeof useInitiateTransferMutation
>
export type InitiateTransferMutationResult =
  ApolloReactCommon.MutationResult<InitiateTransferMutation>
export type InitiateTransferMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    InitiateTransferMutation,
    InitiateTransferMutationVariables
  >
export const TransferableToQueryDocument = /*#__PURE__*/ gql`
  query TransferableToQuery($from: ID!) {
    allTransferableTo(input: { from: $from }) {
      to {
        balance {
          value
        }
        externalSource
        id
        name
        type
      }
    }
  }
`

/**
 * __useTransferableToQueryQuery__
 *
 * To run a query within a React component, call `useTransferableToQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferableToQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferableToQueryQuery({
 *   variables: {
 *      from: // value for 'from'
 *   },
 * });
 */
export function useTransferableToQueryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    TransferableToQueryQuery,
    TransferableToQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    TransferableToQueryQuery,
    TransferableToQueryQueryVariables
  >(TransferableToQueryDocument, options)
}
export function useTransferableToQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TransferableToQueryQuery,
    TransferableToQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    TransferableToQueryQuery,
    TransferableToQueryQueryVariables
  >(TransferableToQueryDocument, options)
}
export type TransferableToQueryQueryHookResult = ReturnType<
  typeof useTransferableToQueryQuery
>
export type TransferableToQueryLazyQueryHookResult = ReturnType<
  typeof useTransferableToQueryLazyQuery
>
export type TransferableToQueryQueryResult = ApolloReactCommon.QueryResult<
  TransferableToQueryQuery,
  TransferableToQueryQueryVariables
>
export const UpdateOccupationMutationDocument = /*#__PURE__*/ gql`
  mutation UpdateOccupationMutation($occupation: String) {
    updateEmployment(input: { occupation: $occupation }) {
      uuid
    }
  }
`
export type UpdateOccupationMutationMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdateOccupationMutationMutation,
    UpdateOccupationMutationMutationVariables
  >

/**
 * __useUpdateOccupationMutationMutation__
 *
 * To run a mutation, you first call `useUpdateOccupationMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOccupationMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOccupationMutationMutation, { data, loading, error }] = useUpdateOccupationMutationMutation({
 *   variables: {
 *      occupation: // value for 'occupation'
 *   },
 * });
 */
export function useUpdateOccupationMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateOccupationMutationMutation,
    UpdateOccupationMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateOccupationMutationMutation,
    UpdateOccupationMutationMutationVariables
  >(UpdateOccupationMutationDocument, options)
}
export type UpdateOccupationMutationMutationHookResult = ReturnType<
  typeof useUpdateOccupationMutationMutation
>
export type UpdateOccupationMutationMutationResult =
  ApolloReactCommon.MutationResult<UpdateOccupationMutationMutation>
export type UpdateOccupationMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateOccupationMutationMutation,
    UpdateOccupationMutationMutationVariables
  >
export const SpendSignupSubscribeUserToTierMutationDocument = /*#__PURE__*/ gql`
  mutation SpendSignupSubscribeUserToTierMutation($tierPriceId: ID!) {
    subscribeUserToTier(input: { tierPriceId: $tierPriceId }) {
      __typename
      ... on TierSubscription {
        id
      }
    }
  }
`
export type SpendSignupSubscribeUserToTierMutationMutationFn =
  ApolloReactCommon.MutationFunction<
    SpendSignupSubscribeUserToTierMutationMutation,
    SpendSignupSubscribeUserToTierMutationMutationVariables
  >

/**
 * __useSpendSignupSubscribeUserToTierMutationMutation__
 *
 * To run a mutation, you first call `useSpendSignupSubscribeUserToTierMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSpendSignupSubscribeUserToTierMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [spendSignupSubscribeUserToTierMutationMutation, { data, loading, error }] = useSpendSignupSubscribeUserToTierMutationMutation({
 *   variables: {
 *      tierPriceId: // value for 'tierPriceId'
 *   },
 * });
 */
export function useSpendSignupSubscribeUserToTierMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SpendSignupSubscribeUserToTierMutationMutation,
    SpendSignupSubscribeUserToTierMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SpendSignupSubscribeUserToTierMutationMutation,
    SpendSignupSubscribeUserToTierMutationMutationVariables
  >(SpendSignupSubscribeUserToTierMutationDocument, options)
}
export type SpendSignupSubscribeUserToTierMutationMutationHookResult =
  ReturnType<typeof useSpendSignupSubscribeUserToTierMutationMutation>
export type SpendSignupSubscribeUserToTierMutationMutationResult =
  ApolloReactCommon.MutationResult<SpendSignupSubscribeUserToTierMutationMutation>
export type SpendSignupSubscribeUserToTierMutationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SpendSignupSubscribeUserToTierMutationMutation,
    SpendSignupSubscribeUserToTierMutationMutationVariables
  >
export const SubscriptionMigrationDocument = /*#__PURE__*/ gql`
  query SubscriptionMigration($id: ID!) {
    subscriptionMigration(id: $id) {
      id
      effectiveAt
      toTier {
        id
        key
      }
      fromTier {
        id
        key
      }
    }
    tierSubscriptionByUserId {
      id
      tierPrice {
        billingFrequency
        amount {
          value
        }
      }
      tier {
        key
        id
        name
      }
    }
    subscriptionMigrationWaiversByUserId {
      migration {
        id
      }
      id
    }
  }
`

/**
 * __useSubscriptionMigrationQuery__
 *
 * To run a query within a React component, call `useSubscriptionMigrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionMigrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionMigrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscriptionMigrationQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SubscriptionMigrationQuery,
    SubscriptionMigrationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SubscriptionMigrationQuery,
    SubscriptionMigrationQueryVariables
  >(SubscriptionMigrationDocument, options)
}
export function useSubscriptionMigrationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SubscriptionMigrationQuery,
    SubscriptionMigrationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SubscriptionMigrationQuery,
    SubscriptionMigrationQueryVariables
  >(SubscriptionMigrationDocument, options)
}
export type SubscriptionMigrationQueryHookResult = ReturnType<
  typeof useSubscriptionMigrationQuery
>
export type SubscriptionMigrationLazyQueryHookResult = ReturnType<
  typeof useSubscriptionMigrationLazyQuery
>
export type SubscriptionMigrationQueryResult = ApolloReactCommon.QueryResult<
  SubscriptionMigrationQuery,
  SubscriptionMigrationQueryVariables
>
export const RequestSubscriptionMigrationWaiverDocument = /*#__PURE__*/ gql`
  mutation RequestSubscriptionMigrationWaiver(
    $input: RequestSubscriptionMigrationWaiverInput!
  ) {
    requestSubscriptionMigrationWaiver(input: $input) {
      ... on SubscriptionMigrationWaiver {
        createdAt
      }
    }
  }
`
export type RequestSubscriptionMigrationWaiverMutationFn =
  ApolloReactCommon.MutationFunction<
    RequestSubscriptionMigrationWaiverMutation,
    RequestSubscriptionMigrationWaiverMutationVariables
  >

/**
 * __useRequestSubscriptionMigrationWaiverMutation__
 *
 * To run a mutation, you first call `useRequestSubscriptionMigrationWaiverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestSubscriptionMigrationWaiverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestSubscriptionMigrationWaiverMutation, { data, loading, error }] = useRequestSubscriptionMigrationWaiverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestSubscriptionMigrationWaiverMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RequestSubscriptionMigrationWaiverMutation,
    RequestSubscriptionMigrationWaiverMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RequestSubscriptionMigrationWaiverMutation,
    RequestSubscriptionMigrationWaiverMutationVariables
  >(RequestSubscriptionMigrationWaiverDocument, options)
}
export type RequestSubscriptionMigrationWaiverMutationHookResult = ReturnType<
  typeof useRequestSubscriptionMigrationWaiverMutation
>
export type RequestSubscriptionMigrationWaiverMutationResult =
  ApolloReactCommon.MutationResult<RequestSubscriptionMigrationWaiverMutation>
export type RequestSubscriptionMigrationWaiverMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RequestSubscriptionMigrationWaiverMutation,
    RequestSubscriptionMigrationWaiverMutationVariables
  >
export const CurrentTierDocument = /*#__PURE__*/ gql`
  query currentTier {
    tierSubscriptionByUserId {
      id
      tierPrice {
        id
        amount {
          value
        }
        billingFrequency
      }
    }
  }
`

/**
 * __useCurrentTierQuery__
 *
 * To run a query within a React component, call `useCurrentTierQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentTierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentTierQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentTierQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CurrentTierQuery,
    CurrentTierQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<CurrentTierQuery, CurrentTierQueryVariables>(
    CurrentTierDocument,
    options,
  )
}
export function useCurrentTierLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CurrentTierQuery,
    CurrentTierQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CurrentTierQuery,
    CurrentTierQueryVariables
  >(CurrentTierDocument, options)
}
export type CurrentTierQueryHookResult = ReturnType<typeof useCurrentTierQuery>
export type CurrentTierLazyQueryHookResult = ReturnType<
  typeof useCurrentTierLazyQuery
>
export type CurrentTierQueryResult = ApolloReactCommon.QueryResult<
  CurrentTierQuery,
  CurrentTierQueryVariables
>
export const TaxCenterAccountsAndBankStatementsDocument = /*#__PURE__*/ gql`
  query TaxCenterAccountsAndBankStatements {
    investmentAccountsByUserId {
      __typename
      beneficiary {
        __typename
        firstName
        id
      }
      id
      createdAt
      closedAt
      type
      product
      investmentAccountType
    }
    allBankStatements {
      __typename
      year
      type
      url
    }
  }
`

/**
 * __useTaxCenterAccountsAndBankStatementsQuery__
 *
 * To run a query within a React component, call `useTaxCenterAccountsAndBankStatementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxCenterAccountsAndBankStatementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxCenterAccountsAndBankStatementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaxCenterAccountsAndBankStatementsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    TaxCenterAccountsAndBankStatementsQuery,
    TaxCenterAccountsAndBankStatementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    TaxCenterAccountsAndBankStatementsQuery,
    TaxCenterAccountsAndBankStatementsQueryVariables
  >(TaxCenterAccountsAndBankStatementsDocument, options)
}
export function useTaxCenterAccountsAndBankStatementsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TaxCenterAccountsAndBankStatementsQuery,
    TaxCenterAccountsAndBankStatementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    TaxCenterAccountsAndBankStatementsQuery,
    TaxCenterAccountsAndBankStatementsQueryVariables
  >(TaxCenterAccountsAndBankStatementsDocument, options)
}
export type TaxCenterAccountsAndBankStatementsQueryHookResult = ReturnType<
  typeof useTaxCenterAccountsAndBankStatementsQuery
>
export type TaxCenterAccountsAndBankStatementsLazyQueryHookResult = ReturnType<
  typeof useTaxCenterAccountsAndBankStatementsLazyQuery
>
export type TaxCenterAccountsAndBankStatementsQueryResult =
  ApolloReactCommon.QueryResult<
    TaxCenterAccountsAndBankStatementsQuery,
    TaxCenterAccountsAndBankStatementsQueryVariables
  >
export const GetPartnerDocumentByUserIdDocument = /*#__PURE__*/ gql`
  query GetPartnerDocumentByUserId($input: PartnerDocumentInput!) {
    getPartnerDocumentByUserId(input: $input) {
      documents {
        documentUrl
        subType
      }
    }
  }
`

/**
 * __useGetPartnerDocumentByUserIdQuery__
 *
 * To run a query within a React component, call `useGetPartnerDocumentByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerDocumentByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerDocumentByUserIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPartnerDocumentByUserIdQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetPartnerDocumentByUserIdQuery,
    GetPartnerDocumentByUserIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetPartnerDocumentByUserIdQuery,
    GetPartnerDocumentByUserIdQueryVariables
  >(GetPartnerDocumentByUserIdDocument, options)
}
export function useGetPartnerDocumentByUserIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPartnerDocumentByUserIdQuery,
    GetPartnerDocumentByUserIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetPartnerDocumentByUserIdQuery,
    GetPartnerDocumentByUserIdQueryVariables
  >(GetPartnerDocumentByUserIdDocument, options)
}
export type GetPartnerDocumentByUserIdQueryHookResult = ReturnType<
  typeof useGetPartnerDocumentByUserIdQuery
>
export type GetPartnerDocumentByUserIdLazyQueryHookResult = ReturnType<
  typeof useGetPartnerDocumentByUserIdLazyQuery
>
export type GetPartnerDocumentByUserIdQueryResult =
  ApolloReactCommon.QueryResult<
    GetPartnerDocumentByUserIdQuery,
    GetPartnerDocumentByUserIdQueryVariables
  >
export const TaxCenterTaxStatementsByTaxYearDocument = /*#__PURE__*/ gql`
  query TaxCenterTaxStatementsByTaxYear($taxYear: Int!, $input: PageInput!) {
    taxStatementsByTaxYear(taxYear: $taxYear, pageInput: $input) {
      edges {
        node {
          createdAt
          id
          investmentAccountId
          investmentAccountType
          statementLink
          statementType
          taxFormType
          updatedAt
          uploaded
          year
        }
      }
    }
  }
`

/**
 * __useTaxCenterTaxStatementsByTaxYearQuery__
 *
 * To run a query within a React component, call `useTaxCenterTaxStatementsByTaxYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxCenterTaxStatementsByTaxYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxCenterTaxStatementsByTaxYearQuery({
 *   variables: {
 *      taxYear: // value for 'taxYear'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaxCenterTaxStatementsByTaxYearQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    TaxCenterTaxStatementsByTaxYearQuery,
    TaxCenterTaxStatementsByTaxYearQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    TaxCenterTaxStatementsByTaxYearQuery,
    TaxCenterTaxStatementsByTaxYearQueryVariables
  >(TaxCenterTaxStatementsByTaxYearDocument, options)
}
export function useTaxCenterTaxStatementsByTaxYearLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TaxCenterTaxStatementsByTaxYearQuery,
    TaxCenterTaxStatementsByTaxYearQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    TaxCenterTaxStatementsByTaxYearQuery,
    TaxCenterTaxStatementsByTaxYearQueryVariables
  >(TaxCenterTaxStatementsByTaxYearDocument, options)
}
export type TaxCenterTaxStatementsByTaxYearQueryHookResult = ReturnType<
  typeof useTaxCenterTaxStatementsByTaxYearQuery
>
export type TaxCenterTaxStatementsByTaxYearLazyQueryHookResult = ReturnType<
  typeof useTaxCenterTaxStatementsByTaxYearLazyQuery
>
export type TaxCenterTaxStatementsByTaxYearQueryResult =
  ApolloReactCommon.QueryResult<
    TaxCenterTaxStatementsByTaxYearQuery,
    TaxCenterTaxStatementsByTaxYearQueryVariables
  >
export const RootUserQueryDocument = /*#__PURE__*/ gql`
  query RootUserQuery {
    user {
      uuid
    }
  }
`

/**
 * __useRootUserQueryQuery__
 *
 * To run a query within a React component, call `useRootUserQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRootUserQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRootUserQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useRootUserQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    RootUserQueryQuery,
    RootUserQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RootUserQueryQuery,
    RootUserQueryQueryVariables
  >(RootUserQueryDocument, options)
}
export function useRootUserQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RootUserQueryQuery,
    RootUserQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RootUserQueryQuery,
    RootUserQueryQueryVariables
  >(RootUserQueryDocument, options)
}
export type RootUserQueryQueryHookResult = ReturnType<
  typeof useRootUserQueryQuery
>
export type RootUserQueryLazyQueryHookResult = ReturnType<
  typeof useRootUserQueryLazyQuery
>
export type RootUserQueryQueryResult = ApolloReactCommon.QueryResult<
  RootUserQueryQuery,
  RootUserQueryQueryVariables
>
export const CustomerAccountClosureQueryDocument = /*#__PURE__*/ gql`
  query CustomerAccountClosureQuery {
    customerAccountClosureRequest {
      closedAt
      closureState
    }
  }
`

/**
 * __useCustomerAccountClosureQueryQuery__
 *
 * To run a query within a React component, call `useCustomerAccountClosureQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerAccountClosureQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerAccountClosureQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerAccountClosureQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CustomerAccountClosureQueryQuery,
    CustomerAccountClosureQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CustomerAccountClosureQueryQuery,
    CustomerAccountClosureQueryQueryVariables
  >(CustomerAccountClosureQueryDocument, options)
}
export function useCustomerAccountClosureQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CustomerAccountClosureQueryQuery,
    CustomerAccountClosureQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CustomerAccountClosureQueryQuery,
    CustomerAccountClosureQueryQueryVariables
  >(CustomerAccountClosureQueryDocument, options)
}
export type CustomerAccountClosureQueryQueryHookResult = ReturnType<
  typeof useCustomerAccountClosureQueryQuery
>
export type CustomerAccountClosureQueryLazyQueryHookResult = ReturnType<
  typeof useCustomerAccountClosureQueryLazyQuery
>
export type CustomerAccountClosureQueryQueryResult =
  ApolloReactCommon.QueryResult<
    CustomerAccountClosureQueryQuery,
    CustomerAccountClosureQueryQueryVariables
  >
export const TransitionActionQueryDocument = /*#__PURE__*/ gql`
  query TransitionActionQuery {
    tierSubscriptionByUserId {
      transition {
        transitionAction
      }
    }
  }
`

/**
 * __useTransitionActionQueryQuery__
 *
 * To run a query within a React component, call `useTransitionActionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransitionActionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransitionActionQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransitionActionQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    TransitionActionQueryQuery,
    TransitionActionQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    TransitionActionQueryQuery,
    TransitionActionQueryQueryVariables
  >(TransitionActionQueryDocument, options)
}
export function useTransitionActionQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TransitionActionQueryQuery,
    TransitionActionQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    TransitionActionQueryQuery,
    TransitionActionQueryQueryVariables
  >(TransitionActionQueryDocument, options)
}
export type TransitionActionQueryQueryHookResult = ReturnType<
  typeof useTransitionActionQueryQuery
>
export type TransitionActionQueryLazyQueryHookResult = ReturnType<
  typeof useTransitionActionQueryLazyQuery
>
export type TransitionActionQueryQueryResult = ApolloReactCommon.QueryResult<
  TransitionActionQueryQuery,
  TransitionActionQueryQueryVariables
>
export const UtilsInvestmentsTotalsQueryDocument = /*#__PURE__*/ gql`
  query UtilsInvestmentsTotalsQuery {
    user {
      firstName
      verified
      closedAt
      fundingSource {
        name
      }
    }
    allBankAccounts(input: { type: spend }) {
      createdAt
      availableBalance {
        currency
        value
      }
      id
    }
    allInvestmentAccounts {
      type
      currentBalance {
        currency
        value
      }
    }
    acceptanceDocuments {
      id
      type
      url
    }
  }
`

/**
 * __useUtilsInvestmentsTotalsQueryQuery__
 *
 * To run a query within a React component, call `useUtilsInvestmentsTotalsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUtilsInvestmentsTotalsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUtilsInvestmentsTotalsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useUtilsInvestmentsTotalsQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UtilsInvestmentsTotalsQueryQuery,
    UtilsInvestmentsTotalsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    UtilsInvestmentsTotalsQueryQuery,
    UtilsInvestmentsTotalsQueryQueryVariables
  >(UtilsInvestmentsTotalsQueryDocument, options)
}
export function useUtilsInvestmentsTotalsQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UtilsInvestmentsTotalsQueryQuery,
    UtilsInvestmentsTotalsQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    UtilsInvestmentsTotalsQueryQuery,
    UtilsInvestmentsTotalsQueryQueryVariables
  >(UtilsInvestmentsTotalsQueryDocument, options)
}
export type UtilsInvestmentsTotalsQueryQueryHookResult = ReturnType<
  typeof useUtilsInvestmentsTotalsQueryQuery
>
export type UtilsInvestmentsTotalsQueryLazyQueryHookResult = ReturnType<
  typeof useUtilsInvestmentsTotalsQueryLazyQuery
>
export type UtilsInvestmentsTotalsQueryQueryResult =
  ApolloReactCommon.QueryResult<
    UtilsInvestmentsTotalsQueryQuery,
    UtilsInvestmentsTotalsQueryQueryVariables
  >
export const GraphQlTestUserQueryDocument = /*#__PURE__*/ gql`
  query GraphQLTestUserQuery {
    user {
      uuid
      firstName
      lastName
    }
  }
`

/**
 * __useGraphQlTestUserQueryQuery__
 *
 * To run a query within a React component, call `useGraphQlTestUserQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGraphQlTestUserQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGraphQlTestUserQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGraphQlTestUserQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GraphQlTestUserQueryQuery,
    GraphQlTestUserQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GraphQlTestUserQueryQuery,
    GraphQlTestUserQueryQueryVariables
  >(GraphQlTestUserQueryDocument, options)
}
export function useGraphQlTestUserQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GraphQlTestUserQueryQuery,
    GraphQlTestUserQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GraphQlTestUserQueryQuery,
    GraphQlTestUserQueryQueryVariables
  >(GraphQlTestUserQueryDocument, options)
}
export type GraphQlTestUserQueryQueryHookResult = ReturnType<
  typeof useGraphQlTestUserQueryQuery
>
export type GraphQlTestUserQueryLazyQueryHookResult = ReturnType<
  typeof useGraphQlTestUserQueryLazyQuery
>
export type GraphQlTestUserQueryQueryResult = ApolloReactCommon.QueryResult<
  GraphQlTestUserQueryQuery,
  GraphQlTestUserQueryQueryVariables
>
export const ReactTestingUserQueryDocument = /*#__PURE__*/ gql`
  query ReactTestingUserQuery {
    user {
      uuid
      firstName
      lastName
    }
  }
`

/**
 * __useReactTestingUserQueryQuery__
 *
 * To run a query within a React component, call `useReactTestingUserQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReactTestingUserQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReactTestingUserQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useReactTestingUserQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ReactTestingUserQueryQuery,
    ReactTestingUserQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ReactTestingUserQueryQuery,
    ReactTestingUserQueryQueryVariables
  >(ReactTestingUserQueryDocument, options)
}
export function useReactTestingUserQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ReactTestingUserQueryQuery,
    ReactTestingUserQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ReactTestingUserQueryQuery,
    ReactTestingUserQueryQueryVariables
  >(ReactTestingUserQueryDocument, options)
}
export type ReactTestingUserQueryQueryHookResult = ReturnType<
  typeof useReactTestingUserQueryQuery
>
export type ReactTestingUserQueryLazyQueryHookResult = ReturnType<
  typeof useReactTestingUserQueryLazyQuery
>
export type ReactTestingUserQueryQueryResult = ApolloReactCommon.QueryResult<
  ReactTestingUserQueryQuery,
  ReactTestingUserQueryQueryVariables
>
export const DepositsSuspendedDocument = /*#__PURE__*/ gql`
  query DepositsSuspended {
    settings {
      depositsSuspended
    }
  }
`

/**
 * __useDepositsSuspendedQuery__
 *
 * To run a query within a React component, call `useDepositsSuspendedQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepositsSuspendedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepositsSuspendedQuery({
 *   variables: {
 *   },
 * });
 */
export function useDepositsSuspendedQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    DepositsSuspendedQuery,
    DepositsSuspendedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    DepositsSuspendedQuery,
    DepositsSuspendedQueryVariables
  >(DepositsSuspendedDocument, options)
}
export function useDepositsSuspendedLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    DepositsSuspendedQuery,
    DepositsSuspendedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    DepositsSuspendedQuery,
    DepositsSuspendedQueryVariables
  >(DepositsSuspendedDocument, options)
}
export type DepositsSuspendedQueryHookResult = ReturnType<
  typeof useDepositsSuspendedQuery
>
export type DepositsSuspendedLazyQueryHookResult = ReturnType<
  typeof useDepositsSuspendedLazyQuery
>
export type DepositsSuspendedQueryResult = ApolloReactCommon.QueryResult<
  DepositsSuspendedQuery,
  DepositsSuspendedQueryVariables
>
export const AccountsDocument = /*#__PURE__*/ gql`
  query accounts {
    accounts(status: open) {
      accountType
      status
      id
    }
  }
`

/**
 * __useAccountsQuery__
 *
 * To run a query within a React component, call `useAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AccountsQuery,
    AccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<AccountsQuery, AccountsQueryVariables>(
    AccountsDocument,
    options,
  )
}
export function useAccountsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AccountsQuery,
    AccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<AccountsQuery, AccountsQueryVariables>(
    AccountsDocument,
    options,
  )
}
export type AccountsQueryHookResult = ReturnType<typeof useAccountsQuery>
export type AccountsLazyQueryHookResult = ReturnType<
  typeof useAccountsLazyQuery
>
export type AccountsQueryResult = ApolloReactCommon.QueryResult<
  AccountsQuery,
  AccountsQueryVariables
>
export const UserDataDocument = /*#__PURE__*/ gql`
  query UserData {
    user {
      uuid
      email
      firstName
      lastName
    }
  }
`

/**
 * __useUserDataQuery__
 *
 * To run a query within a React component, call `useUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDataQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserDataQuery,
    UserDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<UserDataQuery, UserDataQueryVariables>(
    UserDataDocument,
    options,
  )
}
export function useUserDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserDataQuery,
    UserDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<UserDataQuery, UserDataQueryVariables>(
    UserDataDocument,
    options,
  )
}
export type UserDataQueryHookResult = ReturnType<typeof useUserDataQuery>
export type UserDataLazyQueryHookResult = ReturnType<
  typeof useUserDataLazyQuery
>
export type UserDataQueryResult = ApolloReactCommon.QueryResult<
  UserDataQuery,
  UserDataQueryVariables
>
